/******/ (() => { // webpackBootstrap
/******/ 	"use strict";
/******/ 	var __webpack_modules__ = ({

/***/ 2523:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "r": () => (/* binding */ ForwardRef)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }


const SvgChIcon3 = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
    width: 36,
    height: 30,
    fill: "none",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M21.075 21.075c-3.6 3.6-9.4 3.6-12.9 0s-3.6-9.4-.1-13c3.6-3.6 9.3-3.6 12.9 0l3.1 3.1 3.8-3.8-3.1-3.1c-5.7-5.7-14.8-5.7-20.5 0-5.7 5.7-5.7 14.8 0 20.5 5.7 5.7 14.8 5.7 20.5 0l3.1-3.1-3.8-3.7-3 3.1z",
    fill: "#2C546E"
  })), _path2 || (_path2 = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M27.461 14.578l3.82-3.816 3.817 3.82-3.82 3.817-3.817-3.821z",
    fill: "#2C546E"
  })), _path3 || (_path3 = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M11.475 11.475c-1.7 1.7-1.7 4.5 0 6.1 1.7 1.7 4.5 1.7 6.1 0l3.1-3.1-3.1-3.1c-1.6-1.6-4.4-1.6-6.1.1z",
    fill: "#1DB9DD"
  })));
};
const ForwardRef = /*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_0__.forwardRef)(SvgChIcon3);

/* unused harmony default export */ var __WEBPACK_DEFAULT_EXPORT__ = (__webpack_require__.p + "f23df3c2b1bec252577c331a25443009.svg");

/***/ }),

/***/ 42158:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "r": () => (/* binding */ ForwardRef)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
var _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }


const SvgChIcon4 = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
    width: 28,
    height: 30,
    viewBox: "0 0 28 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M15.4182 29.1198C11.3735 29.1198 7.58718 27.7416 4.75649 25.2392C1.91609 22.7283 0.227598 19.2553 0.00168372 15.4599C-0.0300257 14.9265 0.389957 14.469 0.939769 14.4382C1.49203 14.406 1.96114 14.8149 1.99285 15.3484C2.18828 18.6359 3.64678 21.6406 6.09957 23.8089C8.56216 25.9859 11.8715 27.1846 15.4181 27.1846C19.4675 27.1846 22.996 25.6074 25.28 22.8173C25.3546 22.7264 25.3307 22.5919 25.2305 22.5282L20.6018 19.5839C20.4766 19.5043 20.3107 19.5112 20.1974 19.6058C18.7356 20.8255 16.4173 21.6891 14.5456 21.6891C8.3572 21.6891 3.57479 17.1379 3.42114 11.1025C3.35322 8.42645 4.37256 5.81456 6.29146 3.74762C8.20329 1.68807 10.8037 0.391311 13.6136 0.0958066C19.463 -0.514612 24.8482 1.82381 27.6704 6.19788L27.9216 6.58727C28.0701 6.81754 28.0016 7.1207 27.7673 7.26952L21.4034 11.3184C21.4034 11.3184 20.9504 11.6205 20.8448 11.6961C20.45 11.979 19.9017 11.9411 19.5523 11.6066C19.3643 11.4269 18.8298 10.9208 18.616 10.7407C17.8341 10.0821 16.9128 9.66948 15.9516 9.5472C15.5463 9.4961 15.1369 9.49518 14.7357 9.54495C12.4227 9.82924 10.5119 11.6537 10.1866 13.886C10.1123 14.3957 9.6328 14.7791 9.10464 14.7309C8.5355 14.6791 8.1313 14.1785 8.20887 13.6349C8.64966 10.5455 11.2889 8.01817 14.4845 7.62537C15.054 7.55512 15.6349 7.55604 16.2095 7.6284C17.5614 7.80032 18.8453 8.37112 19.9237 9.27955C19.9886 9.33434 20.0703 9.40657 20.159 9.48685C20.2736 9.59052 20.4467 9.60529 20.5779 9.52211L25.2384 6.56272C25.3386 6.49907 25.3624 6.36491 25.2883 6.2738C22.7392 3.15093 18.461 1.53662 13.8281 2.01976C11.5073 2.26391 9.35681 3.33737 7.77378 5.04267C6.19755 6.74056 5.36005 8.87565 5.41544 11.0548C5.54378 16.0956 9.38363 19.754 14.5459 19.754C16.0138 19.754 17.9989 18.9797 19.0651 17.9911L19.1269 17.9383C19.208 17.8748 19.4651 17.6501 19.6216 17.5108C19.9607 17.2092 20.4685 17.1719 20.8506 17.4204C20.8506 17.4204 21.3815 17.7659 21.427 17.7949L27.7593 21.8227C27.9992 21.9754 28.0683 22.287 27.9139 22.5218L27.663 22.9037C25.1048 26.7963 20.5275 29.12 15.4184 29.12L15.4182 29.1198Z",
    fill: "url(#paint0_linear_1_45)"
  })), _defs || (_defs = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("defs", null, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("linearGradient", {
    id: "paint0_linear_1_45",
    x1: 19.9372,
    y1: 31.8651,
    x2: 11.6306,
    y2: 2.00747,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("stop", {
    offset: 0.177,
    stopColor: "#F413F7"
  }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("stop", {
    offset: 0.528,
    stopColor: "#722EF2"
  }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("stop", {
    offset: 0.849,
    stopColor: "#0047EE"
  })))));
};
const ForwardRef = /*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_0__.forwardRef)(SvgChIcon4);

/* unused harmony default export */ var __WEBPACK_DEFAULT_EXPORT__ = (__webpack_require__.p + "5557b39e3c211c30067d928fad0f72bf.svg");

/***/ }),

/***/ 93838:
/***/ (() => {

// extracted by mini-css-extract-plugin
/* unused harmony default export */ var __WEBPACK_DEFAULT_EXPORT__ = ({});

/***/ }),

/***/ 17988:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "y": () => (/* binding */ ExternalAuth)
});

;// CONCATENATED MODULE: ./src/api/auth/utils/index.ts
function openAuthWindow(url, title, width = 500, height = 900) {
    const top = window.top.outerHeight / 2 + window.top.screenY - height / 2;
    const left = window.top.outerWidth / 2 + window.top.screenX - width / 2;
    const features = [
        "toolbar=no",
        "location=no",
        "directories=no",
        "status=no",
        "menubar=no",
        "scrollbars=yes",
        "resizable=yes",
        "copyhistory=no",
        `width=${width}`,
        `height=${height}`,
        `top=${top}`,
        `left=${left}`
    ];
    return window.open(url, title, features.join(", "));
}

;// CONCATENATED MODULE: ./src/api/auth/ExternalAuth.ts
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}

function onWindowClose(window1, onClose) {
    const timerId = setInterval(()=>{
        if (window1.closed) {
            clear();
            onClose();
        }
    }, 300);
    function clear() {
        clearInterval(timerId);
    }
    return clear;
}
class ExternalAuth {
    authorize(url, title) {
        if (this.authWindow) {
            this.authWindow.close();
        }
        return new Promise((resolve, reject)=>{
            const startLoadTime = new Date().getTime();
            const handleMessageBind = handleMessage.bind(this);
            this.authWindow = openAuthWindow(url, title);
            window.addEventListener("message", handleMessageBind);
            const removeCloseListener = onWindowClose(this.authWindow, handleClose);
            function handleClose() {
                // prevent rejecting because of broken SSL cetr message
                const unloadTime = new Date().getTime();
                if (unloadTime - startLoadTime < 300) {
                    return null;
                }
                window.removeEventListener("message", handleMessageBind);
                reject(new Error("Canceled By User"));
                return;
            }
            function handleMessage({ data: DTO  }) {
                if (typeof DTO !== "string") {
                    return;
                }
                try {
                    const data = JSON.parse(DTO);
                    switch(data.type){
                        case ExternalAuth.AUTH_SUCCESS_TYPE:
                            var _this_authWindow;
                            removeCloseListener();
                            window.removeEventListener("message", handleMessageBind);
                            (_this_authWindow = this.authWindow) === null || _this_authWindow === void 0 ? void 0 : _this_authWindow.close();
                            resolve(data);
                            break;
                        case ExternalAuth.AUTH_ERROR_TYPE:
                            removeCloseListener();
                            window.removeEventListener("message", handleMessageBind);
                            this.authWindow.close();
                            // TODO backend returns broken json, fix that and handle this properly
                            try {
                                reject(JSON.parse(data.payload));
                            } catch (e) {
                                console.error(e);
                                reject(new Error("Failed to authenticate"));
                            }
                            break;
                    }
                } catch (error) {
                    reject(error);
                }
            }
        });
    }
    constructor(){
        _define_property(this, "authWindow", void 0);
    }
}
_define_property(ExternalAuth, "AUTH_SUCCESS_TYPE", "@auth/success");
_define_property(ExternalAuth, "AUTH_ERROR_TYPE", "@auth/error");


/***/ }),

/***/ 24135:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "N9": () => (/* binding */ install)
/* harmony export */ });
/* unused harmony exports logoutUser, requestInterceptor, responseErrorInterceptor, getAuthToken */
/* harmony import */ var axios__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(9669);
/* harmony import */ var axios__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(axios__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var modules_auth_effects__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(77805);
/* harmony import */ var modules_notification__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(5769);
/* harmony import */ var _storage__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(86758);
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}




function logoutUser(error = {}) {
    var _error_response, _error_response_data;
    let message = "Your session has expired. Please log in again.";
    message = (error === null || error === void 0 ? void 0 : (_error_response = error.response) === null || _error_response === void 0 ? void 0 : (_error_response_data = _error_response.data) === null || _error_response_data === void 0 ? void 0 : _error_response_data.error) || message;
    modules_notification__WEBPACK_IMPORTED_MODULE_2__/* .notification.error */ .t6.error({
        message
    });
    (0,modules_auth_effects__WEBPACK_IMPORTED_MODULE_1__/* .logout */ .kS)();
    if (![
        "/login",
        "/register",
        "/signup",
        "/cyberhaven-login"
    ].find((el)=>window.location.pathname.includes(el))) {
        window.history.pushState({
            from: window.location.pathname + window.location.search
        }, "", "/login");
    } else {
        console.error("unauhenticated call on login page");
    }
    return Promise.reject(error);
}
const publicEndpoints = [
    "/v2/user-management/enabled-auth-providers",
    "/v2/user-management/saml/list-ids"
];
// just get the token but do not logout if it doesn't exists
function requestInterceptor(config, getToken) {
    return _requestInterceptor.apply(this, arguments);
}
function _requestInterceptor() {
    _requestInterceptor = _async_to_generator(function*(config, getToken) {
        // No need for token for public endpoints that used on login page
        const isPublic = publicEndpoints.includes(config.url || "");
        if (isPublic) {
            return config;
        }
        let token = "";
        try {
            token = yield getToken();
            if (!token) {
                // If we have no token, then we do not need to log out if unauthorized error appears
                config.meta = _object_spread_props(_object_spread({}, config.meta), {
                    ignoreUnauthorized: true
                });
                throw new Error("No token set");
            }
            if (config.headers) {
                config.headers.Authorization = `Bearer ${token}`;
            } else {
                config.headers = {
                    Authorization: `Bearer ${token}`
                };
            }
        } catch (e) {
            console.error(e);
        }
        return config;
    });
    return _requestInterceptor.apply(this, arguments);
}
function responseErrorInterceptor(error = {}) {
    var _config_meta, _error_response, _error_response_data, _error_response_data_detail;
    const { config , response  } = error;
    // (#8064) Fix for auth token gets removed from cookies for the first tab, and thus other tabs are not logged out.
    // We allow 401 log out on the url which will never be a part of the login flow.
    if (config.url !== "/v1/graphql" && (config === null || config === void 0 ? void 0 : (_config_meta = config.meta) === null || _config_meta === void 0 ? void 0 : _config_meta.ignoreUnauthorized)) {
        return Promise.reject(error);
    }
    if ((response === null || response === void 0 ? void 0 : response.status) === 401 && ((_error_response = error.response) === null || _error_response === void 0 ? void 0 : (_error_response_data = _error_response.data) === null || _error_response_data === void 0 ? void 0 : (_error_response_data_detail = _error_response_data.detail) === null || _error_response_data_detail === void 0 ? void 0 : _error_response_data_detail.Code) !== "mfa-required") {
        return logoutUser(error);
    }
    return Promise.reject(error);
}
const getAuthToken = _storage__WEBPACK_IMPORTED_MODULE_3__/* .getToken */ .LP;
function install(client = (axios__WEBPACK_IMPORTED_MODULE_0___default())) {
    client.interceptors.request.use((cfg)=>requestInterceptor(cfg, getAuthToken));
    if (true) {
        client.interceptors.response.use((response)=>response, responseErrorInterceptor);
    }
}


/***/ }),

/***/ 71684:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "N9": () => (/* reexport safe */ _auth_interceptor__WEBPACK_IMPORTED_MODULE_0__.N9)
/* harmony export */ });
/* harmony import */ var _auth_interceptor__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(24135);



/***/ }),

/***/ 86758:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Fn": () => (/* binding */ KEY),
/* harmony export */   "LP": () => (/* binding */ getToken),
/* harmony export */   "xy": () => (/* binding */ getTokenExpirationTime)
/* harmony export */ });
/* unused harmony export parsePayload */
/* harmony import */ var jwt_decode__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(96245);
/* harmony import */ var js_cookie__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(36808);
/* harmony import */ var js_cookie__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(js_cookie__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var libs_time_utc__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(75044);
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}



const KEY = "DAT_AUTH";
function getToken() {
    return _getToken.apply(this, arguments);
}
function _getToken() {
    _getToken = _async_to_generator(function*() {
        var _cookie_get;
        return (_cookie_get = js_cookie__WEBPACK_IMPORTED_MODULE_1___default().get(KEY)) !== null && _cookie_get !== void 0 ? _cookie_get : "";
    });
    return _getToken.apply(this, arguments);
}
// returns token expiration time in mils
function getTokenExpirationTime() {
    return getToken().then((el)=>{
        return el ? (0,libs_time_utc__WEBPACK_IMPORTED_MODULE_2__/* .toMils */ .tg)(parsePayload(el).exp) : null;
    });
}
function parsePayload(token) {
    if (!token) {
        return null;
    }
    return (0,jwt_decode__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(token);
}


/***/ }),

/***/ 40399:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Nw": () => (/* reexport */ gsuiteSensorService),
  "st": () => (/* reexport */ o365SensorService),
  "Y1": () => (/* reexport */ salesforceSensorService)
});

// UNUSED EXPORTS: GsuiteSensorService, O365SensorService, SalesforceSensorService

// EXTERNAL MODULE: ./node_modules/axios/index.js
var axios = __webpack_require__(9669);
var axios_default = /*#__PURE__*/__webpack_require__.n(axios);
// EXTERNAL MODULE: ./src/api/auth/interceptors/auth.interceptor.ts
var auth_interceptor = __webpack_require__(24135);
;// CONCATENATED MODULE: ./src/api/cloud-sensors/o365.ts
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}


class O365SensorService {
    monitorUsers() {
        return this.client.get("/users/updated");
    }
    fetchUsers() {
        return this.client.get("/users").then((response)=>response.data);
    }
    updateUser(id, updateData) {
        return this.client.patch(`/users/${id}`, updateData).then((el)=>el.data);
    }
    batch(data) {
        return this.client.patch("/users/batch", data);
    }
    updateAll(params = {
        monitored: true
    }) {
        return this.client.patch("/users/all", params);
    }
    toggleAutoMonitoring(params = {
        monitored: true
    }) {
        return this.client.patch("/users/force_all", params);
    }
    constructor(){
        _define_property(this, "client", axios_default().create({
            baseURL: "/v1/config/o365"
        }));
        (0,auth_interceptor/* install */.N9)(this.client);
    }
}
const o365SensorService = new O365SensorService();


;// CONCATENATED MODULE: ./src/api/cloud-sensors/salesforce.ts
function salesforce_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}


class SalesforceSensorService {
    monitorUsers() {
        return this.client.get("/users/updated");
    }
    fetchUsers() {
        return this.client.get("/users").then((response)=>response.data);
    }
    updateUser(id, updateData) {
        return this.client.patch(`/users/${id}`, updateData).then((el)=>el.data);
    }
    batch(data) {
        return this.client.patch("/users/batch", data);
    }
    updateAll(params = {
        monitored: true
    }) {
        return this.client.patch("/users/all", params);
    }
    toggleAutoMonitoring(params = {
        monitored: true
    }) {
        return this.client.patch("/users/force_all", params);
    }
    constructor(){
        salesforce_define_property(this, "client", axios_default().create({
            baseURL: "/v1/config/salesforce"
        }));
        (0,auth_interceptor/* install */.N9)(this.client);
    }
}
const salesforceSensorService = new SalesforceSensorService();


;// CONCATENATED MODULE: ./src/api/cloud-sensors/gsuite.ts
function gsuite_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}


class GsuiteSensorService {
    monitorUsers() {
        return this.client.get("/users/updated");
    }
    fetchUsers() {
        return this.client.get("/users").then((response)=>response.data);
    }
    updateUser(id, updateData) {
        return this.client.patch(`/users/${id}`, updateData).then((el)=>el.data);
    }
    batch(data) {
        return this.client.patch("/users/batch", data);
    }
    updateAll(params = {
        monitored: true
    }) {
        return this.client.patch("/users/all", params);
    }
    toggleAutoMonitoring(params = {
        monitored: true
    }) {
        return this.client.patch("/users/force_all", params);
    }
    constructor(){
        gsuite_define_property(this, "client", axios_default().create({
            baseURL: "/v1/config/gsuite"
        }));
        (0,auth_interceptor/* install */.N9)(this.client);
    }
}
const gsuiteSensorService = new GsuiteSensorService();


;// CONCATENATED MODULE: ./src/api/cloud-sensors/index.ts






/***/ }),

/***/ 33013:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "CK": () => (/* binding */ BucketTypeEnum),
  "HL": () => (/* binding */ CategoryStatusEnum),
  "K6": () => (/* binding */ DefaultSettings),
  "by": () => (/* binding */ EventTypeEnum),
  "LE": () => (/* binding */ IncidentActionEnum),
  "Sn": () => (/* binding */ IncidentReactionEnum),
  "E$": () => (/* binding */ LocationCategoryValues),
  "eO": () => (/* binding */ LocationEnum),
  "lf": () => (/* binding */ OperatorEnum),
  "oF": () => (/* binding */ RequiredActionEnum),
  "rL": () => (/* binding */ ResolutionStatusEnum),
  "Cm": () => (/* binding */ SearchFieldEnum),
  "DN": () => (/* binding */ SearchFieldIsUsableInPolicies),
  "Mn": () => (/* binding */ SearchFieldToMinimumVersion),
  "XL": () => (/* binding */ SelectionTypeEnum),
  "qP": () => (/* binding */ SelectorEnum),
  "gA": () => (/* binding */ SideSelectorEnum),
  "Uk": () => (/* binding */ SizeUnitEnum),
  "hi": () => (/* binding */ api)
});

// UNUSED EXPORTS: AdminEventTypeEnum, CloudAppEnum, CloudProviderEnum, ColumnEnum, DatasetDomainEnum, DirectoryStateEnum, DirectoryStatusEnum, DirectoryTypeEnum, DurationSecondsEnum, EndpointIssueEnum, EndpointSettingsFilterTypeEnum, EndpointSettingsHookEngineTypeEnum, EndpointSettingsLogLevelEnum, EndpointSettingsMergeModeEnum, EndpointSettingsMonitorModeEnum, EndpointSettingsScreenshotMacPermissionPolicyEnum, EndpointSettingsWindowsMonitorEnum, EndpointUpdatePolicyEnum, FileTagOptionsTypeEnum, FileTypes, IncidentResponseEnum, LogoStyleEnum, NotificationTypeEnum, NotifyStatusEnum, PeriodEnum, ProcessingStateEnum, RealTimeResponseDateTypeEnum, ResponseMessages, StatusMessages, Type_SQLTypeEnum, UserReactionMessages, UserRoleEnum, UserStateEnum, ZoneEnum

// EXTERNAL MODULE: ./node_modules/axios/index.js
var axios = __webpack_require__(9669);
var axios_default = /*#__PURE__*/__webpack_require__.n(axios);
;// CONCATENATED MODULE: ./src/libs/api/index.ts
function cancelable(p, source) {
    const promiseAny = p;
    promiseAny.cancel = ()=>source.cancel("Request was canceled");
    const resolve = promiseAny.then.bind(p);
    promiseAny.then = (res, rej)=>cancelable(resolve(res, rej), source);
    return promiseAny;
}

;// CONCATENATED MODULE: ./src/api/utils.ts
/* eslint-disable */ // prettier-disable
// prettier-ignore
// Code generated by api2. DO NOT EDIT.


function route(method, url, // @ts-ignore
requestMapping, // @ts-ignore
responseMapping) {
    return Object.assign((data)=>{
        let params = null;
        if (method === "GET") {
            params = data;
            data = null;
        }
        const c = axios_default().CancelToken.source();
        return cancelable(axios_default().request({
            method: method,
            url: url,
            data,
            cancelToken: c.token,
            params: params
        }).then((el)=>el.data), c);
    }, {
        method: method,
        url
    });
}
function firstSuccessfulPromise(promises) {
    let errorsCount = 0;
    return new Promise((resolve, reject)=>{
        promises.forEach((p)=>{
            p.then((result)=>{
                resolve(result);
            }).catch(()=>{
                // do nothing, wait for the next promise to resolve
                errorsCount++;
                if (errorsCount >= promises.length) {
                    reject();
                }
            });
        });
    });
}

;// CONCATENATED MODULE: ./src/api/gen.ts
/* eslint-disable */ // prettier-disable
// prettier-ignore
// Code generated by api2. DO NOT EDIT.

const api = {
    antitamper: {
        Service: {
            RevealPassword: route("POST", "/v1/password/reveal", {
                "header": [
                    "Authorization"
                ],
                "json": [
                    "reason",
                    "enabled",
                    "endpoint_group_id"
                ]
            }, {
                "json": [
                    "password"
                ]
            })
        }
    },
    auth: {
        AuthService: {
            UserInvite: route("POST", "/v2/user-management/users/invite", {}, {
                "json": [
                    "sign_in_link",
                    "user_id"
                ]
            }),
            MFAReset: route("POST", "/v2/user-management/users/mfa-reset", {
                "json": [
                    "id"
                ]
            }, {}),
            UpdateEnforceMFA: route("POST", "/v2/user-management/users/mfa-update", {
                "json": [
                    "provider",
                    "enabled"
                ]
            }, {}),
            GetJwtAuth: route("POST", "/v2/user-management/jwt-auth/create", {
                "json": [
                    "id"
                ]
            }, {
                "json": [
                    "jwt"
                ]
            }),
            ValidateJwtAuth: route("POST", "/v2/user-management/jwt-auth/validate", {
                "json": [
                    "jwt"
                ]
            }, {}),
            UserPatch: route("PATCH", "/v2/user-management/users", {
                "json": [
                    "password"
                ]
            }, {}),
            UserDelete: route("DELETE", "/v2/user-management/users", {
                "json": [
                    "id"
                ]
            }, {}),
            UsersList: route("GET", "/v2/user-management/users/list", {
                "header": [
                    "Authorization"
                ]
            }, {
                "json": [
                    "users"
                ]
            }),
            UserGet: route("POST", "/v2/user-management/users/get", {
                "json": [
                    "id"
                ]
            }, {}),
            UserPasswordReset: route("POST", "/v2/user-management/users/password-reset", {
                "json": [
                    "id"
                ]
            }, {}),
            ResetProvider: route("POST", "/v2/user-management/users/provider-reset", {
                "json": [
                    "id"
                ]
            }, {}),
            SAMLProvidersList: route("POST", "/v2/user-management/saml/list", {}, {
                "json": [
                    "providers"
                ]
            }),
            SAMLProviderCreate: route("POST", "/v2/user-management/saml", {}, {}),
            ListEnabledAuthProviders: route("GET", "/v2/user-management/enabled-auth-providers", {}, {
                "json": [
                    "providers"
                ]
            }),
            SAMLProviderPatch: route("PATCH", "/v2/user-management/saml", {}, {}),
            SAMLProviderDelete: route("DELETE", "/v2/user-management/saml", {
                "json": [
                    "id"
                ]
            }, {}),
            SAMLProviderGet: route("POST", "/v2/user-management/saml/get", {
                "json": [
                    "id"
                ]
            }, {}),
            UserGetCurrent: route("GET", "/v2/user-management/me", {}, {}),
            UserPasswordResetEmail: route("POST", "/v2/user-management/users/password-reset-email", {
                "json": [
                    "email"
                ]
            }, {}),
            Signup: route("POST", "/v2/user-management/signup", {
                "header": [
                    "Authorization"
                ]
            }, {}),
            SAMLProvidersListIDs: route("POST", "/v2/user-management/saml/list-ids", {}, {
                "json": [
                    "providers"
                ]
            })
        }
    },
    bucketsetup: {
        ExternalStorageConfigService: {
            TestBucket: route("POST", "/v1/external-buckets/verify", {
                "json": [
                    "bucket"
                ]
            }, {
                "json": [
                    "can_read",
                    "can_read_attributes",
                    "url"
                ]
            }),
            CreateBucket: route("POST", "/v1/external-buckets", {
                "json": [
                    "bucket"
                ]
            }, {
                "json": [
                    "id"
                ]
            }),
            GetConfigurationInfo: route("GET", "/v1/external-buckets/config", {}, {
                "json": [
                    "gcp",
                    "aws",
                    "test_filename"
                ]
            }),
            ListBuckets: route("GET", "/v1/external-buckets", {}, {
                "json": [
                    "buckets"
                ]
            }),
            GetBucket: route("GET", "/v1/external-buckets/get", {
                "query": [
                    "id"
                ]
            }, {
                "json": [
                    "bucket"
                ]
            }),
            UpdateBucket: route("PUT", "/v1/external-buckets", {
                "json": [
                    "bucket"
                ]
            }, {}),
            DeleteBucket: route("DELETE", "/v1/external-buckets", {
                "json": [
                    "id"
                ]
            }, {})
        }
    },
    cloudproxy: {
        Service: {
            HandleGet: route("POST", "/v1/external-content/get", {
                "json": [
                    "url",
                    "content_type",
                    "text_limit"
                ]
            }, {
                "json": [
                    "report",
                    "image",
                    "text",
                    "has_more_data"
                ]
            })
        }
    },
    directory: {
        DirectoryService: {
            FindUser: route("POST", "/v1/directory/user/find", {
                "json": [
                    "filter"
                ]
            }, {
                "json": [
                    "user"
                ]
            }),
            GenPortalLink: route("GET", "/v1/directory/portal-link", {}, {
                "json": [
                    "link"
                ]
            }),
            ListDirectories: route("GET", "/v1/directory/list", {}, {
                "json": [
                    "mapped_user_count",
                    "directories"
                ]
            }),
            DeleteDirectory: route("DELETE", "/v1/directory/delete", {
                "json": [
                    "id"
                ]
            }, {
                "json": [
                    "message"
                ]
            }),
            GetDirectoryEndpointFields: route("GET", "/v1/directory/endpoint/fields", {}, {
                "json": [
                    "fields"
                ]
            }),
            GetCustomMappingsList: route("POST", "/v1/directory/custom-mappings/list", {}, {
                "json": [
                    "list"
                ]
            }),
            UpsertCustomMapping: route("POST", "/v1/directory/custom-mappings/upsert", {
                "json": [
                    "sid",
                    "machine_id",
                    "email",
                    "local_user_name"
                ]
            }, {
                "json": [
                    "mappings"
                ]
            }),
            DeleteCustomMapping: route("DELETE", "/v1/directory/custom-mappings/delete", {
                "json": [
                    "machine_id",
                    "local_user_name"
                ]
            }, {}),
            DirectoryUsersCount: route("GET", "/v1/directory/users/counts", {}, {
                "json": [
                    "counts"
                ]
            })
        }
    },
    endpointsstatusapi: {
        ServiceInterface: {
            Search2: route("POST", "/v1/endpoints-status/_search2", {
                "json": [
                    "filters",
                    "sort_by",
                    "sort_ascending",
                    "page_id",
                    "size"
                ]
            }, {
                "json": [
                    "total_records",
                    "records",
                    "next_page_id"
                ]
            }),
            Export: route("GET", "/v1/endpoints-status/export", {
                "query": [
                    "id"
                ]
            }, {}),
            StatusGroups: route("POST", "/v1/endpoints-status/_status_groups", {}, {
                "json": [
                    "groups",
                    "status2group"
                ]
            }),
            Suggest: route("POST", "/v1/endpoints-status/_suggest", {
                "json": [
                    "filters",
                    "query",
                    "column",
                    "sort_ascending",
                    "page_id",
                    "size"
                ]
            }, {
                "json": [
                    "total_records",
                    "values",
                    "next_page_id"
                ]
            }),
            Unhealthy: route("POST", "/v1/endpoints-status/_unhealthy", {}, {
                "json": [
                    "count",
                    "high_attention_count"
                ]
            }),
            Counts: route("POST", "/v1/endpoints-status/_counts", {
                "json": [
                    "inputs"
                ]
            }, {
                "json": [
                    "counts"
                ]
            }),
            MarkDeleted: route("POST", "/v1/endpoints-status/_mark_deleted", {
                "json": [
                    "filters",
                    "new_value"
                ]
            }, {}),
            SetGroup: route("POST", "/v1/endpoints-status/_set_group", {
                "json": [
                    "filters",
                    "group_id"
                ]
            }, {}),
            GetEndpointInactivityTimeout: route("POST", "/v1/endpoints-status/_get_endpoint_inactivity_timeout", {}, {
                "json": [
                    "timeout_seconds"
                ]
            }),
            SetEndpointInactivityTimeout: route("POST", "/v1/endpoints-status/_set_endpoint_inactivity_timeout", {
                "json": [
                    "timeout_seconds"
                ]
            }, {}),
            GetDefaultPolicies: route("GET", "/v1/endpoint-updates/default_policies", {}, {
                "json": [
                    "windows",
                    "macos",
                    "settings",
                    "settings_timestamp",
                    "uninstall_enabled"
                ]
            }),
            SetDefaultPolicies: route("POST", "/v1/endpoint-updates/default_policies", {
                "json": [
                    "windows",
                    "macos",
                    "settings",
                    "settings_timestamp"
                ]
            }, {}),
            ResetDefaultPolicies: route("POST", "/v1/endpoint-updates/default_policies/reset", {}, {}),
            AddGroup: route("POST", "/v1/endpoint-updates/group/add", {
                "json": [
                    "group"
                ]
            }, {
                "json": [
                    "id"
                ]
            }),
            UpdateGroupsBulk: route("POST", "/v1/endpoint-updates/group/update_bulk", {
                "json": [
                    "group"
                ]
            }, {}),
            UpdateGroup: route("POST", "/v1/endpoint-updates/group/update", {
                "json": [
                    "group"
                ]
            }, {}),
            ListGroups: route("POST", "/v1/endpoint-updates/group/list", {}, {
                "json": [
                    "groups"
                ]
            }),
            DeleteGroup: route("POST", "/v1/endpoint-updates/group/delete", {
                "json": [
                    "id"
                ]
            }, {}),
            UpdateV1: route("POST", "/v1/endpoints-status-update", {
                "json": [
                    "hostname",
                    "os",
                    "os_version",
                    "lightbeam_version"
                ]
            }, {}),
            UpdateV2: route("POST", "/v2/endpoints-status/update", {
                "json": [
                    "hostname",
                    "endpoint_id",
                    "machine_serial_number",
                    "os",
                    "os_version",
                    "lightbeam_version",
                    "errors",
                    "users",
                    "computer_groups"
                ]
            }, {})
        }
    },
    eventsapi: {
        Service: {
            Aggregations: route("POST", "/v2/events/aggregations", {
                "json": [
                    "global_filter",
                    "preview_dataset",
                    "preview_policy",
                    "aggregations"
                ]
            }, {
                "json": [
                    "aggregations"
                ]
            }),
            MViewStatus: route("POST", "/v2/events/mview-status", {}, {
                "json": [
                    "is_precomputed_ready",
                    "stale_as_of"
                ]
            })
        }
    },
    filetagsapi: {
        Service: {
            List: route("GET", "/v1/filetags", {}, {
                "json": [
                    "tags"
                ]
            }),
            Fetch: route("POST", "/v1/filetags", {
                "json": [
                    "id"
                ]
            }, {
                "json": [
                    "tag"
                ]
            }),
            Add: route("PUT", "/v1/filetags", {
                "json": [
                    "tag"
                ]
            }, {
                "json": [
                    "id"
                ]
            }),
            Update: route("PATCH", "/v1/filetags", {
                "json": [
                    "id",
                    "tag"
                ]
            }, {}),
            Delete: route("DELETE", "/v1/filetags", {
                "json": [
                    "id"
                ]
            }, {})
        }
    },
    filtersapi: {
        Service: {
            FiltersToCel: route("POST", "/v2/filters/to-cel", {
                "json": [
                    "filters"
                ]
            }, {
                "json": [
                    "cel_string"
                ]
            }),
            ValidateCelFilters: route("POST", "/v2/filters/validate-cel-filters", {
                "json": [
                    "expressions"
                ]
            }, {
                "json": [
                    "expressions"
                ]
            })
        }
    },
    irm: {
        Service: {
            GetRiskyUsers: route("POST", "/v1/irm/users/list", {
                "json": [
                    "filter",
                    "sort",
                    "fields",
                    "page_size",
                    "offset",
                    "events_filter"
                ]
            }, {
                "json": [
                    "total",
                    "records"
                ]
            }),
            GetRiskyUsersCounts: route("POST", "/v1/irm/users/counts", {
                "json": [
                    "filter",
                    "counters"
                ]
            }, {
                "json": [
                    "counts"
                ]
            }),
            GetRiskyUserFieldsValusCount: route("POST", "/v1/irm/users/fields-values-count", {}, {
                "json": [
                    "fields"
                ]
            }),
            ResetUserRiskScore: route("POST", "/v1/irm/users/risk/reset", {
                "header": [
                    "Authorization"
                ],
                "json": [
                    "matchers",
                    "comment"
                ]
            }, {}),
            GetTimeline: route("POST", "/v1/irm/timeline", {
                "json": [
                    "times_filter",
                    "filter",
                    "period_type",
                    "metrics"
                ]
            }, {
                "json": [
                    "filter",
                    "records"
                ]
            }),
            Suggest: route("POST", "/v1/irm/suggest", {
                "json": [
                    "fields"
                ]
            }, {
                "json": [
                    "fields"
                ]
            }),
            ListUserRiskGroups: route("POST", "/v1/irm/user_risk_group/list", {}, {
                "json": [
                    "groups"
                ]
            }),
            GetUserRiskGroup: route("POST", "/v1/irm/user_risk_group/get", {
                "json": [
                    "id"
                ]
            }, {
                "json": [
                    "group"
                ]
            }),
            AddUserRiskGroup: route("POST", "/v1/irm/user_risk_group/add", {
                "header": [
                    "Authorization"
                ],
                "json": [
                    "group"
                ]
            }, {
                "json": [
                    "id"
                ]
            }),
            UpdateUserRiskGroups: route("POST", "/v1/irm/user_risk_group/update", {
                "header": [
                    "Authorization"
                ],
                "json": [
                    "groups"
                ]
            }, {}),
            DeleteUserRiskGroup: route("POST", "/v1/irm/user_risk_group/delete", {
                "header": [
                    "Authorization"
                ],
                "json": [
                    "id"
                ]
            }, {})
        }
    },
    logoapi: {
        Service: {
            Fetch: route("POST", "/v1/logo/fetch", {
                "json": [
                    "return_data"
                ]
            }, {
                "json": [
                    "sha1_hash",
                    "data",
                    "style"
                ]
            }),
            Update: route("POST", "/v1/logo/update", {
                "json": [
                    "data",
                    "style"
                ]
            }, {
                "json": [
                    "sha1_hash"
                ]
            }),
            Delete: route("POST", "/v1/logo/delete", {}, {})
        }
    },
    riskydashboard: {
        ServiceInterface: {
            AddDataset: route("POST", "/v1/risky-dashboard/dataset/add", {
                "header": [
                    "Authorization"
                ],
                "json": [
                    "dataset"
                ]
            }, {
                "json": [
                    "id"
                ]
            }),
            GetDataset: route("POST", "/v1/risky-dashboard/dataset/get", {
                "json": [
                    "id"
                ]
            }, {
                "json": [
                    "dataset"
                ]
            }),
            ListDatasets: route("POST", "/v1/risky-dashboard/dataset/list", {
                "json": [
                    "filter"
                ]
            }, {
                "json": [
                    "datasets"
                ]
            }),
            UpdateDataset: route("POST", "/v1/risky-dashboard/dataset/update", {
                "header": [
                    "Authorization"
                ],
                "json": [
                    "dataset"
                ]
            }, {}),
            DeleteDataset: route("POST", "/v1/risky-dashboard/dataset/delete", {
                "header": [
                    "Authorization"
                ],
                "json": [
                    "id"
                ]
            }, {}),
            AddCategory: route("POST", "/v1/risky-dashboard/category/add", {
                "header": [
                    "Authorization"
                ],
                "json": [
                    "category"
                ]
            }, {
                "json": [
                    "id"
                ]
            }),
            GetCategory: route("POST", "/v1/risky-dashboard/category/get", {
                "json": [
                    "id"
                ]
            }, {
                "json": [
                    "category"
                ]
            }),
            ListCategories: route("POST", "/v1/risky-dashboard/category/list", {
                "json": [
                    "filter"
                ]
            }, {
                "json": [
                    "categories"
                ]
            }),
            UpdateCategory: route("POST", "/v1/risky-dashboard/category/update", {
                "header": [
                    "Authorization"
                ],
                "json": [
                    "category"
                ]
            }, {}),
            DeleteCategory: route("POST", "/v1/risky-dashboard/category/delete", {
                "header": [
                    "Authorization"
                ],
                "json": [
                    "id"
                ]
            }, {}),
            TotalCount: route("POST", "/v1/risky-dashboard/count/total", {
                "json": [
                    "datasets_filter",
                    "categories_filter",
                    "users_filter",
                    "times_filter",
                    "locations_filter_v2",
                    "locations_filters",
                    "global_filter",
                    "statuses"
                ]
            }, {
                "json": [
                    "counts"
                ]
            }),
            DatasetsCountV2: route("POST", "/v1/risky-dashboard/count/datasets2", {
                "json": [
                    "categories_filter",
                    "users_filter",
                    "times_filter",
                    "locations_filter_v2",
                    "locations_filters",
                    "statuses",
                    "include_irrelevant",
                    "include_all_datasets_record"
                ]
            }, {
                "json": [
                    "records"
                ]
            }),
            CategoriesCountV2: route("POST", "/v1/risky-dashboard/count/categories2", {
                "json": [
                    "datasets_filter",
                    "statuses",
                    "locations_filter_v2",
                    "locations_filters",
                    "users_filter",
                    "times_filter",
                    "include_irrelevant",
                    "include_all_categories_record",
                    "include_uncategorized"
                ]
            }, {
                "json": [
                    "categories"
                ]
            }),
            UsersCount: route("POST", "/v1/risky-dashboard/count/users", {
                "json": [
                    "datasets_filter",
                    "status",
                    "categories_filter",
                    "locations_filter_v2",
                    "locations_filters",
                    "times_filter",
                    "selected_severities",
                    "global_filter",
                    "user_contains",
                    "page_id",
                    "count"
                ]
            }, {
                "json": [
                    "records",
                    "next_page_id",
                    "total"
                ]
            }),
            TimesCount: route("POST", "/v1/risky-dashboard/count/times", {
                "json": [
                    "datasets_filter",
                    "status",
                    "categories_filter",
                    "locations_filter_v2",
                    "locations_filters",
                    "users_filter",
                    "times_filter",
                    "global_filter",
                    "period",
                    "dataflows",
                    "locations",
                    "users"
                ]
            }, {
                "json": [
                    "period_starts",
                    "dataflows_counts",
                    "locations_counts",
                    "users_counts"
                ]
            }),
            Locations: route("POST", "/v1/risky-dashboard/locations", {
                "json": [
                    "status",
                    "side_selector",
                    "datasets_filter",
                    "categories_filter",
                    "users_filter",
                    "times_filter",
                    "locations_filter_v2",
                    "locations_filters",
                    "category_severity_filter",
                    "dataset_sensitivity_filter",
                    "global_filter",
                    "expansions",
                    "no_default_expansions",
                    "page",
                    "page_size",
                    "location_contains"
                ]
            }, {
                "json": [
                    "records",
                    "total_top_records"
                ]
            }),
            EdgeView: route("POST", "/v1/risky-dashboard/edge-view", {
                "json": [
                    "datasets_filter",
                    "statuses",
                    "category_severity_filter",
                    "dataset_sensitivity_filter",
                    "categories_filter",
                    "locations_filter_v2",
                    "locations_filters",
                    "users_filter",
                    "times_filter",
                    "global_filter",
                    "page_size",
                    "page_id"
                ]
            }, {
                "json": [
                    "records",
                    "next_page_id",
                    "total"
                ]
            }),
            EdgeViewExport: route("GET", "/v1/risky-dashboard/edge-view-export", {
                "query": [
                    "id",
                    "include_description",
                    "hidden_columns"
                ]
            }, {}),
            ListViewByID: route("POST", "/v1/risky-dashboard/list-view-by-id", {
                "json": [
                    "flow_id_based_listview",
                    "edge_view_ids",
                    "expansion_ids",
                    "graphviz",
                    "dump_edges",
                    "load_all",
                    "num_preloaded_edges"
                ]
            }, {
                "json": [
                    "id_to_result",
                    "edges"
                ]
            }),
            CountIncidents: route("POST", "/v1/risky-dashboard/incident/count", {
                "json": [
                    "filters",
                    "column",
                    "column_contains",
                    "sort_ascending",
                    "page_id",
                    "max_items"
                ]
            }, {
                "json": [
                    "items",
                    "next_page_id"
                ]
            }),
            CountUnresolvedIncidents: route("POST", "/v1/risky-dashboard/incident/count-unresolved", {
                "json": [
                    "filter"
                ]
            }, {
                "json": [
                    "count"
                ]
            }),
            ListIncidents: route("POST", "/v1/risky-dashboard/incident/list", {
                "header": [
                    "Authorization"
                ],
                "json": [
                    "filters",
                    "sort_by",
                    "sort_desc",
                    "page_id",
                    "page_size"
                ]
            }, {
                "json": [
                    "incidents",
                    "total",
                    "next_page_id"
                ]
            }),
            ResolveIncidents: route("POST", "/v1/risky-dashboard/incident/resolve", {
                "header": [
                    "Authorization",
                    "Referer"
                ],
                "json": [
                    "filters",
                    "new_status"
                ]
            }, {
                "json": [
                    "task_name"
                ]
            }),
            AssignIncident: route("POST", "/v1/risky-dashboard/incident/assign", {
                "header": [
                    "Authorization",
                    "Referer"
                ],
                "json": [
                    "assignee",
                    "filters"
                ]
            }, {
                "json": [
                    "task_name"
                ]
            }),
            UnblockIncidentsManually: route("POST", "/v1/risky-dashboard/incident/unblock", {
                "header": [
                    "Authorization"
                ],
                "json": [
                    "filters"
                ]
            }, {}),
            IncidentListView: route("POST", "/v1/risky-dashboard/incident/listview", {
                "json": [
                    "flow_id_based_listview",
                    "incident_ids",
                    "expansion_ids",
                    "graphviz",
                    "dump_edges",
                    "load_all",
                    "num_preloaded_edges"
                ]
            }, {
                "json": [
                    "id_to_result",
                    "edges"
                ]
            }),
            ExportIncidents: route("GET", "/v1/risky-dashboard/export", {
                "query": [
                    "hidden_columns",
                    "include_description",
                    "id"
                ]
            }, {}),
            ListAdminEvents: route("POST", "/v1/risky-dashboard/admin/events", {
                "json": [
                    "filters",
                    "page_id",
                    "page_size"
                ]
            }, {
                "json": [
                    "events",
                    "total",
                    "next_page_id"
                ]
            }),
            ListAdminTypes: route("POST", "/v1/risky-dashboard/admin/types", {}, {
                "json": [
                    "types"
                ]
            })
        }
    },
    screenshots: {
        Service: {
            Get: route("POST", "/v1/screenshots/get", {
                "json": [
                    "id"
                ]
            }, {
                "json": [
                    "screenshots"
                ]
            })
        }
    },
    shorturlapi: {
        Service: {
            Get: route("GET", "/v1/short-url", {
                "query": [
                    "id"
                ]
            }, {
                "json": [
                    "data"
                ]
            }),
            Create: route("POST", "/v1/short-url", {
                "json": [
                    "data"
                ]
            }, {
                "json": [
                    "id"
                ]
            })
        }
    },
    sid: {
        Service: {
            HandleGet: route("POST", "/v1/local-user/sid", {
                "json": [
                    "from",
                    "to",
                    "source",
                    "username"
                ]
            }, {
                "json": [
                    "info"
                ]
            })
        }
    },
    splunk: {
        Service: {
            GetSplunkConfig: route("GET", "/v1/splunk/parse-event-config", {}, {
                "json": [
                    "config"
                ]
            })
        }
    },
    suggestapi2: {
        Service: {
            MultiTyped: route("POST", "/v1/suggest/multi-typed", {
                "json": [
                    "search",
                    "fields",
                    "field_prefix",
                    "times_filter"
                ]
            }, {
                "json": [
                    "responses"
                ]
            })
        }
    },
    tasks: {
        Service: {
            GetTask: route("GET", "/v1/async-tasks/get", {
                "header": [
                    "Authorization"
                ],
                "json": [
                    "task_id"
                ]
            }, {
                "json": [
                    "task"
                ]
            }),
            ListTasks: route("GET", "/v1/async-tasks", {
                "header": [
                    "Authorization"
                ]
            }, {
                "json": [
                    "tasks"
                ]
            }),
            CancelTask: route("POST", "/v1/async-tasks/cancel", {
                "header": [
                    "Authorization"
                ],
                "json": [
                    "task_name"
                ]
            }, {})
        }
    },
    templateslibrary: {
        ITemplatesLibraryService: {
            ListPolicyTemplates: route("POST", "/v1/templates-library/policies", {}, {
                "json": [
                    "records",
                    "total"
                ]
            }),
            ListDatasetTemplates: route("POST", "/v1/templates-library/datasets", {}, {
                "json": [
                    "records",
                    "total"
                ]
            })
        }
    }
};
const Type_SQLTypeEnum = {
    "SQLType_ARRAY": 6,
    "SQLType_BOOL": 1,
    "SQLType_FLOAT": 3,
    "SQLType_INT": 2,
    "SQLType_STRING": 4,
    "SQLType_TIMESTAMP": 5,
    "SQLType_UNSPECIFIED": 0
};
const BucketTypeEnum = {
    "BucketTypeAzure": "azure",
    "BucketTypeGCP": "gcp",
    "BucketTypeS3": "aws",
    "BucketTypeS3Legacy": "aws-legacy",
    "BucketTypeS3LegacyRole": "aws-legacy-role",
    "BucketTypeUnknown": ""
};
const UserStateEnum = {
    "Active": "active",
    "Inactive": "inactive",
    "Suspended": "suspended"
};
const DirectoryTypeEnum = {
    "AzureSCIMV2_0": "azure scim v2.0",
    "GSuiteDirectory": "gsuite directory",
    "GenericSCIMV1_1": "generic scim v1.1",
    "GenericSCIMV2_0": "generic scim v2.0",
    "OktaSCIMV1_1": "okta scim v1.1",
    "OktaSCIMV2_0": "okta scim v2.0"
};
const DirectoryStateEnum = {
    "InvalidCredentials": "invalid_credentials",
    "Linked": "linked",
    "Unlinked": "unlinked"
};
const ColumnEnum = {
    "ColumnCount": "",
    "ColumnError": "error",
    "ColumnGroup": "group",
    "ColumnHostname": "hostname",
    "ColumnLightbeamVersion": "lightbeam_version",
    "ColumnNone": "",
    "ColumnOS": "os",
    "ColumnOSVersion": "os_version",
    "ColumnReportTime": "report_time",
    "ColumnSerialNumber": "machine_serial_number",
    "ColumnStatusAndRequiredAction": "status_and_required_action"
};
const RequiredActionEnum = {
    "RequiredActionAllowBrowserServices": "Allow browser services",
    "RequiredActionAllowFullDiskAccess": "Allow full disk access",
    "RequiredActionAllowScreenCapture": "Enable screen capture permission",
    "RequiredActionCheckChromeBrowserExtension": "Check Chrome browser extension",
    "RequiredActionCheckChromeBrowserExtensionPolicy": "Chrome extension policy conflict",
    "RequiredActionCheckEdgeBrowserExtension": "Check Edge browser extension",
    "RequiredActionCheckEdgeBrowserExtensionPolicy": "Check Edge browser extension policy",
    "RequiredActionCheckFirefoxBrowserExtension": "Check Firefox browser extension",
    "RequiredActionCheckSafariBrowserExtension": "Check Safari browser extension",
    "RequiredActionChromeExtensionOutdated": "Outdated Chrome extension",
    "RequiredActionCompromisedSensorIntegrity": "Compromised Sensor integrity",
    "RequiredActionContactAdmin": "Contact Admin",
    "RequiredActionCount": "",
    "RequiredActionEdgeExtensionOutdated": "Outdated Edge extension",
    "RequiredActionEnableSafariBrowserExtension": "Enable Safari browser extension",
    "RequiredActionFirefoxExtensionOutdated": "Outdated Firefox extension",
    "RequiredActionFixAccessibilityPermissions": "Fix accessibility permissions",
    "RequiredActionFixAutomationPermissions": "Fix automation permissions",
    "RequiredActionIntegrityCheckFailed": "Self-check Failed",
    "RequiredActionNone": "N/A",
    "RequiredActionOutlookPluginCrashed": "Outlook plugin crashed",
    "RequiredActionOutlookPluginDisabled": "Outlook plugin disabled",
    "RequiredActionOutlookPluginStopped": "Outlook plugin stopped",
    "RequiredActionProcessTerminated": "Sensor process terminated",
    "RequiredActionRestartChromeBrowser": "Restart Chrome browser",
    "RequiredActionRestartExcel": "Restart Excel",
    "RequiredActionRestartPowerPoint": "Restart PowerPoint",
    "RequiredActionRestartWord": "Restart Word",
    "RequiredActionSafariExtensionOutdated": "Outdated Safari extension",
    "RequiredActionSensorDisabled": "Sensor disabled",
    "RequiredActionSensorNonFunctional": "Non-functional Sensor",
    "RequiredActionSensorStopped": "Sensor stopped",
    "RequiredActionUninstall": "Uninstalled sensor",
    "RequiredActionUninstallWithWrongPassword": "Uninstall attempt",
    "RequiredActionUpdateSensor": "Update pending"
};
const LogoStyleEnum = {
    "LogoStyleBanner": "banner",
    "LogoStyleNormal": "logo"
};
const FileTagOptionsTypeEnum = {
    "FileTagOptionCaseInsensitive": "case_insensitive",
    "FileTagOptionNone": "none",
    "FileTagOptionRegularExpression": "regular_expression"
};
const EndpointIssueEnum = {
    "EndpointIssueChromeExtensionHasPolicyConflict": "chrome_extension_has_policy_conflict",
    "EndpointIssueChromeExtensionNeedsUpdate": "chrome_extension_needs_update",
    "EndpointIssueChromeExtensionNotInstalled": "chrome_extension_not_installed",
    "EndpointIssueChromeExtensionNotResponding": "chrome_extension_not_responding",
    "EndpointIssueChromeExtensionV2V3NotInstalled": "chrome_extension_v2_v3_not_installed",
    "EndpointIssueChromeExtensionV3NeedsUpdate": "chrome_extension_v3_needs_update",
    "EndpointIssueChromeExtensionV3NotInstalled": "chrome_extension_v3_not_installed",
    "EndpointIssueCount": "",
    "EndpointIssueEdgeExtensionHasPolicyConflict": "msedge_extension_has_policy_conflict",
    "EndpointIssueEdgeExtensionNeedsUpdate": "msedge_extension_needs_update",
    "EndpointIssueEdgeExtensionNotInstalled": "msedge_extension_not_installed",
    "EndpointIssueEdgeExtensionNotResponding": "msedge_extension_not_responding",
    "EndpointIssueFileWasCreated": "file_was_created",
    "EndpointIssueFileWasDeleted": "file_was_deleted",
    "EndpointIssueFileWasModified": "file_was_modified",
    "EndpointIssueFileWasRenamed": "file_was_renamed",
    "EndpointIssueFirefoxExtensionNeedsUpdate": "firefox_extension_needs_update",
    "EndpointIssueFirefoxExtensionNotInstalled": "firefox_extension_not_installed",
    "EndpointIssueFirefoxExtensionNotResponding": "firefox_extension_not_responding",
    "EndpointIssueGeneralExpiredInstallToken": "general_expired_install_token",
    "EndpointIssueGeneralFileOpsServiceIsDisabled": "general_file_ops_service_is_disabled",
    "EndpointIssueGeneralIncompatibleSettingsFound": "general_incompatible_settings_found",
    "EndpointIssueGeneralIncompatibleSoftwareFound": "general_incompatible_software_found",
    "EndpointIssueGeneralMissingInstallToken": "general_missing_install_token",
    "EndpointIssueGeneralSettingsOutOfDate": "general_settings_out_of_date",
    "EndpointIssueGeneralUpdateRequired": "general_update_required",
    "EndpointIssueInactive": "inactive",
    "EndpointIssueIntegrityCheckFailed": "integrity_check_error",
    "EndpointIssueMacosAccessibilityPermissionNotSet": "macos_accessibility_permission_not_set",
    "EndpointIssueMacosAutomationPermissionNotSet": "macos_automation_permission_not_set",
    "EndpointIssueMacosBrowserServiceIsDisabled": "macos_browser_service_is_disabled",
    "EndpointIssueMacosManualInstall": "macos_profile_removed_or_manual_install",
    "EndpointIssueMacosNoFullDiskAccess": "macos_no_full_disk_access",
    "EndpointIssueMacosPermissionsNotInitialized": "macos_permissions_not_initialized",
    "EndpointIssueMacosProfileNotCompatible": "macos_profile_not_compatible",
    "EndpointIssueMacosProfileNotFound": "macos_profile_not_found",
    "EndpointIssueMacosScreenCapturePermissionNotSet": "macos_screencapture_permission_not_set",
    "EndpointIssueOK": "ok",
    "EndpointIssueRegistryWasCompromised": "registry_was_compromised",
    "EndpointIssueSafariExtensionNeedsUpdate": "safari_extension_needs_update",
    "EndpointIssueSafariExtensionNotInstalled": "safari_extension_not_installed",
    "EndpointIssueSafariExtensionNotResponding": "safari_extension_not_responding",
    "EndpointIssueSensorDowntimeLimitWasReached": "sensor_downtime_limit_was_reached",
    "EndpointIssueServiceStoppedByConfig": "service_stopped_by_config",
    "EndpointIssueServiceWasStopped": "service_was_stopped",
    "EndpointIssueUninstallSuccess": "uninstall_success",
    "EndpointIssueUninstallSuccessWithPassword": "uninstall_success_with_password",
    "EndpointIssueUninstallWrongPassword": "uninstall_wrong_password",
    "EndpointIssueUnknown": "",
    "EndpointIssueWinBackendConnectorServiceIsDisabled": "win_backend_connector_service_is_disabled",
    "EndpointIssueWinClipboardMonitorServiceIsDisabled": "win_clipboard_monitor_service_is_disabled",
    "EndpointIssueWinDriverStartError": "win_driver_start_error",
    "EndpointIssueWinExcelPluginCrashed": "win_excel_plugin_crashed",
    "EndpointIssueWinExcelPluginDisabled": "win_excel_plugin_disabled",
    "EndpointIssueWinExcelRestartRequired": "win_excel_restart_required",
    "EndpointIssueWinHealthMonitorServiceIsDisabled": "win_health_monitor_service_is_disabled",
    "EndpointIssueWinMainServiceIsDisabled": "win_main_service_is_disabled",
    "EndpointIssueWinOfficeToolsMissing": "win_office_tools_missing",
    "EndpointIssueWinOutlookExchangeCacheDisabled": "win_outlook_exchange_cache_disabled",
    "EndpointIssueWinOutlookPluginCrashed": "win_outlook_plugin_crashed",
    "EndpointIssueWinOutlookPluginDisabled": "win_outlook_plugin_disabled",
    "EndpointIssueWinOutlookRestartRequired": "win_outlook_restart_required",
    "EndpointIssueWinPowerPointPluginCrashed": "win_powerpoint_plugin_crashed",
    "EndpointIssueWinPowerPointPluginDisabled": "win_powerpoint_plugin_disabled",
    "EndpointIssueWinPowerPointRestartRequired": "win_powerpoint_restart_required",
    "EndpointIssueWinProcessWasTerminated": "win_process_was_terminated",
    "EndpointIssueWinServiceWasStopped": "win_service_was_stopped",
    "EndpointIssueWinUninstallSuccess": "win_uninstall_success",
    "EndpointIssueWinUninstallSuccessWithPassword": "win_uninstall_success_with_password",
    "EndpointIssueWinUninstallWrongPassword": "win_uninstall_wrong_password",
    "EndpointIssueWinUserHasNotLoggedOutAfterInstallation": "win_user_has_not_logged_out_after_installation",
    "EndpointIssueWinWordPluginCrashed": "win_word_plugin_crashed",
    "EndpointIssueWinWordPluginDisabled": "win_word_plugin_disabled",
    "EndpointIssueWinWordRestartRequired": "win_word_restart_required"
};
const EndpointUpdatePolicyEnum = {
    "EndpointUpdatePolicyAutoLatest": "latest",
    "EndpointUpdatePolicyAutoLatestN": "latest_n",
    "EndpointUpdatePolicyFixed": "fixed",
    "EndpointUpdatePolicyLTSAutoPrevious": "previous_lts",
    "EndpointUpdatePolicyOff": "off",
    "EndpointUpdatePolicyPlatformDefault": "platform_default"
};
const DatasetDomainEnum = {
    "DatasetDomainCorporate": "corporate",
    "DatasetDomainPartner": "partner",
    "DatasetDomainPersonal": "personal",
    "DatasetDomainPublic": "public"
};
const SearchFieldEnum = {
    "SearchFieldAppMainWindowTitle": "app_main_window_title",
    "SearchFieldBrowserPageTitle": "browser_page_title",
    "SearchFieldCloudApp": "cloud_app",
    "SearchFieldCloudAppAccount": "cloud_app_account",
    "SearchFieldCloudDestinationGroups": "cloud_destination_groups",
    "SearchFieldCloudDomain": "cloud_domain",
    "SearchFieldCloudMessagingGroups": "cloud_messaging_groups",
    "SearchFieldCloudMessagingUsers": "cloud_messaging_users",
    "SearchFieldCloudProvider": "cloud_provider",
    "SearchFieldCloudSharedRole": "cloud_shared_role",
    "SearchFieldCloudSharedType": "cloud_shared_type",
    "SearchFieldCloudSharedWith": "cloud_shared_with",
    "SearchFieldCloudWorkspace": "cloud_workspace",
    "SearchFieldContentAttributes": "personal_info_counts",
    "SearchFieldCount": "",
    "SearchFieldDataSize": "data_size",
    "SearchFieldDocumentTags": "content_tags",
    "SearchFieldDomain": "domain",
    "SearchFieldEmailAddress": "email_account",
    "SearchFieldEmailSubject": "email_subject",
    "SearchFieldEndpointAppCommandLine": "app_commandline",
    "SearchFieldEndpointApplication": "app_name",
    "SearchFieldEventType": "event_type",
    "SearchFieldFileName": "path_basename",
    "SearchFieldFilePath": "path",
    "SearchFieldFileSize": "file_size",
    "SearchFieldFileType": "extension",
    "SearchFieldHostname": "hostname",
    "SearchFieldKeywordInMetadata": "keywords",
    "SearchFieldLocalUserGroups": "group_name",
    "SearchFieldLocalUserName": "local_user_name",
    "SearchFieldLocationCategory": "location",
    "SearchFieldMD5Hash": "md5_hash",
    "SearchFieldPrinterName": "printer_name",
    "SearchFieldRemovableMediaName": "removable_device_name",
    "SearchFieldRemovableMediaProductID": "removable_device_product_id",
    "SearchFieldRemovableMediaSerialNo": "removable_device_usb_id",
    "SearchFieldRemovableMediaType": "media_category",
    "SearchFieldRemovableMediaVendorID": "removable_device_vendor_id",
    "SearchFieldSensorName": "sensor_name",
    "SearchFieldURL": "url",
    "SearchFieldUserDirectoryDepartment": "user.department",
    "SearchFieldUserDirectoryEmailAddresses": "user.emails.value",
    "SearchFieldUserDirectoryEmployeeStatus": "user.employee_status",
    "SearchFieldUserDirectoryFirstName": "user.first_name",
    "SearchFieldUserDirectoryFullName": "user.full_name",
    "SearchFieldUserDirectoryGroupNames": "user.user_groups.name",
    "SearchFieldUserDirectoryLastName": "user.last_name",
    "SearchFieldUserDirectoryManagerEmailAddress": "user.manager_email",
    "SearchFieldUserDirectoryManagerName": "user.manager_name",
    "SearchFieldUserDirectoryPrimaryAddressCity": "user.primary_address_city",
    "SearchFieldUserDirectoryPrimaryAddressCountry": "user.primary_address_country",
    "SearchFieldUserDirectoryPrimaryAddressRegion": "user.primary_address_region",
    "SearchFieldUserDirectoryPrimaryAddressZipCode": "user.primary_address_zip_code",
    "SearchFieldUserDirectoryPrimaryEmailAddress": "user.primary_email",
    "SearchFieldUserDirectoryRemote": "user.remote",
    "SearchFieldUserDirectoryStartDate": "user.start_date",
    "SearchFieldUserDirectoryTerminationDate": "user.termination_date",
    "SearchFieldUserDirectoryTitle": "user.title",
    "SearchFieldUserDirectoryUserName": "user.username",
    "SearchFieldUserRiskGroupNames": "user.risk_groups.name",
    "SearchFieldUserRiskGroups": "user.risk_groups.id",
    "SearchFieldWebsiteCategory": "category",
    "SearchFieldZone": "zone"
};
const OperatorEnum = {
    "OperatorContains": "contains",
    "OperatorEndsWith": "ends_with",
    "OperatorEqualsOrIsSubdomain": "equals_or_is_subdomain",
    "OperatorEqualsOrIsSubpath": "equals_or_is_subpath",
    "OperatorHasMultitag": "has_multitag",
    "OperatorHasPhrase": "has_phrase",
    "OperatorHasTag": "has_tag",
    "OperatorHasText": "has_text",
    "OperatorIs": "is",
    "OperatorIsBetween": "is_between",
    "OperatorIsEqualTo": "is_equal_to",
    "OperatorIsGreaterThan": "is_greater_than",
    "OperatorIsLessThan": "is_less_than",
    "OperatorMatchesQuery": "matches_query",
    "OperatorMatchesRegexp": "matches_regexp",
    "OperatorStartsWith": "starts_with"
};
const SelectorEnum = {
    "SelectorMatchAll": "match_all",
    "SelectorMatchAny": "match_any"
};
const SizeUnitEnum = {
    "SizeUnitByte": "B",
    "SizeUnitGigabyte": "GB",
    "SizeUnitKilobyte": "KB",
    "SizeUnitMegabyte": "MB",
    "SizeUnitTerabyte": "TB",
    "SizeUnitUnspecified": ""
};
const CategoryStatusEnum = {
    "CategoryStatusAny": "any",
    "CategoryStatusApproved": "approved",
    "CategoryStatusLowRisky": "low_risky",
    "CategoryStatusNeedsReview": "needs_review",
    "CategoryStatusRisky": "risky",
    "CategoryStatusRiskyOrLow": "risky_or_low"
};
const NotifyStatusEnum = {
    "NotifyStatusDisabled": "",
    "NotifyStatusOnBlock": "on_block",
    "NotifyStatusOnIncident": "on_incident"
};
const RealTimeResponseDateTypeEnum = {
    "Day": "day",
    "Hour": "hour",
    "Minute": "minute",
    "Month": "month",
    "Week": "week"
};
const IncidentActionEnum = {
    "IncidentActionBlock": "block",
    "IncidentActionNone": "",
    "IncidentActionWarn": "warn"
};
const SelectionTypeEnum = {
    "SelectionTypeDataset": "dataset",
    "SelectionTypeSensitivity": "sensitivity"
};
const SideSelectorEnum = {
    "SideSelectorBoth": "",
    "SideSelectorCategory": "category",
    "SideSelectorDataset": "dataset"
};
const PeriodEnum = {
    "Daily": "daily",
    "Hourly": "hourly",
    "Monthly": "monthly",
    "Weekly": "weekly"
};
const LocationEnum = {
    "LocationCloudApps": "cloud_apps",
    "LocationCloudStorage": "cloud_storage",
    "LocationEndpoint": "endpoint",
    "LocationEndpointApps": "endpoint_apps",
    "LocationMail": "mail",
    "LocationPrinter": "printer",
    "LocationRemovableMedia": "removable_media",
    "LocationShare": "share",
    "LocationUnknown": "",
    "LocationWebsite": "website"
};
const CloudProviderEnum = {
    "CloudProviderBox": "box",
    "CloudProviderDropbox": "dropbox",
    "CloudProviderGoogleCloud": "google_cloud",
    "CloudProviderOffice365": "office_365",
    "CloudProviderOpenAI": "openai",
    "CloudProviderSlack": "slack",
    "CloudProviderUnknown": "",
    "CloudProvideriCloud": "icloud"
};
const CloudAppEnum = {
    "CloudAppBingChat": "bing_chat",
    "CloudAppBox": "box",
    "CloudAppChatGPT": "chatgpt",
    "CloudAppDropbox": "dropbox",
    "CloudAppGDrive": "gdrive",
    "CloudAppOneDrive": "onedrive",
    "CloudAppSalesforce": "salesforce",
    "CloudAppSharepoint": "sharepoint",
    "CloudAppSlack": "slack",
    "CloudAppUnknown": "",
    "CloudAppiCloudDrive": "iclouddrive"
};
const ZoneEnum = {
    "ZoneExternal": "external",
    "ZoneInternal": "internal",
    "ZoneUnknown": "undefined"
};
const EventTypeEnum = {
    "EventTypeAppAccess": "app_access",
    "EventTypeAttachmentAdd": "attachment_add",
    "EventTypeAttachmentSave": "attachment_save",
    "EventTypeAttachmentSend": "attachment_send",
    "EventTypeClipboardCopypaste": "clipboard_copypaste",
    "EventTypeCopy": "copy",
    "EventTypeCreate": "create",
    "EventTypeCreateEdit": "create_edit",
    "EventTypeDelete": "delete",
    "EventTypeDlpScan": "dlp_scan",
    "EventTypeDownload": "download",
    "EventTypeEdit": "edit",
    "EventTypeMove": "move",
    "EventTypeReceive": "receive",
    "EventTypeReceivedEmail": "received_email",
    "EventTypeRename": "rename",
    "EventTypeRenameCopy": "rename_copy",
    "EventTypeSaveAs": "save_as",
    "EventTypeSend": "send",
    "EventTypeSentEmail": "sent_email",
    "EventTypeSentToPrinter": "sent_to_printer",
    "EventTypeShare": "share",
    "EventTypeUnknown": "",
    "EventTypeUnzip": "unzip",
    "EventTypeUpload": "upload",
    "EventTypeZip": "zip"
};
const ProcessingStateEnum = {
    "FAILED": "failed",
    "NEW": "new",
    "PROCESSED": "processed",
    "SKIPPED": "skipped"
};
const ResolutionStatusEnum = {
    "Ignored": "ignored",
    "InProgress": "in_progress",
    "Resolved": "resolved",
    "Unresolved": "unresolved"
};
const IncidentResponseEnum = {
    "IncidentResponseAccessRestricted": "access_restricted",
    "IncidentResponseAccessRestrictedExpired": "access_restricted_expired",
    "IncidentResponseAccessRestrictedRateLimited": "access_restricted_rate_limited",
    "IncidentResponseAccessRestrictedRemoved": "access_restricted_removed",
    "IncidentResponseNotApplicable": "not_applicable",
    "IncidentResponsePending": "pending",
    "IncidentResponseSkippedRateLimited": "skipped_rate_limited",
    "IncidentResponseSkippedTimeout": "skipped_timeout",
    "IncidentResponseWarningReceived": "warning_received",
    "IncidentResponseWarningShown": "warned"
};
const IncidentReactionEnum = {
    "IncidentReactionAcknowledged": "acknowledged",
    "IncidentReactionNone": "none",
    "IncidentReactionNotApplicable": "not_applicable",
    "IncidentReactionProvidedExplanation": "provided_explanation",
    "IncidentReactionRequestedReview": "requested_review",
    "IncidentReactionRequestedUnblock": "requested_unblock",
    "IncidentReactionViewedWarning": "warned"
};
const AdminEventTypeEnum = {
    "AdminEventTypeCreatedCategory": "created_category",
    "AdminEventTypeCreatedDataset": "created_dataset",
    "AdminEventTypeCreatedUserRiskGroup": "created_user_risk_group",
    "AdminEventTypeDeletedCategory": "deleted_category",
    "AdminEventTypeDeletedDataset": "deleted_dataset",
    "AdminEventTypeDeletedUserRiskGroup": "deleted_user_risk_group",
    "AdminEventTypeEditedCategory": "edited_category",
    "AdminEventTypeEditedDataset": "edited_dataset",
    "AdminEventTypeEditedPolicyForCategory": "edited_policy_for_category",
    "AdminEventTypeEditedPolicyForDataset": "edited_policy_for_dataset",
    "AdminEventTypeEditedUserRiskGroup": "edited_user_risk_group",
    "AdminEventTypeNone": "none",
    "AdminEventTypeRenamedCategory": "renamed_category",
    "AdminEventTypeRenamedDataset": "renamed_dataset",
    "AdminEventTypeRevealPassword": "reveal_password"
};
const UserRoleEnum = {
    "UserRoleAdmin": "admin",
    "UserRoleInactive": "inactive",
    "UserRoleRbacUser": "rbac_user",
    "UserRoleUser": "user"
};
const DirectoryStatusEnum = {
    "InProgress": "in_progress",
    "Loaded": "loaded",
    "NotStarted": "not_started"
};
const NotificationTypeEnum = {
    "ExecutorV1": "executor_v1",
    "ExecutorV2": "executor_v2"
};
const DurationSecondsEnum = {};
const EndpointSettingsMonitorModeEnum = {
    "MonitorModeBlock": "block",
    "MonitorModeDisable": "disable",
    "MonitorModeTrace": "trace"
};
const EndpointSettingsScreenshotMacPermissionPolicyEnum = {
    "AskUser": "ask_user",
    "Silent": "silent"
};
const EndpointSettingsLogLevelEnum = {
    "Debug": "debug",
    "Error": "error",
    "Info": "info",
    "Trace": "trace",
    "Warn": "warn"
};
const EndpointSettingsHookEngineTypeEnum = {
    "EasyHook": "easyhook",
    "MadcHook": "madchook"
};
const EndpointSettingsWindowsMonitorEnum = {
    "AppMonitor": "AppMonitor",
    "BrowserCommon": "BrowserCommon",
    "BrowserUpload": "BrowserUpload",
    "Dlp": "Dlp",
    "Driver": "Driver",
    "ExplorerDirectoryRenameMonitor": "ExplorerDirectoryRenameMonitor",
    "ExplorerFileOpMonitor": "ExplorerFileOpMonitor",
    "FileDeleteMonitor": "FileDeleteMonitor",
    "Global": "Global",
    "KernelEventFilter": "KernelEventFilter",
    "OneDriveMonitor": "OneDriveMonitor",
    "OutlookCopyMonitor": "OutlookCopyMonitor",
    "OutlookDropToExplorerMonitor": "OutlookDropToExplorerMonitor",
    "SendToOutlookMonitor": "SendToOutlookMonitor",
    "Win10OutlookFileDropMonitor": "Win10OutlookFileDropMonitor"
};
const EndpointSettingsFilterTypeEnum = {
    "ExactMatch": "exact_match",
    "PrefixMatch": "prefix_match",
    "RegularExpression": "regex",
    "SubstringMatch": "substring_match"
};
const EndpointSettingsMergeModeEnum = {
    "Merge": "merge",
    "Replace": "replace"
};
const LocationCategoryValues = {
    "LocationCategoryCloudApps": "cloud_apps",
    "LocationCategoryCloudStorage": "cloud_storage",
    "LocationCategoryEndpoint": "endpoint",
    "LocationCategoryEndpointApps": "endpoint_apps",
    "LocationCategoryMail": "mail",
    "LocationCategoryPrinter": "printer",
    "LocationCategoryRemovableMedia": "removable_media",
    "LocationCategoryShare": "share",
    "LocationCategoryWebsite": "website",
    "LocationCategoryWebsiteBanking": "website.Banking",
    "LocationCategoryWebsiteCloudStorage": "website.Cloud Storage",
    "LocationCategoryWebsiteConsumerInstantMessaging": "website.Consumer Instant Messaging",
    "LocationCategoryWebsiteCorporateFinancial": "website.Corporate Financial",
    "LocationCategoryWebsiteCorporateMessagingAndConferencing": "website.Corporate Messaging and Conferencing",
    "LocationCategoryWebsiteCryptoCurrencies": "website.Crypto Currencies",
    "LocationCategoryWebsiteFileConverters": "website.File converters",
    "LocationCategoryWebsiteGambling": "website.Gambling",
    "LocationCategoryWebsiteGaming": "website.Gaming",
    "LocationCategoryWebsiteGraphicsDesignAndCAD": "website.Graphics, Design and CAD",
    "LocationCategoryWebsiteHRAndPayroll": "website.HR and Payroll",
    "LocationCategoryWebsiteIllegalDrugs": "website.Illegal Drugs",
    "LocationCategoryWebsiteIncognito": "website.Incognito",
    "LocationCategoryWebsiteJobBoardsAndRecruiting": "website.Job Boards and Recruiting",
    "LocationCategoryWebsiteMalwareAndHacking": "website.Malware and Hacking",
    "LocationCategoryWebsiteMusicAndVideo": "website.Music and Video",
    "LocationCategoryWebsiteOther": "website.Other",
    "LocationCategoryWebsitePhishing": "website.Phishing",
    "LocationCategoryWebsitePiracy": "website.Piracy",
    "LocationCategoryWebsiteResearchAndDevelopment": "website.Research and Development",
    "LocationCategoryWebsiteSalesAndCRM": "website.Sales and CRM",
    "LocationCategoryWebsiteShopping": "website.Shopping",
    "LocationCategoryWebsiteSocialMedia": "website.Social Media",
    "LocationCategoryWebsiteSoftwareDownloads": "website.Software Downloads",
    "LocationCategoryWebsiteSourceCodeManagement": "website.Source Code Management",
    "LocationCategoryWebsiteVPNAndProxies": "website.VPN and Proxies",
    "LocationCategoryWebsiteWebMail": "website.Web Mail"
};
const SearchFieldIsUsableInPolicies = {
    "app_commandline": true,
    "app_main_window_title": true,
    "app_name": true,
    "browser_page_title": true,
    "category": true,
    "cloud_app": true,
    "cloud_app_account": true,
    "cloud_destination_groups": true,
    "cloud_domain": true,
    "cloud_messaging_groups": true,
    "cloud_messaging_users": true,
    "cloud_provider": true,
    "cloud_shared_role": true,
    "cloud_shared_type": true,
    "cloud_shared_with": true,
    "cloud_workspace": true,
    "content_tags": false,
    "data_size": true,
    "domain": true,
    "email_account": true,
    "email_subject": false,
    "event_type": true,
    "extension": false,
    "file_size": true,
    "group_name": true,
    "hostname": true,
    "keywords": false,
    "local_user_name": true,
    "location": true,
    "md5_hash": false,
    "media_category": true,
    "path": true,
    "path_basename": false,
    "personal_info_counts": false,
    "printer_name": true,
    "removable_device_name": true,
    "removable_device_product_id": true,
    "removable_device_usb_id": true,
    "removable_device_vendor_id": true,
    "sensor_name": true,
    "url": true,
    "zone": true
};
const ResponseMessages = {
    "access_restricted": "Blocked",
    "access_restricted_expired": "Blocking expired",
    "access_restricted_rate_limited": "Blocked, Response skipped: throttled",
    "access_restricted_removed": "Blocking removed",
    "not_applicable": "N/A",
    "pending": "Response pending",
    "skipped_rate_limited": "Response skipped: throttled",
    "skipped_timeout": "Response skipped: timeout",
    "warned": "Warning shown",
    "warning_received": "Warning received by endpoint"
};
const UserReactionMessages = {
    "acknowledged": "Acknowledged",
    "none": "None",
    "not_applicable": "N/A",
    "provided_explanation": "Provided an explanation",
    "requested_review": "Requested review",
    "requested_unblock": "Requested unblock",
    "warned": "Viewed the warning"
};
const StatusMessages = {
    "any": "Any",
    "approved": "Approved",
    "low_risky": "Low",
    "needs_review": "Uncategorized",
    "risky": "High",
    "risky_or_low": "All"
};
const FileTypes = {
    "3D graphics, CAD": [
        "max",
        "3ds",
        "ma",
        "dwg",
        "nwd",
        "nwf",
        "nwc",
        "fbx",
        "dxf",
        "sketch",
        "vsd",
        "z3d",
        "x",
        "x3d",
        "psd",
        "ai"
    ],
    "Archives": [
        "7zip",
        "7z",
        "zip",
        "zipx",
        "tar",
        "tar.gz",
        "rar",
        "gz",
        "sit",
        "tcl",
        "tk",
        "jardiff",
        "rpb",
        "deb",
        "rpm",
        "pm",
        "der",
        "pl",
        "hqx",
        "xpi",
        "sea"
    ],
    "Audio": [
        "aif",
        "cda",
        "mid",
        "midi",
        "mp3",
        "mpa",
        "ogg",
        "wav",
        "wma",
        "wpl",
        "flac",
        "alac",
        "aac",
        "ra",
        "xspf",
        "m4a",
        "kar",
        "m3u8"
    ],
    "Databases": [
        "csv",
        "dat",
        "db",
        "dbf",
        "log",
        "mdb",
        "sav",
        "sql",
        "xml",
        "pdb",
        "tar"
    ],
    "Documents": [
        "doc",
        "docx",
        "odt",
        "pdf",
        "djvu",
        "rtf",
        "tex",
        "txt",
        "wks",
        "wps",
        "wpd",
        "pages",
        "atom",
        "css",
        "eot",
        "kmz",
        "kml",
        "htc",
        "htm",
        "html",
        "shtml",
        "xhtml",
        "wml",
        "wmlc",
        "rss",
        "mml"
    ],
    "Executables": [
        "jar",
        "jad",
        "war",
        "ear",
        "bin",
        "exe",
        "dll",
        "dmg",
        "iso",
        "img",
        "msi",
        "msm",
        "run",
        "apk",
        "app",
        "bat",
        "cgi",
        "com",
        "command",
        "gadget",
        "osx",
        "pl",
        "py",
        "wsf"
    ],
    "Graphics (Raster images, vector graphics, scanned documents)": [
        "ai",
        "bmp",
        "gif",
        "ico",
        "jpg",
        "jpeg",
        "png",
        "ps",
        "psd",
        "svg",
        "svgz",
        "tif",
        "tiff",
        "art",
        "blp",
        "bti",
        "cd5",
        "cit",
        "cpt",
        "cr2",
        "clip",
        "cpl",
        "dds",
        "dib",
        "egt",
        "exif",
        "grf",
        "icns",
        "iff",
        "ilbm",
        "lbm",
        "jng",
        "jfif",
        "jp2",
        "jps",
        "max",
        "miff",
        "mng",
        "msp",
        "nitf",
        "otb",
        "pbm",
        "pc1",
        "pc2",
        "pc3",
        "pcx",
        "pdn",
        "pgm",
        "obj",
        "off",
        "ogex",
        "prc",
        "eps",
        "webp",
        "wbmp",
        "odg",
        "djvu",
        "pcf",
        "pdf"
    ],
    "Presentations": [
        "gslides",
        "key",
        "keynote",
        "nb",
        "nbp",
        "odp",
        "otp",
        "pez",
        "pot",
        "pps",
        "ppt",
        "pptx",
        "prz",
        "sdd",
        "shf",
        "show",
        "shw",
        "slp",
        "sspss",
        "sti",
        "sxi",
        "thmx",
        "watch"
    ],
    "Source code": [
        "c",
        "class",
        "cpp",
        "cs",
        "h",
        "java",
        "sh",
        "swift",
        "vb",
        "js",
        "py",
        "php",
        "tsx",
        "ts",
        "rb",
        "dpr",
        "perl",
        "r",
        "json",
        "jnlp",
        "cco"
    ],
    "Spreadsheets": [
        "ods",
        "xlr",
        "xls",
        "xlsx",
        "numbers"
    ],
    "System files": [
        "bak",
        "cab",
        "cfg",
        "cpl",
        "cur",
        "dmp",
        "drv",
        "icns",
        "ico",
        "ini",
        "lnk",
        "msi",
        "sys",
        "tmp",
        "crt",
        "pem",
        "dll"
    ],
    "Video": [
        "3g2",
        "3gp",
        "3gpp",
        "avi",
        "flv",
        "h264",
        "m4v",
        "mkv",
        "mov",
        "mp4",
        "mpg",
        "mpeg",
        "rm",
        "swf",
        "vob",
        "wmv",
        "asf",
        "asx",
        "webm"
    ]
};
const DefaultSettings = {
    "popup_settings": {
        "blocking_popup_duration_seconds": 5
    },
    "blocking_settings": {
        "blocking_enabled": true,
        "outlook_plugin_blocking_enabled": true,
        "unblock_duration_seconds": 60,
        "upload_candidate_ttl_seconds": 86400,
        "max_dataset_db_size_bytes": 1073741824,
        "command_line_copy_tracing": false,
        "archive_tracing_enabled": false,
        "app_access_blocking_enabled": true,
        "copy_blocking_enabled": true,
        "ftp_tracing_enabled": true,
        "outlook_copy_tracing_enabled": false,
        "outlook_copy_tracing_enabled_ga": true,
        "web_upload_suspend_requests_enabled": false,
        "suspend_requests_timeout_seconds": 20,
        "save_as_monitor_mode": "disable",
        "save_as_monitor_mode_23_01": "trace",
        "save_as_monitor_mode_23_04": "trace",
        "save_as_monitor_mode_23_05": "trace",
        "save_as_monitor_mode_23_06": "trace",
        "save_as_monitor_mode_ga": "block",
        "command_line_copy_tracing_22_11": false,
        "archive_tracing_enabled_22_11": false,
        "web_upload_suspend_requests_enabled_22_11": false,
        "web_upload_suspend_requests_enabled_23_01": false,
        "new_upload_blocking_enabled": false,
        "upload_suspend_limiter_enabled": true
    },
    "dlp_settings": {
        "scan_removable_media_events": true,
        "scan_create_events": true,
        "scan_edit_events": true,
        "scan_save_as_events": true,
        "scan_app_access_events": false,
        "scan_copy_move_events": false,
        "use_delayed_scan": false,
        "use_delayed_scan_23_04": false,
        "use_delayed_scan_ga": true,
        "mtp_dlp_scan_enabled": false,
        "max_dlp_file_size_mb": 25
    },
    "health_settings": {
        "ping_interval_seconds": 60,
        "enable_chrome_edge_extension_self_repair": false,
        "browser_extension_startup_timeout": 180,
        "browser_extension_inactive_timeout": 60
    },
    "protection_settings": {
        "protection_hash": "",
        "protection_salt": "",
        "status_expiration_timeout_seconds": 604800,
        "statuses_settings": {
            "ProtectServiceWasStopped": {
                "expiration_timeout": 0
            },
            "SensorDowntimeLimitWasReached": {
                "expiration_timeout": 43200
            }
        },
        "protected_processes_wildcards": [],
        "acting_processes_wildcards": [],
        "service_protection_enabled": false,
        "service_protection_enabled_23_03": true,
        "protected_files_folders": [],
        "protected_files_folders_22_12": [],
        "protected_registry_folders": [],
        "service_restart_delay_base": 60,
        "service_restart_delay_max": 300,
        "service_restart_delay_backoff_rate": 120,
        "service_downtime_period": 3600,
        "service_downtime_limit": 0,
        "service_downtime_limit_23_05": 70
    },
    "connection_settings": {
        "default_http_timeout_seconds": 10,
        "upload_raw_edge_timeout_seconds": 10,
        "post_logs_timeout_seconds": 10
    },
    "events_settings": {
        "max_event_buffer_length": 1000,
        "min_send_batch_size": 1,
        "max_send_batch_size": 10,
        "offline_storage_enabled": true,
        "auto_vacuum_interval_seconds": 3600,
        "max_disk_usage_bytes": 1073741824,
        "min_free_disk_space_bytes": 1073741824,
        "storage_size_update_interval_seconds": 300,
        "offline_storage_memory_buffer_size": 100,
        "reinitialize_corrupted_db": false
    },
    "screenshot_settings": {
        "enabled": true,
        "history_size_in_frames": 120,
        "history_size_in_seconds": 30,
        "screenshot_interval_seconds": 1,
        "max_height_in_pixels": 1080,
        "quality": 50,
        "content_type": "image/jpeg",
        "enable_silent_screenshots": true,
        "enable_multimonitor_capture": true,
        "draw_watermark": true,
        "enable_history_macos": true,
        "enable_history_windows": true,
        "enable_dxgi_capture": true,
        "enable_gdi_capture": true,
        "enable_cg_capture": true,
        "enable_cgs_capture": true,
        "permission_policy_macos": "silent"
    },
    "logging_settings": {
        "level": "info",
        "push_interval_seconds": 3600,
        "chunk_size_bytes": 102400
    },
    "macos_settings": {
        "clipboard_enable_tracing": true,
        "clipboard_similar_events_delta_ms": 300,
        "clipboard_enable_dlp_scan": false,
        "clipboard_dlp_lower_bound_bytes": 0,
        "print_enable_tracing": true,
        "print_enable_blocking": false,
        "print_enable_blocking_23_07": false,
        "print_event_matching_interval_ms": 500,
        "blocking": {
            "scan_content_tags_for_uploads": false,
            "scan_content_tags_for_file_copy": false,
            "authentication_timeout_ms": 10000,
            "clipboard_browser_paste": false,
            "clipboard_browser_paste_23_07": false
        },
        "delete_cleans_create_cache_enabled": false,
        "enable_slack_monitor": true,
        "enable_slack_blocker": true
    },
    "windows_settings": {
        "outlook_settings": {
            "exchange_cache_check_enabled": true
        },
        "ui_automation_settings": {
            "url_history_enabled": true
        },
        "enable_slack_monitor": true,
        "slack_settings": {
            "event_matching_time_window_in_seconds": 300
        },
        "outlook_copy_paste_tracking_enabled": true,
        "upload_sensor_v3_enabled": false,
        "upload_sensor_v3_enabled_23_04": false,
        "upload_sensor_v3_enabled_23_06": false,
        "enable_system_printing_tracing": false,
        "enable_system_printing_blocking": false,
        "enable_user_spooler_hooking": false,
        "print_settings": {
            "enable_system_printing_tracing": false,
            "enable_system_printing_blocking": false,
            "enable_user_spooler_hooking": false
        },
        "upload_sensor_settings": {
            "tracing": {
                "read_to_upload_wait_seconds": 10,
                "upload_to_read_wait_seconds": 300,
                "upload_to_extension_upload_wait_seconds": 10
            },
            "blocking": {
                "read_to_upload_wait_seconds": 10,
                "upload_to_read_wait_seconds": 300,
                "upload_to_extension_upload_wait_seconds": 10
            }
        },
        "mtp_copy_tracing_enabled": false,
        "mtp_copy_tracing_enabled_23_07": false,
        "blocking": {
            "scan_content_tags_for_file_copy": false,
            "new_upload_blocking_enabled": false,
            "upload_suspend_limiter_enabled": true,
            "scan_content_tags_for_uploads": true
        },
        "clipboard_settings": {
            "enable_clipboard_monitor": true,
            "enable_browser_paste_blocking": false,
            "enable_browser_paste_blocking_23_04": false,
            "enable_browser_paste_blocking_23_05": false,
            "enable_browser_paste_blocking_23_06": false,
            "enable_browser_paste_blocking_ga": true,
            "enable_dlp_scan_on_copy": false,
            "enable_dlp_scan_on_paste": true,
            "dlp_lower_bound_in_bytes": 0,
            "enable_ui_paste_tracking": true,
            "enable_ui_process_names_list": [
                "winword",
                "excel",
                "powerpnt"
            ]
        },
        "delete_cleans_create_cache_enabled": false,
        "hook_engine": "madchook",
        "diagnostics_settings": {
            "check_api_timeout_seconds": 20,
            "upload_api_timeout_seconds": 3600,
            "log_script_timeout_seconds": 1800,
            "min_free_disk_space_bytes": 4294967296,
            "bundle_retention_count": 5,
            "memory_dump_max_size_bytes": 52428800,
            "mini_dump_count": 2
        },
        "document_extractors": {
            "acrobat": {
                "enabled": false,
                "enable_acrobat": true,
                "enable_acrobat_reader": true,
                "enable_copy_paste": true,
                "enable_printing": true,
                "enable_com_api": true,
                "enable_title_bar_extraction": true,
                "force_filename_in_titlebar": true
            },
            "outlook": {
                "enabled": true,
                "enable_header_extraction": true,
                "enable_com_extraction": true,
                "enable_com_header_comparison": true
            }
        },
        "ntp_settings": {
            "enable_time_drift_correction": true
        }
    },
    "browser_settings": {
        "https_enabled": true,
        "url_notification": true,
        "download_notification": true,
        "upload_notification": true,
        "active_tab_change_notification": true,
        "copy_paste_notification": true,
        "version": true,
        "logging": true,
        "settings": true,
        "process_events": false,
        "blocking": false,
        "report_usage_data": false,
        "upload_wait_time_ms": 500,
        "upload_wait_time_safari_ms": 1000,
        "web_apps": {
            "google_workspace": false,
            "outlook_web_app": false,
            "office_365": false,
            "box": false
        },
        "telemetry_enabled": true,
        "dom_extras": false,
        "update_features_interval_minutes": 0
    },
    "endpoint_info_settings": {
        "collection_enabled": true,
        "cache_update_period_seconds": 600
    },
    "telemetry_settings": {
        "nettelemetry_enabled": false,
        "push_interval_seconds": 120,
        "etwstats_interval_seconds": 3600
    },
    "windows_monitor_settings": {
        "Driver": {
            "event_monitor_settings": {
                "files": {
                    "blacklist": {
                        "entries": [],
                        "merge_mode": "merge"
                    }
                },
                "processes": {
                    "blacklist": {
                        "entries": [],
                        "merge_mode": "merge"
                    }
                }
            }
        },
        "Global": {
            "event_monitor_settings": {
                "files": {
                    "blacklist": {
                        "entries": [],
                        "merge_mode": "merge"
                    }
                }
            }
        },
        "KernelEventFilter": {
            "event_monitor_settings": {
                "processes": {
                    "blacklist": {
                        "entries": [],
                        "merge_mode": "merge"
                    }
                }
            }
        }
    },
    "macos_monitor_settings": {
        "Global": {
            "blacklisted_user_dirs": {
                "entries": [],
                "merge_mode": "merge"
            },
            "blacklisted_dirs": {
                "entries": [],
                "merge_mode": "merge"
            },
            "blacklisted_files": {
                "entries": [],
                "merge_mode": "merge"
            },
            "blacklisted_prefixes": {
                "entries": [],
                "merge_mode": "merge"
            },
            "whitelisted_prefixes": {
                "entries": [],
                "merge_mode": "merge"
            }
        },
        "AppAccess": {
            "blacklisted_process_bundles": {
                "entries": [],
                "merge_mode": "merge"
            }
        },
        "Archiving": {
            "event_match_timeout_ms": 2000,
            "add_auxiliary_events": true
        },
        "IgnoredApps": [
            {
                "name": "system",
                "binaries": [
                    "/sbin/launchd",
                    "/usr/bin/fdesetup",
                    "/usr/bin/codesign",
                    "/usr/bin/sudo"
                ],
                "path_prefixes": [
                    "/sbin/",
                    "/usr/",
                    "/usr/bin/",
                    "/usr/sbin/",
                    "/usr/libexec/",
                    "/Library/SystemExtensions/",
                    "/System/Library/Frameworks/"
                ]
            }
        ],
        "TrackedApps": [
            {
                "name": "system",
                "binaries": [
                    "/sbin/umount",
                    "/usr/libexec/sharingd"
                ],
                "path_prefixes": [
                    "/sbin/mount"
                ]
            }
        ]
    }
};
const SearchFieldToMinimumVersion = {
    "app_commandline": {
        "Major": 0,
        "Minor": 0
    },
    "app_main_window_title": {
        "Major": 0,
        "Minor": 0
    },
    "app_name": {
        "Major": 0,
        "Minor": 0
    },
    "browser_page_title": {
        "Major": 0,
        "Minor": 0
    },
    "category": {
        "Major": 0,
        "Minor": 0
    },
    "cloud_app": {
        "Major": 0,
        "Minor": 0
    },
    "cloud_app_account": {
        "Major": 0,
        "Minor": 0
    },
    "cloud_destination_groups": {
        "Major": 23,
        "Minor": 6
    },
    "cloud_domain": {
        "Major": 23,
        "Minor": 6
    },
    "cloud_messaging_groups": {
        "Major": 23,
        "Minor": 6
    },
    "cloud_messaging_users": {
        "Major": 23,
        "Minor": 6
    },
    "cloud_provider": {
        "Major": 0,
        "Minor": 0
    },
    "cloud_shared_role": {
        "Major": 23,
        "Minor": 6
    },
    "cloud_shared_type": {
        "Major": 23,
        "Minor": 6
    },
    "cloud_shared_with": {
        "Major": 23,
        "Minor": 6
    },
    "cloud_workspace": {
        "Major": 23,
        "Minor": 6
    },
    "content_tags": {
        "Major": 0,
        "Minor": 0
    },
    "data_size": {
        "Major": 0,
        "Minor": 0
    },
    "domain": {
        "Major": 0,
        "Minor": 0
    },
    "email_account": {
        "Major": 0,
        "Minor": 0
    },
    "email_subject": {
        "Major": 0,
        "Minor": 0
    },
    "event_type": {
        "Major": 0,
        "Minor": 0
    },
    "extension": {
        "Major": 0,
        "Minor": 0
    },
    "file_size": {
        "Major": 0,
        "Minor": 0
    },
    "group_name": {
        "Major": 0,
        "Minor": 0
    },
    "hostname": {
        "Major": 0,
        "Minor": 0
    },
    "keywords": {
        "Major": 0,
        "Minor": 0
    },
    "local_user_name": {
        "Major": 0,
        "Minor": 0
    },
    "location": {
        "Major": 0,
        "Minor": 0
    },
    "md5_hash": {
        "Major": 0,
        "Minor": 0
    },
    "media_category": {
        "Major": 0,
        "Minor": 0
    },
    "path": {
        "Major": 0,
        "Minor": 0
    },
    "path_basename": {
        "Major": 0,
        "Minor": 0
    },
    "personal_info_counts": {
        "Major": 0,
        "Minor": 0
    },
    "printer_name": {
        "Major": 0,
        "Minor": 0
    },
    "removable_device_name": {
        "Major": 0,
        "Minor": 0
    },
    "removable_device_product_id": {
        "Major": 22,
        "Minor": 3
    },
    "removable_device_usb_id": {
        "Major": 0,
        "Minor": 0
    },
    "removable_device_vendor_id": {
        "Major": 22,
        "Minor": 3
    },
    "sensor_name": {
        "Major": 23,
        "Minor": 5
    },
    "url": {
        "Major": 0,
        "Minor": 0
    },
    "user.department": {
        "Major": 23,
        "Minor": 6
    },
    "user.emails.value": {
        "Major": 23,
        "Minor": 6
    },
    "user.employee_status": {
        "Major": 23,
        "Minor": 6
    },
    "user.first_name": {
        "Major": 23,
        "Minor": 6
    },
    "user.full_name": {
        "Major": 23,
        "Minor": 6
    },
    "user.last_name": {
        "Major": 23,
        "Minor": 6
    },
    "user.manager_email": {
        "Major": 23,
        "Minor": 6
    },
    "user.manager_name": {
        "Major": 23,
        "Minor": 6
    },
    "user.primary_address_city": {
        "Major": 23,
        "Minor": 6
    },
    "user.primary_address_country": {
        "Major": 23,
        "Minor": 6
    },
    "user.primary_address_region": {
        "Major": 23,
        "Minor": 6
    },
    "user.primary_address_zip_code": {
        "Major": 23,
        "Minor": 6
    },
    "user.primary_email": {
        "Major": 23,
        "Minor": 6
    },
    "user.remote": {
        "Major": 23,
        "Minor": 6
    },
    "user.risk_groups.id": {
        "Major": 23,
        "Minor": 6
    },
    "user.risk_groups.name": {
        "Major": 23,
        "Minor": 6
    },
    "user.start_date": {
        "Major": 23,
        "Minor": 6
    },
    "user.termination_date": {
        "Major": 23,
        "Minor": 6
    },
    "user.title": {
        "Major": 23,
        "Minor": 6
    },
    "user.user_groups.name": {
        "Major": 23,
        "Minor": 6
    },
    "user.username": {
        "Major": 23,
        "Minor": 6
    },
    "zone": {
        "Major": 0,
        "Minor": 0
    }
};


/***/ }),

/***/ 37137:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Le": () => (/* reexport */ AddCommentDocument),
  "oi": () => (/* reexport */ AssingPermissionsDocument),
  "r7": () => (/* reexport */ AssingRolesDocument),
  "$f": () => (/* reexport */ CreateRoleDocument),
  "NU": () => (/* reexport */ DeleteCommentDocument),
  "E9": () => (/* reexport */ DeleteRoleDocument),
  "p0": () => (/* reexport */ GetAllPermissionsDocument),
  "Kr": () => (/* reexport */ GetAuthProvidersDocument),
  "Cy": () => (/* reexport */ GetCommentListDocument),
  "gH": () => (/* reexport */ GetRolesDocument),
  "X0": () => (/* reexport */ GetSettingsDocument),
  "um": () => (/* reexport */ GetUiSettingsDocument),
  "MM": () => (/* reexport */ GetUserPermissionsDocument),
  "FW": () => (/* reexport */ GetUserScopesDocument),
  "aE": () => (/* reexport */ GlobalAuthSettingsDocument),
  "He": () => (/* reexport */ GlobalSettingsDocument),
  "yN": () => (/* reexport */ ListPermissionsForRoleDocument),
  "PG": () => (/* reexport */ ListRolesForUserDocument),
  "mo": () => (/* reexport */ UpdateAuthProviderAvailabilityDocument),
  "Uc": () => (/* reexport */ UpdateCommentDocument),
  "Jv": () => (/* reexport */ UpdateGlobalAuthSettingsDocument),
  "bo": () => (/* reexport */ UpdateGlobalSettingsDocument),
  "vA": () => (/* reexport */ UpdateRoleDocument),
  "M9": () => (/* reexport */ UpdateSettingsDocument),
  "eB": () => (/* reexport */ UpdateUiSettingsDocument)
});

// UNUSED EXPORTS: Auth_Provider_Constraint, Auth_Provider_Select_Column, Auth_Provider_Update_Column, CategoryStatus, Comment_Constraint, Comment_Edit_History_Constraint, Comment_Edit_History_Select_Column, Comment_Edit_History_Update_Column, Comment_Select_Column, Comment_Update_Column, EndpointIssue, EndpointRequiredAction, EndpointStatusColumn, EndpointUpdatePolicy, GetAllUiSettingsDocument, Global_Auth_Settings_Select_Column, Global_Settings_Select_Column, Id_Token_Constraint, Id_Token_Select_Column, Id_Token_Update_Column, Id_Token_View_Select_Column, IncidentReaction, IncidentResponse, Order_By, Permission_Constraint, Permission_Select_Column, Permission_Update_Column, ResolutionStatus, Role_Binding_Constraint, Role_Binding_Select_Column, Role_Binding_Update_Column, Role_Constraint, Role_Permission_Constraint, Role_Permission_Select_Column, Role_Permission_Update_Column, Role_Select_Column, Role_Update_Column, Settings_Constraint, Settings_Select_Column, Settings_Update_Column, Subject_Permission_Select_Column, Subject_Scope_Select_Column, Ui_Settings_Constraint, Ui_Settings_Select_Column, Ui_Settings_Update_Column

;// CONCATENATED MODULE: ./src/api/graphql/api.ts
/* eslint-disable */ // prettier-ignore
var CategoryStatus;
(function(CategoryStatus) {
    CategoryStatus["Any"] = 'ANY';
    CategoryStatus["Approved"] = 'APPROVED';
    CategoryStatus["LowRisky"] = 'LOW_RISKY';
    CategoryStatus["NeedsReview"] = 'NEEDS_REVIEW';
    CategoryStatus["Risky"] = 'RISKY';
    CategoryStatus["RiskyOrLow"] = 'RISKY_OR_LOW';
})(CategoryStatus || (CategoryStatus = {}));
var EndpointIssue;
(function(EndpointIssue) {
    EndpointIssue["ChromeExtensionHasPolicyConflict"] = 'CHROME_EXTENSION_HAS_POLICY_CONFLICT';
    EndpointIssue["ChromeExtensionNeedsUpdate"] = 'CHROME_EXTENSION_NEEDS_UPDATE';
    EndpointIssue["ChromeExtensionNotInstalled"] = 'CHROME_EXTENSION_NOT_INSTALLED';
    EndpointIssue["FirefoxExtensionNeedsUpdate"] = 'FIREFOX_EXTENSION_NEEDS_UPDATE';
    EndpointIssue["FirefoxExtensionNotInstalled"] = 'FIREFOX_EXTENSION_NOT_INSTALLED';
    EndpointIssue["GeneralExpiredInstallToken"] = 'GENERAL_EXPIRED_INSTALL_TOKEN';
    EndpointIssue["GeneralFileOpsServiceIsDisableDxc"] = 'GENERAL_FILE_OPS_SERVICE_IS_DISABLEDxc';
    EndpointIssue["GeneralIncompatibleSettingsFound"] = 'GENERAL_INCOMPATIBLE_SETTINGS_FOUND';
    EndpointIssue["GeneralIncompatibleSoftwareFound"] = 'GENERAL_INCOMPATIBLE_SOFTWARE_FOUND';
    EndpointIssue["GeneralMissingInstallToken"] = 'GENERAL_MISSING_INSTALL_TOKEN';
    EndpointIssue["GeneralSettingsOutOfDate"] = 'GENERAL_SETTINGS_OUT_OF_DATE';
    EndpointIssue["GeneralUpdateRequired"] = 'GENERAL_UPDATE_REQUIRED';
    EndpointIssue["Inactive"] = 'INACTIVE';
    EndpointIssue["MacosAccessibilityPermissionNotSet"] = 'MACOS_ACCESSIBILITY_PERMISSION_NOT_SET';
    EndpointIssue["MacosAutomationPermissionNotSet"] = 'MACOS_AUTOMATION_PERMISSION_NOT_SET';
    EndpointIssue["MacosBrowserServiceIsDisabled"] = 'MACOS_BROWSER_SERVICE_IS_DISABLED';
    EndpointIssue["MacosNoFullDiskAccess"] = 'MACOS_NO_FULL_DISK_ACCESS';
    EndpointIssue["MacosPermissionsNotInitialized"] = 'MACOS_PERMISSIONS_NOT_INITIALIZED';
    EndpointIssue["MacosProfileNotCompatible"] = 'MACOS_PROFILE_NOT_COMPATIBLE';
    EndpointIssue["MacosProfileNotFound"] = 'MACOS_PROFILE_NOT_FOUND';
    EndpointIssue["MacosProfileRemovedOrManualInstall"] = 'MACOS_PROFILE_REMOVED_OR_MANUAL_INSTALL';
    EndpointIssue["MsedgeExtensionHasPolicyConflict"] = 'MSEDGE_EXTENSION_HAS_POLICY_CONFLICT';
    EndpointIssue["MsedgeExtensionNeedsUpdate"] = 'MSEDGE_EXTENSION_NEEDS_UPDATE';
    EndpointIssue["MsedgeExtensionNotInstalled"] = 'MSEDGE_EXTENSION_NOT_INSTALLED';
    EndpointIssue["Ok"] = 'OK';
    EndpointIssue["WinBackendConnectorServiceIsDisabled"] = 'WIN_BACKEND_CONNECTOR_SERVICE_IS_DISABLED';
    EndpointIssue["WinClipboardMonitorServiceIsDisabled"] = 'WIN_CLIPBOARD_MONITOR_SERVICE_IS_DISABLED';
    EndpointIssue["WinHealthMonitorServiceIsDisabled"] = 'WIN_HEALTH_MONITOR_SERVICE_IS_DISABLED';
    EndpointIssue["WinMainServiceIsDisabled"] = 'WIN_MAIN_SERVICE_IS_DISABLED';
    EndpointIssue["WinOfficeToolsMissing"] = 'WIN_OFFICE_TOOLS_MISSING';
    EndpointIssue["WinOutlookExchangeCacheDisabled"] = 'WIN_OUTLOOK_EXCHANGE_CACHE_DISABLED';
    EndpointIssue["WinOutlookPluginDisabled"] = 'WIN_OUTLOOK_PLUGIN_DISABLED';
    EndpointIssue["WinOutlookRestartRequired"] = 'WIN_OUTLOOK_RESTART_REQUIRED';
    EndpointIssue["WinUserHasNotLoggedOutAfterInstallation"] = 'WIN_USER_HAS_NOT_LOGGED_OUT_AFTER_INSTALLATION';
})(EndpointIssue || (EndpointIssue = {}));
var EndpointRequiredAction;
(function(EndpointRequiredAction) {
    EndpointRequiredAction["AllowBrowserServices"] = 'ALLOW_BROWSER_SERVICES';
    EndpointRequiredAction["AllowFullDiskAccess"] = 'ALLOW_FULL_DISK_ACCESS';
    EndpointRequiredAction["CheckChromeBrowserExtension"] = 'CHECK_CHROME_BROWSER_EXTENSION';
    EndpointRequiredAction["CheckChromeBrowserExtensionPolicy"] = 'CHECK_CHROME_BROWSER_EXTENSION_POLICY';
    EndpointRequiredAction["CheckEdgeBrowserExtension"] = 'CHECK_EDGE_BROWSER_EXTENSION';
    EndpointRequiredAction["CheckEdgeBrowserExtensionPolicy"] = 'CHECK_EDGE_BROWSER_EXTENSION_POLICY';
    EndpointRequiredAction["CheckFirefoxBrowserExtension"] = 'CHECK_FIREFOX_BROWSER_EXTENSION';
    EndpointRequiredAction["ContactAdmin"] = 'CONTACT_ADMIN';
    EndpointRequiredAction["EnableOutlookExchangeCache"] = 'ENABLE_OUTLOOK_EXCHANGE_CACHE';
    EndpointRequiredAction["FixAccessibilityPermissions"] = 'FIX_ACCESSIBILITY_PERMISSIONS';
    EndpointRequiredAction["FixAutomationPermissions"] = 'FIX_AUTOMATION_PERMISSIONS';
    EndpointRequiredAction["NA"] = 'N_A';
    EndpointRequiredAction["RestartOutlook"] = 'RESTART_OUTLOOK';
    EndpointRequiredAction["UpdateSensor"] = 'UPDATE_SENSOR';
})(EndpointRequiredAction || (EndpointRequiredAction = {}));
var EndpointStatusColumn;
(function(EndpointStatusColumn) {
    EndpointStatusColumn["Error"] = 'ERROR';
    EndpointStatusColumn["Group"] = 'GROUP';
    EndpointStatusColumn["Hostname"] = 'HOSTNAME';
    EndpointStatusColumn["LightbeamVersion"] = 'LIGHTBEAM_VERSION';
    EndpointStatusColumn["Os"] = 'OS';
    EndpointStatusColumn["OsVersion"] = 'OS_VERSION';
    EndpointStatusColumn["ReportTime"] = 'REPORT_TIME';
    EndpointStatusColumn["StatusAndRequiredAction"] = 'STATUS_AND_REQUIRED_ACTION';
})(EndpointStatusColumn || (EndpointStatusColumn = {}));
var EndpointUpdatePolicy;
(function(EndpointUpdatePolicy) {
    EndpointUpdatePolicy["Fixed"] = 'FIXED';
    EndpointUpdatePolicy["Latest"] = 'LATEST';
    EndpointUpdatePolicy["LatestN"] = 'LATEST_N';
    EndpointUpdatePolicy["Off"] = 'OFF';
    EndpointUpdatePolicy["PlatformDefault"] = 'PLATFORM_DEFAULT';
})(EndpointUpdatePolicy || (EndpointUpdatePolicy = {}));
var IncidentReaction;
(function(IncidentReaction) {
    IncidentReaction["Acknowledged"] = 'ACKNOWLEDGED';
    IncidentReaction["None"] = 'NONE';
    IncidentReaction["NotApplicable"] = 'NOT_APPLICABLE';
    IncidentReaction["ProvidedExplanation"] = 'PROVIDED_EXPLANATION';
    IncidentReaction["RequestedReview"] = 'REQUESTED_REVIEW';
    IncidentReaction["RequestedUnblock"] = 'REQUESTED_UNBLOCK';
    IncidentReaction["Warned"] = 'WARNED';
})(IncidentReaction || (IncidentReaction = {}));
var IncidentResponse;
(function(IncidentResponse) {
    IncidentResponse["AccessRestricted"] = 'ACCESS_RESTRICTED';
    IncidentResponse["AccessRestrictedExpired"] = 'ACCESS_RESTRICTED_EXPIRED';
    IncidentResponse["AccessRestrictedRateLimited"] = 'ACCESS_RESTRICTED_RATE_LIMITED';
    IncidentResponse["AccessRestrictedRemoved"] = 'ACCESS_RESTRICTED_REMOVED';
    IncidentResponse["NotApplicable"] = 'NOT_APPLICABLE';
    IncidentResponse["Pending"] = 'PENDING';
    IncidentResponse["SkippedRateLimited"] = 'SKIPPED_RATE_LIMITED';
    IncidentResponse["SkippedTimeout"] = 'SKIPPED_TIMEOUT';
    IncidentResponse["Warned"] = 'WARNED';
    IncidentResponse["WarningReceived"] = 'WARNING_RECEIVED';
})(IncidentResponse || (IncidentResponse = {}));
var ResolutionStatus;
(function(ResolutionStatus) {
    ResolutionStatus["Ignored"] = 'IGNORED';
    ResolutionStatus["InProgress"] = 'IN_PROGRESS';
    ResolutionStatus["Resolved"] = 'RESOLVED';
    ResolutionStatus["Unresolved"] = 'UNRESOLVED';
})(ResolutionStatus || (ResolutionStatus = {}));
var Auth_Provider_Constraint;
(function(Auth_Provider_Constraint) {
    Auth_Provider_Constraint[/** unique or primary key constraint */ "AuthProviderPkey"] = 'auth_provider_pkey';
})(Auth_Provider_Constraint || (Auth_Provider_Constraint = {}));
var Auth_Provider_Select_Column;
(function(Auth_Provider_Select_Column) {
    Auth_Provider_Select_Column[/** column name */ "Enabled"] = 'enabled';
    Auth_Provider_Select_Column[/** column name */ "EnforceMfa"] = 'enforce_mfa';
    Auth_Provider_Select_Column[/** column name */ "Name"] = 'name';
    Auth_Provider_Select_Column[/** column name */ "Title"] = 'title';
})(Auth_Provider_Select_Column || (Auth_Provider_Select_Column = {}));
var Auth_Provider_Update_Column;
(function(Auth_Provider_Update_Column) {
    Auth_Provider_Update_Column[/** column name */ "Enabled"] = 'enabled';
    Auth_Provider_Update_Column[/** column name */ "EnforceMfa"] = 'enforce_mfa';
    Auth_Provider_Update_Column[/** column name */ "Name"] = 'name';
    Auth_Provider_Update_Column[/** column name */ "Title"] = 'title';
})(Auth_Provider_Update_Column || (Auth_Provider_Update_Column = {}));
var Comment_Constraint;
(function(Comment_Constraint) {
    Comment_Constraint[/** unique or primary key constraint */ "CommentPkey"] = 'comment_pkey';
})(Comment_Constraint || (Comment_Constraint = {}));
var Comment_Edit_History_Constraint;
(function(Comment_Edit_History_Constraint) {
    Comment_Edit_History_Constraint[/** unique or primary key constraint */ "CommentEditHistoryPkey"] = 'comment_edit_history_pkey';
})(Comment_Edit_History_Constraint || (Comment_Edit_History_Constraint = {}));
var Comment_Edit_History_Select_Column;
(function(Comment_Edit_History_Select_Column) {
    Comment_Edit_History_Select_Column[/** column name */ "CommentId"] = 'comment_id';
    Comment_Edit_History_Select_Column[/** column name */ "EditedAt"] = 'edited_at';
    Comment_Edit_History_Select_Column[/** column name */ "EditedBy"] = 'edited_by';
    Comment_Edit_History_Select_Column[/** column name */ "Id"] = 'id';
})(Comment_Edit_History_Select_Column || (Comment_Edit_History_Select_Column = {}));
var Comment_Edit_History_Update_Column;
(function(Comment_Edit_History_Update_Column) {
    Comment_Edit_History_Update_Column[/** column name */ "CommentId"] = 'comment_id';
    Comment_Edit_History_Update_Column[/** column name */ "EditedAt"] = 'edited_at';
    Comment_Edit_History_Update_Column[/** column name */ "EditedBy"] = 'edited_by';
    Comment_Edit_History_Update_Column[/** column name */ "Id"] = 'id';
})(Comment_Edit_History_Update_Column || (Comment_Edit_History_Update_Column = {}));
var Comment_Select_Column;
(function(Comment_Select_Column) {
    Comment_Select_Column[/** column name */ "AuthorId"] = 'author_id';
    Comment_Select_Column[/** column name */ "Content"] = 'content';
    Comment_Select_Column[/** column name */ "CreatedAt"] = 'created_at';
    Comment_Select_Column[/** column name */ "EntityId"] = 'entity_id';
    Comment_Select_Column[/** column name */ "Id"] = 'id';
    Comment_Select_Column[/** column name */ "IsDeleted"] = 'is_deleted';
})(Comment_Select_Column || (Comment_Select_Column = {}));
var Comment_Update_Column;
(function(Comment_Update_Column) {
    Comment_Update_Column[/** column name */ "AuthorId"] = 'author_id';
    Comment_Update_Column[/** column name */ "Content"] = 'content';
    Comment_Update_Column[/** column name */ "CreatedAt"] = 'created_at';
    Comment_Update_Column[/** column name */ "EntityId"] = 'entity_id';
    Comment_Update_Column[/** column name */ "Id"] = 'id';
    Comment_Update_Column[/** column name */ "IsDeleted"] = 'is_deleted';
})(Comment_Update_Column || (Comment_Update_Column = {}));
var Global_Auth_Settings_Select_Column;
(function(Global_Auth_Settings_Select_Column) {
    Global_Auth_Settings_Select_Column[/** column name */ "AuthData"] = 'auth_data';
})(Global_Auth_Settings_Select_Column || (Global_Auth_Settings_Select_Column = {}));
var Global_Settings_Select_Column;
(function(Global_Settings_Select_Column) {
    Global_Settings_Select_Column[/** column name */ "Data"] = 'data';
})(Global_Settings_Select_Column || (Global_Settings_Select_Column = {}));
var Id_Token_Constraint;
(function(Id_Token_Constraint) {
    Id_Token_Constraint[/** unique or primary key constraint */ "IdTokenNameKey"] = 'id_token_name_key';
    Id_Token_Constraint[/** unique or primary key constraint */ "IdTokenPkey"] = 'id_token_pkey';
})(Id_Token_Constraint || (Id_Token_Constraint = {}));
var Id_Token_Select_Column;
(function(Id_Token_Select_Column) {
    Id_Token_Select_Column[/** column name */ "CreatedAt"] = 'created_at';
    Id_Token_Select_Column[/** column name */ "CreatedById"] = 'created_by_id';
    Id_Token_Select_Column[/** column name */ "Id"] = 'id';
    Id_Token_Select_Column[/** column name */ "Name"] = 'name';
})(Id_Token_Select_Column || (Id_Token_Select_Column = {}));
var Id_Token_Update_Column;
(function(Id_Token_Update_Column) {
    Id_Token_Update_Column[/** column name */ "CreatedAt"] = 'created_at';
    Id_Token_Update_Column[/** column name */ "CreatedById"] = 'created_by_id';
    Id_Token_Update_Column[/** column name */ "Id"] = 'id';
    Id_Token_Update_Column[/** column name */ "Name"] = 'name';
})(Id_Token_Update_Column || (Id_Token_Update_Column = {}));
var Id_Token_View_Select_Column;
(function(Id_Token_View_Select_Column) {
    Id_Token_View_Select_Column[/** column name */ "CreatedAt"] = 'created_at';
    Id_Token_View_Select_Column[/** column name */ "CreatedById"] = 'created_by_id';
    Id_Token_View_Select_Column[/** column name */ "Id"] = 'id';
    Id_Token_View_Select_Column[/** column name */ "Name"] = 'name';
})(Id_Token_View_Select_Column || (Id_Token_View_Select_Column = {}));
var Order_By;
(function(Order_By) {
    Order_By[/** in ascending order, nulls last */ "Asc"] = 'asc';
    Order_By[/** in ascending order, nulls first */ "AscNullsFirst"] = 'asc_nulls_first';
    Order_By[/** in ascending order, nulls last */ "AscNullsLast"] = 'asc_nulls_last';
    Order_By[/** in descending order, nulls first */ "Desc"] = 'desc';
    Order_By[/** in descending order, nulls first */ "DescNullsFirst"] = 'desc_nulls_first';
    Order_By[/** in descending order, nulls last */ "DescNullsLast"] = 'desc_nulls_last';
})(Order_By || (Order_By = {}));
var Permission_Constraint;
(function(Permission_Constraint) {
    Permission_Constraint[/** unique or primary key constraint */ "PermissionNameKey"] = 'permission_name_key';
    Permission_Constraint[/** unique or primary key constraint */ "PermissionPkey"] = 'permission_pkey';
})(Permission_Constraint || (Permission_Constraint = {}));
var Permission_Select_Column;
(function(Permission_Select_Column) {
    Permission_Select_Column[/** column name */ "Description"] = 'description';
    Permission_Select_Column[/** column name */ "Id"] = 'id';
    Permission_Select_Column[/** column name */ "Name"] = 'name';
    Permission_Select_Column[/** column name */ "Title"] = 'title';
})(Permission_Select_Column || (Permission_Select_Column = {}));
var Permission_Update_Column;
(function(Permission_Update_Column) {
    Permission_Update_Column[/** column name */ "Description"] = 'description';
    Permission_Update_Column[/** column name */ "Id"] = 'id';
    Permission_Update_Column[/** column name */ "Name"] = 'name';
    Permission_Update_Column[/** column name */ "Title"] = 'title';
})(Permission_Update_Column || (Permission_Update_Column = {}));
var Role_Binding_Constraint;
(function(Role_Binding_Constraint) {
    Role_Binding_Constraint[/** unique or primary key constraint */ "RoleBindingPkey"] = 'role_binding_pkey';
})(Role_Binding_Constraint || (Role_Binding_Constraint = {}));
var Role_Binding_Select_Column;
(function(Role_Binding_Select_Column) {
    Role_Binding_Select_Column[/** column name */ "AssignmentDate"] = 'assignment_date';
    Role_Binding_Select_Column[/** column name */ "RoleId"] = 'role_id';
    Role_Binding_Select_Column[/** column name */ "SubjectId"] = 'subject_id';
    Role_Binding_Select_Column[/** column name */ "SubjectKind"] = 'subject_kind';
})(Role_Binding_Select_Column || (Role_Binding_Select_Column = {}));
var Role_Binding_Update_Column;
(function(Role_Binding_Update_Column) {
    Role_Binding_Update_Column[/** column name */ "AssignmentDate"] = 'assignment_date';
    Role_Binding_Update_Column[/** column name */ "RoleId"] = 'role_id';
    Role_Binding_Update_Column[/** column name */ "SubjectId"] = 'subject_id';
    Role_Binding_Update_Column[/** column name */ "SubjectKind"] = 'subject_kind';
})(Role_Binding_Update_Column || (Role_Binding_Update_Column = {}));
var Role_Constraint;
(function(Role_Constraint) {
    Role_Constraint[/** unique or primary key constraint */ "RoleNameKey"] = 'role_name_key';
    Role_Constraint[/** unique or primary key constraint */ "RolePkey"] = 'role_pkey';
})(Role_Constraint || (Role_Constraint = {}));
var Role_Permission_Constraint;
(function(Role_Permission_Constraint) {
    Role_Permission_Constraint[/** unique or primary key constraint */ "RolePermissionPkey"] = 'role_permission_pkey';
})(Role_Permission_Constraint || (Role_Permission_Constraint = {}));
var Role_Permission_Select_Column;
(function(Role_Permission_Select_Column) {
    Role_Permission_Select_Column[/** column name */ "AssignmentDate"] = 'assignment_date';
    Role_Permission_Select_Column[/** column name */ "PermissionId"] = 'permission_id';
    Role_Permission_Select_Column[/** column name */ "RoleId"] = 'role_id';
})(Role_Permission_Select_Column || (Role_Permission_Select_Column = {}));
var Role_Permission_Update_Column;
(function(Role_Permission_Update_Column) {
    Role_Permission_Update_Column[/** column name */ "AssignmentDate"] = 'assignment_date';
    Role_Permission_Update_Column[/** column name */ "PermissionId"] = 'permission_id';
    Role_Permission_Update_Column[/** column name */ "RoleId"] = 'role_id';
})(Role_Permission_Update_Column || (Role_Permission_Update_Column = {}));
var Role_Select_Column;
(function(Role_Select_Column) {
    Role_Select_Column[/** column name */ "Description"] = 'description';
    Role_Select_Column[/** column name */ "Id"] = 'id';
    Role_Select_Column[/** column name */ "IsDefault"] = 'is_default';
    Role_Select_Column[/** column name */ "Name"] = 'name';
})(Role_Select_Column || (Role_Select_Column = {}));
var Role_Update_Column;
(function(Role_Update_Column) {
    Role_Update_Column[/** column name */ "Description"] = 'description';
    Role_Update_Column[/** column name */ "Id"] = 'id';
    Role_Update_Column[/** column name */ "IsDefault"] = 'is_default';
    Role_Update_Column[/** column name */ "Name"] = 'name';
    Role_Update_Column[/** column name */ "Scope"] = 'scope';
})(Role_Update_Column || (Role_Update_Column = {}));
var Settings_Constraint;
(function(Settings_Constraint) {
    Settings_Constraint[/** unique or primary key constraint */ "SettingsPkey"] = 'settings_pkey';
})(Settings_Constraint || (Settings_Constraint = {}));
var Settings_Select_Column;
(function(Settings_Select_Column) {
    Settings_Select_Column[/** column name */ "AuthData"] = 'auth_data';
    Settings_Select_Column[/** column name */ "CreatedAt"] = 'created_at';
    Settings_Select_Column[/** column name */ "Data"] = 'data';
    Settings_Select_Column[/** column name */ "UpdatedAt"] = 'updated_at';
    Settings_Select_Column[/** column name */ "UserId"] = 'user_id';
})(Settings_Select_Column || (Settings_Select_Column = {}));
var Settings_Update_Column;
(function(Settings_Update_Column) {
    Settings_Update_Column[/** column name */ "AuthData"] = 'auth_data';
    Settings_Update_Column[/** column name */ "CreatedAt"] = 'created_at';
    Settings_Update_Column[/** column name */ "Data"] = 'data';
    Settings_Update_Column[/** column name */ "UpdatedAt"] = 'updated_at';
    Settings_Update_Column[/** column name */ "UserId"] = 'user_id';
})(Settings_Update_Column || (Settings_Update_Column = {}));
var Subject_Permission_Select_Column;
(function(Subject_Permission_Select_Column) {
    Subject_Permission_Select_Column[/** column name */ "Permission"] = 'permission';
    Subject_Permission_Select_Column[/** column name */ "Role"] = 'role';
    Subject_Permission_Select_Column[/** column name */ "SubjectId"] = 'subject_id';
    Subject_Permission_Select_Column[/** column name */ "SubjectKind"] = 'subject_kind';
})(Subject_Permission_Select_Column || (Subject_Permission_Select_Column = {}));
var Subject_Scope_Select_Column;
(function(Subject_Scope_Select_Column) {
    Subject_Scope_Select_Column[/** column name */ "Role"] = 'role';
    Subject_Scope_Select_Column[/** column name */ "Scope"] = 'scope';
    Subject_Scope_Select_Column[/** column name */ "SubjectId"] = 'subject_id';
    Subject_Scope_Select_Column[/** column name */ "SubjectKind"] = 'subject_kind';
})(Subject_Scope_Select_Column || (Subject_Scope_Select_Column = {}));
var Ui_Settings_Constraint;
(function(Ui_Settings_Constraint) {
    Ui_Settings_Constraint[/** unique or primary key constraint */ "UiSettingsPkey"] = 'ui_settings_pkey';
})(Ui_Settings_Constraint || (Ui_Settings_Constraint = {}));
var Ui_Settings_Select_Column;
(function(Ui_Settings_Select_Column) {
    Ui_Settings_Select_Column[/** column name */ "EntityId"] = 'entity_id';
    Ui_Settings_Select_Column[/** column name */ "Settings"] = 'settings';
    Ui_Settings_Select_Column[/** column name */ "UserId"] = 'user_id';
})(Ui_Settings_Select_Column || (Ui_Settings_Select_Column = {}));
var Ui_Settings_Update_Column;
(function(Ui_Settings_Update_Column) {
    Ui_Settings_Update_Column[/** column name */ "EntityId"] = 'entity_id';
    Ui_Settings_Update_Column[/** column name */ "Settings"] = 'settings';
    Ui_Settings_Update_Column[/** column name */ "UserId"] = 'user_id';
})(Ui_Settings_Update_Column || (Ui_Settings_Update_Column = {}));
const GetAuthProvidersDocument = {
    "kind": "Document",
    "definitions": [
        {
            "kind": "OperationDefinition",
            "operation": "query",
            "name": {
                "kind": "Name",
                "value": "GetAuthProviders"
            },
            "selectionSet": {
                "kind": "SelectionSet",
                "selections": [
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "auth_provider"
                        },
                        "selectionSet": {
                            "kind": "SelectionSet",
                            "selections": [
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "name"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "title"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "enabled"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "enforce_mfa"
                                    }
                                }
                            ]
                        }
                    }
                ]
            }
        }
    ]
};
const UpdateAuthProviderAvailabilityDocument = {
    "kind": "Document",
    "definitions": [
        {
            "kind": "OperationDefinition",
            "operation": "mutation",
            "name": {
                "kind": "Name",
                "value": "UpdateAuthProviderAvailability"
            },
            "variableDefinitions": [
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "name"
                        }
                    },
                    "type": {
                        "kind": "NonNullType",
                        "type": {
                            "kind": "NamedType",
                            "name": {
                                "kind": "Name",
                                "value": "String"
                            }
                        }
                    }
                },
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "enabled"
                        }
                    },
                    "type": {
                        "kind": "NonNullType",
                        "type": {
                            "kind": "NamedType",
                            "name": {
                                "kind": "Name",
                                "value": "Boolean"
                            }
                        }
                    }
                }
            ],
            "selectionSet": {
                "kind": "SelectionSet",
                "selections": [
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "update_auth_provider_by_pk"
                        },
                        "arguments": [
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "pk_columns"
                                },
                                "value": {
                                    "kind": "ObjectValue",
                                    "fields": [
                                        {
                                            "kind": "ObjectField",
                                            "name": {
                                                "kind": "Name",
                                                "value": "name"
                                            },
                                            "value": {
                                                "kind": "Variable",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "name"
                                                }
                                            }
                                        }
                                    ]
                                }
                            },
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "_set"
                                },
                                "value": {
                                    "kind": "ObjectValue",
                                    "fields": [
                                        {
                                            "kind": "ObjectField",
                                            "name": {
                                                "kind": "Name",
                                                "value": "enabled"
                                            },
                                            "value": {
                                                "kind": "Variable",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "enabled"
                                                }
                                            }
                                        }
                                    ]
                                }
                            }
                        ],
                        "selectionSet": {
                            "kind": "SelectionSet",
                            "selections": [
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "enabled"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "name"
                                    }
                                }
                            ]
                        }
                    }
                ]
            }
        }
    ]
};
const AddCommentDocument = {
    "kind": "Document",
    "definitions": [
        {
            "kind": "OperationDefinition",
            "operation": "mutation",
            "name": {
                "kind": "Name",
                "value": "AddComment"
            },
            "variableDefinitions": [
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "commentInput"
                        }
                    },
                    "type": {
                        "kind": "NonNullType",
                        "type": {
                            "kind": "NamedType",
                            "name": {
                                "kind": "Name",
                                "value": "comment_insert_input"
                            }
                        }
                    }
                }
            ],
            "selectionSet": {
                "kind": "SelectionSet",
                "selections": [
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "insert_comment"
                        },
                        "arguments": [
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "objects"
                                },
                                "value": {
                                    "kind": "ListValue",
                                    "values": [
                                        {
                                            "kind": "Variable",
                                            "name": {
                                                "kind": "Name",
                                                "value": "commentInput"
                                            }
                                        }
                                    ]
                                }
                            }
                        ],
                        "selectionSet": {
                            "kind": "SelectionSet",
                            "selections": [
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "returning"
                                    },
                                    "selectionSet": {
                                        "kind": "SelectionSet",
                                        "selections": [
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "content"
                                                }
                                            }
                                        ]
                                    }
                                }
                            ]
                        }
                    }
                ]
            }
        }
    ]
};
const GetCommentListDocument = {
    "kind": "Document",
    "definitions": [
        {
            "kind": "OperationDefinition",
            "operation": "query",
            "name": {
                "kind": "Name",
                "value": "GetCommentList"
            },
            "variableDefinitions": [
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "entityId"
                        }
                    },
                    "type": {
                        "kind": "NonNullType",
                        "type": {
                            "kind": "NamedType",
                            "name": {
                                "kind": "Name",
                                "value": "String"
                            }
                        }
                    }
                }
            ],
            "selectionSet": {
                "kind": "SelectionSet",
                "selections": [
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "comment"
                        },
                        "arguments": [
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "where"
                                },
                                "value": {
                                    "kind": "ObjectValue",
                                    "fields": [
                                        {
                                            "kind": "ObjectField",
                                            "name": {
                                                "kind": "Name",
                                                "value": "entity_id"
                                            },
                                            "value": {
                                                "kind": "ObjectValue",
                                                "fields": [
                                                    {
                                                        "kind": "ObjectField",
                                                        "name": {
                                                            "kind": "Name",
                                                            "value": "_eq"
                                                        },
                                                        "value": {
                                                            "kind": "Variable",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "entityId"
                                                            }
                                                        }
                                                    }
                                                ]
                                            }
                                        }
                                    ]
                                }
                            }
                        ],
                        "selectionSet": {
                            "kind": "SelectionSet",
                            "selections": [
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "comment_edit_histories"
                                    },
                                    "selectionSet": {
                                        "kind": "SelectionSet",
                                        "selections": [
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "edited_at"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "edited_by"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "id"
                                                }
                                            }
                                        ]
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "content"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "created_at"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "id"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "entity_id"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "author_id"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "is_deleted"
                                    }
                                }
                            ]
                        }
                    }
                ]
            }
        }
    ]
};
const UpdateCommentDocument = {
    "kind": "Document",
    "definitions": [
        {
            "kind": "OperationDefinition",
            "operation": "mutation",
            "name": {
                "kind": "Name",
                "value": "UpdateComment"
            },
            "variableDefinitions": [
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "commentId"
                        }
                    },
                    "type": {
                        "kind": "NonNullType",
                        "type": {
                            "kind": "NamedType",
                            "name": {
                                "kind": "Name",
                                "value": "uuid"
                            }
                        }
                    }
                },
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "editedBy"
                        }
                    },
                    "type": {
                        "kind": "NonNullType",
                        "type": {
                            "kind": "NamedType",
                            "name": {
                                "kind": "Name",
                                "value": "String"
                            }
                        }
                    }
                },
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "newContent"
                        }
                    },
                    "type": {
                        "kind": "NonNullType",
                        "type": {
                            "kind": "NamedType",
                            "name": {
                                "kind": "Name",
                                "value": "String"
                            }
                        }
                    }
                }
            ],
            "selectionSet": {
                "kind": "SelectionSet",
                "selections": [
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "update_comment_by_pk"
                        },
                        "arguments": [
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "pk_columns"
                                },
                                "value": {
                                    "kind": "ObjectValue",
                                    "fields": [
                                        {
                                            "kind": "ObjectField",
                                            "name": {
                                                "kind": "Name",
                                                "value": "id"
                                            },
                                            "value": {
                                                "kind": "Variable",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "commentId"
                                                }
                                            }
                                        }
                                    ]
                                }
                            },
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "_set"
                                },
                                "value": {
                                    "kind": "ObjectValue",
                                    "fields": [
                                        {
                                            "kind": "ObjectField",
                                            "name": {
                                                "kind": "Name",
                                                "value": "content"
                                            },
                                            "value": {
                                                "kind": "Variable",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "newContent"
                                                }
                                            }
                                        }
                                    ]
                                }
                            }
                        ],
                        "selectionSet": {
                            "kind": "SelectionSet",
                            "selections": [
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "content"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "id"
                                    }
                                }
                            ]
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "insert_comment_edit_history_one"
                        },
                        "arguments": [
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "object"
                                },
                                "value": {
                                    "kind": "ObjectValue",
                                    "fields": [
                                        {
                                            "kind": "ObjectField",
                                            "name": {
                                                "kind": "Name",
                                                "value": "comment_id"
                                            },
                                            "value": {
                                                "kind": "Variable",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "commentId"
                                                }
                                            }
                                        },
                                        {
                                            "kind": "ObjectField",
                                            "name": {
                                                "kind": "Name",
                                                "value": "edited_by"
                                            },
                                            "value": {
                                                "kind": "Variable",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "editedBy"
                                                }
                                            }
                                        }
                                    ]
                                }
                            }
                        ],
                        "selectionSet": {
                            "kind": "SelectionSet",
                            "selections": [
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "id"
                                    }
                                }
                            ]
                        }
                    }
                ]
            }
        }
    ]
};
const DeleteCommentDocument = {
    "kind": "Document",
    "definitions": [
        {
            "kind": "OperationDefinition",
            "operation": "mutation",
            "name": {
                "kind": "Name",
                "value": "DeleteComment"
            },
            "variableDefinitions": [
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "commentId"
                        }
                    },
                    "type": {
                        "kind": "NonNullType",
                        "type": {
                            "kind": "NamedType",
                            "name": {
                                "kind": "Name",
                                "value": "uuid"
                            }
                        }
                    }
                }
            ],
            "selectionSet": {
                "kind": "SelectionSet",
                "selections": [
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "update_comment"
                        },
                        "arguments": [
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "where"
                                },
                                "value": {
                                    "kind": "ObjectValue",
                                    "fields": [
                                        {
                                            "kind": "ObjectField",
                                            "name": {
                                                "kind": "Name",
                                                "value": "id"
                                            },
                                            "value": {
                                                "kind": "ObjectValue",
                                                "fields": [
                                                    {
                                                        "kind": "ObjectField",
                                                        "name": {
                                                            "kind": "Name",
                                                            "value": "_eq"
                                                        },
                                                        "value": {
                                                            "kind": "Variable",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "commentId"
                                                            }
                                                        }
                                                    }
                                                ]
                                            }
                                        }
                                    ]
                                }
                            },
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "_set"
                                },
                                "value": {
                                    "kind": "ObjectValue",
                                    "fields": [
                                        {
                                            "kind": "ObjectField",
                                            "name": {
                                                "kind": "Name",
                                                "value": "is_deleted"
                                            },
                                            "value": {
                                                "kind": "BooleanValue",
                                                "value": true
                                            }
                                        }
                                    ]
                                }
                            }
                        ],
                        "selectionSet": {
                            "kind": "SelectionSet",
                            "selections": [
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "returning"
                                    },
                                    "selectionSet": {
                                        "kind": "SelectionSet",
                                        "selections": [
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "id"
                                                }
                                            }
                                        ]
                                    }
                                }
                            ]
                        }
                    }
                ]
            }
        }
    ]
};
const GetAllPermissionsDocument = {
    "kind": "Document",
    "definitions": [
        {
            "kind": "OperationDefinition",
            "operation": "query",
            "name": {
                "kind": "Name",
                "value": "GetAllPermissions"
            },
            "selectionSet": {
                "kind": "SelectionSet",
                "selections": [
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "permission"
                        },
                        "selectionSet": {
                            "kind": "SelectionSet",
                            "selections": [
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "name"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "title"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "id"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "description"
                                    }
                                }
                            ]
                        }
                    }
                ]
            }
        }
    ]
};
const GetUserPermissionsDocument = {
    "kind": "Document",
    "definitions": [
        {
            "kind": "OperationDefinition",
            "operation": "query",
            "name": {
                "kind": "Name",
                "value": "GetUserPermissions"
            },
            "variableDefinitions": [
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "userId"
                        }
                    },
                    "type": {
                        "kind": "NonNullType",
                        "type": {
                            "kind": "NamedType",
                            "name": {
                                "kind": "Name",
                                "value": "String"
                            }
                        }
                    }
                }
            ],
            "selectionSet": {
                "kind": "SelectionSet",
                "selections": [
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "subject_permission"
                        },
                        "arguments": [
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "where"
                                },
                                "value": {
                                    "kind": "ObjectValue",
                                    "fields": [
                                        {
                                            "kind": "ObjectField",
                                            "name": {
                                                "kind": "Name",
                                                "value": "subject_id"
                                            },
                                            "value": {
                                                "kind": "ObjectValue",
                                                "fields": [
                                                    {
                                                        "kind": "ObjectField",
                                                        "name": {
                                                            "kind": "Name",
                                                            "value": "_eq"
                                                        },
                                                        "value": {
                                                            "kind": "Variable",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "userId"
                                                            }
                                                        }
                                                    }
                                                ]
                                            }
                                        }
                                    ]
                                }
                            }
                        ],
                        "selectionSet": {
                            "kind": "SelectionSet",
                            "selections": [
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "subject_id"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "permission"
                                    }
                                }
                            ]
                        }
                    }
                ]
            }
        }
    ]
};
const GetUserScopesDocument = {
    "kind": "Document",
    "definitions": [
        {
            "kind": "OperationDefinition",
            "operation": "query",
            "name": {
                "kind": "Name",
                "value": "GetUserScopes"
            },
            "variableDefinitions": [
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "userId"
                        }
                    },
                    "type": {
                        "kind": "NonNullType",
                        "type": {
                            "kind": "NamedType",
                            "name": {
                                "kind": "Name",
                                "value": "String"
                            }
                        }
                    }
                }
            ],
            "selectionSet": {
                "kind": "SelectionSet",
                "selections": [
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "subject_scope"
                        },
                        "arguments": [
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "where"
                                },
                                "value": {
                                    "kind": "ObjectValue",
                                    "fields": [
                                        {
                                            "kind": "ObjectField",
                                            "name": {
                                                "kind": "Name",
                                                "value": "subject_id"
                                            },
                                            "value": {
                                                "kind": "ObjectValue",
                                                "fields": [
                                                    {
                                                        "kind": "ObjectField",
                                                        "name": {
                                                            "kind": "Name",
                                                            "value": "_eq"
                                                        },
                                                        "value": {
                                                            "kind": "Variable",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "userId"
                                                            }
                                                        }
                                                    }
                                                ]
                                            }
                                        }
                                    ]
                                }
                            }
                        ],
                        "selectionSet": {
                            "kind": "SelectionSet",
                            "selections": [
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "subject_id"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "scope"
                                    }
                                }
                            ]
                        }
                    }
                ]
            }
        }
    ]
};
const ListPermissionsForRoleDocument = {
    "kind": "Document",
    "definitions": [
        {
            "kind": "OperationDefinition",
            "operation": "query",
            "name": {
                "kind": "Name",
                "value": "ListPermissionsForRole"
            },
            "variableDefinitions": [
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "role_id"
                        }
                    },
                    "type": {
                        "kind": "NonNullType",
                        "type": {
                            "kind": "NamedType",
                            "name": {
                                "kind": "Name",
                                "value": "uuid"
                            }
                        }
                    }
                }
            ],
            "selectionSet": {
                "kind": "SelectionSet",
                "selections": [
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "role_permission"
                        },
                        "arguments": [
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "where"
                                },
                                "value": {
                                    "kind": "ObjectValue",
                                    "fields": [
                                        {
                                            "kind": "ObjectField",
                                            "name": {
                                                "kind": "Name",
                                                "value": "role_id"
                                            },
                                            "value": {
                                                "kind": "ObjectValue",
                                                "fields": [
                                                    {
                                                        "kind": "ObjectField",
                                                        "name": {
                                                            "kind": "Name",
                                                            "value": "_eq"
                                                        },
                                                        "value": {
                                                            "kind": "Variable",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "role_id"
                                                            }
                                                        }
                                                    }
                                                ]
                                            }
                                        }
                                    ]
                                }
                            }
                        ],
                        "selectionSet": {
                            "kind": "SelectionSet",
                            "selections": [
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "permission"
                                    },
                                    "selectionSet": {
                                        "kind": "SelectionSet",
                                        "selections": [
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "description"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "id"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "name"
                                                }
                                            }
                                        ]
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "role_id"
                                    }
                                }
                            ]
                        }
                    }
                ]
            }
        }
    ]
};
const AssingPermissionsDocument = {
    "kind": "Document",
    "definitions": [
        {
            "kind": "OperationDefinition",
            "operation": "mutation",
            "name": {
                "kind": "Name",
                "value": "AssingPermissions"
            },
            "variableDefinitions": [
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "insert_data"
                        }
                    },
                    "type": {
                        "kind": "NonNullType",
                        "type": {
                            "kind": "ListType",
                            "type": {
                                "kind": "NonNullType",
                                "type": {
                                    "kind": "NamedType",
                                    "name": {
                                        "kind": "Name",
                                        "value": "role_permission_insert_input"
                                    }
                                }
                            }
                        }
                    }
                },
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "role_id"
                        }
                    },
                    "type": {
                        "kind": "NonNullType",
                        "type": {
                            "kind": "NamedType",
                            "name": {
                                "kind": "Name",
                                "value": "uuid"
                            }
                        }
                    }
                },
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "permissions_to_delete"
                        }
                    },
                    "type": {
                        "kind": "NonNullType",
                        "type": {
                            "kind": "ListType",
                            "type": {
                                "kind": "NonNullType",
                                "type": {
                                    "kind": "NamedType",
                                    "name": {
                                        "kind": "Name",
                                        "value": "uuid"
                                    }
                                }
                            }
                        }
                    }
                }
            ],
            "selectionSet": {
                "kind": "SelectionSet",
                "selections": [
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "delete_role_permission"
                        },
                        "arguments": [
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "where"
                                },
                                "value": {
                                    "kind": "ObjectValue",
                                    "fields": [
                                        {
                                            "kind": "ObjectField",
                                            "name": {
                                                "kind": "Name",
                                                "value": "_and"
                                            },
                                            "value": {
                                                "kind": "ListValue",
                                                "values": [
                                                    {
                                                        "kind": "ObjectValue",
                                                        "fields": [
                                                            {
                                                                "kind": "ObjectField",
                                                                "name": {
                                                                    "kind": "Name",
                                                                    "value": "role_id"
                                                                },
                                                                "value": {
                                                                    "kind": "ObjectValue",
                                                                    "fields": [
                                                                        {
                                                                            "kind": "ObjectField",
                                                                            "name": {
                                                                                "kind": "Name",
                                                                                "value": "_eq"
                                                                            },
                                                                            "value": {
                                                                                "kind": "Variable",
                                                                                "name": {
                                                                                    "kind": "Name",
                                                                                    "value": "role_id"
                                                                                }
                                                                            }
                                                                        }
                                                                    ]
                                                                }
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "kind": "ObjectValue",
                                                        "fields": [
                                                            {
                                                                "kind": "ObjectField",
                                                                "name": {
                                                                    "kind": "Name",
                                                                    "value": "permission_id"
                                                                },
                                                                "value": {
                                                                    "kind": "ObjectValue",
                                                                    "fields": [
                                                                        {
                                                                            "kind": "ObjectField",
                                                                            "name": {
                                                                                "kind": "Name",
                                                                                "value": "_in"
                                                                            },
                                                                            "value": {
                                                                                "kind": "Variable",
                                                                                "name": {
                                                                                    "kind": "Name",
                                                                                    "value": "permissions_to_delete"
                                                                                }
                                                                            }
                                                                        }
                                                                    ]
                                                                }
                                                            }
                                                        ]
                                                    }
                                                ]
                                            }
                                        }
                                    ]
                                }
                            }
                        ],
                        "selectionSet": {
                            "kind": "SelectionSet",
                            "selections": [
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "affected_rows"
                                    }
                                }
                            ]
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "insert_role_permission"
                        },
                        "arguments": [
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "objects"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "insert_data"
                                    }
                                }
                            },
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "on_conflict"
                                },
                                "value": {
                                    "kind": "ObjectValue",
                                    "fields": [
                                        {
                                            "kind": "ObjectField",
                                            "name": {
                                                "kind": "Name",
                                                "value": "constraint"
                                            },
                                            "value": {
                                                "kind": "EnumValue",
                                                "value": "role_permission_pkey"
                                            }
                                        },
                                        {
                                            "kind": "ObjectField",
                                            "name": {
                                                "kind": "Name",
                                                "value": "update_columns"
                                            },
                                            "value": {
                                                "kind": "EnumValue",
                                                "value": "permission_id"
                                            }
                                        }
                                    ]
                                }
                            }
                        ],
                        "selectionSet": {
                            "kind": "SelectionSet",
                            "selections": [
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "affected_rows"
                                    }
                                }
                            ]
                        }
                    }
                ]
            }
        }
    ]
};
const GetRolesDocument = {
    "kind": "Document",
    "definitions": [
        {
            "kind": "OperationDefinition",
            "operation": "query",
            "name": {
                "kind": "Name",
                "value": "GetRoles"
            },
            "selectionSet": {
                "kind": "SelectionSet",
                "selections": [
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "role_aggregate"
                        },
                        "selectionSet": {
                            "kind": "SelectionSet",
                            "selections": [
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "aggregate"
                                    },
                                    "selectionSet": {
                                        "kind": "SelectionSet",
                                        "selections": [
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "count"
                                                }
                                            }
                                        ]
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "nodes"
                                    },
                                    "selectionSet": {
                                        "kind": "SelectionSet",
                                        "selections": [
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "description"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "name"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "id"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "is_default"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "scope"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "assigned_permissions_aggregate"
                                                },
                                                "selectionSet": {
                                                    "kind": "SelectionSet",
                                                    "selections": [
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "aggregate"
                                                            },
                                                            "selectionSet": {
                                                                "kind": "SelectionSet",
                                                                "selections": [
                                                                    {
                                                                        "kind": "Field",
                                                                        "name": {
                                                                            "kind": "Name",
                                                                            "value": "count"
                                                                        }
                                                                    }
                                                                ]
                                                            }
                                                        },
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "nodes"
                                                            },
                                                            "selectionSet": {
                                                                "kind": "SelectionSet",
                                                                "selections": [
                                                                    {
                                                                        "kind": "Field",
                                                                        "name": {
                                                                            "kind": "Name",
                                                                            "value": "permission_id"
                                                                        }
                                                                    },
                                                                    {
                                                                        "kind": "Field",
                                                                        "name": {
                                                                            "kind": "Name",
                                                                            "value": "permission"
                                                                        },
                                                                        "selectionSet": {
                                                                            "kind": "SelectionSet",
                                                                            "selections": [
                                                                                {
                                                                                    "kind": "Field",
                                                                                    "name": {
                                                                                        "kind": "Name",
                                                                                        "value": "id"
                                                                                    }
                                                                                },
                                                                                {
                                                                                    "kind": "Field",
                                                                                    "name": {
                                                                                        "kind": "Name",
                                                                                        "value": "name"
                                                                                    }
                                                                                }
                                                                            ]
                                                                        }
                                                                    }
                                                                ]
                                                            }
                                                        }
                                                    ]
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "role_bindings_aggregate"
                                                },
                                                "selectionSet": {
                                                    "kind": "SelectionSet",
                                                    "selections": [
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "aggregate"
                                                            },
                                                            "selectionSet": {
                                                                "kind": "SelectionSet",
                                                                "selections": [
                                                                    {
                                                                        "kind": "Field",
                                                                        "name": {
                                                                            "kind": "Name",
                                                                            "value": "count"
                                                                        },
                                                                        "arguments": [
                                                                            {
                                                                                "kind": "Argument",
                                                                                "name": {
                                                                                    "kind": "Name",
                                                                                    "value": "columns"
                                                                                },
                                                                                "value": {
                                                                                    "kind": "EnumValue",
                                                                                    "value": "subject_id"
                                                                                }
                                                                            }
                                                                        ]
                                                                    }
                                                                ]
                                                            }
                                                        },
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "nodes"
                                                            },
                                                            "selectionSet": {
                                                                "kind": "SelectionSet",
                                                                "selections": [
                                                                    {
                                                                        "kind": "Field",
                                                                        "name": {
                                                                            "kind": "Name",
                                                                            "value": "subject_id"
                                                                        }
                                                                    }
                                                                ]
                                                            }
                                                        }
                                                    ]
                                                }
                                            }
                                        ]
                                    }
                                }
                            ]
                        }
                    }
                ]
            }
        }
    ]
};
const ListRolesForUserDocument = {
    "kind": "Document",
    "definitions": [
        {
            "kind": "OperationDefinition",
            "operation": "query",
            "name": {
                "kind": "Name",
                "value": "ListRolesForUser"
            },
            "variableDefinitions": [
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "user_id"
                        }
                    },
                    "type": {
                        "kind": "NonNullType",
                        "type": {
                            "kind": "NamedType",
                            "name": {
                                "kind": "Name",
                                "value": "String"
                            }
                        }
                    }
                }
            ],
            "selectionSet": {
                "kind": "SelectionSet",
                "selections": [
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "role_binding"
                        },
                        "arguments": [
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "where"
                                },
                                "value": {
                                    "kind": "ObjectValue",
                                    "fields": [
                                        {
                                            "kind": "ObjectField",
                                            "name": {
                                                "kind": "Name",
                                                "value": "subject_id"
                                            },
                                            "value": {
                                                "kind": "ObjectValue",
                                                "fields": [
                                                    {
                                                        "kind": "ObjectField",
                                                        "name": {
                                                            "kind": "Name",
                                                            "value": "_eq"
                                                        },
                                                        "value": {
                                                            "kind": "Variable",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "user_id"
                                                            }
                                                        }
                                                    }
                                                ]
                                            }
                                        }
                                    ]
                                }
                            }
                        ],
                        "selectionSet": {
                            "kind": "SelectionSet",
                            "selections": [
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "role"
                                    },
                                    "selectionSet": {
                                        "kind": "SelectionSet",
                                        "selections": [
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "description"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "id"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "name"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "scope"
                                                }
                                            }
                                        ]
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "subject_id"
                                    }
                                }
                            ]
                        }
                    }
                ]
            }
        }
    ]
};
const AssingRolesDocument = {
    "kind": "Document",
    "definitions": [
        {
            "kind": "OperationDefinition",
            "operation": "mutation",
            "name": {
                "kind": "Name",
                "value": "AssingRoles"
            },
            "variableDefinitions": [
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "insert_data"
                        }
                    },
                    "type": {
                        "kind": "NonNullType",
                        "type": {
                            "kind": "ListType",
                            "type": {
                                "kind": "NonNullType",
                                "type": {
                                    "kind": "NamedType",
                                    "name": {
                                        "kind": "Name",
                                        "value": "role_binding_insert_input"
                                    }
                                }
                            }
                        }
                    }
                },
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "user_id"
                        }
                    },
                    "type": {
                        "kind": "NonNullType",
                        "type": {
                            "kind": "NamedType",
                            "name": {
                                "kind": "Name",
                                "value": "String"
                            }
                        }
                    }
                },
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "roles_to_delete"
                        }
                    },
                    "type": {
                        "kind": "NonNullType",
                        "type": {
                            "kind": "ListType",
                            "type": {
                                "kind": "NonNullType",
                                "type": {
                                    "kind": "NamedType",
                                    "name": {
                                        "kind": "Name",
                                        "value": "uuid"
                                    }
                                }
                            }
                        }
                    }
                }
            ],
            "selectionSet": {
                "kind": "SelectionSet",
                "selections": [
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "insert_role_binding"
                        },
                        "arguments": [
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "objects"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "insert_data"
                                    }
                                }
                            },
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "on_conflict"
                                },
                                "value": {
                                    "kind": "ObjectValue",
                                    "fields": [
                                        {
                                            "kind": "ObjectField",
                                            "name": {
                                                "kind": "Name",
                                                "value": "constraint"
                                            },
                                            "value": {
                                                "kind": "EnumValue",
                                                "value": "role_binding_pkey"
                                            }
                                        },
                                        {
                                            "kind": "ObjectField",
                                            "name": {
                                                "kind": "Name",
                                                "value": "update_columns"
                                            },
                                            "value": {
                                                "kind": "EnumValue",
                                                "value": "role_id"
                                            }
                                        }
                                    ]
                                }
                            }
                        ],
                        "selectionSet": {
                            "kind": "SelectionSet",
                            "selections": [
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "affected_rows"
                                    }
                                }
                            ]
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "delete_role_binding"
                        },
                        "arguments": [
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "where"
                                },
                                "value": {
                                    "kind": "ObjectValue",
                                    "fields": [
                                        {
                                            "kind": "ObjectField",
                                            "name": {
                                                "kind": "Name",
                                                "value": "_and"
                                            },
                                            "value": {
                                                "kind": "ListValue",
                                                "values": [
                                                    {
                                                        "kind": "ObjectValue",
                                                        "fields": [
                                                            {
                                                                "kind": "ObjectField",
                                                                "name": {
                                                                    "kind": "Name",
                                                                    "value": "subject_id"
                                                                },
                                                                "value": {
                                                                    "kind": "ObjectValue",
                                                                    "fields": [
                                                                        {
                                                                            "kind": "ObjectField",
                                                                            "name": {
                                                                                "kind": "Name",
                                                                                "value": "_eq"
                                                                            },
                                                                            "value": {
                                                                                "kind": "Variable",
                                                                                "name": {
                                                                                    "kind": "Name",
                                                                                    "value": "user_id"
                                                                                }
                                                                            }
                                                                        }
                                                                    ]
                                                                }
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "kind": "ObjectValue",
                                                        "fields": [
                                                            {
                                                                "kind": "ObjectField",
                                                                "name": {
                                                                    "kind": "Name",
                                                                    "value": "role_id"
                                                                },
                                                                "value": {
                                                                    "kind": "ObjectValue",
                                                                    "fields": [
                                                                        {
                                                                            "kind": "ObjectField",
                                                                            "name": {
                                                                                "kind": "Name",
                                                                                "value": "_in"
                                                                            },
                                                                            "value": {
                                                                                "kind": "Variable",
                                                                                "name": {
                                                                                    "kind": "Name",
                                                                                    "value": "roles_to_delete"
                                                                                }
                                                                            }
                                                                        }
                                                                    ]
                                                                }
                                                            }
                                                        ]
                                                    }
                                                ]
                                            }
                                        }
                                    ]
                                }
                            }
                        ],
                        "selectionSet": {
                            "kind": "SelectionSet",
                            "selections": [
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "affected_rows"
                                    }
                                }
                            ]
                        }
                    }
                ]
            }
        }
    ]
};
const CreateRoleDocument = {
    "kind": "Document",
    "definitions": [
        {
            "kind": "OperationDefinition",
            "operation": "mutation",
            "name": {
                "kind": "Name",
                "value": "CreateRole"
            },
            "variableDefinitions": [
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "role_name"
                        }
                    },
                    "type": {
                        "kind": "NonNullType",
                        "type": {
                            "kind": "NamedType",
                            "name": {
                                "kind": "Name",
                                "value": "String"
                            }
                        }
                    }
                },
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "description"
                        }
                    },
                    "type": {
                        "kind": "NonNullType",
                        "type": {
                            "kind": "NamedType",
                            "name": {
                                "kind": "Name",
                                "value": "String"
                            }
                        }
                    }
                },
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "scope"
                        }
                    },
                    "type": {
                        "kind": "NonNullType",
                        "type": {
                            "kind": "NamedType",
                            "name": {
                                "kind": "Name",
                                "value": "jsonb"
                            }
                        }
                    }
                }
            ],
            "selectionSet": {
                "kind": "SelectionSet",
                "selections": [
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "insert_role_one"
                        },
                        "arguments": [
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "object"
                                },
                                "value": {
                                    "kind": "ObjectValue",
                                    "fields": [
                                        {
                                            "kind": "ObjectField",
                                            "name": {
                                                "kind": "Name",
                                                "value": "name"
                                            },
                                            "value": {
                                                "kind": "Variable",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "role_name"
                                                }
                                            }
                                        },
                                        {
                                            "kind": "ObjectField",
                                            "name": {
                                                "kind": "Name",
                                                "value": "description"
                                            },
                                            "value": {
                                                "kind": "Variable",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "description"
                                                }
                                            }
                                        },
                                        {
                                            "kind": "ObjectField",
                                            "name": {
                                                "kind": "Name",
                                                "value": "is_default"
                                            },
                                            "value": {
                                                "kind": "BooleanValue",
                                                "value": false
                                            }
                                        },
                                        {
                                            "kind": "ObjectField",
                                            "name": {
                                                "kind": "Name",
                                                "value": "scope"
                                            },
                                            "value": {
                                                "kind": "Variable",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "scope"
                                                }
                                            }
                                        }
                                    ]
                                }
                            }
                        ],
                        "selectionSet": {
                            "kind": "SelectionSet",
                            "selections": [
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "id"
                                    }
                                }
                            ]
                        }
                    }
                ]
            }
        }
    ]
};
const UpdateRoleDocument = {
    "kind": "Document",
    "definitions": [
        {
            "kind": "OperationDefinition",
            "operation": "mutation",
            "name": {
                "kind": "Name",
                "value": "UpdateRole"
            },
            "variableDefinitions": [
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "id"
                        }
                    },
                    "type": {
                        "kind": "NonNullType",
                        "type": {
                            "kind": "NamedType",
                            "name": {
                                "kind": "Name",
                                "value": "uuid"
                            }
                        }
                    }
                },
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "name"
                        }
                    },
                    "type": {
                        "kind": "NonNullType",
                        "type": {
                            "kind": "NamedType",
                            "name": {
                                "kind": "Name",
                                "value": "String"
                            }
                        }
                    }
                },
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "description"
                        }
                    },
                    "type": {
                        "kind": "NonNullType",
                        "type": {
                            "kind": "NamedType",
                            "name": {
                                "kind": "Name",
                                "value": "String"
                            }
                        }
                    }
                },
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "scope"
                        }
                    },
                    "type": {
                        "kind": "NonNullType",
                        "type": {
                            "kind": "NamedType",
                            "name": {
                                "kind": "Name",
                                "value": "jsonb"
                            }
                        }
                    }
                }
            ],
            "selectionSet": {
                "kind": "SelectionSet",
                "selections": [
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "update_role"
                        },
                        "arguments": [
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "where"
                                },
                                "value": {
                                    "kind": "ObjectValue",
                                    "fields": [
                                        {
                                            "kind": "ObjectField",
                                            "name": {
                                                "kind": "Name",
                                                "value": "id"
                                            },
                                            "value": {
                                                "kind": "ObjectValue",
                                                "fields": [
                                                    {
                                                        "kind": "ObjectField",
                                                        "name": {
                                                            "kind": "Name",
                                                            "value": "_eq"
                                                        },
                                                        "value": {
                                                            "kind": "Variable",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "id"
                                                            }
                                                        }
                                                    }
                                                ]
                                            }
                                        }
                                    ]
                                }
                            },
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "_set"
                                },
                                "value": {
                                    "kind": "ObjectValue",
                                    "fields": [
                                        {
                                            "kind": "ObjectField",
                                            "name": {
                                                "kind": "Name",
                                                "value": "name"
                                            },
                                            "value": {
                                                "kind": "Variable",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "name"
                                                }
                                            }
                                        },
                                        {
                                            "kind": "ObjectField",
                                            "name": {
                                                "kind": "Name",
                                                "value": "description"
                                            },
                                            "value": {
                                                "kind": "Variable",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "description"
                                                }
                                            }
                                        },
                                        {
                                            "kind": "ObjectField",
                                            "name": {
                                                "kind": "Name",
                                                "value": "scope"
                                            },
                                            "value": {
                                                "kind": "Variable",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "scope"
                                                }
                                            }
                                        }
                                    ]
                                }
                            }
                        ],
                        "selectionSet": {
                            "kind": "SelectionSet",
                            "selections": [
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "returning"
                                    },
                                    "selectionSet": {
                                        "kind": "SelectionSet",
                                        "selections": [
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "id"
                                                }
                                            }
                                        ]
                                    }
                                }
                            ]
                        }
                    }
                ]
            }
        }
    ]
};
const DeleteRoleDocument = {
    "kind": "Document",
    "definitions": [
        {
            "kind": "OperationDefinition",
            "operation": "mutation",
            "name": {
                "kind": "Name",
                "value": "DeleteRole"
            },
            "variableDefinitions": [
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "id"
                        }
                    },
                    "type": {
                        "kind": "NonNullType",
                        "type": {
                            "kind": "NamedType",
                            "name": {
                                "kind": "Name",
                                "value": "uuid"
                            }
                        }
                    }
                }
            ],
            "selectionSet": {
                "kind": "SelectionSet",
                "selections": [
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "delete_role"
                        },
                        "arguments": [
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "where"
                                },
                                "value": {
                                    "kind": "ObjectValue",
                                    "fields": [
                                        {
                                            "kind": "ObjectField",
                                            "name": {
                                                "kind": "Name",
                                                "value": "id"
                                            },
                                            "value": {
                                                "kind": "ObjectValue",
                                                "fields": [
                                                    {
                                                        "kind": "ObjectField",
                                                        "name": {
                                                            "kind": "Name",
                                                            "value": "_eq"
                                                        },
                                                        "value": {
                                                            "kind": "Variable",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "id"
                                                            }
                                                        }
                                                    }
                                                ]
                                            }
                                        }
                                    ]
                                }
                            }
                        ],
                        "selectionSet": {
                            "kind": "SelectionSet",
                            "selections": [
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "returning"
                                    },
                                    "selectionSet": {
                                        "kind": "SelectionSet",
                                        "selections": [
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "id"
                                                }
                                            }
                                        ]
                                    }
                                }
                            ]
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "delete_role_permission"
                        },
                        "arguments": [
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "where"
                                },
                                "value": {
                                    "kind": "ObjectValue",
                                    "fields": [
                                        {
                                            "kind": "ObjectField",
                                            "name": {
                                                "kind": "Name",
                                                "value": "role_id"
                                            },
                                            "value": {
                                                "kind": "ObjectValue",
                                                "fields": [
                                                    {
                                                        "kind": "ObjectField",
                                                        "name": {
                                                            "kind": "Name",
                                                            "value": "_eq"
                                                        },
                                                        "value": {
                                                            "kind": "Variable",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "id"
                                                            }
                                                        }
                                                    }
                                                ]
                                            }
                                        }
                                    ]
                                }
                            }
                        ],
                        "selectionSet": {
                            "kind": "SelectionSet",
                            "selections": [
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "affected_rows"
                                    }
                                }
                            ]
                        }
                    }
                ]
            }
        }
    ]
};
const GlobalSettingsDocument = {
    "kind": "Document",
    "definitions": [
        {
            "kind": "OperationDefinition",
            "operation": "query",
            "name": {
                "kind": "Name",
                "value": "GlobalSettings"
            },
            "selectionSet": {
                "kind": "SelectionSet",
                "selections": [
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "global_settings"
                        },
                        "arguments": [
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "where"
                                },
                                "value": {
                                    "kind": "ObjectValue",
                                    "fields": []
                                }
                            }
                        ],
                        "selectionSet": {
                            "kind": "SelectionSet",
                            "selections": [
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "data"
                                    }
                                }
                            ]
                        }
                    }
                ]
            }
        }
    ]
};
const UpdateGlobalSettingsDocument = {
    "kind": "Document",
    "definitions": [
        {
            "kind": "OperationDefinition",
            "operation": "mutation",
            "name": {
                "kind": "Name",
                "value": "UpdateGlobalSettings"
            },
            "variableDefinitions": [
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "data"
                        }
                    },
                    "type": {
                        "kind": "NamedType",
                        "name": {
                            "kind": "Name",
                            "value": "jsonb"
                        }
                    }
                }
            ],
            "selectionSet": {
                "kind": "SelectionSet",
                "selections": [
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "update_global_settings"
                        },
                        "arguments": [
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "_append"
                                },
                                "value": {
                                    "kind": "ObjectValue",
                                    "fields": [
                                        {
                                            "kind": "ObjectField",
                                            "name": {
                                                "kind": "Name",
                                                "value": "data"
                                            },
                                            "value": {
                                                "kind": "Variable",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "data"
                                                }
                                            }
                                        }
                                    ]
                                }
                            },
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "where"
                                },
                                "value": {
                                    "kind": "ObjectValue",
                                    "fields": []
                                }
                            }
                        ],
                        "selectionSet": {
                            "kind": "SelectionSet",
                            "selections": [
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "returning"
                                    },
                                    "selectionSet": {
                                        "kind": "SelectionSet",
                                        "selections": [
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "data"
                                                }
                                            }
                                        ]
                                    }
                                }
                            ]
                        }
                    }
                ]
            }
        }
    ]
};
const GlobalAuthSettingsDocument = {
    "kind": "Document",
    "definitions": [
        {
            "kind": "OperationDefinition",
            "operation": "query",
            "name": {
                "kind": "Name",
                "value": "GlobalAuthSettings"
            },
            "selectionSet": {
                "kind": "SelectionSet",
                "selections": [
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "global_auth_settings"
                        },
                        "arguments": [
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "where"
                                },
                                "value": {
                                    "kind": "ObjectValue",
                                    "fields": []
                                }
                            }
                        ],
                        "selectionSet": {
                            "kind": "SelectionSet",
                            "selections": [
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "auth_data"
                                    }
                                }
                            ]
                        }
                    }
                ]
            }
        }
    ]
};
const UpdateGlobalAuthSettingsDocument = {
    "kind": "Document",
    "definitions": [
        {
            "kind": "OperationDefinition",
            "operation": "mutation",
            "name": {
                "kind": "Name",
                "value": "UpdateGlobalAuthSettings"
            },
            "variableDefinitions": [
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "auth_data"
                        }
                    },
                    "type": {
                        "kind": "NamedType",
                        "name": {
                            "kind": "Name",
                            "value": "jsonb"
                        }
                    }
                }
            ],
            "selectionSet": {
                "kind": "SelectionSet",
                "selections": [
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "update_global_auth_settings"
                        },
                        "arguments": [
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "_append"
                                },
                                "value": {
                                    "kind": "ObjectValue",
                                    "fields": [
                                        {
                                            "kind": "ObjectField",
                                            "name": {
                                                "kind": "Name",
                                                "value": "auth_data"
                                            },
                                            "value": {
                                                "kind": "Variable",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "auth_data"
                                                }
                                            }
                                        }
                                    ]
                                }
                            },
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "where"
                                },
                                "value": {
                                    "kind": "ObjectValue",
                                    "fields": []
                                }
                            }
                        ],
                        "selectionSet": {
                            "kind": "SelectionSet",
                            "selections": [
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "returning"
                                    },
                                    "selectionSet": {
                                        "kind": "SelectionSet",
                                        "selections": [
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "auth_data"
                                                }
                                            }
                                        ]
                                    }
                                }
                            ]
                        }
                    }
                ]
            }
        }
    ]
};
const GetSettingsDocument = {
    "kind": "Document",
    "definitions": [
        {
            "kind": "OperationDefinition",
            "operation": "query",
            "name": {
                "kind": "Name",
                "value": "GetSettings"
            },
            "variableDefinitions": [
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "user_id"
                        }
                    },
                    "type": {
                        "kind": "NamedType",
                        "name": {
                            "kind": "Name",
                            "value": "String"
                        }
                    },
                    "defaultValue": {
                        "kind": "StringValue",
                        "value": "",
                        "block": false
                    }
                }
            ],
            "selectionSet": {
                "kind": "SelectionSet",
                "selections": [
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "settings_by_pk"
                        },
                        "arguments": [
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "user_id"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "user_id"
                                    }
                                }
                            }
                        ],
                        "selectionSet": {
                            "kind": "SelectionSet",
                            "selections": [
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "data"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "user_id"
                                    }
                                }
                            ]
                        }
                    }
                ]
            }
        }
    ]
};
const UpdateSettingsDocument = {
    "kind": "Document",
    "definitions": [
        {
            "kind": "OperationDefinition",
            "operation": "mutation",
            "name": {
                "kind": "Name",
                "value": "UpdateSettings"
            },
            "variableDefinitions": [
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "data"
                        }
                    },
                    "type": {
                        "kind": "NamedType",
                        "name": {
                            "kind": "Name",
                            "value": "jsonb"
                        }
                    }
                },
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "user_id"
                        }
                    },
                    "type": {
                        "kind": "NonNullType",
                        "type": {
                            "kind": "NamedType",
                            "name": {
                                "kind": "Name",
                                "value": "String"
                            }
                        }
                    }
                }
            ],
            "selectionSet": {
                "kind": "SelectionSet",
                "selections": [
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "insert_settings"
                        },
                        "arguments": [
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "objects"
                                },
                                "value": {
                                    "kind": "ObjectValue",
                                    "fields": [
                                        {
                                            "kind": "ObjectField",
                                            "name": {
                                                "kind": "Name",
                                                "value": "user_id"
                                            },
                                            "value": {
                                                "kind": "Variable",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "user_id"
                                                }
                                            }
                                        },
                                        {
                                            "kind": "ObjectField",
                                            "name": {
                                                "kind": "Name",
                                                "value": "data"
                                            },
                                            "value": {
                                                "kind": "Variable",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "data"
                                                }
                                            }
                                        }
                                    ]
                                }
                            },
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "on_conflict"
                                },
                                "value": {
                                    "kind": "ObjectValue",
                                    "fields": [
                                        {
                                            "kind": "ObjectField",
                                            "name": {
                                                "kind": "Name",
                                                "value": "constraint"
                                            },
                                            "value": {
                                                "kind": "EnumValue",
                                                "value": "settings_pkey"
                                            }
                                        }
                                    ]
                                }
                            }
                        ],
                        "selectionSet": {
                            "kind": "SelectionSet",
                            "selections": [
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "affected_rows"
                                    }
                                }
                            ]
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "update_settings_by_pk"
                        },
                        "arguments": [
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "pk_columns"
                                },
                                "value": {
                                    "kind": "ObjectValue",
                                    "fields": [
                                        {
                                            "kind": "ObjectField",
                                            "name": {
                                                "kind": "Name",
                                                "value": "user_id"
                                            },
                                            "value": {
                                                "kind": "Variable",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "user_id"
                                                }
                                            }
                                        }
                                    ]
                                }
                            },
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "_append"
                                },
                                "value": {
                                    "kind": "ObjectValue",
                                    "fields": [
                                        {
                                            "kind": "ObjectField",
                                            "name": {
                                                "kind": "Name",
                                                "value": "data"
                                            },
                                            "value": {
                                                "kind": "Variable",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "data"
                                                }
                                            }
                                        }
                                    ]
                                }
                            }
                        ],
                        "selectionSet": {
                            "kind": "SelectionSet",
                            "selections": [
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "user_id"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "data"
                                    }
                                }
                            ]
                        }
                    }
                ]
            }
        }
    ]
};
const UpdateUiSettingsDocument = {
    "kind": "Document",
    "definitions": [
        {
            "kind": "OperationDefinition",
            "operation": "mutation",
            "name": {
                "kind": "Name",
                "value": "UpdateUISettings"
            },
            "variableDefinitions": [
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "user_id"
                        }
                    },
                    "type": {
                        "kind": "NonNullType",
                        "type": {
                            "kind": "NamedType",
                            "name": {
                                "kind": "Name",
                                "value": "String"
                            }
                        }
                    }
                },
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "entity_id"
                        }
                    },
                    "type": {
                        "kind": "NonNullType",
                        "type": {
                            "kind": "NamedType",
                            "name": {
                                "kind": "Name",
                                "value": "String"
                            }
                        }
                    }
                },
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "settings"
                        }
                    },
                    "type": {
                        "kind": "NamedType",
                        "name": {
                            "kind": "Name",
                            "value": "jsonb"
                        }
                    }
                }
            ],
            "selectionSet": {
                "kind": "SelectionSet",
                "selections": [
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "insert_ui_settings"
                        },
                        "arguments": [
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "objects"
                                },
                                "value": {
                                    "kind": "ObjectValue",
                                    "fields": [
                                        {
                                            "kind": "ObjectField",
                                            "name": {
                                                "kind": "Name",
                                                "value": "user_id"
                                            },
                                            "value": {
                                                "kind": "Variable",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "user_id"
                                                }
                                            }
                                        },
                                        {
                                            "kind": "ObjectField",
                                            "name": {
                                                "kind": "Name",
                                                "value": "entity_id"
                                            },
                                            "value": {
                                                "kind": "Variable",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "entity_id"
                                                }
                                            }
                                        },
                                        {
                                            "kind": "ObjectField",
                                            "name": {
                                                "kind": "Name",
                                                "value": "settings"
                                            },
                                            "value": {
                                                "kind": "Variable",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "settings"
                                                }
                                            }
                                        }
                                    ]
                                }
                            },
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "on_conflict"
                                },
                                "value": {
                                    "kind": "ObjectValue",
                                    "fields": [
                                        {
                                            "kind": "ObjectField",
                                            "name": {
                                                "kind": "Name",
                                                "value": "constraint"
                                            },
                                            "value": {
                                                "kind": "EnumValue",
                                                "value": "ui_settings_pkey"
                                            }
                                        },
                                        {
                                            "kind": "ObjectField",
                                            "name": {
                                                "kind": "Name",
                                                "value": "update_columns"
                                            },
                                            "value": {
                                                "kind": "ListValue",
                                                "values": [
                                                    {
                                                        "kind": "EnumValue",
                                                        "value": "settings"
                                                    }
                                                ]
                                            }
                                        }
                                    ]
                                }
                            }
                        ],
                        "selectionSet": {
                            "kind": "SelectionSet",
                            "selections": [
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "returning"
                                    },
                                    "selectionSet": {
                                        "kind": "SelectionSet",
                                        "selections": [
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "user_id"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "entity_id"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "settings"
                                                }
                                            }
                                        ]
                                    }
                                }
                            ]
                        }
                    }
                ]
            }
        }
    ]
};
const GetAllUiSettingsDocument = {
    "kind": "Document",
    "definitions": [
        {
            "kind": "OperationDefinition",
            "operation": "query",
            "name": {
                "kind": "Name",
                "value": "GetAllUISettings"
            },
            "variableDefinitions": [
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "user_id"
                        }
                    },
                    "type": {
                        "kind": "NonNullType",
                        "type": {
                            "kind": "NamedType",
                            "name": {
                                "kind": "Name",
                                "value": "String"
                            }
                        }
                    }
                }
            ],
            "selectionSet": {
                "kind": "SelectionSet",
                "selections": [
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "ui_settings"
                        },
                        "arguments": [
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "where"
                                },
                                "value": {
                                    "kind": "ObjectValue",
                                    "fields": [
                                        {
                                            "kind": "ObjectField",
                                            "name": {
                                                "kind": "Name",
                                                "value": "user_id"
                                            },
                                            "value": {
                                                "kind": "ObjectValue",
                                                "fields": [
                                                    {
                                                        "kind": "ObjectField",
                                                        "name": {
                                                            "kind": "Name",
                                                            "value": "_eq"
                                                        },
                                                        "value": {
                                                            "kind": "Variable",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "user_id"
                                                            }
                                                        }
                                                    }
                                                ]
                                            }
                                        }
                                    ]
                                }
                            }
                        ],
                        "selectionSet": {
                            "kind": "SelectionSet",
                            "selections": [
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "user_id"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "entity_id"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "settings"
                                    }
                                }
                            ]
                        }
                    }
                ]
            }
        }
    ]
};
const GetUiSettingsDocument = {
    "kind": "Document",
    "definitions": [
        {
            "kind": "OperationDefinition",
            "operation": "query",
            "name": {
                "kind": "Name",
                "value": "GetUISettings"
            },
            "variableDefinitions": [
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "user_id"
                        }
                    },
                    "type": {
                        "kind": "NonNullType",
                        "type": {
                            "kind": "NamedType",
                            "name": {
                                "kind": "Name",
                                "value": "String"
                            }
                        }
                    }
                },
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "entity_id"
                        }
                    },
                    "type": {
                        "kind": "NonNullType",
                        "type": {
                            "kind": "NamedType",
                            "name": {
                                "kind": "Name",
                                "value": "String"
                            }
                        }
                    }
                }
            ],
            "selectionSet": {
                "kind": "SelectionSet",
                "selections": [
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "ui_settings"
                        },
                        "arguments": [
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "where"
                                },
                                "value": {
                                    "kind": "ObjectValue",
                                    "fields": [
                                        {
                                            "kind": "ObjectField",
                                            "name": {
                                                "kind": "Name",
                                                "value": "_and"
                                            },
                                            "value": {
                                                "kind": "ListValue",
                                                "values": [
                                                    {
                                                        "kind": "ObjectValue",
                                                        "fields": [
                                                            {
                                                                "kind": "ObjectField",
                                                                "name": {
                                                                    "kind": "Name",
                                                                    "value": "user_id"
                                                                },
                                                                "value": {
                                                                    "kind": "ObjectValue",
                                                                    "fields": [
                                                                        {
                                                                            "kind": "ObjectField",
                                                                            "name": {
                                                                                "kind": "Name",
                                                                                "value": "_eq"
                                                                            },
                                                                            "value": {
                                                                                "kind": "Variable",
                                                                                "name": {
                                                                                    "kind": "Name",
                                                                                    "value": "user_id"
                                                                                }
                                                                            }
                                                                        }
                                                                    ]
                                                                }
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "kind": "ObjectValue",
                                                        "fields": [
                                                            {
                                                                "kind": "ObjectField",
                                                                "name": {
                                                                    "kind": "Name",
                                                                    "value": "entity_id"
                                                                },
                                                                "value": {
                                                                    "kind": "ObjectValue",
                                                                    "fields": [
                                                                        {
                                                                            "kind": "ObjectField",
                                                                            "name": {
                                                                                "kind": "Name",
                                                                                "value": "_eq"
                                                                            },
                                                                            "value": {
                                                                                "kind": "Variable",
                                                                                "name": {
                                                                                    "kind": "Name",
                                                                                    "value": "entity_id"
                                                                                }
                                                                            }
                                                                        }
                                                                    ]
                                                                }
                                                            }
                                                        ]
                                                    }
                                                ]
                                            }
                                        }
                                    ]
                                }
                            }
                        ],
                        "selectionSet": {
                            "kind": "SelectionSet",
                            "selections": [
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "user_id"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "entity_id"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "settings"
                                    }
                                }
                            ]
                        }
                    }
                ]
            }
        }
    ]
};

;// CONCATENATED MODULE: ./src/api/graphql/index.ts



/***/ }),

/***/ 48863:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "n": () => (/* binding */ sendGQLRequest)
/* harmony export */ });
/* harmony import */ var libs_api_fetch_gql__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(62006);

const sendGQLRequest = (0,libs_api_fetch_gql__WEBPACK_IMPORTED_MODULE_0__/* .createRequest */ .h)("/v1/graphql");


/***/ }),

/***/ 62688:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "api": () => (/* reexport safe */ _gen__WEBPACK_IMPORTED_MODULE_0__.hi)
/* harmony export */ });
/* unused harmony export graphapi */
/* harmony import */ var _gen__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(33013);


const graphapi = null;


/***/ }),

/***/ 53810:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "F": () => (/* binding */ MViewStatusKey),
/* harmony export */   "i": () => (/* binding */ useMViewsStatus)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var react_query__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(21478);
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(50576);
/* harmony import */ var api_gen__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(33013);
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}




const MViewStatusKey = "m-view-status";
function useStatus(config) {
    return (0,react_query__WEBPACK_IMPORTED_MODULE_1__/* .useQuery */ .aM)([
        MViewStatusKey
    ], /*#__PURE__*/ _async_to_generator(function*() {
        return api_gen__WEBPACK_IMPORTED_MODULE_2__/* .api.eventsapi.Service.MViewStatus */ .hi.eventsapi.Service.MViewStatus({});
    }), config);
}
// Continuously polls for status change
function useMViewsStatus({ onStatusChange , enabled  }) {
    const [status, setStatus] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(null);
    useStatus({
        refetchInterval: getRefetchInterval(status),
        refetchIntervalInBackground: true,
        onSuccess: (response)=>{
            const newStatus = {
                isPrecomputedReady: !response || (response === null || response === void 0 ? void 0 : response.is_precomputed_ready),
                staleAsOf: response === null || response === void 0 ? void 0 : response.stale_as_of
            };
            if (!(0,lodash__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(status, newStatus)) {
                setStatus(newStatus);
                onStatusChange(newStatus);
            }
        },
        enabled
    });
    return status;
}
function getRefetchInterval(status) {
    if (!(status === null || status === void 0 ? void 0 : status.isPrecomputedReady)) {
        // 1 minute interval if data is not ready, so we can quickly update if update completed
        return 1000 * 60;
    }
    // 2 minutes polling interval if data is ready
    return 1000 * 60 * 2;
}


/***/ }),

/***/ 41491:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "m": () => (/* binding */ permissions)
/* harmony export */ });
/* eslint-disable */ // prettier-disable
const permissions = [
    "admin_saml__modify",
    "admin_saml__read",
    "api_token__modify",
    "api_token__read",
    "console__read",
    "global_auth_settings__modify",
    "global_auth_settings__read",
    "global_settings__modify",
    "global_settings__read",
    "incident_comment__modify",
    "incident_comment__read",
    "irm__read",
    "role__create",
    "role__delete",
    "role__read",
    "role__update",
    "user__create",
    "user__delete",
    "user__read",
    "user__update",
    "admin_global_settings__modify",
    "admin_global_settings__read",
    "audit__read",
    "cloud_sensor__modify",
    "cloud_sensor__read",
    "dataset__create",
    "dataset__delete",
    "dataset__read",
    "dataset__update",
    "dataset_policy_template__read",
    "directory_sync__modify",
    "directory_sync__read",
    "directory_user_details__read",
    "dlp_rules__modify",
    "dlp_rules__read",
    "endpoint__read",
    "endpoint__update",
    "external_storage_settings__modify",
    "external_storage_settings__read",
    "file_tags__modify",
    "file_tags__read",
    "flow_captured_content__read",
    "flow_details__read",
    "flow_screenshots__read",
    "flow_stats__read",
    "incident__read",
    "incident__update",
    "policy__create",
    "policy__delete",
    "policy__read",
    "policy__update",
    "visual_analytics__read",
    "assigned_incident__update",
    "assigned_incident__read",
    "incident_details__read"
];


/***/ }),

/***/ 21665:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "R": () => (/* binding */ permissionsSections),
/* harmony export */   "u": () => (/* binding */ resourceDescriptions)
/* harmony export */ });
const resourceDescriptions = {
    directory_user_details: {
        name: "End User Details",
        description: "Full information about end-users, including data from directory integrations"
    },
    dataset: {
        name: "Dataset",
        description: "Dataset definitions"
    },
    policy: {
        name: "Policy",
        description: "Policies definitions"
    },
    dataset_policy_template: {
        name: "Policy and Dataset Templates",
        description: "Policy and Dataset Templates"
    },
    flow_details: {
        name: "Event Details for Dashboard",
        description: "Dashboard details of events, including data flows with filenames, email addresses, etc."
    },
    flow_stats: {
        name: "Event Numbers",
        description: "Aggregate number of events and related statistics"
    },
    flow_screenshots: {
        name: "Endpoint Screenshots",
        description: "Screenshots of incident violations taken on end-user endpoints"
    },
    flow_captured_content: {
        name: "File Content",
        description: "Full content of captured files"
    },
    incident_comment: {
        name: "Incident Comments",
        description: "Comments for each incident"
    },
    incident_details: {
        name: "Event Details for Incidents",
        description: "View event details for incidents"
    },
    incident: {
        name: "Incidents",
        description: "List of all incidents",
        update: {
            linkedWith: [
                "assigned_incident__update"
            ]
        }
    },
    endpoint: {
        name: "Endpoint Sensor Status",
        description: "Endpoint sensors information and management"
    },
    cloud_sensor: {
        name: "Cloud Sensors",
        description: "Cloud sensors and connectors configuration"
    },
    admin_saml: {
        name: "Authentication Providers",
        description: "Cyberhaven console authentication providers configuration"
    },
    admin_global_settings: {
        name: "Logo Settings",
        description: "Configuration of logo image shown in end-user warnings"
    },
    api_token: {
        name: "API Token Management",
        description: "API tokens configuration"
    },
    audit: {
        name: "Audit Log",
        description: "Audit log on RISKS OVERVIEW page"
    },
    role: {
        name: "Role Management",
        description: "Cyberhaven console roles information and management"
    },
    user: {
        name: "User Management",
        description: "Cyberhaven console users information and management"
    },
    dlp_rules: {
        name: "Content Attributes",
        description: "Content attributes configuration"
    },
    file_tags: {
        name: "Document Tags",
        description: "Document tags configuration"
    },
    console: {
        name: "Login via UI",
        description: "Ability to login to Cyberhaven dashboard which gives access to favicons, short url, user defined settings and features enabled"
    },
    global_settings: {
        name: "Feature Control",
        description: "Control of optional and beta features of Cyberhaven"
    },
    global_auth_settings: {
        name: "Automatic Logout",
        description: "Force users to logout after certain period of inactivity"
    },
    directory_sync: {
        name: "Directory Sync Integration",
        description: "Directory integration information and management"
    },
    assigned_incident: {
        name: "Assigned Incidents",
        description: "Access incidents assigned to me",
        update: {
            linkedWith: [
                "incident__update"
            ]
        }
    },
    visual_analytics: {
        name: "Visual Analytics",
        description: "Access to analytics dashboard and tools (kibana and other tools)"
    },
    external_storage_settings: {
        name: "External storage settings",
        description: "Access to external storage settings."
    },
    irm: {
        name: "Insiders",
        description: "List of insiders with related statistics."
    }
};
const permissionsSections = [
    {
        title: "General",
        permissions: {
            console: {
                isRequired: true,
                requiredDescription: "This permission is needed to login from Login page"
            }
        }
    },
    {
        title: "Risks Dashboard",
        permissions: {
            dataset: {
                isRequired: true
            },
            policy: {
                isRequired: true
            },
            flow_stats: {
                isRequired: true
            },
            flow_details: {},
            audit: {},
            flow_captured_content: {},
            dataset_policy_template: {},
            directory_user_details: {}
        }
    },
    {
        title: "Incidents",
        permissions: {
            incident: {
                isRequired: true
            },
            assigned_incident: {
                isRequired: true
            },
            incident_comment: {},
            incident_details: {},
            flow_screenshots: {},
            flow_captured_content: {},
            directory_user_details: {}
        }
    },
    {
        title: "Insider Risk Management",
        permissions: {
            irm: {
                isRequired: true
            },
            incident: {
                isRequired: true
            },
            dataset: {
                isRequired: true
            },
            policy: {
                isRequired: true
            },
            flow_stats: {
                isRequired: true
            },
            visual_analytics: {},
            directory_user_details: {}
        }
    },
    {
        title: "Cloud sensors",
        enabledPermissionTypes: [
            "read",
            "modify"
        ],
        permissions: {
            cloud_sensor: {
                isRequired: true
            }
        }
    },
    {
        title: "Endpoints",
        permissions: {
            endpoint: {
                isRequired: true
            }
        }
    },
    {
        title: "Settings",
        permissions: {
            user: {},
            role: {},
            directory_sync: {},
            global_settings: {},
            dlp_rules: {},
            file_tags: {},
            admin_global_settings: {},
            admin_saml: {},
            api_token: {},
            global_auth_settings: {},
            visual_analytics: {},
            external_storage_settings: {}
        }
    }
];


/***/ }),

/***/ 20346:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Gg": () => (/* binding */ timesCount),
/* harmony export */   "Io": () => (/* binding */ deleteDataset),
/* harmony export */   "J7": () => (/* binding */ overviewEntityReadTransformation),
/* harmony export */   "N4": () => (/* binding */ locationCount),
/* harmony export */   "ON": () => (/* binding */ getDatasetsConnectionsList),
/* harmony export */   "RH": () => (/* binding */ getTotalCounts),
/* harmony export */   "Tw": () => (/* binding */ usersCount),
/* harmony export */   "Ty": () => (/* binding */ createDataset),
/* harmony export */   "WT": () => (/* binding */ resolveIncidents),
/* harmony export */   "Xc": () => (/* binding */ getLocationSubItems),
/* harmony export */   "cr": () => (/* binding */ incidentsListView),
/* harmony export */   "do": () => (/* binding */ updateDataset),
/* harmony export */   "hW": () => (/* binding */ listIncidents),
/* harmony export */   "j_": () => (/* binding */ getCategoriesCounts),
/* harmony export */   "k4": () => (/* binding */ createCategory),
/* harmony export */   "kH": () => (/* binding */ getUserRiskProgression),
/* harmony export */   "kU": () => (/* binding */ listDatasets),
/* harmony export */   "kb": () => (/* binding */ listCategories),
/* harmony export */   "pW": () => (/* binding */ getDatasetConnections),
/* harmony export */   "s4": () => (/* binding */ getRiskyUsers),
/* harmony export */   "tc": () => (/* binding */ countUnresolvedIncidents),
/* harmony export */   "uu": () => (/* binding */ deleteCategory),
/* harmony export */   "v1": () => (/* binding */ getDatasetsCounts),
/* harmony export */   "yr": () => (/* binding */ updateCategory)
/* harmony export */ });
/* unused harmony exports AddCategory, categoriesCount, totalCount, mapStatuses, mapCategoriesResponse, mapDatasetsResponse */
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(87694);
/* harmony import */ var api__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(62688);
/* harmony import */ var api_gen__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(33013);
/* harmony import */ var libs_data_utils__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(50082);
/* harmony import */ var libs_cel_query__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(67511);
/* harmony import */ var _types__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(27107);
// Reexport apis with friendlier names and more suitable types overrides
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}






const overviewEntityReadTransformation = (datasetOrCategory)=>{
    const changeHasPhraseIntoContains = (datasetOrCategory)=>{
        var _datasetOrCategory_query_rules;
        var _datasetOrCategory_query_rules_map;
        datasetOrCategory.query.rules = (_datasetOrCategory_query_rules_map = (_datasetOrCategory_query_rules = datasetOrCategory.query.rules) === null || _datasetOrCategory_query_rules === void 0 ? void 0 : _datasetOrCategory_query_rules.map((rule)=>{
            var _rule_conditions;
            var _rule_conditions_map;
            rule.conditions = (_rule_conditions_map = (_rule_conditions = rule.conditions) === null || _rule_conditions === void 0 ? void 0 : _rule_conditions.map((condition)=>{
                condition.operator = condition.operator === _types__WEBPACK_IMPORTED_MODULE_4__/* .FullOperatorEnum.OperatorHasPhrase */ .b.OperatorHasPhrase ? _types__WEBPACK_IMPORTED_MODULE_4__/* .FullOperatorEnum.OperatorContains */ .b.OperatorContains : condition.operator;
                return condition;
            })) !== null && _rule_conditions_map !== void 0 ? _rule_conditions_map : null;
            return rule;
        })) !== null && _datasetOrCategory_query_rules_map !== void 0 ? _datasetOrCategory_query_rules_map : null;
        return datasetOrCategory;
    };
    return changeHasPhraseIntoContains(datasetOrCategory);
};
const { DeleteCategory: deleteCategory , AddCategory , DeleteDataset: deleteDataset , CategoriesCountV2: categoriesCount , Locations: locationCount , TotalCount: totalCount , UsersCount: usersCount , ListIncidents: listIncidents , ResolveIncidents: resolveIncidents , IncidentListView: incidentsListView , CountUnresolvedIncidents: countUnresolvedIncidents  } = api__WEBPACK_IMPORTED_MODULE_0__.api.riskydashboard.ServiceInterface;
const createCategory = (entity)=>{
    return api__WEBPACK_IMPORTED_MODULE_0__.api.riskydashboard.ServiceInterface.AddCategory({
        category: removeExcessSelectAllValues(entity, "dataset_ids")
    });
};
const updateCategory = (entity)=>{
    return api__WEBPACK_IMPORTED_MODULE_0__.api.riskydashboard.ServiceInterface.UpdateCategory({
        category: removeExcessSelectAllValues(entity, "dataset_ids")
    });
};
const listCategories = (filter)=>{
    return api__WEBPACK_IMPORTED_MODULE_0__.api.riskydashboard.ServiceInterface.ListCategories({
        filter
    }).then((response)=>{
        var _response_categories;
        var _response_categories_map;
        response.categories = (_response_categories_map = (_response_categories = response.categories) === null || _response_categories === void 0 ? void 0 : _response_categories.map(overviewEntityReadTransformation)) !== null && _response_categories_map !== void 0 ? _response_categories_map : response.categories;
        return response;
    });
};
function removeExcessSelectAllValues(entity, field) {
    var _entity_field;
    return _object_spread_props(_object_spread({}, entity), {
        [field]: (_entity_field = entity[field]) === null || _entity_field === void 0 ? void 0 : _entity_field.filter((id)=>![
                "a",
                "l",
                "all"
            ].includes(id))
    });
}
const createDataset = (entity)=>{
    return api__WEBPACK_IMPORTED_MODULE_0__.api.riskydashboard.ServiceInterface.AddDataset({
        dataset: removeExcessSelectAllValues(entity, "category_ids")
    });
};
const updateDataset = (entity)=>{
    return api__WEBPACK_IMPORTED_MODULE_0__.api.riskydashboard.ServiceInterface.UpdateDataset({
        dataset: removeExcessSelectAllValues(entity, "category_ids")
    });
};
const listDatasets = (filter)=>{
    return api__WEBPACK_IMPORTED_MODULE_0__.api.riskydashboard.ServiceInterface.ListDatasets({
        filter
    }).then((response)=>{
        var _response_datasets;
        var _response_datasets_map;
        response.datasets = (_response_datasets_map = (_response_datasets = response.datasets) === null || _response_datasets === void 0 ? void 0 : _response_datasets.map(overviewEntityReadTransformation)) !== null && _response_datasets_map !== void 0 ? _response_datasets_map : response.datasets;
        return response;
    });
};
const timesCount = (params)=>{
    return api__WEBPACK_IMPORTED_MODULE_0__.api.riskydashboard.ServiceInterface.TimesCount(params).then((d)=>{
        if (!d.dataflows_counts) {
            return [];
        }
        return (d.period_starts || []).map((period, i)=>{
            var _d_dataflows_counts, _d_users_counts, _d_locations_counts;
            return {
                date: period,
                flows: (_d_dataflows_counts = d.dataflows_counts) === null || _d_dataflows_counts === void 0 ? void 0 : _d_dataflows_counts[i],
                users: (_d_users_counts = d.users_counts) === null || _d_users_counts === void 0 ? void 0 : _d_users_counts[i],
                locations: (_d_locations_counts = d.locations_counts) === null || _d_locations_counts === void 0 ? void 0 : _d_locations_counts[i]
            };
        });
    });
};
function mapStatuses(statuses) {
    let sum = 0;
    const map = {};
    const values = [];
    function mapValues(name, count) {
        count = count !== null && count !== void 0 ? count : 0;
        map[name] = count;
        sum += count;
        values.push({
            name,
            count
        });
    }
    for(const k in statuses){
        mapValues(k, statuses[k]);
    }
    return {
        statusesMap: map,
        statusesList: values,
        count: sum
    };
}
function mapCategoriesResponse(d) {
    return {
        records: (d.categories || []).map((el)=>{
            const name = el.id === "Uncategorized" ? "Unmatched" : el.name;
            return _object_spread(_object_spread_props(_object_spread({}, el), {
                name
            }), mapStatuses((0,lodash__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(el.status_to_count, [
                el.rule.status,
                "needs_review"
            ])));
        }).sort((0,libs_data_utils__WEBPACK_IMPORTED_MODULE_2__/* .compareBy */ .tT)((el)=>el.count))
    };
}
function getCategoriesCounts(_param) {
    return _getCategoriesCounts.apply(this, arguments);
}
function _getCategoriesCounts() {
    _getCategoriesCounts = _async_to_generator(function*(_param) {
        var { is_search =false  } = _param, params = _object_without_properties(_param, [
            "is_search"
        ]);
        var _params_categories_filter, _params_categories_filter_preview_category;
        if (params.categories_filter && ((_params_categories_filter = params.categories_filter) === null || _params_categories_filter === void 0 ? void 0 : (_params_categories_filter_preview_category = _params_categories_filter.preview_category) === null || _params_categories_filter_preview_category === void 0 ? void 0 : _params_categories_filter_preview_category.category)) {
            var _currCategory_rule, _params_categories_filter1;
            const currCategory = params.categories_filter.preview_category.category;
            const categoryStatus = is_search ? api_gen__WEBPACK_IMPORTED_MODULE_1__/* .CategoryStatusEnum.CategoryStatusNeedsReview */ .HL.CategoryStatusNeedsReview : currCategory.rule.status;
            var _currCategory_rule_status;
            const res = yield api__WEBPACK_IMPORTED_MODULE_0__.api.riskydashboard.ServiceInterface.TotalCount(_object_spread_props(_object_spread({}, params), {
                statuses: [
                    (_currCategory_rule_status = (_currCategory_rule = currCategory.rule) === null || _currCategory_rule === void 0 ? void 0 : _currCategory_rule.status) !== null && _currCategory_rule_status !== void 0 ? _currCategory_rule_status : api_gen__WEBPACK_IMPORTED_MODULE_1__/* .CategoryStatusEnum.CategoryStatusAny */ .HL.CategoryStatusAny
                ]
            }));
            const count = Object.values(res.counts).reduce((acc, el)=>acc + el, 0);
            return mapCategoriesResponse({
                categories: [
                    _object_spread_props(_object_spread({}, currCategory), {
                        name: currCategory.name,
                        rule: _object_spread_props(_object_spread({}, (_params_categories_filter1 = params.categories_filter) === null || _params_categories_filter1 === void 0 ? void 0 : _params_categories_filter1.preview_category.category.rule), {
                            status: categoryStatus
                        }),
                        status_to_count: {
                            [categoryStatus]: count
                        }
                    })
                ]
            });
        }
        return api__WEBPACK_IMPORTED_MODULE_0__.api.riskydashboard.ServiceInterface.CategoriesCountV2(params).then((res)=>{
            return mapCategoriesResponse(res);
        });
    });
    return _getCategoriesCounts.apply(this, arguments);
}
function mapDatasetsResponse(d) {
    return {
        records: (d.records || []).map((el)=>_object_spread({}, el, mapStatuses(el.status_to_count))).sort((0,libs_data_utils__WEBPACK_IMPORTED_MODULE_2__/* .compareBy */ .tT)((el)=>el.count))
    };
}
function getDatasetsCounts(params) {
    return api__WEBPACK_IMPORTED_MODULE_0__.api.riskydashboard.ServiceInterface.DatasetsCountV2(params).then(mapDatasetsResponse);
}
function getDatasetsConnectionsList(datasetsIds, params) {
    return _getDatasetsConnectionsList.apply(this, arguments);
}
function _getDatasetsConnectionsList() {
    _getDatasetsConnectionsList = _async_to_generator(function*(datasetsIds, params) {
        const promises = datasetsIds.map((id)=>{
            const requestParams = _object_spread_props(_object_spread({}, params), {
                datasets_filter: {
                    datasets: [
                        id
                    ],
                    all_datasets: false
                }
            });
            return getDatasetConnections(id, requestParams);
        });
        return Promise.allSettled(promises).then((results)=>{
            const allConnections = {};
            results.forEach((result)=>{
                if (result.status === "fulfilled") {
                    const { id , connections  } = result.value;
                    allConnections[id] = connections;
                }
            });
            return allConnections;
        });
    });
    return _getDatasetsConnectionsList.apply(this, arguments);
}
function getDatasetConnections(id, params) {
    return _getDatasetConnections.apply(this, arguments);
}
function _getDatasetConnections() {
    _getDatasetConnections = _async_to_generator(function*(id, params) {
        return api__WEBPACK_IMPORTED_MODULE_0__.api.riskydashboard.ServiceInterface.CategoriesCountV2(params).then((res)=>{
            const categories = mapCategoriesResponse(res).records;
            const connections = {};
            categories.filter((category)=>category.count > 0 && category.rule.status !== api_gen__WEBPACK_IMPORTED_MODULE_1__/* .CategoryStatusEnum.CategoryStatusAny */ .HL.CategoryStatusAny).forEach((category)=>{
                connections[category.id] = {
                    status: category.rule.status,
                    count: category.count
                };
            });
            return {
                id,
                connections
            };
        });
    });
    return _getDatasetConnections.apply(this, arguments);
}
function getTotalCounts(params) {
    return _getTotalCounts.apply(this, arguments);
}
function _getTotalCounts() {
    _getTotalCounts = _async_to_generator(function*(params) {
        const { counts  } = yield api__WEBPACK_IMPORTED_MODULE_0__.api.riskydashboard.ServiceInterface.TotalCount(params);
        return counts;
    });
    return _getTotalCounts.apply(this, arguments);
}
function getLocationSubItems(params, location) {
    return _getLocationSubItems.apply(this, arguments);
}
function _getLocationSubItems() {
    _getLocationSubItems = _async_to_generator(function*(params, location) {
        return locationCount(_object_spread_props(_object_spread({}, params), {
            page: 0,
            page_size: 1,
            no_default_expansions: true,
            expansions: [
                location
            ]
        }));
    });
    return _getLocationSubItems.apply(this, arguments);
}
function getRiskyUsers(params) {
    return _getRiskyUsers.apply(this, arguments);
}
function _getRiskyUsers() {
    _getRiskyUsers = _async_to_generator(function*(params) {
        var _response_records;
        const response = yield api__WEBPACK_IMPORTED_MODULE_0__.api.irm.Service.GetRiskyUsers(params);
        const nextPage = ((_response_records = response.records) === null || _response_records === void 0 ? void 0 : _response_records.length) && params.offset + response.records.length < response.total ? params.offset + response.records.length : undefined;
        return {
            total: response.total,
            result: response.records || [],
            nextPage
        };
    });
    return _getRiskyUsers.apply(this, arguments);
}
function getUserRiskProgression(_) {
    return _getUserRiskProgression.apply(this, arguments);
}
function _getUserRiskProgression() {
    _getUserRiskProgression = _async_to_generator(function*({ userId , times_filter , period , filter  }) {
        const { records  } = yield api__WEBPACK_IMPORTED_MODULE_0__.api.irm.Service.GetTimeline({
            times_filter,
            metrics: [
                "risk_score"
            ],
            period_type: period,
            filter: (0,libs_cel_query__WEBPACK_IMPORTED_MODULE_3__/* .celCombine */ .lS)(libs_cel_query__WEBPACK_IMPORTED_MODULE_3__/* .CELConditionOperator.AND */ .KM.AND, `name == '${userId}'`, filter)
        });
        return {
            risks: records.map((record)=>({
                    risk: record.metrics.risk_score,
                    date: record.date
                })),
            type: period
        };
    });
    return _getUserRiskProgression.apply(this, arguments);
}


/***/ }),

/***/ 44673:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "KF": () => (/* reexport */ getString),
  "BX": () => (/* reexport */ storeString)
});

// UNUSED EXPORTS: QueryApi, api

// EXTERNAL MODULE: ./node_modules/axios/index.js
var axios = __webpack_require__(9669);
var axios_default = /*#__PURE__*/__webpack_require__.n(axios);
;// CONCATENATED MODULE: ./src/api/short-url/short-url.ts
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}

function storeString(data) {
    return axios_default().post("/v1/short-url", {
        data
    });
}
function getString(id) {
    return axios_default().get("/v1/short-url", {
        params: {
            id
        }
    }).then((el)=>el.data.data);
}
class QueryApi {
    constructor(){
        _define_property(this, "url", "/v1/short-url");
        _define_property(this, "cancelToken", null);
        var _this = this;
        _define_property(this, "post", function() {
            var _ref = _async_to_generator(function*(queryState) {
                _this.cancel();
                const { data  } = yield axios_default().post(_this.url, {
                    data: JSON.stringify(queryState)
                }, {
                    cancelToken: new (axios_default()).CancelToken((c)=>_this.cancelToken = c)
                });
                return data.id;
            });
            return function(queryState) {
                return _ref.apply(this, arguments);
            };
        }());
        _define_property(this, "cancel", ()=>{
            if (this.cancelToken) {
                this.cancelToken();
            }
            this.cancelToken = null;
        });
        _define_property(this, "get", (id)=>{
            if (!id) {
                return null;
            }
            return axios_default().get(this.url, {
                params: {
                    id
                }
            }).then((el)=>{
                return JSON.parse(el.data.data);
            }).catch(()=>null);
        });
    }
}
const api = new QueryApi();


;// CONCATENATED MODULE: ./src/api/short-url/index.ts



/***/ }),

/***/ 15322:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "f": () => (/* reexport */ acceptTerms),
  "R": () => (/* reexport */ fetchTermsAndConditions)
});

// EXTERNAL MODULE: ./node_modules/axios/index.js
var axios = __webpack_require__(9669);
var axios_default = /*#__PURE__*/__webpack_require__.n(axios);
;// CONCATENATED MODULE: ./src/api/terms/terms.ts

const api = {
    terms: "/v1/terms?version=1"
};
function fetchTermsAndConditions() {
    return axios_default().get(api.terms).then((el)=>el.data.consented);
}
function acceptTerms() {
    return axios_default().post(api.terms, null);
}

;// CONCATENATED MODULE: ./src/api/terms/index.ts



/***/ }),

/***/ 27107:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "b": () => (/* binding */ FullOperatorEnum)
/* harmony export */ });
/* harmony import */ var _gen__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(33013);
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}

const FullOperatorEnum = _object_spread_props(_object_spread({}, _gen__WEBPACK_IMPORTED_MODULE_0__/* .OperatorEnum */ .lf), {
    OperatorExists: "exists"
});


/***/ }),

/***/ 8676:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "main": () => (/* binding */ main)
});

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/axios/index.js
var axios = __webpack_require__(9669);
var axios_default = /*#__PURE__*/__webpack_require__.n(axios);
// EXTERNAL MODULE: ./node_modules/react-dom/index.js
var react_dom = __webpack_require__(73935);
// EXTERNAL MODULE: ./node_modules/react-query/es/index.js + 22 modules
var es = __webpack_require__(21478);
// EXTERNAL MODULE: ./src/assets/icons/ch_icon3.svg
var ch_icon3 = __webpack_require__(2523);
// EXTERNAL MODULE: ./src/assets/icons/ch_icon4.svg
var ch_icon4 = __webpack_require__(42158);
// EXTERNAL MODULE: ./src/runenv.tsx
var runenv = __webpack_require__(76223);
// EXTERNAL MODULE: ./src/service.tsx
var service = __webpack_require__(89880);
// EXTERNAL MODULE: ./src/shared/logger.ts
var logger = __webpack_require__(20168);
// EXTERNAL MODULE: ./src/modules/auth/effects.ts
var effects = __webpack_require__(77805);
// EXTERNAL MODULE: ./src/modules/preferences/state.ts
var state = __webpack_require__(86965);
// EXTERNAL MODULE: ./src/modules/terms/state.ts
var terms_state = __webpack_require__(44428);
// EXTERNAL MODULE: ./src/api/auth/interceptors/index.ts
var interceptors = __webpack_require__(71684);
// EXTERNAL MODULE: ./src/ui/atoms/Box.tsx
var Box = __webpack_require__(17299);
// EXTERNAL MODULE: ./src/api/auth/storage.ts
var storage = __webpack_require__(86758);
// EXTERNAL MODULE: ./src/modules/risks/dashboard/apiHooks.tsx
var apiHooks = __webpack_require__(96697);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 20 modules
var react_redux_es = __webpack_require__(28216);
// EXTERNAL MODULE: ./src/ui/index.ts + 23 modules
var ui = __webpack_require__(17218);
;// CONCATENATED MODULE: ./src/shared/NetworkActivityIndicator.tsx



function NetworkActivityIndicator() {
    const isFetching = !!(0,es/* useIsFetching */.yU)();
    return isFetching ? /*#__PURE__*/ react.createElement(ui/* PageProgress */.wm, null) : null;
}

// EXTERNAL MODULE: ./src/shared/check-error.ts
var check_error = __webpack_require__(58983);
// EXTERNAL MODULE: ./src/shared/errors.ts
var errors = __webpack_require__(45026);
// EXTERNAL MODULE: ./node_modules/react-router-dom/dist/index.js
var dist = __webpack_require__(79655);
// EXTERNAL MODULE: ./src/modules/notification/index.ts + 3 modules
var notification = __webpack_require__(5769);
// EXTERNAL MODULE: ./src/modules/auth/organisms/index.ts + 6 modules
var organisms = __webpack_require__(65598);
// EXTERNAL MODULE: ./src/shared/permissions.tsx
var permissions = __webpack_require__(44916);
// EXTERNAL MODULE: ./src/shared/features.ts
var features = __webpack_require__(58767);
// EXTERNAL MODULE: ./node_modules/react-router/dist/index.js
var react_router_dist = __webpack_require__(89250);
// EXTERNAL MODULE: ./src/modules/layout/atoms/index.ts
var atoms = __webpack_require__(39566);
// EXTERNAL MODULE: ./src/modules/layout/organisms/LayoutClassic.tsx + 4 modules
var LayoutClassic = __webpack_require__(7529);
;// CONCATENATED MODULE: ./src/modules/layout/organisms/LayoutFullscreen.tsx

const LayoutFullscreen = (/* unused pure expression or super */ null && (FullscreenContent));

;// CONCATENATED MODULE: ./src/modules/layout/organisms/index.ts



;// CONCATENATED MODULE: ./src/modules/layout/index.ts




// EXTERNAL MODULE: ./src/modules/router/index.ts
var router = __webpack_require__(66943);
// EXTERNAL MODULE: ./src/modules/timezone/index.ts + 1 modules
var timezone = __webpack_require__(43100);
// EXTERNAL MODULE: ./src/shared/index.ts
var shared = __webpack_require__(10451);
// EXTERNAL MODULE: ./src/assets/icons/index.tsx + 1 modules
var icons = __webpack_require__(99899);
// EXTERNAL MODULE: ./src/ui/css/index.ts
var css = __webpack_require__(93461);
// EXTERNAL MODULE: ./src/modules/users/apiHooks.ts
var users_apiHooks = __webpack_require__(25508);
// EXTERNAL MODULE: ./src/modules/external/zendesk/zendeskUtils.ts
var zendeskUtils = __webpack_require__(39820);
;// CONCATENATED MODULE: ./src/modules/external/zendesk/ZendeskWidget.tsx
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}









const zendeskWidgetStyles = (0,css/* css */.iv)({
    display: "flex",
    position: "fixed",
    bottom: 10,
    left: 10,
    width: "36px !important",
    height: "36px !important",
    zIndex: 5000
});
const Zendesk = ({ onClose  })=>{
    const currentUser = (0,users_apiHooks/* useCurrentUser */.xJ)();
    (0,react.useEffect)(()=>{
        return ()=>{
            (0,zendeskUtils/* zendeskAPI */.G)("webWidget", "hide");
        };
    }, []);
    (0,react.useEffect)(()=>{
        var _currentUser_data, _currentUser_data1;
        (0,zendeskUtils/* zendeskAPI */.G)("webWidget", "identify", {
            name: (_currentUser_data = currentUser.data) === null || _currentUser_data === void 0 ? void 0 : _currentUser_data.email,
            email: (_currentUser_data1 = currentUser.data) === null || _currentUser_data1 === void 0 ? void 0 : _currentUser_data1.email,
            organization: runenv/* ENV.CUSTOMER_NAME */.V.CUSTOMER_NAME
        });
        (0,zendeskUtils/* zendeskAPI */.G)("webWidget", "setLocale", "en");
        (0,zendeskUtils/* zendeskAPI */.G)("webWidget", "open");
        (0,zendeskUtils/* zendeskAPI */.G)("webWidget", "show");
        (0,zendeskUtils/* zendeskAPI */.G)("webWidget:on", "close", onClose);
    }, [
        window.zE,
        currentUser.data
    ]);
    return null;
};
const ZendeskWidget = (_param)=>{
    var { className , onLoaded =shared/* noop */.ZT  } = _param, rest = _object_without_properties(_param, [
        "className",
        "onLoaded"
    ]);
    const currentUser = (0,users_apiHooks/* useCurrentUser */.xJ)();
    const [isOpen, setIsOpen] = (0,react.useState)(false);
    const close = ()=>setIsOpen(false);
    if (!currentUser.data) {
        return null;
    }
    return /*#__PURE__*/ react.createElement(Box/* Box */.x, _object_spread({
        "data-testid": "zendesk-widget",
        className: zendeskWidgetStyles({
            className
        }).className
    }, rest), /*#__PURE__*/ react.createElement(Box/* Box */.x, {
        onClick: ()=>setIsOpen(true),
        sx: {
            width: 36,
            height: 36,
            borderRadius: "50%",
            background: "#43A7EA",
            color: "white",
            padding: 5,
            cursor: "pointer",
            display: "flex",
            alignItems: "center",
            justifyContent: "center"
        }
    }, /*#__PURE__*/ react.createElement(icons/* ChatIcon */.kB, {
        width: 18,
        height: 18
    })), isOpen && /*#__PURE__*/ react.createElement(Zendesk, {
        key: String(isOpen),
        onClose: close,
        onLoaded: onLoaded
    }), isOpen && /*#__PURE__*/ (0,react_dom.createPortal)(/*#__PURE__*/ react.createElement(Box/* Box */.x, {
        onClick: close,
        sx: {
            width: "100%",
            height: "100%",
            zIndex: 100,
            position: "fixed",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            background: "transparent"
        }
    }), document.body));
};

// EXTERNAL MODULE: ./src/modules/router/pages/AccessDeniedPage.tsx
var AccessDeniedPage = __webpack_require__(34875);
;// CONCATENATED MODULE: ./src/assets/images/404.svg
var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }


const Svg404 = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    viewBox: "0 0 1920 1024",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m890.42 665v-9.953h3.411c1.126 0 1.982 0.225 2.57 0.677 0.588 0.451 0.882 1.123 0.882 2.016 0 0.456-0.123 0.866-0.369 1.231-0.246 0.364-0.606 0.647-1.08 0.847 0.538 0.146 0.952 0.422 1.244 0.828 0.296 0.401 0.444 0.884 0.444 1.449 0 0.934-0.3 1.652-0.902 2.153-0.597 0.501-1.454 0.752-2.57 0.752h-3.63zm1.729-4.491v3.11h1.921c0.543 0 0.966-0.134 1.272-0.403 0.305-0.269 0.458-0.643 0.458-1.121 0-1.035-0.529-1.563-1.586-1.586h-2.065zm0-1.272h1.696c0.537 0 0.957-0.12 1.258-0.362 0.305-0.246 0.458-0.592 0.458-1.039 0-0.492-0.142-0.848-0.424-1.066-0.278-0.219-0.714-0.329-1.306-0.329h-1.682v2.796zm13.174 3.446h-3.855l-0.807 2.317h-1.798l3.76-9.953h1.552l3.766 9.953h-1.804l-0.814-2.317zm-3.37-1.395h2.885l-1.443-4.129-1.442 4.129zm15.067 0.472c-0.1 1.062-0.492 1.891-1.175 2.488-0.684 0.592-1.593 0.889-2.728 0.889-0.793 0-1.492-0.187-2.098-0.561-0.602-0.378-1.067-0.914-1.395-1.606-0.328-0.693-0.499-1.497-0.513-2.413v-0.93c0-0.939 0.167-1.766 0.499-2.481 0.333-0.716 0.809-1.267 1.429-1.655 0.624-0.387 1.344-0.581 2.16-0.581 1.099 0 1.983 0.299 2.653 0.896 0.669 0.597 1.059 1.44 1.168 2.529h-1.722c-0.082-0.716-0.292-1.231-0.629-1.545-0.333-0.319-0.823-0.478-1.47-0.478-0.752 0-1.331 0.275-1.736 0.827-0.401 0.547-0.606 1.351-0.615 2.413v0.882c0 1.075 0.191 1.895 0.574 2.461 0.387 0.565 0.952 0.847 1.695 0.847 0.679 0 1.19-0.152 1.531-0.458 0.342-0.305 0.559-0.813 0.65-1.524h1.722zm4.91-1.06-1.128 1.196v3.104h-1.73v-9.953h1.73v4.669l0.957-1.183 2.912-3.486h2.092l-3.699 4.409 3.911 5.544h-2.051l-2.994-4.3zm17.242-4.259h-3.104v8.559h-1.715v-8.559h-3.077v-1.394h7.896v1.394zm9.564 3.842c0 0.975-0.168 1.832-0.506 2.571-0.337 0.733-0.82 1.298-1.449 1.695-0.624 0.392-1.344 0.588-2.16 0.588-0.807 0-1.527-0.196-2.16-0.588-0.629-0.397-1.117-0.959-1.463-1.689-0.342-0.729-0.515-1.57-0.52-2.522v-0.561c0-0.97 0.171-1.827 0.513-2.57 0.347-0.743 0.832-1.31 1.456-1.702 0.629-0.397 1.349-0.595 2.16-0.595 0.812 0 1.529 0.196 2.154 0.588 0.629 0.387 1.114 0.948 1.456 1.682 0.342 0.729 0.515 1.579 0.519 2.549v0.554zm-1.729-0.519c0-1.103-0.21-1.949-0.629-2.536-0.415-0.588-1.005-0.882-1.771-0.882-0.747 0-1.333 0.294-1.756 0.882-0.42 0.583-0.634 1.41-0.643 2.481v0.574c0 1.094 0.212 1.939 0.636 2.536 0.428 0.597 1.021 0.896 1.777 0.896 0.766 0 1.354-0.292 1.764-0.875 0.414-0.583 0.622-1.436 0.622-2.557v-0.519zm15.841 5.236h-1.723v-4.423h-4.45v4.423h-1.73v-9.953h1.73v4.142h4.45v-4.142h1.723v9.953zm10.494-4.717c0 0.975-0.169 1.832-0.506 2.571-0.337 0.733-0.82 1.298-1.449 1.695-0.625 0.392-1.345 0.588-2.16 0.588-0.807 0-1.527-0.196-2.161-0.588-0.629-0.397-1.116-0.959-1.463-1.689-0.341-0.729-0.514-1.57-0.519-2.522v-0.561c0-0.97 0.171-1.827 0.513-2.57 0.346-0.743 0.831-1.31 1.456-1.702 0.629-0.397 1.349-0.595 2.16-0.595s1.529 0.196 2.153 0.588c0.629 0.387 1.114 0.948 1.456 1.682 0.342 0.729 0.515 1.579 0.52 2.549v0.554zm-1.73-0.519c0-1.103-0.209-1.949-0.629-2.536-0.414-0.588-1.005-0.882-1.77-0.882-0.748 0-1.333 0.294-1.757 0.882-0.419 0.583-0.633 1.41-0.643 2.481v0.574c0 1.094 0.212 1.939 0.636 2.536 0.429 0.597 1.021 0.896 1.778 0.896 0.765 0 1.353-0.292 1.763-0.875 0.415-0.583 0.622-1.436 0.622-2.557v-0.519zm6.195-4.717 2.871 7.629 2.864-7.629h2.235v9.953h-1.722v-3.281l0.171-4.389-2.94 7.67h-1.237l-2.933-7.663 0.171 4.382v3.281h-1.723v-9.953h2.243zm16.338 5.51h-4.087v3.062h4.778v1.381h-6.508v-9.953h6.46v1.394h-4.73v2.748h4.087v1.368zm4.329 0.745v3.698h-1.73v-9.953h3.805c1.11 0 2 0.289 2.65 0.868s0.98 1.344 0.98 2.297c0 0.975-0.32 1.734-0.96 2.276-0.64 0.543-1.53 0.814-2.69 0.814h-2.055zm0-1.388h2.075c0.62 0 1.09-0.143 1.41-0.431 0.32-0.291 0.49-0.711 0.49-1.257 0-0.538-0.17-0.967-0.5-1.286-0.32-0.323-0.78-0.489-1.35-0.499h-2.125v3.473zm12.075 2.769h-3.85l-0.81 2.317h-1.8l3.76-9.953h1.56l3.76 9.953h-1.8l-0.82-2.317zm-3.37-1.395h2.89l-1.44-4.129-1.45 4.129zm15.11 2.42c-0.36 0.469-0.86 0.825-1.5 1.066-0.64 0.242-1.36 0.363-2.17 0.363-0.84 0-1.58-0.189-2.22-0.568-0.64-0.378-1.14-0.918-1.49-1.62-0.35-0.706-0.53-1.529-0.54-2.468v-0.779c0-1.504 0.36-2.677 1.08-3.52 0.72-0.848 1.73-1.272 3.01-1.272 1.11 0 1.99 0.274 2.64 0.82 0.66 0.547 1.05 1.336 1.18 2.366h-1.7c-0.19-1.199-0.88-1.798-2.08-1.798-0.78 0-1.37 0.28-1.77 0.841-0.4 0.556-0.61 1.374-0.62 2.454v0.765c0 1.076 0.22 1.912 0.67 2.509 0.46 0.593 1.09 0.889 1.9 0.889 0.88 0 1.51-0.201 1.88-0.602v-1.948h-2.05v-1.312h3.78v3.814zm8.21-3.151h-4.08v3.062h4.77v1.381h-6.5v-9.953h6.46v1.394h-4.73v2.748h4.08v1.368z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 275,
    y: 269,
    width: 321,
    height: 112,
    rx: 5,
    fill: "#eee"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 260,
    y: 250,
    width: 321,
    height: 112,
    rx: 5,
    fill: "#F9F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m445.54 307.71c-3.323 1.803-7.13 3.259-10.938 4.299 0.069-0.694 0.069-1.318 0.069-2.011-0.138-8.805-3.185-17.332-8.585-24.195 10.454 2.218 18.485 11.023 19.454 21.907zm-22.569-22.393c6.023 6.864 9.485 15.599 9.692 24.612 0 0.832-0.069 1.733-0.138 2.565-4.223 0.97-8.239 1.525-11.562 1.525-3.253-0.069-7.338-0.555-11.561-1.525-0.069-0.832-0.139-1.664-0.139-2.496 0.208-9.082 3.6-17.817 9.693-24.681 0.692-0.069 1.315-0.069 2.007-0.069 0.693 0 1.385 0.069 2.008 0.069zm-7.131 0.486c-5.4 6.932-8.515 15.39-8.654 24.264 0 0.694 0.07 1.318 0.07 1.942-3.808-1.04-7.546-2.427-10.939-4.299 1.039-10.884 9.069-19.689 19.523-21.907zm-19.592 24.195c3.462 1.803 7.408 3.189 11.285 4.16 0.9 7.279 3.807 14.212 8.377 20.035-11.216-2.357-19.662-12.271-19.662-24.195zm22.708 24.681c-4.985-5.616-8.17-12.618-9.277-19.967 4.084 0.902 8.1 1.387 11.284 1.456 3.185-0.069 7.2-0.554 11.285-1.456-1.108 7.349-4.292 14.282-9.277 19.967-0.692 0.069-1.315 0.069-2.008 0.069-0.692 0-1.384-0.069-2.007-0.069zm7.13-0.486c4.57-5.823 7.408-12.687 8.377-20.035 3.877-0.971 7.754-2.357 11.285-4.16-0.069 11.924-8.515 21.838-19.662 24.195z",
    fill: "#eee"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m208.76 650.25-4.763-8.25h9.526l-4.763 8.25z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m259.75 304.76-8.25 4.763v-9.526l8.25 4.763z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252 305H209.355L209 643",
    stroke: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 808,
    y: 898,
    width: 321,
    height: 112,
    rx: 5,
    fill: "#eee"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 793,
    y: 879,
    width: 321,
    height: 112,
    rx: 3,
    fill: "#F9F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m933.99 916.92c-0.629 0-1.21 0.252-1.706 0.675l20.09 18.764c1.049 1.163 2.16 1.163 3.21 0l20.124-18.764c-0.496-0.423-1.077-0.675-1.706-0.675h-40.012zm-3.058 2.981c-0.119 0.466-0.186 0.966-0.186 1.49v29.808c0 2.477 1.447 4.471 3.244 4.471h40.012c1.797 0 3.244-1.994 3.244-4.471v-29.808c0-0.524-0.067-1.024-0.186-1.49l-20.124 18.786c-1.743 1.931-4.171 1.934-5.914 0l-20.09-18.786z",
    fill: "#eee"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 61,
    y: 669,
    width: 321,
    height: 112,
    rx: 5,
    fill: "#eee"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 46,
    y: 650,
    width: 321,
    height: 112,
    rx: 5,
    fill: "#F9F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m230.7 690.74c0-0.552-0.448-1-1-1h-25.786l-5.068-4.804c-0.186-0.176-0.432-0.274-0.688-0.274h-20.03c-0.552 0-1 0.448-1 1v41.75c0 0.552 0.448 1 1 1h51.572c0.552 0 1-0.448 1-1v-36.672z",
    fill: "#eee"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m208.47 701.07c1.259 0 2.279 1.08 2.279 2.413 0 1.332-1.02 2.413-2.279 2.413-0.518 0-0.984-0.189-1.367-0.498l-5.483 3.634c8e-3 0.081 0.014 0.158 0.014 0.241 0 0.084-6e-3 0.161-0.014 0.242l5.497 3.619c0.38-0.301 0.842-0.483 1.353-0.483 1.259 0 2.279 1.08 2.279 2.413 0 1.332-1.02 2.412-2.279 2.412-1.258 0-2.278-1.08-2.278-2.412 0-0.083 6e-3 -0.16 0.014-0.241l-5.483-3.635c-0.383 0.309-0.849 0.498-1.367 0.498-1.259 0-2.279-1.08-2.279-2.413 0-1.332 1.02-2.412 2.279-2.412 0.511 0 0.972 0.181 1.353 0.482l5.497-3.634c-7e-3 -0.076-0.014-0.148-0.014-0.226 0-1.333 1.02-2.413 2.278-2.413z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m793.25 936.76-8.25 4.763v-9.526l8.25 4.763z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m205.76 762 4.763 8.25h-9.526l4.763-8.25z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206 770L206.574 937H785",
    stroke: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1129,
    y: -1,
    width: 321,
    height: 112,
    rx: 5,
    fill: "#eee"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1114,
    y: -20,
    width: 321,
    height: 112,
    rx: 5,
    fill: "#F9F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1290.6 53.269-3.8-3.825c-0.16-0.1574-0.36-0.285-0.6-0.3729-0.23-0.0879-0.48-0.1336-0.74-0.1336h-20.92c-0.26 0-0.51 0.0457-0.74 0.1336-0.24 0.0879-0.44 0.2155-0.6 0.3729l-3.8 3.825c-0.19 0.1892-0.3 0.4145-0.33 0.6507-0.03 0.2361 0.03 0.4737 0.17 0.686s0.35 0.3909 0.62 0.5158c0.26 0.1249 0.57 0.191 0.88 0.191h28.52c0.31 0 0.62-0.0661 0.88-0.191 0.27-0.1249 0.48-0.3035 0.62-0.5158s0.2-0.4499 0.17-0.686c-0.03-0.2362-0.14-0.4615-0.33-0.6507z",
    fill: "#eee"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1249.5,
    y: 13.875,
    width: 51,
    height: 31.875,
    rx: 1,
    fill: "#eee"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1641.8 456.25-4.76-8.25h9.53l-4.77 8.25z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1903.8 675.25-4.76-8.25h9.53l-4.77 8.25z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1435,
    cy: 39,
    r: 3,
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1435 39h469v628",
    stroke: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1640 39 2 409",
    stroke: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1760,
    y: 695,
    width: 321,
    height: 112,
    rx: 5,
    fill: "#eee"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1745,
    y: 676,
    width: 321,
    height: 112,
    rx: 5,
    fill: "#F9F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1891.6 713.33h-12.78c-1.94 0-3.53 1.589-3.53 3.531v12.771c0 1.942 1.59 3.531 3.53 3.531h12.78c1.94 0 3.53-1.589 3.53-3.531v-12.771c0-1.942-1.59-3.531-3.53-3.531zm0 16.302h-12.78v-12.771h12.78v12.771z",
    fill: "#eee"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1917.6 713.33h-10.95c-1.66 0-3.02 1.589-3.02 3.531v12.771c0 1.942 1.36 3.531 3.02 3.531h10.95c1.66 0 3.03-1.589 3.03-3.531v-12.771c0-1.942-1.37-3.531-3.03-3.531z",
    fill: "#eee"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1891.6 741.67h-12.78c-1.94 0-3.53 1.362-3.53 3.027v10.946c0 1.665 1.59 3.027 3.53 3.027h12.78c1.94 0 3.53-1.362 3.53-3.027v-10.946c0-1.665-1.59-3.027-3.53-3.027z",
    fill: "#eee"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1917.6 741.67h-10.95c-1.66 0-3.02 1.362-3.02 3.027v10.946c0 1.665 1.36 3.027 3.02 3.027h10.95c1.66 0 3.03-1.362 3.03-3.027v-10.946c0-1.665-1.37-3.027-3.03-3.027z",
    fill: "#eee"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1491,
    y: 475,
    width: 321,
    height: 112,
    rx: 5,
    fill: "#eee"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1476,
    y: 456,
    width: 321,
    height: 112,
    rx: 5,
    fill: "#F9F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1657.2 535.25c6.47 0 11.69-5.614 11.69-12.587 0-5.438-3.1-10.079-7.57-11.846-0.66-5.861-5.38-10.365-11-10.365-1.37 0-2.91 0.244-4.12 0.74-2.5-2.768-5.76-4.442-9.63-4.442-7.12 0-13.05 5.849-13.75 13.327-6.47 0-11.69 5.614-11.69 12.586 0 6.973 5.22 12.587 11.69 12.587h34.38z",
    fill: "#eee"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1636.4 520.5v9.032c0 0.055-0.04 0.1-0.1 0.1h-4.57c-0.06 0-0.1-0.045-0.1-0.1v-9.032h-3.71c-0.08 0-0.12-0.083-0.09-0.15l6.1-10.619c0.04-0.067 0.13-0.067 0.17 0l6.09 10.619c0.04 0.067-0.01 0.15-0.08 0.15h-3.71z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1643.6 518.72v-9.032c0-0.055 0.05-0.1 0.1-0.1h4.57c0.06 0 0.1 0.045 0.1 0.1v9.032h3.71c0.08 0 0.13 0.083 0.09 0.15l-6.1 10.619c-0.03 0.067-0.13 0.067-0.17 0l-6.09-10.619c-0.04-0.067 0.01-0.15 0.08-0.15h3.71z",
    fill: "#fff"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1920,
    height: 1024,
    fill: "#fff"
  })))));
};
const ForwardRef = /*#__PURE__*/(/* unused pure expression or super */ null && (forwardRef(Svg404)));

/* harmony default export */ const _404 = (__webpack_require__.p + "0cc783f1272597521c1958fb95091759.svg");
// EXTERNAL MODULE: ./src/modules/router/templates/ErrorPageTemplate.tsx
var ErrorPageTemplate = __webpack_require__(48646);
// EXTERNAL MODULE: ./src/modules/router/messages.ts
var messages = __webpack_require__(77836);
// EXTERNAL MODULE: ./src/modules/router/molecules/index.ts + 4 modules
var molecules = __webpack_require__(6289);
// EXTERNAL MODULE: ./src/modules/router/pages/usePageErrorLog.ts
var usePageErrorLog = __webpack_require__(50253);
;// CONCATENATED MODULE: ./src/modules/router/pages/NotFoundPage.tsx







const bgClassName = (0,css/* css */.iv)({
    backgroundImage: `url(${_404})`
});
// eslint-disable-next-line @typescript-eslint/no-unused-vars
const NotFound = ()=>{
    (0,usePageErrorLog/* usePageErrorLog */.c)();
    return /*#__PURE__*/ react.createElement(molecules/* RouteUserCheck */.$, null, /*#__PURE__*/ react.createElement(ErrorPageTemplate/* ErrorPageTemplate */.J, {
        title: "404",
        className: bgClassName().className,
        subTitle: messages/* messages.notFoundPageSubTitle */.s.notFoundPageSubTitle
    }));
};

// EXTERNAL MODULE: ./src/shared/useAvailableNavigationItems.ts
var useAvailableNavigationItems = __webpack_require__(98598);
// EXTERNAL MODULE: ./src/app/routesPaths.ts
var routesPaths = __webpack_require__(70433);
// EXTERNAL MODULE: ./src/modules/router/helpers.tsx
var helpers = __webpack_require__(69878);
;// CONCATENATED MODULE: ./src/modules/router/pages/HomePage.tsx







function RedirectToHome() {
    const { homeItem , isLoading  } = (0,useAvailableNavigationItems/* useAvailableNavigationItems */.F)();
    if (!isLoading) {
        return /*#__PURE__*/ react.createElement(ui/* LayoutLoader */.GS, null);
    }
    return /*#__PURE__*/ react.createElement(helpers/* RedirectWithSearch */.L, {
        noThrow: true,
        from: "/",
        to: (homeItem === null || homeItem === void 0 ? void 0 : homeItem.path) || routesPaths/* HOME_PAGE_FALLBACK_PATH */.q
    });
}
// eslint-disable-next-line @typescript-eslint/no-unused-vars
function HomePage() {
    return /*#__PURE__*/ react.createElement(permissions/* PermissionsProvider */.E3, null, /*#__PURE__*/ react.createElement(molecules/* RouteUserCheck */.$, null, /*#__PURE__*/ react.createElement(RedirectToHome, null)));
}

;// CONCATENATED MODULE: ./src/modules/router/pages/index.ts




;// CONCATENATED MODULE: ./src/app/routes.ts






const routes_LayoutClassic = (0,router/* namedLazy */.E3)(()=>Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 7529)), "LayoutClassic");
const routes = {
    jwtAuth: {
        path: routesPaths/* ROUTES_PATHS.JWT_AUTH */.b.JWT_AUTH,
        component: (0,react.lazy)(()=>__webpack_require__.e(/* import() */ 817).then(__webpack_require__.bind(__webpack_require__, 4532)))
    },
    login: {
        path: routesPaths/* ROUTES_PATHS.LOGIN */.b.LOGIN,
        component: (0,router/* redirectIfAuthenticated */.tL)((0,react.lazy)(()=>Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 38266))))
    },
    cyberhavenLogin: {
        path: routesPaths/* ROUTES_PATHS.CYBERHAVEN_LOGIN */.b.CYBERHAVEN_LOGIN,
        component: (0,router/* redirectIfAuthenticated */.tL)((0,react.lazy)(()=>__webpack_require__.e(/* import() */ 125).then(__webpack_require__.bind(__webpack_require__, 47943))))
    },
    registration: {
        path: routesPaths/* ROUTES_PATHS.REGISTRATION */.b.REGISTRATION,
        component: (0,react.lazy)(()=>Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 56836)))
    },
    monitoring: {
        path: routesPaths/* ROUTES_PATHS.MONITORING */.b.MONITORING,
        layout: routes_LayoutClassic,
        component: (0,react.lazy)(()=>__webpack_require__.e(/* import() */ 700).then(__webpack_require__.bind(__webpack_require__, 44852)))
    },
    roles: {
        path: routesPaths/* ROUTES_PATHS.ROLES */.b.ROLES,
        layout: routes_LayoutClassic,
        component: (0,router/* lazyImport */.ez)(()=>Promise.all(/* import() */[__webpack_require__.e(27), __webpack_require__.e(575)]).then(__webpack_require__.bind(__webpack_require__, 13027)).then((el)=>el.RolesTable)),
        requiredPermissions: [
            "role__read"
        ]
    },
    usersV2: {
        path: routesPaths/* ROUTES_PATHS.USERS_V2 */.b.USERS_V2,
        layout: routes_LayoutClassic,
        component: (0,router/* lazyImport */.ez)(()=>Promise.all(/* import() */[__webpack_require__.e(62), __webpack_require__.e(37)]).then(__webpack_require__.bind(__webpack_require__, 9062)).then((el)=>el.RbacTable)),
        requiredPermissions: [
            "role__read",
            "user__read"
        ]
    },
    alerts: {
        path: routesPaths/* ROUTES_PATHS.ALERTS */.b.ALERTS,
        layout: routes_LayoutClassic,
        component: (0,router/* namedLazy */.E3)(()=>Promise.all(/* import() */[__webpack_require__.e(100), __webpack_require__.e(191), __webpack_require__.e(995), __webpack_require__.e(273), __webpack_require__.e(368), __webpack_require__.e(254), __webpack_require__.e(37), __webpack_require__.e(485), __webpack_require__.e(650), __webpack_require__.e(51), __webpack_require__.e(489), __webpack_require__.e(463), __webpack_require__.e(626), __webpack_require__.e(446), __webpack_require__.e(98), __webpack_require__.e(125)]).then(__webpack_require__.bind(__webpack_require__, 57569)), "AlertsPage"),
        requiredPermissionsAnyOf: [
            "assigned_incident__read",
            "incident__read"
        ]
    },
    sensors: {
        path: routesPaths/* ROUTES_PATHS.SENSORS */.b.SENSORS,
        layout: routes_LayoutClassic,
        component: (0,router/* lazyImport */.ez)(()=>Promise.all(/* import() */[__webpack_require__.e(100), __webpack_require__.e(995), __webpack_require__.e(273), __webpack_require__.e(119), __webpack_require__.e(37), __webpack_require__.e(485), __webpack_require__.e(27), __webpack_require__.e(62), __webpack_require__.e(979), __webpack_require__.e(671)]).then(__webpack_require__.bind(__webpack_require__, 43671)).then((el)=>el.SensorsPage)),
        requiredPermissions: [
            "cloud_sensor__read"
        ],
        children: [
            {
                index: true,
                path: `${routesPaths/* ROUTES_PATHS.SENSORS */.b.SENSORS}/`,
                component: (0,router/* lazyImport */.ez)(()=>Promise.all(/* import() */[__webpack_require__.e(100), __webpack_require__.e(995), __webpack_require__.e(273), __webpack_require__.e(119), __webpack_require__.e(37), __webpack_require__.e(485), __webpack_require__.e(27), __webpack_require__.e(62), __webpack_require__.e(979), __webpack_require__.e(671)]).then(__webpack_require__.bind(__webpack_require__, 43671)).then((el)=>el.IndexPage)),
                requiredPermissions: [
                    "cloud_sensor__read"
                ]
            },
            {
                path: `${routesPaths/* ROUTES_PATHS.SENSORS */.b.SENSORS}/gsuite/:uuid`,
                component: (0,router/* lazyImport */.ez)(()=>Promise.all(/* import() */[__webpack_require__.e(100), __webpack_require__.e(995), __webpack_require__.e(273), __webpack_require__.e(119), __webpack_require__.e(37), __webpack_require__.e(485), __webpack_require__.e(27), __webpack_require__.e(62), __webpack_require__.e(979), __webpack_require__.e(671)]).then(__webpack_require__.bind(__webpack_require__, 43671)).then((el)=>el.GSuitePage)),
                requiredPermissions: [
                    "cloud_sensor__read"
                ]
            },
            {
                path: `${routesPaths/* ROUTES_PATHS.SENSORS */.b.SENSORS}/salesforce/*`,
                component: (0,router/* lazyImport */.ez)(()=>Promise.all(/* import() */[__webpack_require__.e(100), __webpack_require__.e(995), __webpack_require__.e(273), __webpack_require__.e(119), __webpack_require__.e(37), __webpack_require__.e(485), __webpack_require__.e(27), __webpack_require__.e(62), __webpack_require__.e(979), __webpack_require__.e(671)]).then(__webpack_require__.bind(__webpack_require__, 43671)).then((el)=>el.SalesforcePage)),
                requiredPermissions: [
                    "cloud_sensor__read"
                ]
            },
            {
                path: `${routesPaths/* ROUTES_PATHS.SENSORS */.b.SENSORS}/o365/:uuid`,
                component: (0,router/* lazyImport */.ez)(()=>Promise.all(/* import() */[__webpack_require__.e(100), __webpack_require__.e(995), __webpack_require__.e(273), __webpack_require__.e(119), __webpack_require__.e(37), __webpack_require__.e(485), __webpack_require__.e(27), __webpack_require__.e(62), __webpack_require__.e(979), __webpack_require__.e(671)]).then(__webpack_require__.bind(__webpack_require__, 43671)).then((el)=>el.O365Page)),
                requiredPermissions: [
                    "cloud_sensor__read"
                ]
            },
            {
                path: "*",
                component: NotFound
            }
        ]
    },
    preferences: {
        path: routesPaths/* ROUTES_PATHS.PREFERENCES */.b.PREFERENCES,
        layout: routes_LayoutClassic,
        component: (0,router/* lazyImport */.ez)(()=>Promise.all(/* import() */[__webpack_require__.e(100), __webpack_require__.e(995), __webpack_require__.e(119), __webpack_require__.e(37), __webpack_require__.e(485), __webpack_require__.e(27), __webpack_require__.e(62), __webpack_require__.e(979)]).then(__webpack_require__.bind(__webpack_require__, 46979)).then((el)=>el.PreferencesPage)),
        requiredPermissionsAnyOf: [
            "user__read",
            "role__read",
            "global_settings__read",
            "global_auth_settings__read",
            "dlp_rules__read",
            "file_tags__read",
            "admin_global_settings__read",
            "admin_saml__read",
            "api_token__read",
            "directory_sync__read"
        ]
    },
    endpoint: {
        path: routesPaths/* ROUTES_PATHS.ENDPOINT */.b.ENDPOINT,
        layout: routes_LayoutClassic,
        component: (0,react.lazy)(()=>Promise.all(/* import() */[__webpack_require__.e(191), __webpack_require__.e(802), __webpack_require__.e(650), __webpack_require__.e(473)]).then(__webpack_require__.bind(__webpack_require__, 24657))),
        requiredPermissions: [
            "endpoint__read"
        ]
    },
    risksDashboard: {
        path: routesPaths/* ROUTES_PATHS.RISKS_DASHBOARD */.b.RISKS_DASHBOARD,
        layout: routes_LayoutClassic,
        component: (0,router/* namedLazy */.E3)(()=>Promise.all(/* import() */[__webpack_require__.e(100), __webpack_require__.e(191), __webpack_require__.e(995), __webpack_require__.e(273), __webpack_require__.e(368), __webpack_require__.e(254), __webpack_require__.e(37), __webpack_require__.e(485), __webpack_require__.e(650), __webpack_require__.e(51), __webpack_require__.e(489), __webpack_require__.e(463), __webpack_require__.e(626), __webpack_require__.e(798)]).then(__webpack_require__.bind(__webpack_require__, 54798)), "RiskDashboard"),
        requiredPermissions: [
            "dataset__read",
            "policy__read",
            "flow_stats__read"
        ]
    },
    dataflowsDashboard: {
        path: routesPaths/* ROUTES_PATHS.DATAFLOWS_DASHBOARD */.b.DATAFLOWS_DASHBOARD,
        layout: routes_LayoutClassic,
        component: (0,router/* lazyImport */.ez)(()=>Promise.all(/* import() */[__webpack_require__.e(100), __webpack_require__.e(191), __webpack_require__.e(995), __webpack_require__.e(273), __webpack_require__.e(368), __webpack_require__.e(254), __webpack_require__.e(37), __webpack_require__.e(485), __webpack_require__.e(650), __webpack_require__.e(51), __webpack_require__.e(489), __webpack_require__.e(463), __webpack_require__.e(137)]).then(__webpack_require__.bind(__webpack_require__, 85137)).then((el)=>el.DataflowsDashboard)),
        disabled: !runenv/* ENV.FEATURES */.V.FEATURES[features/* Feature.DashboardV2 */.L.DashboardV2],
        requiredPermissions: [
            "dataset__read",
            "policy__read",
            "flow_stats__read"
        ]
    },
    sharableListView: {
        path: routesPaths/* ROUTES_PATHS.SHARABLE_LISTVIEW */.b.SHARABLE_LISTVIEW,
        component: (0,router/* lazyImport */.ez)(()=>Promise.all(/* import() */[__webpack_require__.e(100), __webpack_require__.e(191), __webpack_require__.e(995), __webpack_require__.e(273), __webpack_require__.e(368), __webpack_require__.e(254), __webpack_require__.e(37), __webpack_require__.e(485), __webpack_require__.e(650), __webpack_require__.e(51), __webpack_require__.e(489), __webpack_require__.e(463), __webpack_require__.e(626), __webpack_require__.e(446), __webpack_require__.e(98), __webpack_require__.e(2)]).then(__webpack_require__.bind(__webpack_require__, 15004)).then((el)=>el.SharableListView)),
        requiredPermissions: [
            "dataset__read",
            "policy__read",
            "audit__read",
            "flow_stats__read"
        ]
    },
    profile: {
        path: routesPaths/* ROUTES_PATHS.PROFILE */.b.PROFILE,
        layout: routes_LayoutClassic,
        component: (0,router/* namedLazy */.E3)(()=>__webpack_require__.e(/* import() */ 951).then(__webpack_require__.bind(__webpack_require__, 78951)), "MyProfilePage"),
        requiredPermissions: [
            "console__read"
        ]
    },
    portal: {
        path: routesPaths/* ROUTES_PATHS.PORTAL */.b.PORTAL,
        layout: routes_LayoutClassic,
        component: (0,react.lazy)(()=>__webpack_require__.e(/* import() */ 125).then(__webpack_require__.bind(__webpack_require__, 70831))),
        requiredPermissions: [
            "console__read"
        ]
    },
    apiTokens: {
        path: routesPaths/* ROUTES_PATHS.API_TOKENS */.b.API_TOKENS,
        layout: routes_LayoutClassic,
        component: (0,router/* namedLazy */.E3)(()=>__webpack_require__.e(/* import() */ 979).then(__webpack_require__.bind(__webpack_require__, 83932)), "TokensPage"),
        requiredPermissions: [
            "api_token__read",
            "api_token__modify"
        ]
    },
    forgotPassword: {
        path: routesPaths/* ROUTES_PATHS.FORGOT_PASSWORD */.b.FORGOT_PASSWORD,
        component: (0,router/* namedLazy */.E3)(()=>__webpack_require__.e(/* import() */ 125).then(__webpack_require__.bind(__webpack_require__, 81218)), "ForgotPasswordPage")
    },
    reset: {
        path: routesPaths/* ROUTES_PATHS.RESET */.b.RESET,
        component: (0,react.lazy)(()=>Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 56836)))
    },
    apittokens2: {
        path: routesPaths/* ROUTES_PATHS.APITTOKENS2 */.b.APITTOKENS2,
        component: (0,router/* lazyImport */.ez)(()=>Promise.all(/* import() */[__webpack_require__.e(51), __webpack_require__.e(700)]).then(__webpack_require__.bind(__webpack_require__, 98198)).then((el)=>el.TokensPage))
    },
    analyticsDashboard: {
        path: routesPaths/* ROUTES_PATHS.ANALYTICS_DASHBOARD */.b.ANALYTICS_DASHBOARD,
        layout: routes_LayoutClassic,
        component: (0,router/* lazyImport */.ez)(()=>__webpack_require__.e(/* import() */ 443).then(__webpack_require__.bind(__webpack_require__, 5443)).then((el)=>el.AnalyticsDashboard)),
        disabled: !runenv/* ENV.FEATURES */.V.FEATURES[features/* Feature.ANALYTICS_DASHBOARD */.L.ANALYTICS_DASHBOARD] || !runenv/* ENV.SUPERSET_URL */.V.SUPERSET_URL,
        requiredPermissions: [
            "visual_analytics__read"
        ]
    },
    insiderRisks: {
        path: routesPaths/* ROUTES_PATHS.INSIDER_RISKS */.b.INSIDER_RISKS,
        layout: routes_LayoutClassic,
        component: (0,router/* lazyImport */.ez)(()=>Promise.all(/* import() */[__webpack_require__.e(100), __webpack_require__.e(191), __webpack_require__.e(273), __webpack_require__.e(368), __webpack_require__.e(271), __webpack_require__.e(37), __webpack_require__.e(650), __webpack_require__.e(51), __webpack_require__.e(489), __webpack_require__.e(2)]).then(__webpack_require__.bind(__webpack_require__, 17163)).then((el)=>el.RiskyUsersPage)),
        disabled: !runenv/* ENV.FEATURES */.V.FEATURES[features/* Feature.INSIDER_RISK_MANAGEMENT_TABLE */.L.INSIDER_RISK_MANAGEMENT_TABLE],
        requiredPermissions: [
            "irm__read",
            "incident__read",
            "dataset__read",
            "policy__read",
            "flow_stats__read"
        ]
    }
};
const routesArray = [
    "alerts",
    "sensors",
    "preferences",
    "endpoint",
    "profile",
    "monitoring",
    "apiTokens",
    "risksDashboard",
    "dataflowsDashboard",
    "portal",
    "registration",
    "login",
    "cyberhavenLogin",
    "forgotPassword",
    "reset",
    "roles",
    "jwtAuth",
    "usersV2",
    "sharableListView",
    "apittokens2",
    "analyticsDashboard",
    "insiderRisks"
].map((el)=>routes[el]).filter((route)=>!route.disabled);

;// CONCATENATED MODULE: ./src/app/Router.tsx











function RouteWrapper({ element , route , nested  }) {
    let LayoutWrapper = route.layout;
    LayoutWrapper = LayoutWrapper !== null && LayoutWrapper !== void 0 ? LayoutWrapper : react.Fragment;
    const wrappedChildren = LayoutWrapper ? /*#__PURE__*/ react.createElement(LayoutWrapper, null, element) : element;
    if (!route.requiredPermissions && !route.requiredPermissionsAnyOf) {
        return wrappedChildren;
    }
    return /*#__PURE__*/ react.createElement(permissions/* PermissionsProvider */.E3, null, runenv/* ENV.FEATURES */.V.FEATURES[features/* Feature.ZendeskWidget */.L.ZendeskWidget] && !nested && /*#__PURE__*/ react.createElement(ZendeskWidget, null), /*#__PURE__*/ react.createElement(LayoutWrapper, null, /*#__PURE__*/ react.createElement(router/* ProtectedRoute */.i1, {
        requiredPermissions: route.requiredPermissions,
        requiredPermissionsAnyOf: route.requiredPermissionsAnyOf
    }, /*#__PURE__*/ react.createElement(timezone/* TimezoneProvider */.A8, null, element))));
}
const Router = ()=>{
    const element = (0,react_router_dist/* useRoutes */.V$)([
        {
            path: "/",
            index: true,
            element: /*#__PURE__*/ react.createElement(HomePage, null)
        },
        ...routesArray.map((route)=>{
            var _route_children;
            return {
                path: route.path,
                element: /*#__PURE__*/ react.createElement(RouteWrapper, {
                    route: route,
                    element: /*#__PURE__*/ react.createElement(route.component)
                }),
                children: (_route_children = route.children) === null || _route_children === void 0 ? void 0 : _route_children.map((route)=>({
                        path: route.path,
                        index: route.index,
                        element: /*#__PURE__*/ react.createElement(RouteWrapper, {
                            nested: true,
                            route: route,
                            element: /*#__PURE__*/ react.createElement(route.component)
                        })
                    }))
            };
        }),
        {
            path: "*",
            element: /*#__PURE__*/ react.createElement(NotFound, null)
        }
    ]);
    return /*#__PURE__*/ react.createElement(atoms/* FullscreenContent */.e, null, element);
};

// EXTERNAL MODULE: ./src/assets/styles/index.css
var styles = __webpack_require__(93838);
// EXTERNAL MODULE: ./node_modules/@mui/styled-engine/StyledEngineProvider/StyledEngineProvider.js
var StyledEngineProvider = __webpack_require__(94810);
// EXTERNAL MODULE: ./node_modules/@mui/material/styles/ThemeProvider.js + 2 modules
var ThemeProvider = __webpack_require__(97338);
// EXTERNAL MODULE: ./node_modules/@mui/material/CssBaseline/CssBaseline.js
var CssBaseline = __webpack_require__(66720);
;// CONCATENATED MODULE: ./src/shared/StylesWrapper.tsx





function StylesWrapper({ children  }) {
    (0,ui/* setupCssVars */.Ih)();
    return /*#__PURE__*/ react.createElement(StyledEngineProvider/* default */.Z, {
        injectFirst: true
    }, /*#__PURE__*/ react.createElement(ThemeProvider/* default */.Z, {
        theme: ui/* theme */.rS
    }, /*#__PURE__*/ react.createElement(react.Fragment, null, /*#__PURE__*/ react.createElement(CssBaseline/* default */.ZP, null), children)));
}

// EXTERNAL MODULE: ./src/shared/environment.tsx
var environment = __webpack_require__(66246);
// EXTERNAL MODULE: ./src/shared/testConstants.ts + 1 modules
var testConstants = __webpack_require__(81202);
// EXTERNAL MODULE: ./node_modules/@mui/icons-material/Cloud.js
var Cloud = __webpack_require__(6914);
// EXTERNAL MODULE: ./node_modules/@mui/icons-material/Settings.js
var Settings = __webpack_require__(94229);
// EXTERNAL MODULE: ./node_modules/@mui/icons-material/Dashboard.js
var Dashboard = __webpack_require__(25709);
// EXTERNAL MODULE: ./node_modules/@mui/icons-material/Person.js
var Person = __webpack_require__(15398);
// EXTERNAL MODULE: ./src/modules/layout/messages.ts
var layout_messages = __webpack_require__(41051);
;// CONCATENATED MODULE: ./src/app/navigation.ts
function navigation_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function navigation_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            navigation_define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}











const getNavigationIcons = ()=>[
        navigation_object_spread({
            "label": "Risks Overview",
            "icon": Dashboard/* default */.Z,
            "data-testid": testConstants/* navigationSelectors.dashboard */.Q_.dashboard
        }, routes.risksDashboard),
        navigation_object_spread({
            "label": layout_messages/* messages.pages.analyticsDashboard */.s.pages.analyticsDashboard,
            "icon": icons/* AnalyticsDashboardIcon */.xo,
            "data-testid": testConstants/* navigationSelectors.analytics */.Q_.analytics,
            "hidden": routes.analyticsDashboard.disabled
        }, routes.analyticsDashboard),
        navigation_object_spread({
            "label": "Dataflows Overview",
            "icon": icons/* DataflowsDashboardIcon */.yC,
            "data-testid": testConstants/* navigationSelectors.dashboardv2 */.Q_.dashboardv2,
            "hidden": !runenv/* ENV.FEATURES */.V.FEATURES[features/* Feature.DashboardV2 */.L.DashboardV2]
        }, routes.dataflowsDashboard),
        navigation_object_spread({
            "label": "User Risk Summary",
            "icon": Person/* default */.Z,
            "data-testid": testConstants/* navigationSelectors.insiders */.Q_.insiders,
            "hidden": routes.insiderRisks.disabled
        }, routes.insiderRisks),
        navigation_object_spread({
            "label": layout_messages/* messages.pages.incidents */.s.pages.incidents,
            "icon": (0,react.lazy)(()=>Promise.all(/* import() */[__webpack_require__.e(446), __webpack_require__.e(352)]).then(__webpack_require__.bind(__webpack_require__, 37352)).then((el)=>({
                        default: el.AlertsSideIcon
                    }))),
            "data-testid": testConstants/* navigationSelectors.incidents */.Q_.incidents
        }, routes.alerts),
        {
            isSpacer: true
        },
        _object_spread_props(navigation_object_spread({
            "label": layout_messages/* messages.pages.cloudSensors */.s.pages.cloudSensors,
            "data-testid": testConstants/* navigationSelectors.sensors.cloud */.Q_.sensors.cloud,
            "icon": Cloud/* default */.Z
        }, routes.sensors), {
            "path": "/sensors/cloud"
        }),
        _object_spread_props(navigation_object_spread({
            "label": layout_messages/* messages.pages.endpointSensors */.s.pages.endpointSensors,
            "icon": (0,react.lazy)(()=>__webpack_require__.e(/* import() */ 393).then(__webpack_require__.bind(__webpack_require__, 21393)).then((el)=>({
                        default: el.EndpointSideIcon
                    }))),
            "data-testid": testConstants/* navigationSelectors.sensors.endpoint */.Q_.sensors.endpoint
        }, routes.endpoint), {
            "path": "/sensors/endpoint"
        }),
        _object_spread_props(navigation_object_spread({
            "label": layout_messages/* messages.pages.preferences */.s.pages.preferences,
            "icon": Settings/* default */.Z,
            "data-testid": testConstants/* navigationSelectors.preferences */.Q_.preferences
        }, routes.preferences), {
            "path": "/preferences"
        })
    ];

// EXTERNAL MODULE: ./node_modules/@mui/material/Dialog/Dialog.js + 1 modules
var Dialog = __webpack_require__(3838);
// EXTERNAL MODULE: ./node_modules/@mui/material/Button/Button.js + 1 modules
var Button = __webpack_require__(72642);
// EXTERNAL MODULE: ./src/libs/hooks/index.ts + 18 modules
var hooks = __webpack_require__(88289);
// EXTERNAL MODULE: ./src/app/setupVersionCheck.ts
var setupVersionCheck = __webpack_require__(80157);
;// CONCATENATED MODULE: ./src/app/NewVersionHandler.tsx
function NewVersionHandler_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function NewVersionHandler_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            NewVersionHandler_define_property(target, key, source[key]);
        });
    }
    return target;
}
function NewVersionHandler_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function NewVersionHandler_object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        NewVersionHandler_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function NewVersionHandler_object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = NewVersionHandler_object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function NewVersionHandler_object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}








const IGNORE_TIMEOUT = 1000 * 60 * 2;
function NewVersionHandler() {
    // If user dismissed update, then do not bother with popup for IGNORE_TIMEOUT
    const [getIsIgnore, setIsIgnore] = (0,hooks/* useStorageWithExpiration */.jv)("ignore-version-updates", false, IGNORE_TIMEOUT);
    const _useModal = (0,hooks/* useModal */.dd)((_param)=>{
        var { extraProps: _  } = _param, args = NewVersionHandler_object_without_properties(_param, [
            "extraProps"
        ]);
        const onDismiss = ()=>{
            setIsIgnore(true);
            args.onClose();
        };
        const onRefresh = ()=>{
            setIsIgnore(true);
            window.location.reload();
        };
        return /*#__PURE__*/ react.createElement(Dialog/* default */.Z, NewVersionHandler_object_spread_props(NewVersionHandler_object_spread({}, args), {
            PaperProps: {
                style: {
                    maxWidth: "300px"
                }
            },
            fullWidth: true,
            disableEscapeKeyDown: true
        }), /*#__PURE__*/ react.createElement(ui/* VStack */.gC, {
            align: "center",
            style: {
                padding: `${ui/* space.8 */.Dh[8]} ${ui/* space.3 */.Dh[3]} ${ui/* space.7 */.Dh[7]}`
            }
        }, /*#__PURE__*/ react.createElement(ui/* Box */.xu, {
            style: {
                marginBottom: ui/* space.5 */.Dh[5]
            }
        }, /*#__PURE__*/ react.createElement(icons/* CyberhavenIcon4 */.Uy, {
            style: {
                width: "1em",
                height: "1em",
                fontSize: "50px"
            }
        })), /*#__PURE__*/ react.createElement(ui/* Text */.xv, {
            variant: "header6MC",
            style: {
                textTransform: "none",
                marginBottom: ui/* space.2 */.Dh[2]
            }
        }, "New version is available!"), /*#__PURE__*/ react.createElement(ui/* Text */.xv, {
            variant: "body2",
            color: "#737373",
            style: {
                marginBottom: ui/* space.5 */.Dh[5],
                textAlign: "center"
            }
        }, "We kindly request that you click on the Refresh button to access the latest version of our product and enjoy an enhanced user experience"), /*#__PURE__*/ react.createElement(ui/* VStack */.gC, {
            align: "center",
            space: "1",
            style: {
                width: "200px"
            }
        }, /*#__PURE__*/ react.createElement(Button/* default */.Z, {
            variant: "contained",
            fullWidth: true,
            color: "primary",
            onClick: onRefresh
        }, "Refresh"), /*#__PURE__*/ react.createElement(Button/* default */.Z, {
            color: "secondary",
            fullWidth: true,
            onClick: onDismiss
        }, "Dismiss"))));
    }, true), [modal, modalApi] = _useModal;
    (0,react.useEffect)(()=>(0,setupVersionCheck/* subscribeOnVersionChange */.IY)(()=>{
            if (!getIsIgnore()) {
                modalApi.handleOpen();
            }
        }), []);
    const location = (0,react_router_dist/* useLocation */.TH)();
    (0,react.useEffect)(()=>{
        // If user was logged out due to inactivity and did not accept update, then we can safely refresh page
        if (modalApi.open && location.pathname.includes(routesPaths/* ROUTES_PATHS.LOGIN */.b.LOGIN)) {
            window.location.reload();
        }
    }, [
        modalApi.open,
        location.pathname
    ]);
    return /*#__PURE__*/ react.createElement(react.Fragment, null, modal);
}

;// CONCATENATED MODULE: ./src/app/App.tsx

















const App_icons = getNavigationIcons();
// DO NOT ADD ANYTHING THAT REQUIRES AUTH HERE
function App({ store  }) {
    return /*#__PURE__*/ react.createElement(dist/* BrowserRouter */.VK, null, /*#__PURE__*/ react.createElement(react_redux_es/* Provider */.zt, {
        store: store
    }, /*#__PURE__*/ react.createElement(es/* ReactQueryConfigProvider */.ON, {
        config: {
            queries: {
                refetchOnWindowFocus: false,
                retry (failureCount, error) {
                    if (axios_default().isAxiosError(error)) {
                        var _error_response;
                        if (((_error_response = error.response) === null || _error_response === void 0 ? void 0 : _error_response.status) === 403) {
                            return false;
                        }
                    }
                    return failureCount < 3 ? true : false;
                }
            },
            mutations: {
                onError (error) {
                    console.error("error", error);
                    if ((0,check_error/* isRbacError */.C)(error).result) {
                        notification/* notification.error */.t6.error({
                            message: "Access denied"
                        });
                    } else {
                        (0,errors/* reportError */.e)(error);
                    }
                }
            }
        }
    }, /*#__PURE__*/ react.createElement(environment/* AppEnvironmentProvider */.k, {
        navigationItems: App_icons,
        routes: routes
    }, /*#__PURE__*/ react.createElement(StylesWrapper, null, /*#__PURE__*/ react.createElement(NetworkActivityIndicator, null), /*#__PURE__*/ react.createElement(notification/* NotificationCenter */.LM, null), /*#__PURE__*/ react.createElement(organisms/* UserInactivityHandler */.p1, null), /*#__PURE__*/ react.createElement(NewVersionHandler, null), /*#__PURE__*/ react.createElement(react.Suspense, {
        fallback: /*#__PURE__*/ react.createElement(ui/* LayoutLoader */.GS, null)
    }, /*#__PURE__*/ react.createElement(Router, null)))))));
}

// EXTERNAL MODULE: ./src/app/setupExternalServices.ts + 7 modules
var setupExternalServices = __webpack_require__(23279);
// EXTERNAL MODULE: ./node_modules/okdux/dist/lib/index.js + 6 modules
var lib = __webpack_require__(56804);
// EXTERNAL MODULE: ./node_modules/redux/es/redux.js
var redux = __webpack_require__(14890);
// EXTERNAL MODULE: ./src/modules/auth/state.ts
var auth_state = __webpack_require__(45386);
// EXTERNAL MODULE: ./src/modules/content-rules/state.ts
var content_rules_state = __webpack_require__(9106);
// EXTERNAL MODULE: ./src/modules/notification/state.ts
var notification_state = __webpack_require__(73420);
// EXTERNAL MODULE: ./src/modules/sensors/state.ts
var sensors_state = __webpack_require__(82333);
;// CONCATENATED MODULE: ./src/app/setupStore.ts






const thunk = ()=>(next)=>(action)=>{
            if (typeof action === "function") {
                return action(store.dispatch, store.getState);
            }
            return next(action);
        };
const rootReducer = (0,lib/* createState */.eK)({
    auth: auth_state/* authState */.f,
    notifications: notification_state/* notificationState */.AE,
    sensors: sensors_state/* sensorsState */.Wv,
    contentRules: content_rules_state/* contentRulesState */.J
});
const enhancer = (0,redux/* compose */.qC)((0,redux/* applyMiddleware */.md)(thunk));
function makeStore(userId = undefined) {
    return (0,redux/* createStore */.MT)(rootReducer.reducer, {
        auth: {
            user: {
                roles: [],
                id: userId
            }
        }
    }, enhancer);
}
const store = makeStore();
rootReducer.use(store.dispatch, store.getState);

// EXTERNAL MODULE: ./src/modules/timezone/timezoneApiHooks.ts
var timezoneApiHooks = __webpack_require__(3750);
;// CONCATENATED MODULE: ./src/app/main.tsx
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}





















function mount(cmp) {
    (0,react_dom.render)(cmp, document.getElementById("root"));
}
function main() {
    return _main.apply(this, arguments);
}
function _main() {
    _main = _async_to_generator(function*() {
        if ("scrollRestoration" in history) {
            history.scrollRestoration = "manual";
        }
        (0,interceptors/* install */.N9)((axios_default()));
        mount(/*#__PURE__*/ react.createElement(Box/* Box */.x, {
            sx: {
                centerContent: true
            }
        }, runenv/* ENV.FEATURES.NEW_LOGO_2023 */.V.FEATURES.NEW_LOGO_2023 ? /*#__PURE__*/ react.createElement(ch_icon4/* ReactComponent */.r, null) : /*#__PURE__*/ react.createElement(ch_icon3/* ReactComponent */.r, null)));
        if (true) {
            yield (0,setupExternalServices/* initExternalServices */.$)();
            (0,setupExternalServices/* watchUserChanges */.p)(store);
        }
        if ((0,effects/* isAuthenticated */.$8)()) {
            try {
                const token = yield (0,storage/* getToken */.LP)();
                const user = yield (0,effects/* fetchMe */.aM)(token);
                yield Promise.all([
                    (0,state/* preloadBetas */.yg)(),
                    (0,users_apiHooks/* preloadCurrentUser */.m8)(es/* queryCache */.sJ, user.id),
                    (0,timezoneApiHooks/* preloadTimezoneSettings */.VQ)(es/* queryCache */.sJ, user.id),
                    (0,terms_state/* preloadTermsState */.Gb)(es/* queryCache */.sJ),
                    (0,apiHooks/* preloadCategoryListAll */.Wn)(es/* queryCache */.sJ)
                ]);
            } catch (e) {
                if (e.isAxiosError && e.response.status === 403) {
                    // If token is invalid we should remove it from cookies, so it won't be used for api requests
                    const authService = yield (0,service/* resolveService */.f)("authService");
                    authService.removeAuthCookie();
                }
                console.error("user is not authenticated");
            }
        } else {
            // preload auth service since it's required for every action on login page
            (0,service/* resolveService */.f)("authService").then(()=>{}).catch((err)=>console.error("authService was not resolved", err));
        }
        (0,logger/* logInfo */.P)("rendering app");
        if (localStorage.getItem("debug")) {
            (0,logger/* logInfo */.P)(runenv/* ENV */.V);
        }
        mount(/*#__PURE__*/ react.createElement(App, {
            store: store
        }));
    });
    return _main.apply(this, arguments);
}


/***/ }),

/***/ 70433:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "b": () => (/* binding */ ROUTES_PATHS),
/* harmony export */   "q": () => (/* binding */ HOME_PAGE_FALLBACK_PATH)
/* harmony export */ });
const ROUTES_PATHS = {
    ALERTS: "/incidents",
    APITTOKENS2: "/api-tokens2",
    API_TOKENS: "/api-tokens",
    CYBERHAVEN_LOGIN: "/cyberhaven-login",
    DATAFLOWS_DASHBOARD: "/dataflows-overview",
    ENDPOINT: "/sensors/endpoint/*",
    FORGOT_PASSWORD: "/forgot",
    GRAPHIQL: "/gapi",
    JWT_AUTH: "/__jwt-auth",
    LOGIN: "/login",
    MONITORING: "/monitoring",
    PORTAL: "/portal",
    PREFERENCES: "/preferences/*",
    PROFILE: "/profile",
    REGISTRATION: "/signup",
    RESET: "/reset",
    RISKS_DASHBOARD: "/overview",
    ROLES: "/roles",
    SENSORS: "/sensors/cloud",
    SHARABLE_LISTVIEW: "/trace-details/:stateId",
    USERS_V2: "/users",
    ANALYTICS_DASHBOARD: "/analytics",
    INSIDER_RISKS: "/insider-risks"
};
// This path should be used for user with minimal permission set - ability to log in
const HOME_PAGE_FALLBACK_PATH = ROUTES_PATHS.PROFILE;


/***/ }),

/***/ 23279:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "$": () => (/* binding */ initExternalServices),
  "p": () => (/* binding */ watchUserChanges)
});

// EXTERNAL MODULE: ./src/service.tsx
var service = __webpack_require__(89880);
// EXTERNAL MODULE: ./src/runenv.tsx
var runenv = __webpack_require__(76223);
// EXTERNAL MODULE: ./node_modules/js-cookie/src/js.cookie.js
var js_cookie = __webpack_require__(36808);
var js_cookie_default = /*#__PURE__*/__webpack_require__.n(js_cookie);
// EXTERNAL MODULE: ./src/shared/mocks.tsx
var mocks = __webpack_require__(76251);
;// CONCATENATED MODULE: ./src/shared/store-when.tsx
function storeWhen(store, compare, fn) {
    const getState = store.getState;
    let initial = getState();
    fn(getState(), getState());
    store.subscribe(()=>{
        const current = getState();
        if (compare(initial, current)) {
            fn(initial, current);
        }
        initial = current;
    });
}

// EXTERNAL MODULE: ./node_modules/react-query/es/index.js + 22 modules
var es = __webpack_require__(21478);
// EXTERNAL MODULE: ./src/shared/features.ts
var features = __webpack_require__(58767);
// EXTERNAL MODULE: ./src/shared/logger.ts
var logger = __webpack_require__(20168);
// EXTERNAL MODULE: ./src/shared/permissions.tsx
var permissions = __webpack_require__(44916);
// EXTERNAL MODULE: ./src/shared/scopes.ts
var scopes = __webpack_require__(48561);
// EXTERNAL MODULE: ./node_modules/@datadog/browser-rum/esm/entries/main.js + 97 modules
var main = __webpack_require__(45351);
// EXTERNAL MODULE: ./node_modules/@mui/x-license-pro/utils/licenseInfo.js + 1 modules
var licenseInfo = __webpack_require__(29049);
// EXTERNAL MODULE: ./src/libs/async/index.ts
var libs_async = __webpack_require__(50074);
;// CONCATENATED MODULE: ./src/modules/external/intercom.js

/* eslint-disable */ function setupIntercom(config) {
    window.intercomSettings = config;
    const [promise, resolve, reject] = (0,libs_async/* newPromise */.fU)();
    (function() {
        var w = window;
        var ic = w.Intercom;
        if (typeof ic === "function") {
            ic("reattach_activator");
            ic("update", w.intercomSettings);
        } else {
            var d = document;
            var i = function() {
                i.c(arguments);
            };
            i.q = [];
            i.c = function(args) {
                i.q.push(args);
            };
            w.Intercom = i;
            var l = function() {
                var s = d.createElement("script");
                s.type = "text/javascript";
                s.async = true;
                s.src = "https://widget.intercom.io/widget/" + config.app_id;
                var x = d.getElementsByTagName("script")[0];
                x.parentNode.insertBefore(s, x);
                s.addEventListener("load", (e)=>{
                    resolve((...args)=>window.Intercom(...args));
                });
                s.addEventListener("error", ()=>reject("Error loading script."));
                s.addEventListener("abort", ()=>reject("Script loading aborted."));
            };
            l();
        }
    })();
    return promise;
}

;// CONCATENATED MODULE: ./src/modules/external/fullstory.js

/* eslint-disable */ const HOST = "fullstory.cyberhaven.io";
function setupFullStory({ debug =false , orgId  }) {
    window["_fs_debug"] = debug;
    window["_fs_host"] = HOST;
    window["_fs_script"] = HOST + "/s/fs.js";
    window["_fs_org"] = orgId;
    window["_fs_namespace"] = "FS";
    const [promise, resolve, reject] = (0,libs_async/* newPromise */.fU)();
    (function(m, n, e, t, l, o, g, y) {
        if (e in m) {
            if (m.console && m.console.log) {
                m.console.log('FullStory namespace conflict. Please set window["_fs_namespace"].');
            }
            return;
        }
        g = m[e] = function(a, b, s) {
            g.q ? g.q.push([
                a,
                b,
                s
            ]) : g._api(a, b, s);
        };
        g.q = [];
        o = n.createElement(t);
        o.async = 1;
        o.crossOrigin = "anonymous";
        o.on;
        o.src = "https://" + _fs_script;
        o.addEventListener("load", (e)=>{
            resolve(g);
        });
        o.addEventListener("error", ()=>reject("Error loading script."));
        o.addEventListener("abort", ()=>reject("Script loading aborted."));
        y = n.getElementsByTagName(t)[0];
        y.parentNode.insertBefore(o, y);
        g.identify = function(i, v, s) {
            g(l, {
                uid: i
            }, s);
            if (v) g(l, v, s);
        };
        g.setUserVars = function(v, s) {
            g(l, v, s);
        };
        g.event = function(i, v, s) {
            g("event", {
                n: i,
                p: v
            }, s);
        };
        g.anonymize = function() {
            g.identify(!!0);
        };
        g.shutdown = function() {
            g("rec", !1);
        };
        g.restart = function() {
            g("rec", !0);
        };
        g.log = function(a, b) {
            g("log", [
                a,
                b
            ]);
        };
        g.consent = function(a) {
            g("consent", !arguments.length || a);
        };
        g.identifyAccount = function(i, v) {
            o = "account";
            v = v || {};
            v.acctId = i;
            g(o, v);
        };
        g.clearUserCookie = function() {};
        g._w = {};
        y = "XMLHttpRequest";
        g._w[y] = m[y];
        y = "fetch";
        g._w[y] = m[y];
        if (m[y]) m[y] = function() {
            return g._w[y].apply(this, arguments);
        };
        g._v = "1.2.0";
    })(window, document, window["_fs_namespace"], "script", "user");
    return promise;
}

;// CONCATENATED MODULE: ./src/modules/external/pendo.js
/* eslint-disable prettier/prettier */ 
function setupPendo({ apiKey  }) {
    const url = `https://content.analytics.cyberhaven.io/agent/static/${apiKey}/pendo.js`;
    const [promise, resolve, reject] = (0,libs_async/* newPromise */.fU)();
    (function(p, e, n, d, o) {
        if (!url) {
            return;
        }
        var v, w, x, y, z;
        o = p[d] = p[d] || {};
        o._q = [];
        v = [
            "initialize",
            "identify",
            "updateOptions",
            "pageLoad"
        ];
        for(w = 0, x = v.length; w < x; ++w){
            (function(m) {
                o[m] = o[m] || function() {
                    o._q[m === v[0] ? "unshift" : "push"]([
                        m
                    ].concat([].slice.call(arguments, 0)));
                };
            })(v[w]);
        }
        y = e.createElement(n);
        y.async = !0;
        y.src = url;
        y.onerror = reject;
        y.onabort = reject;
        y.onload = ()=>resolve(window.pendo);
        z = e.getElementsByTagName(n)[0];
        z.parentNode.insertBefore(y, z);
    })(window, document, "script", "pendo");
    return promise;
}

;// CONCATENATED MODULE: ./src/modules/external/index.tsx



// see https://developers.intercom.com/installing-intercom/docs/intercom-for-web
function external_setupIntercom(config) {
    return setupIntercom(config);
}
function setupFullstory(config) {
    return setupFullStory(config);
}
function external_setupPendo(config) {
    return setupPendo(config);
}

// EXTERNAL MODULE: ./src/modules/external/zendesk/zendeskUtils.ts
var zendeskUtils = __webpack_require__(39820);
// EXTERNAL MODULE: ./src/modules/analytics/Analytics.ts
var Analytics = __webpack_require__(95520);
// EXTERNAL MODULE: ./node_modules/memoize-one/dist/memoize-one.esm.js
var memoize_one_esm = __webpack_require__(30845);
;// CONCATENATED MODULE: ./src/libs/async/lazyService.tsx

function LazyService(cb) {
    cb = (0,memoize_one_esm/* default */.Z)(cb);
    return {
        then (next, rej) {
            return next(cb(), rej);
        }
    };
}

// EXTERNAL MODULE: ./src/api/short-url/index.ts + 1 modules
var short_url = __webpack_require__(44673);
;// CONCATENATED MODULE: ./src/modules/query/services.ts
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}

function mergeObjects(params, currentState = {}) {
    const newStateForKeys = params.reduce((acc, { key , data  })=>{
        const currentStateForKey = currentState && currentState[key];
        let mergedState = data;
        if (isObject(currentStateForKey) && isObject(data)) {
            mergedState = _object_spread({}, currentStateForKey, data);
        }
        acc[key] = mergedState;
        return acc;
    }, _object_spread({}, currentState));
    return newStateForKeys;
}
const getStateId = ()=>{
    var _window_history_state;
    // search in current url first
    const urlState = new URLSearchParams(window.location.search).get("s");
    if (urlState) {
        return urlState;
    }
    const from = (_window_history_state = window.history.state) === null || _window_history_state === void 0 ? void 0 : _window_history_state.from;
    if (!from) {
        return undefined;
    }
    // check if we have state in from
    return new URLSearchParams(from.substring(from.indexOf("?"))).get("s");
};

// EXTERNAL MODULE: ./src/modules/auth/effects.ts
var effects = __webpack_require__(77805);
;// CONCATENATED MODULE: ./src/app/setupExternalServices.ts
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function setupExternalServices_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function setupExternalServices_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            setupExternalServices_define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}



















const identity = ()=>{};
const customerName = runenv/* ENV.CUSTOMER_NAME */.V.CUSTOMER_NAME;
const domain = runenv/* ENV.TOPLEVEL_DOMAIN */.V.TOPLEVEL_DOMAIN || "cyberhaven.io";
const deploymentId = window.location.host.endsWith("." + domain) ? window.location.host.slice(0, -domain.length - 1) : "";
const stackdriverApiKey = runenv/* ENV.STACKDRIVER_ERROR_REPORTER_API_KEY */.V.STACKDRIVER_ERROR_REPORTER_API_KEY;
const analyticsApiKey = runenv/* ENV.ANALYTICS_API_KEY */.V.ANALYTICS_API_KEY;
const getErrorReporterCustomerName = (prefix)=>prefix + runenv/* ENV.CUSTOMER_NAME */.V.CUSTOMER_NAME;
const intercomApiKey = runenv/* ENV.INTERCOM_API_KEY */.V.INTERCOM_API_KEY;
const enableIntercom = !runenv/* ENV.FEATURES */.V.FEATURES[features/* Feature.ZendeskWidget */.L.ZendeskWidget];
const fullstoryApiKey = runenv/* ENV.FULLSTORY_API_KEY */.V.FULLSTORY_API_KEY;
function setMuiXLicense() {
    licenseInfo/* LicenseInfo.setLicenseKey */.T.setLicenseKey(runenv/* ENV.MUI_X_LICENSE_KEY */.V.MUI_X_LICENSE_KEY);
}
// Key should be set once before first component render (https://mui.com/x/introduction/licensing/)
setMuiXLicense();
function setupReporter(config) {
    return _setupReporter.apply(this, arguments);
}
function _setupReporter() {
    _setupReporter = _async_to_generator(function*(config) {
        return Promise.all(/* import() */[__webpack_require__.e(136), __webpack_require__.e(125)]).then(__webpack_require__.bind(__webpack_require__, 18546)).then((el)=>el.setupErrorReporter(config));
    });
    return _setupReporter.apply(this, arguments);
}
function createServices() {
    return _createServices.apply(this, arguments);
}
function _createServices() {
    _createServices = _async_to_generator(function*() {
        let errorReporter = Promise.resolve(mocks/* mockErrorHandler */.c);
        console.group("init services"); // eslint-disable-line no-console
        let datadog = undefined;
        if (runenv/* ENV.IS_INTERNAL */.V.IS_INTERNAL && runenv/* ENV.ENABLE_DATADOG */.V.ENABLE_DATADOG) {
            main/* datadogRum.init */.v.init({
                applicationId: runenv/* ENV.DATADOG_APP_ID */.V.DATADOG_APP_ID,
                clientToken: runenv/* ENV.DATADOG_TOKEN */.V.DATADOG_TOKEN,
                site: "datadoghq.com",
                service: runenv/* ENV.APP_ANALYTICS_CUSTOMER_NAME */.V.APP_ANALYTICS_CUSTOMER_NAME,
                version: runenv/* ENV.VERSION */.V.VERSION,
                sampleRate: 100,
                replaySampleRate: 100,
                trackInteractions: true,
                actionNameAttribute: "data-testid",
                defaultPrivacyLevel: "mask"
            });
            main/* datadogRum.startSessionReplayRecording */.v.startSessionReplayRecording();
            datadog = main/* datadogRum */.v;
        }
        if (stackdriverApiKey) {
            errorReporter = setupReporter({
                key: stackdriverApiKey,
                projectId: runenv/* ENV.STACKDRIVER_PROJECT_ID */.V.STACKDRIVER_PROJECT_ID,
                service: "frontend",
                version: runenv/* ENV.CUSTOMER_NAME */.V.CUSTOMER_NAME + "__" + runenv/* ENV.VERSION */.V.VERSION + (runenv/* ENV.GIT_COMMIT_DIRTY */.V.GIT_COMMIT_DIRTY ? "__dirty" : "")
            });
            (0,logger/* logInfo */.P)("error reporter");
        }
        let intercom = identity;
        if (intercomApiKey && enableIntercom) {
            // inject intercom a bit later, maybe we should use more nicer metric here but I guess this one is fine
            intercom = (0,libs_async/* idleDelay */.v7)(500).then(()=>external_setupIntercom({
                    app_id: intercomApiKey,
                    alignment: "left"
                }));
            (0,logger/* logInfo */.P)("intercom");
        }
        const zendesk = (0,zendeskUtils/* setupZendesk */.V)({
            webWidget: {
                chat: {
                    connectOnPageLoad: true
                },
                launcher: {
                    chatLabel: {
                        en: ""
                    }
                },
                offset: {
                    horizontal: "42px",
                    vertical: "30px"
                },
                position: {
                    horizontal: "left",
                    vertical: "bottom"
                }
            }
        });
        let fullstory;
        if (fullstoryApiKey) {
            fullstory = setupFullstory({
                orgId: fullstoryApiKey
            });
            (0,logger/* logInfo */.P)("fullstory");
        } else {
            fullstory = Promise.resolve({
                identify: identity,
                restart: identity,
                shutdown: identity,
                event: identity,
                log: identity,
                setUserVars: identity
            });
        }
        let pendo = Promise.resolve({
            track: identity,
            initialize: identity,
            identify: identity
        });
        if (analyticsApiKey) {
            pendo = external_setupPendo({
                apiKey: analyticsApiKey
            });
            (0,logger/* logInfo */.P)("pendo");
        }
        const services = {
            errorReporter: errorReporter,
            pendo: pendo,
            intercom: intercom,
            fullstory: fullstory,
            datadog,
            zendesk,
            permissions: new permissions/* PermissionsServiceImp */.bV(es/* queryCache */.sJ)
        };
        console.groupEnd(); // eslint-disable-line no-console
        const authService = LazyService(()=>{
            return Promise.all(/* import() */[__webpack_require__.e(658), __webpack_require__.e(70)]).then(__webpack_require__.bind(__webpack_require__, 51070)).then((el)=>new el.AuthService({
                    apiKey: runenv/* ENV.FIREBASE_API_KEY */.V.FIREBASE_API_KEY,
                    authDomain: runenv/* ENV.FIREBASE_AUTH_DOMAIN */.V.FIREBASE_AUTH_DOMAIN
                }));
        });
        return _object_spread_props(setupExternalServices_object_spread({}, services), {
            authService,
            logger: (0,Analytics/* setupLogger */.FZ)(services.pendo, services.fullstory, services.intercom, services.errorReporter,  true ? Promise.resolve(datadog) : 0)
        });
    });
    return _createServices.apply(this, arguments);
}
function handleRedirectCookieUpdate(user) {
    return _handleRedirectCookieUpdate.apply(this, arguments);
}
function _handleRedirectCookieUpdate() {
    _handleRedirectCookieUpdate = _async_to_generator(function*(user) {
        const key = "DAT_DEPLOYMENTS";
        if (!user || !(user === null || user === void 0 ? void 0 : user.id) || !deploymentId) {
            return;
        }
        let info;
        try {
            info = JSON.parse(atob(js_cookie_default().get(key)));
        } catch (e) {
            (0,logger/* logInfo */.P)("no cookie");
        }
        if (!Array.isArray(info)) {
            info = [];
        }
        const now = Math.floor(new Date().getTime() / 1000);
        info = info.filter((obj)=>{
            return (obj === null || obj === void 0 ? void 0 : obj.id) !== deploymentId && (obj === null || obj === void 0 ? void 0 : obj.last_active) >= now - 60 * 60 * 24 * 30;
        });
        info.unshift({
            id: deploymentId,
            last_active: now
        });
        // the following cookie is used by redirect.cyberhaven.io
        // to redirect the user to their deployment
        js_cookie_default().set(key, btoa(JSON.stringify(info)), {
            path: "/",
            expires: 3650,
            domain: domain,
            secure: true,
            sameSite: "lax"
        });
    });
    return _handleRedirectCookieUpdate.apply(this, arguments);
}
function handleUserUpdate(user) {
    return _handleUserUpdate.apply(this, arguments);
}
function _handleUserUpdate() {
    _handleUserUpdate = // this function is called whenever user changes or logs out, so we need to disable some services
    _async_to_generator(function*(user) {
        const errorHandler = yield (0,service/* resolveService */.f)("errorReporter");
        var _user_id;
        errorHandler.setUser(getErrorReporterCustomerName((_user_id = user === null || user === void 0 ? void 0 : user.id) !== null && _user_id !== void 0 ? _user_id : "anonymous"));
        const permissions = yield (0,service/* resolveService */.f)("permissions");
        permissions.setCurrentUser(user === null || user === void 0 ? void 0 : user.id);
        if (user === null || user === void 0 ? void 0 : user.id) {
            permissions.preloadPermissions();
            (0,scopes/* preloadUserScope */.AV)(es/* queryCache */.sJ, user.id);
        }
    });
    return _handleUserUpdate.apply(this, arguments);
}
function deployment_info(format_date, date_suffix = "", bool_suffix = "") {
    const info = {
        deployment_id: deploymentId,
        deployment_commit_id: runenv/* ENV.GIT_COMMIT_DIRTY */.V.GIT_COMMIT_DIRTY,
        deployment_master_hash: runenv/* ENV.GIT_COMMIT_MASTER_HASH */.V.GIT_COMMIT_MASTER_HASH,
        deployment_version: runenv/* ENV.GIT_TAG */.V.GIT_TAG
    };
    info["deployment_commit_at" + date_suffix] = format_date(new Date(runenv/* ENV.GIT_COMMIT_DATE */.V.GIT_COMMIT_DATE));
    info["deployment_master_at" + date_suffix] = format_date(new Date(runenv/* ENV.GIT_COMMIT_MASTER_DATE */.V.GIT_COMMIT_MASTER_DATE));
    info["deployment_commit_dirty" + bool_suffix] = !!runenv/* ENV.GIT_COMMIT_DIRTY */.V.GIT_COMMIT_DIRTY;
    return info;
}
function getAnonUser() {
    return "anonymus_" + runenv/* ENV.CUSTOMER_NAME */.V.CUSTOMER_NAME;
}
function handlePendoUserUpdate(user) {
    return _handlePendoUserUpdate.apply(this, arguments);
}
function _handlePendoUserUpdate() {
    _handlePendoUserUpdate = _async_to_generator(function*(user) {
        const pendo = yield (0,service/* resolveService */.f)("pendo");
        if (!user || !(user === null || user === void 0 ? void 0 : user.id)) {
            // we do not need to stop tracking after logout
            return;
        }
        const customerProps = setupExternalServices_object_spread({
            id: customerName
        }, deployment_info((d)=>isNaN(d.getTime()) ? "" : d.toISOString()));
        const config = (0,Analytics/* getConfig */.iE)(user, customerProps);
        pendo.initialize(config); // this completely re-initializes pendo
    });
    return _handlePendoUserUpdate.apply(this, arguments);
}
function handleIntercomUserUpdate(user) {
    return _handleIntercomUserUpdate.apply(this, arguments);
}
function _handleIntercomUserUpdate() {
    _handleIntercomUserUpdate = _async_to_generator(function*(user) {
        const intercom = yield (0,service/* resolveService */.f)("intercom");
        if (!user || !(user === null || user === void 0 ? void 0 : user.id)) {
            // we need to shutdown intercom on login because it also logs out the user from
            // the intercom messenger — so someone else on the same machine cannot read messages
            // after the user logged out
            intercom("shutdown");
            return;
        }
        intercom("boot", {
            name: user.name,
            user_id: user.id,
            email: user.email,
            user_hash: user.userHash,
            horizontal_padding: 0,
            company: setupExternalServices_object_spread({
                id: customerName,
                name: customerName
            }, deployment_info((d)=>Math.floor(d.getTime() / 1000)))
        });
    });
    return _handleIntercomUserUpdate.apply(this, arguments);
}
function handleZendeskUserUpdate(user) {
    return _handleZendeskUserUpdate.apply(this, arguments);
}
function _handleZendeskUserUpdate() {
    _handleZendeskUserUpdate = _async_to_generator(function*(user) {
        const zendesk = yield (0,service/* resolveService */.f)("zendesk");
        if (!user || !(user === null || user === void 0 ? void 0 : user.id)) {
            return;
        }
        zendesk.api("webWidget", "identify", {
            name: user.name || user.email,
            email: user.email,
            company: setupExternalServices_object_spread({
                id: customerName,
                name: customerName
            }, deployment_info((d)=>Math.floor(d.getTime() / 1000)))
        });
    });
    return _handleZendeskUserUpdate.apply(this, arguments);
}
function fullstoryHandleUserChange(user) {
    return _fullstoryHandleUserChange.apply(this, arguments);
}
function _fullstoryHandleUserChange() {
    _fullstoryHandleUserChange = // make fullstory change handler separate to prevent issue when some service failed and other won't be initialized
    _async_to_generator(function*(user) {
        const fullstory = yield (0,service/* resolveService */.f)("fullstory");
        if (!user || !(user === null || user === void 0 ? void 0 : user.id)) {
            // we do not need to stop tracking after logout
            return;
        }
        // Do not remove it if you are not aware of consiquences.
        // this fix avoids creation of unknown users
        // if we initialize fullstory later it will introduce double initialization.
        if (!user || !(user === null || user === void 0 ? void 0 : user.id)) {
            fullstory.identify(getAnonUser(), {
                email: "anonymous@cyberhaven.com",
                displayName: `Anonymus(${runenv/* ENV.CUSTOMER_NAME */.V.CUSTOMER_NAME})`
            });
            return;
        }
        fullstory.identify(user.id, setupExternalServices_object_spread({
            displayName: user.name,
            email: user.email,
            customer: customerName
        }, deployment_info((d)=>d, "_date", "_bool")));
    });
    return _fullstoryHandleUserChange.apply(this, arguments);
}
function handleStateLoad(user) {
    return _handleStateLoad.apply(this, arguments);
}
function _handleStateLoad() {
    _handleStateLoad = _async_to_generator(function*(user) {
        if (!user) {
            return;
        }
        const stateId = getStateId();
        if (!stateId) {
            return;
        }
        // wait for cookie to be set
        (0,short_url/* getString */.KF)(stateId).then((state)=>{
            var _window_history_state;
            const newState = _object_spread_props(setupExternalServices_object_spread({}, window.history.state), {
                usr: setupExternalServices_object_spread({}, (_window_history_state = window.history.state) === null || _window_history_state === void 0 ? void 0 : _window_history_state.usr, JSON.parse(state))
            });
            window.history.pushState(newState, "", window.location.toString());
        }).catch((e)=>{
            console.error("failed to preload state", e);
        });
    });
    return _handleStateLoad.apply(this, arguments);
}
function initExternalServices() {
    return _initExternalServices.apply(this, arguments);
}
function _initExternalServices() {
    _initExternalServices = _async_to_generator(function*() {
        const services = createServices();
        (0,service/* setServices */.H)(services);
        window.s = services;
    });
    return _initExternalServices.apply(this, arguments);
}
function watchUserChanges(store) {
    function handleError(e) {
        return _handleError.apply(this, arguments);
    }
    function _handleError() {
        _handleError = _async_to_generator(function*(e) {
            const errorHandler = yield (0,service/* resolveService */.f)("errorReporter");
            errorHandler.report(e);
            console.error(e);
        });
        return _handleError.apply(this, arguments);
    }
    const refresher = (0,effects/* handleTokenRefresh */.hD)();
    storeWhen(store, (a, b)=>{
        var _a_auth_user, _b_auth;
        return ((_a_auth_user = a.auth.user) === null || _a_auth_user === void 0 ? void 0 : _a_auth_user.id) !== ((_b_auth = b.auth) === null || _b_auth === void 0 ? void 0 : _b_auth.user.id);
    }, function() {
        var _ref = _async_to_generator(function*(_, b) {
            const user = b.auth.user;
            handleRedirectCookieUpdate(user).catch(handleError);
            handleIntercomUserUpdate(user).catch(handleError);
            handleZendeskUserUpdate(user).catch(handleError);
            fullstoryHandleUserChange(user).catch(handleError);
            handlePendoUserUpdate(user).catch(handleError);
            handleUserUpdate(user).catch(handleError);
            handleStateLoad(user === null || user === void 0 ? void 0 : user.id).catch(handleError);
            refresher.run(user).catch(handleError);
        });
        return function(_, b) {
            return _ref.apply(this, arguments);
        };
    }());
}


/***/ }),

/***/ 80157:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "IY": () => (/* binding */ subscribeOnVersionChange),
/* harmony export */   "Pb": () => (/* binding */ silentlyUpdateVersion),
/* harmony export */   "Ye": () => (/* binding */ checkVersion)
/* harmony export */ });
/* unused harmony export setup */
/* harmony import */ var _routesPaths__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(70433);
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}

let currentVersion = null;
function getNewVersion() {
    return _getNewVersion.apply(this, arguments);
}
function _getNewVersion() {
    _getNewVersion = _async_to_generator(function*() {
        if (false) {}
        const el = yield fetch("/v1/web-config", {
            cache: "no-store",
            method: "GET"
        });
        const headers = new Map(el.headers);
        return headers.get("x-version");
    });
    return _getNewVersion.apply(this, arguments);
}
// Polls every 30 seconds and checks if the backend version is the same. If the backend was updated then we should reload the page to prevent frontend from possible bugs
function setup() {
    return _setup.apply(this, arguments);
}
function _setup() {
    _setup = _async_to_generator(function*(n = 30000) {
        currentVersion = yield getNewVersion();
        const t = setInterval(/*#__PURE__*/ _async_to_generator(function*() {
            const shouldRefresh = window.location.pathname.includes(_routesPaths__WEBPACK_IMPORTED_MODULE_0__/* .ROUTES_PATHS.LOGIN */ .b.LOGIN);
            yield checkVersion(shouldRefresh);
        }), n);
        return ()=>{
            clearInterval(t);
        };
    });
    return _setup.apply(this, arguments);
}
const versionChangeSubscribers = new Map();
function subscribeOnVersionChange(callback) {
    versionChangeSubscribers.set(callback, callback);
    return ()=>{
        versionChangeSubscribers.delete(callback);
    };
}
// This is required when we expect version update and do not want to trigger subscribers or refresh
function silentlyUpdateVersion() {
    return _silentlyUpdateVersion.apply(this, arguments);
}
function _silentlyUpdateVersion() {
    _silentlyUpdateVersion = _async_to_generator(function*() {
        currentVersion = yield getNewVersion();
    });
    return _silentlyUpdateVersion.apply(this, arguments);
}
const checkVersion = function() {
    var _ref = _async_to_generator(function*(forceRefresh = false) {
        const newVersion = yield getNewVersion();
        if (newVersion !== currentVersion) {
            console.warn("version changed from %s to %s %s", currentVersion, newVersion, forceRefresh ? ", refreshing page" : "");
            // Update current version to new only if we actually reacted to it - refreshed page or subscribers received event
            // Otherwise we will trigger this event again next time we check version
            if (forceRefresh) {
                currentVersion = newVersion;
                window.location.reload();
                return;
            }
            if (versionChangeSubscribers.size) {
                currentVersion = newVersion;
                versionChangeSubscribers.forEach((callback)=>callback());
            }
        }
    });
    return function checkVersion() {
        return _ref.apply(this, arguments);
    };
}();
setup();


/***/ }),

/***/ 99899:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "oA": () => (/* binding */ ActionAttachIcon),
  "wq": () => (/* binding */ ActionCopyIcon),
  "cS": () => (/* binding */ ActionCopypasteIcon),
  "ON": () => (/* binding */ ActionCreateCloudIcon),
  "i0": () => (/* binding */ ActionDeleteIcon),
  "DB": () => (/* binding */ ActionDownloadIcon),
  "Tr": () => (/* binding */ ActionEditIcon),
  "_n": () => (/* binding */ ActionHideIcon),
  "TT": () => (/* binding */ ActionMoveIcon),
  "T1": () => (/* binding */ ActionReceiveIcon),
  "ZU": () => (/* binding */ ActionSentIcon),
  "I_": () => (/* binding */ ActionSentToPrinterIcon),
  "e3": () => (/* binding */ ActionUnzipIcon),
  "Ze": () => (/* binding */ ActionUploadIcon),
  "dL": () => (/* binding */ ActionViewIcon),
  "nt": () => (/* binding */ ActionZipIcon),
  "op": () => (/* binding */ AfricaIcon),
  "FP": () => (/* binding */ AmericaIcon),
  "xo": () => (/* binding */ AnalyticsDashboardIcon),
  "oX": () => (/* binding */ ArrowDownIconCentered),
  "LZ": () => (/* binding */ ArrowRightIcon),
  "sI": () => (/* binding */ AsiaIcon),
  "U5": () => (/* binding */ AustraliaIcon),
  "eZ": () => (/* binding */ BlockResponseIcon),
  "m": () => (/* binding */ CalendarFilledIcon),
  "AW": () => (/* binding */ CalendarSimpleIcon),
  "xm": () => (/* binding */ CameraIcon),
  "kB": () => (/* binding */ ChatIcon),
  "MZ": () => (/* binding */ CmdIcon),
  "W5": () => (/* binding */ CollapseIcon),
  "ZS": () => (/* reexport */ ContentAttributeIcon),
  "J9": () => (/* binding */ ContentIcon),
  "Ki": () => (/* reexport */ ch_icon3/* ReactComponent */.r),
  "Uy": () => (/* reexport */ ch_icon4/* ReactComponent */.r),
  "yC": () => (/* binding */ DataflowsDashboardIcon),
  "Fr": () => (/* binding */ DatasetsIcon),
  "W8": () => (/* binding */ DlpScannerIcon),
  "LQ": () => (/* binding */ EmailIcon),
  "Uc": () => (/* binding */ EndpointGroupsIcon),
  "mh": () => (/* binding */ EndpointInstallersIcon),
  "tc": () => (/* binding */ EuropeIcon),
  "q6": () => (/* binding */ EventIcon),
  "oe": () => (/* binding */ ExpandFullIcon),
  "Qq": () => (/* binding */ ExpandIcon),
  "Es": () => (/* binding */ ExpandRowIcon),
  "aA": () => (/* binding */ FileIcon),
  "sH": () => (/* binding */ FiltersIcon),
  "Dx": () => (/* binding */ FlowIcon),
  "BH": () => (/* binding */ HelpCircleIcon),
  "F_": () => (/* binding */ HistoryIcon),
  "GA": () => (/* binding */ IncidentAssignIcon),
  "ef": () => (/* binding */ IncidentCommentDeletedIcon),
  "Ip": () => (/* binding */ IncidentEditIcon),
  "vX": () => (/* binding */ IncidentIgnoredIcon),
  "J5": () => (/* binding */ IncidentMessageIcon),
  "V$": () => (/* binding */ IncidentNewIcon),
  "VI": () => (/* binding */ IncidentPhotoIcon),
  "s_": () => (/* binding */ IncidentResolvedIcon),
  "Mj": () => (/* binding */ IncidentUserIcon),
  "sz": () => (/* binding */ InfoIcon),
  "lZ": () => (/* binding */ InstallerIcon),
  "GG": () => (/* binding */ InstallerOpenIcon),
  "xP": () => (/* binding */ LinkIcon),
  "by": () => (/* binding */ LocalTimeIcon),
  "Dc": () => (/* binding */ LocationCloudIcon),
  "bG": () => (/* binding */ LocationEndpointAppsIcon),
  "n4": () => (/* binding */ LocationEndpointIcon),
  "K$": () => (/* binding */ LocationMailIcon),
  "EM": () => (/* binding */ LocationPrinterIcon),
  "VH": () => (/* binding */ LocationRemovableMediaIcon),
  "yI": () => (/* binding */ LocationShareIcon),
  "JR": () => (/* binding */ LocationWebsiteIcon),
  "S3": () => (/* binding */ LongArrow),
  "Lx": () => (/* binding */ MacIcon),
  "N3": () => (/* binding */ MonitorResponseIcon),
  "BP": () => (/* binding */ OtherCountriesIcon),
  "oE": () => (/* binding */ PlanetIcon),
  "GQ": () => (/* binding */ PoliciesIcon),
  "qI": () => (/* binding */ PolicyIcon),
  "J_": () => (/* binding */ PopupWindowIcon),
  "Bc": () => (/* binding */ RemoveCircleOutlinedIcon),
  "Ub": () => (/* binding */ ResponseIcon),
  "V1": () => (/* binding */ RevertIcon),
  "W1": () => (/* binding */ SearchIcon),
  "ao": () => (/* binding */ SortAscIcon),
  "k6": () => (/* binding */ SortDescIcon),
  "fz": () => (/* binding */ SortIcon),
  "__": () => (/* binding */ StartedTrackingIcon),
  "Ig": () => (/* binding */ TableSettingsIcon),
  "hm": () => (/* binding */ UploadFileIcon),
  "H9": () => (/* binding */ UserProfileIcon),
  "Vt": () => (/* binding */ UsersWidgetIcon),
  "O_": () => (/* binding */ VerifyUserIcon),
  "CL": () => (/* binding */ WarnResponseIcon),
  "T6": () => (/* binding */ WarningTriangleIcon),
  "WI": () => (/* binding */ WindowsIcon)
});

// UNUSED EXPORTS: ArrowCircleUpIcon, ArrowDownIcon, AssigneeIcon, BlockIcon, CalendarIcon, CheckIcon, CloseIcon, ExportDownIconIcon, ExportIcon, FolderSettingsIcon, GraphExpandIcon, LinkSquareIcon, LocationCloudStorageIcon, RemoveCircleCrossedIcon, SelectIcon, SensitiveLocationsIcon, SettingsIcon, UninstallProtectionIcon, WarningAltIcon

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/assets/icons/internal.tsx + 111 modules
var internal = __webpack_require__(13554);
// EXTERNAL MODULE: ./node_modules/@mui/material/SvgIcon/SvgIcon.js + 1 modules
var SvgIcon = __webpack_require__(33502);
;// CONCATENATED MODULE: ./src/assets/icons/ContentAttributeIcon.jsx
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}

const ContentAttributeIcon = (props)=>/*#__PURE__*/ react.createElement("svg", _object_spread({
        xmlns: "http://www.w3.org/2000/svg",
        version: "1.1",
        id: "Layer_1",
        x: "0px",
        y: "0px",
        viewBox: "0 0 164 164",
        width: "64px",
        height: "64px"
    }, props), /*#__PURE__*/ react.createElement("g", null, /*#__PURE__*/ react.createElement("path", {
        d: "M31,2C15.009,2,2,15.009,2,31s13.009,29,29,29s29-13.009,29-29S46.991,2,31,2z M31,58C16.112,58,4,45.888,4,31   S16.112,4,31,4s27,12.112,27,27S45.888,58,31,58z"
    }), /*#__PURE__*/ react.createElement("path", {
        d: "M31,50c-0.552,0-1,0.448-1,1v2c0,0.552,0.448,1,1,1s1-0.448,1-1v-2C32,50.448,31.552,50,31,50z"
    }), /*#__PURE__*/ react.createElement("path", {
        d: "M37.013,50.077c-0.143-0.534-0.688-0.852-1.225-0.707c-0.533,0.143-0.85,0.691-0.707,1.225l0.518,1.932   c0.12,0.447,0.523,0.742,0.965,0.742c0.085,0,0.172-0.011,0.259-0.035c0.533-0.143,0.85-0.691,0.707-1.225L37.013,50.077z"
    }), /*#__PURE__*/ react.createElement("path", {
        d: "M21.75,47.521c-0.479-0.277-1.09-0.112-1.366,0.366l-1,1.732c-0.276,0.478-0.112,1.09,0.366,1.366   c0.157,0.091,0.33,0.134,0.499,0.134c0.346,0,0.682-0.179,0.867-0.5l1-1.732C22.392,48.41,22.229,47.798,21.75,47.521z"
    }), /*#__PURE__*/ react.createElement("path", {
        d: "M41.616,47.888c-0.277-0.478-0.889-0.643-1.366-0.366c-0.479,0.276-0.642,0.888-0.366,1.366l1,1.732   c0.186,0.321,0.521,0.5,0.867,0.5c0.169,0,0.342-0.043,0.499-0.134c0.479-0.276,0.642-0.888,0.366-1.366L41.616,47.888z"
    }), /*#__PURE__*/ react.createElement("path", {
        d: "M26.212,49.37c-0.537-0.145-1.082,0.173-1.225,0.707l-0.518,1.932c-0.143,0.534,0.174,1.082,0.707,1.225   c0.087,0.023,0.174,0.035,0.259,0.035c0.442,0,0.846-0.295,0.965-0.742l0.518-1.932C27.062,50.061,26.745,49.512,26.212,49.37z"
    }), /*#__PURE__*/ react.createElement("path", {
        d: "M38.351,11.322c0.712,0.267,1.419,0.576,2.099,0.919c0.145,0.073,0.298,0.107,0.45,0.107c0.366,0,0.718-0.201,0.894-0.549   c0.249-0.493,0.051-1.095-0.442-1.343c-0.746-0.376-1.52-0.715-2.3-1.007c-0.515-0.193-1.093,0.069-1.287,0.586   S37.833,11.128,38.351,11.322z"
    }), /*#__PURE__*/ react.createElement("path", {
        d: "M47.263,14.737c-0.661-0.661-1.365-1.286-2.093-1.856c-0.435-0.341-1.064-0.265-1.404,0.17   c-0.341,0.435-0.265,1.063,0.17,1.404c0.665,0.521,1.309,1.092,1.913,1.696C49.815,20.117,52,25.391,52,31   c0,4.215-1.234,8.24-3.531,11.663c-2.401-4.407-6.262-7.541-10.72-8.836C39.147,31.786,40,29.287,40,27v-2c0-4.962-4.038-9-9-9   s-9,4.038-9,9v2c0,2.287,0.853,4.786,2.25,6.827c-4.457,1.295-8.318,4.429-10.72,8.836C11.234,39.239,10,35.215,10,31   c0-5.609,2.185-10.883,6.151-14.849c4.748-4.749,11.544-6.949,18.187-5.886c0.553,0.089,1.059-0.284,1.146-0.829   c0.087-0.545-0.284-1.059-0.829-1.146c-7.275-1.165-14.717,1.246-19.917,6.446C10.393,19.081,8,24.856,8,31   s2.393,11.919,6.737,16.263c0.195,0.195,0.451,0.293,0.707,0.293s0.512-0.098,0.707-0.293c0.391-0.391,0.391-1.023,0-1.414   c-0.458-0.458-0.886-0.937-1.295-1.428c0.012-0.021,0.033-0.035,0.044-0.057c2.243-4.613,6.208-7.795,10.767-8.829   C27.158,37.02,28.998,38,31,38c2.002,0,3.842-0.98,5.334-2.464c4.559,1.033,8.524,4.216,10.767,8.83   c0.011,0.022,0.028,0.039,0.04,0.06c-0.409,0.49-0.835,0.968-1.292,1.424c-0.391,0.391-0.391,1.023,0,1.414   c0.195,0.195,0.451,0.293,0.707,0.293s0.512-0.098,0.707-0.293C51.607,42.919,54,37.144,54,31S51.607,19.081,47.263,14.737z M31,36   c-3.704,0-7-5.033-7-9v-2c0-3.86,3.14-7,7-7s7,3.14,7,7v2C38,30.967,34.704,36,31,36z"
    })));

// EXTERNAL MODULE: ./src/assets/icons/ch_icon3.svg
var ch_icon3 = __webpack_require__(2523);
// EXTERNAL MODULE: ./src/assets/icons/ch_icon4.svg
var ch_icon4 = __webpack_require__(42158);
;// CONCATENATED MODULE: ./src/assets/icons/index.tsx
function icons_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function icons_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            icons_define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}



function PopupWindowIcon() {
    return /*#__PURE__*/ react.createElement(internal/* PopupIconPure */.rQ, null);
}
function convertToDashCase(input) {
    const words = input.split(/(?=[A-Z])/);
    return words.map((word)=>word.toLowerCase()).join("-");
}
function Icon(props, component, noWrapper = false) {
    var _component_type, _component_type_render;
    const finalProps = _object_spread_props(icons_object_spread({}, props), {
        "data-icon-testid": convertToDashCase((component === null || component === void 0 ? void 0 : (_component_type = component.type) === null || _component_type === void 0 ? void 0 : (_component_type_render = _component_type.render) === null || _component_type_render === void 0 ? void 0 : _component_type_render.name) || "")
    });
    if (noWrapper) {
        return /*#__PURE__*/ react.cloneElement(component, finalProps);
    }
    return /*#__PURE__*/ (0,react.createElement)(SvgIcon/* default */.Z, finalProps, component);
}
const LongArrow = (props)=>Icon(icons_object_spread({
        color: "action"
    }, props), /*#__PURE__*/ react.createElement(internal/* LongArrowPure */._l, null));



const StartedTrackingIcon = (props)=>Icon(props, /*#__PURE__*/ react.createElement(internal/* StartedTracking */.vS, null));
const PlanetIcon = (props)=>Icon(props, /*#__PURE__*/ react.createElement(internal/* Planet */.ji, null));
const ArrowDownIcon = (props)=>Icon(props, /*#__PURE__*/ React.createElement(ArrowDown, null));
const ArrowDownIconCentered = (props)=>Icon(props, /*#__PURE__*/ react.createElement(internal/* ArrowDown */.K5, null), true);
const ActionAttachIcon = (props)=>Icon(props, /*#__PURE__*/ react.createElement(internal/* ActionAttach */.G0, null));
const ActionZipIcon = (props)=>Icon(props, /*#__PURE__*/ react.createElement(internal/* ActionZip */.Rm, null));
const ActionUnzipIcon = (props)=>Icon(props, /*#__PURE__*/ react.createElement(internal/* ActionUnzip */.iG, null));
const ActionCopyIcon = (props)=>Icon(props, /*#__PURE__*/ react.createElement(internal/* ActionCopy */.js, null));
const ActionReceiveIcon = (props)=>Icon(props, /*#__PURE__*/ react.createElement(internal/* ActionReceive */.xm, null));
const ActionCopypasteIcon = (props)=>Icon(props, /*#__PURE__*/ react.createElement(internal/* ActionCopypaste */.Ql, null));
const ActionDownloadIcon = (props)=>Icon(props, /*#__PURE__*/ react.createElement(internal/* ActionDownload */.gZ, null));
const ActionCreateCloudIcon = (props)=>Icon(props, /*#__PURE__*/ react.createElement(internal/* ActionCreateCloud */.CI, null));
const ActionEditIcon = (props)=>Icon(props, /*#__PURE__*/ react.createElement(internal/* ActionEdit */.yd, null));
const ActionMoveIcon = (props)=>Icon(props, /*#__PURE__*/ react.createElement(internal/* ActionMove */.yL, null));
const ActionViewIcon = (props)=>Icon(props, /*#__PURE__*/ react.createElement(internal/* ActionView */.kl, null));
const ActionHideIcon = (props)=>Icon(props, /*#__PURE__*/ react.createElement(internal/* ActionHide */.Uc, null));
const ActionUploadIcon = (props)=>Icon(props, /*#__PURE__*/ react.createElement(internal/* ActionUpload */.KT, null));
const ActionDeleteIcon = (props)=>Icon(props, /*#__PURE__*/ react.createElement(internal/* ActionDelete */.nO, null));
const ActionSentIcon = (props)=>Icon(props, /*#__PURE__*/ react.createElement(internal/* ActionSent */.SO, null));
const ActionSentToPrinterIcon = (props)=>Icon(props, /*#__PURE__*/ react.createElement(internal/* ActionSentToPrinter */.AK, null));
const LocationMailIcon = (props)=>Icon(props, /*#__PURE__*/ react.createElement(internal/* LocationMail */.Zv, null));
const LocationEndpointAppsIcon = (props)=>Icon(props, /*#__PURE__*/ react.createElement(internal/* LocationEndpointApps */.S6, null));
const LocationCloudIcon = (props)=>Icon(props, /*#__PURE__*/ react.createElement(internal/* LocationCloud */.Ii, null));
const LocationShareIcon = (props)=>Icon(props, /*#__PURE__*/ react.createElement(internal/* LocationShare */.a7, null));
const LocationEndpointIcon = (props)=>Icon(props, /*#__PURE__*/ react.createElement(internal/* LocationEndpoint */.Ky, null));
const LocationWebsiteIcon = (props)=>Icon(props, /*#__PURE__*/ react.createElement(internal/* LocationWebsite */.w$, null));
const LocationPrinterIcon = (props)=>Icon(props, /*#__PURE__*/ react.createElement(internal/* LocationPrinter */.JV, null));
const ExpandIcon = (props)=>Icon(props, /*#__PURE__*/ react.createElement(internal/* Expand */.M0, null));
const ExpandFullIcon = (props)=>Icon(props, /*#__PURE__*/ react.createElement(internal/* ExpandFull */.eJ, null));
const LocationCloudStorageIcon = (props)=>Icon(props, /*#__PURE__*/ React.createElement(LocationCloudStorage, null));
const LocationRemovableMediaIcon = (props)=>Icon(props, /*#__PURE__*/ react.createElement(internal/* LocationRemovableMedia */.Ye, null));
const FileIcon = (props)=>Icon(props, /*#__PURE__*/ react.createElement(internal/* File */.$B, null));
const ExpandRowIcon = (props)=>Icon(props, /*#__PURE__*/ react.createElement(internal/* ExpandRow */.A8, null));
const CalendarIcon = (props)=>Icon(props, /*#__PURE__*/ React.createElement(Calendar, null));
const GraphExpandIcon = (props)=>Icon(props, /*#__PURE__*/ React.createElement(GraphExpand, null));
const SensitiveLocationsIcon = (props)=>Icon(props, /*#__PURE__*/ React.createElement(SensitiveLocations, null));
const SelectIcon = (props)=>Icon(props, /*#__PURE__*/ React.createElement("path", {
        d: "M7 10l5 5 5-5z"
    }));
const ResponseIcon = (props)=>Icon(props, /*#__PURE__*/ react.createElement(internal/* ResponseAlert */.vW, null));
const FiltersIcon = (props)=>Icon(props, /*#__PURE__*/ react.createElement(internal/* Filters */.x$, null));
const UploadFileIcon = (props)=>Icon(props, /*#__PURE__*/ react.createElement(internal/* UploadFile */.G1, null));
const MacIcon = (props)=>Icon(props, /*#__PURE__*/ react.createElement(internal/* Mac */.Zi, null));
const WindowsIcon = (props)=>Icon(props, /*#__PURE__*/ react.createElement(internal/* Windows */.de, null));
const SettingsIcon = (props)=>Icon(props, /*#__PURE__*/ React.createElement(Settings, null));
const InstallerIcon = (props)=>Icon(props, /*#__PURE__*/ react.createElement(internal/* Installer */.AM, null));
const InstallerOpenIcon = (props)=>Icon(props, /*#__PURE__*/ react.createElement(internal/* InstallerOpen */.XJ, null));
const HistoryIcon = (props)=>Icon(props, /*#__PURE__*/ react.createElement(internal/* History */.Ay, null));
const CmdIcon = (props)=>Icon(props, /*#__PURE__*/ react.createElement(internal/* Cmd */.E, null));
const CollapseIcon = (props)=>Icon(props, /*#__PURE__*/ react.createElement(internal/* Collapse */.UO, null));
const FolderSettingsIcon = (props)=>Icon(props, /*#__PURE__*/ React.createElement(FolderSettings, null));
const SortDescIcon = (props)=>Icon(props, /*#__PURE__*/ react.createElement(internal/* SortDesc */.tX, null));
const SortAscIcon = (props)=>Icon(props, /*#__PURE__*/ react.createElement(internal/* SortAsc */.Hz, null));
const SortIcon = (props)=>Icon(props, /*#__PURE__*/ react.createElement(internal/* Sort */.Nf, null));
const ExportIcon = (props)=>Icon(props, /*#__PURE__*/ React.createElement(Export, null));
const SearchIcon = (props)=>Icon(props, /*#__PURE__*/ react.createElement(internal/* Search */.HN, null));
const ContentIcon = (props)=>Icon(props, /*#__PURE__*/ react.createElement(internal/* Content */.VY, null));
const EventIcon = (props)=>Icon(props, /*#__PURE__*/ react.createElement(internal/* Event */.ju, null));
const PolicyIcon = (props)=>Icon(props, /*#__PURE__*/ react.createElement(internal/* Policy */.GC, null));
const IncidentAssignIcon = (props)=>Icon(props, /*#__PURE__*/ react.createElement(internal/* IncidentAssign */.uq, null));
const IncidentEditIcon = (props)=>Icon(props, /*#__PURE__*/ react.createElement(internal/* IncidentEdit */.w5, null));
const IncidentIgnoredIcon = (props)=>Icon(props, /*#__PURE__*/ react.createElement(internal/* IncidentIgnored */.qm, null));
const IncidentMessageIcon = (props)=>Icon(props, /*#__PURE__*/ react.createElement(internal/* IncidentMessage */.lu, null));
const IncidentCommentDeletedIcon = (props)=>Icon(props, /*#__PURE__*/ react.createElement(internal/* IncidentCommentDeleted */.yq, null));
const IncidentResolvedIcon = (props)=>Icon(props, /*#__PURE__*/ react.createElement(internal/* IncidentResolved */.k6, null));
const IncidentNewIcon = (props)=>Icon(props, /*#__PURE__*/ react.createElement(internal/* IncidentNew */.ik, null));
const IncidentPhotoIcon = (props)=>Icon(props, /*#__PURE__*/ react.createElement(internal/* IncidentPhoto */.Zc, null));
const IncidentUserIcon = (props)=>Icon(props, /*#__PURE__*/ react.createElement(internal/* IncidentUser */.G4, null));
const AmericaIcon = (props)=>Icon(props, /*#__PURE__*/ react.createElement(internal/* America */.pM, null), true);
const OtherCountriesIcon = (props)=>Icon(props, /*#__PURE__*/ react.createElement(internal/* OtherCountries */.AE, null), true);
const AfricaIcon = (props)=>Icon(props, /*#__PURE__*/ react.createElement(internal/* Africa */.Fw, null), true);
const EuropeIcon = (props)=>Icon(props, /*#__PURE__*/ react.createElement(internal/* Europe */.sH, null), true);
const AsiaIcon = (props)=>Icon(props, /*#__PURE__*/ react.createElement(internal/* Asia */.x5, null), true);
const AustraliaIcon = (props)=>Icon(props, /*#__PURE__*/ react.createElement(internal/* Australia */.Lf, null), true);
const ChatIcon = (props)=>Icon(props, /*#__PURE__*/ react.createElement(internal/* Chat */.en, null), true);
const WarningTriangleIcon = (props)=>Icon(props, /*#__PURE__*/ react.createElement(internal/* WarningTriangle */._B, null));
const LocalTimeIcon = (props)=>Icon(props, /*#__PURE__*/ react.createElement(internal/* LocalTime */.PE, null), true);
const CalendarFilledIcon = (props)=>Icon(props, /*#__PURE__*/ react.createElement(internal/* CalendarFilled */.JG, null));
const DatasetsIcon = (props)=>Icon(props, /*#__PURE__*/ react.createElement(internal/* Datasets */.QC, null));
const PoliciesIcon = (props)=>Icon(props, /*#__PURE__*/ react.createElement(internal/* Policies */.rE, null));
const FlowIcon = (props)=>Icon(props, /*#__PURE__*/ react.createElement(internal/* Flow */.Zw, null));
const DataflowsDashboardIcon = (props)=>Icon(props, /*#__PURE__*/ react.createElement(internal/* DataflowsDashboard */.a0, null));
const UsersWidgetIcon = (props)=>Icon(props, /*#__PURE__*/ react.createElement(internal/* UsersWidget */.Q$, null));
const LinkIcon = (props)=>Icon(props, /*#__PURE__*/ react.createElement(internal/* Link */.rU, null));
const UserProfileIcon = (props)=>Icon(props, /*#__PURE__*/ react.createElement(internal/* UserProfile */.Iw, null));
const DlpScannerIcon = (props)=>Icon(props, /*#__PURE__*/ react.createElement(internal/* DlpScanner */.RU, null));
const UninstallProtectionIcon = (props)=>Icon(props, /*#__PURE__*/ React.createElement(UninstallProtection, null));
const EndpointGroupsIcon = (props)=>Icon(props, /*#__PURE__*/ react.createElement(internal/* EndpointGroups */.fB, null));
const EndpointInstallersIcon = (props)=>Icon(props, /*#__PURE__*/ react.createElement(internal/* EndpointInstallers */.KE, null));
const TableSettingsIcon = (props)=>Icon(props, /*#__PURE__*/ react.createElement(internal/* TableSettings */._2, null), true);
const RevertIcon = (props)=>Icon(props, /*#__PURE__*/ react.createElement(internal/* Revert */.Rg, null));
const AnalyticsDashboardIcon = (props)=>Icon(props, /*#__PURE__*/ react.createElement(internal/* AnalyticsDashboard */.BT, null));
const CheckIcon = (props)=>Icon(props, /*#__PURE__*/ React.createElement(Check, null), true);
const CloseIcon = (props)=>Icon(props, /*#__PURE__*/ React.createElement(Close, null));
const ArrowCircleUpIcon = (props)=>Icon(props, /*#__PURE__*/ React.createElement(ArrowCircleUp, null), true);
const ExportDownIconIcon = (props)=>Icon(props, /*#__PURE__*/ React.createElement(ExportDownIcon, null));
const InfoIcon = (props)=>Icon(props, /*#__PURE__*/ react.createElement(internal/* Info */.kI, null));
const CalendarSimpleIcon = (props)=>Icon(props, /*#__PURE__*/ react.createElement(internal/* CalendarSimple */.LB, null));
const AssigneeIcon = (props)=>Icon(props, /*#__PURE__*/ React.createElement(Assignee, null));
const WarningAltIcon = (props)=>Icon(props, /*#__PURE__*/ React.createElement(WarningAlt, null));
const BlockIcon = (props)=>Icon(props, /*#__PURE__*/ React.createElement(Block, null));
const LinkSquareIcon = (props)=>Icon(props, /*#__PURE__*/ React.createElement(LinkSquare, null), true);
const HelpCircleIcon = (props)=>Icon(props, /*#__PURE__*/ react.createElement(internal/* HelpCircle */.j$, null), true);
const ArrowRightIcon = (props)=>Icon(props, /*#__PURE__*/ react.createElement(internal/* ArrowRight */.ol, null), true);
const BlockResponseIcon = (props)=>Icon(props, /*#__PURE__*/ react.createElement(internal/* BlockResponse */.qS, null), true);
const WarnResponseIcon = (props)=>Icon(props, /*#__PURE__*/ react.createElement(internal/* WarnResponse */.jx, null), true);
const MonitorResponseIcon = (props)=>Icon(props, /*#__PURE__*/ react.createElement(internal/* MonitorResponse */.kP, null), true);
const EmailIcon = (props)=>Icon(props, /*#__PURE__*/ react.createElement(internal/* Email */.GT, null), true);
const VerifyUserIcon = (props)=>Icon(props, /*#__PURE__*/ react.createElement(internal/* VerifyUser */.dA, null), true);
const CameraIcon = (props)=>Icon(props, /*#__PURE__*/ react.createElement(internal/* Camera */.V1, null), true);
const RemoveCircleOutlinedIcon = (props)=>Icon(props, /*#__PURE__*/ react.createElement(internal/* RemoveCircleOutlined */.BC, null));
const RemoveCircleCrossedIcon = (props)=>Icon(props, /*#__PURE__*/ React.createElement(RemoveCircleCrossed, null), true);


/***/ }),

/***/ 13554:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "G0": () => (/* reexport */ action_attach_ForwardRef),
  "js": () => (/* reexport */ action_copy_ForwardRef),
  "Ql": () => (/* reexport */ action_copypaste_ForwardRef),
  "CI": () => (/* reexport */ action_create_cloud_ForwardRef),
  "nO": () => (/* reexport */ action_delete_ForwardRef),
  "gZ": () => (/* reexport */ action_download_ForwardRef),
  "yd": () => (/* reexport */ action_edit_ForwardRef),
  "Uc": () => (/* reexport */ action_hide_ForwardRef),
  "yL": () => (/* reexport */ action_move_ForwardRef),
  "xm": () => (/* reexport */ action_receive_ForwardRef),
  "SO": () => (/* reexport */ action_sent_ForwardRef),
  "AK": () => (/* reexport */ action_sent_to_printer_ForwardRef),
  "iG": () => (/* reexport */ action_zip_ForwardRef),
  "KT": () => (/* reexport */ action_upload_ForwardRef),
  "kl": () => (/* reexport */ action_view_ForwardRef),
  "Rm": () => (/* reexport */ action_zip_ForwardRef),
  "Fw": () => (/* reexport */ africa_ForwardRef),
  "pM": () => (/* reexport */ america_ForwardRef),
  "BT": () => (/* reexport */ analytics_dashboard_ForwardRef),
  "K5": () => (/* reexport */ arrow_down_ForwardRef),
  "ol": () => (/* reexport */ arrow_right_ForwardRef),
  "x5": () => (/* reexport */ asia_ForwardRef),
  "Lf": () => (/* reexport */ australia_ForwardRef),
  "gO": () => (/* reexport */ block_ForwardRef),
  "qS": () => (/* reexport */ block_response_ForwardRef),
  "JG": () => (/* reexport */ calendar_filled_ForwardRef),
  "LB": () => (/* reexport */ calendar_simple_ForwardRef),
  "V1": () => (/* reexport */ camera_ForwardRef),
  "en": () => (/* reexport */ chat_ForwardRef),
  "E": () => (/* reexport */ cmd_ForwardRef),
  "UO": () => (/* reexport */ collapse_ForwardRef),
  "VY": () => (/* reexport */ content_icon_ForwardRef),
  "a0": () => (/* reexport */ dataflows_dashboard_ForwardRef),
  "QC": () => (/* reexport */ datasets_ForwardRef),
  "RU": () => (/* reexport */ dlp_scan_ForwardRef),
  "GT": () => (/* reexport */ email_ForwardRef),
  "fB": () => (/* reexport */ groups_ForwardRef),
  "KE": () => (/* reexport */ installers_ForwardRef),
  "sH": () => (/* reexport */ europe_ForwardRef),
  "ju": () => (/* reexport */ event_icon_ForwardRef),
  "M0": () => (/* reexport */ expand_icon_ForwardRef),
  "eJ": () => (/* reexport */ expand_full_ForwardRef),
  "A8": () => (/* reexport */ expand_row_ForwardRef),
  "$B": () => (/* reexport */ file_ForwardRef),
  "x$": () => (/* reexport */ filters_icon_ForwardRef),
  "Zw": () => (/* reexport */ flow_ForwardRef),
  "ie": () => (/* reexport */ google_ForwardRef),
  "j$": () => (/* reexport */ help_circle_ForwardRef),
  "Ay": () => (/* reexport */ action_history_ForwardRef),
  "uq": () => (/* reexport */ incident_action_assign_ForwardRef),
  "yq": () => (/* reexport */ incident_action_comment_deleted_ForwardRef),
  "w5": () => (/* reexport */ incident_action_edit_ForwardRef),
  "qm": () => (/* reexport */ incident_action_ignored_ForwardRef),
  "lu": () => (/* reexport */ incident_action_message_ForwardRef),
  "ik": () => (/* reexport */ incident_action_new_ForwardRef),
  "Zc": () => (/* reexport */ incident_action_photo_ForwardRef),
  "k6": () => (/* reexport */ incident_action_resolved_ForwardRef),
  "G4": () => (/* reexport */ incident_action_user_ForwardRef),
  "kI": () => (/* reexport */ info_ForwardRef),
  "AM": () => (/* reexport */ installer_ForwardRef),
  "XJ": () => (/* reexport */ installer_open_ForwardRef),
  "rU": () => (/* reexport */ link_ForwardRef),
  "PE": () => (/* reexport */ local_time_ForwardRef),
  "Ii": () => (/* reexport */ location_cloud_ForwardRef),
  "Ky": () => (/* reexport */ location_endpoint_ForwardRef),
  "S6": () => (/* reexport */ location_endpoint_app_ForwardRef),
  "Zv": () => (/* reexport */ location_mail_ForwardRef),
  "JV": () => (/* reexport */ location_printer_ForwardRef),
  "Ye": () => (/* reexport */ location_removable_ForwardRef),
  "a7": () => (/* reexport */ location_share_ForwardRef),
  "w$": () => (/* reexport */ location_website_ForwardRef),
  "_l": () => (/* reexport */ ForwardRef),
  "Zi": () => (/* reexport */ mac_ForwardRef),
  "kP": () => (/* reexport */ monitor_response_ForwardRef),
  "AE": () => (/* reexport */ other_coutries_ForwardRef),
  "ji": () => (/* reexport */ planet_ForwardRef),
  "rE": () => (/* reexport */ policies_ForwardRef),
  "GC": () => (/* reexport */ policy_ForwardRef),
  "rQ": () => (/* reexport */ popupwindow_ForwardRef),
  "BC": () => (/* reexport */ remove_circle_outlined_ForwardRef),
  "vW": () => (/* reexport */ response_icon_ForwardRef),
  "Rg": () => (/* reexport */ revert_ForwardRef),
  "HN": () => (/* reexport */ search_ForwardRef),
  "Nf": () => (/* reexport */ sort_ForwardRef),
  "Hz": () => (/* reexport */ sort_asc_ForwardRef),
  "tX": () => (/* reexport */ sort_desc_ForwardRef),
  "vS": () => (/* reexport */ started_tracking_ForwardRef),
  "_2": () => (/* reexport */ table_settings_ForwardRef),
  "G1": () => (/* reexport */ upload_file_ForwardRef),
  "Iw": () => (/* reexport */ user_profile_ForwardRef),
  "Q$": () => (/* reexport */ users_widget_ForwardRef),
  "dA": () => (/* reexport */ verify_user_ForwardRef),
  "jx": () => (/* reexport */ warn_response_ForwardRef),
  "lw": () => (/* reexport */ warning_alt_ForwardRef),
  "_B": () => (/* reexport */ warning_triangle_ForwardRef),
  "de": () => (/* reexport */ windows_ForwardRef)
});

// UNUSED EXPORTS: ArrowCircleUp, Assignee, Calendar, Check, Close, Export, ExportDownIcon, FolderSettings, GraphExpand, LinkSquare, LocationCloudStorage, PencilIcon, RemoveCircleCrossed, SensitiveLocations, Settings, UninstallProtection

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
;// CONCATENATED MODULE: ./src/assets/icons/long-arrow.svg
var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }


const SvgLongArrow = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/react.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/react.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/react.createElement("path", {
    d: "M16.01 11H4V13H16.01V16L20 12L16.01 8V11Z",
    fill: "currentColor"
  })));
};
const ForwardRef = /*#__PURE__*/(0,react.forwardRef)(SvgLongArrow);

/* harmony default export */ const long_arrow = (__webpack_require__.p + "b82a897cea2cd1ebe509e83ae0573304.svg");
;// CONCATENATED MODULE: ./src/assets/icons/popupwindow.svg
var popupwindow_path, _path2;
function popupwindow_extends() { popupwindow_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return popupwindow_extends.apply(this, arguments); }


const SvgPopupwindow = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/react.createElement("svg", popupwindow_extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/react.createElement("title", {
    id: titleId
  }, title) : null, popupwindow_path || (popupwindow_path = /*#__PURE__*/react.createElement("path", {
    d: "M3.7 3.5h12.6c.11 0 .2.09.2.2v12.6a.2.2 0 01-.2.2H3.7a.2.2 0 01-.2-.2V3.7c0-.11.09-.2.2-.2z",
    fill: "currentColor",
    stroke: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/react.createElement("path", {
    d: "M7.7 7.505h12.6c.108 0 .195.087.195.195v12.6a.195.195 0 01-.195.195H7.7a.195.195 0 01-.195-.195V7.7c0-.108.087-.195.195-.195z",
    fill: "#fff",
    stroke: "currentColor",
    strokeWidth: 1.01
  })));
};
const popupwindow_ForwardRef = /*#__PURE__*/(0,react.forwardRef)(SvgPopupwindow);

/* harmony default export */ const popupwindow = (__webpack_require__.p + "00caba5d3f91fd55503a7a5dab2d4c8b.svg");
;// CONCATENATED MODULE: ./src/assets/icons/started-tracking.svg
var started_tracking_path, _rect, _rect2;
function started_tracking_extends() { started_tracking_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return started_tracking_extends.apply(this, arguments); }


const SvgStartedTracking = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/react.createElement("svg", started_tracking_extends({
    viewBox: "0 0 17 13",
    fill: "none",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/react.createElement("title", {
    id: titleId
  }, title) : null, started_tracking_path || (started_tracking_path = /*#__PURE__*/react.createElement("path", {
    d: "M16.25 1.625H8.125L6.5 0H0V13H16.25V1.625Z",
    fill: "currentColor"
  })), _rect || (_rect = /*#__PURE__*/react.createElement("rect", {
    x: 10,
    y: 5,
    width: 2,
    height: 6,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/react.createElement("rect", {
    x: 8,
    y: 9,
    width: 2,
    height: 6,
    transform: "rotate(-90 8 9)",
    fill: "white"
  })));
};
const started_tracking_ForwardRef = /*#__PURE__*/(0,react.forwardRef)(SvgStartedTracking);

/* harmony default export */ const started_tracking = (__webpack_require__.p + "2f78bc0825634130ebf0370b39dfb619.svg");
;// CONCATENATED MODULE: ./src/assets/icons/action_attach.svg
var action_attach_path;
function action_attach_extends() { action_attach_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return action_attach_extends.apply(this, arguments); }


const SvgActionAttach = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/react.createElement("svg", action_attach_extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/react.createElement("title", {
    id: titleId
  }, title) : null, action_attach_path || (action_attach_path = /*#__PURE__*/react.createElement("path", {
    d: "M17.3966 17.1727L17.5412 7.87664C17.5624 6.47995 17.1667 5.39211 16.3647 4.63975C15.2539 3.59876 13.7558 3.61845 13.4679 3.63426L9.87102 3.57871C8.50473 3.55702 7.42874 3.94525 6.67661 4.73555C5.62051 5.84554 5.61589 7.35027 5.63179 7.61737C5.63179 7.61737 5.49418 16.6706 5.49342 16.675C5.48779 17.0652 5.8312 17.3811 6.25851 17.3877C6.68636 17.3947 7.03915 17.0874 7.04491 16.6981C7.04593 16.6923 7.1849 7.56312 7.1849 7.56312C7.18591 7.55733 7.13991 6.4938 7.81043 5.79849C8.25117 5.34122 8.93562 5.11695 9.84661 5.13014L13.5461 5.18397C13.5534 5.18287 14.6128 5.12023 15.3096 5.78157C15.7731 6.22247 15.9981 6.9187 15.9834 7.85211L15.8404 17.1559C15.8394 17.1805 15.81 19.076 14.7772 20.0847C14.3382 20.5154 13.7784 20.7191 13.0649 20.7083C10.6811 20.6706 10.381 18.8131 10.4117 16.813C10.4325 15.3948 10.4127 11.2746 10.4122 11.095C10.4122 11.095 10.3323 8.51134 11.6424 8.53063C12.4873 8.54477 12.8451 9.46051 12.8172 11.3163L12.7441 16.8143C12.7495 17.1939 13.0878 17.5035 13.508 17.5098C13.9289 17.5173 14.2771 17.2173 14.2933 16.8382L14.3726 11.3398C14.3971 9.72294 14.4423 7.01757 11.5932 6.97376C10.8567 6.96221 10.1975 7.20197 9.75343 7.73123C8.85677 8.79901 8.8347 10.6934 8.86177 11.0416C8.86271 11.4318 8.78469 15.4467 8.76312 16.7875C8.70797 20.3767 10.2099 22.2198 13.042 22.2633C14.177 22.2796 15.1291 21.9208 15.8702 21.1918C17.3667 19.7257 17.3956 17.2758 17.3966 17.1727Z",
    fill: "currentColor"
  })));
};
const action_attach_ForwardRef = /*#__PURE__*/(0,react.forwardRef)(SvgActionAttach);

/* harmony default export */ const action_attach = (__webpack_require__.p + "914de3abc26dde6430e0c085fc445184.svg");
;// CONCATENATED MODULE: ./src/assets/icons/action_zip.svg
var action_zip_path, action_zip_rect, action_zip_rect2, _rect3, _rect4, _rect5, _rect6, action_zip_path2, _path3;
function action_zip_extends() { action_zip_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return action_zip_extends.apply(this, arguments); }


const SvgActionZip = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/react.createElement("svg", action_zip_extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/react.createElement("title", {
    id: titleId
  }, title) : null, action_zip_path || (action_zip_path = /*#__PURE__*/react.createElement("path", {
    d: "M24 6.33089H12L9.6 4.32353H0V21.6176H24V6.33089Z",
    fill: "currentColor"
  })), action_zip_rect || (action_zip_rect = /*#__PURE__*/react.createElement("rect", {
    x: 15,
    y: 7.14706,
    width: 1.5,
    height: 1.41176,
    rx: 0.4,
    fill: "white"
  })), action_zip_rect2 || (action_zip_rect2 = /*#__PURE__*/react.createElement("rect", {
    x: 16.5,
    y: 8.55881,
    width: 1.5,
    height: 1.41176,
    rx: 0.4,
    fill: "white"
  })), _rect3 || (_rect3 = /*#__PURE__*/react.createElement("rect", {
    x: 15,
    y: 9.97057,
    width: 1.5,
    height: 1.41176,
    rx: 0.4,
    fill: "white"
  })), _rect4 || (_rect4 = /*#__PURE__*/react.createElement("rect", {
    x: 16.5,
    y: 11.3823,
    width: 1.5,
    height: 1.41177,
    rx: 0.4,
    fill: "white"
  })), _rect5 || (_rect5 = /*#__PURE__*/react.createElement("rect", {
    x: 15,
    y: 12.7941,
    width: 1.5,
    height: 1.41177,
    rx: 0.4,
    fill: "white"
  })), _rect6 || (_rect6 = /*#__PURE__*/react.createElement("rect", {
    x: 16.5,
    y: 14.2059,
    width: 1.5,
    height: 1.41176,
    rx: 0.4,
    fill: "white"
  })), action_zip_path2 || (action_zip_path2 = /*#__PURE__*/react.createElement("path", {
    d: "M13.5 17.6177C13.5 16.5131 14.3954 15.6177 15.5 15.6177H17.5C18.6046 15.6177 19.5 16.5131 19.5 17.6177V20.2647C19.5 20.817 19.0523 21.2647 18.5 21.2647H14.5C13.9477 21.2647 13.5 20.817 13.5 20.2647V17.6177Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/react.createElement("path", {
    d: "M15 18.5294C15 17.701 15.6716 17.0294 16.5 17.0294V17.0294C17.3284 17.0294 18 17.701 18 18.5294V18.9118C18 19.4316 17.5786 19.853 17.0588 19.853H15.9412C15.4214 19.853 15 19.4316 15 18.9118V18.5294Z",
    fill: "currentColor"
  })));
};
const action_zip_ForwardRef = /*#__PURE__*/(0,react.forwardRef)(SvgActionZip);

/* harmony default export */ const action_zip = (__webpack_require__.p + "28e09f9f8e30e2216e435e030bffa0a2.svg");
;// CONCATENATED MODULE: ./src/assets/icons/action_copy.svg
var action_copy_path, action_copy_path2, action_copy_path3, _path4, _path5;
function action_copy_extends() { action_copy_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return action_copy_extends.apply(this, arguments); }


const SvgActionCopy = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/react.createElement("svg", action_copy_extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/react.createElement("title", {
    id: titleId
  }, title) : null, action_copy_path || (action_copy_path = /*#__PURE__*/react.createElement("path", {
    d: "M1.5 3.9C1.5 3.40294 1.90294 3 2.4 3H14.1C14.5971 3 15 3.40294 15 3.9V20.1C15 20.5971 14.5971 21 14.1 21H2.4C1.90294 21 1.5 20.5971 1.5 20.1V3.9Z",
    fill: "currentColor"
  })), action_copy_path2 || (action_copy_path2 = /*#__PURE__*/react.createElement("path", {
    d: "M7.875 5.64999C7.875 5.15293 8.27794 4.74998 8.775 4.74998H15.6272C15.8659 4.74998 16.0948 4.84481 16.2636 5.01359L19.25 7.99998L22.2364 10.9864C22.4052 11.1552 22.5 11.3841 22.5 11.6228V21.725C22.5 22.222 22.0971 22.625 21.6 22.625H8.775C8.27794 22.625 7.875 22.222 7.875 21.725V5.64999Z",
    fill: "currentColor"
  })), action_copy_path3 || (action_copy_path3 = /*#__PURE__*/react.createElement("path", {
    d: "M9.5 6.375H17.625L19.25 8L20.875 9.625V21H9.5V6.375Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/react.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.7502 12.5H14.6252V14.75H12.3755V15.875H14.6252V18.125H15.7502V15.875H18.0005V14.75H15.7502V12.5Z",
    fill: "currentColor"
  })), _path5 || (_path5 = /*#__PURE__*/react.createElement("path", {
    d: "M21.4132 11.25L16.9 11.25C16.4029 11.25 16 10.8471 16 10.35V8V5.8364C16 5.43549 16.4847 5.23472 16.7682 5.5182L19.25 8L21.7315 10.4818C22.0149 10.7653 21.8141 11.25 21.4132 11.25Z",
    fill: "currentColor"
  })));
};
const action_copy_ForwardRef = /*#__PURE__*/(0,react.forwardRef)(SvgActionCopy);

/* harmony default export */ const action_copy = (__webpack_require__.p + "fa63bfd298343f98eabfba712d5eef77.svg");
;// CONCATENATED MODULE: ./src/assets/icons/action_edit.svg
var _ellipse, action_edit_path, action_edit_rect;
function action_edit_extends() { action_edit_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return action_edit_extends.apply(this, arguments); }


const SvgActionEdit = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/react.createElement("svg", action_edit_extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/react.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/react.createElement("ellipse", {
    cx: 13,
    cy: 11,
    rx: 1,
    ry: 1,
    fill: "white"
  })), action_edit_path || (action_edit_path = /*#__PURE__*/react.createElement("path", {
    d: "M16.0134 4.5C16.2379 4.5 16.4652 4.58616 16.6351 4.75574L19.2471 7.3895L19.2526 7.39497C19.5815 7.74344 19.5856 8.29978 19.246 8.63895L10.1346 17.7309C9.96936 17.8958 9.74158 17.9866 9.51461 17.9866L6.87797 18C6.65128 18 6.42185 17.9089 6.25657 17.7443C6.08223 17.5703 6 17.3386 6 17.1121V17.1105L6.01343 14.4658C6.01343 14.2199 6.12335 14.0137 6.25574 13.863C6.26068 13.8572 6.26534 13.852 6.27027 13.8471L13.5588 6.58753L15.3805 4.75602C15.383 4.75356 15.3855 4.75109 15.3879 4.74891C15.5625 4.58479 15.7892 4.5 16.0134 4.5ZM16.0154 6.625L15.4329 7.20624L16.8177 8.58807L17.4002 8.00684L16.0154 6.625Z",
    fill: "currentColor"
  })), action_edit_rect || (action_edit_rect = /*#__PURE__*/react.createElement("rect", {
    x: 1.5,
    y: 19.5,
    width: 21,
    height: 3,
    rx: 0.4,
    fill: "currentColor"
  })));
};
const action_edit_ForwardRef = /*#__PURE__*/(0,react.forwardRef)(SvgActionEdit);

/* harmony default export */ const action_edit = (__webpack_require__.p + "b89e751b8980dd835df8b23c97d095ce.svg");
;// CONCATENATED MODULE: ./src/assets/icons/action_move.svg
var action_move_path;
function action_move_extends() { action_move_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return action_move_extends.apply(this, arguments); }


const SvgActionMove = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/react.createElement("svg", action_move_extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/react.createElement("title", {
    id: titleId
  }, title) : null, action_move_path || (action_move_path = /*#__PURE__*/react.createElement("path", {
    d: "M23.7722 10.377C23.8838 10.2973 23.8838 10.1313 23.7722 10.0515L16.3162 4.72589C16.1839 4.63134 16 4.72596 16 4.88864V8.07143L10.6667 8.07143C7.83769 8.07143 5.12458 9.27551 3.12419 11.4188C1.1899 13.4912 0.0752149 16.2777 0.00367116 19.2C-0.000383939 19.3656 0.134315 19.5 0.3 19.5H3.7C3.86569 19.5 3.99939 19.3656 4.00588 19.2C4.07586 17.4147 4.76853 15.7179 5.95262 14.4492C7.20286 13.1097 8.89856 12.3571 10.6667 12.3571L16 12.3571V15.5399C16 15.7026 16.1839 15.7972 16.3162 15.7027L23.7722 10.377Z",
    fill: "currentColor"
  })));
};
const action_move_ForwardRef = /*#__PURE__*/(0,react.forwardRef)(SvgActionMove);

/* harmony default export */ const action_move = (__webpack_require__.p + "365e44b90d462605a868f2351743607a.svg");
;// CONCATENATED MODULE: ./src/assets/icons/action_view.svg
var action_view_path, action_view_ellipse, action_view_path2;
function action_view_extends() { action_view_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return action_view_extends.apply(this, arguments); }


const SvgActionView = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/react.createElement("svg", action_view_extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/react.createElement("title", {
    id: titleId
  }, title) : null, action_view_path || (action_view_path = /*#__PURE__*/react.createElement("path", {
    d: "M12.001 8.20691C9.74459 8.20691 7.89844 10.0938 7.89844 12.4C7.89844 14.7062 9.74459 16.5931 12.001 16.5931C14.2574 16.5931 16.1036 14.7062 16.1036 12.4C16.1036 10.0938 14.2574 8.20691 12.001 8.20691Z",
    fill: "currentColor"
  })), action_view_ellipse || (action_view_ellipse = /*#__PURE__*/react.createElement("ellipse", {
    cx: 13,
    cy: 11,
    rx: 1,
    ry: 1,
    fill: "white"
  })), action_view_path2 || (action_view_path2 = /*#__PURE__*/react.createElement("path", {
    d: "M23.6154 11.8234C20.7179 7.36827 16.4872 4.79999 12 4.79999C7.51282 4.79999 3.28205 7.36827 0.384615 11.8234L0.370202 11.845C0.14605 12.1811 0.14605 12.6189 0.370202 12.9549L0.384615 12.9765C3.28205 17.4317 7.51282 20 12 20C16.4872 20 20.7179 17.4317 23.6154 12.9765L23.6298 12.9549C23.8539 12.6189 23.8539 12.1811 23.6298 11.845L23.6154 11.8234ZM12 17.9034C8.41026 17.9034 4.97436 15.9117 2.48718 12.4C4.97436 8.88827 8.41026 6.89654 12 6.89654C15.5897 6.89654 19.0256 8.88827 21.5128 12.4C19.0256 15.9117 15.5897 17.9034 12 17.9034Z",
    fill: "currentColor"
  })));
};
const action_view_ForwardRef = /*#__PURE__*/(0,react.forwardRef)(SvgActionView);

/* harmony default export */ const action_view = (__webpack_require__.p + "b9afb35ae7be29ca32cf6d447bc3fabe.svg");
;// CONCATENATED MODULE: ./src/assets/icons/action_delete.svg
var action_delete_path, action_delete_path2;
function action_delete_extends() { action_delete_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return action_delete_extends.apply(this, arguments); }


const SvgActionDelete = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/react.createElement("svg", action_delete_extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/react.createElement("title", {
    id: titleId
  }, title) : null, action_delete_path || (action_delete_path = /*#__PURE__*/react.createElement("path", {
    d: "M18.7387 7.50267H6.92713C6.38693 7.50267 5.84925 7.49525 5.30904 7.50515C5.30151 7.50515 5.29648 7.50762 5.28894 7.50762C5.28141 7.50762 5.26884 7.50762 5.26131 7.50762C5.25377 7.50762 5.24874 7.50762 5.24372 7.5101H5.24121C5.1407 7.51752 5.04523 7.54226 4.95477 7.58185C4.94724 7.58433 4.94221 7.58928 4.93467 7.59175C4.6809 7.71052 4.5 7.95549 4.5 8.25241V20.0875C4.5 20.1988 4.50503 20.3126 4.50754 20.424C4.51005 20.9708 4.71859 21.4954 5.10804 21.8888C5.50502 22.2872 6.05779 22.4975 6.6206 22.5C6.74874 22.5 6.87688 22.4975 7.00251 22.4975H16.2864C16.6533 22.4975 17.0201 22.5 17.3869 22.5C17.9623 22.4975 18.5502 22.2724 18.9372 21.8418C19.2965 21.4434 19.495 20.956 19.495 20.4215C19.495 20.0825 19.5 19.741 19.5 19.4021V8.24994C19.5025 7.84909 19.1457 7.50267 18.7387 7.50267ZM10.3065 18.1129C10.3065 18.5286 9.95979 18.8379 9.55276 18.8552C9.14572 18.8725 8.79899 18.5014 8.79899 18.1129V11.8947C8.79899 11.479 9.14572 11.1697 9.55276 11.1524C9.95979 11.1351 10.3065 11.5062 10.3065 11.8947V18.1129ZM15.2311 18.1129C15.2311 18.5286 14.8844 18.8379 14.4774 18.8552C14.0703 18.8725 13.7236 18.5014 13.7236 18.1129V11.8947C13.7236 11.479 14.0678 11.1697 14.4774 11.1524C14.8844 11.1351 15.2311 11.5062 15.2311 11.8947V18.1129Z",
    fill: "currentColor"
  })), action_delete_path2 || (action_delete_path2 = /*#__PURE__*/react.createElement("path", {
    d: "M20.9992 5.04261C20.9758 4.52323 20.5872 4.08522 20.063 4.08522H16.3416V2.97704C16.3416 2.78317 16.3486 2.59169 16.3088 2.39782C16.2035 1.87605 15.7401 1.51224 15.2275 1.50027C15.1667 1.50027 15.1058 1.50027 15.045 1.50027H9.23121C8.86375 1.50027 8.50332 1.48352 8.18033 1.71329C7.83394 1.95503 7.635 2.31166 7.635 2.74488V4.08522H3.93703C3.44787 4.08522 2.97743 4.52562 3.00084 5.04261C3.02424 5.56199 3.41276 6 3.93703 6H20.063C20.5521 6 21.0226 5.5596 20.9992 5.04261Z",
    fill: "currentColor"
  })));
};
const action_delete_ForwardRef = /*#__PURE__*/(0,react.forwardRef)(SvgActionDelete);

/* harmony default export */ const action_delete = (__webpack_require__.p + "1131024c39b3b15e3bd05ac4d432d895.svg");
;// CONCATENATED MODULE: ./src/assets/icons/action_upload.svg
var action_upload_path, action_upload_rect;
function action_upload_extends() { action_upload_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return action_upload_extends.apply(this, arguments); }


const SvgActionUpload = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/react.createElement("svg", action_upload_extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/react.createElement("title", {
    id: titleId
  }, title) : null, action_upload_path || (action_upload_path = /*#__PURE__*/react.createElement("path", {
    d: "M6.32539 15.7072L11.7532 7.85689C11.8725 7.68437 12.1275 7.68437 12.2468 7.85689L17.6746 15.7072C17.8122 15.9061 17.6698 16.1778 17.4278 16.1778H14.25L14.2519 22.0999C14.252 22.3208 14.0729 22.5 13.8519 22.5H10.1519C9.93105 22.5 9.75198 22.321 9.75191 22.1001L9.75 16.1778H6.57215C6.33024 16.1778 6.18781 15.9061 6.32539 15.7072Z",
    fill: "currentColor"
  })), action_upload_rect || (action_upload_rect = /*#__PURE__*/react.createElement("rect", {
    x: 1.5,
    y: 3,
    width: 21,
    height: 3,
    rx: 0.4,
    fill: "currentColor"
  })));
};
const action_upload_ForwardRef = /*#__PURE__*/(0,react.forwardRef)(SvgActionUpload);

/* harmony default export */ const action_upload = (__webpack_require__.p + "74fc83026d98a1e9535e5ed4091bb928.svg");
;// CONCATENATED MODULE: ./src/assets/icons/action_receive.svg
var action_receive_path, action_receive_path2;
function action_receive_extends() { action_receive_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return action_receive_extends.apply(this, arguments); }


const SvgActionReceive = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/react.createElement("svg", action_receive_extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/react.createElement("title", {
    id: titleId
  }, title) : null, action_receive_path || (action_receive_path = /*#__PURE__*/react.createElement("path", {
    d: "M16.2081 8.36061L12.2534 14.6002C12.1356 14.7861 11.8644 14.7861 11.7466 14.6002L7.79193 8.36061C7.66533 8.16086 7.80884 7.90001 8.04532 7.90001L10.3125 7.90001L10.3111 2.10014C10.311 1.76872 10.5797 1.5 10.9111 1.5L13.0861 1.5C13.4174 1.5 13.686 1.76854 13.6861 2.09986L13.6875 7.90001L15.9547 7.90001C16.1912 7.90001 16.3347 8.16086 16.2081 8.36061Z",
    fill: "currentColor"
  })), action_receive_path2 || (action_receive_path2 = /*#__PURE__*/react.createElement("path", {
    d: "M16.7682 10.5261L15.2859 12.0948L20.6471 14.1863L12 17.585L3.35294 14.1863L8.68941 12.0686L7.20706 10.5L2.12611 12.5483C1.74777 12.7008 1.5 13.0678 1.5 13.4757V17.6635C1.5 18.0737 1.75051 18.4423 2.1319 18.5933L11.6319 22.3543C11.8684 22.4479 12.1316 22.4479 12.3681 22.3543L21.8681 18.5933C22.2495 18.4423 22.5 18.0737 22.5 17.6635V13.4797C22.5 13.0698 22.2498 12.7014 21.8688 12.5502L16.7682 10.5261Z",
    fill: "currentColor"
  })));
};
const action_receive_ForwardRef = /*#__PURE__*/(0,react.forwardRef)(SvgActionReceive);

/* harmony default export */ const action_receive = (__webpack_require__.p + "e56b58649b1c9caf2880019a7ec0cdf3.svg");
;// CONCATENATED MODULE: ./src/assets/icons/action_download.svg
var action_download_path, action_download_rect;
function action_download_extends() { action_download_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return action_download_extends.apply(this, arguments); }


const SvgActionDownload = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/react.createElement("svg", action_download_extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/react.createElement("title", {
    id: titleId
  }, title) : null, action_download_path || (action_download_path = /*#__PURE__*/react.createElement("path", {
    d: "M6.32539 9.79285L11.7532 17.6431C11.8725 17.8156 12.1275 17.8156 12.2468 17.6431L17.6746 9.79284C17.8122 9.59386 17.6698 9.32223 17.4278 9.32223H14.25L14.2519 3.40013C14.252 3.17916 14.0729 3 13.8519 3L10.1519 3C9.93105 3 9.75198 3.17901 9.75191 3.39987L9.75 9.32223H6.57215C6.33024 9.32223 6.18781 9.59386 6.32539 9.79285Z",
    fill: "currentColor"
  })), action_download_rect || (action_download_rect = /*#__PURE__*/react.createElement("rect", {
    x: 1.5,
    y: 19.5,
    width: 21,
    height: 3,
    rx: 0.4,
    fill: "currentColor"
  })));
};
const action_download_ForwardRef = /*#__PURE__*/(0,react.forwardRef)(SvgActionDownload);

/* harmony default export */ const action_download = (__webpack_require__.p + "e151799cf5e1fb52e77cff7fdca109ca.svg");
;// CONCATENATED MODULE: ./src/assets/icons/action_copypaste.svg
var action_copypaste_path;
function action_copypaste_extends() { action_copypaste_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return action_copypaste_extends.apply(this, arguments); }


const SvgActionCopypaste = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/react.createElement("svg", action_copypaste_extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/react.createElement("title", {
    id: titleId
  }, title) : null, action_copypaste_path || (action_copypaste_path = /*#__PURE__*/react.createElement("path", {
    d: "M12.9167 4.97761L22.8928 12.4295C23.1069 12.5895 23.1069 12.9105 22.8928 13.0705L12.9167 20.5224C12.6529 20.7194 12.2773 20.5312 12.2773 20.2019V15.8438L2.92195 15.8464C2.59051 15.8465 2.32178 15.5778 2.32178 15.2464L2.32178 10.2589C2.32178 9.92758 2.5903 9.65898 2.92161 9.65889L12.2773 9.65625V5.29807C12.2773 4.96881 12.6529 4.78056 12.9167 4.97761Z",
    fill: "currentColor"
  })));
};
const action_copypaste_ForwardRef = /*#__PURE__*/(0,react.forwardRef)(SvgActionCopypaste);

/* harmony default export */ const action_copypaste = (__webpack_require__.p + "943cf6e3cbea257f820524cb0d8ec38f.svg");
;// CONCATENATED MODULE: ./src/assets/icons/action_create_cloud.svg
var action_create_cloud_path, action_create_cloud_rect, action_create_cloud_path2;
function action_create_cloud_extends() { action_create_cloud_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return action_create_cloud_extends.apply(this, arguments); }


const SvgActionCreateCloud = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/react.createElement("svg", action_create_cloud_extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/react.createElement("title", {
    id: titleId
  }, title) : null, action_create_cloud_path || (action_create_cloud_path = /*#__PURE__*/react.createElement("path", {
    d: "M18.9606 21C21.6258 21 23.7715 18.5942 23.7715 15.6058C23.7715 13.275 22.4975 11.2858 20.6585 10.5289C20.3863 8.01677 18.4445 6.08656 16.1306 6.08656C15.5648 6.08656 14.9321 6.19129 14.4327 6.40387C13.4043 5.21738 12.0629 4.50003 10.4708 4.50003C7.53723 4.50003 5.09663 7.0067 4.81089 10.2116C2.14566 10.2116 0 12.6174 0 15.6058C0 18.5942 2.14566 21 4.81089 21H18.9606Z",
    fill: "currentColor"
  })), action_create_cloud_rect || (action_create_cloud_rect = /*#__PURE__*/react.createElement("rect", {
    x: 7.42859,
    y: 16.5,
    width: 9.65716,
    height: 1.5,
    rx: 0.4,
    fill: "white"
  })), action_create_cloud_path2 || (action_create_cloud_path2 = /*#__PURE__*/react.createElement("path", {
    d: "M13.0378 11.9175V15.7571C13.0378 15.8124 12.993 15.8571 12.9378 15.8571H11.6825C11.6272 15.8571 11.5825 15.8124 11.5825 15.7571V11.9175H10.585C10.5055 11.9175 10.4578 11.8292 10.5014 11.7627L12.2265 9.12779C12.2659 9.06749 12.3543 9.06749 12.3938 9.12779L14.1189 11.7627C14.1624 11.8292 14.1147 11.9175 14.0352 11.9175H13.0378Z",
    fill: "white"
  })));
};
const action_create_cloud_ForwardRef = /*#__PURE__*/(0,react.forwardRef)(SvgActionCreateCloud);

/* harmony default export */ const action_create_cloud = (__webpack_require__.p + "de366bb705c1cfb068317a4a285f7240.svg");
;// CONCATENATED MODULE: ./src/assets/icons/action_sent.svg
var action_sent_path;
function action_sent_extends() { action_sent_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return action_sent_extends.apply(this, arguments); }


const SvgActionSent = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/react.createElement("svg", action_sent_extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/react.createElement("title", {
    id: titleId
  }, title) : null, action_sent_path || (action_sent_path = /*#__PURE__*/react.createElement("path", {
    d: "M22.3433 4.60756C22.3354 4.60014 22.3268 4.59346 22.3175 4.58764C22.1598 4.48797 21.9648 4.47306 21.807 4.54422L1.78875 13.1597C1.78624 13.1607 1.78383 13.1619 1.78142 13.163C1.60257 13.2499 1.5 13.3891 1.5 13.5451C1.5 13.7473 1.62159 13.9143 1.80401 13.9651C2.15337 14.1015 2.68055 14.3237 3.29003 14.5805C5.55865 15.5367 7.48514 16.3281 8.08286 16.3281C8.17366 16.3281 8.24415 16.311 8.29843 16.2757C8.30275 16.2729 8.30689 16.2699 8.31094 16.2667L19.6626 7.34498L9.09758 17.4135C9.01364 17.4904 8.98376 17.635 8.98376 17.7365C8.98376 17.7389 8.9838 17.7412 8.98393 17.7436L9.18222 22.0756C9.18425 22.2704 9.33442 22.4505 9.53314 22.4955C9.54633 22.4985 9.55983 22.5 9.57337 22.5H9.66775C9.8127 22.5 9.94787 22.4509 10.0385 22.3652C10.0517 22.3527 10.0627 22.3383 10.071 22.3224L12.2649 18.1475L16.5356 20.7904C16.5843 20.821 16.6602 20.8618 16.7562 20.8618C16.84 20.8618 16.9084 20.8307 16.9567 20.8025C17.0934 20.7549 17.1887 20.6604 17.233 20.5284L22.4753 5.11239C22.4819 5.09797 22.4865 5.08254 22.4885 5.06629C22.5253 4.89566 22.473 4.72939 22.3433 4.60756Z",
    fill: "currentColor"
  })));
};
const action_sent_ForwardRef = /*#__PURE__*/(0,react.forwardRef)(SvgActionSent);

/* harmony default export */ const action_sent = (__webpack_require__.p + "ab6eae5f4d9ab3575359d5645cac3c94.svg");
;// CONCATENATED MODULE: ./src/assets/icons/action_sent_to_printer.svg
var action_sent_to_printer_path;
function action_sent_to_printer_extends() { action_sent_to_printer_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return action_sent_to_printer_extends.apply(this, arguments); }


const SvgActionSentToPrinter = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/react.createElement("svg", action_sent_to_printer_extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/react.createElement("title", {
    id: titleId
  }, title) : null, action_sent_to_printer_path || (action_sent_to_printer_path = /*#__PURE__*/react.createElement("path", {
    d: "M12.9167 4.97761L22.8928 12.4295C23.1069 12.5895 23.1069 12.9105 22.8928 13.0705L12.9167 20.5224C12.6529 20.7194 12.2773 20.5312 12.2773 20.2019V15.8438L2.92195 15.8464C2.59051 15.8465 2.32178 15.5778 2.32178 15.2464L2.32178 10.2589C2.32178 9.92758 2.5903 9.65898 2.92161 9.65889L12.2773 9.65625V5.29807C12.2773 4.96881 12.6529 4.78056 12.9167 4.97761Z",
    fill: "currentColor"
  })));
};
const action_sent_to_printer_ForwardRef = /*#__PURE__*/(0,react.forwardRef)(SvgActionSentToPrinter);

/* harmony default export */ const action_sent_to_printer = (__webpack_require__.p + "943cf6e3cbea257f820524cb0d8ec38f.svg");
;// CONCATENATED MODULE: ./src/assets/icons/file.svg
var file_path, file_path2;
function file_extends() { file_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return file_extends.apply(this, arguments); }


const SvgFile = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/react.createElement("svg", file_extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/react.createElement("title", {
    id: titleId
  }, title) : null, file_path || (file_path = /*#__PURE__*/react.createElement("path", {
    d: "M3.875 0c-.825 0-1.5.675-1.5 1.5v21c0 .825.675 1.5 1.5 1.5h15c.825 0 1.5-.675 1.5-1.5V6l-6-6h-10.5z",
    fill: "#C4C4C4"
  })), file_path2 || (file_path2 = /*#__PURE__*/react.createElement("path", {
    d: "M15.875 6h4.5l-6-6v4.5c0 .825.675 1.5 1.5 1.5z",
    fill: "#6C6E70"
  })));
};
const file_ForwardRef = /*#__PURE__*/(0,react.forwardRef)(SvgFile);

/* harmony default export */ const file = (__webpack_require__.p + "e582741b232a6a240affec9e0273d451.svg");
;// CONCATENATED MODULE: ./src/assets/icons/calendar.svg
var calendar_path, calendar_rect, calendar_path2, calendar_path3, calendar_path4;
function calendar_extends() { calendar_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return calendar_extends.apply(this, arguments); }


const SvgCalendar = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", calendar_extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, calendar_path || (calendar_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.252 20H18.748C19.4385 20 20 19.4385 20 18.748V6.2525C20 5.562 19.438 5 18.7475 5H5.2525C4.562 5 4 5.562 4 6.2525V18.748C4 19.4385 4.562 20 5.252 20ZM5 6.2525C5 6.1135 5.1135 6 5.2525 6H18.7475C18.8865 6 19 6.1135 19 6.2525V18.748C19 18.887 18.887 19 18.748 19H5.252C5.113 19 5 18.887 5 18.748V6.2525Z",
    fill: "currentColor"
  })), calendar_rect || (calendar_rect = /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 10,
    width: 5,
    height: 5,
    fill: "currentColor"
  })), calendar_path2 || (calendar_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7 7C6.724 7 6.5 6.776 6.5 6.5V4.5C6.5 4.224 6.724 4 7 4C7.276 4 7.5 4.224 7.5 4.5V6.5C7.5 6.776 7.276 7 7 7Z",
    fill: "currentColor"
  })), calendar_path3 || (calendar_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17 7C16.7235 7 16.5 6.776 16.5 6.5V4.5C16.5 4.224 16.7235 4 17 4C17.2765 4 17.5 4.224 17.5 4.5V6.5C17.5 6.776 17.2765 7 17 7Z",
    fill: "currentColor"
  })), calendar_path4 || (calendar_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M19.5 9H4.5C4.224 9 4 8.776 4 8.5C4 8.224 4.224 8 4.5 8H19.5C19.7765 8 20 8.224 20 8.5C20 8.776 19.7765 9 19.5 9Z",
    fill: "currentColor"
  })));
};
const calendar_ForwardRef = /*#__PURE__*/(/* unused pure expression or super */ null && (forwardRef(SvgCalendar)));

/* harmony default export */ const calendar = (__webpack_require__.p + "ce0d75e6618f1248ae4c9fecee5d1bf9.svg");
;// CONCATENATED MODULE: ./src/assets/icons/location_mail.svg
var location_mail_path;
function location_mail_extends() { location_mail_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return location_mail_extends.apply(this, arguments); }


const SvgLocationMail = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/react.createElement("svg", location_mail_extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/react.createElement("title", {
    id: titleId
  }, title) : null, location_mail_path || (location_mail_path = /*#__PURE__*/react.createElement("path", {
    d: "M2.96512 4.5C2.68103 4.5 2.41849 4.60712 2.1944 4.78756L11.2674 12.777C11.7411 13.2724 12.2429 13.2723 12.7173 12.777L21.8056 4.78756C21.5815 4.60712 21.319 4.5 21.0349 4.5H2.96512ZM1.58394 5.76923C1.53018 5.96779 1.5 6.18081 1.5 6.40385V19.0962C1.5 20.1509 2.15344 21 2.96512 21H21.0349C21.8466 21 22.5 20.1509 22.5 19.0962V6.40385C22.5 6.18081 22.4698 5.96779 22.4161 5.76923L13.3278 13.7686C12.5404 14.5907 11.4442 14.592 10.657 13.7686L1.58394 5.76923Z",
    fill: "currentColor"
  })));
};
const location_mail_ForwardRef = /*#__PURE__*/(0,react.forwardRef)(SvgLocationMail);

/* harmony default export */ const location_mail = (__webpack_require__.p + "a34c36c6d90d4f61c4e691eea0285178.svg");
;// CONCATENATED MODULE: ./src/assets/icons/location_cloud.svg
var location_cloud_path, location_cloud_path2, location_cloud_path3;
function location_cloud_extends() { location_cloud_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return location_cloud_extends.apply(this, arguments); }


const SvgLocationCloud = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/react.createElement("svg", location_cloud_extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/react.createElement("title", {
    id: titleId
  }, title) : null, location_cloud_path || (location_cloud_path = /*#__PURE__*/react.createElement("path", {
    d: "M19.1429 21C21.8337 21 24 18.5942 24 15.6058C24 13.275 22.7138 11.2858 20.8571 10.5289C20.5823 8.01677 18.6219 6.08656 16.2857 6.08656C15.7144 6.08656 15.0756 6.19128 14.5714 6.40387C13.5331 5.21737 12.1789 4.50003 10.5714 4.50003C7.60969 4.50003 5.14563 7.00669 4.85714 10.2115C2.16629 10.2115 0 12.6174 0 15.6058C0 18.5942 2.16629 21 4.85714 21H19.1429Z",
    fill: "currentColor"
  })), location_cloud_path2 || (location_cloud_path2 = /*#__PURE__*/react.createElement("path", {
    d: "M10.6651 14.5845V17.9C10.6651 17.9552 10.6203 18 10.5651 18H8.97943C8.9242 18 8.87943 17.9552 8.87943 17.9V14.5845H7.60126C7.5244 14.5845 7.47627 14.5014 7.51453 14.4347L9.68552 10.6512C9.72395 10.5842 9.82056 10.5842 9.85899 10.6512L12.03 14.4347C12.0682 14.5014 12.0201 14.5845 11.9433 14.5845H10.6651Z",
    fill: "white"
  })), location_cloud_path3 || (location_cloud_path3 = /*#__PURE__*/react.createElement("path", {
    d: "M13.3357 13.9154V10.6C13.3357 10.5447 13.3804 10.5 13.4357 10.5H15.0213C15.0765 10.5 15.1213 10.5447 15.1213 10.6V13.9154H16.3995C16.4763 13.9154 16.5245 13.9985 16.4862 14.0652L14.3152 17.8488C14.2768 17.9158 14.1802 17.9158 14.1417 17.8488L11.9707 14.0652C11.9325 13.9985 11.9806 13.9154 12.0575 13.9154H13.3357Z",
    fill: "white"
  })));
};
const location_cloud_ForwardRef = /*#__PURE__*/(0,react.forwardRef)(SvgLocationCloud);

/* harmony default export */ const location_cloud = (__webpack_require__.p + "e846fbf812944be37d1390608a156c1b.svg");
;// CONCATENATED MODULE: ./src/assets/icons/location_cloud_storage.svg
var location_cloud_storage_path, location_cloud_storage_path2, location_cloud_storage_path3;
function location_cloud_storage_extends() { location_cloud_storage_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return location_cloud_storage_extends.apply(this, arguments); }


const SvgLocationCloudStorage = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", location_cloud_storage_extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, location_cloud_storage_path || (location_cloud_storage_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.1429 21C21.8337 21 24 18.5942 24 15.6058C24 13.275 22.7138 11.2858 20.8571 10.5289C20.5823 8.01677 18.6219 6.08656 16.2857 6.08656C15.7144 6.08656 15.0756 6.19128 14.5714 6.40387C13.5331 5.21737 12.1789 4.50003 10.5714 4.50003C7.60969 4.50003 5.14563 7.00669 4.85714 10.2115C2.16629 10.2115 0 12.6174 0 15.6058C0 18.5942 2.16629 21 4.85714 21H19.1429Z",
    fill: "currentColor"
  })), location_cloud_storage_path2 || (location_cloud_storage_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.6651 14.5845V17.9C10.6651 17.9552 10.6203 18 10.5651 18H8.97943C8.9242 18 8.87943 17.9552 8.87943 17.9V14.5845H7.60126C7.5244 14.5845 7.47627 14.5014 7.51453 14.4347L9.68552 10.6512C9.72395 10.5842 9.82056 10.5842 9.85899 10.6512L12.03 14.4347C12.0682 14.5014 12.0201 14.5845 11.9433 14.5845H10.6651Z",
    fill: "white"
  })), location_cloud_storage_path3 || (location_cloud_storage_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3357 13.9154V10.6C13.3357 10.5447 13.3804 10.5 13.4357 10.5H15.0213C15.0765 10.5 15.1213 10.5447 15.1213 10.6V13.9154H16.3995C16.4763 13.9154 16.5245 13.9985 16.4862 14.0652L14.3152 17.8488C14.2768 17.9158 14.1802 17.9158 14.1417 17.8488L11.9707 14.0652C11.9325 13.9985 11.9806 13.9154 12.0575 13.9154H13.3357Z",
    fill: "white"
  })));
};
const location_cloud_storage_ForwardRef = /*#__PURE__*/(/* unused pure expression or super */ null && (forwardRef(SvgLocationCloudStorage)));

/* harmony default export */ const location_cloud_storage = (__webpack_require__.p + "e846fbf812944be37d1390608a156c1b.svg");
;// CONCATENATED MODULE: ./src/assets/icons/location_share.svg
var location_share_path, location_share_path2;
function location_share_extends() { location_share_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return location_share_extends.apply(this, arguments); }


const SvgLocationShare = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/react.createElement("svg", location_share_extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/react.createElement("title", {
    id: titleId
  }, title) : null, location_share_path || (location_share_path = /*#__PURE__*/react.createElement("path", {
    d: "M24 5.94531C24 5.39303 23.5523 4.94531 23 4.94531H12.75L10.7893 3.08675C10.6035 2.91065 10.3573 2.8125 10.1014 2.8125H2.5C1.94772 2.8125 1.5 3.26022 1.5 3.8125V20.1875C1.5 20.7398 1.94772 21.1875 2.5 21.1875H23C23.5523 21.1875 24 20.7398 24 20.1875V5.94531Z",
    fill: "currentColor"
  })), location_share_path2 || (location_share_path2 = /*#__PURE__*/react.createElement("path", {
    d: "M15.25 9C15.9403 9 16.5 9.59257 16.5 10.3235C16.5 11.0545 15.9403 11.6471 15.25 11.6471C14.9656 11.6471 14.71 11.5434 14.5 11.3741L11.4922 13.3676C11.4964 13.4121 11.5 13.4543 11.5 13.5C11.5 13.5457 11.4964 13.5879 11.4922 13.6324L14.5078 15.6176C14.7164 15.4525 14.9696 15.3529 15.25 15.3529C15.9403 15.3529 16.5 15.9455 16.5 16.6765C16.5 17.4074 15.9403 18 15.25 18C14.5597 18 14 17.4074 14 16.6765C14 16.6308 14.0035 16.5886 14.0077 16.5441L11 14.5506C10.79 14.7199 10.5344 14.8235 10.25 14.8235C9.55968 14.8235 9 14.231 9 13.5C9 12.769 9.55968 12.1765 10.25 12.1765C10.5305 12.1765 10.7836 12.276 10.9922 12.4412L14.0078 10.4476C14.004 10.4058 14 10.3664 14 10.3235C14 9.59257 14.5596 9 15.25 9Z",
    fill: "white"
  })));
};
const location_share_ForwardRef = /*#__PURE__*/(0,react.forwardRef)(SvgLocationShare);

/* harmony default export */ const location_share = (__webpack_require__.p + "abd88c8fea61ae34255da78ae755ba06.svg");
;// CONCATENATED MODULE: ./src/assets/icons/location_website.svg
var location_website_rect, location_website_path;
function location_website_extends() { location_website_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return location_website_extends.apply(this, arguments); }


const SvgLocationWebsite = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/react.createElement("svg", location_website_extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/react.createElement("title", {
    id: titleId
  }, title) : null, location_website_rect || (location_website_rect = /*#__PURE__*/react.createElement("rect", {
    width: 24,
    height: 24,
    fill: "none"
  })), location_website_path || (location_website_path = /*#__PURE__*/react.createElement("path", {
    d: "M20.9245 11.1681C19.7161 11.8235 18.3315 12.3529 16.9469 12.7311C16.972 12.479 16.972 12.2521 16.972 12C16.9217 8.79832 15.814 5.69748 13.8504 3.20168C17.6517 4.0084 20.572 7.21008 20.9245 11.1681ZM12.7175 3.02521C14.9077 5.52101 16.1664 8.69748 16.242 11.9748C16.242 12.2773 16.2168 12.605 16.1916 12.9076C14.6559 13.2605 13.1958 13.4622 11.9874 13.4622C10.8042 13.437 9.31888 13.2605 7.78322 12.9076C7.75804 12.605 7.73287 12.3025 7.73287 12C7.80839 8.69748 9.04196 5.52101 11.2573 3.02521C11.5091 3 11.7357 3 11.9874 3C12.2392 3 12.4909 3.02521 12.7175 3.02521ZM10.1245 3.20168C8.16084 5.72269 7.02797 8.79832 6.97762 12.0252C6.97762 12.2773 7.0028 12.5042 7.0028 12.7311C5.61818 12.3529 4.25874 11.8487 3.02517 11.1681C3.4028 7.21008 6.32308 4.0084 10.1245 3.20168ZM3 12C4.25874 12.6555 5.69371 13.1597 7.1035 13.5126C7.43077 16.1597 8.48811 18.6807 10.1497 20.7983C6.07133 19.9412 3 16.3361 3 12ZM11.2573 20.9748C9.44476 18.9328 8.28671 16.3866 7.88392 13.7143C9.36923 14.042 10.8294 14.2185 11.9874 14.2437C13.1455 14.2185 14.6056 14.042 16.0909 13.7143C15.6881 16.3866 14.5301 18.9076 12.7175 20.9748C12.4657 21 12.2392 21 11.9874 21C11.7357 21 11.4839 20.9748 11.2573 20.9748ZM13.8504 20.7983C15.5119 18.6807 16.5441 16.1849 16.8965 13.5126C18.3063 13.1597 19.7161 12.6555 21 12C20.9748 16.3361 17.9035 19.9412 13.8504 20.7983Z",
    fill: "currentColor"
  })));
};
const location_website_ForwardRef = /*#__PURE__*/(0,react.forwardRef)(SvgLocationWebsite);

/* harmony default export */ const location_website = (__webpack_require__.p + "fd3c72eba83b8940c63845c4092f41e6.svg");
;// CONCATENATED MODULE: ./src/assets/icons/location_endpoint.svg
var location_endpoint_path, location_endpoint_rect;
function location_endpoint_extends() { location_endpoint_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return location_endpoint_extends.apply(this, arguments); }


const SvgLocationEndpoint = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/react.createElement("svg", location_endpoint_extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/react.createElement("title", {
    id: titleId
  }, title) : null, location_endpoint_path || (location_endpoint_path = /*#__PURE__*/react.createElement("path", {
    d: "M17.8723 20.0383L16.4408 18.2383C16.3819 18.1643 16.3058 18.1042 16.2183 18.0629C16.1309 18.0215 16.0346 18 15.9369 18H8.06311C7.96544 18 7.86909 18.0215 7.78165 18.0629C7.69422 18.1042 7.61807 18.1643 7.5592 18.2383L6.12767 20.0383C6.05685 20.1274 6.01357 20.2334 6.00271 20.3445C5.99184 20.4557 6.01382 20.5675 6.06618 20.6674C6.11853 20.7673 6.19918 20.8514 6.29906 20.9101C6.39894 20.9689 6.51409 21 6.63157 21H17.3684C17.4859 21 17.6011 20.9689 17.7009 20.9101C17.8008 20.8514 17.8815 20.7673 17.9338 20.6674C17.9862 20.5675 18.0082 20.4557 17.9973 20.3445C17.9864 20.2334 17.9432 20.1274 17.8723 20.0383Z",
    fill: "currentColor"
  })), location_endpoint_rect || (location_endpoint_rect = /*#__PURE__*/react.createElement("rect", {
    x: 1.5,
    y: 3,
    width: 21,
    height: 13.5,
    rx: 1,
    fill: "currentColor"
  })));
};
const location_endpoint_ForwardRef = /*#__PURE__*/(0,react.forwardRef)(SvgLocationEndpoint);

/* harmony default export */ const location_endpoint = (__webpack_require__.p + "40cd08282dc6f71d02a02a3a06e417d6.svg");
;// CONCATENATED MODULE: ./src/assets/icons/location_endpoint_app.svg
var location_endpoint_app_path, location_endpoint_app_path2, location_endpoint_app_path3, location_endpoint_app_path4;
function location_endpoint_app_extends() { location_endpoint_app_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return location_endpoint_app_extends.apply(this, arguments); }


const SvgLocationEndpointApp = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/react.createElement("svg", location_endpoint_app_extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/react.createElement("title", {
    id: titleId
  }, title) : null, location_endpoint_app_path || (location_endpoint_app_path = /*#__PURE__*/react.createElement("path", {
    d: "M9.16469 3H4.33531C3.60089 3 3 3.60089 3 4.33531V9.16469C3 9.89911 3.60089 10.5 4.33531 10.5H9.16469C9.89911 10.5 10.5 9.89911 10.5 9.16469V4.33531C10.5 3.60089 9.89911 3 9.16469 3ZM9.16469 9.16469H4.33531V4.33531H9.16469V9.16469Z",
    fill: "currentColor"
  })), location_endpoint_app_path2 || (location_endpoint_app_path2 = /*#__PURE__*/react.createElement("path", {
    d: "M19.6647 3H14.8353C14.1009 3 13.5 3.60089 13.5 4.33531V9.16469C13.5 9.89911 14.1009 10.5 14.8353 10.5H19.6647C20.3991 10.5 21 9.89911 21 9.16469V4.33531C21 3.60089 20.3991 3 19.6647 3Z",
    fill: "currentColor"
  })), location_endpoint_app_path3 || (location_endpoint_app_path3 = /*#__PURE__*/react.createElement("path", {
    d: "M9.16469 13.5H4.33531C3.60089 13.5 3 14.1009 3 14.8353V19.6647C3 20.3991 3.60089 21 4.33531 21H9.16469C9.89911 21 10.5 20.3991 10.5 19.6647V14.8353C10.5 14.1009 9.89911 13.5 9.16469 13.5Z",
    fill: "currentColor"
  })), location_endpoint_app_path4 || (location_endpoint_app_path4 = /*#__PURE__*/react.createElement("path", {
    d: "M19.6647 13.5H14.8353C14.1009 13.5 13.5 14.1009 13.5 14.8353V19.6647C13.5 20.3991 14.1009 21 14.8353 21H19.6647C20.3991 21 21 20.3991 21 19.6647V14.8353C21 14.1009 20.3991 13.5 19.6647 13.5Z",
    fill: "currentColor"
  })));
};
const location_endpoint_app_ForwardRef = /*#__PURE__*/(0,react.forwardRef)(SvgLocationEndpointApp);

/* harmony default export */ const location_endpoint_app = (__webpack_require__.p + "867d704fd9475f571eb0cb76a0c81cbd.svg");
;// CONCATENATED MODULE: ./src/assets/icons/location_removable.svg
var location_removable_path;
function location_removable_extends() { location_removable_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return location_removable_extends.apply(this, arguments); }


const SvgLocationRemovable = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/react.createElement("svg", location_removable_extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/react.createElement("title", {
    id: titleId
  }, title) : null, location_removable_path || (location_removable_path = /*#__PURE__*/react.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.75 16.9118C18.75 16.4238 18.3477 16.0294 17.85 16.0294C17.3523 16.0294 16.95 16.4238 16.95 16.9118C16.95 17.3997 17.3523 17.7941 17.85 17.7941C18.3477 17.7941 18.75 17.3997 18.75 16.9118ZM15.15 16.9118C15.15 16.4238 14.7477 16.0294 14.25 16.0294C13.7523 16.0294 13.35 16.4238 13.35 16.9118C13.35 17.3997 13.7523 17.7941 14.25 17.7941C14.7477 17.7941 15.15 17.3997 15.15 16.9118ZM21 15.5882V18.2353C21 19.2085 20.1927 20 19.2 20H4.8C3.8073 20 3 19.2085 3 18.2353V15.5882C3 14.615 3.8073 13.8235 4.8 13.8235H19.2C20.1927 13.8235 21 14.615 21 15.5882ZM4.8 12.9412C4.4193 12.9412 4.0593 13.0153 3.7146 13.1229L5.5452 6.25824C5.772 5.51706 6.4812 5 7.2696 5H16.7304C17.5188 5 18.228 5.51706 18.4548 6.25824L20.2854 13.1229C19.9407 13.0153 19.5807 12.9412 19.2 12.9412H4.8Z",
    fill: "currentColor"
  })));
};
const location_removable_ForwardRef = /*#__PURE__*/(0,react.forwardRef)(SvgLocationRemovable);

/* harmony default export */ const location_removable = (__webpack_require__.p + "803a8b8013a7765f101f9bee284f3b11.svg");
;// CONCATENATED MODULE: ./src/assets/icons/location_printer.svg
var location_printer_path;
function location_printer_extends() { location_printer_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return location_printer_extends.apply(this, arguments); }


const SvgLocationPrinter = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/react.createElement("svg", location_printer_extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/react.createElement("title", {
    id: titleId
  }, title) : null, location_printer_path || (location_printer_path = /*#__PURE__*/react.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.4445 7.4H20.4444C20.8569 7.40041 21.2523 7.54804 21.5439 7.8105C21.8355 8.07296 21.9995 8.42882 22 8.8V15.2C21.9995 15.5712 21.8355 15.927 21.5439 16.1895C21.2523 16.452 20.8569 16.5996 20.4444 16.6H18.4445V20C18.4441 20.2651 18.327 20.5193 18.1187 20.7068C17.9104 20.8942 17.6279 20.9997 17.3334 21H6.66669C6.37211 20.9997 6.0897 20.8942 5.8814 20.7068C5.6731 20.5193 5.55593 20.2651 5.55558 20V16.6H3.55556C3.14314 16.5996 2.74774 16.452 2.45611 16.1895C2.16449 15.927 2.00045 15.5712 2 15.2V8.8C2.00045 8.42882 2.16449 8.07296 2.45611 7.8105C2.74774 7.54804 3.14314 7.40041 3.55556 7.4H5.55558V4C5.55593 3.73488 5.6731 3.48071 5.8814 3.29324C6.0897 3.10577 6.37211 3.00031 6.66669 3H6.75H17.25H17.3334C17.6279 3.00031 17.9104 3.10577 18.1187 3.29324C18.327 3.48071 18.4441 3.73488 18.4445 4V7.4ZM17.4904 20.1413C17.5321 20.1039 17.5555 20.053 17.5556 20V14.3111H6.44447V20C6.44455 20.053 6.46799 20.1039 6.50964 20.1413C6.5513 20.1788 6.60778 20.1999 6.66669 20.2H17.3334C17.3923 20.1999 17.4488 20.1788 17.4904 20.1413ZM18.4938 10.8315C18.6765 10.9414 18.8914 11 19.1111 11C19.4058 11 19.6884 10.8946 19.8968 10.7071C20.1052 10.5196 20.2222 10.2652 20.2222 10C20.2222 9.80222 20.1571 9.60888 20.035 9.44443C19.9129 9.27998 19.7393 9.15181 19.5363 9.07612C19.3333 9.00043 19.1099 8.98063 18.8943 9.01921C18.6788 9.0578 18.4808 9.15304 18.3254 9.29289C18.17 9.43275 18.0642 9.61093 18.0214 9.80491C17.9785 9.99889 18.0005 10.2 18.0846 10.3827C18.1687 10.5654 18.3111 10.7216 18.4938 10.8315Z",
    fill: "currentColor"
  })));
};
const location_printer_ForwardRef = /*#__PURE__*/(0,react.forwardRef)(SvgLocationPrinter);

/* harmony default export */ const location_printer = (__webpack_require__.p + "b3f25b5c2305ef4c3163423621ef0578.svg");
;// CONCATENATED MODULE: ./src/assets/icons/expand_row.svg
var _circle, expand_row_path;
function expand_row_extends() { expand_row_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return expand_row_extends.apply(this, arguments); }


const SvgExpandRow = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/react.createElement("svg", expand_row_extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/react.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/react.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    fill: "currentColor"
  })), expand_row_path || (expand_row_path = /*#__PURE__*/react.createElement("path", {
    fill: "#fff",
    d: "M8.64 9.81l2.93-3.9a.53.53 0 01.86 0l2.93 3.9c.26.35.01.86-.43.86H9.07a.53.53 0 01-.43-.86zm6.72 4.38l-2.93 3.9a.53.53 0 01-.86 0l-2.93-3.9a.53.53 0 01.43-.86h5.86c.44 0 .7.5.43.86z"
  })));
};
const expand_row_ForwardRef = /*#__PURE__*/(0,react.forwardRef)(SvgExpandRow);

/* harmony default export */ const expand_row = (__webpack_require__.p + "6b6c71dff05dc0d691aa2ba5f2af591a.svg");
;// CONCATENATED MODULE: ./src/assets/icons/graph_expand.svg
var graph_expand_path;
function graph_expand_extends() { graph_expand_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return graph_expand_extends.apply(this, arguments); }


const SvgGraphExpand = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", graph_expand_extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, graph_expand_path || (graph_expand_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.1681 17.9315C11.1681 18.1988 10.845 18.3326 10.656 18.1436L8.84446 16.3321L6.38852 18.7881C6.27136 18.9052 6.08141 18.9052 5.96425 18.7881L5.21213 18.036C5.09497 17.9188 5.09497 17.7289 5.21213 17.6117L7.66808 15.1557L5.85656 13.3442C5.66757 13.1552 5.80142 12.8321 6.06869 12.8321H10.8681C11.0338 12.8321 11.1681 12.9664 11.1681 13.1321V17.9315ZM17.6116 5.21213C17.7288 5.09497 17.9187 5.09497 18.0359 5.21213L18.788 5.96425C18.9052 6.08141 18.9052 6.27136 18.788 6.38852L16.332 8.84446L18.1436 10.656C18.3326 10.845 18.1987 11.1681 17.9314 11.1681H13.132C12.9663 11.1681 12.832 11.0338 12.832 10.8681V6.06869C12.832 5.80142 13.1552 5.66757 13.3441 5.85656L15.1557 7.66808L17.6116 5.21213Z",
    fill: "currentColor"
  })));
};
const graph_expand_ForwardRef = /*#__PURE__*/(/* unused pure expression or super */ null && (forwardRef(SvgGraphExpand)));

/* harmony default export */ const graph_expand = (__webpack_require__.p + "44c86f66a578a40a69a43f13f5e92851.svg");
;// CONCATENATED MODULE: ./src/assets/icons/sensitive-locations.svg
var sensitive_locations_path, sensitive_locations_path2, sensitive_locations_path3, sensitive_locations_path4, sensitive_locations_path5, _path6, _path7;
function sensitive_locations_extends() { sensitive_locations_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return sensitive_locations_extends.apply(this, arguments); }


const SvgSensitiveLocations = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", sensitive_locations_extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, sensitive_locations_path || (sensitive_locations_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 18.361V14.2047C2.35578 15.6891 6.31259 16.2829 9.88057 16.2829C10.3833 16.2829 10.8938 16.2711 11.4064 16.2467L8.3706 21.6569C8.27505 21.652 8.17995 21.6466 8.08532 21.6408C3.47937 21.3576 0 20.0033 0 18.361Z",
    fill: "#757575"
  })), sensitive_locations_path2 || (sensitive_locations_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 6.66844C2.35578 8.17569 6.31259 8.76945 9.88057 8.76945C11.8886 8.76945 14.0197 8.5814 15.9193 8.1483L12.6997 14.0223C11.8067 14.1113 10.8605 14.159 9.88057 14.159C4.41424 14.159 0 12.6746 0 10.8476V6.66844Z",
    fill: "#757575"
  })), sensitive_locations_path3 || (sensitive_locations_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.88057 6.66842C15.3375 6.66842 19.7611 5.17565 19.7611 3.33421C19.7611 1.49278 15.3375 0 9.88057 0C4.42368 0 0 1.49278 0 3.33421C0 5.17565 4.42368 6.66842 9.88057 6.66842Z",
    fill: "#757575"
  })), sensitive_locations_path4 || (sensitive_locations_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5007 9.75708C16.6369 9.5117 16.9903 9.5117 17.1265 9.75708L23.9546 22.0579C24.0868 22.296 23.9144 22.5882 23.6418 22.5882H9.9855C9.71288 22.5882 9.54045 22.296 9.6726 22.0579L16.5007 9.75708Z",
    fill: "#757575"
  })), sensitive_locations_path5 || (sensitive_locations_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M19.7647 9.41177C19.7647 10.4157 19.9059 10.949 19.2 11.5765L16.9412 7.76471L19.7647 6.35294V9.41177Z",
    fill: "#757575"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M16.2354 14.1172H17.6471V17.981H16.2354V14.1172Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M16.2354 19.1698H17.6471V19.7642H16.2354V19.1698Z",
    fill: "white"
  })));
};
const sensitive_locations_ForwardRef = /*#__PURE__*/(/* unused pure expression or super */ null && (forwardRef(SvgSensitiveLocations)));

/* harmony default export */ const sensitive_locations = (__webpack_require__.p + "a8f04a7fd8c84863380aef2cda31ae79.svg");
;// CONCATENATED MODULE: ./src/assets/icons/response_icon.svg
var response_icon_path, response_icon_path2, response_icon_path3;
function response_icon_extends() { response_icon_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return response_icon_extends.apply(this, arguments); }


const SvgResponseIcon = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/react.createElement("svg", response_icon_extends({
    width: 24,
    height: 24,
    viewBox: "0 0 18 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/react.createElement("title", {
    id: titleId
  }, title) : null, response_icon_path || (response_icon_path = /*#__PURE__*/react.createElement("path", {
    d: "M11.0633 9.42672C11.0633 9.42672 8.20925 8.69368 7.80641 7.89558C7.62262 7.53008 7.80321 7.06345 7.98703 6.74163C8.07122 6.62867 8.15271 6.50932 8.23158 6.3836C8.70786 5.62172 9.07125 4.61906 9.10848 3.38093C9.16447 1.51733 7.72113 0.0053193 6.00839 0C6.00737 0 6.00576 0 6.00471 0C6.00365 0 6.00256 0 6.00044 0C4.28817 0.0053193 2.84494 1.51733 2.90086 3.38093C2.93816 4.61906 3.30206 5.62172 3.77776 6.3836H3.77721H3.77776C3.85663 6.50936 3.93918 6.6287 4.02286 6.74163C4.20613 7.06345 4.38672 7.53008 4.20344 7.89558C3.80122 8.69368 0.946188 9.42672 0.946188 9.42672C0.396936 9.61 0 10.13 0 10.7416V12H12.0094V10.7416C12.0094 10.13 11.6136 9.61 11.0633 9.42672Z",
    fill: "currentColor"
  })), response_icon_path2 || (response_icon_path2 = /*#__PURE__*/react.createElement("path", {
    d: "M14.0001 3.26985V4.73733C14.0001 4.73733 13.9914 4.92603 14.1423 4.92603C14.2932 4.92603 16.241 4.92603 16.241 4.92603C16.241 4.92603 16.4052 4.88506 16.4052 5.20023C16.4052 5.51539 16.4052 5.92574 16.4052 5.92574C16.4052 5.92574 16.4113 6.07378 16.5077 5.95182C16.6041 5.82985 17.954 4.123 17.954 4.123C17.954 4.123 18.0575 4.00898 17.954 3.87827C17.8506 3.74763 16.4826 2.02006 16.4826 2.02006C16.4826 2.02006 16.4052 1.94521 16.4052 2.08467C16.4052 2.22421 16.4052 2.90055 16.4052 2.90055C16.4052 2.90055 16.4323 3.07507 16.2248 3.07507C16.0174 3.07507 14.1355 3.07507 14.1355 3.07507C14.1355 3.07507 14.0001 3.06302 14.0001 3.26985Z",
    fill: "currentColor"
  })), response_icon_path3 || (response_icon_path3 = /*#__PURE__*/react.createElement("path", {
    d: "M14.9999 7.73015V6.26267C14.9999 6.26267 15.0086 6.07397 14.8577 6.07397C14.7068 6.07397 12.759 6.07397 12.759 6.07397C12.759 6.07397 12.5948 6.11494 12.5948 5.79977C12.5948 5.48461 12.5948 5.07426 12.5948 5.07426C12.5948 5.07426 12.5887 4.92622 12.4923 5.04818C12.3959 5.17015 11.046 6.877 11.046 6.877C11.046 6.877 10.9425 6.99102 11.046 7.12173C11.1494 7.25237 12.5174 8.97994 12.5174 8.97994C12.5174 8.97994 12.5948 9.05479 12.5948 8.91533C12.5948 8.77579 12.5948 8.09945 12.5948 8.09945C12.5948 8.09945 12.5677 7.92493 12.7752 7.92493C12.9826 7.92493 14.8645 7.92493 14.8645 7.92493C14.8645 7.92493 14.9999 7.93698 14.9999 7.73015Z",
    fill: "currentColor"
  })));
};
const response_icon_ForwardRef = /*#__PURE__*/(0,react.forwardRef)(SvgResponseIcon);

/* harmony default export */ const response_icon = (__webpack_require__.p + "0c48e26947efef2698d6c4acac535ff4.svg");
;// CONCATENATED MODULE: ./src/assets/icons/filters_icon.svg
var filters_icon_path;
function filters_icon_extends() { filters_icon_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return filters_icon_extends.apply(this, arguments); }


const SvgFiltersIcon = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/react.createElement("svg", filters_icon_extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/react.createElement("title", {
    id: titleId
  }, title) : null, filters_icon_path || (filters_icon_path = /*#__PURE__*/react.createElement("path", {
    d: "M20.1087 4.26805C20.0285 4.10471 19.8543 4 19.6626 4H4.49115C4.29944 4 4.1254 4.10453 4.04506 4.26805C3.96492 4.43139 3.9932 4.62349 4.11774 4.76028L10.067 11.2971V18.5391C10.067 18.7296 10.1917 18.9003 10.3811 18.969C10.4387 18.9899 10.4988 19 10.5581 19C10.6938 19 10.8266 18.9471 10.9217 18.8492L13.9593 15.7122C14.0416 15.6274 14.0869 15.5168 14.0869 15.4021V11.2971L20.0362 4.76028C20.1605 4.62349 20.189 4.4312 20.1087 4.26805Z",
    fill: "currentColor"
  })));
};
const filters_icon_ForwardRef = /*#__PURE__*/(0,react.forwardRef)(SvgFiltersIcon);

/* harmony default export */ const filters_icon = (__webpack_require__.p + "6ee922fdba2e531a6137a13178397bff.svg");
;// CONCATENATED MODULE: ./src/assets/icons/expand_icon.svg
var expand_icon_path;
function expand_icon_extends() { expand_icon_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return expand_icon_extends.apply(this, arguments); }


const SvgExpandIcon = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/react.createElement("svg", expand_icon_extends({
    width: 22,
    height: 18,
    viewBox: "0 0 22 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/react.createElement("title", {
    id: titleId
  }, title) : null, expand_icon_path || (expand_icon_path = /*#__PURE__*/react.createElement("path", {
    d: "M11 18L0.607698 -1.9576e-06L21.3923 -1.40549e-07L11 18Z",
    fill: "#1F1F1F"
  })));
};
const expand_icon_ForwardRef = /*#__PURE__*/(0,react.forwardRef)(SvgExpandIcon);

/* harmony default export */ const expand_icon = (__webpack_require__.p + "daf2a6aa984655ffe6dc9f0e2d74da45.svg");
;// CONCATENATED MODULE: ./src/assets/icons/expand_full.svg
var expand_full_path;
function expand_full_extends() { expand_full_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return expand_full_extends.apply(this, arguments); }


const SvgExpandFull = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/react.createElement("svg", expand_full_extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/react.createElement("title", {
    id: titleId
  }, title) : null, expand_full_path || (expand_full_path = /*#__PURE__*/react.createElement("path", {
    d: "M14.6667 4L16.7111 6.04444L14.1422 8.59556L15.4044 9.85778L17.9556 7.28889L20 9.33333V4H14.6667ZM4 9.33333L6.04444 7.28889L8.59556 9.85778L9.85778 8.59556L7.28889 6.04444L9.33333 4H4V9.33333ZM9.33333 20L7.28889 17.9556L9.85778 15.4044L8.59556 14.1422L6.04444 16.7111L4 14.6667V20H9.33333ZM20 14.6667L17.9556 16.7111L15.4044 14.1422L14.1422 15.4044L16.7111 17.9556L14.6667 20H20V14.6667Z",
    fill: "currentColor"
  })));
};
const expand_full_ForwardRef = /*#__PURE__*/(0,react.forwardRef)(SvgExpandFull);

/* harmony default export */ const expand_full = (__webpack_require__.p + "0405677d8c28d59aa4bdd3fbd08d96d5.svg");
;// CONCATENATED MODULE: ./src/assets/icons/search.svg
var search_path, search_path2;
function search_extends() { search_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return search_extends.apply(this, arguments); }


const SvgSearch = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/react.createElement("svg", search_extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/react.createElement("title", {
    id: titleId
  }, title) : null, search_path || (search_path = /*#__PURE__*/react.createElement("path", {
    d: "M15.5 14h-.79l-.28-.27C15.41 12.59 16 11.11 16 9.5 16 5.91 13.09 3 9.5 3S3 5.91 3 9.5 5.91 16 9.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19l-4.99-5zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14z"
  })), search_path2 || (search_path2 = /*#__PURE__*/react.createElement("path", {
    d: "M0 0h24v24H0z",
    fill: "none"
  })));
};
const search_ForwardRef = /*#__PURE__*/(0,react.forwardRef)(SvgSearch);

/* harmony default export */ const search = (__webpack_require__.p + "79a3b881ae3808172ad5ec5081d44897.svg");
;// CONCATENATED MODULE: ./src/assets/icons/upload_file.svg
var upload_file_path, upload_file_path2, upload_file_path3, upload_file_rect;
function upload_file_extends() { upload_file_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return upload_file_extends.apply(this, arguments); }


const SvgUploadFile = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/react.createElement("svg", upload_file_extends({
    viewBox: "0 0 77 96",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/react.createElement("title", {
    id: titleId
  }, title) : null, upload_file_path || (upload_file_path = /*#__PURE__*/react.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5 0C2.23858 0 0 2.23857 0 5V91C0 93.7614 2.23858 96 5 96L58.5 96L59.2352 83.8693C59.3868 81.368 61.3666 79.3652 63.8659 79.1848L76 78.3086L76 91V5C76 2.23858 73.7614 0 71 0H5Z",
    fill: "#F4F7FB"
  })), upload_file_path2 || (upload_file_path2 = /*#__PURE__*/react.createElement("path", {
    d: "M59.0907 82.8617C59.1828 80.812 60.8109 79.1644 62.8594 79.0478L75.9999 78.3L58.4999 96L59.0907 82.8617Z",
    fill: "#E6EEF3"
  })), upload_file_path3 || (upload_file_path3 = /*#__PURE__*/react.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.4066 39C38.304 39 38.2175 39.0191 38.161 39.0601L32.0753 45.0505C32.0266 45.0993 31.9976 45.1617 32.0002 45.231C32.0028 45.3003 32.0261 45.399 32.0954 45.3964L35.1181 45.2611L35.3789 45.2912L35.4992 45.4115L35.5844 51.3172C35.5897 51.6509 36.1302 51.9238 36.7975 51.9238H40.0007C40.6706 51.9238 41.2087 51.6509 41.2138 51.3172L41.3141 45.4115L41.4344 45.2912L41.6951 45.2611L44.7178 45.4014C44.7872 45.4041 44.8105 45.3003 44.8131 45.231C44.8185 45.1591 44.7892 45.0993 44.7379 45.0505L38.6572 39.0601C38.5983 39.0191 38.5093 39 38.4066 39Z",
    fill: "#8999A7"
  })), upload_file_rect || (upload_file_rect = /*#__PURE__*/react.createElement("rect", {
    x: 32,
    y: 53.6629,
    width: 12.8068,
    height: 3.60075,
    fill: "#8999A7"
  })));
};
const upload_file_ForwardRef = /*#__PURE__*/(0,react.forwardRef)(SvgUploadFile);

/* harmony default export */ const upload_file = (__webpack_require__.p + "105e0da366754fd952b38211237350b9.svg");
;// CONCATENATED MODULE: ./src/assets/icons/pencil.svg
var pencil_path;
function pencil_extends() { pencil_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return pencil_extends.apply(this, arguments); }


const SvgPencil = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", pencil_extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 120,
    viewBox: "0 0 22 160",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, pencil_path || (pencil_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.127 22.562l-7.127 1.438 1.438-7.128 5.689 5.69zm1.414-1.414l11.228-11.225-5.69-5.692-11.227 11.227 5.689 5.69zm9.768-21.148l-2.816 2.817 5.691 5.691 2.816-2.819-5.691-5.689z"
  })));
};
const pencil_ForwardRef = /*#__PURE__*/(/* unused pure expression or super */ null && (forwardRef(SvgPencil)));

/* harmony default export */ const pencil = (__webpack_require__.p + "f3d03f52541ef0f6422cd13d856b8ec8.svg");
;// CONCATENATED MODULE: ./src/assets/icons/windows.svg
var windows_path;
function windows_extends() { windows_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return windows_extends.apply(this, arguments); }


const SvgWindows = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/react.createElement("svg", windows_extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/react.createElement("title", {
    id: titleId
  }, title) : null, windows_path || (windows_path = /*#__PURE__*/react.createElement("path", {
    d: "M0 3.398L9.80804 2.06636L9.81233 11.4979L0.00895962 11.5535L0 3.398ZM9.80337 12.5846L9.81098 22.0243L0.00761293 20.6806L0.00706326 12.5212L9.80337 12.5846ZM10.9923 1.89216L23.997 0V11.3779L10.9923 11.4808V1.89216ZM24 12.6733L23.9969 24L10.9923 22.1702L10.9741 12.6521L24 12.6733Z",
    fill: "currentColor"
  })));
};
const windows_ForwardRef = /*#__PURE__*/(0,react.forwardRef)(SvgWindows);

/* harmony default export */ const windows = (__webpack_require__.p + "a1371861a7b0c2326c82f387632c1c14.svg");
;// CONCATENATED MODULE: ./src/assets/icons/mac.svg
var mac_path;
function mac_extends() { mac_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return mac_extends.apply(this, arguments); }


const SvgMac = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/react.createElement("svg", mac_extends({
    width: 22,
    height: 24,
    viewBox: "0 0 22 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/react.createElement("title", {
    id: titleId
  }, title) : null, mac_path || (mac_path = /*#__PURE__*/react.createElement("path", {
    d: "M21.5389 18.7033C21.1439 19.5418 20.6764 20.3136 20.1347 21.0232C19.3963 21.9906 18.7917 22.6602 18.3258 23.032C17.6035 23.6424 16.8297 23.955 16.001 23.9728C15.4061 23.9728 14.6887 23.8172 13.8536 23.5017C13.0157 23.1876 12.2457 23.032 11.5417 23.032C10.8033 23.032 10.0114 23.1876 9.16436 23.5017C8.31602 23.8172 7.63261 23.9816 7.1101 23.9979C6.31545 24.0291 5.52338 23.7076 4.73276 23.032C4.22814 22.6276 3.59697 21.9343 2.84085 20.9521C2.02959 19.9033 1.36263 18.687 0.840114 17.3004C0.280522 15.8026 0 14.3523 0 12.9482C0 11.3398 0.378221 9.95259 1.13579 8.79011C1.73117 7.85636 2.52324 7.11979 3.51458 6.57906C4.50592 6.03834 5.57706 5.76279 6.73059 5.74516C7.36176 5.74516 8.18946 5.92456 9.21804 6.27715C10.2437 6.63091 10.9023 6.81031 11.191 6.81031C11.4069 6.81031 12.1385 6.60054 13.3788 6.18233C14.5517 5.79449 15.5416 5.63391 16.3525 5.69716C18.5499 5.86012 20.2008 6.6561 21.2987 8.09013C19.3334 9.18432 18.3613 10.7169 18.3806 12.6829C18.3984 14.2142 19.0029 15.4886 20.1911 16.5004C20.7296 16.97 21.3309 17.333 22 17.5907C21.8549 17.9774 21.7017 18.3477 21.5389 18.7033V18.7033ZM16.4992 0.480137C16.4992 1.68041 16.022 2.8011 15.0708 3.8384C13.9229 5.07155 12.5345 5.78412 11.0289 5.67168C11.0097 5.52769 10.9985 5.37614 10.9985 5.21688C10.9985 4.06462 11.5444 2.83147 12.5139 1.82321C12.9978 1.3127 13.6134 0.888228 14.3598 0.549615C15.1046 0.216055 15.8092 0.031589 16.4718 0C16.4911 0.160458 16.4992 0.320926 16.4992 0.480121V0.480137Z",
    fill: "currentColor"
  })));
};
const mac_ForwardRef = /*#__PURE__*/(0,react.forwardRef)(SvgMac);

/* harmony default export */ const mac = (__webpack_require__.p + "7757177b120bcb78a23afc476628d8b8.svg");
;// CONCATENATED MODULE: ./src/assets/icons/planet.svg
var planet_path, planet_path2;
function planet_extends() { planet_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return planet_extends.apply(this, arguments); }


const SvgPlanet = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/react.createElement("svg", planet_extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/react.createElement("title", {
    id: titleId
  }, title) : null, planet_path || (planet_path = /*#__PURE__*/react.createElement("path", {
    opacity: 0.8,
    d: "M12.3837 21.0002C12.5 21.0002 12.6551 21.0002 12.7714 21.0002C12.8102 20.8063 12.8102 20.5737 12.7714 20.3798C12.6163 19.837 12.6551 19.2941 12.6551 18.79C12.6551 18.441 12.6551 18.0533 12.2674 17.8982C11.7245 17.6655 11.4531 17.239 11.2592 16.7349C11.1429 16.5023 11.0265 16.2308 10.7551 16.1533C10.7551 15.9594 10.6388 15.688 10.9102 15.5716C10.7163 15.4553 10.7551 15.1451 10.9102 14.9512C11.0265 14.8349 11.1429 14.7186 11.2204 14.6023C11.2592 14.5635 11.298 14.4859 11.298 14.4472C11.2592 14.2533 11.4143 14.0206 11.1816 13.8267C11.1816 13.8267 11.1816 13.7492 11.2204 13.6716C11.1816 13.6329 11.1041 13.5941 11.0265 13.5553C10.949 13.6716 10.9102 13.7492 10.8327 13.8655C10.7163 13.7104 10.4449 13.788 10.3286 13.5553C10.3286 13.5165 10.2122 13.4778 10.1735 13.4778C10.1347 13.4778 10.0959 13.439 10.0959 13.439C10.1735 13.2063 9.90204 13.09 9.86327 12.9349C9.78572 12.8961 9.66939 12.8961 9.59184 12.8574C9.51429 12.8186 9.39796 12.8186 9.32041 12.7798C9.24286 12.741 9.16531 12.7023 9.12653 12.6247C8.97143 12.3921 8.93266 12.3533 8.66123 12.4696C8.62245 12.5084 8.5449 12.5084 8.46735 12.4696C8.2347 12.3921 8.04082 12.2757 7.80817 12.1594C7.76939 12.1206 7.69184 12.1206 7.65306 12.1206C7.38163 12.0431 7.26531 11.888 7.30408 11.6165C7.30408 11.5002 7.30408 11.3839 7.22653 11.3063C7.07143 11.0349 6.91633 10.8023 6.76123 10.5696C6.6449 10.3757 6.52857 10.2206 6.52857 9.98797C6.52857 9.94919 6.4898 9.91042 6.37347 9.87164C6.37347 9.94919 6.29592 10.0267 6.3347 10.1043C6.37347 10.2594 6.45102 10.3757 6.4898 10.5308C6.56735 10.7635 6.6449 10.9961 6.72245 11.2288C6.68368 11.2288 6.68368 11.2676 6.6449 11.2676C6.4898 11.0349 6.3347 10.7635 6.17959 10.4921C6.17959 10.4533 6.25714 10.4145 6.21837 10.3757C6.10204 10.0655 6.21837 9.60021 5.79184 9.40634C5.75306 9.36756 5.71429 9.29001 5.67551 9.21246C5.59796 8.74715 5.67551 8.32062 5.98572 7.93287C6.14082 7.73899 6.29592 7.50634 6.45102 7.31246C6.4898 7.31246 6.56735 7.35123 6.60612 7.31246C6.8 7.11858 6.56735 6.96348 6.56735 6.7696C6.60612 6.7696 6.6449 6.73082 6.68368 6.73082C6.6449 6.49817 6.4898 6.42062 6.4898 6.30429C6.45102 6.18797 6.56735 6.03287 6.60612 5.87776C6.52857 5.87776 6.45102 5.87776 6.41225 5.87776C6.41225 5.87776 6.41225 5.87776 6.41225 5.83899C6.41225 5.37368 6.41225 5.37368 5.94694 5.21858C5.86939 5.1798 5.83061 5.14103 5.75306 5.10225C5.71429 5.10225 5.71429 5.06348 5.67551 5.06348C4.00816 6.7696 3 9.05736 3 11.5778C3 16.7737 7.18776 21.0002 12.3837 21.0002Z",
    fill: "currentColor"
  })), planet_path2 || (planet_path2 = /*#__PURE__*/react.createElement("path", {
    opacity: 0.8,
    d: "M8.04097 3.7449C8.11852 3.7449 8.1573 3.78367 8.23485 3.78367C8.35118 3.78367 8.4675 3.82245 8.58383 3.82245C8.66138 3.82245 8.77771 3.70612 8.85526 3.86123C8.85526 3.86123 8.93281 3.86123 8.97158 3.86123C9.04913 3.86123 9.12669 3.82245 9.20424 3.78367C9.43689 3.66735 9.63077 3.5898 9.9022 3.7449C10.1348 3.86123 10.4451 3.86123 10.7165 3.86123C10.7553 3.86123 10.794 3.86123 10.8328 3.9C10.794 3.93878 10.7553 3.97755 10.7165 3.97755C10.7165 4.01633 10.7165 4.01633 10.7165 4.0551C10.9104 4.01633 11.0655 4.01633 11.2593 3.97755C11.2593 4.01633 11.2593 4.0551 11.2593 4.13265C11.2981 4.13265 11.2981 4.13265 11.2981 4.09388C11.4532 3.93878 11.5695 3.82245 11.8022 3.93878C11.9573 4.01633 12.1512 3.97755 12.3451 4.01633C12.3838 4.01633 12.4614 3.93878 12.5002 3.9C12.6553 3.7449 12.7716 3.70612 12.9267 3.82245C12.8491 3.9 12.7716 3.93878 12.6553 4.01633L12.694 4.0551C12.8491 3.97755 13.0042 3.9 13.043 3.70612C13.1206 3.43469 13.6634 3.12449 14.0124 3.16327C13.8185 3.24082 13.6634 3.27959 13.5471 3.35714C13.4308 3.43469 13.392 3.5898 13.3144 3.70612C13.4308 3.7449 13.6246 3.7449 13.4308 3.97755C13.4308 3.97755 13.4695 3.97755 13.4695 4.01633C13.6246 3.97755 13.741 3.93878 13.9349 3.9C13.9349 3.82245 13.8961 3.82245 13.8961 3.78367C13.8961 3.7449 13.8961 3.70612 13.8961 3.70612C13.8185 3.66735 13.7022 3.66735 13.6246 3.62857V3.5898C13.6634 3.5898 13.741 3.5898 13.7797 3.55102C13.7022 3.51225 13.6634 3.51225 13.6246 3.47347C13.6246 3.43469 13.6246 3.43469 13.6246 3.39592C13.8573 3.31837 14.0512 3.20204 14.2838 3.12449C14.2838 3.12449 14.2838 3.16327 14.3226 3.16327C14.2451 3.24082 14.1675 3.31837 14.09 3.35714C14.3226 3.27959 14.5165 3.24082 14.7491 3.16327C14.7491 3.20204 14.7491 3.27959 14.7879 3.31837C14.8267 3.31837 14.9042 3.31837 14.9818 3.31837V3.27959C14.943 3.27959 14.8655 3.24082 14.8267 3.24082C14.9818 3.12449 15.0981 3.16327 15.1757 3.27959C15.2532 3.35714 15.292 3.51225 15.4859 3.47347C15.5634 3.43469 15.6798 3.5898 15.7961 3.62857C15.7573 3.70612 15.6798 3.7449 15.641 3.82245C15.7961 3.9 15.99 3.97755 16.1838 4.09388C15.9512 4.17143 15.7573 4.52041 15.5246 4.0551C15.4859 4.13265 15.4471 4.21021 15.4083 4.24898C15.6022 4.36531 15.5246 4.52041 15.4083 4.63674C15.3308 4.59796 15.2144 4.55919 15.1369 4.48163C15.1369 4.48163 15.1369 4.48163 15.1369 4.52041C15.1757 4.55919 15.2532 4.63674 15.292 4.67551C15.292 4.71429 15.292 4.71429 15.2532 4.75306C15.0981 4.71429 14.943 4.67551 14.7879 4.63674C14.7491 4.48163 14.7104 4.32653 14.4389 4.40408C14.3614 4.44286 14.2838 4.40408 14.1675 4.40408C14.1675 4.36531 14.1675 4.32653 14.1675 4.32653C14.2838 4.32653 14.3614 4.28776 14.4777 4.28776C14.594 4.28776 14.7104 4.32653 14.7491 4.17143C14.7491 4.13265 14.8655 4.13265 14.9042 4.09388C15.0593 4.01633 15.0981 3.93878 14.9818 3.78367C14.9042 3.70612 14.8267 3.62857 14.7104 3.5898C14.6328 3.5898 14.5553 3.5898 14.5165 3.5898C14.4389 3.5898 14.3226 3.62857 14.2451 3.62857C14.2838 3.70612 14.2838 3.78367 14.3226 3.9C14.1675 4.17143 13.8961 4.0551 13.5859 4.13265C13.741 4.24898 13.8185 4.32653 13.9349 4.40408C13.9349 4.44286 13.9349 4.44286 13.9349 4.48163C13.741 4.52041 13.5083 4.52041 13.3144 4.55919C13.3144 4.52041 13.3144 4.52041 13.3144 4.48163C13.3532 4.44286 13.392 4.36531 13.4695 4.28776C13.2369 4.36531 13.0818 4.44286 12.8879 4.48163C12.5389 4.59796 12.19 4.75306 11.9185 4.98572C11.7634 5.10204 11.8022 5.25715 11.841 5.41225C11.8797 5.4898 11.9961 5.4898 12.0736 5.52857C12.2287 5.60612 12.3451 5.68368 12.5002 5.76123C12.6165 5.8 12.7328 5.8 12.8491 5.8C12.7716 5.9551 12.7328 6.11021 12.6553 6.26531C12.694 6.34286 12.7328 6.42041 12.8104 6.53674C12.9267 6.34286 13.0042 6.18776 13.1206 6.03266C13.1593 5.9551 13.2369 5.87755 13.3144 5.83878C13.392 5.76123 13.5083 5.76123 13.5859 5.68368C13.741 5.56735 13.8185 5.45102 13.7022 5.29592C13.8185 5.14082 13.9349 5.02449 14.0124 4.86939C14.09 4.71429 14.2063 4.63674 14.3614 4.71429C14.4002 4.75306 14.4777 4.67551 14.5553 4.67551C14.6328 4.67551 14.6716 4.67551 14.7491 4.71429C14.8267 4.79184 14.9042 4.86939 14.9818 4.94694C14.9818 4.94694 14.943 4.94694 14.943 4.98572C14.9042 5.06327 14.9042 5.14082 14.9042 5.21837C14.9818 5.21837 15.0593 5.25714 15.0981 5.25714C15.2532 5.17959 15.4083 5.10204 15.5246 5.02449C15.5634 5.14082 15.641 5.25715 15.641 5.37347C15.641 5.41225 15.641 5.4898 15.6022 5.56735C15.5634 5.72245 15.5246 5.8 15.7185 5.83878C15.8349 5.87755 15.9512 6.03266 16.1063 6.18776C15.9124 6.34286 15.7185 6.45919 15.5246 6.57551C15.5634 6.61429 15.5634 6.65306 15.5634 6.65306C15.8736 6.65306 15.7185 6.92449 15.7961 7.0796C15.7961 7.0796 15.7185 7.15715 15.6798 7.19592C15.641 7.15715 15.6022 7.11837 15.5634 7.04082C15.4083 7.04082 15.2144 7.00204 14.9818 6.96327C15.0981 6.80817 15.1757 6.73062 15.2532 6.61429C15.0593 6.53674 14.8655 6.57551 14.7104 6.73062C14.6716 6.76939 14.594 6.73062 14.5553 6.69184C14.4777 6.61429 14.4002 6.61429 14.3226 6.69184C14.1287 6.80817 13.9736 6.88572 13.7797 7.00204C13.8961 6.96327 14.0124 6.88572 14.1287 6.84694C14.2063 6.80817 14.2838 6.80817 14.3614 6.80817C14.4389 6.80817 14.4777 6.84694 14.5553 6.88572C14.5165 6.92449 14.4777 6.96327 14.4002 7.00204C14.4002 7.04082 14.4389 7.11837 14.4389 7.15715L14.4777 7.11837C14.5165 7.15715 14.5553 7.2347 14.6328 7.27347C14.6716 7.31225 14.7104 7.35102 14.7491 7.31225C14.8267 7.27347 14.9042 7.2347 14.943 7.15715C15.0206 7.27347 14.9818 7.31225 14.8655 7.35102C14.6716 7.42858 14.4777 7.50613 14.2451 7.58368C14.2063 7.58368 14.1675 7.62245 14.1287 7.62245C14.1287 7.58368 14.09 7.58368 14.09 7.5449C14.2063 7.46735 14.2838 7.3898 14.4389 7.27347C14.3226 7.27347 14.2063 7.27347 14.1675 7.31225C13.9349 7.42858 13.7022 7.5449 13.4695 7.66123C13.3532 7.73878 13.3144 7.81633 13.4308 7.93266C13.2369 7.97143 13.0818 7.97143 12.8879 8.04898C12.7716 8.12653 12.6553 8.24286 12.5002 8.28164C12.4614 8.39796 12.4226 8.47551 12.3838 8.59184H12.3451C12.3451 8.51429 12.3451 8.47551 12.3063 8.39796C12.3063 8.39796 12.3063 8.39796 12.2675 8.39796C12.2675 8.43674 12.2287 8.51429 12.2287 8.55306C12.2675 8.94082 12.0349 9.05715 11.7634 9.17347C11.5695 9.2898 11.3757 9.4449 11.2206 9.6C11.143 9.71633 11.143 9.94898 11.143 10.1041C11.1818 10.298 11.143 10.4918 10.9491 10.6857C10.9104 10.4918 10.8716 10.298 10.794 10.1041C10.7553 10.0265 10.7165 9.91021 10.6777 9.87143C10.4063 9.79388 10.1736 9.75511 9.9022 9.71633C9.9022 9.83266 9.86342 9.91021 9.86342 9.98776C9.82465 9.98776 9.78587 9.98776 9.7471 9.98776C9.43689 9.83266 9.12669 9.91021 8.81648 10.0653C8.66138 10.1429 8.58383 10.298 8.54505 10.4918C8.54505 10.6469 8.42873 10.802 8.38995 10.9959C8.38995 11.151 8.42873 11.3449 8.4675 11.5C8.4675 11.5776 8.50628 11.6163 8.54505 11.6939C8.58383 11.6939 8.66138 11.6939 8.70016 11.6939C8.89403 11.7714 9.20424 11.7327 9.35934 11.5776L9.39811 11.5388C9.35934 11.151 9.70832 11.3061 9.86342 11.2286C9.9022 11.2286 9.97975 11.1898 10.0573 11.1898C9.86342 11.5388 9.70832 11.849 9.55322 12.198C9.66954 12.198 9.82465 12.2367 9.97975 12.2367C10.2512 12.198 10.2512 12.198 10.4451 12.3143C10.4063 12.5082 10.3287 12.702 10.3287 12.8959C10.29 13.2061 10.6002 13.3612 10.8328 13.2449C11.0655 13.1286 11.143 13.1674 11.2981 13.4388C11.492 13.051 11.8022 12.8959 12.1124 12.7796C12.1124 12.9347 12.1124 13.051 12.0736 13.1674C12.19 13.0123 12.2675 12.8571 12.3838 12.7408C12.5389 12.8571 12.6165 13.051 12.8491 13.051C13.043 13.0123 13.2369 13.051 13.392 13.051C13.5471 13.2061 13.7022 13.3225 13.8185 13.4388C13.8961 13.5163 13.9736 13.5551 14.0124 13.6327C14.1287 13.7878 14.2451 13.9041 14.4389 13.8653C14.7491 13.8265 15.0206 13.9429 15.1369 14.2143C15.2144 14.3694 15.4471 14.4857 15.3308 14.7184C15.3308 14.7184 15.3695 14.7572 15.4083 14.7959C15.4471 14.8735 15.4859 14.951 15.5634 15.0286C15.8349 14.8347 16.0287 14.8735 16.1838 15.1837C16.494 15.2225 16.7655 15.2612 17.0369 15.3388C17.4634 15.4551 17.7349 15.8816 17.6573 16.2694C17.6573 16.3469 17.5798 16.4245 17.541 16.5021C17.4247 16.6572 17.2695 16.851 17.1532 17.0061C17.1144 17.0449 17.1144 17.1225 17.1144 17.2C17.192 17.6653 16.9981 18.0918 16.843 18.5184C16.843 18.5572 16.8042 18.5959 16.7655 18.5959C16.5716 18.6735 16.3777 18.751 16.1838 18.7898C15.9512 18.8674 15.8349 18.9837 15.8349 19.1776C15.8736 19.449 15.8349 19.7204 15.6022 19.8755C15.5634 19.9143 15.4859 19.9143 15.4859 19.9531C15.4471 20.0306 15.4471 20.1469 15.4083 20.2245C19.0532 18.9449 21.6512 15.4551 21.6512 11.3837C21.6512 6.18776 17.4247 2 12.2675 2C10.4063 2 8.66138 2.54286 7.22668 3.47347C7.30424 3.47347 7.34301 3.47347 7.42056 3.51225C7.69199 3.70612 7.84709 3.7449 8.04097 3.7449Z",
    fill: "currentColor"
  })));
};
const planet_ForwardRef = /*#__PURE__*/(0,react.forwardRef)(SvgPlanet);

/* harmony default export */ const planet = (__webpack_require__.p + "9aa8c412a63e3fb289beb945c4b95ab0.svg");
;// CONCATENATED MODULE: ./src/assets/icons/arrow_down.svg
var arrow_down_path;
function arrow_down_extends() { arrow_down_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return arrow_down_extends.apply(this, arguments); }


const SvgArrowDown = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/react.createElement("svg", arrow_down_extends({
    width: 12,
    height: 8,
    viewBox: "0 0 12 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/react.createElement("title", {
    id: titleId
  }, title) : null, arrow_down_path || (arrow_down_path = /*#__PURE__*/react.createElement("path", {
    opacity: 0.54,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.6 0.600098L6 5.2001L1.4 0.600098L0 2.0001L6 8.0001L12 2.0001L10.6 0.600098Z",
    fill: "currentColor"
  })));
};
const arrow_down_ForwardRef = /*#__PURE__*/(0,react.forwardRef)(SvgArrowDown);

/* harmony default export */ const arrow_down = (__webpack_require__.p + "a7449974996d2e8265dce00c160395bd.svg");
;// CONCATENATED MODULE: ./src/assets/icons/settings.svg
var settings_path, settings_path2;
function settings_extends() { settings_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return settings_extends.apply(this, arguments); }


const SvgSettings = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", settings_extends({
    width: 20,
    height: 24,
    viewBox: "0 0 20 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, settings_path || (settings_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.00204 18.15C8.14318 18.15 7.31948 17.8181 6.71217 17.2274C6.10486 16.6366 5.76368 15.8354 5.76368 15C5.76368 14.1646 6.10486 13.3634 6.71217 12.7726C7.31948 12.1819 8.14318 11.85 9.00204 11.85C9.86091 11.85 10.6846 12.1819 11.2919 12.7726C11.8992 13.3634 12.2404 14.1646 12.2404 15C12.2404 15.8354 11.8992 16.6366 11.2919 17.2274C10.6846 17.8181 9.86091 18.15 9.00204 18.15V18.15ZM15.8766 15.873C15.9136 15.585 15.9414 15.297 15.9414 15C15.9414 14.703 15.9136 14.406 15.8766 14.1L17.8289 12.633C18.0047 12.498 18.051 12.255 17.9399 12.057L16.0894 8.943C15.9784 8.745 15.7286 8.664 15.525 8.745L13.2212 9.645C12.74 9.294 12.2404 8.988 11.6575 8.763L11.3152 6.378C11.2782 6.162 11.0839 6 10.8525 6H7.15155C6.92024 6 6.72593 6.162 6.68892 6.378L6.34658 8.763C5.76368 8.988 5.26404 9.294 4.78291 9.645L2.47905 8.745C2.27549 8.664 2.02567 8.745 1.91464 8.943L0.0641489 12.057C-0.0561333 12.255 -0.000618345 12.498 0.175179 12.633L2.12745 14.1C2.09044 14.406 2.06268 14.703 2.06268 15C2.06268 15.297 2.09044 15.585 2.12745 15.873L0.175179 17.367C-0.000618345 17.502 -0.0561333 17.745 0.0641489 17.943L1.91464 21.057C2.02567 21.255 2.27549 21.327 2.47905 21.255L4.78291 20.346C5.26404 20.706 5.76368 21.012 6.34658 21.237L6.68892 23.622C6.72593 23.838 6.92024 24 7.15155 24H10.8525C11.0839 24 11.2782 23.838 11.3152 23.622L11.6575 21.237C12.2404 21.003 12.74 20.706 13.2212 20.346L15.525 21.255C15.7286 21.327 15.9784 21.255 16.0894 21.057L17.9399 17.943C18.051 17.745 18.0047 17.502 17.8289 17.367L15.8766 15.873Z",
    fill: "currentColor"
  })), settings_path2 || (settings_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5014 8.1C12.9288 8.1 12.3797 7.87875 11.9748 7.48492C11.5699 7.0911 11.3425 6.55695 11.3425 6C11.3425 5.44305 11.5699 4.9089 11.9748 4.51508C12.3797 4.12125 12.9288 3.9 13.5014 3.9C14.0739 3.9 14.6231 4.12125 15.0279 4.51508C15.4328 4.9089 15.6603 5.44305 15.6603 6C15.6603 6.55695 15.4328 7.0911 15.0279 7.48492C14.6231 7.87875 14.0739 8.1 13.5014 8.1V8.1ZM18.0844 6.582C18.1091 6.39 18.1276 6.198 18.1276 6C18.1276 5.802 18.1091 5.604 18.0844 5.4L19.3859 4.422C19.5031 4.332 19.534 4.17 19.46 4.038L18.2263 1.962C18.1523 1.83 17.9857 1.776 17.85 1.83L16.3141 2.43C15.9934 2.196 15.6603 1.992 15.2717 1.842L15.0434 0.252C15.0188 0.108 14.8892 0 14.735 0H12.2677C12.1135 0 11.984 0.108 11.9593 0.252L11.7311 1.842C11.3425 1.992 11.0094 2.196 10.6886 2.43L9.1527 1.83C9.01699 1.776 8.85045 1.83 8.77643 1.962L7.54277 4.038C7.46258 4.17 7.49959 4.332 7.61679 4.422L8.9183 5.4C8.89363 5.604 8.87512 5.802 8.87512 6C8.87512 6.198 8.89363 6.39 8.9183 6.582L7.61679 7.578C7.49959 7.668 7.46258 7.83 7.54277 7.962L8.77643 10.038C8.85045 10.17 9.01699 10.218 9.1527 10.17L10.6886 9.564C11.0094 9.804 11.3425 10.008 11.7311 10.158L11.9593 11.748C11.984 11.892 12.1135 12 12.2677 12H14.735C14.8892 12 15.0188 11.892 15.0434 11.748L15.2717 10.158C15.6603 10.002 15.9934 9.804 16.3141 9.564L17.85 10.17C17.9857 10.218 18.1523 10.17 18.2263 10.038L19.46 7.962C19.534 7.83 19.5031 7.668 19.3859 7.578L18.0844 6.582Z",
    fill: "currentColor"
  })));
};
const settings_ForwardRef = /*#__PURE__*/(/* unused pure expression or super */ null && (forwardRef(SvgSettings)));

/* harmony default export */ const settings = (__webpack_require__.p + "509c6965976b5e98c2e09c97f0050b17.svg");
;// CONCATENATED MODULE: ./src/assets/icons/installer.svg
var installer_path, installer_path2, installer_path3, installer_path4;
function installer_extends() { installer_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return installer_extends.apply(this, arguments); }


const SvgInstaller = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/react.createElement("svg", installer_extends({
    width: 24,
    height: 20,
    viewBox: "0 0 24 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/react.createElement("title", {
    id: titleId
  }, title) : null, installer_path || (installer_path = /*#__PURE__*/react.createElement("path", {
    d: "M12.5713 4.57144H23.9999V18.4286C23.9999 18.9809 23.5521 19.4286 22.9999 19.4286H12.5713V4.57144Z",
    fill: "currentColor"
  })), installer_path2 || (installer_path2 = /*#__PURE__*/react.createElement("path", {
    d: "M0 4.57144H11.4286V19.4286H1C0.447716 19.4286 0 18.9809 0 18.4286V4.57144Z",
    fill: "currentColor"
  })), installer_path3 || (installer_path3 = /*#__PURE__*/react.createElement("path", {
    d: "M0 0.999999C0 0.447715 0.447715 0 1 0H10.4286C10.9809 0 11.4286 0.447715 11.4286 1V3.42857H0V0.999999Z",
    fill: "currentColor"
  })), installer_path4 || (installer_path4 = /*#__PURE__*/react.createElement("path", {
    d: "M12.5713 0.999999C12.5713 0.447715 13.019 0 13.5713 0H22.9999C23.5521 0 23.9999 0.447715 23.9999 1V3.42857H12.5713V0.999999Z",
    fill: "currentColor"
  })));
};
const installer_ForwardRef = /*#__PURE__*/(0,react.forwardRef)(SvgInstaller);

/* harmony default export */ const installer = (__webpack_require__.p + "ac27193b12206d01cc8af0939a24cab6.svg");
;// CONCATENATED MODULE: ./src/assets/icons/installer_open.svg
var installer_open_path;
function installer_open_extends() { installer_open_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return installer_open_extends.apply(this, arguments); }


const SvgInstallerOpen = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/react.createElement("svg", installer_open_extends({
    width: 24,
    height: 20,
    viewBox: "0 0 24 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/react.createElement("title", {
    id: titleId
  }, title) : null, installer_open_path || (installer_open_path = /*#__PURE__*/react.createElement("path", {
    d: "M23.9548 5.55724C23.9192 5.65494 23.8644 5.73711 23.7967 5.79453C23.729 5.85196 23.651 5.88237 23.5714 5.88235H14.5714C14.5049 5.88243 14.4392 5.8612 14.3797 5.82036C14.3202 5.77951 14.2684 5.72017 14.2286 5.64706L12 1.56853L9.77142 5.64706C9.73153 5.72017 9.67978 5.77951 9.62026 5.82036C9.56074 5.8612 9.4951 5.88243 9.42856 5.88235H0.428571C0.34898 5.88235 0.270962 5.85193 0.203258 5.7945C0.135554 5.73707 0.0808396 5.65489 0.0452456 5.55718C0.00965152 5.45947 -0.00541577 5.35009 0.00173193 5.24129C0.00887962 5.13249 0.0379598 5.02857 0.0857143 4.94118L2.65714 0.235294C2.69702 0.16218 2.74878 0.102842 2.80829 0.0619958C2.86781 0.0211498 2.93345 -7.757e-05 3 2.12994e-07H21C21.0665 -7.757e-05 21.1322 0.0211498 21.1917 0.0619958C21.2512 0.102842 21.3029 0.16218 21.3428 0.235294L23.9143 4.94118C23.962 5.02857 23.9911 5.1325 23.9983 5.24131C24.0054 5.35012 23.9904 5.45952 23.9548 5.55724ZM9.42856 7.05882H2.57143V19.4118C2.57143 19.5678 2.61658 19.7174 2.69695 19.8277C2.77732 19.938 2.88633 20 3 20H11.5714V4.31365L10.4571 6.35294C10.3371 6.57171 10.1817 6.74931 10.0033 6.87178C9.82481 6.99426 9.62809 7.05828 9.42856 7.05882ZM13.5428 6.35294L12.4286 4.31365V20H21C21.1136 20 21.2226 19.938 21.303 19.8277C21.3834 19.7174 21.4285 19.5678 21.4285 19.4118V7.05882H14.5714C14.3719 7.05828 14.1752 6.99426 13.9967 6.87178C13.8182 6.74931 13.6629 6.57171 13.5428 6.35294Z",
    fill: "currentColor"
  })));
};
const installer_open_ForwardRef = /*#__PURE__*/(0,react.forwardRef)(SvgInstallerOpen);

/* harmony default export */ const installer_open = (__webpack_require__.p + "e82c75b4ca3e42081a2b9481277a16fa.svg");
;// CONCATENATED MODULE: ./src/assets/icons/action_history.svg
var action_history_path, action_history_path2;
function action_history_extends() { action_history_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return action_history_extends.apply(this, arguments); }


const SvgActionHistory = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/react.createElement("svg", action_history_extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/react.createElement("title", {
    id: titleId
  }, title) : null, action_history_path || (action_history_path = /*#__PURE__*/react.createElement("path", {
    d: "M7.88679 2.36914C7.88679 7.27249 7.88679 12.1784 7.88679 17.0842C7.88679 18.0553 7.60819 19.2584 6.87073 20H18.9051C20.3664 20 21 18.1839 21 17.0842V2.36914H7.88679ZM9.95443 14.9655C9.55838 14.9655 9.55838 14.4106 9.95443 14.4106H18.2414C18.6374 14.4106 18.6374 14.9655 18.2414 14.9655H9.95443ZM9.95443 11.8454C9.55838 11.8454 9.55838 11.288 9.95443 11.288H16.6736C17.0696 11.288 17.0696 11.8454 16.6736 11.8454H9.95443ZM9.95443 8.72281C9.55838 8.72281 9.55838 8.1679 9.95443 8.1679H18.2414C18.6374 8.1679 18.6374 8.72281 18.2414 8.72281H9.95443ZM9.95443 5.60273C9.55838 5.60273 9.55838 5.0453 9.95443 5.0453H15.0621C15.4581 5.0453 15.4581 5.60273 15.0621 5.60273H9.95443Z",
    fill: "currentColor"
  })), action_history_path2 || (action_history_path2 = /*#__PURE__*/react.createElement("path", {
    d: "M4 5.8418V17.0837C4 17.9186 4.41517 19.9894 5.63608 19.9995C6.87885 19.9995 7.28582 17.9211 7.28582 17.0837V5.8418H4Z",
    fill: "currentColor"
  })));
};
const action_history_ForwardRef = /*#__PURE__*/(0,react.forwardRef)(SvgActionHistory);

/* harmony default export */ const action_history = (__webpack_require__.p + "06600116d0943a031704b4403926c4a8.svg");
;// CONCATENATED MODULE: ./src/assets/icons/google.svg
var _g;
function google_extends() { google_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return google_extends.apply(this, arguments); }


const SvgGoogle = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/react.createElement("svg", google_extends({
    width: "118px",
    height: "120px",
    viewBox: "0 0 118 120",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/react.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/react.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/react.createElement("g", {
    id: "Artboard-1",
    transform: "translate(-332.000000, -639.000000)"
  }, /*#__PURE__*/react.createElement("g", {
    id: "google_buttn",
    transform: "translate(332.000000, 639.000000)"
  }, /*#__PURE__*/react.createElement("g", {
    id: "logo_googleg_48dp"
  }, /*#__PURE__*/react.createElement("path", {
    d: "M117.6,61.3636364 C117.6,57.1090909 117.218182,53.0181818 116.509091,49.0909091 L60,49.0909091 L60,72.3 L92.2909091,72.3 C90.9,79.8 86.6727273,86.1545455 80.3181818,90.4090909 L80.3181818,105.463636 L99.7090909,105.463636 C111.054545,95.0181818 117.6,79.6363636 117.6,61.3636364 L117.6,61.3636364 Z",
    id: "Shape",
    fill: "#4285F4"
  }), /*#__PURE__*/react.createElement("path", {
    d: "M60,120 C76.2,120 89.7818182,114.627273 99.7090909,105.463636 L80.3181818,90.4090909 C74.9454545,94.0090909 68.0727273,96.1363636 60,96.1363636 C44.3727273,96.1363636 31.1454545,85.5818182 26.4272727,71.4 L6.38181818,71.4 L6.38181818,86.9454545 C16.2545455,106.554545 36.5454545,120 60,120 L60,120 Z",
    id: "Shape",
    fill: "#34A853"
  }), /*#__PURE__*/react.createElement("path", {
    d: "M26.4272727,71.4 C25.2272727,67.8 24.5454545,63.9545455 24.5454545,60 C24.5454545,56.0454545 25.2272727,52.2 26.4272727,48.6 L26.4272727,33.0545455 L6.38181818,33.0545455 C2.31818182,41.1545455 0,50.3181818 0,60 C0,69.6818182 2.31818182,78.8454545 6.38181818,86.9454545 L26.4272727,71.4 L26.4272727,71.4 Z",
    id: "Shape",
    fill: "#FBBC05"
  }), /*#__PURE__*/react.createElement("path", {
    d: "M60,23.8636364 C68.8090909,23.8636364 76.7181818,26.8909091 82.9363636,32.8363636 L100.145455,15.6272727 C89.7545455,5.94545455 76.1727273,0 60,0 C36.5454545,0 16.2545455,13.4454545 6.38181818,33.0545455 L26.4272727,48.6 C31.1454545,34.4181818 44.3727273,23.8636364 60,23.8636364 L60,23.8636364 Z",
    id: "Shape",
    fill: "#EA4335"
  }), /*#__PURE__*/react.createElement("path", {
    d: "M0,0 L120,0 L120,120 L0,120 L0,0 Z",
    id: "Shape"
  })))))));
};
const google_ForwardRef = /*#__PURE__*/(0,react.forwardRef)(SvgGoogle);

/* harmony default export */ const google = (__webpack_require__.p + "340144d67488cbdf293c45b8e9db3e60.svg");
;// CONCATENATED MODULE: ./src/assets/icons/cmd.svg
var cmd_path;
function cmd_extends() { cmd_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return cmd_extends.apply(this, arguments); }


const SvgCmd = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/react.createElement("svg", cmd_extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/react.createElement("title", {
    id: titleId
  }, title) : null, cmd_path || (cmd_path = /*#__PURE__*/react.createElement("path", {
    d: "M22.6957 0H1.30435C0.958417 0 0.626651 0.137423 0.382037 0.382037C0.137423 0.626651 0 0.958417 0 1.30435V22.6957C0 23.0416 0.137423 23.3735 0.382037 23.6181C0.626651 23.8628 0.958417 24.0001 1.30435 24.0001H22.6957C23.0416 24.0001 23.3735 23.8628 23.6181 23.6181C23.8628 23.3735 24.0001 23.0416 24.0001 22.6957V1.30435C24.0001 0.958417 23.8628 0.626651 23.6181 0.382037C23.3735 0.137423 23.0416 0 22.6957 0ZM5.47828 16.6305L8.90222 13.174L5.47828 9.75005L7.33698 7.89134L11.674 12.2609C11.7972 12.3823 11.8951 12.527 11.9619 12.6865C12.0287 12.8461 12.0631 13.0173 12.0631 13.1903C12.0631 13.3632 12.0287 13.5345 11.9619 13.694C11.8951 13.8536 11.7972 13.9983 11.674 14.1196L7.30437 18.4566L5.47828 16.6305ZM16.6957 18.4892H11.5761V15.8805H16.663L16.6957 18.4892Z",
    fill: "currentColor"
  })));
};
const cmd_ForwardRef = /*#__PURE__*/(0,react.forwardRef)(SvgCmd);

/* harmony default export */ const cmd = (__webpack_require__.p + "f563795d93a1fb91644d625bed46810f.svg");
;// CONCATENATED MODULE: ./src/assets/icons/collapse.svg
var collapse_path;
function collapse_extends() { collapse_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return collapse_extends.apply(this, arguments); }


const SvgCollapse = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/react.createElement("svg", collapse_extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/react.createElement("title", {
    id: titleId
  }, title) : null, collapse_path || (collapse_path = /*#__PURE__*/react.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.1681 17.9315C11.1681 18.1988 10.845 18.3326 10.656 18.1436L8.84446 16.3321L6.38852 18.7881C6.27136 18.9052 6.08141 18.9052 5.96425 18.7881L5.21213 18.036C5.09497 17.9188 5.09497 17.7289 5.21213 17.6117L7.66808 15.1557L5.85656 13.3442C5.66757 13.1552 5.80142 12.8321 6.06869 12.8321H10.8681C11.0338 12.8321 11.1681 12.9664 11.1681 13.1321V17.9315ZM17.6116 5.21213C17.7288 5.09497 17.9187 5.09497 18.0359 5.21213L18.788 5.96425C18.9052 6.08141 18.9052 6.27136 18.788 6.38852L16.332 8.84446L18.1436 10.656C18.3326 10.845 18.1987 11.1681 17.9314 11.1681H13.132C12.9663 11.1681 12.832 11.0338 12.832 10.8681V6.06869C12.832 5.80142 13.1552 5.66757 13.3441 5.85656L15.1557 7.66808L17.6116 5.21213Z",
    fill: "currentColor"
  })));
};
const collapse_ForwardRef = /*#__PURE__*/(0,react.forwardRef)(SvgCollapse);

/* harmony default export */ const collapse = (__webpack_require__.p + "44c86f66a578a40a69a43f13f5e92851.svg");
;// CONCATENATED MODULE: ./src/assets/icons/folder_settings.svg
var folder_settings_path, folder_settings_path2, folder_settings_path3;
function folder_settings_extends() { folder_settings_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return folder_settings_extends.apply(this, arguments); }


const SvgFolderSettings = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", folder_settings_extends({
    width: 24,
    height: 21,
    viewBox: "0 0 24 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, folder_settings_path || (folder_settings_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.565 5.45995L18.06 5.46996V5.44493V3.96496C18.06 3.14489 17.3899 2.47497 16.5699 2.47497H7.73997C7.60496 2.47497 7.47996 2.41992 7.38496 2.32495L5.56996 0.44995C5.28997 0.164917 4.89998 0 4.49999 0H1.48999C0.669981 0 0 0.66992 0 1.48999V5.44493H13.81C15.31 5.44493 16.6299 5.44994 17.565 5.45995Z",
    fill: "currentColor"
  })), folder_settings_path2 || (folder_settings_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.1199 14.9698V13.73C10.1199 12.8306 10.7449 12.0743 11.5833 11.8726C11.137 11.1329 11.2314 10.1592 11.863 9.52789L12.738 8.65289C13.0884 8.3023 13.5813 8.10113 14.0901 8.10113C14.4426 8.10113 14.7873 8.19781 15.0828 8.37359C15.2842 7.53521 16.0405 6.91022 16.9399 6.91022H18.06V6.51495H0.504973H0V15.8149C0 16.6348 0.669981 17.3048 1.48999 17.3048H11.3707C11.4178 17.1366 11.4879 16.9757 11.5796 16.8262C10.7429 16.6231 10.1199 15.8677 10.1199 14.9698Z",
    fill: "currentColor"
  })), folder_settings_path3 || (folder_settings_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M23.09 12.8199H22.425C22.335 12.535 22.22 12.2599 22.08 11.995L22.55 11.525C22.905 11.1649 22.905 10.59 22.55 10.235L21.675 9.35998C21.335 9.01501 20.73 9.01501 20.385 9.35998L19.915 9.82995C19.65 9.68994 19.375 9.57495 19.09 9.48498V8.81994C19.09 8.31995 18.68 7.91003 18.18 7.91003H16.94C16.44 7.91003 16.03 8.31995 16.03 8.81994V9.48498C15.745 9.57495 15.47 9.68994 15.205 9.82995L14.735 9.35998C14.39 9.01501 13.79 9.01501 13.445 9.35998L12.57 10.235C12.215 10.59 12.215 11.1649 12.57 11.525L13.04 11.995C12.9 12.2599 12.785 12.535 12.7 12.8199H12.03C11.53 12.8199 11.12 13.23 11.12 13.73V14.97C11.12 15.47 11.53 15.88 12.03 15.88H12.7C12.785 16.1649 12.9 16.4399 13.04 16.7049L12.57 17.1749C12.395 17.35 12.3 17.5799 12.3 17.8199C12.3 18.0649 12.395 18.2949 12.57 18.4649L13.445 19.3399C13.785 19.6849 14.39 19.6849 14.735 19.3399L15.205 18.87C15.47 19.0099 15.745 19.125 16.03 19.2099V19.88C16.03 20.38 16.44 20.7899 16.94 20.7899H18.18C18.68 20.7899 19.09 20.38 19.09 19.88V19.2099C19.375 19.125 19.65 19.0099 19.915 18.87L20.39 19.3399C20.73 19.6849 21.335 19.6849 21.68 19.3399L22.55 18.4649C22.905 18.11 22.905 17.5299 22.55 17.1749L22.08 16.7049C22.22 16.4399 22.335 16.1649 22.425 15.88H23.09C23.59 15.88 24 15.47 24 14.97V13.73C24 13.23 23.59 12.8199 23.09 12.8199ZM17.56 17.3299C15.92 17.3299 14.58 15.99 14.58 14.35C14.58 12.7099 15.92 11.37 17.56 11.37C19.205 11.37 20.54 12.7099 20.54 14.35C20.54 15.99 19.205 17.3299 17.56 17.3299Z",
    fill: "currentColor"
  })));
};
const folder_settings_ForwardRef = /*#__PURE__*/(/* unused pure expression or super */ null && (forwardRef(SvgFolderSettings)));

/* harmony default export */ const folder_settings = (__webpack_require__.p + "13f415df1a5aca5ed869705f7112596a.svg");
;// CONCATENATED MODULE: ./src/assets/icons/sort_asc.svg
var sort_asc_g, _defs;
function sort_asc_extends() { sort_asc_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return sort_asc_extends.apply(this, arguments); }


const SvgSortAsc = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/react.createElement("svg", sort_asc_extends({
    width: 19,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/react.createElement("title", {
    id: titleId
  }, title) : null, sort_asc_g || (sort_asc_g = /*#__PURE__*/react.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/react.createElement("path", {
    d: "M0 5.94261H2.39685V15.8469H6.31899V5.94261H8.71584L4.35792 0L0 5.94261Z",
    fill: "currentColor"
  }), /*#__PURE__*/react.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.9577 16.8142H18.3546L13.9966 22.7569L9.63867 16.8142H12.0355V6.90991H15.9577V16.8142Z",
    fill: "#BABABA"
  }))), _defs || (_defs = /*#__PURE__*/react.createElement("defs", null, /*#__PURE__*/react.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/react.createElement("rect", {
    width: 18.3529,
    height: 24,
    fill: "white"
  })))));
};
const sort_asc_ForwardRef = /*#__PURE__*/(0,react.forwardRef)(SvgSortAsc);

/* harmony default export */ const sort_asc = (__webpack_require__.p + "4d881408500de31b63f795c9336bf83b.svg");
;// CONCATENATED MODULE: ./src/assets/icons/sort_desc.svg
var sort_desc_g, sort_desc_defs;
function sort_desc_extends() { sort_desc_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return sort_desc_extends.apply(this, arguments); }


const SvgSortDesc = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/react.createElement("svg", sort_desc_extends({
    width: 19,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/react.createElement("title", {
    id: titleId
  }, title) : null, sort_desc_g || (sort_desc_g = /*#__PURE__*/react.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/react.createElement("path", {
    d: "M0 5.94261H2.39685V15.8469H6.31899V5.94261H8.71584L4.35792 0L0 5.94261Z",
    fill: "#BABABA"
  }), /*#__PURE__*/react.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.9577 16.8142H18.3546L13.9966 22.7569L9.63867 16.8142H12.0355V6.90991H15.9577V16.8142Z",
    fill: "currentColor"
  }))), sort_desc_defs || (sort_desc_defs = /*#__PURE__*/react.createElement("defs", null, /*#__PURE__*/react.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/react.createElement("rect", {
    width: 18.3529,
    height: 24,
    fill: "white"
  })))));
};
const sort_desc_ForwardRef = /*#__PURE__*/(0,react.forwardRef)(SvgSortDesc);

/* harmony default export */ const sort_desc = (__webpack_require__.p + "973b2ae271754ce9738612c148924626.svg");
;// CONCATENATED MODULE: ./src/assets/icons/sort.svg
var sort_g, sort_defs;
function sort_extends() { sort_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return sort_extends.apply(this, arguments); }


const SvgSort = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/react.createElement("svg", sort_extends({
    width: 19,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/react.createElement("title", {
    id: titleId
  }, title) : null, sort_g || (sort_g = /*#__PURE__*/react.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/react.createElement("path", {
    d: "M0 5.94261H2.39685V15.8469H6.31899V5.94261H8.71584L4.35792 0L0 5.94261Z",
    fill: "currentColor"
  }), /*#__PURE__*/react.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.9577 16.8142H18.3546L13.9966 22.7569L9.63867 16.8142H12.0355V6.90991H15.9577V16.8142Z",
    fill: "currentColor"
  }))), sort_defs || (sort_defs = /*#__PURE__*/react.createElement("defs", null, /*#__PURE__*/react.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/react.createElement("rect", {
    width: 18.3529,
    height: 24,
    fill: "white"
  })))));
};
const sort_ForwardRef = /*#__PURE__*/(0,react.forwardRef)(SvgSort);

/* harmony default export */ const sort = (__webpack_require__.p + "e20b899f14632cbb12eab48119575ed1.svg");
;// CONCATENATED MODULE: ./src/assets/icons/export_action.svg
var export_action_path;
function export_action_extends() { export_action_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return export_action_extends.apply(this, arguments); }


const SvgExportAction = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", export_action_extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, export_action_path || (export_action_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12C21 16.9706 16.9706 21 12 21ZM12.5154 7.41976C12.2248 7.12546 11.7538 7.12665 11.4618 7.42395L7.98629 10.9629C7.42162 11.5288 8.26832 12.3773 8.83299 11.8114L11.1911 9.44639C11.3071 9.32997 11.4012 9.37085 11.4012 9.53594V16.061C11.4012 16.3932 11.667 16.6624 12 16.6624C12.3308 16.6624 12.5988 16.3937 12.5988 16.061V9.53594C12.5988 9.37007 12.6933 9.33033 12.809 9.44639L15.1671 11.8114C15.7315 12.3773 16.5785 11.5288 16.0138 10.9629L12.5154 7.41976Z",
    fill: "currentColor"
  })));
};
const export_action_ForwardRef = /*#__PURE__*/(/* unused pure expression or super */ null && (forwardRef(SvgExportAction)));

/* harmony default export */ const export_action = (__webpack_require__.p + "c9d195d2499960acb698a97e41387d50.svg");
;// CONCATENATED MODULE: ./src/assets/icons/content_icon.svg
var content_icon_path;
function content_icon_extends() { content_icon_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return content_icon_extends.apply(this, arguments); }


const SvgContentIcon = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/react.createElement("svg", content_icon_extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/react.createElement("title", {
    id: titleId
  }, title) : null, content_icon_path || (content_icon_path = /*#__PURE__*/react.createElement("path", {
    d: "M20.8833 5.71667H15.95V3.86667C15.95 3.70312 15.885 3.54626 15.7694 3.43062C15.6537 3.31497 15.4969 3.25 15.3333 3.25H3.61667C3.45312 3.25 3.29626 3.31497 3.18062 3.43062C3.06497 3.54626 3 3.70312 3 3.86667V18.6667C3 18.8302 3.06497 18.9871 3.18062 19.1027C3.29626 19.2184 3.45312 19.2833 3.61667 19.2833H8.55V21.1333C8.55 21.2969 8.61497 21.4537 8.73062 21.5694C8.84627 21.685 9.00312 21.75 9.16667 21.75H20.8833C21.0469 21.75 21.2037 21.685 21.3194 21.5694C21.435 21.4537 21.5 21.2969 21.5 21.1333V6.33333C21.5 6.16978 21.435 6.01293 21.3194 5.89728C21.2037 5.78164 21.0469 5.71667 20.8833 5.71667ZM6.08333 5.71667H12.8667C13.0302 5.71667 13.1871 5.78164 13.3027 5.89728C13.4184 6.01293 13.4833 6.16978 13.4833 6.33333C13.4833 6.49688 13.4184 6.65373 13.3027 6.76938C13.1871 6.88503 13.0302 6.95 12.8667 6.95H6.08333C5.91978 6.95 5.76293 6.88503 5.64728 6.76938C5.53164 6.65373 5.46667 6.49688 5.46667 6.33333C5.46667 6.16978 5.53164 6.01293 5.64728 5.89728C5.76293 5.78164 5.91978 5.71667 6.08333 5.71667ZM6.08333 8.18333H12.8667C13.0302 8.18333 13.1871 8.2483 13.3027 8.36395C13.4184 8.4796 13.4833 8.63645 13.4833 8.8C13.4833 8.96355 13.4184 9.1204 13.3027 9.23605C13.1871 9.3517 13.0302 9.41667 12.8667 9.41667H6.08333C5.91978 9.41667 5.76293 9.3517 5.64728 9.23605C5.53164 9.1204 5.46667 8.96355 5.46667 8.8C5.46667 8.63645 5.53164 8.4796 5.64728 8.36395C5.76293 8.2483 5.91978 8.18333 6.08333 8.18333ZM6.08333 10.65H12.8667C13.0302 10.65 13.1871 10.715 13.3027 10.8306C13.4184 10.9463 13.4833 11.1031 13.4833 11.2667C13.4833 11.4302 13.4184 11.5871 13.3027 11.7027C13.1871 11.8184 13.0302 11.8833 12.8667 11.8833H6.08333C5.91978 11.8833 5.76293 11.8184 5.64728 11.7027C5.53164 11.5871 5.46667 11.4302 5.46667 11.2667C5.46667 11.1031 5.53164 10.9463 5.64728 10.8306C5.76293 10.715 5.91978 10.65 6.08333 10.65ZM6.08333 13.1167H12.8667C13.0302 13.1167 13.1871 13.1816 13.3027 13.2973C13.4184 13.4129 13.4833 13.5698 13.4833 13.7333C13.4833 13.8969 13.4184 14.0537 13.3027 14.1694C13.1871 14.285 13.0302 14.35 12.8667 14.35H6.08333C5.91978 14.35 5.76293 14.285 5.64728 14.1694C5.53164 14.0537 5.46667 13.8969 5.46667 13.7333C5.46667 13.5698 5.53164 13.4129 5.64728 13.2973C5.76293 13.1816 5.91978 13.1167 6.08333 13.1167ZM6.08333 16.8167C5.91978 16.8167 5.76293 16.7517 5.64728 16.636C5.53164 16.5204 5.46667 16.3636 5.46667 16.2C5.46667 16.0364 5.53164 15.8796 5.64728 15.764C5.76293 15.6483 5.91978 15.5833 6.08333 15.5833H12.8667C13.0302 15.5833 13.1871 15.6483 13.3027 15.764C13.4184 15.8796 13.4833 16.0364 13.4833 16.2C13.4833 16.3636 13.4184 16.5204 13.3027 16.636C13.1871 16.7517 13.0302 16.8167 12.8667 16.8167H6.08333ZM20.2667 20.5167H9.78333V19.2833H15.3333C15.4969 19.2833 15.6537 19.2184 15.7694 19.1027C15.885 18.9871 15.95 18.8302 15.95 18.6667V6.95H20.2667V20.5167Z",
    fill: "currentColor"
  })));
};
const content_icon_ForwardRef = /*#__PURE__*/(0,react.forwardRef)(SvgContentIcon);

/* harmony default export */ const content_icon = (__webpack_require__.p + "eda9c7983924d6660e4e67bfbf830c27.svg");
;// CONCATENATED MODULE: ./src/assets/icons/event_icon.svg
var event_icon_path;
function event_icon_extends() { event_icon_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return event_icon_extends.apply(this, arguments); }


const SvgEventIcon = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/react.createElement("svg", event_icon_extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/react.createElement("title", {
    id: titleId
  }, title) : null, event_icon_path || (event_icon_path = /*#__PURE__*/react.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.1765 22L2.55882 22C2.25019 22 2 21.7498 2 21.4412V10.8235C2 10.5149 2.25019 10.2647 2.55882 10.2647H13.1765C13.4851 10.2647 13.7353 10.5149 13.7353 10.8235L13.7353 21.4412C13.7353 21.7498 13.4851 22 13.1765 22ZM15.4118 7.79794L17.6132 5.59655C17.7223 5.48743 17.8992 5.48743 18.0083 5.59655L18.4035 5.99169C18.5126 6.1008 18.5126 6.27773 18.4035 6.38684L16.2021 8.58823H17.0882C17.2426 8.58823 17.3676 8.71333 17.3676 8.86765V9.42647C17.3676 9.58079 17.2426 9.70588 17.0882 9.70588H14.8529C14.5443 9.70588 14.2941 9.45569 14.2941 9.14706V6.91176C14.2941 6.75745 14.4192 6.63235 14.5735 6.63235H15.1324C15.2867 6.63235 15.4118 6.75745 15.4118 6.91176V7.79794ZM11.5 3C11.8086 3 12.0588 3.25019 12.0588 3.55882C12.0588 3.86745 11.8086 4.11765 11.5 4.11765C11.1914 4.11765 10.9412 3.86745 10.9412 3.55882C10.9412 3.25019 11.1914 3 11.5 3ZM9.26471 3C9.57334 3 9.82353 3.25019 9.82353 3.55882C9.82353 3.86745 9.57334 4.11765 9.26471 4.11765C8.95608 4.11765 8.70588 3.86745 8.70588 3.55882C8.70588 3.25019 8.95608 3 9.26471 3ZM13.7353 3C14.0439 3 14.2941 3.25019 14.2941 3.55882C14.2941 3.86745 14.0439 4.11765 13.7353 4.11765C13.4267 4.11765 13.1765 3.86745 13.1765 3.55882C13.1765 3.25019 13.4267 3 13.7353 3ZM18.2059 3C18.5145 3 18.7647 3.25019 18.7647 3.55882C18.7647 3.86745 18.5145 4.11765 18.2059 4.11765C17.8973 4.11765 17.6471 3.86745 17.6471 3.55882C17.6471 3.25019 17.8973 3 18.2059 3ZM15.9706 3C16.2792 3 16.5294 3.25019 16.5294 3.55882C16.5294 3.86745 16.2792 4.11765 15.9706 4.11765C15.662 4.11765 15.4118 3.86745 15.4118 3.55882C15.4118 3.25019 15.662 3 15.9706 3ZM18.2059 14.1765C18.5145 14.1765 18.7647 14.4267 18.7647 14.7353C18.7647 15.0439 18.5145 15.2941 18.2059 15.2941C17.8973 15.2941 17.6471 15.0439 17.6471 14.7353C17.6471 14.4267 17.8973 14.1765 18.2059 14.1765ZM15.9706 14.1765C16.2792 14.1765 16.5294 14.4267 16.5294 14.7353C16.5294 15.0439 16.2792 15.2941 15.9706 15.2941C15.662 15.2941 15.4118 15.0439 15.4118 14.7353C15.4118 14.4267 15.662 14.1765 15.9706 14.1765ZM20.4412 14.1765C20.7498 14.1765 21 14.4267 21 14.7353C21 15.0439 20.7498 15.2941 20.4412 15.2941C20.1325 15.2941 19.8824 15.0439 19.8824 14.7353C19.8824 14.4267 20.1325 14.1765 20.4412 14.1765ZM20.4412 9.70588C20.7498 9.70588 21 9.95608 21 10.2647C21 10.5733 20.7498 10.8235 20.4412 10.8235C20.1325 10.8235 19.8824 10.5733 19.8824 10.2647C19.8824 9.95608 20.1325 9.70588 20.4412 9.70588ZM20.4412 5.23529C20.7498 5.23529 21 5.48549 21 5.79412C21 6.10275 20.7498 6.35294 20.4412 6.35294C20.1325 6.35294 19.8824 6.10275 19.8824 5.79412C19.8824 5.48549 20.1325 5.23529 20.4412 5.23529ZM20.4412 7.47059C20.7498 7.47059 21 7.72078 21 8.02941C21 8.33804 20.7498 8.58823 20.4412 8.58823C20.1325 8.58823 19.8824 8.33804 19.8824 8.02941C19.8824 7.72078 20.1325 7.47059 20.4412 7.47059ZM9.26471 5.23529C9.57334 5.23529 9.82353 5.48549 9.82353 5.79412C9.82353 6.10275 9.57334 6.35294 9.26471 6.35294C8.95608 6.35294 8.70588 6.10275 8.70588 5.79412C8.70588 5.48549 8.95608 5.23529 9.26471 5.23529ZM9.26471 7.47059C9.57334 7.47059 9.82353 7.72078 9.82353 8.02941C9.82353 8.33804 9.57334 8.58823 9.26471 8.58823C8.95608 8.58823 8.70588 8.33804 8.70588 8.02941C8.70588 7.72078 8.95608 7.47059 9.26471 7.47059ZM20.4412 11.9412C20.7498 11.9412 21 12.1914 21 12.5C21 12.8086 20.7498 13.0588 20.4412 13.0588C20.1325 13.0588 19.8824 12.8086 19.8824 12.5C19.8824 12.1914 20.1325 11.9412 20.4412 11.9412ZM20.4412 3C20.7498 3 21 3.25019 21 3.55882C21 3.86745 20.7498 4.11765 20.4412 4.11765C20.1325 4.11765 19.8824 3.86745 19.8824 3.55882C19.8824 3.25019 20.1325 3 20.4412 3Z",
    fill: "currentColor"
  })));
};
const event_icon_ForwardRef = /*#__PURE__*/(0,react.forwardRef)(SvgEventIcon);

/* harmony default export */ const event_icon = (__webpack_require__.p + "26444f819b2bb62db55c90836d9a88a6.svg");
;// CONCATENATED MODULE: ./src/assets/icons/policy.svg
var policy_path, policy_path2, policy_path3;
function policy_extends() { policy_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return policy_extends.apply(this, arguments); }


const SvgPolicy = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/react.createElement("svg", policy_extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/react.createElement("title", {
    id: titleId
  }, title) : null, policy_path || (policy_path = /*#__PURE__*/react.createElement("path", {
    d: "M20.7087 5.91426C20.7198 5.84307 20.7055 5.77025 20.6684 5.70853C20.6312 5.64682 20.5735 5.60014 20.5054 5.57667C17.8507 4.40527 15.2029 3.22844 12.5618 2.0462C12.5019 2.01583 12.4358 2 12.3686 2C12.3015 2 12.2353 2.01583 12.1754 2.0462C9.51944 3.23522 6.86277 4.41408 4.20543 5.58277C4.14091 5.59994 4.08479 5.63987 4.04741 5.69519C4.01003 5.75051 3.99393 5.81749 4.00206 5.88375C4.02037 7.69373 4.00003 9.50574 4.02037 11.3177C4.02408 11.911 4.07234 12.5031 4.16476 13.0891C4.46169 14.954 5.20704 16.719 6.33673 18.2323C7.78064 20.1785 9.62722 21.5695 11.966 22.2732C12.2187 22.3536 12.4901 22.3536 12.7428 22.2732C14.9028 21.628 16.8011 20.3116 18.1626 18.5149C19.819 16.4352 20.7158 13.8524 20.7047 11.1937C20.7047 10.4107 20.7047 9.62979 20.7047 8.84682C20.6965 7.87066 20.6965 6.89246 20.7087 5.91426ZM19.2852 9.41219C19.2852 10.0609 19.2852 10.7117 19.2852 11.3605C19.2951 13.5668 18.5519 15.7105 17.1783 17.4371C16.0483 18.9303 14.4718 20.0245 12.6777 20.5608C12.468 20.6275 12.2428 20.6275 12.0331 20.5608C10.146 19.9898 8.50116 18.8099 7.3556 17.2052C6.41668 15.9489 5.79695 14.4833 5.54969 12.9345C5.47762 12.4471 5.44227 11.9549 5.44394 11.4621C5.42971 9.95925 5.44394 8.45432 5.44394 6.95143C5.43696 6.89693 5.44974 6.84173 5.47996 6.79584C5.51018 6.74995 5.55584 6.71641 5.60867 6.70129C7.80369 5.72513 10.0014 4.74557 12.2019 3.76262C12.2514 3.7376 12.306 3.72457 12.3615 3.72457C12.417 3.72457 12.4717 3.7376 12.5211 3.76262C14.7175 4.74421 16.9166 5.72174 19.1184 6.69519C19.1762 6.71342 19.2257 6.75173 19.2577 6.80319C19.2898 6.85465 19.3024 6.91589 19.2933 6.97584C19.2852 7.78728 19.2892 8.59872 19.2892 9.41219H19.2852Z",
    fill: "currentColor"
  })), policy_path2 || (policy_path2 = /*#__PURE__*/react.createElement("path", {
    d: "M17.9754 7.61871C16.1464 6.80524 14.3161 5.99177 12.4844 5.17829C12.4445 5.16137 12.4017 5.15239 12.3583 5.15186V12.1681H18.0913C18.1089 11.9471 18.1184 11.7234 18.1198 11.4969C18.1198 10.958 18.1198 10.4171 18.1198 9.86999C18.1198 9.19481 18.1198 8.51963 18.1198 7.83631C18.1251 7.78886 18.1135 7.74106 18.0871 7.70127C18.0607 7.66149 18.0211 7.63226 17.9754 7.61871Z",
    fill: "currentColor"
  })), policy_path3 || (policy_path3 = /*#__PURE__*/react.createElement("path", {
    d: "M6.70293 12.8025C6.90846 14.0895 7.42351 15.3073 8.20379 16.3512C9.15516 17.6841 10.521 18.6644 12.0881 19.1394C12.1756 19.1675 12.2667 19.1826 12.3586 19.1842V12.168H6.62769C6.64395 12.3713 6.66429 12.593 6.70293 12.8025Z",
    fill: "currentColor"
  })));
};
const policy_ForwardRef = /*#__PURE__*/(0,react.forwardRef)(SvgPolicy);

/* harmony default export */ const policy = (__webpack_require__.p + "de01bac5d492bae094c0096abe4047a4.svg");
;// CONCATENATED MODULE: ./src/assets/icons/incident_action_assign.svg
var incident_action_assign_path, incident_action_assign_path2, incident_action_assign_circle, incident_action_assign_path3;
function incident_action_assign_extends() { incident_action_assign_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return incident_action_assign_extends.apply(this, arguments); }


const SvgIncidentActionAssign = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/react.createElement("svg", incident_action_assign_extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/react.createElement("title", {
    id: titleId
  }, title) : null, incident_action_assign_path || (incident_action_assign_path = /*#__PURE__*/react.createElement("path", {
    d: "M13.1759 6.56035C13.1759 4.87526 11.8061 3.5 10.1155 3.5C8.42499 3.5 7.06061 4.87526 7.06061 6.56035C7.06061 8.24545 8.43043 9.6207 10.121 9.6207C11.8115 9.6207 13.1759 8.24545 13.1759 6.56035Z",
    fill: "currentColor"
  })), incident_action_assign_path2 || (incident_action_assign_path2 = /*#__PURE__*/react.createElement("path", {
    d: "M10.1153 9.62061C6.74507 9.62061 4 12.3657 4 15.7359V16.7578H16.2305V15.7359C16.2305 12.3602 13.4855 9.62061 10.1153 9.62061Z",
    fill: "currentColor"
  })), incident_action_assign_circle || (incident_action_assign_circle = /*#__PURE__*/react.createElement("circle", {
    cx: 15.0076,
    cy: 15.6032,
    r: 4.48455,
    fill: "currentColor"
  })), incident_action_assign_path3 || (incident_action_assign_path3 = /*#__PURE__*/react.createElement("path", {
    d: "M14.6369 17.7786L15.654 16.946L17.9922 15.0416L16.9751 14.209L14.6369 16.1134L13.6549 15.3095L12.6378 16.1421L13.6198 16.946L14.6369 17.7786Z",
    fill: "#F7F7F7"
  })));
};
const incident_action_assign_ForwardRef = /*#__PURE__*/(0,react.forwardRef)(SvgIncidentActionAssign);

/* harmony default export */ const incident_action_assign = (__webpack_require__.p + "01e8abf367c39325975a5517fa63a6cc.svg");
;// CONCATENATED MODULE: ./src/assets/icons/incident_action_edit.svg
var incident_action_edit_g, incident_action_edit_defs;
function incident_action_edit_extends() { incident_action_edit_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return incident_action_edit_extends.apply(this, arguments); }


const SvgIncidentActionEdit = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/react.createElement("svg", incident_action_edit_extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/react.createElement("title", {
    id: titleId
  }, title) : null, incident_action_edit_g || (incident_action_edit_g = /*#__PURE__*/react.createElement("g", {
    clipPath: "url(#clip0_2_561)"
  }, /*#__PURE__*/react.createElement("path", {
    d: "M4 16.6671V20H7.33287L17.1626 10.1703L13.8297 6.83738L4 16.6671ZM19.74 7.59283C20.0867 7.24622 20.0867 6.68629 19.74 6.33967L17.6603 4.25996C17.3137 3.91335 16.7538 3.91335 16.4072 4.25996L14.7807 5.8864L18.1136 9.21927L19.74 7.59283Z",
    fill: "currentColor"
  }))), incident_action_edit_defs || (incident_action_edit_defs = /*#__PURE__*/react.createElement("defs", null, /*#__PURE__*/react.createElement("clipPath", {
    id: "clip0_2_561"
  }, /*#__PURE__*/react.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
};
const incident_action_edit_ForwardRef = /*#__PURE__*/(0,react.forwardRef)(SvgIncidentActionEdit);

/* harmony default export */ const incident_action_edit = (__webpack_require__.p + "d8b9999b905eb199ff65f1e4844440f6.svg");
;// CONCATENATED MODULE: ./src/assets/icons/incident_action_ignored.svg
var incident_action_ignored_path;
function incident_action_ignored_extends() { incident_action_ignored_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return incident_action_ignored_extends.apply(this, arguments); }


const SvgIncidentActionIgnored = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/react.createElement("svg", incident_action_ignored_extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/react.createElement("title", {
    id: titleId
  }, title) : null, incident_action_ignored_path || (incident_action_ignored_path = /*#__PURE__*/react.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.8481 19.2V17.0786C18.9144 16.9326 19.7365 16.0562 19.7365 15V6.6C19.7365 5.44204 18.7482 4.5 17.5334 4.5H6.20311C4.98845 4.5 4 5.44204 4 6.6V15C4 16.158 4.98845 17.1 6.20311 17.1H14.8853L17.3109 19.4121C17.3711 19.4695 17.4515 19.5 17.5334 19.5C17.574 19.5 17.6149 19.4925 17.6539 19.4771C17.7715 19.4307 17.8481 19.3213 17.8481 19.2ZM13.529 8L14.6159 9.08695L12.8948 10.808L14.6159 12.5291L13.529 13.6161L11.8079 11.895L10.087 13.6159L9.00002 12.529L10.7209 10.808L9 9.08709L10.087 8.00014L11.8079 9.72109L13.529 8Z",
    fill: "currentColor"
  })));
};
const incident_action_ignored_ForwardRef = /*#__PURE__*/(0,react.forwardRef)(SvgIncidentActionIgnored);

/* harmony default export */ const incident_action_ignored = (__webpack_require__.p + "427d2b87e71ed81f4060dce711b680f3.svg");
;// CONCATENATED MODULE: ./src/assets/icons/incident_action_message.svg
var incident_action_message_path;
function incident_action_message_extends() { incident_action_message_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return incident_action_message_extends.apply(this, arguments); }


const SvgIncidentActionMessage = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/react.createElement("svg", incident_action_message_extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/react.createElement("title", {
    id: titleId
  }, title) : null, incident_action_message_path || (incident_action_message_path = /*#__PURE__*/react.createElement("path", {
    d: "M17.8481 17.0786V19.2C17.8481 19.3213 17.7715 19.4307 17.6539 19.4771C17.6149 19.4925 17.574 19.5 17.5334 19.5C17.4515 19.5 17.3711 19.4695 17.3109 19.4121L14.8853 17.1H6.20311C4.98845 17.1 4 16.158 4 15V6.6C4 5.44204 4.98845 4.5 6.20311 4.5H17.5334C18.7482 4.5 19.7365 5.44204 19.7365 6.6V15C19.7365 16.0562 18.9144 16.9326 17.8481 17.0786Z",
    fill: "currentColor"
  })));
};
const incident_action_message_ForwardRef = /*#__PURE__*/(0,react.forwardRef)(SvgIncidentActionMessage);

/* harmony default export */ const incident_action_message = (__webpack_require__.p + "2af24c15bea2cd09d23a5f09a9ca90d2.svg");
;// CONCATENATED MODULE: ./src/assets/icons/incident_action_comment_deleted.svg
var incident_action_comment_deleted_path;
function incident_action_comment_deleted_extends() { incident_action_comment_deleted_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return incident_action_comment_deleted_extends.apply(this, arguments); }


const SvgIncidentActionCommentDeleted = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/react.createElement("svg", incident_action_comment_deleted_extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/react.createElement("title", {
    id: titleId
  }, title) : null, incident_action_comment_deleted_path || (incident_action_comment_deleted_path = /*#__PURE__*/react.createElement("path", {
    d: "M6 19C6 20.1 6.9 21 8 21H16C17.1 21 18 20.1 18 19V7H6V19ZM19 4H15.5L14.5 3H9.5L8.5 4H5V6H19V4Z",
    fill: "#1F1F1F"
  })));
};
const incident_action_comment_deleted_ForwardRef = /*#__PURE__*/(0,react.forwardRef)(SvgIncidentActionCommentDeleted);

/* harmony default export */ const incident_action_comment_deleted = (__webpack_require__.p + "85ab073f243f570bd2f0462076c02446.svg");
;// CONCATENATED MODULE: ./src/assets/icons/incident_action_resolved.svg
var incident_action_resolved_path;
function incident_action_resolved_extends() { incident_action_resolved_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return incident_action_resolved_extends.apply(this, arguments); }


const SvgIncidentActionResolved = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/react.createElement("svg", incident_action_resolved_extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/react.createElement("title", {
    id: titleId
  }, title) : null, incident_action_resolved_path || (incident_action_resolved_path = /*#__PURE__*/react.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.8481 19.2V17.0786C18.9144 16.9326 19.7365 16.0562 19.7365 15V6.6C19.7365 5.44204 18.7482 4.5 17.5334 4.5H6.20311C4.98845 4.5 4 5.44204 4 6.6V15C4 16.158 4.98845 17.1 6.20311 17.1H14.8853L17.3109 19.4121C17.3711 19.4695 17.4515 19.5 17.5334 19.5C17.574 19.5 17.6149 19.4925 17.6539 19.4771C17.7715 19.4307 17.8481 19.3213 17.8481 19.2ZM12.4432 12.4339L11.1135 13.6001L9.78384 12.4339L8.5 11.3079L9.82969 10.1417L11.1135 11.2677L14.1703 8.6001L15.5 9.76632L12.4432 12.4339Z",
    fill: "currentColor"
  })));
};
const incident_action_resolved_ForwardRef = /*#__PURE__*/(0,react.forwardRef)(SvgIncidentActionResolved);

/* harmony default export */ const incident_action_resolved = (__webpack_require__.p + "0fd3ec553f441ced5f482accf034c266.svg");
;// CONCATENATED MODULE: ./src/assets/icons/incident_action_new.svg
var incident_action_new_path;
function incident_action_new_extends() { incident_action_new_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return incident_action_new_extends.apply(this, arguments); }


const SvgIncidentActionNew = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/react.createElement("svg", incident_action_new_extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/react.createElement("title", {
    id: titleId
  }, title) : null, incident_action_new_path || (incident_action_new_path = /*#__PURE__*/react.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5 6.90909L12 4L19 6.90909V11.2727C19 15.3091 16.0133 19.0836 12 20C7.98667 19.0836 5 15.3091 5 11.2727V6.90909ZM11 12.4706V7.76468H13V12.4706H11ZM11 15.2943V13.412H13V15.2943H11Z",
    fill: "currentColor"
  })));
};
const incident_action_new_ForwardRef = /*#__PURE__*/(0,react.forwardRef)(SvgIncidentActionNew);

/* harmony default export */ const incident_action_new = (__webpack_require__.p + "3a6a6b292d9a09a9a5dd2b70669d9c26.svg");
;// CONCATENATED MODULE: ./src/assets/icons/incident_action_photo.svg
var incident_action_photo_path, incident_action_photo_path2, incident_action_photo_path3;
function incident_action_photo_extends() { incident_action_photo_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return incident_action_photo_extends.apply(this, arguments); }


const SvgIncidentActionPhoto = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/react.createElement("svg", incident_action_photo_extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/react.createElement("title", {
    id: titleId
  }, title) : null, incident_action_photo_path || (incident_action_photo_path = /*#__PURE__*/react.createElement("path", {
    d: "M12.1541 15.6239C13.8308 15.6239 15.1677 14.2644 15.1677 12.6103C15.1677 10.9562 13.8082 9.59668 12.1541 9.59668C10.5 9.59668 9.1405 10.9562 9.1405 12.6103C9.1405 14.2644 10.4774 15.6239 12.1541 15.6239Z",
    fill: "currentColor"
  })), incident_action_photo_path2 || (incident_action_photo_path2 = /*#__PURE__*/react.createElement("path", {
    d: "M3 7.48923V17.4364C3 18.2974 3.70242 18.9998 4.56344 18.9998H19.7674C20.6284 18.9998 21.3308 18.2974 21.3308 17.4364V7.48923C21.3308 6.6282 20.6284 5.92578 19.7674 5.92578H4.56344C3.67976 5.92578 3 6.6282 3 7.48923ZM17.9094 8.37291C18.3852 8.37291 18.7477 8.75811 18.7477 9.21128C18.7477 9.68711 18.3625 10.0496 17.9094 10.0496C17.4562 10.0496 17.071 9.66445 17.071 9.21128C17.0483 8.73545 17.4335 8.37291 17.9094 8.37291ZM12.1541 8.46355C14.4426 8.46355 16.3006 10.3216 16.3006 12.6101C16.3006 14.8986 14.4426 16.7566 12.1541 16.7566C9.86556 16.7566 8.00755 14.8986 8.00755 12.6101C8.00755 10.3216 9.86556 8.46355 12.1541 8.46355Z",
    fill: "currentColor"
  })), incident_action_photo_path3 || (incident_action_photo_path3 = /*#__PURE__*/react.createElement("path", {
    d: "M8.84592 5.13293C9.16314 5.13293 9.41239 4.88369 9.41239 4.56647C9.41239 4.24924 9.14048 4 8.84592 4H6.51208C6.19486 4 5.94562 4.24924 5.94562 4.56647C5.94562 4.88369 6.19486 5.13293 6.51208 5.13293H8.84592Z",
    fill: "currentColor"
  })));
};
const incident_action_photo_ForwardRef = /*#__PURE__*/(0,react.forwardRef)(SvgIncidentActionPhoto);

/* harmony default export */ const incident_action_photo = (__webpack_require__.p + "4092574ebbbe9f87171afc026fa8e90b.svg");
;// CONCATENATED MODULE: ./src/assets/icons/incident_action_user.svg
var incident_action_user_path, incident_action_user_path2, incident_action_user_ellipse, incident_action_user_path3;
function incident_action_user_extends() { incident_action_user_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return incident_action_user_extends.apply(this, arguments); }


const SvgIncidentActionUser = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/react.createElement("svg", incident_action_user_extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/react.createElement("title", {
    id: titleId
  }, title) : null, incident_action_user_path || (incident_action_user_path = /*#__PURE__*/react.createElement("path", {
    d: "M13.3843 6.63641C13.3843 4.90943 12.058 3.5 10.4212 3.5C8.78436 3.5 7.46332 4.90943 7.46332 6.63641C7.46332 8.36339 8.78962 9.77282 10.4264 9.77282C12.0633 9.77282 13.3843 8.36339 13.3843 6.63641Z",
    fill: "currentColor"
  })), incident_action_user_path2 || (incident_action_user_path2 = /*#__PURE__*/react.createElement("path", {
    d: "M10.421 9.77295C7.15787 9.77295 4.5 12.5862 4.5 16.0402V17.0875H16.342V16.0402C16.342 12.5807 13.6841 9.77295 10.421 9.77295Z",
    fill: "currentColor"
  })), incident_action_user_ellipse || (incident_action_user_ellipse = /*#__PURE__*/react.createElement("ellipse", {
    cx: 15.1579,
    cy: 15.9041,
    rx: 4.34207,
    ry: 4.596,
    fill: "currentColor"
  })), incident_action_user_path3 || (incident_action_user_path3 = /*#__PURE__*/react.createElement("path", {
    d: "M14.7989 18.1334L15.7837 17.2801L18.0476 15.3284L17.0628 14.4751L14.7989 16.4269L13.8481 15.603L12.8633 16.4563L13.8141 17.2801L14.7989 18.1334Z",
    fill: "#F7F7F7"
  })));
};
const incident_action_user_ForwardRef = /*#__PURE__*/(0,react.forwardRef)(SvgIncidentActionUser);

/* harmony default export */ const incident_action_user = (__webpack_require__.p + "f1fd80673e6f567ecb6be761fb333114.svg");
;// CONCATENATED MODULE: ./src/assets/icons/america.svg
var america_path;
function america_extends() { america_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return america_extends.apply(this, arguments); }


const SvgAmerica = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/react.createElement("svg", america_extends({
    width: 26,
    height: 38,
    viewBox: "0 0 26 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/react.createElement("title", {
    id: titleId
  }, title) : null, america_path || (america_path = /*#__PURE__*/react.createElement("path", {
    d: "M0.5 2.67969L0.685805 2.61293L0.763418 2.64379L0.712012 2.7005L0.5 2.67969ZM0.886052 2.86558H0.767449L0.710667 2.80216H0.83431L0.906548 2.68003L0.957954 2.73673L0.886052 2.86558ZM16.0381 37.7404H16.1688L16.0713 37.7679L15.9746 37.7981L16.0381 37.7404ZM17.9751 19.9886L18.0893 19.951V20.2006L17.8739 20.2261L17.9751 19.9886ZM16.8985 10.1717L16.7144 10.1275V9.96908L16.7779 9.78522H16.917L16.9106 9.9815L16.9741 9.94359L17.0504 10.007L16.8985 10.1717ZM16.1842 9.78287L16.2195 9.92681L16.321 9.97748L16.5421 9.93755L16.4829 10.0704L16.2511 10.004L16.0992 9.89326L16.1842 9.78287ZM15.9403 9.07692L15.8839 9.05142H16.2101L16.4799 9.22858H16.2131L15.9403 9.07692ZM18.2096 9.22824L18.2731 9.17154L18.2284 9.38024L18.3369 9.29166L18.3877 9.58893L18.2445 9.6547V9.55069L18.1279 9.6547L18.1027 9.58893L18.2096 9.22824ZM13.4043 2.98983L13.4722 3.15759H13.2232L13.0424 3.29415L13.2726 3.36259L13.279 3.23576L13.5219 3.2012L13.7584 3.45621L13.9573 3.41292L14.1126 3.53136L14.4643 3.7424L14.6152 4.04069L14.4606 4.07827L14.5299 4.22121L14.7294 4.33327L15.0641 4.40776L15.1074 4.53827H15.4249L15.3251 4.89863L15.2008 5.13484L14.972 4.89225L14.7291 4.73691L14.6481 4.87346L14.8594 5.1345L15.0768 5.2214L15.1954 5.53847L15.0708 5.66564L14.8594 5.53814L14.6165 5.45124L14.6975 5.61463L14.9955 5.71864L15.0953 5.89983L14.6417 5.83641L14.5238 5.66563H14.2691L14.1257 5.47606L13.8579 5.24622L13.6989 5.27307L13.5837 5.36399L13.3351 5.38278V5.06571L13.615 5.07813L13.7702 5.06571L13.9261 4.97244L13.8075 4.82347L13.9882 4.71777L14.0383 4.55001L13.8639 4.29501L13.5528 4.04001L13.286 3.82259L13.077 4.01552L12.773 3.86017L12.4689 3.87259L12.3211 3.77293L12.1158 3.62999L12.3523 3.58034L12.2902 3.49948H12.1154V3.27601L12.352 2.96532L12.6695 2.89184L12.5287 3.04014L12.4951 3.18308L12.5637 3.36963L12.6695 3.28273L12.6211 3.12671L12.738 2.9962L13.0492 2.95292L13.4043 2.98983ZM14.8362 6.10616C14.9142 6.1169 15.0829 6.15045 15.1474 6.13468C15.0973 6.20111 15.0509 6.4645 15.0261 6.55644C14.975 6.49839 14.9273 6.489 14.8557 6.47356C14.8386 6.3927 14.8504 6.14542 14.8362 6.10617L14.8362 6.10616ZM13.8629 5.56798C13.826 5.57771 13.7904 5.59684 13.7598 5.62469C13.7322 5.62133 13.6368 5.61127 13.6109 5.60288C13.658 5.59751 13.7006 5.5804 13.7332 5.55221L13.7914 5.50591L13.8629 5.56798ZM12.8297 8.31127V8.42535L12.6201 8.31127L12.6456 8.24148L12.8297 8.31127ZM12.5287 5.01946L12.6201 5.14596L12.8297 5.24058L12.773 5.3862L12.8872 5.36069L12.9947 5.39257L12.9379 5.52544L12.7232 5.50665V5.41808L12.5707 5.43049L12.4316 5.53819L12.2414 5.61436L12.2408 5.44995H12.0634L12.1712 5.34862L12.2854 4.93122H12.4376L12.4252 5.05772L12.5287 5.01946ZM12.773 5.72876L12.6208 5.89954L12.4686 5.83613L12.5005 5.70326L12.697 5.66534L12.773 5.72876ZM13.0007 6.01328L13.0327 5.83613L13.1529 5.88679L13.0962 6.01329L13.0007 6.01328ZM13.1822 5.63817L13.1563 5.62709C13.1573 5.62474 13.1583 5.62273 13.1593 5.62038L13.1818 5.56737C13.195 5.57811 13.2087 5.5875 13.2238 5.59522C13.2084 5.60797 13.1943 5.6224 13.1822 5.63817V5.63817ZM13.3354 4.43797L13.5595 4.28899L13.6526 4.36985L13.6996 4.48192L13.5286 4.56278L13.3354 4.43797ZM11.8288 3.14019L11.7203 3.23548L11.6336 3.16636L11.6638 2.97243L11.733 2.80735L11.8889 2.7077L12.019 2.79862H12.1792L12.2182 2.85935L11.9716 3.11469L11.772 3.08886L11.8288 3.14019ZM14.1841 0.91699L14.3749 0.726408L14.4791 0.80425L14.6178 0.726408L14.4965 0.639844H14.6961L14.644 0.449262L14.8094 0.37142L14.7569 0.241574L15.0882 0.0942823H15.1941L15.1487 0.215411L15.2986 0.0942823L15.5583 0.0939468L15.5482 0.215745L15.3778 0.363036L15.5253 0.354313L15.6208 0.319754L15.6809 0.397596L15.6376 0.224467L15.8254 0.336869L15.9121 0.198296L15.8512 0.0939511L15.9621 0L16.1617 0.147292L16.1053 0.372429L16.2397 0.294587L16.3089 0.320422L16.2652 0.450269L16.413 0.502275L16.7426 0.874034L16.8985 0.813304L16.9587 0.917314L17.1146 0.839472L17.2792 0.917314L17.0796 1.07266L17.1919 1.15923L17.3565 1.08138L17.4086 1.15923L17.5816 1.14178L17.5527 1.34947L17.7029 1.37531L17.9115 1.33202L17.7896 1.55716L18.007 1.53971L17.9723 1.79069L17.7644 1.76485L17.7802 1.96415L17.9949 1.9816L18.0651 1.80847L18.1958 1.86048L18.266 2.00777L18.6195 2.13762L18.725 2.30203L18.5435 2.35403L18.2405 2.26747L18.3006 2.37148L18.438 2.43221L18.3772 2.66607L18.5681 2.48422L18.81 2.44966V2.79558L18.603 3.13278L18.4532 3.33208L18.4098 3.47066L18.5029 3.72163L18.4528 3.93804L18.217 4.05044V4.15445L18.1051 4.20646V4.33631L18.055 4.37086L18.144 4.48327L18.2821 4.69968V4.84697L18.2045 5.00265L18.2825 5.05466L18.4471 5.4697L18.4189 5.58009L18.471 5.66565L18.2801 5.78308L18.0553 5.5113L17.8995 5.61565L17.6915 5.70188L17.4835 5.42473L17.25 5.38145V5.24288L17.0504 5.18215L16.9382 4.98285L17.0158 4.87884L16.9382 4.79227L16.8512 4.93085L16.6089 4.73154L16.453 4.55606L16.3489 4.42856L16.3922 4.31616L16.2367 4.23832V4.07391L16.4181 4.08263L16.4359 3.9615L16.3489 3.80582L16.3398 3.55485L16.2246 3.54612L15.9853 3.55485L16.1933 3.65014L16.072 3.76254L15.8812 3.69342L15.812 3.54613L15.9245 3.52029L15.812 3.40789H16.0196L16.2192 3.39917L15.9081 3.15659H15.726L15.6561 3.31227L15.5348 3.22571L15.5338 3.04486L15.4824 2.83716L15.266 2.57747L14.9895 2.43018L14.8769 2.30033L14.7845 2.24833H14.4314L14.2637 2.35234H14.0534L13.9432 2.17048L13.7796 2.10203H14.0652L14.1717 2.01547L14.1616 1.90307L14.037 1.97252L13.8206 1.93796L13.6993 1.83395L13.8814 1.64337L14.081 1.49608L14.1677 1.53936L14.1075 1.34006L13.9684 1.38334L13.8992 1.26222L14.09 1.03708H14.1945L14.1841 0.91699ZM12.4131 1.12502L12.5733 1.0559L12.6946 1.27231L12.8159 1.38471L12.9114 1.25923L12.7336 1.1985L12.7027 0.94316L13.036 0.826396L13.1795 0.882764L13.2783 0.735473L13.6982 0.631463L14.088 0.756946L13.8239 1.0465L14.0275 1.02469L13.7698 1.34445L13.6199 1.57832L13.4036 1.63032L13.5027 1.82962L13.4251 1.95075L13.2208 2.07624L13.3334 2.20608L13.1781 2.34029L13.0904 2.32284L13.034 2.20608L12.822 2.27386L12.6096 2.24936L12.4144 2.20608L12.4836 2.08093H12.6832L12.6009 1.92088L12.7528 1.89907L12.8179 1.99772L12.8744 1.95544V1.76922L12.6842 1.83834L12.6496 1.73433L12.4416 1.82526L12.2595 1.60012L12.3983 1.54811L12.2162 1.42699L12.4131 1.12502ZM12.2179 1.8776L12.1527 1.95108L12.0485 1.8776H12.2179ZM11.9713 1.56153L12.0724 1.54408L12.1833 1.69574V1.8125L11.9713 1.78231L11.9713 1.56153ZM11.9457 2.01147H12.1534L12.188 2.14132L12.3224 2.15004L12.4003 2.27117L12.3311 2.36444L12.4742 2.49631H12.6694L12.9073 2.3923L13.1281 2.47014L13.1801 2.5567L13.0444 2.72547L12.3966 2.68655V2.62079L12.2491 2.68655L12.0973 2.58254L12.1708 2.39196L12.1577 2.26211L12.149 2.17118L12.0364 2.23627L11.9064 2.0977L11.9457 2.01147ZM11.9844 2.39666L12.0102 2.49631L11.9669 2.61709H11.8543L11.7502 2.49597L11.8587 2.3792L11.9844 2.39666ZM11.6336 1.48669V1.32799L11.7505 1.31054L11.7764 1.44475L11.8816 1.60043L11.8416 1.76048H11.7505L11.733 1.61754L11.5943 1.6001L11.6336 1.48669ZM11.3779 1.95173L11.4169 2.1715L11.5079 2.06313L11.5943 2.1715L11.6339 2.06313L11.7898 2.10641V2.18861L11.6642 2.26646L11.6944 2.32282L11.5946 2.47012L11.4343 2.41811L11.5351 2.2537H11.3651L11.2828 2.06178L11.3779 1.95173ZM11.3215 2.6862L11.5681 2.70801L11.5939 2.8033L11.438 2.97274L11.5204 3.0885L11.438 3.26163H11.2778L11.2603 3.33947L11.1605 3.31363L11.1387 3.15594L10.9697 2.9459L11.0305 2.84625L11.1649 2.97241L11.2448 2.8637L11.1474 2.7815L11.3215 2.6862ZM10.9361 1.50549L11.2086 1.52965L11.0829 1.67091L10.9139 1.63467L10.9361 1.50549ZM10.8971 2.07622L10.8538 1.92054L10.9707 1.83833L11.0574 1.87155L11.0053 2.08092L11.1571 2.11984L10.9707 2.34162L10.7718 2.23055L10.6505 2.28826L10.3693 2.27954L10.2436 2.18425L10.4858 2.14097L10.4381 2.07185L10.2604 2.09768L10.1606 1.92019L10.3726 1.95106L10.4116 1.81215L10.5675 1.76216L10.6888 1.8712L10.6844 2.0242L10.7929 2.11949L10.8971 2.07622ZM10.1962 1.53368L10.4818 1.4451L10.7284 1.52965L10.5248 1.72158L10.4556 1.62528L10.3081 1.72158L10.2083 1.69138L10.0783 1.76251L9.96137 1.61354L10.1962 1.53368ZM8.91412 2.34464L9.39492 2.09366L9.4685 1.92054L9.77593 1.97254L9.79776 2.12822L9.99297 2.15406L9.9886 2.43121L10.0578 2.45302L9.97113 2.59595L10.0578 2.56576L10.2053 2.69124L10.1274 2.76908L10.2487 2.81236L10.3353 2.63924L10.4351 2.80364L10.3441 3.04186L10.4351 3.06367L10.5131 2.80398L10.5823 2.66541L10.6992 2.71741L10.669 2.6134L10.8249 2.54831L10.9374 2.6956L10.8161 2.81237L10.7076 2.74728L10.7466 2.93786L10.6122 3.34854L10.8158 3.59918L10.7637 3.7203L10.6035 3.64246L10.6686 3.78104L10.6428 3.86324L10.3831 3.82868L10.2097 3.76795V3.63374L9.97988 3.70286L9.63784 3.72467L9.36535 3.60354L9.39995 3.43478L9.17921 3.31801V3.12307L9.40399 3.10563L9.66807 3.25728L9.785 3.23984L9.65061 3.07543L9.31293 2.98013L9.27833 2.85901L9.59416 2.84592L9.45103 2.82847L9.35123 2.66406L9.66303 2.39598L9.13015 2.69426L8.91345 2.6379L8.95679 2.52113L8.91412 2.34464ZM3.76548 0.89148L3.8599 0.747203V0.62373L3.95666 0.572395C3.93113 0.681102 3.93113 0.638829 3.95666 0.747542L3.8898 0.948517L3.76548 0.89148ZM2.86768 1.57159L2.9967 1.63366L2.93992 1.7521L2.84181 1.72627L2.86768 1.57159ZM3.04845 3.59784H2.8576L2.69229 3.5049L2.77461 3.40491L2.93454 3.35525L2.95537 3.45423H3.04306L3.12068 3.50489L3.04845 3.59784ZM3.24432 3.44819H3.12068V3.35525H3.24432V3.44819ZM4.2714 6.29344L4.28686 6.48904L4.20924 6.65412C4.20924 6.23405 4.20488 6.32329 4.23512 6.0693L4.34364 6.01528L4.4367 6.12366L4.2714 6.29344ZM14.2652 35.3128L14.2494 35.3668L14.3025 35.4212L14.2867 35.4457H14.2101L14.149 35.3152L14.2192 35.2843L14.2652 35.3128ZM14.2252 35.1907L14.2521 35.0867L14.2814 35.1024V35.2199L14.2252 35.1907ZM13.853 35.7768H13.9222L13.9088 35.862L13.818 35.8379L13.853 35.7768ZM13.8594 36.1264L14.0001 36.0842L14.0401 36.2704L14.0001 36.3157L13.9894 36.2546L13.9229 36.2892H13.8274L13.8594 36.1264ZM13.9229 36.3637L13.8493 36.3767L13.8701 36.3244L13.9229 36.3637ZM13.8698 36.6633L13.8953 36.5942L13.8452 36.5465L13.9497 36.3959L13.98 36.4828L13.937 36.5573L13.9679 36.6153V36.6854L13.8835 36.8049L13.8698 36.6633ZM14.1339 37.1276L14.194 37.2045L14.1833 37.2568L14.1322 37.2468V37.1857L14.069 37.1276L14.0694 37.1149L14.1339 37.1276ZM14.1187 37.0344V36.9921L14.156 36.9918V37.034L14.1187 37.0344ZM14.0633 36.875L13.9756 36.8884L14.0022 36.7871L14.0764 36.8273L14.0633 36.875ZM13.8963 36.9918L13.9098 36.9176L13.9521 36.9552L13.8963 36.9918ZM13.9518 37.1276V37.032L14.0149 37.0219L14.0394 37.0807L13.9518 37.1276ZM14.2622 37.5541L14.1826 37.4501L14.1933 37.4001L14.068 37.3578L14.0126 37.2467L14.0391 37.2743L14.1103 37.3108L14.1933 37.341H14.2968V37.4112L14.2488 37.4336L14.2968 37.485L14.321 37.5789L14.2622 37.5541ZM14.4487 37.5836L14.3687 37.6078V37.5259L14.4487 37.5041V37.5836ZM14.7561 37.8356L14.7108 37.7957H14.7937L14.743 37.7403H14.5727L14.5384 37.6917L14.618 37.6809L14.6177 37.6393H14.567L14.5034 37.6074V37.5434L14.6442 37.6074L14.6761 37.6873L14.7958 37.7239L14.8458 37.8537L14.7561 37.8356ZM15.1136 37.9289L15.0679 37.8725L15.0525 37.9426L14.9328 37.8725L14.9187 37.8272H15.0383L15.1341 37.8406L15.164 37.8718L15.2349 37.8819L15.2651 37.9393L15.1136 37.9289ZM15.4049 38L15.3437 37.9913L15.4049 37.9413L15.4529 37.9711L15.4049 38ZM16.7243 34.8696L16.6256 34.8961L16.5832 34.8055L16.645 34.6938L16.7395 34.6693L16.7791 34.7122L16.7243 34.8696ZM25.3609 25.2082L25.0232 25.5669L24.7941 25.8135L24.7285 26.0252L24.4907 26.3768L24.4564 26.3161L24.3522 26.3238L24.2656 26.5614L24.231 27.3327L24.1698 27.4928L24.0996 27.8236L23.9521 28.0276L23.8913 28.3584L23.7606 28.5081L23.4975 28.8795L23.4757 29.0959L23.2422 29.1956L23.1857 29.3643L22.8611 29.3774L22.5299 29.4284L22.4412 29.5603L22.127 29.6703L21.6116 29.9784L21.3082 30.2538L21.2474 30.685L21.1543 31.0265L20.8274 31.2694L20.6561 31.5389L20.3964 31.8261L20.1487 31.9804L20.3812 31.7654L20.5516 31.562L20.4229 31.5318L20.2526 31.7526L20.053 32.0509L19.7371 32.4659L19.3437 32.7729L18.6805 32.7021H18.5249L18.3986 32.5901L18.3287 32.733L18.5064 32.7937L18.6596 32.9105L18.5461 33.0316L18.5847 33.1484L18.6989 33.1786L18.7164 33.2732L18.4352 33.6279L18.1509 33.7842L17.4796 33.8842L17.1887 33.8456L17.232 34.0053L17.1151 34.1919L17.1604 34.3392L17.0261 34.4301L16.8013 34.4214L16.5526 34.3315L16.4314 34.3878V34.673L16.5526 34.7022L16.5369 34.7723L16.4414 34.8492L16.5362 34.9049L16.3299 35.0391L16.3158 35.182L16.2415 35.325L15.9506 35.3957L15.7187 35.5863L15.714 35.7252L15.8353 35.8849L16.0732 35.9068V35.9953L15.9425 36.1859L15.7517 36.297L15.5813 36.4476L15.5138 36.6308L15.3028 36.6808L15.164 36.8714L15.2151 36.8815L15.2104 36.9972L15.3213 37.1915L15.1882 37.1415L15.0773 37.1922L15.2984 37.27L15.2937 37.4183L15.6193 37.6733L15.884 37.7602L15.5682 37.8723L15.3364 37.7991H15.0501L14.8505 37.7602L14.7158 37.5529L14.6033 37.5747L14.5424 37.427L14.356 37.477L14.3351 37.3267L14.2249 37.2566L14.235 37.0855L14.1802 36.8862L14.059 36.7751L14.1023 36.6365L14.0321 36.549L13.981 36.3715L14.1198 36.2886L14.029 36.0735L14.1235 35.9568L14.1843 35.8789L14.0196 35.8303L13.9027 35.7145L14.1537 35.5639L14.2824 35.7145L14.486 35.3038L14.4359 35.2132L14.6355 34.5845L14.5576 34.5143L14.4306 34.5751L14.3543 34.7237L14.3691 34.8781L14.2928 35.0123L14.1762 34.9948L14.2243 34.8562L14.234 34.6485L14.3553 34.5576L14.3156 34.4466L14.3375 34.2003L14.3993 34.1006L14.5152 33.9617L14.4332 33.7524L14.4154 33.4417L14.5461 33.3511L14.8972 32.6458L15.0404 32.1267L15.0185 31.6684L15.1093 31.5355L15.0874 31.2483L15.1529 31.1178L15.2971 30.633L15.379 29.876L15.5279 29.1641L15.4835 28.3853L15.1583 28.1105L14.7632 27.8756L14.1876 27.6203L13.8557 27.2673L13.8167 26.9956L13.4471 26.4386L13.0879 25.6672L12.9058 25.4739L12.7368 25.1441L12.421 24.9354L12.5077 24.8656L12.382 24.6955L12.3602 24.5137L12.6327 24.2218L12.7496 24.1916L12.7755 23.9107L12.6599 24.0121L12.4996 23.8789L12.5386 23.5319L12.6122 23.4598L12.6381 23.3544L12.7247 23.2333L12.6989 23.0182L13.0755 22.9008L13.0322 22.7502H13.132L13.1232 22.6072L13.3228 22.5415L13.5825 22.1955L13.5103 22.1254L13.4659 21.7104L13.5271 21.6496L13.4659 21.4591L13.4884 21.4158L13.3927 21.2728L13.2018 20.9675L13.3117 20.8746L13.2254 20.8528L13.0258 20.6642L12.8655 20.7075L12.7758 20.8518L12.6602 20.896L12.6256 20.9524L12.7469 21.1336L12.509 21.2037L12.4744 21.0531L12.4311 20.992L12.4052 21.1225L12.2449 20.9494L12.1018 20.9108L11.9372 20.9326L11.8505 20.833L11.8159 20.8981L11.7205 20.8152V20.6622L11.4738 20.5317L11.4261 20.4199L11.3482 20.376L11.3828 20.4817L11.1792 20.4042L11.11 20.2737L11.1318 20.063L10.6685 19.5939L10.6251 19.4942L10.7293 19.5244L10.6991 19.4332L10.6298 19.3996L10.5734 19.465L10.3738 19.4214L10.0019 19.2741L9.78551 19.1953L9.57316 19.154L8.94116 18.5007L8.71638 18.4357L8.4308 18.5699H8.21409L7.82871 18.4098L7.6167 18.2669L7.39999 18.1803L7.04922 17.9683L6.86275 17.7733L6.71525 17.7388L6.49048 17.6348L6.34734 17.4053L6.08763 17.2234L5.9791 16.912H6.08326L6.06579 16.7996L6.14373 16.644L6.08292 16.5097L6.05268 16.3021L5.89242 16.034L5.85344 15.891L5.62799 15.6357L5.60212 15.4971L5.50233 15.376L5.37667 15.3069L5.33333 15.1683L5.42875 15.0817L5.39415 14.9952L5.28563 14.9563L5.29436 14.8351L5.22078 14.8177L5.1556 14.7311L5.15123 14.5795L5.07328 14.5362L4.87808 14.1255L4.80013 13.6715L4.84784 13.5158L4.76552 13.4813L4.73528 13.3689L4.62272 13.3558L4.53167 13.239L4.44062 13.3689L4.42751 13.7363L4.57065 14.0044L4.57502 14.104L4.69631 14.3292L4.66607 14.4848L4.73125 14.5023L4.75309 14.6147L4.85289 14.8485L4.87473 15.0824L4.91807 15.2297L4.95267 15.6236L5.0612 15.6494L5.16535 15.8269L5.15225 15.9913L5.00475 16.0346L4.94394 15.8226L4.59754 15.3512L4.66272 15.2126L4.65835 15.0093L4.51623 14.8495L4.49439 14.7543H4.42081L4.20007 14.5378L4.12212 14.3604L4.24778 14.4036L4.39527 14.4644L4.34319 14.356L4.40401 14.2261L4.30858 13.954L4.15672 13.8067L4.07004 12.981L4.0613 12.7304L3.88793 12.419L3.80125 12.3757L3.74548 12.2328L3.53347 12.1073L3.54221 11.9862L3.43805 11.5104L3.51163 11.4107L3.44645 11.3198L3.45519 11.138L3.52877 11.1725V11.0339H3.47669L3.39807 10.7269L3.47602 10.2425L3.62788 10.0042L3.72768 9.5761L3.96992 9.2946L4.42452 8.52021L4.52867 8.04008L4.61099 8.08772L4.54177 7.93204L4.43325 7.62907L4.3553 7.21839L4.42888 7.14491L4.55018 7.34421L4.73229 7.54754L4.57202 7.24456L4.54615 7.03251L4.64594 6.86374L4.58076 6.74698L4.64157 6.59532L4.55925 6.45239L4.58949 6.28362L4.68929 6.24034L4.7585 6.10613L4.74976 5.99776L4.78874 5.80282L4.69768 5.74645L4.56766 5.9065L4.54582 5.76792L4.66711 5.49984L4.65401 5.26598L4.52398 5.32234L4.65401 5.07573L4.73633 4.8204L4.80151 4.7902L4.76253 4.73819L4.72793 4.2235L4.80588 4.17149L4.65401 4.11948L4.65838 3.95507L4.42487 3.74738L4.44234 3.63498C4.40706 3.54103 4.42218 3.50278 4.43361 3.37092C4.33382 3.2347 4.38355 3.26456 4.2384 3.23671C4.1198 3.37092 4.17255 3.3263 4.02169 3.42293L3.92627 3.32764L3.49318 3.34945L3.52779 3.22832C3.58087 3.24611 3.61212 3.26288 3.66655 3.26288L3.67965 3.15451C3.82984 3.1025 3.76264 3.13438 3.94844 3.03338H4.11744L4.19976 3.1025L4.22563 2.9901L4.10433 2.95118H3.84025L3.64504 3.03774L3.48914 3.02466L3.31141 3.05049L3.33728 3.13706L3.29394 3.20617L2.7829 3.22798L2.66597 3.20215L2.57929 3.24107L2.41029 3.26288L2.2628 3.19779L2.08506 3.2196L1.98091 3.15048L1.95907 3.18068L1.74706 3.15048L1.69498 3.03808L1.56496 3.05989L1.54312 2.9646L1.44031 2.97701L1.3926 3.03338L1.31902 2.95554L1.17588 2.88642L1.27567 2.83441L1.43157 2.86461V2.9297L1.59621 2.92098V2.96426L1.66979 2.92534L1.81729 2.91662L1.93421 2.98573L1.87373 3.04177L1.91708 3.07632L1.99503 3.00284H2.18956L2.29808 3.07632L2.36327 3.0374L2.63172 3.00285L2.8696 2.86864L3.04733 2.8428L2.89984 2.77771L2.93881 2.70423L2.78292 2.73443L2.86087 2.59149L2.81315 2.45728L2.65255 2.40561L2.81719 2.2714L2.92975 2.25395L3.05104 2.12411L2.95999 2.0721L2.93008 1.96373L3.11219 1.71309L3.21198 1.86877L3.25969 1.82113L3.22945 1.73892L3.25969 1.58727L3.37225 1.46614L3.66658 1.3883L3.74889 1.4185L3.99551 1.33629L4.01735 1.37957L3.97837 1.44869L4.01298 1.51378L4.16888 1.53123L4.19912 1.60907L4.31167 1.6178L4.52402 1.43158L4.63254 1.46177L4.68899 1.41849L4.5892 1.34937L4.48068 1.33629L4.48941 1.23228L4.40273 1.1588L4.38089 1.03332L4.52402 0.890379L4.62818 0.881656V0.756174L4.68899 0.682694L4.90973 0.786703L5.10058 0.825623L5.13518 0.899103L4.94871 0.990031L4.98332 1.16316L5.10024 1.18497L5.33375 0.994387L5.29914 0.903459L5.46814 0.760522L5.64588 0.50083L5.79774 0.448823L5.95364 0.60887L6.36488 0.56995L6.50365 0.669604L6.47341 0.738722L6.6209 0.643431L6.73346 0.782004L6.928 0.803813L6.92363 0.93366L6.86281 1.01586L6.94076 1.06351L6.84097 1.26684L6.91019 1.28865L6.96226 1.36213L6.97973 1.56545L7.07079 1.6433V1.75167L7.22265 1.86843V2.07613L7.3137 2.12377L7.26163 2.2449L7.33957 2.40931L7.42189 2.60425L7.53041 2.52204L8.08916 2.48748L8.18895 2.55258L8.08043 2.61331L8.22793 2.65659L8.39692 2.55693L8.42716 2.65659L8.33174 2.78207L8.33611 2.91628L8.60019 2.77771L8.47017 3.00721L8.70804 2.93373L8.97213 3.37494L9.12803 3.40078L9.21908 3.48298L9.24495 3.63027L8.99834 3.67355L9.27956 3.85105H9.58261L9.73011 4.11477L9.66493 4.26206L9.76908 4.2275L9.82989 3.95035L10.0983 3.90271L9.82586 3.87687L9.8692 3.78158L10.1766 3.75139L10.1245 3.90707L10.4448 4.16676L10.9037 4.19696L10.9081 4.06711H11.0425L10.8993 3.89398L11.0858 3.71213L11.2854 3.86378L11.3244 4.04128L11.1124 4.09764L11.199 4.17548L11.0747 4.29091L11.2091 4.42512L11.2179 4.26507L11.3133 4.24326L11.491 4.13086L11.4346 4.03121L11.4998 3.90136L11.3479 3.75842L11.2914 3.67186L11.3781 3.60677L11.3391 3.50276L11.616 3.24742L11.746 3.35143V3.5722L11.8458 3.70641L11.7373 3.87082L11.8717 3.91847L11.8499 4.24695L11.9668 4.03489L12.1186 4.07381L12.162 4.23822L12.0753 4.32479L12.1795 4.54556L12.3182 4.42443L12.3962 4.22949L12.5003 4.19057L12.4745 3.9698L12.5786 3.90471L12.9119 4.07347L12.9294 4.23788L12.8125 4.28117L12.9122 4.56636L12.7782 4.71433L12.5141 4.82673L12.3884 4.75761L12.2671 4.72742L12.3061 4.84855L12.0894 5.01731L12.1371 5.12971L11.8646 5.36358L11.4578 5.41994L11.5532 5.49342L11.4709 5.61455L11.2545 5.70112L10.8214 6.09032L10.7303 6.38424L10.6611 6.52282L10.7088 6.63958L10.8997 6.64394L10.9518 7.03314L10.8694 7.14152L11.2417 7.08079L11.6617 7.42235L11.8784 7.50892L12.0343 7.6646L12.5497 7.70789V8.30042L12.8397 8.7111L12.9915 8.81511L13.0567 8.70673L13.1565 8.8235L13.1521 8.66345L13.213 8.53797L13.1263 8.37356L13.1437 8.13534L13.0658 7.86323L13.3816 7.70754L13.555 7.40054L13.5116 7.05462L13.265 6.76875L13.425 6.54361L13.3353 6.24969L13.3786 6.07657L13.2872 5.91215L13.3779 5.78231L13.5815 5.84304L13.854 5.8776L13.9273 5.79976L14.1984 5.99034L14.3197 6.14602L14.6107 6.18494L14.605 6.43155L14.6564 6.67413L14.8499 6.71742L14.9806 6.87746L15.2339 6.71742L15.2672 6.58321L15.3374 6.28023L16.0662 7.0459L15.9996 7.23212L16.3507 7.43981L16.4173 7.61731L16.5493 7.51765L16.6491 7.60422L16.9139 7.64314L16.7805 7.76862L16.9357 7.72097L17.0133 7.85518L17.0909 7.80318L17.2129 7.85518L17.3009 8.06288L17.4222 8.17964L17.2915 8.43061L17.5193 8.39371L17.4286 8.65978L17.4098 8.91914L17.5405 8.78023L17.6695 8.80573L17.5932 8.91981L17.7222 8.95772L17.9887 8.86915L18.0388 8.97685L18.0122 9.14126L18.1701 9.08456V9.23017L18.0794 9.33788L17.9091 9.65427H17.7511L17.902 9.46437L17.7663 9.49625L17.7293 9.39492L17.564 9.47712L17.273 9.52141L17.0516 9.57207V9.44558L17.1413 9.29996L17.096 9.16709L17.1413 9.09093V8.85035L17.2949 8.43196L16.9659 8.54033L16.8568 8.73963L16.7069 8.8782L15.9493 8.91276L15.5427 8.9953L15.4214 9.22044L15.3089 9.2248L15.1177 9.41973L14.698 10.0079L14.8412 9.90826L15.0575 9.60562L15.5686 9.26841L15.9237 9.2295L16.0578 9.42443L15.8901 9.58884L15.6593 9.58012L15.746 9.66668L15.9455 9.61032L15.9623 9.82672L16.2002 10.0988C16.388 10.1411 16.7281 10.1599 16.8369 10.233L16.504 10.4625L16.253 10.5189L16.0416 10.8474L15.8592 10.7608L15.8279 10.5833L16.1021 10.3193L16.0702 10.2371L15.8706 10.3626L15.5995 10.4102V10.5313L15.3085 10.6568L14.9776 10.8561L14.8667 11.2279L15.0226 11.4097L14.7803 11.5352L14.5105 11.5178L14.311 11.6302L14.6587 11.6043L14.2213 11.7429L14.2387 11.8902C14.1531 12.0231 14.1252 12.0647 14.0469 12.1975L13.9088 12.0764L14.0301 12.3579L13.9199 12.4834L13.7986 12.7173L13.7811 12.6176L13.8352 12.4834L13.7522 12.3881L13.7257 12.0683L13.6101 12.3623L13.688 12.4401L13.7216 12.5958L13.6309 12.7042C13.8218 12.7548 13.7741 12.7115 13.7956 12.8817L13.8654 13.085C13.7556 13.1524 13.7143 13.1759 13.6531 13.2192L13.7263 13.3014L13.7132 13.3705L13.5063 13.388L13.3359 13.5873L13.1928 13.6131L13.0151 13.7517L12.6949 14.0587L12.4748 14.3345L12.4792 14.6804L12.5961 14.9656L12.6179 15.13L12.7698 15.5018L12.7829 15.8433L12.6354 16.0852H12.4966L12.4748 15.9598L12.3404 15.8212L12.1149 15.3756L12.1408 14.9864L11.8203 14.6713L11.5478 14.7797L11.3832 14.5764L11.1234 14.5073L10.8768 14.5764L10.4955 14.5499L10.4001 14.6972L10.5432 14.8314L10.4911 14.8834L10.3308 14.7666L10.0842 14.8357L9.87624 14.6539L9.72875 14.7146L9.4734 14.6106L9.1747 14.667C8.76009 14.9287 8.91465 14.8411 8.52557 15.0307L8.39117 15.2947L8.41301 15.6061L8.20503 16.0557L8.12272 16.5013L8.20067 16.9596L8.40024 17.3877L8.4913 17.6991L8.68214 17.7293L8.83401 17.8937L9.02485 17.8635L9.54462 17.79L9.76133 17.7166L9.91723 17.5478L10.017 17.1458L10.4978 17.016L10.9568 17.0291L10.9742 17.2411L10.7834 17.423L10.6792 17.9853L10.558 18.046L10.5015 18.444L10.3019 18.6517L10.4965 18.7208L11.2629 18.6775L11.7914 18.8506L11.8912 19.0845L11.8219 19.3143L11.6701 20.0052L11.7309 20.1582L12.1294 20.6886L12.2379 20.6497L12.3377 20.7598L12.5023 20.7098L12.879 20.5192L13.308 20.6138L13.679 20.9943L13.689 20.8121L13.8621 20.6038L13.9965 20.5373L13.979 20.3467L14.1265 20.1545L14.2743 20.087L14.323 20.2035L14.362 20.0317L14.6933 19.9931L14.9107 19.8267L15.1959 19.6945L15.1922 19.8606L15.0081 19.9512L15.1425 20.1478L15.2467 20.0572L15.5376 19.9871L15.4674 19.7878L15.5951 19.7696L15.6253 19.9263L16.0063 20.0149L16.0453 20.2142L16.6343 20.1421L16.765 20.2675L16.9747 20.3021L17.2559 20.1182L17.7367 20.0682L17.5589 20.1988L18.0458 20.3544L18.1832 20.4098L18.0962 20.5152L18.0297 20.6802L18.3992 20.6306L18.5988 20.9171L18.7245 20.8571L18.8552 20.9456L18.8683 21.11L18.9936 21.1215L19.2261 21.3201L19.9334 21.25L20.1444 21.3322L20.4373 21.4023L20.7485 21.6744L20.8993 21.6892L21.1261 22.3347L21.3321 22.3673V22.5749L20.8644 23.0816L20.8298 23.2705L20.6352 23.4134L20.8261 23.3634L21.0256 23.198L21.0865 23.2524L21.1298 22.9548L21.7621 22.9068L21.7279 23.1319L21.615 23.3292L21.3438 23.3993L21.5259 23.4527L21.74 23.2705L21.8576 23.0712L22.1331 23.0279L22.6582 23.1836L22.8306 23.2702L22.8407 23.5154L23.0053 23.4866L23.183 23.3869L23.564 23.497L24.0485 23.4268L24.3395 23.548L24.6106 23.7473L24.9698 23.9724L25.329 23.957L25.4392 24.2643L25.5 24.779L25.3609 25.2082ZM16.2392 17.8998L16.721 17.9441L16.6196 18.0642H16.2107L16.2392 17.8998ZM14.7189 17.9877L14.8707 17.9313L14.7662 17.8367L14.7162 17.6659L14.5139 17.6341L14.6984 17.5327L14.9504 17.6089L15.1412 17.5646L15.4453 17.5965L15.6039 17.7609L15.7947 17.7421L15.9257 17.9005L15.8555 18.0333L15.7803 17.988L15.5394 17.9283L15.4073 18.0451L15.325 17.9874L15.2343 18.0132L15.0952 18.1904L14.9698 18.0196L14.7656 18.032L14.5186 18.0196L14.4286 18.1273L14.2807 17.9874L14.4511 17.931L14.7189 17.9877ZM13.2681 16.0454L13.3628 16.1783L13.4052 16.3682L13.4576 16.3937V16.5456L13.3356 16.4443L13.3689 16.3366L13.2674 16.2605L13.2681 16.0454ZM12.0891 17.1275H11.9561L12.0128 17.0013L12.1207 17.0332L12.0891 17.1275ZM13.6726 18.1531L13.3685 18.1911L13.3359 18.1025L13.2419 18.0307L13.5839 17.9877L13.768 18.0756L13.6726 18.1531ZM13.4455 17.5962L13.5342 17.4442L13.5039 17.3496H13.3074L13.1606 17.2355V17.1026H12.8498L12.6408 16.9187L12.2729 16.9191L12.3428 16.7926H12.0132L11.8865 16.9067H11.7723L11.7279 16.9952L11.5445 17.0271L11.6392 16.7929L11.9305 16.66H12.3105L12.8363 16.7298L12.9949 16.8563L13.2385 16.907L13.5033 17.0714L13.5913 17.1791L13.9458 17.217L14.0022 17.3559H14.1534L14.3385 17.4948C13.8272 17.6227 14.0469 17.5962 13.4455 17.5962L13.4455 17.5962ZM16.968 37.1869L16.8638 37.1346H16.968L17.0365 36.9685H17.1796L17.2499 37.0108L16.968 37.1869ZM17.2475 37.2024L17.1373 37.2154V37.1574L17.3708 36.9688L17.5364 36.9913L17.5596 37.0614L17.2475 37.2024Z",
    fill: "currentColor"
  })));
};
const america_ForwardRef = /*#__PURE__*/(0,react.forwardRef)(SvgAmerica);

/* harmony default export */ const america = (__webpack_require__.p + "85088e887584f12d265dfc77a5fdd5a9.svg");
;// CONCATENATED MODULE: ./src/assets/icons/other_coutries.svg
var other_coutries_path, other_coutries_path2, other_coutries_path3, other_coutries_path4, other_coutries_path5, other_coutries_path6, other_coutries_path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68;
function other_coutries_extends() { other_coutries_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return other_coutries_extends.apply(this, arguments); }


const SvgOtherCoutries = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/react.createElement("svg", other_coutries_extends({
    width: 50,
    height: 36,
    viewBox: "0 0 50 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/react.createElement("title", {
    id: titleId
  }, title) : null, other_coutries_path || (other_coutries_path = /*#__PURE__*/react.createElement("path", {
    d: "M10.5068 16.4683C10.8348 16.3589 11.3269 16.5778 11.6553 16.6869C11.5459 16.3589 11.9834 16.5229 12.0925 16.3589C12.2019 16.2494 12.147 15.8668 12.311 15.9759C12.2016 15.8119 13.022 15.9213 13.0766 15.9213C13.4046 15.9213 14.0062 15.8119 13.8421 15.3198C13.9516 15.3744 14.0607 15.4293 14.2251 15.3744C14.1706 15.4838 14.3346 15.5929 14.1706 15.5929C14.28 15.7024 14.444 15.6475 14.5535 15.7569C14.7175 15.921 14.7721 16.1399 14.7175 16.3585C14.2255 16.1399 14.6081 17.0695 14.6081 17.1786C14.7175 17.124 14.6626 16.96 14.6081 16.8505C14.7721 16.96 15.0456 16.632 15.2642 16.6865C15.4827 16.7411 15.8111 17.0695 15.5922 17.3426C15.7017 17.3426 15.7562 17.124 15.8657 17.2331C15.9752 17.3426 15.7017 17.4517 15.6471 17.5066C15.8657 17.4521 15.9752 17.5066 15.8657 17.6706C15.9202 17.6161 16.0297 17.6161 16.0843 17.6706C16.0297 17.7252 15.9748 17.7801 15.9748 17.8347C16.1933 17.6706 16.9589 18.1081 17.1778 18.2176C17.3418 18.3271 17.4513 18.4911 17.6153 18.6006C17.7793 18.7101 17.9983 18.7101 18.1074 18.8741C18.326 19.1476 17.8339 20.2957 17.7244 20.2412C17.6699 20.4052 17.8884 20.3506 17.943 20.2957C17.9975 20.4052 17.943 20.5143 17.8335 20.5692C17.9975 20.5692 18.1616 20.3506 18.271 20.5692C18.3256 20.7332 18.0525 21.0067 17.9975 20.7878C17.8335 21.1158 18.3805 20.8423 18.5445 21.0063C18.435 21.1158 18.435 21.2249 18.271 21.2798C18.435 21.2798 18.5445 21.1158 18.654 21.1704C18.5445 21.2798 18.49 21.3889 18.326 21.4984C18.4354 21.5529 18.3805 21.717 18.4354 21.7719C18.326 21.6079 18.1619 21.7173 17.9979 21.7173L18.1074 21.8268C18.0528 21.8268 18.0528 21.8814 18.0528 21.9363C18.2169 21.9363 18.2169 22.0458 18.0528 22.1549C18.2169 22.0454 18.1623 22.1003 18.2169 22.1549C18.1623 22.1003 18.3809 22.4829 18.3263 22.3734C18.3263 22.4829 18.4358 22.428 18.3263 22.592C18.2718 22.7015 18.0528 22.6465 18.2169 22.5374C17.7793 22.592 18.3263 22.756 18.3809 22.756C18.4354 22.756 18.3263 22.6465 18.5449 22.7015C18.6544 22.756 18.7635 22.92 18.8184 22.975C18.8729 23.139 18.7638 23.467 19.037 23.303C19.201 23.1935 19.1464 22.8655 19.365 22.92C19.3105 23.0841 19.1464 23.1386 19.0915 23.2481C19.037 23.4121 19.1461 23.4121 19.0915 23.5761C18.982 23.8496 18.654 23.9591 18.3805 23.9042C18.3805 24.0136 18.3805 24.0682 18.4351 24.1777C18.3805 24.1231 18.3256 24.0682 18.271 24.0136C18.5445 24.3417 17.943 24.2871 18.0525 24.2871C17.9979 24.3417 17.8339 24.4511 17.9979 24.5057C17.8884 24.6152 17.6699 24.3962 17.6699 24.2871C17.6699 24.0136 18.2714 23.8496 17.9434 23.4121C17.9434 23.4121 17.8339 23.3026 17.7794 23.3026C18.1074 23.6856 17.9434 23.9587 17.5059 24.2867C17.4513 24.0132 17.1229 24.1227 17.0138 24.2867C16.9047 24.2879 16.9047 24.6708 16.6861 24.5614C16.4676 24.5068 16.6316 24.2333 16.5221 24.0693C16.4126 23.9598 16.0301 24.0148 15.9206 24.1239C16.1392 24.0144 16.1392 24.2333 15.9751 24.2879C15.9206 24.2879 15.4281 24.0144 15.5922 24.2333C15.5376 24.1788 15.5376 24.1788 15.5376 24.1239C15.4281 24.3424 15.2641 24.4519 15.1546 24.6159C15.1001 24.3974 14.9361 24.5614 14.8266 24.5064C14.8812 24.561 14.8812 24.725 14.7171 24.561C14.9357 24.9985 14.4986 24.725 14.3342 24.7796C14.1701 24.8341 14.2247 24.889 14.1701 25.0531C14.0607 25.2716 13.8967 25.3811 13.7872 25.5451C13.7872 25.4356 13.7872 25.3265 13.8417 25.2716C13.6232 25.4356 13.7322 25.5997 13.4588 25.6546C13.5133 25.6546 13.6228 25.4906 13.5133 25.6C13.6228 25.5455 13.6773 25.3815 13.4588 25.3815C13.6228 25.655 13.1853 25.6 13.3493 25.436C12.9663 25.7641 12.4743 25.5455 12.0368 25.7095C12.0368 25.6 11.9822 25.6 11.9273 25.4909C11.8728 25.6004 11.7087 25.6004 11.7087 25.7644C11.6542 25.3815 11.3807 25.983 11.3258 25.655C11.2712 25.7644 11.1618 25.819 11.0523 25.819C11.1068 25.5455 10.6693 25.6004 10.5602 25.5455C10.2322 25.3815 9.84923 25.3269 9.46666 25.2175C8.9746 25.108 8.53709 24.944 8.04499 24.8345C7.7715 24.7799 7.33399 24.889 7.11543 24.5064C7.11543 24.6159 7.11543 24.6705 7.16997 24.7799C6.73246 24.7799 6.45897 24.6705 6.13089 24.4519C6.13089 24.5064 6.13089 24.5614 6.07635 24.5614C5.96687 24.3428 5.85778 24.3974 5.58429 24.3428C5.47481 24.3428 4.98275 24.0693 4.98275 24.1242C4.87328 23.9057 4.92821 23.7962 4.92821 23.5772C4.92821 23.3587 4.81873 23.3038 4.65471 23.1397C4.60017 23.0852 4.49069 22.9757 4.43614 22.9212C4.3816 22.8117 4.43614 22.7571 4.43614 22.6477C4.3816 22.4837 4.27213 22.7571 4.3816 22.3742C4.43615 22.2102 4.49107 22.1556 4.49107 21.9912C4.49107 21.8817 4.3816 21.7726 4.43653 21.6082C4.546 21.4442 5.09261 21.2802 5.03806 21.5537C5.14754 21.4992 5.09261 21.3897 5.14754 21.3351C5.25701 21.2257 5.42103 21.2257 5.5305 21.0616C5.69452 20.8431 5.5305 20.8431 5.5305 20.7336C5.36648 20.1866 6.13204 20.6791 6.13204 20.0226C6.13204 19.5851 5.96802 19.6946 5.74907 19.4756C5.47558 19.1476 5.85855 19.3661 5.85855 19.3661C5.85855 19.2021 5.58505 19.2567 5.69452 19.0381C5.91309 19.3116 6.07749 18.8741 6.18658 18.7646C6.24113 18.7101 6.46008 18.6551 6.51463 18.546C6.51463 18.546 6.6241 18.218 6.56917 18.2725C6.67865 18.1631 6.89721 18.4911 7.00669 18.1631C7.06123 18.0536 6.84267 17.6161 7.00669 17.5615C7.11616 17.507 7.11616 17.7256 7.22525 17.7256C7.2798 17.7256 7.55329 17.5615 7.55329 17.507C7.60784 17.4524 7.66277 17.343 7.77186 17.2884H7.88133C7.99081 17.1789 8.0999 16.9604 8.20937 16.9055C8.31885 16.8509 8.42794 16.9055 8.53742 16.8509C8.59196 16.8509 8.75598 16.7414 8.81091 16.7414C9.02948 16.6869 9.0844 16.9055 9.24842 16.9055C9.19388 16.7414 9.46699 16.8509 9.52192 16.796C9.46737 16.7414 9.52192 16.4679 9.57646 16.413C9.68594 16.3035 9.79503 16.3585 9.95943 16.3035C10.014 16.249 10.0689 16.03 10.178 16.085C10.342 16.1395 10.178 16.3585 10.2325 16.4679C10.0685 16.4679 10.0685 16.5225 10.014 16.632C10.1238 16.6323 10.4523 16.6869 10.5068 16.4683Z",
    fill: "currentColor"
  })), other_coutries_path2 || (other_coutries_path2 = /*#__PURE__*/react.createElement("path", {
    d: "M43.7547 33.4201C43.4267 33.2561 43.9733 32.6 44.1377 33.0921C44.3013 33.3652 43.9733 33.9122 43.7547 33.4201Z",
    fill: "currentColor"
  })), other_coutries_path3 || (other_coutries_path3 = /*#__PURE__*/react.createElement("path", {
    d: "M19.9672 19.6946C19.6392 19.2025 20.1858 18.3821 20.6233 18.929C20.8418 19.2025 20.8968 19.6946 20.5687 19.8586C20.4047 19.9135 19.8032 20.0226 19.9672 19.6946Z",
    fill: "currentColor"
  })), other_coutries_path4 || (other_coutries_path4 = /*#__PURE__*/react.createElement("path", {
    d: "M19.858 20.4056C19.6939 20.2416 19.5299 19.8586 19.6394 19.6946C19.6939 19.8041 20.5144 20.6791 19.858 20.4056Z",
    fill: "currentColor"
  })), other_coutries_path5 || (other_coutries_path5 = /*#__PURE__*/react.createElement("path", {
    d: "M13.2411 27.3503C13.0771 27.2409 13.1317 27.4598 13.2411 27.5143C13.4597 27.6238 13.6241 27.4598 13.6786 27.2958C13.7332 27.1318 13.6786 26.8583 13.4601 26.8037C13.1317 26.8033 13.2957 27.2409 13.2411 27.3503Z",
    fill: "currentColor"
  })), other_coutries_path6 || (other_coutries_path6 = /*#__PURE__*/react.createElement("path", {
    d: "M8.21029 28.3895C7.99172 28.663 8.21029 28.8815 8.31976 29.155C8.3743 29.2096 8.48378 29.5925 8.59325 29.538C8.6478 29.4285 8.42885 28.1709 8.21029 28.3895Z",
    fill: "currentColor"
  })), other_coutries_path7 || (other_coutries_path7 = /*#__PURE__*/react.createElement("path", {
    d: "M3.56221 20.4056C3.45273 20.351 3.34364 20.4056 3.28871 20.2961C3.23417 20.2415 3.28871 20.1866 3.17924 20.1321C3.39819 19.8586 3.67168 20.3506 3.56221 20.4056Z",
    fill: "currentColor"
  })), _path8 || (_path8 = /*#__PURE__*/react.createElement("path", {
    d: "M2.79692 19.4759C2.68745 19.4759 2.6329 19.4214 2.57835 19.3664C2.68783 19.3664 2.79692 19.3664 2.85185 19.4759H2.79692Z",
    fill: "currentColor"
  })), _path9 || (_path9 = /*#__PURE__*/react.createElement("path", {
    d: "M2.52364 18.7651C2.85168 18.6011 2.4691 19.0932 2.52364 18.7651V18.7651Z",
    fill: "currentColor"
  })), _path10 || (_path10 = /*#__PURE__*/react.createElement("path", {
    d: "M2.90602 16.031C2.85148 16.1404 2.96057 16.3045 3.07004 16.195C3.17952 16.0855 3.0155 15.9764 2.90602 16.031Z",
    fill: "currentColor"
  })), _path11 || (_path11 = /*#__PURE__*/react.createElement("path", {
    d: "M2.96102 15.5934C2.85155 15.7029 2.90647 15.9764 3.12504 15.8669C3.23451 15.8124 3.12504 15.5389 2.96102 15.5934Z",
    fill: "currentColor"
  })), _path12 || (_path12 = /*#__PURE__*/react.createElement("path", {
    d: "M2.85125 14.9919C2.74178 15.0465 2.68723 14.9919 2.63268 14.8824C2.57814 15.0465 2.57814 15.4294 2.68723 15.5385C2.57776 15.4291 2.9058 15.484 2.85125 15.5385C3.17967 15.3749 3.34369 14.7734 2.85125 14.9919Z",
    fill: "currentColor"
  })), _path13 || (_path13 = /*#__PURE__*/react.createElement("path", {
    d: "M0.773495 13.4061C0.664021 13.5152 0.66402 13.6247 0.5 13.6796C0.882968 13.8437 0.882968 13.4061 0.773495 13.4061Z",
    fill: "currentColor"
  })), _path14 || (_path14 = /*#__PURE__*/react.createElement("path", {
    d: "M3.56225 13.789C3.6168 13.5705 3.83575 13.297 3.94522 13.1875C3.99976 13.1329 3.99976 13.0235 4.05469 12.9689C4.05469 12.9689 4.21871 12.8595 4.16417 12.9144C4.05469 12.9689 4.32819 13.1879 4.32819 13.2424C4.38273 13.0784 4.60168 13.0239 4.49221 12.8595C4.7657 12.8049 4.54675 13.1329 4.49221 13.1875C4.32819 13.4061 4.00015 13.461 3.94522 13.7345V13.5159C3.89067 13.4614 3.72665 13.7894 3.72665 13.844C3.61718 13.789 3.67172 13.789 3.56225 13.789Z",
    fill: "currentColor"
  })), _path15 || (_path15 = /*#__PURE__*/react.createElement("path", {
    d: "M4.76543 12.4219C4.65596 12.1484 4.984 11.9298 5.20295 11.9298C5.1484 12.1484 4.98438 12.4219 4.76543 12.4219Z",
    fill: "currentColor"
  })), _path16 || (_path16 = /*#__PURE__*/react.createElement("path", {
    d: "M5.03891 11.8203C4.76542 11.7108 5.03891 11.3283 5.20293 11.3828C5.4215 11.4923 4.92944 11.6563 5.20293 11.8203H5.03891Z",
    fill: "currentColor"
  })), _path17 || (_path17 = /*#__PURE__*/react.createElement("path", {
    d: "M5.7498 11.3282C5.53123 11.2736 5.53123 11.1096 5.58578 10.9452C5.64032 10.8907 5.7498 10.8907 5.80435 10.8357C5.96837 10.6172 5.96837 10.4528 6.18731 10.7812C5.96875 10.7267 6.13277 10.8357 6.02329 10.8907V11.0001C5.85927 10.9456 5.80473 10.9456 5.91382 10.9456C5.91382 11.0001 5.69525 11.1096 5.7498 11.0551C5.7498 11.1096 5.80434 11.2187 5.7498 11.3282Z",
    fill: "currentColor"
  })), _path18 || (_path18 = /*#__PURE__*/react.createElement("path", {
    d: "M6.07775 10.344C6.13229 10.18 6.0232 10.1254 6.18722 10.016C6.24177 9.9614 6.2967 10.18 6.24177 10.18C6.62474 10.1254 6.89785 9.57844 7.11679 9.35988L7.39028 9.14131C7.44483 9.03184 7.39028 8.81327 7.44483 8.75834C7.5543 8.59432 7.60885 8.92237 7.60885 8.97691C7.60885 9.14093 7.33535 9.41443 7.28081 9.46897C7.11679 9.63299 7.00731 9.79701 6.78875 9.96103C6.67927 10.0156 6.35123 10.0705 6.57018 10.2891C6.46033 10.1251 6.18684 10.5626 6.07775 10.344Z",
    fill: "currentColor"
  })), _path19 || (_path19 = /*#__PURE__*/react.createElement("path", {
    d: "M4.92908 2.14132C4.92908 2.41481 4.43702 2.14132 4.43702 1.9773C4.38247 1.64926 4.71051 1.7038 4.87453 1.75873C4.92908 1.75873 4.65596 1.86821 4.92907 1.92275C5.03855 1.9773 5.25712 1.70418 5.31204 1.64926C5.64008 1.48524 5.8041 1.53978 6.13213 1.64926C6.3507 1.7038 6.73367 1.7038 6.78822 1.9773C6.84276 2.30534 6.51472 2.25079 6.29615 2.30534C6.02266 2.35988 5.96811 2.41481 5.74917 2.30534C5.58515 2.30534 5.09309 1.9773 4.92908 2.14132Z",
    fill: "currentColor"
  })), _path20 || (_path20 = /*#__PURE__*/react.createElement("path", {
    d: "M3.89068 1.21166C3.94523 1.37568 4.21872 1.37568 4.16417 1.21166C4.16417 1.10257 3.94561 1.10257 3.89068 1.21166Z",
    fill: "currentColor"
  })), _path21 || (_path21 = /*#__PURE__*/react.createElement("path", {
    d: "M14.9914 10.0703H14.9368C14.9914 9.96087 14.8274 9.79685 14.8274 9.74231C14.9368 9.79685 14.9914 9.85178 15.1009 9.79685C14.9914 10.0154 15.2649 9.79685 15.3194 9.90633C15.374 10.0158 15.374 10.0703 15.374 10.1798C15.2649 10.1249 15.1554 10.0703 14.9914 10.0703Z",
    fill: "currentColor"
  })), _path22 || (_path22 = /*#__PURE__*/react.createElement("path", {
    d: "M18.1629 7.55503C18.0535 7.55503 17.8349 7.60958 17.78 7.44556C17.944 7.39101 18.327 7.11752 18.491 7.22699C18.7099 7.33647 18.2724 7.50049 18.1629 7.55503Z",
    fill: "currentColor"
  })), _path23 || (_path23 = /*#__PURE__*/react.createElement("path", {
    d: "M20.0767 6.84429C20.0221 6.68027 20.9517 6.24275 20.8968 6.13329C20.9513 6.24276 20.8422 6.24276 20.7873 6.35186C20.7327 6.35186 20.7327 6.35186 20.6778 6.4064C20.6778 6.46095 20.6778 6.57042 20.6233 6.62497C20.5142 6.73482 20.3502 6.95338 20.0767 6.84429Z",
    fill: "currentColor"
  })), _path24 || (_path24 = /*#__PURE__*/react.createElement("path", {
    d: "M17.233 10.0159C16.9049 9.7973 17.0689 9.19577 17.233 8.9223C17.6159 8.37531 17.4515 9.08632 17.5064 9.08632C17.6705 9.08632 17.6705 8.53933 17.8345 8.75828C17.889 8.59426 18.108 8.37531 17.9985 8.21129C17.9985 8.21129 17.5064 8.53933 17.561 8.10182C17.561 7.9378 17.725 7.82832 17.8345 7.82832C18.108 7.77378 18.0531 8.04689 18.1625 8.10182C18.3811 8.21129 18.272 8.04727 18.436 8.04727C18.6546 8.04727 18.6546 8.15675 18.819 8.26584C18.9285 8.32038 19.0925 8.42986 19.2565 8.37531C19.366 8.32077 19.3111 8.15674 19.4205 8.15674C19.4751 8.15674 19.4205 8.37531 19.4205 8.43024C19.4751 8.26622 19.9675 7.39116 20.2955 7.66469C20.405 7.71924 20.241 7.82871 20.2955 7.88326L20.3501 8.04728H20.5141C20.5141 8.10183 20.4596 8.15675 20.4046 8.15675C20.4592 8.10221 20.5687 8.04728 20.6781 8.04728C20.5687 7.99273 20.5141 7.88326 20.5141 7.77379C20.5687 7.55522 20.6236 7.71924 20.6236 7.60977C20.6781 7.50029 20.6236 7.11771 20.7876 7.11771C20.7331 7.22718 20.7331 7.3912 20.8421 7.44575C20.7876 7.33627 20.7876 7.11771 20.9516 7.11771C21.0062 7.11771 21.0611 7.28172 21.1156 7.28172C21.2797 7.33627 21.4986 7.50029 21.7172 7.44575C21.4437 7.3912 21.1156 7.22718 21.2797 6.89876C21.3342 6.84421 21.4437 6.78928 21.4982 6.73474C21.5528 6.62526 21.4437 6.62526 21.4982 6.51617C21.5528 6.35215 21.4982 6.2976 21.7717 6.18813C22.0452 6.07866 21.9903 6.18813 22.2092 6.24268C22.1547 6.24268 22.5922 6.18813 22.5373 6.18813H22.9202C22.9748 6.18813 23.0843 6.07866 23.1937 6.02411C23.3578 5.96956 23.5767 5.96956 23.6858 5.91464C24.0138 5.86009 25.0529 5.14909 25.2714 5.80516C25.326 5.69569 25.326 5.64114 25.2169 5.58659C25.3809 5.64114 25.5449 5.69607 25.7639 5.75062C25.7639 5.69607 25.7093 5.64114 25.6544 5.64114C25.7639 5.5866 25.9279 5.53167 25.9824 5.64114C25.9279 5.53167 26.4199 5.14908 26.3105 5.25817C26.4745 5.09415 26.584 4.98468 26.6385 5.25817C26.6385 5.1487 26.6931 5.09415 26.748 4.98468C26.6934 5.09415 26.8025 4.98468 26.8575 4.93013C26.912 4.82066 26.8029 4.71157 26.912 4.60209C26.912 4.71157 26.9666 4.76611 27.076 4.82066C26.912 4.54717 27.1306 4.65664 27.1855 4.60209C27.1855 4.54755 27.3495 4.21912 27.295 4.16458C27.2404 4.11003 27.7325 4.3286 27.6779 4.11003C27.7325 4.11003 27.7874 4.16458 27.7874 4.21951C27.8969 4.11003 27.9514 4.27405 28.006 4.16496C28.006 4.11042 27.842 3.94639 27.842 3.94639C27.8965 3.89185 28.0605 3.89185 28.1155 3.94639C28.006 4.16496 28.17 4.27444 28.2795 4.38391C28.389 4.16534 28.1155 3.94639 28.17 3.67291C28.3886 3.72746 28.3886 4.05588 28.6075 4.11042C28.553 4.05588 28.553 3.9464 28.553 3.89186C28.6624 3.89186 28.717 4.00133 28.7715 4.11042C28.7715 3.9464 28.8261 3.78238 28.9901 3.89186C28.9356 3.78238 28.9901 3.78238 29.0996 3.78238C29.1541 3.67291 28.9901 3.67291 28.9901 3.61836C29.0447 3.56382 29.2636 3.67291 29.3731 3.56382C29.4825 3.45434 29.2636 3.23578 29.5371 3.23578C29.4276 3.34525 29.4825 3.45434 29.5371 3.56382C29.6466 3.34525 30.0292 3.18085 30.2481 3.23578C30.0841 3.50927 30.3026 3.23578 30.3026 3.3998C30.3026 3.45434 30.1932 3.56382 30.1386 3.61837C30.3026 3.56382 30.3572 3.61837 30.4667 3.61837C30.4667 3.61837 30.4121 3.78238 30.4667 3.78238C30.4667 3.67291 30.6307 3.45434 30.7402 3.61837C30.6856 3.18085 31.0682 3.56382 31.1231 3.2354C31.2326 3.39942 30.9591 3.61836 30.9046 3.72746C30.9591 3.72746 31.4515 3.34449 31.2875 3.72746C31.397 3.67291 31.4515 3.34449 31.561 3.45396C31.5065 3.34449 31.944 3.12592 32.108 3.071C32.2175 3.01645 32.819 2.68803 32.9281 2.85243C32.8186 2.57893 33.3656 2.52439 33.5296 2.46946C33.3656 2.85243 32.8735 2.96152 32.5455 3.18046C32.1626 3.45395 31.616 3.67252 31.397 4.05548C31.2875 4.2195 30.7409 5.75056 30.4129 5.53202C30.7959 5.80552 29.8659 6.29757 29.7019 6.35211C29.3738 6.51614 28.3348 7.06311 28.5533 7.44568C28.4988 7.44568 28.2798 7.6097 28.2798 7.55515C28.2798 7.66463 28.3893 7.77372 28.3893 7.82865C28.3348 7.99267 28.0613 7.93812 27.9518 8.04722C28.1158 8.15669 27.7878 8.32071 27.7332 8.37526C27.8973 8.37526 27.5692 8.64875 27.5147 8.75822C27.5147 8.8677 27.5147 9.19574 27.5692 9.30521C27.6787 9.46923 27.5692 9.41469 27.7878 9.35976C27.9518 9.35976 28.4439 9.14119 28.1158 9.46923C28.3344 9.46923 28.3893 9.30521 28.5533 9.19574C28.7719 9.08627 28.8814 9.08626 29.0454 8.92224C29.2094 8.75822 29.4284 8.1567 29.8109 8.43018C29.428 8.21162 30.467 7.33662 30.631 7.22715C31.1231 6.78964 31.7796 6.57107 32.2167 6.13359C32.3261 6.51655 32.0526 6.89913 31.8886 7.22715C31.7246 7.50065 31.7246 7.77414 31.5056 8.04725C31.2871 8.32074 31.0681 8.26581 31.4511 8.43021C31.6151 8.48476 31.6697 8.37567 31.8341 8.59423C31.8886 8.70371 31.8886 8.9772 31.8341 9.08629C31.8886 9.03175 31.9435 8.97682 31.9981 8.86773L32.0526 8.92227C32.2167 9.03175 32.3261 9.19577 32.2712 9.35979C32.1617 9.35979 32.0526 9.14122 31.9432 9.19577C31.7791 9.25031 31.9432 9.41433 31.8337 9.46926C31.7788 9.25031 31.7242 9.25031 31.6693 9.35979H31.5598C31.5053 9.30524 31.3958 9.25031 31.5053 9.14122C31.0678 9.08667 30.6302 8.81318 30.1382 8.86773C29.8647 8.86773 29.6461 9.25069 29.3726 9.08629C29.3726 9.19577 29.3181 9.30486 29.1541 9.25031C29.2086 9.14084 29.1541 9.14084 29.0995 9.19577C29.045 9.25031 28.9901 9.35979 28.9901 9.41433C28.9355 9.46888 28.7166 9.7973 28.6071 9.68783C28.6071 9.63328 28.6616 9.63328 28.7166 9.63328H28.498C28.6075 9.74276 28.3885 9.7973 28.2794 9.52381C28.1154 9.85185 27.6779 9.63328 27.4044 9.68783C27.2949 9.68783 27.1309 9.7973 26.9669 9.7973C26.8574 9.7973 26.7483 9.7973 26.6389 9.74276C26.5843 9.74276 26.3654 9.63328 26.3654 9.63328C26.3654 9.63328 26.0919 9.68783 26.0373 9.74276C25.8188 9.7973 25.6544 9.96133 25.4903 9.90678C25.6544 9.74276 25.7638 9.57874 25.9824 9.46926C26.1464 9.35979 26.2559 9.41472 26.201 9.19577C26.201 8.92228 25.3809 8.64878 25.1074 8.59424C24.5604 8.53969 24.2324 8.86773 23.8498 9.25032C23.6312 9.46888 23.3028 10.0704 22.9202 9.74238C23.1388 10.1253 22.9202 9.74238 22.8657 9.9064C22.8657 10.0704 22.8657 10.1799 22.8111 10.3439C22.7566 10.4534 22.5926 10.7269 22.5926 10.8909C22.5926 10.9454 22.8111 10.6723 22.8111 10.6723C22.9206 10.6178 23.0297 10.5083 23.1392 10.6723C23.3577 10.8909 22.8657 11.0004 22.7016 11.0004C22.5376 11.0004 22.5376 10.8909 22.3736 10.8909C22.2641 10.8909 22.2096 10.9454 22.1001 10.9454C21.8262 10.8909 21.7171 10.3443 21.4982 10.0708C21.4982 10.1803 21.7168 10.4538 21.6077 10.5629C21.5531 10.6174 21.2796 10.2894 21.1702 10.3443C20.9516 10.3988 20.7872 10.7273 20.6232 10.8913C20.5686 10.9458 20.4591 10.9458 20.4046 11.0008C20.2951 11.1648 20.6781 11.0553 20.3501 11.2193C20.5141 11.3834 20.1315 11.3288 20.1315 11.4928C20.1315 11.5474 20.2955 11.5474 20.2955 11.6568C20.2955 11.8754 20.0769 11.8754 19.9675 11.7114C20.0769 11.9849 19.7489 12.0394 19.53 11.9849C19.2565 11.9303 19.147 11.7114 19.0379 11.4379C18.9284 11.1644 18.8739 10.8909 18.6549 10.6178C18.6004 10.5083 18.272 10.2348 18.4909 10.1257C18.3269 10.0712 18.3814 9.85225 18.5454 9.90718V9.74278C18.436 9.96134 18.2174 9.68823 18.0534 9.68823C17.8894 9.68823 17.7799 9.85225 17.6704 9.9068C17.5064 9.96134 17.397 10.0159 17.233 10.0159Z",
    fill: "currentColor"
  })), _path25 || (_path25 = /*#__PURE__*/react.createElement("path", {
    d: "M17.3427 9.9611C17.2881 9.9611 17.2879 10.0159 17.233 10.0159L17.3427 9.9611Z",
    fill: "currentColor"
  })), _path26 || (_path26 = /*#__PURE__*/react.createElement("path", {
    d: "M26.2561 4.82096C26.1466 4.76642 25.8186 4.82096 25.9826 4.65694C26.0371 4.6024 26.3656 4.6024 26.4746 4.6024C26.4201 4.65694 26.3106 4.82096 26.2561 4.82096Z",
    fill: "currentColor"
  })), _path27 || (_path27 = /*#__PURE__*/react.createElement("path", {
    d: "M33.0367 6.24266C32.9822 6.35214 32.7087 6.46123 32.7087 6.62563C32.7632 6.8442 33.0367 6.68017 33.1462 6.62563C33.0367 6.78965 33.3102 6.78965 33.3648 6.7351C33.6383 6.68056 33.5833 6.51654 33.5833 6.29759C33.6379 6.13357 33.5288 6.18811 33.6379 6.02409C33.6379 6.02409 33.9659 5.7506 33.9114 5.7506C33.7477 5.69567 33.0917 6.02371 33.0367 6.24266Z",
    fill: "currentColor"
  })), _path28 || (_path28 = /*#__PURE__*/react.createElement("path", {
    d: "M32.0523 7.88308C31.8883 7.93763 31.9429 8.0471 31.8883 8.15658C31.8338 8.26605 31.7243 8.21112 31.6697 8.32059C31.8338 8.37514 32.1073 8.26605 32.2713 8.10203C32.3258 8.04748 32.4898 7.55504 32.3258 7.66451C32.2163 7.71906 32.3258 7.88308 32.2713 7.99255C32.2709 7.88308 32.1614 7.77399 32.0523 7.88308Z",
    fill: "currentColor"
  })), _path29 || (_path29 = /*#__PURE__*/react.createElement("path", {
    d: "M31.8335 11.4922C31.779 11.1641 32.107 11.0001 32.3256 10.8361C32.5441 10.5626 32.6536 10.2891 32.8176 10.016C32.9816 9.74251 33.2006 9.52395 33.4192 9.30501C33.6377 9.08644 33.8021 8.75802 34.0207 8.59401C34.4037 8.42999 34.4582 8.64856 34.5127 8.97698C34.5673 9.19555 34.7862 9.41449 34.7862 9.57851C34.7317 9.96148 34.1302 10.016 34.2942 10.5081C34.1847 10.5081 34.1302 10.5081 34.0207 10.4535C33.9112 10.727 33.6377 10.891 33.4192 11.1096C33.1457 11.3282 32.9271 11.6017 32.6536 11.8206C32.5441 11.8752 32.3256 12.0392 32.2161 12.0392C31.9975 11.9843 31.9975 11.6562 31.8335 11.4922Z",
    fill: "currentColor"
  })), _path30 || (_path30 = /*#__PURE__*/react.createElement("path", {
    d: "M35.1693 9.25016C35.2787 8.97667 35.4427 9.14069 35.6613 9.19562C35.8253 9.25016 36.0443 9.35964 36.0443 9.08614C36.2083 9.19562 36.0988 9.46911 35.9897 9.52366C35.9352 9.52366 35.9352 9.41418 35.8803 9.41418C35.7708 9.41418 35.6617 9.46873 35.6068 9.52366C35.6613 9.5782 35.7162 9.63313 35.6613 9.74222C35.6068 9.74222 35.2783 9.5782 35.3333 9.79677C35.0052 9.74222 35.2238 9.46873 35.3878 9.35925C35.2787 9.30509 35.2242 9.30509 35.1693 9.25016Z",
    fill: "currentColor"
  })), _path31 || (_path31 = /*#__PURE__*/react.createElement("path", {
    d: "M36.1536 9.41431C36.3176 9.30484 36.0441 9.14081 36.2081 9.03134C36.3176 8.92187 36.5362 9.03134 36.5362 9.14082C36.5911 9.30522 36.1536 9.6878 36.1536 9.41431Z",
    fill: "currentColor"
  })), _path32 || (_path32 = /*#__PURE__*/react.createElement("path", {
    d: "M36.7001 0.282079C36.6456 0.336625 36.0986 0.118059 36.1531 0.00858564C36.2081 -0.0459599 36.7001 0.172986 36.7001 0.282079Z",
    fill: "currentColor"
  })), _path33 || (_path33 = /*#__PURE__*/react.createElement("path", {
    d: "M41.8404 1.92267C41.8949 1.97721 42.2234 2.14123 42.1684 1.92267C42.1139 1.86812 41.8953 1.86812 41.8404 1.92267Z",
    fill: "currentColor"
  })), _path34 || (_path34 = /*#__PURE__*/react.createElement("path", {
    d: "M21.9903 16.7966C22.0998 17.0152 22.3184 17.1247 22.3733 16.7966C22.3733 16.5231 22.0453 16.6326 21.9903 16.7966Z",
    fill: "currentColor"
  })), _path35 || (_path35 = /*#__PURE__*/react.createElement("path", {
    d: "M22.8106 19.0385C22.7561 18.9839 22.2091 18.2729 22.5371 18.3275C22.6466 18.3824 22.8106 18.929 22.8106 19.0385Z",
    fill: "currentColor"
  })), _path36 || (_path36 = /*#__PURE__*/react.createElement("path", {
    d: "M24.1778 20.515C23.9592 20.4604 24.1778 20.2415 24.3418 20.351C24.5058 20.46 24.3418 20.5695 24.1778 20.515Z",
    fill: "currentColor"
  })), _path37 || (_path37 = /*#__PURE__*/react.createElement("path", {
    d: "M26.9669 21.1164C26.7483 21.007 26.8029 20.6789 26.6388 20.5149C26.6388 20.5694 26.5294 20.5149 26.7483 20.4603C26.8578 20.4058 27.0764 20.4603 27.1858 20.5149C26.9669 20.6789 27.1858 21.007 26.9669 21.1164Z",
    fill: "currentColor"
  })), _path38 || (_path38 = /*#__PURE__*/react.createElement("path", {
    d: "M25.5998 23.3584C25.5453 23.3038 25.5453 23.2489 25.4904 23.2489C25.4358 23.3034 25.5449 23.3584 25.4358 23.3584C25.4904 23.1943 25.3813 23.0849 25.2172 23.0303C25.2718 23.1398 25.2718 23.2489 25.2172 23.3038C25.1078 23.0852 24.9987 22.9758 25.0532 22.8118C25.0532 22.7572 25.1627 22.7572 25.1627 22.6477C25.1627 22.5383 25.1081 22.4292 25.1081 22.3197C25.1627 22.1557 25.6551 22.1557 25.7642 22.2651C26.0377 22.4837 26.3112 23.1947 26.3658 23.5228C26.4203 23.7413 26.3658 24.1788 26.0377 24.1243C25.7638 24.0694 25.8733 23.5224 25.5998 23.3584Z",
    fill: "currentColor"
  })), _path39 || (_path39 = /*#__PURE__*/react.createElement("path", {
    d: "M40.4737 20.3509C40.2552 20.6243 39.8176 20.0774 39.9817 19.8588C40.0911 19.7493 40.3097 19.6948 40.4737 19.7493C40.7472 19.9137 40.4737 20.0777 40.4737 20.3509Z",
    fill: "currentColor"
  })), _path40 || (_path40 = /*#__PURE__*/react.createElement("path", {
    d: "M42.8247 22.6475C42.5512 22.3741 42.9887 22.1555 43.1528 22.4835C43.3713 22.8116 43.0978 22.8661 42.8247 22.6475Z",
    fill: "currentColor"
  })), _path41 || (_path41 = /*#__PURE__*/react.createElement("path", {
    d: "M26.5291 16.195C26.3105 16.2495 26.4196 15.812 26.4196 15.7575C26.4196 15.3745 26.2556 15.0465 26.1461 14.6639C26.2556 14.7185 26.5836 14.4999 26.6931 14.4999C26.9666 14.4999 27.0211 14.5544 27.0761 14.7734C27.2401 15.2655 27.0215 16.0309 26.5291 16.195Z",
    fill: "currentColor"
  })), _path42 || (_path42 = /*#__PURE__*/react.createElement("path", {
    d: "M23.85 25.8194C23.7405 25.7099 23.5765 25.7648 23.5765 25.6008C23.5765 25.5462 23.7405 25.3822 23.7951 25.3822C23.9046 25.4368 23.6856 25.8743 24.0686 25.6557C23.9591 25.7103 23.9046 25.7648 23.85 25.8194Z",
    fill: "currentColor"
  })), _path43 || (_path43 = /*#__PURE__*/react.createElement("path", {
    d: "M24.7249 25.7645C24.6703 25.7645 24.6154 25.8191 24.5609 25.8191C24.5609 25.4365 24.9438 25.4365 24.7249 25.7645Z",
    fill: "currentColor"
  })), _path44 || (_path44 = /*#__PURE__*/react.createElement("path", {
    d: "M25.5452 29.5924C25.4907 29.5924 25.4907 29.5378 25.4357 29.5378C25.3812 29.3193 25.8187 29.2644 25.5452 29.5924Z",
    fill: "currentColor"
  })), _path45 || (_path45 = /*#__PURE__*/react.createElement("path", {
    d: "M23.5219 34.1858C23.4124 34.2952 23.0843 34.1858 23.3033 34.0218C23.4669 33.8028 23.7404 34.0763 23.5219 34.1858Z",
    fill: "currentColor"
  })), _path46 || (_path46 = /*#__PURE__*/react.createElement("path", {
    d: "M17.6704 32.1077C18.0534 32.1077 17.561 31.7797 17.6704 32.1077V32.1077Z",
    fill: "currentColor"
  })), _path47 || (_path47 = /*#__PURE__*/react.createElement("path", {
    d: "M17.2878 32.9826C17.3972 33.2561 16.9048 32.8731 16.9048 32.764C16.9048 32.6 17.3423 32.272 17.3423 32.4905C17.5063 32.381 17.6158 32.6 17.5609 32.7091C17.6158 32.8731 17.4518 32.9277 17.2878 32.9826Z",
    fill: "currentColor"
  })), _path48 || (_path48 = /*#__PURE__*/react.createElement("path", {
    d: "M13.241 35.6076C13.1865 35.7716 13.3505 35.8811 13.4051 35.717C13.4596 35.6076 13.2956 35.553 13.241 35.6076Z",
    fill: "currentColor"
  })), _path49 || (_path49 = /*#__PURE__*/react.createElement("path", {
    d: "M14.0615 34.678C14.007 34.8421 14.2255 34.7875 14.2801 34.678C14.171 34.678 14.007 34.4045 14.0615 34.678Z",
    fill: "currentColor"
  })), _path50 || (_path50 = /*#__PURE__*/react.createElement("path", {
    d: "M12.4211 35.6074C12.2025 35.6074 12.1476 35.2794 11.8741 35.4979C11.9286 35.3339 11.7101 35.3339 11.7101 35.1699C11.7101 35.0059 11.8195 35.0604 11.9286 35.0059C12.1472 34.8964 12.4756 34.6229 12.6942 34.5683C12.9677 34.5138 13.1317 34.7869 13.4052 34.6229C13.4597 34.5683 13.4597 34.4589 13.5146 34.4043C13.6241 34.3498 13.6787 34.3498 13.8427 34.3498C13.6787 34.0763 13.8427 33.7482 14.0613 33.5842C14.2798 33.4202 14.6628 33.5297 14.8813 33.3107C14.8268 33.4202 14.9359 33.5293 15.0454 33.5293C15.0454 33.4748 15.0454 33.2013 15.0999 33.1463C15.2094 32.9823 15.2094 33.1463 15.2639 33.1463C15.4825 33.0918 16.1389 32.8728 16.1389 33.2009C16.4124 32.9823 16.631 33.4194 16.467 33.6384C16.6856 33.5838 16.5765 33.2554 16.85 33.2554C17.0685 33.2554 17.178 33.6384 17.342 33.7475C16.85 33.802 17.3966 33.857 17.1234 33.9661C17.014 34.0206 16.9049 33.9661 16.85 33.9661C16.9594 34.0206 17.014 34.0755 17.014 34.1846C16.85 34.1846 16.6859 34.0206 16.5219 33.9661C16.6314 34.1301 16.5765 34.1846 16.4674 34.2941C16.4128 34.2395 16.3579 34.2395 16.3034 34.2395L16.1939 34.349C15.9204 34.4036 15.8658 34.2395 15.5923 34.4036C15.6469 34.2395 15.7564 34.2395 15.8109 34.0755C15.8109 34.2395 15.1548 33.857 15.5923 33.9115C15.3188 33.5835 14.7173 33.857 14.7723 34.2395C14.6082 34.1301 14.6628 34.349 14.5537 34.4036C14.3897 34.4581 14.2802 34.2941 14.0616 34.349C14.2256 34.4585 14.0616 34.513 13.9521 34.4585C13.8976 34.7865 14.1162 34.7865 14.1707 35.0055C14.2253 35.2241 14.0612 35.607 13.7877 35.443C14.0063 35.279 13.8972 35.1695 13.6783 35.1695C13.5688 35.1695 13.2953 35.3335 13.1862 35.3881C12.9676 35.4975 13.0767 35.4975 12.8582 35.4426C12.6945 35.5529 12.3665 35.3339 12.4211 35.6074Z",
    fill: "currentColor"
  })), _path51 || (_path51 = /*#__PURE__*/react.createElement("path", {
    d: "M31.9429 29.9752C31.8334 29.9206 31.4508 29.3736 31.3959 29.2642C31.3959 28.9907 31.7239 28.8812 31.9429 28.8267C32.982 28.6081 31.8334 29.2642 31.8883 29.3736C31.8883 29.5377 32.1618 29.3191 32.2713 29.3191C32.2709 29.5377 32.1614 29.9202 31.9429 29.9752Z",
    fill: "currentColor"
  })), _path52 || (_path52 = /*#__PURE__*/react.createElement("path", {
    d: "M30.4663 35.9902C30.3569 35.9357 30.3023 35.9357 30.2478 35.8262C30.2478 35.7717 30.3573 35.5527 30.4118 35.6622C30.4663 35.4982 30.2478 35.4436 30.2478 35.2792C30.3023 35.0607 30.5758 35.1698 30.6853 35.2792C30.9588 35.4982 30.7944 35.9902 30.4663 35.9902Z",
    fill: "currentColor"
  })), _path53 || (_path53 = /*#__PURE__*/react.createElement("path", {
    d: "M34.513 33.803C34.2944 33.9124 34.349 33.1469 34.6225 33.0374C35.0054 32.8734 35.552 33.5295 35.0054 33.639C34.9509 32.8734 34.2944 33.5844 34.5679 33.7484C34.5675 33.7484 34.513 33.803 34.513 33.803Z",
    fill: "currentColor"
  })), _path54 || (_path54 = /*#__PURE__*/react.createElement("path", {
    d: "M38.0676 14.8278C37.9036 14.7733 37.7941 14.6638 38.0131 14.6093C38.2316 14.5543 38.3411 14.7733 38.0676 14.8278Z",
    fill: "currentColor"
  })), _path55 || (_path55 = /*#__PURE__*/react.createElement("path", {
    d: "M40.8017 12.1485C40.6922 12.1485 40.4187 11.9845 40.5831 11.875C40.6926 11.8205 40.8566 12.0394 40.8017 12.1485Z",
    fill: "currentColor"
  })), _path56 || (_path56 = /*#__PURE__*/react.createElement("path", {
    d: "M41.7858 14.7732C41.8404 14.9373 42.1138 15.0467 42.1138 14.8278C42.0593 14.7183 41.8404 14.5543 41.7858 14.7732Z",
    fill: "currentColor"
  })), _path57 || (_path57 = /*#__PURE__*/react.createElement("path", {
    d: "M43.5906 14.0077C43.4811 14.1171 43.4266 13.6247 43.4266 13.6247C43.5906 13.6792 43.536 13.7887 43.6451 13.8433C43.6997 13.8978 43.8092 13.8978 43.8637 13.8978C43.9732 13.9524 44.1372 13.9524 44.2467 14.0073C44.7387 14.3903 43.9732 14.6634 43.8092 14.8823C43.7546 14.9918 43.8092 15.4293 43.5906 15.3744C43.372 15.3198 43.6451 14.8274 43.7001 14.7183C43.8095 14.5543 43.9735 14.4448 43.9186 14.1713C43.9186 14.0077 43.8092 13.8437 43.5906 14.0077Z",
    fill: "currentColor"
  })), _path58 || (_path58 = /*#__PURE__*/react.createElement("path", {
    d: "M43.8637 15.6482C43.9182 15.5388 44.0823 15.5388 44.2467 15.5937C44.1921 15.7028 44.0281 15.7028 43.8637 15.6482Z",
    fill: "currentColor"
  })), _path59 || (_path59 = /*#__PURE__*/react.createElement("path", {
    d: "M41.7857 16.9606C41.4577 16.8511 41.5672 16.4136 41.9497 16.4685C42.3323 16.578 42.0592 17.0155 41.7857 16.9606Z",
    fill: "currentColor"
  })), _path60 || (_path60 = /*#__PURE__*/react.createElement("path", {
    d: "M45.2855 19.2571C45.067 19.2026 45.1761 18.9836 45.3401 18.9836C45.6681 19.0931 45.559 19.6401 45.2855 19.2571Z",
    fill: "currentColor"
  })), _path61 || (_path61 = /*#__PURE__*/react.createElement("path", {
    d: "M48.6212 30.2485C48.4571 30.194 48.4026 29.7564 48.6212 29.811C48.8397 29.8655 48.6757 30.139 48.6212 30.2485Z",
    fill: "currentColor"
  })), _path62 || (_path62 = /*#__PURE__*/react.createElement("path", {
    d: "M47.1996 32.1625C47.0356 32.2719 46.6526 32.1079 47.0356 31.9984C47.0901 31.9984 47.5826 31.9984 47.5826 32.1079C47.528 32.2719 47.2545 32.1079 47.1996 32.1625Z",
    fill: "currentColor"
  })), _path63 || (_path63 = /*#__PURE__*/react.createElement("path", {
    d: "M47.637 35.4434C47.0355 35.2794 47.6916 34.4593 47.9105 34.8419C47.9105 34.7873 47.5825 35.0059 47.5825 35.1154C47.637 35.4434 48.0745 35.2249 48.184 35.334C48.6215 35.6075 47.637 35.4434 47.637 35.4434Z",
    fill: "currentColor"
  })), _path64 || (_path64 = /*#__PURE__*/react.createElement("path", {
    d: "M49.3871 35.5528C49.3871 35.5528 49.3871 35.6073 49.3325 35.6073C49.278 35.6073 49.2231 35.3888 49.1685 35.3888C49.5515 35.3888 49.3325 35.1153 49.5515 35.0607C49.77 35.0062 49.7155 35.6077 49.442 35.6077C49.5511 35.4979 49.4416 35.5528 49.3871 35.5528Z",
    fill: "currentColor"
  })), _path65 || (_path65 = /*#__PURE__*/react.createElement("path", {
    d: "M45.559 24.8349C44.9029 25.163 45.6135 25.71 45.9965 25.3819C46.2696 25.1084 45.887 24.6709 45.559 24.8349Z",
    fill: "currentColor"
  })), _path66 || (_path66 = /*#__PURE__*/react.createElement("path", {
    d: "M13.8971 34.1311C13.8971 34.0216 13.8971 33.8576 13.9517 33.7481C13.952 33.9125 13.8971 34.0216 13.8971 34.1311Z",
    fill: "currentColor"
  })), _path67 || (_path67 = /*#__PURE__*/react.createElement("path", {
    d: "M29.865 8.92198C29.9195 8.75796 30.0836 8.81251 30.193 8.86744C30.193 8.70342 29.8105 8.75796 29.865 8.92198Z",
    fill: "currentColor"
  })), _path68 || (_path68 = /*#__PURE__*/react.createElement("path", {
    d: "M16.1939 34.349C16.0844 34.4585 15.9757 34.4043 15.8113 34.4593C15.8659 34.2407 15.5928 34.4593 15.4833 34.4593C15.5382 34.0214 15.9753 34.2395 16.1939 34.349Z",
    fill: "currentColor"
  })));
};
const other_coutries_ForwardRef = /*#__PURE__*/(0,react.forwardRef)(SvgOtherCoutries);

/* harmony default export */ const other_coutries = (__webpack_require__.p + "e7a22ef8faa85f49990b1cfa207ef27d.svg");
;// CONCATENATED MODULE: ./src/assets/icons/africa.svg
var africa_path;
function africa_extends() { africa_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return africa_extends.apply(this, arguments); }


const SvgAfrica = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/react.createElement("svg", africa_extends({
    width: 26,
    height: 31,
    viewBox: "0 0 26 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/react.createElement("title", {
    id: titleId
  }, title) : null, africa_path || (africa_path = /*#__PURE__*/react.createElement("path", {
    d: "M13.725 30.869C13.6307 30.795 13.5149 30.7484 13.4677 30.7654C13.4138 30.7848 13.3819 30.733 13.3819 30.626C13.3819 30.5323 13.3433 30.3903 13.2961 30.3104C13.2275 30.1941 13.2275 30.1589 13.2961 30.134C13.4233 30.088 13.4003 29.8018 13.2449 29.4972C13.1695 29.3495 13.0436 29.0568 12.9651 28.8469C12.8865 28.637 12.7518 28.3808 12.6657 28.2776C12.5796 28.1744 12.463 27.9973 12.4067 27.8841C12.2937 27.6568 12.1094 26.7548 12.0362 26.0712C12.0008 25.7402 11.8971 25.4419 11.6186 24.8703C11.4149 24.452 11.2037 24.0325 11.1494 23.9381C11.0199 23.713 11.0219 23.0631 11.1537 22.5762C11.2114 22.3628 11.2886 22.0766 11.3252 21.9403C11.3617 21.8039 11.4716 21.6124 11.5694 21.5146C11.825 21.259 11.8568 20.8843 11.67 20.3312C11.5595 20.0042 11.5383 19.8578 11.5919 19.7932C11.6461 19.7279 11.5921 19.4975 11.3876 18.9219C11.0935 18.0937 10.9203 17.7813 10.5015 17.3238C10.3593 17.1684 10.1751 16.9071 10.0921 16.7431C9.9507 16.4637 9.94789 16.4309 10.0474 16.2212C10.1058 16.0981 10.166 15.8617 10.1813 15.6959C10.1966 15.53 10.2463 15.2514 10.2918 15.0766C10.3807 14.7351 10.327 14.5605 10.0236 14.2065C9.89351 14.0547 9.86731 14.051 9.38901 14.1173C8.96219 14.1765 8.87254 14.1705 8.76845 14.0763C8.70153 14.0158 8.64678 13.9199 8.64678 13.8632C8.64678 13.8066 8.56523 13.6533 8.46555 13.5227L8.28432 13.285L7.72783 13.3171C7.4097 13.3354 7.08316 13.396 6.96547 13.4585C6.85224 13.5187 6.553 13.6507 6.30049 13.7519C5.86359 13.9271 5.81988 13.9319 5.39688 13.8521C4.92204 13.7625 4.73494 13.7827 4.07629 13.9945C3.77352 14.0918 3.61203 14.1114 3.49297 14.065C3.40242 14.0297 3.05135 13.7625 2.7128 13.4711C2.37425 13.1798 2.02657 12.9092 1.94016 12.8699C1.76547 12.7903 1.5784 12.4661 1.5784 12.2429C1.5784 12.114 1.26131 11.6705 0.93824 11.3474C0.87465 11.2838 0.790859 11.1724 0.752034 11.0999C0.71321 11.0273 0.639758 10.968 0.588811 10.968C0.414538 10.968 0.273586 10.6462 0.289334 10.2842C0.300042 10.0381 0.271494 9.90617 0.189886 9.82457C0.0830154 9.7177 0.0844658 9.6974 0.211758 9.51863C0.358552 9.31248 0.613392 8.44371 0.616032 8.14043C0.616918 8.03841 0.582227 7.8772 0.538934 7.78219C0.478228 7.64895 0.480085 7.58549 0.547051 7.5048C0.617863 7.41948 0.613102 7.36846 0.521246 7.22827C0.459295 7.13372 0.375985 7.05636 0.336112 7.05636C0.154431 7.05636 0.665049 5.91406 1.02633 5.51229C1.0942 5.43681 1.18851 5.25413 1.23589 5.10635C1.28327 4.95856 1.41832 4.73882 1.536 4.61803C1.65368 4.49725 1.79988 4.30631 1.86089 4.19374C1.93137 4.06369 2.04446 3.97453 2.17103 3.94921C2.40666 3.90209 2.9361 3.49951 3.06275 3.27117C3.11179 3.18276 3.15331 3.00233 3.15501 2.87023C3.15672 2.73813 3.23181 2.47178 3.32187 2.27835C3.48151 1.9355 3.55326 1.86297 4.04727 1.54505C4.27822 1.39642 4.43334 1.20145 4.68309 0.745904L4.80258 0.527937L4.95759 0.702404C5.09549 0.857621 5.16938 0.878045 5.62728 0.887514C6.1007 0.897306 6.17961 0.877777 6.61154 0.643928C7.15525 0.349553 7.85973 0.182887 8.46572 0.205262C8.69938 0.213889 8.93604 0.192834 8.99163 0.158474C9.04723 0.124112 9.29348 0.0915495 9.53885 0.0861124C9.78421 0.0806773 10.0747 0.0518491 10.1844 0.0220528C10.338 -0.0196657 10.404 -0.00456389 10.4715 0.0877375C10.5197 0.153661 10.5921 0.187242 10.6323 0.162363C10.7259 0.104569 10.7246 0.145652 10.626 0.361909C10.5606 0.505569 10.567 0.559039 10.6623 0.664353C10.7971 0.813356 10.7244 1.10636 10.5344 1.17925C10.3868 1.2359 10.4243 1.53171 10.5793 1.53297C10.6419 1.53345 10.75 1.58537 10.8196 1.64828C10.9944 1.80651 11.2885 1.90948 11.5655 1.90948C11.8996 1.90948 12.2623 2.10349 12.3574 2.33299C12.4081 2.45528 12.5062 2.54373 12.6186 2.56845C12.9769 2.64727 13.2722 2.75386 13.4925 2.88386C13.6703 2.98877 13.7468 3.00069 13.8584 2.94093C14.0101 2.85975 14.0177 2.83686 14.0274 2.43273C14.0322 2.23341 14.0768 2.13476 14.2054 2.03893C14.5044 1.81613 14.7564 1.80865 15.0584 2.01359C15.2068 2.11426 15.4384 2.2139 15.5731 2.23502C15.7079 2.25614 15.8428 2.31506 15.873 2.36595C15.9032 2.41684 16.0196 2.45848 16.1318 2.45848C16.2439 2.45848 16.5622 2.52514 16.8391 2.6066L17.3426 2.75471L17.6485 2.6066C18.2196 2.33017 18.4526 2.41807 18.5352 2.94106C18.5666 3.13925 18.6674 3.44372 18.7592 3.61766C18.8511 3.7916 19.0549 4.19641 19.2121 4.51723C19.3693 4.83805 19.58 5.23951 19.6804 5.40936C19.7807 5.5792 19.8543 5.75815 19.844 5.80701C19.8194 5.92344 20.082 6.34576 20.2093 6.39463C20.3584 6.45184 20.4938 6.83414 20.5497 7.35551C20.5952 7.78086 20.6227 7.84252 20.87 8.07337C21.0716 8.26154 21.1755 8.43964 21.2777 8.77199C21.4348 9.2829 21.5397 9.47087 21.5935 9.33814C21.6503 9.19838 21.7444 9.24054 21.7057 9.38839C21.6799 9.48728 21.7157 9.54174 21.837 9.58786C22.0172 9.65636 22.7528 10.3897 22.9208 10.6683C23.0144 10.8234 23.0127 10.8452 22.9023 10.9076C22.7938 10.969 22.8115 11.0056 23.0695 11.2535C23.3807 11.5525 23.354 11.5492 24.0874 11.3769C24.2573 11.3369 24.6178 11.2615 24.8886 11.2092C25.1594 11.1569 25.4744 11.0658 25.5886 11.0067C25.7028 10.9477 25.8255 10.8994 25.8614 10.8994C25.9668 10.8994 25.9929 11.5385 25.8917 11.642C25.8429 11.6919 25.803 11.7917 25.803 11.8637C25.803 11.9887 25.5387 12.5898 24.9903 13.7118C24.7309 14.2428 24.2177 14.8195 23.3797 15.5221C23.1608 15.7056 22.8121 16.0979 22.6047 16.3939C22.3973 16.6898 22.1542 16.9875 22.0646 17.0553C21.8875 17.1892 21.3424 18.3398 21.3424 18.5797C21.3424 18.661 21.3916 18.8026 21.4518 18.8944C21.512 18.9862 21.547 19.1009 21.5297 19.1493C21.5124 19.1977 21.525 19.2895 21.5578 19.3532C21.5922 19.4203 21.5909 19.4855 21.5547 19.5078C21.4679 19.5615 21.65 20.311 21.7716 20.4006C21.8449 20.4547 21.8797 20.7301 21.9115 21.5083C21.9476 22.3933 21.9376 22.5682 21.8434 22.7093C21.6188 23.0456 21.3689 23.271 21.0825 23.3957C20.7894 23.5232 19.7228 24.4972 19.6618 24.693C19.6442 24.7496 19.6708 24.9144 19.721 25.0593C19.8195 25.3436 19.8671 26.192 19.7969 26.4131C19.7732 26.488 19.5745 26.6396 19.3551 26.7504C18.8278 27.0165 18.7296 27.1211 18.7783 27.3645C18.8378 27.6623 18.6252 28.3088 18.4243 28.4404C18.3311 28.5014 18.1489 28.7258 18.0194 28.939C17.786 29.3233 16.9136 30.2273 16.6326 30.3761C16.2754 30.5653 15.7815 30.6876 15.3377 30.6967C14.8134 30.7074 14.1468 30.8318 14.0397 30.9389C13.9485 31.0301 13.9236 31.0246 13.725 30.869H13.725ZM19.7771 21.533C19.7703 20.9215 19.6709 20.3177 19.5587 20.2055C19.4473 20.094 19.4194 20.1938 19.4924 20.4428C19.5304 20.5724 19.5426 20.7945 19.5194 20.9364C19.4691 21.2442 19.6209 22.1673 19.7166 22.1354C19.7539 22.1229 19.7808 21.856 19.7771 21.533ZM18.3563 19.6319C18.3289 19.5659 18.264 19.3764 18.2122 19.2109C18.1604 19.0455 18.0665 18.8724 18.0035 18.8263C17.9395 18.7795 17.9068 18.6956 17.9296 18.6364C17.9773 18.512 17.7949 17.759 17.6929 17.6589C17.6453 17.6123 17.638 17.7773 17.6701 18.1736C17.7059 18.6157 17.7567 18.8179 17.8802 19.0087C17.9697 19.1472 18.0639 19.3479 18.0895 19.4548C18.1525 19.718 18.1766 19.752 18.3 19.752C18.3744 19.752 18.3913 19.716 18.3563 19.6319ZM19.3015 16.9974C19.2429 16.9387 19.2653 16.8572 19.3907 16.6726C19.7208 16.1867 19.5332 15.816 19.0396 15.9789C18.7388 16.0782 18.666 16.2175 18.666 16.6937V17.0756H19.0229C19.2901 17.0756 19.3601 17.056 19.3015 16.9974ZM23.1876 26.9233C22.9553 26.7971 22.8696 26.5647 22.813 25.9085C22.7762 25.4821 22.7878 25.3503 22.8702 25.2566C22.927 25.1919 23.0392 25.0083 23.1195 24.8485C23.2538 24.5815 23.2593 24.5197 23.1874 24.0845C23.1195 23.6731 23.1251 23.5695 23.2302 23.2942C23.2967 23.1199 23.3943 22.9774 23.4471 22.9774C23.6158 22.9774 24.2316 22.6319 24.4364 22.4224C24.5454 22.3109 24.6537 22.1432 24.6772 22.0496C24.7007 21.956 24.7493 21.8794 24.7852 21.8794C24.821 21.8794 24.83 21.8464 24.8051 21.8062C24.7782 21.7625 24.8095 21.7417 24.8828 21.7547C24.975 21.771 25.0213 21.712 25.0681 21.5191C25.1024 21.3776 25.1578 21.2617 25.1913 21.2617C25.361 21.2617 25.6529 22.4878 25.5559 22.7934C25.5167 22.917 25.5057 22.9195 25.4483 22.817C25.3391 22.6218 25.2608 22.6914 25.3023 22.9468C25.324 23.081 25.3108 23.2586 25.2727 23.3414C25.2347 23.4243 25.1419 23.7082 25.0663 23.9724C24.818 24.8414 24.167 26.633 24.0613 26.7387C23.9728 26.8272 23.5063 27.0277 23.4012 27.0225C23.3823 27.0215 23.2862 26.9769 23.1876 26.9233ZM0.457521 11.1967C0.374165 11.1134 0.410108 11.0403 0.514712 11.0804C0.571327 11.1022 0.617649 11.1475 0.617649 11.1812C0.617649 11.2532 0.523105 11.2623 0.457521 11.1967Z",
    fill: "currentColor"
  })));
};
const africa_ForwardRef = /*#__PURE__*/(0,react.forwardRef)(SvgAfrica);

/* harmony default export */ const africa = (__webpack_require__.p + "b713ebc14a4e77a5d2ff04151514ce84.svg");
;// CONCATENATED MODULE: ./src/assets/icons/europe.svg
var europe_path, europe_path2;
function europe_extends() { europe_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return europe_extends.apply(this, arguments); }


const SvgEurope = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/react.createElement("svg", europe_extends({
    width: 46,
    height: 32,
    viewBox: "0 0 46 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/react.createElement("title", {
    id: titleId
  }, title) : null, europe_path || (europe_path = /*#__PURE__*/react.createElement("path", {
    d: "M0.83261 9.57635H1.16453L1.46878 9.53561L2.02198 9.87779H2.1695L2.40921 10H2.66737L2.87943 9.93482L3.11915 9.69855L3.31276 9.65782L3.39574 9.53561L3.54326 9.60893L3.66312 9.53561L3.99503 9.25046L4.38227 9.16083L4.57589 8.9816V8.85939L4.83404 8.73718L4.9539 8.59868L4.77873 8.46832H5V8.35426L4.94468 8.2239L5 8.02444L4.92885 7.91402L4.72058 7.84041L4.65116 7.75453H4.44985L4.46373 7.49075L4.35265 7.41714L4.34571 7.24538L4.13745 7.31899L4.03332 7.18403L3.92919 7L3.73482 7.04294L3.72093 7.32512L3.49879 7.39874L3.36689 7.34353L3.2697 7.53369H3.1378L3.0059 7.3742H2.9163V7.50302L2.97813 7.69319L2.95037 7.77907L2.85318 7.61344L2.72822 7.52756L2.61021 7.31285L2.35335 7.52142L2.38112 7.75453L2.25616 7.79134L1.97848 7.3926L1.87435 7.43554L1.95071 7.66251L1.93683 7.93243L1.67303 7.88949L1.51337 8.25755L1.45783 8.09805L1.40229 7.90789L1.29816 7.77907L1.45089 7.61958L1.3537 7.50302L1.2218 7.44781L0.902465 7.03681L0.673378 7.06134L0.603957 7.14109L0.666438 7.19017L0.791392 7.14109L0.902465 7.22697L0.71503 7.29445L0.7428 7.34353L0.902465 7.411L0.958001 7.61958L0.839988 7.51529L0.763626 7.50302L0.721975 7.54596L0.54148 7.31899L0.437352 7.36193L0.395696 7.47848L0.295038 7.49075L0.433877 7.61958L0.295038 7.63798L0.406111 7.70852L0.54495 7.776L0.465118 7.88028L0.204791 7.74226L0.242972 7.87109L0.204791 7.9447L0.0451261 7.88028L0 7.97537L0.239501 8.07658L0.454707 7.97537L0.687264 7.91402L0.812222 7.90175L0.881639 7.84654L0.985772 7.92323L1.20792 8.03364L1.15585 8.12566L0.895525 8.26982L1.09337 8.35877L1.2218 8.27595L1.22527 8.43544L1.11767 8.5H0.822633L0.562305 8.5704L0.312393 8.59494L0.295038 8.71456L0.402641 8.65935L0.600486 8.64401L0.951061 8.66548L1.03436 8.79124L1.03089 8.9538L1.23915 8.83111L1.20097 8.99061L1.2461 9.03355L1.40923 9.07956L1.23915 9.22372L1.22527 9.34947L1.04131 9.45682L0.892054 9.48442L0.808747 9.46295L0.791392 9.51816L0.83261 9.57635Z",
    fill: "currentColor"
  })), europe_path2 || (europe_path2 = /*#__PURE__*/react.createElement("path", {
    d: "M42.4156 21.8336L42.7136 21.7646L42.8327 21.4098L42.4653 21.2324L42.4156 21.1141H42.1574L42.217 20.9761L41.9389 20.8184L41.0582 20.2369L40.9126 19.9477V19.6586L41.3363 18.7124L41.3628 18.2261L41.0715 17.8844H40.4888L39.628 18.1078L39.2308 17.937L39.0189 17.5427L38.7805 17.3213L38.8559 16.7653L40.2241 15.4633L40.2372 15.1772L40.0518 14.7566L39.1135 14.8223L38.7607 14.2165L39.0189 13.7532L39.6218 13.3559L40.2749 11.7471L40.6305 9.55232L41.5197 8.21182L43.669 7.19988L44.8608 6.26679L45.7711 4.98024L46 4.1282L45.5342 3.4018L44.7132 2.9024L44.1305 2.42929L43.4684 2.14016L42.7136 2.03174L42.5447 1.9036L42.3461 1.96274L42.3262 2.10073L42.1472 2.16088L42.1123 2.35384L42.3118 2.66059L42.2918 2.86344L42.4713 3.00198L42.4613 3.25925L42.247 3.4819L41.9379 3.50663L41.8731 3.5858L41.9927 3.79854L41.8182 3.99645L41.6238 3.96676L41.4941 3.84308L41.5241 3.66496L41.549 3.50169L41.6537 3.46706L41.5141 3.20978L41.4991 3.09599L41.2997 3.15536L41.0205 3.30873L40.8361 3.40274L40.7463 3.60064L40.5968 3.76392L40.4223 3.72433L40.3325 3.64022H40.0334L39.9387 3.59569L39.7293 3.71938L39.5847 3.77875L39.4202 4.06077L39.4003 4.27352L39.2058 4.10035H39.156L38.9765 4.417L38.9266 4.33784L38.9665 4.17457L38.5577 4.13499V4.01624L38.7621 3.89255L38.9067 3.88266L38.8768 3.77381L38.822 3.66002L38.8469 3.45716L38.8918 3.33347L38.8369 3.28895L38.7671 3.19989L38.6176 3.22463L38.1639 3.57591L38.2486 3.71939L38.2985 3.90246L38.0891 4.01625L38.0343 3.96183L38.0891 3.89256L38.0642 3.80351L37.8947 3.74414L37.7252 3.79361L37.6354 3.89749L37.2765 4.01624L37.0372 4.27351L36.8577 4.42689L36.5536 4.605L36.4738 4.66438L36.3392 4.65943L36.3143 4.75839L36.399 4.83755L36.2694 4.87218L35.8855 4.99587L35.8407 5.38673L35.7958 5.60937L35.7709 5.85181L35.5017 5.90623L35.2823 5.97549L34.9483 5.94086L34.7588 5.84686L34.699 5.61432L34.5843 5.47579L34.4099 5.40157L34.365 5.14924L34.5694 4.96123V4.78807L34.7389 4.70396L35.1527 4.67427L35.2225 4.60995L35.1776 4.48131L35.1278 4.27351L34.9832 4.01129L34.7987 3.86285L34.5544 3.73917L34.2653 3.73422L33.9761 3.73917L33.8066 3.67979L33.6321 3.55116L33.6072 3.59074L33.7019 3.72433L33.8365 3.82823L34.011 3.97171L34.0409 4.16467V4.46647L34.011 4.74354L33.9013 5.06018L33.8415 5.31251L33.8166 5.45599L33.8515 5.52031L34.0409 5.59948L34.1456 5.78748L34.1855 5.97054L34.1406 6.04476L34.1357 6.09918L34.2104 6.16845L34.1357 6.28224L34.0509 6.49994L33.9562 6.70279L33.9711 6.7869L34.011 6.8809L33.9562 7.01944L33.8964 6.90564L33.7468 6.79679L33.6421 6.74237L33.672 6.683L33.6072 6.62858L33.5424 6.60384V6.51478H33.4178L33.328 6.54447L33.0688 6.37625L32.9043 6.56921L32.67 6.86607L32.4656 6.95512L32.296 7.0046L32.1963 7.14313L32.1116 7.29156L31.9471 7.39051L31.8125 7.50926L31.7776 7.65274L31.8324 7.85064L32.0119 8.13266L32.1914 8.53094L32.1839 8.70164L32.0567 8.73874L31.9147 8.54578L31.8174 8.62742L31.81 8.78327L31.638 8.7239L31.4211 8.58289L31.2341 8.50868L31.0621 8.54578L30.9799 8.62L30.9425 8.5161L31.0098 8.42705L30.8677 8.36767L30.7481 8.31573V8.18214L30.4041 8.03371L30.3218 8.07823V8.26377L30.1498 8.29345L30.1872 8.44188L30.3143 8.63484L30.4116 8.8278L30.5536 8.93912L30.7107 8.84264L30.8004 8.87233L30.9088 9.03931L30.8565 9.1395L30.9425 9.33988L30.8715 9.4512L30.6583 9.63302L30.4489 9.58107L30.2059 9.44377L29.9741 9.39182L29.9479 9.18402L29.6899 8.97251L29.5628 9.06157L29.2711 8.77213L29.3048 8.39735L29.2076 8.26376L29.1702 7.98175L29.058 7.81105L29.1777 7.55872L29.2375 7.43256L29.1777 7.31382L29.2151 7.22476L29.2973 7.28413L29.2898 7.13571L29.1851 6.99841L28.9945 6.81658L28.7626 6.70526L28.643 6.62733V6.47519L28.5383 6.42324L28.5009 6.26739L28.3476 6.13751L28.2354 6.08556L28.1719 5.9594L28.0784 5.87035L28.1195 5.77015L28.0784 5.6811L27.9812 5.59205V5.49928L28.0859 5.52154L28.1382 5.55123L28.2616 5.65513L28.3813 5.84066L28.557 5.98538L28.6392 6.05217L28.6766 5.94456L28.8 6.06701L28.9533 6.11154L29.0992 6.15607L29.1478 6.30079L29.3011 6.20802L29.4618 6.33047L29.66 6.47519L29.8731 6.53827L30.1199 6.57538L30.3555 6.63475L30.5686 6.69783L30.7668 6.81286L30.9126 6.88708L31.2155 6.8574L31.4697 6.81658L31.6754 6.71268L31.8623 6.62733L32.0792 6.45664L32.24 6.25997L32.3671 6.08928L32.4606 5.94827L32.5017 5.75531L32.5466 5.55122L32.4269 5.41763L32.3708 5.13562L32.3783 4.91298L32.1914 4.72373L31.9782 4.60869L31.9147 4.51221L31.6492 4.38976L31.2828 4.01869H31.0547L30.9799 3.87768L30.6509 3.49548L30.3592 3.22088L30.0601 3.00195L29.6563 2.80157L29.4768 2.74591L29.3011 2.77931L29.0842 2.71994L28.9085 2.65315L28.6953 2.70881L28.6654 2.87208L28.5271 3.00195L28.4822 2.95744L28.5719 2.82015V2.527L28.3925 2.4565L28.1083 2.40083L27.8952 2.24127L27.8652 2.13737L27.9475 2.03347L28.0709 2.16335L28.2541 2.24127L28.3738 2.19675L28.3999 2.08914L28.3364 1.98153H28.1532L28.0634 1.9036L27.9475 1.78115L27.8391 1.80712V1.98524L27.7493 2.01121V2.07429L27.7718 2.17077L27.6409 2.18191L27.5549 2.07059L27.3867 2.0038L27.1773 1.97411L27.0314 1.85907L26.9754 1.89247L26.9043 2.08172L26.766 1.99266L26.7921 1.91103L26.766 1.80713L26.6463 1.73662L26.4967 1.62159L26.3061 1.55851L26.1303 1.47316L26.1528 1.35071L26.3248 1.41008L26.5304 1.45461L26.751 1.51398L26.9006 1.49171L27.0427 1.35071L27.2147 1.24681H27.353L27.3754 1.12064L27.3193 0.998191L27.2408 1.03901L27.1997 0.949954L27.1623 0.849765L26.9193 0.916555L26.8707 0.849765L26.9716 0.727311L26.837 0.619702L26.7248 0.723601L26.7099 0.578884L26.5416 0.634546L26.4706 0.604858L26.5117 0.512088L26.3547 0.330262L26.2388 0.426742L26.1116 0.593723V0.83863L26.1378 0.92026L26.0481 0.935104L25.8686 0.901706L25.8237 0.816361L25.9247 0.716171L25.9808 0.612272L25.8611 0.671644L25.7452 0.693908L25.7826 0.604853L25.8574 0.556615L25.8237 0.489824L25.891 0.411898L25.9994 0.37108L26.063 0.330262L26.0817 0.233783L25.9434 0.17812L25.9022 0.029689L25.7452 0.0964795L25.6629 0L25.6106 0.0482373L25.6592 0.192954L25.5208 0.163266L25.4573 0.222638L25.5882 0.378489L25.6293 0.460125L25.4087 0.649369V0.860883L25.2853 0.99818L25.1095 1.09837L25.0871 0.90541V0.675348L25.0572 0.564025L25.1843 0.437861L25.0572 0.315408L24.9376 0.538056L24.8777 0.716171L24.773 0.864598L24.6235 1.02787L24.5936 1.30246L24.4291 1.54737L24.2832 1.47315L24.3244 1.20228L24.4365 0.949949L24.3617 0.842339L24.5076 0.705042L24.5861 0.54919L24.717 0.426737L24.6796 0.359946L24.5749 0.274601L24.5337 0.393344L24.4103 0.319128L24.2234 0.230073L24.1486 0.441582L24.0215 0.389629L23.9953 0.474974L24.1748 0.575164L24.1262 0.723596L24.0402 0.656805L23.9542 0.738441L23.9841 0.920266L23.8495 0.901712L23.8682 0.74586L23.7971 0.601143L23.7186 0.534351L23.6812 0.593723L23.7111 0.753284L23.756 0.83863L23.7785 0.935109L23.6812 1.07983L23.5354 1.25052L23.513 1.47687L23.6027 1.64014C23.6027 1.64014 23.4644 1.72178 23.4531 1.72549C23.4419 1.7292 23.2924 1.58819 23.2924 1.58819L23.2064 1.43976L23.2587 1.35813L23.0792 1.30617L23.1017 1.41378L23.0568 1.48057L22.9596 1.38038L22.9334 1.23196L22.8287 1.20598L22.7539 1.31359L22.6231 1.26536L22.4735 1.31359L22.5483 1.48429L22.6979 1.5214L22.8399 1.60674L22.8063 1.73662L22.8325 1.84794L22.6754 1.78486L22.5034 1.65498L22.4548 1.80713L22.3912 1.82568L22.3464 1.91845L22.2604 1.88134L22.2978 1.7626L22.2342 1.61417L22.208 1.77002L22.1819 1.92587L22.1407 2.04832L22.0809 2.18191L22.1333 2.28952L22.0473 2.31921L21.9575 2.36374L21.9351 2.25242L21.9687 2.02607L21.9575 1.88877L22.0024 1.69952L21.9351 1.70323L21.8341 1.95184L21.7481 2.09656L21.778 2.23386L21.6958 2.20789L21.6397 2.09656L21.6659 1.97782L21.5612 1.98895L21.3555 2.04461L21.3368 1.95184L21.4901 1.84051L21.6285 1.70322L21.606 1.60303L21.5126 1.59932L21.4565 1.64014L21.4004 1.5585L21.206 1.72177L21.2621 1.8368H21.1798L21.1013 1.97781L20.9704 2.1485L20.933 2.21529L20.9592 2.25982L21.105 2.26724L21.191 2.21529L21.2022 2.08542L21.2658 2.06315L21.2994 2.20416L21.3518 2.32661L21.378 2.44907L21.5275 2.53812L21.5462 2.71624L21.4714 2.79045L21.4116 2.74592L21.4341 2.63832L21.3443 2.527L21.2172 2.35259L21.0863 2.42681L21.1686 2.63461L21.0602 2.65316L21.0003 2.46763H20.933L20.8582 2.54184L20.8134 2.42681L20.6003 2.27838L20.4918 2.3897L20.5143 2.49731L20.346 2.59379V2.69398L20.3011 2.75706L20.331 2.8387L20.3011 2.87952V2.94631L20.4694 2.85354L20.5479 2.79046L20.7199 2.81272L20.8209 2.69769L20.9031 2.86467L20.7124 2.93146L20.5965 3.01681L20.5517 3.21347L20.5778 3.33222L20.4245 3.48435L20.1778 3.55857L20.0581 3.52517V3.36932L19.9272 3.30253V3.46209L19.7964 3.51404L19.7739 3.37675L19.7178 3.30624L19.7627 3.16523L19.5945 3.23945V3.42127H19.4898L19.4225 3.15781L19.3589 3.19121L19.2692 3.35448L19.157 3.36562L19.0224 3.50663L19.0672 3.5994L19.228 3.48437L19.3364 3.4621L19.2542 3.61053L19.3925 3.58827L19.4972 3.50292L19.5832 3.52519V3.62167L19.4411 3.74783L19.4187 3.82205L19.2804 3.83318L19.1532 3.90368L19.0224 3.99273L18.8279 4.01871L18.7195 4.06694L18.5849 4.21166L18.4652 4.28217L18.3232 4.33412L18.2446 4.55305L18.4765 4.41204L18.6148 4.28959L18.8092 4.10777L18.9513 4.10406L18.9663 4.17827L19.1121 4.08179L19.2654 3.97047L19.4673 3.85544L19.5757 3.97418L19.6954 3.86286L19.8487 3.71814L19.9272 3.66248L19.9945 3.81091L20.2226 3.78493L20.4619 3.67732L20.6414 3.71443L20.6937 3.86657L20.4918 3.87028L20.2787 3.98531L20.1478 3.8777L19.8973 4.00758L20.0618 4.16714L19.9908 4.38978L19.9459 4.48626L19.8749 4.39349L19.815 4.1189L19.6916 4.24506L19.4972 4.25619L19.4598 4.37865L19.6019 4.35267L19.7141 4.38978L19.7814 4.49739L19.643 4.49368L19.4935 4.57532L19.4187 4.59016L19.3589 4.46029L19.2729 4.57532L19.2205 4.69035L19.314 4.76086L19.4561 4.69035L19.5832 4.70149L19.5944 4.82765L19.4449 4.85734L19.4187 4.90557L19.5682 5.0874L19.4748 5.10224L19.3103 4.96123L19.1644 5.08369L19.1457 5.22841L19.2243 5.33972L19.4112 5.32488L19.5009 5.37683L19.5832 5.46218L19.5458 5.59576L19.4336 5.48816L19.2953 5.44734L19.1308 5.45105L19.0074 5.51784L18.8429 5.644L18.7083 5.83696L18.7045 5.91489L18.7756 5.97055L18.7307 6.05589L18.4764 6.08558L18.3979 6.3676L18.368 6.45665L18.4428 6.542L18.5886 6.59766L18.5587 6.62735L18.4166 6.63477L18.3979 6.7869L18.2035 6.86483L18.3007 6.96873L18.2783 7.00955L18.1624 6.98728L18.1362 7.02439L18.1624 7.20251L17.9791 7.36949V7.46597L18.1399 7.581L18.1025 7.66264L17.8745 7.62553L17.8408 7.69603L17.8745 7.83333L18.0764 7.98547L18.0614 8.14503L17.8745 7.97804L17.6501 8.20439L17.4794 8.26129L17.4494 8.31571L17.5841 8.43446L17.5492 8.51361L17.26 8.74615L17.1354 8.85995L16.931 9.11722L16.8312 9.31513V9.47345L16.6318 9.55756V9.69609L16.7864 9.62188L16.7315 9.7802L16.7814 9.83462L16.8263 9.90883L16.9758 9.7802L17.1204 9.71588L17.275 9.55756L17.2401 9.40913L17.3896 9.30028L17.4744 9.28049L17.5242 9.40418L17.3398 9.47839L17.3896 9.52292L17.5143 9.50313L17.5093 9.64166L17.3398 9.72577L17.25 9.79504L17.2351 10.0276L16.9011 9.98305V10.1117L16.7415 10.1067V9.97316L16.5621 9.82967L16.4324 10.0276L16.3377 10.0919L16.2031 10.0523L16.0785 10.0919L16.0286 10.2057L15.8591 10.2156L15.8142 10.5273L15.6746 10.5471L15.6098 10.4283L15.3606 10.5372L15.3157 10.7549L15.5201 10.7301L15.4702 10.9973L15.196 10.9168L15.0515 10.9676L15.2658 11.0963L15.0515 11.1655L14.8072 11.2991V11.4525L14.7075 11.3659L14.6128 11.2397L14.5779 11.3041V11.4277L14.4083 11.3659L14.3336 11.4179L14.528 11.6059H14.4582L14.3585 11.5416L14.2638 11.7642L14.4133 11.972L14.3435 12.1699L14.4083 12.4173H14.6726L14.9617 12.3629L14.9318 12.4816L14.6576 12.5608L14.3286 12.635L14.3734 12.7587L14.2937 12.8626L14.2887 12.922L14.3834 13.011L14.2638 13.0902L14.3086 13.3475L14.4382 13.3128L14.5828 13.4563L14.6177 13.5503L14.4981 13.5998L14.3984 13.8125L14.4632 13.8373L14.6327 13.6443L14.7424 13.5404L14.7922 13.392L14.867 13.2238L15.1462 13.1298L15.1412 13.2584L14.877 13.3574L14.8371 13.5454L14.6975 13.7086L14.7374 13.8521L14.6078 14.0055L14.5479 14.0847L14.5031 14.0203L14.4283 14.0352L14.3934 14.2133L14.4682 14.3073L14.6526 14.243L14.7174 14.0847L14.8371 14.1787L14.8221 14.3815L14.7474 14.4112V14.5844L14.8072 14.7279L14.7025 14.7229L14.6177 14.6487L14.5679 14.7031L14.5579 14.9406L14.7623 15.1187L14.862 15.2127L15.0614 15.2919L15.0714 15.4749L15.1861 15.4898L15.5749 15.465L15.7694 15.4403L16.1532 15.1533L16.572 14.6784L16.6917 14.5003L16.8163 14.5992L16.9908 14.426L17.0058 14.2578L16.9509 14.0946L17.0456 14.0154L17.1753 14.1044L17.2251 14.3964L17.3946 14.4953L17.3896 14.6982L17.4594 15.0742L17.5791 15.3166L17.5193 15.4304L17.6888 15.6629L17.7286 15.94L17.9281 16.321L18.0627 16.6327L18.2471 16.885L18.1823 17.0829L18.1424 17.3253L18.302 17.5975L18.297 17.8993L18.5512 17.929L18.9102 17.8646L18.8853 17.6024L19.0049 17.3798L19.1694 17.3204L19.2841 17.1967L19.6879 17.2561L19.8724 16.9543L20.007 16.5882L20.1117 16.0686L20.2014 15.5393L20.1366 14.9455L20.4955 14.7823L20.6002 14.5893L20.7847 14.6833L20.9991 14.4607L21.0739 14.2578L21.2533 14.0154L21.2434 13.6493L21.1686 13.4316L20.7947 13.0803L20.5953 13.1199L20.5653 13.0011L20.336 12.7735L20.3609 11.9225L20.4955 11.7791L20.5454 11.3288L20.6052 11.2843L20.4806 11.1309L20.5653 11.0171L20.695 11.0765L20.7648 10.9168L20.7847 10.6263L21.039 10.6213L21.024 10.369L21.378 10.1414L21.4328 10.0078L21.9014 9.74063L21.9513 9.60705L22.1158 9.56747L22.2604 9.27556L22.3053 9.10239L22.5645 8.8847L22.5346 8.72142L22.3701 8.55815L22.4349 8.4493L22.38 8.29098L22.5844 8.01886L22.5894 7.65274L22.8138 7.62305L22.9833 7.45978V7.12335L23.1278 7.17777H23.3223L23.3921 7.27672L23.4968 7.17282L23.8657 7.2223L24.0701 7.24209L24.3343 7.40536L24.4839 7.72696L24.5936 8.09308L24.5288 8.36025L24.4091 8.30088L24.2047 8.36025L24.0751 8.60764L23.7959 9.07271L23.5267 9.43389L23.407 9.59221L23.2525 9.54768L23.2026 9.59221L23.1677 9.80001L23.0182 9.88412L23.0531 10.1909L22.6592 10.2206L22.6493 10.4976L22.4498 10.6362L22.38 10.844L22.4399 11.0369L22.5695 11.2348L22.4947 11.5762L22.6542 11.8434L22.6243 12.2837L22.5595 12.5162L22.4897 13.0605L22.5346 13.0951L22.6492 13.0259L22.7888 13.1743L22.9334 13.2188L22.9234 13.4068L23.063 13.4711L23.083 13.5998L23.2874 13.6245L23.3273 13.8026L23.5616 13.7136L23.8856 13.5849L24.1648 13.5454L24.444 13.3376L24.7681 13.2782L25.0722 13.1347L25.3912 13.0704L25.6505 13.1347L25.8997 13.0555L26.1989 12.8725L26.2487 12.9368L26.0643 13.105L26.3061 13.3524L26.4432 13.4711L26.8121 13.4068L26.9118 13.5849L26.9417 13.7631L26.7772 13.7136L26.4681 13.674L26.3534 13.8224L26.159 13.8373L26.0692 13.9709L25.8948 14.0055L25.8449 14.2034H25.5557L25.1569 14.144L24.8528 14.0451L24.6534 14.0995L24.3842 14.1688L24.2296 14.1539L23.9405 14.3271L23.6962 14.4013L23.6264 14.6239L23.5765 14.8317L23.6763 15.0494L23.6912 15.2078L23.8707 15.2721L24.0053 15.1583L24.1698 15.2523L24.0801 15.3958L24.0252 15.8114L24.0651 16.1379L24.0302 16.3853L23.8009 16.5634L23.5566 16.5337L23.417 16.3853L23.3821 16.1676L23.2824 16.133L23.078 15.851L22.8985 15.9351L22.6443 16.0884L22.5795 16.222L22.5396 16.509L22.3701 16.6723L22.3252 16.9939L22.4 17.5678L22.5047 18.1615L22.4698 18.4089L22.2205 18.394L22.051 18.3495L21.8267 18.394L21.8316 18.5227L21.9413 18.5623L21.9363 18.6167L21.8316 18.6563L21.6871 18.8294L21.5724 18.9432L21.383 18.8888L21.1387 18.869L21.019 18.4781L20.9093 18.4633L20.5753 18.5029L20.2812 18.6711L20.0818 18.6909L19.8574 18.9581L19.6281 19.0174L19.319 19.1065L19.0597 19.245L19.0946 19.3489L19.0597 19.4281L18.9401 19.4132L18.8005 19.2846L18.7207 19.151L18.646 19.0669L18.5562 19.0867L18.4416 19.0026L18.5163 18.864L18.636 18.8393L18.646 18.7107L18.4266 18.6661L18.3917 18.8047L18.3169 18.8838L18.1674 18.8542L18.0278 18.9135L17.8732 19.0273L17.6239 19.0768L17.4893 19.2351L17.2151 19.2054V19.0471L17.4046 18.8195L17.3448 18.7503L17.26 18.775L17.1952 18.8987L17.0755 18.8591L16.8662 18.8047L16.7266 18.7354L16.7166 18.5523L16.5521 18.4583L16.5471 18.3841L16.6917 18.3445L16.6817 18.2802L16.5172 18.2357L16.562 18.1071L16.6418 18.0724L16.592 17.9339L16.6269 17.8449L16.7315 17.9191L16.7964 18.0576L16.901 18.1566L17.0307 18.211L17.1204 18.2159L17.1603 18.1219L17.1952 18.0378L17.1254 17.924L16.9958 17.8053L16.8911 17.7855L16.7714 17.8102L16.7116 17.8152L16.6468 17.7261L16.7515 17.6024L16.7615 17.4688L16.8512 17.4293L16.8861 17.2215L16.921 17.1621L17.0157 17.1225L17.0805 17.1621L17.1553 17.1868L17.1952 17.1126L17.2351 17.0186L17.1703 16.9147L17.0606 16.885L16.9359 16.9196L16.901 16.791L16.8761 16.5783L16.9758 16.3952L17.0556 16.2418L17.0356 15.8856L16.8512 15.9746L16.7266 16.0588L16.6219 16.2666L16.5421 16.3457L16.3078 16.3902L16.0834 16.4595L15.9389 16.5931L15.9289 16.6772L15.9937 16.7465L16.0834 16.7019L16.1682 16.8207V16.9345L16.0834 16.9295L15.9089 16.8702L15.9239 17.1621L15.8641 17.3402L15.8591 17.6519L15.9189 17.7805L16.0485 17.929L16.1333 18.1021L16.1532 18.4633L16.2529 18.6216L16.1881 18.8443L16.2878 19.062L16.2729 19.1955L16.4424 19.2945L16.3676 19.3341L16.233 19.2747L16.1233 19.2945L16.0685 19.4281L16.0735 19.5221L15.9239 19.532L15.8192 19.626L15.7793 19.4281L15.3605 19.5171L15.2658 19.7299L15.1561 19.6458L14.9617 19.6705L14.6775 19.7002L14.508 19.9228L14.503 20.0366L14.5778 20.1257L14.6576 20.1653L14.5928 20.3434L14.3335 20.571L14.2638 20.5067L14.3186 20.3236L14.3535 20.2148L14.2638 20.0911L14.1491 20.1257L14.0793 20.2543L14.0295 20.5116L13.9796 20.7145L13.855 20.8678L13.6605 21.0262L13.7902 21.1202L13.835 21.1894L13.7702 21.229L13.5708 21.1894L13.4561 21.3131L13.2418 21.4368L13.0324 21.5704L12.7133 21.6496L12.6136 21.7238L12.5725 21.9365V22.1839L12.4241 22.3659L12.1848 22.5154L11.9655 22.5995L11.8608 22.6342L11.8159 22.7578L11.9007 22.837L11.8608 22.9063L11.7362 22.9557L11.432 22.931L11.2376 22.8766L11.098 22.7974L10.9634 22.649L10.8587 22.6539L10.8238 22.7677L10.9086 22.8964L11.0183 23.1685L11.0532 23.4109L10.9485 23.4752H10.8039H10.5852L10.3652 23.5L10.2854 23.4109L10.1907 23.3169L9.96135 23.3862L9.76691 23.4456H9.59741L9.39799 23.5247L9.35811 23.6534L9.43289 23.6781L9.60738 23.6534L9.62732 23.7919L9.49271 23.9106L9.58245 24.0393L9.72702 24.0145L9.92146 24.0393L10.066 24.1234L10.1508 24.1926L10.425 24.1679L10.5496 24.3114L10.5596 24.4252L10.6792 24.5093L10.754 24.6924L10.6643 24.8012L10.7989 24.9496L10.9285 25.0634L11.108 25.1525L11.2077 25.2861L11.2177 25.5879L11.3672 25.7611L11.3772 25.8847L11.2576 25.8402L11.1927 25.8847L11.1628 26.147L11.1828 26.3993L11.1229 26.5329L11.0731 26.8891C11.0731 26.8891 11.0133 27.1365 11.0083 27.1513C11.0033 27.1662 10.759 27.3196 10.759 27.3196L10.4748 27.275L9.86163 27.2552L9.7021 27.2206L9.42292 27.2305L9.17365 27.1563L8.87452 27.087L8.37099 27.1365L8.14665 27.1612L7.86747 27.0227H7.74283L7.56336 27.2948L7.34898 27.3196L7.10968 27.4531L7.17449 27.5966L7.19942 27.745H7.34899L7.31907 28.0815L7.28417 28.3289L7.40881 28.6307L7.34399 29.0562L7.3091 29.3134L7.25426 29.6153L7.10968 29.9368L7.05983 30.0012L7 30.2683L7.15455 30.3178L7.13959 30.4415L7.24927 30.4712L7.32904 30.3772L7.34898 30.6394L7.31408 30.9214L7.27918 31.248L7.28417 31.3519H7.4437L7.75778 31.3172L7.96717 31.3519L8.19151 31.3073L8.51058 31.3964L8.59034 31.6636L8.71996 31.9011L8.96425 32L9.09387 31.8417L9.2883 31.7031L9.42291 31.6834L9.58743 31.5597L9.85664 31.5646L10.1259 31.5547L10.3951 31.5399L10.6393 31.525L10.7789 31.3766L10.9435 31.1243L11.1279 31.0105L11.3024 31.0303L11.3772 30.8324L11.5068 30.5899L11.771 30.3079L11.5168 29.9517L11.6614 29.6796L11.9705 29.1304L12.1948 28.8286L12.4291 28.7197L12.6485 28.6801L12.8678 28.5218L13.2019 28.3486L13.3315 28.2002L13.3215 27.938L13.2218 27.6213L13.2816 27.4185L13.6057 27.1167L14.0643 27.0771L14.0992 27.2354L14.3535 27.2255L14.6676 27.3888L15.0415 27.3443L15.4752 26.9633L15.8042 26.8594L15.9688 26.6467L16.228 26.4685L16.4424 26.5724L16.896 26.8248L16.9658 27.1315L17.0755 27.3641L17.0954 27.4976L17.2849 27.6708L17.4295 27.8539L17.6339 27.9479L17.7735 28.1161L17.943 28.3189L18.1673 28.5069L18.4166 28.6356L18.7456 28.7147L18.8204 28.8632L18.9899 28.977L19.0946 29.0512L19.309 29.0759L19.2791 29.3085L19.4386 29.4074L19.6729 29.5212L19.7626 29.7834L19.8923 30.0655L19.9172 30.2782L19.8075 30.3821L19.7477 30.5157L19.6629 30.7482L19.7277 30.8076L19.8424 30.8125L19.992 30.6097L20.0618 30.4068L20.1016 30.2633L20.2313 30.1644L20.3509 30.1397V30.0011L20.2911 29.8379L20.1465 29.7834L20.0368 29.7092V29.5806L20.306 29.1452L20.3709 29.1304L20.4456 29.1947L20.5703 29.2986L20.7348 29.3035L20.8046 29.3827L20.8445 29.4965L20.9541 29.5756L21.009 29.5657L21.0439 29.447L21.004 29.3134L20.8594 29.1798L20.6251 29.0067L20.3958 28.8434L20.0169 28.695L19.7277 28.5366L19.7477 28.4129L19.8723 28.3288L19.8324 28.2794L19.6928 28.2447L19.5682 28.2892L19.3438 28.2447L19.1245 28.0913L18.8652 27.8192L18.6957 27.5075L18.6608 27.3245L18.5312 27.1068L18.4066 27.0325L18.2321 26.8643L18.0227 26.7654L17.9479 26.5774L17.8184 26.4587L17.8682 26.2954L17.9779 26.1766L17.9231 26.0134L17.8632 25.8798L17.9131 25.7462L18.0677 25.6769L18.1125 25.7165L18.302 25.6126L18.4864 25.5384L18.6809 25.5829L18.621 25.7413L18.5861 25.8748L18.6709 26.0431L18.7507 26.1667L18.8753 26.0678L18.9202 25.8748L18.9949 25.7512L19.0947 25.9045L19.2143 25.9837L19.2941 26.0925L19.2891 26.2904L19.3389 26.4537L19.4386 26.6615L19.5882 26.8446L19.7228 27.0128L19.8325 27.1365L20.1167 27.1315L20.346 27.2948L20.4956 27.4482L20.3983 27.5001L20.518 27.5966L20.8022 27.6486L21.0714 27.8341L21.2583 27.938L21.4079 28.1755L21.6247 28.2868L21.5874 28.5391L21.5724 28.7915L21.6098 28.9251L21.4752 29.1997L21.5201 29.3332L21.692 29.3926L21.8416 29.5633L21.7033 29.6635L21.8005 29.8713L21.9351 30.0865L22.137 30.1422L22.2267 30.2943L22.3651 30.3648L22.4212 30.5429H22.5745L22.7951 30.5058L23.1278 30.5578L23.3821 30.6394L23.3896 30.7507L23.2587 30.8138L23.068 30.7062L22.8923 30.6914L22.7951 30.5986L22.6941 30.6468L22.6492 30.721L22.5296 30.7099L22.3912 30.8509L22.5221 30.9919L22.6792 31.1478L22.6156 31.2517L22.7165 31.5114L22.8399 31.4038L22.911 31.4001L22.9783 31.5597L23.0269 31.7118L23.0979 31.671L23.1465 31.5226L23.2512 31.5188L23.3522 31.6895L23.3634 31.5708L23.3148 31.3964L23.2624 31.2443L23.1914 31.107L23.2512 31.055L23.3597 31.0995L23.4756 31.1626L23.4943 31.0921L23.3933 30.9511L23.3372 30.8695L23.4457 30.7953L23.5616 30.7804L23.6812 30.8324L23.7635 30.8843L23.8308 30.8695L23.8495 30.721L23.9429 30.6097L23.9355 30.4539L23.8607 30.4019L23.7074 30.35L23.5765 30.2052L23.483 30.1681L23.4232 30.2052L23.4868 30.2869L23.6289 30.4205L23.6214 30.5021L23.5317 30.5058L23.4943 30.4353L23.3821 30.3611L23.2811 30.2572L23.3335 30.1644L23.2849 30.068L23.3111 29.9529L23.2849 29.901L23.3709 29.9715L23.4569 29.9529L23.397 29.8379L23.2437 29.682L23.1839 29.5299L23.1091 29.4149L23.0718 29.2776L23.1129 29.1477L23.2026 29.1032L23.3111 29.0772L23.3709 29.1811L23.4943 29.3035L23.6251 29.3332L23.7074 29.2813L23.7672 29.1996L23.741 29.0623L23.8158 28.9696L23.9691 28.9139L24.1374 28.8731L24.3169 28.8508L24.4365 28.7989L24.5711 28.8583L24.7244 28.9065L24.9001 28.9436L25.0198 28.836L25.0273 28.6542L25.1507 28.6096L25.0572 28.3759L25.3563 28.105L25.805 28.1681L25.7564 28.0048L25.6031 27.8675L25.6442 27.7599L25.82 27.4927L25.8536 27.2441L25.9995 27.1625L26.1191 27.1662L26.1341 26.7877L26.1415 26.5354L26.336 26.3647L26.4668 26.2014H26.6314L26.68 25.9602L26.7248 25.7895L26.6052 25.719L26.6501 25.6114L26.7174 25.5223L26.7697 25.5928L26.9828 25.4518L27.0651 25.3182L26.9043 25.1475L26.9342 25.0622L27.095 25.1698L27.1735 25.2143L27.2221 25.0585L27.2408 24.9583L27.3679 24.9323L27.5998 24.9397L27.7381 24.9212L27.7718 24.7913L27.8839 24.8396L27.9213 24.9249L28.0559 24.9954L27.9961 25.1142L27.8914 25.1513L27.9774 25.2589L28.1158 25.3071L28.2354 25.2886L28.385 25.2589L28.5308 25.2886L28.6916 25.3182L28.6966 25.479L28.5769 25.5335L28.4024 25.5978L28.198 25.7759L28.3127 25.8155L28.4473 25.8996L28.4872 26.0134L28.6367 25.9985L28.6667 26.142L28.6318 26.3102L28.6866 26.429L28.7414 26.5081L28.8561 26.4933L29.0057 26.4339L29.1054 26.3251L29.1452 26.241L29.2599 26.236L29.4194 26.1964L29.4992 26.1321L29.559 26.048L29.6936 26.0084L29.8133 26.0579L29.9678 26.0529H30.0576L30.0775 25.9144L29.9928 25.7709L29.8382 25.86L29.6837 25.9045L29.5989 25.9491L29.4643 25.9194L29.3696 25.7215L29.3098 25.6176L29.1353 25.5038L29.1502 25.3257L29.2599 25.2168L29.4843 25.0882L29.5192 24.9051L29.6338 25.0041L29.7584 24.9298L29.9928 24.8853L30.242 24.816L30.4464 24.7418L30.6459 24.6231L30.8403 24.5489L31.0297 24.5637L31.3089 24.4796L31.5033 24.4351L31.5682 24.5489L31.4535 24.722L31.1843 24.8111L31.1594 24.915L31.0198 24.8853L30.8154 24.9546L30.8752 25.103L31.0397 25.1673L30.9948 25.4147L30.8602 25.4296L30.8004 25.6275L30.6808 25.8303L30.601 25.8699L30.3767 25.8353L30.2869 25.9788L30.3368 26.0084L30.4365 25.9293L30.5013 26.0678L30.5811 26.2558L30.7904 26.335L31.0098 26.4785L31.1793 26.5477L31.3987 26.6615L31.5682 26.8495L31.7377 27.0474L31.8723 27.1711L32.0567 27.087L32.6301 27.2998L33.1336 27.3245L33.7219 27.6016L33.8016 27.745L34.021 27.7599L34.1107 27.6411L34.4198 27.6659L34.8187 27.8687L34.7289 28.0221L35.1078 28.2101L35.4069 28.3684L35.5415 28.5911L35.8606 28.6307L36.1797 28.2893L35.9703 27.9776L35.6512 27.5273L35.6562 27.2057L35.7459 26.8792L35.6263 26.8446L35.4219 26.5576L35.2075 26.5428L35.3022 26.3201L35.7659 25.6769L35.8756 25.6176L35.8905 25.7066L35.9354 25.6472L36.0102 25.5335L36.1348 25.6374L36.2545 25.5829L36.3193 25.3999L36.424 25.1525L36.1473 24.9397L36.4015 24.821L35.9977 24.1456L35.6388 24.0046L35.6014 24.1382L35.4369 24.0417L35.4742 23.7078L35.1452 23.6039L35.3696 22.9656L35.377 22.461L35.6836 22.0528L36.0875 22.4981L36.3642 22.3942L36.2146 21.9415L36.6483 21.7263L36.6408 21.5407L37.284 21.1251V20.9767L37.613 21.0954L37.6205 21.2216L37.7775 21.2364L37.8448 21.1103L38.1514 20.9767L38.2112 21.2364L38.6076 21.2068L39.1684 21.6892L39.1984 21.986L39.3105 21.9044L39.2731 21.5778L39.8265 21.986L40.2079 21.5407L40.3425 21.6149L40.4921 21.511L40.7239 21.7114L40.851 21.5036H41.1801L41.382 21.8227L41.6587 21.8599L41.6961 22.0157L41.9728 21.7337L42.2345 21.897L42.4156 21.8336Z",
    fill: "currentColor"
  })));
};
const europe_ForwardRef = /*#__PURE__*/(0,react.forwardRef)(SvgEurope);

/* harmony default export */ const europe = (__webpack_require__.p + "c5a9e64d4d1d9cdebbba5a9e0705ba96.svg");
;// CONCATENATED MODULE: ./src/assets/icons/asia.svg
var asia_path, asia_path2;
function asia_extends() { asia_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return asia_extends.apply(this, arguments); }


const SvgAsia = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/react.createElement("svg", asia_extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/react.createElement("title", {
    id: titleId
  }, title) : null, asia_path || (asia_path = /*#__PURE__*/react.createElement("path", {
    d: "M27.3857 3.42582L28.3622 2.74877C28.5582 2.61307 28.8238 2.64071 28.9875 2.81375L30.3097 4.21164C30.426 4.33442 30.6116 4.36098 30.7573 4.27519C30.9533 4.15995 30.9964 3.89502 30.8467 3.72342L27.7411 0.165134C27.6496 0.06031 27.5171 0 27.3778 0H25.2128C25.1808 0 25.1492 0.0032309 25.118 0.00933369L23.5898 0.315191C23.5352 0.325961 23.4828 0.346423 23.4347 0.375501L22.4259 0.986857C22.3383 1.03999 22.236 1.06368 22.1337 1.05471L20.3072 0.894598C20.2307 0.887777 20.1568 0.863007 20.0918 0.821723L18.9861 0.123492C18.8623 0.0452324 18.7097 0.0276421 18.5715 0.0753874L16.5748 0.762849C16.5533 0.770388 16.5324 0.779003 16.512 0.789414L15.0136 1.55621C14.9766 1.57524 14.9375 1.58924 14.8969 1.59785L13.9732 1.79996C13.8486 1.82725 13.7187 1.80391 13.611 1.73571L13.1511 1.44313C13.0348 1.36918 12.8923 1.34836 12.7595 1.38641L12.2264 1.53862C12.2048 1.54472 12.1833 1.54939 12.161 1.55262L10.8242 1.74109C10.3582 1.80679 10.0836 1.23456 10.4261 0.912188C10.5172 0.82639 10.5578 0.699308 10.5334 0.576534L10.4975 0.397758C10.4383 0.101234 10.0638 0.00287187 9.86639 0.231906L9.24283 0.955984C9.22058 0.981832 9.19581 1.00517 9.16852 1.02563L8.10089 1.83443C8.03089 1.88756 7.9774 1.95971 7.94653 2.04192L7.85176 2.29788C7.8015 2.43358 7.69272 2.53948 7.55595 2.58651L6.14872 3.06935C6.03169 3.10955 5.93476 3.19284 5.87768 3.30269L5.13242 4.7311C5.0994 4.79428 5.08073 4.86392 5.07822 4.93536L5.01898 6.44886C5.01252 6.60968 4.92636 6.75723 4.78887 6.84123L4.08346 7.27345C3.94776 7.35674 3.86161 7.50141 3.85371 7.6608L3.80094 8.71586C3.79555 8.82248 3.75355 8.92372 3.68211 9.0027L3.508 9.19511C3.29728 9.4281 2.92321 9.40045 2.74874 9.13911L2.32657 8.50586C2.2117 8.33354 1.99954 8.25385 1.79994 8.3077L1.4747 8.39529C1.29305 8.44411 1.15627 8.59453 1.12468 8.77976L0.963857 9.72067C0.935856 9.88581 0.995089 10.0535 1.12073 10.164L1.46285 10.4652C1.66855 10.6461 1.68255 10.9621 1.49336 11.1602L0.449069 12.2555C0.371527 12.337 0.324859 12.4425 0.316961 12.5549L0.00105173 17.0835C-0.00110219 17.1176 -2.5173e-05 17.1517 0.00500066 17.1858L0.490711 20.5535C0.524815 20.7908 0.728361 20.967 0.968165 20.967H3.73129C3.86484 20.967 3.99228 20.9118 4.08346 20.8141L4.74364 20.1083C4.89872 19.9428 4.91739 19.6916 4.78815 19.5045L4.07054 18.4653C3.98833 18.3461 3.85658 18.27 3.71191 18.2585L3.38954 18.2326C3.17127 18.215 2.99178 18.0528 2.95301 17.837L2.55992 15.6476C2.52725 15.4659 2.63602 15.2886 2.813 15.2358L2.89413 15.2114C3.08547 15.154 3.28723 15.262 3.34574 15.4526L3.86591 17.1499C3.91258 17.3018 4.03069 17.421 4.18182 17.4687L4.47835 17.5624C4.58317 17.5954 4.67364 17.6633 4.73466 17.7548L4.93893 18.061C4.98488 18.13 5.0477 18.186 5.12165 18.2237L7.15424 19.2568C7.22137 19.2909 7.27989 19.3405 7.3244 19.4015L8.98831 21.6674L9.08272 21.8103L9.64275 24.3498C9.64849 24.4036 9.66321 24.456 9.68654 24.5052L10.9197 27.1082C10.9581 27.189 11.0177 27.2576 11.0927 27.306L12.0907 27.9547C12.2964 28.0886 12.5699 28.0463 12.7261 27.8571L12.8582 27.697C12.9278 27.6126 12.9555 27.5013 12.9336 27.394L12.5211 25.3625C12.5003 25.2602 12.5132 25.1543 12.5577 25.0599L13.0908 23.9341C13.1307 23.8497 13.1946 23.7786 13.2739 23.7298L15.3887 22.4285C15.4907 22.3657 15.6127 22.343 15.7305 22.3653L17.0609 22.6148C17.2203 22.6446 17.3538 22.7526 17.4166 22.902L17.9853 24.2561C18.0502 24.4108 18.191 24.5207 18.3568 24.5461L19.2895 24.6897C19.4392 24.7127 19.5691 24.8046 19.6409 24.9378L19.9647 25.5391C20.0153 25.6332 20.0333 25.7416 20.0157 25.8471L19.9116 26.4714C19.9008 26.5357 19.9033 26.601 19.9188 26.6642L20.1719 27.7081C20.1841 27.7587 20.2045 27.8072 20.2322 27.8513L20.4748 28.2373C20.6834 28.5693 20.4099 28.9936 20.0214 28.9409C19.5738 28.8799 19.3139 29.4313 19.6456 29.7378L20.972 30.9638C20.9914 30.9817 21.0119 30.9979 21.0341 31.0122L22.4389 31.9381C22.5519 32.0124 22.6966 32.0181 22.8151 31.9524L23.0161 31.8408C23.1716 31.7543 23.2416 31.5679 23.1813 31.4003L22.986 30.8579C22.9648 30.7997 22.9328 30.7459 22.8915 30.6996L22.4934 30.0326L22.4381 29.8042C22.4855 29.6904 22.4877 29.563 22.4439 29.4478L22.1531 28.6813C22.1226 28.6009 22.0713 28.5306 22.0045 28.4767L21.0061 27.6733C20.7854 27.4956 20.7645 27.1671 20.9609 26.9632L21.2887 26.6222C21.4265 26.4789 21.6376 26.4348 21.821 26.5109L22.7993 26.9165C22.9425 26.9761 23.1059 26.9629 23.238 26.881L24.4007 26.1612C24.5124 26.0919 24.591 25.9807 24.6186 25.8521L24.7461 25.2569C24.778 25.1087 24.7378 24.954 24.6384 24.8394L23.8651 23.9502C23.6228 23.6717 23.7707 23.2348 24.1326 23.1612L24.9615 22.9921C25.0692 22.9702 25.1661 22.912 25.2365 22.8273L26.1285 21.7504C26.1734 21.6961 26.2057 21.6333 26.2237 21.5655L26.331 21.1584C26.363 21.0367 26.4412 20.9322 26.5493 20.8676L27.3545 20.3844C27.4403 20.3327 27.5081 20.2559 27.5483 20.164L28.6932 17.5477C28.7463 17.426 28.747 17.2881 28.6953 17.1661L28.3636 16.3838C28.3442 16.3379 28.3176 16.2952 28.285 16.2571L27.5598 15.4153C27.5121 15.36 27.4406 15.3374 27.4062 15.2613L27.3164 14.9296L27.5526 14.3265C27.7095 14.1093 27.585 13.8024 27.3207 13.7564L27.0885 13.7158C26.7611 13.6584 26.5884 13.2951 26.7507 13.005L26.7927 12.9304C26.8792 12.7757 27.0468 12.6845 27.2238 12.6949L27.9084 12.7365C28.0606 12.7459 28.1995 12.8266 28.2832 12.9544L28.9965 14.0468C29.1667 14.3075 29.5353 14.3412 29.7497 14.1158L29.8455 14.0149C29.9783 13.8752 30.0106 13.6681 29.9266 13.4947L29.0155 11.6154C28.9369 11.4528 28.9552 11.26 29.0636 11.1153L29.3013 10.7984C29.3885 10.682 29.3885 10.682 29.6032 10.5076L29.6445 10.2796L29.3501 6.74789C29.3361 6.67322 29.3041 6.60286 29.2568 6.54327L28.6214 5.74883C28.5176 5.61924 28.3388 5.57652 28.1877 5.64508L28.0405 5.71221C27.8309 5.80735 27.5868 5.68601 27.5361 5.46164L27.1901 3.92948C27.1466 3.7367 27.2242 3.53782 27.3857 3.42582Z",
    fill: "currentColor"
  })), asia_path2 || (asia_path2 = /*#__PURE__*/react.createElement("path", {
    d: "M32.0859 10.8297L31.5866 9.75343L31.6717 9.50716L31.69 9.13884L31.4961 8.80821C31.1684 8.69728 30.8377 8.9676 30.8812 9.31044L30.9221 9.63245C30.9318 9.70748 30.9594 9.77927 31.0025 9.84174L31.6175 10.7227C31.6763 10.8071 31.7058 10.9083 31.7015 11.011L31.6397 12.4458C31.6365 12.5248 31.6128 12.6016 31.5719 12.6691L30.5725 14.3108C30.4443 14.5211 30.5014 14.7951 30.7028 14.9372C30.9397 15.1041 31.2696 15.018 31.3949 14.7566L31.9876 13.5196C31.998 13.498 32.0066 13.4761 32.0134 13.4532L32.2884 12.5471C32.3067 12.4868 32.3128 12.4232 32.306 12.3604L32.1631 11.0415C32.1549 10.9654 32.1283 10.8929 32.0859 10.8297Z",
    fill: "currentColor"
  })));
};
const asia_ForwardRef = /*#__PURE__*/(0,react.forwardRef)(SvgAsia);

/* harmony default export */ const asia = (__webpack_require__.p + "9b6a5cc57dc6c955953b1808859a0c19.svg");
;// CONCATENATED MODULE: ./src/assets/icons/australia.svg
var australia_path, australia_path2, australia_path3, australia_path4;
function australia_extends() { australia_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return australia_extends.apply(this, arguments); }


const SvgAustralia = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/react.createElement("svg", australia_extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/react.createElement("title", {
    id: titleId
  }, title) : null, australia_path || (australia_path = /*#__PURE__*/react.createElement("path", {
    d: "M32.9473 15.8803L32.9737 15.6794L32.9624 15.6185L32.8254 15.4093L32.8435 15.2866L32.8194 15.2211L32.7502 15.1241L32.699 14.9487L32.5425 14.7967L32.5176 14.6718L32.6177 14.586L32.5485 13.8817L32.641 13.5784L32.5206 13.5039L32.477 13.397L32.4251 13.3639L32.4032 13.2082L32.4469 13.0945L32.4153 12.9621L32.2219 12.923L32.0879 12.701L32.0556 12.5347L31.7809 12.3526L31.6191 12.0041L31.4152 11.8002L31.3791 11.7897L31.358 11.8566L31.2955 11.8867L31.3023 11.8416L31.2022 11.7904L31.0773 11.6565L30.9923 11.6256L30.8741 11.4164L30.747 11.3705L30.6928 11.2607L30.7026 11.1342L30.6567 11.0394L30.7086 10.688L30.598 10.5307L30.616 10.4321L30.5581 10.3456L30.4986 10.3351L30.4761 10.381L30.5242 10.5593L30.2037 10.3885L30.1043 10.1876L30.0396 10.1853L29.9756 10.3524L30.072 10.6075L30.0223 10.5458L29.8951 10.387L29.7762 10.4848L29.7981 10.3576L29.6543 10.1176L29.5798 9.8512L29.5904 9.68489L29.4248 9.42001L29.4045 9.24693L29.0079 8.93163L28.9575 8.79617L29.0177 8.72167L29.0576 8.70512L29.175 8.77285L29.0395 8.51097L28.9613 8.49667L28.7814 8.36498L28.7927 8.46958L28.7498 8.48839L28.6362 8.37627L28.6557 8.34316L28.591 8.2649L28.3397 8.219L28.2659 8.06097L28.2163 8.06021L28.2231 8.1603L28.141 8.15879L28.0801 8.07451L28.0477 7.90896L27.922 7.71331L27.9469 7.80286L27.7076 7.79458L27.6526 7.74265L27.5006 7.70879L27.4006 7.60871L27.2388 7.57183L27.004 7.35135L27.0499 7.05034L26.9506 7.01272L26.785 6.79599L26.779 6.71397L26.8542 6.55444L26.8625 6.32943L26.803 6.051L26.6811 5.80192L26.7406 5.65518L26.721 5.6311L26.6187 5.66647L26.2883 5.26613L26.3372 4.96362L26.253 4.82215V4.66939L26.1619 4.42632L26.195 4.32925L26.1499 4.1637L26.2161 4.00492L25.9249 3.84388L25.8737 3.73025L25.6938 3.67908L25.6427 3.61813L25.6133 3.43225L25.5622 3.3555L25.5298 3.34797L25.4959 3.42398L25.1505 3.61963L25.0489 3.61888L24.9632 3.55717L24.8841 3.23058L24.8149 3.15759L24.757 3.00708L24.8089 2.73618L24.7494 2.62932L24.7434 2.27489L24.6193 2.25005L24.6742 2.05666L24.5508 1.97388L24.5478 1.88659L24.386 1.82112L24.4063 1.66008L24.4853 1.53291L24.407 1.46293L24.2972 1.48249L24.2084 1.40423L24.2137 1.03775L24.1504 0.780391L24.1151 0.702883L24.0044 0.608823L23.9232 0.672788L23.9292 0.596781L24.0082 0.507987L23.8705 0.474121L23.7877 0.627632L23.6282 0.672033L23.6079 1.02271L23.4641 1.48023L23.5274 1.59913L23.4401 1.61644L23.4197 1.51711L23.3844 1.53291L23.3242 1.71953L23.1759 1.98366L23.203 2.01527L23.2504 2.00022L23.2316 1.91669L23.3016 1.93249L23.2775 1.95206L23.413 2.12739L23.4589 2.26134L23.4521 2.29671L23.3904 2.13191L23.3415 2.11686L23.3016 2.22748L23.1759 2.3381L23.2534 2.58492L23.1338 2.81745L23.0743 3.06427L23.0811 3.16511L23.1812 3.32841L23.1165 3.61135L23.1534 3.84839L23.2339 4.06963L23.0661 4.49857L23.0172 4.81011L23.0382 4.95233L22.9238 5.31504L22.8486 5.48511L22.6544 5.73721L22.5536 6.12023L22.1969 6.30911L21.8884 6.34298L21.7213 6.22559L21.5595 6.17893L21.4128 6.05853L21.2683 6.02767L21.1885 5.90878L21.1712 5.79891L21.0644 5.65067L20.9274 5.6311L20.7611 5.54908L20.4759 5.51747L20.1222 5.26011L20.0229 5.10208L19.7219 4.99748L19.445 4.81763L19.229 4.8086L19.071 4.65584L18.8678 4.55877L18.7797 4.38268L18.1785 4.02072L18.0934 3.82281L18.2289 3.75358L18.2966 3.57824L18.5216 3.33142L18.627 2.95064L18.5465 3.00181L18.4795 2.88066L18.4945 2.7866L18.5525 2.70758L18.5171 2.65867L18.5465 2.60825L18.6849 2.53074L18.7692 2.57589L18.8971 2.42163L18.9062 2.58266L18.9724 2.56009L18.9799 2.58642L19.0514 2.42163L19.01 2.19211L19.1131 2.23049L19.1319 2.12965L19.2147 1.99646L19.4051 1.84219L19.3216 1.72931L19.2388 1.68717L19.1726 1.70373L19.2245 1.75716L19.156 1.78049L19.0461 1.55248L19.0649 1.49001L18.9739 1.50657L18.7504 1.68341L18.9024 1.74361L18.8452 1.88885L18.8016 1.92271L18.6375 1.93626L18.5916 1.858L18.6571 1.76318L18.6428 1.73834L18.5826 1.76619L18.5547 1.72404L18.624 1.63675L18.5103 1.66987L18.3892 1.77672L18.335 1.70223L18.4321 1.58032L18.3975 1.53968L18.5615 1.38165L18.5337 1.34929L18.5036 1.34854L18.5066 1.40648L18.4027 1.48926L18.2718 1.50807L18.2628 1.59085L18.3282 1.57354L18.2658 1.62396L18.0551 1.63525L17.9761 1.78725L17.8556 1.76393L17.6818 1.6518L17.6006 1.53893L17.3921 1.59762L17.2725 1.57354L17.1393 1.59311L17.122 1.49754L17.0113 1.41326L16.9233 1.46969L16.839 1.42154L16.8954 1.32371L16.8066 1.30866L16.6968 1.39219L16.602 1.40347L16.4861 1.35456L16.4447 1.29436L16.3032 1.30791L16.0865 0.993355L16.0511 0.990345L15.93 1.14461L15.8856 1.13483L15.7479 0.933151L15.6147 0.821783L15.562 0.849622L15.4559 0.830059L15.5281 1.0084L15.4709 1.05055L15.4092 0.904556L15.3227 0.819527L15.2324 0.860909L15.1481 0.976798L15.2249 0.970027L15.3107 1.01593L15.4055 1.14838L15.6387 1.07613L15.7343 1.10849L15.8991 1.25899L15.8532 1.33123L15.8472 1.56978L15.8562 1.60816L15.9465 1.65557L15.8073 1.62847L15.6982 1.66761V1.79403L15.6485 1.85875L15.6764 1.79855L15.6305 1.71126L15.5183 1.709L15.3867 1.7993L15.2798 1.76544L14.9216 1.78951L14.5393 1.66685L14.5416 1.83993L14.4264 1.83617L14.3693 1.91142L14.4821 1.98743L14.4347 2.07397L14.3316 1.89788L14.1759 1.87756L14.2007 1.89637L14.1729 2.01602L14.1962 2.10407L14.2654 2.12438L14.1932 2.12965L14.1179 2.04387L13.9915 2.1003L13.9697 2.28467L13.8861 2.32832L13.8508 2.29596L13.8169 2.31101L13.7966 2.49613L13.9177 2.64437L13.7356 2.79864L13.6566 2.81293L13.6205 2.74445L13.5626 2.80466L13.4843 3.20424L13.2879 3.32765L13.1878 3.48794L13.178 3.55491L13.3263 3.6693L13.4241 3.68736L13.5159 3.65801L13.4595 3.71369L13.3639 3.73552L13.4361 3.8514L13.5099 3.89881L13.6559 3.85291L13.5392 3.93343L13.4136 3.9116L13.3963 4.06587L13.4828 4.20057L13.4376 4.21788L13.2623 3.98836L13.0727 3.9116L13.0945 4.13435L13.0411 4.20057L13.0366 4.0305L12.506 3.84689L12.3849 3.8815L12.4345 4.0892L12.357 4.08694L12.3187 3.97632L12.2253 4.10425L12.3066 4.30517L12.3029 4.38644L12.2788 4.30668L12.1764 4.22917L12.1478 4.41428L12.0854 4.46846L12.1283 4.38268L12.1253 4.13359L12.2223 3.88075L12.2073 3.79873L12.0688 3.67983L12.0334 3.69714L11.7889 3.357L11.6768 3.28175L11.5985 3.17113L11.3773 3.12598L11.3562 3.18543L11.2659 3.02213L11.2155 2.9815L11.1357 3.00031L11.0439 3.03718L11.0793 3.18468L10.925 3.40065L10.8061 3.27347L10.8445 3.17941L10.7068 3.2509L10.6691 3.40366L10.5909 3.34948L10.563 3.25767L10.6052 3.23961L10.612 3.1764L10.4487 3.14705L10.5006 3.18016L10.554 3.31712L10.4652 3.63995L10.3553 3.74756L10.2921 3.68811L10.3072 3.59781L10.2086 3.54739L10.1431 3.73702L10.2139 3.43752L10.1236 3.39463L10.092 3.46687L10.0995 3.66854L9.8933 3.64672L9.73001 3.83485L9.81729 3.96428L9.76838 4.00341L9.97382 4.15843L9.88126 4.17799L9.75033 4.07565L9.75258 4.18401L9.68184 4.04706L9.60208 4.14037L9.53661 4.13134L9.4749 4.18176L9.52156 4.24647L9.654 4.18251L9.62164 4.23819H9.56671L9.54564 4.3285L9.69689 4.2999L9.67959 4.40826L9.76538 4.48427L9.37632 4.25927L9.34171 4.26754L9.33568 4.44965L9.27474 4.48126L9.17315 4.4489L9.10316 4.60918L9.12649 4.77474L9.23636 4.83569L9.30258 4.72281L9.39288 4.72808L9.30107 4.82064L9.28302 4.98619L9.22206 5.02834L9.18293 4.96889L9.14982 4.97641L9.10542 5.07725L9.12574 5.1683L9.30107 5.1668L9.52833 5.23377L9.18745 5.22474L9.11294 5.18862L9.0708 5.23678L8.98652 5.23227L8.91278 5.13143L8.76904 5.09757L8.70959 5.21044L8.58016 5.10961L8.64036 5.05844L8.5749 5.00726L8.44772 5.03511L8.43869 5.13369L8.55909 5.17733L8.5606 5.25334L8.50491 5.33762L8.32882 5.31203L8.39128 5.36847L8.48309 5.36697L8.47857 5.45953L8.608 5.64163L8.71035 5.64615L8.63284 5.73495L8.66219 5.85234L8.73067 5.91329L8.68175 5.91179L8.51846 5.73194L8.46653 5.73344L8.45149 5.79816L8.48836 5.91103L8.4432 6.04799L8.45299 6.24365L8.06168 5.49489L7.9473 5.38503L7.97439 5.29096L8.03233 5.27365L7.97664 5.21797L7.9187 5.23904L7.89764 5.31354L7.78852 5.39707L7.78175 5.53402L7.62974 5.55735L7.59512 5.60401L7.63651 5.69657L7.53266 5.69732L7.47698 5.73269L7.30992 5.94264L7.28208 6.21053L7.33024 6.33545L7.33927 6.49649L7.37238 6.54916L7.46118 6.5898L7.44161 6.69741L7.11653 6.96832L7.0029 6.99616L6.98408 7.13011L6.87121 7.28211L6.74779 7.54775L6.57471 7.78178L6.37078 7.95185L5.80715 8.19868L5.35639 8.27919L5.19009 8.36498L4.86877 8.26866L4.77997 8.27694L4.69795 8.3394L4.55196 8.55085L4.08916 8.62761L4.04326 8.60579L3.77536 8.83079L3.64066 8.88948L3.36073 8.93689L3.13572 8.84207L2.97995 8.9256L2.84225 8.86615L2.65261 9.00236L2.4675 9.05729L2.3945 9.14158L2.20261 9.23112L2.10553 9.37711L1.95277 9.45989L1.81581 9.62168L1.48998 9.76466L1.40043 9.77143L1.16188 9.90387L0.934622 10.4321L0.756278 10.5074L0.720907 10.4713L0.746491 10.3087L0.693818 10.1974L0.774336 9.88957L0.763799 9.8685L0.655441 9.90613L0.576424 10.0235L0.349917 10.5751L0.473332 10.8648L0.482363 10.9506L0.434951 11.0951L0.441727 11.3141L0.421408 11.3901L0.30552 11.4811L0.249081 11.594L0.127926 12.0154L0.132442 12.1923L0.316052 12.482L0.313796 12.6031L0.387543 12.8123L0.474082 12.865L0.659952 13.2721L0.842817 13.4655L0.827764 13.604L0.801425 13.5972L0.773585 13.7726L0.814222 13.8719L0.792394 13.9449L0.690057 14.0254L0.599753 13.9042L0.534287 13.6333L0.468816 13.7598L0.399585 13.7853L0.373246 13.6386L0.416142 13.5069L0.386038 13.4219L0.200168 13.1924L0.136207 13.3451L0.218981 13.4791L0.266388 13.6747L0.519989 13.9118L0.515469 14.0668L0.456774 14.1541L0.341641 14.2L0.262628 14.0668L0.236289 13.8636L0.115134 13.7139L0.0895495 13.8583L0.0519235 13.6311L0 13.8222L0.0459026 13.9675L0.294988 14.2323L0.58169 14.6951L0.732194 15.0654L0.748001 15.1609L0.710375 15.2934L0.759288 15.5139L1.04373 15.8803L1.10996 16.0143L1.13855 16.2348L1.31464 16.444L1.35754 16.5456L1.43128 16.8082L1.39817 17.344L1.46891 17.5449L1.48847 17.7624L2.02652 18.913L2.07243 19.7347L2.03706 19.9259L1.96632 19.8085L2.01749 19.6866L1.93546 19.8295L2.03179 20.4045L1.77367 20.7529L1.62919 20.7837L1.44633 20.6573L1.41096 20.8214L1.45611 21.3805L1.54867 21.479L1.64575 21.4151L1.85344 21.4994L2.11381 21.7206L2.24399 21.9298L2.44266 21.9757L2.64132 22.1082L2.97845 22.1646L3.04015 22.124L3.3532 22.1247L3.57971 22.2436L3.59852 22.1751L3.67528 22.1541L3.84459 22.2308L3.89501 22.2022L3.78213 22.1774L3.76633 22.136L3.96575 22.0999L4.12905 22.0126L4.28858 21.8327L4.48649 21.7499L4.51508 21.7176L4.50304 21.6612L4.64376 21.5656L4.88607 21.616L4.98164 21.5596L5.09753 21.4459L5.21868 21.2179L5.37972 21.0983L5.53624 21.0501L5.87262 21.0945L5.97345 21.0388L6.23683 20.9794L6.72597 20.941L6.98709 21.0215L7.16092 20.9485L7.22413 21.0155L7.23091 21.1374L7.26251 21.1479L7.37087 21.1367L7.3799 21.087L7.45515 21.0351L7.85625 21.029L7.99772 20.9809L8.06544 21.0095L8.12038 21.1389L8.28443 21.0178L8.42515 21.0283L8.58393 20.9049L8.61252 20.8221L8.76453 20.6897L8.88719 20.281L9.03092 20.132L9.41018 20.047L9.86395 19.758L10.0378 19.7076L10.411 19.4382L10.49 19.4555L10.5803 19.4111L10.995 19.4856L11.524 19.4382L12.2171 19.2125L12.8853 18.8881L13.8244 18.7798L14.3512 18.8091L14.6409 18.6789L15.1481 18.916L15.4965 19.208L15.6041 19.2185L15.8141 19.1207L15.9781 19.1402L16.2897 19.3652L16.55 19.3833L16.6486 19.2757L16.7043 19.293L16.6953 19.3284L16.8292 19.4232L16.9308 19.5646L16.8759 19.5707L16.851 19.7031L17.0648 19.6181L17.1972 19.7483L17.2138 19.834L17.1415 19.9597L17.0979 19.8807L17.0324 19.8762L17.1912 20.2878L17.2409 20.3435L17.4568 20.2825L17.5501 20.3187L17.6728 20.6054L17.6585 20.7672L17.8158 20.8951L18.0016 21.1284L18.1002 21.6657L18.1928 21.7296L18.1115 21.756L18.0686 21.7266L17.9618 21.6122L17.958 21.5505L17.8797 21.7071L17.964 21.6777L18.0543 21.7364L18.3132 22.0615L18.3425 22.0622L18.3786 21.9772L18.4298 21.9697L18.5683 22.1164L18.6074 22.0999L18.6202 21.905L18.6089 21.853L18.4998 21.9298L18.4434 21.9253L18.5013 21.75L18.5517 21.6499L18.636 21.5972L18.706 21.4775L18.7722 21.4482L18.8535 21.3173L18.9385 21.1645L19.3065 20.935L19.3765 20.8116L19.4344 20.8469L19.5338 20.8432L19.5894 20.7965L19.8167 20.272L19.904 20.1772L20.0507 20.1411L20.0778 20.0011L20.0726 19.898L20.0349 19.8544L20.0417 19.6971L20.0854 19.7302L20.1982 20.1576L20.2682 20.2246L20.2742 20.2743L20.1094 20.345L20.0846 20.4188L20.1945 20.6927L19.9123 21.0102L19.8641 21.2179L19.7889 21.2819L19.8227 21.4061L19.8272 21.7733L19.7746 22.051L19.7339 22.0728L19.6496 22.0186L19.5074 22.0412L19.4389 22.0141L19.3675 22.2579L19.2817 22.3617L19.3313 22.4137L19.442 22.3407L19.5556 22.358L19.6098 22.288L19.7633 22.2301L19.9702 22.291L20.0304 22.2421L20.1343 21.8237L20.1456 21.6401L20.1741 21.5415L20.2517 21.4617L20.2419 21.376L20.3119 21.2556L20.4157 21.4324L20.4609 21.5949L20.6415 21.841L20.6565 22.1345L20.6166 22.2218L20.5956 22.4513L20.4706 22.586L20.3623 22.6402L20.3134 22.7267L20.3803 22.7771L20.6753 22.7613L20.8266 22.647L21.0471 22.6658L21.0839 22.6184L21.0215 22.5837L21.0298 22.5168L21.1645 22.4874L21.2277 22.425L21.3451 22.4829L21.3278 22.7997L21.251 22.808L21.2457 22.665L21.184 22.6116L21.1336 22.6319L21.1351 22.7207L21.5166 23.1045L21.7266 23.6689L21.7582 23.9127L21.6686 24.0414L21.6536 24.1354L21.6942 24.2716L21.6686 24.3243L21.8666 24.6238L21.9704 24.6629L22.1623 25.0031L22.3045 25.146L22.4422 25.2198L22.662 25.2115L22.8456 25.3108L23.0585 25.5306L23.1541 25.5772L23.2188 25.5592L23.194 25.4779L23.3008 25.4215L23.4754 25.4471L23.635 25.5592L23.8141 25.5215L23.9412 25.572L24.1602 25.7413L24.3604 25.8053L24.7645 26.037L24.9188 25.8918L25.0091 25.867L25.1882 25.6465L25.4342 25.4802L25.6758 25.4395L25.7179 25.3748L25.7142 25.2988L25.6577 25.283L25.5561 25.3319L25.4433 25.3124L25.4387 25.2747L25.5682 25.2484L25.8872 25.0083L26.0355 25.1882L26.0618 25.2853L25.9422 25.496L25.7593 25.5343L25.8737 25.6675L25.979 25.6585L26.128 25.505L26.1627 25.3891L26.3169 25.3778L26.408 25.5306L26.3071 25.6119L26.2936 25.7089L26.4501 25.8527L26.5487 25.809L26.6209 25.8203L26.6932 26.034L26.7737 26.0408L26.8249 25.9956L26.8881 26.0227L26.9739 26.1303L27.0333 26.2861L27.0943 26.338L27.1673 26.2635L27.1552 25.9806L27.1259 25.967L27.1086 26.0303L27.0145 26.0965L26.9234 25.9302L26.952 25.8873L27.1251 25.8888L27.4863 25.8203L27.8942 25.3906L28.2102 25.1265L28.6595 24.9609L29.4767 24.9338L29.6965 24.8721L29.7717 24.8315L29.8635 24.6915L29.996 24.4078L30.0539 24.3898L30.0547 24.3559L30.0441 24.2852L29.9629 24.1911L29.9591 24.0429L30.1021 23.501L30.1495 23.4393L30.1713 23.0488L30.4798 22.3347L30.613 22.2353L30.598 22.151L30.6717 22.1209L30.6732 22.1872L30.7003 22.2165L30.7221 22.1977L30.7349 22.1315L30.6491 21.9885L30.7184 21.8974L30.759 21.7123L30.7259 21.6717L30.8027 21.4482L31.0156 21.178L30.9374 21.1359L31.0788 21.0923L31.1338 20.7589L31.2271 20.634L31.2534 20.5294L31.2188 20.4985L31.2271 20.4541L31.3249 20.406L31.519 20.0387L31.7907 19.9244L31.7764 19.8393L32.1053 19.5707L32.091 19.3088L32.3664 18.8543L32.5515 18.1808L32.4951 18.0732L32.5056 17.8211L32.6975 17.2409L32.7885 16.7224L32.766 16.6569L32.8563 16.392L32.9849 16.2235L33 16.0369L32.9473 15.8803Z",
    fill: "currentColor"
  })), australia_path2 || (australia_path2 = /*#__PURE__*/react.createElement("path", {
    d: "M25.121 26.7866L25.0864 26.7964L25.0849 26.8852L25.0209 26.9326L25.0067 27.1034L25.0044 27.1614L25.0511 27.2223L25.0465 27.363L25.0751 27.3841L25.2256 27.2765L25.2587 27.1629L25.2279 26.8799L25.121 26.7866Z",
    fill: "currentColor"
  })), australia_path3 || (australia_path3 = /*#__PURE__*/react.createElement("path", {
    d: "M28.4216 27.3877L28.4382 27.4901L28.5119 27.5307L28.6782 27.4713L28.6429 27.2327L28.5428 27.1635L28.381 26.9475L28.311 26.9776L28.2117 27.1085L28.3283 27.2124L28.4216 27.3877Z",
    fill: "currentColor"
  })), australia_path4 || (australia_path4 = /*#__PURE__*/react.createElement("path", {
    d: "M28.6648 28.9748L28.6317 28.8024L28.6671 28.673L28.6242 28.4916L28.6761 28.3065L28.631 28.2049L28.4729 28.0627L28.3849 28.0371L28.3277 28.1643L28.2758 28.1944L28.1426 28.1297L28.0907 28.1425L27.9898 28.296L27.9311 28.3314L27.8815 28.287L27.7106 28.3216L27.6045 28.2862L27.4427 28.3765L27.4465 28.4284L27.5443 28.4916L27.433 28.4713L27.4149 28.3998L27.372 28.3863L27.2501 28.4743L27.2539 28.512L27.1831 28.4721L26.9333 28.4796L26.183 28.0981L26.0536 28.1191L25.9467 28.0401L25.7639 28.0183L25.7142 28.0514L25.7127 28.1763L25.6465 28.2365L25.7014 28.5443L25.9212 29.0839L26.1605 29.4353L26.1868 29.5956L26.332 29.7551L26.4088 29.7822L26.3411 29.9718L26.3057 29.8078L26.1401 29.6588L26.1251 29.6784L26.1695 30.0704L26.2462 30.1216L26.3328 30.394L26.3749 30.4617L26.4434 30.4768L26.6406 30.8312L26.8753 30.8718L26.9069 30.8147L26.9649 30.8628L26.9634 30.9366L26.767 30.8861L26.7188 30.92L26.8054 31.0562L26.8641 31.0758L26.9626 31.0457L27.0153 31.0968L27.2629 31.1209L27.3336 31.1744L27.439 31.1909L27.454 31.2248L27.5217 31.1909L27.6692 30.8222L27.5661 30.7281L27.5669 30.6529L27.6015 30.6325L27.6723 30.7733L27.7377 30.8154L27.7942 30.8011L27.7896 30.6499L27.8769 30.3948L27.8514 30.33L27.9251 30.3774L27.9409 30.5468L28.0214 30.5204L28.0432 30.4768L28.0019 30.3451L28.047 30.3112L28.266 30.4241L28.3262 30.5295L28.2299 30.5565L28.1682 30.4309L28.0967 30.5189L28.1072 30.5723L28.2366 30.7748L28.3262 30.704L28.4044 30.7537L28.3683 30.5919L28.4075 30.397L28.3352 30.3233L28.3262 30.3744L28.2795 30.3594L28.3126 30.248L28.3713 30.1871L28.3623 30.0727L28.4112 29.9718L28.4729 29.5256L28.5677 29.3375L28.6611 29.5512L28.6332 29.6776L28.6626 29.7024L28.7055 29.6415L28.6242 29.1945L28.6648 28.9748Z",
    fill: "currentColor"
  })));
};
const australia_ForwardRef = /*#__PURE__*/(0,react.forwardRef)(SvgAustralia);

/* harmony default export */ const australia = (__webpack_require__.p + "e07a025b319ae9c501c52f8bb7f3dede.svg");
;// CONCATENATED MODULE: ./src/assets/icons/warning_triangle.svg
var warning_triangle_path;
function warning_triangle_extends() { warning_triangle_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return warning_triangle_extends.apply(this, arguments); }


const SvgWarningTriangle = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/react.createElement("svg", warning_triangle_extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/react.createElement("title", {
    id: titleId
  }, title) : null, warning_triangle_path || (warning_triangle_path = /*#__PURE__*/react.createElement("path", {
    d: "M17.4763 15.0662L12.0024 5.6398C11.5048 4.78673 10.2678 4.78673 9.78442 5.6398L4.31056 15.0662C3.81294 15.9193 4.43852 16.9998 5.41955 16.9998H16.353C17.3483 16.9998 17.9739 15.9335 17.4763 15.0662ZM10.865 7.60186C11.2773 7.58764 11.6185 7.90043 11.6469 8.31275C11.6469 8.34118 11.6469 8.3554 11.6469 8.38384L11.4621 12.3364C11.4479 12.6492 11.1778 12.8909 10.8792 12.8767C10.5806 12.8624 10.3531 12.6207 10.3389 12.3364L10.1541 8.36962C10.1256 7.97152 10.4527 7.61608 10.865 7.60186ZM10.8934 15.3648C10.4242 15.3648 10.0403 14.9809 10.0403 14.5117C10.0403 14.0425 10.4242 13.6586 10.8934 13.6586C11.3626 13.6586 11.7465 14.0425 11.7465 14.5117C11.7465 14.9809 11.3626 15.3648 10.8934 15.3648Z",
    fill: "currentColor"
  })));
};
const warning_triangle_ForwardRef = /*#__PURE__*/(0,react.forwardRef)(SvgWarningTriangle);

/* harmony default export */ const warning_triangle = (__webpack_require__.p + "37da2d947a3bb92959a3da7fcee2ed8c.svg");
;// CONCATENATED MODULE: ./src/assets/icons/chat.svg
var chat_path;
function chat_extends() { chat_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return chat_extends.apply(this, arguments); }


const SvgChat = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/react.createElement("svg", chat_extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 28 32",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/react.createElement("title", {
    id: titleId
  }, title) : null, chat_path || (chat_path = /*#__PURE__*/react.createElement("path", {
    fill: "currentColor",
    d: "M28 32s-4.714-1.855-8.527-3.34H3.437C1.54 28.66 0 27.026 0 25.013V3.644C0 1.633 1.54 0 3.437 0h21.125c1.898 0 3.437 1.632 3.437 3.645v18.404H28V32zm-4.139-11.982a.88.88 0 00-1.292-.105c-.03.026-3.015 2.681-8.57 2.681-5.486 0-8.517-2.636-8.571-2.684a.88.88 0 00-1.29.107 1.01 1.01 0 00-.219.708.992.992 0 00.318.664c.142.128 3.537 3.15 9.762 3.15 6.226 0 9.621-3.022 9.763-3.15a.992.992 0 00.317-.664 1.01 1.01 0 00-.218-.707z"
  })));
};
const chat_ForwardRef = /*#__PURE__*/(0,react.forwardRef)(SvgChat);

/* harmony default export */ const chat = (__webpack_require__.p + "233079a9dd12d0a2bdddb9f20d6ef8e9.svg");
;// CONCATENATED MODULE: ./src/assets/icons/local_time.svg
var local_time_path, local_time_path2, local_time_path3, local_time_path4, local_time_path5, local_time_path6, local_time_path7, local_time_path8, local_time_path9, local_time_path10, local_time_path11;
function local_time_extends() { local_time_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return local_time_extends.apply(this, arguments); }


const SvgLocalTime = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/react.createElement("svg", local_time_extends({
    width: 58,
    height: 49,
    viewBox: "0 0 58 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/react.createElement("title", {
    id: titleId
  }, title) : null, local_time_path || (local_time_path = /*#__PURE__*/react.createElement("path", {
    d: "M45.1058 27.8193L33.6923 16.4116C33.1547 15.874 32.2828 15.874 31.7508 16.4116L20.3373 27.8193C19.7997 28.3569 19.7997 29.2288 20.3373 29.7608C20.8748 30.2928 21.7467 30.2984 22.2787 29.7608L32.7155 19.324L43.1582 29.7608C43.6958 30.2984 44.5677 30.2984 45.0997 29.7608C45.6428 29.2235 45.6428 28.3513 45.1052 27.8193H45.1058Z",
    fill: "currentColor"
  })), local_time_path2 || (local_time_path2 = /*#__PURE__*/react.createElement("path", {
    d: "M28.4325 32.9421H32.173V35.509H28.4325V32.9421Z",
    fill: "currentColor"
  })), local_time_path3 || (local_time_path3 = /*#__PURE__*/react.createElement("path", {
    d: "M28.4325 29.2783H32.173V31.8452H28.4325V29.2783Z",
    fill: "currentColor"
  })), local_time_path4 || (local_time_path4 = /*#__PURE__*/react.createElement("path", {
    d: "M33.2695 32.9421H37.0101V35.509H33.2695V32.9421Z",
    fill: "currentColor"
  })), local_time_path5 || (local_time_path5 = /*#__PURE__*/react.createElement("path", {
    d: "M33.2695 29.2783H37.0101V31.8452H33.2695V29.2783Z",
    fill: "currentColor"
  })), local_time_path6 || (local_time_path6 = /*#__PURE__*/react.createElement("path", {
    d: "M42.5112 38.2568V30.639C42.4672 30.6062 42.4233 30.5786 42.3849 30.5403L32.7212 20.8765L23.0575 30.5403C23.0191 30.5786 22.9752 30.6062 22.9368 30.639V32.9534L23.8857 31.6536L26.5786 35.3502V38.257L42.5112 38.2568ZM27.3349 28.7302C27.3349 28.4284 27.5816 28.1817 27.8833 28.1817H37.5581C37.706 28.1817 37.8434 28.2421 37.9474 28.3464C38.0517 28.4451 38.1065 28.5877 38.1065 28.7302V36.0578C38.1065 36.3595 37.8598 36.6062 37.558 36.6062L27.8833 36.606C27.5816 36.606 27.3349 36.3593 27.3349 36.0575L27.3349 28.7302Z",
    fill: "currentColor"
  })), local_time_path7 || (local_time_path7 = /*#__PURE__*/react.createElement("path", {
    d: "M26.5786 39.3538H44.42V41.0046H26.5786V39.3538Z",
    fill: "currentColor"
  })), local_time_path8 || (local_time_path8 = /*#__PURE__*/react.createElement("path", {
    d: "M26.0027 13.7025C26.0027 10.0004 22.9972 7 19.295 7C15.5928 7 12.5931 10.0002 12.5931 13.7025C12.5931 18.5235 18.3082 21.4245 19.295 26.1801C20.2878 21.4247 26.0027 18.5234 26.0027 13.7025ZM16.0701 13.7025C16.0701 11.9202 17.5179 10.472 19.3006 10.472C21.083 10.472 22.5311 11.9198 22.5311 13.7025C22.5311 15.4849 21.0833 16.9331 19.3006 16.9331C17.518 16.9328 16.0701 15.485 16.0701 13.7025Z",
    fill: "currentColor"
  })), local_time_path9 || (local_time_path9 = /*#__PURE__*/react.createElement("path", {
    d: "M11.5012 35.7068V41.005H14.6989V35.7068L13.0973 33.513L11.5012 35.7068Z",
    fill: "currentColor"
  })), local_time_path10 || (local_time_path10 = /*#__PURE__*/react.createElement("path", {
    d: "M16.893 35.7067V37.4618H15.7961V39.9628H16.893V41.0049H20.0907V35.7067L18.4891 33.5129L16.893 35.7067Z",
    fill: "currentColor"
  })), local_time_path11 || (local_time_path11 = /*#__PURE__*/react.createElement("path", {
    d: "M22.2839 35.7067V37.4618H21.187V39.9628H22.2839V41.0049H25.4816V35.7067L23.8855 33.5129L22.2839 35.7067Z",
    fill: "currentColor"
  })));
};
const local_time_ForwardRef = /*#__PURE__*/(0,react.forwardRef)(SvgLocalTime);

/* harmony default export */ const local_time = (__webpack_require__.p + "6074b6513f1448270eef6962912fc4c0.svg");
;// CONCATENATED MODULE: ./src/assets/icons/calendar_filled.svg
var calendar_filled_g;
function calendar_filled_extends() { calendar_filled_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return calendar_filled_extends.apply(this, arguments); }


const SvgCalendarFilled = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/react.createElement("svg", calendar_filled_extends({
    width: 24,
    height: 24,
    viewBox: "0 1 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/react.createElement("title", {
    id: titleId
  }, title) : null, calendar_filled_g || (calendar_filled_g = /*#__PURE__*/react.createElement("g", {
    opacity: 0.7
  }, /*#__PURE__*/react.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.252 20H18.748C19.4385 20 20 19.4385 20 18.748V6.2525C20 5.562 19.438 5 18.7475 5H5.2525C4.562 5 4 5.562 4 6.2525V18.748C4 19.4385 4.562 20 5.252 20ZM5 6.2525C5 6.1135 5.1135 6 5.2525 6H18.7475C18.8865 6 19 6.1135 19 6.2525V18.748C19 18.887 18.887 19 18.748 19H5.252C5.113 19 5 18.887 5 18.748V6.2525Z",
    fill: "currentColor"
  }), /*#__PURE__*/react.createElement("path", {
    d: "M7 7C6.724 7 6.5 6.776 6.5 6.5V4.5C6.5 4.224 6.724 4 7 4C7.276 4 7.5 4.224 7.5 4.5V6.5C7.5 6.776 7.276 7 7 7Z",
    fill: "currentColor"
  }), /*#__PURE__*/react.createElement("path", {
    d: "M17 7C16.7235 7 16.5 6.776 16.5 6.5V4.5C16.5 4.224 16.7235 4 17 4C17.2765 4 17.5 4.224 17.5 4.5V6.5C17.5 6.776 17.2765 7 17 7Z",
    fill: "currentColor"
  }), /*#__PURE__*/react.createElement("path", {
    d: "M19.5 9H4.5C4.224 9 4 8.776 4 8.5C4 8.224 4.224 8 4.5 8H19.5C19.7765 8 20 8.224 20 8.5C20 8.776 19.7765 9 19.5 9Z",
    fill: "currentColor"
  }), /*#__PURE__*/react.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19 9H5V19H19V9ZM11 10H6V15H11V10Z",
    fill: "currentColor"
  }))));
};
const calendar_filled_ForwardRef = /*#__PURE__*/(0,react.forwardRef)(SvgCalendarFilled);

/* harmony default export */ const calendar_filled = (__webpack_require__.p + "ed28ac0984c858783ca79b66074548f9.svg");
;// CONCATENATED MODULE: ./src/assets/icons/dataflows-dashboard.svg
var dataflows_dashboard_path, dataflows_dashboard_path2, dataflows_dashboard_path3;
function dataflows_dashboard_extends() { dataflows_dashboard_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return dataflows_dashboard_extends.apply(this, arguments); }


const SvgDataflowsDashboard = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/react.createElement("svg", dataflows_dashboard_extends({
    width: 24,
    height: 16,
    y: 4,
    viewBox: "0 0 20 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/react.createElement("title", {
    id: titleId
  }, title) : null, dataflows_dashboard_path || (dataflows_dashboard_path = /*#__PURE__*/react.createElement("path", {
    d: "M4.08975 1.48975L2.6 0L0 2.6L2.6 5.2L4.3293 3.4707H6.22917C7.7541 3.4707 8.99167 4.80187 8.99167 6.44213C8.99167 9.17731 11.053 11.3945 13.5958 11.3945H14.8609L16.4667 13.0003L19.0667 10.4003L16.4667 7.80029L14.8534 9.41356H13.5958C12.0691 9.41356 10.8333 8.08436 10.8333 6.44213C10.8333 3.70694 8.77204 1.48975 6.22917 1.48975H4.08975Z",
    fill: "currentColor"
  })), dataflows_dashboard_path2 || (dataflows_dashboard_path2 = /*#__PURE__*/react.createElement("path", {
    d: "M16.4667 0L19.0667 2.6L16.4667 5.2L14.7374 3.4707H13.5958C13.0885 3.4707 12.6249 3.63508 12.2183 3.89408C11.9899 3.27105 11.6805 2.69456 11.303 2.17414C11.977 1.74733 12.7543 1.48975 13.5958 1.48975H14.977L16.4667 0Z",
    fill: "currentColor"
  })), dataflows_dashboard_path3 || (dataflows_dashboard_path3 = /*#__PURE__*/react.createElement("path", {
    d: "M4.21326 9.41356L2.6 7.80029L0 10.4003L2.6 13.0003L4.20579 11.3945H6.2292C7.06905 11.3945 7.84805 11.1369 8.52202 10.7096C8.14495 10.1911 7.83563 9.61465 7.60543 8.99161C7.20071 9.25117 6.73661 9.41356 6.2292 9.41356H4.21326Z",
    fill: "currentColor"
  })));
};
const dataflows_dashboard_ForwardRef = /*#__PURE__*/(0,react.forwardRef)(SvgDataflowsDashboard);

/* harmony default export */ const dataflows_dashboard = (__webpack_require__.p + "933709534f2f678883be668dfe9be947.svg");
;// CONCATENATED MODULE: ./src/assets/icons/datasets.svg
var datasets_path, datasets_path2, datasets_path3, datasets_path4, datasets_path5, datasets_path6;
function datasets_extends() { datasets_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return datasets_extends.apply(this, arguments); }


const SvgDatasets = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/react.createElement("svg", datasets_extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/react.createElement("title", {
    id: titleId
  }, title) : null, datasets_path || (datasets_path = /*#__PURE__*/react.createElement("path", {
    d: "M5.36667 9.23546H13.0333C13.5424 9.25657 14.0503 9.17187 14.5249 8.9867C14.9995 8.80153 15.4306 8.51991 15.7909 8.15966C16.1511 7.7994 16.4327 7.36833 16.6179 6.89369C16.8031 6.41906 16.8878 5.91117 16.8667 5.40213V4.63546H12.2667C11.8602 4.63493 11.4705 4.47322 11.183 4.18578C10.8956 3.89833 10.7339 3.50863 10.7333 3.10213C10.7325 2.28905 10.4092 1.5095 9.83423 0.934564C9.25929 0.359629 8.47975 0.0362733 7.66667 0.0354614H3.06667C2.25359 0.0362733 1.47404 0.359629 0.899103 0.934564C0.324167 1.5095 0.000811864 2.28905 0 3.10213V12.8564L0.109327 12.6743C0.61385 11.6957 1.36334 10.8646 2.28472 10.2619C3.2061 9.65921 4.26792 9.30558 5.36667 9.23546Z",
    fill: "currentColor"
  })), datasets_path2 || (datasets_path2 = /*#__PURE__*/react.createElement("path", {
    d: "M19.1667 13.1916C19.9562 13.1918 20.7378 13.3481 21.4667 13.6516V7.70229C21.4659 6.88921 21.1425 6.10966 20.5676 5.53472C19.9926 4.95979 19.2131 4.63643 18.4 4.63562V5.40229C18.427 6.11429 18.3066 6.8242 18.0465 7.48752C17.7863 8.15085 17.392 8.7533 16.8882 9.25712C16.3843 9.76095 15.7819 10.1553 15.1186 10.4154C14.4552 10.6756 13.7453 10.7959 13.0333 10.769H5.36667C4.54504 10.8479 3.75625 11.1313 3.07227 11.5933C2.3883 12.0554 1.83092 12.6813 1.45099 13.4141L1.33676 13.6047C0.462002 15.0643 -2.15306e-05 16.734 7.52526e-10 18.4356C7.52528e-10 19.249 0.323094 20.029 0.898206 20.6041C1.47332 21.1792 2.25334 21.5023 3.06667 21.5023H13.616C13.2364 20.5893 13.0882 19.5968 13.1843 18.6128C13.2805 17.6288 13.6182 16.6837 14.1673 15.8615C14.7164 15.0393 15.4601 14.3655 16.3322 13.8997C17.2043 13.4339 18.178 13.1907 19.1667 13.1916Z",
    fill: "currentColor"
  })), datasets_path3 || (datasets_path3 = /*#__PURE__*/react.createElement("path", {
    d: "M17.6334 19.969H16.1C15.6766 19.969 15.3334 20.3122 15.3334 20.7356V22.269C15.3334 22.6924 15.6766 23.0356 16.1 23.0356H17.6334C18.0568 23.0356 18.4 22.6924 18.4 22.269V20.7356C18.4 20.3122 18.0568 19.969 17.6334 19.969Z",
    fill: "currentColor"
  })), datasets_path4 || (datasets_path4 = /*#__PURE__*/react.createElement("path", {
    d: "M22.2333 19.969H20.7C20.2765 19.969 19.9333 20.3122 19.9333 20.7356V22.269C19.9333 22.6924 20.2765 23.0356 20.7 23.0356H22.2333C22.6567 23.0356 23 22.6924 23 22.269V20.7356C23 20.3122 22.6567 19.969 22.2333 19.969Z",
    fill: "currentColor"
  })), datasets_path5 || (datasets_path5 = /*#__PURE__*/react.createElement("path", {
    d: "M17.6334 15.3688H16.1C15.6766 15.3688 15.3334 15.7121 15.3334 16.1355V17.6688C15.3334 18.0923 15.6766 18.4355 16.1 18.4355H17.6334C18.0568 18.4355 18.4 18.0923 18.4 17.6688V16.1355C18.4 15.7121 18.0568 15.3688 17.6334 15.3688Z",
    fill: "currentColor"
  })), datasets_path6 || (datasets_path6 = /*#__PURE__*/react.createElement("path", {
    d: "M22.0089 15.5933C21.8652 15.4496 21.6702 15.3688 21.4669 15.3688C21.2636 15.3688 21.0686 15.4496 20.9249 15.5933L19.8408 16.6774C19.6971 16.8211 19.6163 17.0161 19.6163 17.2194C19.6163 17.4227 19.6971 17.6177 19.8408 17.7614L20.9249 18.8457C21.0686 18.9894 21.2636 19.0701 21.4669 19.0701C21.6702 19.0701 21.8652 18.9894 22.0089 18.8457L23.093 17.7614C23.2367 17.6177 23.3175 17.4227 23.3175 17.2194C23.3175 17.0161 23.2367 16.8211 23.093 16.6774L22.0089 15.5933Z",
    fill: "currentColor"
  })));
};
const datasets_ForwardRef = /*#__PURE__*/(0,react.forwardRef)(SvgDatasets);

/* harmony default export */ const datasets = (__webpack_require__.p + "06b395a08efb22c3c7d20f2c38235b62.svg");
;// CONCATENATED MODULE: ./src/assets/icons/policies.svg
var policies_path, policies_path2, policies_path3, policies_path4;
function policies_extends() { policies_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return policies_extends.apply(this, arguments); }


const SvgPolicies = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/react.createElement("svg", policies_extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/react.createElement("title", {
    id: titleId
  }, title) : null, policies_path || (policies_path = /*#__PURE__*/react.createElement("path", {
    d: "M16 18.0355H23V20.0355H16V18.0355Z",
    fill: "currentColor"
  })), policies_path2 || (policies_path2 = /*#__PURE__*/react.createElement("path", {
    d: "M21.55 21.0355C21.3681 21.0355 21.1904 20.9255 21.0855 20.7259C20.9231 20.4154 20.9993 20.0047 21.2555 19.808L22.3543 18.9643L21.2942 18.2895C21.0258 18.1187 20.922 17.7168 21.0629 17.3915C21.205 17.0662 21.5355 16.9409 21.8047 17.1121L23.7062 18.3216C23.8797 18.432 23.9915 18.6464 23.9996 18.8836C24.0072 19.1212 23.9107 19.3453 23.7449 19.4725L21.8434 20.9315C21.7523 21.002 21.65 21.0355 21.5501 21.0355L21.55 21.0355Z",
    fill: "currentColor"
  })), policies_path3 || (policies_path3 = /*#__PURE__*/react.createElement("path", {
    d: "M5.34211 9.82422H12.9737C13.4804 9.84523 13.986 9.76092 14.4584 9.57659C14.9309 9.39227 15.36 9.11194 15.7186 8.75333C16.0772 8.39473 16.3575 7.96563 16.5418 7.49317C16.7262 7.0207 16.8105 6.51514 16.7895 6.00843V5.24527H12.2105C11.8059 5.24474 11.418 5.08377 11.1318 4.79764C10.8457 4.51152 10.6847 4.1236 10.6842 3.71895C10.6834 2.90959 10.3615 2.13361 9.78922 1.56131C9.21692 0.989004 8.44094 0.667129 7.63158 0.666321H3.05263C2.24327 0.667129 1.46729 0.989004 0.894988 1.56131C0.322684 2.13361 0.000808149 2.90959 0 3.71895V13.4286L0.108826 13.2473C0.61104 12.2732 1.3571 11.4459 2.27426 10.8459C3.19142 10.246 4.24839 9.89401 5.34211 9.82422V9.82422Z",
    fill: "currentColor"
  })), policies_path4 || (policies_path4 = /*#__PURE__*/react.createElement("path", {
    d: "M19.0789 13.7621C19.8648 13.7623 20.6429 13.9179 21.3684 14.22V8.2979C21.3676 7.48854 21.0457 6.71256 20.4734 6.14026C19.9011 5.56795 19.1251 5.24608 18.3158 5.24527V6.00843C18.3427 6.71717 18.2229 7.42383 17.9639 8.08412C17.7049 8.74441 17.3124 9.3441 16.8109 9.84562C16.3094 10.3471 15.7097 10.7397 15.0494 10.9986C14.3891 11.2576 13.6824 11.3774 12.9737 11.3505H5.34211C4.52424 11.4291 3.73906 11.7112 3.05821 12.1711C2.37737 12.6311 1.82254 13.2542 1.44435 13.9836L1.33064 14.1733C0.459888 15.6262 -2.14321e-05 17.2883 7.49082e-10 18.9821C7.49084e-10 19.7917 0.321615 20.5682 0.894095 21.1406C1.46657 21.7131 2.24302 22.0347 3.05263 22.0347H13.5537C13.1759 21.126 13.0283 20.138 13.124 19.1585C13.2197 18.1789 13.5558 17.2382 14.1025 16.4198C14.6491 15.6014 15.3893 14.9306 16.2575 14.4669C17.1256 14.0033 18.0948 13.7612 19.0789 13.7621V13.7621Z",
    fill: "currentColor"
  })));
};
const policies_ForwardRef = /*#__PURE__*/(0,react.forwardRef)(SvgPolicies);

/* harmony default export */ const policies = (__webpack_require__.p + "f5229fb8c6222b66fe9b4d8f6fa18a10.svg");
;// CONCATENATED MODULE: ./src/assets/icons/action_hide.svg
var action_hide_path, action_hide_path2, action_hide_path3, action_hide_path4;
function action_hide_extends() { action_hide_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return action_hide_extends.apply(this, arguments); }


const SvgActionHide = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/react.createElement("svg", action_hide_extends({
    width: 24,
    height: 14,
    viewBox: "0 0 12 7",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/react.createElement("title", {
    id: titleId
  }, title) : null, action_hide_path || (action_hide_path = /*#__PURE__*/react.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.39414 1L1.19703 1.18116C0.999914 1.36232 0.999914 1.36231 1 1.3624L1.00072 1.36321L1.00233 1.36491L1.00798 1.37101C1.01282 1.37621 1.01981 1.38365 1.02887 1.39306C1.04697 1.41206 1.07333 1.43922 1.10757 1.47364C1.17587 1.54231 1.27573 1.63948 1.40338 1.75564C1.65849 1.9878 2.02629 2.29706 2.47814 2.60676C3.37605 3.22195 4.63473 3.85837 6.01593 3.85837C7.39713 3.85837 8.65602 3.22195 9.55372 2.60676C10.0056 2.29706 10.3734 1.9878 10.6285 1.75564C10.7561 1.63947 10.8559 1.54231 10.9243 1.47364C10.9585 1.43922 10.9849 1.41206 11.003 1.39306C11.012 1.38365 11.019 1.37621 11.0239 1.37101L11.0295 1.36491L11.0311 1.36321L11.0317 1.36258C11.0318 1.36249 11.0319 1.36231 10.8348 1.18116L10.6377 1L10.6369 1.0009L10.633 1.00511L10.6157 1.02331C10.6001 1.03971 10.5764 1.06427 10.5449 1.09573C10.4821 1.15884 10.3886 1.24991 10.2681 1.35963C10.0267 1.57924 9.67834 1.87236 9.25104 2.16503C8.39088 2.75457 7.2401 3.32288 6.01593 3.32288C4.79176 3.32288 3.64088 2.75457 2.78081 2.16503C2.3537 1.87236 2.00517 1.57925 1.76388 1.35963C1.64332 1.24991 1.54983 1.15884 1.487 1.09573C1.45563 1.06427 1.43187 1.03971 1.41628 1.02331L1.39898 1.00511L1.39503 1.0009L1.39414 1Z",
    fill: "currentColor",
    stroke: "currentColor",
    strokeWidth: 0.5
  })), action_hide_path2 || (action_hide_path2 = /*#__PURE__*/react.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.28355 6.00029V3.59082H5.74805V6.00029H6.28355Z",
    fill: "currentColor",
    stroke: "currentColor",
    strokeWidth: 0.5
  })), action_hide_path3 || (action_hide_path3 = /*#__PURE__*/react.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.18918 4.85066L3.79549 3.24435L3.41686 2.86572L1.81055 4.47203L2.18918 4.85066Z",
    fill: "currentColor",
    stroke: "currentColor",
    strokeWidth: 0.5
  })), action_hide_path4 || (action_hide_path4 = /*#__PURE__*/react.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.84215 4.85066L8.23584 3.24435L8.61447 2.86572L10.2208 4.47203L9.84215 4.85066Z",
    fill: "currentColor",
    stroke: "currentColor",
    strokeWidth: 0.5
  })));
};
const action_hide_ForwardRef = /*#__PURE__*/(0,react.forwardRef)(SvgActionHide);

/* harmony default export */ const action_hide = (__webpack_require__.p + "4ad2a7ed8f080b04b5ff97164c077fa4.svg");
;// CONCATENATED MODULE: ./src/assets/icons/flow.svg
var flow_path;
function flow_extends() { flow_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return flow_extends.apply(this, arguments); }


const SvgFlow = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/react.createElement("svg", flow_extends({
    width: 18,
    height: 21,
    viewBox: "0 0 18 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/react.createElement("title", {
    id: titleId
  }, title) : null, flow_path || (flow_path = /*#__PURE__*/react.createElement("path", {
    d: "M3.28926 0.0354614C1.48043 0.0354614 0 1.39903 0 3.03875C0 4.35756 0.957995 5.47848 2.27483 5.8698V14.9013C0.958041 15.2958 0 16.4348 0 17.7537C0 19.3937 1.48047 20.7355 3.28926 20.7355C5.09804 20.7355 6.58649 19.3937 6.58649 17.7537C6.58649 16.4348 5.6207 15.2958 4.30391 14.9013V14.7575C4.30391 13.3943 4.76425 12.8629 5.61169 12.3792C6.45913 11.8957 7.79345 11.5991 9.23406 11.28C10.6744 10.9608 12.2367 10.612 13.5298 9.73521C14.7046 8.93861 15.549 7.64751 15.6935 5.8769C17.0225 5.4923 18 4.36561 18 3.03879C18 1.39903 16.5118 0.0355025 14.7028 0.0355025C12.8939 0.0355025 11.4135 1.39907 11.4135 3.03879C11.4135 4.3496 12.36 5.46472 13.6644 5.86245C13.5574 7.12304 13.0573 7.76202 12.3091 8.26945C11.4622 8.8441 10.1712 9.18508 8.75833 9.49814C7.34566 9.81137 5.82664 10.0895 4.5339 10.8274C4.45624 10.8718 4.37927 10.9153 4.30408 10.964V5.87001C5.62088 5.47868 6.58666 4.35777 6.58666 3.03896C6.58666 1.3992 5.09844 0.0356708 3.28943 0.0356708L3.28926 0.0354614ZM3.28926 1.88211C4.00169 1.88211 4.5652 2.39291 4.5652 3.03879C4.5652 3.68463 4.00173 4.17412 3.28926 4.17412C2.57679 4.17412 2.02111 3.68463 2.02111 3.03879C2.02111 2.39295 2.57683 1.88211 3.28926 1.88211ZM14.7026 1.88211C15.415 1.88211 15.9785 2.39291 15.9785 3.03879C15.9785 3.68463 15.4151 4.17412 14.7026 4.17412C13.9901 4.17412 13.4344 3.68463 13.4344 3.03879C13.4344 2.39295 13.9902 1.88211 14.7026 1.88211ZM3.28926 16.5972C4.00169 16.5972 4.5652 17.108 4.5652 17.7539C4.5652 18.3997 4.00173 18.8892 3.28926 18.8892C2.57679 18.8892 2.02111 18.3997 2.02111 17.7539C2.02111 17.108 2.57683 16.5972 3.28926 16.5972Z",
    fill: "currentColor"
  })));
};
const flow_ForwardRef = /*#__PURE__*/(0,react.forwardRef)(SvgFlow);

/* harmony default export */ const flow = (__webpack_require__.p + "4e43ba933d3d6dedcce87b82eb820247.svg");
;// CONCATENATED MODULE: ./src/assets/icons/users_widget.svg
var users_widget_path, users_widget_path2, users_widget_path3;
function users_widget_extends() { users_widget_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return users_widget_extends.apply(this, arguments); }


const SvgUsersWidget = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/react.createElement("svg", users_widget_extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/react.createElement("title", {
    id: titleId
  }, title) : null, users_widget_path || (users_widget_path = /*#__PURE__*/react.createElement("path", {
    d: "M11 0C12.4587 0 13.8576 0.579462 14.8891 1.61091C15.9205 2.64236 16.5 4.04131 16.5 5.5C16.5 6.95869 15.9205 8.35764 14.8891 9.38909C13.8576 10.4205 12.4587 11 11 11C9.54131 11 8.14236 10.4205 7.11091 9.38909C6.07946 8.35764 5.5 6.95869 5.5 5.5C5.5 4.04131 6.07946 2.64236 7.11091 1.61091C8.14236 0.579462 9.54131 0 11 0Z",
    fill: "currentColor"
  })), users_widget_path2 || (users_widget_path2 = /*#__PURE__*/react.createElement("path", {
    d: "M11 13.75C12.2629 13.75 13.476 13.8563 14.6054 14.0519C13.0318 15.1335 12 16.9463 12 19C12 20.0929 12.2922 21.1175 12.8027 22H0V19.25C0 16.2112 4.9225 13.75 11 13.75Z",
    fill: "currentColor"
  })), users_widget_path3 || (users_widget_path3 = /*#__PURE__*/react.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.9805 15.9772C18.6183 14.477 16.4795 14.477 14.1173 15.9772C13.6703 19.1694 14.4365 21.6274 17.5329 23C20.6613 21.6274 21.4274 19.1694 20.9805 15.9772ZM16.9583 22.202C15.6176 21.372 14.6599 20.0312 14.7876 16.9668H15.1707C14.9791 19.3929 15.6495 21.0528 16.9583 22.202Z",
    fill: "currentColor"
  })));
};
const users_widget_ForwardRef = /*#__PURE__*/(0,react.forwardRef)(SvgUsersWidget);

/* harmony default export */ const users_widget = (__webpack_require__.p + "dc58a9fba78e4628677169266ff53a0c.svg");
;// CONCATENATED MODULE: ./src/assets/icons/link.svg
var link_path, link_path2;
function link_extends() { link_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return link_extends.apply(this, arguments); }


const SvgLink = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/react.createElement("svg", link_extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/react.createElement("title", {
    id: titleId
  }, title) : null, link_path || (link_path = /*#__PURE__*/react.createElement("path", {
    d: "M13.8875 12.159C14.5204 11.6088 15.3524 12.57 14.7278 13.1272L14.7281 13.1277C14.1409 13.6443 13.3977 13.9294 12.6352 13.9294H8.16733C3.94309 13.7784 3.94535 7.6504 8.16733 7.5H12.6352C13.3978 7.5 14.1409 7.78501 14.7278 8.30165C15.3547 8.85677 14.5164 9.82232 13.8875 9.2698C13.6367 9.04879 13.2159 8.78559 12.6349 8.78559H8.16704C5.64103 8.85217 5.64387 12.5772 8.16704 12.6432H12.6349C13.2159 12.6432 13.6371 12.38 13.8875 12.159Z",
    fill: "currentColor"
  })), link_path2 || (link_path2 = /*#__PURE__*/react.createElement("path", {
    d: "M11.3651 10.0712H15.833L15.8327 10.0706C20.0569 10.2216 20.0546 16.3496 15.8327 16.5H11.3648C10.6022 16.5 9.85913 16.215 9.27215 15.6984C8.64475 15.1432 9.48475 14.1783 10.1125 14.7302C10.3633 14.9512 10.7841 15.2144 11.3651 15.2144H15.833C18.359 15.1478 18.3561 11.4228 15.833 11.3568H11.3651C10.7841 11.3568 10.3629 11.62 10.1125 11.841C9.84745 12.0758 9.4437 12.0482 9.21175 11.7801C8.48209 10.7259 10.6049 10.037 11.3651 10.0712Z",
    fill: "currentColor"
  })));
};
const link_ForwardRef = /*#__PURE__*/(0,react.forwardRef)(SvgLink);

/* harmony default export */ const icons_link = (__webpack_require__.p + "a22d5f99413b33b0ffb7f2fc78aa68b2.svg");
;// CONCATENATED MODULE: ./src/assets/icons/user_profile.svg
var user_profile_rect, user_profile_path, user_profile_path2;
function user_profile_extends() { user_profile_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return user_profile_extends.apply(this, arguments); }


const SvgUserProfile = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/react.createElement("svg", user_profile_extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/react.createElement("title", {
    id: titleId
  }, title) : null, user_profile_rect || (user_profile_rect = /*#__PURE__*/react.createElement("rect", {
    width: 24,
    height: 24,
    fill: "#D3D7DA",
    fillOpacity: 0.01
  })), user_profile_path || (user_profile_path = /*#__PURE__*/react.createElement("path", {
    d: "M14.8001 8.73418C14.8001 10.2442 13.5465 11.4684 12.0001 11.4684C10.4537 11.4684 9.20004 10.2442 9.20004 8.73418C9.20004 7.22414 10.4537 6 12.0001 6C13.5465 6 14.8001 7.22414 14.8001 8.73418Z",
    fill: "currentColor"
  })), user_profile_path2 || (user_profile_path2 = /*#__PURE__*/react.createElement("path", {
    d: "M12.3684 12.2311V17.6504H5C4.99973 16.7962 5.20559 15.9534 5.60144 15.1865C5.99741 14.4196 6.57306 13.7488 7.28443 13.2258C7.99566 12.7027 8.82363 12.341 9.70493 12.1686C10.5861 11.9962 11.4973 12.0176 12.3684 12.2311ZM15.3158 14.1531V11.7051L19.0001 14.8525L15.3158 18V15.552H13.1053V14.1531H15.3158Z",
    fill: "currentColor"
  })));
};
const user_profile_ForwardRef = /*#__PURE__*/(0,react.forwardRef)(SvgUserProfile);

/* harmony default export */ const user_profile = (__webpack_require__.p + "013db46ea05e520d42493fc8f583c877.svg");
;// CONCATENATED MODULE: ./src/assets/icons/dlp_scan.svg
var dlp_scan_rect, dlp_scan_path, dlp_scan_path2, dlp_scan_path3;
function dlp_scan_extends() { dlp_scan_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return dlp_scan_extends.apply(this, arguments); }


const SvgDlpScan = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/react.createElement("svg", dlp_scan_extends({
    width: 24,
    height: 24,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/react.createElement("title", {
    id: titleId
  }, title) : null, dlp_scan_rect || (dlp_scan_rect = /*#__PURE__*/react.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    fillOpacity: 0.01
  })), dlp_scan_path || (dlp_scan_path = /*#__PURE__*/react.createElement("path", {
    d: "M2.43005 11.9631H15.5649V17H2.43005V11.9631Z",
    fill: "currentColor"
  })), dlp_scan_path2 || (dlp_scan_path2 = /*#__PURE__*/react.createElement("path", {
    d: "M2.43005 1H15.5649V6.03695H2.43005V1Z",
    fill: "currentColor"
  })), dlp_scan_path3 || (dlp_scan_path3 = /*#__PURE__*/react.createElement("path", {
    d: "M0 8.39383H18V9.61188H0V8.39383Z",
    fill: "currentColor"
  })));
};
const dlp_scan_ForwardRef = /*#__PURE__*/(0,react.forwardRef)(SvgDlpScan);

/* harmony default export */ const dlp_scan = (__webpack_require__.p + "735ea5a2d90f7031898407bb10510f82.svg");
;// CONCATENATED MODULE: ./src/assets/icons/uninstall_protection.svg
var uninstall_protection_path;
function uninstall_protection_extends() { uninstall_protection_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return uninstall_protection_extends.apply(this, arguments); }


const SvgUninstallProtection = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", uninstall_protection_extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, uninstall_protection_path || (uninstall_protection_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.24004 5.61692C4.55119 5.61692 4 6.15914 4 6.83678V17.1548C4 17.8324 4.55119 18.3746 5.24004 18.3746H18.76C19.4488 18.3746 20 17.8324 20 17.1548L19.9999 6.81984C19.9999 6.1422 19.4487 5.59998 18.7598 5.59998H5.23992L5.24004 5.61692ZM19.1389 6.81984V8.5818L4.87843 8.58192V6.81983C4.87843 6.61656 5.0507 6.4471 5.25733 6.4471H18.7772C18.9839 6.46412 19.1389 6.61658 19.1389 6.81984ZM13.6448 12.2923L12.6114 13.3089L13.6448 14.3255C13.8171 14.495 13.8171 14.766 13.6448 14.9185C13.5587 15.0032 13.4554 15.0371 13.3521 15.0371C13.2487 15.0371 13.1281 15.0032 13.0421 14.9184L12.0087 13.9018L10.9753 14.9184C10.8891 15.0032 10.7858 15.0371 10.6653 15.0371C10.5447 15.0371 10.4414 15.0032 10.3554 14.9184C10.1831 14.749 10.1831 14.4779 10.3554 14.3254L11.3888 13.3088L10.3554 12.2922C10.1831 12.1227 10.1831 11.8517 10.3554 11.6991C10.5276 11.5296 10.8031 11.5296 10.9582 11.6991L11.9916 12.7157L13.0251 11.6991C13.1974 11.5296 13.4728 11.5296 13.6279 11.6991C13.8172 11.8518 13.8171 12.1229 13.6448 12.2923ZM8.21965 7.51448C8.21965 7.80249 7.97854 8.02279 7.70294 8.02279C7.41016 8.02279 7.18622 7.7856 7.18622 7.51448C7.18622 7.24337 7.42733 7.00617 7.70294 7.00617C7.97854 7.00617 8.21965 7.24336 8.21965 7.51448ZM9.94193 7.51448C9.94193 7.80249 9.70082 8.02279 9.42522 8.02279C9.14962 8.02279 8.9085 7.7856 8.9085 7.51448C8.9085 7.24337 9.14962 7.00617 9.42522 7.00617C9.70082 7.00617 9.94193 7.24336 9.94193 7.51448ZM6.49737 7.51448C6.49737 7.80249 6.25626 8.02279 5.98066 8.02279C5.70505 8.02279 5.46394 7.7856 5.46394 7.51448C5.46394 7.24337 5.70505 7.00617 5.98066 7.00617C6.25626 7.00617 6.49737 7.24336 6.49737 7.51448Z",
    fill: "#545454"
  })));
};
const uninstall_protection_ForwardRef = /*#__PURE__*/(/* unused pure expression or super */ null && (forwardRef(SvgUninstallProtection)));

/* harmony default export */ const uninstall_protection = (__webpack_require__.p + "09f43eb8aa8312627473e44e5700b752.svg");
;// CONCATENATED MODULE: ./src/assets/icons/groups.svg
var groups_path, groups_path2;
function groups_extends() { groups_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return groups_extends.apply(this, arguments); }


const SvgGroups = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/react.createElement("svg", groups_extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/react.createElement("title", {
    id: titleId
  }, title) : null, groups_path || (groups_path = /*#__PURE__*/react.createElement("path", {
    d: "M19.6667 5.5H4.33333C4.14924 5.5 4 5.66982 4 5.87931V16.1207C4 16.3302 4.14924 16.5 4.33333 16.5H19.6667C19.8508 16.5 20 16.3302 20 16.1207V5.87931C20 5.66982 19.8508 5.5 19.6667 5.5Z",
    fill: "#545454"
  })), groups_path2 || (groups_path2 = /*#__PURE__*/react.createElement("path", {
    d: "M15.68 17.5H8.32C8.14327 17.5 8 17.6492 8 17.8333V18.1667C8 18.3508 8.14327 18.5 8.32 18.5H15.68C15.8567 18.5 16 18.3508 16 18.1667V17.8333C16 17.6492 15.8567 17.5 15.68 17.5Z",
    fill: "#545454"
  })));
};
const groups_ForwardRef = /*#__PURE__*/(0,react.forwardRef)(SvgGroups);

/* harmony default export */ const groups = (__webpack_require__.p + "5416b27ac98c5bb4d7b9954ef2a10ac0.svg");
;// CONCATENATED MODULE: ./src/assets/icons/installers.svg
var installers_path;
function installers_extends() { installers_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return installers_extends.apply(this, arguments); }


const SvgInstallers = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/react.createElement("svg", installers_extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/react.createElement("title", {
    id: titleId
  }, title) : null, installers_path || (installers_path = /*#__PURE__*/react.createElement("path", {
    d: "M11.9264 14.5188C11.2465 14.5188 10.5944 14.256 10.1136 13.7884C9.63282 13.3207 9.36271 12.6864 9.36271 12.025C9.36271 11.3636 9.63282 10.7293 10.1136 10.2617C10.5944 9.79401 11.2465 9.53127 11.9264 9.53127C12.6064 9.53127 13.2584 9.79401 13.7392 10.2617C14.22 10.7293 14.4901 11.3636 14.4901 12.025C14.4901 12.6864 14.22 13.3207 13.7392 13.7884C13.2584 14.256 12.6064 14.5188 11.9264 14.5188ZM17.3688 12.7161C17.3981 12.4881 17.4201 12.2601 17.4201 12.025C17.4201 11.7899 17.3981 11.5548 17.3688 11.3125L18.9144 10.1511C19.0535 10.0443 19.0902 9.8519 19.0023 9.69515L17.5373 7.2299C17.4494 7.07315 17.2516 7.00902 17.0905 7.07315L15.2666 7.78565C14.8857 7.50777 14.4901 7.26552 14.0287 7.0874L13.7576 5.19927C13.7283 5.02827 13.5745 4.90002 13.3914 4.90002H10.4614C10.2783 4.90002 10.1245 5.02827 10.0952 5.19927L9.82418 7.0874C9.36271 7.26552 8.96717 7.50777 8.58628 7.78565L6.76238 7.07315C6.60124 7.00902 6.40346 7.07315 6.31557 7.2299L4.85059 9.69515C4.75537 9.8519 4.79932 10.0443 4.93849 10.1511L6.48404 11.3125C6.45474 11.5548 6.43276 11.7899 6.43276 12.025C6.43276 12.2601 6.45474 12.4881 6.48404 12.7161L4.93849 13.8989C4.79932 14.0058 4.75537 14.1981 4.85059 14.3549L6.31557 16.8201C6.40346 16.9769 6.60124 17.0339 6.76238 16.9769L8.58628 16.2573C8.96717 16.5423 9.36271 16.7845 9.82418 16.9626L10.0952 18.8508C10.1245 19.0218 10.2783 19.15 10.4614 19.15H13.3914C13.5745 19.15 13.7283 19.0218 13.7576 18.8508L14.0287 16.9626C14.4901 16.7774 14.8857 16.5423 15.2666 16.2573L17.0905 16.9769C17.2516 17.0339 17.4494 16.9769 17.5373 16.8201L19.0023 14.3549C19.0902 14.1981 19.0535 14.0058 18.9144 13.8989L17.3688 12.7161Z",
    fill: "#545454"
  })));
};
const installers_ForwardRef = /*#__PURE__*/(0,react.forwardRef)(SvgInstallers);

/* harmony default export */ const installers = (__webpack_require__.p + "9b680d87b8cc8c557e801c88ad47b094.svg");
;// CONCATENATED MODULE: ./src/assets/icons/table_settings.svg
var table_settings_path;
function table_settings_extends() { table_settings_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return table_settings_extends.apply(this, arguments); }


const SvgTableSettings = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/react.createElement("svg", table_settings_extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/react.createElement("title", {
    id: titleId
  }, title) : null, table_settings_path || (table_settings_path = /*#__PURE__*/react.createElement("path", {
    opacity: 0.8,
    d: "M8.89847 12.0114C8.08614 12.0114 7.30708 11.6975 6.73267 11.1388C6.15827 10.58 5.83557 9.82222 5.83557 9.03206C5.83557 8.2419 6.15827 7.4841 6.73267 6.92537C7.30708 6.36664 8.08614 6.05275 8.89847 6.05275C9.71079 6.05275 10.4899 6.36664 11.0643 6.92537C11.6387 7.4841 11.9614 8.2419 11.9614 9.03206C11.9614 9.82222 11.6387 10.58 11.0643 11.1388C10.4899 11.6975 9.71079 12.0114 8.89847 12.0114ZM15.4005 9.85776C15.4355 9.58536 15.4618 9.31297 15.4618 9.03206C15.4618 8.75115 15.4355 8.47025 15.4005 8.18083L17.247 6.79332C17.4133 6.66564 17.4571 6.4358 17.352 6.24853L15.6018 3.30327C15.4968 3.116 15.2605 3.03939 15.068 3.116L12.889 3.96723C12.4339 3.63525 11.9614 3.34583 11.41 3.13303L11.0862 0.877262C11.0512 0.672967 10.8675 0.519745 10.6487 0.519745H7.14824C6.92946 0.519745 6.74569 0.672967 6.71069 0.877262L6.3869 3.13303C5.83558 3.34583 5.36301 3.63525 4.90796 3.96723L2.72893 3.116C2.53641 3.03939 2.30013 3.116 2.19511 3.30327L0.444889 6.24853C0.331125 6.4358 0.383631 6.66564 0.549903 6.79332L2.39639 8.18083C2.36138 8.47025 2.33513 8.75115 2.33513 9.03206C2.33513 9.31297 2.36138 9.58536 2.39639 9.85776L0.549903 11.2708C0.383631 11.3985 0.331125 11.6283 0.444889 11.8156L2.19511 14.7608C2.30013 14.9481 2.53641 15.0162 2.72893 14.9481L4.90796 14.0884C5.36301 14.4289 5.83558 14.7183 6.3869 14.9311L6.71069 17.1869C6.74569 17.3912 6.92946 17.5444 7.14824 17.5444H10.6487C10.8675 17.5444 11.0512 17.3912 11.0862 17.1869L11.41 14.9311C11.9614 14.7098 12.4339 14.4289 12.889 14.0884L15.068 14.9481C15.2605 15.0162 15.4968 14.9481 15.6018 14.7608L17.352 11.8156C17.4571 11.6283 17.4133 11.3985 17.247 11.2708L15.4005 9.85776Z",
    fill: "currentColor"
  })));
};
const table_settings_ForwardRef = /*#__PURE__*/(0,react.forwardRef)(SvgTableSettings);

/* harmony default export */ const table_settings = (__webpack_require__.p + "fbcddb7dff514582eda5859977b25fb9.svg");
;// CONCATENATED MODULE: ./src/assets/icons/revert.svg
var revert_path;
function revert_extends() { revert_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return revert_extends.apply(this, arguments); }


const SvgRevert = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/react.createElement("svg", revert_extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/react.createElement("title", {
    id: titleId
  }, title) : null, revert_path || (revert_path = /*#__PURE__*/react.createElement("path", {
    d: "M7.87213 9.17148H13.5312C15.9993 9.17148 18 11.1722 18 13.6402C18 16.1083 15.9993 18.109 13.5312 18.109H10.6853C10.2366 18.109 9.87282 17.7452 9.87282 17.2965C9.87282 16.8478 10.2366 16.484 10.6853 16.484H13.5312C15.1018 16.484 16.375 15.2108 16.375 13.6402C16.375 12.0697 15.1018 10.7965 13.5312 10.7965H7.87213L9.70638 12.6307C10.0395 12.9639 10.0395 13.5041 9.70638 13.8372C9.37321 14.1704 8.83304 14.1704 8.49987 13.8372L5.24987 10.5872C4.91671 10.2541 4.91671 9.7139 5.24987 9.38073L8.49987 6.13073C8.83304 5.79757 9.37321 5.79757 9.70638 6.13073C10.0395 6.4639 10.0395 7.00407 9.70638 7.33723L7.87213 9.17148Z",
    fill: "currentColor"
  })));
};
const revert_ForwardRef = /*#__PURE__*/(0,react.forwardRef)(SvgRevert);

/* harmony default export */ const revert = (__webpack_require__.p + "12c23a8dc367500251c5c60978897d73.svg");
;// CONCATENATED MODULE: ./src/assets/icons/analytics-dashboard.svg
var analytics_dashboard_rect, analytics_dashboard_path, analytics_dashboard_path2, analytics_dashboard_path3;
function analytics_dashboard_extends() { analytics_dashboard_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return analytics_dashboard_extends.apply(this, arguments); }


const SvgAnalyticsDashboard = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/react.createElement("svg", analytics_dashboard_extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/react.createElement("title", {
    id: titleId
  }, title) : null, analytics_dashboard_rect || (analytics_dashboard_rect = /*#__PURE__*/react.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    fillOpacity: 0.01
  })), analytics_dashboard_path || (analytics_dashboard_path = /*#__PURE__*/react.createElement("path", {
    d: "M8.37665 20C8.53063 19.9905 8.67459 19.9205 8.77721 19.8051C8.87968 19.6898 8.93229 19.5386 8.92378 19.3846V12C8.93229 11.846 8.87968 11.6948 8.77721 11.5795C8.6746 11.4642 8.53065 11.3941 8.37665 11.3846H4.5479C4.39392 11.3941 4.24996 11.4642 4.14734 11.5795C4.04486 11.6948 3.99225 11.846 4.00077 12V19.3846C3.99226 19.5386 4.04486 19.6898 4.14734 19.8051C4.24995 19.9205 4.3939 19.9905 4.5479 20H8.37665Z",
    fill: "currentColor"
  })), analytics_dashboard_path2 || (analytics_dashboard_path2 = /*#__PURE__*/react.createElement("path", {
    d: "M14.0518 4H9.94951C9.72368 4 9.53906 4.27569 9.53906 4.61538V19.3846C9.53906 19.7243 9.72368 20 9.94951 20H14.0518C14.2789 20 14.4623 19.7243 14.4623 19.3846V4.61538C14.4623 4.27569 14.2777 4 14.0518 4V4Z",
    fill: "currentColor"
  })), analytics_dashboard_path3 || (analytics_dashboard_path3 = /*#__PURE__*/react.createElement("path", {
    d: "M19.4536 7.69231H15.6249C15.4709 7.70178 15.3269 7.77184 15.2243 7.88723C15.1218 8.00247 15.0692 8.15371 15.0777 8.30769V19.3846C15.0692 19.5386 15.1218 19.6898 15.2243 19.8051C15.3269 19.9205 15.4709 19.9905 15.6249 20H19.454H19.4538C19.6078 19.9905 19.7518 19.9205 19.8544 19.8051C19.9569 19.6898 20.0095 19.5386 20.001 19.3846V8.30769C20.0095 8.15371 19.9569 8.00247 19.8544 7.88723C19.7518 7.77184 19.6078 7.70179 19.4538 7.69231H19.4536Z",
    fill: "currentColor"
  })));
};
const analytics_dashboard_ForwardRef = /*#__PURE__*/(0,react.forwardRef)(SvgAnalyticsDashboard);

/* harmony default export */ const analytics_dashboard = (__webpack_require__.p + "20b8c8c196357e768ad61074dc463083.svg");
;// CONCATENATED MODULE: ./src/assets/icons/check.svg
var check_path;
function check_extends() { check_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return check_extends.apply(this, arguments); }


const SvgCheck = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", check_extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, check_path || (check_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.49992 13.4997L3.99992 9.99967L2.83325 11.1663L7.49992 15.833L17.4999 5.833L16.3333 4.66634L7.49992 13.4997Z",
    fill: "currentColor"
  })));
};
const check_ForwardRef = /*#__PURE__*/(/* unused pure expression or super */ null && (forwardRef(SvgCheck)));

/* harmony default export */ const check = (__webpack_require__.p + "c2d8ed845b225d87c9b3dcea2e267a6f.svg");
;// CONCATENATED MODULE: ./src/assets/icons/close.svg
var close_path;
function close_extends() { close_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return close_extends.apply(this, arguments); }


const SvgClose = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", close_extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, close_path || (close_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.8334 5.16566L14.6667 4.03568L10 8.55563L5.33335 4.03568L4.16669 5.16566L8.83335 9.68561L4.16669 14.2056L5.33335 15.3356L10 10.8156L14.6667 15.3356L15.8334 14.2056L11.1667 9.68561L15.8334 5.16566Z",
    fill: "currentColors"
  })));
};
const close_ForwardRef = /*#__PURE__*/(/* unused pure expression or super */ null && (forwardRef(SvgClose)));

/* harmony default export */ const icons_close = (__webpack_require__.p + "b754fc5097d05efbe3b6f6805845cb1c.svg");
;// CONCATENATED MODULE: ./src/assets/icons/arrow_circle_up.svg
var arrow_circle_up_g, arrow_circle_up_defs;
function arrow_circle_up_extends() { arrow_circle_up_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return arrow_circle_up_extends.apply(this, arguments); }


const SvgArrowCircleUp = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", arrow_circle_up_extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, arrow_circle_up_g || (arrow_circle_up_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_615_20168)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.7653 20C7.44158 20 3.92177 16.41 3.92177 12C3.92177 7.59 7.44158 4 11.7653 4C16.0891 4 19.6089 7.59 19.6089 12C19.6089 16.41 16.0891 20 11.7653 20ZM11.7653 22C17.1774 22 21.5698 17.52 21.5698 12C21.5698 6.48 17.1774 2 11.7653 2C6.35328 2 1.96088 6.48 1.96088 12C1.96088 17.52 6.35328 22 11.7653 22ZM10.7849 12V15C10.7849 15.55 11.2261 16 11.7653 16C12.3046 16 12.7458 15.55 12.7458 15V12H14.5008C14.942 12 15.1577 11.46 14.8439 11.15L12.1085 8.36C11.9124 8.16 11.6085 8.16 11.4124 8.36L8.67694 11.15C8.373 11.46 8.5887 12 9.0299 12H10.7849Z",
    fill: "currentColor"
  }))), arrow_circle_up_defs || (arrow_circle_up_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_615_20168"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 23.5307,
    height: 24
  })))));
};
const arrow_circle_up_ForwardRef = /*#__PURE__*/(/* unused pure expression or super */ null && (forwardRef(SvgArrowCircleUp)));

/* harmony default export */ const arrow_circle_up = (__webpack_require__.p + "af5fda5f5198a29da65bc4b622a55516.svg");
;// CONCATENATED MODULE: ./src/assets/icons/export_down_icon.svg
var export_down_icon_path;
function export_down_icon_extends() { export_down_icon_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return export_down_icon_extends.apply(this, arguments); }


const SvgExportDownIcon = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", export_down_icon_extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, export_down_icon_path || (export_down_icon_path = /*#__PURE__*/React.createElement("path", {
    d: "M5 20H19V18H5V20ZM19 9H15V3H9V9H5L12 16L19 9Z",
    fill: "currentColor"
  })));
};
const export_down_icon_ForwardRef = /*#__PURE__*/(/* unused pure expression or super */ null && (forwardRef(SvgExportDownIcon)));

/* harmony default export */ const export_down_icon = (__webpack_require__.p + "15d838de6ce47088669b2b6e9a56999e.svg");
;// CONCATENATED MODULE: ./src/assets/icons/info.svg
var info_g;
function info_extends() { info_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return info_extends.apply(this, arguments); }


const SvgInfo = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/react.createElement("svg", info_extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/react.createElement("title", {
    id: titleId
  }, title) : null, info_g || (info_g = /*#__PURE__*/react.createElement("g", {
    transform: "translate(2 2)"
  }, /*#__PURE__*/react.createElement("path", {
    d: "M9 5H11V7H9V5ZM9 9H11V15H9V9ZM10 0C4.48 0 0 4.48 0 10C0 15.52 4.48 20 10 20C15.52 20 20 15.52 20 10C20 4.48 15.52 0 10 0ZM10 18C5.59 18 2 14.41 2 10C2 5.59 5.59 2 10 2C14.41 2 18 5.59 18 10C18 14.41 14.41 18 10 18Z",
    fill: "currentColor"
  }))));
};
const info_ForwardRef = /*#__PURE__*/(0,react.forwardRef)(SvgInfo);

/* harmony default export */ const info = (__webpack_require__.p + "9d126bdc6bd48fc8e2aaca20fb75363f.svg");
;// CONCATENATED MODULE: ./src/assets/icons/calendar-simple.svg
var calendar_simple_g;
function calendar_simple_extends() { calendar_simple_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return calendar_simple_extends.apply(this, arguments); }


const SvgCalendarSimple = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/react.createElement("svg", calendar_simple_extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/react.createElement("title", {
    id: titleId
  }, title) : null, calendar_simple_g || (calendar_simple_g = /*#__PURE__*/react.createElement("g", {
    transform: "translate(1 1) scale(1.2)"
  }, /*#__PURE__*/react.createElement("path", {
    d: "M16.3 1.63643L16 1.63636V0L13 7.29558e-05V1.63643H5V7.29561e-05H2V1.63643H1.7C0.765 1.63643 0 2.37279 0 3.27279V16.3636C0 17.2636 0.765 18 1.7 18H16.3C17.235 18 18 17.2636 18 16.3636V3.27279C18 2.37279 17.235 1.63643 16.3 1.63643ZM16 16H2V5H16V16Z",
    fill: "currentColor"
  }))));
};
const calendar_simple_ForwardRef = /*#__PURE__*/(0,react.forwardRef)(SvgCalendarSimple);

/* harmony default export */ const calendar_simple = (__webpack_require__.p + "d04a6669c6ce8e7a112c8bde2908b87a.svg");
;// CONCATENATED MODULE: ./src/assets/icons/assignee.svg
var assignee_g;
function assignee_extends() { assignee_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return assignee_extends.apply(this, arguments); }


const SvgAssignee = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", assignee_extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, assignee_g || (assignee_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(1 1) scale(1.2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.425 9.9C7.425 10.521 6.921 11.025 6.3 11.025C5.679 11.025 5.175 10.521 5.175 9.9C5.175 9.279 5.679 8.775 6.3 8.775C6.921 8.775 7.425 9.279 7.425 9.9ZM11.7 8.775C11.079 8.775 10.575 9.279 10.575 9.9C10.575 10.521 11.079 11.025 11.7 11.025C12.321 11.025 12.825 10.521 12.825 9.9C12.825 9.279 12.321 8.775 11.7 8.775ZM18 9C18 13.968 13.968 18 9 18C4.032 18 0 13.968 0 9C0 4.032 4.032 0 9 0C13.968 0 18 4.032 18 9ZM7.794 1.908C9.054 3.996 11.34 5.4 13.95 5.4C14.364 5.4 14.769 5.355 15.156 5.292C13.896 3.204 11.61 1.8 9 1.8C8.586 1.8 8.181 1.845 7.794 1.908ZM2.178 6.723C3.717 5.85 4.905 4.428 5.472 2.727C3.933 3.6 2.745 5.022 2.178 6.723ZM16.2 9C16.2 8.298 16.092 7.623 15.903 6.984C15.273 7.119 14.625 7.2 13.95 7.2C11.133 7.2 8.622 5.904 6.966 3.879C6.021 6.183 4.14 7.992 1.8 8.874C1.809 8.91 1.8 8.955 1.8 9C1.8 12.969 5.031 16.2 9 16.2C12.969 16.2 16.2 12.969 16.2 9Z",
    fill: "currentColor"
  }))));
};
const assignee_ForwardRef = /*#__PURE__*/(/* unused pure expression or super */ null && (forwardRef(SvgAssignee)));

/* harmony default export */ const assignee = (__webpack_require__.p + "926ef1dcd1398d9c8b7a299f5ab8d157.svg");
;// CONCATENATED MODULE: ./src/assets/icons/warning-alt.svg
var warning_alt_g;
function warning_alt_extends() { warning_alt_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return warning_alt_extends.apply(this, arguments); }


const SvgWarningAlt = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/react.createElement("svg", warning_alt_extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/react.createElement("title", {
    id: titleId
  }, title) : null, warning_alt_g || (warning_alt_g = /*#__PURE__*/react.createElement("g", {
    transform: "translate(0 1) scale(1.5)"
  }, /*#__PURE__*/react.createElement("path", {
    fill: "currentColor",
    d: "M7.57 2.374a.5.5 0 0 1 .86 0l5.445 9.226a.5.5 0 0 1-.43.754H2.554a.5.5 0 0 1-.43-.754l5.444-9.226ZM.227 11.53C-.42 12.624.388 14 1.68 14h12.64c1.293 0 2.099-1.375 1.452-2.47L9.452.822c-.646-1.095-2.258-1.095-2.904 0l-6.32 10.71ZM7.16 5.768v1.647c0 .452.377.823.839.823.462 0 .84-.37.84-.823V5.768A.834.834 0 0 0 8 4.945c-.462 0-.84.37-.84.823Zm0 4.116h1.678v1.646H7.161V9.884Z"
  }))));
};
const warning_alt_ForwardRef = /*#__PURE__*/(0,react.forwardRef)(SvgWarningAlt);

/* harmony default export */ const warning_alt = (__webpack_require__.p + "efa32151d4c37def95f8ac77ffceafb5.svg");
;// CONCATENATED MODULE: ./src/assets/icons/block.svg
var block_g;
function block_extends() { block_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return block_extends.apply(this, arguments); }


const SvgBlock = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/react.createElement("svg", block_extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/react.createElement("title", {
    id: titleId
  }, title) : null, block_g || (block_g = /*#__PURE__*/react.createElement("g", {
    transform: "scale(1.5)"
  }, /*#__PURE__*/react.createElement("path", {
    fill: "currentColor",
    d: "M8 0C3.584 0 0 3.584 0 8s3.584 8 8 8 8-3.584 8-8-3.584-8-8-8Zm0 14.4A6.398 6.398 0 0 1 1.6 8c0-1.48.504-2.84 1.352-3.92l8.968 8.968A6.322 6.322 0 0 1 8 14.4Zm5.048-2.48L4.08 2.952A6.322 6.322 0 0 1 8 1.6c3.536 0 6.4 2.864 6.4 6.4 0 1.48-.504 2.84-1.352 3.92Z"
  }))));
};
const block_ForwardRef = /*#__PURE__*/(0,react.forwardRef)(SvgBlock);

/* harmony default export */ const block = (__webpack_require__.p + "89b9842c5d3fe98a218802cb9f6c448b.svg");
;// CONCATENATED MODULE: ./src/assets/icons/link_square.svg
var link_square_path;
function link_square_extends() { link_square_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return link_square_extends.apply(this, arguments); }


const SvgLinkSquare = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", link_square_extends({
    width: 14,
    height: 13,
    viewBox: "0 0 14 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, link_square_path || (link_square_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.7498 1.67177H7.79573V1H13V5.72504H12.2671V2.14756L7.21748 6.78351L6.69888 6.30886L11.7498 1.67177ZM1 2.12858H5.53246V2.80036H1.73285V11.3282H11.0358V7.68558H11.7687V12H1V2.12858Z",
    fill: "current",
    stroke: "black",
    strokeWidth: 0.6,
    strokeMiterlimit: 10
  })));
};
const link_square_ForwardRef = /*#__PURE__*/(/* unused pure expression or super */ null && (forwardRef(SvgLinkSquare)));

/* harmony default export */ const link_square = (__webpack_require__.p + "81735d6f37d6824fbd3ac3937a6064b0.svg");
;// CONCATENATED MODULE: ./src/assets/icons/help_circle.svg
var help_circle_circle, help_circle_path;
function help_circle_extends() { help_circle_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return help_circle_extends.apply(this, arguments); }


const SvgHelpCircle = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/react.createElement("svg", help_circle_extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/react.createElement("title", {
    id: titleId
  }, title) : null, help_circle_circle || (help_circle_circle = /*#__PURE__*/react.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 8,
    fill: "#757575"
  })), help_circle_path || (help_circle_path = /*#__PURE__*/react.createElement("path", {
    d: "M12.1816 14.5977H11.0918C11.0957 14.2227 11.1289 13.916 11.1914 13.6777C11.2578 13.4355 11.3652 13.2148 11.5137 13.0156C11.6621 12.8164 11.8594 12.5898 12.1055 12.3359C12.2852 12.1523 12.4492 11.9805 12.5977 11.8203C12.75 11.6562 12.873 11.4805 12.9668 11.293C13.0605 11.1016 13.1074 10.873 13.1074 10.6074C13.1074 10.3379 13.0586 10.1055 12.9609 9.91016C12.8672 9.71484 12.7266 9.56445 12.5391 9.45898C12.3555 9.35352 12.127 9.30078 11.8535 9.30078C11.627 9.30078 11.4121 9.3418 11.209 9.42383C11.0059 9.50586 10.8418 9.63281 10.7168 9.80469C10.5918 9.97266 10.5273 10.1934 10.5234 10.4668H9.43945C9.44727 10.0254 9.55664 9.64648 9.76758 9.33008C9.98242 9.01367 10.2715 8.77148 10.6348 8.60352C10.998 8.43555 11.4043 8.35156 11.8535 8.35156C12.3496 8.35156 12.7715 8.44141 13.1191 8.62109C13.4707 8.80078 13.7383 9.05859 13.9219 9.39453C14.1055 9.72656 14.1973 10.1211 14.1973 10.5781C14.1973 10.9297 14.125 11.2539 13.9805 11.5508C13.8398 11.8438 13.6582 12.1191 13.4355 12.377C13.2129 12.6348 12.9766 12.8809 12.7266 13.1152C12.5117 13.3145 12.3672 13.5391 12.293 13.7891C12.2188 14.0391 12.1816 14.3086 12.1816 14.5977ZM11.0449 16.4551C11.0449 16.2793 11.0996 16.1309 11.209 16.0098C11.3184 15.8887 11.4766 15.8281 11.6836 15.8281C11.8945 15.8281 12.0547 15.8887 12.1641 16.0098C12.2734 16.1309 12.3281 16.2793 12.3281 16.4551C12.3281 16.623 12.2734 16.7676 12.1641 16.8887C12.0547 17.0098 11.8945 17.0703 11.6836 17.0703C11.4766 17.0703 11.3184 17.0098 11.209 16.8887C11.0996 16.7676 11.0449 16.623 11.0449 16.4551Z",
    fill: "white"
  })));
};
const help_circle_ForwardRef = /*#__PURE__*/(0,react.forwardRef)(SvgHelpCircle);

/* harmony default export */ const help_circle = (__webpack_require__.p + "3bb7702ae272b14abe486abcdf03645d.svg");
;// CONCATENATED MODULE: ./src/assets/icons/arrow_right.svg
var arrow_right_g, arrow_right_defs;
function arrow_right_extends() { arrow_right_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return arrow_right_extends.apply(this, arguments); }


const SvgArrowRight = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/react.createElement("svg", arrow_right_extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/react.createElement("title", {
    id: titleId
  }, title) : null, arrow_right_g || (arrow_right_g = /*#__PURE__*/react.createElement("g", {
    clipPath: "url(#clip0_237_373)"
  }, /*#__PURE__*/react.createElement("path", {
    d: "M4.59703 14.2587L5.85786 15.5125L12.8633 8.49995L5.85078 1.48745L4.59703 2.7412L10.3558 8.49995L4.59703 14.2587Z",
    fill: "currentColor"
  }))), arrow_right_defs || (arrow_right_defs = /*#__PURE__*/react.createElement("defs", null, /*#__PURE__*/react.createElement("clipPath", {
    id: "clip0_237_373"
  }, /*#__PURE__*/react.createElement("rect", {
    width: 17,
    height: 17,
    transform: "translate(17 17) rotate(180)"
  })))));
};
const arrow_right_ForwardRef = /*#__PURE__*/(0,react.forwardRef)(SvgArrowRight);

/* harmony default export */ const arrow_right = (__webpack_require__.p + "f5fcb5f5204daadae68fc10fabea9f56.svg");
;// CONCATENATED MODULE: ./src/assets/icons/block_response.svg
var block_response_g, block_response_defs;
function block_response_extends() { block_response_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return block_response_extends.apply(this, arguments); }


const SvgBlockResponse = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/react.createElement("svg", block_response_extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/react.createElement("title", {
    id: titleId
  }, title) : null, block_response_g || (block_response_g = /*#__PURE__*/react.createElement("g", {
    clipPath: "url(#clip0_263_600)"
  }, /*#__PURE__*/react.createElement("path", {
    d: "M12 3C7.032 3 3 7.032 3 12C3 16.968 7.032 21 12 21C16.968 21 21 16.968 21 12C21 7.032 16.968 3 12 3ZM4.8 12C4.8 8.022 8.022 4.8 12 4.8C13.665 4.8 15.195 5.367 16.41 6.321L6.321 16.41C5.367 15.195 4.8 13.665 4.8 12ZM12 19.2C10.335 19.2 8.805 18.633 7.59 17.679L17.679 7.59C18.633 8.805 19.2 10.335 19.2 12C19.2 15.978 15.978 19.2 12 19.2Z",
    fill: "currentColor"
  }))), block_response_defs || (block_response_defs = /*#__PURE__*/react.createElement("defs", null, /*#__PURE__*/react.createElement("clipPath", {
    id: "clip0_263_600"
  }, /*#__PURE__*/react.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
};
const block_response_ForwardRef = /*#__PURE__*/(0,react.forwardRef)(SvgBlockResponse);

/* harmony default export */ const block_response = (__webpack_require__.p + "166fac7cb7eba6fc60fd159e381f7363.svg");
;// CONCATENATED MODULE: ./src/assets/icons/warn_response.svg
var warn_response_path;
function warn_response_extends() { warn_response_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return warn_response_extends.apply(this, arguments); }


const SvgWarnResponse = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/react.createElement("svg", warn_response_extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/react.createElement("title", {
    id: titleId
  }, title) : null, warn_response_path || (warn_response_path = /*#__PURE__*/react.createElement("path", {
    d: "M12.0876 5.11407L20.057 18.8833H4.11816L12.0876 5.11407ZM2.28721 17.8249C1.47227 19.2325 2.48829 21 4.11816 21H20.057C21.6869 21 22.7029 19.2325 21.888 17.8249L13.9185 4.05571C13.1036 2.6481 11.0716 2.6481 10.2566 4.05571L2.28721 17.8249ZM11.0292 10.4164V12.5331C11.0292 13.1152 11.5055 13.5915 12.0876 13.5915C12.6697 13.5915 13.1459 13.1152 13.1459 12.5331V10.4164C13.1459 9.83434 12.6697 9.35808 12.0876 9.35808C11.5055 9.35808 11.0292 9.83434 11.0292 10.4164ZM11.0292 15.7082H13.1459V17.8249H11.0292V15.7082Z",
    fill: "currentColor"
  })));
};
const warn_response_ForwardRef = /*#__PURE__*/(0,react.forwardRef)(SvgWarnResponse);

/* harmony default export */ const warn_response = (__webpack_require__.p + "0e2ad6b822bb8011724d1db50212a25f.svg");
;// CONCATENATED MODULE: ./src/assets/icons/monitor_response.svg
var monitor_response_path;
function monitor_response_extends() { monitor_response_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return monitor_response_extends.apply(this, arguments); }


const SvgMonitorResponse = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/react.createElement("svg", monitor_response_extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/react.createElement("title", {
    id: titleId
  }, title) : null, monitor_response_path || (monitor_response_path = /*#__PURE__*/react.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4 5H20C20.5523 5 21 5.44772 21 6V18C21 18.5523 20.5523 19 20 19H4C3.44772 19 3 18.5523 3 18V6C3 5.44772 3.44772 5 4 5ZM1 6C1 4.34315 2.34315 3 4 3H20C21.6569 3 23 4.34315 23 6V18C23 19.6569 21.6569 21 20 21H4C2.34315 21 1 19.6569 1 18V6ZM13.5897 13.3275L10.1277 5.90894L6.94575 11H5C4.44772 11 4 11.4477 4 12C4 12.5523 4.44772 13 5 13H8.05425L9.87231 10.0911L13.4103 17.6725L16.0803 13H19C19.5523 13 20 12.5523 20 12C20 11.4477 19.5523 11 19 11H14.9197L13.5897 13.3275Z",
    fill: "currentColor"
  })));
};
const monitor_response_ForwardRef = /*#__PURE__*/(0,react.forwardRef)(SvgMonitorResponse);

/* harmony default export */ const monitor_response = (__webpack_require__.p + "ec5774a9bac6e6917e6668171610ba91.svg");
;// CONCATENATED MODULE: ./src/assets/icons/email.svg
var email_g, email_defs;
function email_extends() { email_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return email_extends.apply(this, arguments); }


const SvgEmail = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/react.createElement("svg", email_extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/react.createElement("title", {
    id: titleId
  }, title) : null, email_g || (email_g = /*#__PURE__*/react.createElement("g", {
    clipPath: "url(#clip0_263_609)"
  }, /*#__PURE__*/react.createElement("path", {
    d: "M20 4H4C2.9 4 2 4.9 2 6V18C2 19.1 2.9 20 4 20H20C21.1 20 22 19.1 22 18V6C22 4.9 21.1 4 20 4ZM19.6 8.25L13.06 12.34C12.41 12.75 11.59 12.75 10.94 12.34L4.4 8.25C4.15 8.09 4 7.82 4 7.53C4 6.86 4.73 6.46 5.3 6.81L12 11L18.7 6.81C19.27 6.46 20 6.86 20 7.53C20 7.82 19.85 8.09 19.6 8.25Z",
    fill: "currentColor"
  }))), email_defs || (email_defs = /*#__PURE__*/react.createElement("defs", null, /*#__PURE__*/react.createElement("clipPath", {
    id: "clip0_263_609"
  }, /*#__PURE__*/react.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
};
const email_ForwardRef = /*#__PURE__*/(0,react.forwardRef)(SvgEmail);

/* harmony default export */ const email = (__webpack_require__.p + "1da7271ae4f8d441ed926715c2fe430a.svg");
;// CONCATENATED MODULE: ./src/assets/icons/verify_user.svg
var verify_user_g, verify_user_defs;
function verify_user_extends() { verify_user_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return verify_user_extends.apply(this, arguments); }


const SvgVerifyUser = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/react.createElement("svg", verify_user_extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/react.createElement("title", {
    id: titleId
  }, title) : null, verify_user_g || (verify_user_g = /*#__PURE__*/react.createElement("g", {
    clipPath: "url(#clip0_293_268)"
  }, /*#__PURE__*/react.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4 11.1818C4 15.7227 7.7 20.9691 12 22C16.3 20.9691 20 15.7227 20 11.1818V6.27273C20 6.27273 18.25 5.98182 16 5C13.75 4.01818 12 3 12 3C12 3 10.25 4.01818 8 5C5.75 5.98182 4 6.27273 4 6.27273V11.1818ZM13 7V13H11V7H13ZM13 17V15H11V17H13Z",
    fill: "currentColor"
  }))), verify_user_defs || (verify_user_defs = /*#__PURE__*/react.createElement("defs", null, /*#__PURE__*/react.createElement("clipPath", {
    id: "clip0_293_268"
  }, /*#__PURE__*/react.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
};
const verify_user_ForwardRef = /*#__PURE__*/(0,react.forwardRef)(SvgVerifyUser);

/* harmony default export */ const verify_user = (__webpack_require__.p + "a862d6d71a2b7ae03a2fc092fce92508.svg");
;// CONCATENATED MODULE: ./src/assets/icons/camera.svg
var camera_g, camera_defs;
function camera_extends() { camera_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return camera_extends.apply(this, arguments); }


const SvgCamera = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/react.createElement("svg", camera_extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/react.createElement("title", {
    id: titleId
  }, title) : null, camera_g || (camera_g = /*#__PURE__*/react.createElement("g", {
    clipPath: "url(#clip0_263_606)"
  }, /*#__PURE__*/react.createElement("path", {
    d: "M9.66 10.65L13.953 3.216C13.323 3.081 12.675 3 12 3C9.84 3 7.86 3.765 6.312 5.025L9.606 10.74L9.66 10.65ZM20.586 9.3C19.758 6.672 17.751 4.566 15.186 3.594L11.892 9.3H20.586ZM20.82 10.2H14.079L14.34 10.65L18.624 18.075C20.1 16.473 21 14.349 21 12C21 11.379 20.937 10.785 20.82 10.2ZM8.886 12L5.376 5.925C3.909 7.527 3 9.651 3 12C3 12.621 3.063 13.215 3.18 13.8H9.921L8.886 12ZM3.414 14.7C4.242 17.328 6.249 19.434 8.814 20.406L12.108 14.7H3.414ZM13.557 14.7L10.047 20.784C10.677 20.919 11.325 21 12 21C14.16 21 16.14 20.235 17.688 18.975L14.394 13.26L13.557 14.7Z",
    fill: "currentColor"
  }))), camera_defs || (camera_defs = /*#__PURE__*/react.createElement("defs", null, /*#__PURE__*/react.createElement("clipPath", {
    id: "clip0_263_606"
  }, /*#__PURE__*/react.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
};
const camera_ForwardRef = /*#__PURE__*/(0,react.forwardRef)(SvgCamera);

/* harmony default export */ const camera = (__webpack_require__.p + "eeb41f49bfcb2a61f35524fa5b917787.svg");
;// CONCATENATED MODULE: ./src/assets/icons/remove_circle_outlined.svg
var remove_circle_outlined_g, remove_circle_outlined_defs;
function remove_circle_outlined_extends() { remove_circle_outlined_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return remove_circle_outlined_extends.apply(this, arguments); }


const SvgRemoveCircleOutlined = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/react.createElement("svg", remove_circle_outlined_extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/react.createElement("title", {
    id: titleId
  }, title) : null, remove_circle_outlined_g || (remove_circle_outlined_g = /*#__PURE__*/react.createElement("g", {
    opacity: 0.6,
    clipPath: "url(#clip0_211_644)"
  }, /*#__PURE__*/react.createElement("path", {
    d: "M7 11V13H17V11H7ZM12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM12 20C7.59 20 4 16.41 4 12C4 7.59 7.59 4 12 4C16.41 4 20 7.59 20 12C20 16.41 16.41 20 12 20Z",
    fill: "#323232"
  }))), remove_circle_outlined_defs || (remove_circle_outlined_defs = /*#__PURE__*/react.createElement("defs", null, /*#__PURE__*/react.createElement("clipPath", {
    id: "clip0_211_644"
  }, /*#__PURE__*/react.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
};
const remove_circle_outlined_ForwardRef = /*#__PURE__*/(0,react.forwardRef)(SvgRemoveCircleOutlined);

/* harmony default export */ const remove_circle_outlined = (__webpack_require__.p + "c53280103c2eeb61d3971d7ac693f784.svg");
;// CONCATENATED MODULE: ./src/assets/icons/remove_circle_crossed.svg
var remove_circle_crossed_path;
function remove_circle_crossed_extends() { remove_circle_crossed_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return remove_circle_crossed_extends.apply(this, arguments); }


const SvgRemoveCircleCrossed = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", remove_circle_crossed_extends({
    width: 17,
    height: 18,
    viewBox: "0 0 17 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, remove_circle_crossed_path || (remove_circle_crossed_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.33333 0.666664C3.73333 0.666664 0 4.4 0 9C0 13.6 3.73333 17.3333 8.33333 17.3333C12.9333 17.3333 16.6667 13.6 16.6667 9C16.6667 4.4 12.9333 0.666664 8.33333 0.666664ZM8.33333 15.6667C4.65 15.6667 1.66667 12.6833 1.66667 9C1.66667 7.45833 2.19167 6.04166 3.075 4.91666L12.4167 14.2583C11.2917 15.1417 9.875 15.6667 8.33333 15.6667ZM13.5917 13.0833L4.25 3.74166C5.375 2.85833 6.79167 2.33333 8.33333 2.33333C12.0167 2.33333 15 5.31666 15 9C15 10.5417 14.475 11.9583 13.5917 13.0833Z",
    fill: "#757575"
  })));
};
const remove_circle_crossed_ForwardRef = /*#__PURE__*/(/* unused pure expression or super */ null && (forwardRef(SvgRemoveCircleCrossed)));

/* harmony default export */ const remove_circle_crossed = (__webpack_require__.p + "be32ec7fdd19003a0aff681922371cbd.svg");
;// CONCATENATED MODULE: ./src/assets/icons/internal.tsx


















































































































/***/ }),

/***/ 38873:
/***/ ((__unused_webpack_module, __unused_webpack___webpack_exports__, __webpack_require__) => {


// EXTERNAL MODULE: ./node_modules/@juggle/resize-observer/lib/exports/resize-observer.js + 23 modules
var resize_observer = __webpack_require__(86254);
// EXTERNAL MODULE: ./node_modules/core-js/stable/index.js
var stable = __webpack_require__(28594);
// EXTERNAL MODULE: ./node_modules/regenerator-runtime/runtime.js
var runtime = __webpack_require__(35666);
// EXTERNAL MODULE: ./src/assets/styles/index.css
var styles = __webpack_require__(93838);
// EXTERNAL MODULE: ./src/app/setupExternalServices.ts + 7 modules
var setupExternalServices = __webpack_require__(23279);
// EXTERNAL MODULE: ./src/app/setupVersionCheck.ts
var setupVersionCheck = __webpack_require__(80157);
;// CONCATENATED MODULE: ./src/shared/fullstory-styles-fix.ts
// @ts-nocheck
function overrideInsert() {
    const appendChildOriginal = Element.prototype.appendChild;
    Element.prototype.appendChild = function() {
        const res = appendChildOriginal.apply(this, arguments);
        if (res.tagName === "STYLE") {
            res.classList.add("fs-css-in-js");
        }
        return res;
    };
    const insertBeforeOriginal = Element.prototype.insertBefore;
    Element.prototype.insertBefore = function() {
        const res = insertBeforeOriginal.apply(this, arguments);
        if (res.tagName === "STYLE") {
            res.classList.add("fs-css-in-js");
        }
        return res;
    };
}

;// CONCATENATED MODULE: ./src/index.ts







window.ResizeObserver = resize_observer.ResizeObserver;
overrideInsert();
Promise.resolve(/* import() eager */).then(__webpack_require__.bind(__webpack_require__, 8676)).then(({ main  })=>main());


/***/ }),

/***/ 62006:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Q": () => (/* binding */ GraphqlError),
/* harmony export */   "h": () => (/* binding */ createRequest)
/* harmony export */ });
/* harmony import */ var axios__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(9669);
/* harmony import */ var axios__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(axios__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var graphql__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(15148);
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}


class GraphqlError extends Error {
    constructor(errors){
        var _errors_;
        super((errors === null || errors === void 0 ? void 0 : (_errors_ = errors[0]) === null || _errors_ === void 0 ? void 0 : _errors_.message) || "Graphql error");
        _define_property(this, "errors", void 0);
        this.errors = errors;
    }
}
// reference implementation
function createRequest(url) {
    return function() {
        var _request = _async_to_generator(function*(query, variables) {
            var _res_data;
            const res = yield axios__WEBPACK_IMPORTED_MODULE_0___default().post(url, {
                query: (0,graphql__WEBPACK_IMPORTED_MODULE_1__/* .print */ .S)(query),
                variables
            });
            if (res.data.errors) {
                throw new GraphqlError(res.data.errors);
            }
            return (_res_data = res.data) === null || _res_data === void 0 ? void 0 : _res_data.data;
        });
        function request(query, variables) {
            return _request.apply(this, arguments);
        }
        return request;
    }();
}


/***/ }),

/***/ 50074:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "fU": () => (/* binding */ newPromise),
/* harmony export */   "v7": () => (/* binding */ idleDelay)
/* harmony export */ });
/* unused harmony export delay */
function newPromise() {
    let res;
    let err;
    return [
        new Promise((r, k)=>{
            res = r;
            err = k;
        }),
        res,
        err
    ];
}
function delay(time = 1000) {
    return new Promise((res)=>{
        setTimeout(res, time);
    });
}
function idleDelay(time = 1000) {
    const [promise, resolve] = newPromise();
    setTimeout(()=>{
        requestAnimationFrame(resolve);
    }, time);
    return promise;
}



/***/ }),

/***/ 67511:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Ad": () => (/* binding */ lowerCEL),
/* harmony export */   "KM": () => (/* binding */ CELConditionOperator),
/* harmony export */   "NV": () => (/* binding */ CELOperators),
/* harmony export */   "lS": () => (/* binding */ celCombine),
/* harmony export */   "zO": () => (/* binding */ lower)
/* harmony export */ });
var CELConditionOperator;
(function(CELConditionOperator) {
    CELConditionOperator["OR"] = "||";
    CELConditionOperator["AND"] = "&&";
})(CELConditionOperator || (CELConditionOperator = {}));
const CELOperators = {
    equal: (field, value)=>`${field} == ${value}`,
    notEqual: (field, value)=>`${field} != ${value}`,
    empty: (field)=>CELOperators.equal(field, "null"),
    notEmpty: (field)=>CELOperators.notEqual(field, "null"),
    greater: (field, value)=>`${field} > ${value}`,
    greaterOrEqual: (field, value)=>`${field} >= ${value}`,
    less: (field, value)=>`${field} < ${value}`,
    lessOrEqual: (field, value)=>`${field} <= ${value}`,
    anyOf: (field, values)=>`${field} in [${values.join(",")}]`,
    search: (fields, value)=>fields.map((field)=>CELOperators.stringContains(field, [
                value
            ])).join(` ${CELConditionOperator.OR} `),
    stringContains: (field, values)=>`[${values.map(CELOperators.toString).join(",")}].exists(x, ${lowerCEL(field)}.contains(${lowerCEL("x")}))`,
    stringStartsWith: (field, value)=>`${lowerCEL(field)}.startsWith("${lower(value)}")`,
    stringMatchesWith: (field, value)=>`${lowerCEL(field)}.matches("${lower(value)}")`,
    stringEndsWith: (field, value)=>`${lowerCEL(field)}.endsWith("${lower(value)}")`,
    exists: (field, emptyValue = '""')=>`${field} != ${emptyValue}`,
    existsContains: (field, values, valueAccessor)=>celCombine(CELConditionOperator.OR, ...values.map(CELOperators.toString).map((v)=>`${field}.exists(x, ${lowerCEL(valueAccessor ? valueAccessor("x") : "x")}.contains(${lower(v)}))`)),
    existsIs: (field, values, valueAccessor)=>celCombine(CELConditionOperator.OR, ...values.map((v)=>`${field}.exists(x, ${valueAccessor ? valueAccessor("x") : "x"} == ${v})`)),
    listEmpty: (field, valueAccessor)=>`!${CELOperators.listNotEmpty(field, valueAccessor)}`,
    listNotEmpty: (field, valueAccessor)=>`${field}.exists(x, size(string(${valueAccessor ? valueAccessor("x") : "x"})) > 0)`,
    toString: (value)=>`"${value}"`,
    toDate: (value)=>`timestamp(${CELOperators.toString(value)})`
};
function lower(value) {
    return String(value).toLowerCase();
}
function lowerCEL(field) {
    return `${field}.lowerAscii()`;
}
function celNonEmptyExpr(s) {
    if (!s) {
        return false;
    }
    return s.split("").some((c)=>c !== "(" && c !== ")" && c !== " ");
}
const celCombine = (op, ...elems)=>{
    const parts = [];
    for (const e of elems){
        if (celNonEmptyExpr(e)) {
            parts.push("(" + e + ")");
        }
    }
    if (parts.length === 0) {
        return "";
    }
    if (parts.length === 1) {
        return parts[0];
    }
    return "(" + parts.join(" " + op + " ") + ")";
};


/***/ }),

/***/ 85429:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "j": () => (/* binding */ SuggesterUI),
  "$": () => (/* binding */ useSuggesterData)
});

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/highlight-words-core/dist/index.js
var dist = __webpack_require__(96928);
// EXTERNAL MODULE: ./node_modules/escape-string-regexp/index.js
var escape_string_regexp = __webpack_require__(63150);
var escape_string_regexp_default = /*#__PURE__*/__webpack_require__.n(escape_string_regexp);
// EXTERNAL MODULE: ./node_modules/lodash-es/debounce.js + 1 modules
var debounce = __webpack_require__(99111);
// EXTERNAL MODULE: ./node_modules/@mui/material/Popper/Popper.js + 56 modules
var Popper = __webpack_require__(26376);
// EXTERNAL MODULE: ./node_modules/@mui/material/MenuList/MenuList.js + 1 modules
var MenuList = __webpack_require__(83975);
// EXTERNAL MODULE: ./node_modules/@mui/material/MenuItem/MenuItem.js + 1 modules
var MenuItem = __webpack_require__(33797);
// EXTERNAL MODULE: ./node_modules/@mui/material/LinearProgress/LinearProgress.js + 1 modules
var LinearProgress = __webpack_require__(69041);
// EXTERNAL MODULE: ./src/ui/theme.ts
var theme = __webpack_require__(73728);
// EXTERNAL MODULE: ./src/ui/css/index.ts
var css = __webpack_require__(93461);
// EXTERNAL MODULE: ./src/libs/hooks/useSize.tsx
var useSize = __webpack_require__(93906);
// EXTERNAL MODULE: ./src/libs/hooks/useAsync2.ts
var useAsync2 = __webpack_require__(94043);
// EXTERNAL MODULE: ./src/libs/hooks/index.ts + 18 modules
var hooks = __webpack_require__(88289);
;// CONCATENATED MODULE: ./src/libs/hooks/useFocused.tsx

function useFocusChange(ref, onChange) {
    const onChangeRef = (0,react.useRef)(null);
    onChangeRef.current = onChange;
    (0,react.useEffect)(()=>{
        function onBlur(ev) {
            onChangeRef.current(ev);
        }
        function onFocus(ev) {
            onChangeRef.current(ev);
        }
        ref.current.addEventListener("focus", onFocus, true);
        ref.current.addEventListener("blur", onBlur, true);
        return ()=>{
            if (ref.current) {
                ref.current.removeEventListener("focus", onFocus);
                ref.current.removeEventListener("blur", onBlur);
            }
        };
    }, [
        ref,
        onChangeRef
    ]);
}

;// CONCATENATED MODULE: ./src/libs/code-editor/dom-helpers.ts
function setNativeValue(element, value) {
    const { set: valueSetter  } = Object.getOwnPropertyDescriptor(element, "value") || {};
    const prototype = Object.getPrototypeOf(element);
    const { set: prototypeValueSetter  } = Object.getOwnPropertyDescriptor(prototype, "value") || {};
    if (prototypeValueSetter && valueSetter !== prototypeValueSetter) {
        prototypeValueSetter.call(element, value);
    } else if (valueSetter) {
        valueSetter.call(element, value);
    } else {
        throw new Error("The given element does not have a value setter");
    }
}

;// CONCATENATED MODULE: ./src/libs/code-editor/useSuggest.ts



function shouldPreventBlur(e) {
    return e.relatedTarget && e.relatedTarget.dataset.name === "suggestionItem";
}
function useSuggest({ textareaRef , onInputValueChange , items , replaceValue , onBlur  }) {
    const [visible, updateVisible] = (0,react.useState)(false);
    const activeRef = (0,react.useRef)(false);
    const focusedIndexRef = (0,react.useRef)(-1);
    const itemsSizeLengthRef = (0,react.useRef)(items.length);
    const changeRef = (0,react.useRef)(onInputValueChange);
    const [focusedIndex, setFocusedIndex] = (0,react.useState)(-1);
    const [isFocused, setFocused] = (0,react.useState)(false);
    // handle focus and blur changes
    useFocusChange(textareaRef, (event)=>{
        // do not blur if we click on item from select
        if (event.type === "blur" && shouldPreventBlur(event)) {
            event.preventDefault();
            event.stopImmediatePropagation();
            event.stopPropagation();
            return false;
        } else if (event.type === "blur") {
            // now it's fine to blur
            onBlur(event);
            setFocused(false);
            updateVisible(false);
            return;
        }
        if (event.type === "focus") {
            setFocused(false);
            return;
        }
        return;
    });
    activeRef.current = isFocused;
    changeRef.current = onInputValueChange;
    focusedIndexRef.current = focusedIndex;
    itemsSizeLengthRef.current = items.length;
    const suggestValues = (0,react.useCallback)(()=>{
        if (!activeRef.current) {
            return;
        }
        setTimeout(()=>{
            // do not suggest if we out of focus
            if (!activeRef.current) {
                return;
            }
            changeRef.current(textareaRef);
        });
    }, [
        activeRef,
        textareaRef
    ]);
    (0,react.useLayoutEffect)(()=>{
        updateVisible(true);
        setFocusedIndex(-1);
    }, [
        items
    ]);
    function set(w) {
        const el = textareaRef.current;
        const { newValue , retriggerSuggest , insertIndex  } = replaceValue({
            value: el.value,
            word: w,
            selectionStart: el.selectionStart
        });
        setNativeValue(el, newValue);
        el.dispatchEvent(new Event("change", {
            bubbles: true
        }));
        el.focus();
        updateVisible(false);
        el.selectionEnd = el.selectionStart = insertIndex || el.value.length;
        retriggerSuggest && suggestValues();
    }
    const setRef = (0,react.useRef)(null);
    setRef.current = set;
    (0,react.useEffect)(()=>{
        const el = textareaRef.current;
        function onChange(e) {
            if (e.key === "Escape") {
                updateVisible(false);
                setFocused(false);
                setFocusedIndex(-1);
                return;
            }
            if (e.key === "Enter" && focusedIndex !== -1) {
                var _setRef_current;
                e.stopPropagation();
                e.preventDefault();
                setFocusedIndex(-1);
                (_setRef_current = setRef.current) === null || _setRef_current === void 0 ? void 0 : _setRef_current.call(setRef, items[focusedIndex].value);
            } else if (e.key === "Enter" || e.key === "Tab") {
                return;
            } else if (e.key === "ArrowDown" && visible && isFocused && items.length > 0) {
                e.stopPropagation();
                e.preventDefault();
                updateVisible(true);
                setFocused(true);
                setFocusedIndex((i)=>Math.min(i + 1, items.length));
            } else if (e.key === "ArrowUp" && focusedIndex !== -1 && visible) {
                setFocusedIndex((i)=>Math.max(i - 1, 0));
            } else if (e.key !== "ArrowDown" && e.key !== "ArrowUp") {
                updateVisible(true);
                setFocused(true);
                suggestValues();
            }
        }
        el.addEventListener("keydown", onChange);
        return ()=>{
            el.removeEventListener("keydown", onChange);
        };
    }, [
        suggestValues,
        focusedIndex,
        items,
        visible,
        textareaRef,
        isFocused
    ]);
    return {
        onItemClick (e, el) {
            e.preventDefault();
            e.stopPropagation();
            set(el.value);
        },
        visible: visible && isFocused,
        focusedIndex
    };
}

;// CONCATENATED MODULE: ./src/libs/code-editor/Suggester.tsx












function useScrollFollower(index) {
    const listRef = (0,react.useRef)(null);
    (0,react.useEffect)(()=>{
        if (listRef.current) {
            const skip = 5;
            const itemSize = 40;
            const nextIndex = Math.max(Math.ceil((index - skip) / skip) * skip, 0);
            listRef.current.scrollTop = nextIndex * itemSize;
        }
    }, [
        index
    ]);
    return listRef;
}
function useFetchMethod(suggester, textareaRef) {
    return (0,react.useMemo)(()=>{
        const fn = (0,debounce["default"])((res, req)=>{
            suggester.resolveSuggestions(textareaRef.current).then(res).catch(req);
        }, 200);
        let prev;
        return ()=>new Promise((res, req)=>{
                prev && prev();
                fn(res, req);
                prev = res;
            });
    }, [
        textareaRef
    ]);
}
const useSuggesterData = ({ onBlur , suggester , textareaRef  })=>{
    const fetchMethod = useFetchMethod(suggester, textareaRef);
    const [highlightWord, setHighlightWord] = (0,react.useState)(null);
    const [fetchSuggestions, { error , loading , value: items  }] = (0,useAsync2/* useAsyncCallback */.UK)(fetchMethod, ()=>{
        setHighlightWord(suggester.resolveWord(textareaRef.current));
    });
    const prevValue = (0,hooks/* usePrevious */.D9)(items);
    const suggestItems = !loading && !error && items ? items : prevValue || [];
    const { visible , focusedIndex , onItemClick  } = useSuggest({
        items: suggestItems,
        textareaRef,
        onInputValueChange () {
            fetchSuggestions();
        },
        onBlur,
        replaceValue: (v)=>{
            return suggester.insert(v);
        }
    });
    const sizes = (0,useSize/* useSize */.t)(textareaRef);
    const isOpen = !!(visible && !!textareaRef.current) && !!suggestItems.length;
    return {
        sizes,
        visible,
        focusedIndex,
        onItemClick,
        suggestItems,
        highlightWord,
        loading,
        isOpen
    };
};
function SuggesterUI({ textareaRef , onBlur , suggester , heading  }) {
    const { focusedIndex , highlightWord , onItemClick , sizes , suggestItems , loading , isOpen  } = useSuggesterData({
        textareaRef,
        onBlur,
        suggester
    });
    return /*#__PURE__*/ react.createElement(RenderSuggest, {
        heading: heading,
        loading: loading,
        anchorEl: textareaRef.current,
        open: isOpen,
        suggestions: suggestItems,
        highlightWord: highlightWord,
        onItemClick: onItemClick,
        focused: focusedIndex,
        width: sizes.width,
        key: (0,react.useMemo)(()=>Math.random(), [
            sizes.height,
            suggestItems.length
        ])
    });
}
const contentStyles = (0,css/* css */.iv)({
    maxHeight: "400px",
    overflow: "auto",
    background: "white",
    border: `1px solid ${theme/* theme.palette.divider */.rS.palette.divider}`,
    position: "relative"
});
function RenderSuggest({ anchorEl , suggestions , onItemClick , focused , width , highlightWord , open , loading , heading  }) {
    const listRef = useScrollFollower(focused);
    const focusedIndex = Math.min(focused, suggestions.length - 1);
    return /*#__PURE__*/ react.createElement(Popper/* default */.Z, {
        style: {
            zIndex: 2000,
            maxWidth: 700,
            minWidth: width + 30,
            marginLeft: -10
        },
        placement: "bottom-start",
        anchorEl: anchorEl,
        open: open,
        translate: "no"
    }, /*#__PURE__*/ react.createElement("div", {
        ref: listRef,
        className: contentStyles().className
    }, loading && /*#__PURE__*/ react.createElement(LinearProgress/* default */.Z, {
        style: {
            position: "absolute",
            top: 0,
            height: 4,
            width: "100%"
        }
    }), /*#__PURE__*/ react.createElement(MenuList/* default */.Z, {
        dense: true,
        style: {
            maxWidth: 700,
            pointerEvents: loading ? "none" : "all",
            opacity: loading ? 0.5 : 1
        }
    }, heading && /*#__PURE__*/ react.createElement(MenuItem/* default */.Z, {
        "data-name": "suggestionItem",
        dense: true,
        style: {
            height: "25px",
            padding: "0px 10px",
            color: "#ccc"
        },
        key: "top-10"
    }, /*#__PURE__*/ react.createElement("span", null, heading)), suggestions.map((el, i)=>{
        const title = (0,dist.findAll)({
            searchWords: [
                escape_string_regexp_default()(highlightWord || "")
            ],
            textToHighlight: el.subtitle || ""
        }).map(({ end , highlight , start  }, i)=>{
            const text = el.subtitle.substr(start, end - start);
            if (highlight) {
                return /*#__PURE__*/ react.createElement("mark", {
                    style: {
                        backgroundColor: "rgba(255, 255, 5, 0.6)"
                    },
                    key: text + i
                }, text);
            }
            return text;
        });
        return /*#__PURE__*/ react.createElement(MenuItem/* default */.Z, {
            onClick: (e)=>onItemClick(e, el),
            title: el.tooltip || "",
            "data-name": "suggestionItem",
            selected: i === focusedIndex,
            dense: true,
            style: {
                height: "25px",
                padding: "0px 10px"
            },
            key: i
        }, /*#__PURE__*/ react.createElement("span", null, title));
    }))));
}


/***/ }),

/***/ 71843:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "pq": () => (/* reexport */ CodeEditor),
  "ND": () => (/* reexport */ SuggestCodeEditor)
});

// UNUSED EXPORTS: SuggestContext

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/prismjs/components/prism-core.js
var prism_core = __webpack_require__(28325);
// EXTERNAL MODULE: ./src/ui/css/index.ts
var css = __webpack_require__(93461);
// EXTERNAL MODULE: ./node_modules/react-simple-code-editor/lib/index.js
var lib = __webpack_require__(40460);
;// CONCATENATED MODULE: ./src/libs/code-editor/SimpleCodeEditor.override.jsx
/* eslint-disable */ function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}


const styles = {
    container: {
        position: "relative",
        textAlign: "left",
        boxSizing: "border-box",
        padding: 0,
        overflow: "hidden"
    },
    textarea: {
        border: "inherit",
        position: "absolute",
        top: 0,
        left: 0,
        height: "100%",
        width: "100%",
        resize: "none",
        color: "inherit",
        overflow: "hidden",
        MozOsxFontSmoothing: "grayscale",
        WebkitFontSmoothing: "antialiased",
        WebkitTextFillColor: "transparent"
    },
    highlight: {
        position: "relative",
        pointerEvents: "none"
    },
    editor: {
        marginTop: 0,
        marginRight: 0,
        marginBottom: 0,
        marginLeft: 0,
        outline: "none",
        // borderTop: 0,
        // borderRight: 0,
        // borderBottom: 0,
        // borderLeft: 0,
        background: "none",
        border: "none",
        boxSizing: "inherit",
        display: "inherit",
        fontFamily: "inherit",
        fontSize: "inherit",
        fontStyle: "inherit",
        fontVariantLigatures: "inherit",
        fontWeight: "inherit",
        letterSpacing: "inherit",
        lineHeight: "inherit",
        tabSize: "inherit",
        textIndent: "inherit",
        textRendering: "inherit",
        textTransform: "inherit",
        whiteSpace: "break-spaces",
        wordBreak: "break-all",
        overflowWrap: "break-word"
    }
};
const container = "npm__react-simple-code-editor__container";
const cssText = /* CSS */ `
/**
 * Make sure that layout related properties cannot be set on the children
 * They will likely break the editor when set. The user can always use !important to force override.
 */
.${container} > pre * {
  display: inline;
  font-family: inherit;
  font-size: inherit;
  font-style: inherit;
  font-variant-ligatures: inherit;
  font-weight: inherit;
  letter-spacing: inherit;
  line-height: inherit;
  margin-top: 0;
  margin-right: 0;
  margin-bottom: 0;
  margin-left: 0;
  padding-top: 0;
  padding-right: 0;
  padding-bottom: 0;
  padding-left: 0;
  border-top: 0;
  border-right: 0;
  border-bottom: 0;
  border-left: 0;
}
/**
 * Reset the text fill color so that placeholder is visible
 */
.${container} > textarea:empty {
  -webkit-text-fill-color: inherit !important;
}
/**
 * Hack to apply on some CSS on IE10 and IE11
 */
@media all and (-ms-high-contrast: none), (-ms-high-contrast: active) {
  /**
    * IE doesn't support '-webkit-text-fill-color'
    * So we use 'color: transparent' to make the text transparent on IE
    * Unlike other browsers, it doesn't affect caret color in IE
    */
  .${container} > textarea {
    color: transparent !important;
  }
  .${container} > textarea::selection {
    background-color: #accef7 !important;
    color: transparent !important;
  }
}
`;
class SimpleCodeEditor extends lib/* default */.Z {
    render() {
        const _this_props = this.props, { value , style , className , padding , highlight , autoFocus , disabled , form , maxLength , minLength , name , placeholder , readOnly , required , onClick , onFocus , onBlur , onKeyUp , /* eslint-disable no-unused-vars */ onKeyDown , onValueChange , tabSize , insertSpaces , ignoreTabKey , children  } = _this_props, rest = _object_without_properties(_this_props, [
            "value",
            "style",
            "className",
            "padding",
            "highlight",
            "autoFocus",
            "disabled",
            "form",
            "maxLength",
            "minLength",
            "name",
            "placeholder",
            "readOnly",
            "required",
            "onClick",
            "onFocus",
            "onBlur",
            "onKeyUp",
            "onKeyDown",
            "onValueChange",
            "tabSize",
            "insertSpaces",
            "ignoreTabKey",
            "children"
        ]);
        const contentStyle = {
            paddingTop: padding,
            paddingRight: padding,
            paddingBottom: padding,
            paddingLeft: padding
        };
        const highlighted = highlight(value);
        return /*#__PURE__*/ react.createElement("div", _object_spread_props(_object_spread({}, rest), {
            style: _object_spread({}, styles.container, style),
            className: `${container} ${className || ""}`
        }), children({
            "ref": (c)=>this._input = c,
            "style": _object_spread({}, styles.editor, styles.textarea, contentStyle),
            value,
            "onChange": this._handleChange,
            "onKeyDown": this._handleKeyDown,
            onClick,
            onKeyUp,
            onFocus,
            onBlur,
            disabled,
            form,
            maxLength,
            minLength,
            name,
            placeholder,
            readOnly,
            required,
            autoFocus,
            "autoCapitalize": "off",
            "autoComplete": "off",
            "autoCorrect": "off",
            "spellCheck": false,
            "data-gramm": false
        }), /*#__PURE__*/ react.createElement("pre", _object_spread({
            "aria-hidden": "true",
            style: _object_spread({}, styles.editor, styles.highlight, contentStyle)
        }, typeof highlighted === "string" ? {
            dangerouslySetInnerHTML: {
                __html: highlighted + "<br />"
            }
        } : {
            children: highlighted
        })), /*#__PURE__*/ react.createElement("style", {
            type: "text/css",
            dangerouslySetInnerHTML: {
                __html: cssText
            }
        }));
    }
}


// EXTERNAL MODULE: ./node_modules/prismjs/themes/prism-coy.css
var prism_coy = __webpack_require__(50775);
// EXTERNAL MODULE: ./node_modules/prismjs/components/prism-clike.js
var prism_clike = __webpack_require__(35433);
// EXTERNAL MODULE: ./node_modules/prismjs/components/prism-markup.js
var prism_markup = __webpack_require__(24335);
// EXTERNAL MODULE: ./node_modules/prismjs/components/prism-java.js
var prism_java = __webpack_require__(52503);
;// CONCATENATED MODULE: ./src/libs/code-editor/LucenePrism.css
// extracted by mini-css-extract-plugin
/* harmony default export */ const LucenePrism = ({});
;// CONCATENATED MODULE: ./src/libs/code-editor/LucenePrism.ts

Prism.languages.lucene = {
    string: {
        pattern: /(?:[rub]|rb|br)?(")(?:\\.|(?!\1)[^\\\r\n])*\1/i,
        greedy: true
    },
    function: {
        pattern: /((?:^|\s)def[ \t]+)[a-zA-Z_]\w*(?=\s*\()/g,
        lookbehind: true
    },
    keyword: /\b(?:AND|OR|NOT|TO)\b/,
    builtin: /\b(?:source|destination|personal_info_search)\b/,
    operator: /&&|\||!|\*|~|\^|-|\+/,
    punctuation: /[:]/,
    whitespace: /[^\S\r\n]/,
    bracket: /\(|\)|\[|\]/
};
/* harmony default export */ const code_editor_LucenePrism = ("");

;// CONCATENATED MODULE: ./src/libs/code-editor/VarsPrism.css
// extracted by mini-css-extract-plugin
/* harmony default export */ const VarsPrism = ({});
;// CONCATENATED MODULE: ./src/libs/code-editor/VarsPrism.ts

Prism.languages.vars = {
    var: {
        pattern: /\{\{\w*[\}]*/,
        inside: {
            ld: {
                pattern: /^(?:\{\{)/
            },
            rd: {
                pattern: /\}\}$/
            },
            property: /\b[a-zA-Z_]\w*\b/
        }
    }
};
/* harmony default export */ const code_editor_VarsPrism = ("");

// EXTERNAL MODULE: ./src/libs/code-editor/Suggester.tsx + 3 modules
var Suggester = __webpack_require__(85429);
;// CONCATENATED MODULE: ./src/libs/code-editor/CodeEditor.tsx
function CodeEditor_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function CodeEditor_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            CodeEditor_define_property(target, key, source[key]);
        });
    }
    return target;
}
function CodeEditor_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function CodeEditor_object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        CodeEditor_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function CodeEditor_object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = CodeEditor_object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function CodeEditor_object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}











const Style = (0,css/* css */.iv)({
    "& textarea": {
        outline: "none"
    },
    "fontSize": "13px",
    "minHeight": "34px",
    "height": "auto"
});
const SuggestContext = /*#__PURE__*/ react.createContext({
    suggester: null
});
function EditorImpl(_param, ref) {
    var { className , onChange , language , suggest , innerRef , inputRef , suggestConfig , SuggesterComponent =Suggester/* SuggesterUI */.j  } = _param, rest = CodeEditor_object_without_properties(_param, [
        "className",
        "onChange",
        "language",
        "suggest",
        "innerRef",
        "inputRef",
        "suggestConfig",
        "SuggesterComponent"
    ]);
    const internalRef = (0,react.useRef)(null);
    useKeypress(internalRef);
    const onRefChange = (0,react.useCallback)((ref, internalRef, inputRef, editorRef)=>{
        return (textareaRef)=>{
            if (ref && ref.current) {
                ref.current = textareaRef;
            }
            internalRef.current = textareaRef;
            inputRef && inputRef(textareaRef);
            editorRef(textareaRef);
        };
    }, [
        inputRef,
        ref,
        internalRef
    ]);
    suggestConfig = suggestConfig || (0,react.useContext)(SuggestContext);
    const F = SimpleCodeEditor;
    return /*#__PURE__*/ react.createElement(react.Fragment, null, /*#__PURE__*/ react.createElement(F, CodeEditor_object_spread_props(CodeEditor_object_spread({}, rest), {
        onValueChange: onChange,
        highlight: (code)=>(0,prism_core.highlight)(code, prism_core.languages[language]),
        padding: 10,
        ignoreTabKey: true,
        className: Style({
            className
        }).className
    }), (_param)=>/*#__PURE__*/ {
        var { ref: editorRef , onBlur  } = _param, params = CodeEditor_object_without_properties(_param, [
            "ref",
            "onBlur"
        ]);
        return react.createElement(react.Fragment, null, /*#__PURE__*/ react.createElement("textarea", CodeEditor_object_spread_props(CodeEditor_object_spread({
            // TODO
            onBlur: suggestConfig ? null : onBlur,
            ref: onRefChange(ref, internalRef, inputRef, editorRef)
        }, params), {
            style: CodeEditor_object_spread_props(CodeEditor_object_spread({}, params.style), {
                border: "none",
                whiteSpace: "break-spaces"
            })
        })), suggestConfig && internalRef.current && /*#__PURE__*/ react.createElement(SuggesterComponent, {
            textareaRef: internalRef,
            onBlur: onBlur,
            suggester: suggestConfig.suggester
        }));
    }));
}
const CodeEditor = /*#__PURE__*/ react.forwardRef(EditorImpl);
CodeEditor.defaultProps = {
    language: "lucene"
};
const SuggestCodeEditor = /*#__PURE__*/ react.forwardRef((props, ref)=>{
    return EditorImpl(CodeEditor_object_spread_props(CodeEditor_object_spread({
        language: "lucene"
    }, props), {
        suggest: true
    }), ref);
});
function useKeypress(internalRef) {
    (0,react.useEffect)(()=>{
        const item = internalRef.current;
        function onType(e) {
            if (e.shiftKey && e.which === 13) {
                e.preventDefault();
                item.blur();
            }
        }
        item.addEventListener("keydown", onType);
        return ()=>{
            item.removeEventListener("keydown", onType);
        };
    }, [
        internalRef
    ]);
}

;// CONCATENATED MODULE: ./src/libs/code-editor/index.ts



/***/ }),

/***/ 87287:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "t": () => (/* binding */ DefaultThContent)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var assets_icons__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(99899);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(2658);
/* harmony import */ var libs_layouts__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(5855);
/* harmony import */ var ui_css__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(93461);





const textStyles = (0,ui_css__WEBPACK_IMPORTED_MODULE_3__/* .css */ .iv)({
    fontSize: "13px",
    fontWeight: 500,
    textTransform: "uppercase"
});
function DefaultThContent(props) {
    var _props_sort, _props_sort1;
    const direction = (props === null || props === void 0 ? void 0 : (_props_sort = props.sort) === null || _props_sort === void 0 ? void 0 : _props_sort.sort_desc) ? "desc" : "asc";
    const active = (props === null || props === void 0 ? void 0 : (_props_sort1 = props.sort) === null || _props_sort1 === void 0 ? void 0 : _props_sort1.sort_by) === props.column.id;
    const hasSort = props.column.sortable;
    const Icon = active ? direction === "asc" ? assets_icons__WEBPACK_IMPORTED_MODULE_1__/* .SortAscIcon */ .ao : assets_icons__WEBPACK_IMPORTED_MODULE_1__/* .SortDescIcon */ .k6 : assets_icons__WEBPACK_IMPORTED_MODULE_1__/* .SortIcon */ .fz;
    return /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(libs_layouts__WEBPACK_IMPORTED_MODULE_2__/* .HStack */ .Ug, {
        space: 2,
        align: "center",
        className: props.className + " rt-th",
        style: props.style
    }, /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_mui_material__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
        noWrap: true,
        component: "div",
        color: "textSecondary",
        className: textStyles().className
    }, props.children), hasSort && /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Icon, {
        cursor: "pointer",
        fontSize: "small",
        onClick: props === null || props === void 0 ? void 0 : props.toggleSort,
        color: active ? "primary" : "action"
    }));
}


/***/ }),

/***/ 81252:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Vt": () => (/* reexport */ CELL_BLANK),
  "y8": () => (/* reexport */ CELL_EMPTY),
  "RM": () => (/* reexport */ TableBody),
  "Tj": () => (/* reexport */ TableInner),
  "Mb": () => (/* reexport */ TableLoader),
  "Td": () => (/* reexport */ Td)
});

// UNUSED EXPORTS: FullRow, Pagination, Row, TableRow

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-content-loader/dist/react-content-loader.es.js
var react_content_loader_es = __webpack_require__(24561);
// EXTERNAL MODULE: ./src/ui/css/index.ts
var css = __webpack_require__(93461);
;// CONCATENATED MODULE: ./src/libs/css-grid-table/TableLoader.tsx
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}



const TableRow = ({ style , className , height , animate  })=>{
    const random = Math.random() * (1 - 0.6) + 0.6;
    const common = {
        rx: 4,
        height: 12
    };
    return /*#__PURE__*/ react.createElement(react_content_loader_es/* default */.ZP, {
        height: height,
        width: 1372,
        animate: animate,
        className: className,
        primaryColor: "#cbcbcb",
        secondaryColor: "#a0b9ed",
        style: _object_spread_props(_object_spread({
            height: height,
            width: "100%"
        }, style), {
            viewBox: "-10 -5 1350 40"
        })
    }, /*#__PURE__*/ react.createElement("rect", _object_spread({
        x: "24",
        y: "13.4286",
        width: 473 * random
    }, common)), /*#__PURE__*/ react.createElement("rect", _object_spread({
        x: "585",
        y: "13.4286",
        width: 370 * random
    }, common)), /*#__PURE__*/ react.createElement("rect", _object_spread({
        x: "1190 ",
        y: "13.4286",
        width: 160 * random
    }, common)));
};
const fadeAnimation = (0,css/* keyframes */.F4)({
    "0%": {
        opacity: 0.1
    },
    "100%": {
        opacity: 1
    }
});
const animationClassname = (0,css/* css */.iv)({
    animation: `${fadeAnimation} 4s ease-out`,
    animationFillMode: "forwards",
    opacity: 0.01,
    boxShadow: "2px 1px 1px 0px hsla(0, 0%, 92%, 1)"
});
const Table = /*#__PURE__*/ react.memo(({ count =10 , style , height =35 , animate =true  })=>/*#__PURE__*/ react.createElement(react.Fragment, null, Array(count).fill("").map((_, i)=>/*#__PURE__*/ react.createElement(TableRow, {
            key: i,
            height: height,
            animate: animate,
            className: animate ? animationClassname().className : "",
            style: _object_spread({
                animationDelay: Math.max(i / 3 - 0.5, 0) + "s"
            }, style)
        }))), ()=>true);
const TableLoader = Table;

// EXTERNAL MODULE: ./src/shared/testConstants.ts + 1 modules
var testConstants = __webpack_require__(81202);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(94184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./node_modules/lodash-es/get.js
var get = __webpack_require__(16423);
// EXTERNAL MODULE: ./node_modules/@mui/icons-material/KeyboardArrowRight.js
var KeyboardArrowRight = __webpack_require__(48317);
// EXTERNAL MODULE: ./node_modules/@mui/material/Typography/Typography.js + 1 modules
var Typography = __webpack_require__(2658);
// EXTERNAL MODULE: ./src/ui/index.ts + 23 modules
var ui = __webpack_require__(17218);
// EXTERNAL MODULE: ./src/ui/atoms/CopyTextToClipboard.tsx
var CopyTextToClipboard = __webpack_require__(54638);
// EXTERNAL MODULE: ./node_modules/constate/dist/constate.es.js
var constate_es = __webpack_require__(11521);
// EXTERNAL MODULE: ./node_modules/lodash-es/keyBy.js
var keyBy = __webpack_require__(69884);
// EXTERNAL MODULE: ./src/libs/hooks/useSize.tsx
var useSize = __webpack_require__(93906);
// EXTERNAL MODULE: ./node_modules/lodash-es/throttle.js
var throttle = __webpack_require__(111);
;// CONCATENATED MODULE: ./src/libs/css-grid-table/useResizeListener.ts


function useResizeListener() {
    const [pageXDiff, setPageXDiff] = (0,react.useState)(null);
    const [curCol, setCurCol] = (0,react.useState)(null);
    const pageXRef = (0,react.useRef)(null);
    const onMouseDown = (0,react.useCallback)(function onMouseDown(e) {
        const current = e.target.parentElement;
        const col = current.previousSibling.dataset["id"];
        pageXRef.current = e.pageX;
        setCurCol(col);
    }, [
        setCurCol,
        pageXRef
    ]);
    (0,react.useEffect)(()=>{
        const onMouseMove = (0,throttle/* default */.Z)(function onMouseMove(e) {
            if (!pageXRef.current) {
                return;
            }
            const prevPageX = pageXRef.current;
            setPageXDiff(e.pageX - prevPageX);
        }, 20);
        function onMouseUp() {
            pageXRef.current = null;
            setCurCol(null);
            setPageXDiff(0);
        }
        document.addEventListener("mousemove", onMouseMove);
        document.addEventListener("mouseup", onMouseUp);
        return ()=>{
            document.removeEventListener("mousemove", onMouseMove);
            document.removeEventListener("mouseup", onMouseUp);
        };
    }, []);
    return {
        onMouseDown,
        pageXDiff,
        curCol
    };
}

;// CONCATENATED MODULE: ./src/libs/css-grid-table/resizeServices.ts
function resizeServices_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function resizeServices_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            resizeServices_define_property(target, key, source[key]);
        });
    }
    return target;
}
function resizeServices_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function resizeServices_object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        resizeServices_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
class SizeNode {
    constructor(id, width){
        resizeServices_define_property(this, "id", void 0);
        resizeServices_define_property(this, "width", void 0);
        this.id = id;
        this.width = width;
    }
}
const normalizeColumnsSizes = (columns)=>{
    return columns.map((c)=>{
        return resizeServices_object_spread_props(resizeServices_object_spread({}, c), {
            minWidth: c.minWidth || 130
        });
    });
};
const parseColumnSize = (column, totalMin, totalWidth)=>{
    return [
        column.minWidth,
        column.maxWidth || totalWidth - (totalMin - (column.minWidth || 0))
    ];
};
const calculateTotalMin = (columns)=>{
    return columns.reduce((acc, c)=>{
        if (!c.resizable) {
            return acc;
        }
        return acc + (c.minWidth || 0);
    }, 0);
};
const parseMinMaxSizes = (columns, tableWidth)=>{
    const normalizedColumns = normalizeColumnsSizes(columns);
    const map = new Map();
    const totalMin = calculateTotalMin(normalizedColumns);
    return normalizedColumns.reduce((acc, column)=>{
        if (column.resizable) {
            acc.set(column.id, parseColumnSize(column, totalMin, tableWidth));
        }
        return acc;
    }, map);
};
const calculateRealSizes = (columns, parent = document)=>{
    return columns.reduce((acc, c)=>{
        const head = parent.querySelector(`[data-id=${c.id}]`);
        if (head) {
            acc.set(c.id, head.getBoundingClientRect().width);
        }
        return acc;
    }, new Map());
};
const isResizePossible = (currentColumn, sizeDiff, columns, minMaxSizes, realSizes)=>{
    const columnIndex = columns.findIndex((c)=>c.id === currentColumn);
    const getRealSizeTotal = (arr)=>arr.reduce((acc, c)=>{
            const size = realSizes.get(c.id);
            return acc + size;
        }, 0);
    const getMinSizeTotal = (arr)=>arr.reduce((acc, c)=>{
            const size = minMaxSizes.get(c.id)[0];
            return acc + size;
        }, 0);
    const getMaxSizeTotal = (arr)=>arr.reduce((acc, c)=>{
            const size = minMaxSizes.get(c.id)[1];
            return acc + size;
        }, 0);
    const [left, right] = splitArray(columns, columnIndex).map((arr)=>arr.filter((c)=>c.resizable));
    if (sizeDiff >= 0) {
        // if (minMaxSizes.get(currentColumn)[1] <= realSizes.get(currentColumn) + sizeDiff) {
        //   return false;
        // }
        const rightSizeMinTotal = getMinSizeTotal(right);
        const rightSizeTotal = getRealSizeTotal(right);
        if (rightSizeTotal - sizeDiff <= rightSizeMinTotal) {
            return false;
        }
    } else {
        const currColumn = columns[columnIndex];
        const leftSizeMinTotal = getMinSizeTotal([
            ...left,
            currColumn
        ]);
        const leftSizeTotal = getRealSizeTotal([
            ...left,
            currColumn
        ]);
        if (leftSizeMinTotal >= leftSizeTotal + sizeDiff) {
            return false;
        }
        const rightSizeMaxTotal = getMaxSizeTotal(right);
        const rightSizeTotal = getRealSizeTotal(right);
        if (rightSizeMaxTotal <= rightSizeTotal - sizeDiff) {
            return false;
        }
    }
    return true;
};
const calculateCurrentSizes = (currentColumn, sizeDiff, columns, minMaxSizes, realSizes)=>{
    const diffLeft = Math.abs(sizeDiff);
    const currentIndex = columns.findIndex((c)=>c.id === currentColumn);
    const [left, right] = splitArray(columns, currentIndex);
    const _currentColumn = columns[currentIndex];
    if (sizeDiff >= 0) {
        const mapBefore = (column)=>{
            const realWidth = realSizes.get(column.id);
            return new SizeNode(column.id, column.resizable ? realWidth : column.width);
        };
        const mapCurrent = (column, diffLeft)=>{
            const realWidth = realSizes.get(column.id);
            return new SizeNode(column.id, (realWidth || 0) + diffLeft);
        };
        const mapAfter = (column, diffLeft)=>{
            if (!column.resizable) {
                return [
                    new SizeNode(column.id, column.width),
                    diffLeft
                ];
            }
            const colMinWidth = minMaxSizes.get(column.id)[0];
            const realWidth = realSizes.get(column.id);
            const availableWidth = (realWidth || 0) - colMinWidth;
            if (availableWidth >= diffLeft) {
                return [
                    new SizeNode(column.id, (realWidth || 0) - diffLeft),
                    0
                ];
            } else {
                return [
                    new SizeNode(column.id, colMinWidth),
                    diffLeft - availableWidth
                ];
            }
        };
        const leftColumns = left.map(mapBefore);
        const newCurrentColumn = mapCurrent(_currentColumn, diffLeft);
        const [rightColumns] = right.reduce(reduceWithAcc(mapAfter), [
            [],
            diffLeft
        ]);
        return leftColumns.concat(newCurrentColumn, rightColumns);
    } else {
        // diff < 0
        const mapAfter = (c, diffLeft)=>{
            if (!c.resizable) {
                return [
                    c,
                    diffLeft
                ];
            }
            const realWidth = realSizes.get(c.id);
            const colMaxWidth = minMaxSizes.get(c.id)[1];
            const available = colMaxWidth - (realWidth || 0);
            if (available >= diffLeft) {
                return [
                    new SizeNode(c.id, (realWidth || 0) + diffLeft),
                    0
                ];
            } else {
                return [
                    new SizeNode(c.id, colMaxWidth),
                    diffLeft - available
                ];
            }
        };
        const mapCurrent = (c, diffLeft)=>{
            const colMinWidth = minMaxSizes.get(c.id)[0];
            const realWidth = realSizes.get(c.id);
            const available = (realWidth || 0) - colMinWidth;
            if (available >= diffLeft) {
                return [
                    new SizeNode(c.id, (realWidth || 0) - diffLeft),
                    0
                ];
            } else {
                return [
                    new SizeNode(c.id, colMinWidth),
                    diffLeft - available
                ];
            }
        };
        const mapBefore = (c, diffLeft)=>{
            const realWidth = realSizes.get(c.id);
            if (c.resizable) {
                if (diffLeft === 0) {
                    return [
                        new SizeNode(c.id, realWidth),
                        0
                    ];
                } else {
                    return mapCurrent(c, diffLeft);
                }
            } else {
                return [
                    new SizeNode(c.id, c.width),
                    diffLeft
                ];
            }
        };
        const [rightColumns] = right.reduce(reduceWithAcc(mapAfter), [
            [],
            diffLeft
        ]);
        const [newCurrentColumn, leftSizeLeft] = mapCurrent(_currentColumn, diffLeft);
        const [leftColumn] = left.reduceRight(reduceWithAcc(mapBefore), [
            [],
            leftSizeLeft
        ]);
        return leftColumn.reverse().concat(newCurrentColumn, rightColumns);
    }
};
function splitArray(arr, idx) {
    const left = arr.slice(0, idx);
    const right = arr.slice(idx + 1);
    return [
        left,
        right
    ];
}
function reduceWithAcc(map) {
    return (acc, c)=>{
        const diffLeft = acc[1];
        const [column, newDiff] = map(c, diffLeft);
        acc[0].push(column);
        acc[1] = newDiff;
        return acc;
    };
}
function toGridTemplateColumns(columns) {
    return columns.map(({ width  })=>{
        if (typeof width === "number") {
            width = `${width}px`;
        }
        return `${width || "minmax(100px, 1fr)"}`;
    }).join(" ") + " [col-end]";
}

;// CONCATENATED MODULE: ./src/libs/css-grid-table/useResize.ts





function useResize(columns, tableRef) {
    const { pageXDiff , onMouseDown , curCol  } = useResizeListener();
    const tableSize = (0,useSize/* useSize */.t)(tableRef);
    const [sizes, setSizes] = (0,react.useState)();
    const realSizesRef = (0,react.useRef)();
    const prevRealSizesRef = (0,react.useRef)();
    const minMaxSizesRef = (0,react.useRef)();
    const prevTableWidthRef = (0,react.useRef)(0);
    // calculate new sizes after table resize
    (0,react.useEffect)(()=>{
        if (sizes && prevRealSizesRef.current) {
            const prevTableWidth = prevTableWidthRef.current;
            const newSizes = columns.map((c)=>{
                if (!c.resizable) {
                    return c;
                }
                const prevWidth = prevRealSizesRef.current.get(c.id);
                const scaleFactor = prevWidth / prevTableWidth;
                return {
                    id: c.id,
                    width: scaleFactor * tableSize.width
                };
            });
            setSizes(newSizes);
        }
    }, [
        columns,
        tableSize.width
    ]);
    (0,react.useEffect)(()=>{
        minMaxSizesRef.current = parseMinMaxSizes(columns, tableSize.width);
    }, [
        columns,
        tableSize.width
    ]);
    // calculate current sizes
    (0,react.useEffect)(()=>{
        if (curCol) {
            realSizesRef.current = calculateRealSizes(columns, tableRef.current);
        }
        if (!curCol) {
            prevTableWidthRef.current = tableSize.width;
            prevRealSizesRef.current = calculateRealSizes(columns, tableRef.current);
        }
    }, [
        curCol,
        columns
    ]);
    (0,react.useEffect)(()=>{
        if (!curCol || !isResizePossible(curCol, pageXDiff, columns, minMaxSizesRef.current, realSizesRef.current)) {
            return;
        }
        const newSizes = calculateCurrentSizes(curCol, pageXDiff, columns, minMaxSizesRef.current, realSizesRef.current);
        setSizes(newSizes);
    }, [
        curCol,
        columns,
        pageXDiff
    ]);
    // solution to fix small sizes of columns which dom sometimes returns
    const sizesFixed = (0,react.useMemo)(()=>{
        const columnsMap = (0,keyBy/* default */.Z)(columns, "id");
        if (!sizes || sizes.every((s)=>getWidth(s.width) >= 60)) {
            return sizes;
        }
        return sizes.map((node)=>{
            var _columnsMap_node_id;
            const minWidth = Number.parseInt(String((_columnsMap_node_id = columnsMap[node.id]) === null || _columnsMap_node_id === void 0 ? void 0 : _columnsMap_node_id.minWidth)) || 60;
            return new SizeNode(node.id, Math.max(node.width, minWidth));
        });
    }, [
        sizes,
        columns
    ]);
    return {
        onMouseDown,
        sizes: sizesFixed,
        isResizeActive: !!curCol
    };
}
function getWidth(val) {
    if (typeof val === "number") {
        return val;
    }
    return Number.parseFloat(String(val).replace("minmax(", ""));
}

;// CONCATENATED MODULE: ./src/libs/css-grid-table/state.ts




const emptyFn = ()=>{};
const [TableStateProvider, useTableState, useResizeHandlers] = (0,constate_es/* default */.Z)(({ columns  })=>{
    const tableRef = (0,react.useRef)(null);
    const isResizable = (0,react.useMemo)(()=>columns.some((c)=>c.resizable), [
        columns
    ]);
    const { sizes , onMouseDown , isResizeActive  } = isResizable ? useResize(columns, tableRef) : {
        sizes: null,
        onMouseDown: emptyFn,
        isResizeActive: false
    };
    const gridTemplateColumns = (0,react.useMemo)(()=>{
        return sizes ? toGridTemplateColumns(sizes) : toGridTemplateColumns(columns);
    }, [
        sizes
    ]);
    return {
        gridTemplateColumns,
        onMouseDown,
        tableRef,
        isResizeActive
    };
}, ({ gridTemplateColumns , tableRef , isResizeActive  })=>{
    return {
        gridTemplateColumns,
        tableRef,
        isResizeActive
    };
}, ({ onMouseDown  })=>{
    return onMouseDown;
});

// EXTERNAL MODULE: ./src/libs/css-grid-table/ThContent.tsx
var ThContent = __webpack_require__(87287);
;// CONCATENATED MODULE: ./src/libs/css-grid-table/Table.tsx
function Table_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function Table_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            Table_define_property(target, key, source[key]);
        });
    }
    return target;
}
function Table_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function Table_object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        Table_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}












const expandColumnPadding = 24;
const CELL_BLANK = undefined; // render Td
const CELL_EMPTY = Symbol("CELL_EMPTY"); // Dont render Td (useful when cell is merged vertically or horizontally, refer to getColSpan/getRawSpan)
const loadingClassName = (0,css/* css */.iv)({
    td: {
        opacity: 0.6,
        filter: "blur(1px)",
        userSelect: "none"
    }
});
// to fix selection headers during resizing in safari
const resizeActiveClassName = (0,css/* css */.iv)({
    "th,td": {
        userSelect: "none"
    }
});
const resizerClassName = (0,css/* css */.iv)({
    "position": "absolute",
    "left": "0px",
    "top": "0",
    "bottom": "0",
    "userSelect": "none",
    "cursor": "col-resize",
    "width": "5px",
    "&:hover": {
        borderLeft: `2px solid ${ui/* theme.palette.divider */.rS.palette.divider} !important`
    }
});
const stripedClassName = (0,css/* css */.iv)({
    "& > td": {
        background: ui/* theme.secondaryBackground */.rS.secondaryBackground
    }
});
const stripedCellClassName = (0,css/* css */.iv)({
    background: ui/* theme.secondaryBackground */.rS.secondaryBackground
});
const borderBottomClassName = (0,css/* css */.iv)({
    borderBottom: `1px solid ${ui/* theme.palette.divider */.rS.palette.divider}`
});
const highlightOnHoverClassName = (0,css/* css */.iv)({
    "&:hover": {
        background: "#e5e5e5"
    }
});
const highlightClassName = (0,css/* css */.iv)({
    background: "#e5e5e5"
});
const borderNone = (0,css/* css */.iv)({
    borderLeft: "none"
});
const TableInner = (0,css/* styled */.zo)("table", {
    "display": "grid",
    "width": "100%",
    "flexGrow": 1,
    "overflowY": "auto",
    "overflowX": "auto",
    "gridAutoRows": "min-content",
    '&[data-borderless="true"]': {
        borderTop: "none"
    },
    "> tbody": {
        "display": "contents",
        "gridTemplateColumns": "inherit",
        "> tr": {
            "display": "contents",
            "&.row": {
                "&:hover > td": {
                    background: "#e5e5e5"
                },
                "&:last-child td": {
                    borderBottom: `1px solid ${ui/* theme.palette.divider */.rS.palette.divider}`
                }
            }
        }
    },
    '[data-type="checkbox"]': {
        borderRight: "none"
    },
    "> thead": {
        "display": "contents",
        "borderLeft": `1px solid ${ui/* theme.palette.divider */.rS.palette.divider}`,
        "> tr": {
            display: "contents"
        }
    },
    "variants": {
        borders: {
            full: {
                border: `1px solid ${ui/* theme.palette.divider */.rS.palette.divider}`
            },
            vertical: {
                borderTop: `1px solid ${ui/* theme.palette.divider */.rS.palette.divider}`
            },
            none: {
                borderBottom: "none"
            }
        }
    },
    "defaultVariants": {
        borders: "full"
    }
});
const Th = (0,css/* styled */.zo)("th", {
    "position": "sticky",
    "top": "0",
    "background": "white",
    "zIndex": 1,
    "whiteSpace": "nowrap",
    "padding": "15px",
    "lineHeight": "normal",
    "letterSpacing": "normal",
    "textAlign": "left",
    "display": "flex",
    "alignItems": "center",
    "borderLeft": `1px solid ${ui/* theme.palette.divider */.rS.palette.divider}`,
    "borderBottom": `1px solid ${ui/* theme.palette.divider */.rS.palette.divider}`,
    "overflow": "hidden",
    "textOverflow": "ellipsis",
    "&:last-child": {
        paddingRight: "12px"
    },
    "&:first-child": {
        paddingLeft: "20px",
        borderLeft: "none",
        [`.${resizerClassName().className}`]: {
            display: "none"
        }
    },
    ":hover": {
        [`.${resizerClassName().className}`]: {
            borderLeft: `1px solid ${ui/* theme.palette.divider */.rS.palette.divider}`
        }
    }
});
const Td = (0,css/* styled */.zo)("td", {
    "whiteSpace": "nowrap",
    "position": "relative",
    "padding": "5px 15px 5px 15px",
    "letterSpacing": "normal",
    "display": "flex",
    "alignItems": "center",
    "minHeight": "48px",
    "&:first-child": {
        paddingLeft: "20px",
        borderRight: "none",
        borderLeft: "none"
    },
    "&:last-child": {
        borderRight: "none"
    },
    "borderLeft": `1px solid ${ui/* theme.palette.divider */.rS.palette.divider}`,
    "borderBottom": `1px solid ${ui/* theme.secondaryBackground */.rS.secondaryBackground}`
});
const FullCell = (0,css/* styled */.zo)("td", {
    gridColumn: "1 / col-end",
    padding: "0"
});
const LoaderContainer = (0,css/* styled */.zo)("div", {
    position: "absolute",
    left: "0",
    right: "0",
    top: "0",
    bottom: "0",
    zIndex: 5
});
const Wrapper = (0,css/* styled */.zo)("div", {
    position: "relative",
    display: "flex",
    overflow: "hidden",
    flexGrow: 1
});
const Resizer = ({ onMouseDown  })=>{
    return /*#__PURE__*/ react.createElement("div", {
        onMouseDown: onMouseDown,
        className: resizerClassName().className
    });
};
const HeaderCell = (_param)=>{
    var { children , column , resizable  } = _param, props = _object_without_properties(_param, [
        "children",
        "column",
        "resizable"
    ]);
    const onMouseDown = useResizeHandlers();
    return /*#__PURE__*/ react.createElement(Th, Table_object_spread_props(Table_object_spread({}, props), {
        "data-id": column.id,
        className: classnames_default()(props.className)
    }), children, " ", resizable && /*#__PURE__*/ react.createElement(Resizer, {
        onMouseDown: onMouseDown
    }));
};
function CellRenderer({ children , CellComponent =react.Fragment , props , index  }) {
    return /*#__PURE__*/ react.createElement(CopyTextToClipboard/* CopyTextToClipboard */.E, {
        sx: {
            width: "100%"
        }
    }, typeof children === "function" ? children(props, index) : /*#__PURE__*/ react.createElement(CellComponent, props, children));
}
function FullRow(_param) {
    var { children  } = _param, props = _object_without_properties(_param, [
        "children"
    ]);
    return /*#__PURE__*/ react.createElement("tr", {
        className: "full-row"
    }, /*#__PURE__*/ react.createElement(FullCell, props, children));
}
function ExpandRow(_param) {
    var { expanded  } = _param, props = _object_without_properties(_param, [
        "expanded"
    ]);
    return /*#__PURE__*/ react.createElement(KeyboardArrowRight/* default */.Z, Table_object_spread_props(Table_object_spread({}, props), {
        fontSize: "default",
        cursor: "pointer",
        "data-testid": expanded ? testConstants/* listViewSelectors.CollapseBtn */.R7.CollapseBtn : testConstants/* listViewSelectors.ExpandBtn */.R7.ExpandBtn,
        style: {
            position: "absolute",
            left: 1,
            transition: "transform .2s ease-in",
            transform: expanded ? "translateY(-50%) rotate(90deg)" : "translateY(-50%)",
            top: "50%"
        }
    }));
}
function TableContainer({ children , className , bordered , borders  }) {
    const { gridTemplateColumns , tableRef , isResizeActive  } = useTableState();
    return /*#__PURE__*/ react.createElement(TableInner, {
        "data-borderless": bordered ? "false" : "true",
        className: classnames_default()(className, isResizeActive && resizeActiveClassName().className),
        style: {
            gridTemplateColumns
        },
        ref: tableRef,
        borders: borders
    }, children);
}
function TableBody({ columns , renderSubComponent , expand ={} , expandPosIndex =0 , data , children , loading , getId , striped , onSortChange , sort , theadProps , classes ={} , ThComponent =ThContent/* DefaultThContent */.t , noData , infiniteScrollRef , infiniteScrollMargin , loader =/*#__PURE__*/ react.createElement(ui/* Loader */.aN, {
    loading: true
}) , bordered =true , borderBottomCell =false , highlightCell =null , borders ="full"  }) {
    var _dataRef_current, _dataRef_current1, _dataRef_current2;
    const isExpandable = !!renderSubComponent;
    const RowComponent = isExpandable ? ExpandableRow : Row;
    const dataRef = (0,react.useRef)(data);
    const itemWithRefIndex = (0,react.useMemo)(()=>{
        var _dataRef_current, _dataRef_current1;
        if (!((_dataRef_current = dataRef.current) === null || _dataRef_current === void 0 ? void 0 : _dataRef_current.length) || !infiniteScrollMargin) {
            return false;
        }
        return Math.round(((_dataRef_current1 = dataRef.current) === null || _dataRef_current1 === void 0 ? void 0 : _dataRef_current1.length) * (1 - infiniteScrollMargin));
    }, [
        (_dataRef_current = dataRef.current) === null || _dataRef_current === void 0 ? void 0 : _dataRef_current.length
    ]);
    if (!loading) {
        dataRef.current = data;
    }
    if (!columns) {
        return null;
    }
    const hasDataLength = !!((_dataRef_current1 = dataRef.current) === null || _dataRef_current1 === void 0 ? void 0 : _dataRef_current1.length);
    return /*#__PURE__*/ react.createElement(TableStateProvider, {
        columns: columns
    }, /*#__PURE__*/ react.createElement(Wrapper, null, !loading && !hasDataLength && noData, loading && hasDataLength && /*#__PURE__*/ react.createElement(LoaderContainer, null, loader), loading && !hasDataLength && /*#__PURE__*/ react.createElement(LoaderContainer, {
        style: {
            top: 55
        }
    }, /*#__PURE__*/ react.createElement(TableLoader, null)), /*#__PURE__*/ react.createElement(TableContainer, {
        bordered: bordered,
        borders: borders,
        className: classes.table
    }, /*#__PURE__*/ react.createElement("thead", theadProps || {}, /*#__PURE__*/ react.createElement("tr", null, columns.map((column, i)=>{
        var _column_getHeaderProps, _columns_;
        const headerProps = (_column_getHeaderProps = column.getHeaderProps) === null || _column_getHeaderProps === void 0 ? void 0 : _column_getHeaderProps.call(column, column);
        const toggleSort = ()=>{
            onSortChange === null || onSortChange === void 0 ? void 0 : onSortChange({
                sort_by: column.id,
                sort_desc: (sort === null || sort === void 0 ? void 0 : sort.sort_by) === column.id ? !(sort === null || sort === void 0 ? void 0 : sort.sort_desc) : false
            });
        };
        var _column_type;
        return /*#__PURE__*/ react.createElement(HeaderCell, {
            key: column.id + column.Header || i,
            style: Table_object_spread({}, column.thStyle, expandPosIndex === i && isExpandable ? {
                paddingLeft: expandColumnPadding
            } : {}),
            resizable: ((_columns_ = columns[i - 1]) === null || _columns_ === void 0 ? void 0 : _columns_.resizable) && column.resizable,
            className: classnames_default()(column.thClassName, classes.th),
            column: column,
            "data-type": (_column_type = column.type) !== null && _column_type !== void 0 ? _column_type : "cell"
        }, /*#__PURE__*/ react.createElement(CellRenderer, {
            CellComponent: ThComponent,
            index: i,
            props: Table_object_spread({
                column,
                sort,
                toggleSort
            }, headerProps)
        }, column.Header));
    }))), /*#__PURE__*/ react.createElement("tbody", {
        className: classnames_default()(loading && loadingClassName().className)
    }, !!((_dataRef_current2 = dataRef.current) === null || _dataRef_current2 === void 0 ? void 0 : _dataRef_current2.length) && dataRef.current.map((item, i)=>{
        return /*#__PURE__*/ react.createElement(RowComponent, {
            infiniteScrollRef: itemWithRefIndex === i ? infiniteScrollRef : undefined,
            index: i,
            className: striped && i % 2 === 0 ? stripedClassName().className : undefined,
            borderBottom: borderBottomCell,
            tdClassName: classes.td,
            hidden: loading,
            columns: columns,
            key: (getId === null || getId === void 0 ? void 0 : getId(item)) || i,
            item: item,
            expanded: expand[i],
            subContent: isExpandable ? renderSubComponent(item, i) : undefined,
            expandPosIndex: expandPosIndex,
            highlightCell: highlightCell
        });
    })), /*#__PURE__*/ react.createElement("tbody", null, react.Children.map(children, (el)=>{
        return /*#__PURE__*/ react.createElement(FullRow, null, el);
    })))));
}
function Row({ className , columns , item , index , tdClassName , borderBottom , highlightCell , infiniteScrollRef  }) {
    return /*#__PURE__*/ react.createElement("tr", {
        className: className
    }, columns.map((column, k)=>{
        var _column_getItemId, _column_getRowSpan, _column_getColSpan;
        const value = (column === null || column === void 0 ? void 0 : column.accessor) ? column.accessor(item) : item[column.id];
        const ref = (index)=>index === 5 ? infiniteScrollRef : undefined;
        if (value === CELL_EMPTY) {
            return null;
        }
        if (value === CELL_BLANK && !column.supportEmptyValue) {
            return /*#__PURE__*/ react.createElement(Td, {
                // ref is placed on the 5th column. Next task is to reimplement the table to MUI X.
                ref: ref(k),
                key: k,
                "data-column": column.id,
                "data-type": column.type,
                className: classnames_default()(borderNone().className, column.className)
            });
        }
        return /*#__PURE__*/ react.createElement(Td, {
            key: column.id || k,
            // ref is placed on the 5th column. Next task is to reimplement the table to MUI X.
            ref: ref(k),
            "data-id": column.id,
            "data-type": column.type,
            className: classnames_default()(column.className, tdClassName, (column.borderBottom || borderBottom) && borderBottomClassName().className, column.striped && index % 2 === 0 ? stripedCellClassName().className : null, column.highlightOnHover && highlightOnHoverClassName().className, ((_column_getItemId = column.getItemId) === null || _column_getItemId === void 0 ? void 0 : _column_getItemId.call(column, value)) === highlightCell && highlightClassName().className),
            style: Table_object_spread_props(Table_object_spread({}, typeof column.tdStyle === "function" ? column.tdStyle(item) : column.tdStyle), {
                gridRow: `span ${(_column_getRowSpan = column.getRowSpan) === null || _column_getRowSpan === void 0 ? void 0 : _column_getRowSpan.call(column, item)}`,
                gridColumn: `span ${(_column_getColSpan = column.getColSpan) === null || _column_getColSpan === void 0 ? void 0 : _column_getColSpan.call(column, item)}`
            })
        }, column.Cell ? /*#__PURE__*/ react.createElement(CellRenderer, {
            index: k,
            props: {
                original: item,
                value: value
            }
        }, column.Cell) : /*#__PURE__*/ react.createElement(Typography/* default */.Z, {
            title: column.truncateText ? value : undefined,
            noWrap: column.truncateText
        }, value));
    }));
}
function ExpandableRow({ subContent , expanded , columns , item , hidden , className , expandPosIndex , tdClassName , infiniteScrollRef  }) {
    const [isExpanded, update] = (0,react.useState)(expanded);
    const expandedContent = isExpanded && subContent;
    const styles = hidden ? {
        display: "none"
    } : {};
    function toggle() {
        update((s)=>!s);
    }
    (0,react.useLayoutEffect)(()=>{
        update(expanded);
    }, [
        expanded
    ]);
    return /*#__PURE__*/ react.createElement(react.Fragment, {
        key: item.id
    }, /*#__PURE__*/ react.createElement("tr", {
        className: className + " row"
    }, columns.map((column, k)=>{
        const value = (column === null || column === void 0 ? void 0 : column.accessor) ? column.accessor(item) : (0,get/* default */.Z)(item, column.id);
        return /*#__PURE__*/ react.createElement(Td, {
            // ref is placed on the 5th column. Next task is to reimplement the table to MUI X.
            ref: k === 5 ? infiniteScrollRef : undefined,
            "data-type": column.type,
            "data-column": column.id,
            key: k,
            className: classnames_default()(tdClassName, column.className),
            style: Table_object_spread({}, typeof column.tdStyle === "function" ? column.tdStyle(item) : column.tdStyle, expandPosIndex === k ? {
                paddingLeft: expandColumnPadding
            } : {})
        }, k === expandPosIndex && /*#__PURE__*/ react.createElement(ExpandRow, {
            expanded: isExpanded,
            onClick: toggle
        }), column.Cell ? /*#__PURE__*/ react.createElement(CellRenderer, {
            index: k,
            props: {
                original: item,
                value: value
            }
        }, column.Cell) : /*#__PURE__*/ react.createElement(CellRenderer, {
            index: k,
            CellComponent: Td
        }, value));
    })), isExpanded && /*#__PURE__*/ react.createElement(FullRow, {
        key: "expand-content",
        style: styles
    }, expandedContent));
}

;// CONCATENATED MODULE: ./src/libs/css-grid-table/Pagination.tsx
function Pagination_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function Pagination_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            Pagination_define_property(target, key, source[key]);
        });
    }
    return target;
}
function Pagination_object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = Pagination_object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function Pagination_object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}



const spacerStyles = (0,css/* css */.iv)({
    display: "none"
});
const toolbarStyles = (0,css/* css */.iv)({
    justifyContent: "flex-end"
});
const classes = {
    spacer: spacerStyles().className,
    toolbar: toolbarStyles().className
};
function Pagination(_param) {
    var { onChangePage , disabled  } = _param, props = Pagination_object_without_properties(_param, [
        "onChangePage",
        "disabled"
    ]);
    return /*#__PURE__*/ React.createElement(TablePagination, Pagination_object_spread({
        component: "div",
        classes: classes,
        rowsPerPageOptions: [
            25
        ],
        nextIconButtonProps: {
            disabled: disabled.next
        },
        backIconButtonProps: {
            disabled: disabled.prev || props.page === 0
        },
        labelDisplayedRows: ({ from , to , count  })=>`${from}-${to} of ${count === Infinity ? "Many" : count}`,
        onPageChange: (_, n)=>{
            onChangePage(n);
        }
    }, props));
}

;// CONCATENATED MODULE: ./src/libs/css-grid-table/index.tsx





/***/ }),

/***/ 49248:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "w": () => (/* binding */ selectors)
/* harmony export */ });
/* unused harmony export groupAttr */
const groupAttr = {
    role: "group"
};
// helper selectors
const selectors = {
    touchParent: `*:focus > &, *:focus-within > &, *:hover > &`,
    touchGroup: `[role="group"]:hover &, [role="group"]:focus &, [role="group"]:focus-within &`,
    hoverGroup: `[role="group"]:hover &`,
    errorGroup: `[role="group"][data-error="true"] &`,
    touch: "&:hover, &:focus, &:focus-within"
};


/***/ }),

/***/ 50082:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "tT": () => (/* reexport */ compareBy),
  "qr": () => (/* reexport */ compareByProp),
  "td": () => (/* reexport */ formatBytes),
  "eL": () => (/* reexport */ jsxJoin),
  "uK": () => (/* reexport */ partition),
  "JQ": () => (/* reexport */ hash_sha256),
  "MR": () => (/* reexport */ sortBy)
});

// UNUSED EXPORTS: bulkJson, encode64, encode64Tostring, groupBy

;// CONCATENATED MODULE: ./src/libs/data-utils/sortBy.ts
function compareBy(keyFn, asc = false) {
    const compare = new Intl.Collator("en", {
        numeric: true
    }).compare;
    return (a, b)=>compare(keyFn(b), keyFn(a)) * (asc ? -1 : 1);
}
function sortBy(items, fn) {
    return items.sort(compareBy(fn));
}
function isSortableProp(a) {
    return typeof a === "string" || typeof a === "number";
}
function compareByProp(key, options = {}) {
    var _options, _options1;
    var _sensitivity;
    (_sensitivity = (_options = options).sensitivity) !== null && _sensitivity !== void 0 ? _sensitivity : _options.sensitivity = "base";
    var _numeric;
    (_numeric = (_options1 = options).numeric) !== null && _numeric !== void 0 ? _numeric : _options1.numeric = true;
    const compare = new Intl.Collator("en", options).compare;
    return (a, b)=>{
        if (isSortableProp(a === null || a === void 0 ? void 0 : a[key]) && isSortableProp(b === null || b === void 0 ? void 0 : b[key])) {
            return compare(a === null || a === void 0 ? void 0 : a[key], b === null || b === void 0 ? void 0 : b[key]);
        }
        return -1;
    };
}

// EXTERNAL MODULE: ./node_modules/js-sha256/src/sha256.js
var sha256 = __webpack_require__(72023);
;// CONCATENATED MODULE: ./src/libs/data-utils/hash.ts

// special base64 encoding
// took from here https://gist.github.com/jonleighton/958841
function base64ArrayBuffer(arrayBuffer) {
    var bytes = new Uint8Array(arrayBuffer);
    return BytesToBase64(bytes);
}
function BytesToBase64(bytes) {
    var encodings = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789-_";
    var base64 = "";
    var byteLength = bytes.byteLength;
    var byteRemainder = byteLength % 3;
    var mainLength = byteLength - byteRemainder;
    var a, b, c, d;
    var chunk;
    // Main loop deals with bytes in chunks of 3
    for(var i = 0; i < mainLength; i = i + 3){
        // Combine the three bytes into a single integer
        chunk = bytes[i] << 16 | bytes[i + 1] << 8 | bytes[i + 2];
        // Use bitmasks to extract 6-bit segments from the triplet
        a = (chunk & 16515072) >> 18; // 16515072 = (2^6 - 1) << 18
        b = (chunk & 258048) >> 12; // 258048   = (2^6 - 1) << 12
        c = (chunk & 4032) >> 6; // 4032     = (2^6 - 1) << 6
        d = chunk & 63; // 63       = 2^6 - 1
        // Convert the raw binary segments to the appropriate ASCII encoding
        base64 += encodings[a] + encodings[b] + encodings[c] + encodings[d];
    }
    // Deal with the remaining bytes and padding
    if (byteRemainder === 1) {
        chunk = bytes[mainLength];
        a = (chunk & 252) >> 2; // 252 = (2^6 - 1) << 2
        // Set the 4 least significant bits to zero
        b = (chunk & 3) << 4; // 3   = 2^2 - 1
        base64 += encodings[a] + encodings[b];
    } else if (byteRemainder === 2) {
        chunk = bytes[mainLength] << 8 | bytes[mainLength + 1];
        a = (chunk & 64512) >> 10; // 64512 = (2^6 - 1) << 10
        b = (chunk & 1008) >> 4; // 1008  = (2^6 - 1) << 4
        // Set the 2 least significant bits to zero
        c = (chunk & 15) << 2; // 15    = 2^4 - 1
        base64 += encodings[a] + encodings[b] + encodings[c];
    }
    return base64;
}
function encode64(buff) {
    return base64ArrayBuffer(new Uint8Array(buff).slice(0, 9));
}
function encode64Tostring(string) {
    return BytesToBase64(new TextEncoder().encode(string));
}
function hash_sha256(message) {
    const hashBuffer = sha256.sha256.arrayBuffer(message);
    return encode64(hashBuffer);
}

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
;// CONCATENATED MODULE: ./src/libs/data-utils/jsx.tsx

function jsxJoin(children, joinItem) {
    const res = [];
    const childrenArray = react.Children.toArray(children);
    childrenArray.forEach((el, i)=>{
        res.push(el);
        if (i !== childrenArray.length - 1) {
            res.push(/*#__PURE__*/ react.createElement(react.Fragment, {
                key: i + "divider"
            }, joinItem(el, i)));
        }
    });
    return res;
}

// EXTERNAL MODULE: ./node_modules/lodash-es/reduce.js + 1 modules
var reduce = __webpack_require__(85697);
;// CONCATENATED MODULE: ./src/libs/data-utils/partition.ts

/**
 * Creates an array of elements split into two groups, the first of which
 * contains elements `predicate` returns truthy for, the second of which
 * contains elements `predicate` returns falsey for. The predicate is
 * invoked with one argument: (value).
 *
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {Array} Returns the array of grouped elements.
 * @see groupBy, keyBy
 *
 * const users = [
 *   { 'user': 'barney',  'age': 36, 'active': false },
 *   { 'user': 'fred',    'age': 40, 'active': true },
 *   { 'user': 'pebbles', 'age': 1,  'active': false }
 * ]
 *
 * partition(users, ({ active }) => active)
 * // => objects for [['fred'], ['barney', 'pebbles']]
 */ function partition(collection, predicate) {
    return (0,reduce/* default */.Z)(collection, (result, value, key)=>{
        result[predicate(value, key) ? 0 : 1].push(value);
        return result;
    }, [
        [],
        []
    ]);
}

;// CONCATENATED MODULE: ./src/libs/data-utils/format-bytes.ts
function formatBytes(bytes, decimals = 2) {
    if (bytes === 0) {
        return "0 Bytes";
    }
    if (bytes === 1) {
        return "1 Byte";
    }
    const k = 1024;
    const dm = decimals < 0 ? 0 : decimals;
    const sizes = [
        "Bytes",
        "KB",
        "MB",
        "GB",
        "TB"
    ];
    const i = Math.min(Math.floor(Math.log(bytes) / Math.log(k)), sizes.length - 1);
    const value = parseFloat((bytes / Math.pow(k, i)).toFixed(dm));
    return value + " " + sizes[i];
}

;// CONCATENATED MODULE: ./src/libs/data-utils/index.ts









/***/ }),

/***/ 76376:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "o5": () => (/* binding */ subscribeEvent)
});

// UNUSED EXPORTS: useObserver, useScrollHeight

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
;// CONCATENATED MODULE: ./src/libs/dom/useObserver.ts

function useObserver_useObserver(cb, ref, config) {
    useEffect(()=>{
        if (!ref.current) {
            return;
        }
        const observer = new MutationObserver(cb);
        observer.observe(ref.current, config);
        return ()=>{
            observer.disconnect();
        };
    }, [
        cb,
        ref.current
    ]);
}

;// CONCATENATED MODULE: ./src/libs/dom/useScrollHeight.ts


function useScrollHeight(containerRef, initialHeight = 0) {
    const [scrollHeight, setScrollHeight] = useState(initialHeight);
    const updateScrollHeight = useCallback(()=>{
        if (containerRef.current) {
            setScrollHeight(containerRef.current.scrollHeight);
        }
    }, [
        containerRef.current
    ]);
    useObserver(updateScrollHeight, containerRef, {
        childList: true,
        subtree: true,
        attributes: true
    });
    return scrollHeight;
}

;// CONCATENATED MODULE: ./src/libs/dom/index.tsx


function subscribeEvent(target, event, cb) {
    target.addEventListener(event, cb);
    return ()=>{
        target.removeEventListener(event, cb);
    };
}


/***/ }),

/***/ 88289:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "ol": () => (/* reexport */ useActions/* useActions */.o),
  "m": () => (/* reexport */ useAnchorPositionedPopover),
  "FL": () => (/* reexport */ useAnimatedChange),
  "UK": () => (/* reexport */ useAsync2/* useAsyncCallback */.UK),
  "IT": () => (/* reexport */ useAsync2/* useAsyncSimple2 */.IT),
  "pU": () => (/* reexport */ useBrowserStorageState),
  "CJ": () => (/* reexport */ useControlledSet),
  "qY": () => (/* reexport */ useModal/* useDisclosure */.qY),
  "NM": () => (/* reexport */ useExpansion),
  "HA": () => (/* reexport */ useHasScrollbar),
  "K7": () => (/* reexport */ useKeyDown),
  "dd": () => (/* reexport */ useModal/* useModal */.dd),
  "h0": () => (/* reexport */ usePagination),
  "Sv": () => (/* reexport */ useModal/* usePopover */.Sv),
  "j6": () => (/* reexport */ useModal/* usePopoverDisclosure */.j6),
  "D9": () => (/* reexport */ usePrevious),
  "Wd": () => (/* reexport */ hooks_useQueryParam/* useQueryParam */.W),
  "Em": () => (/* reexport */ useRafCall),
  "cH": () => (/* reexport */ useSelection),
  "v9": () => (/* reexport */ useSelector),
  "$X": () => (/* reexport */ useSet),
  "dE": () => (/* reexport */ useStateWithSetters),
  "jv": () => (/* reexport */ useStorageWithExpiration),
  "iP": () => (/* reexport */ useWindowSize)
});

// UNUSED EXPORTS: createHistoryHook, useAsync, useAsyncSimple, useHover, useNamedHistoryState, useQuery

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
;// CONCATENATED MODULE: ./src/libs/hooks/useAsync.ts
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}

/**
 * @deprecated use react query instead
 */ const useAsync = (fn, args, fetchInitial = true)=>{
    const [state, set] = useState({
        loading: fetchInitial
    });
    let shouldFetch = fetchInitial;
    const refetch = useCallback((params = args)=>{
        set({
            loading: true
        });
        const promise = fn(params);
        handlePromiseState(promise, set);
    }, [
        JSON.stringify(args)
    ]);
    useEffect(()=>{
        if (!shouldFetch) {
            shouldFetch = true;
            return;
        }
        return refetch(args);
    }, [
        JSON.stringify(args)
    ]);
    return _object_spread_props(_object_spread({}, state), {
        refetch
    });
};
function handlePromiseState(promise, set, reqId) {
    return promise.then((value)=>{
        set({
            loading: false,
            value,
            reqId
        });
    }, (error)=>{
        set({
            loading: false,
            error,
            reqId
        });
    });
}

// EXTERNAL MODULE: ./src/libs/hooks/useAsync2.ts
var useAsync2 = __webpack_require__(94043);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 20 modules
var es = __webpack_require__(28216);
;// CONCATENATED MODULE: ./src/libs/hooks/useSelector.tsx

function useSelector(selector) {
    const select = selector.select ? selector.select : selector;
    return (0,es/* useSelector */.v9)(select);
}

// EXTERNAL MODULE: ./node_modules/keycode/index.js
var keycode = __webpack_require__(27537);
var keycode_default = /*#__PURE__*/__webpack_require__.n(keycode);
;// CONCATENATED MODULE: ./src/libs/hooks/useKeyDown.ts


function useKeyDown(key, onKeyDownHandler, ...params) {
    (0,react.useEffect)(()=>{
        window.addEventListener("keydown", onKeyDown);
        return ()=>window.removeEventListener("keydown", onKeyDown);
        function onKeyDown(event) {
            if (keycode_default()(event) === key) {
                onKeyDownHandler(event);
            }
        }
    }, params);
}

;// CONCATENATED MODULE: ./src/libs/hooks/useHover.tsx

const useHover = ()=>{
    const [isHovered, setHovered] = React.useState(false);
    const bind = {
        onMouseEnter: ()=>setHovered(true),
        onMouseLeave: ()=>setHovered(false)
    };
    return [
        isHovered,
        bind
    ];
};

;// CONCATENATED MODULE: ./src/libs/hooks/useRafCall.ts

function useRafCall() {
    const r = (0,react.useRef)(null);
    function call(fn) {
        cancelAnimationFrame(r.current);
        r.current = requestAnimationFrame(()=>fn());
    }
    function cancel() {
        cancelAnimationFrame(r.current);
    }
    return (0,react.useMemo)(()=>[
            call,
            cancel
        ], []);
}

// EXTERNAL MODULE: ./src/libs/hooks/useActions.tsx
var useActions = __webpack_require__(30550);
// EXTERNAL MODULE: ./src/libs/hooks/useModal.tsx
var useModal = __webpack_require__(50882);
;// CONCATENATED MODULE: ./src/libs/hooks/useSet.tsx
function useSet_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function useSet_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            useSet_define_property(target, key, source[key]);
        });
    }
    return target;
}

const useControlledSet = (initialSet = new Set())=>{
    const [set, setSet] = (0,react.useState)(initialSet);
    const stableActions = (0,react.useMemo)(()=>{
        const add = (item)=>setSet((prevSet)=>new Set([
                    ...Array.from(prevSet),
                    item
                ]));
        const remove = (item)=>setSet((prevSet)=>new Set(Array.from(prevSet).filter((i)=>i !== item)));
        const toggle = (item)=>setSet((prevSet)=>prevSet.has(item) ? new Set(Array.from(prevSet).filter((i)=>i !== item)) : new Set([
                    ...Array.from(prevSet),
                    item
                ]));
        return {
            add,
            remove,
            toggle,
            reset: (v = initialSet)=>setSet(v)
        };
    }, [
        setSet
    ]);
    const removeMany = (items)=>{
        const newSet = new Set(Array.from(set));
        for (const item of items){
            newSet.delete(item);
        }
        setSet(newSet);
    };
    const utils = useSet_object_spread({
        has: (0,react.useCallback)((item)=>set.has(item), [
            set
        ]),
        removeMany
    }, stableActions);
    return [
        set,
        utils
    ];
};
const useSet = (set, setSet)=>{
    const stableActions = (0,react.useMemo)(()=>{
        const add = (item)=>{
            const res = new Set([
                ...Array.from(set),
                item
            ]);
            return setSet(res);
        };
        const remove = (item)=>setSet(new Set(Array.from(set).filter((i)=>i !== item)));
        const toggle = (item)=>setSet(set.has(item) ? new Set(Array.from(set).filter((i)=>i !== item)) : new Set([
                ...Array.from(set),
                item
            ]));
        return {
            add,
            remove,
            toggle,
            reset: (v = set)=>setSet(v)
        };
    }, [
        setSet
    ]);
    const utils = useSet_object_spread({
        has: (0,react.useCallback)((item)=>set.has(item), [
            set
        ])
    }, stableActions);
    return [
        set,
        utils
    ];
};

// EXTERNAL MODULE: ./src/libs/hooks/useQueryParam.ts
var hooks_useQueryParam = __webpack_require__(12635);
// EXTERNAL MODULE: ./node_modules/react-use/lib/useMountedState.js
var useMountedState = __webpack_require__(95929);
;// CONCATENATED MODULE: ./src/libs/hooks/useAnimated.tsx
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}


function useAnimatedChange(_param) {
    var { key , keyframes , animateMount  } = _param, options = _object_without_properties(_param, [
        "key",
        "keyframes",
        "animateMount"
    ]);
    const ref = (0,react.useRef)();
    const mounted = (0,useMountedState["default"])();
    (0,react.useLayoutEffect)(()=>{
        var _ref_current;
        if (!mounted() && !animateMount) {
            return;
        }
        ref === null || ref === void 0 ? void 0 : (_ref_current = ref.current) === null || _ref_current === void 0 ? void 0 : _ref_current.animate(keyframes, options);
    }, [
        key
    ]);
    return {
        ref
    };
}

;// CONCATENATED MODULE: ./src/libs/hooks/useNamedQueryParam.tsx


// this hook is useful for creating modals where state looks like this dataset=id
// this hook converts that state into boolean
function useNamedHistoryState(props) {
    const [state, setState] = useQueryParam(props.name, props.defaultValue, props.keepInHistory);
    return [
        state === props.value,
        useCallback((switchValue)=>{
            if (switchValue) {
                setState(props.value);
            } else {
                setState(null);
            }
        }, [])
    ];
}

;// CONCATENATED MODULE: ./src/libs/hooks/usePrevious.ts

function usePrevious(value, defaultValue = undefined) {
    const ref = (0,react.useRef)(defaultValue);
    (0,react.useEffect)(()=>{
        ref.current = value;
    }, [
        value
    ]); // Only re-run if value changes
    return ref.current;
}

;// CONCATENATED MODULE: ./src/libs/hooks/usePagination.tsx
function usePagination_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function usePagination_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            usePagination_define_property(target, key, source[key]);
        });
    }
    return target;
}
function usePagination_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function usePagination_object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        usePagination_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}

function usePagination({ page =0 , perPage =50  }) {
    const [pageValue, updatePage] = (0,react.useState)(page);
    const [pageSizeValue, updatePageSize] = (0,react.useState)(perPage);
    (0,react.useEffect)(()=>{
        updatePageSize(perPage);
    }, [
        perPage
    ]);
    const handlers = (0,react.useMemo)(()=>({
            handlePageSize (perPage, page) {
                updatePage(page);
                updatePageSize(perPage);
            },
            handlePage: updatePage,
            reset () {
                updatePage(0);
            }
        }), [
        perPage
    ]);
    return usePagination_object_spread_props(usePagination_object_spread({}, handlers), {
        perPage: pageSizeValue,
        page: pageValue
    });
}

// EXTERNAL MODULE: ./node_modules/@mui/material/Popover/Popover.js + 1 modules
var Popover = __webpack_require__(62206);
;// CONCATENATED MODULE: ./src/libs/hooks/useAnchorPositionedPopover.tsx
function useAnchorPositionedPopover_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function useAnchorPositionedPopover_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            useAnchorPositionedPopover_define_property(target, key, source[key]);
        });
    }
    return target;
}
function useAnchorPositionedPopover_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function useAnchorPositionedPopover_object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        useAnchorPositionedPopover_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}


function useAnchorPositionedPopover(render) {
    const [anchorEl, setAnchorEl] = (0,react.useState)(null);
    const [props, setProps] = (0,react.useState)({});
    const [position, setPosition] = (0,react.useState)(null);
    function handleOpen(anchor, props) {
        setProps(props);
        setAnchorEl(anchor);
        const el = anchor.getBoundingClientRect();
        const MinHeight = 500;
        setPosition({
            left: el.left,
            top: Math.min(el.top, window.innerHeight - MinHeight),
            maxHeight: Math.max(MinHeight, window.innerHeight - el.top)
        });
    }
    function handleClose() {
        setAnchorEl(null);
    }
    const popProps = {
        onClose: handleClose,
        open: !!anchorEl,
        anchorPosition: position,
        anchorReference: "anchorPosition"
    };
    return [
        /*#__PURE__*/ react.createElement(Popover/* default */.ZP, useAnchorPositionedPopover_object_spread_props(useAnchorPositionedPopover_object_spread({
            TransitionProps: {
                onExited () {
                    setProps(null);
                }
            }
        }, popProps), {
            onClose: handleClose,
            style: {
                maxHeight: position === null || position === void 0 ? void 0 : position.maxHeight
            },
            keepMounted: false
        }), render({
            onClose: handleClose
        }, props)),
        {
            onOpen: handleOpen
        }
    ];
}

// EXTERNAL MODULE: ./node_modules/lodash-es/debounce.js + 1 modules
var debounce = __webpack_require__(99111);
;// CONCATENATED MODULE: ./src/libs/hooks/useWindowSize.tsx


function useWindowSize(debounceTime = 100) {
    const isClient = typeof window === "object";
    function getSize() {
        return {
            width: isClient ? window.innerWidth : undefined,
            height: isClient ? window.innerHeight : undefined
        };
    }
    const [windowSize, setWindowSize] = (0,react.useState)(getSize);
    (0,react.useEffect)(()=>{
        if (!isClient) {
            return;
        }
        const updateSize = (0,debounce["default"])(setWindowSize, debounceTime);
        function handleResize() {
            updateSize(getSize());
        }
        window.addEventListener("resize", handleResize);
        return ()=>{
            window.removeEventListener("resize", handleResize);
        };
    }, []); // Empty array ensures that effect is only run on mount and unmount
    return windowSize;
}

;// CONCATENATED MODULE: ./src/libs/hooks/useSelection.ts

function useSelection({ selectedItems , onChange , mapKey =(item)=>item , defaultState =[]  }) {
    const selectedItemsArray = (0,react.useMemo)(()=>Array.isArray(selectedItems) ? selectedItems : [
            ...selectedItems
        ], [
        selectedItems
    ]);
    const selectedItemsKeysSet = (0,react.useMemo)(()=>new Set(selectedItemsArray.map(mapKey)), [
        selectedItemsArray
    ]);
    const isEqual = (0,react.useCallback)((a, b)=>mapKey(a) === mapKey(b), []);
    const isSelected = (0,react.useCallback)((item)=>selectedItemsKeysSet.has(mapKey(item)), [
        selectedItemsKeysSet
    ]);
    const onSelect = (item, isMulti)=>{
        const selected = isSelected(item);
        if (isMulti) {
            onChange(selected ? selectedItemsArray.filter((el)=>!isEqual(el, item)) : selectedItemsArray.filter((el)=>!defaultState.includes(el)).concat(item));
        } else {
            onChange(selected && selectedItemsArray.length === 1 ? defaultState : [
                item
            ]);
        }
    };
    const resetSelection = ()=>{
        onChange(defaultState);
    };
    return {
        onSelect,
        isSelected,
        selectedCount: selectedItemsArray.length,
        resetSelection
    };
}

;// CONCATENATED MODULE: ./src/libs/hooks/useExpansion.ts

function useExpansion({ expandedItems , onChange , mapKey =(item)=>item , defaultState =[]  }) {
    const expandedItemsArray = (0,react.useMemo)(()=>Array.isArray(expandedItems) ? expandedItems : [
            ...expandedItems
        ], [
        expandedItems
    ]);
    const expandedItemsKeysSet = (0,react.useMemo)(()=>new Set(expandedItemsArray.map(mapKey)), [
        expandedItemsArray
    ]);
    const isEqual = (0,react.useCallback)((a, b)=>mapKey(a) === mapKey(b), []);
    const isExpanded = (0,react.useCallback)((item)=>expandedItemsKeysSet.has(mapKey(item)), [
        expandedItemsKeysSet
    ]);
    const onExpand = (item)=>{
        const expanded = isExpanded(item);
        onChange(expanded ? expandedItemsArray.filter((el)=>!isEqual(el, item)) : expandedItemsArray.filter((el)=>!defaultState.includes(el)).concat(item));
    };
    const resetExpansion = ()=>{
        onChange(defaultState);
    };
    return {
        onExpand,
        isExpanded,
        resetExpansion
    };
}

// EXTERNAL MODULE: ./node_modules/lodash-es/upperFirst.js + 1 modules
var upperFirst = __webpack_require__(85295);
// EXTERNAL MODULE: ./node_modules/lodash-es/isEqual.js
var isEqual = __webpack_require__(50576);
;// CONCATENATED MODULE: ./src/libs/hooks/useStateWithSetters.ts
function useStateWithSetters_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function useStateWithSetters_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            useStateWithSetters_define_property(target, key, source[key]);
        });
    }
    return target;
}
function useStateWithSetters_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function useStateWithSetters_object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        useStateWithSetters_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}


// Extends state with setters for each field and reset method
function useStateWithSetters({ state , setState , defaultState  }) {
    const latestState = (0,react.useRef)(state);
    latestState.current = state;
    return (0,react.useMemo)(()=>{
        const stateWithSetters = {
            resetAll: ()=>{
                setState(defaultState);
            }
        };
        for (const field of Object.keys(defaultState)){
            stateWithSetters[field] = latestState.current[field];
            stateWithSetters[`set${(0,upperFirst/* default */.Z)(field)}`] = (value)=>{
                var _latestState_current;
                if ((0,isEqual/* default */.Z)((_latestState_current = latestState.current) === null || _latestState_current === void 0 ? void 0 : _latestState_current[field], value)) {
                    return;
                }
                latestState.current = useStateWithSetters_object_spread_props(useStateWithSetters_object_spread({}, latestState.current), {
                    [field]: value
                });
                setState(latestState.current);
            };
            stateWithSetters[`reset${(0,upperFirst/* default */.Z)(field)}`] = ()=>{
                latestState.current = useStateWithSetters_object_spread_props(useStateWithSetters_object_spread({}, latestState.current), {
                    [field]: defaultState[field]
                });
                setState(latestState.current);
            };
        }
        return stateWithSetters;
    }, [
        latestState.current
    ]);
}

// EXTERNAL MODULE: ./node_modules/react-use/esm/usePrevious.js
var esm_usePrevious = __webpack_require__(37176);
;// CONCATENATED MODULE: ./src/libs/hooks/useBrowserStorageState.ts



function useBrowserStorageState({ key , storage =sessionStorage , getStateToStore =(hookResult)=>Array.isArray(hookResult) ? hookResult[0] : hookResult , useStateHook , defaultState  }) {
    const initialState = (0,react.useMemo)(()=>getStateFromStorage(storage, key), []);
    const hookResult = useStateHook(initialState !== null ? initialState : defaultState || null);
    const stateToStore = (0,react.useMemo)(()=>getStateToStore(hookResult), [
        hookResult
    ]);
    const previousStateToStore = (0,esm_usePrevious/* default */.Z)(stateToStore);
    (0,react.useEffect)(()=>{
        if (!(0,isEqual/* default */.Z)(previousStateToStore, stateToStore)) {
            setStateToStorage(storage, key, stateToStore);
        }
    }, [
        stateToStore
    ]);
    return hookResult;
}
function getStateFromStorage(storage, key) {
    const stateString = storage.getItem(key);
    try {
        return stateString ? JSON.parse(stateString) : null;
    } catch (err) {
        console.error(`Failed to load state from storage, key:${key}`);
        return null;
    }
}
function setStateToStorage(storage, key, state) {
    storage.setItem(key, JSON.stringify(state));
}

// EXTERNAL MODULE: ./node_modules/lodash-es/throttle.js
var throttle = __webpack_require__(111);
;// CONCATENATED MODULE: ./src/libs/hooks/useHasScrollbar.ts


function useHasScrollbar(el, throttleTime = 1) {
    const [state, setState] = (0,react.useState)({
        horizontal: false,
        vertical: false
    });
    (0,react.useEffect)(()=>{
        if (!el) {
            return;
        }
        setState({
            horizontal: el.scrollWidth > el.clientWidth,
            vertical: el.scrollHeight > el.clientHeight
        });
        const handleResize = (0,throttle/* default */.Z)(()=>{
            setState({
                horizontal: el.scrollWidth > el.clientWidth,
                vertical: el.scrollHeight > el.clientHeight
            });
        }, throttleTime);
        let resizeObserver = new ResizeObserver(()=>handleResize());
        resizeObserver.observe(el);
        return ()=>{
            handleResize === null || handleResize === void 0 ? void 0 : handleResize.cancel();
            resizeObserver === null || resizeObserver === void 0 ? void 0 : resizeObserver.disconnect();
            resizeObserver = null;
        };
    }, [
        el
    ]);
    return state;
}

;// CONCATENATED MODULE: ./src/libs/hooks/useStorageWithExpiration.ts
function useStorageWithExpiration(key, defaultValue, ttl) {
    const get = ()=>{
        const item = localStorage.getItem(key);
        if (!item) {
            return defaultValue;
        }
        try {
            const entry = JSON.parse(item);
            if (Date.now() > entry.timestamp + ttl) {
                throw new Error("item expired");
            }
            return entry.value;
        } catch (e) {
            remove();
        }
        return defaultValue;
    };
    const set = (value)=>{
        const entry = {
            value,
            timestamp: Date.now()
        };
        localStorage.setItem(key, JSON.stringify(entry));
    };
    const remove = ()=>{
        localStorage.removeItem(key);
    };
    return [
        get,
        set,
        remove
    ];
}

;// CONCATENATED MODULE: ./src/libs/hooks/index.ts
























/***/ }),

/***/ 30550:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "o": () => (/* binding */ useActions)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);

function makeReducer(methods) {
    return (state, action)=>{
        const actions = methods(state);
        if (actions[action.type]) {
            return actions[action.type](action.payload);
        }
        throw new Error("unknown action");
    };
}
/**
 * Example
 * const counterActions = (state: number)=>({
 *  increment(n:number) {
 *     return state+=1;
 *  },
 *  decrement(n:number) {
 *     return state-=1;
 *  }
 * })
 *
 * // in component
 * const [state, action] = useActions(counterActions, 0)
 */ function useActions(methods, initialState, initialize) {
    const reducer = (0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(()=>makeReducer(methods), [
        methods
    ]);
    const actionTypes = (0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(()=>Object.keys(methods(null)), [
        methods
    ]);
    const [state, dispatch] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useReducer)(reducer, initialState, initialize);
    const actions = (0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(()=>actionTypes.reduce((acc, el)=>{
            acc[el] = (payload)=>dispatch({
                    type: el,
                    payload
                });
            return acc;
        }, {}), actionTypes);
    return [
        state,
        actions
    ];
}


/***/ }),

/***/ 94043:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "IT": () => (/* binding */ useAsyncSimple2),
/* harmony export */   "UK": () => (/* binding */ useAsyncCallback)
/* harmony export */ });
/* unused harmony exports useAsyncSimple, useQuery */
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}

/**
 * @deprecated use react query instead
 */ function useAsyncSimple(fn, initialState = {
    loading: true
}) {
    return useAsyncSimple2(fn, initialState).state;
}
/**
 * @deprecated use react query instead
 */ function useQuery(fn, initialState = {
    loading: true
}) {
    const res = useAsyncSimple2(fn, initialState);
    return [
        res.state,
        res.set
    ];
}
/**
 * @deprecated use react query instead
 */ function useAsyncSimple2(fn, initialState = {
    loading: true
}) {
    const [state, set] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(initialState);
    const [refetchCounter, setRefetchCounter] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(0);
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(()=>{
        let setState = set;
        let call = (fn)=>fn();
        setState((state)=>{
            return _object_spread_props(_object_spread({}, state), {
                loading: true
            });
        });
        Promise.resolve().then(()=>call(fn)).then((value)=>{
            setState({
                value,
                loading: false
            });
            return value;
        }, (error)=>{
            setState({
                error,
                loading: false
            });
            return error;
        });
        return ()=>{
            setState = ()=>null;
            call = ()=>Promise.resolve();
        };
    }, [
        fn,
        refetchCounter
    ]);
    return {
        state,
        set,
        refetch: ()=>setRefetchCounter((s)=>s + 1)
    };
}
/**
 * @deprecated use react query instead
 */ function useAsyncCallback(fn, cb, errorCb) {
    const [req, setReq] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(undefined);
    const reqestFn = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(()=>{
        if (req === undefined) {
            return Promise.resolve(null);
        }
        return req();
    }, [
        req
    ]);
    const data = useAsyncSimple(reqestFn);
    const cbRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(null);
    cbRef.current = cb;
    const errorCbRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(null);
    errorCbRef.current = errorCb;
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(()=>{
        if (data.value && !data.error && !data.loading) {
            cbRef.current && cbRef.current(data.value);
        } else if (data.error && !data.loading) {
            errorCbRef.current && errorCbRef.current(data.error);
        }
    }, [
        data.value,
        data.error,
        data.loading
    ]);
    const call = (...data)=>setReq(()=>()=>fn(...data));
    return [
        call,
        _object_spread_props(_object_spread({}, data), {
            loading: req ? data.loading : false
        })
    ];
}


/***/ }),

/***/ 12541:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "P": () => (/* binding */ useMemoize)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);

/**
 *
 * @param fn computable function
 * @param args arguments which it requires
 */ function useMemoize(fn, args) {
    return (0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(()=>fn.apply(null, args), args);
}


/***/ }),

/***/ 50882:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Sv": () => (/* binding */ usePopover),
/* harmony export */   "dd": () => (/* binding */ useModal),
/* harmony export */   "j6": () => (/* binding */ usePopoverDisclosure),
/* harmony export */   "qY": () => (/* binding */ useDisclosure)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}

function useModal(render, disableBackdropClick) {
    const [state, setState] = react__WEBPACK_IMPORTED_MODULE_0__.useState({
        open: false,
        extraProps: {}
    });
    const onOpen = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)((extraProps = {})=>setState({
            open: true,
            extraProps
        }), []);
    const onClose = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)((_, reason)=>{
        if (!disableBackdropClick || reason !== "backdropClick") {
            setState({
                open: false,
                extraProps: {}
            });
        }
    }, []);
    return [
        render(_object_spread({
            onClose
        }, state)),
        {
            open: state.open,
            handleClose: onClose,
            handleOpen: onOpen
        }
    ];
}
function usePopover(fn) {
    const [anchorEl, setAnchorEl] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(null);
    function handleOpen($el) {
        setAnchorEl($el);
    }
    function handleClose() {
        setAnchorEl(null);
    }
    const api = {
        onClose: handleClose,
        open: !!anchorEl,
        anchorEl
    };
    return [
        fn(api),
        _object_spread_props(_object_spread({}, api), {
            onOpen: handleOpen
        })
    ];
}
function usePopoverDisclosure() {
    const [anchorEl, setAnchorEl] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(null);
    const onOpen = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(($el)=>setAnchorEl($el), []);
    const onClose = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(()=>setAnchorEl(null), []);
    return {
        onClose,
        open: !!anchorEl,
        anchorEl,
        onOpen
    };
}
function useDisclosure() {
    const [isOpen, setAnchorEl] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(null);
    const onOpen = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(($el)=>setAnchorEl($el), []);
    const onClose = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(()=>setAnchorEl(null), []);
    return {
        onClose,
        open: !!isOpen,
        onOpen
    };
}


/***/ }),

/***/ 93689:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "D": () => (/* binding */ useOnChange2)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);

// this one doesn't fire onChange on initial render
const useOnChange2 = (v, cb)=>{
    const ref = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(v);
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(()=>{
        if (ref.current !== v) {
            ref.current = v;
            cb();
        }
    });
};


/***/ }),

/***/ 12635:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "P": () => (/* binding */ createHistoryHook),
/* harmony export */   "W": () => (/* binding */ useQueryParam)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var memoize_one__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(30845);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(28216);
/* harmony import */ var react_router_dom__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(79655);
/* harmony import */ var react_router_dom__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(89250);
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}




function useQueryParam(name, initialValue, keepInHistory = true) {
    const [search, setSearch] = (0,react_router_dom__WEBPACK_IMPORTED_MODULE_2__/* .useSearchParams */ .lr)();
    const memoParse = (0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(()=>{
        return (0,memoize_one__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(JSON.parse);
    }, []);
    const paramValue = (0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(()=>{
        const values = search;
        return (values === null || values === void 0 ? void 0 : values.has(name)) ? memoParse(values.get(name)) : initialValue;
    }, [
        search,
        name
    ]);
    const setValue = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)((value)=>{
        setSearch((prevSearchObject)=>{
            const searchObject = new URLSearchParams(prevSearchObject);
            if (value === null) {
                searchObject.delete(name);
            } else {
                searchObject.set(name, JSON.stringify(value));
            }
            return searchObject;
        }, {
            replace: !keepInHistory,
            state: getHistoryState()
        });
    }, [
        name,
        setSearch,
        keepInHistory
    ]);
    return [
        paramValue,
        setValue
    ];
}
const getUrlState = ()=>new URLSearchParams(window.location.search);
// React router contains current state inside "usr" property
const getHistoryState = ()=>{
    var _window_history_state;
    return (_window_history_state = window.history.state) === null || _window_history_state === void 0 ? void 0 : _window_history_state.usr;
};
function createHistoryHook(hash) {
    return function useHistoryParam(name, defaultValue, keepInHistory = true) {
        var _location_state;
        const navigate = (0,react_router_dom__WEBPACK_IMPORTED_MODULE_4__/* .useNavigate */ .s0)();
        const location = (0,react_router_dom__WEBPACK_IMPORTED_MODULE_4__/* .useLocation */ .TH)();
        const locationRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(null);
        locationRef.current = location;
        var _location_state_name;
        const paramValue = (_location_state_name = (_location_state = location.state) === null || _location_state === void 0 ? void 0 : _location_state[name]) !== null && _location_state_name !== void 0 ? _location_state_name : defaultValue;
        // TODO: Amirov Set query hash string if we have state in history but no query param
        // be careful do not make this call async
        const setValue = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)((value, { openNewTab =false , newPath =undefined  } = {})=>{
            if ((0,react_redux__WEBPACK_IMPORTED_MODULE_1__/* .shallowEqual */ .wU)(value, paramValue)) {
                return;
            }
            const { pathname  } = locationRef.current;
            const newState = ()=>_object_spread_props(_object_spread({}, getHistoryState()), {
                    [name]: value
                });
            const hashStr = hash(JSON.stringify(newState()));
            const searchState = getUrlState();
            searchState.set("s", hashStr);
            const nextLocationObject = {
                state: newState(),
                replace: !keepInHistory
            };
            const url = (newPath || pathname) + "?" + searchState.toString();
            if (openNewTab) {
                window.open(url, "_blank");
            } else {
                navigate(url, nextLocationObject);
            }
        }, [
            name,
            keepInHistory,
            paramValue
        ]);
        return [
            paramValue,
            setValue
        ];
    };
}


/***/ }),

/***/ 93906:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "t": () => (/* binding */ useSize)
/* harmony export */ });
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(111);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _juggle_resize_observer__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(86254);



function getSize(el) {
    if (!el) {
        return {
            width: 0,
            height: 0,
            clientWidth: 0,
            clientHeight: 0
        };
    }
    return {
        width: el.offsetWidth,
        height: el.offsetHeight,
        clientWidth: el.clientWidth,
        clientHeight: el.clientHeight
    };
}
function useSize(ref, throttleTime = 1) {
    const [ComponentSize, setComponentSize] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(getSize(ref ? ref.current : {}));
    const handleResize = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(function handleResize() {
        if (ref.current) {
            setComponentSize(getSize(ref.current));
        }
    }, [
        ref
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useLayoutEffect)(()=>{
        if (!ref.current) {
            return;
        }
        handleResize();
        const resizer = (0,lodash__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(handleResize, throttleTime);
        let resizeObserver = new _juggle_resize_observer__WEBPACK_IMPORTED_MODULE_1__.ResizeObserver(()=>resizer());
        resizeObserver.observe(ref.current);
        return ()=>{
            resizer.cancel();
            resizeObserver === null || resizeObserver === void 0 ? void 0 : resizeObserver.disconnect();
            resizeObserver = null;
        };
    }, [
        ref.current
    ]);
    return ComponentSize;
}


/***/ }),

/***/ 5855:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Ug": () => (/* reexport */ HStack),
  "aV": () => (/* reexport */ Overlay),
  "LZ": () => (/* reexport */ Spacer),
  "Kq": () => (/* reexport */ Stack),
  "EC": () => (/* reexport */ StackInner),
  "Jv": () => (/* reexport */ VDivider),
  "G3": () => (/* reexport */ ZStack)
});

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/ui/css/index.ts
var css = __webpack_require__(93461);
// EXTERNAL MODULE: ./src/ui/atoms/Box.tsx
var Box = __webpack_require__(17299);
;// CONCATENATED MODULE: ./src/libs/layouts/Stack.tsx
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}



const VStackStyles = (0,css/* css */.iv)({
    "display": "flex",
    "flexDirection": "column",
    "& > *:only-child": {
        height: "100%"
    },
    "& > * + *": {
        marginTop: "calc(5px * var(--stack-space-ratio-element))"
    }
});
const VStackPaddingModeStyles = (0,css/* css */.iv)({
    "display": "grid",
    "gridAutoRows": "min-content",
    "& > *": {
        paddingTop: "calc(2.5px * var(--stack-space-ratio-element))",
        paddingBottom: "calc(2.5px * var(--stack-space-ratio-element))"
    },
    '*[data-nested="true"]': {
        paddingTop: "0",
        paddingBottom: "0"
    }
});
const HStackStyles = (0,css/* css */.iv)({
    "display": "flex",
    "flexDirection": "row",
    "& > *:only-child": {
        width: "100%"
    },
    "& > * + *": {
        marginLeft: "calc(5px * var(--stack-space-ratio-element))"
    }
});
const defaultElement = "div";
/**
 * The alignment property doesn’t
 * position the VStack inside its container;
 * instead, it positions the views inside the VStack.
    The alignment property of a VStack only applies to the horizontal alignment
    of the contained controls using HorizontalAlignment.
    Similarly, the alignment property for an HStack only controls the vertical alignment
    using align.
  @deprecated The component should not be used
 */ const Stack = /*#__PURE__*/ (0,react.forwardRef)(function Stack(_param, ref) {
    var { children , className , align , space =1 , style , fullWidth , sx  } = _param, props = _object_without_properties(_param, [
        "children",
        "className",
        "align",
        "space",
        "style",
        "fullWidth",
        "sx"
    ]);
    return /*#__PURE__*/ react.createElement(Box/* Box */.x, _object_spread({
        ref: ref,
        as: defaultElement,
        "data-component": "VStack",
        style: style,
        className: [
            VStackStyles().className,
            className
        ].join(" "),
        sx: _object_spread({}, stackStyles({
            space,
            alignItems: align,
            fullWidth
        }), sx)
    }, props), children);
});
const StackInner = /*#__PURE__*/ (0,react.forwardRef)(function Stack(_param, ref) {
    var { children , className , align , space =1 , style , nested =false  } = _param, props = _object_without_properties(_param, [
        "children",
        "className",
        "align",
        "space",
        "style",
        "nested"
    ]);
    return /*#__PURE__*/ react.createElement(Box/* Box */.x, _object_spread({
        ref: ref,
        as: defaultElement,
        "data-component": "VStackInner",
        "data-nested": nested,
        style: style,
        className: [
            VStackPaddingModeStyles().className,
            className
        ].join(" "),
        sx: stackStyles({
            space,
            alignItems: align
        })
    }, props), children);
});
/**
 * @deprecated The component should not be used
 */ const HStack = /*#__PURE__*/ (0,react.forwardRef)(function HStack(_param, ref) {
    var { children , className , align , space =1 , style , fullWidth  } = _param, props = _object_without_properties(_param, [
        "children",
        "className",
        "align",
        "space",
        "style",
        "fullWidth"
    ]);
    return /*#__PURE__*/ react.createElement(Box/* Box */.x, _object_spread({
        ref: ref,
        as: defaultElement,
        "data-component": "HStack",
        style: style,
        className: [
            HStackStyles().className,
            className
        ].join(" "),
        sx: stackStyles({
            space,
            alignItems: align,
            fullWidth
        })
    }, props), children);
});
function stackStyles({ space , alignItems , fullWidth =false  }) {
    const spaceValue = space === "inherit" ? "var(--stack-space-ratio-element)" : space;
    let restStyles = {};
    if (fullWidth) {
        restStyles = {
            width: "100%"
        };
    }
    return _object_spread_props(_object_spread({}, restStyles), {
        alignItems,
        "--stack-space-ratio": spaceValue,
        ">*": {
            "--stack-space-ratio-element": space === "inherit" ? "var(--stack-space-ratio)" : space
        }
    });
}
function Spacer() {
    return /*#__PURE__*/ react.createElement("div", {
        style: {
            marginRight: "auto",
            marginBottom: "auto"
        }
    });
}
HStack.Spacer = Spacer;
Stack.Spacer = Spacer;
const overlayStyles = (0,css/* css */.iv)({
    position: "absolute",
    top: "0",
    left: "0",
    right: "0",
    bottom: "0",
    background: "white"
});
function Overlay(_param) {
    var { className  } = _param, props = _object_without_properties(_param, [
        "className"
    ]);
    return /*#__PURE__*/ react.createElement("div", _object_spread_props(_object_spread({}, props), {
        className: overlayStyles({
            className
        }).className
    }));
}
function VDivider(props) {
    return /*#__PURE__*/ react.createElement(Box/* Box */.x, _object_spread_props(_object_spread({
        as: defaultElement
    }, props), {
        style: _object_spread_props(_object_spread({}, props.style), {
            marginLeft: `calc(-${props.space} * var(--space))`,
            marginRight: `calc(-${props.space} * var(--space))`
        })
    }));
}

;// CONCATENATED MODULE: ./src/libs/layouts/ZStack.tsx
function ZStack_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function ZStack_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            ZStack_define_property(target, key, source[key]);
        });
    }
    return target;
}
function ZStack_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function ZStack_object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ZStack_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function ZStack_object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = ZStack_object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function ZStack_object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}


const ZStackStyles = (0,css/* css */.iv)({
    "display": "grid",
    "justifyItems": "center",
    "placeItems": "center",
    "width": "fit-content",
    "> *": {
        gridArea: "1/1/1/1",
        zIndex: 1
    }
});
const ZStack = /*#__PURE__*/ (0,react.forwardRef)(function ZStack(_param, ref) {
    var { as: Comp = "div" , className , alignX , alignY , fullWidth , style  } = _param, props = ZStack_object_without_properties(_param, [
        "as",
        "className",
        "alignX",
        "alignY",
        "fullWidth",
        "style"
    ]);
    return /*#__PURE__*/ react.createElement(Comp, ZStack_object_spread({
        ref: ref,
        "data-component": "ZStack",
        style: ZStack_object_spread_props(ZStack_object_spread({}, style), {
            width: fullWidth ? "100%" : undefined,
            alignItems: alignY,
            justifyItems: alignX
        }),
        className: [
            ZStackStyles,
            className
        ].join(" ")
    }, props));
});

;// CONCATENATED MODULE: ./src/libs/layouts/index.tsx




/***/ }),

/***/ 87063:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "H": () => (/* reexport */ asyncAct),
  "_": () => (/* reexport */ effectsFetching)
});

// EXTERNAL MODULE: ./node_modules/okdux/dist/lib/index.js + 6 modules
var lib = __webpack_require__(56804);
;// CONCATENATED MODULE: ./src/libs/restatex/asyncAction.ts

/**@deprecated */ function asyncAct() {
    return (name)=>{
        let thunk;
        const actions = {
            request: (0,lib/* createAction */.PH)(name + "_REQUEST"),
            success: (0,lib/* createAction */.PH)(name + "_SUCCESS"),
            failure: (0,lib/* createAction */.PH)(name + "_FAILURE"),
            cancel: (0,lib/* createAction */.PH)(name + "_CANCEL"),
            use: (t)=>{
                thunk = t && t(actions);
            }
        };
        const call = (...args)=>{
            const dispatch = actions.request.getDispatch();
            if (thunk && dispatch) {
                return dispatch(thunk(...args));
            } else {
                throw new Error(`called a not implemented action ${name}`);
            }
        };
        return Object.assign(call, actions);
    };
}

;// CONCATENATED MODULE: ./src/libs/restatex/reduxUtils.ts
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}

function effectsFetching(actionsMap) {
    const reducerBuilder = (0,lib/* createState */.eK)({});
    Object.keys(actionsMap).forEach((el)=>{
        const { success , request , failure , cancel  } = actionsMap[el];
        const successType = success.getType();
        const errorType = failure.getType();
        const requestType = request.getType();
        success && reducerBuilder.on(success, (state)=>_object_spread_props(_object_spread({}, state), {
                [errorType]: null,
                [requestType]: false,
                [successType]: true
            }));
        request && reducerBuilder.on(request, (state, payload)=>_object_spread_props(_object_spread({}, state), {
                [errorType]: null,
                [requestType]: payload || true,
                [successType]: false
            }));
        failure && reducerBuilder.on(failure, (state, payload)=>_object_spread_props(_object_spread({}, state), {
                [errorType]: payload,
                [requestType]: false,
                [successType]: false
            }));
        cancel && reducerBuilder.on(cancel, (state)=>_object_spread_props(_object_spread({}, state), {
                [errorType]: false,
                [requestType]: false,
                [successType]: false
            }));
    }, {});
    return reducerBuilder;
}

;// CONCATENATED MODULE: ./src/libs/restatex/index.ts




/***/ }),

/***/ 75044:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "S7": () => (/* binding */ DATE_FORMAT_WITH_TIME),
/* harmony export */   "bI": () => (/* binding */ isSameUTCDay),
/* harmony export */   "g$": () => (/* binding */ formatUTC),
/* harmony export */   "p6": () => (/* binding */ formatDate),
/* harmony export */   "tg": () => (/* binding */ toMils),
/* harmony export */   "xn": () => (/* binding */ toUTC)
/* harmony export */ });
/* unused harmony exports revertToUTC, toInteger, endOfUTCToday, startOfUTCToday, addUTCDays, subDays, isToday, addUTCMilliseconds, addUTCMinutes, subUTCMinutes, startOfUTCDay, endOfUTCDay, startOfUTCMonth, startOfUTCYear, startOfUTCWeek */
/* harmony import */ var date_fns_format__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(46630);

const MILLISECONDS_IN_MINUTE = 60000;
const DATE_FORMAT_WITH_TIME = "yyyy-MM-dd, HH:mm";
function toUTC(date) {
    if (!date) {
        return date;
    }
    const offset = date.getTimezoneOffset();
    return addUTCMinutes(new Date(date), offset);
}
function revertToUTC(date) {
    if (!date) {
        return date;
    }
    const offset = date.getTimezoneOffset();
    return addUTCMinutes(new Date(date), -offset);
}
function formatUTC(date, specifier = DATE_FORMAT_WITH_TIME) {
    return (0,date_fns_format__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(toUTC(date), specifier);
}
const formatDate = date_fns_format__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z;
function isSameUTCDay(dirtyDateLeft, dirtyDateRight) {
    const dateLeftStartOfDay = startOfUTCDay(dirtyDateLeft);
    const dateRightStartOfDay = startOfUTCDay(dirtyDateRight);
    return dateLeftStartOfDay.getTime() === dateRightStartOfDay.getTime();
}
function toInteger(number) {
    if (isNaN(number)) {
        return number;
    }
    return number < 0 ? Math.ceil(number) : Math.floor(number);
}
function endOfUTCToday() {
    return endOfUTCDay(new Date());
}
function startOfUTCToday() {
    return startOfUTCDay(new Date());
}
function addUTCDays(dirtyDate, dirtyAmount) {
    const date = new Date(dirtyDate);
    const amount = toInteger(dirtyAmount);
    date.setUTCDate(date.getUTCDate() + amount);
    return date;
}
function subDays(dirtyDate, dirtyAmount) {
    return addUTCDays(dirtyDate, -dirtyAmount);
}
function isToday(dirtyDate) {
    return isSameUTCDay(dirtyDate, new Date());
}
function addUTCMilliseconds(dirtyDate, dirtyAmount) {
    var timestamp = new Date(dirtyDate).getTime();
    var amount = toInteger(dirtyAmount);
    return new Date(timestamp + amount);
}
function addUTCMinutes(dirtyDate, dirtyAmount) {
    const amount = toInteger(dirtyAmount);
    return addUTCMilliseconds(dirtyDate, amount * MILLISECONDS_IN_MINUTE);
}
function subUTCMinutes(dirtyDate, dirtyAmount) {
    return addUTCMinutes(dirtyDate, -dirtyAmount);
}
function startOfUTCDay(oldDate) {
    const date = new Date(oldDate);
    date.setUTCHours(0, 0, 0, 0);
    return date;
}
function endOfUTCDay(oldDate) {
    const date = new Date(oldDate);
    date.setUTCHours(23, 59, 59, 999);
    return date;
}
function startOfUTCMonth(oldDate) {
    const date = new Date(oldDate);
    date.setUTCDate(1);
    date.setUTCHours(0, 0, 0, 0);
    return date;
}
function startOfUTCYear(dirtyDate) {
    var cleanDate = new Date(dirtyDate);
    var date = new Date(0);
    date.setUTCFullYear(cleanDate.getUTCFullYear(), 0, 1);
    date.setUTCHours(0, 0, 0, 0);
    return date;
}
function startOfUTCWeek(dirtyDate, options = {}) {
    var weekStartsOn = options.weekStartsOn || 0;
    // Test if weekStartsOn is between 0 and 6 _and_ is not NaN
    if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) {
        throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");
    }
    var date = new Date(dirtyDate);
    var day = date.getUTCDay();
    var diff = (day < weekStartsOn ? 7 : 0) + day - weekStartsOn;
    date.setUTCDate(date.getUTCDate() - diff);
    date.setUTCHours(0, 0, 0, 0);
    return date;
}
// converts seconds to milliseconds
function toMils(t) {
    return t * 1000;
}


/***/ }),

/***/ 69113:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "rJ": () => (/* reexport */ convertTime),
  "zp": () => (/* reexport */ endOfDate),
  "WU": () => (/* reexport */ format),
  "K$": () => (/* reexport */ fromSecondsToTimeData),
  "gL": () => (/* reexport */ fromTimeDataToSeconds),
  "os": () => (/* reexport */ getOffset),
  "T1": () => (/* reexport */ startOfDate),
  "HR": () => (/* reexport */ timeRanges),
  "ZU": () => (/* reexport */ toDate)
});

// UNUSED EXPORTS: DATE_FORMAT_ISO, add, sub, toInteger

// EXTERNAL MODULE: ./node_modules/date-fns/esm/subDays/index.js
var subDays = __webpack_require__(7069);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/subMonths/index.js + 1 modules
var subMonths = __webpack_require__(65942);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/format/index.js + 17 modules
var esm_format = __webpack_require__(46630);
// EXTERNAL MODULE: ./src/shared/index.ts
var shared = __webpack_require__(10451);
;// CONCATENATED MODULE: ./src/libs/time/time.ts






const START_TIME = "T00:00:00Z";
const END_TIME = "T23:59:59Z";
const DATE_FORMAT_ISO = "yyyy-MM-dd'T'HH:mm:ss.'000Z'";
const format = (date, format, options)=>{
    if (!date) {
        return null;
    }
    if (typeof date === "string") {
        const dateFromString = new Date(date);
        if (!Number(dateFromString)) {
            return null;
        }
        return (0,esm_format/* default */.Z)(dateFromString, format, options);
    }
    return (0,esm_format/* default */.Z)(date, format, options);
};
function toInteger(dirtyNumber) {
    if (dirtyNumber === null || dirtyNumber === true || dirtyNumber === false) {
        return NaN;
    }
    const number = Number(dirtyNumber);
    if (isNaN(number)) {
        return number;
    }
    return number < 0 ? Math.ceil(number) : Math.floor(number);
}
/**
 * @name add
 * @category Common Helpers
 * @summary Add the specified years, months, weeks, days, hours, minutes and seconds to the given date.
 *
 * @description
 * Add the specified years, months, weeks, days, hours, minutes and seconds to the given date.
 *
 * @param {Date|Number} dirtyDate - the date to be changed
 * @param {Duration} duration - the object with years, months, weeks, days, hours, minutes and seconds to be added. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
 *
 * | Key            | Description                        |
 * |----------------|------------------------------------|
 * | years          | Amount of years to be added        |
 * | months         | Amount of months to be added       |
 * | weeks          | Amount of weeks to be added       |
 * | days           | Amount of days to be added         |
 * | hours          | Amount of hours to be added        |
 * | minutes        | Amount of minutes to be added      |
 * | seconds        | Amount of seconds to be added      |
 *
 * All values default to 0
 *
 * @returns {Date} the new date with the seconds added
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Add the following duration to 1 September 2014, 10:19:50
 * const result = add(new Date(2014, 8, 1, 10, 19, 50), {
 *   years: 2,
 *   months: 9,
 *   weeks: 1,
 *   days: 7,
 *   hours: 5,
 *   minutes: 9,
 *   seconds: 30,
 * })
 * //=> Thu Jun 15 2017 15:29:20
 */ function add(dirtyDate, duration) {
    if (!duration || typeof duration !== "object") {
        return new Date(NaN);
    }
    const years = "years" in duration ? toInteger(duration.years) : 0;
    const months = "months" in duration ? toInteger(duration.months) : 0;
    const weeks = "weeks" in duration ? toInteger(duration.weeks) : 0;
    const days = "days" in duration ? toInteger(duration.days) : 0;
    const hours = "hours" in duration ? toInteger(duration.hours) : 0;
    const minutes = "minutes" in duration ? toInteger(duration.minutes) : 0;
    const seconds = "seconds" in duration ? toInteger(duration.seconds) : 0;
    // Add years and months
    const date = new Date(dirtyDate);
    const dateWithMonths = months || years ? addMonths(date, months + years * 12) : date;
    // Add weeks and days
    const dateWithDays = days || weeks ? addDays(dateWithMonths, days + weeks * 7) : dateWithMonths;
    // Add days, hours, minutes and seconds
    const minutesToAdd = minutes + hours * 60;
    const secondsToAdd = seconds + minutesToAdd * 60;
    const msToAdd = secondsToAdd * 1000;
    const finalDate = new Date(dateWithDays.getTime() + msToAdd);
    return finalDate;
}
function sub(dirtyDate, duration) {
    if (!duration || typeof duration !== "object") {
        return new Date(NaN);
    }
    const years = "years" in duration ? toInteger(duration.years) : 0;
    const months = "months" in duration ? toInteger(duration.months) : 0;
    const weeks = "weeks" in duration ? toInteger(duration.weeks) : 0;
    const days = "days" in duration ? toInteger(duration.days) : 0;
    const hours = "hours" in duration ? toInteger(duration.hours) : 0;
    const minutes = "minutes" in duration ? toInteger(duration.minutes) : 0;
    const seconds = "seconds" in duration ? toInteger(duration.seconds) : 0;
    // Subtract years and months
    const dateWithoutMonths = (0,subMonths/* default */.Z)(new Date(dirtyDate), months + years * 12);
    // Subtract weeks and days
    const dateWithoutDays = (0,subDays/* default */.Z)(dateWithoutMonths, days + weeks * 7);
    // Subtract hours, minutes and seconds
    const minutestoSub = minutes + hours * 60;
    const secondstoSub = seconds + minutestoSub * 60;
    const mstoSub = secondstoSub * 1000;
    const finalDate = new Date(dateWithoutDays.getTime() - mstoSub);
    return finalDate;
}
const getOffset = (timeZone = "UTC", date = new Date())=>{
    const utcDate = new Date(date.toLocaleString("en-US", {
        timeZone: "UTC"
    }));
    const tzDate = new Date(date.toLocaleString("en-US", {
        timeZone
    }));
    return (tzDate.getTime() - utcDate.getTime()) / 6e4;
};
function convertRelativeTime(relative, timezone) {
    const now = new Date();
    let endDate = timezone ? new Date(now.toLocaleString("en-US", {
        timeZone: timezone
    })) : now;
    if (relative.offset) {
        endDate = sub(endDate, relative.offset);
    }
    const startDate = sub(endDate, relative.duration);
    return {
        start_time: startOfDate(format(startDate, shared/* DATE_FORMAT */.zT)),
        end_time: endOfDate(format(endDate, shared/* DATE_FORMAT */.zT))
    };
}
function convertTime(dateFilters, timezone) {
    if (dateFilters.relative) {
        return convertRelativeTime(dateFilters.relative, timezone);
    }
    return {
        start_time: dateFilters.start_time,
        end_time: dateFilters.end_time
    };
}
function toDate(date) {
    if (!date) {
        return null;
    }
    return date.split("T")[0];
}
// We need this method for backward compatibility
function startOfDate(t) {
    if ((t || "").includes("T")) {
        return t;
    }
    return addTimePrefix(t, START_TIME);
}
// We need this method for backward compatibility
function endOfDate(t) {
    if ((t || "").includes("T")) {
        return t;
    }
    return addTimePrefix(t, END_TIME);
}
function addTimePrefix(t, prefix) {
    if (!t) {
        return t;
    }
    if (t && t.indexOf(prefix) !== -1) {
        return t;
    }
    return String(t) + prefix;
}

;// CONCATENATED MODULE: ./src/libs/time/timeRangeConvertor.ts
const MINUTE_SECONDS = 60;
const HOUR_SECONDS = MINUTE_SECONDS * 60;
const DAY_SECONDS = HOUR_SECONDS * 24;
const timeRanges = {
    second: {
        range: "second",
        value: 1
    },
    minute: {
        range: "minute",
        value: MINUTE_SECONDS
    },
    hour: {
        range: "hour",
        value: HOUR_SECONDS
    },
    day: {
        range: "day",
        value: DAY_SECONDS
    },
    week: {
        range: "week",
        value: DAY_SECONDS * 7
    },
    month: {
        range: "month",
        value: DAY_SECONDS * 30
    },
    year: {
        range: "year",
        value: DAY_SECONDS * 365
    }
};
function fromSecondsToTimeData(seconds, options = {}) {
    const { min ="minute" , max ="year" , precision =0  } = options;
    const k = Math.pow(10, precision);
    const toTimeData = (range)=>({
            range: range.range,
            value: Math.floor(seconds / range.value * k) / k
        });
    const availableRanges = [
        "second",
        "minute",
        "hour",
        "day",
        "week",
        "month",
        "year"
    ];
    const ranges = availableRanges.slice(availableRanges.indexOf(min), availableRanges.indexOf(max) + 1).reverse();
    for (const range of ranges){
        if (seconds >= timeRanges[range].value) {
            return toTimeData(timeRanges[range]);
        }
    }
    return toTimeData(timeRanges[min]);
}
function fromTimeDataToSeconds(time) {
    const timeRange = timeRanges[time.range];
    return time.value * timeRange.value;
}

;// CONCATENATED MODULE: ./src/libs/time/index.ts




/***/ }),

/***/ 81287:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "m": () => (/* binding */ TimezoneRegions)
/* harmony export */ });
var TimezoneRegions;
(function(TimezoneRegions) {
    TimezoneRegions["America"] = "America";
    TimezoneRegions["Africa"] = "Africa";
    TimezoneRegions["Europe"] = "Europe";
    TimezoneRegions["Asia"] = "Asia";
    TimezoneRegions["Australia"] = "Australia";
    TimezoneRegions["Other"] = "Other";
    TimezoneRegions["LocalTime"] = "LocalTime";
})(TimezoneRegions || (TimezoneRegions = {}));


/***/ }),

/***/ 4840:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "eN": () => (/* binding */ TIMEZONE_NAME_OFFSET_LENGTH),
  "qI": () => (/* binding */ addLocalTZOffset),
  "MV": () => (/* binding */ findTimezone),
  "oE": () => (/* binding */ formatDateTimeZoned),
  "w9": () => (/* binding */ getCurrentRegion),
  "vd": () => (/* binding */ getCurrentTimezone),
  "Qr": () => (/* binding */ getCurrentTimezoneOffset),
  "gI": () => (/* binding */ getLocalTimeTimezones),
  "i2": () => (/* binding */ getTimezonesCities),
  "Y7": () => (/* binding */ groupTimezonesByUtcAndFilterBySearch),
  "YN": () => (/* binding */ isSameDayUTC),
  "BA": () => (/* binding */ isTimezoneGroupActive),
  "ht": () => (/* binding */ removeLocalTZOffset),
  "Fh": () => (/* binding */ removeTimezoneOffset),
  "dH": () => (/* binding */ shiftDateByTimezoneOffset),
  "fN": () => (/* binding */ shiftHoursByTimezoneOffset)
});

// UNUSED EXPORTS: convertTimeFilterToZonedApiFormat, getTimezoneRegionFromCode, mapUtcToZonedTime

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/lodash-es/groupBy.js
var groupBy = __webpack_require__(15643);
// EXTERNAL MODULE: ./node_modules/lodash-es/keyBy.js
var keyBy = __webpack_require__(69884);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/addMinutes/index.js
var esm_addMinutes = __webpack_require__(58545);
// EXTERNAL MODULE: ./src/shared/index.ts
var shared = __webpack_require__(10451);
// EXTERNAL MODULE: ./src/libs/time-utc/index.ts
var time_utc = __webpack_require__(75044);
// EXTERNAL MODULE: ./src/libs/time/index.ts + 2 modules
var time = __webpack_require__(69113);
;// CONCATENATED MODULE: ./src/libs/utils/removeDiacriticsInString.ts
function removeDiacriticsInString(str) {
    return (str || "").normalize("NFD").replace(/[\u0300-\u036f]/g, "");
}

// EXTERNAL MODULE: ./src/libs/timezone/timezoneTypes.ts
var timezoneTypes = __webpack_require__(81287);
// EXTERNAL MODULE: ./src/libs/timezone/timezonesList.ts + 1 modules
var timezonesList = __webpack_require__(29177);
;// CONCATENATED MODULE: ./src/libs/timezone/timezoneUtils.tsx










const MINUTES_IN_HOUR = 60;
// example +10:30, -2:50, 5:00
const HOURS_MINUTES_REGEX = /[-+]?(\d+):?(\d+)?/;
const timezonesMap = (0,keyBy/* default */.Z)(timezonesList/* timezonesList */.F, "tzCode");
const getTimezoneOffsetMinutes = (timezone, date)=>{
    let sumInMinutes;
    try {
        sumInMinutes = (0,time/* getOffset */.os)(timezone, date);
    } catch (e) {
        const { utc  } = timezonesMap[timezone];
        const sign = utc[0];
        const [hours, minutes] = utc.slice(1).split(":");
        sumInMinutes = Number(hours) * MINUTES_IN_HOUR + Number(minutes);
        sumInMinutes = sign === "-" ? -sumInMinutes : sumInMinutes;
    }
    return sumInMinutes;
};
function getCurrentTimezoneOffset(date) {
    return (date ? new Date(date) : new Date()).getTimezoneOffset();
}
function removeLocalTZOffset(date) {
    return new Date(+new Date(date) - getCurrentTimezoneOffset(date) * 1000 * 60);
}
function addLocalTZOffset(date) {
    return new Date(+new Date(date) + getCurrentTimezoneOffset(date) * 1000 * 60);
}
function getCurrentTimezone() {
    const userTz = Intl.DateTimeFormat().resolvedOptions().timeZone;
    if (!findTimezone(userTz, timezonesList/* timezonesList */.F)) {
        // in case the user timezone is not in the list, return the default GMT+00:00, normally this should not happen
        return "Europe/Dublin";
    }
    return userTz;
}
function mapUtcToZonedTime(date, timezone) {
    const utcDate = toUTC(new Date(date));
    return addMinutes(utcDate, -getTimezoneOffsetMinutes(timezone, utcDate));
}
function removeTimezoneOffset(date, timezone) {
    const utcDate = (0,time_utc/* toUTC */.xn)(new Date(date));
    return (0,esm_addMinutes/* default */.Z)(utcDate, getTimezoneOffsetMinutes(timezone, utcDate));
}
function shiftDateByTimezoneOffset(date, timezone, add = true) {
    const dateObject = new Date(date);
    const offsetInMinutes = getTimezoneOffsetMinutes(timezone, dateObject);
    return (0,esm_addMinutes/* default */.Z)(dateObject, add ? offsetInMinutes : -offsetInMinutes);
}
function shiftHoursByTimezoneOffset(date, hours, timezone, add = true) {
    const offsetInHours = getTimezoneOffsetMinutes(timezone, date) / 60;
    const newHours = hours + (add ? offsetInHours : -offsetInHours);
    if (newHours < 0 || newHours > 24) {
        return Math.abs(Math.abs(newHours) - 24);
    }
    return newHours;
}
function formatDateTimeZoned(date, timezone, dateFormat = shared/* DATE_FORMAT_WITH_TIME */.S7) {
    if (!date) {
        return null;
    }
    return (0,time/* format */.WU)(removeTimezoneOffset(date, timezone), dateFormat);
}
const convertTimeFilterToZonedApiFormat = (timeFilter, timezone)=>{
    const { start_time , end_time  } = convertTime(timeFilter, timezone);
    return {
        start_time: format(mapUtcToZonedTime(start_time, timezone), DATE_FORMAT_ISO),
        end_time: format(mapUtcToZonedTime(end_time, timezone), DATE_FORMAT_ISO)
    };
};
const getGroupedTimezonesForParticularRegion = (groupedTimezones, selectedRegion)=>{
    return Object.entries(groupedTimezones).reduce((acc, [utc, timezones])=>{
        const regionTimezones = timezones.filter(({ tzCode  })=>getTimezoneRegionFromCode(tzCode) === selectedRegion);
        if (regionTimezones.length) {
            acc[utc] = regionTimezones;
        }
        return acc;
    }, {});
};
function matchTimezone(tzName, search) {
    const name = removeDiacriticsInString(tzName.slice(12)).toLocaleLowerCase();
    const matchIndex = name.indexOf(removeDiacriticsInString(search.trim().toLowerCase()));
    return {
        match: matchIndex > -1,
        matchIndex
    };
}
function matchByTimezoneOffset(search, utc) {
    var _search_match;
    const utcSign = utc[0];
    const [utcHours, utcMinutes] = utc.slice(1).split(":");
    let searchMatch = (_search_match = search.match(HOURS_MINUTES_REGEX)) === null || _search_match === void 0 ? void 0 : _search_match[0];
    if (!searchMatch) {
        return false;
    }
    let searchSign = searchMatch[0];
    if (searchSign === "-" || searchSign === "+") {
        searchMatch = searchMatch.slice(1);
    } else {
        searchSign = "";
    }
    if (searchSign && searchSign !== utcSign) {
        return false;
    }
    const [searchHours, searchMinutes] = searchMatch.split(":");
    return (Number(utcHours) === Number(searchHours) || utcHours.startsWith(searchHours)) && utcMinutes.startsWith(searchMinutes || "0");
}
const getLocalTimeTimezones = (timezonesList, tzCode)=>{
    const timezone = findTimezone(tzCode, timezonesList);
    if (!timezone) {
        return {};
    }
    return {
        [timezone.utc]: timezonesList.filter((tz)=>{
            return tz.utc === timezone.utc && timezone.tzCode.split("/")[0] === tz.tzCode.split("/")[0];
        })
    };
};
const groupTimezonesByUtcAndFilterBySearch = (timezonesList, search, selectedRegion)=>{
    const trimmed = search.trim().toLocaleLowerCase();
    const grouped = (0,groupBy/* default */.Z)(timezonesList, "utc");
    if (!trimmed) {
        return selectedRegion ? getGroupedTimezonesForParticularRegion(grouped, selectedRegion) : grouped;
    }
    return Object.entries(grouped).reduce((acc, [utc, timezones])=>{
        const regionTimezones = selectedRegion ? timezones.filter(({ tzCode  })=>getTimezoneRegionFromCode(tzCode) === selectedRegion) : timezones;
        if (matchByTimezoneOffset(search, utc) && regionTimezones.length || regionTimezones.some((tz)=>matchTimezone(tz.name, trimmed).match)) {
            acc[utc] = regionTimezones;
        }
        return acc;
    }, {});
};
const TIMEZONE_NAME_OFFSET_LENGTH = 12;
const getTimezonesCities = (timezones, search)=>{
    return timezones.reduce((acc, tz, index)=>{
        const cityLabel = removeDiacriticsInString(tz.name.slice(TIMEZONE_NAME_OFFSET_LENGTH) + (index + 1 < timezones.length ? ", " : ""));
        if (search) {
            const { match , matchIndex  } = matchTimezone(tz.name, search);
            if (!match) {
                acc.push({
                    id: tz.tzCode,
                    content: cityLabel
                });
                return acc;
            }
            const searchTrimmed = search.trim().toLowerCase();
            acc.push({
                content: /*#__PURE__*/ react.createElement(react.Fragment, null, cityLabel.slice(0, matchIndex), /*#__PURE__*/ react.createElement("b", null, cityLabel.slice(matchIndex, matchIndex + searchTrimmed.length)), cityLabel.slice(matchIndex + searchTrimmed.length)),
                id: tz.tzCode
            });
        } else {
            acc.push({
                id: tz.tzCode,
                content: cityLabel
            });
        }
        return acc;
    }, []);
};
const findTimezone = (tzCode, timezones = timezonesList/* timezonesList */.F)=>timezones.find((tz)=>tz.tzCode === tzCode);
const getCurrentRegion = (tzCode, timezones, isLocalTimezone)=>{
    if (isLocalTimezone) {
        return timezoneTypes/* TimezoneRegions.LocalTime */.m.LocalTime;
    }
    const timezone = findTimezone(tzCode, timezones);
    return timezone ? getTimezoneRegionFromCode(timezone.tzCode) : timezoneTypes/* TimezoneRegions.Other */.m.Other;
};
const isTimezoneGroupActive = (timezones, currentTimezone)=>{
    return timezones.some((tz)=>tz.tzCode.toLocaleLowerCase().includes(currentTimezone.toLocaleLowerCase()));
};
const getTimezoneRegionFromCode = (tzCode)=>{
    const region = tzCode.split("/")[0];
    switch(region){
        case timezoneTypes/* TimezoneRegions.Asia */.m.Asia:
        case timezoneTypes/* TimezoneRegions.Europe */.m.Europe:
        case timezoneTypes/* TimezoneRegions.Australia */.m.Australia:
        case timezoneTypes/* TimezoneRegions.America */.m.America:
        case timezoneTypes/* TimezoneRegions.Africa */.m.Africa:
            return region;
        default:
            return timezoneTypes/* TimezoneRegions.Other */.m.Other;
    }
};
const isSameDayUTC = (dateA, dateB)=>{
    if (!dateA || !dateB) {
        return false;
    }
    return new Date(dateA).getUTCDate() === new Date(dateB).getUTCDate();
};


/***/ }),

/***/ 29177:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "F": () => (/* binding */ timezonesList)
});

// EXTERNAL MODULE: ./src/libs/time/index.ts + 2 modules
var time = __webpack_require__(69113);
;// CONCATENATED MODULE: ./src/libs/timezone/timezones.json
const timezones_namespaceObject = JSON.parse('[{"label":"Pacific/Midway (GMT-11:00)","tzCode":"Pacific/Midway","name":"(GMT-11:00) Midway","utc":"-11:00","showInList":true},{"label":"Pacific/Niue (GMT-11:00)","tzCode":"Pacific/Niue","name":"(GMT-11:00) Alofi","utc":"-11:00","showInList":true},{"label":"Pacific/Pago_Pago (GMT-11:00)","tzCode":"Pacific/Pago_Pago","name":"(GMT-11:00) Pago Pago","utc":"-11:00","showInList":true},{"label":"America/Adak (GMT-10:00)","tzCode":"America/Adak","name":"(GMT-10:00) Adak","utc":"-10:00","showInList":true},{"label":"Pacific/Honolulu (GMT-10:00)","tzCode":"Pacific/Honolulu","name":"(GMT-10:00) Honolulu","utc":"-10:00","showInList":true},{"label":"Pacific/Rarotonga (GMT-10:00)","tzCode":"Pacific/Rarotonga","name":"(GMT-10:00) Avarua","utc":"-10:00","showInList":true},{"label":"Pacific/Tahiti (GMT-10:00)","tzCode":"Pacific/Tahiti","name":"(GMT-10:00) Faaa","utc":"-10:00","showInList":true},{"label":"Pacific/Marquesas (GMT-09:30)","tzCode":"Pacific/Marquesas","name":"(GMT-09:30) Taiohae","utc":"-09:30","showInList":true},{"label":"America/Anchorage (GMT-09:00)","tzCode":"America/Anchorage","name":"(GMT-09:00) Anchorage","utc":"-09:00","showInList":true},{"label":"America/Juneau (GMT-09:00)","tzCode":"America/Juneau","name":"(GMT-09:00) Juneau","utc":"-09:00"},{"label":"America/Metlakatla (GMT-09:00)","tzCode":"America/Metlakatla","name":"(GMT-09:00) Metlakatla","utc":"-09:00"},{"label":"America/Nome (GMT-09:00)","tzCode":"America/Nome","name":"(GMT-09:00) Nome","utc":"-09:00","showInList":true},{"label":"America/Sitka (GMT-09:00)","tzCode":"America/Sitka","name":"(GMT-09:00) Sitka","utc":"-09:00"},{"label":"America/Yakutat (GMT-09:00)","tzCode":"America/Yakutat","name":"(GMT-09:00) Yakutat","utc":"-09:00","showInList":true},{"label":"Pacific/Gambier (GMT-09:00)","tzCode":"Pacific/Gambier","name":"(GMT-09:00) Gambier","utc":"-09:00","showInList":true},{"label":"America/Los_Angeles (GMT-08:00)","tzCode":"America/Los_Angeles","name":"(GMT-08:00) Los Angeles","utc":"-08:00","showInList":true},{"label":"America/Tijuana (GMT-08:00)","tzCode":"America/Tijuana","name":"(GMT-08:00) Tijuana","utc":"-08:00"},{"label":"America/Vancouver (GMT-08:00)","tzCode":"America/Vancouver","name":"(GMT-08:00) Vancouver","utc":"-08:00","showInList":true},{"label":"Pacific/Pitcairn (GMT-08:00)","tzCode":"Pacific/Pitcairn","name":"(GMT-08:00) Adamstown","utc":"-08:00"},{"label":"America/Boise (GMT-07:00)","tzCode":"America/Boise","name":"(GMT-07:00) Boise","utc":"-07:00"},{"label":"America/Cambridge_Bay (GMT-07:00)","tzCode":"America/Cambridge_Bay","name":"(GMT-07:00) Cambridge Bay","utc":"-07:00"},{"label":"America/Chihuahua (GMT-07:00)","tzCode":"America/Chihuahua","name":"(GMT-07:00) Chihuahua","utc":"-07:00","showInList":true},{"label":"America/Creston (GMT-07:00)","tzCode":"America/Creston","name":"(GMT-07:00) Creston","utc":"-07:00"},{"label":"America/Dawson (GMT-07:00)","tzCode":"America/Dawson","name":"(GMT-07:00) Dawson","utc":"-07:00"},{"label":"America/Dawson_Creek (GMT-07:00)","tzCode":"America/Dawson_Creek","name":"(GMT-07:00) Fort St. John","utc":"-07:00"},{"label":"America/Denver (GMT-07:00)","tzCode":"America/Denver","name":"(GMT-07:00) Denver","utc":"-07:00","showInList":true},{"label":"America/Edmonton (GMT-07:00)","tzCode":"America/Edmonton","name":"(GMT-07:00) Calgary","utc":"-07:00"},{"label":"America/Fort_Nelson (GMT-07:00)","tzCode":"America/Fort_Nelson","name":"(GMT-07:00) Fort Nelson","utc":"-07:00","showInList":true},{"label":"America/Hermosillo (GMT-07:00)","tzCode":"America/Hermosillo","name":"(GMT-07:00) Hermosillo","utc":"-07:00"},{"label":"America/Inuvik (GMT-07:00)","tzCode":"America/Inuvik","name":"(GMT-07:00) Inuvik","utc":"-07:00"},{"label":"America/Mazatlan (GMT-07:00)","tzCode":"America/Mazatlan","name":"(GMT-07:00) Culiacán","utc":"-07:00","showInList":true},{"label":"America/Ojinaga (GMT-07:00)","tzCode":"America/Ojinaga","name":"(GMT-07:00) Ciudad Juárez","utc":"-07:00"},{"label":"America/Phoenix (GMT-07:00)","tzCode":"America/Phoenix","name":"(GMT-07:00) Phoenix","utc":"-07:00","showInList":true},{"label":"America/Whitehorse (GMT-07:00)","tzCode":"America/Whitehorse","name":"(GMT-07:00) Whitehorse","utc":"-07:00"},{"label":"America/Yellowknife (GMT-07:00)","tzCode":"America/Yellowknife","name":"(GMT-07:00) Yellowknife","utc":"-07:00","showInList":true},{"label":"America/Bahia_Banderas (GMT-06:00)","tzCode":"America/Bahia_Banderas","name":"(GMT-06:00) Mezcales","utc":"-06:00"},{"label":"America/Belize (GMT-06:00)","tzCode":"America/Belize","name":"(GMT-06:00) Belize City","utc":"-06:00"},{"label":"America/Chicago (GMT-06:00)","tzCode":"America/Chicago","name":"(GMT-06:00) Chicago","utc":"-06:00"},{"label":"America/Costa_Rica (GMT-06:00)","tzCode":"America/Costa_Rica","name":"(GMT-06:00) San José","utc":"-06:00"},{"label":"America/El_Salvador (GMT-06:00)","tzCode":"America/El_Salvador","name":"(GMT-06:00) San Salvador","utc":"-06:00"},{"label":"America/Guatemala (GMT-06:00)","tzCode":"America/Guatemala","name":"(GMT-06:00) Guatemala City","utc":"-06:00"},{"label":"America/Indiana/Knox (GMT-06:00)","tzCode":"America/Indiana/Knox","name":"(GMT-06:00) Knox","utc":"-06:00","showInList":true},{"label":"America/Indiana/Tell_City (GMT-06:00)","tzCode":"America/Indiana/Tell_City","name":"(GMT-06:00) Tell City","utc":"-06:00","showInList":true},{"label":"America/Managua (GMT-06:00)","tzCode":"America/Managua","name":"(GMT-06:00) Managua","utc":"-06:00"},{"label":"America/Matamoros (GMT-06:00)","tzCode":"America/Matamoros","name":"(GMT-06:00) Reynosa","utc":"-06:00"},{"label":"America/Menominee (GMT-06:00)","tzCode":"America/Menominee","name":"(GMT-06:00) Menominee","utc":"-06:00"},{"label":"America/Merida (GMT-06:00)","tzCode":"America/Merida","name":"(GMT-06:00) Mérida","utc":"-06:00"},{"label":"America/Mexico_City (GMT-06:00)","tzCode":"America/Mexico_City","name":"(GMT-06:00) Mexico City","utc":"-06:00","showInList":true},{"label":"America/Monterrey (GMT-06:00)","tzCode":"America/Monterrey","name":"(GMT-06:00) Monterrey","utc":"-06:00","showInList":true},{"label":"America/North_Dakota/Beulah (GMT-06:00)","tzCode":"America/North_Dakota/Beulah","name":"(GMT-06:00) Beulah","utc":"-06:00"},{"label":"America/North_Dakota/Center (GMT-06:00)","tzCode":"America/North_Dakota/Center","name":"(GMT-06:00) Center","utc":"-06:00"},{"label":"America/North_Dakota/New_Salem (GMT-06:00)","tzCode":"America/North_Dakota/New_Salem","name":"(GMT-06:00) Mandan","utc":"-06:00"},{"label":"America/Rainy_River (GMT-06:00)","tzCode":"America/Rainy_River","name":"(GMT-06:00) Rainy River","utc":"-06:00"},{"label":"America/Rankin_Inlet (GMT-06:00)","tzCode":"America/Rankin_Inlet","name":"(GMT-06:00) Rankin Inlet","utc":"-06:00"},{"label":"America/Regina (GMT-06:00)","tzCode":"America/Regina","name":"(GMT-06:00) Saskatoon","utc":"-06:00","showInList":true},{"label":"America/Resolute (GMT-06:00)","tzCode":"America/Resolute","name":"(GMT-06:00) Resolute","utc":"-06:00"},{"label":"America/Swift_Current (GMT-06:00)","tzCode":"America/Swift_Current","name":"(GMT-06:00) Swift Current","utc":"-06:00"},{"label":"America/Tegucigalpa (GMT-06:00)","tzCode":"America/Tegucigalpa","name":"(GMT-06:00) Tegucigalpa","utc":"-06:00"},{"label":"America/Winnipeg (GMT-06:00)","tzCode":"America/Winnipeg","name":"(GMT-06:00) Winnipeg","utc":"-06:00"},{"label":"Pacific/Easter (GMT-06:00)","tzCode":"Pacific/Easter","name":"(GMT-06:00) Easter","utc":"-06:00","showInList":true},{"label":"Pacific/Galapagos (GMT-06:00)","tzCode":"Pacific/Galapagos","name":"(GMT-06:00) Puerto Ayora","utc":"-06:00"},{"label":"America/Atikokan (GMT-05:00)","tzCode":"America/Atikokan","name":"(GMT-05:00) Atikokan","utc":"-05:00"},{"label":"America/Bogota (GMT-05:00)","tzCode":"America/Bogota","name":"(GMT-05:00) Bogotá","utc":"-05:00","showInList":true},{"label":"America/Cancun (GMT-05:00)","tzCode":"America/Cancun","name":"(GMT-05:00) Cancún","utc":"-05:00"},{"label":"America/Cayman (GMT-05:00)","tzCode":"America/Cayman","name":"(GMT-05:00) George Town","utc":"-05:00"},{"label":"America/Detroit (GMT-05:00)","tzCode":"America/Detroit","name":"(GMT-05:00) Detroit","utc":"-05:00"},{"label":"America/Eirunepe (GMT-05:00)","tzCode":"America/Eirunepe","name":"(GMT-05:00) Eirunepé","utc":"-05:00"},{"label":"America/Grand_Turk (GMT-05:00)","tzCode":"America/Grand_Turk","name":"(GMT-05:00) Cockburn Town","utc":"-05:00","showInList":true},{"label":"America/Guayaquil (GMT-05:00)","tzCode":"America/Guayaquil","name":"(GMT-05:00) Guayaquil","utc":"-05:00"},{"label":"America/Havana (GMT-05:00)","tzCode":"America/Havana","name":"(GMT-05:00) Havana","utc":"-05:00","showInList":true},{"label":"America/Indiana/Indianapolis (GMT-05:00)","tzCode":"America/Indiana/Indianapolis","name":"(GMT-05:00) Indianapolis","utc":"-05:00","showInList":true},{"label":"America/Indiana/Marengo (GMT-05:00)","tzCode":"America/Indiana/Marengo","name":"(GMT-05:00) Marengo","utc":"-05:00"},{"label":"America/Indiana/Petersburg (GMT-05:00)","tzCode":"America/Indiana/Petersburg","name":"(GMT-05:00) Petersburg","utc":"-05:00","showInList":true},{"label":"America/Indiana/Vevay (GMT-05:00)","tzCode":"America/Indiana/Vevay","name":"(GMT-05:00) Vevay","utc":"-05:00"},{"label":"America/Indiana/Vincennes (GMT-05:00)","tzCode":"America/Indiana/Vincennes","name":"(GMT-05:00) Vincennes","utc":"-05:00"},{"label":"America/Indiana/Winamac (GMT-05:00)","tzCode":"America/Indiana/Winamac","name":"(GMT-05:00) Winamac","utc":"-05:00"},{"label":"America/Iqaluit (GMT-05:00)","tzCode":"America/Iqaluit","name":"(GMT-05:00) Iqaluit","utc":"-05:00"},{"label":"America/Jamaica (GMT-05:00)","tzCode":"America/Jamaica","name":"(GMT-05:00) Kingston","utc":"-05:00"},{"label":"America/Kentucky/Louisville (GMT-05:00)","tzCode":"America/Kentucky/Louisville","name":"(GMT-05:00) Louisville","utc":"-05:00"},{"label":"America/Kentucky/Monticello (GMT-05:00)","tzCode":"America/Kentucky/Monticello","name":"(GMT-05:00) Monticello","utc":"-05:00"},{"label":"America/Lima (GMT-05:00)","tzCode":"America/Lima","name":"(GMT-05:00) Lima","utc":"-05:00","showInList":true},{"label":"America/Nassau (GMT-05:00)","tzCode":"America/Nassau","name":"(GMT-05:00) Nassau","utc":"-05:00"},{"label":"America/New_York (GMT-05:00)","tzCode":"America/New_York","name":"(GMT-05:00) New York City","utc":"-05:00","showInList":true},{"label":"America/Nipigon (GMT-05:00)","tzCode":"America/Nipigon","name":"(GMT-05:00) Nipigon","utc":"-05:00"},{"label":"America/Panama (GMT-05:00)","tzCode":"America/Panama","name":"(GMT-05:00) Panamá","utc":"-05:00"},{"label":"America/Pangnirtung (GMT-05:00)","tzCode":"America/Pangnirtung","name":"(GMT-05:00) Pangnirtung","utc":"-05:00"},{"label":"America/Port-au-Prince (GMT-05:00)","tzCode":"America/Port-au-Prince","name":"(GMT-05:00) Port-au-Prince","utc":"-05:00","showInList":true},{"label":"America/Rio_Branco (GMT-05:00)","tzCode":"America/Rio_Branco","name":"(GMT-05:00) Rio Branco","utc":"-05:00","showInList":true},{"label":"America/Thunder_Bay (GMT-05:00)","tzCode":"America/Thunder_Bay","name":"(GMT-05:00) Thunder Bay","utc":"-05:00"},{"label":"America/Toronto (GMT-05:00)","tzCode":"America/Toronto","name":"(GMT-05:00) Toronto","utc":"-05:00"},{"label":"America/AnguillaSandy Hill (GMT-04:00)","tzCode":"America/Anguilla","name":"(GMT-04:00) The Valley","utc":"-04:00"},{"label":"America/Antigua (GMT-04:00)","tzCode":"America/Antigua","name":"(GMT-04:00) Saint John’s","utc":"-04:00","showInList":true},{"label":"America/Aruba (GMT-04:00)","tzCode":"America/Aruba","name":"(GMT-04:00) Oranjestad","utc":"-04:00"},{"label":"America/Asuncion (GMT-04:00)","tzCode":"America/Asuncion","name":"(GMT-04:00) Asunción","utc":"-04:00","showInList":true},{"label":"America/Barbados (GMT-04:00)","tzCode":"America/Barbados","name":"(GMT-04:00) Bridgetown","utc":"-04:00"},{"label":"America/Blanc-Sablon (GMT-04:00)","tzCode":"America/Blanc-Sablon","name":"(GMT-04:00) Lévis","utc":"-04:00"},{"label":"America/Boa_Vista (GMT-04:00)","tzCode":"America/Boa_Vista","name":"(GMT-04:00) Boa Vista","utc":"-04:00"},{"label":"America/Campo_Grande (GMT-04:00)","tzCode":"America/Campo_Grande","name":"(GMT-04:00) Campo Grande","utc":"-04:00"},{"label":"America/Caracas (GMT-04:00)","tzCode":"America/Caracas","name":"(GMT-04:00) Caracas","utc":"-04:00","showInList":true},{"label":"America/Cuiaba (GMT-04:00)","tzCode":"America/Cuiaba","name":"(GMT-04:00) Cuiabá","utc":"-04:00","showInList":true},{"label":"America/Curacao (GMT-04:00)","tzCode":"America/Curacao","name":"(GMT-04:00) Willemstad","utc":"-04:00"},{"label":"America/Dominica (GMT-04:00)","tzCode":"America/Dominica","name":"(GMT-04:00) Roseau","utc":"-04:00"},{"label":"America/Glace_Bay (GMT-04:00)","tzCode":"America/Glace_Bay","name":"(GMT-04:00) Sydney","utc":"-04:00"},{"label":"America/Goose_Bay (GMT-04:00)","tzCode":"America/Goose_Bay","name":"(GMT-04:00) Labrador City","utc":"-04:00"},{"label":"America/Grenada (GMT-04:00)","tzCode":"America/Grenada","name":"(GMT-04:00) Saint George\'s","utc":"-04:00"},{"label":"America/Guadeloupe (GMT-04:00)","tzCode":"America/Guadeloupe","name":"(GMT-04:00) Les Abymes","utc":"-04:00"},{"label":"America/Guyana (GMT-04:00)","tzCode":"America/Guyana","name":"(GMT-04:00) Georgetown","utc":"-04:00","showInList":true},{"label":"America/Halifax (GMT-04:00)","tzCode":"America/Halifax","name":"(GMT-04:00) Halifax","utc":"-04:00"},{"label":"America/Kralendijk (GMT-04:00)","tzCode":"America/Kralendijk","name":"(GMT-04:00) Kralendijk","utc":"-04:00"},{"label":"America/La_Paz (GMT-04:00)","tzCode":"America/La_Paz","name":"(GMT-04:00) Santa Cruz de la Sierra","utc":"-04:00"},{"label":"America/Lower_Princes (GMT-04:00)","tzCode":"America/Lower_Princes","name":"(GMT-04:00) Cul de Sac","utc":"-04:00"},{"label":"America/Manaus (GMT-04:00)","tzCode":"America/Manaus","name":"(GMT-04:00) Manaus","utc":"-04:00","showInList":true},{"label":"America/Marigot (GMT-04:00)","tzCode":"America/Marigot","name":"(GMT-04:00) Marigot","utc":"-04:00"},{"label":"America/Martinique (GMT-04:00)","tzCode":"America/Martinique","name":"(GMT-04:00) Fort-de-France","utc":"-04:00"},{"label":"America/Moncton (GMT-04:00)","tzCode":"America/Moncton","name":"(GMT-04:00) Moncton","utc":"-04:00"},{"label":"America/Montserrat (GMT-04:00)","tzCode":"America/Montserrat","name":"(GMT-04:00) Brades","utc":"-04:00"},{"label":"America/Porto_Velho (GMT-04:00)","tzCode":"America/Porto_Velho","name":"(GMT-04:00) Porto Velho","utc":"-04:00"},{"label":"America/Port_of_Spain (GMT-04:00)","tzCode":"America/Port_of_Spain","name":"(GMT-04:00) Chaguanas","utc":"-04:00"},{"label":"America/Puerto_Rico (GMT-04:00)","tzCode":"America/Puerto_Rico","name":"(GMT-04:00) San Juan","utc":"-04:00","showInList":true},{"label":"America/Santiago (GMT-04:00)","tzCode":"America/Santiago","name":"(GMT-04:00) Santiago","utc":"-04:00","showInList":true},{"label":"America/Santo_Domingo (GMT-04:00)","tzCode":"America/Santo_Domingo","name":"(GMT-04:00) Santo Domingo","utc":"-04:00"},{"label":"America/St_Barthelemy (GMT-04:00)","tzCode":"America/St_Barthelemy","name":"(GMT-04:00) Gustavia","utc":"-04:00"},{"label":"America/St_Kitts (GMT-04:00)","tzCode":"America/St_Kitts","name":"(GMT-04:00) Basseterre","utc":"-04:00"},{"label":"America/St_Lucia (GMT-04:00)","tzCode":"America/St_Lucia","name":"(GMT-04:00) Castries","utc":"-04:00"},{"label":"America/St_Thomas (GMT-04:00)","tzCode":"America/St_Thomas","name":"(GMT-04:00) Saint Croix","utc":"-04:00"},{"label":"America/St_Vincent (GMT-04:00)","tzCode":"America/St_Vincent","name":"(GMT-04:00) Kingstown","utc":"-04:00"},{"label":"America/Thule (GMT-04:00)","tzCode":"America/Thule","name":"(GMT-04:00) Thule","utc":"-04:00"},{"label":"America/Tortola (GMT-04:00)","tzCode":"America/Tortola","name":"(GMT-04:00) Road Town","utc":"-04:00"},{"label":"Atlantic/Bermuda (GMT-04:00)","tzCode":"Atlantic/Bermuda","name":"(GMT-04:00) Hamilton","utc":"-04:00"},{"label":"America/St_Johns (GMT-03:30)","tzCode":"America/St_Johns","name":"(GMT-03:30) St. John\'s","utc":"-03:30","showInList":true},{"label":"America/Araguaina (GMT-03:00)","tzCode":"America/Araguaina","name":"(GMT-03:00) Palmas","utc":"-03:00","showInList":true},{"label":"America/Argentina/Buenos_Aires (GMT-03:00)","tzCode":"America/Argentina/Buenos_Aires","name":"(GMT-03:00) Buenos Aires","utc":"-03:00","showInList":true},{"label":"America/Argentina/Catamarca (GMT-03:00)","tzCode":"America/Argentina/Catamarca","name":"(GMT-03:00) San Fernando del Valle de Catamarca","utc":"-03:00"},{"label":"America/Argentina/Cordoba (GMT-03:00)","tzCode":"America/Argentina/Cordoba","name":"(GMT-03:00) Córdoba","utc":"-03:00"},{"label":"America/Argentina/Jujuy (GMT-03:00)","tzCode":"America/Argentina/Jujuy","name":"(GMT-03:00) San Salvador de Jujuy","utc":"-03:00"},{"label":"America/Argentina/La_Rioja (GMT-03:00)","tzCode":"America/Argentina/La_Rioja","name":"(GMT-03:00) La Rioja","utc":"-03:00"},{"label":"America/Argentina/Mendoza (GMT-03:00)","tzCode":"America/Argentina/Mendoza","name":"(GMT-03:00) Mendoza","utc":"-03:00"},{"label":"America/Argentina/Rio_Gallegos (GMT-03:00)","tzCode":"America/Argentina/Rio_Gallegos","name":"(GMT-03:00) Comodoro Rivadavia","utc":"-03:00"},{"label":"America/Argentina/Salta (GMT-03:00)","tzCode":"America/Argentina/Salta","name":"(GMT-03:00) Salta","utc":"-03:00"},{"label":"America/Argentina/San_Juan (GMT-03:00)","tzCode":"America/Argentina/San_Juan","name":"(GMT-03:00) San Juan","utc":"-03:00"},{"label":"America/Argentina/San_Luis (GMT-03:00)","tzCode":"America/Argentina/San_Luis","name":"(GMT-03:00) San Luis","utc":"-03:00"},{"label":"America/Argentina/Tucuman (GMT-03:00)","tzCode":"America/Argentina/Tucuman","name":"(GMT-03:00) San Miguel de Tucumán","utc":"-03:00"},{"label":"America/Argentina/Ushuaia (GMT-03:00)","tzCode":"America/Argentina/Ushuaia","name":"(GMT-03:00) Ushuaia","utc":"-03:00"},{"label":"America/Bahia (GMT-03:00)","tzCode":"America/Bahia","name":"(GMT-03:00) Salvador","utc":"-03:00","showInList":true},{"label":"America/Belem (GMT-03:00)","tzCode":"America/Belem","name":"(GMT-03:00) Belém","utc":"-03:00"},{"label":"America/Cayenne (GMT-03:00)","tzCode":"America/Cayenne","name":"(GMT-03:00) Cayenne","utc":"-03:00","showInList":true},{"label":"America/Fortaleza (GMT-03:00)","tzCode":"America/Fortaleza","name":"(GMT-03:00) Fortaleza","utc":"-03:00","showInList":true},{"label":"America/Godthab (GMT-03:00)","tzCode":"America/Godthab","name":"(GMT-03:00) Nuuk","utc":"-03:00","showInList":true},{"label":"America/Maceio (GMT-03:00)","tzCode":"America/Maceio","name":"(GMT-03:00) Maceió","utc":"-03:00"},{"label":"America/Miquelon (GMT-03:00)","tzCode":"America/Miquelon","name":"(GMT-03:00) Saint-Pierre","utc":"-03:00","showInList":true},{"label":"America/Montevideo (GMT-03:00)","tzCode":"America/Montevideo","name":"(GMT-03:00) Montevideo","utc":"-03:00","showInList":true},{"label":"America/Paramaribo (GMT-03:00)","tzCode":"America/Paramaribo","name":"(GMT-03:00) Paramaribo","utc":"-03:00"},{"label":"America/Punta_Arenas (GMT-03:00)","tzCode":"America/Punta_Arenas","name":"(GMT-03:00) Punta Arenas","utc":"-03:00","showInList":true},{"label":"America/Recife (GMT-03:00)","tzCode":"America/Recife","name":"(GMT-03:00) Recife","utc":"-03:00"},{"label":"America/Santarem (GMT-03:00)","tzCode":"America/Santarem","name":"(GMT-03:00) Santarém","utc":"-03:00"},{"label":"America/Sao_Paulo (GMT-03:00)","tzCode":"America/Sao_Paulo","name":"(GMT-03:00) São Paulo","utc":"-03:00"},{"label":"Antarctica/Palmer (GMT-03:00)","tzCode":"Antarctica/Palmer","name":"(GMT-03:00) Palmer","utc":"-03:00"},{"label":"Antarctica/Rothera (GMT-03:00)","tzCode":"Antarctica/Rothera","name":"(GMT-03:00) Rothera","utc":"-03:00"},{"label":"Atlantic/Stanley (GMT-03:00)","tzCode":"Atlantic/Stanley","name":"(GMT-03:00) Stanley","utc":"-03:00"},{"label":"America/Noronha (GMT-02:00)","tzCode":"America/Noronha","name":"(GMT-02:00) Itamaracá","utc":"-02:00","showInList":true},{"label":"Atlantic/South_Georgia (GMT-02:00)","tzCode":"Atlantic/South_Georgia","name":"(GMT-02:00) Grytviken","utc":"-02:00","showInList":true},{"label":"America/Scoresbysund (GMT-01:00)","tzCode":"America/Scoresbysund","name":"(GMT-01:00) Scoresbysund","utc":"-01:00","showInList":true},{"label":"Atlantic/Azores (GMT-01:00)","tzCode":"Atlantic/Azores","name":"(GMT-01:00) Ponta Delgada","utc":"-01:00","showInList":true},{"label":"Atlantic/Cape_Verde (GMT-01:00)","tzCode":"Atlantic/Cape_Verde","name":"(GMT-01:00) Praia","utc":"-01:00","showInList":true},{"label":"Africa/Abidjan (GMT+00:00)","tzCode":"Africa/Abidjan","name":"(GMT+00:00) Abidjan","utc":"+00:00"},{"label":"Africa/Accra (GMT+00:00)","tzCode":"Africa/Accra","name":"(GMT+00:00) Accra","utc":"+00:00"},{"label":"Africa/Bamako (GMT+00:00)","tzCode":"Africa/Bamako","name":"(GMT+00:00) Bamako","utc":"+00:00"},{"label":"Africa/Banjul (GMT+00:00)","tzCode":"Africa/Banjul","name":"(GMT+00:00) Serekunda","utc":"+00:00"},{"label":"Africa/Bissau (GMT+00:00)","tzCode":"Africa/Bissau","name":"(GMT+00:00) Bissau","utc":"+00:00"},{"label":"Africa/Casablanca (GMT+00:00)","tzCode":"Africa/Casablanca","name":"(GMT+00:00) Casablanca","utc":"+00:00","showInList":true},{"label":"Africa/Conakry (GMT+00:00)","tzCode":"Africa/Conakry","name":"(GMT+00:00) Camayenne","utc":"+00:00"},{"label":"Africa/Dakar (GMT+00:00)","tzCode":"Africa/Dakar","name":"(GMT+00:00) Dakar","utc":"+00:00"},{"label":"Africa/El_Aaiun (GMT+00:00)","tzCode":"Africa/El_Aaiun","name":"(GMT+00:00) Laayoune","utc":"+00:00"},{"label":"Africa/Freetown (GMT+00:00)","tzCode":"Africa/Freetown","name":"(GMT+00:00) Freetown","utc":"+00:00"},{"label":"Africa/Lome (GMT+00:00)","tzCode":"Africa/Lome","name":"(GMT+00:00) Lomé","utc":"+00:00"},{"label":"Africa/Monrovia (GMT+00:00)","tzCode":"Africa/Monrovia","name":"(GMT+00:00) Monrovia","utc":"+00:00","showInList":true},{"label":"Africa/Nouakchott (GMT+00:00)","tzCode":"Africa/Nouakchott","name":"(GMT+00:00) Nouakchott","utc":"+00:00"},{"label":"Africa/Ouagadougou (GMT+00:00)","tzCode":"Africa/Ouagadougou","name":"(GMT+00:00) Ouagadougou","utc":"+00:00"},{"label":"Africa/Sao_Tome (GMT+00:00)","tzCode":"Africa/Sao_Tome","name":"(GMT+00:00) São Tomé","utc":"+00:00","showInList":true},{"label":"America/Danmarkshavn (GMT+00:00)","tzCode":"America/Danmarkshavn","name":"(GMT+00:00) Danmarkshavn","utc":"+00:00","showInList":true},{"label":"Antarctica/Troll (GMT+00:00)","tzCode":"Antarctica/Troll","name":"(GMT+00:00) Troll","utc":"+00:00"},{"label":"Atlantic/Canary (GMT+00:00)","tzCode":"Atlantic/Canary","name":"(GMT+00:00) Las Palmas de Gran Canaria","utc":"+00:00"},{"label":"Atlantic/Faroe (GMT+00:00)","tzCode":"Atlantic/Faroe","name":"(GMT+00:00) Tórshavn","utc":"+00:00"},{"label":"Atlantic/Madeira (GMT+00:00)","tzCode":"Atlantic/Madeira","name":"(GMT+00:00) Funchal","utc":"+00:00"},{"label":"Atlantic/Reykjavik (GMT+00:00)","tzCode":"Atlantic/Reykjavik","name":"(GMT+00:00) Reykjavík","utc":"+00:00","showInList":true},{"label":"Atlantic/St_Helena (GMT+00:00)","tzCode":"Atlantic/St_Helena","name":"(GMT+00:00) Jamestown","utc":"+00:00"},{"label":"Europe/Dublin (GMT+00:00)","tzCode":"Europe/Dublin","name":"(GMT+00:00) Dublin","utc":"+00:00","showInList":true},{"label":"Europe/Guernsey (GMT+00:00)","tzCode":"Europe/Guernsey","name":"(GMT+00:00) Saint Peter Port","utc":"+00:00"},{"label":"Europe/Isle_of_Man (GMT+00:00)","tzCode":"Europe/Isle_of_Man","name":"(GMT+00:00) Douglas","utc":"+00:00"},{"label":"Europe/Jersey (GMT+00:00)","tzCode":"Europe/Jersey","name":"(GMT+00:00) Saint Helier","utc":"+00:00"},{"label":"Europe/Lisbon (GMT+00:00)","tzCode":"Europe/Lisbon","name":"(GMT+00:00) Lisbon","utc":"+00:00","showInList":true},{"label":"Europe/London (GMT+00:00)","tzCode":"Europe/London","name":"(GMT+00:00) London","utc":"+00:00","showInList":true},{"label":"Africa/Algiers (GMT+01:00)","tzCode":"Africa/Algiers","name":"(GMT+01:00) Algiers","utc":"+01:00"},{"label":"Africa/Bangui (GMT+01:00)","tzCode":"Africa/Bangui","name":"(GMT+01:00) Bangui","utc":"+01:00"},{"label":"Africa/Brazzaville (GMT+01:00)","tzCode":"Africa/Brazzaville","name":"(GMT+01:00) Brazzaville","utc":"+01:00"},{"label":"Africa/Ceuta (GMT+01:00)","tzCode":"Africa/Ceuta","name":"(GMT+01:00) Ceuta","utc":"+01:00"},{"label":"Africa/Douala (GMT+01:00)","tzCode":"Africa/Douala","name":"(GMT+01:00) Douala","utc":"+01:00"},{"label":"Africa/Kinshasa (GMT+01:00)","tzCode":"Africa/Kinshasa","name":"(GMT+01:00) Kinshasa","utc":"+01:00"},{"label":"Africa/Lagos (GMT+01:00)","tzCode":"Africa/Lagos","name":"(GMT+01:00) Lagos","utc":"+01:00"},{"label":"Africa/Libreville (GMT+01:00)","tzCode":"Africa/Libreville","name":"(GMT+01:00) Libreville","utc":"+01:00"},{"label":"Africa/Luanda (GMT+01:00)","tzCode":"Africa/Luanda","name":"(GMT+01:00) Luanda","utc":"+01:00"},{"label":"Africa/Malabo (GMT+01:00)","tzCode":"Africa/Malabo","name":"(GMT+01:00) Bata","utc":"+01:00"},{"label":"Africa/Ndjamena (GMT+01:00)","tzCode":"Africa/Ndjamena","name":"(GMT+01:00) N\'Djamena","utc":"+01:00"},{"label":"Africa/Niamey (GMT+01:00)","tzCode":"Africa/Niamey","name":"(GMT+01:00) Niamey","utc":"+01:00"},{"label":"Africa/Porto-Novo (GMT+01:00)","tzCode":"Africa/Porto-Novo","name":"(GMT+01:00) Cotonou","utc":"+01:00"},{"label":"Africa/Tunis (GMT+01:00)","tzCode":"Africa/Tunis","name":"(GMT+01:00) Tunis","utc":"+01:00","showInList":true},{"label":"Africa/Windhoek (GMT+01:00)","tzCode":"Africa/Windhoek","name":"(GMT+01:00) Windhoek","utc":"+01:00","showInList":true},{"label":"Arctic/Longyearbyen (GMT+01:00)","tzCode":"Arctic/Longyearbyen","name":"(GMT+01:00) Longyearbyen","utc":"+01:00"},{"label":"Europe/Amsterdam (GMT+01:00)","tzCode":"Europe/Amsterdam","name":"(GMT+01:00) Amsterdam","utc":"+01:00","showInList":true},{"label":"Europe/Andorra (GMT+01:00)","tzCode":"Europe/Andorra","name":"(GMT+01:00) Andorra la Vella","utc":"+01:00"},{"label":"Europe/Belgrade (GMT+01:00)","tzCode":"Europe/Belgrade","name":"(GMT+01:00) Belgrade","utc":"+01:00","showInList":true},{"label":"Europe/Berlin (GMT+01:00)","tzCode":"Europe/Berlin","name":"(GMT+01:00) Berlin","utc":"+01:00","showInList":true},{"label":"Europe/Bratislava (GMT+01:00)","tzCode":"Europe/Bratislava","name":"(GMT+01:00) Bratislava","utc":"+01:00","showInList":true},{"label":"Europe/Brussels (GMT+01:00)","tzCode":"Europe/Brussels","name":"(GMT+01:00) Brussels","utc":"+01:00","showInList":true},{"label":"Europe/Budapest (GMT+01:00)","tzCode":"Europe/Budapest","name":"(GMT+01:00) Budapest","utc":"+01:00","showInList":true},{"label":"Europe/Copenhagen (GMT+01:00)","tzCode":"Europe/Copenhagen","name":"(GMT+01:00) Copenhagen","utc":"+01:00","showInList":true},{"label":"Europe/Gibraltar (GMT+01:00)","tzCode":"Europe/Gibraltar","name":"(GMT+01:00) Gibraltar","utc":"+01:00"},{"label":"Europe/Ljubljana (GMT+01:00)","tzCode":"Europe/Ljubljana","name":"(GMT+01:00) Ljubljana","utc":"+01:00","showInList":true},{"label":"Europe/Luxembourg (GMT+01:00)","tzCode":"Europe/Luxembourg","name":"(GMT+01:00) Luxembourg","utc":"+01:00"},{"label":"Europe/Madrid (GMT+01:00)","tzCode":"Europe/Madrid","name":"(GMT+01:00) Madrid","utc":"+01:00","showInList":true},{"label":"Europe/Malta (GMT+01:00)","tzCode":"Europe/Malta","name":"(GMT+01:00) Birkirkara","utc":"+01:00"},{"label":"Europe/Monaco (GMT+01:00)","tzCode":"Europe/Monaco","name":"(GMT+01:00) Monaco","utc":"+01:00"},{"label":"Europe/Oslo (GMT+01:00)","tzCode":"Europe/Oslo","name":"(GMT+01:00) Oslo","utc":"+01:00"},{"label":"Europe/Paris (GMT+01:00)","tzCode":"Europe/Paris","name":"(GMT+01:00) Paris","utc":"+01:00","showInList":true},{"label":"Europe/Podgorica (GMT+01:00)","tzCode":"Europe/Podgorica","name":"(GMT+01:00) Podgorica","utc":"+01:00"},{"label":"Europe/Prague (GMT+01:00)","tzCode":"Europe/Prague","name":"(GMT+01:00) Prague","utc":"+01:00","showInList":true},{"label":"Europe/Rome (GMT+01:00)","tzCode":"Europe/Rome","name":"(GMT+01:00) Rome","utc":"+01:00","showInList":true},{"label":"Europe/San_Marino (GMT+01:00)","tzCode":"Europe/San_Marino","name":"(GMT+01:00) Serravalle","utc":"+01:00"},{"label":"Europe/Sarajevo (GMT+01:00)","tzCode":"Europe/Sarajevo","name":"(GMT+01:00) Sarajevo","utc":"+01:00","showInList":true},{"label":"Europe/Skopje (GMT+01:00)","tzCode":"Europe/Skopje","name":"(GMT+01:00) Skopje","utc":"+01:00","showInList":true},{"label":"Europe/Stockholm (GMT+01:00)","tzCode":"Europe/Stockholm","name":"(GMT+01:00) Stockholm","utc":"+01:00","showInList":true},{"label":"Europe/Tirane (GMT+01:00)","tzCode":"Europe/Tirane","name":"(GMT+01:00) Tirana","utc":"+01:00"},{"label":"Europe/Vaduz (GMT+01:00)","tzCode":"Europe/Vaduz","name":"(GMT+01:00) Schaan","utc":"+01:00"},{"label":"Europe/Vatican (GMT+01:00)","tzCode":"Europe/Vatican","name":"(GMT+01:00) Vatican City","utc":"+01:00"},{"label":"Europe/Vienna (GMT+01:00)","tzCode":"Europe/Vienna","name":"(GMT+01:00) Vienna","utc":"+01:00","showInList":true},{"label":"Europe/Warsaw (GMT+01:00)","tzCode":"Europe/Warsaw","name":"(GMT+01:00) Warsaw","utc":"+01:00","showInList":true},{"label":"Europe/Zagreb (GMT+01:00)","tzCode":"Europe/Zagreb","name":"(GMT+01:00) Zagreb","utc":"+01:00","showInList":true},{"label":"Europe/Zurich (GMT+01:00)","tzCode":"Europe/Zurich","name":"(GMT+01:00) Zürich","utc":"+01:00"},{"label":"Africa/Blantyre (GMT+02:00)","tzCode":"Africa/Blantyre","name":"(GMT+02:00) Lilongwe","utc":"+02:00"},{"label":"Africa/Bujumbura (GMT+02:00)","tzCode":"Africa/Bujumbura","name":"(GMT+02:00) Bujumbura","utc":"+02:00"},{"label":"Africa/Cairo (GMT+02:00)","tzCode":"Africa/Cairo","name":"(GMT+02:00) Cairo","utc":"+02:00","showInList":true},{"label":"Africa/Gaborone (GMT+02:00)","tzCode":"Africa/Gaborone","name":"(GMT+02:00) Gaborone","utc":"+02:00","showInList":true},{"label":"Africa/Harare (GMT+02:00)","tzCode":"Africa/Harare","name":"(GMT+02:00) Harare","utc":"+02:00","showInList":true},{"label":"Africa/Johannesburg (GMT+02:00)","tzCode":"Africa/Johannesburg","name":"(GMT+02:00) Cape Town","utc":"+02:00"},{"label":"Africa/Juba (GMT+02:00)","tzCode":"Africa/Juba","name":"(GMT+02:00) Juba","utc":"+02:00"},{"label":"Africa/Khartoum (GMT+02:00)","tzCode":"Africa/Khartoum","name":"(GMT+02:00) Khartoum","utc":"+02:00","showInList":true},{"label":"Africa/Kigali (GMT+02:00)","tzCode":"Africa/Kigali","name":"(GMT+02:00) Kigali","utc":"+02:00"},{"label":"Africa/Lubumbashi (GMT+02:00)","tzCode":"Africa/Lubumbashi","name":"(GMT+02:00) Lubumbashi","utc":"+02:00"},{"label":"Africa/Lusaka (GMT+02:00)","tzCode":"Africa/Lusaka","name":"(GMT+02:00) Lusaka","utc":"+02:00"},{"label":"Africa/Maputo (GMT+02:00)","tzCode":"Africa/Maputo","name":"(GMT+02:00) Maputo","utc":"+02:00"},{"label":"Africa/Maseru (GMT+02:00)","tzCode":"Africa/Maseru","name":"(GMT+02:00) Maseru","utc":"+02:00"},{"label":"Africa/Mbabane (GMT+02:00)","tzCode":"Africa/Mbabane","name":"(GMT+02:00) Manzini","utc":"+02:00"},{"label":"Africa/Tripoli (GMT+02:00)","tzCode":"Africa/Tripoli","name":"(GMT+02:00) Tripoli","utc":"+02:00","showInList":true},{"label":"Asia/Amman (GMT+02:00)","tzCode":"Asia/Amman","name":"(GMT+02:00) Amman","utc":"+02:00","showInList":true},{"label":"Asia/Beirut (GMT+02:00)","tzCode":"Asia/Beirut","name":"(GMT+02:00) Beirut","utc":"+02:00","showInList":true},{"label":"Asia/Damascus (GMT+02:00)","tzCode":"Asia/Damascus","name":"(GMT+02:00) Aleppo","utc":"+02:00","showInList":true},{"label":"Asia/Famagusta (GMT+02:00)","tzCode":"Asia/Famagusta","name":"(GMT+02:00) Famagusta","utc":"+02:00"},{"label":"Asia/Gaza (GMT+02:00)","tzCode":"Asia/Gaza","name":"(GMT+02:00) Gaza","utc":"+02:00","showInList":true},{"label":"Asia/Hebron (GMT+02:00)","tzCode":"Asia/Hebron","name":"(GMT+02:00) East Jerusalem","utc":"+02:00","showInList":true},{"label":"Asia/Jerusalem (GMT+02:00)","tzCode":"Asia/Jerusalem","name":"(GMT+02:00) Jerusalem","utc":"+02:00","showInList":true},{"label":"Asia/Nicosia (GMT+02:00)","tzCode":"Asia/Nicosia","name":"(GMT+02:00) Nicosia","utc":"+02:00"},{"label":"Europe/Athens (GMT+02:00)","tzCode":"Europe/Athens","name":"(GMT+02:00) Athens","utc":"+02:00","showInList":true},{"label":"Europe/Bucharest (GMT+02:00)","tzCode":"Europe/Bucharest","name":"(GMT+02:00) Bucharest","utc":"+02:00","showInList":true},{"label":"Europe/Chisinau (GMT+02:00)","tzCode":"Europe/Chisinau","name":"(GMT+02:00) Chisinau","utc":"+02:00","showInList":true},{"label":"Europe/Helsinki (GMT+02:00)","tzCode":"Europe/Helsinki","name":"(GMT+02:00) Helsinki","utc":"+02:00","showInList":true},{"label":"Europe/Kaliningrad (GMT+02:00)","tzCode":"Europe/Kaliningrad","name":"(GMT+02:00) Kaliningrad","utc":"+02:00","showInList":true},{"label":"Europe/Kiev (GMT+02:00)","tzCode":"Europe/Kiev","name":"(GMT+02:00) Kyiv","utc":"+02:00","showInList":true},{"label":"Europe/Mariehamn (GMT+02:00)","tzCode":"Europe/Mariehamn","name":"(GMT+02:00) Mariehamn","utc":"+02:00"},{"label":"Europe/Riga (GMT+02:00)","tzCode":"Europe/Riga","name":"(GMT+02:00) Riga","utc":"+02:00","showInList":true},{"label":"Europe/Sofia (GMT+02:00)","tzCode":"Europe/Sofia","name":"(GMT+02:00) Sofia","utc":"+02:00","showInList":true},{"label":"Europe/Tallinn (GMT+02:00)","tzCode":"Europe/Tallinn","name":"(GMT+02:00) Tallinn","utc":"+02:00","showInList":true},{"label":"Europe/Uzhgorod (GMT+02:00)","tzCode":"Europe/Uzhgorod","name":"(GMT+02:00) Uzhgorod","utc":"+02:00"},{"label":"Europe/Vilnius (GMT+02:00)","tzCode":"Europe/Vilnius","name":"(GMT+02:00) Vilnius","utc":"+02:00","showInList":true},{"label":"Europe/Zaporozhye (GMT+02:00)","tzCode":"Europe/Zaporozhye","name":"(GMT+02:00) Luhansk","utc":"+02:00"},{"label":"Africa/Addis_Ababa (GMT+03:00)","tzCode":"Africa/Addis_Ababa","name":"(GMT+03:00) Addis Ababa","utc":"+03:00"},{"label":"Africa/Asmara (GMT+03:00)","tzCode":"Africa/Asmara","name":"(GMT+03:00) Asmara","utc":"+03:00"},{"label":"Africa/Dar_es_Salaam (GMT+03:00)","tzCode":"Africa/Dar_es_Salaam","name":"(GMT+03:00) Dar es Salaam","utc":"+03:00"},{"label":"Africa/Djibouti (GMT+03:00)","tzCode":"Africa/Djibouti","name":"(GMT+03:00) Djibouti","utc":"+03:00"},{"label":"Africa/Kampala (GMT+03:00)","tzCode":"Africa/Kampala","name":"(GMT+03:00) Kampala","utc":"+03:00"},{"label":"Africa/Mogadishu (GMT+03:00)","tzCode":"Africa/Mogadishu","name":"(GMT+03:00) Mogadishu","utc":"+03:00"},{"label":"Africa/Nairobi (GMT+03:00)","tzCode":"Africa/Nairobi","name":"(GMT+03:00) Nairobi","utc":"+03:00","showInList":true},{"label":"Antarctica/Syowa (GMT+03:00)","tzCode":"Antarctica/Syowa","name":"(GMT+03:00) Syowa","utc":"+03:00"},{"label":"Asia/Aden (GMT+03:00)","tzCode":"Asia/Aden","name":"(GMT+03:00) Sanaa","utc":"+03:00"},{"label":"Asia/Baghdad (GMT+03:00)","tzCode":"Asia/Baghdad","name":"(GMT+03:00) Baghdad","utc":"+03:00","showInList":true},{"label":"Asia/Bahrain (GMT+03:00)","tzCode":"Asia/Bahrain","name":"(GMT+03:00) Manama","utc":"+03:00"},{"label":"Asia/Kuwait (GMT+03:00)","tzCode":"Asia/Kuwait","name":"(GMT+03:00) Al Aḩmadī","utc":"+03:00","showInList":true},{"label":"Asia/Qatar (GMT+03:00)","tzCode":"Asia/Qatar","name":"(GMT+03:00) Doha","utc":"+03:00"},{"label":"Asia/Riyadh (GMT+03:00)","tzCode":"Asia/Riyadh","name":"(GMT+03:00) Riyadh","utc":"+03:00","showInList":true},{"label":"Europe/Istanbul (GMT+03:00)","tzCode":"Europe/Istanbul","name":"(GMT+03:00) Istanbul","utc":"+03:00","showInList":true},{"label":"Europe/Kirov (GMT+03:00)","tzCode":"Europe/Kirov","name":"(GMT+03:00) Kirov","utc":"+03:00"},{"label":"Europe/Minsk (GMT+03:00)","tzCode":"Europe/Minsk","name":"(GMT+03:00) Minsk","utc":"+03:00","showInList":true},{"label":"Europe/Moscow (GMT+03:00)","tzCode":"Europe/Moscow","name":"(GMT+03:00) Moscow, St. Petersburg","utc":"+03:00","showInList":true},{"label":"Europe/Simferopol (GMT+03:00)","tzCode":"Europe/Simferopol","name":"(GMT+03:00) Simferopol","utc":"+03:00"},{"label":"Europe/Volgograd (GMT+03:00)","tzCode":"Europe/Volgograd","name":"(GMT+03:00) Volgograd","utc":"+03:00","showInList":true},{"label":"Indian/Antananarivo (GMT+03:00)","tzCode":"Indian/Antananarivo","name":"(GMT+03:00) Antananarivo","utc":"+03:00"},{"label":"Indian/Comoro (GMT+03:00)","tzCode":"Indian/Comoro","name":"(GMT+03:00) Moroni","utc":"+03:00"},{"label":"Indian/Mayotte (GMT+03:00)","tzCode":"Indian/Mayotte","name":"(GMT+03:00) Mamoudzou","utc":"+03:00"},{"label":"Asia/Tehran (GMT+03:30)","tzCode":"Asia/Tehran","name":"(GMT+03:30) Tehran","utc":"+03:30","showInList":true},{"label":"Asia/Baku (GMT+04:00)","tzCode":"Asia/Baku","name":"(GMT+04:00) Baku","utc":"+04:00","showInList":true},{"label":"Asia/Dubai (GMT+04:00)","tzCode":"Asia/Dubai","name":"(GMT+04:00) Dubai","utc":"+04:00","showInList":true},{"label":"Asia/Muscat (GMT+04:00)","tzCode":"Asia/Muscat","name":"(GMT+04:00) Muscat","utc":"+04:00","showInList":true},{"label":"Asia/Tbilisi (GMT+04:00)","tzCode":"Asia/Tbilisi","name":"(GMT+04:00) Tbilisi","utc":"+04:00","showInList":true},{"label":"Asia/Yerevan (GMT+04:00)","tzCode":"Asia/Yerevan","name":"(GMT+04:00) Yerevan","utc":"+04:00","showInList":true},{"label":"Europe/Astrakhan (GMT+04:00)","tzCode":"Europe/Astrakhan","name":"(GMT+04:00) Astrakhan","utc":"+04:00","showInList":true},{"label":"Europe/Samara (GMT+04:00)","tzCode":"Europe/Samara","name":"(GMT+04:00) Samara","utc":"+04:00","showInList":true},{"label":"Europe/Saratov (GMT+04:00)","tzCode":"Europe/Saratov","name":"(GMT+04:00) Saratov","utc":"+04:00","showInList":true},{"label":"Europe/Ulyanovsk (GMT+04:00)","tzCode":"Europe/Ulyanovsk","name":"(GMT+04:00) Ulyanovsk","utc":"+04:00","showInList":true},{"label":"Indian/Mahe (GMT+04:00)","tzCode":"Indian/Mahe","name":"(GMT+04:00) Victoria","utc":"+04:00"},{"label":"Indian/Mauritius (GMT+04:00)","tzCode":"Indian/Mauritius","name":"(GMT+04:00) Port Louis","utc":"+04:00","showInList":true},{"label":"Indian/Reunion (GMT+04:00)","tzCode":"Indian/Reunion","name":"(GMT+04:00) Saint-Denis","utc":"+04:00"},{"label":"Asia/Kabul (GMT+04:30)","tzCode":"Asia/Kabul","name":"(GMT+04:30) Kabul","utc":"+04:30","showInList":true},{"label":"Antarctica/Mawson (GMT+05:00)","tzCode":"Antarctica/Mawson","name":"(GMT+05:00) Mawson","utc":"+05:00"},{"label":"Asia/Aqtau (GMT+05:00)","tzCode":"Asia/Aqtau","name":"(GMT+05:00) Shevchenko","utc":"+05:00"},{"label":"Asia/Aqtobe (GMT+05:00)","tzCode":"Asia/Aqtobe","name":"(GMT+05:00) Aktobe","utc":"+05:00"},{"label":"Asia/Ashgabat (GMT+05:00)","tzCode":"Asia/Ashgabat","name":"(GMT+05:00) Ashgabat","utc":"+05:00","showInList":true},{"label":"Asia/Atyrau (GMT+05:00)","tzCode":"Asia/Atyrau","name":"(GMT+05:00) Atyrau","utc":"+05:00"},{"label":"Asia/Dushanbe (GMT+05:00)","tzCode":"Asia/Dushanbe","name":"(GMT+05:00) Dushanbe","utc":"+05:00"},{"label":"Asia/Karachi (GMT+05:00)","tzCode":"Asia/Karachi","name":"(GMT+05:00) Karachi","utc":"+05:00","showInList":true},{"label":"Asia/Oral (GMT+05:00)","tzCode":"Asia/Oral","name":"(GMT+05:00) Oral","utc":"+05:00"},{"label":"Asia/Qyzylorda (GMT+05:00)","tzCode":"Asia/Qyzylorda","name":"(GMT+05:00) Kyzylorda","utc":"+05:00","showInList":true},{"label":"Asia/Samarkand (GMT+05:00)","tzCode":"Asia/Samarkand","name":"(GMT+05:00) Samarkand","utc":"+05:00"},{"label":"Asia/Tashkent (GMT+05:00)","tzCode":"Asia/Tashkent","name":"(GMT+05:00) Tashkent","utc":"+05:00","showInList":true},{"label":"Asia/Yekaterinburg (GMT+05:00)","tzCode":"Asia/Yekaterinburg","name":"(GMT+05:00) Yekaterinburg","utc":"+05:00","showInList":true},{"label":"Indian/Kerguelen (GMT+05:00)","tzCode":"Indian/Kerguelen","name":"(GMT+05:00) Port-aux-Français","utc":"+05:00"},{"label":"Indian/Maldives (GMT+05:00)","tzCode":"Indian/Maldives","name":"(GMT+05:00) Male","utc":"+05:00"},{"label":"Asia/Colombo (GMT+05:30)","tzCode":"Asia/Colombo","name":"(GMT+05:30) Colombo","utc":"+05:30","showInList":true},{"label":"Asia/Kolkata (GMT+05:30)","tzCode":"Asia/Kolkata","name":"(GMT+05:30) Mumbai","utc":"+05:30","showInList":true},{"label":"Asia/Kathmandu (GMT+05:45)","tzCode":"Asia/Kathmandu","name":"(GMT+05:45) Kathmandu","utc":"+05:45","showInList":true},{"label":"Antarctica/Vostok (GMT+06:00)","tzCode":"Antarctica/Vostok","name":"(GMT+06:00) Vostok","utc":"+06:00"},{"label":"Asia/Almaty (GMT+06:00)","tzCode":"Asia/Almaty","name":"(GMT+06:00) Almaty","utc":"+06:00","showInList":true},{"label":"Asia/Bishkek (GMT+06:00)","tzCode":"Asia/Bishkek","name":"(GMT+06:00) Bishkek","utc":"+06:00"},{"label":"Asia/Dhaka (GMT+06:00)","tzCode":"Asia/Dhaka","name":"(GMT+06:00) Dhaka","utc":"+06:00","showInList":true},{"label":"Asia/Omsk (GMT+06:00)","tzCode":"Asia/Omsk","name":"(GMT+06:00) Omsk","utc":"+06:00","showInList":true},{"label":"Asia/Qostanay (GMT+06:00)","tzCode":"Asia/Qostanay","name":"(GMT+06:00) Kostanay","utc":"+06:00"},{"label":"Asia/Thimphu (GMT+06:00)","tzCode":"Asia/Thimphu","name":"(GMT+06:00) himphu","utc":"+06:00"},{"label":"Asia/Urumqi (GMT+06:00)","tzCode":"Asia/Urumqi","name":"(GMT+08:00) Urumqi","utc":"+08:00","showInList":true},{"label":"Indian/Chagos (GMT+06:00)","tzCode":"Indian/Chagos","name":"(GMT+06:00) British Indian Ocean Territory","utc":"+06:00"},{"label":"Asia/Yangon (GMT+06:30)","tzCode":"Asia/Yangon","name":"(GMT+06:30) Yangon","utc":"+06:30","showInList":true},{"label":"Indian/Cocos (GMT+06:30)","tzCode":"Indian/Cocos","name":"(GMT+06:30) West Island","utc":"+06:30"},{"label":"Antarctica/Davis (GMT+07:00)","tzCode":"Antarctica/Davis","name":"(GMT+07:00) Davis","utc":"+07:00"},{"label":"Asia/Bangkok (GMT+07:00)","tzCode":"Asia/Bangkok","name":"(GMT+07:00) Bangkok","utc":"+07:00","showInList":true},{"label":"Asia/Barnaul (GMT+07:00)","tzCode":"Asia/Barnaul","name":"(GMT+07:00) Barnaul","utc":"+07:00","showInList":true},{"label":"Asia/Hovd (GMT+07:00)","tzCode":"Asia/Hovd","name":"(GMT+07:00) Khovd","utc":"+07:00","showInList":true},{"label":"Asia/Ho_Chi_Minh (GMT+07:00)","tzCode":"Asia/Ho_Chi_Minh","name":"(GMT+07:00) Ho Chi Minh City","utc":"+07:00"},{"label":"Asia/Jakarta (GMT+07:00)","tzCode":"Asia/Jakarta","name":"(GMT+07:00) Jakarta","utc":"+07:00","showInList":true},{"label":"Asia/Krasnoyarsk (GMT+07:00)","tzCode":"Asia/Krasnoyarsk","name":"(GMT+07:00) Krasnoyarsk","utc":"+07:00","showInList":true},{"label":"Asia/Novokuznetsk (GMT+07:00)","tzCode":"Asia/Novokuznetsk","name":"(GMT+07:00) Novokuznetsk","utc":"+07:00"},{"label":"Asia/Novosibirsk (GMT+07:00)","tzCode":"Asia/Novosibirsk","name":"(GMT+07:00) Novosibirsk","utc":"+07:00","showInList":true},{"label":"Asia/Phnom_Penh (GMT+07:00)","tzCode":"Asia/Phnom_Penh","name":"(GMT+07:00) Phnom Penh","utc":"+07:00"},{"label":"Asia/Pontianak (GMT+07:00)","tzCode":"Asia/Pontianak","name":"(GMT+07:00) Pontianak","utc":"+07:00"},{"label":"Asia/Tomsk (GMT+07:00)","tzCode":"Asia/Tomsk","name":"(GMT+07:00) Tomsk","utc":"+07:00","showInList":true},{"label":"Asia/Vientiane (GMT+07:00)","tzCode":"Asia/Vientiane","name":"(GMT+07:00) Vientiane","utc":"+07:00"},{"label":"Indian/Christmas (GMT+07:00)","tzCode":"Indian/Christmas","name":"(GMT+07:00) Flying Fish Cove","utc":"+07:00"},{"label":"Asia/Brunei (GMT+08:00)","tzCode":"Asia/Brunei","name":"(GMT+08:00) Bandar Seri Begawan","utc":"+08:00"},{"label":"Asia/Choibalsan (GMT+08:00)","tzCode":"Asia/Choibalsan","name":"(GMT+08:00) Baruun-Urt","utc":"+08:00"},{"label":"Asia/Hong_Kong (GMT+08:00)","tzCode":"Asia/Hong_Kong","name":"(GMT+08:00) Hong Kong","utc":"+08:00","showInList":true},{"label":"Asia/Irkutsk (GMT+08:00)","tzCode":"Asia/Irkutsk","name":"(GMT+08:00) Irkutsk","utc":"+08:00","showInList":true},{"label":"Asia/Kuala_Lumpur (GMT+08:00)","tzCode":"Asia/Kuala_Lumpur","name":"(GMT+08:00) Kota Bharu","utc":"+08:00","showInList":true},{"label":"Asia/Kuching (GMT+08:00)","tzCode":"Asia/Kuching","name":"(GMT+08:00) Kuching","utc":"+08:00"},{"label":"Asia/Macau (GMT+08:00)","tzCode":"Asia/Macau","name":"(GMT+08:00) Macau","utc":"+08:00"},{"label":"Asia/Makassar (GMT+08:00)","tzCode":"Asia/Makassar","name":"(GMT+08:00) Makassar","utc":"+08:00"},{"label":"Asia/Manila (GMT+08:00)","tzCode":"Asia/Manila","name":"(GMT+08:00) Quezon City","utc":"+08:00"},{"label":"Asia/Shanghai (GMT+08:00)","tzCode":"Asia/Shanghai","name":"(GMT+08:00) Shanghai","utc":"+08:00"},{"label":"Asia/Singapore (GMT+08:00)","tzCode":"Asia/Singapore","name":"(GMT+08:00) Singapore","utc":"+08:00","showInList":true},{"label":"Asia/Taipei (GMT+08:00)","tzCode":"Asia/Taipei","name":"(GMT+08:00) Taipei","utc":"+08:00","showInList":true},{"label":"Asia/Ulaanbaatar (GMT+08:00)","tzCode":"Asia/Ulaanbaatar","name":"(GMT+08:00) Ulan Bator","utc":"+08:00","showInList":true},{"label":"Australia/Perth (GMT+08:00)","tzCode":"Australia/Perth","name":"(GMT+08:00) Perth","utc":"+08:00","showInList":true},{"label":"Australia/Eucla (GMT+08:45)","tzCode":"Australia/Eucla","name":"(GMT+08:45) Eucla","utc":"+08:45","showInList":true},{"label":"Asia/Chita (GMT+09:00)","tzCode":"Asia/Chita","name":"(GMT+09:00) Chita","utc":"+09:00","showInList":true},{"label":"Asia/Dili (GMT+09:00)","tzCode":"Asia/Dili","name":"(GMT+09:00) Dili","utc":"+09:00"},{"label":"Asia/Jayapura (GMT+09:00)","tzCode":"Asia/Jayapura","name":"(GMT+09:00) Ambon","utc":"+09:00"},{"label":"Asia/Khandyga (GMT+09:00)","tzCode":"Asia/Khandyga","name":"(GMT+09:00) Khandyga","utc":"+09:00"},{"label":"Asia/Pyongyang (GMT+09:00)","tzCode":"Asia/Pyongyang","name":"(GMT+09:00) Pyongyang","utc":"+09:00","showInList":true},{"label":"Asia/Seoul (GMT+09:00)","tzCode":"Asia/Seoul","name":"(GMT+09:00) Seoul","utc":"+09:00","showInList":true},{"label":"Asia/Tokyo (GMT+09:00)","tzCode":"Asia/Tokyo","name":"(GMT+09:00) Tokyo, Osaka, Sapporo","utc":"+09:00","showInList":true},{"label":"Asia/Yakutsk (GMT+09:00)","tzCode":"Asia/Yakutsk","name":"(GMT+09:00) Yakutsk","utc":"+09:00","showInList":true},{"label":"Pacific/Palau (GMT+09:00)","tzCode":"Pacific/Palau","name":"(GMT+09:00) Koror","utc":"+09:00"},{"label":"Australia/Adelaide (GMT+09:30)","tzCode":"Australia/Adelaide","name":"(GMT+09:30) Adelaide","utc":"+09:30","showInList":true},{"label":"Australia/Broken_Hill (GMT+09:30)","tzCode":"Australia/Broken_Hill","name":"(GMT+09:30) Broken Hill","utc":"+09:30"},{"label":"Australia/Darwin (GMT+09:30)","tzCode":"Australia/Darwin","name":"(GMT+09:30) Darwin","utc":"+09:30","showInList":true},{"label":"Antarctica/DumontDUrville (GMT+10:00)","tzCode":"Antarctica/DumontDUrville","name":"(GMT+10:00) DumontDUrville","utc":"+10:00"},{"label":"Antarctica/Macquarie (GMT+10:00)","tzCode":"Antarctica/Macquarie","name":"(GMT+10:00) Macquarie","utc":"+10:00"},{"label":"Asia/Ust-Nera (GMT+10:00)","tzCode":"Asia/Ust-Nera","name":"(GMT+10:00) Ust-Nera","utc":"+10:00"},{"label":"Asia/Vladivostok (GMT+10:00)","tzCode":"Asia/Vladivostok","name":"(GMT+10:00) Vladivostok","utc":"+10:00","showInList":true},{"label":"Australia/Brisbane (GMT+10:00)","tzCode":"Australia/Brisbane","name":"(GMT+10:00) Brisbane","utc":"+10:00","showInList":true},{"label":"Australia/Currie (GMT+10:00)","tzCode":"Australia/Currie","name":"(GMT+10:00) Currie","utc":"+10:00"},{"label":"Australia/Hobart (GMT+10:00)","tzCode":"Australia/Hobart","name":"(GMT+10:00) Hobart","utc":"+10:00","showInList":true},{"label":"Australia/Lindeman (GMT+10:00)","tzCode":"Australia/Lindeman","name":"(GMT+10:00) Lindeman","utc":"+10:00"},{"label":"Australia/Melbourne (GMT+10:00)","tzCode":"Australia/Melbourne","name":"(GMT+10:00) Melbourne","utc":"+10:00","showInList":true},{"label":"Australia/Sydney (GMT+10:00)","tzCode":"Australia/Sydney","name":"(GMT+10:00) Sydney","utc":"+10:00","showInList":true},{"label":"Pacific/Chuuk (GMT+10:00)","tzCode":"Pacific/Chuuk","name":"(GMT+10:00) Weno","utc":"+10:00","showInList":true},{"label":"Pacific/Guam (GMT+10:00)","tzCode":"Pacific/Guam","name":"(GMT+10:00) Dededo Village","utc":"+10:00","showInList":true},{"label":"Pacific/Port_Moresby (GMT+10:00)","tzCode":"Pacific/Port_Moresby","name":"(GMT+10:00) Port Moresby","utc":"+10:00","showInList":true},{"label":"Pacific/Saipan (GMT+10:00)","tzCode":"Pacific/Saipan","name":"(GMT+10:00) Saipan","utc":"+10:00"},{"label":"Australia/Lord_Howe (GMT+10:30)","tzCode":"Australia/Lord_Howe","name":"(GMT+10:30) Lord Howe","utc":"+10:30","showInList":true},{"label":"Antarctica/Casey (GMT+11:00)","tzCode":"Antarctica/Casey","name":"(GMT+11:00) Casey","utc":"+11:00"},{"label":"Asia/Magadan (GMT+11:00)","tzCode":"Asia/Magadan","name":"(GMT+11:00) Magadan","utc":"+11:00","showInList":true},{"label":"Asia/Sakhalin (GMT+11:00)","tzCode":"Asia/Sakhalin","name":"(GMT+11:00) Yuzhno-Sakhalinsk","utc":"+11:00","showInList":true},{"label":"Asia/Srednekolymsk (GMT+11:00)","tzCode":"Asia/Srednekolymsk","name":"(GMT+11:00) Srednekolymsk","utc":"+11:00"},{"label":"Pacific/Bougainville (GMT+11:00)","tzCode":"Pacific/Bougainville","name":"(GMT+11:00) Arawa","utc":"+11:00","showInList":true},{"label":"Pacific/Efate (GMT+11:00)","tzCode":"Pacific/Efate","name":"(GMT+11:00) Port-Vila","utc":"+11:00"},{"label":"Pacific/Guadalcanal (GMT+11:00)","tzCode":"Pacific/Guadalcanal","name":"(GMT+11:00) Honiara","utc":"+11:00"},{"label":"Pacific/Kosrae (GMT+11:00)","tzCode":"Pacific/Kosrae","name":"(GMT+11:00) Tofol","utc":"+11:00"},{"label":"Pacific/Norfolk (GMT+11:00)","tzCode":"Pacific/Norfolk","name":"(GMT+11:00) Kingston","utc":"+11:00","showInList":true},{"label":"Pacific/Noumea (GMT+11:00)","tzCode":"Pacific/Noumea","name":"(GMT+11:00) Nouméa","utc":"+11:00"},{"label":"Pacific/Pohnpei (GMT+11:00)","tzCode":"Pacific/Pohnpei","name":"(GMT+11:00) Kolonia","utc":"+11:00"},{"label":"Antarctica/McMurdo (GMT+12:00)","tzCode":"Antarctica/McMurdo","name":"(GMT+12:00) McMurdo","utc":"+12:00"},{"label":"Asia/Anadyr (GMT+12:00)","tzCode":"Asia/Anadyr","name":"(GMT+12:00) Anadyr","utc":"+12:00","showInList":true},{"label":"Asia/Kamchatka (GMT+12:00)","tzCode":"Asia/Kamchatka","name":"(GMT+12:00) Petropavlovsk-Kamchatsky","utc":"+12:00"},{"label":"Pacific/Auckland (GMT+12:00)","tzCode":"Pacific/Auckland","name":"(GMT+12:00) Auckland","utc":"+12:00","showInList":true},{"label":"Pacific/Fiji (GMT+12:00)","tzCode":"Pacific/Fiji","name":"(GMT+12:00) Suva","utc":"+12:00","showInList":true},{"label":"Pacific/Funafuti (GMT+12:00)","tzCode":"Pacific/Funafuti","name":"(GMT+12:00) Funafuti","utc":"+12:00"},{"label":"Pacific/Kwajalein (GMT+12:00)","tzCode":"Pacific/Kwajalein","name":"(GMT+12:00) Ebaye","utc":"+12:00"},{"label":"Pacific/Majuro (GMT+12:00)","tzCode":"Pacific/Majuro","name":"(GMT+12:00) Majuro","utc":"+12:00"},{"label":"Pacific/Nauru (GMT+12:00)","tzCode":"Pacific/Nauru","name":"(GMT+12:00) Yaren","utc":"+12:00"},{"label":"Pacific/Tarawa (GMT+12:00)","tzCode":"Pacific/Tarawa","name":"(GMT+12:00) Tarawa","utc":"+12:00"},{"label":"Pacific/Wake (GMT+12:00)","tzCode":"Pacific/Wake","name":"(GMT+12:00) Wake","utc":"+12:00"},{"label":"Pacific/Wallis (GMT+12:00)","tzCode":"Pacific/Wallis","name":"(GMT+12:00) Mata-Utu","utc":"+12:00"},{"label":"Pacific/Chatham (GMT+12:45)","tzCode":"Pacific/Chatham","name":"(GMT+12:45) Waitangi","utc":"+12:45","showInList":true},{"label":"Pacific/Apia (GMT+13:00)","tzCode":"Pacific/Apia","name":"(GMT+13:00) Apia","utc":"+13:00","showInList":true},{"label":"Pacific/Enderbury (GMT+13:00)","tzCode":"Pacific/Enderbury","name":"(GMT+13:00) Enderbury","utc":"+13:00"},{"label":"Pacific/Fakaofo (GMT+13:00)","tzCode":"Pacific/Fakaofo","name":"(GMT+13:00) Atafu Village","utc":"+13:00"},{"label":"Pacific/Tongatapu (GMT+13:00)","tzCode":"Pacific/Tongatapu","name":"(GMT+13:00) Nuku‘alofa","utc":"+13:00","showInList":true},{"label":"Pacific/Kiritimati (GMT+14:00)","tzCode":"Pacific/Kiritimati","name":"(GMT+14:00) Kiritimati","utc":"+14:00","showInList":true}]');
;// CONCATENATED MODULE: ./src/libs/timezone/timezonesList.ts
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}


const localTimezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
const timezonesList = timezones_namespaceObject.filter(({ showInList , tzCode  })=>showInList || tzCode === localTimezone).map((tz)=>{
    try {
        const offsetInMinutes = (0,time/* getOffset */.os)(tz.tzCode);
        const plus = offsetInMinutes >= 0;
        const offsetInHours = Math.abs(offsetInMinutes / 60);
        const fullHours = Math.floor(offsetInHours);
        const hoursString = ("00" + fullHours).slice(-2);
        const floatHours = offsetInHours - fullHours;
        const minutesString = ("00" + floatHours * 60).slice(-2);
        return _object_spread_props(_object_spread({}, tz), {
            offsetInMinutes,
            utc: `${plus ? "+" : "-"}${hoursString}:${minutesString}`
        });
    } catch (e) {
        // normally this should not happen, js supports all timezones that we are currently using
        console.error("some of timezone codes in timezones.json file could obsolete");
        const [utcHours, utcMinutes] = tz.utc.slice(1).split(":");
        return _object_spread({
            offsetInMinutes: Number(utcHours) * 60 + Number(utcMinutes)
        }, tz);
    }
}).sort((tzA, tzB)=>tzA.offsetInMinutes - tzB.offsetInMinutes);


/***/ }),

/***/ 95520:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "AD": () => (/* binding */ eventsConstants),
/* harmony export */   "FZ": () => (/* binding */ setupLogger),
/* harmony export */   "Kz": () => (/* binding */ logEvent),
/* harmony export */   "iE": () => (/* binding */ getConfig),
/* harmony export */   "q_": () => (/* binding */ isThirdPartyEditMode)
/* harmony export */ });
/* harmony import */ var service__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(89880);
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85295);
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(21618);
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}


function logEvent(text, p) {
    return _logEvent.apply(this, arguments);
}
function _logEvent() {
    _logEvent = _async_to_generator(function*(text, p) {
        const logger = yield (0,service__WEBPACK_IMPORTED_MODULE_0__/* .resolveService */ .f)("logger");
        logger.event(text, p);
    });
    return _logEvent.apply(this, arguments);
}
function setupLogger(pendoP, fullstoryP, intercomP, errorReporterP, datadogP) {
    return _setupLogger.apply(this, arguments);
}
function _setupLogger() {
    _setupLogger = _async_to_generator(function*(pendoP, fullstoryP, intercomP, errorReporterP, datadogP) {
        const errorReporterd = yield errorReporterP;
        const pendo = yield pendoP;
        const fullstory = yield fullstoryP;
        const intercom = yield intercomP;
        const datadog = yield datadogP;
        function trackEvent(name, vars) {
            return _trackEvent.apply(this, arguments);
        }
        function _trackEvent() {
            _trackEvent = _async_to_generator(function*(name, vars) {
                try {
                    pendo.track(name, vars);
                    fullstory.event(name, vars);
                    intercom("trackEvent", name, vars);
                    datadog === null || datadog === void 0 ? void 0 : datadog.addAction(name, vars);
                } catch (e) {
                    errorReporterd.report(e);
                    console.error(e);
                }
            });
            return _trackEvent.apply(this, arguments);
        }
        return {
            event: trackEvent,
            error: (args)=>errorReporterd.report(args, {
                    skipLocalFrames: 2
                })
        };
    });
    return _setupLogger.apply(this, arguments);
}
function getConfig(user, customerProps) {
    const userId = `${user.id}_${customerProps.id}`;
    const userProps = {
        id: userId,
        customer: customerProps.id,
        email: user.email
    };
    return {
        visitor: userProps,
        account: customerProps,
        excludeAllText: true,
        excludeTitle: true,
        guides: {
            disable: false
        }
    };
}
const isPendoDesignerRequested = window.location.search.indexOf("pendo-designer") !== -1;
// This function checks if pendo or intercom edit mode is active at this moment.
// We're disabling MUI Dialog modal focus enforcement in such cases, otherwise edit mode won't work.
function isThirdPartyEditMode() {
    return isPendoDesignerRequested || document.querySelectorAll("body > #pendo-action-bar-container, body > #intersection-container").length > 0;
}
function mapKeys(obj, prefix) {
    const fullPrefix = prefix ? prefix + " / " : "";
    return Object.entries(obj).reduce((res, [key, value])=>{
        res[key] = typeof value === "object" ? mapKeys(value, fullPrefix + (value[".."] || (0,lodash__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)((0,lodash__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(key)))) : fullPrefix + (value || (0,lodash__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)((0,lodash__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(key)));
        return res;
    }, {});
}
const CRUD = {
    create: "",
    update: "",
    delete: ""
};
/* Events are logged for analytics purposes, in addition to clicks.
   Please use events for things that change data, like creating a dataset
   (usually such events cause changes on the backend), or events that are
   important for "marking" users as thouse who accomplished a milestone.
   Otherwise, prefer tracking clicks through data-testid. */ const eventsConstants = mapKeys({
    // Authentication
    auth: {
        login: "",
        logout: ""
    },
    // Graph
    graph: {
        "..": "Map",
        "search": {
            performSearch: "",
            templates: _object_spread_props(_object_spread({}, CRUD), {
                updateMonitoring: ""
            })
        }
    },
    // Reports
    reports: _object_spread_props(_object_spread({}, CRUD), {
        addChart: "",
        removeChart: ""
    }),
    // Risks dashboard
    dashboard: {
        datasets: CRUD,
        categories: CRUD
    },
    // Preferences
    preferences: {
        users: _object_spread_props(_object_spread({}, CRUD), {
            inviteUser: "",
            updatePassword: ""
        }),
        betas: {
            feature: ""
        },
        timezone: {
            rules: CRUD
        },
        contentInspection: {
            rules: CRUD
        },
        definitionOfInternal: {
            rules: CRUD
        },
        directory: _object_spread({}, CRUD)
    },
    incidents: {
        markAs: "",
        bulkMarkAs: "",
        viewDetails: "",
        assignTo: "",
        bultAssignTo: ""
    },
    // Listview (in multiple pages)
    listView: {
        // unfortunately we can't track this with clicks due to auto-expanding
        viewFlowDetails: ""
    }
});


/***/ }),

/***/ 44759:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "mI": () => (/* binding */ useDefaultProviderAvailabilityUpdate),
  "EK": () => (/* binding */ useDefaultProviders),
  "_u": () => (/* binding */ useDefaultProvidersList),
  "pO": () => (/* binding */ useForgotPassword),
  "p0": () => (/* binding */ useGlobalAuthSettings),
  "Rc": () => (/* binding */ useGlobalAuthSettingsUpdate),
  "f0": () => (/* binding */ useLogin),
  "Zo": () => (/* binding */ useLoginWithRedirect),
  "Qf": () => (/* binding */ usePasswordProviderMFAUpdate),
  "b4": () => (/* binding */ useSAMLProviderCreate),
  "UU": () => (/* binding */ useSAMLProviderDelete),
  "ts": () => (/* binding */ useSAMLProviderUpdate),
  "vI": () => (/* binding */ useSAMLProviders),
  "aF": () => (/* binding */ useSAMLProvidersList),
  "QS": () => (/* binding */ useSignUp)
});

// EXTERNAL MODULE: ./node_modules/react-query/es/index.js + 22 modules
var es = __webpack_require__(21478);
// EXTERNAL MODULE: ./src/service.tsx
var service = __webpack_require__(89880);
// EXTERNAL MODULE: ./node_modules/axios/index.js
var axios = __webpack_require__(9669);
var axios_default = /*#__PURE__*/__webpack_require__.n(axios);
// EXTERNAL MODULE: ./node_modules/react-router/dist/index.js
var dist = __webpack_require__(89250);
// EXTERNAL MODULE: ./src/app/setupVersionCheck.ts
var setupVersionCheck = __webpack_require__(80157);
// EXTERNAL MODULE: ./src/api/index.ts
var api = __webpack_require__(62688);
// EXTERNAL MODULE: ./src/modules/notification/index.ts + 3 modules
var notification = __webpack_require__(5769);
;// CONCATENATED MODULE: ./src/api/auth/interfaces/User.ts
const EUserRole = {
    INACTIVE: "inactive"
};

;// CONCATENATED MODULE: ./src/api/auth/interfaces/index.ts






// EXTERNAL MODULE: ./src/api/auth/storage.ts
var storage = __webpack_require__(86758);
// EXTERNAL MODULE: ./src/modules/preferences/state.ts
var state = __webpack_require__(86965);
// EXTERNAL MODULE: ./src/modules/analytics/Analytics.ts
var Analytics = __webpack_require__(95520);
// EXTERNAL MODULE: ./src/api/graphql/network.ts
var network = __webpack_require__(48863);
// EXTERNAL MODULE: ./src/api/graphql/index.ts + 1 modules
var graphql = __webpack_require__(37137);
// EXTERNAL MODULE: ./src/modules/auth/effects.ts
var effects = __webpack_require__(77805);
// EXTERNAL MODULE: ./src/modules/auth/messages.ts
var messages = __webpack_require__(23456);
;// CONCATENATED MODULE: ./src/modules/auth/apiHooks.ts
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}















function useSignUp(email) {
    const navigate = (0,dist/* useNavigate */.s0)();
    return (0,es/* useMutation */.Db)(function() {
        var _ref = _async_to_generator(function*({ type , values , cloud , params  }) {
            const svc = yield (0,service/* resolveService */.f)("authService");
            try {
                const currentUser = yield svc.getCurrentUser();
                if (!currentUser) {
                    yield svc.signInWithEmailLink(email);
                }
            } catch (e) {
                handleLoginError(svc, e, /*#__PURE__*/ _async_to_generator(function*() {
                    yield postSignUpSetup(svc, type, cloud, params, values);
                }));
                if (e.code !== "auth/multi-factor-auth-required") {
                    yield svc.logout();
                }
                throw e;
            }
            return yield postSignUpSetup(svc, type, cloud, params, values);
        });
        return function(_) {
            return _ref.apply(this, arguments);
        };
    }(), {
        onSuccess () {
            notification/* notification.open */.t6.open({
                message: messages/* messages.notifications.signUpSuccess */.s.notifications.signUpSuccess
            });
            navigate("/login");
        }
    });
    function postSignUpSetup(svc, type, cloud, params, values) {
        return _postSignUpSetup.apply(this, arguments);
    }
    function _postSignUpSetup() {
        _postSignUpSetup = _async_to_generator(function*(svc, type, cloud, params, values) {
            yield svc.unlinkAll();
            const p = type === "cloud" ? svc.linkCloudProvider(cloud, params) : svc.linkCredentials(values);
            return p.then(signup).then(()=>svc.refreshToken()).catch(function() {
                var _ref = _async_to_generator(function*(el) {
                    var _el_response, _el_response_data, _el_response_data_detail, _el_response1, _el_response_data1, _el_response_data_detail1;
                    if (el.code === "auth/provider-already-linked") {
                        notification/* notification.open */.t6.open({
                            message: el.message + " Please visit login page."
                        });
                        navigate("/login");
                    } else if ((el === null || el === void 0 ? void 0 : (_el_response = el.response) === null || _el_response === void 0 ? void 0 : (_el_response_data = _el_response.data) === null || _el_response_data === void 0 ? void 0 : (_el_response_data_detail = _el_response_data.detail) === null || _el_response_data_detail === void 0 ? void 0 : _el_response_data_detail.Code) === "invalid-email") {
                        el.message = el.response.data.message;
                        var _el_response_data_message;
                        notification/* notification.error */.t6.error({
                            props: {
                                autoHideDuration: 10000
                            },
                            message: (_el_response_data_message = el.response.data.message) !== null && _el_response_data_message !== void 0 ? _el_response_data_message : el.message
                        });
                        yield svc.unlinkAll();
                    } else if (((_el_response1 = el.response) === null || _el_response1 === void 0 ? void 0 : (_el_response_data1 = _el_response1.data) === null || _el_response_data1 === void 0 ? void 0 : (_el_response_data_detail1 = _el_response_data1.detail) === null || _el_response_data_detail1 === void 0 ? void 0 : _el_response_data_detail1.Code) === "mfa-required") {
                        el.type = "mfa-required";
                        el.finishAuth = ()=>signup().then(()=>svc.refreshToken()).then(onAuthDone).then(onUserVerified).then(()=>navigate("/"));
                    }
                    throw el;
                });
                return function(el) {
                    return _ref.apply(this, arguments);
                };
            }()).then(onAuthDone).then(onUserVerified).then(()=>{
                navigate("/");
            });
        });
        return _postSignUpSetup.apply(this, arguments);
    }
}
function signup(v) {
    return _signup.apply(this, arguments);
}
function _signup() {
    _signup = _async_to_generator(function*(v) {
        yield axios_default().post("/v2/user-management/signup");
        return v;
    });
    return _signup.apply(this, arguments);
}
function onAuthDone() {
    return _onAuthDone.apply(this, arguments);
}
function _onAuthDone() {
    _onAuthDone = _async_to_generator(function*() {
        var _userInfo_roles;
        const s = yield (0,service/* resolveService */.f)("authService");
        // wait for user to be resolved
        yield s.getCurrentUser();
        const userInfo = yield api.api.auth.AuthService.UserGetCurrent({});
        if ((_userInfo_roles = userInfo.roles) === null || _userInfo_roles === void 0 ? void 0 : _userInfo_roles.includes(EUserRole.INACTIVE)) {
            throw new Error(messages/* messages.notifications.accountNotApproved */.s.notifications.accountNotApproved);
        }
        const expirationTime = yield (0,storage/* getTokenExpirationTime */.xy)();
        if ((expirationTime || 0) < Date.now()) {
            notification/* notification.warning */.t6.warning({
                message: messages/* messages.notifications.systemClockOutOfSync */.s.notifications.systemClockOutOfSync,
                description: messages/* messages.notifications.systemClockOutOfSyncDescription */.s.notifications.systemClockOutOfSyncDescription,
                props: {
                    autoHideDuration: 10000
                }
            });
        }
        return userInfo;
    });
    return _onAuthDone.apply(this, arguments);
}
function onUserVerified(user) {
    return _onUserVerified.apply(this, arguments);
}
function _onUserVerified() {
    _onUserVerified = _async_to_generator(function*(user) {
        localStorage.setItem("authenticated", "on");
        const { success  } = effects.authEffects.login;
        const permissions = yield (0,service/* resolveService */.f)("permissions");
        permissions.setCurrentUser(user.id);
        (0,state/* preloadBetas */.yg)();
        success(user);
        (0,Analytics/* logEvent */.Kz)(Analytics/* eventsConstants.auth.login */.AD.auth.login);
        // After login user feature flags can be different from anonymous.
        // In that case we can refresh as part of login process instead of showing popup.
        (0,setupVersionCheck/* checkVersion */.Ye)(true);
    });
    return _onUserVerified.apply(this, arguments);
}
function handleLoginError(svc, error, onVerify) {
    var _error_response, _error_response_data, _error_response_data_detail, _error_response1, _error_response_data1, _error_response_data_detail1;
    if ((error === null || error === void 0 ? void 0 : (_error_response = error.response) === null || _error_response === void 0 ? void 0 : (_error_response_data = _error_response.data) === null || _error_response_data === void 0 ? void 0 : (_error_response_data_detail = _error_response_data.detail) === null || _error_response_data_detail === void 0 ? void 0 : _error_response_data_detail.Code) === "sign-up-incomplete") {
        error.message = messages/* messages.notifications.notInvitedAccount */.s.notifications.notInvitedAccount;
    }
    if (error.code === "auth/wrong-password" || error.code === "auth/user-not-found") {
        error.message = messages/* messages.loginError */.s.loginError;
    }
    if (error.code === "auth/admin-restricted-operation") {
        error.message = "You are not invited. Contact admin to get the invite.";
    }
    if (error.code === "auth/multi-factor-auth-required") {
        error.type = "mfa";
        let verificationId;
        error.sendCode = function() {
            var _ref = _async_to_generator(function*(verifier) {
                verificationId = yield svc.loginMFASendCode(verifier, error.resolver);
                return verificationId;
            });
            return function(verifier) {
                return _ref.apply(this, arguments);
            };
        }();
        error.verifyCode = function() {
            var _ref = _async_to_generator(function*(code) {
                return svc.loginMFAAssert(verificationId, error.resolver, code).then(onVerify).catch((err)=>{
                    var _err_response, _err_response_data, _err_response1, _err_response2, _err_response3, _err_response_data1, _err_response_data_detail;
                    let message = ((_err_response = err.response) === null || _err_response === void 0 ? void 0 : (_err_response_data = _err_response.data) === null || _err_response_data === void 0 ? void 0 : _err_response_data.error) || (error === null || error === void 0 ? void 0 : error.message) || error.code || (err === null || err === void 0 ? void 0 : (_err_response1 = err.response) === null || _err_response1 === void 0 ? void 0 : _err_response1.data) || "Something went wrong. Please contact an admin";
                    if (((_err_response2 = err.response) === null || _err_response2 === void 0 ? void 0 : _err_response2.status) === 403) {
                        message = messages/* messages.loginError */.s.loginError;
                    }
                    if ((err === null || err === void 0 ? void 0 : (_err_response3 = err.response) === null || _err_response3 === void 0 ? void 0 : (_err_response_data1 = _err_response3.data) === null || _err_response_data1 === void 0 ? void 0 : (_err_response_data_detail = _err_response_data1.detail) === null || _err_response_data_detail === void 0 ? void 0 : _err_response_data_detail.Code) === "invalid-provider") {
                        message = messages/* messages.notifications.notInvitedAccount */.s.notifications.notInvitedAccount;
                    }
                    notification/* notification.error */.t6.error({
                        message,
                        props: {
                            autoHideDuration: 4000
                        }
                    });
                    throw err;
                });
            });
            return function(code) {
                return _ref.apply(this, arguments);
            };
        }();
    }
    if (((_error_response1 = error.response) === null || _error_response1 === void 0 ? void 0 : (_error_response_data1 = _error_response1.data) === null || _error_response_data1 === void 0 ? void 0 : (_error_response_data_detail1 = _error_response_data1.detail) === null || _error_response_data_detail1 === void 0 ? void 0 : _error_response_data_detail1.Code) === "mfa-required") {
        error.type = "mfa-required";
        error.finishAuth = ()=>svc.refreshToken().then(onAuthDone).then(onUserVerified);
    }
    throw error;
}
function useLogin() {
    return (0,es/* useMutation */.Db)(function() {
        var _ref = _async_to_generator(function*({ type , cloud , values , params  }) {
            const svc = yield (0,service/* resolveService */.f)("authService");
            let res;
            if (type === "cloud") {
                res = svc.signInCloud(cloud, params).then(onAuthDone).then(onUserVerified);
            } else {
                res = svc.signInPassword(values).then(onAuthDone).then(onUserVerified);
            }
            return res.catch(function() {
                var _ref = _async_to_generator(function*(error) {
                    return handleLoginError(svc, error, /*#__PURE__*/ _async_to_generator(function*() {
                        yield onUserVerified((yield onAuthDone()));
                    }));
                });
                return function(error) {
                    return _ref.apply(this, arguments);
                };
            }());
        });
        return function(_) {
            return _ref.apply(this, arguments);
        };
    }(), {
        onError (e) {
            if (e.type !== "mfa" && e.type !== "mfa-required") {
                notification/* notification.error */.t6.error({
                    message: e.message,
                    props: {
                        autoHideDuration: 10000
                    }
                });
            }
        }
    });
}
function useLoginWithRedirect() {
    return (0,es/* useMutation */.Db)(function() {
        var _ref = _async_to_generator(function*({ cloud , params  }) {
            const svc = yield (0,service/* resolveService */.f)("authService");
            try {
                const result = yield svc.getRedirectResult();
                if (!result.token) {
                    yield svc.signInCloudWithRedirect(cloud, params);
                    return;
                }
                const userInfo = yield onAuthDone();
                onUserVerified(userInfo);
            } catch (error) {
                handleLoginError(svc, error, /*#__PURE__*/ _async_to_generator(function*() {
                    yield onUserVerified((yield onAuthDone()));
                }));
            }
        });
        return function(_) {
            return _ref.apply(this, arguments);
        };
    }(), {
        onError (e) {
            if (e.type !== "mfa" && e.type !== "mfa-required") {
                notification/* notification.error */.t6.error({
                    message: e.message,
                    props: {
                        autoHideDuration: 10000
                    }
                });
            }
        }
    });
}
const AuthProvidersKey = "auth-providers";
const AuthProviderListKey = "auth-providers-list";
function useDefaultProviders() {
    return (0,es/* useQuery */.aM)([
        AuthProvidersKey
    ], api.api.auth.AuthService.ListEnabledAuthProviders);
}
function useDefaultProvidersList() {
    return (0,es/* useQuery */.aM)([
        AuthProviderListKey
    ], ()=>(0,network/* sendGQLRequest */.n)(graphql/* GetAuthProvidersDocument */.Kr, {}));
}
function useDefaultProviderAvailabilityUpdate() {
    const cache = (0,es/* useQueryCache */.Zq)();
    return (0,es/* useMutation */.Db)(({ name , enabled  })=>(0,network/* sendGQLRequest */.n)(graphql/* UpdateAuthProviderAvailabilityDocument */.mo, {
            name,
            enabled
        }), {
        onSuccess () {
            cache.invalidateQueries([
                AuthProviderListKey
            ]);
        },
        throwOnError: true
    });
}
function usePasswordProviderMFAUpdate() {
    const cache = (0,es/* useQueryCache */.Zq)();
    return (0,es/* useMutation */.Db)(({ enforce  })=>api.api.auth.AuthService.UpdateEnforceMFA({
            provider: "password",
            enabled: enforce
        }), {
        onSuccess () {
            cache.invalidateQueries([
                AuthProviderListKey
            ]);
        },
        onError () {
            notification/* notification.error */.t6.error({
                message: "Error updating MFA"
            });
        },
        throwOnError: true
    });
}
const SAMLProviderListKey = "saml-provider-list";
function useSAMLProviders() {
    return (0,es/* useQuery */.aM)([
        "saml-providers"
    ], ()=>{
        return api.api.auth.AuthService.SAMLProvidersListIDs({});
    });
}
function useSAMLProvidersList() {
    return (0,es/* useQuery */.aM)([
        SAMLProviderListKey
    ], api.api.auth.AuthService.SAMLProvidersList);
}
function useSAMLProviderUpdate({ onDone  }) {
    const cache = (0,es/* useQueryCache */.Zq)();
    return (0,es/* useMutation */.Db)(api.api.auth.AuthService.SAMLProviderPatch, {
        onSuccess () {
            cache.invalidateQueries([
                SAMLProviderListKey
            ]);
            onDone === null || onDone === void 0 ? void 0 : onDone();
        },
        throwOnError: true
    });
}
function useSAMLProviderCreate({ onDone  }) {
    const cache = (0,es/* useQueryCache */.Zq)();
    return (0,es/* useMutation */.Db)(api.api.auth.AuthService.SAMLProviderCreate, {
        onSuccess () {
            cache.invalidateQueries([
                SAMLProviderListKey
            ]);
            onDone === null || onDone === void 0 ? void 0 : onDone();
        },
        throwOnError: true
    });
}
function useSAMLProviderDelete() {
    const cache = (0,es/* useQueryCache */.Zq)();
    return (0,es/* useMutation */.Db)(api.api.auth.AuthService.SAMLProviderDelete, {
        onSuccess () {
            cache.invalidateQueries([
                SAMLProviderListKey
            ]);
        },
        throwOnError: true
    });
}
function useForgotPassword(props = {}) {
    return (0,es/* useMutation */.Db)(function() {
        var _ref = _async_to_generator(function*({ email  }) {
            return api.api.auth.AuthService.UserPasswordResetEmail({
                email
            });
        });
        return function(_) {
            return _ref.apply(this, arguments);
        };
    }(), _object_spread({
        onSuccess () {
            notification/* notification.success */.t6.success({
                message: messages/* messages.resetAuthMethod */.s.resetAuthMethod
            });
        }
    }, props));
}
const AuthSettingsKey = "auth-settings";
function useGlobalAuthSettings(config) {
    return (0,es/* useQuery */.aM)([
        AuthSettingsKey
    ], ()=>{
        return (0,network/* sendGQLRequest */.n)(graphql/* GlobalAuthSettingsDocument */.aE, {}).then((result)=>{
            var _result_global_auth_settings, _result_global_auth_settings_;
            return result === null || result === void 0 ? void 0 : (_result_global_auth_settings = result.global_auth_settings) === null || _result_global_auth_settings === void 0 ? void 0 : (_result_global_auth_settings_ = _result_global_auth_settings[0]) === null || _result_global_auth_settings_ === void 0 ? void 0 : _result_global_auth_settings_.auth_data;
        });
    }, config);
}
function useGlobalAuthSettingsUpdate({ onSuccess , onError  }) {
    const cache = (0,es/* useQueryCache */.Zq)();
    return (0,es/* useMutation */.Db)((settings)=>(0,network/* sendGQLRequest */.n)(graphql/* UpdateGlobalAuthSettingsDocument */.Jv, {
            auth_data: settings
        }), {
        onSuccess () {
            cache.invalidateQueries([
                AuthSettingsKey
            ]);
            onSuccess === null || onSuccess === void 0 ? void 0 : onSuccess();
        },
        onError
    });
}


/***/ }),

/***/ 15807:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "s8": () => (/* reexport */ EmailField),
  "ZI": () => (/* reexport */ PasswordField),
  "Mx": () => (/* reexport */ ProviderButton),
  "Ft": () => (/* reexport */ TwoFactorAuthForm),
  "yP": () => (/* reexport */ TwoFactorPhoneAuthForm)
});

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@mui/material/TextField/TextField.js + 1 modules
var TextField = __webpack_require__(94659);
// EXTERNAL MODULE: ./node_modules/@mui/material/InputAdornment/InputAdornment.js + 1 modules
var InputAdornment = __webpack_require__(80270);
// EXTERNAL MODULE: ./node_modules/@mui/icons-material/Person.js
var Person = __webpack_require__(15398);
// EXTERNAL MODULE: ./src/ui/index.ts + 23 modules
var ui = __webpack_require__(17218);
;// CONCATENATED MODULE: ./src/modules/auth/atoms/EmailField.tsx
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}




const EmailField = (props)=>/*#__PURE__*/ react.createElement(TextField/* default */.Z, _object_spread_props(_object_spread({}, (0,ui/* mapProps */.jM)(props)), {
        variant: "standard",
        InputProps: {
            startAdornment: /*#__PURE__*/ react.createElement(InputAdornment/* default */.Z, {
                position: "start"
            }, /*#__PURE__*/ react.createElement(Person/* default */.Z, {
                color: "action"
            }))
        }
    }));

// EXTERNAL MODULE: ./node_modules/@mui/material/IconButton/IconButton.js + 1 modules
var IconButton = __webpack_require__(6867);
// EXTERNAL MODULE: ./node_modules/@mui/icons-material/Lock.js
var Lock = __webpack_require__(73595);
// EXTERNAL MODULE: ./node_modules/@mui/icons-material/Visibility.js
var Visibility = __webpack_require__(22961);
// EXTERNAL MODULE: ./node_modules/@mui/icons-material/VisibilityOff.js
var VisibilityOff = __webpack_require__(72450);
;// CONCATENATED MODULE: ./src/modules/auth/atoms/PasswordField.tsx
function PasswordField_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function PasswordField_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            PasswordField_define_property(target, key, source[key]);
        });
    }
    return target;
}
function PasswordField_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function PasswordField_object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        PasswordField_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}






class PasswordField extends react.PureComponent {
    render() {
        const _this_props = this.props, { hideIcon  } = _this_props, props = _object_without_properties(_this_props, [
            "hideIcon"
        ]);
        return /*#__PURE__*/ react.createElement(TextField/* default */.Z, PasswordField_object_spread_props(PasswordField_object_spread({}, (0,ui/* mapProps */.jM)(props)), {
            type: this.state.visible ? "text" : "password",
            variant: "standard",
            InputProps: {
                startAdornment: !hideIcon && /*#__PURE__*/ react.createElement(InputAdornment/* default */.Z, {
                    position: "start"
                }, /*#__PURE__*/ react.createElement(Lock/* default */.Z, {
                    color: "action"
                })),
                endAdornment: /*#__PURE__*/ react.createElement(InputAdornment/* default */.Z, {
                    position: "end"
                }, /*#__PURE__*/ react.createElement(IconButton/* default */.Z, {
                    disableRipple: true,
                    tabIndex: -1,
                    "aria-label": "Toggle password visibility",
                    onClick: this.toggleVisibility,
                    size: "large"
                }, this.state.visible ? /*#__PURE__*/ react.createElement(VisibilityOff/* default */.Z, null) : /*#__PURE__*/ react.createElement(Visibility/* default */.Z, null)))
            }
        }));
    }
    constructor(...args){
        super(...args);
        PasswordField_define_property(this, "state", {
            visible: false
        });
        PasswordField_define_property(this, "toggleVisibility", ()=>{
            this.setState({
                visible: !this.state.visible
            });
        });
    }
}

// EXTERNAL MODULE: ./node_modules/react-final-form/dist/react-final-form.es.js
var react_final_form_es = __webpack_require__(66688);
// EXTERNAL MODULE: ./node_modules/@mui/icons-material/esm/ArrowBack.js
var ArrowBack = __webpack_require__(94669);
// EXTERNAL MODULE: ./node_modules/@mui/material/LinearProgress/LinearProgress.js + 1 modules
var LinearProgress = __webpack_require__(69041);
// EXTERNAL MODULE: ./node_modules/@mui/material/Grid/Grid.js + 2 modules
var Grid = __webpack_require__(15725);
// EXTERNAL MODULE: ./node_modules/@mui/material/FormHelperText/FormHelperText.js + 1 modules
var FormHelperText = __webpack_require__(3460);
// EXTERNAL MODULE: ./node_modules/@mui/material/Button/Button.js + 1 modules
var Button = __webpack_require__(72642);
// EXTERNAL MODULE: ./node_modules/@mui/material/Box/Box.js
var Box = __webpack_require__(99226);
// EXTERNAL MODULE: ./node_modules/@mui/material/Typography/Typography.js + 1 modules
var Typography = __webpack_require__(2658);
// EXTERNAL MODULE: ./src/modules/form-utils/index.ts + 7 modules
var form_utils = __webpack_require__(10554);
// EXTERNAL MODULE: ./src/libs/layouts/index.tsx + 2 modules
var layouts = __webpack_require__(5855);
// EXTERNAL MODULE: ./src/modules/auth/messages.ts
var messages = __webpack_require__(23456);
;// CONCATENATED MODULE: ./src/modules/auth/atoms/TwoFactorAuthForm.tsx







function TwoFactorAuthForm({ handleSubmit , error , submitting  }) {
    return /*#__PURE__*/ react.createElement("form", {
        onSubmit: handleSubmit,
        autoComplete: "on"
    }, submitting && /*#__PURE__*/ react.createElement(LinearProgress/* default */.Z, null), /*#__PURE__*/ react.createElement(Grid/* default */.ZP, {
        container: true,
        direction: "column",
        spacing: 4
    }, /*#__PURE__*/ react.createElement(Grid/* default */.ZP, {
        item: true
    }, !submitting && error && /*#__PURE__*/ react.createElement(FormHelperText/* default */.Z, {
        error: true
    }, error)), /*#__PURE__*/ react.createElement(Grid/* default */.ZP, {
        item: true,
        style: {
            width: "100%"
        }
    }, /*#__PURE__*/ react.createElement(react_final_form_es/* Field */.gN, {
        name: "twoFactorCode",
        component: form_utils/* TextFieldComponent */.af,
        fullWidth: true,
        label: messages/* messages.twoFACodeLabel */.s.twoFACodeLabel
    })), /*#__PURE__*/ react.createElement(Grid/* default */.ZP, {
        container: true,
        item: true,
        direction: "row",
        justifyContent: "space-between"
    }, /*#__PURE__*/ react.createElement(Button/* default */.Z, {
        fullWidth: true,
        color: "primary",
        variant: "outlined",
        type: "submit",
        disabled: submitting
    }, messages/* messages.logIn */.s.logIn))));
}
function TwoFactorPhoneAuthForm({ handleSubmit , error , submitting , resend , onCancel  }) {
    return /*#__PURE__*/ react.createElement("form", {
        onSubmit: handleSubmit,
        autoComplete: "on"
    }, submitting && /*#__PURE__*/ react.createElement(LinearProgress/* default */.Z, null), /*#__PURE__*/ react.createElement(layouts/* Stack */.Kq, {
        space: 3
    }, onCancel && /*#__PURE__*/ react.createElement(Box/* default */.Z, {
        marginLeft: -3
    }, /*#__PURE__*/ react.createElement(Button/* default */.Z, {
        color: "primary",
        onClick: onCancel
    }, /*#__PURE__*/ react.createElement(ArrowBack/* default */.Z, {
        fontSize: "small"
    }), " Back")), /*#__PURE__*/ react.createElement(layouts/* Stack */.Kq, {
        space: 4
    }, /*#__PURE__*/ react.createElement(Typography/* default */.Z, {
        variant: "body2"
    }, messages/* messages.enterVerificationCode */.s.enterVerificationCode), /*#__PURE__*/ react.createElement(layouts/* Stack */.Kq, null, /*#__PURE__*/ react.createElement(react_final_form_es/* Field */.gN, {
        name: "twoFactorCode",
        component: form_utils/* TextFieldComponent */.af,
        fullWidth: true,
        label: messages/* messages.twoFAPoneCodeLabel */.s.twoFAPoneCodeLabel
    }), !submitting && error && /*#__PURE__*/ react.createElement(FormHelperText/* default */.Z, {
        error: true
    }, error))), /*#__PURE__*/ react.createElement(Button/* default */.Z, {
        id: "mfaSendCodeButton",
        fullWidth: true,
        color: "primary",
        variant: "contained",
        type: "submit",
        style: {
            alignSelf: "flex-start"
        },
        disabled: submitting
    }, messages/* messages.logIn */.s.logIn), /*#__PURE__*/ react.createElement(Button/* default */.Z, {
        fullWidth: true,
        color: "primary",
        type: "button",
        onClick: resend
    }, messages/* messages.resendMFALoginCode */.s.resendMFALoginCode)));
}

// EXTERNAL MODULE: ./src/assets/icons/internal.tsx + 111 modules
var internal = __webpack_require__(13554);
// EXTERNAL MODULE: ./node_modules/@mui/icons-material/Business.js
var Business = __webpack_require__(54788);
// EXTERNAL MODULE: ./node_modules/@mui/icons-material/PermIdentity.js
var PermIdentity = __webpack_require__(78878);
;// CONCATENATED MODULE: ./src/modules/auth/atoms/ProviderButton.tsx






const icons = {
    google: {
        Icon: internal/* Google */.ie
    },
    saml: {
        Icon: Business/* default */.Z
    },
    password: {
        Icon: PermIdentity/* default */.Z
    }
};
function ProviderButton(props) {
    const { Icon  } = icons[props.type];
    return /*#__PURE__*/ react.createElement(Button/* default */.Z, {
        size: "large",
        variant: "outlined",
        onClick: props.onClick,
        style: {
            textTransform: "none"
        }
    }, /*#__PURE__*/ react.createElement(layouts/* HStack */.Ug, {
        space: 2,
        align: "center",
        style: {
            width: "100%",
            whiteSpace: "nowrap",
            overflow: "hidden",
            textOverflow: "ellipsis"
        }
    }, /*#__PURE__*/ react.createElement(Icon, {
        style: {
            fontSize: 20,
            width: 20,
            height: 20,
            minWidth: 20
        }
    }), /*#__PURE__*/ react.createElement("span", null, props.label)));
}

;// CONCATENATED MODULE: ./src/modules/auth/atoms/index.ts






/***/ }),

/***/ 7877:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "V": () => (/* binding */ defaultInactivityPromptTimeout),
/* harmony export */   "p": () => (/* binding */ defaultInactivityTimeout)
/* harmony export */ });
const defaultInactivityTimeout = 30 * 60; // 30 minutes
const defaultInactivityPromptTimeout = 60 * 3; // 3 minutes


/***/ }),

/***/ 77805:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$8": () => (/* binding */ isAuthenticated),
/* harmony export */   "aM": () => (/* binding */ fetchMe),
/* harmony export */   "authEffects": () => (/* binding */ authEffects),
/* harmony export */   "g$": () => (/* binding */ refreshToken),
/* harmony export */   "hD": () => (/* binding */ handleTokenRefresh),
/* harmony export */   "kS": () => (/* binding */ logout),
/* harmony export */   "w4": () => (/* binding */ setTokenUpdateTimer)
/* harmony export */ });
/* harmony import */ var okdux__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(56804);
/* harmony import */ var service__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(89880);
/* harmony import */ var js_cookie__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(36808);
/* harmony import */ var js_cookie__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(js_cookie__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var app_setupVersionCheck__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(80157);
/* harmony import */ var api__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(62688);
/* harmony import */ var api_auth_storage__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(86758);
/* harmony import */ var modules_analytics_Analytics__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(95520);
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}







const authEffects = (0,okdux__WEBPACK_IMPORTED_MODULE_0__/* .createEffects */ .xG)({
    login: okdux__WEBPACK_IMPORTED_MODULE_0__/* .build.async */ .J_.async(),
    signup: okdux__WEBPACK_IMPORTED_MODULE_0__/* .build.async */ .J_.async(),
    refreshToken: okdux__WEBPACK_IMPORTED_MODULE_0__/* .build.async */ .J_.async(),
    logout: okdux__WEBPACK_IMPORTED_MODULE_0__/* .build.async */ .J_.async()
}, "auth");
function refreshToken() {
    return _refreshToken.apply(this, arguments);
}
function _refreshToken() {
    _refreshToken = _async_to_generator(function*() {
        const svc = yield (0,service__WEBPACK_IMPORTED_MODULE_1__/* .resolveService */ .f)("authService");
        yield svc.refreshToken();
    });
    return _refreshToken.apply(this, arguments);
}
const setTokenUpdateTimer = ()=>{
    let timer;
    let canceled = false;
    function run() {
        return _run.apply(this, arguments);
    }
    function _run() {
        _run = _async_to_generator(function*() {
            if (canceled) {
                return;
            }
            const expirationTime = yield (0,api_auth_storage__WEBPACK_IMPORTED_MODULE_5__/* .getTokenExpirationTime */ .xy)();
            // token time left minus 15s so we have enough time amount to get new token from backend
            const refreshIn = Math.max((expirationTime || 0) - Date.now() - 15000, 0); // - 15s
            timer = setTimeout(()=>{
                refreshToken().then(run);
            }, refreshIn);
        });
        return _run.apply(this, arguments);
    }
    return {
        run () {
            canceled = false;
            return run();
        },
        pause () {
            canceled = true;
            clearTimeout(timer);
        }
    };
};
function handleTokenRefresh() {
    const timer = setTokenUpdateTimer();
    return {
        run (user) {
            return _async_to_generator(function*() {
                if (user === null || user === void 0 ? void 0 : user.id) {
                    // if user exists we start update token timer
                    timer.run();
                } else {
                    // reset refresh interval on log out
                    timer === null || timer === void 0 ? void 0 : timer.pause();
                }
            })();
        }
    };
}
function fetchMe(token) {
    return _fetchMe.apply(this, arguments);
}
function _fetchMe() {
    _fetchMe = _async_to_generator(function*(token) {
        const res = yield api__WEBPACK_IMPORTED_MODULE_4__.api.auth.AuthService.UserGetCurrent({});
        const { success  } = authEffects.login;
        success(_object_spread_props(_object_spread({}, res), {
            token
        }));
        return res;
    });
    return _fetchMe.apply(this, arguments);
}
function logout() {
    return _logout.apply(this, arguments);
}
function _logout() {
    _logout = _async_to_generator(function*() {
        const { failure , success , request  } = authEffects.logout;
        const svc = yield (0,service__WEBPACK_IMPORTED_MODULE_1__/* .resolveService */ .f)("authService");
        request();
        try {
            svc.removeAuthCookie();
            yield svc.logout();
            (0,modules_analytics_Analytics__WEBPACK_IMPORTED_MODULE_6__/* .logEvent */ .Kz)(modules_analytics_Analytics__WEBPACK_IMPORTED_MODULE_6__/* .eventsConstants.auth.logout */ .AD.auth.logout);
            // After logout there is a probability that feature flags for anonymous user are different.
            // To not trigger extra popup appearance we update version silently.
            (0,app_setupVersionCheck__WEBPACK_IMPORTED_MODULE_3__/* .silentlyUpdateVersion */ .Pb)();
            success();
        } catch (error) {
            failure(error);
            throw error;
        }
    });
    return _logout.apply(this, arguments);
}
// just fast method to get if user is authenticated, indexed db is slow
function isAuthenticated() {
    return !!js_cookie__WEBPACK_IMPORTED_MODULE_2___default().get(api_auth_storage__WEBPACK_IMPORTED_MODULE_5__/* .KEY */ .Fn);
}


/***/ }),

/***/ 38266:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "AddNewSAMLProvider": () => (/* reexport */ organisms/* AddNewSAMLProvider */.Ep),
  "AuthProviderTable": () => (/* reexport */ organisms/* AuthProviderTable */.x2),
  "DeleteSAMLProvider": () => (/* reexport */ organisms/* DeleteSAMLProvider */.aX),
  "EditSAMLProvider": () => (/* reexport */ organisms/* EditSAMLProvider */.Ee),
  "EmailField": () => (/* reexport */ atoms/* EmailField */.s8),
  "LoginForm": () => (/* reexport */ organisms/* LoginForm */.U0),
  "LoginPage": () => (/* reexport */ LoginPage),
  "PasswordField": () => (/* reexport */ atoms/* PasswordField */.ZI),
  "ProviderButton": () => (/* reexport */ atoms/* ProviderButton */.Mx),
  "RegistrationForm": () => (/* reexport */ organisms/* RegistrationForm */.GG),
  "RegistrationPage": () => (/* reexport */ RegistrationPage.RegistrationPage),
  "TwoFactorAuthForm": () => (/* reexport */ atoms/* TwoFactorAuthForm */.Ft),
  "TwoFactorPhoneAuthForm": () => (/* reexport */ atoms/* TwoFactorPhoneAuthForm */.yP),
  "UserInactivityHandler": () => (/* reexport */ organisms/* UserInactivityHandler */.p1),
  "authEffects": () => (/* reexport */ effects.authEffects),
  "authState": () => (/* reexport */ state/* authState */.f),
  "canSignUp": () => (/* reexport */ organisms/* canSignUp */.V4),
  "default": () => (/* reexport */ LoginPage),
  "defaultInactivityPromptTimeout": () => (/* reexport */ constants/* defaultInactivityPromptTimeout */.V),
  "defaultInactivityTimeout": () => (/* reexport */ constants/* defaultInactivityTimeout */.p),
  "fetchMe": () => (/* reexport */ effects/* fetchMe */.aM),
  "handleTokenRefresh": () => (/* reexport */ effects/* handleTokenRefresh */.hD),
  "initialState": () => (/* reexport */ state/* initialState */.E),
  "isAuthenticated": () => (/* reexport */ effects/* isAuthenticated */.$8),
  "logout": () => (/* reexport */ effects/* logout */.kS),
  "refreshToken": () => (/* reexport */ effects/* refreshToken */.g$),
  "setTokenUpdateTimer": () => (/* reexport */ effects/* setTokenUpdateTimer */.w4)
});

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/modules/auth/organisms/index.ts + 6 modules
var organisms = __webpack_require__(65598);
// EXTERNAL MODULE: ./src/modules/auth/pages/PageTemplate.tsx + 2 modules
var PageTemplate = __webpack_require__(36157);
;// CONCATENATED MODULE: ./src/modules/auth/pages/LoginPage.tsx



const LoginPage = ()=>{
    return /*#__PURE__*/ react.createElement(PageTemplate/* PageTemplate */.P, null, /*#__PURE__*/ react.createElement(organisms/* LoginForm */.U0, null));
};

// EXTERNAL MODULE: ./src/modules/auth/state.ts
var state = __webpack_require__(45386);
// EXTERNAL MODULE: ./src/modules/auth/effects.ts
var effects = __webpack_require__(77805);
// EXTERNAL MODULE: ./src/modules/auth/atoms/index.ts + 4 modules
var atoms = __webpack_require__(15807);
// EXTERNAL MODULE: ./src/modules/auth/pages/RegistrationPage.tsx
var RegistrationPage = __webpack_require__(56836);
;// CONCATENATED MODULE: ./src/modules/auth/pages/index.ts



// EXTERNAL MODULE: ./src/modules/auth/constants.ts
var constants = __webpack_require__(7877);
;// CONCATENATED MODULE: ./src/modules/auth/index.ts









/***/ }),

/***/ 26653:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "m": () => (/* binding */ useAuthService),
/* harmony export */   "u": () => (/* binding */ useCaptcha)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var react_query__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(21478);
/* harmony import */ var service__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(89880);



function useAuthService() {
    const { data , error  } = (0,react_query__WEBPACK_IMPORTED_MODULE_1__/* .useQuery */ .aM)([
        "AuthService"
    ], ()=>(0,service__WEBPACK_IMPORTED_MODULE_2__/* .resolveService */ .f)("authService"));
    return {
        service: data,
        error
    };
}
function useCaptcha(deps, mount = true) {
    const [id, setState] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(null);
    const { service  } = useAuthService();
    const verifierInstance = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(null);
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useLayoutEffect)(()=>{
        if (service && mount) {
            const id = Math.random().toString();
            setState(id);
            requestAnimationFrame(()=>{
                verifierInstance.current = service === null || service === void 0 ? void 0 : service.loginMFASetupRecapcha(id);
            });
        }
    }, [
        service,
        mount,
        ...deps
    ]);
    return [
        /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", {
            id: id,
            style: {
                position: "absolute",
                width: 0,
                height: 0,
                whiteSpace: "nowrap"
            }
        }),
        verifierInstance
    ];
}


/***/ }),

/***/ 23456:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "s": () => (/* binding */ messages)
/* harmony export */ });
const messages = {
    accountSetup: "Setting up your account",
    loginError: "Incorrect username or password",
    resetAuthMethod: "If this email is registered, you will receive a one-time login link shortly",
    validation: {
        containNum: "Password must contain at least 1 number",
        lowLetter: "Password must contain at least 1 lowercase letter",
        upperLetter: "Password must contain at least 1 uppercase letter",
        specialLetter: "Password must contain at least 1 special character (#?!@$%^&*-+)",
        maxLength: "Password must be shorter than or equal to 50 characters",
        maxLengthByte: "Password is too long",
        minLength: "Password must be longer than or equal to 8 characters",
        required: "This field is required",
        nameMinLength: "Name must be longer than or equal to 3 characters",
        passEquality: "Passwords are not identical"
    },
    notifications: {
        systemClockOutOfSync: "Your system clock is inconsistent with that of the Cyberhaven server.",
        systemClockOutOfSyncDescription: "This may lead to inconsistencies in the filtering of events.",
        accountNotApproved: "Your account is not approved yet, please contact your administrator to obtain access",
        notInvitedAccount: "You are not invited. Please contact your administrator to obtain access",
        unrecognizedCreds: "Unrecognized user email or password",
        signUpSuccess: "Authenticated successfully.",
        invalidToken: "Invite token is invalid. Please contact your administrator for a new invite link",
        expiredToken: "Invite token expired. Please contact your administrator to obtain a new invitation link",
        twoFACodeNotValid: "Verification code is not valid"
    },
    inactivityPopup: {
        title: "Your session will expire in:",
        description: "Please click “Extend session” to keep working or click “Log out” to end your session now",
        stay: "Extend session",
        logout: "Log out"
    },
    formFields: {
        email: "Email",
        password: "Password",
        name: "Full Name",
        nameRule: `Username should be at least 3 characters long`,
        repeatPass: "Repeat password",
        repeatPassRule: `Passwords should have at least 8 characters and contain a mix of uppercase and lowercase letters,
    numbers, and symbols (such as #?!@$%^&*-+).`
    },
    logIn: "Log in",
    forgotPassword: "Problems logging in?",
    resendMFALoginCode: "Resend code",
    signUp: "Sign up",
    signUpWithGoogle: "Sign up with Google",
    twoFACodeLabel: "Enter your 2FA code from Google Authenticator",
    twoFAPoneCodeLabel: "Enter your verification code sent by sms",
    enterVerificationCode: "Please enter the verification code sent to your phone.",
    authProviderPageTitle: "Providers",
    failedToUpdateProvider: "Failed to update provider",
    enabledProvider: "Enabled",
    disabledProvider: "Disabled",
    lastEnabledProvidedTooltip: "At least one provider should be enabled",
    setupMFA: "Setup SMS authentication"
};


/***/ }),

/***/ 65598:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Ep": () => (/* reexport */ AddNewSAMLProvider),
  "x2": () => (/* reexport */ AuthProviderTable),
  "aX": () => (/* reexport */ DeleteSAMLProvider),
  "Ee": () => (/* reexport */ EditSAMLProvider),
  "U0": () => (/* reexport */ LoginForm),
  "GG": () => (/* reexport */ RegistrationForm),
  "p1": () => (/* reexport */ UserInactivityHandler),
  "V4": () => (/* reexport */ canSignUp)
});

// EXTERNAL MODULE: ./node_modules/react-copy-to-clipboard/lib/index.js
var lib = __webpack_require__(74855);
var lib_default = /*#__PURE__*/__webpack_require__.n(lib);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-final-form/dist/react-final-form.es.js
var react_final_form_es = __webpack_require__(66688);
// EXTERNAL MODULE: ./src/runenv.tsx
var runenv = __webpack_require__(76223);
// EXTERNAL MODULE: ./node_modules/react-final-form-arrays/dist/react-final-form-arrays.es.js
var react_final_form_arrays_es = __webpack_require__(84589);
// EXTERNAL MODULE: ./node_modules/final-form-arrays/dist/final-form-arrays.es.js
var final_form_arrays_es = __webpack_require__(73342);
// EXTERNAL MODULE: ./src/shared/permissions.tsx
var permissions = __webpack_require__(44916);
// EXTERNAL MODULE: ./node_modules/@mui/material/Typography/Typography.js + 1 modules
var Typography = __webpack_require__(2658);
// EXTERNAL MODULE: ./node_modules/@mui/material/IconButton/IconButton.js + 1 modules
var IconButton = __webpack_require__(6867);
// EXTERNAL MODULE: ./node_modules/@mui/material/Button/Button.js + 1 modules
var Button = __webpack_require__(72642);
// EXTERNAL MODULE: ./node_modules/@mui/material/Divider/Divider.js
var Divider = __webpack_require__(67720);
// EXTERNAL MODULE: ./node_modules/@mui/material/FormHelperText/FormHelperText.js + 1 modules
var FormHelperText = __webpack_require__(3460);
// EXTERNAL MODULE: ./node_modules/@mui/material/Dialog/Dialog.js + 1 modules
var Dialog = __webpack_require__(3838);
// EXTERNAL MODULE: ./node_modules/@mui/material/Paper/Paper.js + 2 modules
var Paper = __webpack_require__(64680);
// EXTERNAL MODULE: ./node_modules/@mui/icons-material/esm/ContentCopy.js
var ContentCopy = __webpack_require__(96406);
// EXTERNAL MODULE: ./node_modules/@mui/icons-material/esm/Delete.js
var Delete = __webpack_require__(46761);
// EXTERNAL MODULE: ./node_modules/@mui/icons-material/esm/Close.js
var Close = __webpack_require__(95537);
// EXTERNAL MODULE: ./node_modules/@mui/icons-material/esm/Edit.js
var Edit = __webpack_require__(51797);
// EXTERNAL MODULE: ./src/libs/layouts/index.tsx + 2 modules
var layouts = __webpack_require__(5855);
// EXTERNAL MODULE: ./src/modules/form-utils/index.ts + 7 modules
var form_utils = __webpack_require__(10554);
// EXTERNAL MODULE: ./src/modules/notification/index.ts + 3 modules
var notification = __webpack_require__(5769);
// EXTERNAL MODULE: ./src/ui/index.ts + 23 modules
var ui = __webpack_require__(17218);
// EXTERNAL MODULE: ./src/modules/auth/apiHooks.ts + 2 modules
var apiHooks = __webpack_require__(44759);
;// CONCATENATED MODULE: ./src/modules/auth/organisms/SAMLProviderActions.tsx
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}














const messages = {
    formStep1: "STEP 1: Configure SAML provider",
    formStep2: "STEP 2: Fill additional information",
    formStep2Hint: "All fields are required",
    form: {
        authCallbackLabel: "Add this authorization callback URL to your SAML app configuration",
        name: "Name",
        entityId: "Identity provider entity ID",
        ssoUrl: "SSO URL",
        spId: "Service provider entity ID",
        certificate: "Certificate",
        addCertificate: "+Add additional certificate"
    },
    buttons: {
        save: "Save",
        cancel: "Cancel",
        Delete: "Delete"
    },
    notification: {
        copyCallBack: "Callback URL was copied"
    },
    addNew: "Add new saml",
    createNewProvider: "Add new saml provider",
    editProvider: "Edit saml provider",
    cancel: "Cancel",
    created: "Provider was created",
    updated: "Provider was updated",
    confirmDelete: (provider)=>`Are you sure you want to delete "${provider}" provider?`
};
const localTheme = {
    callbackURLBackground: "rgba(191, 191, 191, 0.1)",
    copyURLBackground: "rgba(191, 191, 191, 0.2)"
};
function CallbackURL({ value  }) {
    return /*#__PURE__*/ react.createElement(layouts/* Stack */.Kq, {
        space: 2
    }, /*#__PURE__*/ react.createElement(Typography/* default */.Z, null, messages.form.authCallbackLabel), /*#__PURE__*/ react.createElement(layouts/* HStack */.Ug, {
        space: 0
    }, /*#__PURE__*/ react.createElement(ui/* Box */.xu, {
        style: {
            flexGrow: 1
        },
        sx: {
            paddingX: ui/* space.2 */.Dh[2],
            paddingY: ui/* space.4 */.Dh[4],
            background: localTheme.callbackURLBackground
        }
    }, /*#__PURE__*/ react.createElement(Typography/* default */.Z, {
        noWrap: true
    }, value)), /*#__PURE__*/ react.createElement(layouts/* HStack.Spacer */.Ug.Spacer, null), /*#__PURE__*/ react.createElement(ui/* Box */.xu, {
        sx: {
            background: localTheme.copyURLBackground,
            centerContent: true,
            width: "52px"
        }
    }, /*#__PURE__*/ react.createElement((lib_default()), {
        text: value,
        onCopy: ()=>notification/* notification.success */.t6.success({
                message: messages.notification.copyCallBack
            })
    }, /*#__PURE__*/ react.createElement(ContentCopy/* default */.Z, {
        fontSize: "small",
        cursor: "pointer"
    })))));
}
function Certificate({ name  }) {
    const { fields  } = (0,react_final_form_arrays_es/* useFieldArray */.Dq)(name);
    return /*#__PURE__*/ react.createElement(layouts/* Stack */.Kq, {
        align: "flex-start",
        fullWidth: true
    }, fields.map((name, i)=>{
        return /*#__PURE__*/ react.createElement(layouts/* Stack */.Kq, {
            space: 1,
            fullWidth: true,
            key: name
        }, /*#__PURE__*/ react.createElement(layouts/* HStack */.Ug, {
            space: 2,
            fullWidth: true
        }, /*#__PURE__*/ react.createElement(Typography/* default */.Z, {
            variant: "caption"
        }, messages.form.certificate), /*#__PURE__*/ react.createElement(layouts/* HStack.Spacer */.Ug.Spacer, null), /*#__PURE__*/ react.createElement(permissions/* Can */.m1, {
            do: "admin_saml__modify"
        }, /*#__PURE__*/ react.createElement(IconButton/* default */.Z, {
            color: "secondary",
            size: "small",
            onClick: ()=>fields.remove(i)
        }, /*#__PURE__*/ react.createElement(Delete/* default */.Z, {
            fontSize: "small"
        })))), /*#__PURE__*/ react.createElement(react_final_form_es/* Field */.gN, {
            validate: form_utils/* required */.C1,
            name: name,
            render: ({ input  })=>{
                return /*#__PURE__*/ react.createElement(ui/* Box */.xu, _object_spread_props(_object_spread({
                    as: form_utils/* TextFieldComponent */.af
                }, input), {
                    placeholder: "Certificate",
                    multiline: true,
                    sx: {
                        paddingX: ui/* space.2 */.Dh[2],
                        paddingTop: ui/* space.3 */.Dh[3],
                        paddingBottom: ui/* space.8 */.Dh[8],
                        background: localTheme.callbackURLBackground
                    },
                    style: {
                        appearance: "none"
                    }
                }));
            }
        }));
    }), /*#__PURE__*/ react.createElement(permissions/* Can */.m1, {
        do: "admin_saml__modify"
    }, /*#__PURE__*/ react.createElement(Button/* default */.Z, {
        onClick: ()=>fields.push("")
    }, messages.form.addCertificate)));
}
function SAMLProviderForm({ submitError , onCancel , loading  }) {
    return /*#__PURE__*/ react.createElement(ui/* Box */.xu, {
        sx: {
            paddingY: ui/* space.3 */.Dh[3]
        }
    }, /*#__PURE__*/ react.createElement(layouts/* Stack */.Kq, {
        space: 7
    }, /*#__PURE__*/ react.createElement(layouts/* Stack */.Kq, {
        space: 1
    }, /*#__PURE__*/ react.createElement(Typography/* default */.Z, {
        style: {
            fontWeight: 500
        }
    }, messages.formStep1), /*#__PURE__*/ react.createElement(CallbackURL, {
        value: runenv/* ENV.SSO_AUTH_URL */.V.SSO_AUTH_URL
    })), /*#__PURE__*/ react.createElement(layouts/* Stack */.Kq, {
        space: 5
    }, /*#__PURE__*/ react.createElement(Typography/* default */.Z, {
        style: {
            fontWeight: 500
        }
    }, messages.formStep2, /*#__PURE__*/ react.createElement(Typography/* default */.Z, {
        component: "span",
        display: "inline"
    }, "(", messages.formStep2Hint, ")")), /*#__PURE__*/ react.createElement(react_final_form_es/* Field */.gN, {
        validate: form_utils/* required */.C1,
        name: "name",
        label: messages.form.name,
        component: form_utils/* TextFieldComponent */.af
    }), /*#__PURE__*/ react.createElement(react_final_form_es/* Field */.gN, {
        validate: form_utils/* required */.C1,
        name: "idp_entity_id",
        label: messages.form.entityId,
        component: form_utils/* TextFieldComponent */.af
    }), /*#__PURE__*/ react.createElement(react_final_form_es/* Field */.gN, {
        name: "sso_url",
        validate: form_utils/* required */.C1,
        label: messages.form.ssoUrl,
        component: form_utils/* TextFieldComponent */.af
    }), /*#__PURE__*/ react.createElement(react_final_form_es/* Field */.gN, {
        validate: form_utils/* required */.C1,
        name: "rp_entity_id",
        label: messages.form.spId,
        component: form_utils/* TextFieldComponent */.af
    }), /*#__PURE__*/ react.createElement(Certificate, {
        name: "x509_certificates"
    })), /*#__PURE__*/ react.createElement(Divider/* default */.Z, null), submitError && /*#__PURE__*/ react.createElement(FormHelperText/* default */.Z, {
        error: true
    }, submitError), /*#__PURE__*/ react.createElement(layouts/* HStack */.Ug, {
        space: 1
    }, /*#__PURE__*/ react.createElement(layouts/* Spacer */.LZ, null), /*#__PURE__*/ react.createElement(Button/* default */.Z, {
        onClick: onCancel
    }, messages.buttons.cancel), /*#__PURE__*/ react.createElement(permissions/* Can */.m1, {
        do: "admin_saml__modify"
    }, /*#__PURE__*/ react.createElement(ui/* LoadingButton */.fl, {
        isLoading: loading,
        type: "submit",
        color: "primary",
        variant: "contained"
    }, messages.buttons.save)))));
}
function getSubmitError(error) {
    return (error === null || error === void 0 ? void 0 : error.response.data.error) || (error === null || error === void 0 ? void 0 : error.message);
}
function SAMLProviderModal({ open , title , error , initialValues , onCancel , onSubmit  }) {
    if (!open) {
        return null;
    }
    return /*#__PURE__*/ react.createElement(Dialog/* default */.Z, {
        open: true
    }, /*#__PURE__*/ react.createElement(layouts/* Stack */.Kq, {
        space: 1
    }, /*#__PURE__*/ react.createElement(ui/* Box */.xu, {
        as: Paper/* default */.Z,
        sx: {
            paddingTop: ui/* space.3 */.Dh[3],
            paddingX: ui/* space.3 */.Dh[3]
        }
    }, /*#__PURE__*/ react.createElement(layouts/* HStack */.Ug, {
        style: {
            width: "100%"
        }
    }, /*#__PURE__*/ react.createElement(Typography/* default */.Z, {
        variant: "h5",
        style: {
            textTransform: "uppercase"
        }
    }, title), /*#__PURE__*/ react.createElement(layouts/* HStack.Spacer */.Ug.Spacer, null), /*#__PURE__*/ react.createElement(Close/* default */.Z, {
        style: {
            cursor: "pointer"
        },
        onClick: onCancel
    })), /*#__PURE__*/ react.createElement(react_final_form_es/* Form */.l0, {
        keepDirtyOnReinitialize: true,
        onSubmit: onSubmit,
        initialValues: initialValues,
        mutators: _object_spread({}, final_form_arrays_es/* default */.Z),
        render: (props)=>{
            return /*#__PURE__*/ react.createElement(ui/* Box */.xu, {
                as: "form",
                onSubmit: props.handleSubmit
            }, /*#__PURE__*/ react.createElement(SAMLProviderForm, {
                onCancel: onCancel,
                loading: props.submitting,
                submitError: getSubmitError(error)
            }));
        }
    }))));
}
function EditSAMLProvider({ provider  }) {
    const [isEditing, setIsEditing] = (0,react.useState)(false);
    const [update, { error  }] = (0,apiHooks/* useSAMLProviderUpdate */.ts)({
        onDone () {
            setIsEditing(false);
            notification/* notification.success */.t6.success({
                message: messages.updated
            });
        }
    });
    function cancel() {
        setIsEditing(false);
    }
    return /*#__PURE__*/ react.createElement(react.Fragment, null, /*#__PURE__*/ react.createElement(SAMLProviderModal, {
        open: isEditing,
        title: messages.editProvider,
        initialValues: provider,
        error: error,
        onCancel: cancel,
        onSubmit: update
    }), /*#__PURE__*/ react.createElement(IconButton/* default */.Z, {
        color: "secondary",
        onClick: ()=>{
            setIsEditing(true);
        },
        size: "large"
    }, /*#__PURE__*/ react.createElement(Edit/* default */.Z, {
        fontSize: "small"
    })));
}
function AddNewSAMLProvider() {
    const [isAdding, setIsAdding] = (0,react.useState)(false);
    const [create, { error  }] = (0,apiHooks/* useSAMLProviderCreate */.b4)({
        onDone () {
            setIsAdding(false);
            notification/* notification.success */.t6.success({
                message: messages.created
            });
        }
    });
    function cancel() {
        setIsAdding(false);
    }
    return /*#__PURE__*/ react.createElement(layouts/* HStack */.Ug, {
        style: {
            width: "100%"
        }
    }, /*#__PURE__*/ react.createElement(SAMLProviderModal, {
        open: isAdding,
        title: messages.createNewProvider,
        initialValues: {
            x509_certificates: [
                ""
            ],
            enabled: true
        },
        error: error,
        onCancel: cancel,
        onSubmit: create
    }), /*#__PURE__*/ react.createElement(layouts/* HStack.Spacer */.Ug.Spacer, null), /*#__PURE__*/ react.createElement(Button/* default */.Z, {
        variant: "contained",
        color: "primary",
        onClick: ()=>setIsAdding(true)
    }, messages.addNew));
}
function DeleteSAMLProvider({ provider  }) {
    const [samlProviderDelete] = (0,apiHooks/* useSAMLProviderDelete */.UU)();
    const [deleteConfirmNode, deleteConfirmActions] = (0,ui/* useFormDialog */.xq)({
        onSubmit: ()=>{
            samlProviderDelete({
                id: provider.id
            });
        },
        messages: {
            confirm: "Yes",
            cancel: "Cancel"
        },
        children: /*#__PURE__*/ react.createElement(ui/* Text */.xv, {
            variant: "body2",
            color: "textSecondary"
        }, messages.confirmDelete(provider.name))
    });
    return /*#__PURE__*/ react.createElement(react.Fragment, null, /*#__PURE__*/ react.createElement(IconButton/* default */.Z, {
        color: "secondary",
        onClick: ()=>{
            deleteConfirmActions.handleOpen();
        },
        size: "large"
    }, /*#__PURE__*/ react.createElement(Delete/* default */.Z, {
        fontSize: "small"
    })), deleteConfirmNode);
}

// EXTERNAL MODULE: ./node_modules/lodash-es/reduce.js + 1 modules
var reduce = __webpack_require__(85697);
// EXTERNAL MODULE: ./node_modules/lodash-es/upperFirst.js + 1 modules
var upperFirst = __webpack_require__(85295);
// EXTERNAL MODULE: ./node_modules/react-query/es/index.js + 22 modules
var es = __webpack_require__(21478);
// EXTERNAL MODULE: ./node_modules/react-router-dom/dist/index.js
var dist = __webpack_require__(79655);
// EXTERNAL MODULE: ./node_modules/@mui/material/LinearProgress/LinearProgress.js + 1 modules
var LinearProgress = __webpack_require__(69041);
// EXTERNAL MODULE: ./src/modules/users/utils.ts
var utils = __webpack_require__(82735);
// EXTERNAL MODULE: ./src/modules/auth/useAuthProviders.ts
var useAuthProviders = __webpack_require__(2219);
// EXTERNAL MODULE: ./src/modules/auth/atoms/index.ts + 4 modules
var atoms = __webpack_require__(15807);
// EXTERNAL MODULE: ./src/modules/auth/messages.ts
var auth_messages = __webpack_require__(23456);
// EXTERNAL MODULE: ./src/modules/users/organisms/SetupPhoneMFA.tsx
var SetupPhoneMFA = __webpack_require__(73646);
;// CONCATENATED MODULE: ./src/modules/auth/organisms/SetupMFA.tsx





function SetupMFA({ onDone  }) {
    return /*#__PURE__*/ react.createElement(react.Fragment, null, /*#__PURE__*/ react.createElement(ui/* VStack */.gC, null, /*#__PURE__*/ react.createElement(Typography/* default */.Z, {
        variant: "h6",
        style: {
            textTransform: "capitalize"
        }
    }, auth_messages/* messages.setupMFA */.s.setupMFA), /*#__PURE__*/ react.createElement(SetupPhoneMFA/* SetupPhoneMFA */.U, {
        onDone: onDone
    })));
}

// EXTERNAL MODULE: ./src/modules/auth/loginHooks.tsx
var loginHooks = __webpack_require__(26653);
;// CONCATENATED MODULE: ./src/modules/auth/organisms/LoginForm.tsx
function LoginForm_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function LoginForm_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            LoginForm_define_property(target, key, source[key]);
        });
    }
    return target;
}
function LoginForm_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function LoginForm_object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        LoginForm_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}















const initialValues = {
    email: "",
    password: ""
};
const validate = (values)=>{
    return (0,reduce/* default */.Z)(values, (errors, value, field)=>{
        if (!value) {
            errors[field] = auth_messages/* messages.validation.required */.s.validation.required;
        }
        return errors;
    }, {});
};
const renderForm = ({ handleSubmit , submitting , error , submitError  })=>{
    return /*#__PURE__*/ react.createElement("form", {
        onSubmit: handleSubmit,
        autoComplete: "on"
    }, submitting && /*#__PURE__*/ react.createElement(LinearProgress/* default */.Z, null), /*#__PURE__*/ react.createElement(layouts/* Stack */.Kq, {
        space: 4
    }, !submitting && error && /*#__PURE__*/ react.createElement(FormHelperText/* default */.Z, {
        error: true
    }, error || submitError), /*#__PURE__*/ react.createElement(react_final_form_es/* Field */.gN, {
        name: "email",
        component: atoms/* EmailField */.s8,
        placeholder: auth_messages/* messages.formFields.email */.s.formFields.email,
        fullWidth: true,
        parse: utils/* parseEmail */.g$,
        validate: utils/* validateEmail */.oH
    }), /*#__PURE__*/ react.createElement(react_final_form_es/* Field */.gN, {
        name: "password",
        component: atoms/* PasswordField */.ZI,
        placeholder: auth_messages/* messages.formFields.password */.s.formFields.password,
        fullWidth: true
    }), /*#__PURE__*/ react.createElement(layouts/* Stack */.Kq, {
        space: 2
    }, /*#__PURE__*/ react.createElement(Button/* default */.Z, {
        fullWidth: true,
        color: "primary",
        variant: "contained",
        type: "submit",
        disabled: submitting
    }, auth_messages/* messages.logIn */.s.logIn), /*#__PURE__*/ react.createElement(dist/* Link */.rU, {
        to: "/forgot",
        style: {
            textAlign: "center",
            color: "#818181",
            textDecoration: "none"
        }
    }, auth_messages/* messages.forgotPassword */.s.forgotPassword))));
};
function LoginForm() {
    const [login, { error , reset  }] = (0,apiHooks/* useLogin */.f0)();
    const [captchaNode, verifier] = (0,loginHooks/* useCaptcha */.u)([], (error === null || error === void 0 ? void 0 : error.type) === "mfa");
    const [sendCode, { error: sendCodeError  }] = (0,es/* useMutation */.Db)(()=>{
        return (error === null || error === void 0 ? void 0 : error.type) === "mfa" ? error.sendCode(verifier.current) : Promise.resolve();
    });
    window.loginInternal = ()=>{
        login({
            type: "cloud",
            cloud: "google",
            params: {
                name: "google.com"
            }
        });
    };
    const { providers , isAllLoading , isSomeLoading , isPasswordAuthEnabled  } = (0,useAuthProviders/* useAvailableAuthProviders */.e0)();
    (0,react.useEffect)(()=>{
        if ((error === null || error === void 0 ? void 0 : error.type) === "mfa") {
            setTimeout(()=>{
                sendCode();
            }, 200);
        }
    }, [
        error
    ]);
    if ((error === null || error === void 0 ? void 0 : error.type) === "mfa") {
        return /*#__PURE__*/ react.createElement(react_final_form_es/* Form */.l0, {
            validate: (0,utils/* getValidator */.Te)((0,utils/* getNotEmptyValidatorWithLabel */.AC)("twoFactorCode", "Two factor code is required")),
            onSubmit: (v)=>{
                return error.verifyCode(v.twoFactorCode);
            },
            render: (props)=>{
                /*#__PURE__*/ return react.createElement(react.Fragment, null, captchaNode, /*#__PURE__*/ react.createElement(atoms/* TwoFactorPhoneAuthForm */.yP, LoginForm_object_spread_props(LoginForm_object_spread({}, props), {
                    error: props.error || (sendCodeError === null || sendCodeError === void 0 ? void 0 : sendCodeError.message),
                    onCancel: reset,
                    resend: ()=>{
                        sendCode();
                    }
                })));
            }
        });
    }
    if ((error === null || error === void 0 ? void 0 : error.type) === "mfa-required") {
        return /*#__PURE__*/ react.createElement(SetupMFA, {
            onDone: error.finishAuth
        });
    }
    return /*#__PURE__*/ react.createElement(layouts/* Stack */.Kq, {
        space: 4
    }, isAllLoading && /*#__PURE__*/ react.createElement(ui/* Loader */.aN, {
        loading: true
    }), isSomeLoading && !isAllLoading && /*#__PURE__*/ react.createElement(LinearProgress/* default */.Z, null), /*#__PURE__*/ react.createElement(layouts/* Stack */.Kq, {
        space: 2
    }, providers.map((provider)=>{
        return /*#__PURE__*/ react.createElement(atoms/* ProviderButton */.Mx, {
            key: provider.id,
            type: provider.cloudType,
            label: `Log in with ${(0,upperFirst/* default */.Z)(provider.name)}`,
            onClick: ()=>login({
                    type: "cloud",
                    cloud: provider.cloudType,
                    params: {
                        name: provider.id
                    }
                })
        });
    })), isPasswordAuthEnabled && /*#__PURE__*/ react.createElement(react.Fragment, null, !!(providers === null || providers === void 0 ? void 0 : providers.length) && /*#__PURE__*/ react.createElement(ui/* DividerWithText */.ZC, null, "OR"), /*#__PURE__*/ react.createElement(react_final_form_es/* Form */.l0, {
        initialValues: initialValues,
        validate: validate,
        onSubmit: (values)=>login({
                type: "local",
                values
            }),
        render: (values)=>{
            return renderForm(LoginForm_object_spread_props(LoginForm_object_spread({}, values), {
                submitError: error === null || error === void 0 ? void 0 : error.message
            }));
        }
    })));
}

// EXTERNAL MODULE: ./node_modules/@mui/material/Grid/Grid.js + 2 modules
var Grid = __webpack_require__(15725);
// EXTERNAL MODULE: ./src/modules/auth/utils.ts
var auth_utils = __webpack_require__(27490);
;// CONCATENATED MODULE: ./src/modules/auth/organisms/RegistrationForm.tsx
function RegistrationForm_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function RegistrationForm_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            RegistrationForm_define_property(target, key, source[key]);
        });
    }
    return target;
}
function RegistrationForm_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function RegistrationForm_object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        RegistrationForm_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
















function RegistrationForm_validate(values) {
    const passwordsFilled = !!values.password && !!values.passwordRepeat;
    const passwordsEqual = values.password === values.passwordRepeat;
    const errors = [
        "password",
        "passwordRepeat",
        "email"
    ].reduce((errors, field)=>{
        const value = values[field];
        if (!value) {
            errors[field] = auth_messages/* messages.validation.required */.s.validation.required;
        }
        return errors;
    }, {});
    if (values.name && values.name.length < 3) {
        errors.name = auth_messages/* messages.validation.nameMinLength */.s.validation.nameMinLength;
    }
    const complexityValidation = (0,auth_utils/* validatePasswordComplexity */.V)(values.password);
    if (complexityValidation) {
        errors.password = complexityValidation;
        return errors;
    }
    if (passwordsFilled && !passwordsEqual) {
        errors.passwordRepeat = auth_messages/* messages.validation.passEquality */.s.validation.passEquality;
    }
    return errors;
}
function canSignUp(params) {
    if (!params.oobCode) {
        return {
            error: true,
            errorMessage: auth_messages/* messages.notifications.notInvitedAccount */.s.notifications.notInvitedAccount
        };
    }
    return {
        error: null,
        errorMessage: ""
    };
}
function RegistrationForm(props) {
    const initialValues = {
        email: props.email,
        name: props.email.split("@")[0],
        password: "",
        passwordRepeat: ""
    };
    const isPasswordOnlyAuth = !!props.isPasswordReset;
    const { providers , isAllLoading , isSomeLoading , isPasswordAuthEnabled  } = (0,useAuthProviders/* useAvailableAuthProviders */.e0)();
    const [passwordToggle, setPasswordToggle] = (0,react.useState)(isPasswordOnlyAuth);
    const [mutate, { error , isLoading: isSigningUp , reset  }] = (0,apiHooks/* useSignUp */.QS)(props.email);
    const [captchaNode, verifier] = (0,loginHooks/* useCaptcha */.u)([], (error === null || error === void 0 ? void 0 : error.type) === "mfa");
    const [sendCode, { error: sendCodeError  }] = (0,es/* useMutation */.Db)(()=>{
        return (error === null || error === void 0 ? void 0 : error.type) === "mfa" ? error.sendCode(verifier.current) : Promise.resolve("");
    });
    // hack for internal auth
    window.internalAuthSignUp = ()=>mutate({
            type: "cloud",
            cloud: "google",
            params: {
                name: "google.com"
            }
        });
    (0,react.useEffect)(()=>{
        if ((error === null || error === void 0 ? void 0 : error.type) === "mfa") {
            setTimeout(()=>{
                sendCode();
            }, 200);
        }
    }, [
        error
    ]);
    if ((error === null || error === void 0 ? void 0 : error.type) === "mfa") {
        return /*#__PURE__*/ react.createElement(react_final_form_es/* Form */.l0, {
            validate: (0,utils/* getValidator */.Te)((0,utils/* getNotEmptyValidatorWithLabel */.AC)("twoFactorCode", "Two factor code is required")),
            onSubmit: (v)=>{
                return error.verifyCode(v.twoFactorCode);
            },
            render: (props)=>{
                /*#__PURE__*/ return react.createElement(react.Fragment, null, captchaNode, /*#__PURE__*/ react.createElement(atoms/* TwoFactorPhoneAuthForm */.yP, RegistrationForm_object_spread_props(RegistrationForm_object_spread({}, props), {
                    error: props.error || (sendCodeError === null || sendCodeError === void 0 ? void 0 : sendCodeError.message),
                    onCancel: reset,
                    resend: ()=>{
                        sendCode();
                    }
                })));
            }
        });
    }
    if ((error === null || error === void 0 ? void 0 : error.type) === "mfa-required") {
        return /*#__PURE__*/ react.createElement(SetupMFA, {
            onDone: error.finishAuth
        });
    }
    return /*#__PURE__*/ react.createElement(react.Fragment, null, isAllLoading && /*#__PURE__*/ react.createElement(ui/* Loader */.aN, {
        loading: true
    }), (isSomeLoading && !isAllLoading || isSigningUp) && /*#__PURE__*/ react.createElement(LinearProgress/* default */.Z, null), /*#__PURE__*/ react.createElement(layouts/* Stack */.Kq, {
        space: 3
    }, /*#__PURE__*/ react.createElement(layouts/* Stack */.Kq, {
        space: 2
    }, !isPasswordOnlyAuth && providers.map((provider)=>{
        return /*#__PURE__*/ react.createElement(atoms/* ProviderButton */.Mx, {
            key: provider.id,
            type: provider.cloudType,
            label: `Sign up with ${(0,upperFirst/* default */.Z)(provider.name)}`,
            onClick: ()=>mutate({
                    type: "cloud",
                    cloud: provider.cloudType,
                    params: {
                        name: provider.id
                    }
                })
        });
    }), !passwordToggle && isPasswordAuthEnabled && /*#__PURE__*/ react.createElement(atoms/* ProviderButton */.Mx, {
        type: "password",
        label: "Sign up with Password",
        onClick: ()=>setPasswordToggle(true)
    })), error && !isSigningUp && /*#__PURE__*/ react.createElement(Grid/* default */.ZP, {
        item: true
    }, /*#__PURE__*/ react.createElement(FormHelperText/* default */.Z, {
        error: true
    }, error === null || error === void 0 ? void 0 : error.message)), passwordToggle && /*#__PURE__*/ react.createElement(react_final_form_es/* Form */.l0, {
        initialValues: initialValues,
        validate: RegistrationForm_validate,
        onSubmit: (values)=>mutate({
                type: "local",
                values
            }),
        render: ({ handleSubmit , submitting  })=>{
            return /*#__PURE__*/ react.createElement("form", {
                onSubmit: handleSubmit
            }, /*#__PURE__*/ react.createElement(Grid/* default */.ZP, {
                container: true,
                direction: "column",
                spacing: 2
            }, /*#__PURE__*/ react.createElement(Grid/* default */.ZP, {
                item: true
            }, /*#__PURE__*/ react.createElement(react_final_form_es/* Field */.gN, {
                name: "email",
                component: ui/* TextFieldInput */.Nl,
                label: auth_messages/* messages.formFields.email */.s.formFields.email,
                fullWidth: true,
                disabled: true,
                parse: utils/* parseEmail */.g$,
                validateOnBlur: true,
                validate: utils/* validateEmail */.oH
            })), /*#__PURE__*/ react.createElement(Grid/* default */.ZP, {
                item: true
            }, /*#__PURE__*/ react.createElement(react_final_form_es/* Field */.gN, {
                hideIcon: true,
                fullWidth: true,
                component: atoms/* PasswordField */.ZI,
                name: "password",
                label: auth_messages/* messages.formFields.password */.s.formFields.password,
                autoComplete: "new-password"
            })), /*#__PURE__*/ react.createElement(Grid/* default */.ZP, {
                item: true
            }, /*#__PURE__*/ react.createElement(react_final_form_es/* Field */.gN, {
                hideIcon: true,
                fullWidth: true,
                component: atoms/* PasswordField */.ZI,
                name: "passwordRepeat",
                label: auth_messages/* messages.formFields.repeatPass */.s.formFields.repeatPass,
                autoComplete: "new-password"
            }), /*#__PURE__*/ react.createElement(FormHelperText/* default */.Z, null, auth_messages/* messages.formFields.repeatPassRule */.s.formFields.repeatPassRule)), /*#__PURE__*/ react.createElement(Button/* default */.Z, {
                fullWidth: true,
                color: "primary",
                variant: "outlined",
                type: "submit",
                disabled: submitting
            }, auth_messages/* messages.signUp */.s.signUp)));
        }
    }), /*#__PURE__*/ react.createElement(dist/* Link */.rU, {
        to: "/forgot",
        style: {
            textAlign: "center",
            color: "#818181",
            textDecoration: "none"
        }
    }, auth_messages/* messages.forgotPassword */.s.forgotPassword)));
}

// EXTERNAL MODULE: ./src/modules/table/index.tsx + 8 modules
var table = __webpack_require__(25373);
// EXTERNAL MODULE: ./src/modules/graph-search-panel/atoms/index.tsx + 4 modules
var graph_search_panel_atoms = __webpack_require__(92722);
;// CONCATENATED MODULE: ./src/modules/auth/organisms/AuthProviderTable.tsx
function AuthProviderTable_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function AuthProviderTable_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            AuthProviderTable_define_property(target, key, source[key]);
        });
    }
    return target;
}
function AuthProviderTable_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function AuthProviderTable_object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        AuthProviderTable_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}











function AuthProviderStatusCell({ provider , enabled  }) {
    const [updateSAMLProvider] = (0,apiHooks/* useSAMLProviderUpdate */.ts)({});
    const [updateDefaultProviderAvailability] = (0,apiHooks/* useDefaultProviderAvailabilityUpdate */.mI)();
    const enabledProvidersCount = (0,useAuthProviders/* useEnabledProvidersCount */.C6)();
    const isLastEnabledProvider = enabledProvidersCount === 1 && enabled;
    const [checked, setChecked] = (0,react.useState)(enabled);
    (0,react.useEffect)(()=>{
        setChecked(enabled);
    }, [
        enabled
    ]);
    const updateProviderAvailability = (newChecked)=>{
        // optimistic update
        setChecked(newChecked);
        const updateFn = provider.type === useAuthProviders/* ProviderType.SAML */.lP.SAML ? ()=>updateSAMLProvider(AuthProviderTable_object_spread_props(AuthProviderTable_object_spread({}, provider.data), {
                enabled: newChecked
            })) : ()=>updateDefaultProviderAvailability({
                name: provider.data.name,
                enabled: newChecked
            });
        updateFn().catch(()=>{
            notification/* notification.error */.t6.error({
                message: auth_messages/* messages.failedToUpdateProvider */.s.failedToUpdateProvider
            });
            setChecked(checked);
        });
    };
    return /*#__PURE__*/ react.createElement(permissions/* Can */.m1, {
        do: "admin_saml__modify"
    }, ({ canDo  })=>/*#__PURE__*/ react.createElement(ui/* HStack */.Ug, {
            space: "1",
            title: isLastEnabledProvider ? auth_messages/* messages.lastEnabledProvidedTooltip */.s.lastEnabledProvidedTooltip : ""
        }, /*#__PURE__*/ react.createElement(graph_search_panel_atoms/* Switch */.rs, {
            checked: checked,
            onChange: (event)=>updateProviderAvailability(event.target.checked),
            disabled: !canDo || isLastEnabledProvider
        }), /*#__PURE__*/ react.createElement(ui/* Typography */.ZT, null, checked ? auth_messages/* messages.enabledProvider */.s.enabledProvider : auth_messages/* messages.disabledProvider */.s.disabledProvider)));
}
function AuthProviderEnforceMFACell({ provider , enabled  }) {
    const [updatePasswordProviderMFA] = (0,apiHooks/* usePasswordProviderMFAUpdate */.Qf)();
    const [checked, setChecked] = (0,react.useState)(enabled);
    (0,react.useEffect)(()=>{
        setChecked(enabled);
    }, [
        enabled
    ]);
    const updateProviderMFA = (newChecked)=>{
        // optimistic update
        setChecked(newChecked);
        updatePasswordProviderMFA({
            enforce: newChecked
        }).catch(()=>{
            notification/* notification.error */.t6.error({
                message: auth_messages/* messages.failedToUpdateProvider */.s.failedToUpdateProvider
            });
            setChecked(checked);
        });
    };
    if (provider.id !== "password") {
        return null;
    }
    return /*#__PURE__*/ react.createElement(permissions/* Can */.m1, {
        do: "admin_saml__modify"
    }, ({ canDo  })=>/*#__PURE__*/ react.createElement(ui/* HStack */.Ug, {
            space: "1"
        }, /*#__PURE__*/ react.createElement(graph_search_panel_atoms/* Switch */.rs, {
            checked: checked,
            onChange: (event)=>updateProviderMFA(event.target.checked),
            disabled: !canDo
        }), /*#__PURE__*/ react.createElement(ui/* Typography */.ZT, null, checked ? auth_messages/* messages.enabledProvider */.s.enabledProvider : auth_messages/* messages.disabledProvider */.s.disabledProvider)));
}
function AuthProviderActionsCell({ provider  }) {
    if (provider.type !== useAuthProviders/* ProviderType.SAML */.lP.SAML) {
        return null;
    }
    return /*#__PURE__*/ react.createElement(permissions/* Can */.m1, {
        do: "admin_saml__modify"
    }, /*#__PURE__*/ react.createElement(ui/* HStack */.Ug, {
        space: "1",
        fullWidth: true,
        sx: {
            justifyContent: "center"
        }
    }, /*#__PURE__*/ react.createElement(EditSAMLProvider, {
        provider: provider.data
    }), /*#__PURE__*/ react.createElement(DeleteSAMLProvider, {
        provider: provider.data
    })));
}
const columns = [
    {
        Header: "Name",
        id: "name",
        resizable: true,
        width: "1fr",
        Cell: ({ value  })=>{
            return /*#__PURE__*/ react.createElement(ui/* Typography */.ZT, {
                noWrap: true,
                title: value
            }, value);
        }
    },
    {
        Header: "Status",
        id: "enabled",
        resizable: true,
        width: "1fr",
        Cell: ({ original , value  })=>/*#__PURE__*/ react.createElement(AuthProviderStatusCell, {
                provider: original,
                enabled: value
            })
    },
    {
        Header: "Enforce MFA",
        id: "enforce_mfa",
        resizable: true,
        width: "1fr",
        Cell: ({ original , value  })=>/*#__PURE__*/ react.createElement(AuthProviderEnforceMFACell, {
                provider: original,
                enabled: value
            })
    },
    {
        Header: "Actions",
        id: "id",
        width: 200,
        Cell: ({ original  })=>/*#__PURE__*/ react.createElement(AuthProviderActionsCell, {
                provider: original
            })
    }
].filter((el)=>{
    if (el.id === "enforce_mfa") {
        return runenv/* ENV.FEATURES.ENFORCE_2FA_UI */.V.FEATURES.ENFORCE_2FA_UI;
    }
    return true;
});
function AuthProviderTable() {
    const { isLoading , data  } = (0,useAuthProviders/* useAuthProviders */.pl)();
    return /*#__PURE__*/ react.createElement(ui/* TableTemplate */.Tt, null, /*#__PURE__*/ react.createElement(table/* GenericTable */.m, {
        isLoading: isLoading,
        data: data,
        columns: columns
    }));
}

// EXTERNAL MODULE: ./node_modules/react-idle-timer/dist/index.esm.js
var index_esm = __webpack_require__(88460);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/formatDuration/index.js
var formatDuration = __webpack_require__(784);
// EXTERNAL MODULE: ./node_modules/react-router/dist/index.js
var react_router_dist = __webpack_require__(89250);
// EXTERNAL MODULE: ./src/libs/hooks/index.ts + 18 modules
var hooks = __webpack_require__(88289);
// EXTERNAL MODULE: ./src/modules/auth/state.ts
var state = __webpack_require__(45386);
// EXTERNAL MODULE: ./src/modules/auth/effects.ts
var effects = __webpack_require__(77805);
// EXTERNAL MODULE: ./src/modules/auth/constants.ts
var constants = __webpack_require__(7877);
;// CONCATENATED MODULE: ./src/modules/auth/organisms/UserInactivityHandler.tsx
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function UserInactivityHandler_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function UserInactivityHandler_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            UserInactivityHandler_define_property(target, key, source[key]);
        });
    }
    return target;
}
function UserInactivityHandler_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function UserInactivityHandler_object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        UserInactivityHandler_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}












const getRemainingTimeSeconds = (remainingTime)=>{
    return Math.ceil(remainingTime / 1000);
};
function UserInactivityTracker({ onStay , onIdle , onMessage , timeout , promptTimeout  }) {
    const timer = (0,index_esm/* useIdleTimer */.Yp)({
        crossTab: true,
        syncTimers: 500,
        timeout,
        promptBeforeIdle: promptTimeout,
        onIdle: ()=>onIdle(timer),
        onPrompt: ()=>inactivityPopupApi.handleOpen(),
        onMessage: (message)=>{
            inactivityPopupApi.handleClose();
            onMessage(timer, message);
        }
    });
    const [inactivityPopup, inactivityPopupApi] = (0,hooks/* useModal */.dd)((args)=>{
        const [remainingTime, setRemainingTime] = (0,react.useState)();
        const formatTimeNum = (num)=>String(num).padStart(2, "0");
        const remainingTimeMilliseconds = timer.getRemainingTime();
        const timeLabels = {
            xMinutes: "min",
            xSeconds: "s"
        };
        const updateRemainingTime = ()=>{
            const remainingSeconds = getRemainingTimeSeconds(timer.getRemainingTime());
            setRemainingTime((0,formatDuration/* default */.Z)({
                minutes: remainingSeconds > 59 ? Math.floor(remainingSeconds / 60) : undefined,
                seconds: Math.floor(remainingSeconds % 60)
            }, {
                zero: true,
                delimiter: " : ",
                format: [
                    "minutes",
                    "seconds"
                ],
                locale: {
                    formatDistance: (token, count)=>{
                        return `${formatTimeNum(count)} ${timeLabels[token]}`;
                    }
                }
            }));
        };
        (0,react.useEffect)(()=>{
            if (!args.open) {
                return;
            }
            if (remainingTimeMilliseconds === 0 && args.open) {
                onIdle(timer);
            }
            if (remainingTimeMilliseconds > promptTimeout) {
                onStay(timer);
            }
        }, [
            remainingTimeMilliseconds,
            args.open
        ]);
        (0,react.useEffect)(()=>{
            if (args.open) {
                const interval = setInterval(()=>{
                    updateRemainingTime();
                }, 1000);
                return ()=>{
                    clearInterval(interval);
                };
            }
            return;
        }, [
            args.open
        ]);
        return /*#__PURE__*/ react.createElement(Dialog/* default */.Z, UserInactivityHandler_object_spread_props(UserInactivityHandler_object_spread({}, args), {
            TransitionProps: {
                onEntering: updateRemainingTime
            },
            maxWidth: "xs",
            fullWidth: true,
            disableEscapeKeyDown: true
        }), /*#__PURE__*/ react.createElement(ui/* Card */.Zb, {
            style: {
                padding: `${ui/* space.5 */.Dh[5]} ${ui/* space.4 */.Dh[4]}`
            },
            space: 0
        }, /*#__PURE__*/ react.createElement(ui/* Text */.xv, {
            variant: "subtitle2",
            bold: true,
            style: {
                marginBottom: ui/* space.3 */.Dh[3]
            }
        }, auth_messages/* messages.inactivityPopup.title */.s.inactivityPopup.title), /*#__PURE__*/ react.createElement(ui/* Text */.xv, {
            variant: "header5M",
            style: {
                marginBottom: ui/* space.5 */.Dh[5]
            }
        }, remainingTime), /*#__PURE__*/ react.createElement(ui/* Text */.xv, {
            variant: "body2",
            color: "#737373",
            style: {
                marginBottom: ui/* space.6 */.Dh[6]
            }
        }, auth_messages/* messages.inactivityPopup.description */.s.inactivityPopup.description), /*#__PURE__*/ react.createElement(ui/* CardActions */.T$, null, /*#__PURE__*/ react.createElement(Button/* default */.Z, {
            onClick: ()=>{
                onIdle(timer);
                args.onClose();
            }
        }, auth_messages/* messages.inactivityPopup.logout */.s.inactivityPopup.logout), /*#__PURE__*/ react.createElement(Button/* default */.Z, {
            onClick: ()=>{
                onStay(timer);
                args.onClose();
            },
            variant: "contained",
            color: "primary"
        }, auth_messages/* messages.inactivityPopup.stay */.s.inactivityPopup.stay))));
    }, true);
    return /*#__PURE__*/ react.createElement(react.Fragment, null, inactivityPopup);
}
const crossTabMessages = {
    logout: "LOGOUT_USER",
    stay: "STAY"
};
function UserInactivityHandler() {
    const { id  } = (0,hooks/* useSelector */.v9)(state/* authState.stores.user */.f.stores.user);
    const navigate = (0,react_router_dist/* useNavigate */.s0)();
    const { data , isLoading , isError  } = (0,apiHooks/* useGlobalAuthSettings */.p0)({
        enabled: id
    });
    // Save logging out state to handle multiple logout messages and prevent multiple logout flows start in parallel
    const isLoggingOutRef = (0,react.useRef)(false);
    if (!id || isLoading || isError) {
        return null;
    }
    const inactivityPromptTimeout = ((data === null || data === void 0 ? void 0 : data.inactivity_prompt_timeout_seconds) || constants/* defaultInactivityPromptTimeout */.V) * 1000;
    const inactivityTimeout = ((data === null || data === void 0 ? void 0 : data.inactivity_timeout_seconds) || constants/* defaultInactivityTimeout */.p) * 1000 - inactivityPromptTimeout;
    const handleLogout = (timer)=>{
        timer.message(crossTabMessages.logout, true);
    };
    const handleStay = (timer)=>{
        timer.message(crossTabMessages.stay, true);
    };
    const handleMessage = function() {
        var _ref = _async_to_generator(function*(timer, message) {
            if (message === crossTabMessages.logout && !isLoggingOutRef.current) {
                isLoggingOutRef.current = true;
                yield (0,effects/* logout */.kS)();
                navigate("/login");
                isLoggingOutRef.current = false;
            }
            if (message === crossTabMessages.stay) {
                timer.activate();
            }
        });
        return function handleMessage(timer, message) {
            return _ref.apply(this, arguments);
        };
    }();
    return /*#__PURE__*/ react.createElement(UserInactivityTracker, {
        timeout: inactivityTimeout,
        promptTimeout: inactivityPromptTimeout,
        onIdle: handleLogout,
        onStay: handleStay,
        onMessage: handleMessage
    });
}

;// CONCATENATED MODULE: ./src/modules/auth/organisms/index.ts







/***/ }),

/***/ 36157:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "P": () => (/* binding */ PageTemplate)
});

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
;// CONCATENATED MODULE: ./src/assets/images/cyberhaven-logo3.svg
var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }


const SvgCyberhavenLogo3 = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/react.createElement("svg", _extends({
    width: 264,
    height: 27,
    viewBox: "0 0 264 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/react.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/react.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M59.4422 18.2567C58.6058 18.8581 57.6401 19.2808 56.612 19.4941C56.0184 19.6168 55.4135 19.6755 54.8057 19.6715C51.8379 19.7021 49.1568 18.0033 48.079 15.4045C47.3434 13.6337 47.3434 11.6669 48.079 9.89609C48.4269 9.06003 48.9438 8.29598 49.6027 7.6466C50.2588 6.99588 51.0483 6.47718 51.9231 6.11982C52.8532 5.74379 53.8572 5.55445 54.8696 5.56378C55.4732 5.55845 56.0738 5.61178 56.6646 5.72246C57.18 5.81846 57.6827 5.96514 58.1655 6.15982C58.6143 6.3425 59.0374 6.57185 59.4308 6.84254C59.8284 7.11322 60.2047 7.40791 60.5569 7.72793L59.4308 8.85602C58.8244 8.33064 58.1442 7.88528 57.4115 7.53059C55.2048 6.49051 52.5323 6.93321 50.8382 8.62C50.3255 9.13737 49.9237 9.74275 49.6553 10.4028C49.3656 11.1082 49.2207 11.8576 49.2278 12.6136C49.2222 13.371 49.367 14.1231 49.6553 14.8311C49.9208 15.4965 50.3227 16.1059 50.8382 16.6246C51.3394 17.1313 51.9458 17.538 52.6175 17.8193C53.319 18.118 54.0787 18.2674 54.8483 18.2607C55.7373 18.2834 56.6177 18.106 57.4186 17.742C58.1968 17.362 58.9096 16.8739 59.5316 16.2925L60.6137 17.2873C60.2516 17.6433 59.8596 17.97 59.4422 18.2674V18.2567Z",
    fill: "#373D48"
  })), _path2 || (_path2 = /*#__PURE__*/react.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M77.2037 19.4371H75.5678V14.0407L69.5312 5.80682H71.5207L76.4042 12.6206L81.3289 5.80682H83.236L77.2037 14.0221V19.4371Z",
    fill: "#373D48"
  })), _path3 || (_path3 = /*#__PURE__*/react.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M101.744 6.05004C102.284 6.19138 102.792 6.42206 103.246 6.73009C103.648 7.00611 103.976 7.3688 104.199 7.7875C104.425 8.22753 104.537 8.71023 104.529 9.19826C104.539 9.60229 104.472 10.0063 104.334 10.389C104.212 10.717 104.033 11.0237 103.806 11.2984C103.591 11.5504 103.339 11.7691 103.055 11.9465C102.792 12.1211 102.512 12.2691 102.217 12.3878C102.637 12.5012 103.043 12.6532 103.43 12.8465C103.792 13.0225 104.122 13.2466 104.414 13.5159C104.698 13.7853 104.923 14.1026 105.078 14.4533C105.25 14.848 105.334 15.272 105.325 15.6974C105.335 16.2454 105.206 16.7855 104.95 17.2775C104.702 17.7455 104.337 18.1509 103.884 18.4576C103.38 18.7936 102.815 19.0403 102.217 19.1883C101.515 19.363 100.793 19.4483 100.065 19.4417H93.6284V5.80735H99.7956C100.455 5.79935 101.111 5.88203 101.744 6.05004ZM101.949 11.2555C102.574 10.8328 102.926 10.138 102.879 9.41533C102.903 8.77395 102.595 8.1619 102.05 7.77387C101.351 7.33384 100.517 7.1245 99.6767 7.17783H95.2675V11.8808H99.5503C100.399 11.9142 101.239 11.6955 101.949 11.2555ZM102.737 17.4281C103.363 17.0147 103.724 16.328 103.691 15.6093C103.724 14.9012 103.352 14.2292 102.714 13.8478C102.069 13.4345 101.108 13.2304 99.8386 13.2304H95.2675V18.0601H100.147C101.065 18.1068 101.977 17.8814 102.751 17.4134L102.737 17.4281Z",
    fill: "#373D48"
  })), _path4 || (_path4 = /*#__PURE__*/react.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M126.85 7.20645H117.995V11.8628H125.916V13.2615H117.995V18.0352H126.955V19.438H116.357V5.80768H126.85V7.20645Z",
    fill: "#373D48"
  })), _path5 || (_path5 = /*#__PURE__*/react.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M148.006 19.4379L143.797 14.1509H139.669V19.4379H138.032V5.8076H144.274C145.008 5.79694 145.738 5.89561 146.44 6.09963C147.042 6.27297 147.603 6.55299 148.093 6.92502C148.54 7.27438 148.901 7.71441 149.148 8.21178C149.401 8.73448 149.528 9.30386 149.521 9.87856C149.531 10.3999 149.432 10.9186 149.229 11.4053C149.044 11.8427 148.766 12.2414 148.411 12.5761C148.044 12.9148 147.621 13.1948 147.157 13.4041C146.658 13.6295 146.127 13.7868 145.581 13.8722L150.037 19.4379H148.006ZM146.88 7.93932C146.226 7.46329 145.313 7.23394 144.135 7.23394H139.632V12.7757H144.101C144.609 12.781 145.116 12.7157 145.603 12.581C146.03 12.465 146.434 12.2756 146.79 12.0249C147.118 11.7876 147.384 11.4822 147.566 11.1329C147.759 10.7635 147.855 10.3555 147.848 9.9448C147.888 9.16741 147.524 8.41935 146.871 7.93932H146.88Z",
    fill: "#373D48"
  })), _path6 || (_path6 = /*#__PURE__*/react.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M162.393 13.3007V19.4385H160.757V5.80682H162.393V11.8633H170.771V5.80682H172.409V19.4385H170.771V13.3007H162.393Z",
    fill: "#373D48"
  })), _path7 || (_path7 = /*#__PURE__*/react.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M197.792 19.448H196.029L194.329 15.8464H186.445L184.727 19.448H183.011L189.629 5.71899H191.159L197.778 19.4666L197.792 19.448ZM190.39 7.5295L187.071 14.4807H193.686L190.39 7.5295Z",
    fill: "#373D48"
  })), _path8 || (_path8 = /*#__PURE__*/react.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M217.268 5.80682H219.032L212.789 19.5318H211.332L205.091 5.80682H206.919L212.085 17.5477L217.268 5.80682Z",
    fill: "#373D48"
  })), _path9 || (_path9 = /*#__PURE__*/react.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M240.14 7.20645H231.282V11.8628H239.206V13.2615H231.282V18.0352H240.246V19.438H229.644V5.80768H240.14V7.20645Z",
    fill: "#373D48"
  })), _path10 || (_path10 = /*#__PURE__*/react.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M261.972 5.80682H263.571V19.4371H262.264L252.895 8.26033V19.4371H251.3V5.80682H252.831L261.972 16.7303V5.80682Z",
    fill: "#373D48"
  })), _path11 || (_path11 = /*#__PURE__*/react.createElement("path", {
    d: "M28.2609 9.69255L24.8247 13.1287L28.2609 16.5649L31.6971 13.1287L28.2609 9.69255Z",
    fill: "#373D48"
  })), _path12 || (_path12 = /*#__PURE__*/react.createElement("path", {
    d: "M18.9779 18.9779C15.7487 22.207 10.5121 22.207 7.28088 18.9779C4.05172 15.7487 4.04961 10.5121 7.28088 7.28088C10.51 4.04961 15.7487 4.04961 18.9779 7.28088L21.7626 10.0656L25.1982 6.62999L22.4135 3.84529C17.2864 -1.28176 8.97234 -1.28176 3.84529 3.84529C-1.28176 8.97234 -1.28176 17.2843 3.84529 22.4114C8.97445 27.5384 17.2864 27.5384 22.4135 22.4114L25.1982 19.6267L21.7626 16.1911L18.9779 18.9779Z",
    fill: "#373D48"
  })), _path13 || (_path13 = /*#__PURE__*/react.createElement("path", {
    d: "M10.3461 10.3457C8.80845 11.8834 8.80845 14.3774 10.3461 15.9151C11.8859 17.4528 14.3778 17.4528 15.9155 15.9151L18.7002 13.1304L15.9155 10.3457C14.3778 8.80591 11.8838 8.80802 10.3461 10.3457Z",
    fill: "#39CEF7"
  })));
};
const ForwardRef = /*#__PURE__*/(0,react.forwardRef)(SvgCyberhavenLogo3);

/* harmony default export */ const cyberhaven_logo3 = (__webpack_require__.p + "4fcf1ebd79de7baa6391da275d03fa6c.svg");
;// CONCATENATED MODULE: ./src/assets/images/cyberhaven-logo4.svg
var cyberhaven_logo4_path, cyberhaven_logo4_path2, cyberhaven_logo4_path3, cyberhaven_logo4_path4, cyberhaven_logo4_path5, cyberhaven_logo4_path6, cyberhaven_logo4_path7, cyberhaven_logo4_path8, cyberhaven_logo4_path9, cyberhaven_logo4_path10, cyberhaven_logo4_path11, cyberhaven_logo4_path12, _defs;
function cyberhaven_logo4_extends() { cyberhaven_logo4_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return cyberhaven_logo4_extends.apply(this, arguments); }


const SvgCyberhavenLogo4 = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/react.createElement("svg", cyberhaven_logo4_extends({
    width: 299,
    height: 53,
    viewBox: "0 0 299 53",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/react.createElement("title", {
    id: titleId
  }, title) : null, cyberhaven_logo4_path || (cyberhaven_logo4_path = /*#__PURE__*/react.createElement("path", {
    d: "M27.3557 52.7024C20.1794 52.7024 13.4615 50.208 8.43916 45.6791C3.39962 41.1347 0.403814 34.8491 0.00298734 27.9801C-0.0532729 27.0147 0.691878 26.1866 1.66738 26.1309C2.64723 26.0726 3.47954 26.8127 3.5358 27.7782C3.88255 33.7281 6.47028 39.1662 10.8221 43.0904C15.1914 47.0305 21.063 49.2001 27.3554 49.2001C34.5401 49.2001 40.8006 46.3455 44.8528 41.2958C44.9852 41.1312 44.9429 40.8879 44.7651 40.7726L36.5527 35.4439C36.3305 35.2998 36.0362 35.3122 35.8351 35.4836C33.2415 37.691 29.1282 39.2539 25.8074 39.2539C14.8277 39.2539 6.34255 31.017 6.06994 20.0938C5.94943 15.2506 7.75799 10.5235 11.1626 6.78263C14.5546 3.05516 19.1685 0.708213 24.1539 0.173395C34.5321 -0.93137 44.0867 3.30081 49.0941 11.2172L49.5397 11.922C49.8032 12.3387 49.6817 12.8874 49.266 13.1567L37.9749 20.4845C37.9749 20.4845 37.1711 21.0313 36.9837 21.1682C36.2832 21.6801 35.3104 21.6115 34.6905 21.0062C34.3571 20.681 33.4086 19.765 33.0293 19.439C31.6421 18.247 30.0074 17.5003 28.3019 17.279C27.5829 17.1865 26.8566 17.1848 26.1447 17.2749C22.0409 17.7894 18.6508 21.0915 18.0734 25.1316C17.9416 26.054 17.0909 26.748 16.1538 26.6607C15.1441 26.5669 14.4269 25.6609 14.5645 24.6771C15.3466 19.0858 20.0293 14.5117 25.699 13.8008C26.7095 13.6736 27.7401 13.6753 28.7595 13.8062C31.1582 14.1174 33.4362 15.1505 35.3495 16.7946C35.4647 16.8937 35.6095 17.0244 35.767 17.1698C35.9703 17.3574 36.2774 17.3841 36.5102 17.2336L44.7791 11.8775C44.9568 11.7623 44.9991 11.5195 44.8676 11.3546C40.3449 5.70271 32.7542 2.78106 24.5344 3.65545C20.4168 4.09733 16.6013 6.04013 13.7926 9.12647C10.996 12.1994 9.51004 16.0636 9.60831 20.0075C9.83601 29.1305 16.6488 35.7517 25.8079 35.7517C28.4123 35.7517 31.9345 34.3504 33.8261 32.5612L33.9357 32.4656C34.0796 32.3506 34.5357 31.9439 34.8134 31.6918C35.4152 31.146 36.316 31.0786 36.9941 31.5284C36.9941 31.5284 37.936 32.1535 38.0167 32.2061L49.2517 39.4957C49.6774 39.7721 49.8001 40.336 49.5261 40.761L49.0809 41.4522C44.5419 48.4972 36.4208 52.7028 27.3559 52.7028L27.3557 52.7024Z",
    fill: "url(#paint0_linear_1_27)"
  })), cyberhaven_logo4_path2 || (cyberhaven_logo4_path2 = /*#__PURE__*/react.createElement("path", {
    d: "M61.5932 26.1858C61.5932 19.2503 67.0733 13.9215 74.0361 13.9215C79.2329 13.9215 83.374 16.7897 85.2369 20.9192C85.2913 21.0395 85.2331 21.1831 85.1128 21.2335L80.9677 22.9839C80.8513 23.0344 80.7193 22.98 80.665 22.8675C79.458 20.2865 77.1138 18.6797 74.1486 18.6409C70.5508 18.5944 67.3722 21.2141 66.7357 24.7188C65.8624 29.508 69.3438 33.7385 74.1331 33.7385C77.2884 33.7385 79.6287 31.86 80.762 29.3256C80.8125 29.2092 80.9483 29.1549 81.0648 29.2053L85.2486 30.9557C85.3728 31.0062 85.431 31.1498 85.3728 31.2701C83.4283 35.4927 79.5123 38.454 74.0322 38.454C66.9802 38.4501 61.5932 32.9778 61.5932 26.1858Z",
    fill: "black"
  })), cyberhaven_logo4_path3 || (cyberhaven_logo4_path3 = /*#__PURE__*/react.createElement("path", {
    d: "M61.3215 26.2829C61.3215 19.2619 66.8638 13.8633 73.9002 13.8633C79.1553 13.8633 83.343 16.7703 85.2214 20.9502C85.2758 21.0705 85.2175 21.2141 85.0933 21.2685L80.9056 23.0421C80.7892 23.0926 80.6534 23.0383 80.599 22.9218C79.3765 20.306 77.009 18.6836 74.0128 18.641C70.3762 18.5944 67.1626 21.2452 66.5184 24.7925C65.6373 29.64 69.1575 33.9248 73.9973 33.9248C77.1875 33.9248 79.555 32.023 80.6999 29.4576C80.7543 29.3412 80.8862 29.283 81.0065 29.3334L85.2369 31.1071C85.3611 31.1575 85.4194 31.305 85.365 31.4253C83.4012 35.7023 79.4425 38.6985 73.9002 38.6985C66.7667 38.7024 61.3215 33.1602 61.3215 26.2829Z",
    fill: "black"
  })), cyberhaven_logo4_path4 || (cyberhaven_logo4_path4 = /*#__PURE__*/react.createElement("path", {
    d: "M96.8453 33.2456C96.7483 33.4862 96.4611 33.4862 96.368 33.2456L90.3445 14.3601C90.2979 14.2165 90.2009 14.1195 90.0573 14.1195H85.039C84.8488 14.1195 84.7984 14.2165 84.8488 14.3601L92.6887 37.5963C93.0729 38.7917 93.4998 39.9405 93.4998 40.8953C93.4998 42.2808 92.7353 43.2394 90.7287 43.2394H85.136C84.9924 43.2394 84.8954 43.3365 84.8954 43.4801V47.5436C84.8954 47.6872 84.9924 47.7842 85.136 47.7842H91.7339C96.1817 47.7842 97.7108 45.8708 99.3836 40.9457L108.326 14.364C108.372 14.1738 108.229 14.1234 108.085 14.1234H103.16C103.016 14.1234 102.919 14.2204 102.873 14.364L96.8492 33.2495L96.8453 33.2456Z",
    fill: "black"
  })), cyberhaven_logo4_path5 || (cyberhaven_logo4_path5 = /*#__PURE__*/react.createElement("path", {
    d: "M116.367 36.3078C117.609 37.5497 120.431 38.7956 122.822 38.7956C129.707 38.7956 134.007 33.6803 134.007 26.2208C134.007 18.7613 129.466 13.646 122.822 13.646C118.805 13.646 116.464 15.9397 116.224 16.1803C116.08 16.3239 115.839 16.1803 115.839 16.0367V4.89795C115.839 4.75435 115.742 4.65732 115.599 4.65732H110.961C110.817 4.65732 110.72 4.75435 110.72 4.89795V38.0776C110.72 38.2212 110.817 38.3182 110.961 38.3182H115.024C115.215 38.3182 115.312 38.2716 115.358 38.0776L115.836 36.3582C115.933 36.1176 116.169 36.1176 116.36 36.3116L116.367 36.3078ZM128.845 26.2208C128.845 30.8587 126.454 34.1576 122.104 34.1576C118.04 34.1576 115.839 30.8587 115.839 26.2208C115.839 21.3461 118.04 18.3305 122.104 18.3305C126.454 18.3305 128.845 21.5828 128.845 26.2208Z",
    fill: "black"
  })), cyberhaven_logo4_path6 || (cyberhaven_logo4_path6 = /*#__PURE__*/react.createElement("path", {
    d: "M159.58 27.8936C159.677 27.4627 159.77 26.9388 159.77 26.2208C159.77 18.7613 155.322 13.646 148.103 13.646C140.884 13.646 136.437 18.7147 136.437 26.2208C136.437 33.7269 141.028 38.7956 148.103 38.7956C153.506 38.7956 157.81 36.0711 158.955 31.3866V31.34C158.955 31.2429 158.811 31.1498 158.714 31.1498H153.789C153.599 31.1498 153.502 31.2468 153.455 31.3904C152.547 33.1602 150.828 34.1615 148.099 34.1615C144.276 34.1615 141.835 31.437 141.835 28.3787C141.835 28.2351 141.932 28.1381 142.076 28.1381H159.335C159.479 28.1381 159.525 28.041 159.572 27.8974L159.58 27.8936ZM142.084 23.9736C141.94 23.9736 141.843 23.8766 141.843 23.733C141.843 21.676 143.849 18.3305 148.107 18.3305C152.365 18.3305 154.228 21.4393 154.228 23.733C154.228 23.8766 154.131 23.9736 153.987 23.9736H142.084Z",
    fill: "black"
  })), cyberhaven_logo4_path7 || (cyberhaven_logo4_path7 = /*#__PURE__*/react.createElement("path", {
    d: "M176.264 18.4275C176.408 18.4275 176.505 18.3305 176.505 18.1869V13.8827C176.505 13.7391 176.408 13.6421 176.264 13.6421H173.73C171.436 13.6421 169.713 14.7405 168.184 16.2735C168.04 16.4171 167.804 16.4171 167.707 16.1765L167.229 14.4067C167.183 14.2165 167.086 14.1195 166.895 14.1195H162.785C162.688 14.1195 162.595 14.2165 162.595 14.3601V38.0737C162.595 38.2173 162.692 38.3143 162.785 38.3143H167.47C167.613 38.3143 167.711 38.2173 167.711 38.0737V24.7343C167.711 21.4354 169.624 18.4236 173.493 18.4236H176.264V18.4275Z",
    fill: "black"
  })), cyberhaven_logo4_path8 || (cyberhaven_logo4_path8 = /*#__PURE__*/react.createElement("path", {
    d: "M201.042 38.3143C201.185 38.3143 201.282 38.2173 201.282 38.0737V24.9749C201.282 18.8544 198.224 13.646 191.005 13.646C188.28 13.646 185.936 15.0315 185.028 16.2269C184.884 16.4171 184.5 16.4171 184.5 16.1299V4.89795C184.5 4.75435 184.403 4.65732 184.26 4.65732H179.622C179.478 4.65732 179.381 4.75435 179.381 4.89795V38.0776C179.381 38.2212 179.478 38.3182 179.622 38.3182H184.26C184.403 38.3182 184.5 38.2212 184.5 38.0776V24.7382C184.5 21.4392 186.414 18.4275 190.283 18.4275C194.537 18.4275 196.116 21.7264 196.116 24.9788V38.0776C196.116 38.2212 196.213 38.3182 196.357 38.3182H201.042V38.3143Z",
    fill: "black"
  })), cyberhaven_logo4_path9 || (cyberhaven_logo4_path9 = /*#__PURE__*/react.createElement("path", {
    d: "M221.813 36.0206C221.957 35.877 222.147 35.9236 222.244 36.0672C223.055 37.5032 224.491 38.3143 227.123 38.3143H229.036C229.18 38.3143 229.277 38.2173 229.277 38.0737V34.1538C229.277 34.0102 229.18 33.9132 229.036 33.9132H227.984C226.979 33.9132 226.311 33.1952 226.311 32.3335V22.5337C226.311 16.6073 222.201 13.6421 215.603 13.6421C210.057 13.6421 205.086 16.4132 205.086 22.0564C205.086 22.2 205.183 22.297 205.326 22.297H209.964C210.108 22.297 210.205 22.2 210.205 22.0564C210.251 20.0498 211.734 18.3266 215.607 18.3266C220.769 18.3266 221.2 20.8144 221.2 22.2931C221.2 22.8675 220.672 23.6321 219.671 23.6321H214.746C207.767 23.6321 204.274 26.9776 204.274 31.1382C204.274 35.5859 207.333 38.7878 213.787 38.7878C217.851 38.7878 220.622 37.2587 221.817 36.0167L221.813 36.0206ZM213.783 34.1577C210.438 34.1577 209.386 32.4849 209.386 31.1459C209.386 29.6633 210.197 27.8004 214.885 27.8004H220.955C221.099 27.8004 221.196 27.8974 221.196 28.041V28.3748C221.15 31.0528 219.139 34.1577 213.787 34.1577H213.783Z",
    fill: "black"
  })), cyberhaven_logo4_path10 || (cyberhaven_logo4_path10 = /*#__PURE__*/react.createElement("path", {
    d: "M239.678 33.2456C239.581 33.4862 239.294 33.4862 239.201 33.2456L233.177 14.4106C233.131 14.267 233.034 14.1234 232.89 14.1234H227.965C227.775 14.1234 227.631 14.2204 227.678 14.4106L235.711 38.0776C235.758 38.2212 235.855 38.3182 235.999 38.3182H242.884C243.027 38.3182 243.124 38.2212 243.171 38.0776L251.154 14.4106C251.201 14.2204 251.057 14.1234 250.918 14.1234H246.039C245.896 14.1234 245.752 14.267 245.705 14.4106L239.682 33.2456H239.678Z",
    fill: "black"
  })), cyberhaven_logo4_path11 || (cyberhaven_logo4_path11 = /*#__PURE__*/react.createElement("path", {
    d: "M274.243 27.8936C274.34 27.4627 274.433 26.9388 274.433 26.2208C274.433 18.7613 269.986 13.646 262.767 13.646C255.548 13.646 251.1 18.7147 251.1 26.2208C251.1 33.7269 255.691 38.7956 262.767 38.7956C268.169 38.7956 272.473 36.0711 273.618 31.3866V31.34C273.618 31.2429 273.475 31.1498 273.378 31.1498H268.453C268.262 31.1498 268.165 31.2468 268.119 31.3904C267.211 33.1602 265.491 34.1615 262.763 34.1615C258.94 34.1615 256.499 31.437 256.499 28.3787C256.499 28.2351 256.596 28.1381 256.739 28.1381H273.999C274.142 28.1381 274.189 28.041 274.239 27.8974L274.243 27.8936ZM256.743 23.9736C256.6 23.9736 256.503 23.8766 256.503 23.733C256.503 21.676 258.509 18.3305 262.767 18.3305C267.024 18.3305 268.887 21.4393 268.887 23.733C268.887 23.8766 268.79 23.9736 268.647 23.9736H256.743Z",
    fill: "black"
  })), cyberhaven_logo4_path12 || (cyberhaven_logo4_path12 = /*#__PURE__*/react.createElement("path", {
    d: "M282.417 16.2269C282.273 16.3705 281.986 16.4676 281.889 16.1804L281.412 14.364C281.365 14.2204 281.268 14.1234 281.078 14.1234H277.014C276.871 14.1234 276.774 14.2204 276.774 14.364V38.0776C276.774 38.2212 276.871 38.3182 277.014 38.3182H281.652C281.796 38.3182 281.893 38.2212 281.893 38.0776V24.7382C281.893 21.4393 283.806 18.3305 287.679 18.3305C291.933 18.3305 293.513 21.7265 293.513 24.975V38.0737C293.513 38.2173 293.61 38.3143 293.753 38.3143H298.438C298.582 38.3143 298.679 38.2173 298.679 38.0737V24.975C298.679 18.8544 295.62 13.646 288.401 13.646C285.82 13.646 283.379 14.9384 282.424 16.2269H282.417Z",
    fill: "black"
  })), _defs || (_defs = /*#__PURE__*/react.createElement("defs", null, /*#__PURE__*/react.createElement("linearGradient", {
    id: "paint0_linear_1_27",
    x1: 35.3734,
    y1: 57.671,
    x2: 20.0825,
    y2: 3.79013,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/react.createElement("stop", {
    offset: 0.177,
    stopColor: "#F413F7"
  }), /*#__PURE__*/react.createElement("stop", {
    offset: 0.528,
    stopColor: "#722EF2"
  }), /*#__PURE__*/react.createElement("stop", {
    offset: 0.849,
    stopColor: "#0047EE"
  })))));
};
const cyberhaven_logo4_ForwardRef = /*#__PURE__*/(0,react.forwardRef)(SvgCyberhavenLogo4);

/* harmony default export */ const cyberhaven_logo4 = (__webpack_require__.p + "bd4be7bb1593b8499f0ee602578e2789.svg");
// EXTERNAL MODULE: ./src/runenv.tsx
var runenv = __webpack_require__(76223);
// EXTERNAL MODULE: ./node_modules/@mui/material/Paper/Paper.js + 2 modules
var Paper = __webpack_require__(64680);
// EXTERNAL MODULE: ./src/libs/layouts/index.tsx + 2 modules
var layouts = __webpack_require__(5855);
// EXTERNAL MODULE: ./src/ui/atoms/Box.tsx
var Box = __webpack_require__(17299);
// EXTERNAL MODULE: ./src/ui/vars.tsx
var vars = __webpack_require__(29400);
;// CONCATENATED MODULE: ./src/modules/auth/pages/PageTemplate.tsx
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}








function PageTemplate({ children  }) {
    const logoSx = {
        width: "100%",
        centerContent: true
    };
    const sizeLogoSx = runenv/* ENV.FEATURES.NEW_LOGO_2023 */.V.FEATURES.NEW_LOGO_2023 ? {
        height: 43,
        paddingX: 80
    } : {
        height: 28,
        paddingX: vars/* space.3 */.Dh[3]
    };
    return /*#__PURE__*/ react.createElement(Box/* Box */.x, {
        sx: {
            width: "100vw",
            height: "100vh",
            centerContent: true
        }
    }, /*#__PURE__*/ react.createElement(layouts/* Stack */.Kq, {
        space: 5,
        style: {
            flexBasis: "400px 1 1",
            maxWidth: 400
        },
        fullWidth: true
    }, /*#__PURE__*/ react.createElement(Box/* Box */.x, {
        sx: _object_spread({}, logoSx, sizeLogoSx)
    }, runenv/* ENV.FEATURES.NEW_LOGO_2023 */.V.FEATURES.NEW_LOGO_2023 ? /*#__PURE__*/ react.createElement(cyberhaven_logo4_ForwardRef, null) : /*#__PURE__*/ react.createElement(ForwardRef, null)), /*#__PURE__*/ react.createElement(Box/* Box */.x, {
        as: Paper/* default */.Z,
        sx: {
            paddingX: vars/* space.10 */.Dh[10],
            paddingY: vars/* space.8 */.Dh[8]
        },
        elevation: 3,
        square: true
    }, children)));
}


/***/ }),

/***/ 56836:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "RegistrationPage": () => (/* binding */ RegistrationPage),
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(7995);
/* harmony import */ var query_string__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(17563);
/* harmony import */ var service__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(89880);
/* harmony import */ var shared_logger__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(20168);
/* harmony import */ var react_router_dom__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(89250);
/* harmony import */ var _organisms__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(65598);
/* harmony import */ var _PageTemplate__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(36157);
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}








const RegistrationPage = ()=>{
    const { search  } = (0,react_router_dom__WEBPACK_IMPORTED_MODULE_5__/* .useLocation */ .TH)();
    const params = (0,query_string__WEBPACK_IMPORTED_MODULE_1__.parse)(search);
    const email = (0,lodash__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(params.email, '"');
    const isPasswordReset = !!params.reset;
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(()=>{
        function run() {
            return _run.apply(this, arguments);
        }
        function _run() {
            _run = // on invite accept logout user
            _async_to_generator(function*() {
                const auth = yield (0,service__WEBPACK_IMPORTED_MODULE_2__/* .resolveService */ .f)("authService");
                auth.logout();
            });
            return _run.apply(this, arguments);
        }
        run().catch((err)=>{
            (0,shared_logger__WEBPACK_IMPORTED_MODULE_7__/* .logInfo */ .P)(err);
        });
    }, []);
    return /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_PageTemplate__WEBPACK_IMPORTED_MODULE_4__/* .PageTemplate */ .P, null, /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_organisms__WEBPACK_IMPORTED_MODULE_3__/* .RegistrationForm */ .GG, {
        email: email,
        isPasswordReset: isPasswordReset
    }));
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (RegistrationPage);


/***/ }),

/***/ 45386:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "E": () => (/* binding */ initialState),
/* harmony export */   "f": () => (/* binding */ authState)
/* harmony export */ });
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(6610);
/* harmony import */ var okdux__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(56804);
/* harmony import */ var libs_restatex__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(87063);
/* harmony import */ var _effects__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(77805);




const initialState = {
    id: "",
    email: "",
    name: "",
    roles: [],
    sign_in_provider: undefined
};
const mergeNew = (a, b)=>(0,lodash__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({}, a, b);
const authState = (0,okdux__WEBPACK_IMPORTED_MODULE_0__/* .createState */ .eK)({
    user: (0,okdux__WEBPACK_IMPORTED_MODULE_0__/* .createState */ .eK)(initialState).on(_effects__WEBPACK_IMPORTED_MODULE_2__.authEffects.login.success, mergeNew).on(_effects__WEBPACK_IMPORTED_MODULE_2__.authEffects.signup.success, mergeNew).on(_effects__WEBPACK_IMPORTED_MODULE_2__.authEffects.refreshToken.success, mergeNew).on(_effects__WEBPACK_IMPORTED_MODULE_2__.authEffects.logout.success, ()=>initialState),
    fetching: (0,libs_restatex__WEBPACK_IMPORTED_MODULE_1__/* .effectsFetching */ ._)(_effects__WEBPACK_IMPORTED_MODULE_2__.authEffects)
});



/***/ }),

/***/ 2219:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "C6": () => (/* binding */ useEnabledProvidersCount),
/* harmony export */   "e0": () => (/* binding */ useAvailableAuthProviders),
/* harmony export */   "lP": () => (/* binding */ ProviderType),
/* harmony export */   "pl": () => (/* binding */ useAuthProviders),
/* harmony export */   "pn": () => (/* binding */ AuthProvidersProvider)
/* harmony export */ });
/* harmony import */ var constate__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(11521);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _apiHooks__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(44759);
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}



const googleProviderName = "google.com";
const passwordProviderName = "password";
const googleCloudType = "google";
const samlCloudType = "saml";
var ProviderType;
(function(ProviderType) {
    ProviderType["SAML"] = "SAML";
    ProviderType["Default"] = "Default";
})(ProviderType || (ProviderType = {}));
const [AuthProvidersProvider, useAuthProviders, useEnabledProvidersCount] = (0,constate__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(()=>{
    var _samlData_providers;
    const { isLoading: isLoadingDefault , isFetching: isFetchingDefault , data: defaultData  } = (0,_apiHooks__WEBPACK_IMPORTED_MODULE_1__/* .useDefaultProvidersList */ ._u)();
    const { isLoading: isLoadingSAML , isFetching: isFetchingSaml , data: samlData  } = (0,_apiHooks__WEBPACK_IMPORTED_MODULE_1__/* .useSAMLProvidersList */ .aF)();
    const sortedDefaultProviders = sortDefaultProviders((defaultData === null || defaultData === void 0 ? void 0 : defaultData.auth_provider) || []);
    const defaultProviders = sortedDefaultProviders.map((provider)=>({
            id: provider.name,
            name: provider.title,
            enabled: provider.enabled,
            enforce_mfa: provider.enforce_mfa,
            data: provider,
            type: ProviderType.Default
        }));
    const samlProviders = (samlData === null || samlData === void 0 ? void 0 : (_samlData_providers = samlData.providers) === null || _samlData_providers === void 0 ? void 0 : _samlData_providers.map((provider)=>({
            id: provider.id,
            name: provider.name,
            enabled: provider.enabled,
            enforce_mfa: false,
            data: provider,
            type: ProviderType.SAML
        }))) || [];
    const data = [
        ...defaultProviders,
        ...samlProviders
    ];
    const enabledProvidersCount = (0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(()=>data.filter((p)=>p.enabled).length, [
        data
    ]);
    return {
        isLoading: isLoadingSAML || isFetchingSaml || isLoadingDefault || isFetchingDefault,
        data: [
            ...defaultProviders,
            ...samlProviders
        ],
        enabledProvidersCount
    };
}, ({ isLoading , data  })=>({
        isLoading,
        data
    }), ({ enabledProvidersCount  })=>enabledProvidersCount);
function getDefaultProviderCloudType(name) {
    if (name === googleProviderName) {
        return googleCloudType;
    }
    return name;
}
function useAvailableAuthProviders() {
    var _samlData_providers;
    const { data: defaultData , isLoading: isLoadingDefault  } = (0,_apiHooks__WEBPACK_IMPORTED_MODULE_1__/* .useDefaultProviders */ .EK)();
    const { data: samlData , isLoading: isLoadingSAML  } = (0,_apiHooks__WEBPACK_IMPORTED_MODULE_1__/* .useSAMLProviders */ .vI)();
    const sortedDefaultProviders = sortDefaultProviders((defaultData === null || defaultData === void 0 ? void 0 : defaultData.providers) || []);
    const isPasswordAuthEnabled = sortedDefaultProviders.some(({ name  })=>name === passwordProviderName);
    const defaultProvidersWithoutPassword = sortedDefaultProviders.filter(({ name  })=>name !== passwordProviderName).map(({ name , title  })=>({
            id: name,
            name: title,
            cloudType: getDefaultProviderCloudType(name)
        }));
    const samlProviders = (samlData === null || samlData === void 0 ? void 0 : (_samlData_providers = samlData.providers) === null || _samlData_providers === void 0 ? void 0 : _samlData_providers.map((provider)=>_object_spread_props(_object_spread({}, provider), {
            cloudType: samlCloudType
        }))) || [];
    return {
        providers: [
            ...defaultProvidersWithoutPassword,
            ...samlProviders
        ],
        isSomeLoading: isLoadingDefault || isLoadingSAML,
        isAllLoading: isLoadingDefault && isLoadingSAML,
        isPasswordAuthEnabled
    };
}
function sortDefaultProviders(providers) {
    return [
        ...providers
    ].sort((a, b)=>a.title.localeCompare(b.title, "en", {
            sensitivity: "base"
        }));
}


/***/ }),

/***/ 27490:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "V": () => (/* binding */ validatePasswordComplexity)
/* harmony export */ });
/* harmony import */ var _messages__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(23456);

const validatePasswordComplexity = (password = "")=>{
    const errors = [];
    if (!/\d/.test(password)) {
        errors.push(_messages__WEBPACK_IMPORTED_MODULE_0__/* .messages.validation.containNum */ .s.validation.containNum);
    }
    if (!RegExp("\\p{Ll}", "u").test(password)) {
        errors.push(_messages__WEBPACK_IMPORTED_MODULE_0__/* .messages.validation.lowLetter */ .s.validation.lowLetter);
    }
    if (!RegExp("\\p{Lu}", "u").test(password)) {
        errors.push(_messages__WEBPACK_IMPORTED_MODULE_0__/* .messages.validation.upperLetter */ .s.validation.upperLetter);
    }
    if (!/[#?!@$%^&*\-+]/.test(password)) {
        errors.push(_messages__WEBPACK_IMPORTED_MODULE_0__/* .messages.validation.specialLetter */ .s.validation.specialLetter);
    }
    if (password.length > 50) {
        errors.push(_messages__WEBPACK_IMPORTED_MODULE_0__/* .messages.validation.maxLength */ .s.validation.maxLength);
    } else if (new Blob([
        password
    ]).size > 50) {
        errors.push(_messages__WEBPACK_IMPORTED_MODULE_0__/* .messages.validation.maxLengthByte */ .s.validation.maxLengthByte);
    }
    if (password.length < 8) {
        errors.push(_messages__WEBPACK_IMPORTED_MODULE_0__/* .messages.validation.minLength */ .s.validation.minLength);
    }
    return errors.length > 0 ? errors.join(". ") + "." : null;
};


/***/ }),

/***/ 17787:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "f": () => (/* binding */ DOMAIN_NAME),
/* harmony export */   "l": () => (/* binding */ CREATE_NEW_ID)
/* harmony export */ });
const DOMAIN_NAME = "content-rules";
const CREATE_NEW_ID = "new_rule_id";


/***/ }),

/***/ 9106:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "J": () => (/* binding */ contentRulesState),
/* harmony export */   "N": () => (/* binding */ actions),
/* harmony export */   "contentRulesEffects": () => (/* binding */ contentRulesEffects)
/* harmony export */ });
/* harmony import */ var okdux__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(56804);
/* harmony import */ var libs_restatex__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(87063);
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(17787);



const contentRulesEffects = (0,okdux__WEBPACK_IMPORTED_MODULE_0__/* .createEffects */ .xG)({
    list: okdux__WEBPACK_IMPORTED_MODULE_0__/* .build.async */ .J_.async(),
    create: okdux__WEBPACK_IMPORTED_MODULE_0__/* .build.async */ .J_.async(),
    update: okdux__WEBPACK_IMPORTED_MODULE_0__/* .build.async */ .J_.async(),
    remove: okdux__WEBPACK_IMPORTED_MODULE_0__/* .build.async */ .J_.async()
}, _constants__WEBPACK_IMPORTED_MODULE_2__/* .DOMAIN_NAME */ .f);
const actions = (0,okdux__WEBPACK_IMPORTED_MODULE_0__/* .createActions */ .dA)({
    expand: okdux__WEBPACK_IMPORTED_MODULE_0__/* .build.action */ .J_.action()
}, _constants__WEBPACK_IMPORTED_MODULE_2__/* .DOMAIN_NAME */ .f);
const rules = (0,okdux__WEBPACK_IMPORTED_MODULE_0__/* .createState */ .eK)([]);
const expanded = (0,okdux__WEBPACK_IMPORTED_MODULE_0__/* .createState */ .eK)("");
const isInitialLoaded = (0,okdux__WEBPACK_IMPORTED_MODULE_0__/* .createState */ .eK)(false);
const contentRulesState = (0,okdux__WEBPACK_IMPORTED_MODULE_0__/* .createState */ .eK)({
    rules,
    fetching: (0,libs_restatex__WEBPACK_IMPORTED_MODULE_1__/* .effectsFetching */ ._)(contentRulesEffects),
    expanded,
    isInitialLoaded
});
rules.on(contentRulesEffects.list.success, (_, p)=>p);
rules.on(contentRulesEffects.remove.success, (s, p)=>s.filter((rule)=>rule.id !== p.id));
rules.on(contentRulesEffects.create.success, (s, p)=>s.concat(p));
rules.on(contentRulesEffects.update.success, (s, p)=>s.map((rule)=>rule.id !== p.id ? rule : p));
expanded.on(actions.expand, (_, p)=>p);
expanded.on(contentRulesEffects.create.success, ()=>"");
expanded.on(contentRulesEffects.remove.success, ()=>"");
expanded.on(contentRulesEffects.update.success, ()=>"");
isInitialLoaded.on(contentRulesEffects.list.success, ()=>true);



/***/ }),

/***/ 39820:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "G": () => (/* binding */ zendeskAPI),
/* harmony export */   "V": () => (/* binding */ setupZendesk)
/* harmony export */ });
const canUseDOM = ()=>{
    return !(typeof window === "undefined" || !window.document || !window.document.createElement);
};
const zendeskKey = "d1fcc180-3fec-4f0f-af06-ce5859f77fb7";
const ZENDESK_WIDGET_HEIGHT = 420;
const zendeskAPI = (type, command, payload)=>{
    if (canUseDOM() && window.zE) {
        window.zE.call(null, type, command, payload);
    } else {
        console.warn("Zendesk is not initialized yet");
    }
};
const setupZendesk = (settings)=>{
    const handleLoaded = ()=>{
        zendeskAPI("webWidget", "hide");
        zendeskAPI("webWidget:on", "open", function onOpen() {
            var _document_getElementById;
            const targetNode = (_document_getElementById = document.getElementById("launcher")) === null || _document_getElementById === void 0 ? void 0 : _document_getElementById.parentElement;
            const observer = new MutationObserver(function() {
                const webWidget = document.getElementById("webWidget");
                if (webWidget) {
                    var _webWidget_contentWindow;
                    const style = document.createElement("style");
                    style.innerHTML = `
            div[class*='styles__Fields'] > div:not(:last-child) {
              display: none;
            }

            label[data-garden-id="forms.input_label"][data-fieldid="name"],
            label[data-garden-id="forms.input_label"][data-fieldid="email"],
            label[data-garden-id="forms.input_label"][data-fieldid="email"] + input,
            label[data-garden-id="forms.input_label"][data-fieldid="name"] + input {
                display: none;
            }

            button[data-garden-id="buttons.icon_button"] {
                display: none !important;
            }

            main[data-testid="scroll-container-content"] > div > div > div > p {
                display: none;
            }
          `;
                    webWidget === null || webWidget === void 0 ? void 0 : (_webWidget_contentWindow = webWidget.contentWindow) === null || _webWidget_contentWindow === void 0 ? void 0 : _webWidget_contentWindow.document.head.appendChild(style);
                    webWidget.onload = ()=>{
                        var _webWidget_contentWindow;
                        webWidget === null || webWidget === void 0 ? void 0 : (_webWidget_contentWindow = webWidget.contentWindow) === null || _webWidget_contentWindow === void 0 ? void 0 : _webWidget_contentWindow.document.head.appendChild(style);
                    };
                    webWidget.style.height = `${ZENDESK_WIDGET_HEIGHT}px`;
                }
            });
            observer.observe(targetNode, {
                childList: true
            });
        });
    };
    const insertScript = (zendeskKey, defer)=>{
        const script = document.createElement("script");
        if (defer) {
            script.defer = true;
        } else {
            script.async = true;
        }
        script.id = "ze-snippet";
        script.src = `https://static.zdassets.com/ekr/snippet.js?key=${zendeskKey}`;
        script.addEventListener("load", handleLoaded);
        document.body.appendChild(script);
    };
    if (canUseDOM() && !window.zE) {
        insertScript(zendeskKey, true);
        window.zESettings = settings;
    }
    return {
        api: zendeskAPI
    };
};


/***/ }),

/***/ 10554:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "gP": () => (/* reexport */ Condition),
  "ol": () => (/* reexport */ LuceneField),
  "DC": () => (/* reexport */ OnChangeDelayed),
  "af": () => (/* reexport */ TextFieldComponent),
  "s3": () => (/* reexport */ TextFieldComponentV2),
  "fb": () => (/* reexport */ getNextName),
  "C1": () => (/* reexport */ required)
});

// UNUSED EXPORTS: AutoSave, AutoSaveComponent, CheckboxComponent, CheckboxField, DisableCondition, LUCENE_INPUT_RESIZE_EVENT, createRadioTransformer, useAutosave, useFormChanged

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-final-form/dist/react-final-form.es.js
var react_final_form_es = __webpack_require__(66688);
// EXTERNAL MODULE: ./node_modules/lodash-es/isString.js
var isString = __webpack_require__(36378);
// EXTERNAL MODULE: ./node_modules/lodash-es/isEqual.js
var lodash_es_isEqual = __webpack_require__(50576);
// EXTERNAL MODULE: ./node_modules/lodash-es/debounce.js + 1 modules
var debounce = __webpack_require__(99111);
// EXTERNAL MODULE: ./node_modules/object-diff/index.js
var object_diff = __webpack_require__(19359);
var object_diff_default = /*#__PURE__*/__webpack_require__.n(object_diff);
// EXTERNAL MODULE: ./node_modules/react-use/lib/useMountedState.js
var useMountedState = __webpack_require__(95929);
// EXTERNAL MODULE: ./node_modules/constate/dist/constate.es.js
var constate_es = __webpack_require__(11521);
;// CONCATENATED MODULE: ./src/modules/form-utils/AutoSave.tsx
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}







var _React_Component;
// TODO refactor or think about different approach this
class AutoSaveComponent extends (_React_Component = react.Component) {
    componentDidMount() {
        document.addEventListener("keyup", this.handleSubmitKey);
        document.addEventListener("keydown", this.handleSubmitKey);
    }
    componentWillUnmount() {
        document.removeEventListener("keyup", this.handleSubmitKey);
        document.removeEventListener("keydown", this.handleSubmitKey);
    }
    componentWillReceiveProps(nextProps) {
        if (this.props.initialValues !== nextProps.initialValues || // update after request (setQuery)
        this.props.active && this.props.active === nextProps.active && this.props.values === nextProps.values // update on request or success
        ) {
            return;
        }
        if (this.props.active) {
            this.hasDiff(nextProps.values) && this.cancelRequest();
            // blur occurred
            if (this.props.active !== nextProps.active) {
                // when blur occurs new active always undefined (??)
                this.save(nextProps.values);
            }
            if (this.props.active === nextProps.active) {
                // change
                if (this.isOnChange(this.props.active)) {
                    this.save(nextProps.values);
                    return;
                }
            }
        }
    }
    cancelRequest() {
        this.props.cancel && this.props.cancel();
    }
    isOnChange(field) {
        const { fieldsOnChange  } = this.props;
        if (!fieldsOnChange) {
            return false;
        }
        if ((0,isString["default"])(fieldsOnChange)) {
            return field.includes(fieldsOnChange);
        } else {
            return fieldsOnChange.some((key)=>field.includes(key));
        }
    }
    hasDiff(nextValues) {
        if (this.prevValues === nextValues) {
            return false;
        }
        const difference = object_diff_default()(this.prevValues, nextValues);
        const keys = Object.keys(difference);
        return !keys.every((key)=>this.skipField(key));
    }
    skipField(field) {
        const { fieldsToSkip =[]  } = this.props;
        return fieldsToSkip.includes(field);
    }
    render() {
        // This component doesn't have to render anything, but it can render
        // submitting state.
        return this.state.submitting && this.props.render ? this.props.render() : null;
    }
    constructor(props){
        super(props);
        _define_property(this, "promise", void 0);
        _define_property(this, "prevValues", void 0);
        _define_property(this, "keysMap", void 0);
        _define_property(this, "handleSubmitKey", (e)=>{
            this.keysMap[e.keyCode] = e.type === "keydown";
            // 91 - cmd
            // 13 - enter
            // 17 - ctrl
            if (this.props.active && this.keysMap[13] && (this.keysMap[91] || this.keysMap[17])) {
                this.cancelRequest();
                this.save(this.props.values);
            }
        });
        var _this = this;
        _define_property(this, "save", function() {
            var _ref = _async_to_generator(function*(nextValues) {
                if (_this.promise) {
                    yield _this.promise;
                }
                const { save  } = _this.props;
                const hasDiff = _this.hasDiff(nextValues);
                // This diff step is totally optional
                if (hasDiff) {
                    _this.setState({
                        submitting: true
                    });
                    _this.prevValues = nextValues;
                    _this.promise = save(nextValues);
                    yield _this.promise;
                    delete _this.promise;
                    _this.setState({
                        submitting: false
                    });
                }
            });
            return function(nextValues) {
                return _ref.apply(this, arguments);
            };
        }());
        this.keysMap = {};
        this.prevValues = props.values;
        this.state = {
            submitting: false
        };
    }
}
_define_property(AutoSaveComponent, "defaultProps", {
    fieldsToSkip: []
});
const AutoSave = (props)=>/*#__PURE__*/ React.createElement(FormSpy, _object_spread_props(_object_spread({}, props), {
        component: AutoSaveComponent,
        subscription: {
            values: true,
            active: true,
            initialValues: true
        }
    }));
const [OnChangeDelayed, useAutosave] = (0,constate_es/* default */.Z)(({ onChange  })=>{
    const { subscribe  } = (0,react_final_form_es/* useForm */.cI)();
    const prevValue = (0,react.useRef)(undefined);
    const onChangeRef = (0,react.useRef)(undefined);
    onChangeRef.current = onChange;
    const mounted = (0,useMountedState["default"])();
    (0,react.useLayoutEffect)(()=>{
        const notTrottled = (v)=>{
            var _prevValue_current;
            if (!(0,lodash_es_isEqual/* default */.Z)(v.values, ((_prevValue_current = prevValue.current) === null || _prevValue_current === void 0 ? void 0 : _prevValue_current.values) || v.initialValues) && mounted()) {
                var _onChangeRef_current;
                (_onChangeRef_current = onChangeRef.current) === null || _onChangeRef_current === void 0 ? void 0 : _onChangeRef_current.call(onChangeRef, "values", v.values);
                prevValue.current = v;
            }
        };
        const debounced = (0,debounce["default"])(notTrottled, 1000);
        const unsub = subscribe((v)=>{
            if (v.active) {
                debounced(v);
            } else {
                debounced.cancel();
                notTrottled(v);
            }
        }, {
            values: true,
            active: true,
            initialValues: true
        });
        return ()=>{
            unsub();
            debounced.cancel();
        };
    }, [
        subscribe
    ]);
    return {
        onChange
    };
});

// EXTERNAL MODULE: ./src/ui/index.ts + 23 modules
var ui = __webpack_require__(17218);
;// CONCATENATED MODULE: ./src/modules/form-utils/Condition.tsx
function Condition_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function Condition_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            Condition_define_property(target, key, source[key]);
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}



const Condition = ({ when , is , children  })=>{
    return /*#__PURE__*/ react.createElement(react_final_form_es/* Field */.gN, {
        name: when,
        subscription: {
            value: true
        }
    }, ({ input: { value  }  })=>{
        return value === is ? children : null;
    });
};
function DisableCondition(_param) {
    var { when , is , children  } = _param, rest = _object_without_properties(_param, [
        "when",
        "is",
        "children"
    ]);
    const { input  } = useField(when, {
        subscription: {
            value: true
        }
    });
    const isDisabled = typeof is === "function" ? is(input.value) : input.value === is;
    return /*#__PURE__*/ React.createElement(Disabled, Condition_object_spread({
        variant: "grayscale",
        isDisabled: isDisabled ? true : false
    }, rest), typeof children === "function" ? children(isDisabled) : children);
}

// EXTERNAL MODULE: ./node_modules/@mui/material/TextField/TextField.js + 1 modules
var TextField = __webpack_require__(94659);
;// CONCATENATED MODULE: ./src/modules/form-utils/Fields.tsx
function Fields_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function Fields_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            Fields_define_property(target, key, source[key]);
        });
    }
    return target;
}
function Fields_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function Fields_object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        Fields_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function Fields_object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = Fields_object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function Fields_object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}




function TextFieldComponent(props) {
    return /*#__PURE__*/ react.createElement(TextField/* default */.Z, Fields_object_spread({
        fullWidth: true,
        variant: "standard"
    }, (0,ui/* mapProps */.jM)(props)));
}
const TextFieldComponentV2 = /*#__PURE__*/ react.forwardRef(function TextFieldComponentV2(_param, ref) {
    var { input , meta , hasHelperText  } = _param, props = Fields_object_without_properties(_param, [
        "input",
        "meta",
        "hasHelperText"
    ]);
    return /*#__PURE__*/ react.createElement(TextField/* default */.Z, Fields_object_spread({
        ref: ref,
        fullWidth: true
    }, props, input, (0,ui/* mapErrorOnly */.Hy)({
        meta,
        hasHelperText
    })));
});
const CheckboxComponent = (_param)=>{
    var { label , labelProps  } = _param, props = Fields_object_without_properties(_param, [
        "label",
        "labelProps"
    ]);
    const _mapProps = mapProps(props), { type: _  } = _mapProps, mprops = Fields_object_without_properties(_mapProps, [
        "type"
    ]);
    if (label) {
        return /*#__PURE__*/ React.createElement(FormControlLabel, Fields_object_spread_props(Fields_object_spread({}, labelProps), {
            control: /*#__PURE__*/ React.createElement(Checkbox, mprops),
            label: label
        }));
    }
    return /*#__PURE__*/ React.createElement(Checkbox, mprops);
};
function CheckboxField(_param) {
    var { name  } = _param, props = Fields_object_without_properties(_param, [
        "name"
    ]);
    return /*#__PURE__*/ React.createElement(Field, Fields_object_spread({
        name: name,
        component: CheckboxComponent,
        type: "checkbox"
    }, props));
}

// EXTERNAL MODULE: ./src/ui/css/index.ts
var css = __webpack_require__(93461);
// EXTERNAL MODULE: ./node_modules/@mui/material/InputAdornment/InputAdornment.js + 1 modules
var InputAdornment = __webpack_require__(80270);
// EXTERNAL MODULE: ./node_modules/@mui/material/Menu/Menu.js + 1 modules
var Menu = __webpack_require__(32301);
// EXTERNAL MODULE: ./node_modules/@mui/material/MenuItem/MenuItem.js + 1 modules
var MenuItem = __webpack_require__(33797);
// EXTERNAL MODULE: ./node_modules/@mui/icons-material/esm/MoreVert.js
var MoreVert = __webpack_require__(34685);
// EXTERNAL MODULE: ./src/libs/code-editor/index.ts + 6 modules
var code_editor = __webpack_require__(71843);
// EXTERNAL MODULE: ./src/ui/theme.ts
var theme = __webpack_require__(73728);
;// CONCATENATED MODULE: ./src/modules/form-utils/Lucene/LuceneField.tsx
/* eslint-disable */ function LuceneField_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function LuceneField_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            LuceneField_define_property(target, key, source[key]);
        });
    }
    return target;
}
function LuceneField_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function LuceneField_object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        LuceneField_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function LuceneField_object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = LuceneField_object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function LuceneField_object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}







const inputClassName = (0,css/* css */.iv)({
    "fontSize": "15px",
    "textarea,  pre": {
        border: "none",
        padding: "10px 10px 10px 0 !important"
    }
});
const HoverableMoreVert = (0,css/* styled */.zo)(MoreVert/* default */.Z, {
    "cursor": "pointer",
    "&:hover": {
        color: theme/* theme.palette.primary.main */.rS.palette.primary.main
    }
});
/**
 * LuceneField
 *
 * @description
 * Component for react-final-form/Field
 * Renders input with helper menu (if value is not empty) for value formatting via templates
 *
 * @param templates: Array<Template>
 * @see src/modules/graph/organisms/SidePanel/Search/queryTemplates
 *
 * @example
 * ```
 * <Field
 *  name='lorem ipsum'
 *  component={LuceneField}
 *  label="Lorem ipsum"
 *  templates: Template[]
 * />
 * ```
 */ class LuceneField extends react.Component {
    render() {
        const { anchorEl  } = this.state;
        const _this_props = this.props, { templates , input: { value  } , suggest , suggestConfig  } = _this_props, rest = LuceneField_object_without_properties(_this_props, [
            "templates",
            "input",
            "suggest",
            "suggestConfig"
        ]);
        let C = suggest ? code_editor/* SuggestCodeEditor */.ND : code_editor/* CodeEditor */.pq;
        return /*#__PURE__*/ react.createElement(TextFieldComponent, LuceneField_object_spread_props(LuceneField_object_spread({}, rest), {
            input: this.props.input,
            inputProps: {
                className: inputClassName().className,
                suggestConfig: suggestConfig
            },
            InputProps: {
                inputComponent: C,
                inputRef: this.$input,
                endAdornment: !!value && /*#__PURE__*/ react.createElement(InputAdornment/* default */.Z, {
                    position: "end"
                }, /*#__PURE__*/ react.createElement(HoverableMoreVert, {
                    onClick: this.handleMoreClick
                }), /*#__PURE__*/ react.createElement(Menu/* default */.Z, {
                    anchorEl: anchorEl,
                    open: !!anchorEl,
                    onClose: this.handleClose,
                    TransitionProps: {
                        onExited: this.handleExit
                    }
                }, templates.map((template, i)=>/*#__PURE__*/ react.createElement(MenuItem/* default */.Z, {
                        key: i,
                        onClick: this.handleTemplateClick(template)
                    }, /*#__PURE__*/ react.createElement(template.Label, {
                        value: this.props.input.value
                    }))))) || undefined
            }
        }));
    }
    constructor(...args){
        super(...args);
        LuceneField_define_property(this, "$input", /*#__PURE__*/ react.createRef());
        LuceneField_define_property(this, "state", {
            anchorEl: null,
            template: null
        });
        LuceneField_define_property(this, "handleMoreClick", (event)=>this.setState({
                anchorEl: event.currentTarget
            }));
        LuceneField_define_property(this, "handleClose", ()=>this.setState({
                anchorEl: null
            }));
        LuceneField_define_property(this, "handleTemplateClick", (template)=>()=>{
                this.setState({
                    template
                });
                this.handleClose();
            });
        /**
   * If template was selected
   * - change input value
   * - setup selection range
   * - focus input
   */ LuceneField_define_property(this, "handleExit", ()=>{
            if (this.state.template) {
                const { restoreSelection: [start = 0, end = 0] = [] , getValue  } = this.state.template;
                const value = getValue(this.props.input.value);
                this.props.input.onChange(value);
                setTimeout(()=>{
                    this.$input.current.setSelectionRange(start, end);
                });
            }
            this.$input.current.focus();
            this.setState({
                template: null
            });
        });
    }
}

;// CONCATENATED MODULE: ./src/modules/form-utils/Lucene/index.ts



;// CONCATENATED MODULE: ./src/modules/form-utils/helpers.ts
function createRadioTransformer(keys) {
    return {
        format (current) {
            return keys.reduce((acc, k)=>{
                acc[k] = current === k;
                return acc;
            }, {});
        },
        parse (current) {
            return keys.reduce((acc, k)=>{
                if (current[k]) {
                    return k;
                }
                return acc;
            }, "");
        }
    };
}
const required = (v)=>{
    if (!v) {
        return "Required";
    }
    return;
};
function getNextName(prefix, names) {
    const regexp = new RegExp(`^\\s\\((\\d+)\\)$`);
    const maxNumber = names.reduce((acc, name)=>{
        if (name.includes(prefix)) {
            const match = name.replace(prefix, "").match(regexp);
            if (match && match[1] && acc < parseInt(match[1])) {
                return parseInt(match[1]);
            }
        }
        return acc;
    }, 0);
    return `${prefix} (${maxNumber + 1})`;
}

;// CONCATENATED MODULE: ./src/modules/form-utils/useFormChanged.ts


function useFormChanged() {
    const form = useForm();
    const isEq = isEqual(form.getState().values, form.getState().initialValues);
    return !isEq;
}

;// CONCATENATED MODULE: ./src/modules/form-utils/index.ts








/***/ }),

/***/ 92722:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "rs": () => (/* reexport */ Switch_Switch)
});

// UNUSED EXPORTS: CardHeaderAction, CardSpacingContent, CustomButton, CustomCard, CustomCardActions, CustomCardContent, CustomIconButton, CustomSelect, DialogTitleIconContainer, FilterContainer, KeywordSearchLabel, KeywordSearchNoFound, LabelWithIcon, ListContainer, ListContent, ListHeader, ListItemContainer, LuceneField, LuceneHelperInfo, ScriptHelperInfo, SelectControl, SetInitialOnMount, StyledCartHeader, StyledDialogContent, StyledDialogTitle, StyledSwitch, TogglerIcon, checkDotName, spacingClassName

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-final-form/dist/react-final-form.es.js
var react_final_form_es = __webpack_require__(66688);
// EXTERNAL MODULE: ./src/shared/styles.ts
var styles = __webpack_require__(78420);
// EXTERNAL MODULE: ./node_modules/@mui/material/DialogContent/DialogContent.js + 1 modules
var DialogContent = __webpack_require__(77750);
// EXTERNAL MODULE: ./node_modules/@mui/material/DialogTitle/DialogTitle.js
var DialogTitle = __webpack_require__(37645);
// EXTERNAL MODULE: ./node_modules/@mui/material/SvgIcon/SvgIcon.js + 1 modules
var SvgIcon = __webpack_require__(33502);
// EXTERNAL MODULE: ./node_modules/@mui/material/Grid/Grid.js + 2 modules
var Grid = __webpack_require__(15725);
// EXTERNAL MODULE: ./node_modules/@mui/material/IconButton/IconButton.js + 1 modules
var IconButton_IconButton = __webpack_require__(6867);
// EXTERNAL MODULE: ./node_modules/@mui/material/Button/Button.js + 1 modules
var Button = __webpack_require__(72642);
// EXTERNAL MODULE: ./node_modules/@mui/material/CardHeader/CardHeader.js + 1 modules
var CardHeader = __webpack_require__(18515);
// EXTERNAL MODULE: ./node_modules/@mui/material/Card/Card.js + 1 modules
var Card = __webpack_require__(65295);
// EXTERNAL MODULE: ./node_modules/@mui/material/CardContent/CardContent.js + 1 modules
var CardContent = __webpack_require__(42643);
// EXTERNAL MODULE: ./node_modules/@mui/material/Switch/Switch.js
var Switch = __webpack_require__(72852);
// EXTERNAL MODULE: ./node_modules/@mui/system/esm/colorManipulator.js
var colorManipulator = __webpack_require__(41796);
// EXTERNAL MODULE: ./src/ui/css/index.ts
var css = __webpack_require__(93461);
// EXTERNAL MODULE: ./src/modules/form-utils/index.ts + 7 modules
var form_utils = __webpack_require__(10554);
// EXTERNAL MODULE: ./src/ui/index.ts + 23 modules
var ui = __webpack_require__(17218);
// EXTERNAL MODULE: ./src/modules/graph-search-panel/messages.ts
var graph_search_panel_messages = __webpack_require__(88066);
;// CONCATENATED MODULE: ./src/modules/graph-search-panel/atoms/HelperInfo.tsx




const tooltipStyles = (0,css/* css */.iv)({
    padding: "15px",
    maxHeight: "600px",
    overflow: "auto",
    maxWidth: "350px",
    backgroundColor: "rgba(45, 45, 45, 0.97)"
});
const popperStyles = (0,css/* css */.iv)({
    opacity: 1
});
const classes = {
    tooltip: tooltipStyles().className,
    popper: popperStyles().className
};
const ddClassName = (0,css/* css */.iv)({
    fontSize: "13px",
    lineHeight: "24px",
    color: "#bababa",
    marginLeft: "25px",
    pre: {
        color: "white",
        fontWeight: "bold"
    }
});
function HelperInfo_HelperInfo({ label , links , examples  }) {
    return /*#__PURE__*/ React.createElement(Tooltip, {
        classes: classes,
        enterDelay: 500,
        leaveDelay: 500,
        title: /*#__PURE__*/ React.createElement("div", null, links.map((link)=>/*#__PURE__*/ React.createElement("a", {
                rel: "noopener noreferrer",
                style: {
                    color: "white",
                    display: "block",
                    marginBottom: 15,
                    fontSize: 15
                },
                target: "_blank",
                href: link.url
            }, link.label)), /*#__PURE__*/ React.createElement("dl", null, examples.map((el)=>/*#__PURE__*/ React.createElement(React.Fragment, {
                key: el.group
            }, /*#__PURE__*/ React.createElement("dt", {
                style: {
                    margin: "25px 0 10px",
                    fontSize: 15
                }
            }, el.group), /*#__PURE__*/ React.createElement("dd", {
                className: ddClassName().className
            }, el.explanation)))))
    }, /*#__PURE__*/ React.createElement(Typography, {
        variant: "caption",
        style: {
            cursor: "pointer",
            position: "relative"
        }
    }, label, /*#__PURE__*/ React.createElement(HelpIcon, {
        fontSize: "small",
        style: {
            position: "absolute",
            top: 0,
            right: -24
        }
    })));
}

;// CONCATENATED MODULE: ./src/modules/graph-search-panel/atoms/LuceneHelperInfo.tsx



const examples = [
    {
        group: graph_search_panel_messages/* messages.luceneHelper.search */.s.luceneHelper.search,
        explanation: /*#__PURE__*/ react.createElement("div", null, graph_search_panel_messages/* messages.luceneHelper.searchExp */.s.luceneHelper.searchExp, /*#__PURE__*/ react.createElement("pre", {
            style: {
                whiteSpace: "pre-wrap"
            }
        }, graph_search_panel_messages/* messages.luceneHelper.searchExample */.s.luceneHelper.searchExample))
    },
    {
        group: graph_search_panel_messages/* messages.luceneHelper.fuzzySearches */.s.luceneHelper.fuzzySearches,
        explanation: /*#__PURE__*/ react.createElement("div", null, graph_search_panel_messages/* messages.luceneHelper.fuzzySearchesExp */.s.luceneHelper.fuzzySearchesExp, ":", /*#__PURE__*/ react.createElement("pre", null, graph_search_panel_messages/* messages.luceneHelper.fuzzySearchesExample */.s.luceneHelper.fuzzySearchesExample))
    },
    {
        group: graph_search_panel_messages/* messages.luceneHelper.wildcardSearches */.s.luceneHelper.wildcardSearches,
        explanation: /*#__PURE__*/ react.createElement("div", null, graph_search_panel_messages/* messages.luceneHelper.wildcardSearchesExp1 */.s.luceneHelper.wildcardSearchesExp1, ":", /*#__PURE__*/ react.createElement("pre", null, graph_search_panel_messages/* messages.luceneHelper.wildcardSearchesExample1 */.s.luceneHelper.wildcardSearchesExample1), graph_search_panel_messages/* messages.luceneHelper.wildcardSearchesExp2 */.s.luceneHelper.wildcardSearchesExp2, ":", /*#__PURE__*/ react.createElement("pre", null, graph_search_panel_messages/* messages.luceneHelper.wildcardSearchesExample2 */.s.luceneHelper.wildcardSearchesExample2), graph_search_panel_messages/* messages.luceneHelper.wildcardSearchesExp3 */.s.luceneHelper.wildcardSearchesExp3)
    },
    {
        group: graph_search_panel_messages/* messages.luceneHelper.fieldGrouping */.s.luceneHelper.fieldGrouping,
        explanation: /*#__PURE__*/ react.createElement("div", null, graph_search_panel_messages/* messages.luceneHelper.fieldGroupingExp */.s.luceneHelper.fieldGroupingExp, ":", /*#__PURE__*/ react.createElement("pre", null, graph_search_panel_messages/* messages.luceneHelper.fieldGroupingExample */.s.luceneHelper.fieldGroupingExample))
    },
    {
        group: graph_search_panel_messages/* messages.luceneHelper.rangeSearches */.s.luceneHelper.rangeSearches,
        explanation: /*#__PURE__*/ react.createElement("div", null, /*#__PURE__*/ react.createElement("p", null, graph_search_panel_messages/* messages.luceneHelper.rangeSearchesExp1 */.s.luceneHelper.rangeSearchesExp1), /*#__PURE__*/ react.createElement("pre", null, graph_search_panel_messages/* messages.luceneHelper.rangeSearchesExample1 */.s.luceneHelper.rangeSearchesExample1), /*#__PURE__*/ react.createElement("p", null, graph_search_panel_messages/* messages.luceneHelper.rangeSearchesExp1 */.s.luceneHelper.rangeSearchesExp1, ", ", graph_search_panel_messages/* messages.luceneHelper.rangeSearchesExp2 */.s.luceneHelper.rangeSearchesExp2), /*#__PURE__*/ react.createElement("pre", null, graph_search_panel_messages/* messages.luceneHelper.rangeSearchesExample2 */.s.luceneHelper.rangeSearchesExample2))
    },
    {
        group: graph_search_panel_messages/* messages.luceneHelper.not */.s.luceneHelper.not,
        explanation: /*#__PURE__*/ react.createElement("div", null, graph_search_panel_messages/* messages.luceneHelper.notExp */.s.luceneHelper.notExp, ":", /*#__PURE__*/ react.createElement("pre", null, graph_search_panel_messages/* messages.luceneHelper.notExample */.s.luceneHelper.notExample), graph_search_panel_messages/* messages.luceneHelper.notOr */.s.luceneHelper.notOr, /*#__PURE__*/ react.createElement("pre", null, graph_search_panel_messages/* messages.luceneHelper.notOrExample */.s.luceneHelper.notOrExample))
    },
    {
        group: graph_search_panel_messages/* messages.luceneHelper.escaping */.s.luceneHelper.escaping,
        explanation: /*#__PURE__*/ react.createElement("div", null, graph_search_panel_messages/* messages.luceneHelper.escapingExp */.s.luceneHelper.escapingExp, ":", /*#__PURE__*/ react.createElement("pre", null, graph_search_panel_messages/* messages.luceneHelper.escapingExample */.s.luceneHelper.escapingExample))
    }
];
const links = [
    {
        label: graph_search_panel_messages/* messages.luceneHelper.guidelineLabel */.s.luceneHelper.guidelineLabel,
        url: "https://lucene.apache.org/core/2_9_4/queryparsersyntax.html"
    },
    {
        label: graph_search_panel_messages/* messages.luceneHelper.searchQueryLabel */.s.luceneHelper.searchQueryLabel,
        url: "https://docs.cyberhaven.io/v1/docs/lucene-search-syntax"
    }
];
function LuceneHelperInfo() {
    return /*#__PURE__*/ React.createElement(HelperInfo, {
        examples: examples,
        links: links,
        label: messages.luceneHelper.title
    });
}

;// CONCATENATED MODULE: ./src/modules/graph-search-panel/atoms/ScriptHelperInfo.tsx



const ScriptHelperInfo_examples = [
    {
        group: graph_search_panel_messages/* messages.scriptHelper.search */.s.scriptHelper.search,
        explanation: /*#__PURE__*/ react.createElement("div", null, graph_search_panel_messages/* messages.scriptHelper.searchExp */.s.scriptHelper.searchExp, /*#__PURE__*/ react.createElement("pre", {
            style: {
                whiteSpace: "pre-wrap"
            }
        }, graph_search_panel_messages/* messages.scriptHelper.searchExample */.s.scriptHelper.searchExample))
    }
];
const ScriptHelperInfo_links = [
    {
        label: graph_search_panel_messages/* messages.scriptHelper.guidelineLabel */.s.scriptHelper.guidelineLabel,
        url: "https://www.elastic.co/guide/en/elasticsearch/painless/master/painless-guide.html"
    }
];
function ScriptHelperInfo() {
    return /*#__PURE__*/ React.createElement(HelperInfo, {
        examples: ScriptHelperInfo_examples,
        links: ScriptHelperInfo_links,
        label: messages.scriptHelper.title
    });
}

;// CONCATENATED MODULE: ./src/modules/graph-search-panel/atoms/Switch.tsx


function Switch_Switch(props) {
    return /*#__PURE__*/ react.createElement("div", {
        style: {
            width: 40,
            height: 25,
            marginLeft: 9,
            left: -9,
            top: -6.5,
            position: "relative"
        }
    }, /*#__PURE__*/ react.createElement(Switch/* default */.Z, props));
}

;// CONCATENATED MODULE: ./src/modules/graph-search-panel/atoms/index.tsx
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}











const StyledDialogContent = (0,css/* styled */.zo)(DialogContent/* default */.Z, {
    display: "flex",
    flexDirection: "column",
    height: "700px",
    paddingBottom: (0,styles/* spacing */.W)(1)({
        theme: ui/* theme */.rS
    })
});
const StyledDialogTitle = (0,css/* styled */.zo)(DialogTitle/* default */.Z, {
    display: "flex",
    alignItems: "center"
});
const DialogTitleIconContainer = (0,css/* styled */.zo)(SvgIcon/* default */.Z, {
    marginRight: (0,styles/* spacing */.W)(2)({
        theme: ui/* theme */.rS
    })
});
const FilterContainer = (0,css/* styled */.zo)(Grid/* default */.ZP, {
    flex: "0 0 auto"
});
const ListContainer = (0,css/* styled */.zo)(Grid/* default */.ZP, {
    position: "relative",
    flex: "1 0 auto",
    overflow: "hidden",
    display: "flex",
    flexDirection: "column"
});
const ListContent = (0,css/* styled */.zo)("div", {
    flex: 1,
    overflowY: "auto",
    borderBottom: `1px solid ${ui/* theme.palette.divider */.rS.palette.divider}`,
    borderTop: `1px solid ${ui/* theme.palette.divider */.rS.palette.divider}`,
    paddingTop: (0,styles/* spacing */.W)(1)({
        theme: ui/* theme */.rS
    }),
    paddingBottom: (0,styles/* spacing */.W)(1)({
        theme: ui/* theme */.rS
    })
});
const ListItemContainer = (0,css/* styled */.zo)(Grid/* default */.ZP, {
    overflow: "hidden"
});
const ListHeader = (0,css/* styled */.zo)(Grid/* default */.ZP, {
    paddingTop: (0,styles/* spacing */.W)(2)({
        theme: ui/* theme */.rS
    }),
    paddingBottom: (0,styles/* spacing */.W)(1)({
        theme: ui/* theme */.rS
    })
});
const CustomIconButton = (0,css/* styled */.zo)(IconButton_IconButton/* default */.Z, {
    "&:hover": {
        backgroundcolor: "transparent"
    }
});
const CustomButton = (0,css/* styled */.zo)(Button/* default */.Z, {
    "&:hover": {
        backgroundcolor: "transparent"
    }
});
const CardHeaderAction = (0,css/* css */.iv)({
    margin: "0px",
    visibility: "hidden",
    alignSelf: "center"
});
const StyledCartHeader = (0,css/* styled */.zo)(CardHeader/* default */.Z, {
    "background": ui/* theme.secondaryBackground */.rS.secondaryBackground,
    "borderRadius": ui/* theme.shape.borderRadius */.rS.shape.borderRadius,
    "padding": "0 14px 0 9px",
    "height": "42px",
    "cursor": "pointer",
    "&:hover": {
        background: (0,colorManipulator/* darken */._j)(ui/* theme.secondaryBackground */.rS.secondaryBackground, 0.05)
    }
});
const CustomCard = (0,css/* styled */.zo)(Card/* default */.Z, {
    borderBottom: "1px solid white",
    padding: "0px 0px 0px 0px",
    borderRadius: "5px",
    marginBottom: "5px"
});
const CustomCardContent = (0,css/* styled */.zo)(CardContent/* default */.Z, {
    paddingBottom: "0 !important",
    padding: "0 15px"
});
const CardSpacingContent = (0,css/* styled */.zo)("div", {
    "& > *": {
        paddingBottom: "8px"
    }
});
function CustomSelect(_param) {
    var { label , onChange , onFocus , onBlur , value , options , InputProps ={} , meta ={}  } = _param, rest = _object_without_properties(_param, [
        "label",
        "onChange",
        "onFocus",
        "onBlur",
        "value",
        "options",
        "InputProps",
        "meta"
    ]);
    const { error , helperText  } = mapErrorOnly({
        meta
    });
    return /*#__PURE__*/ React.createElement(FormControl, _object_spread_props(_object_spread({
        fullWidth: true
    }, rest), {
        error: error
    }), /*#__PURE__*/ React.createElement(InputLabel, null, label), /*#__PURE__*/ React.createElement(Select, {
        MenuProps: {
            "data-testid": rest["data-testid"] ? `${rest["data-testid"]}/menu` : undefined
        },
        value: value,
        onChange: onChange,
        onFocus: onFocus,
        onBlur: onBlur,
        input: /*#__PURE__*/ React.createElement(Input, _object_spread({
            name: label
        }, InputProps))
    }, options.map((el)=>/*#__PURE__*/ React.createElement(MenuItem, {
            key: el.value,
            value: el.value,
            dense: true
        }, /*#__PURE__*/ React.createElement("div", {
            style: {
                display: "flex",
                justifyContent: "center",
                alignItems: "center"
            }
        }, el.icon, /*#__PURE__*/ React.createElement(ListItemText, {
            primary: el.label,
            style: {
                marginLeft: theme.spacing(1)
            }
        }))))), error && /*#__PURE__*/ React.createElement(FormHelperText, null, helperText));
}
function SelectControl(_param) {
    var { label , onChange , errorLabel , onFocus , onBlur , value , InputProps ={} , children , SelectProps  } = _param, rest = _object_without_properties(_param, [
        "label",
        "onChange",
        "errorLabel",
        "onFocus",
        "onBlur",
        "value",
        "InputProps",
        "children",
        "SelectProps"
    ]);
    const handleChangeMultiple = (event)=>{
        onChange(event.target.value);
    };
    return /*#__PURE__*/ React.createElement(FormControl, _object_spread({
        fullWidth: true
    }, rest), /*#__PURE__*/ React.createElement(InputLabel, null, label), /*#__PURE__*/ React.createElement(Select, _object_spread({
        multiple: true,
        value: value || [],
        onChange: handleChangeMultiple,
        onFocus: onFocus,
        onBlur: onBlur,
        input: /*#__PURE__*/ React.createElement(Input, _object_spread({
            name: label
        }, InputProps))
    }, SelectProps), children), rest.error && /*#__PURE__*/ React.createElement(FormHelperText, null, errorLabel));
}
class SetInitialOnMount extends react.Component {
    componentDidMount() {
        const name = this.props.name;
        const value = this.props.value;
        setTimeout(()=>{
            this.form && value && this.form.change(name, value);
        });
    }
    render() {
        return /*#__PURE__*/ React.createElement(FormSpy, {
            subscription: {
                initialValues: true
            }
        }, ({ form  })=>{
            return /*#__PURE__*/ React.createElement(Field, {
                name: this.props.name
            }, (value)=>{
                if (!value) {
                    this.form = form;
                }
                return null;
            });
        });
    }
    constructor(...args){
        super(...args);
        _define_property(this, "form", void 0);
    }
}
const LuceneField = (0,css/* styled */.zo)(form_utils/* LuceneField */.ol, {
    "&:not(:first-child)": {
        marginTop: (0,styles/* spacing */.W)(2)
    },
    "minHeight": "fit-content"
});
const StyledSwitch = (0,css/* styled */.zo)(Switch/* default */.Z, {
    height: "22px",
    marginRight: "-8px"
});
const CustomCardActions = /*#__PURE__*/ (/* unused pure expression or super */ null && (React.memo(({ name , showDots =true  })=>{
    return /*#__PURE__*/ React.createElement(Field, {
        name: name,
        type: "checkbox"
    }, (_param)=>/*#__PURE__*/ {
        var { input: { name , value  }  } = _param, rest = _object_without_properties(_param.input, [
            "name",
            "value"
        ]);
        return React.createElement(React.Fragment, null, value && showDots && /*#__PURE__*/ React.createElement(CustomIconButton, {
            style: {
                width: 10
            }
        }, /*#__PURE__*/ React.createElement(MoreVertIcon, null)), /*#__PURE__*/ React.createElement(StyledSwitch, _object_spread({
            checked: value
        }, rest)));
    });
})));
function checkDotName(name) {
    return name ? name + "." : "";
}
const LabelWithIcon = ({ label , icon  })=>{
    return /*#__PURE__*/ React.createElement("div", {
        style: {
            display: "flex",
            alignItems: "center"
        }
    }, icon, /*#__PURE__*/ React.createElement(Typography, {
        style: {
            display: "inline-flex",
            alignItems: "center",
            fontWeight: 500
        },
        variant: "subtitle1"
    }, label));
};
const KeywordSearchLabel = ({ label , onDelete  })=>{
    return /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(Typography, {
        noWrap: true
    }, label), onDelete && /*#__PURE__*/ React.createElement(IconButton, {
        onClick: onDelete,
        style: {
            padding: "4px"
        },
        size: "large"
    }, /*#__PURE__*/ React.createElement(CloseIcon, {
        fontSize: "small"
    })));
};
const KeywordSearchNoFound = ({ children  })=>/*#__PURE__*/ React.createElement(Typography, {
        style: {
            padding: "16px"
        },
        align: "left",
        variant: "button",
        color: "textSecondary"
    }, children);
const spacingClassName = (0,css/* css */.iv)({
    padding: `${(0,styles/* spacing */.W)(3)({
        theme: ui/* theme */.rS
    })} ${(0,styles/* spacing */.W)(4)({
        theme: ui/* theme */.rS
    })}`,
    margin: 0
});
function TogglerIcon({ isOpen  }) {
    return /*#__PURE__*/ React.createElement(KeyboardArrowDown, {
        color: "action",
        style: {
            transition: "transform 0.3s ease",
            transform: !isOpen ? "rotate(-90deg)" : "",
            marginRight: "6px"
        }
    });
}





/***/ }),

/***/ 88066:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "s": () => (/* binding */ messages)
/* harmony export */ });
const messages = {
    none: "None",
    keywordsField: {
        label: (fields)=>"Keywords search for: " + fields,
        placeholder: "Space separated values"
    },
    keywordsSearch: {
        locationWithNoMatch: "Locations with no matches",
        searchIn: (search, location)=>`Search for ${search} in ${location}`,
        searchFor: "Search for",
        in: "in",
        searchByKeywordsPlaceholder: "Search",
        keywordsSearchNotFound: "No matching results",
        keywordsScrolledContent: "Keywords scrolled content",
        keywordsSearchPopover: "Keywords search popover",
        keywordsSearchBackdrop: "Keywords search backdrop"
    },
    newSearchName: "New Search",
    validation: {
        required: "Field is required",
        searchNameUnique: "Search name must be unique"
    },
    categories: {
        endpointHosts: "Endpoints",
        endpointGroups: "Endpoint groups",
        endpointFiles: "Endpoint files",
        mailAccounts: "Mail accounts",
        mailGroups: "Mail groups",
        mailFiles: "Mail files",
        website: "Websites",
        shareHosts: "Shares",
        shareGroups: "Share groups",
        shareFiles: "Share files",
        cloudProviders: "Cloud providers",
        cloudFiles: "Cloud files",
        cloudApps: "Cloud apps",
        cloudAppsFiles: "Cloud apps files",
        cloudAppsAccount: "Cloud apps accounts",
        endpointApps: "Endpoint apps",
        printers: "Printers",
        removableFiles: "Files on removable media",
        removableMedia: "Removable media"
    },
    categoryTypes: {
        webMail: "Web Mail",
        socialMedia: "Social Media",
        consumerInstantMessaging: "Consumer Instant Messaging",
        corporateMessagingAndConferencing: "Corporate Messaging and Conferencing",
        cloudStorage: "Cloud Storage",
        corporateFinancial: "Corporate Financial",
        HRAndPayroll: "HR and Payroll",
        salesAndCRM: "Sales and CRM",
        banking: "Banking",
        cryptoCurrencies: "Crypto Currencies",
        softwareDownloads: "Software Downloads",
        malwareAndHacking: "Malware and Hacking",
        piracy: "Piracy",
        phishing: "Phishing",
        sourceCodeManagement: "Source Code Management",
        researchAndDevelopment: "Research and Development",
        graphicsDesignAndCAD: "Graphics, Design and CAD",
        jobBoardsAndRecruiting: "Job Boards and Recruiting",
        adult: "Adult",
        VPNAndProxies: "VPN and Proxies",
        illegalDrugs: "Illegal Drugs",
        gambling: "Gambling",
        musicAndVideo: "Music and Video",
        shopping: "Shopping",
        gaming: "Gaming",
        other: "Other"
    },
    appTypes: {
        salesforce: "Salesforce",
        onedrive: "OneDrive",
        gdrive: "Google Drive",
        box: "Box"
    },
    zoneTypes: {
        all: "All",
        internal: "Internal",
        external: "External"
    },
    mediaCategoryTypes: {
        all: "All",
        cdDvd: "CD/DVD",
        usb: "USB Devices"
    },
    exclude: "Exclude current",
    include: "Include another",
    templateSelect: {
        edit: "Edit template name",
        deleteMessage: "Do you want to delete this template?",
        noResult: "No results"
    },
    search: "Search",
    queryPanel: {
        from: "Source",
        to: "Destination",
        content: "Content",
        contentPlaceholder: "Content attributes included in search",
        people: "People",
        flowId: "Flow Id Search",
        advancedSearch: "Advanced Search",
        disableMonitoringTitle: "In order to set up monitoring, you should save the current search"
    },
    locationSelection: {
        zonesTitle: "Zones",
        zonesDeprecatedTooltip: "Zones field will be removed in the next release, please, use all zones",
        typeOfLocation: "Type of location",
        addNewLocation: "Add new location (OR)",
        notAllZone: (zone)=>`All ${zone} locations`,
        allZone: (zone)=>`All ${zone}`,
        sources: "Sources",
        destinations: "Destinations",
        all: "All"
    },
    extensionSelect: {
        fileType: "File type",
        failedToAddExtension: "Failed to add custom extension",
        failedToRemoveExtension: "Failed to remove custom extension",
        noResults: "No Results",
        addNewExtension: (extension)=>`Add '.${extension}' as a new extension`,
        tagsLimitReached: "Tags limit reached",
        customExtLimitReached: "Custom extensions limit reached",
        removeExtension: "Remove extension",
        placeholder: "Type to search or to add custom extension"
    },
    saveAsBtn: {
        btnLabel: "Save ...",
        modalTitle: "Save search",
        searchNamePlaceholder: "Search name",
        saveAsDuplicate: "Save as new search (duplicate)"
    },
    peopleSearch: {
        group: "Local user group (or SID)",
        user: "Local user name (or SID)"
    },
    flowSearch: {
        flowId: "Flow ID"
    },
    contentSearch: {
        md5: "MD5 hashes",
        fileName: "Filename"
    },
    clear: "Clear",
    scriptHelper: {
        title: "Painless Scripting Language",
        guidelineLabel: "Full Painless Guide",
        search: "Search",
        searchExp: "Cross domain sharing:",
        searchExample: `doc["source.domain"].size() != 0 &&doc["destination.domain"].size() != 0 && doc["source.domain"].value != doc["destination.domain"].value`
    },
    luceneHelper: {
        title: "Lucene Syntax",
        guidelineLabel: "Lucene Guide",
        searchQueryLabel: "Search query documentation",
        search: "Search",
        searchExp: "To search for endpoints or mail, but not endpoint apps, use a query like this",
        searchExample: `(source.location: endpoint OR source.location:mail OR destination.location:endpoint OR destination.location:mail) NOT destination.location: endpoint_apps`,
        fuzzySearches: "Fuzzy Searches:",
        fuzzySearchesExp: `To do a fuzzy search use the tilde, "~", symbol at the end of a Single word Term. For
      example to search for a term similar in spelling to "padf-pc" use the fuzzy search`,
        fuzzySearchesExample: "padf-pc~",
        wildcardSearches: "Wildcard Searches:",
        wildcardSearchesExp1: `To search for "text" or "test" you can use the query`,
        wildcardSearchesExample1: `te?t`,
        wildcardSearchesExp2: `Multiple character wildcard search looks for 0 or more characters. For example, to search
    for test, tests or tester, you can use the query`,
        wildcardSearchesExample2: `test*`,
        wildcardSearchesExp3: `Note: You cannot use a * or ? symbol as the first character of a search.`,
        fieldGrouping: "Field Grouping:",
        fieldGroupingExp: `To search for a title that contains both the word "return" and the phrase "pink panther" use
    the query`,
        fieldGroupingExample: `title:(+return +"pink panther")`,
        rangeSearches: "Range Searches:",
        rangeSearchesExp1: "This will find all documents whose titles are between Aida and Carmen",
        rangeSearchesExample1: "title:[Aida TO Carmen]",
        rangeSearchesExp2: "but not including Aida and Carmen.",
        rangeSearchesExample2: "title:{Aida TO Carmen}",
        not: "NOT:",
        notExp: `To search for documents that contain "jakarta apache" but not "Apache Lucene" use the query:`,
        notExample: `"jakarta apache" -"Apache Lucene"`,
        notOr: "or",
        notOrExample: '"jakarta apache" NOT "Apache Lucene"',
        escaping: "Escaping:",
        // eslint-disable-next-line no-useless-escape
        escapingExp: `To escape characters (+ - && || ! ( ) {} [ ] ^ " ~ * ? : \) use the \ before the character.
    For example to search for (1+1):2 use the query`,
        // eslint-disable-next-line no-useless-escape
        escapingExample: `\(1\+1\)\:2`
    },
    advancedSearch: {
        searchType: "Search type",
        advancedSearchTitle: "Advanced",
        scriptedSearchTitle: "Scripted",
        advancedSearchPlaceholder: "Enter Lucene query...",
        scriptedSearchPlaceholder: "Enter script..."
    },
    monitoring: {
        notifyLabel: "Notify people or groups (via email)",
        blockingPlaceholder: "Warning message",
        warnLabel: "Warn users as they are about to send sensitive data using Outlook",
        blockLabel: "Block potentially harmful users actions",
        warnTypeLabel: "Email app notifications:",
        logLabel: "Log incident",
        aria: {
            openMonitoring: "open monitoring dialog"
        },
        applyLabel: "Save",
        cancelLabel: "Cancel",
        title: "Monitoring",
        subtitle: "When a new flow matches this search, perform the following actions:"
    }
};


/***/ }),

/***/ 68224:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "CU": () => (/* binding */ initialTimeRange)
/* harmony export */ });
/* unused harmony exports expandMore, MIN_WEIGHT, MIN_COUNT, DOMAIN_NAME, SAVED_SEARCH, DATE_FORMAT, defaultFromToItem, fromToInititalState, stringInitialState, queryInitialState */
/* harmony import */ var date_fns_subWeeks__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(36961);
/* harmony import */ var date_fns_subMinutes__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(1784);
/* harmony import */ var date_fns_endOfToday__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(85521);
/* harmony import */ var runenv__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(76223);
/* harmony import */ var shared__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(10451);





const expandMore = {
    base: 10,
    delta: 5
};
// content attributes
const MIN_WEIGHT = 100;
const MIN_COUNT = 1;
const DOMAIN_NAME = "graph"; // used for savind graph request state in url and for actions prefix
const SAVED_SEARCH = "graph/saved_search"; // for saving saved search state in url
// export const INDIRECT_TOGGLE = "graph/indirect_toggle"; // for saving indirect toggle state in url
const DATE_FORMAT = "yyyy-MM-dd";
const prevWeek = (0,date_fns_subMinutes__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)((0,date_fns_subWeeks__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(new Date(), 1), 1);
const nextTime = (0,date_fns_endOfToday__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)();
const initialTimeRange = {
    start: runenv__WEBPACK_IMPORTED_MODULE_0__/* .ENV.START_DATE */ .V.START_DATE || (0,shared__WEBPACK_IMPORTED_MODULE_1__/* .formatDateTimeLocal */ .Z8)(prevWeek, DATE_FORMAT),
    end: runenv__WEBPACK_IMPORTED_MODULE_0__/* .ENV.END_DATE */ .V.END_DATE || (0,shared__WEBPACK_IMPORTED_MODULE_1__/* .formatDateTimeLocal */ .Z8)(nextTime, DATE_FORMAT)
};
const defaultFromToItem = {
    zone: "*",
    location: "*"
};
const fromToInititalState = [
    defaultFromToItem
];
const stringInitialState = "";
const contentSearchInitialValue = {
    value: [],
    file_search: {
        name_query: "",
        extensions: null,
        md5_hash_query: ""
    }
};
const queryInitialState = {
    start_time: initialTimeRange.start,
    end_time: initialTimeRange.end,
    peopleSearch: {
        group_query: "",
        user_query: ""
    },
    from: fromToInititalState,
    simple_search: [],
    to: fromToInititalState,
    advancedSearch: {
        search: stringInitialState,
        raw_id_from_flow: "",
        script: stringInitialState
    },
    contentSearch: contentSearchInitialValue,
    searchName: "",
    monitoring: null
};


/***/ }),

/***/ 92268:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "H": () => (/* reexport */ locationIconMap)
});

// UNUSED EXPORTS: getIcon

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/assets/icons/index.tsx + 1 modules
var icons = __webpack_require__(99899);
// EXTERNAL MODULE: ./node_modules/@mui/icons-material/SelectAll.js
var SelectAll = __webpack_require__(17188);
// EXTERNAL MODULE: ./src/modules/graph/services/index.ts + 2 modules
var services = __webpack_require__(15585);
;// CONCATENATED MODULE: ./src/modules/graph/icons/locationsIconMap.tsx




const locationIconMap = {
    [services/* locations.all.value */.Kl.all.value]: /*#__PURE__*/ react.createElement(SelectAll/* default */.Z, null),
    [services/* locations.endpoint.value */.Kl.endpoint.value]: /*#__PURE__*/ react.createElement(icons/* LocationEndpointIcon */.n4, {
        htmlColor: services/* locations.endpoint.color */.Kl.endpoint.color
    }),
    [services/* locations.mail.value */.Kl.mail.value]: /*#__PURE__*/ react.createElement(icons/* LocationMailIcon */.K$, {
        htmlColor: services/* locations.mail.color */.Kl.mail.color
    }),
    [services/* locations.share.value */.Kl.share.value]: /*#__PURE__*/ react.createElement(icons/* LocationShareIcon */.yI, {
        htmlColor: services/* locations.share.color */.Kl.share.color
    }),
    [services/* locations.cloud_storage.value */.Kl.cloud_storage.value]: /*#__PURE__*/ react.createElement(icons/* LocationCloudIcon */.Dc, {
        htmlColor: services/* locations.cloud_storage.color */.Kl.cloud_storage.color
    }),
    [services/* locations.cloud_apps.value */.Kl.cloud_apps.value]: /*#__PURE__*/ react.createElement(icons/* LocationEndpointAppsIcon */.bG, {
        htmlColor: services/* locations.cloud_apps.color */.Kl.cloud_apps.color
    }),
    [services/* locations.website.value */.Kl.website.value]: /*#__PURE__*/ react.createElement(icons/* LocationWebsiteIcon */.JR, {
        htmlColor: services/* locations.website.color */.Kl.website.color
    }),
    [services/* locations.printer.value */.Kl.printer.value]: /*#__PURE__*/ react.createElement(icons/* LocationPrinterIcon */.EM, {
        htmlColor: services/* locations.printer.color */.Kl.printer.color
    }),
    [services/* locations.endpoint_apps.value */.Kl.endpoint_apps.value]: /*#__PURE__*/ react.createElement(icons/* LocationEndpointAppsIcon */.bG, {
        htmlColor: services/* locations.endpoint_apps.color */.Kl.endpoint_apps.color
    }),
    [services/* locations.removable_media.value */.Kl.removable_media.value]: /*#__PURE__*/ react.createElement(icons/* LocationRemovableMediaIcon */.VH, {
        htmlColor: services/* locations.removable_media.color */.Kl.removable_media.color
    })
};
function getIcon(type) {
    return locationIconMap[type];
}

;// CONCATENATED MODULE: ./src/modules/graph/icons/index.ts



/***/ }),

/***/ 15585:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Pj": () => (/* binding */ getContentAttribute),
  "_n": () => (/* reexport */ getLocationLabelPlural),
  "Kl": () => (/* reexport */ locations)
});

// UNUSED EXPORTS: getLocationLabel, mediaCategories, zones

;// CONCATENATED MODULE: ./src/modules/graph/messages.ts
const messages = {
    alertsNotificationText: (action)=>`Template ${action}`,
    created: "created",
    updated: "updated",
    removed: "removed",
    noComponentsToExpand: "No more components to expand by",
    datePickerToday: "Today",
    datePickerDate: (startDate, endDate)=>`${startDate} to ${endDate}`,
    sophosShowMoreAttr: (count)=>`${count} more attributes`,
    contentAttributes: "Content attributes",
    none: "None",
    zoomIn: "Zoom in",
    zoomOut: "Zoom out",
    fitToScreen: "Fit map to screen",
    searchFrom: "Search flows from here",
    searchTo: "Search flows to here",
    expandBy: "Expand By",
    nothingExpand: "Nothing to expand",
    collapse: "Collapse",
    edgeInfoPanel: {
        tabTitle: (label)=>`${label} insights`
    },
    graphTabTitle: "Map",
    listTabTitle: "List",
    insightshTabTitle: "Insights",
    zones: {
        internal: "Internal",
        external: "External",
        undefined: "Undefined"
    },
    mediaCategory: {
        usb: "USB Devices",
        optical: "CD/DVD"
    },
    locations: {
        all: "All",
        mail: "Email",
        mailPlural: "Email",
        mailDomain: "Email domain",
        mailAccount: "Address",
        cloudStorage: "Cloud Storage",
        cloudStoragePlural: "Cloud Storage",
        cloudProvider: "Provider",
        cloudStoragePath: "Path",
        cloudApps: "Cloud App",
        cloudAppsPlural: "Cloud Apps",
        cloudApp: "App",
        cloudAppsAccountName: "Account name",
        website: "Website",
        websitePlural: "Websites",
        websiteDomain: "Domain",
        websiteUrl: "URL",
        websiteCategory: "Website category",
        share: "Shared Folder",
        sharePlural: "Shared Folders",
        shareHostname: "Hostname",
        shareGroupName: "Group name",
        sharePath: "Path",
        endpoint: "Endpoint",
        endpointPlural: "Endpoints",
        endpointHostname: "Hostname",
        endpointGroupName: "Group name",
        endpointLocalUserName: "Local user name",
        endpointPath: "Path",
        endpointApps: "Endpoint App",
        endpointAppsPlural: "Endpoint Apps",
        endpointAppsCommandline: "Command line",
        endpointAppsGroupName: "Group name",
        endpointAppsAppName: "Application name",
        endpointAppsHostname: "Hostname",
        endpointAppsLocalUserName: "Local user name",
        endpointAppsPath: "Path",
        removableMedia: "Removable Media",
        removableMediaPlural: "Removable Media",
        mediaCategory: "Category",
        removableMediaLocalUserName: "Local user name",
        removableMediaDeviceName: "Device name",
        removableMediaSerialNumber: "Serial number",
        removableMediaPath: "Path",
        printer: "Printer",
        printerPlural: "Printers",
        printerName: "Printer name"
    },
    notSupportedTitle: "Portrait mode currently is not supported",
    notSupportedSubTitle: "Please rotate device into landscape mode to view data flows",
    notifications: {
        badRequest: "Bad request. Please try modifying your query"
    }
};

;// CONCATENATED MODULE: ./src/modules/graph/services/locationsConfigurationInfo.ts

const zones = {
    internal: {
        label: messages.zones.internal,
        value: "Internal",
        color: "#E0EEFD"
    },
    external: {
        label: messages.zones.external,
        value: "External",
        color: "rgba(232, 99, 102, 0.2)"
    },
    undefined: {
        label: messages.zones.undefined,
        value: "Undefined",
        color: "#B4B4B4"
    }
};
const mediaCategories = {
    usb: {
        label: messages.mediaCategory.usb,
        value: "usb"
    },
    optical: {
        label: messages.mediaCategory.optical,
        value: "optical"
    }
};
const locations = {
    all: {
        label: messages.locations.all,
        labelPlural: messages.locations.all,
        value: "*",
        color: "#ccc",
        keywords: [
            {
                label: "Email account or Email subject or Hostname or Path or Removable device name or Salesforce account name or Url"
            }
        ]
    },
    mail: {
        label: messages.locations.mail,
        labelPlural: messages.locations.mailPlural,
        value: "mail",
        color: "#4CCBAB",
        clusterColor: "#4CCBAB33",
        keywords: [
            "email_account",
            {
                label: "Email subject"
            }
        ],
        source: true,
        destination: true,
        fields: {
            domain: {
                name: "mail.domain",
                suggestName: "domain",
                label: messages.locations.mailDomain
            },
            email_account: {
                suggestName: "email_account",
                name: "mail.email_account",
                label: messages.locations.mailAccount
            }
        }
    },
    cloud_storage: {
        label: messages.locations.cloudStorage,
        labelPlural: messages.locations.cloudStoragePlural,
        value: "cloud_storage",
        color: "#3E75C8",
        clusterColor: "#3E75C833",
        keywords: [
            "path"
        ],
        source: true,
        destination: true,
        fields: {
            cloud_provider: {
                name: "cloud_storage.cloud_provider",
                suggestName: "cloud_provider",
                label: messages.locations.cloudProvider
            },
            path: {
                name: "cloud_storage.path",
                suggestName: "path",
                label: messages.locations.cloudStoragePath
            }
        }
    },
    cloud_apps: {
        label: messages.locations.cloudApps,
        labelPlural: messages.locations.cloudAppsPlural,
        value: "cloud_apps",
        color: "#3E75C8",
        clusterColor: "#3E75C833",
        keywords: [
            "salesforce_account_name"
        ],
        source: true,
        destination: true,
        fields: {
            cloud_app: {
                name: "cloud_apps.cloud_app",
                label: messages.locations.cloudApp
            },
            salesforce_account_name: {
                name: "cloud_apps.salesforce_account_name",
                label: messages.locations.cloudAppsAccountName
            }
        }
    },
    website: {
        label: messages.locations.website,
        labelPlural: messages.locations.websitePlural,
        value: "website",
        color: "#8B60AD",
        clusterColor: "#8B60AD33",
        keywords: [
            "url"
        ],
        source: true,
        destination: true,
        fields: {
            domain: {
                name: "website.domain",
                label: messages.locations.websiteDomain
            },
            url: {
                name: "website.url",
                label: messages.locations.websiteUrl
            },
            category: {
                name: "website.category",
                label: messages.locations.websiteCategory
            }
        }
    },
    share: {
        label: messages.locations.share,
        labelPlural: messages.locations.sharePlural,
        value: "share",
        color: "#E56574",
        clusterColor: "#E5657433",
        keywords: [
            "path",
            "hostname"
        ],
        source: true,
        destination: true,
        fields: {
            hostname: {
                name: "share.hostname",
                label: messages.locations.shareHostname
            },
            group_name: {
                name: "share.group_name",
                label: messages.locations.shareGroupName
            },
            path: {
                name: "share.path",
                label: messages.locations.sharePath
            }
        }
    },
    endpoint: {
        label: messages.locations.endpoint,
        labelPlural: messages.locations.endpointPlural,
        value: "endpoint",
        color: "#FE9E46",
        clusterColor: "#FE9E4633",
        keywords: [
            "path",
            "hostname"
        ],
        source: true,
        destination: true,
        fields: {
            hostname: {
                name: "endpoint.hostname",
                label: messages.locations.endpointHostname
            },
            group_name: {
                name: "endpoint.group_name",
                label: messages.locations.endpointGroupName
            },
            local_user_name: {
                name: "endpoint.local_user_name",
                label: messages.locations.endpointLocalUserName
            },
            path: {
                name: "endpoint.path",
                label: messages.locations.endpointPath
            }
        }
    },
    endpoint_apps: {
        label: messages.locations.endpointApps,
        labelPlural: messages.locations.endpointAppsPlural,
        value: "endpoint_apps",
        color: "#FE9E46",
        clusterColor: "#FE9E4633",
        keywords: [
            "path",
            "hostname"
        ],
        source: true,
        destination: true,
        fields: {
            app_commandline: {
                name: "endpoint_apps.app_commandline",
                label: messages.locations.endpointAppsCommandline
            },
            group_name: {
                name: "endpoint_apps.group_name",
                label: messages.locations.endpointAppsGroupName
            },
            app_name: {
                name: "endpoint_apps.app_name",
                label: messages.locations.endpointAppsAppName
            },
            hostname: {
                name: "endpoint_apps.hostname",
                label: messages.locations.endpointAppsHostname
            },
            local_user_name: {
                name: "endpoint_apps.local_user_name",
                label: messages.locations.endpointAppsLocalUserName
            },
            path: {
                name: "endpoint_apps.path",
                label: messages.locations.endpointAppsPath
            }
        }
    },
    removable_media: {
        label: messages.locations.removableMedia,
        labelPlural: messages.locations.removableMediaPlural,
        value: "removable_media",
        color: "#2ED6D9",
        clusterColor: "#2ED6D933",
        keywords: [
            "path",
            "deviceName"
        ],
        source: true,
        destination: true,
        fields: {
            local_user_name: {
                name: "removable_media.local_user_name",
                label: messages.locations.removableMediaLocalUserName
            },
            deviceName: {
                name: "removable_media.removable_device_name",
                label: messages.locations.removableMediaDeviceName
            },
            deviceSerial: {
                name: "removable_media.removable_device_id",
                label: messages.locations.removableMediaSerialNumber
            },
            mediaCategory: {
                name: "removable_media.media_category",
                label: messages.locations.mediaCategory
            },
            path: {
                name: "removable_media.path",
                label: messages.locations.removableMediaPath
            }
        }
    },
    printer: {
        label: messages.locations.printer,
        labelPlural: messages.locations.printerPlural,
        value: "printer",
        color: "#ABDA7C",
        clusterColor: "#ABDA7C33",
        keywords: [
            "printerName"
        ],
        source: false,
        destination: true,
        fields: {
            printerName: {
                name: "printer.printer_name",
                label: messages.locations.printerName
            }
        }
    }
};
const getLocationLabel = (type)=>{
    var _locations_type;
    return locations === null || locations === void 0 ? void 0 : (_locations_type = locations[type]) === null || _locations_type === void 0 ? void 0 : _locations_type.label;
};
const getLocationLabelPlural = (type)=>{
    var _locations_type;
    return locations === null || locations === void 0 ? void 0 : (_locations_type = locations[type]) === null || _locations_type === void 0 ? void 0 : _locations_type.labelPlural;
};

// EXTERNAL MODULE: ./src/assets/content-attributes/PredefinedContentControlLists.json
var PredefinedContentControlLists = __webpack_require__(6503);
;// CONCATENATED MODULE: ./src/modules/graph/services/index.ts
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}


const contentOptionsKv = PredefinedContentControlLists/* predefinedContentCondition.reduce */.$.reduce((acc, el)=>{
    acc[el.name] = {
        value: el.name,
        label: el.title + " " + (el.countryTitle || "")
    };
    return acc;
}, {});
function makeDefault(key) {
    return {
        value: key,
        label: key ? key.split(":")[0] : "",
        attributes: []
    };
}
// TODO refactor format with 1:1:1 to something more reasonable
const getContentAttribute = (key, values)=>{
    const [valueKey, minWeight, minCount] = key.split(":");
    const kvObj = contentOptionsKv[valueKey] || makeDefault(key);
    return _object_spread(_object_spread_props(_object_spread({}, kvObj), {
        minWeight: Number(minWeight),
        minCount: Number(minCount)
    }), values);
};


/***/ }),

/***/ 39566:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "e": () => (/* binding */ FullscreenContent),
/* harmony export */   "m": () => (/* binding */ BetaLabel)
/* harmony export */ });
/* harmony import */ var ui_css__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(93461);
/* harmony import */ var ui_theme__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(73728);


const BetaLabel = (0,ui_css__WEBPACK_IMPORTED_MODULE_0__/* .styled */ .zo)("div", {
    padding: "0px 4px",
    background: "#43a7ea",
    color: "white",
    fontSize: "9px",
    borderRadius: "2px",
    position: "absolute",
    top: "8px",
    left: "25px",
    textTransform: "uppercase",
    zIndex: ui_theme__WEBPACK_IMPORTED_MODULE_1__/* .theme.zIndex.modal */ .rS.zIndex.modal + 2
});
const FullscreenContent = (0,ui_css__WEBPACK_IMPORTED_MODULE_0__/* .styled */ .zo)("div", {
    flex: "1 1 100%",
    height: "100%",
    boxSizing: "border-box",
    flexDirection: "column",
    display: "flex",
    position: "relative",
    overflow: "hidden"
});


/***/ }),

/***/ 41051:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "s": () => (/* binding */ messages)
/* harmony export */ });
const messages = {
    notSupportedTitle: "Your screen size is not supported",
    notSupportedSubtitle: "Please open the Cyberhaven dashboard from a device with a larger display",
    pages: {
        dataFlows: "Data Flows",
        incidents: "Incidents",
        analyticsDashboard: "Visual Analytics",
        cloudSensors: "Cloud Sensors",
        endpointSensors: "Endpoint Sensors",
        preferences: "Preferences",
        accounts: "Accounts",
        reports: "Reports"
    },
    betaLabel: "beta"
};


/***/ }),

/***/ 7529:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "LayoutClassic": () => (/* binding */ LayoutClassic)
});

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-use/lib/useMedia.js
var useMedia = __webpack_require__(99501);
// EXTERNAL MODULE: ./node_modules/react-error-boundary/dist/react-error-boundary.umd.js
var react_error_boundary_umd = __webpack_require__(35800);
// EXTERNAL MODULE: ./src/shared/errors.ts
var errors = __webpack_require__(45026);
// EXTERNAL MODULE: ./node_modules/@mui/icons-material/CancelPresentation.js
var CancelPresentation = __webpack_require__(19536);
// EXTERNAL MODULE: ./src/modules/auth/index.ts + 2 modules
var auth = __webpack_require__(38266);
// EXTERNAL MODULE: ./src/ui/index.ts + 23 modules
var ui = __webpack_require__(17218);
// EXTERNAL MODULE: ./src/libs/layouts/index.tsx + 2 modules
var layouts = __webpack_require__(5855);
// EXTERNAL MODULE: ./src/libs/hooks/index.ts + 18 modules
var hooks = __webpack_require__(88289);
// EXTERNAL MODULE: ./src/ui/atoms/Alert.tsx
var Alert = __webpack_require__(77723);
// EXTERNAL MODULE: ./src/modules/layout/atoms/index.ts
var atoms = __webpack_require__(39566);
// EXTERNAL MODULE: ./src/assets/icons/index.tsx + 1 modules
var icons = __webpack_require__(99899);
// EXTERNAL MODULE: ./src/runenv.tsx
var runenv = __webpack_require__(76223);
// EXTERNAL MODULE: ./src/shared/testConstants.ts + 1 modules
var testConstants = __webpack_require__(81202);
// EXTERNAL MODULE: ./src/shared/useAvailableNavigationItems.ts
var useAvailableNavigationItems = __webpack_require__(98598);
// EXTERNAL MODULE: ./src/app/routesPaths.ts
var routesPaths = __webpack_require__(70433);
// EXTERNAL MODULE: ./node_modules/react-router-dom/dist/index.js
var dist = __webpack_require__(79655);
// EXTERNAL MODULE: ./src/ui/css/index.ts
var css = __webpack_require__(93461);
// EXTERNAL MODULE: ./src/modules/layout/messages.ts
var messages = __webpack_require__(41051);
// EXTERNAL MODULE: ./node_modules/@mui/material/ListItem/ListItem.js + 2 modules
var ListItem = __webpack_require__(65965);
// EXTERNAL MODULE: ./node_modules/@mui/material/Tooltip/Tooltip.js + 1 modules
var Tooltip = __webpack_require__(14563);
// EXTERNAL MODULE: ./src/ui/theme.ts
var theme = __webpack_require__(73728);
;// CONCATENATED MODULE: ./src/modules/layout/molecules/NavigationItem.tsx





const CustomListItem = (0,css/* styled */.zo)(ListItem/* default */.ZP, {
    "background": "white !important",
    '&[data-selected="true"], :hover, :focus': {
        "::before": {
            display: "block",
            content: '""',
            background: theme/* theme.palette.primary.main */.rS.palette.primary.main,
            width: "3px",
            height: [
                "90%",
                "30px"
            ],
            position: "absolute",
            left: "0"
        },
        "svg": {
            color: theme/* theme.palette.primary.main */.rS.palette.primary.main
        }
    }
});
const NavigationItem = ({ disabled , path , label , "icon": Icon , "data-testid": testId  })=>{
    return /*#__PURE__*/ react.createElement(Tooltip/* default */.Z, {
        title: label,
        placement: "right"
    }, /*#__PURE__*/ react.createElement(dist/* NavLink */.OL, {
        to: path,
        "data-testid": testId
    }, ({ isActive  })=>/*#__PURE__*/ react.createElement(CustomListItem, {
            disabled: disabled,
            "data-selected": isActive
        }, /*#__PURE__*/ react.createElement(Icon, {
            color: isActive ? "primary" : "action"
        }))));
};

// EXTERNAL MODULE: ./src/shared/logger.ts
var logger = __webpack_require__(20168);
// EXTERNAL MODULE: ./node_modules/@mui/material/Typography/Typography.js + 1 modules
var Typography = __webpack_require__(2658);
// EXTERNAL MODULE: ./node_modules/@mui/material/Link/Link.js + 2 modules
var Link = __webpack_require__(1079);
// EXTERNAL MODULE: ./node_modules/@mui/material/Menu/Menu.js + 1 modules
var Menu = __webpack_require__(32301);
// EXTERNAL MODULE: ./node_modules/@mui/material/MenuItem/MenuItem.js + 1 modules
var MenuItem = __webpack_require__(33797);
// EXTERNAL MODULE: ./node_modules/@mui/material/ListItemText/ListItemText.js
var ListItemText = __webpack_require__(59334);
// EXTERNAL MODULE: ./node_modules/@mui/material/ListItemIcon/ListItemIcon.js
var ListItemIcon = __webpack_require__(48885);
// EXTERNAL MODULE: ./node_modules/@mui/material/Divider/Divider.js
var Divider = __webpack_require__(67720);
// EXTERNAL MODULE: ./node_modules/@mui/material/Avatar/Avatar.js + 2 modules
var Avatar = __webpack_require__(67109);
// EXTERNAL MODULE: ./node_modules/@mui/icons-material/Business.js
var Business = __webpack_require__(54788);
// EXTERNAL MODULE: ./src/ui/messages.ts
var ui_messages = __webpack_require__(16239);
;// CONCATENATED MODULE: ./src/modules/layout/molecules/ProfileMenu.tsx
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}










const Terms = ()=>{
    return /*#__PURE__*/ react.createElement(Typography/* default */.Z, null, /*#__PURE__*/ react.createElement(Link/* default */.Z, {
        target: "_blank",
        underline: "hover",
        href: "https://cyberhaven.io/legal/enterprise-terms"
    }, ui_messages/* messages.copyright.enterpriseTerms */.s.copyright.enterpriseTerms));
};
const noHover = (0,css/* css */.iv)({
    "&:hover": {
        background: "white"
    }
});
const ApplicationVersion = ()=>/*#__PURE__*/ react.createElement("div", {
        style: {
            userSelect: "all"
        }
    }, runenv/* ENV.GIT_TAG */.V.GIT_TAG);
function useProfileMenu({ logout , user  }) {
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    return (0,hooks/* usePopover */.Sv)((_param)=>{
        var { onOpen  } = _param, api = _object_without_properties(_param, [
            "onOpen"
        ]);
        return /*#__PURE__*/ react.createElement(Menu/* default */.Z, api, /*#__PURE__*/ react.createElement(MenuItem/* default */.Z, {
            className: noHover().className
        }, /*#__PURE__*/ react.createElement(ListItemText/* default */.Z, {
            secondary: user.email
        })), /*#__PURE__*/ react.createElement(MenuItem/* default */.Z, {
            className: noHover().className
        }, /*#__PURE__*/ react.createElement(ListItemIcon/* default */.Z, null, /*#__PURE__*/ react.createElement(Business/* default */.Z, {
            fontSize: "small"
        })), /*#__PURE__*/ react.createElement(ListItemText/* default */.Z, {
            style: {
                textTransform: "capitalize"
            },
            primary: runenv/* ENV.CUSTOMER_NAME */.V.CUSTOMER_NAME
        })), /*#__PURE__*/ react.createElement(Divider/* default */.Z, null), /*#__PURE__*/ react.createElement(MenuItem/* default */.Z, _object_spread_props(_object_spread({
            component: dist/* Link */.rU
        }, {
            to: "/profile"
        }), {
            onClick: api.onClose
        }), /*#__PURE__*/ react.createElement(ListItemText/* default */.Z, {
            primary: "Account settings"
        })), /*#__PURE__*/ react.createElement(MenuItem/* default */.Z, {
            onClick: logout
        }, ui_messages/* messages.profileMenu.logout */.s.profileMenu.logout), /*#__PURE__*/ react.createElement(MenuItem/* default */.Z, {
            className: noHover().className
        }, /*#__PURE__*/ react.createElement(ListItemText/* default */.Z, {
            primary: /*#__PURE__*/ react.createElement(Terms, null),
            secondary: /*#__PURE__*/ react.createElement(layouts/* HStack */.Ug, {
                as: Typography/* default */.Z
            }, /*#__PURE__*/ react.createElement("span", null, "\xa9 Cyberhaven"), /*#__PURE__*/ react.createElement("div", {
                onClick: ()=>{
                    (0,logger/* logInfo */.P)(runenv/* ENV */.V);
                }
            }, /*#__PURE__*/ react.createElement(ApplicationVersion, null)))
        })));
    });
}
function badgeName(name) {
    return name.split(" ").map((el)=>el[0]).join("");
}
const avatarStyles = (0,css/* css */.iv)({
    width: "24px",
    height: "24px",
    fontSize: "0.74rem",
    cursor: "pointer",
    marginTop: "auto"
});
function ProfileMenuItem(_param) {
    var { children =""  } = _param, props = _object_without_properties(_param, [
        "children"
    ]);
    return /*#__PURE__*/ react.createElement(ListItem/* default */.ZP, props, /*#__PURE__*/ react.createElement(Avatar/* default */.Z, {
        className: avatarStyles().className,
        children: badgeName(children)
    }));
}

;// CONCATENATED MODULE: ./src/modules/layout/molecules/index.ts



;// CONCATENATED MODULE: ./src/modules/layout/organisms/Sidebar.tsx














const boxStyles = (0,css/* css */.iv)({
    display: "flex",
    placeSelf: "center",
    position: "relative"
});
function SidebarTemplate({ homePath , children  }) {
    return /*#__PURE__*/ react.createElement(layouts/* Stack */.Kq, {
        style: {
            flexGrow: 1,
            borderRight: `1px solid ${ui/* theme.palette.divider */.rS.palette.divider}`
        }
    }, /*#__PURE__*/ react.createElement(ui/* Box */.xu, {
        "data-testid": testConstants/* navigationSelectors.home */.Q_.home,
        as: dist/* Link */.rU,
        to: homePath,
        className: boxStyles().className,
        sx: {
            paddingTop: ui/* space.3 */.Dh[3]
        }
    }, runenv/* ENV.FEATURES.NEW_LOGO_2023 */.V.FEATURES.NEW_LOGO_2023 ? /*#__PURE__*/ react.createElement(icons/* CyberhavenIcon4 */.Uy, null) : /*#__PURE__*/ react.createElement(icons/* CyberhavenIcon3 */.Ki, {
        viewBox: "-5 0 41 30"
    }), runenv/* ENV.IS_BETA_ENV */.V.IS_BETA_ENV && /*#__PURE__*/ react.createElement(atoms/* BetaLabel */.m, {
        "data-fs": "unmask"
    }, messages/* messages.betaLabel */.s.betaLabel)), /*#__PURE__*/ react.createElement(layouts/* Stack */.Kq, {
        style: {
            flexGrow: 1
        },
        space: 0
    }, children), /*#__PURE__*/ react.createElement("div", {
        style: {
            height: 50
        }
    }));
}
const Sidebar = /*#__PURE__*/ react.memo(function Sidebar({ user  }) {
    const { availableItems: links , homeItem  } = (0,useAvailableNavigationItems/* useAvailableNavigationItems */.F)();
    const [modal, api] = useProfileMenu({
        logout: auth.logout,
        user: user
    });
    return /*#__PURE__*/ react.createElement(SidebarTemplate, {
        homePath: (homeItem === null || homeItem === void 0 ? void 0 : homeItem.path) || routesPaths/* HOME_PAGE_FALLBACK_PATH */.q
    }, modal, links === null || links === void 0 ? void 0 : links.map((item, i)=>/*#__PURE__*/ react.createElement(react.Fragment, {
            key: i
        }, !item.isSpacer ? /*#__PURE__*/ react.createElement(NavigationItem, item) : /*#__PURE__*/ react.createElement("div", {
            style: {
                flexGrow: 1
            }
        }))), /*#__PURE__*/ react.createElement(ProfileMenuItem, {
        onClick: (e)=>api.onOpen(e.target),
        "data-testid": testConstants/* navigationSelectors.profile */.Q_.profile
    }, user.email));
});

;// CONCATENATED MODULE: ./src/modules/layout/organisms/LayoutClassic.tsx













function FallbackComponent({ error , failMessage ="Failed to load page"  }) {
    (0,react.useLayoutEffect)(()=>{
        (0,errors/* reportError */.e)(error);
    }, [
        error
    ]);
    return /*#__PURE__*/ react.createElement(ui/* Box */.xu, {
        sx: {
            centerContent: true,
            height: "100%"
        }
    }, /*#__PURE__*/ react.createElement(Alert/* Alert */.b, {
        title: failMessage,
        icon: /*#__PURE__*/ react.createElement(CancelPresentation/* default */.Z, null)
    }));
}
const LayoutClassic = /*#__PURE__*/ react.forwardRef(({ children  }, ref)=>{
    const user = (0,hooks/* useSelector */.v9)(auth.authState.stores.user);
    const isSmall = (0,useMedia/* default */.Z)("(max-width: 1024px)");
    return /*#__PURE__*/ react.createElement(layouts/* HStack */.Ug, {
        space: 0,
        ref: ref,
        style: {
            height: "100%"
        }
    }, user.id && /*#__PURE__*/ react.createElement(Sidebar, {
        user: user
    }), /*#__PURE__*/ react.createElement(atoms/* FullscreenContent */.e, null, !isSmall ? /*#__PURE__*/ react.createElement(react_error_boundary_umd.ErrorBoundary, {
        fallbackRender: ({ error  })=>/*#__PURE__*/ react.createElement(FallbackComponent, {
                error: error
            })
    }, /*#__PURE__*/ react.createElement(react.Suspense, {
        fallback: /*#__PURE__*/ react.createElement(ui/* LayoutLoader */.GS, null)
    }, children)) : /*#__PURE__*/ react.createElement(Alert/* Alert */.b, {
        title: messages/* messages.notSupportedTitle */.s.notSupportedTitle,
        subtitle: messages/* messages.notSupportedSubtitle */.s.notSupportedSubtitle,
        icon: /*#__PURE__*/ react.createElement(CancelPresentation/* default */.Z, null)
    })));
});


/***/ }),

/***/ 5769:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "LM": () => (/* reexport */ NotificationCenter),
  "dE": () => (/* reexport */ apiErrorNotification),
  "t6": () => (/* reexport */ state/* notification */.t6)
});

// UNUSED EXPORTS: actions, graphApiErrorNotification, initialState, notificationState

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@mui/base/Portal/Portal.js
var Portal = __webpack_require__(78385);
// EXTERNAL MODULE: ./node_modules/@mui/material/Snackbar/Snackbar.js + 2 modules
var Snackbar = __webpack_require__(84972);
// EXTERNAL MODULE: ./src/libs/hooks/index.ts + 18 modules
var hooks = __webpack_require__(88289);
// EXTERNAL MODULE: ./src/modules/notification/state.ts
var state = __webpack_require__(73420);
// EXTERNAL MODULE: ./src/shared/testConstants.ts + 1 modules
var testConstants = __webpack_require__(81202);
// EXTERNAL MODULE: ./node_modules/@mui/material/SnackbarContent/SnackbarContent.js + 1 modules
var SnackbarContent = __webpack_require__(57518);
// EXTERNAL MODULE: ./node_modules/@mui/styles/withStyles/withStyles.js + 34 modules
var withStyles = __webpack_require__(72116);
// EXTERNAL MODULE: ./node_modules/@mui/material/colors/amber.js
var amber = __webpack_require__(90872);
// EXTERNAL MODULE: ./src/ui/css/index.ts
var css = __webpack_require__(93461);
;// CONCATENATED MODULE: ./src/modules/notification/Notification.tsx






const styles = (theme)=>({
        default: {},
        success: {},
        error: {
            color: theme.palette.error.light
        },
        warning: {
            color: amber/* default.700 */.Z[700]
        }
    });
const snackbarStyles = (0,css/* css */.iv)({
    justifyContent: "center"
});
const NotificationContent = /*#__PURE__*/ (0,react.forwardRef)(({ message , description , classes , type , action  }, ref)=>{
    return /*#__PURE__*/ react.createElement(SnackbarContent/* default */.Z, {
        style: {
            justifyContent: "center"
        },
        "data-testid": testConstants/* notificationsSelectors.Message */.ho.Message,
        className: snackbarStyles({
            className: classes[type]
        }).className,
        action: action,
        ref: ref,
        message: /*#__PURE__*/ react.createElement(react.Fragment, null, /*#__PURE__*/ react.createElement("span", null, message), /*#__PURE__*/ react.createElement("br", null), /*#__PURE__*/ react.createElement("span", null, description))
    });
});
const Notification = (0,withStyles/* default */.Z)(styles)(NotificationContent);

;// CONCATENATED MODULE: ./src/modules/notification/NotificationCenter.tsx
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}





const NotificationCenter = ()=>{
    const { open , message , description , type , action , props  } = (0,hooks/* useSelector */.v9)(state/* notificationState */.AE);
    return /*#__PURE__*/ react.createElement(Portal/* default */.Z, {
        container: document.body
    }, /*#__PURE__*/ react.createElement(Snackbar/* default */.Z, _object_spread({
        anchorOrigin: {
            vertical: "bottom",
            horizontal: "center"
        },
        open: open,
        autoHideDuration: 2000,
        onClose: state/* actions.close */.Nw.close
    }, props), /*#__PURE__*/ react.createElement(Notification, {
        type: type,
        message: message,
        description: description,
        action: action
    })));
};

;// CONCATENATED MODULE: ./src/modules/notification/utils.ts
function utils_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function utils_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            utils_define_property(target, key, source[key]);
        });
    }
    return target;
}
const apiErrorNotification = (error, props)=>{
    if (!error.response) {
        return {
            message: "Something went wrong. Please try again later"
        };
    }
    if (!error.response.data) {
        return {
            message: error.message
        };
    }
    return {
        message: error.message,
        description: error.response.data.error,
        props: utils_object_spread({
            autoHideDuration: 5000
        }, props)
    };
};
const graphApiErrorNotification = (error, props)=>{
    return apiErrorNotification(error, utils_object_spread({
        autoHideDuration: 5000
    }, props));
};

;// CONCATENATED MODULE: ./src/modules/notification/index.ts





/***/ }),

/***/ 73420:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "AE": () => (/* binding */ notificationState),
/* harmony export */   "Nw": () => (/* binding */ actions),
/* harmony export */   "t6": () => (/* binding */ notification)
/* harmony export */ });
/* unused harmony export initialState */
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(80207);
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(6610);
/* harmony import */ var okdux__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(56804);



const actions = (0,okdux__WEBPACK_IMPORTED_MODULE_1__/* .createActions */ .dA)({
    open: okdux__WEBPACK_IMPORTED_MODULE_1__/* .build.action */ .J_.action(),
    warning: okdux__WEBPACK_IMPORTED_MODULE_1__/* .build.action */ .J_.action(),
    success: okdux__WEBPACK_IMPORTED_MODULE_1__/* .build.action */ .J_.action(),
    error: okdux__WEBPACK_IMPORTED_MODULE_1__/* .build.action */ .J_.action(),
    close: okdux__WEBPACK_IMPORTED_MODULE_1__/* .build.action */ .J_.action()
}, "notification");
const initialState = {
    type: "default",
    message: "",
    description: "",
    open: false,
    props: {},
    action: null
};
const notificationState = (0,okdux__WEBPACK_IMPORTED_MODULE_1__/* .createState */ .eK)(initialState);
notificationState.on(actions.open, open("default")).on(actions.warning, open("warning")).on(actions.success, open("success")).on(actions.error, open("error")).on(actions.close, close());
function open(type) {
    return (state, payload)=>(0,lodash__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({}, state, initialState, {
            type,
            open: true
        }, payload);
}
function close() {
    return (state)=>(0,lodash__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({}, state, {
            open: false
        });
}
const notification = actions;


/***/ }),

/***/ 86965:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "MZ": () => (/* binding */ useBetas),
/* harmony export */   "nm": () => (/* binding */ initialBetaState),
/* harmony export */   "yg": () => (/* binding */ preloadBetas)
/* harmony export */ });
/* harmony import */ var shared_auth_hooks__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(48351);
/* harmony import */ var runenv__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(76223);
/* harmony import */ var react_query__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(21478);
/* harmony import */ var api_graphql__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(37137);
/* harmony import */ var api_graphql_network__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(48863);
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}





const initialBetaState = {
    gsuite: runenv__WEBPACK_IMPORTED_MODULE_1__/* .ENV.IS_BETA_ENV */ .V.IS_BETA_ENV,
    CONTENT_REPORT: Boolean(runenv__WEBPACK_IMPORTED_MODULE_1__/* .ENV.FEATURES.ENABLE_EXTERNAL_CONTENT */ .V.FEATURES.ENABLE_EXTERNAL_CONTENT)
};
const ONLY_CYBERHAVEN_USERS = [];
function preloadBetas() {
    react_query__WEBPACK_IMPORTED_MODULE_2__/* .queryCache.prefetchQuery */ .sJ.prefetchQuery([
        "beta"
    ], ()=>{
        return (0,api_graphql_network__WEBPACK_IMPORTED_MODULE_4__/* .sendGQLRequest */ .n)(api_graphql__WEBPACK_IMPORTED_MODULE_3__/* .GlobalSettingsDocument */ .He, {}).then((el)=>getBeta(el));
    });
}
function getBeta(el) {
    var _el_global_settings, _el_global_settings_, _el_global_settings__data;
    return el === null || el === void 0 ? void 0 : (_el_global_settings = el.global_settings) === null || _el_global_settings === void 0 ? void 0 : (_el_global_settings_ = _el_global_settings[0]) === null || _el_global_settings_ === void 0 ? void 0 : (_el_global_settings__data = _el_global_settings_.data) === null || _el_global_settings__data === void 0 ? void 0 : _el_global_settings__data.beta;
}
function useBetas() {
    var _data_email;
    const { data  } = (0,shared_auth_hooks__WEBPACK_IMPORTED_MODULE_0__/* .useCurrentUser */ .xJ)();
    const isCyberHavenUser = (data === null || data === void 0 ? void 0 : (_data_email = data.email) === null || _data_email === void 0 ? void 0 : _data_email.endsWith("cyberhaven.com")) || false;
    for (const feature of ONLY_CYBERHAVEN_USERS){
        initialBetaState[feature] = initialBetaState[feature] && isCyberHavenUser;
    }
    return _object_spread({}, initialBetaState, (0,react_query__WEBPACK_IMPORTED_MODULE_2__/* .useQuery */ .aM)([
        "beta"
    ], ()=>(0,api_graphql_network__WEBPACK_IMPORTED_MODULE_4__/* .sendGQLRequest */ .n)(api_graphql__WEBPACK_IMPORTED_MODULE_3__/* .GlobalSettingsDocument */ .He, {}).then((el)=>getBeta(el) ? _object_spread_props(_object_spread({}, getBeta(el)), {
                CONTENT_REPORT: Boolean(initialBetaState["CONTENT_REPORT"])
            }) : initialBetaState), {
        initialStale: true,
        initialData: initialBetaState,
        staleTime: 10 * 10,
        keepPreviousData: true
    }).data);
}


/***/ }),

/***/ 8726:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "B": () => (/* binding */ rangeTypes),
/* harmony export */   "u": () => (/* binding */ formatNumber)
/* harmony export */ });
/* harmony import */ var d3_time__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(60590);
/* harmony import */ var d3_time__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(89692);
/* harmony import */ var d3_time__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(67519);
/* harmony import */ var d3_time__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(47512);
/* harmony import */ var d3_format__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(68195);
/* harmony import */ var d3_format__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(28602);
/* harmony import */ var d3_time_format__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(88152);
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(35173);




const p = (0,d3_format__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(1);
const formatSmallNumber = (0,d3_format__WEBPACK_IMPORTED_MODULE_1__/* .format */ .WU)("." + p + "f");
const formatNumber = (v)=>{
    return v > 1000 ? (0,d3_format__WEBPACK_IMPORTED_MODULE_1__/* .format */ .WU)(".2s")(v) : formatSmallNumber(v);
};
const rangeTypes = {
    hourly: {
        interval: d3_time__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z,
        format: (d, { withHour  })=>{
            if (withHour) {
                return (0,d3_time_format__WEBPACK_IMPORTED_MODULE_3__/* .utcFormat */ .g0)("%b %d, %_I%p")(d);
            }
            return (0,d3_time_format__WEBPACK_IMPORTED_MODULE_3__/* .utcFormat */ .g0)("%_H")(d);
        }
    },
    daily: {
        interval: d3_time__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z,
        format: (d, { withMonth  })=>{
            if (withMonth) {
                return (0,d3_time_format__WEBPACK_IMPORTED_MODULE_3__/* .utcFormat */ .g0)("%b %_d")(d);
            }
            return (0,d3_time_format__WEBPACK_IMPORTED_MODULE_3__/* .utcFormat */ .g0)("%_d")(d);
        }
    },
    weekly: {
        interval: d3_time__WEBPACK_IMPORTED_MODULE_5__/* .utcSunday */ .Ox,
        format: (d, { min , max  })=>{
            const f = (0,d3_time_format__WEBPACK_IMPORTED_MODULE_3__/* .utcFormat */ .g0)("%b %_d");
            const start = f(new Date((0,lodash__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(d.getTime(), min.getTime(), max.getTime())));
            const next = d3_time__WEBPACK_IMPORTED_MODULE_4__/* ["default"].offset */ .Z.offset(d3_time__WEBPACK_IMPORTED_MODULE_5__/* .utcSunday.offset */ .Ox.offset(d, 1), -1);
            const newD = (0,lodash__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(next.getTime(), min.getTime(), max.getTime());
            const end = f(new Date(newD));
            if (start === end) {
                return start;
            }
            return `${start}-${end}`;
        }
    },
    monthly: {
        interval: d3_time__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z,
        format: (0,d3_time_format__WEBPACK_IMPORTED_MODULE_3__/* .utcFormat */ .g0)("%_B")
    }
};


/***/ }),

/***/ 53010:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Au": () => (/* binding */ isNullSensitivityAllowed),
/* harmony export */   "Wx": () => (/* binding */ isAllSensitivitiesSelected),
/* harmony export */   "Zq": () => (/* binding */ sensitivityList),
/* harmony export */   "cE": () => (/* binding */ NULL_SENSITIVITY),
/* harmony export */   "dG": () => (/* binding */ sensitivityMap),
/* harmony export */   "ou": () => (/* binding */ SensitivityItem)
/* harmony export */ });
/* unused harmony exports DEFAULT_SENSITIVITY, sensitivityListWithNull */
/* harmony import */ var assets_icons__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(99899);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var ui__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(17218);
/* harmony import */ var ui_types__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(9527);
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}




const NULL_SENSITIVITY = -1;
const sensitivityMap = {
    [ui_types__WEBPACK_IMPORTED_MODULE_3__/* .Sensitivity.Unrestricted */ .Y.Unrestricted]: {
        label: "Unrestricted",
        sensitivity: ui_types__WEBPACK_IMPORTED_MODULE_3__/* .Sensitivity.Unrestricted */ .Y.Unrestricted
    },
    [ui_types__WEBPACK_IMPORTED_MODULE_3__/* .Sensitivity.Low */ .Y.Low]: {
        label: "Low",
        sensitivity: ui_types__WEBPACK_IMPORTED_MODULE_3__/* .Sensitivity.Low */ .Y.Low
    },
    [ui_types__WEBPACK_IMPORTED_MODULE_3__/* .Sensitivity.Moderate */ .Y.Moderate]: {
        label: "Moderate",
        sensitivity: ui_types__WEBPACK_IMPORTED_MODULE_3__/* .Sensitivity.Moderate */ .Y.Moderate
    },
    [ui_types__WEBPACK_IMPORTED_MODULE_3__/* .Sensitivity.High */ .Y.High]: {
        label: "High",
        sensitivity: ui_types__WEBPACK_IMPORTED_MODULE_3__/* .Sensitivity.High */ .Y.High
    },
    [ui_types__WEBPACK_IMPORTED_MODULE_3__/* .Sensitivity.Critical */ .Y.Critical]: {
        label: "Critical",
        sensitivity: ui_types__WEBPACK_IMPORTED_MODULE_3__/* .Sensitivity.Critical */ .Y.Critical
    },
    null_value: {
        label: "Undefined",
        sensitivity: NULL_SENSITIVITY,
        isNullItem: true
    }
};
const DEFAULT_SENSITIVITY = ui_types__WEBPACK_IMPORTED_MODULE_3__/* .Sensitivity.Low */ .Y.Low;
const sensitivityListWithNull = Object.values(sensitivityMap).map((_param)=>{
    var { label , sensitivity  } = _param, rest = _object_without_properties(_param, [
        "label",
        "sensitivity"
    ]);
    return _object_spread({
        sensitivity,
        label
    }, rest);
}).sort((a, b)=>b.sensitivity - a.sensitivity);
const sensitivityList = sensitivityListWithNull.filter(({ isNullItem  })=>!isNullItem);
const isNullSensitivityAllowed = (sensitivities)=>{
    if (!sensitivities) {
        return false;
    }
    return sensitivities.includes(NULL_SENSITIVITY);
};
const isAllSensitivitiesSelected = (sensitivities)=>{
    if (!sensitivities) {
        return false;
    }
    const severitiesSet = new Set(sensitivities);
    return sensitivityList.every((v)=>severitiesSet.has(v.sensitivity));
};
const SensitivityItem = ({ containerProps , sensitivity , label: labelProps = null , isNullItem =false  })=>{
    if (!sensitivityMap[sensitivity] && !isNullItem) {
        return null;
    }
    const _ref = containerProps || {}, { style  } = _ref, restContainerProps = _object_without_properties(_ref, [
        "style"
    ]);
    const { label  } = sensitivityMap[sensitivity] || sensitivityMap.null_value;
    return /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_1__.createElement("div", _object_spread({
        style: _object_spread({
            display: "flex",
            alignItems: "center",
            padding: "3px 0"
        }, style)
    }, restContainerProps), !isNullItem ? /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_1__.createElement(ui__WEBPACK_IMPORTED_MODULE_2__/* .SensitivityBars */ .U9, {
        barsCount: sensitivity
    }) : /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_1__.createElement(assets_icons__WEBPACK_IMPORTED_MODULE_0__/* .RemoveCircleOutlinedIcon */ .Bc, null), /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_1__.createElement("span", {
        style: {
            marginLeft: 8
        }
    }, labelProps || label));
};


/***/ }),

/***/ 68905:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Dw": () => (/* binding */ isNullSeverityAllowed),
/* harmony export */   "HR": () => (/* binding */ isAllSeveritiesSelected),
/* harmony export */   "V4": () => (/* binding */ severityList),
/* harmony export */   "jZ": () => (/* binding */ severityMap),
/* harmony export */   "kh": () => (/* binding */ SeverityItem),
/* harmony export */   "vz": () => (/* binding */ severityListWithNull),
/* harmony export */   "xL": () => (/* binding */ NULL_SEVERITY),
/* harmony export */   "zb": () => (/* binding */ Severity)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _mui_system__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(41796);
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}


var Severity;
(function(Severity) {
    Severity[Severity["Informational"] = 0] = "Informational";
    Severity[Severity["Low"] = 1] = "Low";
    Severity[Severity["Medium"] = 2] = "Medium";
    Severity[Severity["High"] = 3] = "High";
    Severity[Severity["Critical"] = 4] = "Critical";
})(Severity || (Severity = {}));
const NULL_SEVERITY = -1;
const severityMap = {
    [Severity.Informational]: {
        label: "Informational",
        color: "#60CAFA",
        severity: Severity.Informational,
        unselectedColor: (0,_mui_system__WEBPACK_IMPORTED_MODULE_1__/* .lighten */ .$n)("#60CAFA", 0.6)
    },
    [Severity.Low]: {
        label: "Low",
        color: "#F1C21B",
        severity: Severity.Low,
        unselectedColor: (0,_mui_system__WEBPACK_IMPORTED_MODULE_1__/* .lighten */ .$n)("#F1C21B", 0.6)
    },
    [Severity.Medium]: {
        label: "Medium",
        color: "#FF832B",
        severity: Severity.Medium,
        unselectedColor: (0,_mui_system__WEBPACK_IMPORTED_MODULE_1__/* .lighten */ .$n)("#FF832B", 0.6)
    },
    [Severity.High]: {
        label: "High",
        color: "#DA1E28",
        severity: Severity.High,
        unselectedColor: (0,_mui_system__WEBPACK_IMPORTED_MODULE_1__/* .lighten */ .$n)("#DA1E28", 0.6)
    },
    [Severity.Critical]: {
        label: "Critical",
        color: "#570000",
        severity: Severity.Critical,
        unselectedColor: (0,_mui_system__WEBPACK_IMPORTED_MODULE_1__/* .lighten */ .$n)("#570000", 0.6)
    },
    null_value: {
        label: "Unmatched",
        color: "#7C7C7C",
        unselectedColor: (0,_mui_system__WEBPACK_IMPORTED_MODULE_1__/* .lighten */ .$n)("#570000", 0.6),
        severity: NULL_SEVERITY,
        isNullItem: true
    }
};
const severityListWithNull = Object.values(severityMap).map((_param)=>{
    var { label , color , severity  } = _param, rest = _object_without_properties(_param, [
        "label",
        "color",
        "severity"
    ]);
    return _object_spread({
        severity,
        label,
        color
    }, rest);
}).sort((a, b)=>b.severity - a.severity);
const severityList = severityListWithNull.filter(({ isNullItem  })=>!isNullItem);
const isNullSeverityAllowed = (severities)=>{
    if (!severities) {
        return false;
    }
    return severities.includes(NULL_SEVERITY);
};
const isAllSeveritiesSelected = (severities)=>{
    if (!severities) {
        return false;
    }
    const severitiesSet = new Set(severities);
    return severityList.every((v)=>severitiesSet.has(v.severity));
};
const SeverityItem = ({ containerProps , severity , onClick , showLabel =true , nullSeverity =false  })=>{
    if (!severityMap[severity] && !nullSeverity) {
        return null;
    }
    const { color , label  } = severityMap[severity] || severityMap.null_value;
    const marginRight = showLabel ? 10 : 0;
    return /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", _object_spread({
        onClick: onClick,
        style: {
            display: "flex",
            alignItems: "center",
            padding: "3px 0"
        }
    }, containerProps), /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", {
        style: {
            background: color,
            width: 16,
            height: 16,
            marginRight
        }
    }), showLabel && label);
};


/***/ }),

/***/ 96697:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$2": () => (/* binding */ useDatasetListAll),
/* harmony export */   "Jt": () => (/* binding */ useDatasetsForList),
/* harmony export */   "LT": () => (/* binding */ LocationsTotalKey),
/* harmony export */   "Lg": () => (/* binding */ useCategoryUpsert),
/* harmony export */   "Lq": () => (/* binding */ useCategoryDelete),
/* harmony export */   "MT": () => (/* binding */ fetchLocationsData),
/* harmony export */   "UL": () => (/* binding */ useDatasetUpsert),
/* harmony export */   "Wn": () => (/* binding */ preloadCategoryListAll),
/* harmony export */   "b5": () => (/* binding */ useCategory),
/* harmony export */   "cA": () => (/* binding */ LocationsKey),
/* harmony export */   "gO": () => (/* binding */ useCategoryListAll),
/* harmony export */   "lk": () => (/* binding */ useAdminEventsList),
/* harmony export */   "p9": () => (/* binding */ useDataset),
/* harmony export */   "qQ": () => (/* binding */ useTimesCount),
/* harmony export */   "rf": () => (/* binding */ useUsersCounts),
/* harmony export */   "tk": () => (/* binding */ useDatasetDelete),
/* harmony export */   "ws": () => (/* binding */ usePoliciesCounts),
/* harmony export */   "xW": () => (/* binding */ useLocationsData),
/* harmony export */   "z": () => (/* binding */ useDatasetCounts)
/* harmony export */ });
/* unused harmony exports DataSetsKey, AggregationsKey, DatasetCountsKey, UserCountsKey, LocationsCountsKey, DataSetsAllKey, CategoriesKey, CategoriesAllKey, UsersKey, TrendsKey, StatusCountsKey, AdminEventsKey, UserManagementKey, getDatasetNullFilter, useFiltersCel, useLocationsCounts, useDatesCel, getDatasetQueryKey, useCategoriesForBubbles, useDatasetValue, useLocationsTotalData, getEntityEditKey */
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var react_query__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(21478);
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(9775);
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(87694);
/* harmony import */ var shared_check_error__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(58983);
/* harmony import */ var shared_dashboard__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(38440);
/* harmony import */ var runenv__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(76223);
/* harmony import */ var shared_scopes__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(48561);
/* harmony import */ var libs_cel_query__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(67511);
/* harmony import */ var api__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(62688);
/* harmony import */ var api_gen__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(33013);
/* harmony import */ var api_risks__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(20346);
/* harmony import */ var modules_analytics_Analytics__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(95520);
/* harmony import */ var libs_data_utils__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(50082);
/* harmony import */ var modules_risks_shared__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(18889);
/* harmony import */ var modules_notification__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(5769);
/* harmony import */ var api_mview_status__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(53810);
/* harmony import */ var _utils__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(8764);
/* harmony import */ var _state__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(41465);
/* harmony import */ var _dashboard_core_severity__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(68905);
/* harmony import */ var _dashboard_core_sensitivity__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(53010);
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}




















const DataSetsKey = "datasets";
const AggregationsKey = "aggregations";
const DatasetCountsKey = "datasetCounts";
const UserCountsKey = "usersCounts";
const LocationsCountsKey = "locationsCounts";
const DataSetsAllKey = "datasets-all";
const CategoriesKey = "categories";
const CategoriesAllKey = "categories-all";
const LocationsKey = "locations";
const LocationsTotalKey = "locationsTotal";
const UsersKey = "users";
const TrendsKey = "trends";
const StatusCountsKey = "statusCounts";
const AdminEventsKey = "adminEvents";
const UserManagementKey = "usm";
const getPreviewPolicyKey = (previewPolicy)=>{
    if (!previewPolicy) {
        return previewPolicy;
    }
    return (0,lodash__WEBPACK_IMPORTED_MODULE_19__/* ["default"] */ .Z)(previewPolicy === null || previewPolicy === void 0 ? void 0 : previewPolicy.policy, [
        "name"
    ]);
};
const checkIfAllQueriesAreReady = (...queries)=>{
    return queries.every(({ isFetching , isFetched , enabled =true  })=>!isFetching && isFetched && enabled);
};
const DATASET_NOT_NULL = "dataset_id != null";
const getDatasetNullFilter = ({ selectedSensitivities  })=>{
    if ((0,_dashboard_core_sensitivity__WEBPACK_IMPORTED_MODULE_18__/* .isNullSensitivityAllowed */ .Au)(selectedSensitivities)) {
        return "";
    }
    return DATASET_NOT_NULL;
};
const getDatasetFilter = ({ datasetFilter , previewPolicy , policyEdit , selectedSensitivities  })=>{
    if (!datasetFilter) {
        var _previewPolicy_policy_dataset_ids;
        if (((_previewPolicy_policy_dataset_ids = previewPolicy === null || previewPolicy === void 0 ? void 0 : previewPolicy.policy.dataset_ids) === null || _previewPolicy_policy_dataset_ids === void 0 ? void 0 : _previewPolicy_policy_dataset_ids.length) && !policyEdit.isSearch) {
            datasetFilter = {
                all_datasets: false,
                dataset_ids: previewPolicy === null || previewPolicy === void 0 ? void 0 : previewPolicy.policy.dataset_ids
            };
        } else {
            if (!policyEdit.isNew) {
                datasetFilter = {
                    all_datasets: true,
                    dataset_ids: null
                };
            }
        }
    }
    if ((0,_dashboard_core_sensitivity__WEBPACK_IMPORTED_MODULE_18__/* .isNullSensitivityAllowed */ .Au)(selectedSensitivities)) {
        var _datasetFilter_dataset_ids;
        if (!(datasetFilter === null || datasetFilter === void 0 ? void 0 : (_datasetFilter_dataset_ids = datasetFilter.dataset_ids) === null || _datasetFilter_dataset_ids === void 0 ? void 0 : _datasetFilter_dataset_ids.length)) {
            // if not dataset ids are selected and null sensitivity is allowed, we return null so to-cel doesn't include dataset_id != null
            datasetFilter = null;
        }
    }
    return datasetFilter;
};
function useUsersCounts({ limit =10 , filters , search  }) {
    var _q_categories_filter, _q_datasets_filter, _categoriesFilter_policy_ids;
    const { data: datasets = []  } = useDatasetListAll();
    const { policyEdit , selectedSeverities , globalFilter  } = (0,_state__WEBPACK_IMPORTED_MODULE_16__/* .useFilters */ .mN)();
    const q = _object_spread_props(_object_spread({}, filters), {
        include_all_categories_record: false,
        include_uncategorized: true
    });
    const categorySeverities = selectedSeverities || null;
    let categoriesFilter = (0,_utils__WEBPACK_IMPORTED_MODULE_15__/* .catergoriesFilterToPolicyFilterV2 */ .IT)(q.categories_filter);
    const previewPolicy = (0,_utils__WEBPACK_IMPORTED_MODULE_15__/* .previewPolicyToPreviewPolicyV2 */ .bc)((_q_categories_filter = q.categories_filter) === null || _q_categories_filter === void 0 ? void 0 : _q_categories_filter.preview_category, datasets.map((d)=>d.id) || []);
    const previewDataset = (0,_utils__WEBPACK_IMPORTED_MODULE_15__/* .previewDatasetToPreviewDatasetV2 */ .w5)((_q_datasets_filter = q.datasets_filter) === null || _q_datasets_filter === void 0 ? void 0 : _q_datasets_filter.preview_dataset);
    let datasetFilter = (0,_utils__WEBPACK_IMPORTED_MODULE_15__/* .datasetsFilterToDatasetFilterV2 */ .bi)(q.datasets_filter);
    const selectedSensitivities = q.selected_sensitivities;
    const isPolicyUncategorizedSelected = categoriesFilter === null || categoriesFilter === void 0 ? void 0 : (_categoriesFilter_policy_ids = categoriesFilter.policy_ids) === null || _categoriesFilter_policy_ids === void 0 ? void 0 : _categoriesFilter_policy_ids.includes("Uncategorized");
    datasetFilter = getDatasetFilter({
        datasetFilter,
        previewPolicy,
        policyEdit,
        selectedSensitivities
    });
    if (categoriesFilter && isPolicyUncategorizedSelected) {
        categoriesFilter = {
            all_policies: false,
            policy_ids: [
                null,
                ...(categoriesFilter === null || categoriesFilter === void 0 ? void 0 : categoriesFilter.policy_ids) || []
            ]
        };
    }
    const _useDatesCel = useDatesCel(), { data: datesCel  } = _useDatesCel, dateCelQuery = _object_without_properties(_useDatesCel, [
        "data"
    ]);
    const _useFiltersCel = useFiltersCel({
        // times filter should be null, global times filter is applied in the query
        times_filter: null,
        locations_filters: q.locations_filters || null,
        users_filter: search ? null : {
            users: null,
            user_contains: search
        },
        side_selector: "",
        category_severity_filter: (0,_utils__WEBPACK_IMPORTED_MODULE_15__/* .selectedSeveritiesToFilter */ .bA)(categorySeverities, isPolicyUncategorizedSelected),
        dataset_sensitivity_filter: (0,_utils__WEBPACK_IMPORTED_MODULE_15__/* .selectedSensitivitiesToFilter */ .bY)({
            sensitivities: selectedSensitivities,
            isUncategorizedIncluded: isPolicyUncategorizedSelected
        }),
        datasets_filter: datasetFilter,
        policies_filter: categoriesFilter,
        status_filter: "any",
        preview_policy: previewPolicy,
        preview_dataset: previewDataset
    }), { data: filtersCel = "true"  } = _useFiltersCel, filtersQuery = _object_without_properties(_useFiltersCel, [
        "data"
    ]);
    const usersQuery = (0,react_query__WEBPACK_IMPORTED_MODULE_1__/* .useInfiniteQuery */ .NS)([
        UserCountsKey,
        filtersCel,
        search,
        previewDataset,
        getEntityEditKey(policyEdit),
        getPreviewPolicyKey(previewPolicy),
        globalFilter
    ], /*#__PURE__*/ _async_to_generator(function*(...argumentList) {
        var _previewDataset_dataset, _ref, _aggUsersRes_values;
        const offset = argumentList.at(-1) || 0;
        const res = yield api__WEBPACK_IMPORTED_MODULE_7__.api.eventsapi.Service.Aggregations({
            global_filter: (0,libs_cel_query__WEBPACK_IMPORTED_MODULE_6__/* .celCombine */ .lS)(libs_cel_query__WEBPACK_IMPORTED_MODULE_6__/* .CELConditionOperator.AND */ .KM.AND, !search ? "true" : `local_user_name.existsContainsCI('${search.toLocaleLowerCase().trim()}')`, datesCel, getDatasetNullFilter({
                selectedSensitivities
            }), globalFilter),
            preview_dataset: previewDataset ? _object_spread_props(_object_spread({}, previewDataset === null || previewDataset === void 0 ? void 0 : previewDataset.dataset), {
                name: previewDataset === null || previewDataset === void 0 ? void 0 : (_previewDataset_dataset = previewDataset.dataset) === null || _previewDataset_dataset === void 0 ? void 0 : _previewDataset_dataset.name,
                applied_policies: ((_ref = previewDataset === null || previewDataset === void 0 ? void 0 : previewDataset.dataset) === null || _ref === void 0 ? void 0 : _ref.category_ids) || []
            }) : null,
            preview_policy: (policyEdit === null || policyEdit === void 0 ? void 0 : policyEdit.isSearch) || policyEdit.isNew || policyEdit.isEdit ? previewPolicy === null || previewPolicy === void 0 ? void 0 : previewPolicy.policy : null,
            aggregations: {
                users: {
                    type: "group_by",
                    group_by: [
                        "local_user_name"
                    ],
                    limit,
                    filter: filtersCel,
                    item_queries: runenv__WEBPACK_IMPORTED_MODULE_4__/* .ENV.FEATURES.USER_WIDGET_DIRECTORY_DETAILS_ENABLED */ .V.FEATURES.USER_WIDGET_DIRECTORY_DETAILS_ENABLED ? {
                        ids: {
                            aggregation: "array_distinct",
                            query: "e.destination.endpoint_id",
                            percentile: false
                        }
                    } : undefined,
                    offset
                }
            }
        });
        const aggUsersRes = res.aggregations.users;
        const usersResponse = {
            records: ((_aggUsersRes_values = aggUsersRes.values) === null || _aggUsersRes_values === void 0 ? void 0 : _aggUsersRes_values.filter((d)=>!!d.value).map(({ value , count , item_queries  })=>{
                const existingValue = value;
                return {
                    user: existingValue[0],
                    endpoint_ids: (item_queries === null || item_queries === void 0 ? void 0 : item_queries.ids) || [],
                    count
                };
            })) || [],
            total: aggUsersRes.cardinality,
            offset,
            limit
        };
        return usersResponse;
    }), {
        enabled: checkIfAllQueriesAreReady(filtersQuery, dateCelQuery),
        getFetchMore: (lastPage)=>{
            return lastPage.offset + lastPage.limit;
        }
    });
    return _object_spread_props(_object_spread({}, usersQuery), {
        isLoading: filtersQuery.isLoading || usersQuery.isLoading || dateCelQuery.isLoading,
        isFetching: filtersQuery.isFetching || usersQuery.isFetching || dateCelQuery.isFetching,
        isFetched: filtersQuery.isFetched && usersQuery.isFetched && dateCelQuery.isFetched
    });
}
const useFiltersCel = (rawFilters, enabled = true)=>{
    const filters = (0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(()=>{
        var _f_policies_filter, _f_policies_filter_policy_ids, _f_datasets_filter, _f_datasets_filter_dataset_ids, _f_datasets_filter1;
        const f = _object_spread({}, rawFilters);
        if (!((_f_policies_filter = f.policies_filter) === null || _f_policies_filter === void 0 ? void 0 : (_f_policies_filter_policy_ids = _f_policies_filter.policy_ids) === null || _f_policies_filter_policy_ids === void 0 ? void 0 : _f_policies_filter_policy_ids.length)) {
            f.policies_filter = null;
        }
        if (!((_f_datasets_filter = f.datasets_filter) === null || _f_datasets_filter === void 0 ? void 0 : (_f_datasets_filter_dataset_ids = _f_datasets_filter.dataset_ids) === null || _f_datasets_filter_dataset_ids === void 0 ? void 0 : _f_datasets_filter_dataset_ids.length) && !((_f_datasets_filter1 = f.datasets_filter) === null || _f_datasets_filter1 === void 0 ? void 0 : _f_datasets_filter1.all_datasets)) {
            f.datasets_filter = null;
        }
        return f;
    }, [
        rawFilters
    ]);
    const filtersQuery = (0,react_query__WEBPACK_IMPORTED_MODULE_1__/* .useQuery */ .aM)([
        "filtersCel",
        rawFilters
    ], /*#__PURE__*/ _async_to_generator(function*() {
        const res = yield api__WEBPACK_IMPORTED_MODULE_7__.api.filtersapi.Service.FiltersToCel({
            filters
        });
        return res === null || res === void 0 ? void 0 : res.cel_string;
    }), {
        enabled
    });
    return _object_spread_props(_object_spread({}, filtersQuery), {
        enabled
    });
};
function usePoliciesCounts(apiQuery) {
    var _apiQuery_datasets_filter, _q_categories_filter, _q_datasets_filter, _policiesFilter_policy_ids, _policiesFilter_policy_ids1;
    const { policyEdit , datasetEdit , selectedCategories , globalFilter  } = (0,_state__WEBPACK_IMPORTED_MODULE_16__/* .useFilters */ .mN)();
    const q = _object_spread_props(_object_spread({}, (0,lodash__WEBPACK_IMPORTED_MODULE_19__/* ["default"] */ .Z)(apiQuery, [
        "categories_filter.categories",
        "categories_filter.all_categories"
    ])), {
        statuses: [
            api_gen__WEBPACK_IMPORTED_MODULE_8__/* .CategoryStatusEnum.CategoryStatusApproved */ .HL.CategoryStatusApproved,
            api_gen__WEBPACK_IMPORTED_MODULE_8__/* .CategoryStatusEnum.CategoryStatusLowRisky */ .HL.CategoryStatusLowRisky,
            api_gen__WEBPACK_IMPORTED_MODULE_8__/* .CategoryStatusEnum.CategoryStatusRisky */ .HL.CategoryStatusRisky
        ],
        include_irrelevant: !!(apiQuery === null || apiQuery === void 0 ? void 0 : (_apiQuery_datasets_filter = apiQuery.datasets_filter) === null || _apiQuery_datasets_filter === void 0 ? void 0 : _apiQuery_datasets_filter.all_datasets),
        include_all_categories_record: false,
        include_uncategorized: true,
        is_search: policyEdit.isSearch,
        is_search_datasets: datasetEdit.isSearch
    });
    const _useDatasetListAll = useDatasetListAll(), { data: datasets = []  } = _useDatasetListAll, datasetsQuery = _object_without_properties(_useDatasetListAll, [
        "data"
    ]);
    const categorySeverities = q.category_severities || null;
    const policiesFilter = (0,_utils__WEBPACK_IMPORTED_MODULE_15__/* .catergoriesFilterToPolicyFilterV2 */ .IT)(q.categories_filter);
    const previewPolicy = (0,_utils__WEBPACK_IMPORTED_MODULE_15__/* .previewPolicyToPreviewPolicyV2 */ .bc)((_q_categories_filter = q.categories_filter) === null || _q_categories_filter === void 0 ? void 0 : _q_categories_filter.preview_category, datasets.map((d)=>d.id));
    const previewDataset = (0,_utils__WEBPACK_IMPORTED_MODULE_15__/* .previewDatasetToPreviewDatasetV2 */ .w5)((_q_datasets_filter = q.datasets_filter) === null || _q_datasets_filter === void 0 ? void 0 : _q_datasets_filter.preview_dataset);
    let datasetFilter = (0,_utils__WEBPACK_IMPORTED_MODULE_15__/* .datasetsFilterToDatasetFilterV2 */ .bi)(q.datasets_filter);
    if (!datasetFilter) {
        var _previewPolicy_policy_dataset_ids;
        if (((_previewPolicy_policy_dataset_ids = previewPolicy === null || previewPolicy === void 0 ? void 0 : previewPolicy.policy.dataset_ids) === null || _previewPolicy_policy_dataset_ids === void 0 ? void 0 : _previewPolicy_policy_dataset_ids.length) && !policyEdit.isSearch) {
            datasetFilter = {
                all_datasets: false,
                dataset_ids: previewPolicy === null || previewPolicy === void 0 ? void 0 : previewPolicy.policy.dataset_ids
            };
        } else {
            if (!policyEdit.isNew) {
                datasetFilter = {
                    all_datasets: true,
                    dataset_ids: null
                };
            }
        }
    }
    const _useCategoryListAll = useCategoryListAll(), { data: categoriesRes = {
        categories: []
    }  } = _useCategoryListAll, categoriesQuery = _object_without_properties(_useCategoryListAll, [
        "data"
    ]);
    const _useDatesCel = useDatesCel(), { data: datesCel  } = _useDatesCel, dateCelQuery = _object_without_properties(_useDatesCel, [
        "data"
    ]);
    const selectedSensitivities = q.selected_sensitivities;
    datasetFilter = getDatasetFilter({
        datasetFilter,
        previewPolicy,
        policyEdit,
        selectedSensitivities
    });
    const isUncategorizedIncluded = policiesFilter === null || policiesFilter === void 0 ? void 0 : (_policiesFilter_policy_ids = policiesFilter.policy_ids) === null || _policiesFilter_policy_ids === void 0 ? void 0 : _policiesFilter_policy_ids.includes("Uncategorized");
    const _useFiltersCel = useFiltersCel({
        // times filter should be null, global times filter is applied in the query
        times_filter: null,
        locations_filters: q.locations_filters || null,
        users_filter: q.users_filter || null,
        side_selector: "category",
        category_severity_filter: (0,_utils__WEBPACK_IMPORTED_MODULE_15__/* .selectedSeveritiesToFilter */ .bA)(categorySeverities, policiesFilter === null || policiesFilter === void 0 ? void 0 : (_policiesFilter_policy_ids1 = policiesFilter.policy_ids) === null || _policiesFilter_policy_ids1 === void 0 ? void 0 : _policiesFilter_policy_ids1.includes("Uncategorized")),
        dataset_sensitivity_filter: (0,_utils__WEBPACK_IMPORTED_MODULE_15__/* .selectedSensitivitiesToFilter */ .bY)({
            sensitivities: selectedSensitivities,
            isUncategorizedIncluded
        }),
        datasets_filter: datasetFilter,
        policies_filter: policiesFilter,
        status_filter: "any",
        preview_policy: previewPolicy,
        preview_dataset: previewDataset
    }), { data: filtersCel = "true"  } = _useFiltersCel, filtersQuery = _object_without_properties(_useFiltersCel, [
        "data"
    ]);
    const { categories  } = categoriesRes;
    const countsQuery = (0,react_query__WEBPACK_IMPORTED_MODULE_1__/* .useQuery */ .aM)([
        LocationsCountsKey,
        filtersCel,
        previewDataset,
        apiQuery.datasets_filter.datasets,
        categories,
        getEntityEditKey(policyEdit),
        getPreviewPolicyKey(previewPolicy),
        datesCel,
        globalFilter
    ], /*#__PURE__*/ _async_to_generator(function*() {
        var _previewDataset_dataset, _ref;
        const res = yield api__WEBPACK_IMPORTED_MODULE_7__.api.eventsapi.Service.Aggregations({
            aggregations: {
                policies: {
                    type: "group_by",
                    filter: filtersCel,
                    group_by: [
                        "policy_id"
                    ]
                }
            },
            global_filter: (0,libs_cel_query__WEBPACK_IMPORTED_MODULE_6__/* .celCombine */ .lS)(libs_cel_query__WEBPACK_IMPORTED_MODULE_6__/* .CELConditionOperator.AND */ .KM.AND, datesCel, getDatasetNullFilter({
                selectedSensitivities
            }), globalFilter),
            preview_dataset: previewDataset ? _object_spread_props(_object_spread({}, previewDataset === null || previewDataset === void 0 ? void 0 : previewDataset.dataset), {
                name: previewDataset === null || previewDataset === void 0 ? void 0 : (_previewDataset_dataset = previewDataset.dataset) === null || _previewDataset_dataset === void 0 ? void 0 : _previewDataset_dataset.name,
                applied_policies: ((_ref = previewDataset === null || previewDataset === void 0 ? void 0 : previewDataset.dataset) === null || _ref === void 0 ? void 0 : _ref.category_ids) || []
            }) : null,
            preview_policy: (policyEdit === null || policyEdit === void 0 ? void 0 : policyEdit.isSearch) || policyEdit.isNew || policyEdit.isEdit ? previewPolicy === null || previewPolicy === void 0 ? void 0 : previewPolicy.policy : null
        });
        const countsMap = {};
        for (const { count , value  } of res.aggregations.policies.values || []){
            const id = (value === null || value === void 0 ? void 0 : value[0]) || "other";
            countsMap[id] = {
                count,
                id,
                dataset_ids: []
            };
        }
        return countsMap;
    }), {
        enabled: checkIfAllQueriesAreReady(datasetsQuery, categoriesQuery, dateCelQuery, filtersQuery)
    });
    const countsData = countsQuery.data;
    const datasetFilters = apiQuery.datasets_filter.datasets || [];
    const data = (0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(()=>{
        const countsMap = _object_spread({}, countsData);
        datasets.forEach((dataset)=>{
            var _dataset_category_ids;
            (_dataset_category_ids = dataset.category_ids) === null || _dataset_category_ids === void 0 ? void 0 : _dataset_category_ids.forEach((id)=>{
                if (!countsMap[id]) {
                    countsMap[id] = {
                        count: 0,
                        id,
                        dataset_ids: []
                    };
                } else {
                    countsMap[id] = _object_spread_props(_object_spread({}, countsMap[id]), {
                        dataset_ids: [
                            ...countsMap[id].dataset_ids
                        ]
                    });
                }
                countsMap[id].dataset_ids.push(dataset.id);
            });
        });
        for (const category of categories){
            const id = category.id;
            if (countsMap[id]) {
                const ids = [
                    ...new Set([
                        ...countsMap[id].dataset_ids,
                        ...category.dataset_ids || []
                    ])
                ];
                countsMap[id] = _object_spread_props(_object_spread({}, countsMap[id]), {
                    dataset_ids: ids
                });
            }
        }
        if (datasetFilters.length) {
            for (const count of Object.values(countsMap)){
                if (count.id === "other") {
                    continue;
                }
                if (!count.dataset_ids.some((id)=>datasetFilters.includes(id))) {
                    delete countsMap[count.id];
                }
            }
        }
        const result = categories.filter((category)=>{
            return !datasetFilters.length || countsMap[category.id] && countsMap[category.id].dataset_ids.some((id)=>datasetFilters.includes(id)) || selectedCategories.length === 1 && selectedCategories[0] === category.id;
        }).map((category)=>{
            const mergedCategory = _object_spread(_object_spread_props(_object_spread({}, category), {
                // @ts-ignore
                count: 0,
                // @ts-ignore
                dataset_ids: category.dataset_ids || []
            }), countsMap[category.id]);
            if (policyEdit.isEdit && mergedCategory.id === policyEdit.id) {
                mergedCategory.severity = policyEdit.editingPolicyValues.severity;
                mergedCategory.name = policyEdit.editingPolicyValues.name;
                mergedCategory.rule = policyEdit.editingPolicyValues.rule;
            }
            return mergedCategory;
        });
        if (!(previewPolicy === null || previewPolicy === void 0 ? void 0 : previewPolicy.policy)) {
            var _countsMap_other, _countsMap_other1;
            result.push({
                count: ((_countsMap_other = countsMap.other) === null || _countsMap_other === void 0 ? void 0 : _countsMap_other.count) || 0,
                dataset_ids: ((_countsMap_other1 = countsMap.other) === null || _countsMap_other1 === void 0 ? void 0 : _countsMap_other1.dataset_ids) || [],
                id: "Uncategorized",
                name: "Unmatched"
            });
        } else if ((policyEdit === null || policyEdit === void 0 ? void 0 : policyEdit.isSearch) || (policyEdit === null || policyEdit === void 0 ? void 0 : policyEdit.isNew)) {
            var _countsMap_other2, _countsMap_other3;
            result.push({
                count: ((_countsMap_other2 = countsMap.other) === null || _countsMap_other2 === void 0 ? void 0 : _countsMap_other2.count) || 0,
                dataset_ids: ((_countsMap_other3 = countsMap.other) === null || _countsMap_other3 === void 0 ? void 0 : _countsMap_other3.dataset_ids) || [],
                id: "Uncategorized",
                name: policyEdit.editingPolicyValues.name || "Matching events",
                severity: policyEdit.isNew ? policyEdit.editingPolicyValues.severity : null
            });
        }
        return result.sort((a, b)=>a.count - b.count);
    }, [
        countsData,
        policyEdit,
        datasets,
        datasetFilters,
        categories,
        previewPolicy,
        selectedCategories
    ]);
    return _object_spread_props(_object_spread({}, countsQuery), {
        isLoading: datasetsQuery.isFetching || countsQuery.isLoading || filtersQuery.isFetching || categoriesQuery.isFetching || dateCelQuery.isFetching,
        data
    });
}
// TODO anyside locations doesn't work on BE, fix this when it's ready on the BE side
function useLocationsCounts({ location  } = {
    location: "any"
}) {
    const { apiQuery  } = useFilters();
    const groupMap = {
        any: "any_side.location",
        destination: "destination.location",
        source: "source.location"
    };
    return useQuery([
        LocationsCountsKey,
        getDatasetQueryKey(apiQuery)
    ], /*#__PURE__*/ _async_to_generator(function*() {
        const res = yield api.eventsapi.Service.Aggregations({
            aggregations: {
                locations: {
                    type: "group_by",
                    group_by: [
                        groupMap[location]
                    ]
                }
            }
        });
        return res;
    }));
}
function useDatesCel(enabled = true) {
    var _filters_times_filter, _filters_times_filter1;
    const { apiQuery  } = (0,_state__WEBPACK_IMPORTED_MODULE_16__/* .useFilters */ .mN)();
    const q = getDatasetQueryKey(apiQuery);
    const filters = {
        times_filter: q.times_filter || null,
        locations_filters: null,
        users_filter: null,
        side_selector: "",
        category_severity_filter: null,
        datasets_filter: null,
        policies_filter: null,
        status_filter: "any",
        preview_policy: null,
        preview_dataset: null
    };
    const filtersQuery = (0,react_query__WEBPACK_IMPORTED_MODULE_1__/* .useQuery */ .aM)([
        "filtersCelDate",
        (_filters_times_filter = filters.times_filter) === null || _filters_times_filter === void 0 ? void 0 : _filters_times_filter.end_time,
        (_filters_times_filter1 = filters.times_filter) === null || _filters_times_filter1 === void 0 ? void 0 : _filters_times_filter1.start_time
    ], /*#__PURE__*/ _async_to_generator(function*() {
        const res = yield api__WEBPACK_IMPORTED_MODULE_7__.api.filtersapi.Service.FiltersToCel({
            filters
        });
        return res === null || res === void 0 ? void 0 : res.cel_string;
    }), {
        enabled
    });
    return _object_spread_props(_object_spread({}, filtersQuery), {
        enabled
    });
}
function useDatasetCounts() {
    var _q_categories_filter, _categoriesFilter_policy_ids, _previewPolicy_policy_dataset_ids, _previewPolicy_policy, _previewPolicy_policy_dataset_ids1, _categoriesFilter_policy_ids1, _categoriesFilter_policy_ids2;
    const { apiQuery , policyEdit , globalFilter  } = (0,_state__WEBPACK_IMPORTED_MODULE_16__/* .useFilters */ .mN)();
    const _useDatasetListAll = useDatasetListAll(), { data: datasets = []  } = _useDatasetListAll, datasetsQuery = _object_without_properties(_useDatasetListAll, [
        "data"
    ]);
    const q = getDatasetQueryKey(apiQuery);
    let categoriesFilter = _object_spread({}, (0,_utils__WEBPACK_IMPORTED_MODULE_15__/* .catergoriesFilterToPolicyFilterV2 */ .IT)(q.categories_filter));
    let selectedSeverities = (apiQuery === null || apiQuery === void 0 ? void 0 : apiQuery.selected_severities) || null;
    const selectedSensitivities = (apiQuery === null || apiQuery === void 0 ? void 0 : apiQuery.selected_sensitivities) || null;
    const previewPolicy = (0,_utils__WEBPACK_IMPORTED_MODULE_15__/* .previewPolicyToPreviewPolicyV2 */ .bc)((_q_categories_filter = q.categories_filter) === null || _q_categories_filter === void 0 ? void 0 : _q_categories_filter.preview_category, datasets.map((d)=>d.id));
    if (!categoriesFilter.policy_ids && (previewPolicy === null || previewPolicy === void 0 ? void 0 : previewPolicy.policy.id)) {
        var _previewPolicy_policy1;
        categoriesFilter = {
            policy_ids: [
                (_previewPolicy_policy1 = previewPolicy.policy) === null || _previewPolicy_policy1 === void 0 ? void 0 : _previewPolicy_policy1.id
            ],
            all_policies: false
        };
    }
    const isPolicyUncategorizedSelected = categoriesFilter === null || categoriesFilter === void 0 ? void 0 : (_categoriesFilter_policy_ids = categoriesFilter.policy_ids) === null || _categoriesFilter_policy_ids === void 0 ? void 0 : _categoriesFilter_policy_ids.includes("Uncategorized");
    if ((selectedSeverities === null || selectedSeverities === void 0 ? void 0 : selectedSeverities.length) === _dashboard_core_severity__WEBPACK_IMPORTED_MODULE_17__/* .severityList.length */ .V4.length) {
        selectedSeverities = null;
    }
    let datasetFilter = null;
    if (((_previewPolicy_policy_dataset_ids = previewPolicy === null || previewPolicy === void 0 ? void 0 : previewPolicy.policy.dataset_ids) === null || _previewPolicy_policy_dataset_ids === void 0 ? void 0 : _previewPolicy_policy_dataset_ids.length) && !policyEdit.isSearch) {
        datasetFilter = {
            all_datasets: false,
            dataset_ids: previewPolicy === null || previewPolicy === void 0 ? void 0 : previewPolicy.policy.dataset_ids
        };
    } else {
        var _datasets_map;
        datasetFilter = {
            all_datasets: false,
            dataset_ids: (_datasets_map = datasets === null || datasets === void 0 ? void 0 : datasets.map((d)=>d.id)) !== null && _datasets_map !== void 0 ? _datasets_map : null
        };
    }
    if (!(previewPolicy === null || previewPolicy === void 0 ? void 0 : (_previewPolicy_policy = previewPolicy.policy) === null || _previewPolicy_policy === void 0 ? void 0 : (_previewPolicy_policy_dataset_ids1 = _previewPolicy_policy.dataset_ids) === null || _previewPolicy_policy_dataset_ids1 === void 0 ? void 0 : _previewPolicy_policy_dataset_ids1.length)) {
        if ((previewPolicy === null || previewPolicy === void 0 ? void 0 : previewPolicy.policy.selection_type) === api_gen__WEBPACK_IMPORTED_MODULE_8__/* .SelectionTypeEnum.SelectionTypeDataset */ .XL.SelectionTypeDataset) {
            var _datasets_map1;
            previewPolicy.policy.dataset_ids = (_datasets_map1 = datasets === null || datasets === void 0 ? void 0 : datasets.map((d)=>d.id)) !== null && _datasets_map1 !== void 0 ? _datasets_map1 : null;
        }
    }
    if (categoriesFilter && isPolicyUncategorizedSelected) {
        categoriesFilter = {
            all_policies: false,
            policy_ids: [
                null,
                ...(categoriesFilter === null || categoriesFilter === void 0 ? void 0 : categoriesFilter.policy_ids) || []
            ]
        };
    }
    const _useDatesCel = useDatesCel(), { data: datesCel  } = _useDatesCel, datesQuery = _object_without_properties(_useDatesCel, [
        "data"
    ]);
    const isUncategorizedIncluded = categoriesFilter === null || categoriesFilter === void 0 ? void 0 : (_categoriesFilter_policy_ids1 = categoriesFilter.policy_ids) === null || _categoriesFilter_policy_ids1 === void 0 ? void 0 : _categoriesFilter_policy_ids1.includes("Uncategorized");
    const _useFiltersCel = useFiltersCel({
        // times filter should be null, global times filter is applied in the query
        times_filter: null,
        locations_filters: q.locations_filters || null,
        users_filter: q.users_filter || null,
        side_selector: "dataset",
        category_severity_filter: (0,_utils__WEBPACK_IMPORTED_MODULE_15__/* .selectedSeveritiesToFilter */ .bA)(selectedSeverities, categoriesFilter === null || categoriesFilter === void 0 ? void 0 : (_categoriesFilter_policy_ids2 = categoriesFilter.policy_ids) === null || _categoriesFilter_policy_ids2 === void 0 ? void 0 : _categoriesFilter_policy_ids2.includes("Uncategorized")),
        dataset_sensitivity_filter: (0,_utils__WEBPACK_IMPORTED_MODULE_15__/* .selectedSensitivitiesToFilter */ .bY)({
            sensitivities: selectedSensitivities,
            isUncategorizedIncluded
        }),
        datasets_filter: datasetFilter,
        policies_filter: categoriesFilter,
        status_filter: "any",
        preview_policy: previewPolicy,
        preview_dataset: null
    }), { data: filtersCel = "true"  } = _useFiltersCel, filtersQuery = _object_without_properties(_useFiltersCel, [
        "data"
    ]);
    const countsQuery = (0,react_query__WEBPACK_IMPORTED_MODULE_1__/* .useQuery */ .aM)([
        DataSetsKey,
        DatasetCountsKey,
        filtersCel,
        getPreviewPolicyKey(previewPolicy),
        datesCel,
        globalFilter,
        getEntityEditKey(policyEdit)
    ], /*#__PURE__*/ _async_to_generator(function*() {
        const res = yield api__WEBPACK_IMPORTED_MODULE_7__.api.eventsapi.Service.Aggregations({
            aggregations: {
                datasets: {
                    type: "group_by",
                    filter: filtersCel,
                    group_by: [
                        "dataset_id",
                        "policy_severity"
                    ]
                }
            },
            global_filter: (0,libs_cel_query__WEBPACK_IMPORTED_MODULE_6__/* .celCombine */ .lS)(libs_cel_query__WEBPACK_IMPORTED_MODULE_6__/* .CELConditionOperator.AND */ .KM.AND, getDatasetNullFilter({
                selectedSensitivities
            }), datesCel, globalFilter),
            preview_policy: previewPolicy === null || previewPolicy === void 0 ? void 0 : previewPolicy.policy
        });
        const datasets = {
            allDatasets: {
                all_datasets: true,
                category_ids: null,
                count: 0,
                last_modified: "0001-01-01T00:00:00Z",
                name: "",
                query: {
                    rules: null
                },
                query_version: 0,
                sensitivity: 0,
                severity: {
                    null: 0,
                    [_dashboard_core_severity__WEBPACK_IMPORTED_MODULE_17__/* .Severity.Informational */ .zb.Informational]: 0,
                    [_dashboard_core_severity__WEBPACK_IMPORTED_MODULE_17__/* .Severity.Low */ .zb.Low]: 0,
                    [_dashboard_core_severity__WEBPACK_IMPORTED_MODULE_17__/* .Severity.Medium */ .zb.Medium]: 0,
                    [_dashboard_core_severity__WEBPACK_IMPORTED_MODULE_17__/* .Severity.High */ .zb.High]: 0,
                    [_dashboard_core_severity__WEBPACK_IMPORTED_MODULE_17__/* .Severity.Critical */ .zb.Critical]: 0
                }
            },
            countsMap: {}
        };
        for (const val of res.aggregations.datasets.values || []){
            // severity null or 0-4
            const [datasetId, severity = null] = val.value || [];
            if (!datasets.countsMap[datasetId]) {
                datasets.countsMap[datasetId] = {
                    id: datasetId,
                    severity: {
                        null: 0,
                        [_dashboard_core_severity__WEBPACK_IMPORTED_MODULE_17__/* .Severity.Informational */ .zb.Informational]: 0,
                        [_dashboard_core_severity__WEBPACK_IMPORTED_MODULE_17__/* .Severity.Low */ .zb.Low]: 0,
                        [_dashboard_core_severity__WEBPACK_IMPORTED_MODULE_17__/* .Severity.Medium */ .zb.Medium]: 0,
                        [_dashboard_core_severity__WEBPACK_IMPORTED_MODULE_17__/* .Severity.High */ .zb.High]: 0,
                        [_dashboard_core_severity__WEBPACK_IMPORTED_MODULE_17__/* .Severity.Critical */ .zb.Critical]: 0
                    },
                    count: 0
                };
            }
            if (datasetId !== null || !policyEdit.isEdit) {
                datasets.allDatasets.count += val.count;
                const severityVal = policyEdit.isSearch ? "null" : severity;
                datasets.allDatasets.severity[severityVal] += val.count;
            }
            // if search show grey result without severity
            if (policyEdit.isSearch) {
                datasets.countsMap[datasetId].severity["null"] = val.count;
            } else {
                datasets.countsMap[datasetId].severity[severity] = val.count;
            }
            datasets.countsMap[datasetId].count += val.count;
        }
        return datasets;
    }), {
        enabled: checkIfAllQueriesAreReady(filtersQuery, datasetsQuery, datesQuery)
    });
    return _object_spread_props(_object_spread({}, countsQuery), {
        isLoading: countsQuery.isFetching || filtersQuery.isFetching || datesQuery.isFetching || datasetsQuery.isFetching,
        isFetching: countsQuery.isFetching || filtersQuery.isFetching || datesQuery.isFetching || datasetsQuery.isFetching
    });
}
function useDatasetListAll() {
    const datasetsScope = (0,shared_scopes__WEBPACK_IMPORTED_MODULE_5__/* .useResourceScope */ .kj)(shared_scopes__WEBPACK_IMPORTED_MODULE_5__/* .CyberhavenResource.Datasets */ .$n.Datasets);
    var _el_datasets_sort;
    return (0,react_query__WEBPACK_IMPORTED_MODULE_1__/* .useQuery */ .aM)([
        DataSetsAllKey,
        datasetsScope
    ], ()=>{
        return (0,api_risks__WEBPACK_IMPORTED_MODULE_9__/* .listDatasets */ .kU)(datasetsScope).then((el)=>{
            var _el_datasets;
            return (_el_datasets_sort = (_el_datasets = el.datasets) === null || _el_datasets === void 0 ? void 0 : _el_datasets.sort((0,libs_data_utils__WEBPACK_IMPORTED_MODULE_11__/* .compareByProp */ .qr)("name"))) !== null && _el_datasets_sort !== void 0 ? _el_datasets_sort : [];
        });
    });
}
function useCategoryListAll() {
    const policiesScope = (0,shared_scopes__WEBPACK_IMPORTED_MODULE_5__/* .useResourceScope */ .kj)(shared_scopes__WEBPACK_IMPORTED_MODULE_5__/* .CyberhavenResource.Policies */ .$n.Policies);
    return (0,react_query__WEBPACK_IMPORTED_MODULE_1__/* .useQuery */ .aM)([
        CategoriesAllKey,
        policiesScope
    ], ()=>{
        return (0,api_risks__WEBPACK_IMPORTED_MODULE_9__/* .listCategories */ .kb)(policiesScope).then((res)=>{
            var _res_categories;
            var _res_categories_sort;
            const categories = (_res_categories_sort = res === null || res === void 0 ? void 0 : (_res_categories = res.categories) === null || _res_categories === void 0 ? void 0 : _res_categories.sort((0,libs_data_utils__WEBPACK_IMPORTED_MODULE_11__/* .compareByProp */ .qr)("name"))) !== null && _res_categories_sort !== void 0 ? _res_categories_sort : [];
            return _object_spread_props(_object_spread({}, res), {
                categories
            });
        });
    });
}
function useDatasetUpsert({ onSuccess  }) {
    const { apiQuery  } = (0,_state__WEBPACK_IMPORTED_MODULE_16__/* .useFilters */ .mN)();
    const { data  } = useDatasetsForList();
    const datasets = data === null || data === void 0 ? void 0 : data.records;
    const queryCache = (0,react_query__WEBPACK_IMPORTED_MODULE_1__/* .useQueryCache */ .Zq)();
    return (0,react_query__WEBPACK_IMPORTED_MODULE_1__/* .useMutation */ .Db)((v)=>v.id ? (0,api_risks__WEBPACK_IMPORTED_MODULE_9__/* .updateDataset */ ["do"])(v) : (0,api_risks__WEBPACK_IMPORTED_MODULE_9__/* .createDataset */ .Ty)(v), {
        onSuccess: (res, req)=>{
            queryCache.invalidateQueries([
                CategoriesAllKey,
                api_mview_status__WEBPACK_IMPORTED_MODULE_14__/* .MViewStatusKey */ .F
            ]);
            (0,modules_analytics_Analytics__WEBPACK_IMPORTED_MODULE_10__/* .logEvent */ .Kz)(modules_analytics_Analytics__WEBPACK_IMPORTED_MODULE_10__/* .eventsConstants.dashboard.datasets.create */ .AD.dashboard.datasets.create);
            onSuccess === null || onSuccess === void 0 ? void 0 : onSuccess(res, req);
        },
        onError: (error, __, context)=>{
            queryCache.setQueryData([
                DataSetsKey,
                getDatasetQueryKey(apiQuery)
            ], {
                records: context.previousDatasets
            });
            if ((0,shared_check_error__WEBPACK_IMPORTED_MODULE_2__/* .isRbacError */ .C)(error).result) {
                modules_notification__WEBPACK_IMPORTED_MODULE_13__/* .notification.error */ .t6.error({
                    message: "Access denied"
                });
            }
        },
        onMutate: function() {
            var _ref = _async_to_generator(function*(data) {
                yield queryCache.cancelQueries([
                    DataSetsKey
                ]);
                queryCache.setQueryData([
                    DataSetsKey,
                    getDatasetQueryKey(apiQuery)
                ], {
                    records: datasets.map((dataset)=>{
                        if (dataset.id !== data.id) {
                            return dataset;
                        }
                        return _object_spread({}, dataset, data);
                    })
                });
                return {
                    previousDatasets: datasets
                };
            });
            return function(data) {
                return _ref.apply(this, arguments);
            };
        }(),
        throwOnError: true
    });
}
function useDatasetDelete() {
    const queryCache = (0,react_query__WEBPACK_IMPORTED_MODULE_1__/* .useQueryCache */ .Zq)();
    return (0,react_query__WEBPACK_IMPORTED_MODULE_1__/* .useMutation */ .Db)(api_risks__WEBPACK_IMPORTED_MODULE_9__/* .deleteDataset */ .Io, {
        onSuccess: ()=>{
            queryCache.invalidateQueries([
                CategoriesAllKey
            ]);
            (0,modules_analytics_Analytics__WEBPACK_IMPORTED_MODULE_10__/* .logEvent */ .Kz)(modules_analytics_Analytics__WEBPACK_IMPORTED_MODULE_10__/* .eventsConstants.dashboard.datasets["delete"] */ .AD.dashboard.datasets["delete"]);
        },
        throwOnError: true
    });
}
function useCategoryDelete() {
    const queryCache = (0,react_query__WEBPACK_IMPORTED_MODULE_1__/* .useQueryCache */ .Zq)();
    return (0,react_query__WEBPACK_IMPORTED_MODULE_1__/* .useMutation */ .Db)(api_risks__WEBPACK_IMPORTED_MODULE_9__/* .deleteCategory */ .uu, {
        onSuccess: (_, { id  })=>{
            queryCache.invalidateQueries([
                DataSetsAllKey
            ]);
            (0,modules_analytics_Analytics__WEBPACK_IMPORTED_MODULE_10__/* .logEvent */ .Kz)(modules_analytics_Analytics__WEBPACK_IMPORTED_MODULE_10__/* .eventsConstants.dashboard.categories["delete"] */ .AD.dashboard.categories["delete"]);
            queryCache.setQueryData([
                CategoriesAllKey
            ], (data)=>{
                var _data_categories;
                return {
                    categories: data === null || data === void 0 ? void 0 : (_data_categories = data.categories) === null || _data_categories === void 0 ? void 0 : _data_categories.filter((category)=>category.id !== id)
                };
            });
        },
        throwOnError: true
    });
}
function useCategoryUpsert({ onSuccess =()=>{}  }) {
    const queryCache = (0,react_query__WEBPACK_IMPORTED_MODULE_1__/* .useQueryCache */ .Zq)();
    return (0,react_query__WEBPACK_IMPORTED_MODULE_1__/* .useMutation */ .Db)((v)=>v.id ? (0,api_risks__WEBPACK_IMPORTED_MODULE_9__/* .updateCategory */ .yr)(v) : (0,api_risks__WEBPACK_IMPORTED_MODULE_9__/* .createCategory */ .k4)(v), {
        onSuccess: (res, req)=>{
            queryCache.invalidateQueries([
                DataSetsAllKey,
                api_mview_status__WEBPACK_IMPORTED_MODULE_14__/* .MViewStatusKey */ .F
            ]);
            (0,modules_analytics_Analytics__WEBPACK_IMPORTED_MODULE_10__/* .logEvent */ .Kz)(modules_analytics_Analytics__WEBPACK_IMPORTED_MODULE_10__/* .eventsConstants.dashboard.categories.update */ .AD.dashboard.categories.update);
            queryCache.setQueryData([
                CategoriesAllKey
            ], (data)=>{
                var _data_categories;
                return {
                    categories: data === null || data === void 0 ? void 0 : (_data_categories = data.categories) === null || _data_categories === void 0 ? void 0 : _data_categories.map((category)=>{
                        if (category.id === req.id) {
                            return _object_spread({}, category, req);
                        }
                        return category;
                    })
                };
            });
            onSuccess(res, req);
        },
        throwOnError: true
    });
}
const getDatasetQueryKey = (apiQuery)=>{
    return _object_spread_props(_object_spread({}, (0,lodash__WEBPACK_IMPORTED_MODULE_20__/* ["default"] */ .Z)(apiQuery, [
        "locations_filters",
        "users_filter",
        "times_filter",
        "statuses",
        "categories_filter"
    ])), {
        include_irrelevant: true,
        statuses: [
            api_gen__WEBPACK_IMPORTED_MODULE_8__/* .CategoryStatusEnum.CategoryStatusAny */ .HL.CategoryStatusAny,
            api_gen__WEBPACK_IMPORTED_MODULE_8__/* .CategoryStatusEnum.CategoryStatusApproved */ .HL.CategoryStatusApproved,
            api_gen__WEBPACK_IMPORTED_MODULE_8__/* .CategoryStatusEnum.CategoryStatusLowRisky */ .HL.CategoryStatusLowRisky,
            api_gen__WEBPACK_IMPORTED_MODULE_8__/* .CategoryStatusEnum.CategoryStatusRiskyOrLow */ .HL.CategoryStatusRiskyOrLow,
            api_gen__WEBPACK_IMPORTED_MODULE_8__/* .CategoryStatusEnum.CategoryStatusRisky */ .HL.CategoryStatusRisky,
            api_gen__WEBPACK_IMPORTED_MODULE_8__/* .CategoryStatusEnum.CategoryStatusNeedsReview */ .HL.CategoryStatusNeedsReview
        ],
        include_all_datasets_record: true
    });
};
// returns datasets and counts for datasets in dataset centric view
function useDatasetsForList(addAllRecord = true) {
    var _datasetsCountsQuery_data, _datasetList_data, _datasetsCountsQuery_data1;
    const datasetsCountsQuery = useDatasetCounts();
    const datasetList = useDatasetListAll();
    const isDeferred = datasetsCountsQuery.isLoading || datasetsCountsQuery.isError;
    const datasetsMap = ((_datasetsCountsQuery_data = datasetsCountsQuery.data) === null || _datasetsCountsQuery_data === void 0 ? void 0 : _datasetsCountsQuery_data.countsMap) || {};
    const finalRecords = (_datasetList_data = datasetList.data) === null || _datasetList_data === void 0 ? void 0 : _datasetList_data.map((el)=>_object_spread({}, datasetsMap[el.id], el));
    if (((_datasetsCountsQuery_data1 = datasetsCountsQuery.data) === null || _datasetsCountsQuery_data1 === void 0 ? void 0 : _datasetsCountsQuery_data1.allDatasets) && addAllRecord) {
        var _datasetsCountsQuery_data2;
        finalRecords === null || finalRecords === void 0 ? void 0 : finalRecords.unshift((_datasetsCountsQuery_data2 = datasetsCountsQuery.data) === null || _datasetsCountsQuery_data2 === void 0 ? void 0 : _datasetsCountsQuery_data2.allDatasets);
    }
    var _datasetList_data1;
    const initialRecords = [
        ...(_datasetList_data1 = datasetList === null || datasetList === void 0 ? void 0 : datasetList.data) !== null && _datasetList_data1 !== void 0 ? _datasetList_data1 : []
    ];
    if (addAllRecord) {
        initialRecords.unshift({
            id: modules_risks_shared__WEBPACK_IMPORTED_MODULE_12__/* .AllDatasets */ .qh,
            name: modules_risks_shared__WEBPACK_IMPORTED_MODULE_12__/* .AllDatasetsLabel */ .g5
        });
    }
    return _object_spread_props(_object_spread({}, datasetList), {
        isDeferred: isDeferred,
        isFetching: datasetsCountsQuery.isFetching || datasetList.isFetching,
        data: {
            records: isDeferred ? initialRecords : finalRecords
        }
    });
}
// returns categories and counts for categories in dataset centric view
function useCategoriesForBubbles(apiQuery) {
    var _apiQuery_datasets_filter;
    const { policyEdit , datasetEdit  } = useFilters();
    const q = _object_spread_props(_object_spread({}, omit(apiQuery, [
        "categories_filter.categories",
        "categories_filter.all_categories"
    ])), {
        statuses: [
            CategoryStatusEnum.CategoryStatusApproved,
            CategoryStatusEnum.CategoryStatusLowRisky,
            CategoryStatusEnum.CategoryStatusRisky
        ],
        include_irrelevant: !!((_apiQuery_datasets_filter = apiQuery.datasets_filter) === null || _apiQuery_datasets_filter === void 0 ? void 0 : _apiQuery_datasets_filter.all_datasets),
        include_all_categories_record: false,
        include_uncategorized: true,
        is_search: policyEdit.isSearch,
        is_search_datasets: datasetEdit.isSearch
    });
    return useQuery([
        CategoriesKey,
        q
    ], /*#__PURE__*/ _async_to_generator(function*() {
        return yield getCategoriesCounts(q);
    }));
}
function useTimesCount(filters, period) {
    return (0,react_query__WEBPACK_IMPORTED_MODULE_1__/* .useQuery */ .aM)([
        TrendsKey,
        {
            filters: (0,lodash__WEBPACK_IMPORTED_MODULE_19__/* ["default"] */ .Z)(filters, [
                "times_filter.segments"
            ]),
            period
        }
    ], (_, { filters , period  })=>(0,api_risks__WEBPACK_IMPORTED_MODULE_9__/* .timesCount */ .Gg)(_object_spread_props(_object_spread({}, filters), {
            period: period,
            dataflows: true,
            dataOrigins: false,
            users: false
        })));
}
function preloadCategoryListAll(cache) {
    return cache.prefetchQuery([
        CategoriesAllKey
    ], ()=>{
        return (0,api_risks__WEBPACK_IMPORTED_MODULE_9__/* .listCategories */ .kb)().then((res)=>{
            var _res_categories;
            return _object_spread_props(_object_spread({}, res), {
                categories: res === null || res === void 0 ? void 0 : (_res_categories = res.categories) === null || _res_categories === void 0 ? void 0 : _res_categories.sort((a, b)=>a.name.localeCompare(b.name))
            });
        });
    });
}
function useDatasetQueryKey({ id  }) {
    return [
        DataSetsAllKey,
        {
            id
        }
    ];
}
function useDataset({ id , value =null  }, options = {}) {
    return (0,react_query__WEBPACK_IMPORTED_MODULE_1__/* .useQuery */ .aM)(useDatasetQueryKey({
        id
    }), /*#__PURE__*/ _async_to_generator(function*() {
        if (id === shared_dashboard__WEBPACK_IMPORTED_MODULE_3__/* .createTypeEnum.search */ .Rm.search || id === shared_dashboard__WEBPACK_IMPORTED_MODULE_3__/* .createTypeEnum["new"] */ .Rm["new"] || !id) {
            return value;
        }
        if (id === modules_risks_shared__WEBPACK_IMPORTED_MODULE_12__/* .AllDatasets */ .qh) {
            return yield Promise.resolve(_object_spread_props(_object_spread({}, value), {
                id: modules_risks_shared__WEBPACK_IMPORTED_MODULE_12__/* .AllDatasets */ .qh,
                name: modules_risks_shared__WEBPACK_IMPORTED_MODULE_12__/* .predefinedDatasetsTitle */ .o_[modules_risks_shared__WEBPACK_IMPORTED_MODULE_12__/* .AllDatasets */ .qh]
            }));
        }
        return yield api__WEBPACK_IMPORTED_MODULE_7__.api.riskydashboard.ServiceInterface.GetDataset({
            id
        }).then((el)=>el.dataset);
    }), options);
}
function useDatasetValue({ id , value =null  }, options = {}) {
    return useQuery(useDatasetQueryKey({
        id
    }), /*#__PURE__*/ _async_to_generator(function*() {
        if (id === createTypeEnum.search || id === createTypeEnum.new || !id) {
            return value;
        }
        if (id === AllDatasets) {
            return yield Promise.resolve({
                id: AllDatasets,
                name: predefinedDatasetsTitle[AllDatasets]
            });
        }
        return yield api.riskydashboard.ServiceInterface.GetDataset({
            id
        }).then((el)=>el.dataset);
    }), options);
}
function useCategoryQueryKey({ id  }) {
    return [
        CategoriesAllKey,
        {
            id
        }
    ];
}
function useCategory({ id , value =null  }) {
    return (0,react_query__WEBPACK_IMPORTED_MODULE_1__/* .useQuery */ .aM)(useCategoryQueryKey({
        id
    }), /*#__PURE__*/ _async_to_generator(function*() {
        if (id === shared_dashboard__WEBPACK_IMPORTED_MODULE_3__/* .createTypeEnum["new"] */ .Rm["new"] || id === shared_dashboard__WEBPACK_IMPORTED_MODULE_3__/* .createTypeEnum.search */ .Rm.search) {
            return value;
        }
        if (id === modules_risks_shared__WEBPACK_IMPORTED_MODULE_12__/* .AllCategories */ .SZ) {
            return Promise.resolve({
                id: modules_risks_shared__WEBPACK_IMPORTED_MODULE_12__/* .AllCategories */ .SZ,
                name: modules_risks_shared__WEBPACK_IMPORTED_MODULE_12__/* .AllCategoriesLabel */ .mp
            });
        }
        return api__WEBPACK_IMPORTED_MODULE_7__.api.riskydashboard.ServiceInterface.GetCategory({
            id
        }).then((el)=>(0,api_risks__WEBPACK_IMPORTED_MODULE_9__/* .overviewEntityReadTransformation */ .J7)(el.category));
    }));
}
const fetchLocationsData = (_, query)=>{
    var _query_categories_filter, _query_categories_filter_preview_category;
    if ((_query_categories_filter = query.categories_filter) === null || _query_categories_filter === void 0 ? void 0 : (_query_categories_filter_preview_category = _query_categories_filter.preview_category) === null || _query_categories_filter_preview_category === void 0 ? void 0 : _query_categories_filter_preview_category.category) {
        var _query_categories_filter1, _query_categories_filter_preview_category1;
        const category = (0,_utils__WEBPACK_IMPORTED_MODULE_15__/* .processPreviewPolicy */ .ul)((_query_categories_filter1 = query.categories_filter) === null || _query_categories_filter1 === void 0 ? void 0 : (_query_categories_filter_preview_category1 = _query_categories_filter1.preview_category) === null || _query_categories_filter_preview_category1 === void 0 ? void 0 : _query_categories_filter_preview_category1.category, query.datasets_filter.datasets || []);
        query = _object_spread_props(_object_spread({}, query), {
            categories_filter: _object_spread_props(_object_spread({}, query.categories_filter), {
                preview_category: _object_spread_props(_object_spread({}, query.categories_filter.preview_category), {
                    category
                })
            })
        });
    }
    return (0,api_risks__WEBPACK_IMPORTED_MODULE_9__/* .locationCount */ .N4)(query).then((data)=>{
        var _data_records;
        return _object_spread_props(_object_spread({}, data), {
            records: (_data_records = data.records) === null || _data_records === void 0 ? void 0 : _data_records.filter((record)=>!!record.count)
        });
    });
};
const useLocationsData = (query)=>{
    return (0,react_query__WEBPACK_IMPORTED_MODULE_1__/* .usePaginatedQuery */ .NE)([
        LocationsKey,
        query
    ], fetchLocationsData, {
        staleTime: 2000
    });
};
const useLocationsTotalData = ()=>{
    const queryCache = useQueryCache();
    useIsFetching(); // todo used it because of having consistency with widget numbers
    return queryCache.getQueryData(LocationsTotalKey);
};
// audit logs apis
function useAdminEventsList(req) {
    return (0,react_query__WEBPACK_IMPORTED_MODULE_1__/* .useInfiniteQuery */ .NS)([
        AdminEventsKey,
        req
    ], (_, __, pageId)=>api__WEBPACK_IMPORTED_MODULE_7__.api.riskydashboard.ServiceInterface.ListAdminEvents({
            filters: req,
            page_id: pageId,
            page_size: 10
        }).then((el)=>el), {
        getFetchMore: (lastPage)=>lastPage.next_page_id
    });
}
// return serializable object
function getEntityEditKey(entity) {
    if (!entity) {
        return null;
    }
    return {
        id: entity.id,
        isEdit: entity.isEdit,
        isEditing: entity.isEditing,
        isNew: entity.isNew,
        isSearch: entity.isSearch,
        editingPolicyValues: (0,lodash__WEBPACK_IMPORTED_MODULE_19__/* ["default"] */ .Z)(entity.editingPolicyValues, "name")
    };
}


/***/ }),

/***/ 41465:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Wy": () => (/* binding */ FiltersProvider),
/* harmony export */   "mN": () => (/* binding */ useFilters)
/* harmony export */ });
/* unused harmony exports filtersNames, getFiltersInitialState, useFiltersInternal */
/* harmony import */ var constate__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__(11521);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var runenv__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(76223);
/* harmony import */ var shared_useHistoryParam__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(21714);
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(50576);
/* harmony import */ var shared_editFiltersHooks__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(26277);
/* harmony import */ var shared_dashboard__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(38440);
/* harmony import */ var date_fns_startOfDay__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(69119);
/* harmony import */ var date_fns_endOfDay__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(83894);
/* harmony import */ var date_fns_subDays__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(7069);
/* harmony import */ var shared_scopes__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(48561);
/* harmony import */ var api_gen__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(33013);
/* harmony import */ var modules_graph_constants__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(68224);
/* harmony import */ var libs_hooks_useOnChange2__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(93689);
/* harmony import */ var modules_table__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(25373);
/* harmony import */ var modules_timezone__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(43100);
/* harmony import */ var libs_timezone_timezoneUtils__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(4840);
/* harmony import */ var modules_risks_shared__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(18889);
/* harmony import */ var libs_time__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(69113);
/* harmony import */ var modules_risks_dataflows_dashboard_utils__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(24559);
/* harmony import */ var _utils__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(8764);
/* harmony import */ var _charts_shared__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(8726);
/* harmony import */ var _dashboard_core_severity__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(68905);
/* harmony import */ var _dashboard_core_sensitivity__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(53010);
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
























const filtersNames = {
    categoryStatus: "status-count",
    timeFilter: "time-filter",
    selectedCategories: "selectedCategories",
    selectedDates: "selectedDates",
    splitBy: "splitBy",
    // TODO think about old value "dataset"
    selectedDatasets: "selectedDatasets",
    selectedUsers: "selectedUsers",
    selectedSensorTypes: "selectedSensorTypes",
    selectedLocations: "selectedLocations",
    expandedLocations: "expandedLocations",
    previewType: "previewType"
};
const getFiltersInitialState = ()=>({
        categoryStatus: "risky_or_low",
        timeFilter: {
            start_time: initialTimeRange.start,
            end_time: initialTimeRange.end
        },
        selectedCategories: [
            AllCategories
        ],
        selectedDates: [],
        selectedDatasets: [
            AllDatasets
        ],
        selectedUsers: [],
        selectedLocations: [],
        expandedLocations: [],
        selectedSensorTypes: []
    });
const getFiltersConfig = ({ defaultCategories , timezone  })=>({
        querySide: {
            queryKey: "query-side",
            defaultValue: api_gen__WEBPACK_IMPORTED_MODULE_6__/* .SideSelectorEnum.SideSelectorCategory */ .gA.SideSelectorCategory
        },
        // Exact UTC date which is sent to an API
        timeFilter: {
            queryKey: "time-filter",
            defaultValue: (()=>{
                const todayInUserTimezone = (0,libs_timezone_timezoneUtils__WEBPACK_IMPORTED_MODULE_11__/* .shiftDateByTimezoneOffset */ .dH)((0,libs_timezone_timezoneUtils__WEBPACK_IMPORTED_MODULE_11__/* .addLocalTZOffset */ .qI)(new Date()), timezone);
                const startTime = runenv__WEBPACK_IMPORTED_MODULE_1__/* .ENV.START_DATE */ .V.START_DATE ? new Date(runenv__WEBPACK_IMPORTED_MODULE_1__/* .ENV.START_DATE */ .V.START_DATE) : (0,libs_timezone_timezoneUtils__WEBPACK_IMPORTED_MODULE_11__/* .removeLocalTZOffset */ .ht)((0,date_fns_startOfDay__WEBPACK_IMPORTED_MODULE_19__/* ["default"] */ .Z)((0,date_fns_subDays__WEBPACK_IMPORTED_MODULE_20__/* ["default"] */ .Z)(todayInUserTimezone, 7)));
                const endTime = runenv__WEBPACK_IMPORTED_MODULE_1__/* .ENV.END_DATE */ .V.END_DATE ? new Date(runenv__WEBPACK_IMPORTED_MODULE_1__/* .ENV.END_DATE */ .V.END_DATE) : (0,libs_timezone_timezoneUtils__WEBPACK_IMPORTED_MODULE_11__/* .removeLocalTZOffset */ .ht)((0,date_fns_endOfDay__WEBPACK_IMPORTED_MODULE_21__/* ["default"] */ .Z)(todayInUserTimezone));
                return {
                    start_time: startTime.toISOString(),
                    end_time: endTime.toISOString()
                };
            })()
        },
        globalFilter: {
            queryKey: "global-filter",
            defaultValue: ""
        },
        selectedCategories: {
            queryKey: "selectedCategories",
            defaultValue: defaultCategories
        },
        selectedDates: {
            queryKey: "selectedDates",
            defaultValue: []
        },
        selectedDatasets: {
            queryKey: "selectedDatasets",
            defaultValue: [
                modules_risks_shared__WEBPACK_IMPORTED_MODULE_12__/* .AllDatasets */ .qh
            ]
        },
        selectedSeverities: {
            queryKey: "selectedSeverities",
            defaultValue: _dashboard_core_severity__WEBPACK_IMPORTED_MODULE_17__/* .severityList.map */ .V4.map((v)=>v.severity)
        },
        selectedSensitivities: {
            queryKey: "selectedSensitivities",
            defaultValue: _dashboard_core_sensitivity__WEBPACK_IMPORTED_MODULE_18__/* .sensitivityList.map */ .Zq.map((v)=>v.sensitivity)
        },
        selectedUsers: {
            queryKey: "selectedUsers",
            defaultValue: new Set([])
        },
        selectedLocations: {
            queryKey: "selectedLocations",
            defaultValue: new Set([])
        },
        selectedLocationsDestinations: {
            queryKey: "selectedLocationsDestinations",
            defaultValue: new Set([])
        },
        selectedLocationsSources: {
            queryKey: "selectedLocationsSources",
            defaultValue: new Set([])
        }
    });
function append(arr, value) {
    if (arr) {
        arr.push(value);
        return arr;
    }
    return [
        value
    ];
}
function useFiltersInternal({ prefix ="" , initialState ={} , categories , datasets  }) {
    var _find;
    const categoryByStatus = (0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(()=>{
        return categories.reduce((acc, el)=>{
            const status = el.rule.status;
            const newValue = append(acc.get(status), el.id);
            if (status === "risky" || status === "low_risky") {
                acc.set(api_gen__WEBPACK_IMPORTED_MODULE_6__/* .CategoryStatusEnum.CategoryStatusRiskyOrLow */ .HL.CategoryStatusRiskyOrLow, append(acc.get(api_gen__WEBPACK_IMPORTED_MODULE_6__/* .CategoryStatusEnum.CategoryStatusRiskyOrLow */ .HL.CategoryStatusRiskyOrLow), el.id));
            }
            acc.set(status, newValue);
            return acc;
        }, new Map());
    }, [
        categories
    ]);
    var _categories_map;
    const defaultCategories = (_categories_map = categories.map((c)=>c.id)) !== null && _categories_map !== void 0 ? _categories_map : [];
    const { timezone  } = (0,modules_timezone__WEBPACK_IMPORTED_MODULE_10__/* .useTimezoneState */ .co)();
    const eventsScope = (0,shared_scopes__WEBPACK_IMPORTED_MODULE_5__/* .useResourceScope */ .kj)(shared_scopes__WEBPACK_IMPORTED_MODULE_5__/* .CyberhavenResource.Events */ .$n.Events);
    let _useFiltersState = (0,modules_table__WEBPACK_IMPORTED_MODULE_9__/* .useFilters */ .mN)({
        filters: getFiltersConfig({
            defaultCategories,
            timezone
        }),
        queryKeyPrefix: prefix,
        initialValue: initialState,
        clearAllFilter: (name)=>{
            return name !== "timeFilter";
        }
    }), { timeFilter , setTimeFilter , globalFilter: globalFilterState , setGlobalFilter , setSelectedDates , selectedDatasets , selectedCategories , setSelectedDatasets: setSelectedDatasetsInternal , setSelectedCategories: setSelectedCategoriesInternal , selectedDates , querySide , setQuerySide , selectedLocations , setSelectedLocations , selectedLocationsDestinations , setSelectedLocationsDestinations , selectedLocationsSources , setSelectedLocationsSources , selectedSeverities , selectedSensitivities , setSelectedSeverities , setSelectedSensitivities  } = _useFiltersState, props = _object_without_properties(_useFiltersState, [
        "timeFilter",
        "setTimeFilter",
        "globalFilter",
        "setGlobalFilter",
        "setSelectedDates",
        "selectedDatasets",
        "selectedCategories",
        "setSelectedDatasets",
        "setSelectedCategories",
        "selectedDates",
        "querySide",
        "setQuerySide",
        "selectedLocations",
        "setSelectedLocations",
        "selectedLocationsDestinations",
        "setSelectedLocationsDestinations",
        "selectedLocationsSources",
        "setSelectedLocationsSources",
        "selectedSeverities",
        "selectedSensitivities",
        "setSelectedSeverities",
        "setSelectedSensitivities"
    ]);
    const globalFilter = (0,shared_scopes__WEBPACK_IMPORTED_MODULE_5__/* .combineScopes */ .Wn)(globalFilterState, eventsScope);
    const userTimezoneTime = {
        start_time: (0,libs_timezone_timezoneUtils__WEBPACK_IMPORTED_MODULE_11__/* .shiftDateByTimezoneOffset */ .dH)(timeFilter.start_time, timezone).toISOString(),
        end_time: (0,libs_timezone_timezoneUtils__WEBPACK_IMPORTED_MODULE_11__/* .shiftDateByTimezoneOffset */ .dH)(timeFilter.end_time, timezone).toISOString()
    };
    const startDate = new Date((0,libs_time__WEBPACK_IMPORTED_MODULE_13__/* .startOfDate */ .T1)(userTimezoneTime.start_time));
    const endDate = new Date((0,libs_time__WEBPACK_IMPORTED_MODULE_13__/* .endOfDate */ .zp)(userTimezoneTime.end_time));
    const availableRanges = (0,modules_risks_dataflows_dashboard_utils__WEBPACK_IMPORTED_MODULE_14__/* .getRanges */ .Go)(startDate, endDate);
    const convertedSelectedDates = (0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(()=>selectedDates.map((el)=>new Date(el)), [
        selectedDates
    ]);
    const [splitDateBy, setSplitDateBy] = (0,shared_useHistoryParam__WEBPACK_IMPORTED_MODULE_2__/* .useHistoryParam */ .B)(prefix + filtersNames.splitBy, availableRanges[0]);
    const [expandedLocations, setExpandedLocations] = (0,shared_useHistoryParam__WEBPACK_IMPORTED_MODULE_2__/* .useHistoryParam */ .B)(prefix + filtersNames.expandedLocations, initialState.expandedLocations || []);
    const [mode, setPreviewType] = (0,shared_useHistoryParam__WEBPACK_IMPORTED_MODULE_2__/* .useHistoryParam */ .B)(prefix + filtersNames.previewType, null);
    const rangeType = _charts_shared__WEBPACK_IMPORTED_MODULE_16__/* .rangeTypes */ .B[splitDateBy] || _charts_shared__WEBPACK_IMPORTED_MODULE_16__/* .rangeTypes */ .B[availableRanges[0]];
    (0,libs_hooks_useOnChange2__WEBPACK_IMPORTED_MODULE_8__/* .useOnChange2 */ .D)(availableRanges.join(","), ()=>{
        setSelectedDates([]);
        if (!availableRanges.includes(splitDateBy)) {
            setSplitDateBy(availableRanges[0]);
        }
    });
    function setSelectedDatasets(v) {
        let newValue = v;
        if (v.length === 0) {
            newValue = [
                modules_risks_shared__WEBPACK_IMPORTED_MODULE_12__/* .AllDatasets */ .qh
            ];
        }
        setSelectedDatasetsInternal(newValue);
    }
    function setSelectedCategories(v) {
        let newValue = v.filter((el)=>Boolean(el));
        if (v.length === 0) {
            newValue = defaultCategories;
        }
        setSelectedCategoriesInternal(newValue);
    }
    const editFilters = (0,shared_editFiltersHooks__WEBPACK_IMPORTED_MODULE_3__/* .useLocationEditFilters */ .l)();
    const originalSetDataset = editFilters.datasetEdit.startEditing;
    editFilters.datasetEdit.startEditing = (id, dataset = shared_dashboard__WEBPACK_IMPORTED_MODULE_4__/* .datasetDefaults */ .Yh)=>{
        if (id === "search") {
            dataset = _object_spread_props(_object_spread({}, dataset), {
                category_ids: categories.map((el)=>el.id)
            });
        }
        originalSetDataset(id, dataset);
    };
    const originalSetPolicy = editFilters.policyEdit.startEditingPolicy;
    editFilters.policyEdit.startEditingPolicy = (id, category = shared_dashboard__WEBPACK_IMPORTED_MODULE_4__/* .policyDefaults */ .go)=>{
        if (id === "search") {
            category = _object_spread_props(_object_spread({}, category), {
                dataset_ids: datasets.map((el)=>el.id),
                dataset_sensitivities: category.dataset_sensitivities || []
            });
        }
        originalSetPolicy(id, category);
    };
    if (editFilters.policyEdit.isEditing) {
        selectedCategories = [
            modules_risks_shared__WEBPACK_IMPORTED_MODULE_12__/* .AllCategories */ .SZ
        ];
    }
    if (editFilters.datasetEdit.isEditing) {
        selectedDatasets = [
            modules_risks_shared__WEBPACK_IMPORTED_MODULE_12__/* .AllDatasets */ .qh
        ];
    }
    const selectedLocationsSetter = {
        "category": {
            selectedLocations: selectedLocationsDestinations,
            setSelectedLocations: setSelectedLocationsDestinations
        },
        "dataset": {
            selectedLocations: selectedLocationsSources,
            setSelectedLocations: setSelectedLocationsSources
        },
        "": {
            selectedLocations: selectedLocations,
            setSelectedLocations: setSelectedLocations
        }
    };
    const allSeverities = (0,_dashboard_core_severity__WEBPACK_IMPORTED_MODULE_17__/* .isAllSeveritiesSelected */ .HR)(selectedSeverities);
    const allSensitivities = (0,_dashboard_core_sensitivity__WEBPACK_IMPORTED_MODULE_18__/* .isAllSensitivitiesSelected */ .Wx)(selectedSensitivities);
    const nullSeverityAllowed = (0,_dashboard_core_severity__WEBPACK_IMPORTED_MODULE_17__/* .isNullSeverityAllowed */ .Dw)(selectedSeverities);
    const nullSensitivityAllowed = (0,_dashboard_core_sensitivity__WEBPACK_IMPORTED_MODULE_18__/* .isNullSensitivityAllowed */ .Au)(selectedSensitivities);
    const isAllPoliciesSelected = selectedCategories.length >= categories.length;
    const isAllPoliciesSelectedAndUncategorized = selectedCategories.length > categories.length;
    const resetSelectedSeverities = ()=>{
        props.resetSelectedSeverities();
        setSelectedCategories(selectedCategories.filter((id)=>id !== modules_risks_shared__WEBPACK_IMPORTED_MODULE_12__/* .uncategorizedCategory */ .wR));
    };
    var _selectedLocationsSetter_querySide;
    return _object_spread_props(_object_spread({}, props, editFilters, (_selectedLocationsSetter_querySide = selectedLocationsSetter[querySide]) !== null && _selectedLocationsSetter_querySide !== void 0 ? _selectedLocationsSetter_querySide : selectedLocationsSetter[""]), {
        getChipsFilterProps: ()=>{
            const _props_getChipsFilterProps = props.getChipsFilterProps(), { filters  } = _props_getChipsFilterProps, restParams = _object_without_properties(_props_getChipsFilterProps, [
                "filters"
            ]);
            return _object_spread({
                filters: _object_spread_props(_object_spread({}, filters), {
                    selectedSeverities: _object_spread_props(_object_spread({}, filters.selectedSeverities), {
                        reset: resetSelectedSeverities
                    })
                })
            }, restParams);
        },
        mode,
        querySide,
        setQuerySide,
        resetSelectedSeverities,
        // idenitify which categories are selected right now
        categorySelectedType: (_find = [
            ...categoryByStatus
        ].find(([, value])=>(0,lodash__WEBPACK_IMPORTED_MODULE_22__/* ["default"] */ .Z)(value, selectedCategories))) === null || _find === void 0 ? void 0 : _find[0],
        setSplitDateBy: (v)=>{
            if (v !== splitDateBy) {
                setSelectedDates([]);
                setSplitDateBy(v);
            }
        },
        setSelectedUsers (users) {
            return props.setSelectedUsers(users);
        },
        globalFilter,
        dateFilters: timeFilter,
        setDateFilters: setTimeFilter,
        startDate,
        endDate,
        setPreviewType,
        expandedLocations,
        setExpandedLocations,
        rangeType,
        splitDateBy,
        selectedDates: convertedSelectedDates,
        setSelectedDates,
        selectedCategory: (selectedCategories === null || selectedCategories === void 0 ? void 0 : selectedCategories[0]) || modules_risks_shared__WEBPACK_IMPORTED_MODULE_12__/* .AllCategories */ .SZ,
        setSelectedCategory: (v)=>setSelectedCategories([
                v
            ]),
        selectedCategories: selectedCategories,
        setSelectedCategories,
        selectedDatasets,
        allDatasets: selectedDatasets === null || selectedDatasets === void 0 ? void 0 : selectedDatasets.includes(modules_risks_shared__WEBPACK_IMPORTED_MODULE_12__/* .AllDatasets */ .qh),
        allCategories: isAllPoliciesSelected,
        allCategoriesAndUncategorized: isAllPoliciesSelectedAndUncategorized,
        allSeverities,
        allSeveritiesWithNull: allSeverities && nullSeverityAllowed,
        allSensitivitiesWithNull: allSensitivities && nullSensitivityAllowed,
        allSensitivities,
        setSelectedSeverities,
        selectAllSeverities: ()=>{
            setSelectedSeverities(_dashboard_core_severity__WEBPACK_IMPORTED_MODULE_17__/* .severityListWithNull.map */ .vz.map((v)=>v.severity));
        },
        selectAllSensitivities: ()=>{
            setSelectedSensitivities(_dashboard_core_sensitivity__WEBPACK_IMPORTED_MODULE_18__/* .sensitivityList.map */ .Zq.map((v)=>v.sensitivity));
        },
        selectedSensitivities,
        selectAllCategories: ()=>setSelectedCategories(defaultCategories.concat(modules_risks_shared__WEBPACK_IMPORTED_MODULE_12__/* .uncategorizedCategory */ .wR)),
        setSelectedSensitivities,
        isNullSeverityAllowed: (0,_dashboard_core_severity__WEBPACK_IMPORTED_MODULE_17__/* .isNullSeverityAllowed */ .Dw)(selectedSeverities),
        isNullSensitivityAllowed: (0,_dashboard_core_sensitivity__WEBPACK_IMPORTED_MODULE_18__/* .isNullSensitivityAllowed */ .Au)(selectedSensitivities),
        selectedDataset: (selectedDatasets === null || selectedDatasets === void 0 ? void 0 : selectedDatasets[0]) || modules_risks_shared__WEBPACK_IMPORTED_MODULE_12__/* .AllDatasets */ .qh,
        setSelectedDataset: (v)=>setSelectedDatasets([
                v
            ]),
        setSelectedDatasets,
        selectedSeverities,
        apiQuery: (0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(()=>{
            return (0,_utils__WEBPACK_IMPORTED_MODULE_15__/* .toQuery */ .L7)({
                selectedDates: convertedSelectedDates,
                timeFilter,
                globalFilter,
                selectedCategories,
                selectedDatasets,
                selectedUsers: props.selectedUsers,
                selectedLocations: selectedLocations,
                selectedLocationsDestinations,
                selectedLocationsSources,
                selectedSeverities,
                selectedSensitivities,
                isAllSeveritiesSelected: allSeverities,
                isAllPoliciesSelected,
                selectedDateRangeType: rangeType,
                previewDataset: editFilters.datasetEdit.editingValues,
                previewCategory: editFilters.policyEdit.editingPolicyValues,
                isBothSearch: editFilters.policyEdit.isSearch && editFilters.datasetEdit.isSearch,
                isAppliedToCategoriesAreHidden: editFilters.policyEdit.isSearch && editFilters.datasetEdit.isEditing
            });
        }, [
            mode,
            rangeType,
            convertedSelectedDates,
            timeFilter,
            selectedCategories,
            selectedDatasets,
            props.selectedUsers,
            selectedLocations,
            editFilters.datasetEdit.editingValues,
            editFilters.policyEdit.editingPolicyValues,
            querySide
        ])
    });
}
const [FiltersProvider, useFilters] = (0,constate__WEBPACK_IMPORTED_MODULE_23__/* ["default"] */ .Z)(useFiltersInternal);


/***/ }),

/***/ 8764:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "IT": () => (/* binding */ catergoriesFilterToPolicyFilterV2),
/* harmony export */   "L7": () => (/* binding */ toQuery),
/* harmony export */   "WF": () => (/* binding */ isPolicyScreenshotsDisabled),
/* harmony export */   "WO": () => (/* binding */ ensurePolicyDatasertsOrder),
/* harmony export */   "Xg": () => (/* binding */ getFlagsForCategory),
/* harmony export */   "bA": () => (/* binding */ selectedSeveritiesToFilter),
/* harmony export */   "bY": () => (/* binding */ selectedSensitivitiesToFilter),
/* harmony export */   "bc": () => (/* binding */ previewPolicyToPreviewPolicyV2),
/* harmony export */   "bi": () => (/* binding */ datasetsFilterToDatasetFilterV2),
/* harmony export */   "ul": () => (/* binding */ processPreviewPolicy),
/* harmony export */   "w5": () => (/* binding */ previewDatasetToPreviewDatasetV2)
/* harmony export */ });
/* unused harmony exports categoryToId, isAlertEnabled */
/* harmony import */ var runenv__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(76223);
/* harmony import */ var api_gen__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(33013);
/* harmony import */ var modules_risks_shared__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(18889);
/* harmony import */ var _dashboard_core_severity__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(68905);
/* harmony import */ var _dashboard_core_sensitivity__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(53010);
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}





function omitEmptyArray(items) {
    const noItems = (items === null || items === void 0 ? void 0 : items.length) === 0;
    return noItems ? null : items;
}
function createDatasetFilter(items, previewDataset, hideAppliedTo) {
    const all = items === null || items === void 0 ? void 0 : items.includes(modules_risks_shared__WEBPACK_IMPORTED_MODULE_2__/* .AllDatasets */ .qh);
    const res = {
        all_datasets: all,
        datasets: all ? null : omitEmptyArray(items)
    };
    if (previewDataset) {
        return _object_spread_props(_object_spread({}, res), {
            all_datasets: false,
            preview_dataset: _object_spread_props(_object_spread({}, previewDataset), {
                category_ids: hideAppliedTo ? [] : previewDataset.category_ids
            })
        });
    }
    return res;
}
function createCategoriesFilter(items, previewCategory, hideAppliedTo, addUncategorized = false) {
    const all = items === null || items === void 0 ? void 0 : items.includes(modules_risks_shared__WEBPACK_IMPORTED_MODULE_2__/* .AllCategories */ .SZ);
    const itemsCopy = [
        ...items
    ];
    if (addUncategorized && !itemsCopy.includes("Uncategorized")) {
        itemsCopy.push("Uncategorized");
    }
    const res = {
        all_categories: all,
        categories: all ? null : omitEmptyArray(itemsCopy)
    };
    if (previewCategory) {
        return _object_spread_props(_object_spread({}, res), {
            all_categories: false,
            preview_category: {
                category: _object_spread_props(_object_spread({}, previewCategory), {
                    dataset_ids: hideAppliedTo ? undefined : previewCategory.dataset_ids
                })
            }
        });
    }
    return res;
}
function createQuerySideLocation(locations, side_selector) {
    const locationsArray = Array.from(locations);
    if (locationsArray.length === 0) {
        return null;
    }
    return {
        side_selector: side_selector,
        location_filters: omitEmptyArray(locationsArray.map((el)=>({
                location_path: el.expand_path
            })))
    };
}
function toQuery({ globalFilter , timeFilter , selectedUsers , selectedLocations , selectedCategories , selectedDates , selectedDatasets , selectedDateRangeType , previewDataset , previewCategory , isBothSearch , isAppliedToCategoriesAreHidden , selectedLocationsDestinations , selectedLocationsSources , selectedSeverities , selectedSensitivities , statuses , allSeveritiesWithNull , isAllPoliciesSelected , isAllSeveritiesSelected  }) {
    var _categories_filter_categories;
    const users = Array.from(selectedUsers.values());
    const locations = Array.from(selectedLocations.values());
    const datasets_filter = createDatasetFilter(selectedDatasets, previewDataset, isBothSearch);
    const categories_filter = createCategoriesFilter(selectedCategories, previewCategory, isBothSearch || isAppliedToCategoriesAreHidden, allSeveritiesWithNull && isAllPoliciesSelected);
    let severitiesFilter = selectedSeverities;
    if (((_categories_filter_categories = categories_filter.categories) === null || _categories_filter_categories === void 0 ? void 0 : _categories_filter_categories.includes("Uncategorized")) && isAllSeveritiesSelected) {
        severitiesFilter = null;
    }
    return {
        categories_filter,
        datasets_filter,
        locations_filters: [
            createQuerySideLocation(locations, api_gen__WEBPACK_IMPORTED_MODULE_1__/* .SideSelectorEnum.SideSelectorBoth */ .gA.SideSelectorBoth),
            createQuerySideLocation(selectedLocationsSources, api_gen__WEBPACK_IMPORTED_MODULE_1__/* .SideSelectorEnum.SideSelectorDataset */ .gA.SideSelectorDataset),
            createQuerySideLocation(selectedLocationsDestinations, api_gen__WEBPACK_IMPORTED_MODULE_1__/* .SideSelectorEnum.SideSelectorCategory */ .gA.SideSelectorCategory)
        ].filter(Boolean),
        users_filter: {
            users: users.map((u)=>u.user)
        },
        times_filter: _object_spread_props(_object_spread({}, timeFilter), {
            segments: omitEmptyArray(selectedDates.map(mapSegments(selectedDateRangeType)))
        }),
        statuses,
        selected_severities: severitiesFilter,
        global_filter: globalFilter,
        selected_sensitivities: selectedSensitivities
    };
}
function mapSegments(selectedDateRangeType) {
    return (el)=>({
            start_time: el.toISOString(),
            end_time: new Date(selectedDateRangeType.interval.offset(el, 1).getTime() - 1).toISOString()
        });
}
function categoryToId(d) {
    return d.id + d.status;
}
const isAlertEnabled = (rule)=>{
    return !!(rule === null || rule === void 0 ? void 0 : rule.create_incident);
};
const checkCategoryField = (category, datasetId, checkFn)=>{
    if (datasetId !== modules_risks_shared__WEBPACK_IMPORTED_MODULE_2__/* .AllDatasets */ .qh && category.id) {
        var _category_dataset_ids;
        return (category === null || category === void 0 ? void 0 : (_category_dataset_ids = category.dataset_ids) === null || _category_dataset_ids === void 0 ? void 0 : _category_dataset_ids.includes(datasetId)) && checkFn(category.rule);
    } else {
        return checkFn(category.rule);
    }
};
function getFlagsForCategory(category, dataset) {
    return {
        notify_email: checkCategoryField(category, dataset, (rule)=>{
            return isAlertEnabled(rule) && !!(rule === null || rule === void 0 ? void 0 : rule.notify_enabled);
        }),
        create_incident: checkCategoryField(category, dataset, isAlertEnabled),
        response_enabled: checkCategoryField(category, dataset, (rule)=>{
            return isAlertEnabled(rule) && !!(rule === null || rule === void 0 ? void 0 : rule.incident_action);
        })
    };
}
const ensurePolicyDatasertsOrder = (policy)=>{
    return _object_spread_props(_object_spread({}, policy), {
        dataset_ids: (policy === null || policy === void 0 ? void 0 : policy.dataset_ids) ? [
            ...policy.dataset_ids
        ].sort() : []
    });
};
const datasetsFilterToDatasetFilterV2 = (filters)=>{
    var _filters_datasets;
    if (!filters) {
        return null;
    }
    if (!((_filters_datasets = filters.datasets) === null || _filters_datasets === void 0 ? void 0 : _filters_datasets.length)) {
        return null;
    }
    return {
        all_datasets: filters.all_datasets,
        dataset_ids: filters.datasets
    };
};
const catergoriesFilterToPolicyFilterV2 = (filters)=>{
    var _filters_categories;
    if (!filters) {
        return null;
    }
    if (!((_filters_categories = filters.categories) === null || _filters_categories === void 0 ? void 0 : _filters_categories.length)) {
        return null;
    }
    return {
        all_policies: filters.all_categories,
        policy_ids: filters.categories
    };
};
const selectedSeveritiesToFilter = (severities, uncategorizedSelected = false)=>{
    if (!severities) {
        return null;
    }
    return {
        category_severities: severities.filter((s)=>s != _dashboard_core_severity__WEBPACK_IMPORTED_MODULE_3__/* .NULL_SEVERITY */ .xL),
        allow_null_severity: (0,_dashboard_core_severity__WEBPACK_IMPORTED_MODULE_3__/* .isNullSeverityAllowed */ .Dw)(severities) || uncategorizedSelected
    };
};
const selectedSensitivitiesToFilter = ({ sensitivities , isUncategorizedIncluded  })=>{
    if (!sensitivities) {
        return null;
    }
    const isAllSelected = (0,_dashboard_core_sensitivity__WEBPACK_IMPORTED_MODULE_4__/* .isAllSensitivitiesSelected */ .Wx)(sensitivities);
    if (isAllSelected && isUncategorizedIncluded) {
        return null;
    }
    return {
        dataset_sensitivities: sensitivities.filter((s)=>s != _dashboard_core_sensitivity__WEBPACK_IMPORTED_MODULE_4__/* .NULL_SENSITIVITY */ .cE),
        allow_null_sensivitity: (0,_dashboard_core_sensitivity__WEBPACK_IMPORTED_MODULE_4__/* .isNullSensitivityAllowed */ .Au)(sensitivities) || !!isUncategorizedIncluded
    };
};
const previewPolicyToPreviewPolicyV2 = (policy, datasetIds = [])=>{
    if (!policy) {
        return null;
    }
    return {
        policy: processPreviewPolicy(policy.category, datasetIds)
    };
};
const processPreviewPolicy = (policy, datasetIds)=>{
    var _policyData_dataset_sensitivities, _policyData_dataset_ids;
    const policyData = _object_spread({}, policy);
    if (policyData.selection_type === api_gen__WEBPACK_IMPORTED_MODULE_1__/* .SelectionTypeEnum.SelectionTypeSensitivity */ .XL.SelectionTypeSensitivity && !((_policyData_dataset_sensitivities = policyData.dataset_sensitivities) === null || _policyData_dataset_sensitivities === void 0 ? void 0 : _policyData_dataset_sensitivities.length)) {
        policyData.dataset_sensitivities = _dashboard_core_sensitivity__WEBPACK_IMPORTED_MODULE_4__/* .sensitivityList.map */ .Zq.map((s)=>s.sensitivity);
    }
    if (policyData.selection_type === api_gen__WEBPACK_IMPORTED_MODULE_1__/* .SelectionTypeEnum.SelectionTypeDataset */ .XL.SelectionTypeDataset && !((_policyData_dataset_ids = policyData.dataset_ids) === null || _policyData_dataset_ids === void 0 ? void 0 : _policyData_dataset_ids.length)) {
        policyData.dataset_ids = datasetIds;
    }
    return policyData;
};
const previewDatasetToPreviewDatasetV2 = (dataset)=>{
    if (!dataset) {
        return null;
    }
    return {
        dataset,
        applied_policies: []
    };
};
function isPolicyScreenshotsDisabled(policy) {
    var _policy_rule, _policy_rule1;
    return !runenv__WEBPACK_IMPORTED_MODULE_0__/* .ENV.FEATURES.ENABLE_SCREENSHOTS */ .V.FEATURES.ENABLE_SCREENSHOTS || !(policy === null || policy === void 0 ? void 0 : (_policy_rule = policy.rule) === null || _policy_rule === void 0 ? void 0 : _policy_rule.create_incident) || (policy === null || policy === void 0 ? void 0 : (_policy_rule1 = policy.rule) === null || _policy_rule1 === void 0 ? void 0 : _policy_rule1.incident_action) === api_gen__WEBPACK_IMPORTED_MODULE_1__/* .IncidentActionEnum.IncidentActionNone */ .LE.IncidentActionNone && !runenv__WEBPACK_IMPORTED_MODULE_0__/* .ENV.FEATURES.ENABLE_SILENT_SCREENSHOTS */ .V.FEATURES.ENABLE_SILENT_SCREENSHOTS;
}


/***/ }),

/***/ 21408:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$": () => (/* binding */ riskColors)
/* harmony export */ });
const riskColors = {
    high: "#B73434",
    low: "#F9A933",
    approved: "#82C363",
    uncategorized: "#CACACA"
};


/***/ }),

/***/ 24559:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "D8": () => (/* binding */ getCountDetails),
/* harmony export */   "EZ": () => (/* binding */ getNodeConnections),
/* harmony export */   "Go": () => (/* binding */ getRanges),
/* harmony export */   "Js": () => (/* binding */ getPoliciesColumnList),
/* harmony export */   "Jx": () => (/* binding */ getDatasetsColumnList),
/* harmony export */   "ME": () => (/* binding */ getConnectionsFromDatasets),
/* harmony export */   "RV": () => (/* binding */ getArrowColors),
/* harmony export */   "Y2": () => (/* binding */ getPolicyRisk),
/* harmony export */   "_i": () => (/* binding */ getExtremeCountsFromConnections),
/* harmony export */   "a3": () => (/* binding */ getTimeDifferenceInDays),
/* harmony export */   "tt": () => (/* binding */ getPolicyIcon),
/* harmony export */   "u_": () => (/* binding */ getConnectionsWithRisk),
/* harmony export */   "wo": () => (/* binding */ getArrowSize)
/* harmony export */ });
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(67326);
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(27812);
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(15937);
/* harmony import */ var date_fns_differenceInCalendarDays__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(92300);
/* harmony import */ var assets_icons_internal__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(13554);
/* harmony import */ var ui_theme__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(73728);
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(21408);





function getRanges(start, end) {
    const res = (0,date_fns_differenceInCalendarDays__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(end, start);
    const types = [];
    if (res <= 1) {
        types.push("hourly");
    }
    if (res > 1 && res < 90) {
        types.push("daily");
    }
    if (res > 13) {
        types.push("weekly");
    }
    if (res > 60) {
        types.push("monthly");
    }
    return types;
}
const statusToRiskMap = {
    risky: "high",
    low_risky: "low",
    approved: "approved",
    any: "uncategorized"
};
function getDatasetsColumnList(datasets, isLoadingCounts) {
    return datasets.map(({ id , name , status_to_count , connections  })=>{
        if (isLoadingCounts) {
            return {
                id: id,
                name
            };
        }
        const { totalCount , countDetails  } = getCountDetails(status_to_count);
        return {
            id: id,
            name,
            totalCount,
            countDetails,
            connections: getConnectionsWithRisk(connections)
        };
    });
}
function getPoliciesColumnList(categories, isLoadingCounts) {
    return categories.map(({ id , name , count , rule  })=>{
        if (isLoadingCounts) {
            return {
                id: id,
                name
            };
        }
        const { risk , incidentAction  } = getPolicyRisk(rule);
        return {
            id: id,
            name,
            totalCount: count,
            risk,
            incidentAction
        };
    });
}
function getPolicyRisk(rule) {
    const incidentAction = rule.create_incident ? rule.incident_action || "none" : null;
    return {
        incidentAction,
        risk: statusToRiskMap[rule.status]
    };
}
function getPolicyIcon(incidentAction) {
    switch(incidentAction){
        case "block":
            return assets_icons_internal__WEBPACK_IMPORTED_MODULE_0__/* .Block */ .gO;
        case "warn":
            return assets_icons_internal__WEBPACK_IMPORTED_MODULE_0__/* .WarningAlt */ .lw;
    }
    return undefined;
}
function getConnectionsFromDatasets(datasetsList) {
    const extremeCounts = getExtremeCountsFromConnections(datasetsList);
    return datasetsList.filter((dataset)=>dataset.connections && dataset.countDetails).map((dataset)=>getNodeConnections(dataset.id, dataset.connections, dataset.countDetails, extremeCounts));
}
// Find min and max counts from all connections
function getExtremeCountsFromConnections(datasetsList) {
    let min = 0;
    let max = 0;
    datasetsList.filter((dataset)=>dataset.connections).forEach((dataset)=>{
        Object.values(dataset.connections).forEach(({ count  })=>{
            if (count < min || !min) {
                min = count;
            }
            if (count > max || !max) {
                max = count;
            }
        });
    });
    return {
        min,
        max
    };
}
const risks = [
    "high",
    "low",
    "approved"
];
function getNodeConnections(id, connections, countDetails, extremeCounts) {
    const connectedIds = (0,lodash__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(Object.keys(connections), (id)=>connections[id].count);
    const highestRisk = (0,lodash__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(risks, (risk)=>countDetails[risk]);
    const metadata = {
        highestRisk,
        connections,
        extremeCounts
    };
    return {
        id,
        connectedIds,
        metadata
    };
}
function getArrowColors(source, target, isLoading) {
    if (isLoading) {
        return {
            sourceColor: ui_theme__WEBPACK_IMPORTED_MODULE_1__/* .theme.palette.grey[400] */ .rS.palette.grey[400],
            targetColor: ui_theme__WEBPACK_IMPORTED_MODULE_1__/* .theme.palette.grey[400] */ .rS.palette.grey[400],
            curveColor: ui_theme__WEBPACK_IMPORTED_MODULE_1__/* .theme.palette.grey[400] */ .rS.palette.grey[400]
        };
    }
    if (source.column === "datasets" && target.column === "policies") {
        return {
            sourceColor: _constants__WEBPACK_IMPORTED_MODULE_2__/* .riskColors */ .$[source.metadata.highestRisk],
            targetColor: _constants__WEBPACK_IMPORTED_MODULE_2__/* .riskColors */ .$[source.metadata.connections[target.id].risk],
            curveColor: _constants__WEBPACK_IMPORTED_MODULE_2__/* .riskColors */ .$[source.metadata.connections[target.id].risk]
        };
    }
    return {
        sourceColor: "transparent",
        targetColor: "transparent",
        curveColor: "transparent"
    };
}
const defaultArrowSize = 4;
function getArrowSize(source, target, isLoading) {
    if (isLoading) {
        return defaultArrowSize;
    }
    if (source.column === "datasets") {
        const { min , max  } = source.metadata.extremeCounts;
        const peak = min + max;
        const connectionCount = source.metadata.connections[target.id].count;
        // Map fraction to value between 4 and 14
        const value = Math.floor(connectionCount / peak * 10) + defaultArrowSize;
        // Resulting width will be value between 2 and 7 with 0.5px step
        return value * 0.5;
    }
    return defaultArrowSize;
}
function getCountDetails(statusToCount) {
    const { risky =0 , low_risky =0 , approved =0 , needs_review =0  } = statusToCount !== null && statusToCount !== void 0 ? statusToCount : {};
    return {
        totalCount: risky + low_risky + approved + needs_review,
        countDetails: {
            high: risky,
            low: low_risky,
            approved: approved,
            uncategorized: needs_review
        }
    };
}
function getConnectionsWithRisk(connections) {
    return connections ? (0,lodash__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(Object.entries(connections).map(([connectionId, { status , count  }])=>[
            connectionId,
            {
                risk: statusToRiskMap[status],
                count
            }
        ])) : null;
}
function getTimeDifferenceInDays(startDate, endDate) {
    return Math.ceil((endDate.getTime() - startDate.getTime()) / 1000 / 60 / 60 / 24);
}


/***/ }),

/***/ 88357:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "gt": () => (/* binding */ sizeEnumOrdered),
/* harmony export */   "oV": () => (/* binding */ rulesSchema)
/* harmony export */ });
/* unused harmony export toNumber */
/* harmony import */ var zod__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(1604);
/* harmony import */ var api_gen__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(33013);


const sizeEnumOrdered = [
    api_gen__WEBPACK_IMPORTED_MODULE_0__/* .SizeUnitEnum.SizeUnitByte */ .Uk.SizeUnitByte,
    api_gen__WEBPACK_IMPORTED_MODULE_0__/* .SizeUnitEnum.SizeUnitKilobyte */ .Uk.SizeUnitKilobyte,
    api_gen__WEBPACK_IMPORTED_MODULE_0__/* .SizeUnitEnum.SizeUnitMegabyte */ .Uk.SizeUnitMegabyte,
    api_gen__WEBPACK_IMPORTED_MODULE_0__/* .SizeUnitEnum.SizeUnitGigabyte */ .Uk.SizeUnitGigabyte,
    api_gen__WEBPACK_IMPORTED_MODULE_0__/* .SizeUnitEnum.SizeUnitTerabyte */ .Uk.SizeUnitTerabyte
];
const SizeByte = 1;
const SizeKB = 1024;
const SizeMB = SizeKB * SizeKB;
const SizeGB = SizeKB * SizeMB;
const SizeTB = SizeKB * SizeGB;
const sizeEnumValues = [
    SizeByte,
    SizeKB,
    SizeMB,
    SizeGB,
    SizeTB
];
function toNumber(unit, suffix) {
    const index = sizeEnumOrdered.indexOf(suffix);
    return unit * sizeEnumValues[index === -1 ? 0 : index];
}
function validateRange(first, second) {
    if (!(first === null || first === void 0 ? void 0 : first.value) && !(second === null || second === void 0 ? void 0 : second.value)) {
        return "Either lower or upper bound should be specified";
    }
    const firstValue = toNumber(parseInt(first === null || first === void 0 ? void 0 : first.value) || 0, first === null || first === void 0 ? void 0 : first.unit);
    const secondValue = toNumber(parseInt(second === null || second === void 0 ? void 0 : second.value) || Infinity, second === null || second === void 0 ? void 0 : second.unit);
    const res = secondValue - firstValue;
    if (res < 0) {
        return `"From" should me smaller`;
    }
    return;
}
const standardObject = zod__WEBPACK_IMPORTED_MODULE_1__.z.object({
    field_name: zod__WEBPACK_IMPORTED_MODULE_1__.z.nativeEnum(api_gen__WEBPACK_IMPORTED_MODULE_0__/* .SearchFieldEnum */ .Cm),
    operator: zod__WEBPACK_IMPORTED_MODULE_1__.z.nativeEnum(api_gen__WEBPACK_IMPORTED_MODULE_0__/* .OperatorEnum */ .lf),
    negated: zod__WEBPACK_IMPORTED_MODULE_1__.z.boolean().default(false),
    selector: zod__WEBPACK_IMPORTED_MODULE_1__.z.nativeEnum(api_gen__WEBPACK_IMPORTED_MODULE_0__/* .SelectorEnum */ .qP),
    values: zod__WEBPACK_IMPORTED_MODULE_1__.z.array(zod__WEBPACK_IMPORTED_MODULE_1__.z.object({
        value: zod__WEBPACK_IMPORTED_MODULE_1__.z.string(),
        min_count: zod__WEBPACK_IMPORTED_MODULE_1__.z.number().transform((v)=>parseInt(v, 10)).optional(),
        unit: zod__WEBPACK_IMPORTED_MODULE_1__.z.string().optional()
    })).default([]),
    case_sensitive: zod__WEBPACK_IMPORTED_MODULE_1__.z.boolean().default(false)
}).superRefine((v, ctx)=>{
    if (v.operator === api_gen__WEBPACK_IMPORTED_MODULE_0__/* .OperatorEnum.OperatorIsBetween */ .lf.OperatorIsBetween) {
        const error = validateRange(v.values[0], v.values[1]);
        if (error) {
            ctx.addIssue({
                code: "custom",
                path: [
                    "values"
                ],
                message: error
            });
        }
    }
    if (v.operator === api_gen__WEBPACK_IMPORTED_MODULE_0__/* .OperatorEnum.OperatorIsGreaterThan */ .lf.OperatorIsGreaterThan || v.operator === api_gen__WEBPACK_IMPORTED_MODULE_0__/* .OperatorEnum.OperatorIsLessThan */ .lf.OperatorIsLessThan || v.operator === api_gen__WEBPACK_IMPORTED_MODULE_0__/* .OperatorEnum.OperatorIsEqualTo */ .lf.OperatorIsEqualTo) {
        var _v_values_;
        if (!((_v_values_ = v.values[0]) === null || _v_values_ === void 0 ? void 0 : _v_values_.value)) {
            ctx.addIssue({
                code: "custom",
                path: [
                    "values"
                ],
                message: `Value is required`
            });
        }
    }
});
const rulesSchema = zod__WEBPACK_IMPORTED_MODULE_1__.z.array(zod__WEBPACK_IMPORTED_MODULE_1__.z.object({
    conditions: zod__WEBPACK_IMPORTED_MODULE_1__.z.array(standardObject).default([])
})).default([]).nullish();


/***/ }),

/***/ 22530:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "A": () => (/* binding */ ActionIcon),
/* harmony export */   "Hd": () => (/* binding */ CategoryStatusText),
/* harmony export */   "Jg": () => (/* binding */ ResolutionStatusActionType),
/* harmony export */   "Mx": () => (/* binding */ SensorName),
/* harmony export */   "Us": () => (/* binding */ ActionType),
/* harmony export */   "dE": () => (/* binding */ SensorType),
/* harmony export */   "uj": () => (/* binding */ sensorTypeToLabel)
/* harmony export */ });
/* unused harmony exports IncidentStatusText, SensorTypesList */
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var assets_icons__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(99899);
/* harmony import */ var api_gen__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(33013);



const IncidentStatusText = {
    [api_gen__WEBPACK_IMPORTED_MODULE_2__/* .ResolutionStatusEnum.Ignored */ .rL.Ignored]: "Ignored",
    [api_gen__WEBPACK_IMPORTED_MODULE_2__/* .ResolutionStatusEnum.InProgress */ .rL.InProgress]: "Assigned",
    [api_gen__WEBPACK_IMPORTED_MODULE_2__/* .ResolutionStatusEnum.Resolved */ .rL.Resolved]: "Resolved",
    [api_gen__WEBPACK_IMPORTED_MODULE_2__/* .ResolutionStatusEnum.Unresolved */ .rL.Unresolved]: "Unresolved"
};
const ActionType = {
    NEW_INCIDENT: "NEW_INCIDENT",
    ASSIGNED: "ASSIGNED",
    RE_ASSIGNED: "RE_ASSIGNED",
    RESOLVED: "RESOLVED",
    IGNORED: "IGNORED",
    RE_OPENED: "RE_OPENED",
    EXPLANATION: "EXPLANATION",
    COMMENT: "COMMENT",
    COMMENT_DELETED: "COMMENT_DELETED",
    UNBLOCKED: "UNBLOCKED",
    POLICY_EDIT: "POLICY_EDIT",
    SOURCE_EDIT: "SOURCE_EDIT"
};
const ActionIcon = {
    [ActionType.NEW_INCIDENT]: /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(assets_icons__WEBPACK_IMPORTED_MODULE_1__/* .IncidentNewIcon */ .V$, null),
    [ActionType.UNBLOCKED]: /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(assets_icons__WEBPACK_IMPORTED_MODULE_1__/* .IncidentUserIcon */ .Mj, null),
    [ActionType.ASSIGNED]: /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(assets_icons__WEBPACK_IMPORTED_MODULE_1__/* .IncidentAssignIcon */ .GA, null),
    [ActionType.RE_ASSIGNED]: /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(assets_icons__WEBPACK_IMPORTED_MODULE_1__/* .IncidentAssignIcon */ .GA, null),
    [ActionType.RESOLVED]: /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(assets_icons__WEBPACK_IMPORTED_MODULE_1__/* .IncidentResolvedIcon */ .s_, null),
    [ActionType.IGNORED]: /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(assets_icons__WEBPACK_IMPORTED_MODULE_1__/* .IncidentIgnoredIcon */ .vX, null),
    [ActionType.RE_OPENED]: /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(assets_icons__WEBPACK_IMPORTED_MODULE_1__/* .IncidentMessageIcon */ .J5, null),
    [ActionType.EXPLANATION]: /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(assets_icons__WEBPACK_IMPORTED_MODULE_1__/* .IncidentMessageIcon */ .J5, null),
    [ActionType.COMMENT]: /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(assets_icons__WEBPACK_IMPORTED_MODULE_1__/* .IncidentMessageIcon */ .J5, null),
    [ActionType.COMMENT_DELETED]: /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(assets_icons__WEBPACK_IMPORTED_MODULE_1__/* .IncidentCommentDeletedIcon */ .ef, null),
    [ActionType.POLICY_EDIT]: /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(assets_icons__WEBPACK_IMPORTED_MODULE_1__/* .IncidentEditIcon */ .Ip, null),
    [ActionType.SOURCE_EDIT]: /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(assets_icons__WEBPACK_IMPORTED_MODULE_1__/* .IncidentEditIcon */ .Ip, null)
};
const ResolutionStatusActionType = {
    [api_gen__WEBPACK_IMPORTED_MODULE_2__/* .ResolutionStatusEnum.Ignored */ .rL.Ignored]: ActionType.IGNORED,
    [api_gen__WEBPACK_IMPORTED_MODULE_2__/* .ResolutionStatusEnum.InProgress */ .rL.InProgress]: ActionType.ASSIGNED,
    [api_gen__WEBPACK_IMPORTED_MODULE_2__/* .ResolutionStatusEnum.Resolved */ .rL.Resolved]: ActionType.RESOLVED,
    [api_gen__WEBPACK_IMPORTED_MODULE_2__/* .ResolutionStatusEnum.Unresolved */ .rL.Unresolved]: ActionType.RE_OPENED
};
const CategoryStatusText = {
    [api_gen__WEBPACK_IMPORTED_MODULE_2__/* .CategoryStatusEnum.CategoryStatusRisky */ .HL.CategoryStatusRisky]: "High",
    [api_gen__WEBPACK_IMPORTED_MODULE_2__/* .CategoryStatusEnum.CategoryStatusLowRisky */ .HL.CategoryStatusLowRisky]: "Low",
    [api_gen__WEBPACK_IMPORTED_MODULE_2__/* .CategoryStatusEnum.CategoryStatusApproved */ .HL.CategoryStatusApproved]: "Approved",
    [api_gen__WEBPACK_IMPORTED_MODULE_2__/* .CategoryStatusEnum.CategoryStatusNeedsReview */ .HL.CategoryStatusNeedsReview]: "Unmatched"
};
var SensorType;
(function(SensorType) {
    SensorType["Endpoint"] = "Endpoint";
    SensorType["Cloud"] = "Cloud";
    SensorType["BrowserExtension"] = "BrowserExtension";
})(SensorType || (SensorType = {}));
const sensorTypeToLabel = {
    [SensorType.Endpoint]: "Endpoint Sensor",
    [SensorType.Cloud]: "Cloud Sensor",
    [SensorType.BrowserExtension]: "Browser Extension"
};
const SensorTypesList = Object.values(SensorType);
var SensorName;
(function(SensorName) {
    SensorName["SensorNameEndpointApplication"] = "EndpointSensorApplication";
    SensorName["SensorNameEndpointFinder"] = "EndpointSensorFinder";
    SensorName["SensorNameEndpointExplorer"] = "EndpointSensorExplorer";
    SensorName["SensorNameEndpointOneDrive"] = "EndpointSensorOneDrive";
    SensorName["SensorNameEndpointOutlook"] = "EndpointSensorOutlook";
    SensorName["SensorNameEndpointBrowser"] = "EndpointSensorBrowser";
    SensorName["SensorNameEndpointOfficeDocTracker"] = "EndpointSensorOfficeDocTracker";
    SensorName["SensorNameEndpointClipboard"] = "EndpointSensorClipboard";
    SensorName["SensorNameEndpointMicrosoftWord"] = "EndpointSensorMicrosoftWord";
    SensorName["SensorNameEndpointMicrosoftExcel"] = "EndpointSensorMicrosoftExcel";
    SensorName["SensorNameEndpointMicrosoftPowerPoint"] = "EndpointSensorMicrosoftPowerPoint";
    SensorName["SensorNameCloudOneDrive"] = "CloudSensorOneDrive";
    SensorName["SensorNameCloudEmailOffice365"] = "CloudSensorEmailOffice365";
    SensorName["SensorNameCloudEmailGoogle"] = "CloudSensorEmailGoogle";
    SensorName["SensorNameCloudSalesforce"] = "CloudSensorSalesforce";
    SensorName["SensorNameBrowserExtension"] = "BrowserExtensionSensor";
    SensorName["SensorNameSlack"] = "EndpointSensorSlack";
})(SensorName || (SensorName = {}));


/***/ }),

/***/ 4990:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "AT": () => (/* binding */ widgetItemsCount),
/* harmony export */   "Au": () => (/* binding */ AllUsersLabel),
/* harmony export */   "Gg": () => (/* binding */ chartHeaderHeight),
/* harmony export */   "SZ": () => (/* binding */ AllCategories),
/* harmony export */   "Wq": () => (/* binding */ AllStatusesLabel),
/* harmony export */   "g5": () => (/* binding */ AllDatasetsLabel),
/* harmony export */   "mP": () => (/* binding */ isInternalId),
/* harmony export */   "mp": () => (/* binding */ AllCategoriesLabel),
/* harmony export */   "o_": () => (/* binding */ predefinedDatasetsTitle),
/* harmony export */   "qh": () => (/* binding */ AllDatasets),
/* harmony export */   "wR": () => (/* binding */ uncategorizedCategory)
/* harmony export */ });
/* unused harmony exports AllUserGroups, predefinedDatasets */
/* harmony import */ var shared_dashboard__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(38440);

const widgetItemsCount = 1000;
const AllDatasets = "risky_all_datasets_count";
const AllCategories = "all_categories";
const AllUserGroups = "all_user_groups";
const AllCategoriesLabel = "All policies";
const AllDatasetsLabel = "All datasets";
const AllUsersLabel = "All";
const AllStatusesLabel = "All";
const predefinedDatasetsTitle = {
    [AllDatasets]: "All datasets"
};
const chartHeaderHeight = 60;
const predefinedDatasets = {
    [AllDatasets]: {
        id: AllDatasets,
        name: predefinedDatasetsTitle[AllDatasets]
    }
};
const uncategorizedCategory = "Uncategorized";
/**
 * checks if id is some internal marker for states like edit or new
 * @param id - id candidate to check
 */ function isInternalId(id) {
    return id === shared_dashboard__WEBPACK_IMPORTED_MODULE_0__/* .createTypeEnum["new"] */ .Rm["new"] || id === shared_dashboard__WEBPACK_IMPORTED_MODULE_0__/* .createTypeEnum.search */ .Rm.search || id === uncategorizedCategory;
}


/***/ }),

/***/ 18889:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "SZ": () => (/* reexport */ dashboardConstants/* AllCategories */.SZ),
  "mp": () => (/* reexport */ dashboardConstants/* AllCategoriesLabel */.mp),
  "qh": () => (/* reexport */ dashboardConstants/* AllDatasets */.qh),
  "g5": () => (/* reexport */ dashboardConstants/* AllDatasetsLabel */.g5),
  "Gg": () => (/* reexport */ dashboardConstants/* chartHeaderHeight */.Gg),
  "st": () => (/* reexport */ checkDatasetContainsCategoryType),
  "Yh": () => (/* reexport */ datasetDefaults),
  "iE": () => (/* reexport */ datasetSchema),
  "T7": () => (/* reexport */ formatLocation),
  "xz": () => (/* reexport */ getCategoryStatusLabel),
  "ek": () => (/* reexport */ getColorForRisk),
  "Vl": () => (/* reexport */ getLocationItemId),
  "eh": () => (/* reexport */ getLocationsWidgetItemLabel),
  "I9": () => (/* reexport */ getSensorNames),
  "mP": () => (/* reexport */ dashboardConstants/* isInternalId */.mP),
  "PA": () => (/* reexport */ lighten40),
  "$s": () => (/* reexport */ theme/* localTheme */.$),
  "Kl": () => (/* reexport */ locations),
  "Dg": () => (/* reexport */ mapLocationsLabel),
  "nf": () => (/* reexport */ parseDataset),
  "AX": () => (/* reexport */ parsePolicy),
  "go": () => (/* reexport */ policyDefaults),
  "wP": () => (/* reexport */ policySchema),
  "o_": () => (/* reexport */ dashboardConstants/* predefinedDatasetsTitle */.o_),
  "zA": () => (/* reexport */ theme/* riskColorsMap */.z),
  "bx": () => (/* reexport */ saturation55),
  "wR": () => (/* reexport */ dashboardConstants/* uncategorizedCategory */.wR),
  "AT": () => (/* reexport */ dashboardConstants/* widgetItemsCount */.AT)
});

// UNUSED EXPORTS: AllStatusesLabel, AllUserGroups, AllUsersLabel, LOCATION_OPTIONS, addLightness, getLocationLabel, mediaCategories, predefinedDatasets, riskyColors, setDatasetDefaults, setSaturation, zones

// EXTERNAL MODULE: ./src/modules/risks/shared/theme.tsx
var theme = __webpack_require__(34437);
// EXTERNAL MODULE: ./src/modules/risks/shared/constants.tsx
var constants = __webpack_require__(22530);
;// CONCATENATED MODULE: ./src/modules/risks/shared/helpers.tsx


// this file should be moved to dataflow-core
const riskyColors = {
    low_risky: theme/* localTheme.yellow */.$.yellow,
    risky: theme/* localTheme.red */.$.red,
    risky_or_low: theme/* localTheme.red */.$.red,
    needs_review: theme/* localTheme.gray2 */.$.gray2,
    approved: theme/* localTheme.green */.$.green
};
function getColorForRisk(r) {
    var _riskyColors_r;
    return (_riskyColors_r = riskyColors[r]) !== null && _riskyColors_r !== void 0 ? _riskyColors_r : riskyColors.needs_review;
}
const getSensorNames = (sensorTypes)=>{
    return Object.values(constants/* SensorName */.Mx).filter((name)=>sensorTypes.some((sensorType)=>name.startsWith(sensorType)));
};

;// CONCATENATED MODULE: ./src/modules/dataflow-core/category-status.ts
function getCategoryStatusLabel(t) {
    return ({
        risky: "High",
        risky_or_low: "Risks",
        low_risky: "Low",
        approved: "Trusted",
        needs_review: "Uncategorized",
        any: "Any"
    })[t];
}

// EXTERNAL MODULE: ./src/modules/risks/shared/dashboardConstants.ts
var dashboardConstants = __webpack_require__(4990);
// EXTERNAL MODULE: ./node_modules/zod/lib/index.mjs
var lib = __webpack_require__(1604);
// EXTERNAL MODULE: ./src/shared/utils.ts
var utils = __webpack_require__(93681);
// EXTERNAL MODULE: ./src/shared/dashboard.ts
var dashboard = __webpack_require__(38440);
// EXTERNAL MODULE: ./src/api/gen.ts + 2 modules
var gen = __webpack_require__(33013);
// EXTERNAL MODULE: ./node_modules/final-form/dist/final-form.es.js
var final_form_es = __webpack_require__(95142);
// EXTERNAL MODULE: ./node_modules/lodash-es/set.js
var set = __webpack_require__(48707);
;// CONCATENATED MODULE: ./src/libs/forms/index.ts
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}


function schemaToFinalFormError(error) {
    const errors = error.errors;
    const res = {};
    for (const err of errors.reverse()){
        if (err.code === "custom" && err.params) {
            (0,set/* default */.Z)(res, err.path, _object_spread_props(_object_spread({}, err.params), {
                message: err.message
            }));
        } else {
            (0,set/* default */.Z)(res, err.path, err.message);
        }
    }
    return _object_spread_props(_object_spread({}, res), {
        [final_form_es/* FORM_ERROR */.Ck]: error.formErrors.formErrors[0]
    });
}

// EXTERNAL MODULE: ./src/modules/risks/dashboard-core/severity.tsx
var severity = __webpack_require__(68905);
// EXTERNAL MODULE: ./src/modules/risks/search/search.schema.ts
var search_schema = __webpack_require__(88357);
// EXTERNAL MODULE: ./src/runenv.tsx
var runenv = __webpack_require__(76223);
;// CONCATENATED MODULE: ./src/modules/risks/shared/fieldValidation.ts


const alwaysAllowedFields = [
    gen/* SearchFieldEnum.SearchFieldAppMainWindowTitle */.Cm.SearchFieldAppMainWindowTitle,
    gen/* SearchFieldEnum.SearchFieldBrowserPageTitle */.Cm.SearchFieldBrowserPageTitle,
    gen/* SearchFieldEnum.SearchFieldCloudApp */.Cm.SearchFieldCloudApp,
    gen/* SearchFieldEnum.SearchFieldCloudAppAccount */.Cm.SearchFieldCloudAppAccount,
    gen/* SearchFieldEnum.SearchFieldCloudProvider */.Cm.SearchFieldCloudProvider,
    gen/* SearchFieldEnum.SearchFieldContentAttributes */.Cm.SearchFieldContentAttributes,
    gen/* SearchFieldEnum.SearchFieldDataSize */.Cm.SearchFieldDataSize,
    gen/* SearchFieldEnum.SearchFieldDocumentTags */.Cm.SearchFieldDocumentTags,
    gen/* SearchFieldEnum.SearchFieldDomain */.Cm.SearchFieldDomain,
    gen/* SearchFieldEnum.SearchFieldEmailAddress */.Cm.SearchFieldEmailAddress,
    gen/* SearchFieldEnum.SearchFieldEmailSubject */.Cm.SearchFieldEmailSubject,
    gen/* SearchFieldEnum.SearchFieldEndpointAppCommandLine */.Cm.SearchFieldEndpointAppCommandLine,
    gen/* SearchFieldEnum.SearchFieldEndpointApplication */.Cm.SearchFieldEndpointApplication,
    gen/* SearchFieldEnum.SearchFieldEventType */.Cm.SearchFieldEventType,
    gen/* SearchFieldEnum.SearchFieldFileName */.Cm.SearchFieldFileName,
    gen/* SearchFieldEnum.SearchFieldFilePath */.Cm.SearchFieldFilePath,
    gen/* SearchFieldEnum.SearchFieldFileSize */.Cm.SearchFieldFileSize,
    gen/* SearchFieldEnum.SearchFieldFileType */.Cm.SearchFieldFileType,
    gen/* SearchFieldEnum.SearchFieldHostname */.Cm.SearchFieldHostname,
    gen/* SearchFieldEnum.SearchFieldKeywordInMetadata */.Cm.SearchFieldKeywordInMetadata,
    gen/* SearchFieldEnum.SearchFieldLocalUserGroups */.Cm.SearchFieldLocalUserGroups,
    gen/* SearchFieldEnum.SearchFieldLocalUserName */.Cm.SearchFieldLocalUserName,
    gen/* SearchFieldEnum.SearchFieldLocationCategory */.Cm.SearchFieldLocationCategory,
    gen/* SearchFieldEnum.SearchFieldMD5Hash */.Cm.SearchFieldMD5Hash,
    gen/* SearchFieldEnum.SearchFieldPrinterName */.Cm.SearchFieldPrinterName,
    gen/* SearchFieldEnum.SearchFieldRemovableMediaName */.Cm.SearchFieldRemovableMediaName,
    gen/* SearchFieldEnum.SearchFieldRemovableMediaSerialNo */.Cm.SearchFieldRemovableMediaSerialNo,
    gen/* SearchFieldEnum.SearchFieldRemovableMediaType */.Cm.SearchFieldRemovableMediaType,
    gen/* SearchFieldEnum.SearchFieldURL */.Cm.SearchFieldURL,
    gen/* SearchFieldEnum.SearchFieldWebsiteCategory */.Cm.SearchFieldWebsiteCategory,
    gen/* SearchFieldEnum.SearchFieldZone */.Cm.SearchFieldZone
];
const supportedFields = runenv/* ENV.FEATURES.CONSOLE_SUPPORTED_ENDPOINT_FIELDS */.V.FEATURES.CONSOLE_SUPPORTED_ENDPOINT_FIELDS || {
    allowed: []
};
const allowedFields = supportedFields.all_allowed ? new Set(Object.values(gen/* SearchFieldEnum */.Cm)) : new Set([
    ...alwaysAllowedFields,
    ...supportedFields.allowed || []
]);
const isAllowedField = (field, { minEndpointVersion  } = {})=>{
    if (allowedFields.has(field)) {
        return true;
    }
    if (supportedFields.automatic && minEndpointVersion) {
        const requiredVersion = getFieldMinRequiredVersion(field);
        // String comparison will work for properly formatted versions like "23.05"
        return minEndpointVersion >= requiredVersion;
    }
    return false;
};
const getFieldMinRequiredVersion = (field)=>{
    const { Major , Minor  } = gen/* SearchFieldToMinimumVersion */.Mn[field];
    const majorStr = Major < 10 ? `0${Major}` : `${Major}`;
    const minorStr = Minor < 10 ? `0${Minor}` : `${Minor}`;
    return `${majorStr}.${minorStr}`;
};

;// CONCATENATED MODULE: ./src/modules/risks/shared/dashboard.schema.ts
function dashboard_schema_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function dashboard_schema_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            dashboard_schema_define_property(target, key, source[key]);
        });
    }
    return target;
}
function dashboard_schema_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function dashboard_schema_object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        dashboard_schema_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}








function emailListRefinement(val) {
    const emailErrors = (0,utils/* validateEmailList */.kX)(val);
    if (emailErrors.length > 0) {
        return (0,utils/* formatValidateEmailList */.ng)(emailErrors);
    }
    return "";
}
const policyDefaults = {
    name: "",
    selection_type: "dataset",
    dataset_sensitivities: [],
    dataset_ids: [],
    severity: severity/* Severity.Low */.zb.Low,
    exclude_origin: false,
    query: {
        rules: []
    },
    rule: dashboard_schema_object_spread_props(dashboard_schema_object_spread({}, dashboard/* policiesFormDefaults */.IR), {
        create_incident: true,
        notify_email: "",
        notify_enabled: false,
        incident_action: gen/* IncidentActionEnum.IncidentActionNone */.LE.IncidentActionNone,
        notify_status: "",
        status: gen/* CategoryStatusEnum.CategoryStatusRisky */.HL.CategoryStatusRisky
    })
};
const datasetDefaults = {
    name: "",
    category_ids: [],
    sensitivity: 1
};
const queryObject = lib.z.object({
    rules: search_schema/* rulesSchema */.oV
}).optional();
const policySchema = lib.z.object({
    id: lib.z.string().optional(),
    last_modified: lib.z.string().optional(),
    name: lib.z.string().min(2),
    severity: lib.z.number().optional(),
    dataset_ids: lib.z.array(lib.z.string()).optional(),
    dataset_sensitivities: lib.z.array(lib.z.number()).optional(),
    exclude_origin: lib.z.boolean().default(false),
    include_non_movement: lib.z.boolean().optional().default(false),
    query: queryObject,
    selection_type: lib.z.nativeEnum(gen/* SelectionTypeEnum */.XL).default(gen/* SelectionTypeEnum.SelectionTypeDataset */.XL.SelectionTypeDataset),
    user_query: queryObject,
    rule: lib.z.object({
        create_incident: lib.z.boolean().optional(),
        notify_email: lib.z.string().optional(),
        notify_enabled: lib.z.boolean(),
        incident_action: lib.z.nativeEnum(gen/* IncidentActionEnum */.LE).default(gen/* IncidentActionEnum.IncidentActionNone */.LE.IncidentActionNone),
        status: lib.z.string()
    }).passthrough().refine((v)=>{
        if (!v.notify_enabled || !(v === null || v === void 0 ? void 0 : v.create_incident)) {
            return true;
        }
        return !emailListRefinement(v.notify_email);
    }, (v)=>({
            path: [
                "notify_email"
            ],
            message: emailListRefinement(v.notify_email)
        }))
}).passthrough();
function parsePolicy(value, options = {}) {
    const schema = options.validateFields ? policySchema.superRefine((v, ctx)=>{
        validateFieldsSelectedType(v, ctx);
        return validateFields(v, ctx, dashboard_schema_object_spread_props(dashboard_schema_object_spread({}, options), {
            entityType: "policy"
        }));
    }) : policySchema;
    policySchema.superRefine((v, ctx)=>{
        validateFieldsSelectedType(v, ctx);
    });
    const values = schema.safeParse(value);
    if (!values.success) {
        return {
            values: null,
            errors: schemaToFinalFormError(values.error)
        };
    }
    // @ts-ignore
    delete values.data.include_non_movement;
    return {
        errors: null,
        values: values.data
    };
}
const datasetSchema = lib.z.object({
    id: lib.z.string().optional(),
    last_modified: lib.z.string().optional(),
    name: lib.z.string().min(2),
    category_ids: lib.z.array(lib.z.string()).nullish(),
    query: lib.z.object({
        rules: search_schema/* rulesSchema.optional */.oV.optional()
    }).optional()
}).passthrough();
function parseDataset(value, options = {}) {
    const schema = options.validateFields ? datasetSchema.superRefine((v, ctx)=>validateFields(v, ctx, dashboard_schema_object_spread_props(dashboard_schema_object_spread({}, options), {
            entityType: "dataset"
        }))) : datasetSchema;
    const values = schema.safeParse(value);
    if (values.success === false) {
        return {
            values: null,
            errors: schemaToFinalFormError(values.error)
        };
    } else {
        return {
            errors: null,
            values: values.data
        };
    }
}
function setDatasetDefaults(value) {
    return value || datasetDefaults;
}
const checkDatasetContainsCategoryType = ({ ids , categories , type  })=>{
    const idsSet = new Set(categories.filter(({ rule  })=>rule.incident_action === type).map(({ id  })=>id));
    return (ids || []).some((catId)=>idsSet.has(catId));
};
function validateFieldsSelectedType(entity, ctx) {
    var _entity_dataset_ids, _entity_dataset_sensitivities;
    if ((entity === null || entity === void 0 ? void 0 : entity.selection_type) === gen/* SelectionTypeEnum.SelectionTypeDataset */.XL.SelectionTypeDataset && !((_entity_dataset_ids = entity.dataset_ids) === null || _entity_dataset_ids === void 0 ? void 0 : _entity_dataset_ids.length)) {
        ctx.addIssue({
            code: "custom",
            path: [
                "dataset_ids"
            ],
            message: "Should have at least 1 dataset selected"
        });
    } else if ((entity === null || entity === void 0 ? void 0 : entity.selection_type) === gen/* SelectionTypeEnum.SelectionTypeSensitivity */.XL.SelectionTypeSensitivity && !((_entity_dataset_sensitivities = entity.dataset_sensitivities) === null || _entity_dataset_sensitivities === void 0 ? void 0 : _entity_dataset_sensitivities.length)) {
        ctx.addIssue({
            code: "custom",
            path: [
                "dataset_sensitivities"
            ],
            message: "Should have at least 1 sensitivity selected"
        });
    }
}
function validateFields(entity, ctx, { minEndpointVersion , entityType  } = {}) {
    var _ref;
    (_ref = [
        entity === null || entity === void 0 ? void 0 : entity.query,
        entity.user_query
    ]) === null || _ref === void 0 ? void 0 : _ref.forEach((query, index)=>{
        var _query_rules;
        return query === null || query === void 0 ? void 0 : (_query_rules = query.rules) === null || _query_rules === void 0 ? void 0 : _query_rules.forEach((rule, ruleIndex)=>{
            var _rule_conditions;
            (_rule_conditions = rule.conditions) === null || _rule_conditions === void 0 ? void 0 : _rule_conditions.forEach((condition, conditionIndex)=>{
                if (!isAllowedField(condition.field_name, {
                    minEndpointVersion
                })) {
                    const pathRoot = index ? "user_query" : "query";
                    ctx.addIssue({
                        code: "custom",
                        path: [
                            pathRoot,
                            "rules",
                            ruleIndex,
                            "conditions",
                            conditionIndex,
                            "field_name"
                        ],
                        message: "Field is not supported",
                        params: {
                            minRequiredVersion: getFieldMinRequiredVersion(condition.field_name),
                            type: "endpoint_field_not_supported",
                            entityType
                        }
                    });
                }
            });
        });
    });
}

// EXTERNAL MODULE: ./node_modules/lodash-es/toArray.js + 3 modules
var toArray = __webpack_require__(1372);
// EXTERNAL MODULE: ./node_modules/lodash-es/startCase.js
var startCase = __webpack_require__(54003);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/libs/layouts/index.tsx + 2 modules
var layouts = __webpack_require__(5855);
// EXTERNAL MODULE: ./src/modules/graph/services/index.ts + 2 modules
var services = __webpack_require__(15585);
// EXTERNAL MODULE: ./src/modules/risks/shared/molecules/LocationIcon.tsx
var LocationIcon = __webpack_require__(71631);
;// CONCATENATED MODULE: ./src/modules/risks/shared/locations.tsx






const locationsMessages = {
    all: "All",
    mail: "Email",
    mailDomain: "Email domain",
    mailAccount: "Address",
    cloudStorage: "Cloud Storage",
    cloudProvider: "Provider",
    cloudStoragePath: "Path",
    cloudApps: "Cloud App",
    cloudApp: "App",
    cloudAppsAccountName: "Account name",
    website: "Website",
    websiteDomain: "Domain",
    websiteUrl: "URL",
    websiteCategory: "Website category",
    share: "Shared Folder",
    shareHostname: "Hostname",
    shareGroupName: "Group name",
    sharePath: "Path",
    endpoint: "Endpoint",
    endpointHostname: "Hostname",
    endpointGroupName: "Group name",
    endpointLocalUserName: "Local user name",
    endpointPath: "Path",
    endpointApps: "Endpoint App",
    endpointAppsCommandline: "Command line",
    endpointAppsGroupName: "Group name",
    endpointAppsAppName: "Application name",
    endpointAppsHostname: "Hostname",
    endpointAppsLocalUserName: "Local user name",
    endpointAppsPath: "Path",
    removableMedia: "Removable media",
    mediaCategory: "Category",
    removableMediaLocalUserName: "Local user name",
    removableMediaDeviceName: "Device name",
    removableMediaSerialNumber: "Serial number",
    removableMediaPath: "Path",
    printer: "Printer",
    printerName: "Printer name"
};
const zones = {
    internal: {
        label: "Internal",
        value: "Internal",
        color: "#E0EEFD"
    },
    external: {
        label: "External",
        value: "External",
        color: "rgba(232, 99, 102, 0.2)"
    },
    undefined: {
        label: "Undefined",
        value: "Undefined",
        color: "#B4B4B4"
    }
};
const mediaCategories = {
    usb: {
        label: "USB Devices",
        value: "usb"
    },
    optical: {
        label: "CD/DVD",
        value: "optical"
    }
};
// TODO remove unused
const locations = {
    all: {
        label: locationsMessages.all,
        value: "*",
        color: "#ccc",
        keywords: [
            {
                label: "Email account or Email subject or Hostname or Path or Removable device name or Salesforce account name or Url"
            }
        ]
    },
    mail: {
        label: locationsMessages.mail,
        value: "mail",
        color: "#4CCBAB",
        clusterColor: "#4CCBAB33",
        keywords: [
            "email_account",
            {
                label: "Email subject"
            }
        ],
        source: true,
        destination: true,
        fields: {
            domain: {
                name: "mail.domain",
                suggestName: "domain",
                label: locationsMessages.mailDomain
            },
            email_account: {
                suggestName: "email_account",
                name: "mail.email_account",
                label: locationsMessages.mailAccount
            }
        }
    },
    cloud_storage: {
        label: locationsMessages.cloudStorage,
        value: "cloud_storage",
        color: "#3E75C8",
        clusterColor: "#3E75C833",
        keywords: [
            "path"
        ],
        source: true,
        destination: true,
        fields: {
            cloud_provider: {
                name: "cloud_storage.cloud_provider",
                suggestName: "cloud_provider",
                label: locationsMessages.cloudProvider
            },
            path: {
                name: "cloud_storage.path",
                suggestName: "path",
                label: locationsMessages.cloudStoragePath
            }
        }
    },
    cloud_apps: {
        label: locationsMessages.cloudApps,
        value: "cloud_apps",
        color: "#3E75C8",
        clusterColor: "#3E75C833",
        keywords: [
            "salesforce_account_name"
        ],
        source: true,
        destination: true,
        fields: {
            cloud_app: {
                name: "cloud_apps.cloud_app",
                label: locationsMessages.cloudApp
            },
            salesforce_account_name: {
                name: "cloud_apps.salesforce_account_name",
                label: locationsMessages.cloudAppsAccountName
            }
        }
    },
    website: {
        label: locationsMessages.website,
        value: "website",
        color: "#8B60AD",
        clusterColor: "#8B60AD33",
        keywords: [
            "url"
        ],
        source: true,
        destination: true,
        fields: {
            domain: {
                name: "website.domain",
                label: locationsMessages.websiteDomain
            },
            url: {
                name: "website.url",
                label: locationsMessages.websiteUrl
            },
            category: {
                name: "website.category",
                label: locationsMessages.websiteCategory
            }
        }
    },
    share: {
        label: locationsMessages.share,
        value: "share",
        color: "#E56574",
        clusterColor: "#E5657433",
        keywords: [
            "path",
            "hostname"
        ],
        source: true,
        destination: true,
        fields: {
            hostname: {
                name: "share.hostname",
                label: locationsMessages.shareHostname
            },
            group_name: {
                name: "share.group_name",
                label: locationsMessages.shareGroupName
            },
            path: {
                name: "share.path",
                label: locationsMessages.sharePath
            }
        }
    },
    endpoint: {
        label: locationsMessages.endpoint,
        value: "endpoint",
        color: "#FE9E46",
        clusterColor: "#FE9E4633",
        keywords: [
            "path",
            "hostname"
        ],
        source: true,
        destination: true,
        fields: {
            hostname: {
                name: "endpoint.hostname",
                label: locationsMessages.endpointHostname
            },
            group_name: {
                name: "endpoint.group_name",
                label: locationsMessages.endpointGroupName
            },
            local_user_name: {
                name: "endpoint.local_user_name",
                label: locationsMessages.endpointLocalUserName
            },
            path: {
                name: "endpoint.path",
                label: locationsMessages.endpointPath
            }
        }
    },
    endpoint_apps: {
        label: locationsMessages.endpointApps,
        value: "endpoint_apps",
        color: "#FE9E46",
        clusterColor: "#FE9E4633",
        keywords: [
            "path",
            "hostname"
        ],
        source: true,
        destination: true,
        fields: {
            app_commandline: {
                name: "endpoint_apps.app_commandline",
                label: locationsMessages.endpointAppsCommandline
            },
            group_name: {
                name: "endpoint_apps.group_name",
                label: locationsMessages.endpointAppsGroupName
            },
            app_name: {
                name: "endpoint_apps.app_name",
                label: locationsMessages.endpointAppsAppName
            },
            hostname: {
                name: "endpoint_apps.hostname",
                label: locationsMessages.endpointAppsHostname
            },
            local_user_name: {
                name: "endpoint_apps.local_user_name",
                label: locationsMessages.endpointAppsLocalUserName
            },
            path: {
                name: "endpoint_apps.path",
                label: locationsMessages.endpointAppsPath
            }
        }
    },
    removable_media: {
        label: locationsMessages.removableMedia,
        value: "removable_media",
        color: "#2ED6D9",
        clusterColor: "#2ED6D933",
        keywords: [
            "path",
            "deviceName"
        ],
        source: true,
        destination: true,
        fields: {
            local_user_name: {
                name: "removable_media.local_user_name",
                label: locationsMessages.removableMediaLocalUserName
            },
            deviceName: {
                name: "removable_media.removable_device_name",
                label: locationsMessages.removableMediaDeviceName
            },
            deviceSerial: {
                name: "removable_media.removable_device_id",
                label: locationsMessages.removableMediaSerialNumber
            },
            mediaCategory: {
                name: "removable_media.media_category",
                label: locationsMessages.mediaCategory
            },
            path: {
                name: "removable_media.path",
                label: locationsMessages.removableMediaPath
            }
        }
    },
    printer: {
        label: locationsMessages.printer,
        value: "printer",
        color: "#ABDA7C",
        clusterColor: "#ABDA7C33",
        keywords: [
            "printerName"
        ],
        source: false,
        destination: true,
        fields: {
            printerName: {
                name: "printer.printer_name",
                label: locationsMessages.printerName
            }
        }
    }
};
const LOCATION_OPTIONS = (0,toArray/* default */.Z)(locations);
function getLocationLabel(key) {
    var _locations_key;
    return (_locations_key = locations[key]) === null || _locations_key === void 0 ? void 0 : _locations_key.label;
}
function mapLocationsLabel(loc) {
    return /*#__PURE__*/ react.createElement(layouts/* HStack */.Ug, {
        style: {
            whiteSpace: "nowrap"
        },
        space: 1,
        as: "span",
        align: "center"
    }, /*#__PURE__*/ react.createElement(LocationIcon/* LocationIcon */._, {
        item: loc,
        shouldShowGenericIconForNested: true
    }), /*#__PURE__*/ react.createElement("span", null, formatLocation(loc)));
}
function formatLocation(loc) {
    var _loc_expand_path, _loc_expand_path1;
    if (((_loc_expand_path = loc.expand_path) === null || _loc_expand_path === void 0 ? void 0 : _loc_expand_path.length) === 1) {
        return getLocationLabel(loc.location);
    }
    if (loc.location === "cloud_storage" && ((_loc_expand_path1 = loc.expand_path) === null || _loc_expand_path1 === void 0 ? void 0 : _loc_expand_path1.length) === 2) {
        return serializeSearch(loc);
    }
    return [
        serializeSearch(loc),
        loc.location_outline
    ].filter(Boolean).join(" ");
}
function serializeSearch(loc) {
    var _loc_expand_path, _loc_query_rules__conditions, _loc_query_rules;
    if (loc.location === "cloud_storage") {
        return (0,startCase/* default */.Z)(loc.expand_path[1]);
    }
    if ((loc === null || loc === void 0 ? void 0 : (_loc_expand_path = loc.expand_path) === null || _loc_expand_path === void 0 ? void 0 : _loc_expand_path.length) === 2) {
        return "";
    }
    const query = (_loc_query_rules__conditions = (_loc_query_rules = loc.query.rules) === null || _loc_query_rules === void 0 ? void 0 : _loc_query_rules[0].conditions) === null || _loc_query_rules__conditions === void 0 ? void 0 : _loc_query_rules__conditions.find((el)=>el.field_name !== "location");
    if (!query) {
        return "";
    }
    switch(loc.location){
        case "removable_media":
            var _query_values;
            return (_query_values = query.values) === null || _query_values === void 0 ? void 0 : _query_values[0].value;
        case "endpoint":
            var _query_values1;
            return (_query_values1 = query.values) === null || _query_values1 === void 0 ? void 0 : _query_values1[0].value;
        case "endpoint_apps":
            var _query_values2;
            return (_query_values2 = query.values) === null || _query_values2 === void 0 ? void 0 : _query_values2[0].value;
    }
    return "";
}
function getLocationsWidgetItemLabel({ location_item  }, depth) {
    const name = location_item.path_component;
    if (depth === 0) {
        var _getLocationLabelPlural;
        return (_getLocationLabelPlural = (0,services/* getLocationLabelPlural */._n)(name)) !== null && _getLocationLabelPlural !== void 0 ? _getLocationLabelPlural : name;
    } else if (depth === 1 && location_item.location === gen/* LocationEnum.LocationCloudStorage */.eO.LocationCloudStorage) {
        return (0,startCase/* default */.Z)(name);
    }
    return name;
}
function getLocationItemId(location) {
    const path = location.expand_path || location.location_path || [];
    return path.join(",");
}

// EXTERNAL MODULE: ./node_modules/color/index.js
var node_modules_color = __webpack_require__(6767);
var color_default = /*#__PURE__*/__webpack_require__.n(node_modules_color);
;// CONCATENATED MODULE: ./src/modules/risks/shared/Color.util.ts

const saturation55 = (color)=>{
    return setSaturation(color, 55);
};
const lighten40 = (color)=>{
    return addLightness(color, 40);
};
const setSaturation = (color, saturation)=>{
    if (!Number.isInteger(saturation)) {
        throw new Error("Saturation must be an integer.");
    }
    if (saturation < 0 || saturation > 100) {
        throw new Error("Saturation must be in [0, 100]");
    }
    const newColor = color_default()(color).hsl();
    // @ts-ignore
    newColor.color[2] = saturation;
    return newColor.hex();
};
const addLightness = (color, lightness)=>{
    const newColor = color_default()(color).hsl();
    // @ts-ignore
    newColor.color[2] += lightness;
    return newColor.hex();
};

;// CONCATENATED MODULE: ./src/modules/risks/shared/index.tsx









/***/ }),

/***/ 71631:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "_": () => (/* binding */ LocationIcon)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(33502);
/* harmony import */ var modules_graph_services__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(15585);
/* harmony import */ var api_gen__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(33013);
/* harmony import */ var ui__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(17218);
/* harmony import */ var modules_graph_icons__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(92268);






function LocationIcon({ item: { expand_path , location , location_outline  } , depth =(expand_path === null || expand_path === void 0 ? void 0 : expand_path.length) ? expand_path.length - 1 : 0 , shouldShowGenericIconForNested =false  }) {
    // start showing icons level before for emails and endpoint apps
    const isFavIconsLevel = location === api_gen__WEBPACK_IMPORTED_MODULE_2__/* .LocationEnum.LocationMail */ .eO.LocationMail || location === api_gen__WEBPACK_IMPORTED_MODULE_2__/* .LocationEnum.LocationEndpointApps */ .eO.LocationEndpointApps ? depth > 0 : depth > 1;
    if (isFavIconsLevel) {
        if (location === api_gen__WEBPACK_IMPORTED_MODULE_2__/* .LocationEnum.LocationWebsite */ .eO.LocationWebsite || location === api_gen__WEBPACK_IMPORTED_MODULE_2__/* .LocationEnum.LocationMail */ .eO.LocationMail) {
            return /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(ui__WEBPACK_IMPORTED_MODULE_3__/* .DomainFavIcon */ .et, {
                size: 16,
                url: location_outline
            });
        }
        if (location === api_gen__WEBPACK_IMPORTED_MODULE_2__/* .LocationEnum.LocationEndpointApps */ .eO.LocationEndpointApps) {
            return /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(ui__WEBPACK_IMPORTED_MODULE_3__/* .AppFavIcon */ .oZ, {
                size: 16,
                app: location_outline,
                color: modules_graph_services__WEBPACK_IMPORTED_MODULE_1__/* .locations.endpoint_apps.color */ .Kl.endpoint_apps.color
            });
        }
    }
    return !isFavIconsLevel || shouldShowGenericIconForNested ? /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_mui_material__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
        fontSize: "small"
    }, modules_graph_icons__WEBPACK_IMPORTED_MODULE_4__/* .locationIconMap */ .H[location] || modules_graph_icons__WEBPACK_IMPORTED_MODULE_4__/* .locationIconMap["*"] */ .H["*"]) : null;
}


/***/ }),

/***/ 34437:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$": () => (/* binding */ localTheme),
/* harmony export */   "z": () => (/* binding */ riskColorsMap)
/* harmony export */ });
// this is a quick hack, everything should be in global theme
const localTheme = {
    grey: "#CACACA",
    gray2: "#FBFBFB",
    backgroundGrey: "#f2f3f4",
    green: "#5DCB6F",
    red: "#BF3E3E",
    blue1: "#C7E5F9",
    blue2: "#43A7EA",
    blue3: "#F8F9FB",
    dividerBlue2: "1px solid #43A7EA",
    white: "#ffffff",
    barHover: "#007dd1",
    menuItemHover: "#ECEEF1",
    yellow: "#F8A458",
    errorBorder: "#FF1212",
    rulesBackground: "#f5f5f5",
    backgroundDark: "#525252",
    rulesHeader: "#5b6064",
    greyBg: "#616161",
    selectedColor: "#E6EAEE",
    sidePanelBackground: "#f8f9fb",
    sidePanelBorder: "1px solid #eeeff3",
    selectedResponseFilter: "rgba(143, 154, 165, 0.44)"
};
const riskColorsMap = {
    low_risky: localTheme.yellow,
    risky: localTheme.red,
    approved: localTheme.green,
    other: localTheme.gray2
};


/***/ }),

/***/ 69878:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "L": () => (/* binding */ RedirectWithSearch),
/* harmony export */   "t": () => (/* binding */ redirectIfAuthenticated)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var react_router_dom__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(89250);
/* harmony import */ var modules_auth__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(38266);
/* harmony import */ var libs_hooks__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(88289);




function redirectIfAuthenticated(Route) {
    return (props)=>{
        const isAuthorized = (0,libs_hooks__WEBPACK_IMPORTED_MODULE_2__/* .useSelector */ .v9)(modules_auth__WEBPACK_IMPORTED_MODULE_1__.authState.select(({ user  })=>!!user.id));
        const location = (0,react_router_dom__WEBPACK_IMPORTED_MODULE_3__/* .useLocation */ .TH)();
        const state = location.state;
        if (isAuthorized) {
            var _window_history_state;
            return /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(react_router_dom__WEBPACK_IMPORTED_MODULE_3__/* .Navigate */ .Fg, {
                to: (state === null || state === void 0 ? void 0 : state.from) || "/",
                replace: true,
                state: (_window_history_state = window.history.state) === null || _window_history_state === void 0 ? void 0 : _window_history_state.usr
            });
        }
        return /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Route, props);
    };
}
const RedirectWithSearch = ({ from , to  })=>{
    var _window_history_state;
    const { search  } = (0,react_router_dom__WEBPACK_IMPORTED_MODULE_3__/* .useLocation */ .TH)();
    const match = (0,react_router_dom__WEBPACK_IMPORTED_MODULE_3__/* .useMatch */ .bS)(from + "/*");
    if (!match) {
        return null;
    }
    const rest = match === null || match === void 0 ? void 0 : match.params["*"];
    const _to = to + (rest ? `/${rest}/` : "") + search;
    return /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(react_router_dom__WEBPACK_IMPORTED_MODULE_3__/* .Navigate */ .Fg, {
        to: _to,
        replace: true,
        state: (_window_history_state = window.history.state) === null || _window_history_state === void 0 ? void 0 : _window_history_state.usr
    });
};


/***/ }),

/***/ 66943:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "E3": () => (/* reexport safe */ _utils__WEBPACK_IMPORTED_MODULE_2__.E),
/* harmony export */   "ez": () => (/* reexport safe */ _utils__WEBPACK_IMPORTED_MODULE_2__.e),
/* harmony export */   "i1": () => (/* reexport safe */ _molecules__WEBPACK_IMPORTED_MODULE_3__.i),
/* harmony export */   "tL": () => (/* reexport safe */ _helpers__WEBPACK_IMPORTED_MODULE_1__.t)
/* harmony export */ });
/* harmony import */ var _templates_ErrorPageTemplate__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(48646);
/* harmony import */ var _helpers__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(69878);
/* harmony import */ var _utils__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(94949);
/* harmony import */ var _molecules__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(6289);






/***/ }),

/***/ 77836:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "s": () => (/* binding */ messages)
/* harmony export */ });
const messages = {
    backBtn: "Back to homepage",
    notFoundPageSubTitle: "The page you requested could not be found",
    accessDenied: "Access denied.",
    accessDeniedPageSubTitle: `Please contact your administrator or login with an administrator account.`
};


/***/ }),

/***/ 6289:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "i": () => (/* reexport */ ProtectedRoute),
  "$": () => (/* reexport */ RouteUserCheck)
});

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/shared/environment.tsx
var environment = __webpack_require__(66246);
// EXTERNAL MODULE: ./src/shared/permissions.tsx
var permissions = __webpack_require__(44916);
// EXTERNAL MODULE: ./node_modules/react-router/dist/index.js
var dist = __webpack_require__(89250);
// EXTERNAL MODULE: ./src/modules/auth/index.ts + 2 modules
var auth = __webpack_require__(38266);
// EXTERNAL MODULE: ./src/libs/hooks/index.ts + 18 modules
var hooks = __webpack_require__(88289);
// EXTERNAL MODULE: ./node_modules/react-query/es/index.js + 22 modules
var es = __webpack_require__(21478);
// EXTERNAL MODULE: ./node_modules/@mui/material/CircularProgress/CircularProgress.js + 1 modules
var CircularProgress = __webpack_require__(59062);
// EXTERNAL MODULE: ./node_modules/@mui/material/Dialog/Dialog.js + 1 modules
var Dialog = __webpack_require__(3838);
// EXTERNAL MODULE: ./node_modules/@mui/material/DialogContent/DialogContent.js + 1 modules
var DialogContent = __webpack_require__(77750);
// EXTERNAL MODULE: ./node_modules/@mui/material/DialogContentText/DialogContentText.js + 1 modules
var DialogContentText = __webpack_require__(56408);
// EXTERNAL MODULE: ./node_modules/@mui/material/Fade/Fade.js
var Fade = __webpack_require__(16628);
// EXTERNAL MODULE: ./node_modules/@mui/material/DialogTitle/DialogTitle.js
var DialogTitle = __webpack_require__(37645);
// EXTERNAL MODULE: ./node_modules/@mui/material/Link/Link.js + 2 modules
var Link = __webpack_require__(1079);
// EXTERNAL MODULE: ./node_modules/@mui/material/DialogActions/DialogActions.js + 1 modules
var DialogActions = __webpack_require__(88979);
// EXTERNAL MODULE: ./node_modules/@mui/material/Button/Button.js + 1 modules
var Button = __webpack_require__(72642);
// EXTERNAL MODULE: ./src/ui/css/index.ts
var css = __webpack_require__(93461);
// EXTERNAL MODULE: ./src/ui/index.ts + 23 modules
var ui = __webpack_require__(17218);
// EXTERNAL MODULE: ./src/api/terms/index.ts + 1 modules
var terms = __webpack_require__(15322);
;// CONCATENATED MODULE: ./src/modules/terms/messages.ts
const messages = {
    title: "Cyberhaven terms and conditions",
    agreeText: "By continuing, you agree to the",
    termsLinkText: "Cyberhaven Enterprise Terms",
    accept: "Accept",
    error: "Error occurred"
};

// EXTERNAL MODULE: ./src/modules/terms/state.ts
var state = __webpack_require__(44428);
;// CONCATENATED MODULE: ./src/modules/terms/TermsAndConditions.tsx








const TermsDownloadLink = "https://www.cyberhaven.com/legal/enterprise-terms";
const StyledCircular = (0,css/* styled */.zo)(CircularProgress/* default */.Z, {
    position: "absolute"
});
const Background = (0,css/* styled */.zo)("div", {
    width: "100%",
    backgroundRepeat: "no-repeat",
    backgroundSize: "cover",
    filter: "blur(6px)",
    height: "100%"
});
const TermsAndConditions = ()=>{
    const { isLoading , isError  } = (0,state/* useTermsStateQuery */.yH)();
    const cache = (0,es/* useQueryCache */.Zq)();
    const [mutate, mutateState] = (0,es/* useMutation */.Db)(()=>{
        // optimistically set value
        cache.setQueryData((0,state/* useTermStateQueryKey */.mY)(), ()=>true, {
            cacheTime: 2000
        });
        return terms/* acceptTerms */.f();
    }, {
        onError () {
            cache.invalidateQueries((0,state/* useTermStateQueryKey */.mY)());
        }
    });
    if (isLoading) {
        return /*#__PURE__*/ react.createElement(ui/* LayoutLoader */.GS, null);
    }
    if (isError) {
        return /*#__PURE__*/ react.createElement(Dialog/* default */.Z, {
            open: true
        }, /*#__PURE__*/ react.createElement(DialogContent/* default */.Z, null, /*#__PURE__*/ react.createElement(DialogContentText/* default */.Z, null, messages.error)));
    }
    return /*#__PURE__*/ react.createElement("div", {
        "data-testid": "terms-and-conditions-page"
    }, /*#__PURE__*/ react.createElement(Dialog/* default */.Z, {
        maxWidth: "lg",
        TransitionComponent: Fade/* default */.Z,
        open: true,
        scroll: "paper"
    }, /*#__PURE__*/ react.createElement(DialogTitle/* default */.Z, null, messages.title), /*#__PURE__*/ react.createElement(DialogContent/* default */.Z, null, /*#__PURE__*/ react.createElement(DialogContentText/* default */.Z, null, messages.agreeText, " ", /*#__PURE__*/ react.createElement(Link/* default */.Z, {
        href: TermsDownloadLink,
        rel: "noopener",
        target: "_blank"
    }, messages.termsLinkText))), /*#__PURE__*/ react.createElement(DialogActions/* default */.Z, null, /*#__PURE__*/ react.createElement(Button/* default */.Z, {
        onClick: ()=>mutate(),
        variant: "contained",
        color: "primary",
        "data-testid": "accept-terms-button",
        disabled: mutateState.isLoading
    }, messages.accept, " ", mutateState.isLoading && /*#__PURE__*/ react.createElement(StyledCircular, {
        size: 20
    })))), /*#__PURE__*/ react.createElement(Background, null));
};

;// CONCATENATED MODULE: ./src/modules/terms/index.ts



// EXTERNAL MODULE: ./src/modules/router/pages/AccessDeniedPage.tsx
var AccessDeniedPage = __webpack_require__(34875);
;// CONCATENATED MODULE: ./src/modules/router/molecules/ProtectedRoute.tsx









const RouteAccessCheck = ({ children , requiredPermissions , requiredPermissionsAnyOf  })=>{
    const isAccepted = (0,state/* useTermsState */.i2)();
    var _ref;
    const { data , isLoading , isError  } = (0,permissions/* useCan */.py)((_ref = requiredPermissions || requiredPermissionsAnyOf) !== null && _ref !== void 0 ? _ref : [], !!requiredPermissionsAnyOf);
    if (isLoading) {
        return /*#__PURE__*/ react.createElement(ui/* LayoutLoader */.GS, null);
    }
    if (isError) {
        return /*#__PURE__*/ react.createElement(ui/* ErrorState */.Te, null);
    }
    if (!data) {
        return /*#__PURE__*/ react.createElement(AccessDeniedPage/* AccessDeniedPage */.X, null);
    }
    if (!isAccepted) {
        return /*#__PURE__*/ react.createElement(TermsAndConditions, null);
    }
    return children;
};
const RouteUserCheck = ({ children  })=>{
    const location = (0,dist/* useLocation */.TH)();
    const { id  } = (0,hooks/* useSelector */.v9)(auth.authState.stores.user);
    const { routes  } = (0,environment/* useAppEnvironment */.f)();
    if (!id && routes) {
        return /*#__PURE__*/ react.createElement(dist/* Navigate */.Fg, {
            to: routes.login.path,
            replace: true,
            state: {
                from: location.pathname + location.search
            }
        });
    }
    return /*#__PURE__*/ react.createElement(react.Fragment, null, children);
};
const ProtectedRoute = (props)=>{
    return /*#__PURE__*/ react.createElement(RouteUserCheck, null, /*#__PURE__*/ react.createElement(RouteAccessCheck, props));
};

;// CONCATENATED MODULE: ./src/modules/router/molecules/index.ts



/***/ }),

/***/ 34875:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "X": () => (/* binding */ AccessDeniedPage)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _templates_ErrorPageTemplate__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(48646);
/* harmony import */ var _messages__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(77836);
/* harmony import */ var _usePageErrorLog__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(50253);




const AccessDeniedPage = ()=>{
    (0,_usePageErrorLog__WEBPACK_IMPORTED_MODULE_3__/* .usePageErrorLog */ .c)();
    return /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_templates_ErrorPageTemplate__WEBPACK_IMPORTED_MODULE_1__/* .ErrorPageTemplate */ .J, {
        title: "403",
        subTitle: /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Fragment, null, _messages__WEBPACK_IMPORTED_MODULE_2__/* .messages.accessDenied */ .s.accessDenied, " ", /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement("br", null), _messages__WEBPACK_IMPORTED_MODULE_2__/* .messages.accessDeniedPageSubTitle */ .s.accessDeniedPageSubTitle)
    });
};


/***/ }),

/***/ 50253:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "c": () => (/* binding */ usePageErrorLog)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(28216);
/* harmony import */ var react_router__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(89250);
/* harmony import */ var runenv__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(76223);
/* harmony import */ var service__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(89880);
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}





// In case we get to AccessDenied or NotFound page we log current state.
function usePageErrorLog() {
    const currentUser = (0,react_redux__WEBPACK_IMPORTED_MODULE_1__/* .useSelector */ .v9)((store)=>{
        var _store_auth;
        return (_store_auth = store.auth) === null || _store_auth === void 0 ? void 0 : _store_auth.user;
    });
    const location = (0,react_router__WEBPACK_IMPORTED_MODULE_4__/* .useLocation */ .TH)();
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(()=>{
        const logInfo = function() {
            var _ref = _async_to_generator(function*() {
                console.group("Page error info");
                console.info("Current user:", currentUser);
                console.info("Current features:", runenv__WEBPACK_IMPORTED_MODULE_2__/* .ENV.FEATURES */ .V.FEATURES);
                console.info("Location:", location);
                const permissionsService = yield (0,service__WEBPACK_IMPORTED_MODULE_3__/* .resolveService */ .f)("permissions");
                console.info("Permissions user id:", permissionsService.userId);
                const permissions = yield permissionsService.preloadPermissions();
                console.info("Permissions:", permissions);
                console.groupEnd();
            });
            return function logInfo() {
                return _ref.apply(this, arguments);
            };
        }();
        logInfo();
    }, []);
}


/***/ }),

/***/ 48646:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "J": () => (/* binding */ ErrorPageTemplate)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var react_router_dom__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(79655);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(2658);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(72642);
/* harmony import */ var ui_css__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(93461);
/* harmony import */ var _messages__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(77836);
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}





const textColor = "#DDDDDD";
const styles = (0,ui_css__WEBPACK_IMPORTED_MODULE_1__/* .css */ .iv)({
    display: "flex",
    width: "100%",
    height: "100%",
    justifyContent: "center",
    alignItems: "center"
});
const textStyles = (0,ui_css__WEBPACK_IMPORTED_MODULE_1__/* .css */ .iv)({
    fontSize: "25vh",
    lineHeight: "1em"
});
const ErrorPageTemplate = ({ title , subTitle , className =""  })=>/*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", {
        className: styles({
            className
        }).className
    }, /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", {
        style: {
            textAlign: "center"
        }
    }, /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_mui_material__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
        variant: "h5",
        className: textStyles({
            css: {
                color: textColor
            }
        }).className
    }, title), /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_mui_material__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
        color: "textSecondary",
        variant: "subtitle1"
    }, subTitle), /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", {
        style: {
            marginTop: "3em"
        }
    }, /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_mui_material__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
        color: "primary",
        variant: "contained",
        component: (props)=>/*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(react_router_dom__WEBPACK_IMPORTED_MODULE_5__/* .Link */ .rU, _object_spread({
                to: "/"
            }, props))
    }, _messages__WEBPACK_IMPORTED_MODULE_2__/* .messages.backBtn */ .s.backBtn))));


/***/ }),

/***/ 94949:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "E": () => (/* binding */ namedLazy),
/* harmony export */   "e": () => (/* binding */ lazyImport)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);

/**
 * @deprecated
 * use lazyImport instead
 */ function namedLazy(fn, name) {
    return /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_0__.lazy)(()=>fn().then((el)=>({
                default: el[name]
            })));
}
/**
 * lazyImport(()=>import("./module").then(el => el.Component))
 */ function lazyImport(fn) {
    return /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_0__.lazy)(()=>fn().then((el)=>({
                default: el
            })));
}


/***/ }),

/***/ 84778:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "uh": () => (/* binding */ fetchUsers),
  "PR": () => (/* binding */ getUser),
  "lj": () => (/* binding */ gsuiteEffects),
  "we": () => (/* binding */ importUsers),
  "x4": () => (/* binding */ login),
  "kS": () => (/* binding */ logout),
  "zk": () => (/* binding */ monitor),
  "ZN": () => (/* binding */ toggle),
  "li": () => (/* binding */ toggleAll),
  "Go": () => (/* binding */ toggleAutoMonitoring)
});

// UNUSED EXPORTS: enableForIds

// EXTERNAL MODULE: ./node_modules/lodash-es/reduce.js + 1 modules
var reduce = __webpack_require__(85697);
// EXTERNAL MODULE: ./node_modules/okdux/dist/lib/index.js + 6 modules
var lib = __webpack_require__(56804);
// EXTERNAL MODULE: ./src/api/cloud-sensors/index.ts + 3 modules
var cloud_sensors = __webpack_require__(40399);
// EXTERNAL MODULE: ./node_modules/axios/index.js
var axios = __webpack_require__(9669);
var axios_default = /*#__PURE__*/__webpack_require__.n(axios);
// EXTERNAL MODULE: ./src/api/auth/ExternalAuth.ts + 1 modules
var ExternalAuth = __webpack_require__(17988);
;// CONCATENATED MODULE: ./src/api/auth/GSuiteAuth.ts
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}


class GSuiteAuth extends ExternalAuth/* ExternalAuth */.y {
    isAuthorized() {
        return !!this.tenant;
    }
    login() {
        return this.authorize("/gsuite/auth/login", "GSuite Login Consent").then(this.getUser);
    }
    logout() {
        return axios_default().get("/gsuite/auth/logout").then((response)=>{
            this.tenant = undefined;
            return response;
        });
    }
    constructor(...args){
        super(...args);
        _define_property(this, "tenant", void 0);
        _define_property(this, "getUser", ()=>{
            if (this.isAuthorized()) {
                return this.tenant;
            }
            return axios_default().get("/gsuite/auth/login/info", {
                meta: {
                    ignoreUnauthorized: true
                }
            }).then((response)=>{
                this.tenant = response.data;
                return this.tenant;
            });
        });
    }
}
const gsuiteAuth = new GSuiteAuth();

// EXTERNAL MODULE: ./src/modules/notification/index.ts + 3 modules
var modules_notification = __webpack_require__(5769);
// EXTERNAL MODULE: ./src/libs/restatex/index.ts + 2 modules
var restatex = __webpack_require__(87063);
// EXTERNAL MODULE: ./src/modules/sensors/messages.ts
var sensors_messages = __webpack_require__(21301);
;// CONCATENATED MODULE: ./src/modules/sensors/gsuite.effects.ts
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}







const gsuiteEffects = (0,lib/* createEffects */.xG)({
    fetchUsers: lib/* build.async */.J_.async(),
    login: (0,restatex/* asyncAct */.H)(),
    logout: lib/* build.async */.J_.async(),
    getUser: (0,restatex/* asyncAct */.H)(),
    toggle: (0,restatex/* asyncAct */.H)(),
    import: (0,restatex/* asyncAct */.H)(),
    enableAll: (0,restatex/* asyncAct */.H)(),
    enableForIds: (0,restatex/* asyncAct */.H)()
}, "gsuite");
function fetchUsers() {
    return _fetchUsers.apply(this, arguments);
}
function _fetchUsers() {
    _fetchUsers = _async_to_generator(function*() {
        const { success , request , failure  } = gsuiteEffects.fetchUsers;
        request();
        try {
            const data = yield cloud_sensors/* gsuiteSensorService.fetchUsers */.Nw.fetchUsers();
            success(data);
        } catch (error) {
            failure();
            modules_notification/* notification.error */.t6.error((0,modules_notification/* apiErrorNotification */.dE)(error));
        }
    });
    return _fetchUsers.apply(this, arguments);
}
function monitor() {
    return _monitor.apply(this, arguments);
}
function _monitor() {
    _monitor = _async_to_generator(function*() {
        const { data  } = yield cloud_sensors/* gsuiteSensorService.monitorUsers */.Nw.monitorUsers();
        const totalChanges = (0,reduce/* default */.Z)(data, countChanges, 0);
        return !!totalChanges;
        function countChanges(acc, changes) {
            return acc + changes.length;
        }
    });
    return _monitor.apply(this, arguments);
}
function logout() {
    return _logout.apply(this, arguments);
}
function _logout() {
    _logout = _async_to_generator(function*() {
        const { success , request , failure  } = gsuiteEffects.logout;
        request();
        try {
            yield gsuiteAuth.logout();
            success();
            modules_notification/* notification.open */.t6.open({
                message: sensors_messages/* messages.notifications.userDisconnected */.s.notifications.userDisconnected
            });
            return;
        } catch (error) {
            failure(error);
            modules_notification/* notification.error */.t6.error({
                message: sensors_messages/* messages.notifications.logoutError */.s.notifications.logoutError,
                description: error.message
            });
            return Promise.reject(error);
        }
    });
    return _logout.apply(this, arguments);
}
function importUsers(users) {
    return _importUsers.apply(this, arguments);
}
function _importUsers() {
    _importUsers = _async_to_generator(function*(users) {
        const { success , request , failure  } = gsuiteEffects.import;
        request();
        try {
            yield cloud_sensors/* gsuiteSensorService.batch */.Nw.batch(users);
            success(users);
            modules_notification/* notification.open */.t6.open({
                message: sensors_messages/* messages.notifications.successfullyImported */.s.notifications.successfullyImported
            });
        } catch (error) {
            failure(error);
            modules_notification/* notification.error */.t6.error({
                message: sensors_messages/* messages.notifications.importError */.s.notifications.importError,
                description: error.message
            });
        }
    });
    return _importUsers.apply(this, arguments);
}
function enableForIds(users) {
    return _enableForIds.apply(this, arguments);
}
function _enableForIds() {
    _enableForIds = _async_to_generator(function*(users) {
        const { success , request , failure  } = gsuiteEffects.enableForIds;
        request();
        try {
            yield gsuiteSensorService.batch(users.map((id)=>({
                    id,
                    monitored: true
                })));
            success(users);
            notification.open({
                message: messages.notifications.usersMonitoringEnabled
            });
        } catch (error) {
            failure(error);
            notification.error({
                message: error.message
            });
        }
    });
    return _enableForIds.apply(this, arguments);
}
function login() {
    return _login.apply(this, arguments);
}
function _login() {
    _login = _async_to_generator(function*() {
        const { success , request , failure  } = gsuiteEffects.login;
        request();
        try {
            const tenant = yield gsuiteAuth.login();
            success(tenant);
        } catch (error) {
            failure(error);
            modules_notification/* notification.error */.t6.error({
                message: sensors_messages/* messages.notifications.gsuiteLoginError */.s.notifications.gsuiteLoginError,
                description: error.message
            });
        }
    });
    return _login.apply(this, arguments);
}
function getUser() {
    return _getUser.apply(this, arguments);
}
function _getUser() {
    _getUser = _async_to_generator(function*() {
        const { success , request , failure  } = gsuiteEffects.getUser;
        request();
        try {
            const tenant = yield gsuiteAuth.getUser();
            success(tenant);
        } catch (error) {
            failure(error);
        }
    });
    return _getUser.apply(this, arguments);
}
function toggle(_) {
    return _toggle.apply(this, arguments);
}
function _toggle() {
    _toggle = _async_to_generator(function*({ id , monitored  }) {
        const { success , request , failure  } = gsuiteEffects.toggle;
        request();
        try {
            yield cloud_sensors/* gsuiteSensorService.updateUser */.Nw.updateUser(id, {
                monitored
            });
            modules_notification/* notification.open */.t6.open({
                message: sensors_messages/* messages.notifications.userMonitoring */.s.notifications.userMonitoring(monitored)
            });
            success({
                id,
                monitored
            });
        } catch (error) {
            failure({
                id
            });
            modules_notification/* notification.error */.t6.error((0,modules_notification/* apiErrorNotification */.dE)(error));
        }
    });
    return _toggle.apply(this, arguments);
}
function toggleAll(params) {
    return _toggleAll.apply(this, arguments);
}
function _toggleAll() {
    _toggleAll = _async_to_generator(function*(params) {
        const { success , request , failure  } = gsuiteEffects.enableAll;
        request();
        try {
            yield cloud_sensors/* gsuiteSensorService.updateAll */.Nw.updateAll(params);
            modules_notification/* notification.open */.t6.open({
                message: sensors_messages/* messages.notifications.allUserMonitoring */.s.notifications.allUserMonitoring(params.monitored)
            });
            success(params);
        } catch (error) {
            failure();
            modules_notification/* notification.error */.t6.error((0,modules_notification/* apiErrorNotification */.dE)(error));
        }
    });
    return _toggleAll.apply(this, arguments);
}
function toggleAutoMonitoring(params) {
    return _toggleAutoMonitoring.apply(this, arguments);
}
function _toggleAutoMonitoring() {
    _toggleAutoMonitoring = _async_to_generator(function*(params) {
        try {
            yield cloud_sensors/* gsuiteSensorService.toggleAutoMonitoring */.Nw.toggleAutoMonitoring(params);
            yield fetchUsers();
            modules_notification/* notification.open */.t6.open({
                message: sensors_messages/* messages.notifications.autoMonitoring */.s.notifications.autoMonitoring(params.monitored)
            });
        } catch (error) {
            modules_notification/* notification.error */.t6.error((0,modules_notification/* apiErrorNotification */.dE)(error));
        }
    });
    return _toggleAutoMonitoring.apply(this, arguments);
}


/***/ }),

/***/ 21301:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "s": () => (/* binding */ messages)
/* harmony export */ });
const messages = {
    notifications: {
        userDisconnected: "User has been disconnected!",
        logoutError: "Logout Error",
        successfullyImported: "Successfully Imported",
        importError: "Import Error",
        usersMonitoringEnabled: "Monitoring for provided users has been enabled",
        salesForceError: "SalesForce Login Error",
        o365LoginError: "O365 Login Error",
        gsuiteLoginError: "Gsuite Login Error",
        userMonitoring: (enabled)=>`Monitoring has been ${enabled ? "enabled" : "disabled"}`,
        allUserMonitoring: (enabled)=>`Monitoring of all users ${enabled ? "enabled" : "disabled"}`,
        autoMonitoring: (enabled)=>`Automatic monitoring of all users ${enabled ? "enabled" : "disabled"}`,
        notConnectedMessage: "Please connect a user or select which user's connection you would like to configure."
    },
    cloudSensors: "Cloud Sensors",
    listOfMonitoredUsers: "List of monitored users",
    enableAutoMonitoring: "Enable automatic monitoring for all users",
    warningMessage: "Some users do not have associated email address so they are excluded from the list",
    searchPlaceholder: "Search for user",
    selectAll: (count)=>`Select all ${count}`,
    showOnlyMonitored: (count)=>`Show only monitored users (${count})`,
    actions: "Actions",
    downloadUsersList: "Download users list",
    importUsersList: "Import users list",
    disconnect: "Disconnect",
    tenantId: "Tenant ID",
    connect: "Connect"
};


/***/ }),

/***/ 46150:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "uh": () => (/* binding */ fetchUsers),
  "PR": () => (/* binding */ getUser),
  "we": () => (/* binding */ importUsers),
  "x4": () => (/* binding */ login),
  "kS": () => (/* binding */ logout),
  "zk": () => (/* binding */ monitor),
  "Gt": () => (/* binding */ o365Effects),
  "ZN": () => (/* binding */ toggle),
  "li": () => (/* binding */ toggleAll),
  "Go": () => (/* binding */ toggleAutoMonitoring)
});

// UNUSED EXPORTS: enableForIds

// EXTERNAL MODULE: ./node_modules/lodash-es/reduce.js + 1 modules
var reduce = __webpack_require__(85697);
// EXTERNAL MODULE: ./node_modules/okdux/dist/lib/index.js + 6 modules
var lib = __webpack_require__(56804);
// EXTERNAL MODULE: ./src/api/cloud-sensors/index.ts + 3 modules
var cloud_sensors = __webpack_require__(40399);
// EXTERNAL MODULE: ./node_modules/axios/index.js
var axios = __webpack_require__(9669);
var axios_default = /*#__PURE__*/__webpack_require__.n(axios);
// EXTERNAL MODULE: ./src/api/auth/ExternalAuth.ts + 1 modules
var ExternalAuth = __webpack_require__(17988);
;// CONCATENATED MODULE: ./src/api/auth/O365Auth.ts
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}


class O365Auth extends ExternalAuth/* ExternalAuth */.y {
    isAuthorized() {
        return !!this.tenant;
    }
    login() {
        return this.authorize("/o365/login-consent", "O365 Login Consent").then(this.getUser);
    }
    logout() {
        return axios_default().get("/o365/logout").then((response)=>{
            this.tenant = undefined;
            return response;
        });
    }
    constructor(...args){
        super(...args);
        _define_property(this, "tenant", void 0);
        _define_property(this, "getUser", ()=>{
            if (this.isAuthorized()) {
                return this.tenant;
            }
            return axios_default().get("/o365/login/info", {
                meta: {
                    ignoreUnauthorized: true
                }
            }).then((response)=>{
                this.tenant = response.data;
                return this.tenant;
            });
        });
    }
}
const o365Auth = new O365Auth();

// EXTERNAL MODULE: ./src/modules/notification/index.ts + 3 modules
var modules_notification = __webpack_require__(5769);
// EXTERNAL MODULE: ./src/libs/restatex/index.ts + 2 modules
var restatex = __webpack_require__(87063);
// EXTERNAL MODULE: ./src/modules/sensors/messages.ts
var sensors_messages = __webpack_require__(21301);
;// CONCATENATED MODULE: ./src/modules/sensors/o365.effects.ts
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}







const o365Effects = (0,lib/* createEffects */.xG)({
    fetchUsers: lib/* build.async */.J_.async(),
    login: (0,restatex/* asyncAct */.H)(),
    logout: lib/* build.async */.J_.async(),
    getUser: (0,restatex/* asyncAct */.H)(),
    toggle: (0,restatex/* asyncAct */.H)(),
    import: (0,restatex/* asyncAct */.H)(),
    enableAll: (0,restatex/* asyncAct */.H)(),
    enableForIds: (0,restatex/* asyncAct */.H)()
}, "o365");
function fetchUsers() {
    return _fetchUsers.apply(this, arguments);
}
function _fetchUsers() {
    _fetchUsers = _async_to_generator(function*() {
        const { success , request , failure  } = o365Effects.fetchUsers;
        request();
        try {
            const data = yield cloud_sensors/* o365SensorService.fetchUsers */.st.fetchUsers();
            success(data);
        } catch (error) {
            failure();
            modules_notification/* notification.error */.t6.error((0,modules_notification/* apiErrorNotification */.dE)(error));
        }
    });
    return _fetchUsers.apply(this, arguments);
}
function monitor() {
    return _monitor.apply(this, arguments);
}
function _monitor() {
    _monitor = _async_to_generator(function*() {
        const { data  } = yield cloud_sensors/* o365SensorService.monitorUsers */.st.monitorUsers();
        const totalChanges = (0,reduce/* default */.Z)(data, countChanges, 0);
        return !!totalChanges;
        function countChanges(acc, changes) {
            return acc + changes.length;
        }
    });
    return _monitor.apply(this, arguments);
}
function logout() {
    return _logout.apply(this, arguments);
}
function _logout() {
    _logout = _async_to_generator(function*() {
        const { success , request , failure  } = o365Effects.logout;
        request();
        try {
            yield o365Auth.logout();
            success();
            modules_notification/* notification.open */.t6.open({
                message: sensors_messages/* messages.notifications.userDisconnected */.s.notifications.userDisconnected
            });
            return;
        } catch (error) {
            failure(error);
            modules_notification/* notification.error */.t6.error({
                message: sensors_messages/* messages.notifications.logoutError */.s.notifications.logoutError,
                description: error.message
            });
            return Promise.reject(error);
        }
    });
    return _logout.apply(this, arguments);
}
function importUsers(users) {
    return _importUsers.apply(this, arguments);
}
function _importUsers() {
    _importUsers = _async_to_generator(function*(users) {
        const { success , request , failure  } = o365Effects.import;
        request();
        try {
            yield cloud_sensors/* o365SensorService.batch */.st.batch(users);
            success(users);
            modules_notification/* notification.open */.t6.open({
                message: sensors_messages/* messages.notifications.successfullyImported */.s.notifications.successfullyImported
            });
        } catch (error) {
            failure(error);
            modules_notification/* notification.error */.t6.error({
                message: sensors_messages/* messages.notifications.importError */.s.notifications.importError,
                description: error.message
            });
        }
    });
    return _importUsers.apply(this, arguments);
}
function enableForIds(users) {
    return _enableForIds.apply(this, arguments);
}
function _enableForIds() {
    _enableForIds = _async_to_generator(function*(users) {
        const { success , request , failure  } = o365Effects.enableForIds;
        request();
        try {
            yield o365SensorService.batch(users.map((id)=>({
                    id,
                    monitored: true
                })));
            success(users);
            notification.open({
                message: messages.notifications.usersMonitoringEnabled
            });
        } catch (error) {
            failure(error);
            notification.error({
                message: error.message
            });
        }
    });
    return _enableForIds.apply(this, arguments);
}
function login() {
    return _login.apply(this, arguments);
}
function _login() {
    _login = _async_to_generator(function*() {
        const { success , request , failure  } = o365Effects.login;
        request();
        try {
            const tenant = yield o365Auth.login();
            success(tenant);
        } catch (error) {
            failure(error);
            modules_notification/* notification.error */.t6.error({
                message: sensors_messages/* messages.notifications.o365LoginError */.s.notifications.o365LoginError,
                description: error.message
            });
        }
    });
    return _login.apply(this, arguments);
}
function getUser() {
    return _getUser.apply(this, arguments);
}
function _getUser() {
    _getUser = _async_to_generator(function*() {
        const { success , request , failure  } = o365Effects.getUser;
        request();
        try {
            const tenant = yield o365Auth.getUser();
            success(tenant);
        } catch (error) {
            failure(error);
        }
    });
    return _getUser.apply(this, arguments);
}
function toggle(_) {
    return _toggle.apply(this, arguments);
}
function _toggle() {
    _toggle = _async_to_generator(function*({ id , monitored  }) {
        const { success , request , failure  } = o365Effects.toggle;
        request();
        try {
            yield cloud_sensors/* o365SensorService.updateUser */.st.updateUser(id, {
                monitored
            });
            modules_notification/* notification.open */.t6.open({
                message: sensors_messages/* messages.notifications.userMonitoring */.s.notifications.userMonitoring(monitored)
            });
            success({
                id,
                monitored
            });
        } catch (error) {
            failure({
                id
            });
            modules_notification/* notification.error */.t6.error((0,modules_notification/* apiErrorNotification */.dE)(error));
        }
    });
    return _toggle.apply(this, arguments);
}
function toggleAll(params) {
    return _toggleAll.apply(this, arguments);
}
function _toggleAll() {
    _toggleAll = _async_to_generator(function*(params) {
        const { success , request , failure  } = o365Effects.enableAll;
        request();
        try {
            yield cloud_sensors/* o365SensorService.updateAll */.st.updateAll(params);
            modules_notification/* notification.open */.t6.open({
                message: sensors_messages/* messages.notifications.allUserMonitoring */.s.notifications.allUserMonitoring(params.monitored)
            });
            success(params);
        } catch (error) {
            failure();
            modules_notification/* notification.error */.t6.error((0,modules_notification/* apiErrorNotification */.dE)(error));
        }
    });
    return _toggleAll.apply(this, arguments);
}
function toggleAutoMonitoring(params) {
    return _toggleAutoMonitoring.apply(this, arguments);
}
function _toggleAutoMonitoring() {
    _toggleAutoMonitoring = _async_to_generator(function*(params) {
        try {
            yield cloud_sensors/* o365SensorService.toggleAutoMonitoring */.st.toggleAutoMonitoring(params);
            yield fetchUsers();
            modules_notification/* notification.open */.t6.open({
                message: sensors_messages/* messages.notifications.autoMonitoring */.s.notifications.autoMonitoring(params.monitored)
            });
        } catch (error) {
            modules_notification/* notification.error */.t6.error((0,modules_notification/* apiErrorNotification */.dE)(error));
        }
    });
    return _toggleAutoMonitoring.apply(this, arguments);
}


/***/ }),

/***/ 56432:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "uh": () => (/* binding */ fetchUsers),
  "PR": () => (/* binding */ getUser),
  "we": () => (/* binding */ importUsers),
  "x4": () => (/* binding */ login),
  "kS": () => (/* binding */ logout),
  "zk": () => (/* binding */ monitor),
  "cJ": () => (/* binding */ salesforceEffects),
  "ZN": () => (/* binding */ toggle),
  "li": () => (/* binding */ toggleAll),
  "Go": () => (/* binding */ toggleAutoMonitoring)
});

// UNUSED EXPORTS: enableForIds

// EXTERNAL MODULE: ./node_modules/lodash-es/reduce.js + 1 modules
var reduce = __webpack_require__(85697);
// EXTERNAL MODULE: ./node_modules/okdux/dist/lib/index.js + 6 modules
var lib = __webpack_require__(56804);
// EXTERNAL MODULE: ./src/api/cloud-sensors/index.ts + 3 modules
var cloud_sensors = __webpack_require__(40399);
// EXTERNAL MODULE: ./node_modules/axios/index.js
var axios = __webpack_require__(9669);
var axios_default = /*#__PURE__*/__webpack_require__.n(axios);
// EXTERNAL MODULE: ./src/api/auth/ExternalAuth.ts + 1 modules
var ExternalAuth = __webpack_require__(17988);
;// CONCATENATED MODULE: ./src/api/auth/SalesforceAuth.ts
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}


class SalesforceAuth extends ExternalAuth/* ExternalAuth */.y {
    isAuthorized() {
        return !!this.tenant;
    }
    login(_token, isSandbox) {
        const sandbox = isSandbox !== undefined && isSandbox === true;
        return this.authorize("/salesforce/login" + (sandbox ? "?sandbox" : ""), "Salesforce Login Consent").then(this.getUser);
    }
    logout() {
        return axios_default().get("/salesforce/logout").then((response)=>{
            this.tenant = undefined;
            return response;
        });
    }
    constructor(...args){
        super(...args);
        _define_property(this, "tenant", void 0);
        _define_property(this, "getUser", ()=>{
            if (this.isAuthorized()) {
                return this.tenant;
            }
            return axios_default().get("/salesforce/login/info", {
                meta: {
                    ignoreUnauthorized: true
                }
            }).then((response)=>{
                this.tenant = response.data;
                return this.tenant;
            });
        });
    }
}
const salesforceAuth = new SalesforceAuth();

// EXTERNAL MODULE: ./src/modules/notification/index.ts + 3 modules
var modules_notification = __webpack_require__(5769);
// EXTERNAL MODULE: ./src/modules/sensors/messages.ts
var sensors_messages = __webpack_require__(21301);
;// CONCATENATED MODULE: ./src/modules/sensors/salesforce.effects.ts
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}






const salesforceEffects = (0,lib/* createEffects */.xG)({
    fetchUsers: lib/* build.async */.J_.async(),
    login: lib/* build.async */.J_.async(),
    logout: lib/* build.async */.J_.async(),
    getUser: lib/* build.async */.J_.async(),
    toggle: lib/* build.async */.J_.async(),
    import: lib/* build.async */.J_.async(),
    enableAll: lib/* build.async */.J_.async(),
    enableForIds: lib/* build.async */.J_.async()
}, "salesforce");
function fetchUsers() {
    return _fetchUsers.apply(this, arguments);
}
function _fetchUsers() {
    _fetchUsers = _async_to_generator(function*(polling = false) {
        const { success , request , failure  } = salesforceEffects.fetchUsers;
        !polling && request();
        try {
            const data = yield cloud_sensors/* salesforceSensorService.fetchUsers */.Y1.fetchUsers();
            success(data);
        } catch (error) {
            failure();
            modules_notification/* notification.error */.t6.error((0,modules_notification/* apiErrorNotification */.dE)(error));
        }
    });
    return _fetchUsers.apply(this, arguments);
}
function monitor() {
    return _monitor.apply(this, arguments);
}
function _monitor() {
    _monitor = _async_to_generator(function*() {
        const { data  } = yield cloud_sensors/* salesforceSensorService.monitorUsers */.Y1.monitorUsers();
        const totalChanges = (0,reduce/* default */.Z)(data, countChanges, 0);
        return !!totalChanges;
        function countChanges(acc, changes) {
            return acc + changes.length;
        }
    });
    return _monitor.apply(this, arguments);
}
function logout() {
    return _logout.apply(this, arguments);
}
function _logout() {
    _logout = _async_to_generator(function*() {
        const { success , request , failure  } = salesforceEffects.logout;
        request();
        try {
            yield salesforceAuth.logout();
            success();
            modules_notification/* notification.open */.t6.open({
                message: sensors_messages/* messages.notifications.userDisconnected */.s.notifications.userDisconnected
            });
            return;
        } catch (error) {
            failure(error);
            modules_notification/* notification.error */.t6.error({
                message: sensors_messages/* messages.notifications.logoutError */.s.notifications.logoutError,
                description: error.message
            });
            return Promise.reject(error);
        }
    });
    return _logout.apply(this, arguments);
}
function importUsers(users) {
    return _importUsers.apply(this, arguments);
}
function _importUsers() {
    _importUsers = _async_to_generator(function*(users) {
        const { success , request , failure  } = salesforceEffects.import;
        request();
        try {
            yield cloud_sensors/* salesforceSensorService.batch */.Y1.batch(users);
            success(users);
            modules_notification/* notification.open */.t6.open({
                message: sensors_messages/* messages.notifications.successfullyImported */.s.notifications.successfullyImported
            });
        } catch (error) {
            failure(error);
            modules_notification/* notification.error */.t6.error({
                message: sensors_messages/* messages.notifications.importError */.s.notifications.importError,
                description: error.message
            });
        }
    });
    return _importUsers.apply(this, arguments);
}
function enableForIds(users) {
    return _enableForIds.apply(this, arguments);
}
function _enableForIds() {
    _enableForIds = _async_to_generator(function*(users) {
        const { success , request , failure  } = salesforceEffects.enableForIds;
        request();
        try {
            yield salesforceSensorService.batch(users.map((id)=>({
                    id,
                    monitored: true
                })));
            success(users);
            notification.open({
                message: messages.notifications.usersMonitoringEnabled
            });
        } catch (error) {
            failure(error);
            notification.error({
                message: error.message
            });
        }
    });
    return _enableForIds.apply(this, arguments);
}
function login(_) {
    return _login.apply(this, arguments);
}
function _login() {
    _login = _async_to_generator(function*({ isSandbox  }) {
        const { success , request , failure  } = salesforceEffects.login;
        request();
        try {
            const tenant = yield salesforceAuth.login(undefined, isSandbox);
            success(tenant);
        } catch (error) {
            failure(error);
            modules_notification/* notification.error */.t6.error({
                message: sensors_messages/* messages.notifications.salesForceError */.s.notifications.salesForceError,
                description: error.message
            });
        }
    });
    return _login.apply(this, arguments);
}
function getUser() {
    return _getUser.apply(this, arguments);
}
function _getUser() {
    _getUser = _async_to_generator(function*() {
        const { success , request , failure  } = salesforceEffects.getUser;
        request();
        try {
            const tenant = yield salesforceAuth.getUser();
            success(tenant);
        } catch (error) {
            failure(error);
        }
    });
    return _getUser.apply(this, arguments);
}
function toggle(_) {
    return _toggle.apply(this, arguments);
}
function _toggle() {
    _toggle = _async_to_generator(function*({ id , monitored  }) {
        const { success , request , failure  } = salesforceEffects.toggle;
        request();
        try {
            yield cloud_sensors/* salesforceSensorService.updateUser */.Y1.updateUser(id, {
                monitored
            });
            modules_notification/* notification.open */.t6.open({
                message: sensors_messages/* messages.notifications.userMonitoring */.s.notifications.userMonitoring(monitored)
            });
            success({
                id,
                monitored
            });
        } catch (error) {
            failure({
                id
            });
            modules_notification/* notification.error */.t6.error((0,modules_notification/* apiErrorNotification */.dE)(error));
        }
    });
    return _toggle.apply(this, arguments);
}
function toggleAll(params) {
    return _toggleAll.apply(this, arguments);
}
function _toggleAll() {
    _toggleAll = _async_to_generator(function*(params) {
        const { success , request , failure  } = salesforceEffects.enableAll;
        request();
        try {
            yield cloud_sensors/* salesforceSensorService.updateAll */.Y1.updateAll(params);
            modules_notification/* notification.open */.t6.open({
                message: sensors_messages/* messages.notifications.allUserMonitoring */.s.notifications.allUserMonitoring(params.monitored)
            });
            success(params);
        } catch (error) {
            failure();
            modules_notification/* notification.error */.t6.error((0,modules_notification/* apiErrorNotification */.dE)(error));
        }
    });
    return _toggleAll.apply(this, arguments);
}
function toggleAutoMonitoring(params) {
    return _toggleAutoMonitoring.apply(this, arguments);
}
function _toggleAutoMonitoring() {
    _toggleAutoMonitoring = _async_to_generator(function*(params) {
        try {
            yield cloud_sensors/* salesforceSensorService.toggleAutoMonitoring */.Y1.toggleAutoMonitoring(params);
            yield fetchUsers();
            modules_notification/* notification.open */.t6.open({
                message: sensors_messages/* messages.notifications.autoMonitoring */.s.notifications.autoMonitoring(params.monitored)
            });
        } catch (error) {
            modules_notification/* notification.error */.t6.error((0,modules_notification/* apiErrorNotification */.dE)(error));
        }
    });
    return _toggleAutoMonitoring.apply(this, arguments);
}



/***/ }),

/***/ 82333:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "W_": () => (/* binding */ initialTenantState),
/* harmony export */   "Wv": () => (/* binding */ sensorsState),
/* harmony export */   "Yl": () => (/* binding */ o365State),
/* harmony export */   "og": () => (/* binding */ salesforceState),
/* harmony export */   "uP": () => (/* binding */ gsuiteState)
/* harmony export */ });
/* harmony import */ var okdux__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(56804);
/* harmony import */ var libs_restatex__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(87063);
/* harmony import */ var _o365_effects__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(46150);
/* harmony import */ var _salesforce_effects__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(56432);
/* harmony import */ var _gsuite_effects__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(84778);
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}





const initialTenantState = {
    id: "",
    email: "",
    name: "",
    isSandbox: false
};
const gsuiteState = (0,okdux__WEBPACK_IMPORTED_MODULE_0__/* .createState */ .eK)({
    tenant: (0,okdux__WEBPACK_IMPORTED_MODULE_0__/* .createState */ .eK)(initialTenantState),
    connectedUsers: (0,okdux__WEBPACK_IMPORTED_MODULE_0__/* .createState */ .eK)([]),
    fetching: (0,libs_restatex__WEBPACK_IMPORTED_MODULE_1__/* .effectsFetching */ ._)(_gsuite_effects__WEBPACK_IMPORTED_MODULE_4__/* .gsuiteEffects */ .lj),
    autoMonitoringEnabled: (0,okdux__WEBPACK_IMPORTED_MODULE_0__/* .createState */ .eK)(false)
});
const o365State = (0,okdux__WEBPACK_IMPORTED_MODULE_0__/* .createState */ .eK)({
    tenant: (0,okdux__WEBPACK_IMPORTED_MODULE_0__/* .createState */ .eK)(initialTenantState),
    connectedUsers: (0,okdux__WEBPACK_IMPORTED_MODULE_0__/* .createState */ .eK)([]),
    fetching: (0,libs_restatex__WEBPACK_IMPORTED_MODULE_1__/* .effectsFetching */ ._)(_o365_effects__WEBPACK_IMPORTED_MODULE_2__/* .o365Effects */ .Gt),
    autoMonitoringEnabled: (0,okdux__WEBPACK_IMPORTED_MODULE_0__/* .createState */ .eK)(false)
});
const salesforceState = (0,okdux__WEBPACK_IMPORTED_MODULE_0__/* .createState */ .eK)({
    tenant: (0,okdux__WEBPACK_IMPORTED_MODULE_0__/* .createState */ .eK)(initialTenantState),
    connectedUsers: (0,okdux__WEBPACK_IMPORTED_MODULE_0__/* .createState */ .eK)([]),
    fetching: (0,libs_restatex__WEBPACK_IMPORTED_MODULE_1__/* .effectsFetching */ ._)(_salesforce_effects__WEBPACK_IMPORTED_MODULE_3__/* .salesforceEffects */ .cJ),
    autoMonitoringEnabled: (0,okdux__WEBPACK_IMPORTED_MODULE_0__/* .createState */ .eK)(false)
});
const sensorsState = (0,okdux__WEBPACK_IMPORTED_MODULE_0__/* .createState */ .eK)({
    o365: o365State,
    salesforce: salesforceState,
    gsuite: gsuiteState
});
salesforceState.on(_salesforce_effects__WEBPACK_IMPORTED_MODULE_3__/* .salesforceEffects["import"].success */ .cJ["import"].success, importUsers).on(_salesforce_effects__WEBPACK_IMPORTED_MODULE_3__/* .salesforceEffects.toggle.success */ .cJ.toggle.success, toggleUser).on(_salesforce_effects__WEBPACK_IMPORTED_MODULE_3__/* .salesforceEffects.enableAll.success */ .cJ.enableAll.success, enableAll).on(_salesforce_effects__WEBPACK_IMPORTED_MODULE_3__/* .salesforceEffects.fetchUsers.success */ .cJ.fetchUsers.success, setUsers).on(_salesforce_effects__WEBPACK_IMPORTED_MODULE_3__/* .salesforceEffects.login.success */ .cJ.login.success, setSalesforceTenant).on(_salesforce_effects__WEBPACK_IMPORTED_MODULE_3__/* .salesforceEffects.logout.success */ .cJ.logout.success, logout).on(_salesforce_effects__WEBPACK_IMPORTED_MODULE_3__/* .salesforceEffects.getUser.success */ .cJ.getUser.success, setSalesforceTenant);
o365State.on(_o365_effects__WEBPACK_IMPORTED_MODULE_2__/* .o365Effects["import"].success */ .Gt["import"].success, importUsers).on(_o365_effects__WEBPACK_IMPORTED_MODULE_2__/* .o365Effects.toggle.success */ .Gt.toggle.success, toggleUser).on(_o365_effects__WEBPACK_IMPORTED_MODULE_2__/* .o365Effects.enableAll.success */ .Gt.enableAll.success, enableAll).on(_o365_effects__WEBPACK_IMPORTED_MODULE_2__/* .o365Effects.fetchUsers.success */ .Gt.fetchUsers.success, setUsers).on(_o365_effects__WEBPACK_IMPORTED_MODULE_2__/* .o365Effects.login.success */ .Gt.login.success, setO365Tenant).on(_o365_effects__WEBPACK_IMPORTED_MODULE_2__/* .o365Effects.logout.success */ .Gt.logout.success, logout).on(_o365_effects__WEBPACK_IMPORTED_MODULE_2__/* .o365Effects.getUser.success */ .Gt.getUser.success, setO365Tenant);
gsuiteState.on(_gsuite_effects__WEBPACK_IMPORTED_MODULE_4__/* .gsuiteEffects["import"].success */ .lj["import"].success, importUsers).on(_gsuite_effects__WEBPACK_IMPORTED_MODULE_4__/* .gsuiteEffects.toggle.success */ .lj.toggle.success, toggleUser).on(_gsuite_effects__WEBPACK_IMPORTED_MODULE_4__/* .gsuiteEffects.enableAll.success */ .lj.enableAll.success, enableAll).on(_gsuite_effects__WEBPACK_IMPORTED_MODULE_4__/* .gsuiteEffects.fetchUsers.success */ .lj.fetchUsers.success, setUsers).on(_gsuite_effects__WEBPACK_IMPORTED_MODULE_4__/* .gsuiteEffects.login.success */ .lj.login.success, setGsuiteTenant).on(_gsuite_effects__WEBPACK_IMPORTED_MODULE_4__/* .gsuiteEffects.logout.success */ .lj.logout.success, logout).on(_gsuite_effects__WEBPACK_IMPORTED_MODULE_4__/* .gsuiteEffects.getUser.success */ .lj.getUser.success, setGsuiteTenant);
function enableAll(state, p) {
    return _object_spread_props(_object_spread({}, state), {
        connectedUsers: state.connectedUsers.map((user)=>_object_spread_props(_object_spread({}, user), {
                monitored: p.monitored
            }))
    });
}
function setUsers(state, payload) {
    return _object_spread_props(_object_spread({}, state), {
        autoMonitoringEnabled: payload.force_monitor_all,
        connectedUsers: payload.entities
    });
}
function setSalesforceTenant(state, payload) {
    const tenant = {
        id: payload.organization_id,
        email: payload.user_email,
        name: payload.user_name,
        isSandbox: payload.is_sandbox
    };
    return _object_spread_props(_object_spread({}, state), {
        tenant
    });
}
function setO365Tenant(state, payload) {
    const tenant = {
        id: payload.id,
        email: payload.default_domain,
        name: payload.display_name,
        isSandbox: false
    };
    return _object_spread_props(_object_spread({}, state), {
        tenant
    });
}
function setGsuiteTenant(state, payload) {
    const tenant = {
        id: payload.id,
        email: payload.default_domain,
        name: payload.display_name,
        isSandbox: false
    };
    return _object_spread_props(_object_spread({}, state), {
        tenant
    });
}
function logout(state) {
    return _object_spread_props(_object_spread({}, state), {
        tenant: _object_spread({}, initialTenantState)
    });
}
function importUsers(state, payload) {
    return payload.reduce(toggleUser, state);
}
function toggleUser(state, payload) {
    return _object_spread_props(_object_spread({}, state), {
        connectedUsers: state.connectedUsers.map((user)=>{
            if (user.id !== payload.id && user.email !== payload.email) {
                return user;
            }
            return _object_spread_props(_object_spread({}, user), {
                monitored: payload.monitored
            });
        })
    });
}



/***/ }),

/***/ 92531:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "J": () => (/* binding */ CheckBox)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(14212);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(50542);
/* harmony import */ var _mui_styles__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(72116);
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}



const StyledCheckbox = (0,_mui_styles__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({
    root: {
        "&:hover": {
            backgroundColor: "transparent !important"
        }
    }
})(_mui_material__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z);
function CheckBox(_param) {
    var { label ="" , checked , onChange , indeterminate =false  } = _param, rest = _object_without_properties(_param, [
        "label",
        "checked",
        "onChange",
        "indeterminate"
    ]);
    return /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_mui_material__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, _object_spread({
        label: label,
        onChange: onChange,
        control: /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(StyledCheckbox, {
            style: {
                padding: "0 5px 0px 8px"
            },
            checked: checked,
            indeterminate: indeterminate,
            disableTouchRipple: true,
            disableRipple: true,
            disableFocusRipple: true
        })
    }, rest));
}


/***/ }),

/***/ 96354:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "g": () => (/* binding */ FilterCard)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(2658);
/* harmony import */ var ui__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(17218);
/* harmony import */ var libs_layouts__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(5855);
/* harmony import */ var ui_atoms_Progress__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(32716);





const getPercentChartBackground = (isSelected)=>isSelected ? "white" : ui__WEBPACK_IMPORTED_MODULE_1__/* .theme.panelBackground.selectedColor */ .rS.panelBackground.selectedColor;
function FilterCard({ label , counter , subLabel , actions =null , selected , onClick =undefined , progressValues , progressColors , overlappingProgress , progressActive  }) {
    const isDisabled = counter === 0;
    return /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(ui__WEBPACK_IMPORTED_MODULE_1__/* .Box */ .xu, {
        sx: {
            paddingX: ui__WEBPACK_IMPORTED_MODULE_1__/* .space[2] */ .Dh[2],
            paddingY: ui__WEBPACK_IMPORTED_MODULE_1__/* .space[3] */ .Dh[3],
            background: selected ? ui__WEBPACK_IMPORTED_MODULE_1__/* .theme.panelBackground.selectedColor */ .rS.panelBackground.selectedColor : "#FFFFFF",
            width: "320px"
        },
        as: libs_layouts__WEBPACK_IMPORTED_MODULE_2__/* .Stack */ .Kq,
        space: 5,
        style: {
            boxShadow: selected ? "unset" : "0px 5px 12px rgba(0, 0, 0, 0.1)",
            cursor: !isDisabled ? "pointer" : "default"
        },
        onClick: !isDisabled ? onClick : undefined
    }, /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(libs_layouts__WEBPACK_IMPORTED_MODULE_2__/* .HStack */ .Ug, null, /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(ui__WEBPACK_IMPORTED_MODULE_1__/* .Box */ .xu, {
        disabled: isDisabled
    }, /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_mui_material__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
        variant: "subtitle2"
    }, label)), /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(libs_layouts__WEBPACK_IMPORTED_MODULE_2__/* .HStack.Spacer */ .Ug.Spacer, null), actions), /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(ui__WEBPACK_IMPORTED_MODULE_1__/* .Box */ .xu, {
        as: libs_layouts__WEBPACK_IMPORTED_MODULE_2__/* .Stack */ .Kq,
        space: 2,
        disabled: isDisabled
    }, /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(libs_layouts__WEBPACK_IMPORTED_MODULE_2__/* .HStack */ .Ug, {
        align: "baseline"
    }, /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_mui_material__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
        variant: "h4"
    }, counter), " ", /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_mui_material__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
        variant: "body2"
    }, subLabel)), /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(ui_atoms_Progress__WEBPACK_IMPORTED_MODULE_3__/* .LineProgress */ .E, {
        overlap: overlappingProgress,
        minValue: 5,
        options: progressValues.map((el, i)=>{
            return {
                value: el !== null && el !== void 0 ? el : 0,
                color: progressColors[i],
                isActive: progressActive === null || progressActive === void 0 ? void 0 : progressActive[i]
            };
        }),
        style: {
            background: getPercentChartBackground(selected)
        }
    })));
}


/***/ }),

/***/ 53144:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "m": () => (/* binding */ GenericTable)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var shared_permissions__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(44916);
/* harmony import */ var libs_css_grid_table__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(81252);
/* harmony import */ var ui__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(17218);
/* harmony import */ var ui_css__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(93461);
/* harmony import */ var _TableFilters__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(16348);
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}






(0,ui__WEBPACK_IMPORTED_MODULE_3__/* .containerStyles */ .Fc)();
const noItemsStyles = (0,ui_css__WEBPACK_IMPORTED_MODULE_4__/* .css */ .iv)({
    position: "absolute",
    height: "calc(100% - 100px)",
    top: "50px"
});
const HEADER_ACTIONS_ID = "header-actions";
const headerCellStyles = (0,ui_css__WEBPACK_IMPORTED_MODULE_4__/* .css */ .iv)({
    [`&[data-column=${HEADER_ACTIONS_ID}]`]: {
        borderLeft: "none"
    }
});
const thHeaderStyles = (0,ui_css__WEBPACK_IMPORTED_MODULE_4__/* .css */ .iv)({
    [`&[data-id=${HEADER_ACTIONS_ID}]`]: {
        borderLeft: "none"
    }
});
function GenericTable(props) {
    var _props_data;
    let expand = props.expand;
    if (props.autoExpandIfLessThan && props.autoExpandIfLessThan === ((_props_data = props.data) === null || _props_data === void 0 ? void 0 : _props_data.length)) {
        expand = Array.from(new Array(props.autoExpandIfLessThan)).reduce((acc, _, index)=>{
            acc[index] = true;
            return acc;
        }, {});
    }
    const rawColumns = react__WEBPACK_IMPORTED_MODULE_0__.useMemo(()=>{
        const columns = [
            ...props.columns || []
        ];
        if (props.headerActions) {
            columns.push({
                id: HEADER_ACTIONS_ID,
                width: 60,
                Header: ()=>/*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement("span", null, props.headerActions),
                className: headerCellStyles().className,
                thClassName: thHeaderStyles().className
            });
        }
        return columns;
    }, [
        props.columns,
        props.headerActions
    ]);
    const columns = (0,shared_permissions__WEBPACK_IMPORTED_MODULE_1__/* .useCanArray */ .tn)({
        items: rawColumns,
        getItemPermission: (field)=>field.requiredPermissions || field.requiredPermissionsAnyOf,
        isDoEither: (field)=>!!field.requiredPermissionsAnyOf
    });
    return /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(libs_css_grid_table__WEBPACK_IMPORTED_MODULE_2__/* .TableBody */ .RM, _object_spread_props(_object_spread({
        infiniteScrollRef: props === null || props === void 0 ? void 0 : props.infiniteScrollRef,
        getId: (v)=>v["id"],
        ThComponent: _TableFilters__WEBPACK_IMPORTED_MODULE_5__/* .ThWithFilter */ .K,
        expandPosIndex: 1,
        loader: /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(ui__WEBPACK_IMPORTED_MODULE_3__/* .Loader */ .aN, {
            loading: true
        }),
        noData: /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(ui__WEBPACK_IMPORTED_MODULE_3__/* .NoItemsFullpage */ .eO, {
            className: noItemsStyles().className
        }),
        striped: true,
        expand: expand,
        theadProps: {
            "data-fs": "unmask"
        },
        loading: props.isLoading || !columns
    }, props), {
        columns: columns
    }));
}


/***/ }),

/***/ 16348:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "K": () => (/* binding */ ThWithFilter),
/* harmony export */   "s": () => (/* binding */ useTableFilterPopover)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(111);
/* harmony import */ var assets_icons__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(99899);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(2658);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(72642);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(62206);
/* harmony import */ var libs_hooks__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(88289);
/* harmony import */ var libs_dom__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(76376);
/* harmony import */ var libs_layouts__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(5855);
/* harmony import */ var ui__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(17218);
/* harmony import */ var libs_css_grid_table_ThContent__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(87287);
/* harmony import */ var _Checkbox__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(92531);
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}










const useFetchNext = (container, el, distance, cb, enabled)=>{
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(()=>{
        if (!container.current || !el.current || !enabled) {
            return;
        }
        const onScroll = (0,lodash__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(()=>{
            var _container_current, _el_current;
            const containerBox = (_container_current = container.current) === null || _container_current === void 0 ? void 0 : _container_current.getBoundingClientRect();
            const elBox = (_el_current = el.current) === null || _el_current === void 0 ? void 0 : _el_current.getBoundingClientRect();
            if (!elBox || !containerBox) {
                return;
            }
            if (elBox.top - containerBox.bottom < distance) {
                cb();
            }
        }, 100);
        return (0,libs_dom__WEBPACK_IMPORTED_MODULE_3__/* .subscribeEvent */ .o5)(container.current, "scroll", onScroll);
    }, [
        container.current,
        el.current,
        enabled,
        distance
    ]);
};
function FilterForm({ title , useOptions , values , onChange , renderOptionLabel  }) {
    const containerRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(null);
    const loadMoreRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(null);
    const [search, setSearch] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)("");
    const { isLoading , data , fetchMore , canFetchMore , isFetchingMore  } = useOptions(search);
    const options = data || [];
    const isAllChecked = new Set(options.map((o)=>o.value)).size === (values === null || values === void 0 ? void 0 : values.size); // todo
    const isIndeterminate = !isAllChecked && (values === null || values === void 0 ? void 0 : values.size) > 0;
    const isChecked = (option)=>values && values.has(option.value); // todo
    const toggleAll = ()=>{
        if (isAllChecked) {
            onChange([]);
        } else {
            onChange(options.map((o)=>o.value));
        }
    };
    useFetchNext(containerRef, loadMoreRef, 100, fetchMore, !!canFetchMore && !isFetchingMore);
    return /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(ui__WEBPACK_IMPORTED_MODULE_5__/* .Box */ .xu, {
        ref: containerRef,
        as: libs_layouts__WEBPACK_IMPORTED_MODULE_4__/* .Stack */ .Kq,
        sx: {
            paddingX: ui__WEBPACK_IMPORTED_MODULE_5__/* .space[3] */ .Dh[3],
            paddingY: ui__WEBPACK_IMPORTED_MODULE_5__/* .space[4] */ .Dh[4]
        },
        space: 4,
        style: {
            maxHeight: 500,
            overflow: "auto"
        }
    }, /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_mui_material__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
        variant: "subtitle2"
    }, title), /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(ui__WEBPACK_IMPORTED_MODULE_5__/* .SearchInput */ .Mj, {
        showCancel: true,
        onCancel: ()=>setSearch(""),
        onRequestSearch: setSearch,
        style: {
            flexShrink: 0
        }
    }), /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(libs_layouts__WEBPACK_IMPORTED_MODULE_4__/* .Stack */ .Kq, null, !isLoading && (options === null || options === void 0 ? void 0 : options.length) === 0 ? null : /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_Checkbox__WEBPACK_IMPORTED_MODULE_7__/* .CheckBox */ .J, {
        label: "Select All",
        color: "primary",
        checked: isAllChecked || isIndeterminate,
        indeterminate: isIndeterminate,
        onChange: toggleAll,
        style: {
            flexShrink: 0
        }
    }), /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(ui__WEBPACK_IMPORTED_MODULE_5__/* .Loader */ .aN, {
        loading: isLoading
    }, options === null || options === void 0 ? void 0 : options.map((option, i)=>{
        const checked = isChecked(option);
        const label = renderOptionLabel ? renderOptionLabel(option) : option.label;
        return /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_Checkbox__WEBPACK_IMPORTED_MODULE_7__/* .CheckBox */ .J, {
            style: {
                flexShrink: 0
            },
            key: option.label + option.value + i,
            label: label,
            checked: checked,
            onChange: ()=>{
                const newSet = new Set(values);
                if (checked) {
                    newSet.delete(option.value);
                } else {
                    newSet.add(option.value);
                }
                onChange(Array.from(newSet));
            }
        });
    }), (options === null || options === void 0 ? void 0 : options.length) === 0 && /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_mui_material__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, null, "No items found")), canFetchMore && /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_mui_material__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {
        size: "small",
        color: "secondary",
        ref: loadMoreRef,
        disabled: !!isFetchingMore,
        onClick: ()=>fetchMore()
    }, isFetchingMore ? "Loading more..." : canFetchMore ? "Load more" : "Nothing more to load")));
}
function useTableFilterPopover(props) {
    return (0,libs_hooks__WEBPACK_IMPORTED_MODULE_2__/* .usePopover */ .Sv)((api)=>/*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_mui_material__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .ZP, _object_spread_props(_object_spread({}, api), {
            anchorOrigin: {
                horizontal: "right",
                vertical: "bottom"
            },
            transformOrigin: {
                horizontal: "right",
                vertical: "top"
            }
        }), /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(FilterForm, props)));
}
function ThWithFilter(props // todo types
) {
    var _props_filterOptions_getValues;
    const hasFilters = !!props.filterOptions;
    const filters = hasFilters ? props.filterOptions.useFilters() : {};
    const [filterNode, actions] = hasFilters ? useTableFilterPopover({
        onChange: props.filterOptions.getOnChange(filters),
        title: `Filter by ${props.column.Header}`,
        useOptions: props.filterOptions.useOptions,
        values: props.filterOptions.getValues(filters),
        renderOptionLabel: props.filterOptions.renderOptionLabel
    }) : [
        null
    ];
    return /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(libs_css_grid_table_ThContent__WEBPACK_IMPORTED_MODULE_6__/* .DefaultThContent */ .t, props, /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(libs_layouts__WEBPACK_IMPORTED_MODULE_4__/* .HStack */ .Ug, {
        space: 3
    }, /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement("span", null, props.children), hasFilters && /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(assets_icons__WEBPACK_IMPORTED_MODULE_1__/* .FiltersIcon */ .sH, {
        fontSize: "small",
        color: ((_props_filterOptions_getValues = props.filterOptions.getValues(filters)) === null || _props_filterOptions_getValues === void 0 ? void 0 : _props_filterOptions_getValues.size) > 0 ? "primary" : "action",
        onClick: (e)=>{
            return actions === null || actions === void 0 ? void 0 : actions.onOpen(e.currentTarget);
        }
    }), filterNode));
}


/***/ }),

/***/ 75319:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "a": () => (/* binding */ TableProvider),
/* harmony export */   "o": () => (/* binding */ useTableState)
/* harmony export */ });
/* harmony import */ var constate__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(11521);

function useTableStateI({ selection , sort , settings  }) {
    return {
        selection,
        sort,
        settings
    };
}
const [TableProvider, useTableState] = (0,constate__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(useTableStateI);


/***/ }),

/***/ 44649:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "P": () => (/* binding */ TopLevelFilters)
/* harmony export */ });
/* unused harmony export FilterSkeleton */
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _mui_material_Skeleton__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(28973);
/* harmony import */ var libs_layouts__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5855);



function FilterSkeleton({ count =3  }) {
    return Array.from({
        length: count
    }, (_, i)=>/*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_mui_material_Skeleton__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
            animation: "wave",
            variant: "rectangular",
            key: i,
            height: 128,
            width: 320
        }));
}
function TopLevelFilters({ isLoading , children  }) {
    return /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(libs_layouts__WEBPACK_IMPORTED_MODULE_1__/* .HStack */ .Ug, {
        "data-fs": "unmask",
        space: 2,
        style: {
            userSelect: "none"
        }
    }, isLoading ? /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(FilterSkeleton, {
        count: react__WEBPACK_IMPORTED_MODULE_0__.Children.toArray(children).length
    }) : /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Fragment, null, children));
}


/***/ }),

/***/ 25373:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "WJ": () => (/* reexport */ AsyncChip),
  "Af": () => (/* reexport */ Chip),
  "j3": () => (/* reexport */ ExportButton),
  "gM": () => (/* reexport */ FilterCard/* FilterCard */.g),
  "x$": () => (/* reexport */ Filters),
  "m": () => (/* reexport */ Table/* GenericTable */.m),
  "Pc": () => (/* reexport */ GlobalSearchBar),
  "tl": () => (/* reexport */ Pagination),
  "or": () => (/* reexport */ TableSelectionCheckbox),
  "L0": () => (/* reexport */ upperFirstEach),
  "Kx": () => (/* reexport */ useCollection/* useCollection */.Kx),
  "mN": () => (/* reexport */ useFilters),
  "yJ": () => (/* reexport */ useCollection/* useInfiniteScrollCollection */.yJ),
  "rK": () => (/* reexport */ useCollection/* useSorting */.rK),
  "oy": () => (/* reexport */ TableProvider/* useTableState */.o)
});

// UNUSED EXPORTS: FilterLabel, FilterSkeleton, TableProvider, TopLevelFilters, computeFilters

// EXTERNAL MODULE: ./node_modules/lodash-es/isEqual.js
var isEqual = __webpack_require__(50576);
// EXTERNAL MODULE: ./node_modules/lodash-es/upperFirst.js + 1 modules
var upperFirst = __webpack_require__(85295);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/shared/index.ts
var shared = __webpack_require__(10451);
;// CONCATENATED MODULE: ./src/modules/table/useFilters.tsx
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}



function useParamWithCallback(name, initialValue, keepInHistory = true, cb) {
    const [value, setValue] = (0,shared/* useHistoryParam */.BU)(name, initialValue instanceof Set ? [
        ...initialValue
    ] : initialValue, keepInHistory);
    return [
        initialValue instanceof Set ? new Set(value) : value,
        (v, preventOrderChange = false)=>{
            const res = setValue(v instanceof Set ? [
                ...v
            ] : v);
            !preventOrderChange && cb(name);
            return res;
        }
    ];
}
const useFilters = (config)=>{
    var _config;
    const [lastActive, setFiltersOrder] = (0,react.useState)("");
    var _queryKeyPrefix;
    (_queryKeyPrefix = (_config = config).queryKeyPrefix) !== null && _queryKeyPrefix !== void 0 ? _queryKeyPrefix : _config.queryKeyPrefix = "";
    const filters = {};
    for(const key in config.filters){
        var _config_initialValue;
        const filter = config.filters[key];
        var _config_initialValue_key;
        const hookDefaultValue = (_config_initialValue_key = (_config_initialValue = config.initialValue) === null || _config_initialValue === void 0 ? void 0 : _config_initialValue[key]) !== null && _config_initialValue_key !== void 0 ? _config_initialValue_key : filter.defaultValue;
        const [value, setValue] = useParamWithCallback(config.queryKeyPrefix + filter.queryKey, hookDefaultValue, true, ()=>{
            setFiltersOrder(key);
        });
        filters[key] = {
            value: value,
            setValue: setValue,
            reset: ()=>setValue(filter.defaultValue),
            isDefault: (0,isEqual/* default */.Z)(filter.defaultValue, value),
            isClearAll: typeof config.clearAllFilter !== "function" || config.clearAllFilter(key),
            isZero: Array.isArray(value) ? value.length === 0 : value instanceof Set ? value.size === 0 : !value,
            queryKey: filter.queryKey
        };
    }
    const resetAll = ()=>{
        for(const k in filters){
            if (filters[k].isClearAll) {
                filters[k].reset();
            }
        }
    };
    const outFilters = {};
    for(const key in config.filters){
        outFilters[key] = filters[key].value;
        outFilters[`reset${(0,upperFirst/* default */.Z)(key)}`] = filters[key].reset;
        outFilters[`set${(0,upperFirst/* default */.Z)(key)}`] = filters[key].setValue;
    }
    return _object_spread_props(_object_spread({}, outFilters), {
        resetAll,
        getChipsFilterProps () {
            return {
                filters,
                resetAll,
                lastActive
            };
        }
    });
};

// EXTERNAL MODULE: ./node_modules/@mui/material/Link/Link.js + 2 modules
var Link = __webpack_require__(1079);
// EXTERNAL MODULE: ./node_modules/@mui/material/Box/Box.js
var Box = __webpack_require__(99226);
// EXTERNAL MODULE: ./src/libs/data-utils/index.ts + 5 modules
var data_utils = __webpack_require__(50082);
// EXTERNAL MODULE: ./src/libs/hooks/index.ts + 18 modules
var hooks = __webpack_require__(88289);
// EXTERNAL MODULE: ./src/libs/layouts/index.tsx + 2 modules
var layouts = __webpack_require__(5855);
// EXTERNAL MODULE: ./src/ui/atoms/index.ts + 36 modules
var atoms = __webpack_require__(1582);
// EXTERNAL MODULE: ./src/ui/molecules/Popover.tsx
var Popover = __webpack_require__(90402);
;// CONCATENATED MODULE: ./src/modules/table/Chip.tsx
/* eslint-disable @typescript-eslint/no-unused-vars */ function Chip_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function Chip_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            Chip_define_property(target, key, source[key]);
        });
    }
    return target;
}
function Chip_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function Chip_object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        Chip_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}








function FilterLabel({ prefix , items , shouldJoinItems  }) {
    return /*#__PURE__*/ react.createElement(layouts/* HStack */.Ug, {
        align: "center",
        space: 1,
        className: "filter-label",
        style: {
            display: "inline-flex"
        }
    }, prefix && /*#__PURE__*/ react.createElement("span", {
        "data-fs": "unmask"
    }, prefix, ":"), shouldJoinItems ? (0,data_utils/* jsxJoin */.eL)(items.map((el)=>/*#__PURE__*/ react.createElement("span", null, el)), ()=>/*#__PURE__*/ react.createElement("b", null, " OR ")) : items.map((el, i)=>/*#__PURE__*/ react.createElement("span", {
            key: i
        }, el)));
}
function replacer(_, value) {
    if (value instanceof Map) {
        return {
            dataType: "Map",
            value: Array.from(value.entries())
        };
    } else if (value instanceof Set) {
        return {
            dataType: "Set",
            value: Array.from(value.keys())
        };
    } else {
        return value;
    }
}
const upperFirstEach = (v)=>[
        ...v
    ].map(upperFirst/* default */.Z);
function Chip(_param) {
    var { animateMount =false , hasDelete =true , hideDefault , isDefault , isZero: _ , showEmpty: ____ , isClearAll: _____ , label =(v)=>v , name , onDelete , prefix , context: ___ , setValue: ______ , value , icon , labelIcon , shouldJoinLabel =true  } = _param, props = _object_without_properties(_param, [
        "animateMount",
        "hasDelete",
        "hideDefault",
        "isDefault",
        "isZero",
        "showEmpty",
        "isClearAll",
        "label",
        "name",
        "onDelete",
        "prefix",
        "context",
        "setValue",
        "value",
        "icon",
        "labelIcon",
        "shouldJoinLabel"
    ]);
    const animateKey = (0,react.useMemo)(()=>{
        return JSON.stringify(value, replacer);
    }, [
        value
    ]);
    const { ref  } = (0,hooks/* useAnimatedChange */.FL)({
        key: animateKey,
        animateMount,
        keyframes: {
            background: [
                "white",
                "#E3F2FD",
                "white"
            ]
        },
        duration: 1000,
        easing: "ease-in-out"
    });
    if (hideDefault && isDefault) {
        return null;
    }
    const textLabel = label(value);
    const items = Array.isArray(textLabel) ? textLabel : [
        textLabel
    ];
    const [visible, truncated] = (0,data_utils/* partition */.uK)(items, (_, i)=>i < 3);
    const hasNoIcons = (isDefault || !hasDelete) && !labelIcon;
    return /*#__PURE__*/ react.createElement(atoms/* FilterChip */.GH, Chip_object_spread_props(Chip_object_spread({
        label: /*#__PURE__*/ react.createElement(layouts/* HStack */.Ug, {
            style: {
                paddingRight: hasNoIcons ? "8px" : 0
            }
        }, /*#__PURE__*/ react.createElement(FilterLabel, {
            prefix: prefix,
            items: visible,
            shouldJoinItems: shouldJoinLabel
        }), truncated.length > 0 && /*#__PURE__*/ react.createElement(Popover/* Popover */.J, {
            target: ({ onClick  })=>/*#__PURE__*/ react.createElement(Link/* default */.Z, {
                    color: "textPrimary",
                    underline: "always",
                    onClick: onClick
                }, "+", truncated.length, " more")
        }, /*#__PURE__*/ react.createElement(layouts/* Stack */.Kq, {
            as: Box/* default */.Z,
            space: 2,
            padding: 2
        }, truncated.map((el, i)=>/*#__PURE__*/ react.createElement("span", {
                key: i
            }, el)))), labelIcon && /*#__PURE__*/ react.createElement(Box/* default */.Z, {
            style: {
                display: "flex",
                marginLeft: 0,
                padding: "0px 4px 0 8px",
                alignItems: "center"
            }
        }, labelIcon)),
        icon: icon,
        ref: ref
    }, props), {
        className: "filter-chip",
        onDelete: isDefault || !hasDelete ? undefined : onDelete
    }));
}
function AsyncChip(_param) {
    var { useValue , value , name , label  } = _param, props = _object_without_properties(_param, [
        "useValue",
        "value",
        "name",
        "label"
    ]);
    const { data  } = useValue();
    return /*#__PURE__*/ react.createElement(Chip, Chip_object_spread_props(Chip_object_spread({}, props), {
        value: value,
        label: ()=>data ? label(data, value) : [
                "Loading ..."
            ]
    }));
}

// EXTERNAL MODULE: ./src/libs/hooks/useMemoize.ts
var useMemoize = __webpack_require__(12541);
// EXTERNAL MODULE: ./src/ui/molecules/TruncateFilters/index.ts + 4 modules
var TruncateFilters = __webpack_require__(2699);
;// CONCATENATED MODULE: ./src/modules/table/Filters.tsx



function Filters({ filters , children , resetAll , showClearAll , lastActive , start , end , fixedSize , showPrefix =true  }) {
    const { nodes , isAllDefault  } = (0,useMemoize/* useMemoize */.P)(computeFilters, [
        filters,
        children,
        lastActive
    ]);
    return /*#__PURE__*/ react.createElement(TruncateFilters/* TruncateFilters */.gm, {
        showPrefix: showPrefix,
        fixedElements: fixedSize,
        hideClearAll: isAllDefault && !showClearAll,
        clearAll: resetAll
    }, start, nodes, end);
}
// Just connects chip components with filters state to create stateful chip comnonents
function computeFilters(filters, chips, lastActiveName) {
    const children = react.Children.toArray(chips);
    const chipsMaps = Object.fromEntries(children.map((el)=>[
            el.props.name,
            el
        ]));
    const items = [];
    for (const node of children){
        var _node_props, _node_props1;
        if (!node || !(node === null || node === void 0 ? void 0 : (_node_props = node.props) === null || _node_props === void 0 ? void 0 : _node_props.name)) {
            continue;
        }
        const name = node.props.name;
        const config = filters[name];
        if (!config.isZero || (node === null || node === void 0 ? void 0 : (_node_props1 = node.props) === null || _node_props1 === void 0 ? void 0 : _node_props1.showEmpty)) {
            items.push(name);
        }
    }
    const filterNodeItems = items.map((key)=>{
        var _chipNode_props;
        const chipNode = chipsMaps[key];
        const filterItem = filters[key];
        if (filterItem.isZero && !(chipNode === null || chipNode === void 0 ? void 0 : (_chipNode_props = chipNode.props) === null || _chipNode_props === void 0 ? void 0 : _chipNode_props.showEmpty) || !chipNode) {
            return null;
        }
        return /*#__PURE__*/ react.cloneElement(chipNode, {
            key,
            name: key,
            isDefault: filterItem.isDefault,
            isZero: filterItem.isZero,
            value: filterItem.value,
            setValue: filterItem.setValue,
            isClearAll: filterItem.isClearAll,
            context: filters,
            animateMount: lastActiveName === key,
            onDelete: filterItem.reset
        });
    });
    const isAllDefault = filterNodeItems.filter(Boolean).every((el)=>{
        if (!el.props.isDefault && el.props.isClearAll) {
            return el.props.isZero;
        }
        return true;
    });
    return {
        nodes: filterNodeItems,
        isAllDefault
    };
}

// EXTERNAL MODULE: ./src/assets/icons/index.tsx + 1 modules
var icons = __webpack_require__(99899);
// EXTERNAL MODULE: ./src/runenv.tsx
var runenv = __webpack_require__(76223);
// EXTERNAL MODULE: ./node_modules/@mui/material/Input/Input.js
var Input = __webpack_require__(79332);
// EXTERNAL MODULE: ./node_modules/@mui/material/InputAdornment/InputAdornment.js + 1 modules
var InputAdornment = __webpack_require__(80270);
// EXTERNAL MODULE: ./node_modules/@mui/material/IconButton/IconButton.js + 1 modules
var IconButton = __webpack_require__(6867);
;// CONCATENATED MODULE: ./src/modules/table/GlobalSearchBar.tsx




function GlobalSearchBar({ value , setValue  }) {
    // show global search if it's enabled, or if the user got a link with it
    if (!(runenv/* ENV.FEATURES.ENABLE_GLOBAL_SEARCH */.V.FEATURES.ENABLE_GLOBAL_SEARCH || value !== "")) {
        return null;
    }
    const [localValue, setLocalValue] = (0,react.useState)(value);
    (0,react.useEffect)(()=>{
        setLocalValue(value);
    }, [
        value
    ]);
    return /*#__PURE__*/ react.createElement(Input/* default */.Z, {
        placeholder: "Search Query (CEL)",
        sx: {
            ml: 2,
            minWidth: "100px",
            flexGrow: 1
        },
        value: localValue,
        onChange: (e)=>setLocalValue(e.target.value),
        onKeyPress: (e)=>{
            if (e.key === "Enter") {
                e.preventDefault();
                setValue(localValue);
            }
        },
        onBlur: ()=>{
            setValue(localValue);
        },
        endAdornment: localValue === value ? null : /*#__PURE__*/ react.createElement(InputAdornment/* default */.Z, {
            position: "end"
        }, /*#__PURE__*/ react.createElement(IconButton/* default */.Z, {
            onClick: ()=>setValue(localValue)
        }, /*#__PURE__*/ react.createElement(icons/* SearchIcon */.W1, null)))
    });
}

// EXTERNAL MODULE: ./node_modules/@mui/material/TablePagination/TablePagination.js + 5 modules
var TablePagination = __webpack_require__(11047);
// EXTERNAL MODULE: ./node_modules/@mui/material/Skeleton/Skeleton.js + 2 modules
var Skeleton = __webpack_require__(28973);
// EXTERNAL MODULE: ./src/ui/css/index.ts
var css = __webpack_require__(93461);
;// CONCATENATED MODULE: ./src/modules/table/Pagination.tsx
function Pagination_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function Pagination_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            Pagination_define_property(target, key, source[key]);
        });
    }
    return target;
}
function Pagination_object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = Pagination_object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function Pagination_object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}





const spacerStyles = (0,css/* css */.iv)({
    display: "none"
});
const toolbarStyles = (0,css/* css */.iv)({
    justifyContent: "flex-end"
});
const selectLabelStyles = (0,css/* css */.iv)({
    color: "#757575"
});
const displayedRowsStyles = (0,css/* css */.iv)({
    color: "#757575"
});
const selectStyles = (0,css/* css */.iv)({
    "&.MuiSelect-select": {
        fontSize: "0.9375rem"
    }
});
const selectIconStyles = (0,css/* css */.iv)({
    "&.MuiTablePagination-selectIcon": {
        top: "calc(50% - 12px)"
    }
});
const classes = {
    spacer: spacerStyles().className,
    select: selectStyles().className,
    toolbar: toolbarStyles().className,
    selectLabel: selectLabelStyles().className,
    selectIcon: selectIconStyles().className,
    displayedRows: displayedRowsStyles().className
};
function Pagination(_param) {
    var { onChangePage , isNextDisabled , isPrevDisabled , isLoading , count =0 , page =0 , perPage: rowsPerPage = 0 , isLastPage , onChangePerPage , lazyCount  } = _param, props = Pagination_object_without_properties(_param, [
        "onChangePage",
        "isNextDisabled",
        "isPrevDisabled",
        "isLoading",
        "count",
        "page",
        "perPage",
        "isLastPage",
        "onChangePerPage",
        "lazyCount"
    ]);
    if (isLoading) {
        return /*#__PURE__*/ react.createElement(layouts/* HStack */.Ug, {
            space: 2
        }, /*#__PURE__*/ react.createElement(Skeleton/* default */.Z, {
            width: "150px",
            height: "55px"
        }), /*#__PURE__*/ react.createElement(Skeleton/* default */.Z, {
            width: "200px",
            height: "55px"
        }));
    }
    return /*#__PURE__*/ react.createElement(TablePagination/* default */.Z, Pagination_object_spread({
        component: "div",
        classes: classes,
        rowsPerPageOptions: [
            10,
            25,
            50,
            100
        ],
        nextIconButtonProps: {
            disabled: isNextDisabled || isLastPage
        },
        backIconButtonProps: {
            disabled: isPrevDisabled || page === 0
        },
        labelDisplayedRows: ({ count  })=>{
            const totalCount = Math.ceil(count / rowsPerPage);
            if (lazyCount && count > rowsPerPage) {
                count = Infinity;
            }
            return `${page + 1} of ${count === Infinity ? "Many" : totalCount}`;
        },
        onPageChange: (_, n)=>{
            if (onChangePage) {
                onChangePage(n);
            }
        },
        count: count,
        page: page,
        onRowsPerPageChange: (e)=>{
            onChangePerPage === null || onChangePerPage === void 0 ? void 0 : onChangePerPage(parseInt(e.target.value, 10));
        },
        rowsPerPage: rowsPerPage
    }, props));
}

// EXTERNAL MODULE: ./src/modules/table/useCollection.tsx
var useCollection = __webpack_require__(92930);
// EXTERNAL MODULE: ./src/modules/table/TopLevelFilters.tsx
var TopLevelFilters = __webpack_require__(44649);
// EXTERNAL MODULE: ./src/modules/table/Table.tsx
var Table = __webpack_require__(53144);
// EXTERNAL MODULE: ./src/modules/table/FilterCard.tsx
var FilterCard = __webpack_require__(96354);
// EXTERNAL MODULE: ./node_modules/@mui/material/Select/Select.js + 2 modules
var Select = __webpack_require__(6733);
// EXTERNAL MODULE: ./node_modules/@mui/material/MenuItem/MenuItem.js + 1 modules
var MenuItem = __webpack_require__(33797);
// EXTERNAL MODULE: ./src/modules/table/Checkbox.tsx
var Checkbox = __webpack_require__(92531);
;// CONCATENATED MODULE: ./src/modules/table/messages.ts
const tableMessages = {
    allOnThisPage: "Select all on this page",
    allOnAllPages: "Select all on all pages"
};

// EXTERNAL MODULE: ./src/modules/table/TableProvider.tsx
var TableProvider = __webpack_require__(75319);
;// CONCATENATED MODULE: ./src/modules/table/TableSelectionCheckbox.tsx







const TableSelectionCheckbox_selectStyles = (0,css/* css */.iv)({
    paddingTop: 3
});
function SelectHeader({ "data-testid": testId , hasSelectOnAllPages =true  }) {
    const { selection: { selectedSize , isAllSelected , isAllOnAllPageSelected , selectAll , toggleAll , selectOnAllPages  }  } = (0,TableProvider/* useTableState */.o)();
    const onSelectChange = (e)=>{
        if (e.target.value === "current") {
            selectAll();
        } else if (e.target.value === "all") {
            selectOnAllPages();
        }
    };
    return /*#__PURE__*/ react.createElement(layouts/* HStack */.Ug, {
        "data-testid": testId,
        space: -1
    }, /*#__PURE__*/ react.createElement(Checkbox/* CheckBox */.J, {
        indeterminate: selectedSize > 0 && !isAllSelected && !isAllOnAllPageSelected,
        checked: selectedSize > 0 || isAllOnAllPageSelected,
        onChange: toggleAll,
        style: {
            marginRight: 0
        }
    }), hasSelectOnAllPages && /*#__PURE__*/ react.createElement(Select/* default */.Z, {
        value: "",
        margin: "dense",
        disableUnderline: true,
        variant: "standard",
        classes: {
            select: TableSelectionCheckbox_selectStyles().className
        },
        onChange: onSelectChange,
        SelectDisplayProps: {
            style: {
                paddingRight: 10
            }
        }
    }, /*#__PURE__*/ react.createElement(MenuItem/* default */.Z, {
        value: "current"
    }, tableMessages.allOnThisPage), /*#__PURE__*/ react.createElement(MenuItem/* default */.Z, {
        value: "all"
    }, tableMessages.allOnAllPages)));
}
function TableSelectionCheckbox({ "data-testid": testId , row  }) {
    const { selection: { isSelected , toggle  }  } = (0,TableProvider/* useTableState */.o)();
    return /*#__PURE__*/ react.createElement(Checkbox/* CheckBox */.J, {
        "data-testid": testId,
        checked: isSelected(row.value),
        onChange: ()=>toggle(row.value)
    });
}
TableSelectionCheckbox.Header = SelectHeader;

// EXTERNAL MODULE: ./node_modules/@mui/icons-material/ArrowDropDown.js
var ArrowDropDown = __webpack_require__(45111);
// EXTERNAL MODULE: ./node_modules/@mui/icons-material/ArrowDropUp.js
var ArrowDropUp = __webpack_require__(29217);
// EXTERNAL MODULE: ./node_modules/@mui/base/ClickAwayListener/ClickAwayListener.js
var ClickAwayListener = __webpack_require__(23926);
// EXTERNAL MODULE: ./node_modules/@mui/icons-material/GetApp.js
var GetApp = __webpack_require__(14689);
// EXTERNAL MODULE: ./node_modules/@mui/material/ButtonGroup/ButtonGroup.js + 1 modules
var ButtonGroup = __webpack_require__(8044);
// EXTERNAL MODULE: ./node_modules/@mui/material/MenuList/MenuList.js + 1 modules
var MenuList = __webpack_require__(83975);
// EXTERNAL MODULE: ./node_modules/@mui/material/Button/Button.js + 1 modules
var Button = __webpack_require__(72642);
// EXTERNAL MODULE: ./node_modules/@mui/material/Popper/Popper.js + 56 modules
var Popper = __webpack_require__(26376);
// EXTERNAL MODULE: ./node_modules/@mui/material/Grow/Grow.js
var Grow = __webpack_require__(96514);
// EXTERNAL MODULE: ./node_modules/@mui/material/Paper/Paper.js + 2 modules
var Paper = __webpack_require__(64680);
// EXTERNAL MODULE: ./node_modules/@mui/material/CircularProgress/CircularProgress.js + 1 modules
var CircularProgress = __webpack_require__(59062);
// EXTERNAL MODULE: ./src/ui/atoms/Box.tsx
var atoms_Box = __webpack_require__(17299);
// EXTERNAL MODULE: ./src/ui/vars.tsx
var vars = __webpack_require__(29400);
;// CONCATENATED MODULE: ./src/modules/table/ExportButton.tsx
function ExportButton_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function ExportButton_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            ExportButton_define_property(target, key, source[key]);
        });
    }
    return target;
}
function ExportButton_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function ExportButton_object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ExportButton_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}










const layoutMessages = {
    exportAll: "Export all available columns"
};
const ButtonsContainer = (0,css/* styled */.zo)(ButtonGroup/* default */.Z, {
    boxShadow: "none"
});
const Menu = (0,css/* styled */.zo)(MenuList/* default */.Z, {
    padding: "5px 0",
    marginTop: -2
});
const MainButton = (0,css/* styled */.zo)(Button/* default */.Z, {
    "&:hover": {
        boxShadow: "none",
        background: vars/* colors.light300 */.O9.light300
    },
    "color": "rgba(0, 0, 0, 0.87)",
    "borderRight": "1px solid rgba(31, 31, 31, 0.03)",
    "background": vars/* colors.light200 */.O9.light200
});
const ArrowMenuButton = (0,css/* styled */.zo)(Button/* default */.Z, {
    "minWidth": "27px !important",
    "width": 27,
    "&:hover": {
        boxShadow: "none",
        background: vars/* colors.light300 */.O9.light300
    },
    "background": vars/* colors.light200 */.O9.light200,
    "color": "rgba(0, 0, 0, 0.87)"
});
function ExportButton({ children =/*#__PURE__*/ react.createElement(react.Fragment, null, "Export") , isLoading , "data-testid": testId , url , exportAllUrl  }) {
    const anchorRef = react.useRef(null);
    const handleClose = (event)=>{
        if (anchorRef.current && anchorRef.current.contains(event.target)) {
            return;
        }
        actions.onClose();
    };
    const [popover, actions] = (0,hooks/* usePopover */.Sv)((api)=>/*#__PURE__*/ react.createElement(Popper/* default */.Z, ExportButton_object_spread_props(ExportButton_object_spread({}, api), {
            anchorEl: anchorRef.current,
            role: undefined,
            transition: true,
            disablePortal: true
        }), ({ TransitionProps , placement  })=>/*#__PURE__*/ react.createElement(Grow/* default */.Z, ExportButton_object_spread_props(ExportButton_object_spread({}, TransitionProps), {
                style: {
                    transformOrigin: placement === "bottom" ? "center top" : "center bottom"
                }
            }), /*#__PURE__*/ react.createElement(Paper/* default */.Z, null, /*#__PURE__*/ react.createElement(ClickAwayListener/* default */.Z, {
                onClickAway: handleClose
            }, /*#__PURE__*/ react.createElement(Menu, {
                id: "export-button-menu"
            }, /*#__PURE__*/ react.createElement("a", {
                style: {
                    textDecoration: "none",
                    pointerEvents: isLoading ? "none" : undefined
                },
                href: exportAllUrl
            }, /*#__PURE__*/ react.createElement(MenuItem/* default */.Z, {
                dense: true,
                onClick: togglePopover
            }, layoutMessages.exportAll))))))));
    const togglePopover = (ev)=>actions.open ? actions.onClose() : actions.onOpen(anchorRef.current || ev.target);
    return /*#__PURE__*/ react.createElement(react.Fragment, null, /*#__PURE__*/ react.createElement(ButtonsContainer, {
        variant: "contained",
        ref: anchorRef,
        "aria-label": "split button"
    }, /*#__PURE__*/ react.createElement(MainButton, {
        href: url,
        "data-testid": testId,
        variant: "contained",
        style: {
            textDecoration: "none",
            pointerEvents: isLoading ? "none" : undefined
        },
        startIcon: isLoading ? /*#__PURE__*/ react.createElement(atoms_Box/* Box */.x, {
            as: CircularProgress/* default */.Z,
            sx: {
                marginX: "2px"
            },
            size: 16,
            color: "inherit"
        }) : /*#__PURE__*/ react.createElement(GetApp/* default */.Z, {
            fontSize: "small"
        })
    }, children), exportAllUrl && /*#__PURE__*/ react.createElement(ArrowMenuButton, {
        size: "small",
        "aria-controls": actions.open ? "export-button-menu" : undefined,
        "aria-expanded": actions.open ? "true" : undefined,
        "aria-label": "export all menu",
        "aria-haspopup": "menu",
        onClick: togglePopover
    }, actions.open ? /*#__PURE__*/ react.createElement(ArrowDropUp/* default */.Z, null) : /*#__PURE__*/ react.createElement(ArrowDropDown/* default */.Z, null))), popover);
}

;// CONCATENATED MODULE: ./src/modules/table/index.tsx














/***/ }),

/***/ 92930:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Kx": () => (/* binding */ useCollection),
/* harmony export */   "rK": () => (/* binding */ useSorting),
/* harmony export */   "yJ": () => (/* binding */ useInfiniteScrollCollection)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var libs_hooks__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(88289);
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}


function useSorting(initialSort) {
    const [sort, setSort] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(initialSort);
    return {
        sort,
        setSort
    };
}
function useTableSelection({ records , getKeys =(d)=>{
    return d === null || d === void 0 ? void 0 : d.map((el)=>el.id);
}  }) {
    const [isAllOnAllPageSelected, setIsAllOnAllPageSelected] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(false);
    const [selected, selectedActions] = (0,libs_hooks__WEBPACK_IMPORTED_MODULE_1__/* .useControlledSet */ .CJ)();
    const recordKeys = (0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(()=>getKeys(records) || [], [
        records
    ]);
    const isAllSelected = (0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(()=>new Set(recordKeys).size === selected.size, [
        recordKeys,
        selected.size
    ]);
    const resetAll = ()=>{
        selectedActions.reset(new Set());
        setIsAllOnAllPageSelected(false);
    };
    const isSelected = (id)=>isAllOnAllPageSelected || selectedActions.has(id);
    const toggle = (id)=>{
        if (isAllOnAllPageSelected) {
            const newSelected = new Set(recordKeys);
            newSelected.delete(id);
            selectedActions.reset(newSelected);
            setIsAllOnAllPageSelected(false);
        } else {
            selectedActions.toggle(id);
        }
    };
    const toggleAll = ()=>{
        const wasAllSelected = isAllOnAllPageSelected;
        if (isAllOnAllPageSelected) {
            setIsAllOnAllPageSelected(false);
        }
        selectedActions.reset(new Set(isAllSelected || wasAllSelected ? [] : recordKeys));
    };
    const selectAll = ()=>{
        if (isAllOnAllPageSelected) {
            setIsAllOnAllPageSelected(false);
        }
        selectedActions.reset(new Set(recordKeys));
    };
    const selectOnAllPages = ()=>{
        setIsAllOnAllPageSelected(true);
        selectedActions.reset(new Set([]));
    };
    const removeItems = (ids)=>{
        selectedActions.removeMany(ids);
    };
    const resetMissing = ()=>{
        const selected = (recordKeys === null || recordKeys === void 0 ? void 0 : recordKeys.filter(isSelected)) || [];
        selectedActions.reset(new Set(selected));
    };
    return {
        resetMissing,
        removeItems,
        selectedSet: selected,
        selectedSize: selected.size,
        isAllSelected,
        isSelected,
        toggle,
        toggleAll,
        selectAll,
        selectOnAllPages,
        toggleAllOnAllPage: ()=>{
            setIsAllOnAllPageSelected((s)=>!s);
            if (!isAllOnAllPageSelected) {
                selectedActions.reset(new Set());
            }
        },
        isAllOnAllPageSelected,
        resetAll,
        isAllIntermediate: !isAllOnAllPageSelected && recordKeys.length < selected.size && selected.size > 0
    };
}
function useCollection(useFetchData, { getPageRecords =(d)=>{
    return d === null || d === void 0 ? void 0 : d.records;
} , getRecordsCount =(rec)=>{
    return rec === null || rec === void 0 ? void 0 : rec.length;
} , getTotalCount =(d)=>{
    return d === null || d === void 0 ? void 0 : d.total;
} , getSelectionKeys , initialSort , initialPerPage =25 , initialPage =0  }) {
    const { page , perPage , handlePage , handlePageSize  } = (0,libs_hooks__WEBPACK_IMPORTED_MODULE_1__/* .usePagination */ .h0)({
        page: initialPage,
        perPage: initialPerPage
    });
    const { sort , setSort  } = useSorting(initialSort);
    const _useFetchData = useFetchData({
        sort_by: sort === null || sort === void 0 ? void 0 : sort.sort_by,
        sort_desc: sort === null || sort === void 0 ? void 0 : sort.sort_desc,
        page: page,
        perPage: perPage
    }), { data , isLoading , isFetching , canFetchMore , fetchMore , error  } = _useFetchData, restQuery = _object_without_properties(_useFetchData, [
        "data",
        "isLoading",
        "isFetching",
        "canFetchMore",
        "fetchMore",
        "error"
    ]);
    const currentPage = data === null || data === void 0 ? void 0 : data[page];
    const records = getPageRecords(currentPage);
    const recordsCount = getRecordsCount(records);
    const totalCount = getTotalCount(data === null || data === void 0 ? void 0 : data[0]);
    var _data_length;
    const fetchedPagesCount = (_data_length = data === null || data === void 0 ? void 0 : data.length) !== null && _data_length !== void 0 ? _data_length : 0;
    const isEmpty = recordsCount === 0 && !isLoading && !isFetching;
    const _useTableSelection = useTableSelection({
        records,
        getKeys: getSelectionKeys
    }), { resetAll , resetMissing , isAllOnAllPageSelected  } = _useTableSelection, restSelection = _object_without_properties(_useTableSelection, [
        "resetAll",
        "resetMissing",
        "isAllOnAllPageSelected"
    ]);
    const prevRecordsRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(false);
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useLayoutEffect)(()=>{
        if (((data === null || data === void 0 ? void 0 : data.length) || 0) <= 1 && page !== 0) {
            handlePage(0);
        }
    }, [
        data === null || data === void 0 ? void 0 : data.length
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useLayoutEffect)(()=>{
        const newData = isFetching || isLoading;
        if (newData === false && prevRecordsRef.current === true && !isAllOnAllPageSelected) {
            resetMissing();
        }
        prevRecordsRef.current = newData;
    });
    const getPaginationProps = ()=>{
        return {
            isLoading: recordsCount === 0 && isLoading,
            isNextDisabled: isLoading || !canFetchMore && page === recordsCount - 1 || isFetching,
            perPage: perPage,
            isLastPage: !canFetchMore && fetchedPagesCount - 1 === page,
            page,
            count: totalCount,
            onChangePerPage: (newPerPage)=>{
                handlePageSize(newPerPage, 0);
            },
            onChangePage: (newPage)=>{
                if (newPage >= fetchedPagesCount) {
                    fetchMore();
                }
                handlePage(newPage);
            }
        };
    };
    const getTableProps = ()=>{
        return {
            isLoading: isLoading || isFetching,
            sort,
            onSortChange: setSort,
            data: records
        };
    };
    const getSelectionProps = ()=>{
        return {
            hasSelection: restSelection.selectedSet.size !== 0 || isAllOnAllPageSelected,
            totalCount: isAllOnAllPageSelected ? totalCount : restSelection.selectedSet.size,
            selectedKeys: isAllOnAllPageSelected ? [
                "all"
            ] : [
                ...restSelection.selectedSet.keys()
            ],
            isAllOnAllPageSelected: isAllOnAllPageSelected
        };
    };
    const selection = _object_spread({
        resetAll,
        isAllOnAllPageSelected
    }, restSelection);
    const getProviderProps = ()=>({
            selection,
            sort
        });
    return _object_spread_props(_object_spread({
        error,
        getPaginationProps,
        getTableProps,
        getSelectionProps,
        records,
        totalCount,
        isEmpty,
        isFetching,
        isLoading,
        sort,
        perPage,
        setSort
    }, restQuery), {
        selection,
        getProviderProps
    });
}
function useInfiniteScrollCollection(useFetchData, { getPageRecords =(d)=>{
    return d === null || d === void 0 ? void 0 : d.records;
} , getTotalCount =(d)=>{
    return d === null || d === void 0 ? void 0 : d.total;
} , getSelectionKeys , initialSort , initialPage =0 , initialPerPage =50  }) {
    const { sort , setSort  } = useSorting(initialSort);
    const _useFetchData = useFetchData({
        sort_by: sort === null || sort === void 0 ? void 0 : sort.sort_by,
        sort_desc: sort === null || sort === void 0 ? void 0 : sort.sort_desc,
        page: initialPage,
        perPage: initialPerPage
    }), { data , isLoading , isFetching , canFetchMore , fetchMore , error  } = _useFetchData, restQuery = _object_without_properties(_useFetchData, [
        "data",
        "isLoading",
        "isFetching",
        "canFetchMore",
        "fetchMore",
        "error"
    ]);
    const records = data === null || data === void 0 ? void 0 : data.reduce((acc, curr)=>acc.concat(getPageRecords(curr)), []);
    const totalCount = getTotalCount(data === null || data === void 0 ? void 0 : data[0]);
    const isEmpty = (records === null || records === void 0 ? void 0 : records.length) === 0 && !isLoading && !isFetching;
    const _useTableSelection = useTableSelection({
        records,
        getKeys: getSelectionKeys
    }), { resetAll , resetMissing , isAllOnAllPageSelected  } = _useTableSelection, restSelection = _object_without_properties(_useTableSelection, [
        "resetAll",
        "resetMissing",
        "isAllOnAllPageSelected"
    ]);
    const prevRecordsRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(false);
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useLayoutEffect)(()=>{
        const newData = isFetching || isLoading;
        if (newData === false && prevRecordsRef.current === true && !isAllOnAllPageSelected) {
            resetMissing();
        }
        prevRecordsRef.current = newData;
    });
    const getTableProps = ()=>{
        return {
            sort,
            isLoading: isLoading || isFetching,
            onSortChange: setSort,
            data: records
        };
    };
    const getSelectionProps = ()=>{
        return {
            hasSelection: restSelection.selectedSet.size !== 0 || isAllOnAllPageSelected,
            totalCount: isAllOnAllPageSelected ? totalCount : restSelection.selectedSet.size,
            selectedKeys: isAllOnAllPageSelected ? [
                "all"
            ] : [
                ...restSelection.selectedSet.keys()
            ],
            isAllOnAllPageSelected: isAllOnAllPageSelected
        };
    };
    const selection = _object_spread({
        resetAll,
        isAllOnAllPageSelected
    }, restSelection);
    const getProviderProps = ()=>({
            selection,
            sort
        });
    const intersectionObserver = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)();
    const infiniteScrollRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)((item)=>{
        if (isLoading || isFetching) {
            return;
        }
        if (intersectionObserver.current) {
            var _intersectionObserver_current;
            (_intersectionObserver_current = intersectionObserver.current) === null || _intersectionObserver_current === void 0 ? void 0 : _intersectionObserver_current.disconnect();
        }
        intersectionObserver.current = new IntersectionObserver((items)=>{
            if (items[0].isIntersecting && canFetchMore) {
                fetchMore();
            }
        });
        if (item) {
            intersectionObserver.current.observe(item);
        }
    }, [
        isFetching,
        isLoading,
        fetchMore,
        canFetchMore
    ]);
    const showInfinityLoader = isFetching || isLoading && (records === null || records === void 0 ? void 0 : records.length) === 0;
    return _object_spread_props(_object_spread({
        error,
        records,
        getTableProps,
        getSelectionProps,
        fetchMore,
        infiniteScrollRef,
        totalCount,
        isEmpty,
        isFetching,
        isLoading,
        sort,
        setSort,
        showInfinityLoader
    }, restQuery), {
        selection,
        getProviderProps
    });
}


/***/ }),

/***/ 44428:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Gb": () => (/* binding */ preloadTermsState),
/* harmony export */   "i2": () => (/* binding */ useTermsState),
/* harmony export */   "mY": () => (/* binding */ useTermStateQueryKey),
/* harmony export */   "yH": () => (/* binding */ useTermsStateQuery)
/* harmony export */ });
/* harmony import */ var react_query__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(21478);
/* harmony import */ var api_terms__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(15322);


function useTermsState() {
    return useTermsStateQuery().data;
}
const useTermStateQueryKey = ()=>[
        "terms"
    ];
function useTermsStateQuery() {
    return (0,react_query__WEBPACK_IMPORTED_MODULE_0__/* .useQuery */ .aM)(useTermStateQueryKey(), ()=>api_terms__WEBPACK_IMPORTED_MODULE_1__/* .fetchTermsAndConditions */ .R());
}
function preloadTermsState(cache) {
    return cache.prefetchQuery(useTermStateQueryKey(), ()=>{
        return api_terms__WEBPACK_IMPORTED_MODULE_1__/* .fetchTermsAndConditions */ .R();
    });
}


/***/ }),

/***/ 43100:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "A8": () => (/* reexport */ TimezoneProvider),
  "mb": () => (/* reexport */ timezoneTypes/* TimezoneRegions */.m),
  "co": () => (/* reexport */ useTimezoneState)
});

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/constate/dist/constate.es.js
var constate_es = __webpack_require__(11521);
// EXTERNAL MODULE: ./src/modules/users/apiHooks.ts
var apiHooks = __webpack_require__(25508);
// EXTERNAL MODULE: ./src/libs/timezone/timezoneUtils.tsx + 1 modules
var timezoneUtils = __webpack_require__(4840);
// EXTERNAL MODULE: ./src/libs/timezone/timezonesList.ts + 1 modules
var timezonesList = __webpack_require__(29177);
// EXTERNAL MODULE: ./src/modules/timezone/timezoneApiHooks.ts
var timezoneApiHooks = __webpack_require__(3750);
;// CONCATENATED MODULE: ./src/modules/timezone/TimezoneProvider.tsx
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}






function useTimezoneStateInternal() {
    var _user_data, _timezoneSetting_data;
    const user = (0,apiHooks/* useCurrentUser */.xJ)();
    const userID = user === null || user === void 0 ? void 0 : (_user_data = user.data) === null || _user_data === void 0 ? void 0 : _user_data.id;
    const timezoneSetting = (0,timezoneApiHooks/* useTimezoneSettings */.hg)({
        userID
    });
    const isTimezoneReady = timezoneSetting.isFetchedAfterMount;
    const timezoneSettingsCode = (_timezoneSetting_data = timezoneSetting.data) === null || _timezoneSetting_data === void 0 ? void 0 : _timezoneSetting_data.tzCode;
    const timezone = timezoneSettingsCode || (0,timezoneUtils/* getCurrentTimezone */.vd)();
    const timezoneUtc = (0,react.useMemo)(()=>{
        const tz = timezonesList/* timezonesList.find */.F.find((tz)=>tz.tzCode === timezone);
        return `GMT ${tz.utc}`;
    }, [
        timezone
    ]);
    const updateTimezone = (0,react.useCallback)(function() {
        var _ref = _async_to_generator(function*(updatedTimezoneCode) {
            if (!timezonesList/* timezonesList.find */.F.find((tz)=>tz.tzCode === updatedTimezoneCode)) {
                throw new Error("invalid timezone code");
            }
            yield (0,timezoneApiHooks/* updateTimezoneSettings */.e8)(userID, updatedTimezoneCode);
            timezoneSetting.refetch();
        });
        return function(updatedTimezoneCode) {
            return _ref.apply(this, arguments);
        };
    }(), [
        userID,
        timezoneSetting
    ]);
    const removeTimezone = (0,react.useCallback)(/*#__PURE__*/ _async_to_generator(function*() {
        yield (0,timezoneApiHooks/* updateTimezoneSettings */.e8)(userID, null);
        timezoneSetting.refetch();
    }), [
        userID,
        timezoneSetting
    ]);
    return {
        timezone,
        updateTimezone,
        removeTimezone,
        isTimezoneReady,
        timezoneUtc,
        isLocalTimezone: !timezoneSettingsCode
    };
}
const [TimezoneProvider, useTimezoneState] = (0,constate_es/* default */.Z)(useTimezoneStateInternal);

// EXTERNAL MODULE: ./src/libs/timezone/timezoneTypes.ts
var timezoneTypes = __webpack_require__(81287);
;// CONCATENATED MODULE: ./src/modules/timezone/index.ts




/***/ }),

/***/ 3750:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "VQ": () => (/* binding */ preloadTimezoneSettings),
/* harmony export */   "e8": () => (/* binding */ updateTimezoneSettings),
/* harmony export */   "hg": () => (/* binding */ useTimezoneSettings)
/* harmony export */ });
/* harmony import */ var react_query__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(21478);
/* harmony import */ var modules_analytics_Analytics__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(95520);
/* harmony import */ var api_graphql_network__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(48863);
/* harmony import */ var api_graphql__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(37137);
/* harmony import */ var _notification__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(5769);
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}





function preloadTimezoneSettings(cache, userID) {
    return cache.prefetchQuery([
        "timezone",
        userID
    ], ()=>fetchTimezoneSettings(userID));
}
function fetchTimezoneSettings(userID) {
    return (0,api_graphql_network__WEBPACK_IMPORTED_MODULE_2__/* .sendGQLRequest */ .n)(api_graphql__WEBPACK_IMPORTED_MODULE_3__/* .GetSettingsDocument */ .X0, {
        user_id: userID
    }).then((el)=>{
        var _el_settings_by_pk, _el_settings_by_pk_data;
        return el === null || el === void 0 ? void 0 : (_el_settings_by_pk = el.settings_by_pk) === null || _el_settings_by_pk === void 0 ? void 0 : (_el_settings_by_pk_data = _el_settings_by_pk.data) === null || _el_settings_by_pk_data === void 0 ? void 0 : _el_settings_by_pk_data.timezone;
    });
}
function useTimezoneSettings({ userID  }) {
    return _object_spread({}, (0,react_query__WEBPACK_IMPORTED_MODULE_0__/* .useQuery */ .aM)([
        "timezone",
        userID
    ], ()=>fetchTimezoneSettings(userID), {
        refetchOnWindowFocus: true,
        initialStale: true,
        initialData: {},
        staleTime: 10 * 1000,
        enabled: !!userID
    }));
}
const updateTimezoneSettings = function() {
    var _ref = _async_to_generator(function*(userID, tzCode) {
        try {
            yield (0,api_graphql_network__WEBPACK_IMPORTED_MODULE_2__/* .sendGQLRequest */ .n)(api_graphql__WEBPACK_IMPORTED_MODULE_3__/* .UpdateSettingsDocument */ .M9, {
                user_id: userID,
                data: {
                    timezone: {
                        tzCode
                    }
                }
            });
            (0,modules_analytics_Analytics__WEBPACK_IMPORTED_MODULE_1__/* .logEvent */ .Kz)(modules_analytics_Analytics__WEBPACK_IMPORTED_MODULE_1__/* .eventsConstants.preferences.timezone */ .AD.preferences.timezone + ": " + tzCode, {
                tzCode
            });
        } catch (error) {
            _notification__WEBPACK_IMPORTED_MODULE_4__/* .notification.error */ .t6.error({
                message: error === null || error === void 0 ? void 0 : error.message
            });
        }
    });
    return function updateTimezoneSettings(userID, tzCode) {
        return _ref.apply(this, arguments);
    };
}();


/***/ }),

/***/ 25508:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$O": () => (/* binding */ useRolesData),
/* harmony export */   "F_": () => (/* binding */ useDeleteUser),
/* harmony export */   "Ht": () => (/* binding */ useResetMFA),
/* harmony export */   "Iv": () => (/* binding */ useDeleteRole),
/* harmony export */   "JA": () => (/* binding */ useRolesByUserList),
/* harmony export */   "K_": () => (/* binding */ getSortedRoles),
/* harmony export */   "V": () => (/* binding */ usePermissionsRoleList),
/* harmony export */   "bF": () => (/* binding */ useRolesList),
/* harmony export */   "dF": () => (/* binding */ usePermissionsList),
/* harmony export */   "dO": () => (/* reexport safe */ shared_auth_hooks__WEBPACK_IMPORTED_MODULE_1__.dO),
/* harmony export */   "ir": () => (/* binding */ useInviteUser),
/* harmony export */   "m8": () => (/* reexport safe */ shared_auth_hooks__WEBPACK_IMPORTED_MODULE_1__.m8),
/* harmony export */   "og": () => (/* binding */ usePatchUser),
/* harmony export */   "pO": () => (/* binding */ useForgotPassword),
/* harmony export */   "qb": () => (/* binding */ useRolePermissionsUpdate),
/* harmony export */   "tN": () => (/* binding */ useAuthProviderReset),
/* harmony export */   "vM": () => (/* binding */ useRolesUpdate),
/* harmony export */   "xJ": () => (/* reexport safe */ shared_auth_hooks__WEBPACK_IMPORTED_MODULE_1__.xJ),
/* harmony export */   "y0": () => (/* binding */ useUpdateRole),
/* harmony export */   "yU": () => (/* binding */ useCreateRole)
/* harmony export */ });
/* unused harmony exports useUser, useUsers */
/* harmony import */ var react_query__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(21478);
/* harmony import */ var shared_auth_hooks__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(48351);
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(44176);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var modules_users_molecules_changeRolesConstants__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(69123);
/* harmony import */ var api__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(62688);
/* harmony import */ var modules_auth__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(38266);
/* harmony import */ var modules_notification__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(5769);
/* harmony import */ var modules_analytics_Analytics__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(95520);
/* harmony import */ var api_graphql__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(37137);
/* harmony import */ var api_graphql_network__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(48863);
/* harmony import */ var api_resources__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(21665);
/* harmony import */ var _messages__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(79799);
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}













const UsersKey = "users";
const UserIDKey = "user";
const usersApi = api__WEBPACK_IMPORTED_MODULE_4__.api.auth.AuthService;

function useUser({ id  }) {
    if (!id) {
        return {};
    }
    return useQuery([
        UserIDKey,
        id
    ], ()=>usersApi.UserGet({
            id
        }));
}
function useUsers() {
    return useQuery([
        UsersKey
    ], ()=>usersApi.UsersList({}));
}
function useDeleteUser() {
    const cache = (0,react_query__WEBPACK_IMPORTED_MODULE_0__/* .useQueryCache */ .Zq)();
    return (0,react_query__WEBPACK_IMPORTED_MODULE_0__/* .useMutation */ .Db)(function() {
        var _ref = _async_to_generator(function*(user) {
            yield usersApi.UserDelete({
                id: String(user.id)
            });
            return user;
        });
        return function(user) {
            return _ref.apply(this, arguments);
        };
    }(), {
        onSuccess (user) {
            return _async_to_generator(function*() {
                cache.invalidateQueries(UsersKey);
                const { user: currentUser  } = modules_auth__WEBPACK_IMPORTED_MODULE_5__.authState.getState();
                if (user.id === currentUser.id) {
                    yield (0,modules_auth__WEBPACK_IMPORTED_MODULE_5__.logout)();
                }
                (0,modules_analytics_Analytics__WEBPACK_IMPORTED_MODULE_7__/* .logEvent */ .Kz)(modules_analytics_Analytics__WEBPACK_IMPORTED_MODULE_7__/* .eventsConstants.preferences.users["delete"] */ .AD.preferences.users["delete"]);
                modules_notification__WEBPACK_IMPORTED_MODULE_6__/* .notification.open */ .t6.open({
                    message: _messages__WEBPACK_IMPORTED_MODULE_11__/* .messages.notifications.getNotificationText */ .s.notifications.getNotificationText(_messages__WEBPACK_IMPORTED_MODULE_11__/* .messages.notifications.statuses.removed */ .s.notifications.statuses.removed)
                });
            })();
        },
        onError (error) {
            modules_notification__WEBPACK_IMPORTED_MODULE_6__/* .notification.error */ .t6.error({
                message: error.message
            });
        }
    });
}
function usePatchUser() {
    const cache = (0,react_query__WEBPACK_IMPORTED_MODULE_0__/* .useQueryCache */ .Zq)();
    return (0,react_query__WEBPACK_IMPORTED_MODULE_0__/* .useMutation */ .Db)(function() {
        var _ref = _async_to_generator(function*({ id , user  }) {
            const { user: currentUser  } = modules_auth__WEBPACK_IMPORTED_MODULE_5__.authState.getState();
            yield usersApi.UserPatch(_object_spread({
                id: id
            }, user));
            if (id === currentUser.id) {
                yield (0,modules_auth__WEBPACK_IMPORTED_MODULE_5__.refreshToken)();
            }
            (0,modules_analytics_Analytics__WEBPACK_IMPORTED_MODULE_7__/* .logEvent */ .Kz)(modules_analytics_Analytics__WEBPACK_IMPORTED_MODULE_7__/* .eventsConstants.preferences.users.update */ .AD.preferences.users.update);
            return user;
        });
        return function(_) {
            return _ref.apply(this, arguments);
        };
    }(), {
        onSuccess (_, req) {
            cache.invalidateQueries(UsersKey);
            cache.invalidateQueries([
                UserIDKey,
                req.id
            ], {
                refetchActive: true
            });
            modules_notification__WEBPACK_IMPORTED_MODULE_6__/* .notification.open */ .t6.open({
                message: _messages__WEBPACK_IMPORTED_MODULE_11__/* .messages.notifications.getNotificationText */ .s.notifications.getNotificationText(_messages__WEBPACK_IMPORTED_MODULE_11__/* .messages.notifications.statuses.updated */ .s.notifications.statuses.updated)
            });
        },
        onError (error) {
            modules_notification__WEBPACK_IMPORTED_MODULE_6__/* .notification.error */ .t6.error({
                message: error === null || error === void 0 ? void 0 : error.message
            });
        }
    });
}
function useInviteUser() {
    const cache = (0,react_query__WEBPACK_IMPORTED_MODULE_0__/* .useQueryCache */ .Zq)();
    return (0,react_query__WEBPACK_IMPORTED_MODULE_0__/* .useMutation */ .Db)(function() {
        var _ref = _async_to_generator(function*({ email , roles  }) {
            const response = yield usersApi.UserInvite({
                email,
                roles: roles
            });
            (0,modules_analytics_Analytics__WEBPACK_IMPORTED_MODULE_7__/* .logEvent */ .Kz)(modules_analytics_Analytics__WEBPACK_IMPORTED_MODULE_7__/* .eventsConstants.preferences.users.inviteUser */ .AD.preferences.users.inviteUser);
            return response;
        });
        return function(_) {
            return _ref.apply(this, arguments);
        };
    }(), {
        throwOnError: true,
        onSuccess () {
            cache.invalidateQueries(UsersKey);
        },
        onError (error) {
            modules_notification__WEBPACK_IMPORTED_MODULE_6__/* .notification.error */ .t6.error({
                message: error === null || error === void 0 ? void 0 : error.message
            });
        }
    });
}
function useForgotPassword(props = {}) {
    const { data: user  } = (0,shared_auth_hooks__WEBPACK_IMPORTED_MODULE_1__/* .useCurrentUser */ .xJ)();
    return (0,react_query__WEBPACK_IMPORTED_MODULE_0__/* .useMutation */ .Db)(function() {
        var _ref = _async_to_generator(function*({ id  }) {
            return api__WEBPACK_IMPORTED_MODULE_4__.api.auth.AuthService.UserPasswordReset({
                id
            });
        });
        return function(_) {
            return _ref.apply(this, arguments);
        };
    }(), _object_spread({
        onSuccess (_, { id  }) {
            modules_notification__WEBPACK_IMPORTED_MODULE_6__/* .notification.success */ .t6.success({
                message: _messages__WEBPACK_IMPORTED_MODULE_11__/* .messages.resetAuthMethod */ .s.resetAuthMethod
            });
            if ((user === null || user === void 0 ? void 0 : user.id) === id) {
                (0,modules_auth__WEBPACK_IMPORTED_MODULE_5__.logout)();
            }
        }
    }, props));
}
function useAuthProviderReset(props = {}) {
    const { data: user  } = (0,shared_auth_hooks__WEBPACK_IMPORTED_MODULE_1__/* .useCurrentUser */ .xJ)();
    return (0,react_query__WEBPACK_IMPORTED_MODULE_0__/* .useMutation */ .Db)(function() {
        var _ref = _async_to_generator(function*({ id  }) {
            return api__WEBPACK_IMPORTED_MODULE_4__.api.auth.AuthService.ResetProvider({
                id
            });
        });
        return function(_) {
            return _ref.apply(this, arguments);
        };
    }(), _object_spread({
        onSuccess (_, { id  }) {
            modules_notification__WEBPACK_IMPORTED_MODULE_6__/* .notification.success */ .t6.success({
                message: _messages__WEBPACK_IMPORTED_MODULE_11__/* .messages.resetAuthProivider */ .s.resetAuthProivider
            });
            if ((user === null || user === void 0 ? void 0 : user.id) === id) {
                (0,modules_auth__WEBPACK_IMPORTED_MODULE_5__.logout)();
            }
        }
    }, props));
}
function useResetMFA() {
    const { data: user  } = (0,shared_auth_hooks__WEBPACK_IMPORTED_MODULE_1__/* .useCurrentUser */ .xJ)();
    const cache = (0,react_query__WEBPACK_IMPORTED_MODULE_0__/* .useQueryCache */ .Zq)();
    return (0,react_query__WEBPACK_IMPORTED_MODULE_0__/* .useMutation */ .Db)(function() {
        var _ref = _async_to_generator(function*({ id  }) {
            return api__WEBPACK_IMPORTED_MODULE_4__.api.auth.AuthService.MFAReset({
                id
            });
        });
        return function(_) {
            return _ref.apply(this, arguments);
        };
    }(), {
        onSuccess (_, { id  }) {
            modules_notification__WEBPACK_IMPORTED_MODULE_6__/* .notification.success */ .t6.success({
                message: _messages__WEBPACK_IMPORTED_MODULE_11__/* .messages.resetMFAMethod */ .s.resetMFAMethod
            });
            cache.invalidateQueries([
                UsersKey
            ], {
                refetchActive: true
            });
            if ((user === null || user === void 0 ? void 0 : user.id) === id && id) {
                (0,modules_auth__WEBPACK_IMPORTED_MODULE_5__.logout)();
            }
        }
    });
}
function useRolesUpdate() {
    const cache = (0,react_query__WEBPACK_IMPORTED_MODULE_0__/* .useQueryCache */ .Zq)();
    return (0,react_query__WEBPACK_IMPORTED_MODULE_0__/* .useMutation */ .Db)((arg)=>{
        return (0,api_graphql_network__WEBPACK_IMPORTED_MODULE_9__/* .sendGQLRequest */ .n)(api_graphql__WEBPACK_IMPORTED_MODULE_8__/* .AssingRolesDocument */ .r7, {
            insert_data: arg.roles.map((el)=>({
                    role_id: el,
                    subject_id: arg.user_id
                })),
            user_id: arg.user_id,
            roles_to_delete: (0,lodash__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)(arg.currentRoles, arg.roles)
        });
    }, {
        onSuccess: (_data, arg)=>{
            cache.invalidateQueries([
                "roles",
                arg.user_id
            ]);
        }
    });
}
function useCreateRole() {
    const cache = (0,react_query__WEBPACK_IMPORTED_MODULE_0__/* .useQueryCache */ .Zq)();
    return (0,react_query__WEBPACK_IMPORTED_MODULE_0__/* .useMutation */ .Db)(function() {
        var _ref = _async_to_generator(function*({ role_name , description , scope =null  }) {
            return (0,api_graphql_network__WEBPACK_IMPORTED_MODULE_9__/* .sendGQLRequest */ .n)(api_graphql__WEBPACK_IMPORTED_MODULE_8__/* .CreateRoleDocument */ .$f, {
                role_name,
                description,
                scope
            });
        });
        return function(_) {
            return _ref.apply(this, arguments);
        };
    }(), {
        onSuccess: ()=>{
            cache.invalidateQueries([
                "roles"
            ]);
        }
    });
}
function useUpdateRole() {
    const cache = (0,react_query__WEBPACK_IMPORTED_MODULE_0__/* .useQueryCache */ .Zq)();
    return (0,react_query__WEBPACK_IMPORTED_MODULE_0__/* .useMutation */ .Db)(function() {
        var _ref = _async_to_generator(function*({ id , name , description , scope =null  }) {
            return (0,api_graphql_network__WEBPACK_IMPORTED_MODULE_9__/* .sendGQLRequest */ .n)(api_graphql__WEBPACK_IMPORTED_MODULE_8__/* .UpdateRoleDocument */ .vA, {
                id,
                name,
                description,
                scope
            });
        });
        return function(_) {
            return _ref.apply(this, arguments);
        };
    }(), {
        onSuccess: ()=>{
            cache.invalidateQueries([
                "roles"
            ]);
        }
    });
}
function useDeleteRole() {
    const cache = (0,react_query__WEBPACK_IMPORTED_MODULE_0__/* .useQueryCache */ .Zq)();
    return (0,react_query__WEBPACK_IMPORTED_MODULE_0__/* .useMutation */ .Db)(function() {
        var _ref = _async_to_generator(function*({ id  }) {
            return (0,api_graphql_network__WEBPACK_IMPORTED_MODULE_9__/* .sendGQLRequest */ .n)(api_graphql__WEBPACK_IMPORTED_MODULE_8__/* .DeleteRoleDocument */ .E9, {
                id
            });
        });
        return function(_) {
            return _ref.apply(this, arguments);
        };
    }(), {
        onSuccess: ()=>{
            cache.invalidateQueries([
                "roles"
            ]);
        }
    });
}
function useRolesData() {
    return (0,react_query__WEBPACK_IMPORTED_MODULE_0__/* .useInfiniteQuery */ .NS)([
        "roles"
    ], ()=>{
        return (0,api_graphql_network__WEBPACK_IMPORTED_MODULE_9__/* .sendGQLRequest */ .n)(api_graphql__WEBPACK_IMPORTED_MODULE_8__/* .GetRolesDocument */ .gH, {});
    }, {
        keepPreviousData: true,
        getFetchMore: ()=>undefined
    });
}
function useRolesByUserList(id) {
    if (!id) {
        return {};
    }
    return (0,react_query__WEBPACK_IMPORTED_MODULE_0__/* .useQuery */ .aM)([
        "roles",
        id
    ], ()=>(0,api_graphql_network__WEBPACK_IMPORTED_MODULE_9__/* .sendGQLRequest */ .n)(api_graphql__WEBPACK_IMPORTED_MODULE_8__/* .ListRolesForUserDocument */ .PG, {
            user_id: id
        }));
}
const getSortedRoles = (rolesData)=>{
    return (rolesData === null || rolesData === void 0 ? void 0 : rolesData.reduce((acc, role)=>{
        if (role.id === modules_users_molecules_changeRolesConstants__WEBPACK_IMPORTED_MODULE_3__/* .ROLE_ADMIN.id */ .yw.id) {
            return [
                role,
                ...acc
            ];
        }
        acc.push(role);
        return acc;
    }, [])) || [];
};
function useRolesList() {
    const _useRolesData = useRolesData(), { data  } = _useRolesData, rest = _object_without_properties(_useRolesData, [
        "data"
    ]);
    const roles = data === null || data === void 0 ? void 0 : data[0].role_aggregate.nodes;
    const rolesData = (0,react__WEBPACK_IMPORTED_MODULE_2__.useMemo)(()=>getSortedRoles(roles), [
        roles
    ]);
    return _object_spread({
        data: rolesData
    }, rest);
}
function usePermissionsRoleList(id) {
    return (0,react_query__WEBPACK_IMPORTED_MODULE_0__/* .useQuery */ .aM)([
        "permissions",
        id
    ], ()=>{
        return (0,api_graphql_network__WEBPACK_IMPORTED_MODULE_9__/* .sendGQLRequest */ .n)(api_graphql__WEBPACK_IMPORTED_MODULE_8__/* .ListPermissionsForRoleDocument */ .yN, {
            role_id: id
        }).then((data)=>{
            var _data_role_permission;
            return data === null || data === void 0 ? void 0 : (_data_role_permission = data.role_permission) === null || _data_role_permission === void 0 ? void 0 : _data_role_permission.map((item)=>{
                const [prefix, mode] = item.permission.name.split("__");
                const permission = api_resources__WEBPACK_IMPORTED_MODULE_10__/* .resourceDescriptions */ .u[prefix];
                return _object_spread_props(_object_spread({}, item.permission), {
                    title: permission.name + " " + mode.toUpperCase(),
                    description: permission.description
                });
            });
        });
    }, {
        enabled: !!id
    });
}
function usePermissionsList() {
    return (0,react_query__WEBPACK_IMPORTED_MODULE_0__/* .useInfiniteQuery */ .NS)([
        "permissions"
    ], ()=>(0,api_graphql_network__WEBPACK_IMPORTED_MODULE_9__/* .sendGQLRequest */ .n)(api_graphql__WEBPACK_IMPORTED_MODULE_8__/* .GetAllPermissionsDocument */ .p0, {}));
}
function useRolePermissionsUpdate() {
    const cache = (0,react_query__WEBPACK_IMPORTED_MODULE_0__/* .useQueryCache */ .Zq)();
    return (0,react_query__WEBPACK_IMPORTED_MODULE_0__/* .useMutation */ .Db)((arg)=>{
        return (0,api_graphql_network__WEBPACK_IMPORTED_MODULE_9__/* .sendGQLRequest */ .n)(api_graphql__WEBPACK_IMPORTED_MODULE_8__/* .AssingPermissionsDocument */ .oi, {
            insert_data: arg.permissions.map((el)=>({
                    role_id: arg.role_id,
                    permission_id: el
                })),
            role_id: arg.role_id,
            permissions_to_delete: (0,lodash__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)(arg.currentPermissions, arg.permissions)
        });
    }, {
        onSuccess: ()=>{
            cache.invalidateQueries([
                "roles"
            ]);
        }
    });
}


/***/ }),

/***/ 79799:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "s": () => (/* binding */ messages)
/* harmony export */ });
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(26786);

const messages = {
    failedToSendAuthLink: "Failed to send auth link.",
    authLinkSent: "Authentication link was sent.",
    setupSmsAuth: "Setup SMS authentication",
    setupSms: `Please enter your mobile phone number to verify your account. You will receive SMS
  with verification code you need to provide on the next step`,
    setupSmsConfirm: (phone)=>`Verification code has been sent to ${phone}.`,
    setupChangePhoneNumber: `Change phone number.`,
    resendAuthCode: "Send auth link",
    resetAuthMethod: "Password was reset.",
    resetAuthProivider: "Auth Provider was reset.",
    resetAuthProividerInProgress: "Auth Provider reset in progress.",
    resetAuthProividerFailed: "Auth Provider reset failed.",
    authResetMessage: "Reset email link was sent to the user.",
    resetMFAMethod: "MFA was reset.",
    notifications: {
        confirmAuth: "Please reauthenticate to proceed",
        statuses: {
            created: "created",
            updated: "updated",
            removed: "removed"
        },
        getNotificationText: (status)=>`User has been ${status}`,
        getDirectoryNotificationText: (status)=>`Directory has been ${status}`,
        passUpdated: "User password has been updated",
        linkCopied: "User sign up link was copied to the clipboard"
    },
    validation: {
        passwordNotIdentical: "Passwords are not identical",
        required: (name)=>`${(0,lodash__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(name)} field is required`,
        maxLength: (name)=>`${(0,lodash__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(name)} is too long`
    },
    backToList: "Back to list",
    userNotFound: "User not found",
    userManagement: "User management",
    inviteModal: {
        closeBtn: "Close",
        content: (email)=>`Email with sign up instructions was sent to ${email}.`,
        title: "Invite link sent",
        emailPlaceholder: "Enter email address",
        emailLabel: "Email",
        inviteTitle: "Invite user to Cyberhaven",
        inviteSubmitBtn: "invite",
        inviteBtn: "invite a member"
    },
    inviteEmail: {
        subject: "Sign Up to Cyberhaven",
        body: (link)=>`Please follow this link ${link} to sign up`
    },
    twoFactorAuth: {
        sectionTitle: "Two factor authentication",
        description: "Google Authenticator app",
        phoneDescription: "Setup phone MFA",
        phoneDescriptionMFAEnabled: "Reset phone MFA",
        descriptionSecondary: "",
        modalTitle: "Setup Google Authenticator app",
        actionDescription: "Scan or type the authenticator code into Google Authenticator app.",
        codeCopied: "Code copied",
        configure: "Configure",
        verifyCode: "Enter your 2FA code from Google Authenticator",
        verifyCodePlaceholder: "Enter your 2FA code from Google Authenticator",
        disable: "disable",
        disableTwoAuthModalTitle: "Are you sure you want to disable 2FA?",
        disableTwoAuthConfirm: "yes",
        copy: "Copy",
        download: "Download",
        notEnabled: "Not enabled"
    },
    recoveryCodes: {
        modalTitle: "Recovery codes",
        generateCodesBtn: "Generate backup codes",
        howToUse: "How to use it?",
        howToUseMessage: "Recovery codes are used to access your account in case you cannot receive two-factor authentication code. Keep these backup codes somewhere safe but accessible.",
        infoMessage: "Download or copy and save your recovery codes",
        copied: "Recovery codes was copied to the clipboard",
        fileTitle: "recovery_codes"
    },
    deleteAccText: "Delete account",
    deleteAccExp: "This action will permanently delete your account and all associated data.",
    deleteAccModalTitle: "Do you really want to delete this account?",
    deleteAccModalContent: "All user data will be permanently removed. This action is irreversible.",
    deleteAccBtn: "Delete account",
    accRoles: "Account roles",
    selectAccRoles: "Select account roles",
    edit: "Edit",
    accountManagement: "Account management",
    ok: "Ok",
    cancel: "Cancel",
    basicInfo: "Basic information",
    userName: "Name",
    changeName: "Change name",
    namePlaceholder: "Enter new name",
    companyEmail: "Company email",
    companyEmailPlaceholder: "Enter new email",
    changeEmail: "Change email",
    password: "Password",
    confirmYourPassword: "Your password",
    changePassword: "Change password",
    passwordTitle: "Type new password",
    repPassword: "Repeat password",
    loadingErrorMessage: "Something went wrong",
    userActions: {
        resetPassword: "Reset password",
        resetMFA: "Reset MFA",
        resetAuthProvider: "Reset auth provider",
        changeRole: "Change role",
        deactivate: "Deactivate",
        delete: "Delete this user",
        confirm: "You are about to delete the user. Confirm?",
        confirmReset: {
            title: "Password reset confirmation",
            body: (isCurrentUser)=>`Further instructions on how to reset the password will be sent to ${isCurrentUser ? "your" : "user’s"} email. Are you sure you want to confirm this action and reset the password?`,
            confirm: "Yes, reset password",
            cancel: "Cancel"
        },
        confirmResetMFA: {
            title: "Mfa reset confirmation",
            body: (isCurrentUser)=>`After resetting MFA, ${isCurrentUser ? "you" : "user"} will be logged out immediately and asked to go through the MFA setup process again.  `,
            confirm: "Yes, reset MFA",
            cancel: "Cancel"
        },
        confirmResetAuthProvider: {
            title: "AUTHENTICATION PROVIDER RESET CONFIRMATION",
            body: (isCurrentUser)=>`Further instructions on how to reset authentication provider will be sent to ${isCurrentUser ? "your" : "user's"}  email. Are you sure you want to confirm this action and reset Provider?`,
            confirm: "Yes, reset Auth Provider",
            cancel: "Cancel"
        }
    },
    changeRole: {
        title: "Roles settings",
        warn: "At least 1 role should be selected",
        required: (pageName)=>`This permission required in order to access ${pageName} page`,
        cancel: "Cancel",
        save: "Save",
        failedToUpdateRoles: "Failed to update roles."
    },
    roles: {
        create: "Create a Role",
        cancel: "Cancel",
        save: "Save",
        roleName: "Role name",
        roleNameEnter: "Enter role name",
        roleDescription: "Role description",
        roleDescriptionEnter: "Enter role description",
        newRoleTitle: "New Role",
        editRoleTitle: "Edit Role",
        action: {
            edit: "Edit Role",
            delete: "Delete Role",
            confirm: "You are about to delete the role. Confirm?"
        }
    },
    usersTabs: {
        list: "Users",
        roles: "Roles"
    },
    userStatus: {
        active: "Active",
        inactive: "Inactive",
        pending: "Invite pending"
    }
};


/***/ }),

/***/ 69123:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "wj": () => (/* binding */ EMPTY_ROLE),
/* harmony export */   "yw": () => (/* binding */ ROLE_ADMIN)
/* harmony export */ });
/* unused harmony export OLD_USER_ROLE */
/* harmony import */ var api_permissions__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(41491);

const ROLE_ADMIN = {
    id: "25a33225-be5a-4c8b-ad4b-5ce10862e12d",
    name: "Global Admin",
    description: "Admin has all of the defined permissions and more",
    assigned_permissions_aggregate: {
        aggregate: {
            count: api_permissions__WEBPACK_IMPORTED_MODULE_0__/* .permissions.length */ .m.length
        }
    }
};
const OLD_USER_ROLE = {
    id: null,
    name: "User",
    description: "Old user permissions"
};
const EMPTY_ROLE = {
    id: null,
    name: "N/A",
    description: "Roles are missing for this user"
};


/***/ }),

/***/ 73646:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "U": () => (/* binding */ SetupPhoneMFA),
/* harmony export */   "k": () => (/* binding */ useSetupPhoneMFA)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var react_query__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(21478);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(3460);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(2658);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(1079);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(72642);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(3838);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(99226);
/* harmony import */ var _mui_material_TextField__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(94659);
/* harmony import */ var _mui_icons_material__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(95537);
/* harmony import */ var modules_notification__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(5769);
/* harmony import */ var libs_hooks__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(88289);
/* harmony import */ var libs_layouts__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(5855);
/* harmony import */ var ui__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(17218);
/* harmony import */ var modules_auth_loginHooks__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(26653);
/* harmony import */ var _messages__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(79799);
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}











function SingleFieldForm({ onSubmit , children  }) {
    return /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(libs_layouts__WEBPACK_IMPORTED_MODULE_4__/* .HStack */ .Ug, {
        as: "form",
        space: 2,
        onSubmit: (e)=>{
            e.preventDefault();
            onSubmit({
                form: e.target
            });
        }
    }, children, /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", {
        id: "recaptcha"
    }));
}
function ErrorMessage({ error  }) {
    return error && /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_mui_material__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
        error: true
    }, error === null || error === void 0 ? void 0 : error.message);
}
function SetupPhoneMFA(props) {
    const [verificationId, setVerificationId] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)("");
    const [phone, setPhone] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(null);
    const { service , error  } = (0,modules_auth_loginHooks__WEBPACK_IMPORTED_MODULE_6__/* .useAuthService */ .m)();
    const [captchaNode, verifierInstance] = (0,modules_auth_loginHooks__WEBPACK_IMPORTED_MODULE_6__/* .useCaptcha */ .u)([
        verificationId
    ]);
    const [resendCode, { error: resendSubmitError  }] = (0,react_query__WEBPACK_IMPORTED_MODULE_1__/* .useMutation */ .Db)(/*#__PURE__*/ _async_to_generator(function*() {
        const res = yield service.setupMFASendCode(phone, verifierInstance.current);
        setVerificationId(res);
    }));
    const [sendCode, { error: submitError , isLoading  }] = (0,react_query__WEBPACK_IMPORTED_MODULE_1__/* .useMutation */ .Db)(function() {
        var _ref = _async_to_generator(function*({ form  }) {
            const phone = form.elements["phone"][0].value;
            const res = yield service.setupMFASendCode(phone, verifierInstance.current);
            setPhone(phone);
            setVerificationId(res);
        });
        return function(_) {
            return _ref.apply(this, arguments);
        };
    }());
    const [verifyCode, { error: verificationError , isLoading: isVerifyLoading  }] = (0,react_query__WEBPACK_IMPORTED_MODULE_1__/* .useMutation */ .Db)(function() {
        var _ref = _async_to_generator(function*({ form  }) {
            const code = form.elements["verificationCode"].value;
            yield service.setupMFAVerify(verificationId, code);
            props.onDone();
        });
        return function(_) {
            return _ref.apply(this, arguments);
        };
    }());
    if (verificationId) {
        return /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(SingleFieldForm, {
            onSubmit: verifyCode,
            key: "verification"
        }, /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(libs_layouts__WEBPACK_IMPORTED_MODULE_4__/* .Stack */ .Kq, {
            space: 1,
            style: {
                width: "100%"
            }
        }, /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_mui_material__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
            variant: "body2",
            color: "textSecondary"
        }, _messages__WEBPACK_IMPORTED_MODULE_7__/* .messages.setupSmsConfirm */ .s.setupSmsConfirm(phone), /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_mui_material__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {
            onClick: ()=>setVerificationId(null)
        }, _messages__WEBPACK_IMPORTED_MODULE_7__/* .messages.setupChangePhoneNumber */ .s.setupChangePhoneNumber)), /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_mui_material_TextField__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z, {
            variant: "standard",
            name: "verificationCode",
            required: true,
            type: "text",
            label: "Enter your verification code"
        }), captchaNode, /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(ErrorMessage, {
            error: error || verificationError || resendSubmitError
        }), /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(ui__WEBPACK_IMPORTED_MODULE_5__/* .CardActions */ .T$, {
            secondary: /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_mui_material__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z, {
                id: "phone",
                color: "primary",
                onClick: ()=>resendCode()
            }, "Send again")
        }, props.onClose && /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_mui_material__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z, {
            color: "primary",
            onClick: props.onClose
        }, "Cancel"), /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(ui__WEBPACK_IMPORTED_MODULE_5__/* .LoadingButton */ .fl, {
            isLoading: isVerifyLoading,
            color: "primary",
            variant: "contained",
            type: "submit"
        }, "Submit code"))));
    }
    return /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(SingleFieldForm, {
        onSubmit: sendCode,
        key: "setup"
    }, /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(libs_layouts__WEBPACK_IMPORTED_MODULE_4__/* .Stack */ .Kq, {
        space: 1
    }, /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_mui_material__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
        variant: "body2",
        color: "textSecondary"
    }, _messages__WEBPACK_IMPORTED_MODULE_7__/* .messages.setupSms */ .s.setupSms), /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_mui_material_TextField__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z, {
        variant: "standard",
        style: {
            width: 300
        },
        placeholder: "+1(123) 456 7890",
        required: true,
        name: "phone",
        type: "tel",
        label: "Enter your phone"
    }), /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(ErrorMessage, {
        error: error || submitError
    }), captchaNode, /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(ui__WEBPACK_IMPORTED_MODULE_5__/* .CardActions */ .T$, null, props.onClose && /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_mui_material__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z, {
        color: "primary",
        onClick: props.onClose
    }, "Cancel"), /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(ui__WEBPACK_IMPORTED_MODULE_5__/* .LoadingButton */ .fl, {
        isLoading: isLoading,
        color: "primary",
        variant: "contained",
        id: "phone",
        type: "submit"
    }, "Send code"))));
}
function useSetupPhoneMFA({ onDone  }) {
    const [hasMFA, setMFA] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(false);
    const { service  } = (0,modules_auth_loginHooks__WEBPACK_IMPORTED_MODULE_6__/* .useAuthService */ .m)();
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useLayoutEffect)(()=>{
        if (service) {
            return service.onUserChange((_, user)=>{
                if (user) {
                    setMFA(service.hasMFA(user));
                }
            });
        }
    }, [
        service
    ]);
    function disableMFA() {
        return service.disableMFA().then(()=>{
            setMFA(false);
            modules_notification__WEBPACK_IMPORTED_MODULE_2__/* .notification.warning */ .t6.warning({
                message: "MFA has been disabled."
            });
        }).catch((e)=>{
            modules_notification__WEBPACK_IMPORTED_MODULE_2__/* .notification.error */ .t6.error({
                message: e === null || e === void 0 ? void 0 : e.message
            });
            throw e;
        });
    }
    const modal = (0,libs_hooks__WEBPACK_IMPORTED_MODULE_3__/* .useModal */ .dd)((props)=>/*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_mui_material__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z, _object_spread_props(_object_spread({}, props), {
            style: {
                margin: 20
            }
        }), /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(libs_layouts__WEBPACK_IMPORTED_MODULE_4__/* .Stack */ .Kq, {
            as: _mui_material__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z,
            padding: 3,
            space: 1,
            style: {
                width: 600
            }
        }, /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(libs_layouts__WEBPACK_IMPORTED_MODULE_4__/* .HStack */ .Ug, null, /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_mui_material__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
            variant: "h6",
            style: {
                textTransform: "capitalize"
            }
        }, _messages__WEBPACK_IMPORTED_MODULE_7__/* .messages.setupSmsAuth */ .s.setupSmsAuth), /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(libs_layouts__WEBPACK_IMPORTED_MODULE_4__/* .HStack.Spacer */ .Ug.Spacer, null), /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_mui_icons_material__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z, {
            onClick: props.onClose
        })), /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(SetupPhoneMFA, {
            onClose: props.onClose,
            onDone: ()=>{
                props.onClose();
                onDone();
                setMFA(true);
            }
        }))));
    return [
        modal[0],
        _object_spread_props(_object_spread({}, modal[1]), {
            hasMFA,
            isComputing: !service,
            disableMFA
        })
    ];
}


/***/ }),

/***/ 82735:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "AC": () => (/* binding */ getNotEmptyValidatorWithLabel),
/* harmony export */   "B_": () => (/* binding */ getNotEmptyValidator),
/* harmony export */   "Te": () => (/* binding */ getValidator),
/* harmony export */   "g$": () => (/* binding */ parseEmail),
/* harmony export */   "gs": () => (/* binding */ getMaxLengthValidator),
/* harmony export */   "oH": () => (/* binding */ validateEmail)
/* harmony export */ });
/* unused harmony exports passwordValidator, transformRoles, getRolesString */
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(27771);
/* harmony import */ var zod__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(1604);
/* harmony import */ var modules_auth_utils__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(27490);
/* harmony import */ var _messages__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(79799);




const getNotEmptyValidator = (...fields)=>(errors, values)=>{
        return fields.reduce((errors, field)=>{
            if (!values[field] || (0,lodash__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(values[field]) && values[field].length === 0) {
                errors[field] = _messages__WEBPACK_IMPORTED_MODULE_1__/* .messages.validation.required */ .s.validation.required(field);
            }
            return errors;
        }, errors);
    };
const validateEmail = (email)=>{
    const parsedEmail = zod__WEBPACK_IMPORTED_MODULE_3__.z.string().email().safeParse(email);
    return parsedEmail.success ? undefined : "Invalid email";
};
const parseEmail = (email)=>{
    const emailAllowedCharacters = /[^a-zA-Z0-9_\/–\-@.\+!%&"'*=?~|#$`\(\)\{\}]/g;
    return email === null || email === void 0 ? void 0 : email.replace(emailAllowedCharacters, "");
};
const getNotEmptyValidatorWithLabel = (field, label = _messages__WEBPACK_IMPORTED_MODULE_1__/* .messages.validation.required */ .s.validation.required(field))=>(errors, values)=>{
        if (!values[field] || (0,lodash__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(values[field]) && values[field].length === 0) {
            errors[field] = label;
        }
        return errors;
    };
const getMaxLengthValidator = (field, val)=>(errors, values)=>{
        if (Boolean(values[field]) && values[field].length > val) {
            errors[field] = _messages__WEBPACK_IMPORTED_MODULE_1__/* .messages.validation.maxLength */ .s.validation.maxLength(field);
        }
        return errors;
    };
const passwordValidator = (errors, values)=>{
    const complexityValidation = validatePasswordComplexity(values.password);
    if (complexityValidation) {
        errors.password = complexityValidation;
        return errors;
    }
    if (values.password !== values.password1) {
        errors.password1 = messages.validation.passwordNotIdentical;
    }
    return errors;
};
const getValidator = (...validators)=>(values)=>{
        return validators.reduce((errors, validator)=>validator(errors, values), {});
    };
const transformRoles = (values)=>{
    const roles = (values.roles || []).map((item)=>isObject(item) ? item["value"] : item);
    return Object.assign({}, values, {
        roles
    });
};
const getRolesString = (roles = [])=>(roles || []).join(", ");


/***/ }),

/***/ 76223:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "V": () => (/* binding */ ENV)
/* harmony export */ });
/* harmony import */ var shared_features__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(58767);
// file with variables that are passed during run time
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}

function getBool(v, defaultValue = false) {
    if (v === "" || v === undefined) {
        return defaultValue;
    }
    return typeof v === "string" ? v === "true" : typeof v === "boolean" ? v : false;
}
// runtime env provided after build
const getEnv = ()=>{
    var _versionInfo_hash, _env_GIT_COMMIT_HASH;
    if (typeof window === "undefined") {
        return {};
    }
    const versionInfo = JSON.parse({"npm_config_user_agent":"yarn/3.6.1 npm/? node/v18.16.1 linux x64","NODE_VERSION":"18.16.1","YARN_VERSION":"1.22.19","npm_node_execpath":"/tmp/xfs-831b8edc/node","HOME":"/root","npm_package_json":"/app/package.json","BABEL_ENV":"production","PATH":"/tmp/xfs-831b8edc:/usr/local/sbin:/usr/local/bin:/usr/sbin:/usr/bin:/sbin:/bin","npm_package_name":"cyberhaven","PROJECT_CWD":"/app","NODE_PATH":"src","npm_package_version":"0.0.1","npm_lifecycle_event":"build","PWD":"/app","BERRY_BIN_FOLDER":"/tmp/xfs-831b8edc","npm_execpath":"/tmp/xfs-831b8edc/yarn","NODE_ENV":"production","INIT_CWD":"/app"}.REACT_APP_VERSION || "{}");
    const isBeta = window.location.host.startsWith("beta") || "production" !== "production";
    const env = window.ENV || {};
    const features = window.FEATURES || {};
    const FIREBASE_AUTH_DOMAIN = env.FIREBASE_AUTH_DOMAIN || "es-scalability-test.firebaseapp.com";
    return _object_spread_props(_object_spread({
        FIREBASE_API_KEY: "AIzaSyC8s2MQBZugyxVHx-G9FGemwLMG4R7wnm8",
        FIREBASE_AUTH_DOMAIN,
        ENABLE_DATADOG: true,
        ALL_PERMISSIONS: getBool({"npm_config_user_agent":"yarn/3.6.1 npm/? node/v18.16.1 linux x64","NODE_VERSION":"18.16.1","YARN_VERSION":"1.22.19","npm_node_execpath":"/tmp/xfs-831b8edc/node","HOME":"/root","npm_package_json":"/app/package.json","BABEL_ENV":"production","PATH":"/tmp/xfs-831b8edc:/usr/local/sbin:/usr/local/bin:/usr/sbin:/usr/bin:/sbin:/bin","npm_package_name":"cyberhaven","PROJECT_CWD":"/app","NODE_PATH":"src","npm_package_version":"0.0.1","npm_lifecycle_event":"build","PWD":"/app","BERRY_BIN_FOLDER":"/tmp/xfs-831b8edc","npm_execpath":"/tmp/xfs-831b8edc/yarn","NODE_ENV":"production","INIT_CWD":"/app"}.REACT_APP_ALL_PERMISSIONS)
    }, env), {
        // ANALYTICS_API_KEY: "7efc2491-30ab-4720-44ae-c8846c6ecf6d",
        GIT_COMMIT_HASH: versionInfo.hash || env.GIT_COMMIT_HASH || "1",
        GIT_COMMIT_DATE: versionInfo.date * 1000 || env.GIT_COMMIT_DATE * 1000,
        GIT_COMMIT_MASTER_HASH: versionInfo.masterHash || env.GIT_COMMIT_MASTER_HASH,
        GIT_COMMIT_MASTER_DATE: versionInfo.masterDate * 1000 || env.GIT_COMMIT_MASTER_DATE * 1000,
        GIT_COMMIT_HASH_ID: ((_versionInfo_hash = versionInfo.hash) === null || _versionInfo_hash === void 0 ? void 0 : _versionInfo_hash.slice(0, 9)) || ((_env_GIT_COMMIT_HASH = env.GIT_COMMIT_HASH) === null || _env_GIT_COMMIT_HASH === void 0 ? void 0 : _env_GIT_COMMIT_HASH.slice(0, 9)),
        GIT_COMMIT_DIRTY: !!(versionInfo.dirty || env.GIT_COMMIT_DIRTY),
        GIT_TAG: env.GIT_TAG || "dev-version",
        VERSION: env.VERSION || "1",
        CUSTOMER_NAME: env.CUSTOMER_NAME || "internal",
        CUSTOMER_CODE: env.CUSTOMER_CODE || "none",
        // if it's internal deployment without sensitive data
        IS_INTERNAL: FIREBASE_AUTH_DOMAIN.includes("es-scalability-test"),
        // api key for development
        // STACKDRIVER_ERROR_REPORTER_API_KEY: "AIzaSyC2f_wjB941CeGRvgkgh_8QsSMQtR-Svbs",
        // this is api key only for testing so it's fine to hardcode it.
        INTERCOM_API_KEY: env.INTERCOM_API_KEY || "uz5fl6w6",
        IS_BETA_ENV: isBeta,
        STACKDRIVER_PROJECT_ID: env.STACKDRIVER_PROJECT_ID || "es-scalability-test",
        TOPLEVEL_DOMAIN: env.TOPLEVEL_DOMAIN || "cyberhaven.io",
        REACT_APP_STORY: !!{"npm_config_user_agent":"yarn/3.6.1 npm/? node/v18.16.1 linux x64","NODE_VERSION":"18.16.1","YARN_VERSION":"1.22.19","npm_node_execpath":"/tmp/xfs-831b8edc/node","HOME":"/root","npm_package_json":"/app/package.json","BABEL_ENV":"production","PATH":"/tmp/xfs-831b8edc:/usr/local/sbin:/usr/local/bin:/usr/sbin:/usr/bin:/sbin:/bin","npm_package_name":"cyberhaven","PROJECT_CWD":"/app","NODE_PATH":"src","npm_package_version":"0.0.1","npm_lifecycle_event":"build","PWD":"/app","BERRY_BIN_FOLDER":"/tmp/xfs-831b8edc","npm_execpath":"/tmp/xfs-831b8edc/yarn","NODE_ENV":"production","INIT_CWD":"/app"}.REACT_APP_STORY,
        MUI_X_LICENSE_KEY: "3dd1a47aaf58cb9b4e96f00bc2464c4fTz01MzkxMSxFPTE2OTk0NjMyMDM3MzQsUz1wcm8sTE09c3Vic2NyaXB0aW9uLEtWPTI=",
        FEATURES: _object_spread({}, shared_features__WEBPACK_IMPORTED_MODULE_0__/* .initialFeatures */ .J, features)
    });
};
// eslint-disable-next-line no-redeclare
const ENV = getEnv();


/***/ }),

/***/ 89880:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "H": () => (/* binding */ setServices),
/* harmony export */   "f": () => (/* binding */ resolveService)
/* harmony export */ });
/* harmony import */ var shared_mocks__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(76251);
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}

let services;
/// we use global parameter to not load unused services in tests
function resolveService(serviceName) {
    return _resolveService.apply(this, arguments);
}
function _resolveService() {
    _resolveService = _async_to_generator(function*(serviceName) {
        // we have to do it here because in out tests we do not import setupExternal services.
        if (false) {}
        if (!services) {
            const msg = "services are not set, failed to resolve service: " + serviceName;
            return Promise.reject(msg);
        }
        const logError = (yield (yield services).errorReporter).report;
        const service = yield (yield services)[serviceName];
        if (!service) {
            logError("Failed to locate service: " + serviceName);
            return Promise.reject("no such service");
        }
        return yield service;
    });
    return _resolveService.apply(this, arguments);
}
function setServices(s) {
    return _setServices.apply(this, arguments);
}
function _setServices() {
    _setServices = _async_to_generator(function*(s) {
        if (yield services) {
            throw new Error("services are already set");
        }
        services = s;
    });
    return _setServices.apply(this, arguments);
}


/***/ }),

/***/ 48351:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Ap": () => (/* binding */ preloadUserPermissions),
/* harmony export */   "Qe": () => (/* binding */ useUserPermissions),
/* harmony export */   "dO": () => (/* binding */ useCurrentUserId),
/* harmony export */   "m8": () => (/* binding */ preloadCurrentUser),
/* harmony export */   "xJ": () => (/* binding */ useCurrentUser)
/* harmony export */ });
/* unused harmony exports useCurrentUserEmail, useIsCyberhavenUser */
/* harmony import */ var react_query__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(21478);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(28216);
/* harmony import */ var api__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(62688);
/* harmony import */ var api_graphql__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(37137);
/* harmony import */ var api_graphql_network__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(48863);
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}





const userKey = "user";
const CACHE_STALE_TIME = 15 * 60 * 1000;
function useCurrentUser() {
    const userId = useCurrentUserId();
    return (0,react_query__WEBPACK_IMPORTED_MODULE_0__/* .useQuery */ .aM)([
        userKey,
        userId
    ], ()=>api__WEBPACK_IMPORTED_MODULE_2__.api.auth.AuthService.UserGet({
            id: userId
        }).then((el)=>el), {
        enabled: !!userId
    });
}
function preloadCurrentUser(cache, userId) {
    return cache.prefetchQuery([
        userKey,
        userId
    ], ()=>api__WEBPACK_IMPORTED_MODULE_2__.api.auth.AuthService.UserGet({
            id: userId
        }), {
        staleTime: CACHE_STALE_TIME
    });
}
function useCurrentUserId() {
    return (0,react_redux__WEBPACK_IMPORTED_MODULE_1__/* .useSelector */ .v9)((store)=>{
        var _store_auth, _store_auth_user;
        return (_store_auth = store.auth) === null || _store_auth === void 0 ? void 0 : (_store_auth_user = _store_auth.user) === null || _store_auth_user === void 0 ? void 0 : _store_auth_user.id;
    });
}
function useCurrentUserEmail() {
    return useSelector((store)=>{
        var _store_auth, _store_auth_user;
        return (_store_auth = store.auth) === null || _store_auth === void 0 ? void 0 : (_store_auth_user = _store_auth.user) === null || _store_auth_user === void 0 ? void 0 : _store_auth_user.email;
    });
}
function preloadUserPermissions(cache, userId) {
    return cache.prefetchQuery([
        userKey,
        "permissions",
        userId
    ], /*#__PURE__*/ _async_to_generator(function*() {
        const roles = yield (0,api_graphql_network__WEBPACK_IMPORTED_MODULE_4__/* .sendGQLRequest */ .n)(api_graphql__WEBPACK_IMPORTED_MODULE_3__/* .GetUserPermissionsDocument */ .MM, {
            userId
        });
        const currentUser = yield preloadCurrentUser(cache, userId);
        const permissions = roles.subject_permission.map((el)=>el.permission).filter(Boolean);
        return {
            roles: currentUser === null || currentUser === void 0 ? void 0 : currentUser.roles,
            permissions
        };
    }), {
        staleTime: CACHE_STALE_TIME
    });
}
const permissionsKey = "permissions";
function useUserPermissions(userId) {
    const queryCache = (0,react_query__WEBPACK_IMPORTED_MODULE_0__/* .useQueryCache */ .Zq)();
    return (0,react_query__WEBPACK_IMPORTED_MODULE_0__/* .useQuery */ .aM)([
        permissionsKey,
        userId
    ], /*#__PURE__*/ _async_to_generator(function*() {
        const roles = yield (0,api_graphql_network__WEBPACK_IMPORTED_MODULE_4__/* .sendGQLRequest */ .n)(api_graphql__WEBPACK_IMPORTED_MODULE_3__/* .GetUserPermissionsDocument */ .MM, {
            userId
        });
        const currentUser = yield preloadCurrentUser(queryCache, userId);
        const permissions = roles.subject_permission.map((el)=>el.permission).filter(Boolean);
        return {
            roles: currentUser === null || currentUser === void 0 ? void 0 : currentUser.roles,
            permissions
        };
    }), {
        enabled: !!userId,
        staleTime: CACHE_STALE_TIME
    });
}
const cyberhavenEmailPostfixes = (/* unused pure expression or super */ null && ([
    "cyberhaven.com",
    "cyberhaven.io"
]));
function useIsCyberhavenUser() {
    const currentUser = useSelector((store)=>{
        var _store_auth;
        return (_store_auth = store.auth) === null || _store_auth === void 0 ? void 0 : _store_auth.user;
    });
    return cyberhavenEmailPostfixes.some((postfix)=>{
        return currentUser === null || currentUser === void 0 ? void 0 : currentUser.email.endsWith(postfix);
    });
}


/***/ }),

/***/ 58983:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "C": () => (/* binding */ isRbacError)
/* harmony export */ });
/* harmony import */ var axios__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(9669);
/* harmony import */ var axios__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(axios__WEBPACK_IMPORTED_MODULE_0__);

function isRbacError(error) {
    if (axios__WEBPACK_IMPORTED_MODULE_0___default().isAxiosError(error)) {
        const { response  } = error;
        if (response) {
            var _data_detail;
            const { status , data  } = response;
            if ([
                401,
                403
            ].includes(status) && (data === null || data === void 0 ? void 0 : (_data_detail = data.detail) === null || _data_detail === void 0 ? void 0 : _data_detail.Code) !== "mfa-required") {
                return {
                    result: true,
                    error: error
                };
            }
        }
    }
    return {
        result: false
    };
}


/***/ }),

/***/ 68446:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "s$": () => (/* binding */ IS_SAFARI)
/* harmony export */ });
/* unused harmony exports browsers, IS_FF, IS_CHROME, IS_IE, IS_EDGE */
/* harmony import */ var bowser_bowser__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(83257);
/* harmony import */ var bowser_bowser__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(bowser_bowser__WEBPACK_IMPORTED_MODULE_0__);

const browsers = {
    FF: "firefox",
    Chrome: "chrome",
    IE: "msie",
    safari: "safari",
    edge: "msedge"
};
const IS_FF = (bowser_bowser__WEBPACK_IMPORTED_MODULE_0___default())[browsers.FF];
const IS_CHROME = (bowser_bowser__WEBPACK_IMPORTED_MODULE_0___default())[browsers.Chrome];
const IS_IE = (bowser_bowser__WEBPACK_IMPORTED_MODULE_0___default())[browsers.IE];
const IS_SAFARI = (bowser_bowser__WEBPACK_IMPORTED_MODULE_0___default())[browsers.safari];
const IS_EDGE = (bowser_bowser__WEBPACK_IMPORTED_MODULE_0___default())[browsers.edge];


/***/ }),

/***/ 38440:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "IR": () => (/* binding */ policiesFormDefaults),
/* harmony export */   "Kk": () => (/* binding */ dialogMessages),
/* harmony export */   "Rm": () => (/* binding */ createTypeEnum),
/* harmony export */   "Yh": () => (/* binding */ datasetDefaults),
/* harmony export */   "go": () => (/* binding */ policyDefaults)
/* harmony export */ });
/* harmony import */ var runenv__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(76223);
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(85295);
/* harmony import */ var api_gen__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(33013);
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}



// DAT-3252: Skip logo data because we use hardcoded warning icon on the endpoint until DAT-3199 is resolved
const dialogMessages = (customer, type = "Warning")=>({
        title: `${type}: violation of ${customer} security policy`,
        explanation: `The action you just performed violates ${customer} security policies`,
        placeholder: `${type === "Warning" ? "Optional:" : ""} Please, provide a justification for your action`,
        check_text: "I acknowledge that I have read and understood this message",
        submit_label: "I UNDERSTAND",
        review_check_text: "I received this by mistake, please review and update this policy",
        allow_label: "ALLOW"
    });
const policiesFormDefaults = {
    show_title: true,
    warning_dialog: _object_spread({}, dialogMessages((0,lodash__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(runenv__WEBPACK_IMPORTED_MODULE_0__/* .ENV.CUSTOMER_NAME */ .V.CUSTOMER_NAME))),
    blocking_dialog: _object_spread({}, dialogMessages((0,lodash__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(runenv__WEBPACK_IMPORTED_MODULE_0__/* .ENV.CUSTOMER_NAME */ .V.CUSTOMER_NAME), "Blocking")),
    // DAT-3252: always show logo
    show_logo: true
};
const policyDefaults = {
    name: "",
    dataset_ids: [],
    selection_type: "dataset",
    exclude_origin: false,
    query: {
        rules: []
    },
    // Low
    severity: 1,
    rule: _object_spread_props(_object_spread({}, policiesFormDefaults), {
        create_incident: false,
        notify_email: "",
        notify_enabled: false,
        incident_action: api_gen__WEBPACK_IMPORTED_MODULE_1__/* .IncidentActionEnum.IncidentActionNone */ .LE.IncidentActionNone,
        notify_status: "",
        status: api_gen__WEBPACK_IMPORTED_MODULE_1__/* .CategoryStatusEnum.CategoryStatusRisky */ .HL.CategoryStatusRisky
    })
};
const datasetDefaults = {
    name: "",
    category_ids: [],
    sensitivity: 1
};
const createTypeEnum = {
    search: "search",
    new: "new"
};


/***/ }),

/***/ 91418:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "S7": () => (/* binding */ DATE_FORMAT_WITH_TIME),
/* harmony export */   "Z8": () => (/* binding */ formatDateTimeLocal),
/* harmony export */   "vG": () => (/* binding */ formatDateTimeUtc),
/* harmony export */   "zT": () => (/* binding */ DATE_FORMAT),
/* harmony export */   "zy": () => (/* binding */ DATE_FORMAT_WITH_TIME_SEC)
/* harmony export */ });
/* unused harmony exports formatDateUtc, formatDateTime */
/* harmony import */ var date_fns_format__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(46630);
/* harmony import */ var libs_time_utc__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(75044);


const DATE_FORMAT_WITH_TIME = "yyyy-MM-dd, HH:mm";
const DATE_FORMAT_WITH_TIME_SEC = "yy-MM-dd, HH:mm:ss";
const DATE_FORMAT = "yyyy-MM-dd";
function formatDateUtc(date, format = DATE_FORMAT) {
    return formatUTC(date, format);
}
function formatDateTime(date, format = DATE_FORMAT_WITH_TIME) {
    if (!date) {
        return null;
    }
    return formatDateTimeUtc(new Date(date), format);
}
function formatDateTimeLocal(date, format = DATE_FORMAT_WITH_TIME) {
    return (0,date_fns_format__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(date ? new Date(date) : new Date(), format);
}
function formatDateTimeUtc(date, format = DATE_FORMAT_WITH_TIME) {
    return (0,libs_time_utc__WEBPACK_IMPORTED_MODULE_1__/* .formatUTC */ .g$)(date, format);
}



/***/ }),

/***/ 26277:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "l": () => (/* binding */ useLocationEditFilters),
/* harmony export */   "q": () => (/* binding */ editConfig)
/* harmony export */ });
/* harmony import */ var shared_dashboard__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(38440);
/* harmony import */ var modules_table__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(25373);
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}


const editConfig = {
    editingDataset: {
        queryKey: "editingDataset",
        defaultValue: {}
    },
    editingPolicy: {
        queryKey: "editingPolicy",
        defaultValue: {}
    }
};
function useLocationEditFilters() {
    const { editingPolicy , editingDataset , setEditingDataset: setEditingDatasetOriginal , setEditingPolicy  } = (0,modules_table__WEBPACK_IMPORTED_MODULE_1__/* .useFilters */ .mN)({
        filters: editConfig,
        queryKeyPrefix: "",
        initialValue: {}
    });
    const setEditingDataset = (editData)=>{
        if (!editData) {
            return setEditingDatasetOriginal(editData);
        }
        const copy = _object_spread({}, editData.values);
        // @ts-ignore
        delete copy.severity;
        setEditingDatasetOriginal({
            id: editData.id,
            values: copy
        });
    };
    return {
        policyEdit: {
            id: editingPolicy === null || editingPolicy === void 0 ? void 0 : editingPolicy.id,
            // means it's either new or search or edit
            isEditing: !!(editingPolicy === null || editingPolicy === void 0 ? void 0 : editingPolicy.id),
            // means that we are editing entity that exists
            isEdit: (editingPolicy === null || editingPolicy === void 0 ? void 0 : editingPolicy.id) !== "new" && (editingPolicy === null || editingPolicy === void 0 ? void 0 : editingPolicy.id) !== "search" && !!(editingPolicy === null || editingPolicy === void 0 ? void 0 : editingPolicy.id),
            isNew: (editingPolicy === null || editingPolicy === void 0 ? void 0 : editingPolicy.id) === "new",
            isSearch: (editingPolicy === null || editingPolicy === void 0 ? void 0 : editingPolicy.id) === "search",
            editingPolicyValues: editingPolicy === null || editingPolicy === void 0 ? void 0 : editingPolicy.values,
            convertToEdit () {
                let values = editingPolicy === null || editingPolicy === void 0 ? void 0 : editingPolicy.values;
                if (editingPolicy === null || editingPolicy === void 0 ? void 0 : editingPolicy.values) {
                    values = _object_spread_props(_object_spread({}, editingPolicy === null || editingPolicy === void 0 ? void 0 : editingPolicy.values), {
                        dataset_ids: []
                    });
                }
                setEditingPolicy({
                    id: shared_dashboard__WEBPACK_IMPORTED_MODULE_0__/* .createTypeEnum["new"] */ .Rm["new"],
                    values: values
                });
            },
            setEditingPolicyValues (v) {
                setEditingPolicy({
                    id: editingPolicy === null || editingPolicy === void 0 ? void 0 : editingPolicy.id,
                    values: v
                });
            },
            startEditingPolicy (id, v = shared_dashboard__WEBPACK_IMPORTED_MODULE_0__/* .policyDefaults */ .go) {
                setEditingPolicy({
                    id: id,
                    values: v
                });
            },
            finishEditingPolicy () {
                setEditingPolicy(undefined);
            },
            cancelEditingPolicy () {
                setEditingPolicy(undefined);
            }
        },
        datasetEdit: {
            isEdit: (editingDataset === null || editingDataset === void 0 ? void 0 : editingDataset.id) !== "new" && (editingDataset === null || editingDataset === void 0 ? void 0 : editingDataset.id) !== "search" && !!editingDataset.id,
            isEditing: !!editingDataset.id,
            isNew: editingDataset.id === "new",
            isSearch: editingDataset.id === "search",
            id: editingDataset === null || editingDataset === void 0 ? void 0 : editingDataset.id,
            editingValues: editingDataset === null || editingDataset === void 0 ? void 0 : editingDataset.values,
            setEditingValues (v) {
                setEditingDataset({
                    id: editingDataset.id,
                    values: v
                });
            },
            startEditing (id, v = shared_dashboard__WEBPACK_IMPORTED_MODULE_0__/* .datasetDefaults */ .Yh) {
                setEditingDataset({
                    id: id,
                    values: v
                });
            },
            convertToEdit () {
                let values = editingDataset === null || editingDataset === void 0 ? void 0 : editingDataset.values;
                if (editingDataset === null || editingDataset === void 0 ? void 0 : editingDataset.values) {
                    values = _object_spread_props(_object_spread({}, editingDataset === null || editingDataset === void 0 ? void 0 : editingDataset.values), {
                        category_ids: []
                    });
                }
                setEditingDataset({
                    id: shared_dashboard__WEBPACK_IMPORTED_MODULE_0__/* .createTypeEnum["new"] */ .Rm["new"],
                    values
                });
            },
            finishEditing () {
                setEditingDataset(undefined);
            },
            cancelEditing () {
                setEditingDataset(undefined);
            }
        }
    };
}


/***/ }),

/***/ 66246:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "f": () => (/* binding */ useAppEnvironment),
/* harmony export */   "k": () => (/* binding */ AppEnvironmentProvider)
/* harmony export */ });
/* harmony import */ var constate__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(11521);

// Environment provider serves generic purpose of storing app scoped data like services
// navigation icons and similar stuff
const [AppEnvironmentProvider, useAppEnvironment] = (0,constate__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(({ navigationItems , routes  })=>{
    return {
        navigationItems: navigationItems !== null && navigationItems !== void 0 ? navigationItems : [],
        routes
    };
});


/***/ }),

/***/ 45026:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "e": () => (/* binding */ reportError)
/* harmony export */ });
/* harmony import */ var service__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(89880);
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}

function reportError(text) {
    return _reportError.apply(this, arguments);
}
function _reportError() {
    _reportError = _async_to_generator(function*(text) {
        if (typeof text === "object") {
            text = JSON.stringify(text);
        }
        const logger = yield (0,service__WEBPACK_IMPORTED_MODULE_0__/* .resolveService */ .f)("errorReporter");
        logger.report(text);
    });
    return _reportError.apply(this, arguments);
}


/***/ }),

/***/ 58767:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "J": () => (/* binding */ initialFeatures),
/* harmony export */   "L": () => (/* binding */ Feature)
/* harmony export */ });
var Feature;
(function(Feature) {
    Feature["ZendeskWidget"] = "zendesk_widget";
    Feature["ANALYTICS_CUSTOMIZABLE_CHARTS"] = "ANALYTICS_CUSTOMIZABLE_CHARTS";
    Feature["ANALYTICS_CUSTOMIZABLE_FILTERS"] = "ANALYTICS_CUSTOMIZABLE_FILTERS";
    Feature["ANALYTICS_DASHBOARD"] = "ANALYTICS_DASHBOARD";
    Feature["ANALYTICS_DASHBOARD_ALERTS"] = "ANALYTICS_DASHBOARD_ALERTS";
    Feature["ANALYTICS_DASHBOARD_AUTO_REFRESH"] = "ANALYTICS_DASHBOARD_AUTO_REFRESH";
    Feature["ANALYTICS_MAX_CONCURRENT_CHARTS_LOADING"] = "ANALYTICS_MAX_CONCURRENT_CHARTS_LOADING";
    Feature["BLOCKING"] = "BLOCKING";
    Feature["CLOUD_APPS_NEW_FIELDS"] = "CLOUD_APPS_NEW_FIELDS";
    Feature["CONSOLE_SUPPORTED_ENDPOINT_FIELDS"] = "CONSOLE_SUPPORTED_ENDPOINT_FIELDS";
    Feature["DASHBOARD_TRENDS_OVER_TIME_WIDGET"] = "DASHBOARD_TRENDS_OVER_TIME_WIDGET";
    Feature["DashboardV2"] = "dashboard_v2";
    Feature["DATAFLOWS_RETENTION_DAYS"] = "DATAFLOWS_RETENTION_DAYS";
    Feature["ANALYTICS_RETENTION_DAYS"] = "ANALYTICS_RETENTION_DAYS";
    Feature["DIRECTORY_INTEGRATION"] = "DIRECTORY_INTEGRATION";
    Feature["NUM_PRELOADED_EDGES"] = "NUM_PRELOADED_EDGES";
    Feature["DIRECTORY_INTEGRATION_CEL_EXPRESSIONS"] = "DIRECTORY_INTEGRATION_CEL_EXPRESSIONS";
    Feature["ENABLE_EXTERNAL_CONTENT"] = "ENABLE_EXTERNAL_CONTENT";
    Feature["ENABLE_READONLY_REMOTE_CONFIG_MODE"] = "ENABLE_READONLY_REMOTE_CONFIG_MODE";
    Feature["ENABLE_SCREENSHOTS"] = "ENABLE_SCREENSHOTS";
    Feature["ENABLE_VISUAL_ANALYTICS_RBAC"] = "ENABLE_VISUAL_ANALYTICS_RBAC";
    Feature["ENABLE_SILENT_SCREENSHOTS"] = "ENABLE_SILENT_SCREENSHOTS";
    Feature["ENFORCE_2FA_UI"] = "ENFORCE_2FA_UI";
    Feature["INSIDER_RISK_MANAGEMENT_TABLE"] = "INSIDER_RISK_MANAGEMENT_TABLE";
    Feature["IRM_USER_GROUPS_STRING_ARRAY"] = "IRM_USER_GROUPS_STRING_ARRAY";
    Feature["NEW_LOGO_2023"] = "NEW_LOGO_2023";
    Feature["SLACK_ENABLED"] = "SLACK_ENABLED";
    Feature["UI_LEGACY_AWS_VISIBLE_FOR_CREATE"] = "UI_LEGACY_AWS_VISIBLE_FOR_CREATE";
    Feature["UPDATE_POLICY_LTS"] = "UPDATE_POLICY_LTS";
    Feature["RO_LOW_PERFORMANCE_INDICATOR"] = "RO_LOW_PERFORMANCE_INDICATOR";
    Feature["VA_EXPORT_TO_PDF"] = "VA_EXPORT_TO_PDF";
    Feature["USER_WIDGET_DIRECTORY_DETAILS_ENABLED"] = "USER_WIDGET_DIRECTORY_DETAILS_ENABLED";
    Feature["DATAFLOWS_ALLOW_NON_PRECOMPUTED"] = "DATAFLOWS_ALLOW_NON_PRECOMPUTED";
    Feature["RO_USER_DIRECTORY_RULES"] = "RO_USER_DIRECTORY_RULES";
    Feature["ENABLE_GLOBAL_SEARCH"] = "ENABLE_GLOBAL_SEARCH";
    Feature["CONTENT_BASED_RBAC"] = "CONTENT_BASED_RBAC";
    Feature["DIRECTORY_INTEGRATION_LIST_OF_INTEGRATION_ADVANCED"] = "DIRECTORY_INTEGRATION_LIST_OF_INTEGRATION_ADVANCED";
})(Feature || (Feature = {}));
/*
  Use this constant to configure local env with features.
  On production this will be empty meaning all features disabled by default.
*/ const devEnvFeatures = {
    [Feature.ZendeskWidget]: {"npm_config_user_agent":"yarn/3.6.1 npm/? node/v18.16.1 linux x64","NODE_VERSION":"18.16.1","YARN_VERSION":"1.22.19","npm_node_execpath":"/tmp/xfs-831b8edc/node","HOME":"/root","npm_package_json":"/app/package.json","BABEL_ENV":"production","PATH":"/tmp/xfs-831b8edc:/usr/local/sbin:/usr/local/bin:/usr/sbin:/usr/bin:/sbin:/bin","npm_package_name":"cyberhaven","PROJECT_CWD":"/app","NODE_PATH":"src","npm_package_version":"0.0.1","npm_lifecycle_event":"build","PWD":"/app","BERRY_BIN_FOLDER":"/tmp/xfs-831b8edc","npm_execpath":"/tmp/xfs-831b8edc/yarn","NODE_ENV":"production","INIT_CWD":"/app"}.ZENDESK_WIDGET === "true",
    ANALYTICS_CUSTOMIZABLE_CHARTS: true,
    ANALYTICS_CUSTOMIZABLE_FILTERS: true,
    ANALYTICS_DASHBOARD_ALERTS: true,
    ANALYTICS_DASHBOARD_AUTO_REFRESH: true,
    ANALYTICS_DASHBOARD: true,
    ANALYTICS_MAX_CONCURRENT_CHARTS_LOADING: 2,
    BLOCKING: true,
    CLOUD_APPS_NEW_FIELDS: true,
    CONSOLE_SUPPORTED_ENDPOINT_FIELDS: {
        allowed: []
    },
    DASHBOARD_TRENDS_OVER_TIME_WIDGET: true,
    dashboard_v2: true,
    DATAFLOWS_RETENTION_DAYS: 30,
    DIRECTORY_INTEGRATION_CEL_EXPRESSIONS: true,
    DIRECTORY_INTEGRATION: true,
    ENABLE_SILENT_SCREENSHOTS: true,
    ENABLE_EXTERNAL_CONTENT: true,
    ENABLE_READONLY_REMOTE_CONFIG_MODE: "reader",
    ENABLE_SCREENSHOTS: true,
    ENABLE_VISUAL_ANALYTICS_RBAC: true,
    ENFORCE_2FA_UI: true,
    INSIDER_RISK_MANAGEMENT_TABLE: true,
    IRM_USER_GROUPS_STRING_ARRAY: false,
    NEW_LOGO_2023: true,
    SLACK_ENABLED: true,
    UI_LEGACY_AWS_VISIBLE_FOR_CREATE: true,
    UPDATE_POLICY_LTS: true,
    NUM_PRELOADED_EDGES: 1000,
    RO_LOW_PERFORMANCE_INDICATOR: true,
    VA_EXPORT_TO_PDF: true,
    ANALYTICS_RETENTION_DAYS: true,
    USER_WIDGET_DIRECTORY_DETAILS_ENABLED: true,
    DATAFLOWS_ALLOW_NON_PRECOMPUTED: true,
    RO_USER_DIRECTORY_RULES: true,
    ENABLE_GLOBAL_SEARCH: true,
    CONTENT_BASED_RBAC: true,
    DIRECTORY_INTEGRATION_LIST_OF_INTEGRATION_ADVANCED: true
};
// True for features that already rolled out to everyone
const prodEnvFallbackFeatures = {
    [Feature.ZendeskWidget]: {"npm_config_user_agent":"yarn/3.6.1 npm/? node/v18.16.1 linux x64","NODE_VERSION":"18.16.1","YARN_VERSION":"1.22.19","npm_node_execpath":"/tmp/xfs-831b8edc/node","HOME":"/root","npm_package_json":"/app/package.json","BABEL_ENV":"production","PATH":"/tmp/xfs-831b8edc:/usr/local/sbin:/usr/local/bin:/usr/sbin:/usr/bin:/sbin:/bin","npm_package_name":"cyberhaven","PROJECT_CWD":"/app","NODE_PATH":"src","npm_package_version":"0.0.1","npm_lifecycle_event":"build","PWD":"/app","BERRY_BIN_FOLDER":"/tmp/xfs-831b8edc","npm_execpath":"/tmp/xfs-831b8edc/yarn","NODE_ENV":"production","INIT_CWD":"/app"}.ZENDESK_WIDGET === "true",
    BLOCKING: true,
    ENABLE_VISUAL_ANALYTICS_RBAC: true,
    DIRECTORY_INTEGRATION: true,
    DATAFLOWS_RETENTION_DAYS: 90,
    ANALYTICS_MAX_CONCURRENT_CHARTS_LOADING: 3,
    ENABLE_READONLY_REMOTE_CONFIG_MODE: ""
};
const initialFeatures =  false ? 0 : prodEnvFallbackFeatures;


/***/ }),

/***/ 10451:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "BU": () => (/* reexport safe */ _useHistoryParam__WEBPACK_IMPORTED_MODULE_2__.B),
/* harmony export */   "CZ": () => (/* reexport safe */ _utils__WEBPACK_IMPORTED_MODULE_0__.CZ),
/* harmony export */   "Ni": () => (/* reexport safe */ _useHistoryParam__WEBPACK_IMPORTED_MODULE_2__.N),
/* harmony export */   "S7": () => (/* reexport safe */ _dateFormat__WEBPACK_IMPORTED_MODULE_1__.S7),
/* harmony export */   "U3": () => (/* reexport safe */ _utils__WEBPACK_IMPORTED_MODULE_0__.U3),
/* harmony export */   "Z8": () => (/* reexport safe */ _dateFormat__WEBPACK_IMPORTED_MODULE_1__.Z8),
/* harmony export */   "ZO": () => (/* reexport safe */ _utils__WEBPACK_IMPORTED_MODULE_0__.ZO),
/* harmony export */   "ZT": () => (/* reexport safe */ _utils__WEBPACK_IMPORTED_MODULE_0__.ZT),
/* harmony export */   "oA": () => (/* reexport safe */ _utils__WEBPACK_IMPORTED_MODULE_0__.oA),
/* harmony export */   "sQ": () => (/* reexport safe */ _utils__WEBPACK_IMPORTED_MODULE_0__.sQ),
/* harmony export */   "vG": () => (/* reexport safe */ _dateFormat__WEBPACK_IMPORTED_MODULE_1__.vG),
/* harmony export */   "zT": () => (/* reexport safe */ _dateFormat__WEBPACK_IMPORTED_MODULE_1__.zT),
/* harmony export */   "zy": () => (/* reexport safe */ _dateFormat__WEBPACK_IMPORTED_MODULE_1__.zy)
/* harmony export */ });
/* harmony import */ var _utils__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(93681);
/* harmony import */ var _dateFormat__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(91418);
/* harmony import */ var _useHistoryParam__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(21714);







/***/ }),

/***/ 20168:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "P": () => (/* binding */ logInfo)
/* harmony export */ });
const logInfo = (...info)=>{
    console.log(...info); // eslint-disable-line no-console
};


/***/ }),

/***/ 76251:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "c": () => (/* binding */ mockErrorHandler)
/* harmony export */ });
/* unused harmony export setupMockLogger */

function setupMockLogger() {
    return {
        event: (event)=>logInfo("user events", event),
        error: (e)=>console.warn("report error", e.message)
    };
}
const mockErrorHandler = {
    report: console.error,
    setUser: ()=>{}
};


/***/ }),

/***/ 44916:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "E3": () => (/* binding */ PermissionsProvider),
/* harmony export */   "bV": () => (/* binding */ PermissionsServiceImp),
/* harmony export */   "m1": () => (/* binding */ Can),
/* harmony export */   "py": () => (/* binding */ useCan),
/* harmony export */   "r6": () => (/* binding */ useCanHook),
/* harmony export */   "tn": () => (/* binding */ useCanArray)
/* harmony export */ });
/* unused harmony export usePermissions */
/* harmony import */ var constate__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(11521);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var react_query__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(21478);
/* harmony import */ var shared_auth_hooks__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(48351);
/* harmony import */ var service__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(89880);
/* harmony import */ var runenv__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(76223);
/* harmony import */ var libs_hooks__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(88289);
/* harmony import */ var modules_auth_state__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(45386);
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}








function usePermissionsHook() {
    var _user_data;
    const currentUserId = (0,shared_auth_hooks__WEBPACK_IMPORTED_MODULE_2__/* .useCurrentUserId */ .dO)();
    const user = (0,shared_auth_hooks__WEBPACK_IMPORTED_MODULE_2__/* .useUserPermissions */ .Qe)(currentUserId);
    var _user_data_permissions;
    const permissions = (_user_data_permissions = user === null || user === void 0 ? void 0 : (_user_data = user.data) === null || _user_data === void 0 ? void 0 : _user_data.permissions) !== null && _user_data_permissions !== void 0 ? _user_data_permissions : [];
    var _user_data_roles;
    return (0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(()=>{
        var _user_data;
        return {
            roles: (_user_data_roles = (_user_data = user.data) === null || _user_data === void 0 ? void 0 : _user_data.roles) !== null && _user_data_roles !== void 0 ? _user_data_roles : [],
            permissions,
            isPending: user.isLoading,
            permissionsSet: new Set(permissions)
        };
    }, [
        user.data
    ]);
}
const [PermissionsProvider, usePermissions] = (0,constate__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(usePermissionsHook);
function canAccess(permissionSet, requiredPermissions, isAnyOf) {
    if (runenv__WEBPACK_IMPORTED_MODULE_4__/* .ENV.ALL_PERMISSIONS */ .V.ALL_PERMISSIONS) {
        return true;
    }
    const requiredPermissionsArray = Array.isArray(requiredPermissions) ? requiredPermissions : [
        requiredPermissions
    ];
    return permissionSet ? isAnyOf ? !!requiredPermissionsArray.find((el)=>permissionSet.has(el)) : requiredPermissionsArray.every((el)=>permissionSet.has(el)) : false;
}
/**
 * How to use it
 * <Can do="users.update"><ActionToRestrict/></Can>
 */ function Can(props) {
    const { permissionsSet , isPending  } = usePermissions();
    const isDoEither = !!props.doAnyOf;
    const doList = props.do || props.doAnyOf;
    if (props.do && props.doAnyOf) {
        throw Error("Only 1 type of do can be used at a time");
    }
    if (isPending) {
        return null;
    }
    if (!doList || !doList.length) {
        return typeof props.children === "function" ? props.children({
            canDo: true
        }) : props.children;
    }
    if (!canAccess(permissionsSet, doList, isDoEither)) {
        return props.fallback ? displayRenderFn(props.fallback) : typeof props.children === "function" ? props.children({
            canDo: false
        }) : null;
    }
    return /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Fragment, null, typeof props.children === "function" ? props.children({
        canDo: true
    }) : props.children);
}
function displayRenderFn(arg) {
    return /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.isValidElement(arg) ? arg : typeof arg === "function" ? arg() : arg;
}
function useCanArray({ items , getItemPermission , isDoEither  }) {
    const { permissionsSet , isPending  } = usePermissions();
    return (0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(()=>{
        if (isPending) {
            return null;
        }
        return items.filter((item)=>{
            const itemPermission = getItemPermission(item);
            if (!itemPermission) {
                return true;
            }
            return canAccess(permissionsSet, itemPermission, typeof isDoEither === "function" ? isDoEither(item) : !!isDoEither);
        });
    }, [
        items,
        isDoEither,
        isPending,
        permissionsSet
    ]);
}
// alternative without resolveService which is unsupported in tests
function useCanHook(_do, isAnyOf = false) {
    const { permissionsSet , isPending  } = usePermissions();
    if (isPending) {
        return null;
    }
    return canAccess(permissionsSet, _do, isAnyOf);
}
// Uses resolveService which is not supported in testing but good for caching
function useCan(_do, isAnyOf = false) {
    // Use user id as part of query key to invalidate cache when user changes
    const { id  } = (0,libs_hooks__WEBPACK_IMPORTED_MODULE_5__/* .useSelector */ .v9)(modules_auth_state__WEBPACK_IMPORTED_MODULE_6__/* .authState.stores.user */ .f.stores.user);
    return (0,react_query__WEBPACK_IMPORTED_MODULE_1__/* .useQuery */ .aM)([
        "permissions",
        _do,
        id
    ], ()=>_do ? (0,service__WEBPACK_IMPORTED_MODULE_3__/* .resolveService */ .f)("permissions").then((el)=>el.canDo(_do, isAnyOf)) : true, {
        suspense: true,
        // Make sure once resolved permission refetches in background
        // This prevents app suddenly show Loading spinner instead of page once permissions refetching after 5 minute timer
        cacheTime: 1000 * 60 * 60,
        refetchInterval: 1000 * 60 * 5,
        refetchIntervalInBackground: true
    });
}
class PermissionsServiceImp {
    setCurrentUser(userId) {
        this.userId = userId;
    }
    preloadPermissions() {
        if (!this.userId) {
            console.error("user is not available yet");
            return false;
        }
        return (0,shared_auth_hooks__WEBPACK_IMPORTED_MODULE_2__/* .preloadUserPermissions */ .Ap)(this.queryCache, this.userId);
    }
    canDo(requiredPermissions, isAnyOf = false) {
        var _this = this;
        return _async_to_generator(function*() {
            if (!_this.userId) {
                console.error("user is not available yet");
                return false;
            }
            const currentUser = yield (0,shared_auth_hooks__WEBPACK_IMPORTED_MODULE_2__/* .preloadUserPermissions */ .Ap)(_this.queryCache, _this.userId);
            if (!currentUser) {
                throw Error("user permissions were not loaded");
            }
            var _currentUser_permissions;
            return canAccess(new Set((_currentUser_permissions = currentUser === null || currentUser === void 0 ? void 0 : currentUser.permissions) !== null && _currentUser_permissions !== void 0 ? _currentUser_permissions : []), requiredPermissions, isAnyOf);
        })();
    }
    constructor(queryCache){
        _define_property(this, "queryCache", void 0);
        _define_property(this, "userId", void 0);
        this.queryCache = queryCache;
        this.userId = undefined;
    }
}


/***/ }),

/***/ 48561:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$n": () => (/* binding */ CyberhavenResource),
/* harmony export */   "AV": () => (/* binding */ preloadUserScope),
/* harmony export */   "Wn": () => (/* binding */ combineScopes),
/* harmony export */   "kj": () => (/* binding */ useResourceScope)
/* harmony export */ });
/* unused harmony export useUserScope */
/* harmony import */ var react_query__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(21478);
/* harmony import */ var runenv__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(76223);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(28216);
/* harmony import */ var api_graphql__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(37137);
/* harmony import */ var api_graphql_network__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(48863);
/* harmony import */ var libs_cel_query__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(67511);
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}






var CyberhavenResource;
(function(CyberhavenResource) {
    CyberhavenResource["Datasets"] = "datasets";
    CyberhavenResource["Policies"] = "policies";
    CyberhavenResource["Incidents"] = "incidents";
    CyberhavenResource["IRMUsers"] = "irm_users";
    CyberhavenResource["Events"] = "events";
})(CyberhavenResource || (CyberhavenResource = {}));
function getUserScope(userId) {
    return _getUserScope.apply(this, arguments);
}
function _getUserScope() {
    _getUserScope = _async_to_generator(function*(userId) {
        const scopes = yield (0,api_graphql_network__WEBPACK_IMPORTED_MODULE_4__/* .sendGQLRequest */ .n)(api_graphql__WEBPACK_IMPORTED_MODULE_3__/* .GetUserScopesDocument */ .FW, {
            userId
        });
        const userScope = {};
        // Merge scopes from user roles
        scopes.subject_scope.forEach((data)=>{
            if (!data.scope) {
                return;
            }
            Object.keys(data.scope).forEach((resource)=>{
                if (!userScope[resource]) {
                    userScope[resource] = [];
                }
                if (!userScope[resource].includes(data.scope[resource])) {
                    userScope[resource].push(data.scope[resource]);
                }
            });
        });
        return userScope;
    });
    return _getUserScope.apply(this, arguments);
}
const scopeKey = "scope";
const STALE_TIME = 15 * 60 * 1000;
const CACHE_TIME = 60 * 60 * 1000;
const REFETCH_INTERVAL = 5 * 60 * 1000;
function preloadUserScope(cache, userId) {
    return cache.prefetchQuery([
        scopeKey,
        userId
    ], /*#__PURE__*/ _async_to_generator(function*() {
        return getUserScope(userId);
    }), {
        staleTime: STALE_TIME
    });
}
function useUserScope(userId) {
    return (0,react_query__WEBPACK_IMPORTED_MODULE_0__/* .useQuery */ .aM)([
        scopeKey,
        userId
    ], ()=>getUserScope(userId), {
        enabled: !!userId,
        staleTime: STALE_TIME,
        cacheTime: CACHE_TIME,
        refetchInterval: REFETCH_INTERVAL,
        refetchIntervalInBackground: true,
        suspense: true
    });
}
// Returns CEL global filter for specified resource
function useResourceScope(resource) {
    const id = (0,react_redux__WEBPACK_IMPORTED_MODULE_2__/* .useSelector */ .v9)((store)=>{
        var _store_auth, _store_auth_user;
        return (_store_auth = store.auth) === null || _store_auth === void 0 ? void 0 : (_store_auth_user = _store_auth.user) === null || _store_auth_user === void 0 ? void 0 : _store_auth_user.id;
    });
    const { data  } = useUserScope(id);
    if (!runenv__WEBPACK_IMPORTED_MODULE_1__/* .ENV.FEATURES.CONTENT_BASED_RBAC */ .V.FEATURES.CONTENT_BASED_RBAC || !id) {
        return "";
    }
    const resourceConditions = data === null || data === void 0 ? void 0 : data[resource];
    return (resourceConditions === null || resourceConditions === void 0 ? void 0 : resourceConditions.length) ? (0,libs_cel_query__WEBPACK_IMPORTED_MODULE_5__/* .celCombine */ .lS)(libs_cel_query__WEBPACK_IMPORTED_MODULE_5__/* .CELConditionOperator.OR */ .KM.OR, ...resourceConditions) // Scopes from different roles combined with OR
     : "";
}
// Combines provided cel filters with conditions from scope
function combineScopes(...filters) {
    return (0,libs_cel_query__WEBPACK_IMPORTED_MODULE_5__/* .celCombine */ .lS)(libs_cel_query__WEBPACK_IMPORTED_MODULE_5__/* .CELConditionOperator.AND */ .KM.AND, ...filters);
}


/***/ }),

/***/ 78420:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "W": () => (/* binding */ spacing)
/* harmony export */ });
// deprecated use theme
function spacing(k = 1) {
    return ({ theme  })=>theme.spacing(k);
}


/***/ }),

/***/ 81202:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "CX": () => (/* binding */ alertSelectors),
  "H6": () => (/* binding */ dashboardSelectors),
  "SS": () => (/* binding */ datePickerSelectors),
  "Yz": () => (/* binding */ directoriesSelectors),
  "Qw": () => (/* binding */ endpointsSelectors),
  "AK": () => (/* binding */ incidentsSelectors),
  "R7": () => (/* binding */ listViewSelectors),
  "QX": () => (/* binding */ modalFormSelectors),
  "Q_": () => (/* binding */ navigationSelectors),
  "ho": () => (/* binding */ notificationsSelectors),
  "M5": () => (/* binding */ rolesSelectors),
  "Y_": () => (/* binding */ searchSelectors),
  "VQ": () => (/* binding */ timeSeriesBarChart),
  "GJ": () => (/* binding */ universalSearchSelectors),
  "P_": () => (/* binding */ updatedSinceSelectors),
  "Rh": () => (/* binding */ usersSelectors)
});

// UNUSED EXPORTS: contentAttributesSelectors, graphSelectors, insightsSelectors, monitoringSelectors, searchFormSelectors, selector, sensitiveLocationsSelectors, sensorsHealthSelectors

;// CONCATENATED MODULE: ./src/libs/testing/makeSelectors.ts
function mapSelectorsFromObjectRec(obj, prefix) {
    for(const k in obj){
        const item = obj[k];
        if (typeof item === "object") {
            mapSelectorsFromObjectRec(item, prefix + "/" + k);
        } else if (typeof item === "string") {
            obj[k] = prefix + "/" + k;
        } else if (typeof item === "function") {
            obj[k] = (...args)=>prefix + "/" + k + "/" + item(args);
        }
    }
    return obj;
}
function makeSelectors(prefix, obj) {
    return mapSelectorsFromObjectRec(obj, prefix);
}
function testifySelector(selector) {
    return `[data-testid="${selector}"]`;
}

;// CONCATENATED MODULE: ./src/shared/testConstants.ts

const searchFormSelectors = (prefix)=>{
    const wrap = (selector)=>`search-form/${prefix}/${selector}`;
    return {
        card: wrap("card"),
        header: wrap("header"),
        locationHeader: wrap("location_header"),
        location_select: wrap("location_input"),
        salesforce: wrap("salesforce"),
        cloud_storage: wrap("provider"),
        email_domain: wrap("email_domain"),
        website_hostname: wrap("website_hostname"),
        share_hostname: wrap("share_hostname"),
        endpoint_hostname: wrap("endpoint_hostname"),
        endpoint_local_user_name: wrap("endpoint_local_user_name"),
        endpoint_groupname: wrap("endpoint_groupname"),
        addNew: wrap("add_new"),
        clearLocation: wrap("clear_location")
    };
};
const wrapMonitoring = (selector)=>"monitoring/" + selector;
const monitoringSelectors = {
    Flags: {
        Log: wrapMonitoring("log_incident"),
        Notify: wrapMonitoring("notify"),
        Warn: wrapMonitoring("show_warning"),
        Block: wrapMonitoring("blocking")
    },
    NotifyTarget: wrapMonitoring("recipient"),
    WarnMessage: wrapMonitoring("message"),
    Dialog: wrapMonitoring("dialog"),
    Open: wrapMonitoring("open"),
    Buttons: {
        OK: wrapMonitoring("ok"),
        Cancel: wrapMonitoring("cancel"),
        Clear: wrapMonitoring("clear")
    }
};
const wrapContentAttributes = (selector)=>"content-attributes/" + selector;
const contentAttributesSelectors = {
    List: {
        Item: wrapContentAttributes("list/item"),
        SelectCheckbox: wrapContentAttributes("list/select-checkbox")
    },
    Filters: {
        Search: wrapContentAttributes("filters/search"),
        OnlySelected: wrapContentAttributes("filters/onlySelected")
    },
    Select: wrapContentAttributes("select"),
    Modal: {
        ApplyButton: wrapContentAttributes("modal/apply-button")
    }
};
const wrapSearch = (selector)=>"search/" + selector;
const searchSelectors = {
    ToggleSearch: wrapSearch("toggle-button"),
    CloseSearch: wrapSearch("close-button"),
    Name: wrapSearch("name"),
    CardList: wrapSearch("criteria-list"),
    SavedSearchSelector: wrapSearch("saved-searches-selector"),
    SavedSearchSelectorPopover: wrapSearch("saved-searches-popover"),
    KeywordSearchInput: wrapSearch("keyword-search"),
    KeywordSearchItem: wrapSearch("keyword-search/item"),
    KeywordSearchSelectedItem: wrapSearch("keyword-search/selected-item"),
    ContentAttributeSelect: wrapSearch("content/content-attribute"),
    SavedList: wrapSearch("saved/list"),
    SavedSearchSelectedItem: wrapSearch("saved/selected"),
    SavedSearchItem: wrapSearch("saved/item"),
    SaveSearchMenu: wrapSearch("saved/item-menu"),
    EnabledIcon: wrapSearch("saved/icon-enabled"),
    MenuItems: {
        Edit: wrapSearch("saved/edit"),
        Delete: wrapSearch("saved/delete")
    },
    FindSaved: wrapSearch("saved/find"),
    Breadcrumbs: wrapSearch("saved/breadcrumbs"),
    Buttons: {
        Search: wrapSearch("execute"),
        Save: wrapSearch("save"),
        Clear: wrapSearch("clear")
    }
};
const graphSelectors = makeSelectors("graph", {
    Graph: {
        MainGraph: "",
        Edge: "",
        Node: "",
        SELECTED_NODE_POLYGON: "",
        IndirectPath: "",
        DirectPath: "",
        OpenMenu: "",
        CollapseButton: ""
    },
    Menu: "",
    MenuItems: {
        SearchFrom: "",
        SearchTo: "",
        ExpandBy: ""
    },
    Tabs: "",
    Buttons: {
        Group: "",
        Home: "",
        Refresh: "",
        ToggleEdges: "",
        ToggleEdgesGroup: "",
        ZoomIn: "",
        ZoomOut: "",
        ZoomGroup: "",
        fitToScreen: ""
    }
});
const wrapNotifications = (selector)=>"notification/" + selector;
const notificationsSelectors = {
    Container: wrapNotifications("container"),
    Message: wrapNotifications("message")
};
const timeSeriesBarChart = makeSelectors("timeSeriesBarChart", {
    bar: "",
    monthAxis: "",
    daysAxis: ""
});
const endpointsSelectors = makeSelectors("endpoints", {
    List: {
        Table: "",
        Search: "",
        Refresh: ""
    },
    Filters: "",
    Tabs: {
        Endpoints: "",
        Installers: ""
    },
    Installers: {
        All: ""
    },
    Export: ""
});
const listViewSelectors = makeSelectors("list-view", {
    Row: "",
    ExpandBtn: "",
    CollapseBtn: "",
    Select: {
        All: "",
        Single: ""
    },
    SubTable: {
        Graph: "",
        Table: "",
        Row: "",
        ExpandHiddenRows: "",
        CollapseHiddenRows: ""
    },
    SearchFlowBtn: "",
    ExportBtn: ""
});
const usersSelectors = makeSelectors("users", {
    List: {
        Item: "item"
    },
    Filters: {
        Input: "input",
        Selector: "selector"
    },
    Profile: {
        Delete: "delete"
    },
    Invite: {
        Roles: ""
    }
});
const alertSelectors = makeSelectors("alerts", {
    Select: "",
    Search: "",
    Table: "",
    Details: "",
    DetailsDrawer: "",
    Export: ""
});
const sensorsHealthSelectors = makeSelectors("endpoint-sensors-health", {
    Table: ""
});
const modalFormSelectors = makeSelectors("ModalForm", {
    Submit: "submit"
});
const datePickerSelectors = makeSelectors("datepicker", {
    input: {
        container: "",
        from: "",
        to: ""
    },
    ranges: {
        "day": "",
        "week": "",
        "month": "",
        "90Days": "",
        "180Days": "",
        "year": "",
        "anytime": ""
    },
    ok: ""
});
const insightsSelectors = makeSelectors("insights", {
    actions: {
        exportMenuBtn: "",
        exportMenu: {
            csv: ""
        },
        addToReport: ""
    }
});
const sensitiveLocationsSelectors = makeSelectors("sensitiveLocations", {
    createForm: {
        buttons: {
            back: "",
            next: ""
        }
    },
    trustedDestination: {
        filters: {
            searchByName: "",
            searchByDestination: ""
        }
    }
});
const dashboardSelectors = makeSelectors("dashboard", {
    datePicker: {
        panel: "",
        anytime: "",
        today: "",
        yesterday: "",
        last7Days: "",
        last30Days: "",
        open: ""
    },
    appliedFilters: {
        panel: "",
        filter: ""
    },
    datasetPreview: {
        dialog: "",
        close: "",
        editName: "",
        setupPolicies: "",
        delete: "",
        save: "",
        form: {
            panel: "",
            preview: ""
        }
    },
    dataSprawl: {
        panel: "",
        filter: "",
        chartWithPanelContainer: "",
        currentDatasetAndCategoryTypesChart: "",
        chartContainer: "",
        categoriesChart: "",
        categoryTypes: {
            needsReview: "",
            risks: "",
            approved: ""
        },
        categories: {
            panel: "",
            add: "",
            select: "",
            labelSelect: "",
            edit: ""
        },
        datasets: {
            panel: "",
            add: "",
            edit: "",
            select: "",
            selectAll: ""
        }
    },
    trendsOverTime: {
        panel: "",
        filter: "",
        chart: "",
        timeRange: ""
    },
    locations: {
        panel: "",
        filter: "",
        select: "",
        pagination: ""
    },
    users: {
        searchButton: "",
        searchInput: "",
        panel: "",
        filter: "",
        select: "",
        pagination: ""
    },
    listViewPanel: {
        openPanelButton: "",
        closePanelButton: ""
    },
    datasetEditForm: {
        form: ""
    },
    categoryEditForm: {
        form: ""
    },
    addUsersForm: {
        form: ""
    },
    addFlowsForm: {
        form: ""
    },
    changesTimeline: {
        filter: "",
        panel: "",
        users: "",
        events: ""
    },
    templateLibrary: {
        policies: {
            list: "",
            search: ""
        }
    }
});
const updatedSinceSelectors = makeSelectors("updatedSince", {
    renew: ""
});
const navigationSelectors = makeSelectors("navigation", {
    home: "",
    dashboard: "",
    dashboardv2: "",
    dataflows: "",
    incidents: "",
    analytics: "",
    reports: "",
    sensors: {
        cloud: "",
        endpoint: ""
    },
    preferences: "",
    profile: "",
    insiders: ""
});
const directoriesSelectors = makeSelectors("directories", {
    list: {
        id: "",
        name: "",
        panel: "",
        row: {
            id: "",
            name: ""
        }
    }
});
const incidentsSelectors = makeSelectors("incidents", {
    filters: {
        panel: "",
        unresolved: "",
        resolved: "",
        ignored: ""
    },
    list: {
        panel: "",
        selectAll: "",
        row: {
            select: ""
        },
        pagination: ""
    },
    incident: {
        history: "",
        changeStatus: "",
        markIgnored: "",
        markResolved: "",
        assignIncident: "",
        markUnresolved: "",
        timeline: {
            panel: ""
        },
        comment: {
            edited: "",
            addComment: "",
            edit: "",
            delete: ""
        }
    }
});
const universalSearchSelectors = makeSelectors("universal-search", {
    searchInput: "",
    list: {
        expand: "",
        collapse: "",
        loadMoreFields: "",
        field: (field)=>field,
        item: "",
        fieldLoadMore: ""
    }
});
const rolesSelectors = makeSelectors("roles-page", {
    actionCell: (roleName)=>`role-action-${roleName}`,
    actionEdit: "action-edit"
});
const selector = (selector)=>`[data-testid="${selector}"]`;


/***/ }),

/***/ 98598:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "F": () => (/* binding */ useAvailableNavigationItems)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _permissions__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(44916);
/* harmony import */ var _environment__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(66246);



function useAvailableNavigationItems() {
    const { navigationItems  } = (0,_environment__WEBPACK_IMPORTED_MODULE_2__/* .useAppEnvironment */ .f)();
    const visibleNavigationItems = (0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(()=>navigationItems.filter((item)=>!item.hidden), [
        navigationItems
    ]);
    const availableItems = (0,_permissions__WEBPACK_IMPORTED_MODULE_1__/* .useCanArray */ .tn)({
        items: visibleNavigationItems,
        getItemPermission: (item)=>item.requiredPermissions || item.requiredPermissionsAnyOf,
        isDoEither: (item)=>!!item.requiredPermissionsAnyOf
    });
    const homeItem = (0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(()=>{
        var _availableItems_filter;
        return ((_availableItems_filter = availableItems === null || availableItems === void 0 ? void 0 : availableItems.filter((link)=>!link.isSpacer)) === null || _availableItems_filter === void 0 ? void 0 : _availableItems_filter[0]) || null;
    }, [
        availableItems
    ]);
    return {
        availableItems,
        isLoading: !!availableItems,
        homeItem
    };
}


/***/ }),

/***/ 21714:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "B": () => (/* binding */ useHistoryParam),
/* harmony export */   "N": () => (/* binding */ historyParamHash)
/* harmony export */ });
/* harmony import */ var libs_hooks_useQueryParam__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(12635);
/* harmony import */ var libs_data_utils__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(50082);
/* harmony import */ var api_short_url__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(44673);



const historyParamHash = (data)=>{
    // do not wait for hash result, we rely that it will always store hash
    (0,api_short_url__WEBPACK_IMPORTED_MODULE_2__/* .storeString */ .BX)(data);
    return (0,libs_data_utils__WEBPACK_IMPORTED_MODULE_1__/* .sha256 */ .JQ)(data);
};
const useHistoryParam = (0,libs_hooks_useQueryParam__WEBPACK_IMPORTED_MODULE_0__/* .createHistoryHook */ .P)(historyParamHash);


/***/ }),

/***/ 73782:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "K": () => (/* binding */ useTimeout)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);

function useTimeout() {
    const ref = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)();
    function timeout(fn, ms) {
        clear();
        ref.current = setTimeout(fn, ms);
    }
    function clear() {
        ref.current && clearTimeout(ref.current);
    }
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(()=>{
        return clear;
    }, []);
    return {
        setTimeout: timeout,
        clearTimeout: clear
    };
}


/***/ }),

/***/ 93681:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "CZ": () => (/* binding */ formatCount),
/* harmony export */   "U3": () => (/* binding */ formatCountTitle),
/* harmony export */   "ZO": () => (/* binding */ sortByTime),
/* harmony export */   "ZT": () => (/* binding */ noop),
/* harmony export */   "aO": () => (/* binding */ noopFilter),
/* harmony export */   "kX": () => (/* binding */ validateEmailList),
/* harmony export */   "ng": () => (/* binding */ formatValidateEmailList),
/* harmony export */   "oA": () => (/* binding */ compact),
/* harmony export */   "sQ": () => (/* binding */ removeWebPrefix)
/* harmony export */ });
/* unused harmony exports isValidBrowser, isValidEmail, formatByCount */
/* harmony import */ var bowser_bowser__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(83257);
/* harmony import */ var bowser_bowser__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(bowser_bowser__WEBPACK_IMPORTED_MODULE_0__);
// eslint-ignore

function removeWebPrefix(label) {
    const re = /https?:\/\/(www.)?(.*) ?/;
    const matches = re.exec(label);
    if (matches && matches[2]) {
        return matches[2];
    }
    return label;
}
// tslint:disable-next-line:no-empty
function noop() {}
function noopFilter() {
    return true;
}
function isValidBrowser(browsers) {
    let isValid = false;
    Object.keys(browsers).forEach((key)=>{
        if (bowser[key] && browsers[key] < bowser.version) {
            isValid = true;
        }
    });
    return isValid;
}
function formatValidateEmailList(array) {
    if (array.length > 1) {
        return `Lines ${array.join(", ")} contain invalid email`;
    }
    if (array.length > 0) {
        return `Line ${array.join("")} contains invalid email`;
    }
    return "";
}
// returns indexes of invalid emails and empty array if it's valid
function validateEmailList(string = "") {
    const regex = /^([a-zA-Z0-9_\-\.+]+)@([a-zA-Z0-9\-]+\.)+([a-zA-Z0-9\-\.]+)+([;]([a-zA-Z0-9_\-\.]+)@([a-zA-Z0-9\-]+\.)+([a-zA-Z0-9\-\.]+))*$/;
    const result = string.split("\n");
    const resultEmails = [];
    for(let i = 0; i < result.length; i++){
        if (!regex.test(result[i])) {
            resultEmails.push(i + 1);
        }
    }
    return resultEmails;
}
function validateEmails(string = "") {
    var regex = /^([a-zA-Z0-9_\-\.+]+)@([a-zA-Z0-9\-]+\.)+([a-zA-Z0-9\-\.]+)+([;]([a-zA-Z0-9_\-\.]+)@([a-zA-Z0-9\-]+\.)+([a-zA-Z0-9\-\.]+))*$/;
    var result = string.replace(/\s/g, "").split(/,|;/);
    for(var i = 0; i < result.length; i++){
        if (!regex.test(result[i])) {
            return false;
        }
    }
    return true;
}
function isValidEmail(address, allowMultiple) {
    if (!allowMultiple) {
        // Fast lookup to detect possibility of multiple emails. Only checks for unquoted delimiters
        const matches = address.match(/[\s,;]+(?=([^"]*"[^"]*")*[^"]*$)/g);
        if (matches && matches.length > 0) {
            return "Does not support more than 1 address";
        }
    }
    // Relaxed version of RFC 5322. Should match 99.9% emails
    // eslint-disable-next-line no-useless-escape
    if (!validateEmails(address)) {
        return "Not a valid email address";
    }
    return undefined;
}
// Old implemetation
function formatCount(n, subject) {
    return `${n} ${subject}${n > 1 ? "s" : ""}`;
}
// Choose singular or plural. (Good for translation)
function formatByCount(n, singular, plural) {
    return `${n > 1 ? plural : singular}`;
}
function formatCountTitle(n, subject) {
    return `${subject}${Math.abs(n) !== 1 ? "s" : ""}`;
}
function compact(array) {
    return (array === null || array === void 0 ? void 0 : array.filter(Boolean)) || [];
}
const sortByTime = (data, reverse = false)=>{
    return data === null || data === void 0 ? void 0 : data.sort((a, b)=>(new Date(a.time || "0").getTime() < new Date(b.time || "0").getTime() ? 1 : -1) * (reverse ? -1 : 1));
};


/***/ }),

/***/ 77723:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "b": () => (/* binding */ Alert)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _mui_icons_material__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(33629);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(2658);
/* harmony import */ var libs_layouts__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5855);
/* harmony import */ var ui_css__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(93461);
/* harmony import */ var ui_atoms_Box__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(17299);
/* harmony import */ var ui_vars__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(29400);
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}







const stackStyles = (0,ui_css__WEBPACK_IMPORTED_MODULE_2__/* .css */ .iv)({
    height: "auto",
    margin: "auto"
});
const fullWidthStyles = (0,ui_css__WEBPACK_IMPORTED_MODULE_2__/* .css */ .iv)({
    width: "100%"
});
function Alert(_param) {
    var { title , subtitle ="" , icon =/*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_mui_icons_material__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, null)  } = _param, rest = _object_without_properties(_param, [
        "title",
        "subtitle",
        "icon"
    ]);
    return /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(ui_atoms_Box__WEBPACK_IMPORTED_MODULE_3__/* .Box */ .x, _object_spread({
        sx: {
            paddingX: ui_vars__WEBPACK_IMPORTED_MODULE_4__/* .space[5] */ .Dh[5],
            height: "100%",
            width: "100%",
            centerContent: true
        }
    }, rest), /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(libs_layouts__WEBPACK_IMPORTED_MODULE_1__/* .Stack */ .Kq, {
        space: 1,
        className: stackStyles().className
    }, icon && /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.cloneElement(icon, {
        style: {
            fontSize: 80,
            width: "100%"
        },
        color: "action"
    }), /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_mui_material__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
        color: "textSecondary",
        align: "center",
        style: {
            fontWeight: 500
        },
        variant: "subtitle1",
        className: fullWidthStyles().className
    }, title), subtitle && /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_mui_material__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
        color: "textSecondary",
        align: "center",
        variant: "subtitle1",
        className: fullWidthStyles().className
    }, subtitle)));
}


/***/ }),

/***/ 17299:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "x": () => (/* binding */ Box)
/* harmony export */ });
/* unused harmony export BoxInternal */
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _radix_ui_react_slot__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(70859);
/* harmony import */ var ui_css__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(93461);
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}



// import { SxProps, Theme } from "@mui/system";
const BoxInternal = (0,ui_css__WEBPACK_IMPORTED_MODULE_1__/* .css */ .iv)({});
const Box = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_0__.forwardRef)(function Box(_param, ref) {
    var { as: Comp = "div" , className , sx , asChild  } = _param, props = _object_without_properties(_param, [
        "as",
        "className",
        "sx",
        "asChild"
    ]);
    const resClassName = BoxInternal({
        className,
        css: sx
    }).toString();
    if (asChild) {
        Comp = _radix_ui_react_slot__WEBPACK_IMPORTED_MODULE_2__/* .Slot */ .g7;
    }
    return /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Comp, _object_spread({
        ref: ref,
        className: resClassName
    }, props));
});


/***/ }),

/***/ 54638:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "E": () => (/* binding */ CopyTextToClipboard),
/* harmony export */   "z": () => (/* binding */ onCopySuccess)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var react_copy_to_clipboard__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(74855);
/* harmony import */ var react_copy_to_clipboard__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(react_copy_to_clipboard__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var shared_useTimeout__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(73782);
/* harmony import */ var _mui_icons_material__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(96406);
/* harmony import */ var modules_notification__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(5769);
/* harmony import */ var ui_messages__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(16239);
/* harmony import */ var ui_theme__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(73728);
/* harmony import */ var ui_atoms_IconButton__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(6867);
/* harmony import */ var ui_atoms_Text__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(21361);
/* harmony import */ var ui_atoms_Stack__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(16343);
/* harmony import */ var ui_atoms_ShowOnHover__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(84030);
/* harmony import */ var ui_css__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(93461);
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}












const iconClass = (0,ui_css__WEBPACK_IMPORTED_MODULE_9__/* .css */ .iv)({
    padding: 0,
    paddingBottom: 4,
    paddingLeft: 2,
    variants: {
        hightlightOnHover: {
            true: {
                "&:hover": {
                    color: ui_theme__WEBPACK_IMPORTED_MODULE_5__/* .theme.palette.primary.main */ .rS.palette.primary.main
                }
            }
        }
    }
});
const onCopySuccess = ()=>modules_notification__WEBPACK_IMPORTED_MODULE_3__/* .notification.success */ .t6.success({
        message: ui_messages__WEBPACK_IMPORTED_MODULE_4__/* .messages.copyTooltip.copiedText */ .s.copyTooltip.copiedText
    });
const CopyTextToClipboard = ({ children , space , sx , className , inlineSuccessSx , showIcon =false , showIconAlways =false , hightlightOnHover =false , spacer =false , iconStyle ={} , iconSize ="small" , text ="" , showInlineSuccess =false , onSuccess =onCopySuccess  })=>{
    var _parentElement_current;
    const parentElement = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(null);
    const [innerText, setInnerText] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(text);
    const [isShowInlineSuccess, setShowInlineSuccess] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(false);
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(()=>{
        var _parentElement_current;
        setInnerText(text || ((_parentElement_current = parentElement.current) === null || _parentElement_current === void 0 ? void 0 : _parentElement_current.innerText) || "");
    }, [
        text,
        (_parentElement_current = parentElement.current) === null || _parentElement_current === void 0 ? void 0 : _parentElement_current.innerText
    ]);
    const { setTimeout  } = (0,shared_useTimeout__WEBPACK_IMPORTED_MODULE_2__/* .useTimeout */ .K)();
    const onCopy = ()=>{
        if (showInlineSuccess) {
            setShowInlineSuccess(true);
            setTimeout(()=>setShowInlineSuccess(false), 3000);
        }
        onSuccess();
    };
    const icon = /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement((react_copy_to_clipboard__WEBPACK_IMPORTED_MODULE_1___default()), {
        text: innerText,
        onCopy: onCopy
    }, /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(ui_atoms_IconButton__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {
        className: iconClass({
            hightlightOnHover
        }).className,
        style: _object_spread({}, iconStyle),
        title: ui_messages__WEBPACK_IMPORTED_MODULE_4__/* .messages.copyTooltip.copy */ .s.copyTooltip.copy,
        size: "large"
    }, /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_mui_icons_material__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z, {
        fontSize: iconSize
    })));
    return /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(ui_atoms_ShowOnHover__WEBPACK_IMPORTED_MODULE_8__/* .ShowOnHover */ .v, {
        ref: parentElement,
        node: showIcon && !isShowInlineSuccess && icon,
        sx: _object_spread({
            userSelect: "text",
            backgroundColor: isShowInlineSuccess ? "rgba(67, 167, 234, 0.2);" : ""
        }, sx),
        className: className,
        space: space,
        spacer: spacer,
        disableOnHover: showIconAlways
    }, isShowInlineSuccess ? /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(ui_atoms_Stack__WEBPACK_IMPORTED_MODULE_7__/* .VStack */ .gC, {
        align: "center",
        sx: inlineSuccessSx,
        fullWidth: true
    }, /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(ui_atoms_Stack__WEBPACK_IMPORTED_MODULE_7__/* .HStack */ .Ug, {
        align: "center",
        sx: {
            height: "100%"
        }
    }, /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(ui_atoms_Text__WEBPACK_IMPORTED_MODULE_6__/* .Text */ .x, null, ui_messages__WEBPACK_IMPORTED_MODULE_4__/* .messages.copyTooltip.copiedText */ .s.copyTooltip.copiedText))) : children);
};


/***/ }),

/***/ 72763:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "S": () => (/* binding */ ErrorBoundary)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var react_error_boundary__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(35800);
/* harmony import */ var react_error_boundary__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(react_error_boundary__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _StateScreens__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(53213);



const ErrorBoundary = ({ children , fallback =/*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_StateScreens__WEBPACK_IMPORTED_MODULE_1__/* .ErrorState */ .Te, null)  })=>{
    return /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(react_error_boundary__WEBPACK_IMPORTED_MODULE_2__.ErrorBoundary, {
        fallback: fallback
    }, children);
};


/***/ }),

/***/ 87093:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Q": () => (/* binding */ ExpandIcon)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _mui_icons_material_ExpandLess__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(60181);
/* harmony import */ var _mui_icons_material_ExpandMore__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(23508);
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}



const ExpandIcon = (_param)=>{
    var { expanded  } = _param, props = _object_without_properties(_param, [
        "expanded"
    ]);
    return expanded ? /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_mui_icons_material_ExpandLess__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, props) : /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_mui_icons_material_ExpandMore__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, props);
};


/***/ }),

/***/ 34246:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Hy": () => (/* binding */ mapErrorOnly),
/* harmony export */   "f0": () => (/* binding */ getErrorLabel),
/* harmony export */   "jM": () => (/* binding */ mapProps)
/* harmony export */ });
/* unused harmony export mapError */
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
const getErrorLabel = (meta)=>{
    const errorText = meta.error || meta.submitError;
    if (meta.touched && errorText) {
        return errorText;
    }
};
const mapErrorOnly = ({ hasHelperText =true , meta  })=>{
    const errorText = meta.error || meta.submitError;
    const errorProps = meta.touched && errorText ? {
        error: Boolean(errorText),
        helperText: hasHelperText ? errorText : ""
    } : {};
    return errorProps;
};
const mapError = (_param)=>{
    var { hasHelperText =true , meta: { touched , error , submitError  } = {
        touched: null,
        error: null,
        submitError: false
    } , input  } = _param, props = _object_without_properties(_param, [
        "hasHelperText",
        "meta",
        "input"
    ]);
    const errorProps = touched && (error || submitError) ? _object_spread_props(_object_spread({}, props, input), {
        error: Boolean(error || submitError)
    }) : _object_spread({}, input, props);
    if (touched && hasHelperText && (error || submitError)) {
        errorProps.helperText = error || submitError;
    }
    return errorProps;
};
const mapProps = (props)=>{
    const { input , meta , is  } = props, rest = _object_without_properties(props, [
        "input",
        "meta",
        "is"
    ]);
    if (rest.type === "checkbox" && !rest.value) {
        input.value = "";
    }
    return _object_spread({}, input, rest, mapError(props));
};


/***/ }),

/***/ 39540:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "f": () => (/* binding */ LoadingButton)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(59062);
/* harmony import */ var ui_atoms_Box__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(17299);
/* harmony import */ var ui_atoms_UIButton__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(18029);
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}




function LoadingButton(_param) {
    var { onClick , children , loaderColor ="inherit" , loader =/*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_mui_material__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
        size: 15,
        color: loaderColor
    }) , isLoading , loadingIndicator  } = _param, props = _object_without_properties(_param, [
        "onClick",
        "children",
        "loaderColor",
        "loader",
        "isLoading",
        "loadingIndicator"
    ]);
    return /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(ui_atoms_UIButton__WEBPACK_IMPORTED_MODULE_2__/* .UIButton */ .y, _object_spread({
        style: {
            whiteSpace: "nowrap"
        },
        disabled: isLoading,
        onClick: onClick
    }, props), isLoading && (loadingIndicator ? loadingIndicator : /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(ui_atoms_Box__WEBPACK_IMPORTED_MODULE_1__/* .Box */ .x, {
        sx: {
            centerContent: true,
            marginRight: 8
        }
    }, loader)), (!loadingIndicator || !isLoading) && /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement("span", null, children));
}


/***/ }),

/***/ 23070:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "l": () => (/* binding */ PageHeaderPill)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _css__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(93461);
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}


const Container = (0,_css__WEBPACK_IMPORTED_MODULE_1__/* .styled */ .zo)("div", {
    display: "flex",
    alignItems: "center",
    gap: "5px",
    height: "22px",
    padding: "0px 9px 0px 2px",
    borderRadius: "16px",
    transition: `background-color .3s ease-out`,
    cursor: "default",
    ["&:hover"]: {
        backgroundColor: "#E0E0E0"
    }
});
const Label = (0,_css__WEBPACK_IMPORTED_MODULE_1__/* .styled */ .zo)("div", {
    color: "rgba(0, 0, 0, 0.87)",
    fontSize: "12px",
    lineHeight: "14px",
    letterSpacing: "0.15px"
});
function PageHeaderPill(_param) {
    var { label , icon  } = _param, rest = _object_without_properties(_param, [
        "label",
        "icon"
    ]);
    return /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Container, rest, icon, /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Label, null, label));
}


/***/ }),

/***/ 32716:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "E": () => (/* binding */ LineProgress)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var runenv__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(76223);
/* harmony import */ var libs_layouts__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(5855);
/* harmony import */ var ui_vars__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(29400);
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}




const LineProgress = /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.forwardRef(function LineProgress(_param, forwardedRef) {
    var { as: Comp = "div" , options , overlap , maxValue =100 , style , shouldRoundToFullWidth , minWidth , divider =true , minValue: _  } = _param, props = _object_without_properties(_param, [
        "as",
        "options",
        "overlap",
        "maxValue",
        "style",
        "shouldRoundToFullWidth",
        "minWidth",
        "divider",
        "minValue"
    ]);
    const radius = ui_vars__WEBPACK_IMPORTED_MODULE_3__/* .radii.md */ .pD.md;
    let percent = 0;
    if (overlap) {
        options.sort((a, b)=>a.value - b.value);
    }
    const hasActive = options.find((el)=>el.isActive);
    const items = options.filter((el)=>el.value > 0).reduce((acc, el, i, arr)=>{
        const value = shouldRoundToFullWidth && !overlap && i === arr.length - 1 ? 100 - percent : Math.floor(el.value / maxValue * 100);
        const last = i === arr.length - 1;
        const width = overlap ? value + "%" : percent + value + "%";
        acc.unshift(/*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", {
            title: el.label,
            key: i,
            className: el.className,
            style: _object_spread({
                width: divider ? `calc(${width} + ${i}px)` : width,
                minWidth: minWidth && el.value > 0 ? minWidth : "auto",
                height: "100%",
                borderRadius: divider ? last ? radius : 0 : radius,
                zIndex: el.isActive || !hasActive ? 1 : 0,
                opacity: el.isActive || !hasActive ? 1 : 0.8
            }, el.color ? {
                background: el.color
            } : {})
        }));
        if (divider && !last && width !== "0%") {
            acc.unshift(/*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", {
                className: el.className,
                key: i + 100,
                style: {
                    width: `calc(${width} + ${i + 1}px)`,
                    height: "100%",
                    background: "#EAEAEA",
                    zIndex: el.isActive || !hasActive ? 1 : 0
                }
            }));
        }
        percent += value;
        return acc;
    }, []);
    if (Math.floor(percent) > 100 && !overlap || isNaN(percent)) {
        if (runenv__WEBPACK_IMPORTED_MODULE_1__/* .ENV.IS_BETA_ENV */ .V.IS_BETA_ENV) {
            throw new Error(`Options have more than 100% total\n${JSON.stringify(options)}, maxValue: ${maxValue}, value: ${percent}`);
        }
    }
    return /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(libs_layouts__WEBPACK_IMPORTED_MODULE_2__/* .ZStack */ .G3, _object_spread({
        as: Comp,
        ref: forwardedRef,
        fullWidth: true,
        style: _object_spread({
            height: 5,
            background: ui_vars__WEBPACK_IMPORTED_MODULE_3__/* .colors.light200 */ .O9.light200,
            borderRadius: radius,
            overflow: "hidden"
        }, style),
        alignX: "flex-start"
    }, props), items);
});


/***/ }),

/***/ 84030:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "v": () => (/* binding */ ShowOnHover)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var libs_layouts__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5855);
/* harmony import */ var libs_css__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(49248);
/* harmony import */ var _Stack__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(16343);
/* harmony import */ var _Box__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(17299);
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}





/**
 * Abstraction to show component on children hover.
 * @param node to be shown once user hovers on the "children" of ShowOnHover.
 * @param spacer to add spacer between children and component to be shown
 */ const ShowOnHover = /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.forwardRef(({ children , space , sx , className , node , disableOnHover , spacer =false  }, ref)=>{
    return /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_Stack__WEBPACK_IMPORTED_MODULE_3__/* .HStack */ .Ug, {
        role: "group",
        ref: ref,
        space: space,
        sx: _object_spread({}, sx),
        className: className
    }, children, spacer && /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(libs_layouts__WEBPACK_IMPORTED_MODULE_1__/* .Spacer */ .LZ, null), node && /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_Box__WEBPACK_IMPORTED_MODULE_4__/* .Box */ .x, {
        sx: !disableOnHover ? {
            visibility: "hidden",
            [libs_css__WEBPACK_IMPORTED_MODULE_2__/* .selectors.hoverGroup */ .w.hoverGroup]: {
                visibility: "visible"
            }
        } : {}
    }, node));
});


/***/ }),

/***/ 16343:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Ug": () => (/* binding */ HStack),
/* harmony export */   "cR": () => (/* binding */ StackSpacer),
/* harmony export */   "gC": () => (/* binding */ VStack)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var ui_css__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(93461);
/* harmony import */ var ui_vars__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(29400);
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}



const HStackStyles = (0,ui_css__WEBPACK_IMPORTED_MODULE_1__/* .css */ .iv)({
    display: "flex",
    flex: "0 1 auto",
    flexDirection: "row"
});
const HStack = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_0__.forwardRef)(function HStack(_param, ref) {
    var { as: Comp = "div" , className , sx , space: spaceValue , align ="center" , fullWidth  } = _param, props = _object_without_properties(_param, [
        "as",
        "className",
        "sx",
        "space",
        "align",
        "fullWidth"
    ]);
    return /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Comp, _object_spread({
        ref: ref,
        "data-component": "HStack",
        className: HStackStyles({
            className,
            css: _object_spread({
                gap: ui_vars__WEBPACK_IMPORTED_MODULE_2__/* .space */ .Dh[spaceValue || 0],
                alignItems: align,
                width: fullWidth ? "100%" : undefined
            }, sx)
        }).toString()
    }, props));
});
const VStackStyles = (0,ui_css__WEBPACK_IMPORTED_MODULE_1__/* .css */ .iv)({
    display: "flex",
    flex: "1 1 auto",
    flexDirection: "column"
});
const VStack = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_0__.forwardRef)(function HStack(_param, ref) {
    var { as: Comp = "div" , className , sx , space: spaceValue , align , fullWidth  } = _param, props = _object_without_properties(_param, [
        "as",
        "className",
        "sx",
        "space",
        "align",
        "fullWidth"
    ]);
    return /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Comp, _object_spread({
        ref: ref,
        "data-component": "HStack",
        className: VStackStyles({
            className,
            css: _object_spread({
                gap: ui_vars__WEBPACK_IMPORTED_MODULE_2__/* .space */ .Dh[spaceValue || 0],
                alignItems: align,
                width: fullWidth ? "100%" : undefined
            }, sx)
        }).toString()
    }, props));
});
function StackSpacer() {
    return /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", {
        style: {
            marginRight: "auto",
            marginBottom: "auto"
        }
    });
}


/***/ }),

/***/ 9827:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "c": () => (/* binding */ HDivider),
/* harmony export */   "i": () => (/* binding */ Divider)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67720);
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}


function Divider(props) {
    const marginX = `calc(var(--padding-x-value) * -1)`;
    return /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_mui_material__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
        style: props.fitContent ? _object_spread({}, props.style) : _object_spread_props(_object_spread({}, props.style), {
            marginLeft: marginX,
            marginRight: marginX
        })
    });
}
function HDivider(props) {
    const marginX = `calc(var(--padding-x-value) * -1)`;
    return /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_mui_material__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
        style: props.fitContent ? _object_spread({}, props.style) : _object_spread_props(_object_spread({}, props.style), {
            marginLeft: marginX,
            marginRight: marginX
        })
    });
}


/***/ }),

/***/ 53213:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Gu": () => (/* binding */ LoadingState),
/* harmony export */   "Pm": () => (/* binding */ NoDataState),
/* harmony export */   "Te": () => (/* binding */ ErrorState),
/* harmony export */   "Z9": () => (/* binding */ AlertState)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _mui_icons_material__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(33629);
/* harmony import */ var _mui_icons_material__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(92511);
/* harmony import */ var _mui_icons_material__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(7755);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(2658);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(72642);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(59062);
/* harmony import */ var ui_css__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(93461);
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}




const Wrapper = (0,ui_css__WEBPACK_IMPORTED_MODULE_1__/* .styled */ .zo)("div", {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    flexWrap: "wrap",
    width: "100%",
    height: "100%"
});
function NoDataState({ title =null  }) {
    return /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Wrapper, {
        "data-fs": "unmask",
        "aria-label": "no-data-component"
    }, /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Wrapper, {
        style: {
            height: "auto",
            margin: "auto"
        }
    }, /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_mui_icons_material__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
        style: {
            fontSize: 80,
            width: "100%"
        },
        color: "action"
    }), /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_mui_material__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
        color: "textSecondary",
        align: "center",
        variant: "subtitle1",
        style: {
            width: "100%"
        }
    }, title)));
}
function AlertState(_param) {
    var { title , icon =/*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_mui_icons_material__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, null)  } = _param, rest = _object_without_properties(_param, [
        "title",
        "icon"
    ]);
    return /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Wrapper, _object_spread({
        "data-fs": "unmask"
    }, rest), /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Wrapper, {
        style: {
            height: "auto",
            margin: "auto"
        }
    }, /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.cloneElement(icon, {
        style: {
            fontSize: 80,
            width: "100%"
        },
        color: "action"
    }), /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_mui_material__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
        color: "textSecondary",
        align: "center",
        variant: "subtitle1",
        style: {
            width: "100%"
        }
    }, title)));
}
function ErrorState({ text ="Something went wrong" , onRefresh  }) {
    return /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Wrapper, {
        "data-fs": "unmask",
        "aria-label": "error-component"
    }, /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Wrapper, {
        style: {
            height: "auto",
            margin: "auto"
        }
    }, /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_mui_icons_material__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
        color: "action",
        style: {
            fontSize: 80,
            width: "100%"
        }
    }), /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_mui_material__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
        color: "textSecondary",
        align: "center",
        variant: "subtitle1",
        style: {
            width: "100%"
        }
    }, text), onRefresh && /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_mui_material__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
        onClick: onRefresh
    }, /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_mui_icons_material__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, null), /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_mui_material__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
        color: "textSecondary",
        align: "center",
        variant: "body2"
    }, "Retry"))));
}
const loadingStyles = (0,ui_css__WEBPACK_IMPORTED_MODULE_1__/* .css */ .iv)({
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    flexDirection: "column",
    height: "100%"
});
function LoadingState(_param = {
    className: ""
}) {
    var { className =""  } = _param, props = _object_without_properties(_param, [
        "className"
    ]);
    return /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", _object_spread({
        "data-fs": "unmask",
        className: loadingStyles({
            className
        }).className
    }, props), /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_mui_material__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, null), /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", null, "Loading..."));
}


/***/ }),

/***/ 21361:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "x": () => (/* binding */ Text)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var ui_css__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(93461);
/* harmony import */ var ui_vars__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(29400);
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}



const textStyles = (0,ui_css__WEBPACK_IMPORTED_MODULE_1__/* .css */ .iv)({
    variants: {
        variant: Object.entries(ui_vars__WEBPACK_IMPORTED_MODULE_2__/* .fontStyles */ .g6).reduce((acc, [key, value])=>{
            acc[key] = value;
            return acc;
        }, {}),
        noWrap: {
            true: {
                whiteSpace: "nowrap",
                overflow: "hidden",
                textOverflow: "ellipsis"
            }
        },
        uppercase: {
            true: {
                textTransform: "uppercase"
            }
        },
        bold: {
            true: {
                fontWeight: 500
            }
        },
        isClickable: {
            true: {
                "cursor": "pointer",
                "&:hover": {
                    "text-decoration": "underline"
                }
            }
        },
        ellipsis: {
            true: {
                textOverflow: "ellipsis",
                whiteSpace: "nowrap",
                overflow: "hidden",
                display: "inline-block"
            }
        }
    }
});
const Text = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_0__.forwardRef)(function Text(_param, ref) {
    var { as: Comp = "div" , className , variant ="body2" , bold , uppercase , sx , color , noWrap , ellipsis , isClickable  } = _param, props = _object_without_properties(_param, [
        "as",
        "className",
        "variant",
        "bold",
        "uppercase",
        "sx",
        "color",
        "noWrap",
        "ellipsis",
        "isClickable"
    ]);
    return /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Comp, _object_spread_props(_object_spread({}, props), {
        ref: ref,
        className: textStyles({
            className,
            variant,
            noWrap,
            ellipsis,
            uppercase,
            bold,
            isClickable,
            css: _object_spread_props(_object_spread({}, sx), {
                color
            })
        })
    }));
});


/***/ }),

/***/ 18029:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "y": () => (/* binding */ UIButton)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(72642);
/* harmony import */ var ui_atoms_Stack__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(16343);
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}



const UIButton = (_param)=>/*#__PURE__*/ {
    var { children  } = _param, props = _object_without_properties(_param, [
        "children"
    ]);
    return react__WEBPACK_IMPORTED_MODULE_0__.createElement(ui_atoms_Stack__WEBPACK_IMPORTED_MODULE_1__/* .HStack */ .Ug, _object_spread({
        as: _mui_material__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z,
        color: "primary",
        align: "center",
        variant: "contained",
        style: {
            flexGrow: 1,
            color: "white"
        },
        onClick: props.onClick
    }, props), children);
};


/***/ }),

/***/ 33707:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "V": () => (/* binding */ UpdateSince)
});

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/shared/testConstants.ts + 1 modules
var testConstants = __webpack_require__(81202);
// EXTERNAL MODULE: ./node_modules/@mui/icons-material/esm/RefreshOutlined.js
var RefreshOutlined = __webpack_require__(70154);
// EXTERNAL MODULE: ./src/ui/css/index.ts
var css = __webpack_require__(93461);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/formatDistance/index.js + 9 modules
var formatDistance = __webpack_require__(28304);
;// CONCATENATED MODULE: ./src/libs/hooks/useInterval.ts

const useInterval = (callback, delay)=>{
    const id = (0,react.useRef)(null);
    (0,react.useEffect)(()=>{
        if (id.current) {
            clearInterval(id.current);
            id.current = null;
        }
        if (delay !== null) {
            id.current = setInterval(callback, delay);
        }
        return ()=>{
            id.current && clearInterval(id.current);
        };
    }, [
        callback,
        delay
    ]);
};
/* harmony default export */ const hooks_useInterval = (useInterval);

;// CONCATENATED MODULE: ./src/ui/atoms/UpdatedSince/UpdateTimeLabel.tsx



function format(time) {
    return ((0,formatDistance/* default */.Z)(time, Date.now(), {
        includeSeconds: false
    }) + " ago").replace("less than", "");
}
const UpdateTimeLabel = ({ time , formatLabel =(s)=>s  })=>{
    const [timeFromNow, setTimeFromNow] = (0,react.useState)("");
    const refresh = (0,react.useCallback)(()=>{
        if (time) {
            setTimeFromNow(format(time));
        }
    }, [
        time,
        setTimeFromNow
    ]);
    (0,react.useEffect)(()=>{
        setTimeFromNow(format(time));
    }, [
        time
    ]);
    hooks_useInterval(refresh, 60000);
    return /*#__PURE__*/ react.createElement("span", null, formatLabel(timeFromNow));
};

// EXTERNAL MODULE: ./src/ui/atoms/PageHeaderPill.tsx
var PageHeaderPill = __webpack_require__(23070);
;// CONCATENATED MODULE: ./src/ui/atoms/UpdatedSince/index.tsx






const spinAnimation = (0,css/* keyframes */.F4)({
    "0%": {
        transform: "rotate(90deg)"
    },
    "100%": {
        transform: "rotate(450deg)"
    }
});
const StyledRefreshIcon = (0,css/* styled */.zo)(RefreshOutlined/* default */.Z, {
    transition: `transform .3s ease-out`,
    fontSize: "21px",
    color: "#757575",
    animation: `${spinAnimation} 1s ease-out`
});
const containerStyles = (0,css/* css */.iv)({
    cursor: "pointer !important",
    ["&:hover"]: {
        [`${StyledRefreshIcon}`]: {
            transform: "rotate(90deg)"
        }
    }
});
function UpdateSince({ time , refreshAction , formatLabel  }) {
    const [count, setCount] = (0,react.useState)(0);
    return /*#__PURE__*/ react.createElement(PageHeaderPill/* PageHeaderPill */.l, {
        key: count,
        className: containerStyles().className,
        "data-fs": "unmask",
        onClick: ()=>{
            refreshAction();
            setCount((c)=>c + 1);
        },
        label: /*#__PURE__*/ react.createElement(UpdateTimeLabel, {
            time: time,
            formatLabel: formatLabel
        }),
        icon: /*#__PURE__*/ react.createElement(StyledRefreshIcon, {
            "data-testid": testConstants/* updatedSinceSelectors.renew */.P_.renew
        })
    });
}


/***/ }),

/***/ 1582:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "UQ": () => (/* reexport */ Accordion_Accordion),
  "rN": () => (/* reexport */ AccordionDetails_AccordionDetails),
  "_O": () => (/* reexport */ AccordionSummary_AccordionSummary),
  "Z9": () => (/* reexport */ StateScreens/* AlertState */.Z9),
  "oZ": () => (/* reexport */ AppFavIcon),
  "e0": () => (/* reexport */ ArrowIcon),
  "qE": () => (/* reexport */ Avatar_Avatar),
  "xu": () => (/* reexport */ atoms_Box/* Box */.x),
  "zx": () => (/* reexport */ Button/* default */.Z),
  "XZ": () => (/* reexport */ Checkbox/* default */.Z),
  "Af": () => (/* reexport */ Chip_Chip),
  "RI": () => (/* reexport */ CircleBullet),
  "_p": () => (/* reexport */ CircleTypes),
  "Ei": () => (/* reexport */ CopyTextToClipboard/* CopyTextToClipboard */.E),
  "Vq": () => (/* reexport */ Dialog/* default */.Z),
  "kX": () => (/* reexport */ DialogActions/* default */.Z),
  "cZ": () => (/* reexport */ DialogContent/* default */.Z),
  "$N": () => (/* reexport */ DialogTitle/* default */.Z),
  "x9": () => (/* reexport */ Disabled),
  "iz": () => (/* reexport */ StackDivider/* Divider */.i),
  "ZC": () => (/* reexport */ DividerWithText),
  "et": () => (/* reexport */ DomainFavIcon),
  "SV": () => (/* reexport */ ErrorBoundary/* ErrorBoundary */.S),
  "Te": () => (/* reexport */ StateScreens/* ErrorState */.Te),
  "Qq": () => (/* reexport */ ExpandIcon/* ExpandIcon */.Q),
  "GH": () => (/* reexport */ FilterChip),
  "cg": () => (/* reexport */ StackDivider/* HDivider */.c),
  "Ug": () => (/* reexport */ Stack/* HStack */.Ug),
  "hU": () => (/* reexport */ IconButton/* default */.Z),
  "GS": () => (/* reexport */ LayoutLoader),
  "uk": () => (/* reexport */ LinearProgress/* default */.Z),
  "rU": () => (/* reexport */ Link_Link),
  "aV": () => (/* reexport */ List/* default */.Z),
  "HC": () => (/* reexport */ ListItem/* default */.ZP),
  "F_": () => (/* reexport */ ListItemText/* default */.Z),
  "aN": () => (/* reexport */ Loader),
  "fl": () => (/* reexport */ LoadingButton/* LoadingButton */.f),
  "Gu": () => (/* reexport */ StateScreens/* LoadingState */.Gu),
  "Ub": () => (/* reexport */ NestedMenuItem),
  "Pm": () => (/* reexport */ StateScreens/* NoDataState */.Pm),
  "eO": () => (/* reexport */ NoItemsFullpage),
  "jC": () => (/* reexport */ Note),
  "wm": () => (/* reexport */ PageProgress),
  "Xk": () => (/* reexport */ Paper/* default */.Z),
  "J2": () => (/* reexport */ Popover/* default */.ZP),
  "q": () => (/* reexport */ Preload),
  "v3": () => (/* reexport */ ShowOnHover/* ShowOnHover */.v),
  "cR": () => (/* reexport */ Stack/* StackSpacer */.cR),
  "xv": () => (/* reexport */ Text/* Text */.x),
  "nv": () => (/* reexport */ TextField/* default */.Z),
  "Nl": () => (/* reexport */ TextFieldInput),
  "CO": () => (/* reexport */ ToggleButtonGroup_ToggleButton),
  "th": () => (/* reexport */ ToggleButtonGroup_ToggleButtonGroup),
  "u": () => (/* reexport */ Tooltip_Tooltip/* default */.Z),
  "ZT": () => (/* reexport */ Typography/* default */.Z),
  "y3": () => (/* reexport */ UIButton/* UIButton */.y),
  "Vv": () => (/* reexport */ UpdatedSince/* UpdateSince */.V),
  "gC": () => (/* reexport */ Stack/* VStack */.gC),
  "Fc": () => (/* reexport */ NoItemsFound_containerStyles),
  "MA": () => (/* reexport */ loaderCenterStyles),
  "Hy": () => (/* reexport */ mapError/* mapErrorOnly */.Hy),
  "jM": () => (/* reexport */ mapError/* mapProps */.jM),
  "z_": () => (/* reexport */ CopyTextToClipboard/* onCopySuccess */.z)
});

// UNUSED EXPORTS: Alert, AsyncButton, BoxInternal, CircleSizes, CopyTooltip, DialogContentText, DisabledStyles, NoItemsView, Switch, ToggleButtonGroupField, ZStack, getErrorLabel, getUserInitials, mapError

// EXTERNAL MODULE: ./src/ui/atoms/Field/mapError.ts
var mapError = __webpack_require__(34246);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@mui/material/TextField/TextField.js + 1 modules
var TextField = __webpack_require__(94659);
;// CONCATENATED MODULE: ./src/ui/atoms/Field/TextField.jsx
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}



class TextFieldInput extends react.PureComponent {
    render() {
        return /*#__PURE__*/ react.createElement(TextField/* default */.Z, _object_spread({
            variant: "standard"
        }, (0,mapError/* mapProps */.jM)(this.props)));
    }
}
TextFieldInput.defaultProps = {
    blacklist: []
};

;// CONCATENATED MODULE: ./src/ui/atoms/Field/index.ts



// EXTERNAL MODULE: ./node_modules/@mui/material/CircularProgress/CircularProgress.js + 1 modules
var CircularProgress_CircularProgress = __webpack_require__(59062);
// EXTERNAL MODULE: ./src/ui/css/index.ts
var css = __webpack_require__(93461);
;// CONCATENATED MODULE: ./src/ui/atoms/Loader/Loader.tsx
function Loader_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function Loader_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            Loader_define_property(target, key, source[key]);
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}



const Wrapper = (0,css/* styled */.zo)("div", {
    textAlign: "center",
    display: "flex",
    height: "100%"
});
const Loader = (_param)=>{
    var { loading , children  } = _param, props = _object_without_properties(_param, [
        "loading",
        "children"
    ]);
    return loading ? /*#__PURE__*/ react.createElement(Wrapper, {
        "aria-label": "Loading"
    }, /*#__PURE__*/ react.createElement(CircularProgress_CircularProgress/* default */.Z, Loader_object_spread({
        style: {
            margin: "auto"
        }
    }, props))) : /*#__PURE__*/ react.createElement(react.Fragment, null, children);
};

// EXTERNAL MODULE: ./node_modules/@mui/material/LinearProgress/LinearProgress.js + 1 modules
var LinearProgress = __webpack_require__(69041);
// EXTERNAL MODULE: ./src/ui/theme.ts
var theme = __webpack_require__(73728);
;// CONCATENATED MODULE: ./src/ui/atoms/Loader/PageProgress.tsx



const PageProgress = (0,css/* styled */.zo)(LinearProgress/* default */.Z, {
    position: "fixed",
    top: "0",
    left: "0",
    height: "4px !important",
    zIndex: theme/* theme.zIndex.modal */.rS.zIndex.modal + 2,
    width: "100%"
});

;// CONCATENATED MODULE: ./src/ui/atoms/Loader/index.tsx



// EXTERNAL MODULE: ./node_modules/@mui/styles/withStyles/withStyles.js + 34 modules
var withStyles = __webpack_require__(72116);
;// CONCATENATED MODULE: ./src/ui/atoms/LayoutLoader/LayoutLoader.tsx



const themeStyles = ()=>({
        loaderWrapper: {
            display: "flex",
            flexDirection: "column",
            maxWidth: "100%",
            height: "100%",
            placeContent: "center",
            alignItems: "center",
            boxSizing: "border-box",
            zIndex: 200
        }
    });
const LayoutLoaderPure = ({ classes ={} , innerRef =null  })=>{
    return /*#__PURE__*/ react.createElement("div", {
        className: classes === null || classes === void 0 ? void 0 : classes.loaderWrapper,
        ref: innerRef
    }, /*#__PURE__*/ react.createElement(CircularProgress_CircularProgress/* default */.Z, {
        className: classes === null || classes === void 0 ? void 0 : classes.progress,
        size: 50
    }), "Loading...");
};
const LayoutLoader = (0,withStyles/* default */.Z)(themeStyles, {
    withTheme: true
})(LayoutLoaderPure);

;// CONCATENATED MODULE: ./src/ui/atoms/LayoutLoader/index.ts


// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(94184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./node_modules/lodash-es/upperFirst.js + 1 modules
var upperFirst = __webpack_require__(85295);
;// CONCATENATED MODULE: ./src/ui/atoms/ToggleButtonGroup/ToggleButtonGroupInternal.tsx
function ToggleButtonGroupInternal_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function ToggleButtonGroupInternal_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            ToggleButtonGroupInternal_define_property(target, key, source[key]);
        });
    }
    return target;
}
function ToggleButtonGroupInternal_object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = ToggleButtonGroupInternal_object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function ToggleButtonGroupInternal_object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}




function isValueSelected(value, candidate) {
    if (candidate === undefined || value === undefined) {
        return false;
    }
    if (Array.isArray(candidate)) {
        return candidate.indexOf(value) >= 0;
    }
    return value === candidate;
}
const styles = (theme)=>({
        /* Styles applied to the root element. */ root: {
            backgroundColor: theme.palette.background.paper,
            borderRadius: theme.shape.borderRadius,
            display: "inline-flex"
        },
        /* Styles applied to the children. */ grouped: {
            "padding": "0px 11px 0px 12px",
            "&:not(:first-child)": {
                marginLeft: -1,
                borderLeft: "1px solid transparent",
                borderTopLeftRadius: 0,
                borderBottomLeftRadius: 0
            },
            "&:not(:last-child)": {
                borderTopRightRadius: 0,
                borderBottomRightRadius: 0
            }
        },
        /* Styles applied to the children if `size="small"`. */ groupedSizeSmall: {
            padding: "0px 7px 0px 8px"
        },
        /* Styles applied to the children if `size="large"`. */ groupedSizeLarge: {
            padding: "0px 15px 0px 16px"
        }
    });
const ToggleButtonGroupInternal_ToggleButtonGroup = /*#__PURE__*/ react.forwardRef(function ToggleButton(props, ref) {
    const { children , classes ={} , className , exclusive =false , onChange , size ="medium" , value  } = props, other = ToggleButtonGroupInternal_object_without_properties(props, [
        "children",
        "classes",
        "className",
        "exclusive",
        "onChange",
        "size",
        "value"
    ]);
    const handleChange = (event, buttonValue)=>{
        if (!onChange) {
            return;
        }
        const index = value && value.indexOf(buttonValue);
        let newValue;
        if (value && index >= 0) {
            newValue = [
                ...value
            ];
            newValue.splice(index, 1);
        } else {
            newValue = value ? [
                ...value,
                buttonValue
            ] : [
                buttonValue
            ];
        }
        onChange(event, newValue);
    };
    const handleExclusiveChange = (event, buttonValue)=>{
        if (!onChange) {
            return;
        }
        onChange(event, value === buttonValue ? null : buttonValue);
    };
    return /*#__PURE__*/ react.createElement("div", ToggleButtonGroupInternal_object_spread({
        className: classnames_default()(classes === null || classes === void 0 ? void 0 : classes.root, className),
        ref: ref,
        role: "group"
    }, other), react.Children.map(children, (child)=>{
        if (!/*#__PURE__*/ react.isValidElement(child)) {
            return null;
        }
        if (false) {}
        const { selected: buttonSelected , value: buttonValue  } = child.props;
        const selected = buttonSelected === undefined ? isValueSelected(buttonValue, value) : buttonSelected;
        return /*#__PURE__*/ react.cloneElement(child, {
            className: classnames_default()(classes.grouped, {
                [classes[`groupedSize${(0,upperFirst/* default */.Z)(size)}`]]: size !== "medium"
            }, child.props.className),
            selected,
            onChange: exclusive ? handleExclusiveChange : handleChange,
            size
        });
    }));
});
/* harmony default export */ const ToggleButtonGroupInternal = ((0,withStyles/* default */.Z)(styles, {
    name: "MuiToggleButtonGroup"
})(ToggleButtonGroupInternal_ToggleButtonGroup));

// EXTERNAL MODULE: ./node_modules/@mui/system/esm/colorManipulator.js
var colorManipulator = __webpack_require__(41796);
// EXTERNAL MODULE: ./node_modules/@mui/material/ButtonBase/ButtonBase.js + 6 modules
var ButtonBase = __webpack_require__(76637);
;// CONCATENATED MODULE: ./src/ui/atoms/ToggleButtonGroup/ToggleButton.tsx
// @inheritedComponent ButtonBase
function ToggleButton_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function ToggleButton_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            ToggleButton_define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function ToggleButton_object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = ToggleButton_object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function ToggleButton_object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}






function capitalize(a) {
    return (0,upperFirst/* default */.Z)(a);
}
const ToggleButton_styles = (theme)=>({
        /* Styles applied to the root element. */ root: _object_spread_props(ToggleButton_object_spread({}, theme.typography.button), {
            "boxSizing": "border-box",
            "textTransform": "none",
            "fontWeight": "normal",
            "borderRadius": theme.shape.borderRadius,
            "padding": "0px 12px",
            "border": `1px solid ${theme.palette.divider}`,
            "color": theme.palette.text.primary,
            "&$selected": {
                "border": "none",
                "borderRadius": theme.shape.borderRadius,
                "color": theme.palette.getContrastText("#000"),
                "backgroundColor": theme.palette.primary.main,
                "&:hover": {
                    backgroundColor: theme.palette.primary.main
                },
                "& + &": {
                    borderLeft: 0,
                    marginLeft: 0
                }
            },
            "&$disabled": {
                color: (0,colorManipulator/* alpha */.Fq)(theme.palette.action.disabled, 0.12)
            },
            "&:hover": {
                "textDecoration": "none",
                // Reset on mouse devices
                "backgroundColor": (0,colorManipulator/* alpha */.Fq)(theme.palette.text.primary, 0.05),
                "@media (hover: none)": {
                    backgroundColor: "transparent"
                },
                "&$disabled": {
                    backgroundColor: "transparent"
                }
            }
        }),
        /* Pseudo-class applied to the root element if `disabled={true}`. */ disabled: {},
        /* Pseudo-class applied to the root element if `selected={true}`. */ selected: {},
        /* Styles applied to the `label` wrapper element. */ label: {
            width: "100%",
            display: "inherit",
            alignItems: "inherit",
            justifyContent: "inherit"
        },
        /* Styles applied to the root element if `size="small"`. */ sizeSmall: {
            height: 25,
            padding: "0px 8px",
            fontSize: theme.typography.pxToRem(13)
        },
        sizeMedium: {
            height: 30,
            padding: "0px 16px",
            fontSize: theme.typography.pxToRem(15)
        },
        /* Styles applied to the root element if `size="large"`. */ sizeLarge: {
            height: 40,
            padding: "0px 16px",
            fontSize: theme.typography.pxToRem(15)
        }
    });
const ToggleButton_ToggleButton = /*#__PURE__*/ react.forwardRef(function ToggleButton(props, ref) {
    const { children , classes , className , disabled =false , disableFocusRipple =false , disableRipple =false , onChange , onClick , selected , selectedColor , size ="medium" , value  } = props, other = ToggleButton_object_without_properties(props, [
        "children",
        "classes",
        "className",
        "disabled",
        "disableFocusRipple",
        "disableRipple",
        "onChange",
        "onClick",
        "selected",
        "selectedColor",
        "size",
        "value"
    ]);
    const handleChange = (event)=>{
        if (onClick) {
            onClick(event, value);
            if (event.isDefaultPrevented()) {
                return;
            }
        }
        if (onChange) {
            onChange(event, value);
        }
    };
    return /*#__PURE__*/ react.createElement(ButtonBase/* default */.Z, ToggleButton_object_spread({
        className: classnames_default()(classes.root, {
            [classes.disabled]: disabled,
            [classes.selected]: selected,
            [classes[`size${capitalize(size)}`]]: size
        }, className),
        disabled: disabled,
        focusRipple: !disableFocusRipple,
        ref: ref,
        onClick: handleChange,
        onChange: onChange,
        value: value,
        disableRipple: disableRipple,
        "aria-pressed": selected,
        style: selected ? {
            backgroundColor: selectedColor
        } : undefined
    }, other), /*#__PURE__*/ react.createElement("span", {
        className: classes.label
    }, children));
});
/* harmony default export */ const ToggleButtonGroup_ToggleButton = ((0,withStyles/* default */.Z)(ToggleButton_styles, {
    name: "MuiToggleButton"
})(ToggleButton_ToggleButton));

;// CONCATENATED MODULE: ./src/ui/atoms/ToggleButtonGroup/ToggleButtonGroup.tsx
function ToggleButtonGroup_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function ToggleButtonGroup_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            ToggleButtonGroup_define_property(target, key, source[key]);
        });
    }
    return target;
}
function ToggleButtonGroup_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function ToggleButtonGroup_object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ToggleButtonGroup_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function ToggleButtonGroup_object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = ToggleButtonGroup_object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function ToggleButtonGroup_object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}



const ToggleButtonGroup_styles = (0,css/* css */.iv)({});
function ToggleButtonGroup_ToggleButtonGroup(_param) {
    var { children , value , onChange , onBlur , onFocus , style , size , spacingSize ="regular" , className  } = _param, rest = ToggleButtonGroup_object_without_properties(_param, [
        "children",
        "value",
        "onChange",
        "onBlur",
        "onFocus",
        "style",
        "size",
        "spacingSize",
        "className"
    ]);
    return /*#__PURE__*/ react.createElement(ToggleButtonGroupInternal, ToggleButtonGroup_object_spread_props(ToggleButtonGroup_object_spread({
        size: size,
        value: value,
        onFocus: onFocus,
        exclusive: true,
        onChange: (_, v)=>{
            if (v !== null) {
                onChange(v);
                setTimeout(()=>{
                    onBlur === null || onBlur === void 0 ? void 0 : onBlur(_);
                });
            }
        }
    }, rest), {
        style: ToggleButtonGroup_object_spread_props(ToggleButtonGroup_object_spread({}, style), {
            display: "grid",
            gridTemplateColumns: `repeat(${react.Children.count(children)}, 1fr)`
        }),
        className: ToggleButtonGroup_styles({
            className,
            css: {
                ">button": {
                    padding: spacingSize === "small" ? `0 10px` : `0 15px`
                }
            }
        }).className
    }), children);
}


;// CONCATENATED MODULE: ./src/ui/atoms/ToggleButtonGroup/index.ts


// EXTERNAL MODULE: ./src/shared/checkBrowser.ts
var checkBrowser = __webpack_require__(68446);
;// CONCATENATED MODULE: ./src/ui/atoms/ToggleButtonGroupField/ToggleButtonGroupField.tsx
function ToggleButtonGroupField_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function ToggleButtonGroupField_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            ToggleButtonGroupField_define_property(target, key, source[key]);
        });
    }
    return target;
}
function ToggleButtonGroupField_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function ToggleButtonGroupField_object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ToggleButtonGroupField_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}




function ToggleButtonGroupField({ inputProps , label , items , className  }) {
    return /*#__PURE__*/ React.createElement(FormControl, {
        fullWidth: true,
        style: {
            marginBottom: 10
        },
        className: className
    }, label && /*#__PURE__*/ React.createElement(FormLabel, {
        filled: true,
        component: "div",
        style: {
            marginBottom: 15
        }
    }, label), /*#__PURE__*/ React.createElement(ToggleButtonGroup, ToggleButtonGroupField_object_spread_props(ToggleButtonGroupField_object_spread({}, inputProps), {
        onChange: (e)=>{
            if (IS_SAFARI) {
                inputProps.onFocus();
            }
            inputProps.onChange(e);
        },
        value: inputProps.value
    }), items.map((el)=>/*#__PURE__*/ React.createElement(ToggleButton, {
            key: el.value.toString(),
            value: el.value,
            "aria-label": el.label,
            classes: el.classes
        }, el.label))));
}

;// CONCATENATED MODULE: ./src/ui/atoms/ToggleButtonGroupField/index.ts


// EXTERNAL MODULE: ./src/ui/messages.ts
var ui_messages = __webpack_require__(16239);
;// CONCATENATED MODULE: ./src/ui/atoms/CopyTooltip.jsx
function CopyTooltip_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}




const TooltipLabelClass = css/* css */.iv`
  max-width: 500px;
`;
class CopyTooltip extends react.Component {
    componentWillUnmount() {
        this.timeout && clearTimeout(this.timeout);
    }
    getLabel() {
        return this.state.showLabel ? this.copiedText : this.props.title;
    }
    render() {
        return /*#__PURE__*/ React.createElement(Tooltip, {
            interactive: true,
            enterDelay: 200,
            leaveDelay: 50,
            classes: {
                tooltip: TooltipLabelClass
            },
            PopperProps: {
                container: this.props.portalContainer,
                disablePortal: !this.props.portalContainer,
                onClick: this.onClick,
                onCopy: this.onCopy
            },
            title: this.getLabel()
        }, this.props.children);
    }
    constructor(...args){
        super(...args);
        CopyTooltip_define_property(this, "copiedText", messages.copyTooltip.copiedText);
        CopyTooltip_define_property(this, "delay", 300);
        CopyTooltip_define_property(this, "state", {
            showLabel: false
        });
        CopyTooltip_define_property(this, "onCopy", (e)=>{
            e.preventDefault();
            e.clipboardData.setData("text/plain", this.props.title);
        });
        CopyTooltip_define_property(this, "onClick", (e)=>{
            this.timeout = setTimeout(()=>this.setState({
                    showLabel: false
                }), this.delay);
            e.nativeEvent.preventDefault();
            e.nativeEvent.stopPropagation();
            this.setState({
                showLabel: true
            });
            if (this.props.title) {
                document.execCommand("copy");
            }
        });
    }
}

// EXTERNAL MODULE: ./src/libs/hooks/index.ts + 18 modules
var hooks = __webpack_require__(88289);
;// CONCATENATED MODULE: ./src/ui/atoms/Preload/Preload.tsx


const Preload = ({ once =null , load =null , isLoaded , loader =null , children  })=>{
    const isLoadedRes = (0,hooks/* useSelector */.v9)(isLoaded);
    (0,react.useLayoutEffect)(()=>{
        if (!once || !isLoadedRes) {
            load === null || load === void 0 ? void 0 : load();
        }
    }, []);
    return (isLoadedRes ? children : loader) || null;
};

;// CONCATENATED MODULE: ./src/ui/atoms/Preload/index.ts


;// CONCATENATED MODULE: ./src/ui/atoms/LoaderCenterStyle.ts
function loaderCenterStyles() {
    return {
        position: "absolute",
        top: "50%",
        left: "50%",
        marginTop: "-12px",
        marginLeft: "-12px"
    };
}

// EXTERNAL MODULE: ./src/ui/atoms/UpdatedSince/index.tsx + 2 modules
var UpdatedSince = __webpack_require__(33707);
// EXTERNAL MODULE: ./src/ui/atoms/Alert.tsx
var Alert = __webpack_require__(77723);
// EXTERNAL MODULE: ./src/ui/atoms/LoadingButton.tsx
var LoadingButton = __webpack_require__(39540);
// EXTERNAL MODULE: ./src/libs/layouts/index.tsx + 2 modules
var layouts = __webpack_require__(5855);
// EXTERNAL MODULE: ./src/ui/atoms/Box.tsx
var atoms_Box = __webpack_require__(17299);
;// CONCATENATED MODULE: ./src/ui/atoms/AsyncButton.tsx
function AsyncButton_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function AsyncButton_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            AsyncButton_define_property(target, key, source[key]);
        });
    }
    return target;
}
function AsyncButton_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function AsyncButton_object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        AsyncButton_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function AsyncButton_object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = AsyncButton_object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function AsyncButton_object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}






function AsyncButton(_param) {
    var { onClick , children , loaderColor ="inherit" , loader =/*#__PURE__*/ React.createElement(CircularProgress, {
        size: 15,
        color: loaderColor
    })  } = _param, props = AsyncButton_object_without_properties(_param, [
        "onClick",
        "children",
        "loaderColor",
        "loader"
    ]);
    const [state, fetch] = useAsyncFn(onClick, [
        onClick
    ]);
    return(// @ts-ignore
    /*#__PURE__*/ React.createElement(MBox, AsyncButton_object_spread_props(AsyncButton_object_spread({
        as: "div",
        disabled: state.loading
    }, props), {
        onClick: fetch
    }), /*#__PURE__*/ React.createElement(HStack, {
        align: "center"
    }, state.loading && /*#__PURE__*/ React.createElement(Box, {
        sx: {
            centerContent: true
        }
    }, loader), /*#__PURE__*/ React.createElement("div", null, children))));
}

;// CONCATENATED MODULE: ./src/ui/atoms/DividerWithText.tsx



const containerStyles = (0,css/* css */.iv)({
    "display": "flex",
    "flexBasis": "100%",
    "alignItems": "center",
    "color": theme/* theme.palette.grey.500 */.rS.palette.grey[500],
    "&:before, &:after": {
        content: '""',
        flexGrow: 1,
        background: theme/* theme.palette.grey.300 */.rS.palette.grey[300],
        height: "1px",
        fontSize: "0px",
        lineHeight: "0px"
    }
});
function DividerWithText({ children  }) {
    return /*#__PURE__*/ react.createElement("div", {
        className: containerStyles().className
    }, /*#__PURE__*/ react.createElement("div", {
        style: {
            padding: "0 8px"
        }
    }, children));
}

// EXTERNAL MODULE: ./node_modules/@mui/material/Chip/Chip.js + 2 modules
var Chip = __webpack_require__(90461);
// EXTERNAL MODULE: ./node_modules/@mui/icons-material/Close.js
var Close = __webpack_require__(50594);
;// CONCATENATED MODULE: ./src/ui/atoms/FilterChip.tsx
function FilterChip_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function FilterChip_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            FilterChip_define_property(target, key, source[key]);
        });
    }
    return target;
}
function FilterChip_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function FilterChip_object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        FilterChip_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}




const filterChipStyles = (0,css/* css */.iv)({
    "height": 28,
    "background": "#fff",
    "borderColor": "#E0E0E0",
    "color": "rgba(0, 0, 0, .87)",
    "borderRadius": "4px",
    "fontWeight": 500,
    "fontSize": 13,
    "textTransform": "none",
    "justifyContent": "flex-start",
    "&:active": {
        boxShadow: "none"
    },
    "&.MuiChip-clickable:hover": {
        background: "#fff",
        color: "rgba(0, 0, 0, .87)"
    },
    ".MuiChip-label": {
        color: "inherit",
        paddingRight: "0",
        paddingLeft: "8px",
        fontSize: 13,
        lineHeight: 1.2
    },
    ".MuiChip-icon": {
        marginLeft: "6px",
        marginRight: "-2px",
        color: "rgba(0, 0, 0, .6)"
    },
    ".MuiChip-deleteIcon": {
        "display": "flex",
        "alignItems": "center",
        "padding": "0 4px 0 8px",
        "marginRight": 0,
        "marginLeft": "auto",
        "height": "100%",
        "color": "rgba(0, 0, 0, .6)",
        "&:hover": {
            color: "rgba(0, 0, 0, .6)"
        }
    }
});
const FilterChip = /*#__PURE__*/ react.forwardRef((props, ref)=>{
    return /*#__PURE__*/ react.createElement(Chip/* default */.Z, FilterChip_object_spread_props(FilterChip_object_spread({
        ref: ref,
        variant: "outlined",
        deleteIcon: props.onDelete ? /*#__PURE__*/ react.createElement("div", null, /*#__PURE__*/ react.createElement(Close/* default */.Z, {
            fontSize: "small"
        })) : undefined
    }, props), {
        className: `${filterChipStyles().className} ${props.className}`
    }));
});

;// CONCATENATED MODULE: ./src/ui/atoms/Disabled.tsx


const DisabledStyles = (0,css/* css */.iv)({
    $$grayscale: "none",
    variants: {
        isDisabled: {
            true: {
                "cursor": "no-drop",
                "pointerEvents": "none",
                "opacity": 0.85,
                "&>*": {
                    pointerEvents: "none",
                    filter: "var(--disabled-filter)",
                    visibility: "var(--disabled-visibility, visible)"
                }
            },
            false: {}
        },
        variant: {
            hidden: {
                "--disabled-visibility": "hidden"
            },
            grayscale: {
                "--disabled-filter": "grayscale(100%)"
            },
            blured: {
                "--disabled-filter": "grayscale(100%) blur(2px)"
            }
        }
    },
    defaultVariants: {
        variant: "grayscale"
    }
});
function Disabled({ isDisabled , variant , children  }) {
    return /*#__PURE__*/ react.createElement("div", {
        className: DisabledStyles({
            isDisabled,
            variant
        })
    }, children);
}

// EXTERNAL MODULE: ./node_modules/@mui/material/Accordion/Accordion.js + 1 modules
var Accordion = __webpack_require__(1820);
;// CONCATENATED MODULE: ./src/ui/atoms/Accordion/Accordion.tsx


const Accordion_Accordion = (0,css/* styled */.zo)(Accordion/* default */.Z, {
    "margin": "0 0 2px 0",
    "boxShadow": "none",
    "&::before": {
        display: "none"
    },
    "&.Mui-expanded": {
        marginTop: 0
    }
});

// EXTERNAL MODULE: ./node_modules/@mui/material/AccordionDetails/AccordionDetails.js + 1 modules
var AccordionDetails = __webpack_require__(85092);
// EXTERNAL MODULE: ./src/ui/vars.tsx
var vars = __webpack_require__(29400);
;// CONCATENATED MODULE: ./src/ui/atoms/Accordion/AccordionDetails.tsx



const AccordionDetails_AccordionDetails = (0,css/* styled */.zo)(AccordionDetails/* default */.Z, {
    "background": vars/* colors.light100 */.O9.light100,
    "padding": `${vars/* space.2 */.Dh[2]} ${vars/* space.3 */.Dh[3]}`,
    "borderRadius": 3,
    "marginTop": 2,
    "&:hover": {
        background: vars/* colors.light200 */.O9.light200,
        cursor: "pointer"
    }
});

// EXTERNAL MODULE: ./node_modules/@mui/material/AccordionSummary/AccordionSummary.js + 1 modules
var AccordionSummary = __webpack_require__(47425);
;// CONCATENATED MODULE: ./src/ui/atoms/Accordion/AccordionSummary.tsx



const AccordionSummary_AccordionSummary = (0,css/* styled */.zo)(AccordionSummary/* default */.Z, {
    "backgroundColor": vars/* colors.light100 */.O9.light100,
    "borderRadius": 3,
    "&.Mui-expanded": {
        minHeight: 48,
        backgroundColor: vars/* colors.light200 */.O9.light200
    },
    "&.Mui-expanded .MuiAccordionSummary-content": {
        margin: "12px 0"
    }
});

;// CONCATENATED MODULE: ./src/ui/atoms/Accordion/index.ts




// EXTERNAL MODULE: ./src/ui/atoms/ExpandIcon.tsx
var ExpandIcon = __webpack_require__(87093);
// EXTERNAL MODULE: ./node_modules/@mui/icons-material/ArrowDropUp.js
var ArrowDropUp = __webpack_require__(29217);
// EXTERNAL MODULE: ./node_modules/@mui/icons-material/ArrowDropDown.js
var ArrowDropDown = __webpack_require__(45111);
;// CONCATENATED MODULE: ./src/ui/atoms/ArrowIcon.tsx
function ArrowIcon_object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = ArrowIcon_object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function ArrowIcon_object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}



const ArrowIcon = (_param)=>{
    var { open  } = _param, props = ArrowIcon_object_without_properties(_param, [
        "open"
    ]);
    return open ? /*#__PURE__*/ react.createElement(ArrowDropUp/* default */.Z, props) : /*#__PURE__*/ react.createElement(ArrowDropDown/* default */.Z, props);
};

// EXTERNAL MODULE: ./src/ui/atoms/Text.tsx
var Text = __webpack_require__(21361);
;// CONCATENATED MODULE: ./src/ui/atoms/Chip/Chip.tsx
function Chip_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function Chip_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            Chip_define_property(target, key, source[key]);
        });
    }
    return target;
}
function Chip_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function Chip_object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        Chip_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function Chip_object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = Chip_object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function Chip_object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}



const chipStyles = (0,css/* css */.iv)({
    borderRadius: "3px",
    textAlign: "center",
    display: "inline-flex",
    justifyContent: "center",
    minWidth: "22px",
    fontWeight: 500,
    fontSize: "12px !important",
    minHeight: "22px",
    alignItems: "center",
    lineHeight: "14px"
});
function Chip_Chip(_param) {
    var { children , color , background =theme/* theme.grey.listViewAttributes */.rS.grey.listViewAttributes , className  } = _param, rest = Chip_object_without_properties(_param, [
        "children",
        "color",
        "background",
        "className"
    ]);
    return /*#__PURE__*/ react.createElement("div", Chip_object_spread_props(Chip_object_spread({}, rest), {
        className: chipStyles({
            className,
            css: {
                background,
                color: color || theme/* theme.palette.getContrastText */.rS.palette.getContrastText(background)
            }
        }).className
    }), children);
}

;// CONCATENATED MODULE: ./src/ui/atoms/Chip/index.ts


// EXTERNAL MODULE: ./node_modules/@mui/icons-material/ErrorOutline.js
var ErrorOutline = __webpack_require__(32141);
// EXTERNAL MODULE: ./node_modules/@mui/material/Typography/Typography.js + 1 modules
var Typography = __webpack_require__(2658);
;// CONCATENATED MODULE: ./src/ui/atoms/NoItemsFound.tsx
function NoItemsFound_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function NoItemsFound_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            NoItemsFound_define_property(target, key, source[key]);
        });
    }
    return target;
}
function NoItemsFound_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function NoItemsFound_object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        NoItemsFound_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function NoItemsFound_object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = NoItemsFound_object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function NoItemsFound_object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}





const StyledFigure = (0,css/* styled */.zo)("figure", {
    "margin": "auto",
    "textAlign": "center",
    "color": "#aaa",
    "& > svg": {
        fontSize: "100px"
    }
});
const NoItemsFound_containerStyles = (0,css/* css */.iv)({
    height: "100%",
    width: "100%",
    display: "flex",
    justifyContent: "center",
    alignItems: "center"
});
function NoItemsView({ children , icon  }) {
    return /*#__PURE__*/ react.createElement(StyledFigure, null, icon, /*#__PURE__*/ react.createElement("figcaption", null, children));
}
NoItemsView.defaultProps = {
    icon: /*#__PURE__*/ react.createElement(ErrorOutline/* default */.Z, null)
};
const defaultProps = {
    title: ui_messages/* messages.noItemsFound.title */.s.noItemsFound.title,
    subtitle: ui_messages/* messages.noItemsFound.subtitle */.s.noItemsFound.subtitle,
    icon: /*#__PURE__*/ react.createElement(ErrorOutline/* default */.Z, null)
};
const NoItemsFullpage = (_param)=>{
    var { className , children , title , subtitle , icon  } = _param, rest = NoItemsFound_object_without_properties(_param, [
        "className",
        "children",
        "title",
        "subtitle",
        "icon"
    ]);
    return /*#__PURE__*/ react.createElement("div", NoItemsFound_object_spread_props(NoItemsFound_object_spread({}, rest), {
        role: "presentation",
        className: NoItemsFound_containerStyles({
            className
        }).className
    }), /*#__PURE__*/ react.createElement(NoItemsView, {
        icon: icon
    }, children, /*#__PURE__*/ react.createElement(Typography/* default */.Z, {
        color: "inherit"
    }, title), /*#__PURE__*/ react.createElement(Typography/* default */.Z, {
        color: "inherit"
    }, subtitle)));
};
NoItemsFullpage.defaultProps = defaultProps;

// EXTERNAL MODULE: ./node_modules/@mui/material/Link/Link.js + 2 modules
var Link = __webpack_require__(1079);
;// CONCATENATED MODULE: ./src/ui/atoms/Link.tsx


const Link_Link = (0,css/* styled */.zo)(Link/* default */.Z, {
    variants: {
        bold: {
            true: {
                ":hover": {
                    fontWeight: "bold"
                }
            }
        }
    }
});

// EXTERNAL MODULE: ./src/ui/atoms/StackDivider.tsx
var StackDivider = __webpack_require__(9827);
// EXTERNAL MODULE: ./src/ui/atoms/Stack.tsx
var Stack = __webpack_require__(16343);
;// CONCATENATED MODULE: ./src/ui/atoms/ZStack.tsx
function ZStack_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function ZStack_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            ZStack_define_property(target, key, source[key]);
        });
    }
    return target;
}
function ZStack_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function ZStack_object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ZStack_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function ZStack_object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = ZStack_object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function ZStack_object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}


const ZStackStyles = (0,css/* css */.iv)({
    "display": "grid",
    "justifyItems": "center",
    "placeItems": "center",
    "width": "fit-content",
    "& > *": {
        gridArea: "1/1/1/1",
        zIndex: 1
    }
});
const ZStack = /*#__PURE__*/ (/* unused pure expression or super */ null && (forwardRef(function ZStack(_param, ref) {
    var { as: Comp = "div" , className , alignX , sx , alignY , fullWidth  } = _param, props = ZStack_object_without_properties(_param, [
        "as",
        "className",
        "alignX",
        "sx",
        "alignY",
        "fullWidth"
    ]);
    return /*#__PURE__*/ React.createElement(Comp, ZStack_object_spread({
        ref: ref,
        "data-component": "ZStack",
        className: ZStackStyles({
            className,
            css: ZStack_object_spread_props(ZStack_object_spread({}, sx), {
                width: fullWidth ? "100%" : undefined,
                alignItems: alignY,
                justifyItems: alignX
            })
        }).toString()
    }, props));
})));

// EXTERNAL MODULE: ./src/assets/icons/index.tsx + 1 modules
var icons = __webpack_require__(99899);
// EXTERNAL MODULE: ./node_modules/react-query/es/index.js + 22 modules
var es = __webpack_require__(21478);
;// CONCATENATED MODULE: ./src/ui/atoms/FavIcon.tsx



function getDomainSafe(str) {
    try {
        var _ref;
        if (str.match(/^(\d+\.?)+$/)) {
            throw new Error("Cannot extract domain from ip address");
        }
        const hasProto = str.includes("http");
        const domain = hasProto ? (_ref = new URL(str)) === null || _ref === void 0 ? void 0 : _ref.hostname : new URL("https://" + str).hostname;
        const domainParts = domain.split(".");
        if (domainParts.length < 2) {
            throw new Error("url should contain at least two domain levels");
        }
        // strip subdomain
        const twoLevelDomain = [
            domainParts.at(-2),
            domainParts.at(-1)
        ].join(".");
        return [
            twoLevelDomain,
            domain
        ];
    } catch (e) {
        return [
            null,
            null
        ];
    }
}
const formatAppName = (app)=>{
    const appName = String(app).toLowerCase();
    if (appName.includes(".")) {
        return appName.split(".").slice(0, -1).join(".");
    }
    return appName;
};
const fetchImage = (src)=>{
    return new Promise((resolve, reject)=>{
        const img = new Image();
        img.onload = ()=>{
            resolve(src);
        };
        img.onerror = reject;
        img.src = src;
    });
};
const fetchImageWithFallback = (src, fallbackSrc)=>{
    return fetchImage(src).catch((error)=>{
        if (fallbackSrc && fallbackSrc !== src) {
            return fetchImage(fallbackSrc);
        }
        throw error;
    });
};
function FavIcon({ url , fallbackUrl , id , fallbackIcon: FallbackIcon , size =18 , color  }) {
    const { data , isLoading , isError  } = (0,es/* useQuery */.aM)([
        "images",
        {
            id
        }
    ], ()=>fetchImageWithFallback(url, fallbackUrl), {
        refetchOnMount: false,
        enabled: !!id
    });
    if (isLoading || isError || !id) {
        return /*#__PURE__*/ react.createElement(FallbackIcon, {
            color: color ? undefined : "action",
            htmlColor: color,
            style: {
                width: size,
                height: size
            }
        });
    }
    return /*#__PURE__*/ react.createElement("img", {
        src: data,
        width: size,
        height: size,
        alt: "favicon",
        style: {
            borderRadius: 2
        }
    });
}
function DomainFavIcon({ url , size =18  }) {
    const [domain, fallback] = (0,react.useMemo)(()=>getDomainSafe(url), [
        url
    ]);
    const getIconUrl = (domain)=>`/v1/favicon?size=64&domain=${domain}`;
    return /*#__PURE__*/ react.createElement(FavIcon, {
        url: getIconUrl(domain),
        fallbackUrl: getIconUrl(fallback),
        id: domain,
        size: size,
        fallbackIcon: icons/* LocationWebsiteIcon */.JR
    });
}
function AppFavIcon({ app , size =18 , color  }) {
    const appName = (0,react.useMemo)(()=>formatAppName(app), [
        app
    ]);
    return /*#__PURE__*/ react.createElement(FavIcon, {
        url: `/v1/icons?app=${appName}`,
        id: appName,
        size: size,
        fallbackIcon: icons/* LocationEndpointAppsIcon */.bG,
        color: color
    });
}

// EXTERNAL MODULE: ./src/ui/atoms/UIButton.tsx
var UIButton = __webpack_require__(18029);
// EXTERNAL MODULE: ./node_modules/@mui/material/Menu/Menu.js + 1 modules
var Menu = __webpack_require__(32301);
// EXTERNAL MODULE: ./node_modules/@mui/material/MenuItem/MenuItem.js + 1 modules
var MenuItem = __webpack_require__(33797);
// EXTERNAL MODULE: ./node_modules/@mui/icons-material/ChevronRight.js
var ChevronRight = __webpack_require__(26215);
;// CONCATENATED MODULE: ./src/ui/atoms/NestedMenuItem.tsx
function NestedMenuItem_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function NestedMenuItem_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            NestedMenuItem_define_property(target, key, source[key]);
        });
    }
    return target;
}
function NestedMenuItem_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function NestedMenuItem_object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        NestedMenuItem_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function NestedMenuItem_object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = NestedMenuItem_object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function NestedMenuItem_object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}




/**
 * Use as a drop-in replacement for `<MenuItem>` when you need to add cascading
 * menu elements as children to this component.
 */ const NestedMenuItem = /*#__PURE__*/ react.forwardRef(function NestedMenuItem(props, ref) {
    const { parentMenuOpen , label , rightIcon =/*#__PURE__*/ react.createElement(ChevronRight/* default */.Z, {
        style: {
            opacity: 0.54
        }
    }) , children , menuClasses , tabIndex: tabIndexProp , ContainerProps: ContainerPropsProp = {}  } = props, MenuItemProps = NestedMenuItem_object_without_properties(props, [
        "parentMenuOpen",
        "label",
        "rightIcon",
        "children",
        "menuClasses",
        "tabIndex",
        "ContainerProps"
    ]);
    const { ref: containerRefProp  } = ContainerPropsProp, ContainerProps = NestedMenuItem_object_without_properties(ContainerPropsProp, [
        "ref"
    ]);
    const menuItemRef = (0,react.useRef)(null);
    (0,react.useImperativeHandle)(ref, ()=>menuItemRef.current);
    const containerRef = (0,react.useRef)(null);
    (0,react.useImperativeHandle)(containerRefProp, ()=>containerRef.current);
    const menuContainerRef = (0,react.useRef)(null);
    const [isSubMenuOpen, setIsSubMenuOpen] = (0,react.useState)(false);
    const handleMouseEnter = (event)=>{
        setIsSubMenuOpen(true);
        if (ContainerProps === null || ContainerProps === void 0 ? void 0 : ContainerProps.onMouseEnter) {
            ContainerProps.onMouseEnter(event);
        }
    };
    const handleMouseLeave = (event)=>{
        setIsSubMenuOpen(false);
        if (ContainerProps === null || ContainerProps === void 0 ? void 0 : ContainerProps.onMouseLeave) {
            ContainerProps.onMouseLeave(event);
        }
    };
    // Check if any immediate children are active
    const isSubmenuFocused = ()=>{
        var _containerRef_current, _containerRef_current_ownerDocument, _menuContainerRef_current;
        const active = (_containerRef_current = containerRef.current) === null || _containerRef_current === void 0 ? void 0 : (_containerRef_current_ownerDocument = _containerRef_current.ownerDocument) === null || _containerRef_current_ownerDocument === void 0 ? void 0 : _containerRef_current_ownerDocument.activeElement;
        var _menuContainerRef_current_children;
        for (const child of (_menuContainerRef_current_children = (_menuContainerRef_current = menuContainerRef.current) === null || _menuContainerRef_current === void 0 ? void 0 : _menuContainerRef_current.children) !== null && _menuContainerRef_current_children !== void 0 ? _menuContainerRef_current_children : []){
            if (child === active) {
                return true;
            }
        }
        return false;
    };
    const handleFocus = (event)=>{
        if (event.target === containerRef.current) {
            setIsSubMenuOpen(true);
        }
        if (ContainerProps === null || ContainerProps === void 0 ? void 0 : ContainerProps.onFocus) {
            ContainerProps.onFocus(event);
        }
    };
    const handleKeyDown = (event)=>{
        var _containerRef_current, _containerRef_current_ownerDocument;
        if (event.key === "Escape") {
            return;
        }
        if (isSubmenuFocused()) {
            event.stopPropagation();
        }
        const active = (_containerRef_current = containerRef.current) === null || _containerRef_current === void 0 ? void 0 : (_containerRef_current_ownerDocument = _containerRef_current.ownerDocument) === null || _containerRef_current_ownerDocument === void 0 ? void 0 : _containerRef_current_ownerDocument.activeElement;
        if (event.key === "ArrowLeft" && isSubmenuFocused()) {
            var _containerRef_current1;
            (_containerRef_current1 = containerRef.current) === null || _containerRef_current1 === void 0 ? void 0 : _containerRef_current1.focus();
        }
        if (event.key === "ArrowRight" && event.target === containerRef.current && event.target === active) {
            var _menuContainerRef_current;
            const firstChild = (_menuContainerRef_current = menuContainerRef.current) === null || _menuContainerRef_current === void 0 ? void 0 : _menuContainerRef_current.children[0];
            firstChild === null || firstChild === void 0 ? void 0 : firstChild.focus();
        }
    };
    const open = isSubMenuOpen && parentMenuOpen;
    // Root element must have a `tabIndex` attribute for keyboard navigation
    let tabIndex;
    if (!props.disabled) {
        tabIndex = tabIndexProp !== undefined ? tabIndexProp : -1;
    }
    return /*#__PURE__*/ react.createElement("div", NestedMenuItem_object_spread_props(NestedMenuItem_object_spread({}, ContainerProps), {
        ref: containerRef,
        onFocus: handleFocus,
        tabIndex: tabIndex,
        onMouseEnter: handleMouseEnter,
        onMouseLeave: handleMouseLeave,
        onKeyDown: handleKeyDown
    }), /*#__PURE__*/ react.createElement(MenuItem/* default */.Z, NestedMenuItem_object_spread_props(NestedMenuItem_object_spread({}, MenuItemProps), {
        ref: menuItemRef
    }), label, rightIcon), /*#__PURE__*/ react.createElement(Menu/* default */.Z, {
        // Set pointer events to 'none' to prevent the invisible Popover div
        // from capturing events for clicks and hovers
        classes: menuClasses,
        style: {
            pointerEvents: "none"
        },
        PaperProps: {
            style: {
                pointerEvents: "auto"
            }
        },
        transitionDuration: 0,
        anchorEl: menuItemRef.current,
        anchorOrigin: {
            vertical: "top",
            horizontal: "left"
        },
        transformOrigin: {
            vertical: "top",
            horizontal: "right"
        },
        open: open,
        autoFocus: false,
        disableAutoFocus: true,
        disableEnforceFocus: true,
        onClose: ()=>{
            setIsSubMenuOpen(false);
        }
    }, /*#__PURE__*/ react.createElement("div", {
        ref: menuContainerRef
    }, children)));
});

// EXTERNAL MODULE: ./src/ui/atoms/StateScreens.tsx
var StateScreens = __webpack_require__(53213);
// EXTERNAL MODULE: ./src/ui/atoms/CopyTextToClipboard.tsx
var CopyTextToClipboard = __webpack_require__(54638);
// EXTERNAL MODULE: ./src/ui/atoms/ShowOnHover.tsx
var ShowOnHover = __webpack_require__(84030);
;// CONCATENATED MODULE: ./src/ui/atoms/CircleBullet.tsx






const CIRCLE_SIZE = 13;
const CircleSizes = {
    DEFAULT: CIRCLE_SIZE,
    SMALL: 8
};
const CircleTypes = {
    NOT_FILLED: "NOT_FILLED",
    FILLED: "FILLED",
    DASHED: "DASHED"
};
const borderLeft = `1px solid ${theme/* theme.palette.primary.main */.rS.palette.primary.main}`;
const classes = {
    container: (0,css/* css */.iv)({
        width: CIRCLE_SIZE,
        flex: "0 !important",
        marginLeft: 15,
        marginRight: 15,
        alignSelf: "stretch"
    }),
    connector: (0,css/* css */.iv)({
        flex: 1,
        variants: {
            showBorder: {
                true: {
                    borderLeft,
                    marginLeft: CIRCLE_SIZE / 2 - 0.3
                }
            }
        }
    }),
    firstConnector: (0,css/* css */.iv)({
        marginTop: vars/* space.3 */.Dh[3]
    }),
    border: (0,css/* css */.iv)({
        borderLeft,
        marginLeft: CIRCLE_SIZE / 2 - 0.3
    }),
    circle: (0,css/* css */.iv)({
        borderRadius: "1em",
        borderColor: theme/* theme.palette.primary.main */.rS.palette.primary.main,
        borderWidth: 1,
        width: CIRCLE_SIZE,
        height: CIRCLE_SIZE,
        borderStyle: "solid",
        variants: {
            type: {
                [CircleTypes.FILLED]: {
                    background: theme/* theme.palette.primary.main */.rS.palette.primary.main
                },
                [CircleTypes.DASHED]: {
                    borderStyle: "dotted"
                },
                [CircleTypes.NOT_FILLED]: {
                    borderStyle: "dotted"
                }
            },
            size: {
                small: {
                    width: CircleSizes.SMALL,
                    height: CircleSizes.SMALL
                }
            }
        }
    })
};
const CircleBullet = ({ type , isFirst =false , isLast =false , showBorder =true , size =undefined , color =undefined , sx , onClick  })=>{
    return /*#__PURE__*/ react.createElement(Stack/* VStack */.gC, {
        onClick: onClick,
        className: classes.container().className,
        sx: sx
    }, /*#__PURE__*/ react.createElement(atoms_Box/* Box */.x, {
        className: showBorder && isFirst ? classes.firstConnector().className : classes.connector({
            showBorder
        }).className
    }), /*#__PURE__*/ react.createElement(atoms_Box/* Box */.x, {
        style: {
            backgroundColor: type === CircleTypes.FILLED ? color : undefined,
            borderColor: color
        },
        className: classes.circle({
            type,
            size
        }).className
    }), /*#__PURE__*/ react.createElement(atoms_Box/* Box */.x, {
        className: classes.connector({
            showBorder: !isLast && showBorder
        }).className
    }));
};

// EXTERNAL MODULE: ./src/ui/atoms/ErrorBoundary.tsx
var ErrorBoundary = __webpack_require__(72763);
// EXTERNAL MODULE: ./node_modules/@mui/system/esm/Box/Box.js
var Box_Box = __webpack_require__(18377);
;// CONCATENATED MODULE: ./src/ui/atoms/Note.tsx



const NoteContainer = (0,css/* styled */.zo)(Box_Box/* default */.Z, {
    background: "#e9f6f9",
    border: "1px solid #d7eff4",
    padding: "10px",
    color: "rgba(0, 0, 0, 0.87)",
    letterSpacing: "-0.2px"
});
function Note({ children , style , title  }) {
    return /*#__PURE__*/ react.createElement(NoteContainer, {
        style: style
    }, /*#__PURE__*/ react.createElement("span", {
        style: {
            fontWeight: "bold"
        }
    }, title || "Note", ": "), children);
}

// EXTERNAL MODULE: ./node_modules/@mui/material/Popover/Popover.js + 1 modules
var Popover = __webpack_require__(62206);
// EXTERNAL MODULE: ./node_modules/@mui/material/Paper/Paper.js + 2 modules
var Paper = __webpack_require__(64680);
// EXTERNAL MODULE: ./node_modules/@mui/material/Button/Button.js + 1 modules
var Button = __webpack_require__(72642);
// EXTERNAL MODULE: ./node_modules/@mui/material/ListItem/ListItem.js + 2 modules
var ListItem = __webpack_require__(65965);
// EXTERNAL MODULE: ./node_modules/@mui/material/ListItemText/ListItemText.js
var ListItemText = __webpack_require__(59334);
// EXTERNAL MODULE: ./node_modules/@mui/material/List/List.js + 1 modules
var List = __webpack_require__(42440);
// EXTERNAL MODULE: ./node_modules/@mui/material/Tooltip/Tooltip.js + 1 modules
var Tooltip_Tooltip = __webpack_require__(14563);
// EXTERNAL MODULE: ./node_modules/@mui/material/Dialog/Dialog.js + 1 modules
var Dialog = __webpack_require__(3838);
// EXTERNAL MODULE: ./node_modules/@mui/material/DialogTitle/DialogTitle.js
var DialogTitle = __webpack_require__(37645);
// EXTERNAL MODULE: ./node_modules/@mui/material/DialogContent/DialogContent.js + 1 modules
var DialogContent = __webpack_require__(77750);
// EXTERNAL MODULE: ./node_modules/@mui/material/DialogActions/DialogActions.js + 1 modules
var DialogActions = __webpack_require__(88979);
// EXTERNAL MODULE: ./node_modules/@mui/material/IconButton/IconButton.js + 1 modules
var IconButton = __webpack_require__(6867);
// EXTERNAL MODULE: ./node_modules/@mui/material/Checkbox/Checkbox.js + 4 modules
var Checkbox = __webpack_require__(14212);
// EXTERNAL MODULE: ./node_modules/@mui/material/Avatar/Avatar.js + 2 modules
var Avatar = __webpack_require__(67109);
;// CONCATENATED MODULE: ./src/ui/atoms/Avatar.tsx
function Avatar_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function Avatar_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            Avatar_define_property(target, key, source[key]);
        });
    }
    return target;
}



const avatarStyles = (0,css/* css */.iv)({
    display: "flex",
    color: "#43A7EA",
    fontSize: 16,
    fontWeight: 500,
    background: "#EEEEEE"
});
const getUserInitials = (firstName, lastName, name)=>{
    if (firstName && lastName) {
        return firstName[0].toUpperCase() + lastName[0].toUpperCase();
    }
    if (name) {
        const nameSplitted = name.split(" ");
        return nameSplitted.length === 1 ? nameSplitted[0].slice(0, 2).toUpperCase() : nameSplitted[0][0].toUpperCase() + nameSplitted[nameSplitted.length - 1][0].toUpperCase();
    }
    return null;
};
const Avatar_Avatar = ({ className , url , firstName , lastName , name , size =38 , style  })=>{
    return /*#__PURE__*/ react.createElement(Avatar/* default */.Z, {
        variant: "circular",
        imgProps: {
            src: url,
            sizes: "20px 20px"
        },
        style: Avatar_object_spread({
            width: size,
            height: size
        }, style),
        className: avatarStyles({
            className
        }).className
    }, !url ? getUserInitials(firstName, lastName, name) : null);
};
Avatar_Avatar.displayName = "Avatar";

;// CONCATENATED MODULE: ./src/ui/atoms/index.ts



































// Re-exporting selectively as there are naming collisions with local component




/***/ }),

/***/ 93461:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "F4": () => (/* binding */ keyframes),
/* harmony export */   "iv": () => (/* binding */ css),
/* harmony export */   "zo": () => (/* binding */ styled)
/* harmony export */ });
/* unused harmony exports theme, config, getCssText */
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(94184);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _stitches_react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(86744);
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}


const t =  false ? 0 : null;
const stitchesCss = (0,_stitches_react__WEBPACK_IMPORTED_MODULE_1__/* .createStitches */ .Th)(_object_spread_props(_object_spread({}, t), {
    theme: {
        colors: {},
        space: {}
    },
    utils: {
        paddingX: (v)=>({
                paddingLeft: v,
                paddingRight: v
            }),
        paddingY: (value)=>({
                paddingTop: value,
                paddingBottom: value
            }),
        marginX: (value)=>({
                marginLeft: value,
                marginRight: value
            }),
        marginY: (value)=>({
                marginTop: value,
                marginBottom: value
            }),
        centerContent: (should)=>should ? {
                display: "flex",
                placeContent: "center",
                placeItems: "center"
            } : {},
        truncate: (type)=>({
                overflow: "hidden",
                textOverflow: type,
                whiteSpace: "nowrap"
            }),
        noOfLines: (n)=>({
                "display": "-webkit-box",
                "-webkit-box-orient": "vertical",
                "-webkit-line-clamp": n,
                "overflow": "hidden"
            })
    }
}));
const { styled , css , theme , config , getCssText , keyframes  } = stitchesCss;



/***/ }),

/***/ 17218:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "UQ": () => (/* reexport */ atoms/* Accordion */.UQ),
  "rN": () => (/* reexport */ atoms/* AccordionDetails */.rN),
  "_O": () => (/* reexport */ atoms/* AccordionSummary */._O),
  "Z9": () => (/* reexport */ atoms/* AlertState */.Z9),
  "oZ": () => (/* reexport */ atoms/* AppFavIcon */.oZ),
  "e0": () => (/* reexport */ atoms/* ArrowIcon */.e0),
  "qE": () => (/* reexport */ atoms/* Avatar */.qE),
  "xu": () => (/* reexport */ atoms/* Box */.xu),
  "zx": () => (/* reexport */ atoms/* Button */.zx),
  "Zb": () => (/* reexport */ Card),
  "T$": () => (/* reexport */ CardActions),
  "XZ": () => (/* reexport */ atoms/* Checkbox */.XZ),
  "Af": () => (/* reexport */ atoms/* Chip */.Af),
  "TX": () => (/* reexport */ ConfirmDelete),
  "Sc": () => (/* reexport */ ConfirmDeletePure),
  "QH": () => (/* reexport */ ConfirmDialog),
  "Ei": () => (/* reexport */ atoms/* CopyTextToClipboard */.Ei),
  "Vq": () => (/* reexport */ atoms/* Dialog */.Vq),
  "kX": () => (/* reexport */ atoms/* DialogActions */.kX),
  "cZ": () => (/* reexport */ atoms/* DialogContent */.cZ),
  "$N": () => (/* reexport */ atoms/* DialogTitle */.$N),
  "x9": () => (/* reexport */ atoms/* Disabled */.x9),
  "iz": () => (/* reexport */ atoms/* Divider */.iz),
  "ZC": () => (/* reexport */ atoms/* DividerWithText */.ZC),
  "et": () => (/* reexport */ atoms/* DomainFavIcon */.et),
  "SV": () => (/* reexport */ atoms/* ErrorBoundary */.SV),
  "Te": () => (/* reexport */ atoms/* ErrorState */.Te),
  "Vx": () => (/* reexport */ ErrorWrapper),
  "Qq": () => (/* reexport */ atoms/* ExpandIcon */.Qq),
  "yl": () => (/* reexport */ ExpandIconButton),
  "zj": () => (/* reexport */ ExpanderPure),
  "p0": () => (/* reexport */ FileUpload),
  "GH": () => (/* reexport */ atoms/* FilterChip */.GH),
  "mt": () => (/* reexport */ TruncateFilters/* FilterLabel */.mt),
  "J1": () => (/* reexport */ FormErrorMessage),
  "cg": () => (/* reexport */ atoms/* HDivider */.cg),
  "Ug": () => (/* reexport */ atoms/* HStack */.Ug),
  "hU": () => (/* reexport */ atoms/* IconButton */.hU),
  "Df": () => (/* reexport */ InlineEditField),
  "GS": () => (/* reexport */ atoms/* LayoutLoader */.GS),
  "uk": () => (/* reexport */ atoms/* LinearProgress */.uk),
  "rU": () => (/* reexport */ atoms/* Link */.rU),
  "aV": () => (/* reexport */ atoms/* List */.aV),
  "HC": () => (/* reexport */ atoms/* ListItem */.HC),
  "F_": () => (/* reexport */ atoms/* ListItemText */.F_),
  "aN": () => (/* reexport */ atoms/* Loader */.aN),
  "fl": () => (/* reexport */ atoms/* LoadingButton */.fl),
  "Gu": () => (/* reexport */ atoms/* LoadingState */.Gu),
  "Ub": () => (/* reexport */ atoms/* NestedMenuItem */.Ub),
  "Pm": () => (/* reexport */ atoms/* NoDataState */.Pm),
  "eO": () => (/* reexport */ atoms/* NoItemsFullpage */.eO),
  "jC": () => (/* reexport */ atoms/* Note */.jC),
  "vx": () => (/* reexport */ OpenModalButton),
  "wm": () => (/* reexport */ atoms/* PageProgress */.wm),
  "PI": () => (/* reexport */ PageTemplate),
  "Xk": () => (/* reexport */ atoms/* Paper */.Xk),
  "J2": () => (/* reexport */ atoms/* Popover */.J2),
  "q": () => (/* reexport */ atoms/* Preload */.q),
  "Mj": () => (/* reexport */ SearchInput),
  "hd": () => (/* reexport */ SearchInputV2),
  "U9": () => (/* reexport */ SensitivityBars),
  "v3": () => (/* reexport */ atoms/* ShowOnHover */.v3),
  "Od": () => (/* reexport */ Skeleton/* default */.Z),
  "cR": () => (/* reexport */ atoms/* StackSpacer */.cR),
  "OK": () => (/* reexport */ Tab),
  "s4": () => (/* reexport */ TableTemplate/* TablePageTemplate */.s),
  "Tt": () => (/* reexport */ TableTemplate/* TableTemplate */.T),
  "mQ": () => (/* reexport */ Tabs),
  "xv": () => (/* reexport */ atoms/* Text */.xv),
  "nv": () => (/* reexport */ atoms/* TextField */.nv),
  "Nl": () => (/* reexport */ atoms/* TextFieldInput */.Nl),
  "CO": () => (/* reexport */ atoms/* ToggleButton */.CO),
  "th": () => (/* reexport */ atoms/* ToggleButtonGroup */.th),
  "u": () => (/* reexport */ atoms/* Tooltip */.u),
  "ZT": () => (/* reexport */ atoms/* Typography */.ZT),
  "y3": () => (/* reexport */ atoms/* UIButton */.y3),
  "Vv": () => (/* reexport */ atoms/* UpdateSince */.Vv),
  "gC": () => (/* reexport */ atoms/* VStack */.gC),
  "O9": () => (/* reexport */ theme/* colors */.O9),
  "Fc": () => (/* reexport */ atoms/* containerStyles */.Fc),
  "Hy": () => (/* reexport */ atoms/* mapErrorOnly */.Hy),
  "jM": () => (/* reexport */ atoms/* mapProps */.jM),
  "z_": () => (/* reexport */ atoms/* onCopySuccess */.z_),
  "Ih": () => (/* reexport */ theme/* setupCssVars */.Ih),
  "Dh": () => (/* reexport */ vars/* space */.Dh),
  "rS": () => (/* reexport */ theme/* theme */.rS),
  "xq": () => (/* reexport */ useFormDialog)
});

// UNUSED EXPORTS: Alert, AnimatedChip, AsyncButton, BoxInternal, CircleBullet, CircleSizes, CircleTypes, ColorPickerPopover, ConfirmDialogMessages, CopyTooltip, DashboardSidepanel, DialogContentText, DisabledStyles, Expander, Experimental_CssVarsProvider, FitTab, ModalForm, NoItemsView, StyledEngineProvider, Switch, THEME_ID, ThemeProvider, ToggleButtonGroupField, TruncateFilters, ZStack, adaptV4Theme, alpha, createMuiTheme, createStyles, createTheme, css, darken, decomposeColor, duration, easing, emphasize, experimentalStyled, experimental_extendTheme, experimental_sx, getContrastRatio, getErrorLabel, getInitColorSchemeScript, getLuminance, getOverlayAlpha, getUserInitials, hexToRgb, hslToRgb, keyframes, lighten, loaderCenterStyles, makeStyles, mapError, private_createTypography, private_excludeVariablesFromRoot, recomposeColor, responsiveFontSizes, rgbToHex, shouldSkipGeneratingVar, styled, themeV5Obj, unstable_createMuiStrictModeTheme, unstable_getUnit, unstable_toUnitless, useColorScheme, useTheme, useThemeProps, withStyles, withTheme

// EXTERNAL MODULE: ./src/ui/css/index.ts
var css = __webpack_require__(93461);
;// CONCATENATED MODULE: ./src/ui/templates/PageTemplate.tsx

const PageTemplate = (0,css/* styled */.zo)("div", {
    padding: "0px 0px 0px 24px",
    minHeight: "100%",
    height: "100%",
    boxSizing: "border-box",
    overflow: "hidden"
});

// EXTERNAL MODULE: ./src/ui/templates/TableTemplate.tsx
var TableTemplate = __webpack_require__(28512);
;// CONCATENATED MODULE: ./src/ui/templates/index.ts



// EXTERNAL MODULE: ./src/ui/theme.ts
var theme = __webpack_require__(73728);
// EXTERNAL MODULE: ./src/ui/atoms/index.ts + 36 modules
var atoms = __webpack_require__(1582);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@mui/material/FormControlLabel/FormControlLabel.js + 1 modules
var FormControlLabel = __webpack_require__(50542);
// EXTERNAL MODULE: ./src/modules/notification/index.ts + 3 modules
var notification = __webpack_require__(5769);
// EXTERNAL MODULE: ./src/ui/messages.ts
var messages = __webpack_require__(16239);
;// CONCATENATED MODULE: ./src/ui/molecules/FileUpload/FileUpload.tsx
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}




class FileUpload extends react.Component {
    render() {
        const { accept , children , multiple , className  } = this.props;
        return /*#__PURE__*/ react.createElement(FormControlLabel/* default */.Z, {
            className: className,
            style: {
                marginRight: 0
            },
            control: /*#__PURE__*/ react.createElement("input", {
                multiple: multiple,
                style: {
                    display: "none"
                },
                type: "file",
                accept: accept,
                onChange: this.onChange,
                ref: this.$input
            }),
            label: children
        });
    }
    constructor(...args){
        super(...args);
        _define_property(this, "$input", /*#__PURE__*/ react.createRef());
        _define_property(this, "onChange", (event)=>{
            const { accept , type  } = this.props;
            const { files  } = event.target;
            const fileList = Array.from(files || []);
            const isAccepted = fileList.every((file)=>this.props.accept.includes(file.type));
            if (!isAccepted) {
                notification/* notification.error */.t6.error({
                    message: messages/* messages.fileUpload.warningMessage */.s.fileUpload.warningMessage(type || accept)
                });
                return;
            }
            this.props.onChange(fileList);
            this.$input.current.value = "";
        });
    }
}
_define_property(FileUpload, "defaultProps", {
    accept: "image/*",
    multiple: false
});

;// CONCATENATED MODULE: ./src/ui/molecules/FileUpload/index.tsx


// EXTERNAL MODULE: ./node_modules/lodash-es/debounce.js + 1 modules
var debounce = __webpack_require__(99111);
// EXTERNAL MODULE: ./node_modules/@mui/material/TextField/TextField.js + 1 modules
var TextField = __webpack_require__(94659);
// EXTERNAL MODULE: ./node_modules/@mui/material/InputAdornment/InputAdornment.js + 1 modules
var InputAdornment = __webpack_require__(80270);
// EXTERNAL MODULE: ./node_modules/@mui/icons-material/Clear.js
var Clear = __webpack_require__(63343);
// EXTERNAL MODULE: ./node_modules/@mui/icons-material/Search.js
var Search = __webpack_require__(42761);
// EXTERNAL MODULE: ./node_modules/@mui/material/colors/grey.js
var grey = __webpack_require__(47036);
;// CONCATENATED MODULE: ./src/ui/molecules/SearchInput.tsx
function SearchInput_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            SearchInput_define_property(target, key, source[key]);
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}








const INPUT_DEBOUNCE = 1000;
const IconClassname = (value)=>(0,css/* css */.iv)({
        color: grey/* default.600 */.Z[600],
        opacity: value ? 1 : 0,
        cursor: "pointer",
        transition: "all 0.5s ease-in"
    });
const searchStyles = (0,css/* css */.iv)({
    "&.Mui-focused": {
        borderColor: "#47A7EA",
        borderWidth: 2,
        background: "white"
    },
    ".MuiInputBase-input": {
        paddingTop: 12,
        paddingBottom: 12
    },
    "&:hover": {
        ".MuiOutlinedInput-notchedOutline": {
            borderColor: "#47A7EA"
        }
    },
    "fieldset": {
        "borderWidth": 1,
        "borderColor": "transparent",
        "&::before": {
            display: "none"
        }
    }
});
function SearchInput(props) {
    const { // eslint-disable-next-line @typescript-eslint/no-unused-vars
    showCancel , initialValue ="" , label , onRequestSearch , onCancel , // eslint-disable-next-line @typescript-eslint/no-unused-vars
    onBlur , className , placeholder =null , inputProps  } = props, rest = _object_without_properties(props, [
        "showCancel",
        "initialValue",
        "label",
        "onRequestSearch",
        "onCancel",
        "onBlur",
        "className",
        "placeholder",
        "inputProps"
    ]);
    const [value, updateValue] = (0,react.useState)(initialValue);
    const handleKeyUp = (e)=>{
        if (e.charCode === 13 || e.key === "Enter") {
            onRequestSearch(value);
        }
    };
    const debouncedUpdate = (0,react.useMemo)(()=>(0,debounce["default"])(onRequestSearch, INPUT_DEBOUNCE), [
        onRequestSearch
    ]);
    const onChange = (e)=>{
        const v = e.target.value || "";
        updateValue(v);
        debouncedUpdate(v);
    };
    (0,react.useLayoutEffect)(()=>{
        updateValue(initialValue);
    }, [
        initialValue
    ]);
    const handleCancel = ()=>{
        debouncedUpdate.cancel();
        updateValue("");
        onCancel && onCancel("");
    };
    return /*#__PURE__*/ react.createElement(TextField/* default */.Z, _object_spread({
        label: label,
        value: value,
        placeholder: placeholder,
        className: searchStyles({
            className
        }).className,
        onChange: onChange,
        id: "search",
        autoComplete: "off",
        onKeyUp: handleKeyUp,
        fullWidth: true,
        margin: "dense",
        variant: "standard",
        InputProps: _object_spread({
            startAdornment: /*#__PURE__*/ react.createElement(InputAdornment/* default */.Z, {
                position: "start"
            }, /*#__PURE__*/ react.createElement(Search/* default */.Z, {
                style: {
                    color: grey/* default.600 */.Z[600]
                }
            })),
            endAdornment: /*#__PURE__*/ react.createElement(InputAdornment/* default */.Z, {
                onClick: handleCancel,
                position: "end"
            }, /*#__PURE__*/ react.createElement(Clear/* default */.Z, {
                className: IconClassname(value)().className
            }))
        }, inputProps)
    }, rest));
}
SearchInput.defaultProps = {
    placeholder: messages/* messages.searchInput.placeholder */.s.searchInput.placeholder
};

// EXTERNAL MODULE: ./node_modules/@mui/material/Button/Button.js + 1 modules
var Button = __webpack_require__(72642);
// EXTERNAL MODULE: ./node_modules/@mui/material/Fab/Fab.js + 1 modules
var Fab = __webpack_require__(11781);
// EXTERNAL MODULE: ./node_modules/react-final-form/dist/react-final-form.es.js
var react_final_form_es = __webpack_require__(66688);
// EXTERNAL MODULE: ./node_modules/final-form/dist/final-form.es.js
var final_form_es = __webpack_require__(95142);
// EXTERNAL MODULE: ./node_modules/@mui/material/FormHelperText/FormHelperText.js + 1 modules
var FormHelperText = __webpack_require__(3460);
;// CONCATENATED MODULE: ./src/api/user-management/error-formatter.ts
function error_formatter_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function error_formatter_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            error_formatter_define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function formatAPIError(errors) {
    if (!Array.isArray(errors)) {
        return (errors === null || errors === void 0 ? void 0 : errors.message) || (errors === null || errors === void 0 ? void 0 : errors.error);
    }
    return errors.reduce((acc, error)=>{
        return _object_spread_props(error_formatter_object_spread({}, acc), {
            [error.property]: Object.values(error.constraints)
        });
    }, {});
}

// EXTERNAL MODULE: ./src/libs/api/fetch-gql.ts
var fetch_gql = __webpack_require__(62006);
// EXTERNAL MODULE: ./src/shared/testConstants.ts + 1 modules
var testConstants = __webpack_require__(81202);
// EXTERNAL MODULE: ./node_modules/@mui/material/Dialog/Dialog.js + 1 modules
var Dialog = __webpack_require__(3838);
// EXTERNAL MODULE: ./node_modules/@mui/material/DialogTitle/DialogTitle.js
var DialogTitle = __webpack_require__(37645);
// EXTERNAL MODULE: ./node_modules/@mui/material/Typography/Typography.js + 1 modules
var Typography = __webpack_require__(2658);
// EXTERNAL MODULE: ./node_modules/@mui/material/DialogContent/DialogContent.js + 1 modules
var DialogContent = __webpack_require__(77750);
// EXTERNAL MODULE: ./node_modules/@mui/material/DialogActions/DialogActions.js + 1 modules
var DialogActions = __webpack_require__(88979);
// EXTERNAL MODULE: ./src/modules/analytics/Analytics.ts
var Analytics = __webpack_require__(95520);
;// CONCATENATED MODULE: ./src/ui/molecules/OpenModalButton/Modal.tsx
function Modal_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}






var _React_Component;
class ModalPure extends (_React_Component = react.Component) {
    render() {
        const { title , isOpen , onClose , onSubmit , submitText , disableSubmit , hideCancel , children , maxWidth , form  } = this.props;
        const { submitting  } = form.getState();
        return /*#__PURE__*/ react.createElement(Dialog/* default */.Z, {
            fullWidth: true,
            maxWidth: maxWidth,
            open: isOpen,
            onClose: onClose,
            disableEscapeKeyDown: submitting,
            disableEnforceFocus: (0,Analytics/* isThirdPartyEditMode */.q_)(),
            onKeyDown: (e)=>{
                e.stopPropagation();
            }
        }, /*#__PURE__*/ react.createElement(DialogTitle/* default */.Z, null, /*#__PURE__*/ react.createElement(Typography/* default */.Z, {
            variant: "h5"
        }, title)), /*#__PURE__*/ react.createElement(DialogContent/* default */.Z, null, children), /*#__PURE__*/ react.createElement(DialogActions/* default */.Z, null, !hideCancel && /*#__PURE__*/ react.createElement(Button/* default */.Z, {
            onClick: onClose,
            disabled: submitting
        }, "Cancel"), /*#__PURE__*/ react.createElement(Button/* default */.Z, {
            type: "submit",
            onClick: onSubmit,
            disabled: submitting || disableSubmit,
            "data-testid": testConstants/* modalFormSelectors.Submit */.QX.Submit,
            color: "primary",
            variant: "contained"
        }, /*#__PURE__*/ react.createElement(atoms/* Loader */.aN, {
            size: 20,
            loading: submitting
        }, submitText))));
    }
}
Modal_define_property(ModalPure, "defaultProps", {
    submitText: messages/* messages.openModalButton.submitText */.s.openModalButton.submitText,
    maxWidth: "md"
});

;// CONCATENATED MODULE: ./src/ui/molecules/OpenModalButton/ModalForm.tsx
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function ModalForm_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function ModalForm_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            ModalForm_define_property(target, key, source[key]);
        });
    }
    return target;
}
function ModalForm_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function ModalForm_object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ModalForm_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}







const onSubmit = (onSubmitFn)=>{
    return function() {
        var _ref = _async_to_generator(function*(values, formApi) {
            try {
                const errors = yield onSubmitFn(values, formApi);
                return errors;
            } catch (error) {
                var _error_response;
                if (error instanceof fetch_gql/* GraphqlError */.Q) {
                    return {
                        [final_form_es/* FORM_ERROR */.Ck]: error.errors[0].message
                    };
                }
                return formatAPIError((_error_response = error.response) === null || _error_response === void 0 ? void 0 : _error_response.data);
            }
        });
        return function(values, formApi) {
            return _ref.apply(this, arguments);
        };
    }();
};
const ModalForm = (props)=>{
    /*#__PURE__*/ return react.createElement(react_final_form_es/* Form */.l0, ModalForm_object_spread_props(ModalForm_object_spread({}, props), {
        onSubmit: onSubmit(props.onSubmit),
        render: (formProps)=>{
            const { submitErrors  } = formProps.form.getState();
            return /*#__PURE__*/ react.createElement(ModalPure, ModalForm_object_spread_props(ModalForm_object_spread({}, formProps), {
                onSubmit: formProps.form.submit,
                onClose: ()=>{
                    var _props_onClose;
                    formProps.form.reset();
                    (_props_onClose = props.onClose) === null || _props_onClose === void 0 ? void 0 : _props_onClose.call(props);
                }
            }), /*#__PURE__*/ react.createElement("form", {
                onSubmit: formProps.handleSubmit
            }, typeof submitErrors === "string" && /*#__PURE__*/ react.createElement(FormHelperText/* default */.Z, {
                error: true
            }, submitErrors), props.children, /*#__PURE__*/ react.createElement("input", {
                type: "submit",
                hidden: true
            })));
        }
    }));
};

;// CONCATENATED MODULE: ./src/ui/molecules/OpenModalButton/OpenModalButton.tsx
function OpenModalButton_asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function OpenModalButton_async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                OpenModalButton_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                OpenModalButton_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function OpenModalButton_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function OpenModalButton_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            OpenModalButton_define_property(target, key, source[key]);
        });
    }
    return target;
}
function OpenModalButton_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function OpenModalButton_object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        OpenModalButton_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function OpenModalButton_object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = OpenModalButton_object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function OpenModalButton_object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}




var OpenModalButton_React_Component;
/**
 * @deprecated This component  should not be used
 */ class OpenModalButton extends (OpenModalButton_React_Component = react.Component) {
    componentDidMount() {
        this._isMounted = true;
    }
    componentWillUnmount() {
        this._isMounted = false;
    }
    render() {
        const _this_props = this.props, { ButtonComponent , children , label , modalProps , variant  } = _this_props, rest = OpenModalButton_object_without_properties(_this_props, [
            "ButtonComponent",
            "children",
            "label",
            "modalProps",
            "variant"
        ]);
        let button = /*#__PURE__*/ react.createElement(ButtonComponent, OpenModalButton_object_spread({
            variant: variant,
            color: "primary",
            size: "small",
            onClick: this.open
        }, rest), label);
        if (variant === "fab") {
            button = /*#__PURE__*/ react.createElement(Fab/* default */.Z, OpenModalButton_object_spread({
                color: "primary",
                size: "small",
                onClick: this.open
            }, rest), label);
        }
        return /*#__PURE__*/ react.createElement(react.Fragment, null, button, /*#__PURE__*/ react.createElement(ModalForm, OpenModalButton_object_spread_props(OpenModalButton_object_spread({}, modalProps), {
            onSubmit: this.onSubmit,
            isOpen: this.state.isOpen,
            onClose: this.close
        }), children));
    }
    constructor(...args){
        super(...args);
        OpenModalButton_define_property(this, "state", {
            isOpen: false
        });
        OpenModalButton_define_property(this, "_isMounted", false);
        OpenModalButton_define_property(this, "open", ()=>this.setState({
                isOpen: true
            }));
        OpenModalButton_define_property(this, "close", ()=>this.setState({
                isOpen: false
            }));
        var _this = this;
        OpenModalButton_define_property(this, "onSubmit", function() {
            var _ref = OpenModalButton_async_to_generator(function*(values, modalApi) {
                let errors = undefined;
                if (_this.props.modalProps.onSubmit) {
                    errors = yield _this.props.modalProps.onSubmit(values, modalApi);
                }
                if (!errors && _this._isMounted) {
                    _this.close();
                }
                return errors;
            });
            return function(values, modalApi) {
                return _ref.apply(this, arguments);
            };
        }());
    }
}
OpenModalButton_define_property(OpenModalButton, "defaultProps", {
    ButtonComponent: Button/* default */.Z
});

;// CONCATENATED MODULE: ./src/ui/molecules/OpenModalButton/index.ts



// EXTERNAL MODULE: ./node_modules/@mui/icons-material/esm/ExpandLess.js
var ExpandLess = __webpack_require__(91680);
// EXTERNAL MODULE: ./node_modules/@mui/icons-material/esm/ExpandMore.js
var ExpandMore = __webpack_require__(6571);
// EXTERNAL MODULE: ./node_modules/@mui/material/ListSubheader/ListSubheader.js + 1 modules
var ListSubheader = __webpack_require__(48277);
// EXTERNAL MODULE: ./node_modules/@mui/material/List/List.js + 1 modules
var List = __webpack_require__(42440);
// EXTERNAL MODULE: ./src/ui/vars.tsx
var vars = __webpack_require__(29400);
;// CONCATENATED MODULE: ./src/ui/molecules/Expander.tsx
function Expander_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function Expander_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            Expander_define_property(target, key, source[key]);
        });
    }
    return target;
}
function Expander_object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = Expander_object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function Expander_object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}





const StyledListSubheader = (0,css/* styled */.zo)(ListSubheader/* default */.Z, {
    display: "flex",
    alignItems: "center",
    background: "white",
    paddingTop: vars/* space.1 */.Dh[1],
    paddingBottom: vars/* space.1 */.Dh[1]
});
const ExpandIconButton = ({ expanded , onClick , className  })=>{
    return /*#__PURE__*/ react.createElement("span", {
        className: className,
        role: "button",
        "aria-label": "Expand",
        style: {
            cursor: "pointer"
        },
        onClick: onClick
    }, expanded ? /*#__PURE__*/ react.createElement(ExpandLess/* default */.Z, {
        color: "action"
    }) : /*#__PURE__*/ react.createElement(ExpandMore/* default */.Z, {
        color: "action"
    }));
};
const expanderIconClassName = (0,css/* css */.iv)({
    position: "absolute",
    top: "-2px",
    right: "-22px"
});
const ExpanderPure = (_param)=>{
    var { isExpanded , onExpand , children , title  } = _param, subHeaderProps = Expander_object_without_properties(_param, [
        "isExpanded",
        "onExpand",
        "children",
        "title"
    ]);
    const expander = /*#__PURE__*/ react.createElement(ExpandIconButton, {
        className: expanderIconClassName().className,
        expanded: isExpanded,
        onClick: ()=>{
            onExpand();
        }
    });
    return /*#__PURE__*/ react.createElement(List/* default */.Z, {
        style: {
            padding: 0
        },
        dense: true,
        disablePadding: true,
        role: "treeitem"
    }, /*#__PURE__*/ react.createElement(StyledListSubheader, Expander_object_spread({
        "aria-label": "Tree item header"
    }, subHeaderProps), /*#__PURE__*/ react.createElement(Typography/* default */.Z, {
        style: {
            position: "relative",
            fontSize: 13
        },
        variant: "subtitle2"
    }, /*#__PURE__*/ react.createElement("span", {
        style: {
            paddingRight: 6
        }
    }, title), " ", expander)), isExpanded && children);
};
const Expander = (_param)=>{
    var { children  } = _param, rest = Expander_object_without_properties(_param, [
        "children"
    ]);
    const [expanded, setExpanded] = useState(false);
    const toggle = ()=>setExpanded((expanded)=>!expanded);
    return /*#__PURE__*/ React.createElement(ExpanderPure, Expander_object_spread({
        onExpand: toggle,
        isExpanded: expanded
    }, rest), children);
};

// EXTERNAL MODULE: ./src/libs/layouts/index.tsx + 2 modules
var layouts = __webpack_require__(5855);
;// CONCATENATED MODULE: ./src/ui/molecules/Card.tsx
function Card_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function Card_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            Card_define_property(target, key, source[key]);
        });
    }
    return target;
}
function Card_object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = Card_object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function Card_object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}



function Card(_param) {
    var { space =3 , children  } = _param, rest = Card_object_without_properties(_param, [
        "space",
        "children"
    ]);
    return(// @ts-ignore
    /*#__PURE__*/ react.createElement(layouts/* Stack */.Kq, Card_object_spread({
        sx: {
            paddingX: vars/* space */.Dh[space + 1],
            paddingY: vars/* space */.Dh[space]
        },
        as: "div",
        space: space
    }, rest), children));
}
function CardActions({ space =3 , children , secondary  }) {
    return /*#__PURE__*/ react.createElement(layouts/* HStack */.Ug, {
        space: space
    }, secondary, /*#__PURE__*/ react.createElement(layouts/* HStack.Spacer */.Ug.Spacer, null), children);
}

// EXTERNAL MODULE: ./node_modules/classnames/index.js
var node_modules_classnames = __webpack_require__(94184);
// EXTERNAL MODULE: ./node_modules/@mui/material/Tabs/Tabs.js + 5 modules
var Tabs_Tabs = __webpack_require__(50395);
// EXTERNAL MODULE: ./node_modules/@mui/material/Tab/Tab.js + 1 modules
var Tab_Tab = __webpack_require__(62640);
;// CONCATENATED MODULE: ./src/ui/molecules/Tabs.tsx
function Tabs_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function Tabs_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            Tabs_define_property(target, key, source[key]);
        });
    }
    return target;
}
function Tabs_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function Tabs_object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        Tabs_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}





const styles = {
    root: (0,css/* css */.iv)({
        "width": "fit-content",
        "background": "#f8f9fb",
        "borderRadius": "3px",
        "--tab-min-height": "30px",
        "minHeight": "var(--tab-min-height)",
        "--tabs-focus-outline-size": "4px"
    }),
    tab: (0,css/* css */.iv)({
        zIndex: 1,
        minHeight: "var(--tab-min-height)",
        textTransform: "capitalize",
        fontWeight: 400
    }),
    fittab: (0,css/* css */.iv)({
        minWidth: "0 !important"
    }),
    flexContainer: (0,css/* css */.iv)({
        paddingLeft: "var(--tabs-focus-outline-size)",
        paddingRight: "var(--tabs-focus-outline-size)"
    }),
    indicator: (0,css/* css */.iv)({
        height: "calc(100% - var(--tabs-focus-outline-size) * 2)",
        background: "#dde5eb",
        pointerEvents: "none",
        marginTop: "var(--tabs-focus-outline-size)",
        marginBottom: "var(--tabs-focus-outline-size)",
        borderRadius: "3px",
        minWidth: "20px"
    })
};
// TODO use proper way of defining how to hide type if less than 1 element is present
const Tabs = /*#__PURE__*/ react.forwardRef(function Tabs(props, ref) {
    if (react.Children.count(props.children) === 0) {
        return /*#__PURE__*/ react.createElement("div", null);
    }
    if (props.hidden && react.Children.count(props.children) <= 1) {
        return /*#__PURE__*/ react.createElement("div", null);
    }
    return /*#__PURE__*/ react.createElement(Tabs_Tabs/* default */.Z, Tabs_object_spread_props(Tabs_object_spread({
        ref: ref
    }, props), {
        classes: Tabs_object_spread_props(Tabs_object_spread({}, props.classes), {
            indicator: styles.indicator().className,
            flexContainer: styles.flexContainer().className
        }),
        className: styles.root({
            className: props.className
        }).className
    }));
});
const Tab = function Tab(props) {
    return /*#__PURE__*/ react.createElement(Tab_Tab/* default */.Z, Tabs_object_spread_props(Tabs_object_spread({}, props), {
        className: styles.tab({
            className: props.className
        }).className
    }));
};
const FitTab = function Tab(props) {
    return /*#__PURE__*/ React.createElement(MTab, Tabs_object_spread_props(Tabs_object_spread({}, props), {
        className: classnames(props.className, styles.tab().className, styles.fittab().className)
    }));
};

// EXTERNAL MODULE: ./node_modules/@mui/material/OutlinedInput/OutlinedInput.js + 1 modules
var OutlinedInput = __webpack_require__(32580);
;// CONCATENATED MODULE: ./src/ui/molecules/SearchInputV2.tsx
function SearchInputV2_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function SearchInputV2_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            SearchInputV2_define_property(target, key, source[key]);
        });
    }
    return target;
}
function SearchInputV2_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function SearchInputV2_object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        SearchInputV2_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function SearchInputV2_object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = SearchInputV2_object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function SearchInputV2_object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}






const rootStyles = (0,css/* css */.iv)({
    fieldset: {
        "borderWidth": 1,
        "borderColor": "transparent",
        "&::before": {
            display: "none"
        }
    },
    input: {
        paddingLeft: 0
    }
});
const SearchInputV2 = /*#__PURE__*/ react.forwardRef(function SearchInputV2(_param, ref) {
    var { size , onChange , onCancel  } = _param, props = SearchInputV2_object_without_properties(_param, [
        "size",
        "onChange",
        "onCancel"
    ]);
    return /*#__PURE__*/ react.createElement(OutlinedInput/* default */.Z, SearchInputV2_object_spread_props(SearchInputV2_object_spread({
        ref: ref
    }, props), {
        fullWidth: true,
        autoFocus: true,
        onKeyDown: (e)=>{
            if (e.key === "Escape") {
                onCancel === null || onCancel === void 0 ? void 0 : onCancel("escape");
            }
        },
        startAdornment: /*#__PURE__*/ react.createElement(InputAdornment/* default */.Z, {
            position: "start"
        }, /*#__PURE__*/ react.createElement(Search/* default */.Z, {
            fontSize: size,
            color: "action"
        })),
        endAdornment: onCancel ? /*#__PURE__*/ react.createElement(InputAdornment/* default */.Z, {
            style: {
                cursor: "pointer"
            },
            onClick: ()=>onCancel("cancel"),
            position: "end"
        }, /*#__PURE__*/ react.createElement(Clear/* default */.Z, {
            fontSize: size,
            color: "action"
        })) : null,
        classes: SearchInputV2_object_spread({
            root: rootStyles().className
        }, props.classes),
        style: SearchInputV2_object_spread({
            borderRadius: vars/* radii.md */.pD.md
        }, props.style),
        onChange: (el)=>{
            const value = el.target.value;
            onChange(value);
        }
    }));
});

// EXTERNAL MODULE: ./src/ui/atoms/Box.tsx
var Box = __webpack_require__(17299);
;// CONCATENATED MODULE: ./src/ui/molecules/ConfimDelete.tsx
function ConfimDelete_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function ConfimDelete_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            ConfimDelete_define_property(target, key, source[key]);
        });
    }
    return target;
}
function ConfimDelete_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function ConfimDelete_object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ConfimDelete_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function ConfimDelete_object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = ConfimDelete_object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function ConfimDelete_object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}






const ConfirmDelete = /*#__PURE__*/ (0,react.forwardRef)(function(_param, ref) {
    var { onClick , children , confirm , cancel , message , className  } = _param, rest = ConfimDelete_object_without_properties(_param, [
        "onClick",
        "children",
        "confirm",
        "cancel",
        "message",
        "className"
    ]);
    return /*#__PURE__*/ react.createElement(ConfirmDeletePure, ConfimDelete_object_spread_props(ConfimDelete_object_spread({}, rest), {
        as: layouts/* Overlay */.aV,
        className: className,
        renderConfirm: (onClose)=>/*#__PURE__*/ react.createElement(layouts/* HStack */.Ug, {
                space: 3,
                align: "center",
                ref: ref
            }, /*#__PURE__*/ react.createElement(Typography/* default */.Z, null, message), /*#__PURE__*/ react.createElement(Button/* default */.Z, {
                onClick: onClose
            }, cancel), /*#__PURE__*/ react.createElement(Button/* default */.Z, {
                variant: "contained",
                color: "primary",
                onClick: ()=>{
                    onClose();
                    onClick();
                }
            }, confirm))
    }), children);
});
const confirmDeleteStyles = (0,css/* css */.iv)({
    background: "white",
    display: "flex",
    alignItems: "center"
});
function ConfirmDeletePure(_param) {
    var { children , className , renderConfirm  } = _param, rest = ConfimDelete_object_without_properties(_param, [
        "children",
        "className",
        "renderConfirm"
    ]);
    const [open, setOpen] = (0,react.useState)(false);
    if (!open) {
        return children(setOpen.bind(null, true));
    }
    return /*#__PURE__*/ react.createElement(Box/* Box */.x, ConfimDelete_object_spread({
        className: confirmDeleteStyles({
            className
        }).className,
        sx: {
            paddingLeft: vars/* space.2 */.Dh[2],
            paddingRight: vars/* space.2 */.Dh[2]
        }
    }, rest), renderConfirm(setOpen.bind(null, false)));
}

// EXTERNAL MODULE: ./src/ui/molecules/TruncateFilters/index.ts + 4 modules
var TruncateFilters = __webpack_require__(2699);
// EXTERNAL MODULE: ./src/libs/hooks/index.ts + 18 modules
var hooks = __webpack_require__(88289);
// EXTERNAL MODULE: ./src/libs/hooks/useOnChange2.ts
var useOnChange2 = __webpack_require__(93689);
;// CONCATENATED MODULE: ./src/ui/molecules/InlineEditField.tsx
function InlineEditField_asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function InlineEditField_async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                InlineEditField_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                InlineEditField_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}



function InlineEditField({ value , onChange , isInitialEditing =false , renderEditView , renderView  }) {
    const [isEditing, setIsEditing] = (0,react.useState)(isInitialEditing);
    const [innerValue, setInnerValue] = (0,react.useState)(value);
    const isSubmittingRef = (0,react.useRef)(false);
    const [error, setError] = (0,react.useState)(null);
    const handleChange = function() {
        var _ref = InlineEditField_async_to_generator(function*() {
            isSubmittingRef.current = true;
            setError(null);
            try {
                yield onChange(innerValue);
            } catch (e) {
                var _e_response, _e_response_data;
                isSubmittingRef.current = false;
                const error = (e === null || e === void 0 ? void 0 : (_e_response = e.response) === null || _e_response === void 0 ? void 0 : (_e_response_data = _e_response.data) === null || _e_response_data === void 0 ? void 0 : _e_response_data.error) || "Something went wrong";
                return setError(error);
            }
            isSubmittingRef.current = false;
            setIsEditing(false);
            setError(null);
        });
        return function handleChange() {
            return _ref.apply(this, arguments);
        };
    }();
    (0,hooks/* useKeyDown */.K7)("enter", /*#__PURE__*/ InlineEditField_async_to_generator(function*() {
        if (isEditing && !isSubmittingRef.current) {
            yield handleChange();
        }
    }), isEditing, innerValue);
    (0,useOnChange2/* useOnChange2 */.D)(value, ()=>setInnerValue(value));
    const edit = renderEditView({
        error: error ? String(error) : "",
        value: innerValue,
        onChange: setInnerValue,
        onBlur: handleChange
    });
    const view = renderView({
        value: innerValue,
        toggleEdit: ()=>setIsEditing((v)=>!v)
    });
    return isEditing ? edit : view;
}

// EXTERNAL MODULE: ./node_modules/react-use/lib/useAsyncFn.js
var useAsyncFn = __webpack_require__(55689);
// EXTERNAL MODULE: ./src/ui/atoms/LoadingButton.tsx
var LoadingButton = __webpack_require__(39540);
// EXTERNAL MODULE: ./src/ui/atoms/StackDivider.tsx
var StackDivider = __webpack_require__(9827);
;// CONCATENATED MODULE: ./src/ui/molecules/ConfirmDialog.tsx






const ConfirmDialogMessages = {
    cancel: "NO, CANCEL",
    confirm: "Yes, delete"
};
function ConfirmDialog({ messages =ConfirmDialogMessages , title ="CONFIRMATION" , onSubmit , onClose , children , hideDivider  }) {
    messages = Object.assign({}, ConfirmDialogMessages, messages);
    const [state, fetch] = (0,useAsyncFn/* default */.Z)(onSubmit, [
        onSubmit
    ]);
    return /*#__PURE__*/ react.createElement(Card, null, /*#__PURE__*/ react.createElement(Typography/* default */.Z, {
        variant: "h6"
    }, title), children, !hideDivider && /*#__PURE__*/ react.createElement(StackDivider/* Divider */.i, null), /*#__PURE__*/ react.createElement(CardActions, null, /*#__PURE__*/ react.createElement(Button/* default */.Z, {
        color: "primary",
        onClick: onClose,
        disabled: state.loading
    }, messages.cancel), /*#__PURE__*/ react.createElement(LoadingButton/* LoadingButton */.f, {
        isLoading: state.loading,
        onClick: fetch,
        variant: "contained",
        color: "primary"
    }, messages.confirm)));
}

;// CONCATENATED MODULE: ./src/ui/molecules/useFormDialog.tsx
function useFormDialog_asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function useFormDialog_async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                useFormDialog_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                useFormDialog_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function useFormDialog_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function useFormDialog_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            useFormDialog_define_property(target, key, source[key]);
        });
    }
    return target;
}
function useFormDialog_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function useFormDialog_object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        useFormDialog_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}






const stopPropagation = (e)=>e.stopPropagation();
const defaultErrorMap = (v)=>({
        [final_form_es/* FORM_ERROR */.Ck]: v
    });
function useFormDialog(props, Component = ConfirmDialog, config = {}) {
    var _config;
    var _mapSubmitError;
    (_mapSubmitError = (_config = config).mapSubmitError) !== null && _mapSubmitError !== void 0 ? _mapSubmitError : _config.mapSubmitError = defaultErrorMap;
    return (0,hooks/* useModal */.dd)((args)=>{
        const onSubmit = react.useCallback(function() {
            var _ref = useFormDialog_async_to_generator(function*(v) {
                try {
                    const res = yield props.onSubmit(v);
                    args.onClose();
                    return res;
                } catch (e) {
                    var _config_mapSubmitError, _e_response, _e_response_data;
                    return config === null || config === void 0 ? void 0 : (_config_mapSubmitError = config.mapSubmitError) === null || _config_mapSubmitError === void 0 ? void 0 : _config_mapSubmitError.call(config, (_e_response = e.response) === null || _e_response === void 0 ? void 0 : (_e_response_data = _e_response.data) === null || _e_response_data === void 0 ? void 0 : _e_response_data.error);
                }
            });
            return function(v) {
                return _ref.apply(this, arguments);
            };
        }(), [
            args.onClose,
            props.onSubmit
        ]);
        const onClose = react.useCallback((e)=>{
            e === null || e === void 0 ? void 0 : e.stopPropagation();
            args === null || args === void 0 ? void 0 : args.onClose();
        }, [
            args.onClose
        ]);
        const onDelete = react.useCallback(function() {
            var _ref = useFormDialog_async_to_generator(function*(v) {
                var _props_onDelete;
                yield props === null || props === void 0 ? void 0 : (_props_onDelete = props.onDelete) === null || _props_onDelete === void 0 ? void 0 : _props_onDelete.call(props, v);
                args === null || args === void 0 ? void 0 : args.onClose();
            });
            return function(v) {
                return _ref.apply(this, arguments);
            };
        }(), [
            args.onClose,
            props === null || props === void 0 ? void 0 : props.onDelete
        ]);
        return /*#__PURE__*/ react.createElement(Dialog/* default */.Z, useFormDialog_object_spread_props(useFormDialog_object_spread({}, args), {
            maxWidth: props.maxWidth || "xs",
            fullWidth: true,
            onClick: stopPropagation,
            disableEscapeKeyDown: true,
            disableEnforceFocus: (0,Analytics/* isThirdPartyEditMode */.q_)(),
            PaperProps: {
                className: props.className
            }
        }), /*#__PURE__*/ react.createElement(Component, useFormDialog_object_spread_props(useFormDialog_object_spread({}, props), {
            onSubmit: onSubmit,
            onClose: onClose,
            onDelete: (props === null || props === void 0 ? void 0 : props.onDelete) ? onDelete : undefined
        })));
    });
}

// EXTERNAL MODULE: ./src/ui/atoms/StateScreens.tsx
var StateScreens = __webpack_require__(53213);
// EXTERNAL MODULE: ./src/ui/atoms/ErrorBoundary.tsx
var ErrorBoundary = __webpack_require__(72763);
;// CONCATENATED MODULE: ./src/ui/molecules/ErrorWrapper.tsx



const ErrorWrapper = ({ children , onRefresh , isNetworkError =false , networkErrorFallback =(onRefresh)=>/*#__PURE__*/ react.createElement(StateScreens/* ErrorState */.Te, {
        text: "Network Error",
        onRefresh: onRefresh
    }) , errorBoundaryFallback =()=>/*#__PURE__*/ react.createElement(StateScreens/* ErrorState */.Te, null)  })=>{
    return isNetworkError ? networkErrorFallback(onRefresh) : /*#__PURE__*/ react.createElement(ErrorBoundary/* ErrorBoundary */.S, {
        fallback: errorBoundaryFallback()
    }, children);
};

// EXTERNAL MODULE: ./src/ui/atoms/Field/mapError.ts
var mapError = __webpack_require__(34246);
;// CONCATENATED MODULE: ./src/ui/molecules/FormErrorMessage.tsx





function FormErrorMessage({ name =final_form_es/* FORM_ERROR */.Ck , isSubmitError , style , className  }) {
    const { meta  } = (0,react_final_form_es/* useField */.U$)(name);
    const errorLabel = isSubmitError ? meta.submitError : (0,mapError/* getErrorLabel */.f0)(meta);
    return errorLabel ? /*#__PURE__*/ react.createElement(FormHelperText/* default */.Z, {
        component: "span",
        error: true,
        style: style,
        className: className
    }, typeof errorLabel === "string" ? /*#__PURE__*/ react.createElement(react.Fragment, null, errorLabel) : /*#__PURE__*/ react.createElement(react.Fragment, null, JSON.stringify(errorLabel))) : null;
}

;// CONCATENATED MODULE: ./src/ui/molecules/SensitivityBars.tsx



const sensitivityBarsStyles = (0,css/* css */.iv)({
    display: "inline-flex"
});
const SensitivityBars = ({ className , maxBars =4 , barsCount =0 , baseColor ="#EAEAEA" , fillColor ="#E03434" , barWidth =3 , barHeight =11 , spaceBetween =2  })=>{
    const bars = new Array(maxBars).fill(0);
    return /*#__PURE__*/ react.createElement(Box/* Box */.x, {
        "data-testid": "sensitivity-bars",
        className: sensitivityBarsStyles({
            className
        }).className
    }, bars.map((_, i)=>{
        const active = i < barsCount;
        return /*#__PURE__*/ react.createElement("div", {
            key: i,
            style: {
                background: active ? fillColor : baseColor,
                width: barWidth,
                marginRight: spaceBetween,
                height: barHeight
            }
        });
    }));
};

// EXTERNAL MODULE: ./src/ui/molecules/DashboardSidepanel.tsx
var DashboardSidepanel = __webpack_require__(57263);
// EXTERNAL MODULE: ./node_modules/react-color/es/index.js + 56 modules
var es = __webpack_require__(58686);
;// CONCATENATED MODULE: ./src/ui/molecules/ColorPickerPopover.tsx
function ColorPickerPopover_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function ColorPickerPopover_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            ColorPickerPopover_define_property(target, key, source[key]);
        });
    }
    return target;
}
function ColorPickerPopover_object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = ColorPickerPopover_object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function ColorPickerPopover_object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}




function ColorPickerPopover(_param) {
    var { children  } = _param, props = ColorPickerPopover_object_without_properties(_param, [
        "children"
    ]);
    const [popover, popoverApi] = usePopover((popoverArgs)=>/*#__PURE__*/ React.createElement(Popover, ColorPickerPopover_object_spread({
            anchorOrigin: {
                vertical: "bottom",
                horizontal: "left"
            },
            transformOrigin: {
                vertical: "top",
                horizontal: "left"
            }
        }, popoverArgs), /*#__PURE__*/ React.createElement(ChromePicker, props)));
    return /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement("div", {
        onClick: (e)=>popoverApi.onOpen(e.target)
    }, children), popover);
}

;// CONCATENATED MODULE: ./src/ui/molecules/index.ts


















// EXTERNAL MODULE: ./node_modules/@mui/material/Skeleton/Skeleton.js + 2 modules
var Skeleton = __webpack_require__(28973);
;// CONCATENATED MODULE: ./src/ui/index.ts









/***/ }),

/***/ 16239:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "s": () => (/* binding */ messages)
/* harmony export */ });
const messages = {
    searchInput: {
        placeholder: "Search"
    },
    openModalButton: {
        submitText: "Save"
    },
    fileUpload: {
        warningMessage: (type)=>`Only ${type} files supported!`
    },
    copyright: {
        enterpriseTerms: "Enterprise terms"
    },
    profileMenu: {
        myAccount: "My account",
        logout: "Logout"
    },
    copyTooltip: {
        copiedText: "Copied to clipboard",
        copy: "Copy"
    },
    noItemsFound: {
        title: "No data to show.",
        subtitle: "Try to refine your search criteria."
    }
};


/***/ }),

/***/ 57263:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "q": () => (/* binding */ DashboardSidepanel)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(72642);
/* harmony import */ var ui_atoms_Box__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(17299);
/* harmony import */ var ui_atoms_Text__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(21361);
/* harmony import */ var ui_css__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(93461);
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}





const dashboardSidepanelStyles = (0,ui_css__WEBPACK_IMPORTED_MODULE_3__/* .css */ .iv)({
    display: "flex",
    flexDirection: "column",
    height: "100vh",
    overflow: "hidden",
    background: "#FFFFFF",
    padding: "20px 24px"
});
const topContent = (0,ui_css__WEBPACK_IMPORTED_MODULE_3__/* .css */ .iv)({
    flexDirection: "flex-start",
    paddingBottom: 12
});
const bottomContent = (0,ui_css__WEBPACK_IMPORTED_MODULE_3__/* .css */ .iv)({
    marginTop: "auto",
    paddingTop: 12
});
const buttonStyles = (0,ui_css__WEBPACK_IMPORTED_MODULE_3__/* .css */ .iv)({
    "width": "100%",
    "color": "#1565C0",
    "background": "#F5FAFD",
    "textTransform": "none",
    "padding": "8px 22px",
    "border": "1px solid #1976D2",
    "borderRadius": 4,
    "fontFize": 15,
    "fontWeight": 500,
    "&:hover": {
        color: "white",
        background: "#1976D2"
    },
    "marginTop": 12
});
const ActionButton = (_param)=>{
    var { className  } = _param, props = _object_without_properties(_param, [
        "className"
    ]);
    return /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_mui_material__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, _object_spread({
        variant: "contained",
        color: "primary",
        className: buttonStyles({
            className
        }).className
    }, props));
};
const TopContent = ({ children  })=>{
    return /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(ui_atoms_Box__WEBPACK_IMPORTED_MODULE_1__/* .Box */ .x, {
        className: topContent().className
    }, children);
};
const BottomContent = ({ children  })=>{
    return /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(ui_atoms_Box__WEBPACK_IMPORTED_MODULE_1__/* .Box */ .x, {
        className: bottomContent().className
    }, children);
};
const mainContentStyles = (0,ui_css__WEBPACK_IMPORTED_MODULE_3__/* .css */ .iv)({
    display: "flex",
    flexDirection: "column",
    flexGrow: 1,
    overflow: "hidden"
});
// scrollable
const MainContent = ({ children  })=>{
    return /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(ui_atoms_Box__WEBPACK_IMPORTED_MODULE_1__/* .Box */ .x, {
        className: mainContentStyles().className
    }, children);
};
const titleStyles = (0,ui_css__WEBPACK_IMPORTED_MODULE_3__/* .css */ .iv)({
    fontWeight: "400 !important",
    paddingBottom: 6
});
const Title = ({ children  })=>{
    return /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(ui_atoms_Text__WEBPACK_IMPORTED_MODULE_2__/* .Text */ .x, {
        className: titleStyles().className,
        variant: "header5M"
    }, children);
};
const DashboardSidepanel = /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.forwardRef((_param, ref)=>{
    var { children , width =400 , className  } = _param, rest = _object_without_properties(_param, [
        "children",
        "width",
        "className"
    ]);
    return /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(ui_atoms_Box__WEBPACK_IMPORTED_MODULE_1__/* .Box */ .x, _object_spread({
        style: {
            width
        },
        "data-testid": "dashbord-sidepanel",
        className: dashboardSidepanelStyles({
            className
        }).className,
        ref: ref
    }, rest), children);
});
DashboardSidepanel.TopContent = TopContent;
DashboardSidepanel.BottomContent = BottomContent;
DashboardSidepanel.ActionButton = ActionButton;
DashboardSidepanel.Title = Title;
DashboardSidepanel.MainContent = MainContent;
DashboardSidepanel.displayName = "DashboardSidepanel";


/***/ }),

/***/ 90402:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "J": () => (/* binding */ Popover)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(62206);
/* harmony import */ var libs_hooks__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(88289);
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}



function Popover(_param) {
    var { children , target , open , onOpenClose  } = _param, rest = _object_without_properties(_param, [
        "children",
        "target",
        "open",
        "onOpenClose"
    ]);
    const _usePopoverDisclosure = (0,libs_hooks__WEBPACK_IMPORTED_MODULE_1__/* .usePopoverDisclosure */ .j6)(), { onOpen  } = _usePopoverDisclosure, props = _object_without_properties(_usePopoverDisclosure, [
        "onOpen"
    ]);
    const isOpen = open !== null && open !== void 0 ? open : props.open;
    const handleClose = ()=>{
        props.onClose();
        onOpenClose === null || onOpenClose === void 0 ? void 0 : onOpenClose(false);
    };
    return /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Fragment, null, /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_mui_material__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP, _object_spread_props(_object_spread({}, props, rest), {
        onClose: handleClose,
        open: isOpen
    }), children), target({
        onOpen,
        isOpen: !isOpen,
        onClick: (v)=>{
            onOpen(v.target);
            onOpenClose === null || onOpenClose === void 0 ? void 0 : onOpenClose(!isOpen);
        }
    }));
}


/***/ }),

/***/ 2699:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "mt": () => (/* reexport */ FilterLabel),
  "gm": () => (/* reexport */ TruncateFilters)
});

// UNUSED EXPORTS: AnimatedChip

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/assets/icons/index.tsx + 1 modules
var icons = __webpack_require__(99899);
// EXTERNAL MODULE: ./node_modules/@mui/material/Popover/Popover.js + 1 modules
var Popover = __webpack_require__(62206);
// EXTERNAL MODULE: ./node_modules/@mui/material/Link/Link.js + 2 modules
var Link = __webpack_require__(1079);
// EXTERNAL MODULE: ./node_modules/@mui/material/Typography/Typography.js + 1 modules
var Typography = __webpack_require__(2658);
// EXTERNAL MODULE: ./src/libs/hooks/index.ts + 18 modules
var hooks = __webpack_require__(88289);
// EXTERNAL MODULE: ./src/ui/atoms/index.ts + 36 modules
var atoms = __webpack_require__(1582);
// EXTERNAL MODULE: ./src/ui/vars.tsx
var vars = __webpack_require__(29400);
// EXTERNAL MODULE: ./src/libs/layouts/index.tsx + 2 modules
var layouts = __webpack_require__(5855);
// EXTERNAL MODULE: ./src/ui/css/index.ts
var css = __webpack_require__(93461);
// EXTERNAL MODULE: ./src/ui/atoms/Box.tsx
var Box = __webpack_require__(17299);
;// CONCATENATED MODULE: ./src/ui/molecules/TruncateFilters/PopoverFilters.tsx





const stackStyles = (0,css/* css */.iv)({
    ".filter-chip": {
        "height": "auto !important",
        "width": "fit-content",
        "> span": {
            whiteSpace: "normal",
            padding: "4px",
            paddingLeft: "8px",
            paddingRight: "8px"
        },
        ".filter-label": {
            flexWrap: "wrap"
        }
    }
});
function PopoverFilters({ children  }) {
    return /*#__PURE__*/ react.createElement(Box/* Box */.x, {
        sx: {
            paddingTop: vars/* space.4 */.Dh[4],
            paddingBottom: vars/* space.4 */.Dh[4],
            paddingLeft: vars/* space.3 */.Dh[3],
            paddingRight: vars/* space.3 */.Dh[3]
        },
        style: {
            width: 400
        }
    }, /*#__PURE__*/ react.createElement(layouts/* Stack */.Kq, {
        space: 3,
        className: stackStyles().className
    }, children));
}

;// CONCATENATED MODULE: ./src/ui/molecules/TruncateFilters/TruncateFilters.tsx







function TruncateFilters({ children , clearAll , hideClearAll , dataId =undefined , fixedElements =200 , showPrefix =true  }) {
    const ref = (0,react.useRef)(null);
    const [cutBefore, setCutBefore] = (0,react.useState)(0);
    const childrenArray = react.Children.toArray(children).filter((c)=>!!c);
    const [comp, actions] = (0,hooks/* usePopover */.Sv)((api)=>/*#__PURE__*/ react.createElement(Popover/* default */.ZP, api, /*#__PURE__*/ react.createElement(PopoverFilters, null, childrenArray.slice(0, cutBefore).map((el)=>/*#__PURE__*/ react.cloneElement(el, {
                animateMount: false
            })), /*#__PURE__*/ react.createElement(Link/* default */.Z, {
            color: "textSecondary",
            style: {
                lineHeight: 1
            },
            onClick: clearAll
        }, "Clear All"))));
    (0,react.useLayoutEffect)(()=>{
        if (actions.open && cutBefore > childrenArray.length) {
            actions.onClose();
        }
    }, [
        childrenArray.length,
        actions.open
    ]);
    // filters label + clear all + +n button
    // todo watch window resize
    (0,react.useLayoutEffect)(()=>{
        const node = ref.current;
        let availableWidth = node.clientWidth - fixedElements;
        const { childNodes  } = node;
        let i;
        for(i = childNodes.length - 1; i >= 0; i--){
            const element = childNodes[i];
            if (element) {
                const style = window.getComputedStyle(childNodes[i]);
                const minWidth = parseInt(style.minWidth || "0");
                const itemSize = minWidth || element.clientWidth || 0;
                availableWidth -= itemSize;
                if (availableWidth < 0) {
                    break;
                }
            }
        }
        setCutBefore(i);
    });
    const filtersNode = showPrefix && /*#__PURE__*/ react.createElement(atoms/* HStack */.Ug, {
        space: "1",
        align: "center",
        style: {
            marginRight: vars/* space.1 */.Dh[1]
        }
    }, /*#__PURE__*/ react.createElement(icons/* FiltersIcon */.sH, {
        style: {
            fontSize: 20,
            color: "#545454"
        }
    }), /*#__PURE__*/ react.createElement(Typography/* default */.Z, {
        style: {
            fontWeight: 400,
            textTransform: "capitalize"
        },
        variant: "h6",
        "data-fs": "unmask"
    }, "Filters applied:"));
    return /*#__PURE__*/ react.createElement(react.Fragment, null, /*#__PURE__*/ react.createElement(atoms/* HStack */.Ug, {
        space: "1",
        align: "center",
        style: {
            height: 0,
            margin: 0,
            overflowY: "hidden"
        },
        ref: ref
    }, filtersNode, children), /*#__PURE__*/ react.createElement(atoms/* HStack */.Ug, {
        space: "1",
        align: "center",
        style: {
            height: 30
        },
        "data-testid": dataId
    }, filtersNode, cutBefore > 0 && /*#__PURE__*/ react.createElement(Link/* default */.Z, {
        color: "textPrimary",
        onClick: (e)=>actions.onOpen(e.currentTarget)
    }, "+ ", cutBefore, " more"), cutBefore > 0 ? childrenArray.slice(cutBefore) : childrenArray, cutBefore > 0 && comp, /*#__PURE__*/ react.createElement(Link/* default */.Z, {
        onClick: clearAll,
        color: "textSecondary",
        style: {
            display: hideClearAll ? "none" : "block",
            lineHeight: 1.5,
            marginLeft: vars/* space.3 */.Dh[3],
            marginTop: vars/* space.1 */.Dh[1]
        },
        "data-fs": "unmask"
    }, "Clear All")));
}

// EXTERNAL MODULE: ./src/ui/theme.ts
var ui_theme = __webpack_require__(73728);
;// CONCATENATED MODULE: ./src/ui/molecules/TruncateFilters/AnimatedChip.tsx
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}





function Chip(props) {
    return /*#__PURE__*/ React.createElement(MChip, _object_spread_props(_object_spread({
        variant: "outlined",
        deleteIcon: /*#__PURE__*/ React.createElement(CloseIcon, {
            style: {
                width: 18,
                height: 18
            },
            fontSize: "small"
        })
    }, props), {
        style: _object_spread({
            height: 30,
            background: "white",
            fontWeight: "normal",
            textTransform: "none"
        }, props.style)
    }));
}
function AnimatedChip(_param) {
    var { animateKey , animateMount =false  } = _param, props = _object_without_properties(_param, [
        "animateKey",
        "animateMount"
    ]);
    const { ref  } = useAnimatedChange({
        key: animateKey,
        animateMount,
        keyframes: {
            background: [
                "white",
                theme.palette.grey["400"],
                "white"
            ]
        },
        duration: 1000,
        easing: "ease-in-out"
    });
    return /*#__PURE__*/ React.createElement(Chip, _object_spread_props(_object_spread({
        innerRef: ref
    }, props), {
        className: "filter-chip"
    }));
}

// EXTERNAL MODULE: ./src/libs/data-utils/index.ts + 5 modules
var data_utils = __webpack_require__(50082);
;// CONCATENATED MODULE: ./src/ui/molecules/TruncateFilters/FilterLabel.tsx




function FilterLabel({ prefix , items  }) {
    return /*#__PURE__*/ react.createElement(layouts/* HStack */.Ug, {
        align: "center",
        space: 1,
        className: "filter-label",
        as: Typography/* default */.Z,
        variant: "body2",
        style: {
            fontSize: 13,
            display: "inline-flex"
        }
    }, /*#__PURE__*/ react.createElement("span", null, prefix, ":"), (0,data_utils/* jsxJoin */.eL)(items.map((el)=>typeof el === "string" ? /*#__PURE__*/ react.createElement("span", null, el) : el), ()=>/*#__PURE__*/ react.createElement("b", null, " OR ")));
}

;// CONCATENATED MODULE: ./src/ui/molecules/TruncateFilters/index.ts





/***/ }),

/***/ 28512:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "T": () => (/* binding */ TableTemplate),
/* harmony export */   "s": () => (/* binding */ TablePageTemplate)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var shared_checkBrowser__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(68446);
/* harmony import */ var libs_layouts__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(5855);
/* harmony import */ var ui_theme__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(73728);
/* harmony import */ var ui_css__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(93461);
/* harmony import */ var ui_atoms_Box__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(17299);
/* harmony import */ var ui_vars__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(29400);
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}







const safariStyles = shared_checkBrowser__WEBPACK_IMPORTED_MODULE_1__/* .IS_SAFARI */ .s$ ? {
    flexShrink: 0
} : {};
const contentStyles = (0,ui_css__WEBPACK_IMPORTED_MODULE_4__/* .css */ .iv)({
    height: "100%",
    flex: 1,
    display: "flex",
    flexDirection: "column",
    overflow: "hidden"
});
function TablePageTemplate({ topbar =null , filters =null , children , sx  }) {
    return /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(libs_layouts__WEBPACK_IMPORTED_MODULE_2__/* .Stack */ .Kq, {
        as: ui_atoms_Box__WEBPACK_IMPORTED_MODULE_5__/* .Box */ .x,
        sx: _object_spread({
            background: "#f2f3f4",
            paddingX: ui_vars__WEBPACK_IMPORTED_MODULE_6__/* .space[2] */ .Dh[2]
        }, sx),
        space: 2,
        style: {
            height: "100%",
            flex: "auto"
        }
    }, (topbar || filters) && /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(libs_layouts__WEBPACK_IMPORTED_MODULE_2__/* .Stack */ .Kq, {
        space: 0
    }, topbar, filters), /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(ui_atoms_Box__WEBPACK_IMPORTED_MODULE_5__/* .Box */ .x, {
        sx: {
            paddingX: ui_vars__WEBPACK_IMPORTED_MODULE_6__/* .space[3] */ .Dh[3],
            paddingTop: filters ? ui_vars__WEBPACK_IMPORTED_MODULE_6__/* .space[3] */ .Dh[3] : 0,
            marginX: ui_vars__WEBPACK_IMPORTED_MODULE_6__/* .space */ .Dh[-2],
            background: "white"
        },
        className: contentStyles().className
    }, children));
}
function TableTemplate({ className , sx , tableFilters , caption , children , "data-testid": testId  }) {
    return /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(libs_layouts__WEBPACK_IMPORTED_MODULE_2__/* .Stack */ .Kq, {
        space: 2,
        style: _object_spread({
            height: "100%"
        }, sx),
        className: className,
        "data-testid": testId
    }, tableFilters && /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(libs_layouts__WEBPACK_IMPORTED_MODULE_2__/* .Stack */ .Kq, {
        space: 3,
        style: safariStyles
    }, tableFilters), /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(ui_atoms_Box__WEBPACK_IMPORTED_MODULE_5__/* .Box */ .x, {
        as: libs_layouts__WEBPACK_IMPORTED_MODULE_2__/* .Stack */ .Kq,
        sx: {
            marginX: ui_vars__WEBPACK_IMPORTED_MODULE_6__/* .space */ .Dh[-3]
        },
        space: 0,
        style: {
            flexGrow: 1,
            overflow: "auto"
        }
    }, children, caption && /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(libs_layouts__WEBPACK_IMPORTED_MODULE_2__/* .HStack */ .Ug, {
        "data-fs": "unmask",
        as: ui_atoms_Box__WEBPACK_IMPORTED_MODULE_5__/* .Box */ .x,
        sx: {
            paddingLeft: ui_vars__WEBPACK_IMPORTED_MODULE_6__/* .space[1] */ .Dh[1],
            paddingY: ui_vars__WEBPACK_IMPORTED_MODULE_6__/* .space[1] */ .Dh[1],
            border: `1px solid ${ui_theme__WEBPACK_IMPORTED_MODULE_3__/* .theme.palette.divider */ .rS.palette.divider}`,
            borderTop: `none`
        },
        style: shared_checkBrowser__WEBPACK_IMPORTED_MODULE_1__/* .IS_SAFARI */ .s$ && {
            flexShrink: 0
        }
    }, caption)));
}


/***/ }),

/***/ 73728:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Ih": () => (/* binding */ setupCssVars),
/* harmony export */   "O9": () => (/* binding */ colors),
/* harmony export */   "rS": () => (/* binding */ theme)
/* harmony export */ });
/* unused harmony export themeV5Obj */
/* harmony import */ var _mui_material_styles__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(23286);
/* harmony import */ var _mui_material_styles__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(88238);
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}

const shadows = [
    "none",
    "0px 1px 2px 0px rgb(0 0 0 / 20%), 0px 1px 1px 0px rgb(0 0 0 / 14%), 0px -1px 1px -1px rgb(0 0 0 / 12%)",
    "0px 3px 1px -2px rgb(0 0 0 / 20%), 0px 2px 2px 0px rgb(0 0 0 / 14%), 0px 1px 5px 0px rgb(0 0 0 / 12%)",
    "0px 3px 3px -2px rgb(0 0 0 / 20%), 0px 3px 4px 0px rgb(0 0 0 / 14%), 0px 1px 8px 0px rgb(0 0 0 / 12%)",
    "0px 2px 4px -1px rgb(0 0 0 / 20%), 0px 4px 5px 0px rgb(0 0 0 / 14%), 0px 1px 10px 0px rgb(0 0 0 / 12%)",
    "0px 3px 5px -1px rgb(0 0 0 / 20%), 0px 5px 8px 0px rgb(0 0 0 / 14%), 0px 1px 14px 0px rgb(0 0 0 / 12%)",
    "0px 3px 5px -1px rgb(0 0 0 / 20%), 0px 6px 10px 0px rgb(0 0 0 / 14%), 0px 1px 18px 0px rgb(0 0 0 / 12%)",
    "0px 5px 5px -3px rgb(0 0 0 / 20%), 0px 8px 10px 1px rgb(0 0 0 / 14%), 0px 3px 14px 2px rgb(0 0 0 / 12%)",
    "0px 5px 5px -3px rgb(0 0 0 / 20%), 0px 8px 10px 1px rgb(0 0 0 / 14%), 0px 3px 14px 2px rgb(0 0 0 / 12%)",
    "0px 5px 6px -3px rgb(0 0 0 / 20%), 0px 9px 12px 1px rgb(0 0 0 / 14%), 0px 3px 16px 2px rgb(0 0 0 / 12%)",
    "0px 6px 6px -3px rgb(0 0 0 / 20%), 0px 10px 14px 1px rgb(0 0 0 / 14%), 0px 4px 18px 3px rgb(0 0 0 / 12%)",
    "0px 6px 7px -4px rgb(0 0 0 / 20%), 0px 11px 15px 1px rgb(0 0 0 / 14%), 0px 4px 20px 3px rgb(0 0 0 / 12%)",
    "0px 7px 8px -4px rgb(0 0 0 / 20%), 0px 12px 17px 2px rgb(0 0 0 / 14%), 0px 5px 22px 4px rgb(0 0 0 / 12%)",
    "0px 7px 8px -4px rgb(0 0 0 / 20%), 0px 13px 19px 2px rgb(0 0 0 / 14%), 0px 5px 24px 4px rgb(0 0 0 / 12%)",
    "0px 7px 9px -4px rgb(0 0 0 / 20%), 0px 14px 21px 2px rgb(0 0 0 / 14%), 0px 5px 26px 4px rgb(0 0 0 / 12%)",
    "0px 8px 9px -5px rgb(0 0 0 / 20%), 0px 15px 22px 2px rgb(0 0 0 / 14%), 0px 6px 28px 5px rgb(0 0 0 / 12%)",
    "0px 8px 10px -5px rgb(0 0 0 / 20%), 0px 16px 24px 2px rgb(0 0 0 / 14%), 0px 6px 30px 5px rgb(0 0 0 / 12%)",
    "0px 8px 11px -5px rgb(0 0 0 / 20%), 0px 17px 26px 2px rgb(0 0 0 / 14%), 0px 6px 32px 5px rgb(0 0 0 / 12%)",
    "0px 9px 11px -5px rgb(0 0 0 / 20%), 0px 18px 28px 2px rgb(0 0 0 / 14%), 0px 7px 34px 6px rgb(0 0 0 / 12%)",
    "0px 9px 12px -6px rgb(0 0 0 / 20%), 0px 19px 29px 2px rgb(0 0 0 / 14%), 0px 7px 36px 6px rgb(0 0 0 / 12%)",
    "0px 10px 13px -6px rgb(0 0 0 / 20%), 0px 20px 31px 3px rgb(0 0 0 / 14%), 0px 8px 38px 7px rgb(0 0 0 / 12%)",
    "0px 10px 13px -6px rgb(0 0 0 / 20%), 0px 21px 33px 3px rgb(0 0 0 / 14%), 0px 8px 40px 7px rgb(0 0 0 / 12%)",
    "0px 10px 14px -6px rgb(0 0 0 / 20%), 0px 22px 35px 3px rgb(0 0 0 / 14%), 0px 8px 42px 7px rgb(0 0 0 / 12%)",
    "0px 11px 14px -7px rgb(0 0 0 / 20%), 0px 23px 36px 3px rgb(0 0 0 / 14%), 0px 9px 44px 8px rgb(0 0 0 / 12%)",
    "0px 11px 15px -7px rgb(0 0 0 / 20%), 0px 24px 38px 3px rgb(0 0 0 / 14%), 0px 9px 46px 8px rgb(0 0 0 / 12%)"
];
const primaryMain = "#43A7EA";
const primaryLight = "#7FD8FF";
const primaryDark = "#0078B7";
const secondaryMain = "#455A64";
const secondaryLight = "#718792";
const secondaryDark = "#1C313A";
const textPrimary = "#1F1F1F";
const textSecondary = "#757575";
const dividerColor = "#DFE1E3";
const dividerColorHover = "#F1F3F4";
const defaultBackground = "#fff";
const secondaryBackground = "#F1F3F4";
const grey1 = "#EDEDED";
const grey2 = "#424242";
const actionActiveColor = "#7b7f84";
const infoBackgroundColor = "rgba(67, 167, 234, 0.2)";
const spacing = 5;
const fontSize = 14;
const borderRadius = 2;
const htmlFontSize = 16;
const getSpacing = (k)=>spacing * k;
const coef = fontSize / 14;
const pxToRem = (size)=>`${size / htmlFontSize * coef}rem`;
const buildVariant = (color = textPrimary, fontWeight, size, casing = {})=>_object_spread({
        color,
        fontWeight,
        fontSize: pxToRem(size)
    }, casing);
const caseAllCaps = {
    textTransform: "uppercase"
};
const headlineFontStyle = buildVariant(textPrimary, 500, 20); // Headline
const titleFontStyle = buildVariant(textPrimary, 500, 16, caseAllCaps); // SEARCH,
const subtitle1FontStyle = buildVariant(textPrimary, 400, 16); // Advanced Search,
const subtitle2FontStyle = buildVariant(textPrimary, 500, 14, caseAllCaps); // ENDPOINT GROUPS
const body1FontStyle = buildVariant(textPrimary, 400, 15); // CV sharing
const body2FontStyle = buildVariant(textPrimary, 400, 14); // Users who interacted with this dataflow
const captionFontStyle = buildVariant(textSecondary, 400, 14); // Users who interacted with this dataflow
const tabTableLabelFontStyle = buildVariant(textSecondary, 500, 13, caseAllCaps); // tab label / table
const borders = {
    border1: `1px solid #f1f1f1`
};
const themeObg = {
    spacing: getSpacing,
    shape: {
        borderRadius
    },
    typography: {
        fontSize,
        h1: {},
        h2: {},
        h3: {},
        h4: {},
        h5: headlineFontStyle,
        h6: titleFontStyle,
        subtitle1: subtitle1FontStyle,
        subtitle2: subtitle2FontStyle,
        body1: body1FontStyle,
        body2: body2FontStyle,
        button: {},
        caption: captionFontStyle,
        overline: {}
    },
    palette: {
        error: {
            main: "#d32f2f",
            light: "#e57373"
        },
        primary: {
            main: primaryMain,
            light: primaryLight,
            dark: primaryDark
        },
        secondary: {
            main: secondaryMain,
            light: secondaryLight,
            dark: secondaryDark
        },
        divider: dividerColor,
        background: {
            default: defaultBackground
        },
        text: {
            primary: textPrimary,
            secondary: textSecondary
        },
        action: {
            // The color of an active action like an icon button.
            active: actionActiveColor,
            // copied this colors from MU v3 to have the correct colors according to our theme
            // The color of an hovered action.
            hover: "rgba(0, 0, 0, 0.08)",
            hoverOpacity: 0.08,
            // The color of a selected action.
            selected: "rgba(0, 0, 0, 0.14)",
            selectedOpacity: 0.14,
            // The color of a disabled action.
            disabled: "rgba(0, 0, 0, 0.26)",
            // The background color of a disabled action.
            disabledBackground: "rgba(0, 0, 0, 0.12)"
        }
    },
    shadows: [
        ...shadows
    ],
    overrides: {
        MuiSvgIcon: {
            colorAction: {
                color: "#757575"
            },
            fontSizeSmall: {
                fontSize: 18
            }
        },
        MuiToolbar: {
            root: {
                background: defaultBackground
            }
        },
        MuiFormLabel: {
            root: _object_spread_props(_object_spread({
                marginBottom: getSpacing(1)
            }, captionFontStyle), {
                lineHeight: 1
            })
        },
        MuiFormHelperText: {
            root: _object_spread_props(_object_spread({}, captionFontStyle), {
                fontSize: 12
            })
        },
        MuiSelect: {
            select: _object_spread_props(_object_spread({}, body1FontStyle), {
                "height": "1.1875em",
                "minHeight": "1.1875em",
                "lineHeight": "1.1875em",
                "fontSize": 14,
                "&:focus": {
                    backgroundColor: "transparent"
                }
            })
        },
        MuiInput: {
            underline: {
                "&:before": {
                    left: 0,
                    right: 0,
                    bottom: 0,
                    content: `""`,
                    position: "absolute",
                    borderBottom: `1px solid ${dividerColor}`
                },
                "&:hover:not(.Mui-disabled):before": {
                    borderBottom: `2px solid ${dividerColorHover}`
                }
            }
        },
        MuiInputBase: {
            input: _object_spread({
                borderColor: dividerColor,
                padding: "10px 0px 10px 0px",
                height: "1.1876em"
            }, body1FontStyle),
            inputMultiline: {
                padding: 0,
                paddingLeft: 0
            }
        },
        MuiOutlinedInput: {
            root: _object_spread_props(_object_spread({}, body1FontStyle), {
                "borderRadius": borderRadius,
                "& $notchedOutline": {
                    borderColor: dividerColorHover
                },
                "&:hover:not($disabled):not($focused):not($error) $notchedOutline": {
                    borderColor: dividerColor
                },
                "background": secondaryBackground,
                "&$focused": {
                    background: defaultBackground
                }
            }),
            inputSizeSmall: {
                paddingTop: 12,
                paddingBottom: 12
            },
            adornedStart: {
                paddingLeft: `${getSpacing(2.3)}px`
            }
        },
        MuiInputLabel: {
            formControl: {
                right: 8
            },
            outlined: {
                "left": 0,
                "right": "auto",
                "transform": "translate(14px, 20px) scale(1)",
                "&$sizeSmall": {
                    transform: "translate(14px, 15px) scale(1)"
                },
                "&$shrink": {
                    transform: "translate(18px, -6px) scale(0.75)"
                }
            },
            shrink: {
                transform: "translate(0, 1.5px) scale(1)"
            }
        },
        MuiButton: {
            root: {},
            contained: {
                boxShadow: "none",
                padding: `3px ${getSpacing(2)}px`
            },
            text: {
                padding: `3px ${getSpacing(2)}px`
            },
            outlined: {
                padding: `2px ${getSpacing(2)}px`
            },
            sizeSmall: {
                minWidth: 40
            }
        },
        MuiFab: {
            root: {},
            primary: {
                color: "#fff"
            }
        },
        MuiPaper: {
            root: {
                background: "white"
            }
        },
        MuiAppBar: {},
        MuiIconButton: {
            root: {
                "&:hover": {
                    backgroundColor: "$labelcolor"
                }
            }
        },
        MuiLink: {
            root: {
                cursor: "pointer",
                textDecoration: "none"
            }
        },
        MuiDialog: {
            paperWidthXs: {
                maxWidth: 430
            }
        },
        MuiDialogTitle: {
            root: {
                padding: `${getSpacing(4)}px ${getSpacing(5)}px`
            }
        },
        MuiDialogContent: {
            root: {
                padding: `${getSpacing(0)}px ${getSpacing(5)}px  ${getSpacing(4)}px`
            }
        },
        MuiDialogActions: {
            root: {
                padding: `${getSpacing(0)}px ${getSpacing(5)}px  ${getSpacing(4)}px `,
                margin: 0
            }
        },
        MuiTabs: {
            indicator: {
                minWidth: 115
            }
        },
        MuiTab: {
            root: {
                "minWidth": "115px !important",
                "&:not(.Mui-selected)": {
                    opacity: 0.7
                }
            },
            /* Styles applied to the root element if `textColor="primary"`. */ textColorPrimary: {
                color: textPrimary
            }
        },
        MuiList: {
            root: {
                "&:focus": {
                    outline: "none"
                }
            }
        },
        MuiListItem: {
            root: {
                paddingTop: `${getSpacing(2)}px`,
                paddingBottom: `${getSpacing(2)}px`
            },
            dense: {
                paddingTop: `${getSpacing(1)}px`,
                paddingBottom: `${getSpacing(1)}px`
            }
        },
        MuiListSubheader: {
            root: _object_spread_props(_object_spread({}, tabTableLabelFontStyle), {
                lineHeight: "40px"
            })
        },
        MuiListItemIcon: {
            root: {
                marginRight: 5,
                minWidth: 24
            }
        },
        MuiListItemText: {
            root: {
                "padding": 0,
                "&$dense": {
                    marginTop: 0,
                    marginBottom: 0
                }
            }
        },
        MuiTableCell: {
            root: _object_spread_props(_object_spread({}, body1FontStyle), {
                borderBottom: `1px solid ${dividerColor}`
            }),
            head: _object_spread({}, tabTableLabelFontStyle)
        },
        MuiMenuItem: {
            root: _object_spread({}, body1FontStyle)
        },
        MuiChip: {
            root: {
                height: 26,
                maxWidth: "100%"
            },
            icon: {
                color: undefined,
                marginLeft: 10,
                fontSize: 20
            },
            deleteIcon: {
                margin: `0 10px 0 -2px`,
                fontSize: 20
            },
            label: {
                display: "block",
                overflow: "hidden",
                textOverflow: "ellipsis"
            }
        },
        MuiAccordionSummary: {
            root: {
                "&$focused": {
                    backgroundColor: "none"
                }
            }
        },
        MuiTablePagination: {
            root: {
                color: textSecondary,
                overflow: "none"
            },
            toolbar: {
                minHeight: 56
            },
            selectIcon: {
                top: "5px",
                right: "-4px"
            }
        }
    },
    props: {
        MuiCheckbox: {
            color: "primary"
        },
        MuiRadio: {
            color: "primary"
        },
        MuiSwitch: {
            color: "primary"
        },
        MuiIconButton: {
            disableRipple: true
        },
        MuiPaper: {
            elevation: 1
        },
        MuiButtonBase: {
            disableRipple: true
        }
    }
};
const light = (n)=>`hsl(0, 0%, calc(100% - ${n * 5}%))`;
const customProperties = {
    borders,
    panelBackground: {
        selectedColor: "#E6EAEE"
    },
    light,
    grey: {
        listViewAttributes: "#5E6C77",
        grey1,
        grey2
    },
    secondaryBackground,
    drawerWidth: 270,
    infoBackgroundColor,
    riskyColors: {
        "100": "#F4C03B",
        "200": "#F48C40",
        "300": "#D95946"
    }
};
const themeV5Obj = {
    components: {
        MuiSvgIcon: {
            styleOverrides: {
                root: {
                    fontSize: "1.5rem"
                }
            }
        },
        MuiButtonBase: {
            styleOverrides: {
                root: {
                    "textTransform": "none",
                    "&.MuiTab-textColorPrimary": {
                        textTransform: "none"
                    },
                    "&.Mui-selected": {
                        textTransform: "none"
                    }
                }
            }
        },
        MuiToggleButton: {
            styleOverrides: {
                root: {
                    "&.Mui-selected": {
                        "&[type=button]": {
                            color: "white"
                        }
                    }
                }
            }
        },
        MuiIconButton: {
            styleOverrides: {
                sizeSmall: {
                    padding: 3,
                    fontSize: "1.125rem"
                }
            }
        },
        MuiButton: {
            styleOverrides: {
                textSizeSmall: {
                    padding: "4px 5px",
                    fontSize: "0.8125rem"
                },
                containedSecondary: {
                    backgroundColor: "#e0e0e0"
                },
                textPrimary: {
                    "color": primaryMain,
                    "&:hover": {
                        background: "rgba(31, 31, 31, 0.08)"
                    }
                },
                outlined: {
                    border: "1px solid rgba(0, 0, 0, 0.23)"
                },
                root: {
                    "color": "#1F1F1F",
                    "&:hover": {
                        backgroundColor: "rgba(31, 31, 31, 0.08)",
                        borderColor: "rgba(0, 0, 0, 0.23)"
                    }
                },
                contained: {
                    color: "rgba(0, 0, 0, 0.87)"
                },
                outlinedSizeLarge: {
                    padding: "7px 21px"
                },
                sizeLarge: {
                    padding: "8px 21px"
                },
                containedPrimary: {
                    "color": "#fff",
                    "&:hover": {
                        backgroundColor: "#0078B7",
                        boxShadow: "0px 2px 4px -1px rgb(0 0 0 / 20%), 0px 4px 5px 0px rgb(0 0 0 / 14%), 0px 1px 10px 0px rgb(0 0 0 / 12%)"
                    }
                },
                containedError: {
                    "color": "#fff",
                    "&:hover": {
                        backgroundColor: "#b71c1c",
                        boxShadow: "0px 2px 4px -1px rgb(0 0 0 / 20%), 0px 4px 5px 0px rgb(0 0 0 / 14%), 0px 1px 10px 0px rgb(0 0 0 / 12%)"
                    }
                }
            }
        },
        MuiBadge: {
            styleOverrides: {
                colorError: {
                    backgroundColor: "#f44336"
                }
            }
        },
        MuiSwitch: {
            styleOverrides: {
                colorPrimary: {
                    "&.Mui-disabled.MuiSwitch-switchBase": {
                        "color": "#8CBBE8",
                        " + .MuiSwitch-track": {
                            backgroundColor: "#C5DDF3",
                            opacity: 1
                        }
                    }
                }
            }
        },
        MuiTypography: {
            styleOverrides: {
                h5: {
                    textTransform: "none",
                    fontSize: "1.25rem",
                    fontWeight: 500,
                    lineHeight: 1.334,
                    letterSpacing: "0em"
                }
            }
        },
        MuiSelect: {
            styleOverrides: {
                select: {
                    "&:hover:not(.Mui-disabled):before": {
                        borderBottomColor: "#F1F3F4"
                    }
                }
            }
        },
        MuiOutlinedInput: {
            styleOverrides: {
                root: {
                    "background": "#F1F3F4",
                    "&.Mui-focused": {
                        background: "#fff"
                    },
                    "&:hover:not(.Mui-focused)  .MuiOutlinedInput-notchedOutline": {
                        borderColor: "#DFE1E3"
                    }
                },
                input: {
                    "height": "1.1876em",
                    "padding": "18.5px 14px",
                    "fontSize": "0.9375rem",
                    "fontWeight": 400,
                    "&.MuiInputBase-inputAdornedEnd": {
                        paddingRight: 0
                    },
                    "&.MuiInputBase-inputAdornedStart": {
                        paddingLeft: 0
                    }
                },
                notchedOutline: {
                    "borderColor": "transparent",
                    "&:before": {
                        left: 0,
                        right: 0,
                        bottom: 0,
                        content: `""`,
                        position: "absolute",
                        borderBottom: `1px solid ${dividerColor}`
                    }
                }
            }
        }
    }
};
const theme = _object_spread({}, customProperties, (0,_mui_material_styles__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)((0,_mui_material_styles__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(themeObg), themeV5Obj));
const colors = theme.palette;
function asCssVars(vars) {
    return Object.keys(vars).reduce((acc, el)=>{
        acc += `--${el}: ${vars[el]};\n`;
        return acc;
    }, ":root{\n") + "}";
}
function setupCssVars() {
    const style = document.createElement("style");
    style.innerHTML = asCssVars({
        space: spacing + "px",
        disabledColor: theme.palette.grey["400"]
    });
    document.head.appendChild(style);
}


/***/ }),

/***/ 9527:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Y": () => (/* binding */ Sensitivity)
/* harmony export */ });
var Sensitivity;
(function(Sensitivity) {
    Sensitivity[Sensitivity["Unrestricted"] = 0] = "Unrestricted";
    Sensitivity[Sensitivity["Low"] = 1] = "Low";
    Sensitivity[Sensitivity["Moderate"] = 2] = "Moderate";
    Sensitivity[Sensitivity["High"] = 3] = "High";
    Sensitivity[Sensitivity["Critical"] = 4] = "Critical";
})(Sensitivity || (Sensitivity = {}));


/***/ }),

/***/ 29400:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Dh": () => (/* binding */ space),
/* harmony export */   "O9": () => (/* binding */ colors),
/* harmony export */   "g6": () => (/* binding */ fontStyles),
/* harmony export */   "pD": () => (/* binding */ radii)
/* harmony export */ });
/* unused harmony export zIndexes */
// file contains variables from design system, edit this file only if design system changes
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
const colorsPalette = {
    white: "#FFFFFF",
    light100: "#F1F3F4",
    light120: "#F7F7F7",
    light180: "#EAEDEF",
    light200: "#E1E5E8",
    light300: "#C5CDD3",
    blue100: "#43A7EA",
    blue200: "#0078B7",
    blue300: "#046294",
    dark100: "#046294",
    dark200: "#1F1F1F",
    dark300: "#000000",
    gray100: "#6B6B6B",
    blueLight100: "#E7F1F8"
};
const brandedColors = {
    // todo sync up with
    bodySecondary: "#737373",
    bodyPrimary: colorsPalette.dark200
};
const colors = _object_spread({}, colorsPalette, brandedColors);
const radii = {
    none: 0,
    sm: "2px",
    md: "4px",
    lg: "0.75rem",
    full: "9999px"
};
// spacing convention on which we agreed with designer.
const space = {
    "-6": "-30px",
    "-5": "-25px",
    "-4": "-20px",
    "-3": "-15px",
    "-2": "-10px",
    "-1": "-5px",
    "0": "0px",
    "1": "5px",
    "2": "10px",
    "3": "15px",
    "4": "20px",
    "5": "25px",
    "6": "30px",
    "7": "35px",
    "8": "40px",
    "9": "45px",
    "10": "50px"
};
const zIndexes = {
    1: 1,
    2: 2,
    3: 3,
    5: 5,
    max: 9999
};
// font styles from https://www.figma.com/file/Wtp3SIo47PW0g1EwSrQmyd/Typography
// should be up to date
// TODO(dmitry) implement variant mapping to h2,h3,h5, span
const fontStyles = {
    header3: {
        fontStyle: "normal",
        fontWeight: "normal",
        fontSize: "48px",
        lineHeight: "56px"
    },
    header4: {
        fontStyle: "normal",
        fontWeight: "normal",
        fontSize: "32px",
        lineHeight: "37px"
    },
    header5M: {
        fontStyle: "normal",
        fontWeight: 500,
        fontSize: "20px",
        lineHeight: "23px"
    },
    header6MC: {
        fontStyle: "normal",
        fontWeight: 500,
        fontSize: "16px",
        lineHeight: "19px",
        textTransform: "uppercase"
    },
    subtitle2: {
        fontStyle: "normal",
        fontWeight: "normal",
        fontSize: "15px",
        lineHeight: "18px"
    },
    subtitle3: {
        fontStyle: "normal",
        fontWeight: "normal",
        fontSize: "14px",
        lineHeight: "16px"
    },
    subtitle4M: {
        fontStyle: "normal",
        fontWeight: 500,
        fontSize: "14px",
        lineHeight: "16px"
    },
    body2: {
        fontStyle: "normal",
        fontWeight: "normal",
        fontSize: "14px",
        lineHeight: "16px"
    },
    body3: {
        fontStyle: "normal",
        fontWeight: "normal",
        fontSize: "13px",
        lineHeight: "15px"
    },
    body4M: {
        fontStyle: "normal",
        fontWeight: 500,
        fontSize: "13px",
        lineHeight: "15px"
    },
    buttonMC: {
        fontStyle: "normal",
        fontWeight: 500,
        fontSize: "14px",
        lineHeight: "16px",
        textTransform: "uppercase"
    },
    buttonM: {
        fontWeight: 500,
        fontSize: "14px",
        lineHeight: "16px",
        letterSpacing: "0.005em"
    },
    button: {
        fontWeight: 400,
        fontSize: "14px",
        lineHeight: "16px",
        letterSpacing: "0.005em"
    },
    caption: {
        fontStyle: "normal",
        fontWeight: "normal",
        fontSize: "12px",
        lineHeight: "14px"
    }
};


/***/ }),

/***/ 6503:
/***/ ((module) => {

module.exports = JSON.parse('{"$":[{"tag":["2","17","46"],"title":"Drivers Licence California","countryTitle":"USA","description":"","name":"DriversLicenceCalifornia"},{"tag":["2","17","46"],"title":"Telephone numbers California","countryTitle":"USA","description":"","name":"TelephonenumbersCalifornia"},{"tag":["2","17","46"],"title":"Social security numbers California","countryTitle":"USA","description":"","name":"SocialsecuritynumbersCalifornia"},{"tag":["2","17","46"],"title":"Postal addresses California","countryTitle":"USA","description":"","name":"PostaladdressesCalifornia"},{"tag":["2","17","46"],"title":"Entity number limited liability California","countryTitle":"USA","description":"","name":"EntitynumberlimitedliabilityCalifornia"},{"tag":["2","17","46"],"title":"Entity number California","countryTitle":"USA","description":"","name":"EntitynumberCalifornia"},{"tag":["2","7"],"title":"Postal addresses","countryTitle":"Global","description":"Addresses where the first line of the address and zip or postcode are provided.\\nCountries supported: Australia, Belgium, Brazil, Canada, Denmark, Finland, France, Germany, Ireland, Italy, Netherlands, Spain, UK, USA, New Zealand, South Africa & Sweden","name":"PostaladdressesGlobal"},{"tag":["2","3","6","7"],"title":"International Bank Account Numbers","countryTitle":"Global","description":"IBAN (International Bank Account Numbers).\\n\\nValues conform to the following:-\\n* Be within the range of IBAN country codes.\\n* Have an appropriate length for an IBAN\\n* Either be contiguous or have an appropriate digit grouping\\n* Have a valid check digit\\n* Must not appear to be part of a larger digit sequence\\n\\nAdditionally for fully supported regions value must conform to that region\'s bank numbering system.","name":"InternationalBankAccountNumbersGlobal"},{"tag":["2","3","6","7"],"title":"Credit card numbers - with phrases","countryTitle":"Global","description":"Specified quantity of both credit or debit card numbers and of associated phrases such as:-\\n* \\"csv\\"\\n* \\"Expiry Date\\"\\n* \\"Bankleitzahl\\"\\n* \\"American Express\\"\\n* \\"handelsbanken\\"\\n\\nFor a definition of credit card numbers that are detected please see the CCL description for \\"Credit card numbers [Global]\\".","name":"CreditordebitcardnumberswithqualifyingtermsGlobal"},{"tag":["2","3","6","7"],"title":"Credit card numbers","countryTitle":"Global","description":"Credit, debit, travel, store or membership card numbers using a common bank identification numbering system. Such as:-\\n* 16 digit card numbers (including MasterCard and VISA)\\n* American Express\\n* CUP (China Union Pay)\\n* Diners Club\\n* Itaú Unibanco\\n* JCB\\n* Maestro\\n* Royal Bank of Canada\\n* ScotiBank\\n* magnetic track data containing card numbers\\n\\nCard numbers must conform to the following:-\\n* Start with a \\"3\\", \\"4\\", \\"5\\" or \\"6\\" i.e. be a standard format ISO/IEC 7812 number with a Major Industry Identifier (MII) for \'Travel and entertainment\', \'Banking and financial\' or \'Merchandising and banking/financial\'.\\n* If not 16 digits then start with a recognised Issuer Identification Number (IIN)\\n* Have an appropriate length for the card issuer\\n* Either be contiguous or have an appropriate digit grouping for the issuer\\n* Any digit groupings to be separated by a white space \\" \\", dash \\"-\\" or dash variant\\n* Have a valid Luhn check digit\\n* Must not appear to be part of a larger digit sequence\\n\\nNOTE: Card numbers used for other non-financial purposes but that use the same format as monetary cards will be detected as credit cards. This is because:- \\n* These cards typically have high PII risk\\n* Loyalty cards (etc.) often do have an actual financial value or financial consequence\\n* Card issuers have been known to upgrade loyalty & travel cards to have a financial value","name":"CreditordebitcardnumbersGlobal"},{"tag":["3","7"],"title":"Bank routing numbers with qualifying terms","countryTitle":"Global","description":"A combination of bank routing numbers (including American Banking Association routing transit number and European sort codes) and qualifying terms (e.g.\\"sort code\\",\\"RTN\\",\\"routing\\").\\nCountries supported: Australia, Brazil Canada, Denmark, Finland, France, Germany, Ireland, Italy, Spain, Sweden, UK, USA, New Zealand","name":"BankroutingnumberswithqualifyingtermsGlobal"},{"tag":["2","17"],"title":"Driver\'s licenses","countryTitle":"USA","description":"USA state driver\'s license details. For distinctive license formats matches on driver\'s number only. Otherwise requires a relevant state name or \\"driver licence\\" string near a driver\'s license number.","name":"DriversLicenseUSA"},{"tag":["2","17"],"title":"Driver\'s licenses with qualifying terms","countryTitle":"USA","description":"A combination of driver\'s license IDs and qualifying terms such as DOB, name, height and weight commonly found on licenses.\\r\\nCountries supported: USA","name":"DriversLicensewithqualifyingtermsUSA"},{"tag":["2","7"],"title":"Bank account details near personally identifiable information","countryTitle":"Global","description":"Bank account details near to other types of personally identifiable information (including national identification or insurance numbers, credit or debit card numbers, postal addresses, telephone numbers, and email addresses).\\nCountries supported: Australia, Brazil Canada, Denmark, Finland, France, Germany, Ireland, Italy, Spain, Sweden, UK, USA, New Zealand, South Africa","name":"BankaccountdetailsnearpersonallyidentifiableinformationGlobal"},{"tag":["2","6","7"],"title":"Credit card near contact details","countryTitle":"Global","description":"Credit or debit card numbers near to contact style Personally Identifiable Information.\\nIncludes:-\\n - Postal addresses \\n - Telephone numbers\\n - Email addresses\\n\\nIncludes protection for all supported regions.","name":"CreditordebitnumbersnearpersonallyidentifiableinformationGlobal"},{"tag":["2","7"],"title":"Combination of PII","countryTitle":"Global","description":"Combination of three or more types of Personally Identifiable Information types from:-\\n\\n- Banking information\\n- Email addresses\\n- Personal Identifiers\\n- Postal Addresses\\n- Telephone numbers","name":"CombinationofpersonallyidentifiableinformationGlobal"},{"tag":["2","17"],"title":"Bank account details with personally identifiable information","countryTitle":"USA","description":"Bank account details with other types of personally identifiable information (including social security numbers, postal addresses, telephone numbers, Driver\'s Licenses and email addresses).","name":"BankaccountdetailsnearpersonallyidentifiableinformationUSA"},{"tag":["2","3","6","17","46"],"title":"Credit or debit card numbers near personally identifiable information","countryTitle":"USA","description":"Credit or debit card numbers near to other types of personally identifiable information.","name":"CreditordebitnumbersnearpersonallyidentifiableinformationUSA"},{"tag":["2","17"],"title":"Combination of PII","countryTitle":"USA","description":"A combination of social security numbers, credit or debit card numbers, postal addresses, telephone numbers, driver\'s licenses and email addresses.","name":"CombinationofpersonallyidentifiableinformationUSA"},{"tag":["2","5","17"],"title":"Social security numbers near personally identifiable information","countryTitle":"USA","description":"Social security numbers near to other types of personally identifiable information (including credit or debit card numbers, postal addresses, telephone numbers, driver\'s licenses and email addresses).","name":"SocialsecuritynumbersnearpersonallyidentifiableinformationUSA"},{"tag":["4","7"],"title":"Confidential document markers","countryTitle":"Global","description":"Confidential document markers such as:-\\n“Top Secret”\\n“重要機密事項”\\n“Apenas para Uso Interno”\\n“streng geheim”\\n","name":"ConfidentialdocumentmarkersGlobal"},{"tag":["2","7"],"title":"Email addresses","countryTitle":"Global","description":"Email address format.","name":"EmailaddressesGlobal"},{"tag":["2","17"],"title":"Ethnicity terms","countryTitle":"USA","description":"Terms used to describe ethnicity.","name":"EthnicitytermsUSA"},{"tag":["2","7"],"title":"Person identification numbers","countryTitle":"Global","description":"Numbering systems from any supported region that can identify individual persons.","name":"NationalidentificationnumberswithqualifyingtermsGlobal"},{"tag":["2","11"],"title":"Social insurance numbers - near phrase","countryTitle":"Canada","description":"Canadian Social Insurance Numbers (SIN) within a short distance of a related phrase.\\n\\nCanadian Social Insurance Numbers (SIN) in the following formats:-\\n- \\"999999998\\"\\n- \\"999 999 998\\"\\n- \\"999-999-998\\"\\n\\nPhrase such as, but not limited to:-\\n- \\"social insurance num\\"\\n- \\"|numéros d\'assurance sociale\\"\\n- \\"SIN\\"","name":"SocialinsurancenumberswithqualifyingtermsCanada"},{"tag":["2","5","17"],"title":"Social Security Numbers with qualifying terms","countryTitle":"USA","description":"A combination of USA Social Security Numbers and qualifying terms such as:-\\n - \\"SSN\\"\\n - \\"Social Security Number\\"\\n - \\"Employee\\"\\n\\nDetects on a qualifying phrase plus a quantity of either:-\\n - Formatted SSN e.g. \\"123-45-6789\\"\\n - Qualifying phrase followed soon after by a 9 digit number sequence e.g. \\"SSN number is 123456789\\"","name":"SocialsecuritynumberswithqualifyingtermsUSA"},{"tag":["2","5","17"],"title":"Social Security Numbers","countryTitle":"USA","description":"USA Social Security Numbers either:-\\n - Formatted SSN e.g. \\"123-45-6789\\"\\n - Qualifying phrase followed soon after by a 9 digit number sequence e.g. \\"SSN number is 123456789\\"\\n","name":"SocialsecuritynumbersUSA"},{"tag":["2","7"],"title":"Passport details","countryTitle":"Global","description":"Passport number and qualifying phrases.\\r\\nCountries supported: Australia, Brazil, Canada, France, Germany, Ireland, Italy, Spain, UK, USA","name":"PassportdetailsGlobal"},{"tag":["2","7"],"title":"Telephone numbers","countryTitle":"Global","description":"Generic detection of telephone numbers in either national or international formats. \\n\\nInternational format includes all common international dialling prefixes e.g.:-\\n  +44 1235 559933\\n  00 44 1235 559933\\n  0011 44 1235 559933\\n  010 44 1235 559933\\n  011 44 1235 559933\\n\\nGeneric national and generic local dialling formats are based on being preceded by a qualifying phrases such as \\"Phone number\\". Includes coverage for phrases in the following languages:-\\n - English\\n - Chinese (Simplified)\\n - Chinese (Traditional)\\n - Dutch\\n - French\\n - Gaelic\\n - German\\n - Italian\\n - Spanish\\n - Unicode telephone icons\\n\\nFor more precise detection consider using the appropriate regional \'Telephone numbers\' CCL.","name":"TelephonenumbersGlobal"},{"tag":["3","11","17"],"title":"CUSIP identifier","countryTitle":"Global","description":"CUSIP identifier for North American based equity and fixed income securities.\\n\\nExcludes foreign market trades (SIN), TBA, Options, Private Placements (PPN) and Syndicated Loans.\\n\\nExcludes number ranges for internal use, non-security assets & internal assets.","name":"CUSIPidentifier"},{"tag":["3","6","7"],"title":"Credit card magnetic track 1","countryTitle":"Global","description":"Credit card magnetic track 1","name":"CCMagStripeTrack1"},{"tag":["3","6","7"],"title":"Credit card magnetic track 2","countryTitle":"Global","description":"Credit card magnetic track 2","name":"CCMagStripeTrack2"},{"tag":["5","7","17","41"],"title":"Prescribable treatment phrases","countryTitle":"Global","description":"Prescribable substance, pharmaceutical or treatment names and descriptions such as found in the ICD-9-PCS & ICD-10-PCS  “Procedure Coding System” classifications or in the FDA recognised pharmaceutical prescription items and other treatment lexicons.\\n\\nDetection is not based on code numbering systems.","name":"PrescriptionDrugsUSA"},{"tag":["3","11"],"title":"Bank routing numbers with qualifying terms","countryTitle":"Canada","description":"Canadian Payments Association routing numbers and qualifying terms","name":"BankroutingnumberswithqualifyingtermsCA"},{"tag":["3","17"],"title":"Bank routing numbers","countryTitle":"USA","description":"American Banking Association routing transit numbers (RTN).\\nDetection requires any one of the following plus a valid checksum:-\\n - A strict \\"9999-9999-9\\" format number sequence.\\n - A 9 digit sequence preceded by a qualifying term.\\nExamples include:-\\n - \\"0210-0002-1\\"\\n - \\"ABA No: 021000021\\"","name":"BankroutingnumberswithqualifyingtermsUS"},{"tag":["5","17","41"],"title":"Pharmaceutical companies","countryTitle":"USA","description":"FDA recognised pharmaceutical firms","name":"PharmaceuticalCompaniesUSA"},{"tag":["5","17","41"],"title":"Protected health information (PHI) related terms","countryTitle":"USA","description":"Lightweight detection of personal health information based on combinations of terms commonly used in medical communications and in medical form field names.\\nDetection is not based on actual personal information, with slight exceptions.\\nDetection is based on phrases that occur when personal medical information is intended to be present, such as the phrase “patient ID”.\\nDetection typically requires indicators of both medical and personal information to be present.\\n\\ne.g. Looks for terms related to:- \\n - Person name fields\\n - Patient id fields\\n - Doctor identifiers\\n - Dates (including \\"date of birth\\", \\"admission date\\")\\n - References to health plans and medical records\\n","name":"phi"},{"tag":["5","17","41"],"title":"Medical patient forms","countryTitle":"USA","description":"Protection of standard patient related medical forms such those specified by the \'Centers for Medicare & Medicaid Services (CMS)\'.\\n\\nAssists in compliance with the privacy aspects of the \'HITECH Act\' and \'HIPAA\'.\\n\\nDetection is based on form numbers, titles and text of standard health sector forms that may contain patient related information. This detection is not based entered data.","name":"MedicalPatientFormsUSA"},{"tag":["5","7","17","41"],"title":"Ailment, disease and diagnosis phrases","countryTitle":"Global","description":"Diagnosis names and descriptions such as found in the ICD-9-CM & ICD-10-CM  “Clinical Modification” classifications or in the “International Classification of Sleep Disorders” (ICSD) and other diagnostic lexicons.\\n\\nDetection is not based on code numbering systems.\\n\\n","name":"MedicalailmentsanddiseasesUSA"},{"tag":["2","11","31","41"],"title":"Personal health card number, British Columbia","countryTitle":"Canada","description":"Personal health card number for the province of British Columbia.","name":"PersonalhealthnumberBCCanada"},{"tag":["2","11","31","41"],"title":"Personal health card number, British Columbia near date of birth","countryTitle":"Canada","description":"Date stamp in common format near personal health card number for the province of British Columbia.","name":"PersonalhealthnumberBCnearDOBCanada"},{"tag":["2","11","31","41"],"title":"Personal health card number, British Columbia with qualifying terms","countryTitle":"Canada","description":"Personal health card number for the province of British Columbia and qualifying terms.","name":"PersonalhealthnumberBCwithqualifyingtermsCanada"},{"tag":["2","11","31","41"],"title":"Personal health card number, Ontario","countryTitle":"Canada","description":"Personal health card number (with AA extension) for the province of Ontario.","name":"PersonalhealthnumberOntarioCanada"},{"tag":["2","11","31","41"],"title":"Personal health card number, Ontario near date of birth","countryTitle":"Canada","description":"Date stamp in common format near personal health card number for the province of Ontario.","name":"PersonalhealthnumberOntarionearDOBCanada"},{"tag":["2","11","31","41"],"title":"Personal health card number, Ontario with qualifying terms","countryTitle":"Canada","description":"Personal health card number for the province of Ontario and qualifying terms.","name":"PersonalhealthnumberOntariowithqualifyingtermsCanada"},{"tag":["2","11","31","41"],"title":"Personal health card number, Quebec","countryTitle":"Canada","description":"Personal health card number for the province of Quebec.","name":"PersonalhealthnumberQuebecCanada"},{"tag":["2","11","31","41"],"title":"Personal health card number, Quebec near date of birth","countryTitle":"Canada","description":"Date stamp in common format near personal health card number for the province of Quebec.","name":"PersonalhealthnumberQuebecnearDOBCanada"},{"tag":["2","11","31","41"],"title":"Personal health card number, Quebec with qualifying terms","countryTitle":"Canada","description":"Personal health card number for the province of Quebec and qualifying terms.","name":"PersonalhealthnumberQuebecwithqualifyingtermsCanada"},{"tag":["2","17"],"title":"Employer Identification Number","countryTitle":"USA","description":"A quantity of EIN in \\"99-9999999\\" format within a document that contains either a strong qualifying phrase (\\"Emp ID Num.\\") or contains at least one EIN shortly after a qualifying phrase (e.g. \\"FEIN 999999999\\").\\n\\nThese 9-digit identification numbers are assigned by the USA Inland Revenue Service to companies. Depending on context. are called:-\\n - Employer Identification Number (EIN)\\n - Federal Employer Identification Number (FEIN)\\n - Tax Identification Number (TIN)\\n - Federal Tax Identification Number (FTIN)","name":"employeridentificationnumber"},{"tag":["2","5","17"],"title":"Social Security Numbers without separators","countryTitle":"USA","description":"Social Security Numbers without separators e.g. \\"123456789\\".\\n\\nWARNING: This will have a high false positive risk when used in isolation. Instead consider using either \\"Social security numbers [USA]\\" or \\"Social security numbers with qualifying terms [USA]\\".","name":"SocialsecuritynumbersnoseperatorUSA"},{"tag":["2","7"],"title":"Date of birth with qualifying terms","countryTitle":"Global","description":"Date of birth phrase followed by common numeric date format.","name":"dateofbirth"},{"tag":["5","17","41"],"title":"EDI X12 forms","countryTitle":"USA","description":"EDI X12 forms that are covered by HIPAA (specifically 148, 270, 271, 275, 276, 277, 278, 820, 834, 835 and 837).","name":"EDIX12HIPAA"},{"tag":["2","11"],"title":"Social insurance numbers - weak format","countryTitle":"Canada","description":"Canadian Social Insurance Numbers (SIN) in the following formats:-\\n- \\"999999998\\"\\n- \\"999 999 998\\"\\n- \\"999-999-998\\"\\n\\nWARNING: Unwanted detections are likely. There is a high risk of unrelated document content having the same format as the information that this CCL is designed to detect. \\n\\nWe recommend instead using one of the alternative CCL(s):-\\n- \\"Social insurance numbers - DEFAULT [Canada]\\"\\n- \\"Social insurance numbers - strict format [Canada]\\"\\n- \\"Social insurance numbers - near phrase [Canada]\\"","name":"SocialinsurancenumbersCanada"},{"tag":["5","17","41"],"title":"National Provider Identifier (NPI)","countryTitle":"USA","description":"Unique 10-digit identification number issued to health care providers in the United States by the Centers for Medicare and Medicaid Services (CMS)\\n\\nThe 10 digit number is validated by checksum and can be prefixed by 80840","name":"NPI"},{"tag":["5","17","41"],"title":"Drug Enforcement Administration number","countryTitle":"USA","description":"Unique 9-digit identification DEA number (aka DEAN) assigned to a health care provider allowing them to write prescriptions for controlled substances.","name":"DEANumber"},{"tag":["2","17"],"title":"Resume/CV","countryTitle":"USA","description":"A detection for standard Resumes requires certain keyword :- Email, Telephone, Education, Employment, Qualification, and References.","name":"CurriculumvitaeUSA"},{"tag":["2","11"],"title":"Resume/CV","countryTitle":"Canada","description":"A detection for standard Resumes requires certain keyword :- Email, Telephone, Education, Employment, Qualification, and References.","name":"CurriculumvitaeCanada"},{"tag":["2","17"],"title":"Person identification numbers","countryTitle":"USA","description":"Numbering systems within this region that can identify individual persons. \\nSuch as:-\\n - Social Security numbers\\n - State driving license numbers\\n - Passport numbers","name":"NationalidentificationnumbersUSA"},{"tag":["5","17","41"],"title":"National Provider Identifier (NPI) with qualifying terms","countryTitle":"USA","description":"Unique 10-digit identification number issued to health care providers in the United States by the Centers for Medicare and Medicaid Services (CMS)\\n\\nThe 10 digit number is validated by checksum and can be prefixed by 80840.\\n\\nA string such as \\"NPI\\" etc. is required to be present in the document for a match to occur.","name":"NPIwithqualifyingtermsUSA"},{"tag":["5","17","41","43"],"title":"Medicaid Recipient ID","countryTitle":"New York","description":"New York state Medicaid Recipient ID number aka \\"Client Identification Number (CIN)\\".\\n\\ne.g. \\"LZ00083W\\"","name":"MedicaidRecipientIDNewYork"},{"tag":["2","5","17"],"title":"Social Security Numbers - strict format","countryTitle":"USA","description":"Formatted Social Security Numbers with hyphen style separators e.g. \\"123-45-6789\\".","name":"SocialSecurityNumbersstrictformatUSA"},{"tag":["2","17"],"title":"Contact details","countryTitle":"USA","description":"Any contact details such as:-\\n - Regional address\\n - Regional telephone number\\n - email address\\n\\nThis is a highly sensitive detection, consider whether \\"Contact details - mixed\\" might be more appropriate to your needs.","name":"ContactdetailsUSA"},{"tag":["2","17"],"title":"Person or banking identifiers with contact details","countryTitle":"USA","description":"Contact details near either person identifiers or banking identifiers.\\nFor example:-\\n - Telephone number near bank account number.","name":"PersonorbankingidentifierswithcontactdetailsUSA"},{"tag":["2","3","17"],"title":"Bank account details","countryTitle":"USA","description":"Banking information such as credit card numbers or bank account numbers, ","name":"BankaccountdetailsUSA"},{"tag":["4","17"],"title":"Restricted information","countryTitle":"USA","description":"Contains either phrases indicating confidential information  or one of the special \\"sensitive\\" document markers i.e. \\"CTRL:X\\", \\"CTRL:XX\\" or \\"CTRL:XXX\\".","name":"RestrictedinformationUSA"},{"tag":["2","17"],"title":"Personal sensitive data","countryTitle":"USA","description":"Specially sensitive personal information such as ethnicity.","name":"PersonalsensitivedataUSA"},{"tag":["2","17"],"title":"Contact details - mixed","countryTitle":"USA","description":"Requires two or more different types of contact details to be present within same document:-\\n - Postal address\\n - Telephone number\\n - Email address","name":"CombinationofcontactdetailsUSA"},{"tag":["4","11"],"title":"Restricted information","countryTitle":"Canada","description":"Contains either phrases indicating confidential information  or one of the special \\"sensitive\\" document markers i.e. \\"CTRL:X\\", \\"CTRL:XX\\" or \\"CTRL:XXX\\".","name":"RestrictedinformationCanada"},{"tag":["2","6","11"],"title":"Person or banking identifiers near contact details","countryTitle":"Canada","description":"Contact details near either person identifiers or banking identifiers.\\nFor example:-\\n - Telephone number near bank account number.","name":"PersonorbankingidentifierswithcontactdetailsCanada"},{"tag":["2","11"],"title":"Contact details","countryTitle":"Canada","description":"Any contact details such as:-\\n - Regional address\\n - Regional telephone number\\n - email address\\n\\nThis is a highly sensitive detection, consider whether \\"Combination of contact details\\" might be more appropriate to your needs.","name":"ContactdetailsCanada"},{"tag":["2","6","11"],"title":"Bank account details","countryTitle":"Canada","description":"Banking information such as credit card numbers or bank account numbers,","name":"BankaccountdetailsCanada"},{"tag":["4","11"],"title":"Personal sensitive data","countryTitle":"Canada","description":"Specially sensitive personal information such as ethnicity.","name":"PersonalsensitivedataCanada"},{"tag":["2","11"],"title":"Combination of contact details","countryTitle":"Canada","description":"Requires two or more different types of  contact details to be present:-\\n - Postal address\\n - Telephone number\\n - Email address","name":"CombinationofcontactdetailsCanada"},{"tag":["2","11"],"title":"Person identification numbers","countryTitle":"Canada","description":"Numbering systems within this region that can identify individual persons.\\n\\nIncludes:-\\n - Social insurance (SIN) numbers near a relevant phrase\\n - Passport numbers","name":"PersonidentificationnumbersCanada"},{"tag":["2","17"],"title":"Contact details - sets","countryTitle":"USA","description":"Potential sets of related contact detail types within close proximity, possibly preceded by a person name prefix or name indicator. Such as might form a full contact details record for a single person or entity.\\n\\nFor example:-\\n - \\"Mr John Smith, Smith@example.com, +44 (0)207 123 1234\\"\\n - \\"77 Tree road, Ashland OH 44805  Tel 419-503-1234\\"","name":"ContactdetailssetsUSA"},{"tag":["2","7"],"title":"Contact details","countryTitle":"Global","description":"Any contact details such as:-\\n - Generic address\\n - Regional or generic telephone number\\n - Email address\\n\\n","name":"ContactdetailsGlobal"},{"tag":["3","17","46"],"title":"Employer Identification Number after qualifying term","countryTitle":"USA","description":"A quantity of EIN in \\"99-9999999\\" or \\"999999999\\" format, each preceded by a qualifying phrase.\\n\\nFor example:-\\n - \\"Tax Ident Num for company is 101234567\\"\\n - \\"EIN 10-1234567\\"\\n\\nThese 9-digit identification numbers are assigned by the USA Inland Revenue Service to companies. Depending on context. are called:-\\n - Employer Identification Number (EIN)\\n - Federal Employer Identification Number (FEIN)\\n - Tax Identification Number (TIN)\\n - Federal Tax Identification Number (FTIN)","name":"EmployerIdentificationNumberafterqualifyingtermsUSA"},{"tag":["17","35"],"title":"Postal boxes","countryTitle":"USA","description":"Postal address component specifying a mail storage box located on the premises of a post office or other secured official location that is not the recipient\'s own physical address.\\n\\nExamples include:-\\n - \\"Postal Box 123-456\\"\\n - \\"Po Box 1505\\"","name":"PostalboxesUSA"},{"tag":["2","17","35"],"title":"Postal codes","countryTitle":"USA","description":"Detects postal codes that define a geographical area or collection of postal destinations and used for mail sorting efficiency.\\n\\nUSA state name or abbreviation followed by a possible ZIP code for that state.\\n\\nNOTE: This CCL is provided to allow choice. It should not be used without considering it suitability to the task and the documents being processed.\\n\\nWarning: Unwanted detections are likely. There is a high risk of unrelated document content having the same format as the information that this CCL is designed to detect.","name":"PostalcodesUSA"},{"tag":["2","3","6","17"],"title":"Bank account numbers","countryTitle":"USA","description":"Bank account numbers with any associated bank routing numbers.\\n\\nExcludes credit and debit card numbers.","name":"BankaccountnumbersUSA"},{"tag":["2","11"],"title":"Social insurance numbers - strict format","countryTitle":"Canada","description":"Canadian Social Insurance Numbers (SIN) in strict groupings:-\\n- \\"999 999 998\\"\\n- \\"999-999-998\\"\\n\\nDue to False Positive risk the format \\"999999998\\" is NOT detected by this identity. \\nIf broader detection is required consider using:-\\n- \\"Social insurance numbers - DEFAULT [Canada]\\"","name":"SocialinsurancenumbersstrictformatCanada"},{"tag":["2","11"],"title":"Social insurance numbers - DEFAULT","countryTitle":"Canada","description":"Canadian Social Insurance Numbers (SIN) near a relevant phrase. \\n\\nFor example:-\\n- \\"999 999 998\\"\\n- \\"999-999-998\\"\\n- \\"99999998 is my social insurance number\\"\\n- \\"SIN: 999999998\\"","name":"SocialinsurancenumbersDEFAULTCanada"},{"tag":["2","3","7"],"title":"Bank account details","countryTitle":"Global","description":"International banking account identifiers and generic bank account number detections.\\nIncludes:-\\n- Bank account phrase near sequence of digits\\n- International Bank Account Numbers (IBAN) for any region\\n- Credit card numbers\\n\\n*Note* Regional specific versions of this CCL will typically provide both the protection provided by this CCL and enhanced detection of that region\'s own national bank account numbers.","name":"BankaccountdetailsGlobal"},{"tag":["900"],"title":"Source Code - Batchfile","countryTitle":"","description":"Source Code - Batch file. Only snippets larger than 128 characters are analyzed; large snippets are split in 1KB chunks.","name":"Source Code - Batchfile"},{"tag":["900"],"title":"Source Code - C","countryTitle":"","description":"Source Code in C programming language. Only snippets larger than 128 characters are analyzed; large snippets are split in 1KB chunks.","name":"Source Code - C"},{"tag":["900"],"title":"Source Code - C#","countryTitle":"","description":"Source Code in C# programming language. Only snippets larger than 128 characters are analyzed; large snippets are split in 1KB chunks.","name":"Source Code - C#"},{"tag":["900"],"title":"Source Code - C++","countryTitle":"","description":"Source Code in C++ programming language. Only snippets larger than 128 characters are analyzed; large snippets are split in 1KB chunks.","name":"Source Code - C++"},{"tag":["900"],"title":"Source Code - CoffeeScript","countryTitle":"","description":"Source Code in CoffeeScript programming language. Only snippets larger than 128 characters are analyzed; large snippets are split in 1KB chunks.","name":"Source Code - CoffeeScript"},{"tag":["900"],"title":"Source Code - Erlang","countryTitle":"","description":"Source Code in Erlang programming language. Only snippets larger than 128 characters are analyzed; large snippets are split in 1KB chunks.","name":"Source Code - Erlang"},{"tag":["900"],"title":"Source Code - Go","countryTitle":"","description":"Source Code in Go programming language. Only snippets larger than 128 characters are analyzed; large snippets are split in 1KB chunks.","name":"Source Code - Go"},{"tag":["900"],"title":"Source Code - Haskell","countryTitle":"","description":"Source Code in Haskell programming language. Only snippets larger than 128 characters are analyzed; large snippets are split in 1KB chunks.","name":"Source Code - Haskell"},{"tag":["900"],"title":"Source Code - Java","countryTitle":"","description":"Source Code in Java programming language. Only snippets larger than 128 characters are analyzed; large snippets are split in 1KB chunks.","name":"Source Code - Java"},{"tag":["900"],"title":"Source Code - JavaScript","countryTitle":"","description":"Source Code in JavaScript programming language. Only snippets larger than 128 characters are analyzed; large snippets are split in 1KB chunks.","name":"Source Code - JavaScript"},{"tag":["900"],"title":"Source Code - Jupyter Notebook","countryTitle":"","description":"Source Code - Jupyter Notebook. Only snippets larger than 128 characters are analyzed; large snippets are split in 1KB chunks.","name":"Source Code - Jupyter Notebook"},{"tag":["900"],"title":"Source Code - Lua","countryTitle":"","description":"Source Code in Lua programming language. Only snippets larger than 128 characters are analyzed; large snippets are split in 1KB chunks.","name":"Source Code - Lua"},{"tag":["900"],"title":"Source Code - Matlab","countryTitle":"","description":"Source Code in Matlab programming language. Only snippets larger than 128 characters are analyzed; large snippets are split in 1KB chunks.","name":"Source Code - Matlab"},{"tag":["900"],"title":"Source Code - Objective-C","countryTitle":"","description":"Source Code in Objective-C programming language. Only snippets larger than 128 characters are analyzed; large snippets are split in 1KB chunks.","name":"Source Code - Objective-C"},{"tag":["900"],"title":"Source Code - PHP","countryTitle":"","description":"Source Code in PHP programming language. Only snippets larger than 128 characters are analyzed; large snippets are split in 1KB chunks.","name":"Source Code - PHP"},{"tag":["900"],"title":"Source Code - Perl","countryTitle":"","description":"Source Code in Perl programming language. Only snippets larger than 128 characters are analyzed; large snippets are split in 1KB chunks.","name":"Source Code - Perl"},{"tag":["900"],"title":"Source Code - PowerShell","countryTitle":"","description":"Source Code in PowerShell programming language. Only snippets larger than 128 characters are analyzed; large snippets are split in 1KB chunks.","name":"Source Code - PowerShell"},{"tag":["900"],"title":"Source Code - Python","countryTitle":"","description":"Source Code in Python programming language. Only snippets larger than 128 characters are analyzed; large snippets are split in 1KB chunks.","name":"Source Code - Python"},{"tag":["900"],"title":"Source Code - R","countryTitle":"","description":"Source Code in R programming language. Only snippets larger than 128 characters are analyzed; large snippets are split in 1KB chunks.","name":"Source Code - R"},{"tag":["900"],"title":"Source Code - Ruby","countryTitle":"","description":"Source Code in Ruby programming language. Only snippets larger than 128 characters are analyzed; large snippets are split in 1KB chunks.","name":"Source Code - Ruby"},{"tag":["900"],"title":"Source Code - Rust","countryTitle":"","description":"Source Code in Rust programming language. Only snippets larger than 128 characters are analyzed; large snippets are split in 1KB chunks.","name":"Source Code - Rust"},{"tag":["900"],"title":"Source Code - Scala","countryTitle":"","description":"Source Code in Scala programming language. Only snippets larger than 128 characters are analyzed; large snippets are split in 1KB chunks.","name":"Source Code - Scala"},{"tag":["900"],"title":"Source Code - Shell","countryTitle":"","description":"Source Code in Shell programming language. Only snippets larger than 128 characters are analyzed; large snippets are split in 1KB chunks.","name":"Source Code - Shell"},{"tag":["900"],"title":"Source Code - Swift","countryTitle":"","description":"Source Code in Swift programming language. Only snippets larger than 128 characters are analyzed; large snippets are split in 1KB chunks.","name":"Source Code - Swift"},{"tag":["900"],"title":"Source Code - TypeScript","countryTitle":"","description":"Source Code in TypeScript programming language. Only snippets larger than 128 characters are analyzed; large snippets are split in 1KB chunks.","name":"Source Code - TypeScript"}],"b":[{"A":{"2":{"title":"PII","id":"2"},"3":{"title":"Financial Data","id":"3"},"4":{"title":"Document classification","id":"4"},"5":{"title":"HIPAA","id":"5"},"6":{"title":"PCI","id":"6"},"35":{"title":"Item identifiers","id":"35"},"46":{"title":"CCPA","id":"46"},"47":{"title":"GDPR","id":"47"},"900":{"title":"Source Code","id":"900"},"999":{"title":"Custom","id":"999"}}},{"A":{"7":{"title":"Global","id":"7"},"8":{"title":"UK","id":"8"},"9":{"title":"Europe","id":"9"},"10":{"title":"Australia","id":"10"},"11":{"title":"Canada","id":"11"},"12":{"title":"France","id":"12"},"13":{"title":"Germany","id":"13"},"14":{"title":"Spain","id":"14"},"15":{"title":"Ireland","id":"15"},"16":{"title":"Italy","id":"16"},"17":{"title":"USA","id":"17"},"18":{"title":"New Zealand","id":"18"},"19":{"title":"Hong Kong","id":"19"},"20":{"title":"Singapore","id":"20"},"21":{"title":"India","id":"21"},"22":{"title":"Indonesia","id":"22"},"23":{"title":"Brazil","id":"23"},"24":{"title":"South Africa","id":"24"},"32":{"title":"Sweden","id":"32"},"33":{"title":"Denmark","id":"33"},"34":{"title":"Finland","id":"34"},"36":{"title":"Belgium","id":"36"},"37":{"title":"Malaysia","id":"37"},"38":{"title":"Netherlands","id":"38"},"39":{"title":"Norway","id":"39"},"40":{"title":"Switzerland","id":"40"},"42":{"title":"Japan","id":"42"},"44":{"title":"Universal","id":"44"},"45":{"title":"Poland","id":"45"}}}]}');

/***/ })

/******/ 	});
/************************************************************************/
/******/ 	// The module cache
/******/ 	var __webpack_module_cache__ = {};
/******/ 	
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/ 		// Check if module is in cache
/******/ 		var cachedModule = __webpack_module_cache__[moduleId];
/******/ 		if (cachedModule !== undefined) {
/******/ 			return cachedModule.exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = __webpack_module_cache__[moduleId] = {
/******/ 			id: moduleId,
/******/ 			loaded: false,
/******/ 			exports: {}
/******/ 		};
/******/ 	
/******/ 		// Execute the module function
/******/ 		__webpack_modules__[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/ 	
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/ 	
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/ 	
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = __webpack_modules__;
/******/ 	
/************************************************************************/
/******/ 	/* webpack/runtime/amd define */
/******/ 	(() => {
/******/ 		__webpack_require__.amdD = function () {
/******/ 			throw new Error('define cannot be used indirect');
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/amd options */
/******/ 	(() => {
/******/ 		__webpack_require__.amdO = {};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/chunk loaded */
/******/ 	(() => {
/******/ 		var deferred = [];
/******/ 		__webpack_require__.O = (result, chunkIds, fn, priority) => {
/******/ 			if(chunkIds) {
/******/ 				priority = priority || 0;
/******/ 				for(var i = deferred.length; i > 0 && deferred[i - 1][2] > priority; i--) deferred[i] = deferred[i - 1];
/******/ 				deferred[i] = [chunkIds, fn, priority];
/******/ 				return;
/******/ 			}
/******/ 			var notFulfilled = Infinity;
/******/ 			for (var i = 0; i < deferred.length; i++) {
/******/ 				var [chunkIds, fn, priority] = deferred[i];
/******/ 				var fulfilled = true;
/******/ 				for (var j = 0; j < chunkIds.length; j++) {
/******/ 					if ((priority & 1 === 0 || notFulfilled >= priority) && Object.keys(__webpack_require__.O).every((key) => (__webpack_require__.O[key](chunkIds[j])))) {
/******/ 						chunkIds.splice(j--, 1);
/******/ 					} else {
/******/ 						fulfilled = false;
/******/ 						if(priority < notFulfilled) notFulfilled = priority;
/******/ 					}
/******/ 				}
/******/ 				if(fulfilled) {
/******/ 					deferred.splice(i--, 1)
/******/ 					var r = fn();
/******/ 					if (r !== undefined) result = r;
/******/ 				}
/******/ 			}
/******/ 			return result;
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/compat get default export */
/******/ 	(() => {
/******/ 		// getDefaultExport function for compatibility with non-harmony modules
/******/ 		__webpack_require__.n = (module) => {
/******/ 			var getter = module && module.__esModule ?
/******/ 				() => (module['default']) :
/******/ 				() => (module);
/******/ 			__webpack_require__.d(getter, { a: getter });
/******/ 			return getter;
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/create fake namespace object */
/******/ 	(() => {
/******/ 		var getProto = Object.getPrototypeOf ? (obj) => (Object.getPrototypeOf(obj)) : (obj) => (obj.__proto__);
/******/ 		var leafPrototypes;
/******/ 		// create a fake namespace object
/******/ 		// mode & 1: value is a module id, require it
/******/ 		// mode & 2: merge all properties of value into the ns
/******/ 		// mode & 4: return value when already ns object
/******/ 		// mode & 16: return value when it's Promise-like
/******/ 		// mode & 8|1: behave like require
/******/ 		__webpack_require__.t = function(value, mode) {
/******/ 			if(mode & 1) value = this(value);
/******/ 			if(mode & 8) return value;
/******/ 			if(typeof value === 'object' && value) {
/******/ 				if((mode & 4) && value.__esModule) return value;
/******/ 				if((mode & 16) && typeof value.then === 'function') return value;
/******/ 			}
/******/ 			var ns = Object.create(null);
/******/ 			__webpack_require__.r(ns);
/******/ 			var def = {};
/******/ 			leafPrototypes = leafPrototypes || [null, getProto({}), getProto([]), getProto(getProto)];
/******/ 			for(var current = mode & 2 && value; typeof current == 'object' && !~leafPrototypes.indexOf(current); current = getProto(current)) {
/******/ 				Object.getOwnPropertyNames(current).forEach((key) => (def[key] = () => (value[key])));
/******/ 			}
/******/ 			def['default'] = () => (value);
/******/ 			__webpack_require__.d(ns, def);
/******/ 			return ns;
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/define property getters */
/******/ 	(() => {
/******/ 		// define getter functions for harmony exports
/******/ 		__webpack_require__.d = (exports, definition) => {
/******/ 			for(var key in definition) {
/******/ 				if(__webpack_require__.o(definition, key) && !__webpack_require__.o(exports, key)) {
/******/ 					Object.defineProperty(exports, key, { enumerable: true, get: definition[key] });
/******/ 				}
/******/ 			}
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/ensure chunk */
/******/ 	(() => {
/******/ 		__webpack_require__.f = {};
/******/ 		// This file contains only the entry chunk.
/******/ 		// The chunk loading function for additional chunks
/******/ 		__webpack_require__.e = (chunkId) => {
/******/ 			return Promise.all(Object.keys(__webpack_require__.f).reduce((promises, key) => {
/******/ 				__webpack_require__.f[key](chunkId, promises);
/******/ 				return promises;
/******/ 			}, []));
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/get javascript chunk filename */
/******/ 	(() => {
/******/ 		// This function allow to reference async chunks
/******/ 		__webpack_require__.u = (chunkId) => {
/******/ 			// return url for filenames based on template
/******/ 			return "" + (chunkId === 817 ? "react-image-gallery" : chunkId) + "." + {"2":"618cf84dfd31ba2f57dc","27":"340cadc0e8bd4a39350e","37":"3c144b6a960392bec5ff","51":"3a7150e1650bd64e6cc7","62":"2824efa8a3c0f0c3d36c","70":"1d633b25197ea6224280","98":"b39c090ae136133ebcb7","100":"f1a52b0dd89425520646","119":"430f1bd5c20d2c05f0c8","125":"aa91afcba727c6edb2f8","136":"b9106ac244adccf75df2","137":"bf7efa18fe6810e226c7","191":"8290841a80051e3b39cf","254":"71de2d3ca1768257ecbe","271":"2b0d1282fb0c9eb55683","272":"7fdbc387f242b45bffef","273":"bb86929287c8f43e5853","311":"def0e97053164a885ea1","352":"0af1a778042a44e154e6","368":"f6d6a6a8b0106d902e84","393":"5a07e9a416a42501f46f","443":"26772997996e7dda94d9","446":"b4a91d867ef7c50fc485","463":"973999dfad0389dbc900","473":"91a71c000207be72af5d","485":"4845a19c65c0392f8f78","489":"ffee57207bf0eb7500df","575":"cbedff316c5b14f38ea5","626":"651196dff768314747d8","650":"7f58746971bbf9f6decd","658":"d2e444bf232db186372b","671":"03e5fc92ee6b81348139","700":"dc86983d0c177dd6c2ee","798":"a639fe19a2ad279a7444","802":"0b8f51c71056607cc9db","817":"da48906d3135e8eea913","951":"a863a2c6e665a589dc54","979":"0136df530ba6b88dd9ac","982":"501168069e8811f5922f","995":"616caaf89381eea29d27"}[chunkId] + ".bundle.js";
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/get mini-css chunk filename */
/******/ 	(() => {
/******/ 		// This function allow to reference async chunks
/******/ 		__webpack_require__.miniCssF = (chunkId) => {
/******/ 			// return url for filenames based on template
/******/ 			return undefined;
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/global */
/******/ 	(() => {
/******/ 		__webpack_require__.g = (function() {
/******/ 			if (typeof globalThis === 'object') return globalThis;
/******/ 			try {
/******/ 				return this || new Function('return this')();
/******/ 			} catch (e) {
/******/ 				if (typeof window === 'object') return window;
/******/ 			}
/******/ 		})();
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/harmony module decorator */
/******/ 	(() => {
/******/ 		__webpack_require__.hmd = (module) => {
/******/ 			module = Object.create(module);
/******/ 			if (!module.children) module.children = [];
/******/ 			Object.defineProperty(module, 'exports', {
/******/ 				enumerable: true,
/******/ 				set: () => {
/******/ 					throw new Error('ES Modules may not assign module.exports or exports.*, Use ESM export syntax, instead: ' + module.id);
/******/ 				}
/******/ 			});
/******/ 			return module;
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/hasOwnProperty shorthand */
/******/ 	(() => {
/******/ 		__webpack_require__.o = (obj, prop) => (Object.prototype.hasOwnProperty.call(obj, prop))
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/load script */
/******/ 	(() => {
/******/ 		var inProgress = {};
/******/ 		var dataWebpackPrefix = "cyberhaven:";
/******/ 		// loadScript function to load a script via script tag
/******/ 		__webpack_require__.l = (url, done, key, chunkId) => {
/******/ 			if(inProgress[url]) { inProgress[url].push(done); return; }
/******/ 			var script, needAttach;
/******/ 			if(key !== undefined) {
/******/ 				var scripts = document.getElementsByTagName("script");
/******/ 				for(var i = 0; i < scripts.length; i++) {
/******/ 					var s = scripts[i];
/******/ 					if(s.getAttribute("src") == url || s.getAttribute("data-webpack") == dataWebpackPrefix + key) { script = s; break; }
/******/ 				}
/******/ 			}
/******/ 			if(!script) {
/******/ 				needAttach = true;
/******/ 				script = document.createElement('script');
/******/ 		
/******/ 				script.charset = 'utf-8';
/******/ 				script.timeout = 120;
/******/ 				if (__webpack_require__.nc) {
/******/ 					script.setAttribute("nonce", __webpack_require__.nc);
/******/ 				}
/******/ 				script.setAttribute("data-webpack", dataWebpackPrefix + key);
/******/ 				script.src = url;
/******/ 			}
/******/ 			inProgress[url] = [done];
/******/ 			var onScriptComplete = (prev, event) => {
/******/ 				// avoid mem leaks in IE.
/******/ 				script.onerror = script.onload = null;
/******/ 				clearTimeout(timeout);
/******/ 				var doneFns = inProgress[url];
/******/ 				delete inProgress[url];
/******/ 				script.parentNode && script.parentNode.removeChild(script);
/******/ 				doneFns && doneFns.forEach((fn) => (fn(event)));
/******/ 				if(prev) return prev(event);
/******/ 			}
/******/ 			var timeout = setTimeout(onScriptComplete.bind(null, undefined, { type: 'timeout', target: script }), 120000);
/******/ 			script.onerror = onScriptComplete.bind(null, script.onerror);
/******/ 			script.onload = onScriptComplete.bind(null, script.onload);
/******/ 			needAttach && document.head.appendChild(script);
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/make namespace object */
/******/ 	(() => {
/******/ 		// define __esModule on exports
/******/ 		__webpack_require__.r = (exports) => {
/******/ 			if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 				Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 			}
/******/ 			Object.defineProperty(exports, '__esModule', { value: true });
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/publicPath */
/******/ 	(() => {
/******/ 		__webpack_require__.p = "/";
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/jsonp chunk loading */
/******/ 	(() => {
/******/ 		// no baseURI
/******/ 		
/******/ 		// object to store loaded and loading chunks
/******/ 		// undefined = chunk not loaded, null = chunk preloaded/prefetched
/******/ 		// [resolve, reject, Promise] = chunk loading, 0 = chunk loaded
/******/ 		var installedChunks = {
/******/ 			179: 0
/******/ 		};
/******/ 		
/******/ 		__webpack_require__.f.j = (chunkId, promises) => {
/******/ 				// JSONP chunk loading for javascript
/******/ 				var installedChunkData = __webpack_require__.o(installedChunks, chunkId) ? installedChunks[chunkId] : undefined;
/******/ 				if(installedChunkData !== 0) { // 0 means "already installed".
/******/ 		
/******/ 					// a Promise means "currently loading".
/******/ 					if(installedChunkData) {
/******/ 						promises.push(installedChunkData[2]);
/******/ 					} else {
/******/ 						if(true) { // all chunks have JS
/******/ 							// setup Promise in chunk cache
/******/ 							var promise = new Promise((resolve, reject) => (installedChunkData = installedChunks[chunkId] = [resolve, reject]));
/******/ 							promises.push(installedChunkData[2] = promise);
/******/ 		
/******/ 							// start chunk loading
/******/ 							var url = __webpack_require__.p + __webpack_require__.u(chunkId);
/******/ 							// create error before stack unwound to get useful stacktrace later
/******/ 							var error = new Error();
/******/ 							var loadingEnded = (event) => {
/******/ 								if(__webpack_require__.o(installedChunks, chunkId)) {
/******/ 									installedChunkData = installedChunks[chunkId];
/******/ 									if(installedChunkData !== 0) installedChunks[chunkId] = undefined;
/******/ 									if(installedChunkData) {
/******/ 										var errorType = event && (event.type === 'load' ? 'missing' : event.type);
/******/ 										var realSrc = event && event.target && event.target.src;
/******/ 										error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
/******/ 										error.name = 'ChunkLoadError';
/******/ 										error.type = errorType;
/******/ 										error.request = realSrc;
/******/ 										installedChunkData[1](error);
/******/ 									}
/******/ 								}
/******/ 							};
/******/ 							__webpack_require__.l(url, loadingEnded, "chunk-" + chunkId, chunkId);
/******/ 						} else installedChunks[chunkId] = 0;
/******/ 					}
/******/ 				}
/******/ 		};
/******/ 		
/******/ 		// no prefetching
/******/ 		
/******/ 		// no preloaded
/******/ 		
/******/ 		// no HMR
/******/ 		
/******/ 		// no HMR manifest
/******/ 		
/******/ 		__webpack_require__.O.j = (chunkId) => (installedChunks[chunkId] === 0);
/******/ 		
/******/ 		// install a JSONP callback for chunk loading
/******/ 		var webpackJsonpCallback = (parentChunkLoadingFunction, data) => {
/******/ 			var [chunkIds, moreModules, runtime] = data;
/******/ 			// add "moreModules" to the modules object,
/******/ 			// then flag all "chunkIds" as loaded and fire callback
/******/ 			var moduleId, chunkId, i = 0;
/******/ 			if(chunkIds.some((id) => (installedChunks[id] !== 0))) {
/******/ 				for(moduleId in moreModules) {
/******/ 					if(__webpack_require__.o(moreModules, moduleId)) {
/******/ 						__webpack_require__.m[moduleId] = moreModules[moduleId];
/******/ 					}
/******/ 				}
/******/ 				if(runtime) var result = runtime(__webpack_require__);
/******/ 			}
/******/ 			if(parentChunkLoadingFunction) parentChunkLoadingFunction(data);
/******/ 			for(;i < chunkIds.length; i++) {
/******/ 				chunkId = chunkIds[i];
/******/ 				if(__webpack_require__.o(installedChunks, chunkId) && installedChunks[chunkId]) {
/******/ 					installedChunks[chunkId][0]();
/******/ 				}
/******/ 				installedChunks[chunkId] = 0;
/******/ 			}
/******/ 			return __webpack_require__.O(result);
/******/ 		}
/******/ 		
/******/ 		var chunkLoadingGlobal = self["webpackChunkcyberhaven"] = self["webpackChunkcyberhaven"] || [];
/******/ 		chunkLoadingGlobal.forEach(webpackJsonpCallback.bind(null, 0));
/******/ 		chunkLoadingGlobal.push = webpackJsonpCallback.bind(null, chunkLoadingGlobal.push.bind(chunkLoadingGlobal));
/******/ 	})();
/******/ 	
/************************************************************************/
/******/ 	
/******/ 	// startup
/******/ 	// Load entry module and return exports
/******/ 	// This entry module depends on other loaded chunks and execution need to be delayed
/******/ 	var __webpack_exports__ = __webpack_require__.O(undefined, [524], () => (__webpack_require__(38873)))
/******/ 	__webpack_exports__ = __webpack_require__.O(__webpack_exports__);
/******/ 	
/******/ })()
;